// bwip-js // Barcode Writer in Pure JavaScript
// https://github.com/metafloor/bwip-js
//
// This code was automatically generated from:
// Barcode Writer in Pure PostScript - Version 2018-02-04
//
// Copyright (c) 2011-2019 Mark Warren
// Copyright (c) 2004-2019 Terry Burton
//
// Licensed MIT. See the LICENSE file in the bwip-js root directory.
"use strict";

function BWIPP() {
	// bwip-js/barcode-hdr.js
	//
	// This code is injected above the cross-compiled barcode.ps.

	// The BWIPJS object (graphics interface)
	var $$ = null;

	// The global dictionary.  Each renderer and encoder declare a
	// $1 local dict.
	var $0 = {
		$error: {} // the postscript error object
	};

	var $j = 0; // stack pointer
	var $k = []; // operand stack
	var $b = {}; // break symbol

	// Array ctor
	//	$a()	: Build a new array up to the Infinity-marker on the stack.
	//	$a(arr)	: Convert native array to a "view" of the array.
	//	$a(len)	: Create a new array of length `len`
	function $a(a) {
		if (!arguments.length) {
			for (var i = $j - 1; i >= 0 && $k[i] !== Infinity; i--);
			if (i < 0) {
				throw new Error('array-marker-not-found');
			}
			a = $k.splice(i + 1, $j - 1 - i);
			$j = i;
		} else if (!(a instanceof Array)) {
			a = new Array(+arguments[0]);
			for (var i = 0, l = a.length; i < l; i++) {
				a[i] = null;
			}
		}
		a.b = a; // base array
		a.o = 0; // offset into base
		return a;
	}

	// dict ctor
	//	$d() : look for the Infinity marker on the stack
	function $d() {
		var d = {};
		for (var i = $j - 1; i >= 0 && $k[i] !== Infinity; i -= 2) {
			if ($k[i - 1] === Infinity) {
				throw new Error('dict-malformed-stack');
			}
			// Unlike javascript, postscript dict keys differentiate between
			// numbers and the string representation of a number.
			var k = $k[i - 1]; // "key" into the dict entry
			var t = typeof k;
			if (t === 'number') {
				d['\uffff' + k] = $k[i];
			} else if (t === 'string') {
				d[k] = $k[i];
			} else if (k instanceof Uint8Array) {
				d[$z(k)] = $k[i];
			} else {
				throw 'dict-not-a-valid-key(' + k + ')';
			}
		}
		if (i < 0) {
			throw 'dict-marker-not-found';
		}
		$j = i;
		return d;
	}

	// string ctor
	//	s(number)	: create zero-filled string of number-length
	//	s(string)	: make a copy of the string
	//	s(uint8[])	: make a copy of the string
	//
	// Returns a Uint8Array-string.
	function $s(v) {
		var t = typeof v;
		if (t === 'number') {
			return new Uint8Array(v);
		}
		if (t !== 'string') {
			v = '' + v;
		}
		var s = new Uint8Array(v.length);
		for (var i = 0; i < v.length; i++) {
			s[i] = v.charCodeAt(i);
		}
		return s;
	}

	// Primarily designed to convert uint8-string to string, but will call the
	// the toString() method on any value.
	function $z(s) {
		if (s instanceof Uint8Array) {
			// Postscript treats nul-char as end of string, even if string is
			// longer.
			for (var i = 0, l = s.length; i < l && s[i]; i++);
			if (i < l) {
				return String.fromCharCode.apply(null, s.subarray(0, i));
			}
			return String.fromCharCode.apply(null, s)
		}
		return '' + s;
	}

	// Copies source to dest and returns a view of just the copied characters
	function $strcpy(dst, src) {
		if (typeof dst === 'string') {
			dst = $s(dst);
		}
		if (src instanceof Uint8Array) {
			for (var i = 0, l = src.length; i < l; i++) {
				dst[i] = src[i];
			}
		} else {
			for (var i = 0, l = src.length; i < l; i++) {
				dst[i] = src.charCodeAt(i);
			}
		}
		return src.length < dst.length ? dst.subarray(0, src.length) : dst;
	}

	// Copies source to dest and should (but doesn't) return a view of just the copied elements
	function $arrcpy(dst, src) {
		for (var i = 0, l = src.length; i < l; i++) {
			dst[i] = src[i];
		}
		dst.length = src.length;
		return dst;
	}

	// cvs operator - convert a value to its string representation
	//	s : string to store into
	//	v : any value
	function $cvs(s, v) {
		var t = typeof v;
		if (t == 'number' || t == 'boolean' || v === null) {
			v = '' + v;
		} else if (t !== 'string') {
			v = '--nostringval--';
		}
		for (var i = 0, l = v.length; i < l; i++) {
			s[i] = v.charCodeAt(i);
		}
		$k[$j++] = i < s.length ? s.subarray(0, i) : s;
	}
	// cvrs operator - convert a number to a radix string
	//	s : string to store into
	//	n : number
	//	r : radix
	function $cvrs(s, n, r) {
		return $strcpy(s, (~~n).toString(r).toUpperCase());
	}

	// get operator
	//	s : source
	//	k : key
	function $get(s, k) {
		if (s instanceof Uint8Array) {
			return s[k];
		}
		if (typeof s === 'string') {
			return s.charCodeAt(k);
		}
		if (s instanceof Array) {
			return s.b[s.o + k];
		}
		// Must be a dict object : with postscript dict objects, a number key
		// is differerent than its string representation.  postscript uses
		// 8-bit strings, so \uffff can never be in a key value.
		if (typeof k === 'number') {
			return s['\uffff' + k];
		}
		if (k instanceof Uint8Array) {
			return s[$z(k)];
		}
		return s[k];
	}

	// put operator
	//	d : dest
	//	k : key
	//	v : value
	function $put(d, k, v) {
		if (d instanceof Uint8Array) {
			d[k] = v;
		} else if (d instanceof Array) {
			d.b[d.o + k] = v;
		} else if (typeof d == 'object') {
			if (k instanceof Uint8Array) {
				d[$z(k)] = v;
			} else {
				d[typeof k == 'number' ? '\uffff' + k : k] = v;
			}
		} else {
			throw 'put-not-writable-' + (typeof d);
		}
	}

	// getinterval operator
	//	s : src
	//	o : offset
	//	l : length
	function $geti(s, o, l) {
		if (s instanceof Uint8Array) {
			return s.subarray(o, o + l);
		}
		if (s instanceof Array) {
			var a = new Array(l);
			a.b = s.b; // base array
			a.o = s.o + o; // offset into base
			return a;
		}
		// Must be a string
		return s.substr(o, l);
	}

	// putinterval operator
	//	d : dst
	//	o : offset
	//	s : src
	function $puti(d, o, s) {
		if (d instanceof Uint8Array) {
			if (typeof s == 'string') {
				for (var i = 0, l = s.length; i < l; i++) {
					d[o + i] = s.charCodeAt(i);
				}
			} else {
				// When both d and s are the same, we want to copy
				// backwards, which works for the general case as well.
				for (var i = s.length - 1; i >= 0; i--) {
					d[o + i] = s[i];
				}
			}
		} else if (d instanceof Array) {
			// Operate on the base arrays
			var darr = d.b;
			var doff = o + d.o;
			var sarr = s.b;
			var soff = s.o;

			for (var i = 0, l = s.length; i < l; i++) {
				darr[doff + i] = sarr[soff + i];
			}
		} else {
			throw 'putinterval-not-writable-' + (typeof d);
		}
	}

	// type operator
	function $type(v) {
		// null can be mis-typed - get it out of the way
		if (v === null || v === undefined) {
			return 'nulltype';
		}
		var t = typeof v;
		if (t == 'number') {
			return v % 1 ? 'realtype' : 'integertype';
		}
		if (t == 'boolean') {
			return 'booleantype';
		}
		if (t == 'string' || v instanceof Uint8Array) {
			return 'stringtype';
		}
		if (t == 'function') {
			return 'operatortype';
		}
		if (v instanceof Array) {
			return 'arraytype';
		}
		return 'dicttype';
		// filetype
		// fonttype
		// gstatetype
		// marktype	(v === Infinity)
		// nametype
		// savetype
	}

	// search operator
	//		string seek search suffix match prefix true %if-found
	//						   string false				%if-not-found
	function $search(str, seek) {
		if (!(str instanceof Uint8Array)) {
			str = $s(str);
		}
		var ls = str.length;

		// Virtually all uses of search in BWIPP are for single-characters.
		// Optimize for that case.
		if (seek.length == 1) {
			var lk = 1;
			var cd = seek instanceof Uint8Array ? seek[0] : seek.charCodeAt(0);
			for (var i = 0; i < ls && str[i] != cd; i++);
		} else {
			// Slow path, 
			if (!(seek instanceof Uint8Array)) {
				seek = $(seek);
			}
			var lk = seek.length;
			var cd = seek[0];
			for (var i = 0; i < ls && str[i] != cd; i++);
			while (i < ls) {
				for (var j = 1; j < lk && str[i + j] === seek[j]; j++);
				if (j === lk) {
					break;
				}
				for (i++; i < ls && str[i] != cd; i++);
			}
		}
		if (i < ls) {
			$k[$j++] = str.subarray(i + lk);
			$k[$j++] = str.subarray(i, i + lk);
			$k[$j++] = str.subarray(0, i);
			$k[$j++] = true;
		} else {
			$k[$j++] = str;
			$k[$j++] = false;
		}
	}

	// The callback is omitted when forall is being used just to push onto the
	// stack.
	function $forall(o, cb) {
		if (o instanceof Uint8Array) {
			for (var i = 0, l = o.length; i < l; i++) {
				$k[$j++] = o[i];
				if (cb && cb() == $b) break;
			}
		} else if (o instanceof Array) {
			// The array may be a view.
			for (var a = o.b, i = o.o, l = o.o + o.length; i < l; i++) {
				$k[$j++] = a[i];
				if (cb && cb() == $b) break;
			}
		} else if (typeof o === 'string') {
			for (var i = 0, l = o.length; i < l; i++) {
				$k[$j++] = o.charCodeAt(i);
				if (cb && cb() == $b) break;
			}
		} else {
			for (var id in o) {
				$k[$j++] = id;
				$k[$j++] = o[id];
				if (cb && cb() == $b) break;
			}
		}
	}

	function $cleartomark() {
		while ($j > 0 && $k[--$j] !== Infinity);
	}

	function $counttomark() {
		for (var i = $j - 1; i >= 0 && $k[i] !== Infinity; i--);
		return $j - i - 1;
	}

	function $aload(a) {
		for (var i = 0, l = a.length, b = a.b, o = a.o; i < l; i++) {
			$k[$j++] = b[o + i];
		}
		// This push has been optimized out.  See $.aload() in psc.js.
		//$k[$j++] = a;
	}

	function $astore(a) {
		for (var i = 0, l = a.length, b = a.b, o = a.o + l - 1; i < l; i++) {
			b[o - i] = $k[--$j];
		}
		$k[$j++] = a;
	}

	function $eq(a, b) {
		if (typeof a === 'string' && typeof b === 'string') {
			return a == b;
		}
		if (a instanceof Uint8Array && b instanceof Uint8Array) {
			if (a.length != b.length) {
				return false;
			}
			for (var i = 0, l = a.length; i < l; i++) {
				if (a[i] != b[i]) {
					return false;
				}
			}
			return true;
		}
		if (a instanceof Uint8Array && typeof b === 'string' ||
			b instanceof Uint8Array && typeof a === 'string') {
			if (a instanceof Uint8Array) {
				a = $z(a);
			} else {
				b = $z(b);
			}
			return a == b;
		}
		return a == b;
	}

	function $ne(a, b) {
		return !$eq(a, b);
	}

	function $lt(a, b) {
		if (a instanceof Uint8Array) {
			a = $z(a);
		}
		if (b instanceof Uint8Array) {
			b = $z(b);
		}
		return a < b;
	}

	function $le(a, b) {
		if (a instanceof Uint8Array) {
			a = $z(a);
		}
		if (b instanceof Uint8Array) {
			b = $z(b);
		}
		return a <= b;
	}

	function $gt(a, b) {
		if (a instanceof Uint8Array) {
			a = $z(a);
		}
		if (b instanceof Uint8Array) {
			b = $z(b);
		}
		return a > b;
	}

	function $ge(a, b) {
		if (a instanceof Uint8Array) {
			a = $z(a);
		}
		if (b instanceof Uint8Array) {
			b = $z(b);
		}
		return a >= b;
	}

	function $an(a, b) { // and
		return (typeof a === 'boolean') ? a && b : a & b;
	}

	function $or(a, b) { // or
		return (typeof a === 'boolean') ? a || b : a | b;
	}

	function $xo(a, b) { // xor
		return (typeof a === 'boolean') ? !a && b || a && !b : a ^ b;
	}

	// DEBUG-BEGIN
	function $stack() {
		console.log('[[[');
		for (var i = $j - 1; i >= 0; i--) {
			console.log(tostring($k[i]));
		}
		console.log(']]]');

		function tostring(v) {
			// null can be mis-typed - get it out of the way
			if (v === null) {
				return 'null';
			} else if (v === undefined) {
				return '<undefined>';
			} else if (v instanceof Array) {
				var s = '<array,' + v.o + ',' + v.length + '>[';
				for (var j = v.o, a = v.b, l = v.length + v.o; j < l; j++) {
					s += (j == v.o ? '' : ',') + tostring(a[j]);
				}
				return s + ']';
			} else if (v instanceof Uint8Array) {
				return '(' + $z[v] + ')';
			} else if (typeof v === 'object') {
				var s = '<<';
				for (var id in v) {
					s += (s.length == 7 ? '' : ',') + id + ':' + tostring(v[id]);
				}
				return s + '>>';
			} else if (typeof v === 'string') {
				return '"' + v + '"';
			} else {
				return '' + v;
			}
		}
	}
	// DEBUG-END
	$0.raiseerror = function() {
		$0.$error.errorinfo = $k[--$j]; /*55*/
		$0.$error.errorname = $k[--$j]; /*56*/
		$0.$error.command = null; /*57*/
		$0.$error.newerror = true; /*58*/
		throw new Error($0.$error.errorname + ": " + $0.$error.errorinfo); /*59*/
	};
	$0.ean5 = function() {
		var $1 = {}; /*756*/
		$1.options = $k[--$j]; /*758*/
		$1.barcode = $k[--$j]; /*759*/
		$1.dontdraw = false; /*761*/
		$1.includetext = false; /*762*/
		$1.textfont = "Helvetica"; /*763*/
		$1.textsize = 12; /*764*/
		$1.textxoffset = 0; /*765*/
		$1.textyoffset = "unset"; /*766*/
		$1.height = 0.7; /*767*/
		$forall($1.options, function() { /*778*/
			var _3 = $k[--$j]; /*778*/
			$1[$k[--$j]] = _3; /*778*/
		}); /*778*/
		$1.textfont = "" + $1.textfont; /*780*/
		$1.textsize = +$1.textsize; /*781*/
		$1.height = +$1.height; /*782*/
		$1.textxoffset = +$1.textxoffset; /*783*/
		if ($eq($1.textyoffset, "unset")) { /*787*/
			$1.textyoffset = ($1.height * 72) + 1; /*785*/
		} else { /*787*/
			$1.textyoffset = +$1.textyoffset; /*787*/
		} /*787*/
		if ($1.barcode.length != 5) { /*793*/
			$k[$j++] = "bwipp.ean5badLength"; /*792*/
			$k[$j++] = "EAN-5 add-on must be 5 digits"; /*792*/
			$0.raiseerror(); /*792*/
		} /*792*/
		$forall($1.barcode, function() { /*798*/
			var _E = $k[--$j]; /*795*/
			if ((_E < 48) || (_E > 57)) { /*797*/
				$k[$j++] = "bwipp.ean5badCharacter"; /*796*/
				$k[$j++] = "EAN-5 add-on must contain only digits"; /*796*/
				$0.raiseerror(); /*796*/
			} /*796*/
		}); /*796*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "112", "11"]); /*805*/
		$1.barchars = "0123456789"; /*808*/
		$1.mirrormaps = $a(["11000", "10100", "10010", "10001", "01100", "00110", "00011", "01010", "01001", "00101"]); /*814*/
		$1.checksum = 0; /*815*/
		for (var _H = 0; _H <= 4; _H += 1) { /*824*/
			$1.i = _H; /*817*/
			$1.barchar = $get($1.barcode, $1.i) - 48; /*818*/
			if (($1.i % 2) == 0) { /*822*/
				$1.checksum = ($1.barchar * 3) + $1.checksum; /*820*/
			} else { /*822*/
				$1.checksum = ($1.barchar * 9) + $1.checksum; /*822*/
			} /*822*/
		} /*822*/
		$1.checksum = $1.checksum % 10; /*825*/
		$1.mirrormap = $get($1.mirrormaps, $1.checksum); /*826*/
		$1.sbs = $s(31); /*828*/
		$1.txt = $a(5); /*829*/
		for (var _W = 0; _W <= 4; _W += 1) { /*859*/
			$1.i = _W; /*832*/
			if ($1.i == 0) { /*838*/
				$puti($1.sbs, 0, $get($1.encs, 10)); /*836*/
			} else { /*838*/
				$puti($1.sbs, (($1.i - 1) * 6) + 7, $get($1.encs, 11)); /*838*/
			} /*838*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*842*/
			$j--; /*843*/
			$1.indx = $k[--$j].length; /*844*/
			$j -= 2; /*845*/
			$1.enc = $get($1.encs, $1.indx); /*846*/
			if ($get($1.mirrormap, $1.i) == 49) { /*856*/
				$1.enclen = $1.enc.length; /*848*/
				$1.revenc = $s($1.enclen); /*849*/
				for (var _v = 0, _u = $1.enclen - 1; _v <= _u; _v += 1) { /*854*/
					$1.j = _v; /*851*/
					$1.char = $get($1.enc, $1.j); /*852*/
					$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*853*/
				} /*853*/
				$1.enc = $1.revenc; /*855*/
			} /*855*/
			$puti($1.sbs, ($1.i * 6) + 3, $1.enc); /*857*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 9) + 13) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*858*/
		} /*858*/
		$k[$j++] = Infinity; /*873*/
		$k[$j++] = "ren"; /*865*/
		$k[$j++] = $0.renlinear; /*865*/
		$k[$j++] = "sbs"; /*865*/
		$k[$j++] = Infinity; /*865*/
		var _1I = $1.sbs; /*864*/
		for (var _1J = 0, _1K = _1I.length; _1J < _1K; _1J++) { /*864*/
			$k[$j++] = $get(_1I, _1J) - 48; /*864*/
		} /*864*/
		var _1M = $a(); /*865*/
		$k[$j++] = _1M; /*866*/
		$k[$j++] = "bhs"; /*866*/
		$k[$j++] = Infinity; /*866*/
		for (var _1N = 0, _1O = 16; _1N < _1O; _1N++) { /*865*/
			$k[$j++] = $1.height; /*865*/
		} /*865*/
		var _1Q = $a(); /*866*/
		$k[$j++] = _1Q; /*867*/
		$k[$j++] = "bbs"; /*867*/
		$k[$j++] = Infinity; /*867*/
		for (var _1R = 0, _1S = 16; _1R < _1S; _1R++) { /*866*/
			$k[$j++] = 0; /*866*/
		} /*866*/
		var _1T = $a(); /*867*/
		$k[$j++] = _1T; /*869*/
		if ($1.includetext) { /*869*/
			$k[$j++] = "txt"; /*868*/
			$k[$j++] = $1.txt; /*868*/
		} /*868*/
		$k[$j++] = "opt"; /*873*/
		$k[$j++] = $1.options; /*873*/
		$k[$j++] = "guardrightpos"; /*873*/
		$k[$j++] = 10; /*873*/
		$k[$j++] = "guardrightypos"; /*873*/
		$k[$j++] = $1.textyoffset + 4; /*873*/
		$k[$j++] = "bordertop"; /*873*/
		$k[$j++] = 10; /*873*/
		var _1Y = $d(); /*873*/
		$k[$j++] = _1Y; /*876*/
		if (!$1.dontdraw) { /*876*/
			$0.renlinear(); /*876*/
		} /*876*/
	};
	$0.ean2 = function() {
		var $1 = {}; /*903*/
		$1.options = $k[--$j]; /*905*/
		$1.barcode = $k[--$j]; /*906*/
		$1.dontdraw = false; /*908*/
		$1.includetext = false; /*909*/
		$1.textfont = "Helvetica"; /*910*/
		$1.textsize = 12; /*911*/
		$1.textxoffset = 0; /*912*/
		$1.textyoffset = "unset"; /*913*/
		$1.height = 0.7; /*914*/
		$forall($1.options, function() { /*925*/
			var _3 = $k[--$j]; /*925*/
			$1[$k[--$j]] = _3; /*925*/
		}); /*925*/
		$1.textfont = "" + $1.textfont; /*927*/
		$1.textsize = +$1.textsize; /*928*/
		$1.height = +$1.height; /*929*/
		$1.textxoffset = +$1.textxoffset; /*930*/
		if ($eq($1.textyoffset, "unset")) { /*934*/
			$1.textyoffset = ($1.height * 72) + 1; /*932*/
		} else { /*934*/
			$1.textyoffset = +$1.textyoffset; /*934*/
		} /*934*/
		if ($1.barcode.length != 2) { /*940*/
			$k[$j++] = "bwipp.ean2badLength"; /*939*/
			$k[$j++] = "EAN-2 add-on must be 2 digits"; /*939*/
			$0.raiseerror(); /*939*/
		} /*939*/
		$forall($1.barcode, function() { /*945*/
			var _E = $k[--$j]; /*942*/
			if ((_E < 48) || (_E > 57)) { /*944*/
				$k[$j++] = "bwipp.ean2badCharacter"; /*943*/
				$k[$j++] = "EAN-2 add-on must contain only digits"; /*943*/
				$0.raiseerror(); /*943*/
			} /*943*/
		}); /*943*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "112", "11"]); /*952*/
		$1.barchars = "0123456789"; /*955*/
		$1.mirrormap = $get($a(["00", "01", "10", "11"]), (~~$z($geti($1.barcode, 0, 2))) % 4); /*958*/
		$1.sbs = $s(13); /*960*/
		$1.txt = $a(2); /*961*/
		for (var _M = 0; _M <= 1; _M += 1) { /*991*/
			$1.i = _M; /*964*/
			if ($1.i == 0) { /*970*/
				$puti($1.sbs, 0, $get($1.encs, 10)); /*968*/
			} else { /*970*/
				$puti($1.sbs, (($1.i - 1) * 6) + 7, $get($1.encs, 11)); /*970*/
			} /*970*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*974*/
			$j--; /*975*/
			$1.indx = $k[--$j].length; /*976*/
			$j -= 2; /*977*/
			$1.enc = $get($1.encs, $1.indx); /*978*/
			if ($get($1.mirrormap, $1.i) == 49) { /*988*/
				$1.enclen = $1.enc.length; /*980*/
				$1.revenc = $s($1.enclen); /*981*/
				for (var _l = 0, _k = $1.enclen - 1; _l <= _k; _l += 1) { /*986*/
					$1.j = _l; /*983*/
					$1.char = $get($1.enc, $1.j); /*984*/
					$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*985*/
				} /*985*/
				$1.enc = $1.revenc; /*987*/
			} /*987*/
			$puti($1.sbs, ($1.i * 6) + 3, $1.enc); /*989*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 9) + 13) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*990*/
		} /*990*/
		$k[$j++] = Infinity; /*1005*/
		$k[$j++] = "ren"; /*997*/
		$k[$j++] = $0.renlinear; /*997*/
		$k[$j++] = "sbs"; /*997*/
		$k[$j++] = Infinity; /*997*/
		var _18 = $1.sbs; /*996*/
		for (var _19 = 0, _1A = _18.length; _19 < _1A; _19++) { /*996*/
			$k[$j++] = $get(_18, _19) - 48; /*996*/
		} /*996*/
		var _1C = $a(); /*997*/
		$k[$j++] = _1C; /*998*/
		$k[$j++] = "bhs"; /*998*/
		$k[$j++] = Infinity; /*998*/
		for (var _1D = 0, _1E = 12; _1D < _1E; _1D++) { /*997*/
			$k[$j++] = $1.height; /*997*/
		} /*997*/
		var _1G = $a(); /*998*/
		$k[$j++] = _1G; /*999*/
		$k[$j++] = "bbs"; /*999*/
		$k[$j++] = Infinity; /*999*/
		for (var _1H = 0, _1I = 12; _1H < _1I; _1H++) { /*998*/
			$k[$j++] = 0; /*998*/
		} /*998*/
		var _1J = $a(); /*999*/
		$k[$j++] = _1J; /*1001*/
		if ($1.includetext) { /*1001*/
			$k[$j++] = "txt"; /*1000*/
			$k[$j++] = $1.txt; /*1000*/
		} /*1000*/
		$k[$j++] = "opt"; /*1005*/
		$k[$j++] = $1.options; /*1005*/
		$k[$j++] = "guardrightpos"; /*1005*/
		$k[$j++] = 10; /*1005*/
		$k[$j++] = "guardrightypos"; /*1005*/
		$k[$j++] = $1.textyoffset + 4; /*1005*/
		$k[$j++] = "bordertop"; /*1005*/
		$k[$j++] = 10; /*1005*/
		var _1O = $d(); /*1005*/
		$k[$j++] = _1O; /*1008*/
		if (!$1.dontdraw) { /*1008*/
			$0.renlinear(); /*1008*/
		} /*1008*/
	};
	$0.ean13 = function() {
		var $1 = {}; /*1037*/
		$1.options = $k[--$j]; /*1039*/
		$1.barcode = $k[--$j]; /*1040*/
		$1.dontdraw = false; /*1042*/
		$1.includetext = false; /*1043*/
		$1.textfont = "Helvetica"; /*1044*/
		$1.textsize = 12; /*1045*/
		$1.textxoffset = -10; /*1046*/
		$1.textyoffset = -4.5; /*1047*/
		$1.height = 1; /*1048*/
		$1.addongap = 12; /*1049*/
		$1.addontextfont = "unset"; /*1050*/
		$1.addontextsize = "unset"; /*1051*/
		$1.addontextxoffset = "unset"; /*1052*/
		$1.addontextyoffset = "unset"; /*1053*/
		$forall($1.options, function() { /*1064*/
			var _3 = $k[--$j]; /*1064*/
			$1[$k[--$j]] = _3; /*1064*/
		}); /*1064*/
		$1.textfont = "" + $1.textfont; /*1066*/
		$1.textsize = +$1.textsize; /*1067*/
		$1.textxoffset = +$1.textxoffset; /*1068*/
		$1.textyoffset = +$1.textyoffset; /*1069*/
		$1.height = +$1.height; /*1070*/
		$1.addongap = +$1.addongap; /*1071*/
		if ($ne($1.addontextfont, "unset")) { /*1072*/
			$1.addontextfont = "" + $1.addontextfont; /*1072*/
		} /*1072*/
		if ($ne($1.addontextsize, "unset")) { /*1073*/
			$1.addontextsize = +$1.addontextsize; /*1073*/
		} /*1073*/
		if ($ne($1.addontextxoffset, "unset")) { /*1074*/
			$1.addontextxoffset = +$1.addontextxoffset; /*1074*/
		} /*1074*/
		if ($ne($1.addontextyoffset, "unset")) { /*1075*/
			$1.addontextyoffset = +$1.addontextyoffset; /*1075*/
		} /*1075*/
		$search($1.barcode, " "); /*1078*/
		if ($k[--$j]) { /*1084*/
			$1.barcode = $k[--$j]; /*1079*/
			$j--; /*1080*/
			$1.addon = $k[--$j]; /*1081*/
		} else { /*1084*/
			$j--; /*1083*/
			$1.addon = ""; /*1084*/
		} /*1084*/
		if (($1.barcode.length != 12) && ($1.barcode.length != 13)) { /*1090*/
			$k[$j++] = "bwipp.ean13badLength"; /*1089*/
			$k[$j++] = "EAN-13 must be 12 or 13 digits"; /*1089*/
			$0.raiseerror(); /*1089*/
		} /*1089*/
		$forall($1.barcode, function() { /*1095*/
			var _Q = $k[--$j]; /*1092*/
			if ((_Q < 48) || (_Q > 57)) { /*1094*/
				$k[$j++] = "bwipp.ean13badCharacter"; /*1093*/
				$k[$j++] = "EAN-13 must contain only digits"; /*1093*/
				$0.raiseerror(); /*1093*/
			} /*1093*/
		}); /*1093*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1098*/
			$k[$j++] = "bwipp.ean13badAddOnLength"; /*1097*/
			$k[$j++] = "Add-on for EAN-13 must be 2 or 5 digits"; /*1097*/
			$0.raiseerror(); /*1097*/
		} /*1097*/
		$1.pad = $s(13); /*1101*/
		$1.checksum = 0; /*1102*/
		for (var _V = 0; _V <= 11; _V += 1) { /*1111*/
			$1.i = _V; /*1104*/
			$1.barchar = $get($1.barcode, $1.i) - 48; /*1105*/
			if (($1.i % 2) == 0) { /*1109*/
				$1.checksum = $1.barchar + $1.checksum; /*1107*/
			} else { /*1109*/
				$1.checksum = ($1.barchar * 3) + $1.checksum; /*1109*/
			} /*1109*/
		} /*1109*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1112*/
		if ($1.barcode.length == 13) { /*1117*/
			if ($get($1.barcode, 12) != ($1.checksum + 48)) { /*1116*/
				$k[$j++] = "bwipp.ean13badCheckDigit"; /*1115*/
				$k[$j++] = "Incorrect EAN-13 check digit provided"; /*1115*/
				$0.raiseerror(); /*1115*/
			} /*1115*/
		} /*1115*/
		$puti($1.pad, 0, $1.barcode); /*1118*/
		$put($1.pad, 12, $1.checksum + 48); /*1119*/
		$1.barcode = $1.pad; /*1120*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "11111", "111"]); /*1127*/
		$1.barchars = "0123456789"; /*1130*/
		$1.mirrormaps = $a(["000000", "001011", "001101", "001110", "010011", "011001", "011100", "010101", "010110", "011010"]); /*1136*/
		$1.sbs = $s(59); /*1138*/
		$1.txt = $a(13); /*1139*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*1142*/
		$1.mirrormap = $get($1.mirrormaps, $get($1.barcode, 0) - 48); /*1145*/
		$put($1.txt, 0, $a([$geti($1.barcode, 0, 1), $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1146*/
		for (var _17 = 1; _17 <= 6; _17 += 1) { /*1169*/
			$1.i = _17; /*1151*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1152*/
			$j--; /*1153*/
			$1.indx = $k[--$j].length; /*1154*/
			$j -= 2; /*1155*/
			$1.enc = $get($1.encs, $1.indx); /*1156*/
			if ($get($1.mirrormap, $1.i - 1) == 49) { /*1166*/
				$1.enclen = $1.enc.length; /*1158*/
				$1.revenc = $s($1.enclen); /*1159*/
				for (var _1O = 0, _1N = $1.enclen - 1; _1O <= _1N; _1O += 1) { /*1164*/
					$1.j = _1O; /*1161*/
					$1.char = $get($1.enc, $1.j); /*1162*/
					$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*1163*/
				} /*1163*/
				$1.enc = $1.revenc; /*1165*/
			} /*1165*/
			$puti($1.sbs, (($1.i - 1) * 4) + 3, $1.enc); /*1167*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 7) + 14) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1168*/
		} /*1168*/
		$puti($1.sbs, ((7 - 1) * 4) + 3, $get($1.encs, 11)); /*1172*/
		for (var _1o = 7; _1o <= 12; _1o += 1) { /*1185*/
			$1.i = _1o; /*1177*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1178*/
			$j--; /*1179*/
			$1.indx = $k[--$j].length; /*1180*/
			$j -= 2; /*1181*/
			$1.enc = $get($1.encs, $1.indx); /*1182*/
			$puti($1.sbs, (($1.i - 1) * 4) + 8, $1.enc); /*1183*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 7) + 18) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1184*/
		} /*1184*/
		$puti($1.sbs, 56, $get($1.encs, 12)); /*1188*/
		$k[$j++] = Infinity; /*1190*/
		var _2E = $1.sbs; /*1190*/
		for (var _2F = 0, _2G = _2E.length; _2F < _2G; _2F++) { /*1190*/
			$k[$j++] = $get(_2E, _2F) - 48; /*1190*/
		} /*1190*/
		$1.sbs = $a(); /*1190*/
		if ($1.includetext) { /*1197*/
			$k[$j++] = Infinity; /*1192*/
			$k[$j++] = $1.height; /*1192*/
			$k[$j++] = $1.height; /*1192*/
			for (var _2M = 0, _2N = 12; _2M < _2N; _2M++) { /*1192*/
				$k[$j++] = $1.height - 0.075; /*1192*/
			} /*1192*/
			$k[$j++] = $1.height; /*1192*/
			$k[$j++] = $1.height; /*1192*/
			for (var _2R = 0, _2S = 12; _2R < _2S; _2R++) { /*1192*/
				$k[$j++] = $1.height - 0.075; /*1192*/
			} /*1192*/
			$k[$j++] = $1.height; /*1192*/
			$k[$j++] = $1.height; /*1192*/
			$1.bhs = $a(); /*1192*/
			$k[$j++] = Infinity; /*1193*/
			$k[$j++] = 0; /*1193*/
			$k[$j++] = 0; /*1193*/
			for (var _2X = 0, _2Y = 12; _2X < _2Y; _2X++) { /*1193*/
				$k[$j++] = 0.075; /*1193*/
			} /*1193*/
			$k[$j++] = 0; /*1193*/
			$k[$j++] = 0; /*1193*/
			for (var _2Z = 0, _2a = 12; _2Z < _2a; _2Z++) { /*1193*/
				$k[$j++] = 0.075; /*1193*/
			} /*1193*/
			$k[$j++] = 0; /*1193*/
			$k[$j++] = 0; /*1193*/
			$1.bbs = $a(); /*1193*/
		} else { /*1197*/
			$k[$j++] = Infinity; /*1195*/
			for (var _2c = 0, _2d = 30; _2c < _2d; _2c++) { /*1195*/
				$k[$j++] = $1.height; /*1195*/
			} /*1195*/
			$1.bhs = $a(); /*1195*/
			$k[$j++] = Infinity; /*1196*/
			for (var _2g = 0, _2h = 30; _2g < _2h; _2g++) { /*1196*/
				$k[$j++] = 0; /*1196*/
			} /*1196*/
			$1.bbs = $a(); /*1196*/
			$1.txt = $a([]); /*1197*/
		} /*1197*/
		$1.guardrightypos = 0; /*1199*/
		if ($ne($1.addon, "")) { /*1220*/
			$k[$j++] = "addopts"; /*1210*/
			$k[$j++] = Infinity; /*1210*/
			$k[$j++] = "dontdraw"; /*1207*/
			$k[$j++] = true; /*1207*/
			$k[$j++] = "includetext"; /*1207*/
			$k[$j++] = true; /*1207*/
			$k[$j++] = "height"; /*1207*/
			$k[$j++] = $1.height - 0.15; /*1207*/
			$k[$j++] = "textxoffset"; /*1207*/
			if ($1.addontextxoffset != "unset") { /*1207*/
				$k[$j++] = $1.addontextxoffset; /*1207*/
			} else { /*1207*/
				$k[$j++] = 95 + $1.addongap; /*1207*/
			} /*1207*/
			if ($1.addontextyoffset != "unset") { /*1208*/
				$k[$j++] = "textyoffset"; /*1208*/
				$k[$j++] = $1.addontextyoffset; /*1208*/
			} /*1208*/
			var _2s = ($1.addontextsize != "unset") ? $1.addontextsize : $1.textsize; /*1209*/
			var _2u = $ne($1.addontextfont, "unset") ? $1.addontextfont : $1.textfont; /*1210*/
			$k[$j++] = "textsize"; /*1210*/
			$k[$j++] = _2s; /*1210*/
			$k[$j++] = "textfont"; /*1210*/
			$k[$j++] = _2u; /*1210*/
			var _2v = $d(); /*1210*/
			$1[$k[--$j]] = _2v; /*1211*/
			if ($1.addon.length == 2) { /*1212*/
				$k[$j++] = $1.addon; /*1212*/
				$k[$j++] = $1.addopts; /*1212*/
				$0.ean2(); /*1212*/
			} /*1212*/
			if ($1.addon.length == 5) { /*1213*/
				$k[$j++] = $1.addon; /*1213*/
				$k[$j++] = $1.addopts; /*1213*/
				$0.ean5(); /*1213*/
			} /*1213*/
			$1.addcode = $k[--$j]; /*1214*/
			$k[$j++] = Infinity; /*1215*/
			$aload($1.sbs); /*1215*/
			$k[$j++] = $1.addongap; /*1215*/
			$aload($1.addcode.sbs); /*1215*/
			$1.sbs = $a(); /*1215*/
			$k[$j++] = Infinity; /*1216*/
			$aload($1.bhs); /*1216*/
			$forall($1.addcode.bhs, function() { /*1216*/
				var _3C = $k[--$j]; /*1216*/
				$k[$j++] = _3C - 0.075; /*1216*/
			}); /*1216*/
			$1.bhs = $a(); /*1216*/
			$k[$j++] = Infinity; /*1217*/
			$aload($1.bbs); /*1217*/
			$forall($1.addcode.bbs, function() { /*1217*/
				var _3H = $k[--$j]; /*1217*/
				$k[$j++] = _3H + 0.075; /*1217*/
			}); /*1217*/
			$1.bbs = $a(); /*1217*/
			$k[$j++] = Infinity; /*1218*/
			$aload($1.txt); /*1218*/
			$aload($1.addcode.txt); /*1218*/
			$1.txt = $a(); /*1218*/
			$1.guardrightypos = ($1.height * 72) - 6; /*1219*/
		} /*1219*/
		var _3U = {
			ren: $0.renlinear,
			sbs: $1.sbs,
			bhs: $1.bhs,
			bbs: $1.bbs,
			txt: $1.txt,
			opt: $1.options,
			guardrightpos: 10,
			guardrightypos: $1.guardrightypos,
			borderbottom: 5
		}; /*1232*/
		$k[$j++] = _3U; /*1235*/
		if (!$1.dontdraw) { /*1235*/
			$0.renlinear(); /*1235*/
		} /*1235*/
	};
	$0.ean8 = function() {
		var $1 = {}; /*1264*/
		$1.options = $k[--$j]; /*1266*/
		$1.barcode = $k[--$j]; /*1267*/
		$1.dontdraw = false; /*1269*/
		$1.includetext = false; /*1270*/
		$1.textfont = "Helvetica"; /*1271*/
		$1.textsize = 12; /*1272*/
		$1.textxoffset = 4; /*1273*/
		$1.textyoffset = -4.5; /*1274*/
		$1.height = 1; /*1275*/
		$1.addongap = 12; /*1276*/
		$1.addontextfont = "unset"; /*1277*/
		$1.addontextsize = "unset"; /*1278*/
		$1.addontextxoffset = "unset"; /*1279*/
		$1.addontextyoffset = "unset"; /*1280*/
		$forall($1.options, function() { /*1291*/
			var _3 = $k[--$j]; /*1291*/
			$1[$k[--$j]] = _3; /*1291*/
		}); /*1291*/
		$1.textfont = "" + $1.textfont; /*1293*/
		$1.textsize = +$1.textsize; /*1294*/
		$1.textxoffset = +$1.textxoffset; /*1295*/
		$1.textyoffset = +$1.textyoffset; /*1296*/
		$1.height = +$1.height; /*1297*/
		$1.addongap = +$1.addongap; /*1298*/
		if ($ne($1.addontextfont, "unset")) { /*1299*/
			$1.addontextfont = "" + $1.addontextfont; /*1299*/
		} /*1299*/
		if ($ne($1.addontextsize, "unset")) { /*1300*/
			$1.addontextsize = +$1.addontextsize; /*1300*/
		} /*1300*/
		if ($ne($1.addontextxoffset, "unset")) { /*1301*/
			$1.addontextxoffset = +$1.addontextxoffset; /*1301*/
		} /*1301*/
		if ($ne($1.addontextyoffset, "unset")) { /*1302*/
			$1.addontextyoffset = +$1.addontextyoffset; /*1302*/
		} /*1302*/
		$search($1.barcode, " "); /*1305*/
		if ($k[--$j]) { /*1311*/
			$1.barcode = $k[--$j]; /*1306*/
			$j--; /*1307*/
			$1.addon = $k[--$j]; /*1308*/
		} else { /*1311*/
			$j--; /*1310*/
			$1.addon = ""; /*1311*/
		} /*1311*/
		if (($1.barcode.length != 7) && ($1.barcode.length != 8)) { /*1317*/
			$k[$j++] = "bwipp.ean8badLength"; /*1316*/
			$k[$j++] = "EAN-8 must be 7 or 8 digits"; /*1316*/
			$0.raiseerror(); /*1316*/
		} /*1316*/
		$forall($1.barcode, function() { /*1322*/
			var _Q = $k[--$j]; /*1319*/
			if ((_Q < 48) || (_Q > 57)) { /*1321*/
				$k[$j++] = "bwipp.ean8badCharacter"; /*1320*/
				$k[$j++] = "EAN-8 must contain only digits"; /*1320*/
				$0.raiseerror(); /*1320*/
			} /*1320*/
		}); /*1320*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1325*/
			$k[$j++] = "bwipp.ean8badAddOnLength"; /*1324*/
			$k[$j++] = "Add-on for EAN-8 must be 2 or 5 digits"; /*1324*/
			$0.raiseerror(); /*1324*/
		} /*1324*/
		$1.pad = $s(8); /*1328*/
		$1.checksum = 0; /*1329*/
		for (var _V = 0; _V <= 6; _V += 1) { /*1338*/
			$1.i = _V; /*1331*/
			$1.barchar = $get($1.barcode, $1.i) - 48; /*1332*/
			if (($1.i % 2) != 0) { /*1336*/
				$1.checksum = $1.barchar + $1.checksum; /*1334*/
			} else { /*1336*/
				$1.checksum = ($1.barchar * 3) + $1.checksum; /*1336*/
			} /*1336*/
		} /*1336*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1339*/
		if ($1.barcode.length == 8) { /*1344*/
			if ($get($1.barcode, 7) != ($1.checksum + 48)) { /*1343*/
				$k[$j++] = "bwipp.ean8badCheckDigit"; /*1342*/
				$k[$j++] = "Incorrect EAN-8 check digit provided"; /*1342*/
				$0.raiseerror(); /*1342*/
			} /*1342*/
		} /*1342*/
		$puti($1.pad, 0, $1.barcode); /*1345*/
		$put($1.pad, 7, $1.checksum + 48); /*1346*/
		$1.barcode = $1.pad; /*1347*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "11111", "111"]); /*1354*/
		$1.barchars = "0123456789"; /*1357*/
		$1.sbs = $s(43); /*1359*/
		$1.txt = $a(8); /*1360*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*1363*/
		for (var _u = 0; _u <= 3; _u += 1) { /*1376*/
			$1.i = _u; /*1368*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1369*/
			$j--; /*1370*/
			$1.indx = $k[--$j].length; /*1371*/
			$j -= 2; /*1372*/
			$1.enc = $get($1.encs, $1.indx); /*1373*/
			$puti($1.sbs, ($1.i * 4) + 3, $1.enc); /*1374*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 7) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1375*/
		} /*1375*/
		$puti($1.sbs, (4 * 4) + 3, $get($1.encs, 11)); /*1379*/
		for (var _1K = 4; _1K <= 7; _1K += 1) { /*1392*/
			$1.i = _1K; /*1384*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1385*/
			$j--; /*1386*/
			$1.indx = $k[--$j].length; /*1387*/
			$j -= 2; /*1388*/
			$1.enc = $get($1.encs, $1.indx); /*1389*/
			$puti($1.sbs, ($1.i * 4) + 8, $1.enc); /*1390*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 7) + $1.textxoffset) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*1391*/
		} /*1391*/
		$puti($1.sbs, 40, $get($1.encs, 12)); /*1395*/
		$k[$j++] = Infinity; /*1397*/
		var _1k = $1.sbs; /*1397*/
		for (var _1l = 0, _1m = _1k.length; _1l < _1m; _1l++) { /*1397*/
			$k[$j++] = $get(_1k, _1l) - 48; /*1397*/
		} /*1397*/
		$1.sbs = $a(); /*1397*/
		if ($1.includetext) { /*1404*/
			$k[$j++] = Infinity; /*1399*/
			$k[$j++] = $1.height; /*1399*/
			$k[$j++] = $1.height; /*1399*/
			for (var _1s = 0, _1t = 8; _1s < _1t; _1s++) { /*1399*/
				$k[$j++] = $1.height - 0.075; /*1399*/
			} /*1399*/
			$k[$j++] = $1.height; /*1399*/
			$k[$j++] = $1.height; /*1399*/
			for (var _1x = 0, _1y = 8; _1x < _1y; _1x++) { /*1399*/
				$k[$j++] = $1.height - 0.075; /*1399*/
			} /*1399*/
			$k[$j++] = $1.height; /*1399*/
			$k[$j++] = $1.height; /*1399*/
			$1.bhs = $a(); /*1399*/
			$k[$j++] = Infinity; /*1400*/
			$k[$j++] = 0; /*1400*/
			$k[$j++] = 0; /*1400*/
			for (var _23 = 0, _24 = 8; _23 < _24; _23++) { /*1400*/
				$k[$j++] = 0.075; /*1400*/
			} /*1400*/
			$k[$j++] = 0; /*1400*/
			$k[$j++] = 0; /*1400*/
			for (var _25 = 0, _26 = 8; _25 < _26; _25++) { /*1400*/
				$k[$j++] = 0.075; /*1400*/
			} /*1400*/
			$k[$j++] = 0; /*1400*/
			$k[$j++] = 0; /*1400*/
			$1.bbs = $a(); /*1400*/
		} else { /*1404*/
			$k[$j++] = Infinity; /*1402*/
			for (var _28 = 0, _29 = 22; _28 < _29; _28++) { /*1402*/
				$k[$j++] = $1.height; /*1402*/
			} /*1402*/
			$1.bhs = $a(); /*1402*/
			$k[$j++] = Infinity; /*1403*/
			for (var _2C = 0, _2D = 22; _2C < _2D; _2C++) { /*1403*/
				$k[$j++] = 0; /*1403*/
			} /*1403*/
			$1.bbs = $a(); /*1403*/
			$1.txt = $a([]); /*1404*/
		} /*1404*/
		$1.guardrightypos = 0; /*1406*/
		if ($ne($1.addon, "")) { /*1427*/
			$k[$j++] = "addopts"; /*1417*/
			$k[$j++] = Infinity; /*1417*/
			$k[$j++] = "dontdraw"; /*1414*/
			$k[$j++] = true; /*1414*/
			$k[$j++] = "includetext"; /*1414*/
			$k[$j++] = true; /*1414*/
			$k[$j++] = "height"; /*1414*/
			$k[$j++] = $1.height - 0.15; /*1414*/
			$k[$j++] = "textxoffset"; /*1414*/
			if ($1.addontextxoffset != "unset") { /*1414*/
				$k[$j++] = $1.addontextxoffset; /*1414*/
			} else { /*1414*/
				$k[$j++] = 67 + $1.addongap; /*1414*/
			} /*1414*/
			if ($1.addontextyoffset != "unset") { /*1415*/
				$k[$j++] = "textyoffset"; /*1415*/
				$k[$j++] = $1.addontextyoffset; /*1415*/
			} /*1415*/
			var _2O = ($1.addontextsize != "unset") ? $1.addontextsize : $1.textsize; /*1416*/
			var _2Q = $ne($1.addontextfont, "unset") ? $1.addontextfont : $1.textfont; /*1417*/
			$k[$j++] = "textsize"; /*1417*/
			$k[$j++] = _2O; /*1417*/
			$k[$j++] = "textfont"; /*1417*/
			$k[$j++] = _2Q; /*1417*/
			var _2R = $d(); /*1417*/
			$1[$k[--$j]] = _2R; /*1418*/
			if ($1.addon.length == 2) { /*1419*/
				$k[$j++] = $1.addon; /*1419*/
				$k[$j++] = $1.addopts; /*1419*/
				$0.ean2(); /*1419*/
			} /*1419*/
			if ($1.addon.length == 5) { /*1420*/
				$k[$j++] = $1.addon; /*1420*/
				$k[$j++] = $1.addopts; /*1420*/
				$0.ean5(); /*1420*/
			} /*1420*/
			$1.addcode = $k[--$j]; /*1421*/
			$k[$j++] = Infinity; /*1422*/
			$aload($1.sbs); /*1422*/
			$k[$j++] = $1.addongap; /*1422*/
			$aload($1.addcode.sbs); /*1422*/
			$1.sbs = $a(); /*1422*/
			$k[$j++] = Infinity; /*1423*/
			$aload($1.bhs); /*1423*/
			$forall($1.addcode.bhs, function() { /*1423*/
				var _2i = $k[--$j]; /*1423*/
				$k[$j++] = _2i - 0.075; /*1423*/
			}); /*1423*/
			$1.bhs = $a(); /*1423*/
			$k[$j++] = Infinity; /*1424*/
			$aload($1.bbs); /*1424*/
			$forall($1.addcode.bbs, function() { /*1424*/
				var _2n = $k[--$j]; /*1424*/
				$k[$j++] = _2n + 0.075; /*1424*/
			}); /*1424*/
			$1.bbs = $a(); /*1424*/
			$k[$j++] = Infinity; /*1425*/
			$aload($1.txt); /*1425*/
			$aload($1.addcode.txt); /*1425*/
			$1.txt = $a(); /*1425*/
			$1.guardrightypos = ($1.height * 72) - 6; /*1426*/
		} /*1426*/
		var _30 = {
			ren: $0.renlinear,
			sbs: $1.sbs,
			bhs: $1.bhs,
			bbs: $1.bbs,
			txt: $1.txt,
			opt: $1.options,
			guardleftpos: 10,
			guardrightpos: 10,
			guardrightypos: $1.guardrightypos,
			borderbottom: 5
		}; /*1440*/
		$k[$j++] = _30; /*1443*/
		if (!$1.dontdraw) { /*1443*/
			$0.renlinear(); /*1443*/
		} /*1443*/
	};
	$0.upca = function() {
		var $1 = {}; /*1472*/
		$1.options = $k[--$j]; /*1474*/
		$1.barcode = $k[--$j]; /*1475*/
		$1.dontdraw = false; /*1477*/
		$1.includetext = false; /*1478*/
		$1.textfont = "Helvetica"; /*1479*/
		$1.textsize = 12; /*1480*/
		$1.textxoffset = -7; /*1481*/
		$1.textyoffset = -4.5; /*1482*/
		$1.height = 1; /*1483*/
		$1.addongap = 12; /*1484*/
		$1.addontextfont = "unset"; /*1485*/
		$1.addontextsize = "unset"; /*1486*/
		$1.addontextxoffset = "unset"; /*1487*/
		$1.addontextyoffset = "unset"; /*1488*/
		$forall($1.options, function() { /*1499*/
			var _3 = $k[--$j]; /*1499*/
			$1[$k[--$j]] = _3; /*1499*/
		}); /*1499*/
		$1.textfont = "" + $1.textfont; /*1501*/
		$1.textsize = +$1.textsize; /*1502*/
		$1.textxoffset = +$1.textxoffset; /*1503*/
		$1.textyoffset = +$1.textyoffset; /*1504*/
		$1.height = +$1.height; /*1505*/
		$1.addongap = +$1.addongap; /*1506*/
		if ($ne($1.addontextfont, "unset")) { /*1507*/
			$1.addontextfont = "" + $1.addontextfont; /*1507*/
		} /*1507*/
		if ($ne($1.addontextsize, "unset")) { /*1508*/
			$1.addontextsize = +$1.addontextsize; /*1508*/
		} /*1508*/
		if ($ne($1.addontextxoffset, "unset")) { /*1509*/
			$1.addontextxoffset = +$1.addontextxoffset; /*1509*/
		} /*1509*/
		if ($ne($1.addontextyoffset, "unset")) { /*1510*/
			$1.addontextyoffset = +$1.addontextyoffset; /*1510*/
		} /*1510*/
		$search($1.barcode, " "); /*1513*/
		if ($k[--$j]) { /*1519*/
			$1.barcode = $k[--$j]; /*1514*/
			$j--; /*1515*/
			$1.addon = $k[--$j]; /*1516*/
		} else { /*1519*/
			$j--; /*1518*/
			$1.addon = ""; /*1519*/
		} /*1519*/
		if (($1.barcode.length == 7) || ($1.barcode.length == 8)) { /*1565*/
			$forall($1.barcode, function() { /*1529*/
				var _Q = $k[--$j]; /*1526*/
				if ((_Q < 48) || (_Q > 57)) { /*1528*/
					$k[$j++] = "bwipp.upcAupcEbadCharacter"; /*1527*/
					$k[$j++] = "UPC-E must contain only digits"; /*1527*/
					$0.raiseerror(); /*1527*/
				} /*1527*/
			}); /*1527*/
			var _S = $get($1.barcode, 0); /*1530*/
			if ((_S != 48) && (_S != 49)) { /*1532*/
				$k[$j++] = "bwipp.upcAupcEbadNumberSystem"; /*1531*/
				$k[$j++] = "UPC-E must have number system 0 or 1"; /*1531*/
				$0.raiseerror(); /*1531*/
			} /*1531*/
			for (var _T = 0, _U = 1; _T < _U; _T++) { /*1560*/
				var _W = ($1.barcode.length == 8) ? 12 : 11; /*1534*/
				$1.upcacode = $s(_W); /*1534*/
				if (($get($1.barcode, 6) - 48) <= 2) { /*1541*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 3)); /*1536*/
					$puti($1.upcacode, 3, $geti($1.barcode, 6, 1)); /*1537*/
					$puti($1.upcacode, 4, "0000"); /*1538*/
					$puti($1.upcacode, 8, $geti($1.barcode, 3, 3)); /*1539*/
					break; /*1540*/
				} /*1540*/
				if (($get($1.barcode, 6) - 48) == 3) { /*1547*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 4)); /*1543*/
					$puti($1.upcacode, 4, "00000"); /*1544*/
					$puti($1.upcacode, 9, $geti($1.barcode, 4, 2)); /*1545*/
					break; /*1546*/
				} /*1546*/
				if (($get($1.barcode, 6) - 48) == 4) { /*1553*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 5)); /*1549*/
					$puti($1.upcacode, 5, "00000"); /*1550*/
					$puti($1.upcacode, 10, $geti($1.barcode, 5, 1)); /*1551*/
					break; /*1552*/
				} /*1552*/
				if (($get($1.barcode, 6) - 48) >= 5) { /*1559*/
					$puti($1.upcacode, 0, $geti($1.barcode, 0, 6)); /*1555*/
					$puti($1.upcacode, 6, "0000"); /*1556*/
					$puti($1.upcacode, 10, $geti($1.barcode, 6, 1)); /*1557*/
					break; /*1558*/
				} /*1558*/
			} /*1558*/
			if ($1.barcode.length == 8) { /*1563*/
				$puti($1.upcacode, 11, $geti($1.barcode, 7, 1)); /*1562*/
			} /*1562*/
			$1.barcode = $1.upcacode; /*1564*/
		} /*1564*/
		if (($1.barcode.length != 11) && ($1.barcode.length != 12)) { /*1570*/
			$k[$j++] = "bwipp.upcAbadLength"; /*1569*/
			$k[$j++] = "UPC-A must be 11 or 12 digits"; /*1569*/
			$0.raiseerror(); /*1569*/
		} /*1569*/
		var _1I = $1.barcode; /*1571*/
		for (var _1J = 0, _1K = _1I.length; _1J < _1K; _1J++) { /*1575*/
			var _1L = $get(_1I, _1J); /*1575*/
			if ((_1L < 48) || (_1L > 57)) { /*1574*/
				$k[$j++] = "bwipp.upcAbadCharacter"; /*1573*/
				$k[$j++] = "UPC-A must contain only digits"; /*1573*/
				$0.raiseerror(); /*1573*/
			} /*1573*/
		} /*1573*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1578*/
			$k[$j++] = "bwipp.upcAbadAddOnLength"; /*1577*/
			$k[$j++] = "Add-on for UPC-A must be 2 or 5 digits"; /*1577*/
			$0.raiseerror(); /*1577*/
		} /*1577*/
		$1.pad = $s(12); /*1581*/
		$1.checksum = 0; /*1582*/
		for (var _1Q = 0; _1Q <= 10; _1Q += 1) { /*1591*/
			$1.i = _1Q; /*1584*/
			$1.barchar = $get($1.barcode, $1.i) - 48; /*1585*/
			if (($1.i % 2) != 0) { /*1589*/
				$1.checksum = $1.checksum + $1.barchar; /*1587*/
			} else { /*1589*/
				$1.checksum = $1.checksum + ($1.barchar * 3); /*1589*/
			} /*1589*/
		} /*1589*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1592*/
		if ($1.barcode.length == 12) { /*1597*/
			if ($get($1.barcode, 11) != ($1.checksum + 48)) { /*1596*/
				$k[$j++] = "bwipp.upcAbadCheckDigit"; /*1595*/
				$k[$j++] = "Incorrect UPC check digit provided"; /*1595*/
				$0.raiseerror(); /*1595*/
			} /*1595*/
		} /*1595*/
		$puti($1.pad, 0, $1.barcode); /*1598*/
		$put($1.pad, 11, $1.checksum + 48); /*1599*/
		$1.barcode = $1.pad; /*1600*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "11111", "111"]); /*1607*/
		$1.barchars = "0123456789"; /*1610*/
		$1.sbs = $s(59); /*1612*/
		$1.txt = $a(12); /*1613*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*1616*/
		for (var _1p = 0; _1p <= 5; _1p += 1) { /*1633*/
			$1.i = _1p; /*1621*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1622*/
			$j--; /*1623*/
			$1.indx = $k[--$j].length; /*1624*/
			$j -= 2; /*1625*/
			$1.enc = $get($1.encs, $1.indx); /*1626*/
			$puti($1.sbs, ($1.i * 4) + 3, $1.enc); /*1627*/
			if ($1.i == 0) { /*1631*/
				$put($1.txt, 0, $a([$geti($1.barcode, 0, 1), $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1629*/
			} else { /*1631*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 7) + 11) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1631*/
			} /*1631*/
		} /*1631*/
		$puti($1.sbs, (6 * 4) + 3, $get($1.encs, 11)); /*1636*/
		for (var _2O = 6; _2O <= 11; _2O += 1) { /*1653*/
			$1.i = _2O; /*1641*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1642*/
			$j--; /*1643*/
			$1.indx = $k[--$j].length; /*1644*/
			$j -= 2; /*1645*/
			$1.enc = $get($1.encs, $1.indx); /*1646*/
			$puti($1.sbs, ($1.i * 4) + 8, $1.enc); /*1647*/
			if ($1.i == 11) { /*1651*/
				$put($1.txt, 11, $a([$geti($1.barcode, 11, 1), $1.textxoffset + 103, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1649*/
			} else { /*1651*/
				$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 7) + $1.textxoffset) + 15, $1.textyoffset, $1.textfont, $1.textsize])); /*1651*/
			} /*1651*/
		} /*1651*/
		$puti($1.sbs, 56, $get($1.encs, 12)); /*1656*/
		$k[$j++] = Infinity; /*1658*/
		var _2x = $1.sbs; /*1658*/
		for (var _2y = 0, _2z = _2x.length; _2y < _2z; _2y++) { /*1658*/
			$k[$j++] = $get(_2x, _2y) - 48; /*1658*/
		} /*1658*/
		$1.sbs = $a(); /*1658*/
		if ($1.includetext) { /*1665*/
			$k[$j++] = Infinity; /*1660*/
			for (var _33 = 0, _34 = 4; _33 < _34; _33++) { /*1660*/
				$k[$j++] = $1.height; /*1660*/
			} /*1660*/
			for (var _36 = 0, _37 = 10; _36 < _37; _36++) { /*1660*/
				$k[$j++] = $1.height - 0.075; /*1660*/
			} /*1660*/
			$k[$j++] = $1.height; /*1660*/
			$k[$j++] = $1.height; /*1660*/
			for (var _3B = 0, _3C = 10; _3B < _3C; _3B++) { /*1660*/
				$k[$j++] = $1.height - 0.075; /*1660*/
			} /*1660*/
			for (var _3E = 0, _3F = 4; _3E < _3F; _3E++) { /*1660*/
				$k[$j++] = $1.height; /*1660*/
			} /*1660*/
			$1.bhs = $a(); /*1660*/
			$k[$j++] = Infinity; /*1661*/
			$k[$j++] = 0; /*1661*/
			$k[$j++] = 0; /*1661*/
			$k[$j++] = 0; /*1661*/
			$k[$j++] = 0; /*1661*/
			for (var _3I = 0, _3J = 10; _3I < _3J; _3I++) { /*1661*/
				$k[$j++] = 0.075; /*1661*/
			} /*1661*/
			$k[$j++] = 0; /*1661*/
			$k[$j++] = 0; /*1661*/
			for (var _3K = 0, _3L = 10; _3K < _3L; _3K++) { /*1661*/
				$k[$j++] = 0.075; /*1661*/
			} /*1661*/
			$k[$j++] = 0; /*1661*/
			$k[$j++] = 0; /*1661*/
			$k[$j++] = 0; /*1661*/
			$k[$j++] = 0; /*1661*/
			$1.bbs = $a(); /*1661*/
		} else { /*1665*/
			$k[$j++] = Infinity; /*1663*/
			for (var _3N = 0, _3O = 30; _3N < _3O; _3N++) { /*1663*/
				$k[$j++] = $1.height; /*1663*/
			} /*1663*/
			$1.bhs = $a(); /*1663*/
			$k[$j++] = Infinity; /*1664*/
			for (var _3R = 0, _3S = 30; _3R < _3S; _3R++) { /*1664*/
				$k[$j++] = 0; /*1664*/
			} /*1664*/
			$1.bbs = $a(); /*1664*/
			$1.txt = $a([]); /*1665*/
		} /*1665*/
		$1.guardrightypos = 0; /*1667*/
		if ($ne($1.addon, "")) { /*1688*/
			$k[$j++] = "addopts"; /*1678*/
			$k[$j++] = Infinity; /*1678*/
			$k[$j++] = "dontdraw"; /*1675*/
			$k[$j++] = true; /*1675*/
			$k[$j++] = "includetext"; /*1675*/
			$k[$j++] = true; /*1675*/
			$k[$j++] = "height"; /*1675*/
			$k[$j++] = $1.height - 0.15; /*1675*/
			$k[$j++] = "textxoffset"; /*1675*/
			if ($1.addontextxoffset != "unset") { /*1675*/
				$k[$j++] = $1.addontextxoffset; /*1675*/
			} else { /*1675*/
				$k[$j++] = 95 + $1.addongap; /*1675*/
			} /*1675*/
			if ($1.addontextyoffset != "unset") { /*1676*/
				$k[$j++] = "textyoffset"; /*1676*/
				$k[$j++] = $1.addontextyoffset; /*1676*/
			} /*1676*/
			var _3d = ($1.addontextsize != "unset") ? $1.addontextsize : $1.textsize; /*1677*/
			var _3f = $ne($1.addontextfont, "unset") ? $1.addontextfont : $1.textfont; /*1678*/
			$k[$j++] = "textsize"; /*1678*/
			$k[$j++] = _3d; /*1678*/
			$k[$j++] = "textfont"; /*1678*/
			$k[$j++] = _3f; /*1678*/
			var _3g = $d(); /*1678*/
			$1[$k[--$j]] = _3g; /*1679*/
			if ($1.addon.length == 2) { /*1680*/
				$k[$j++] = $1.addon; /*1680*/
				$k[$j++] = $1.addopts; /*1680*/
				$0.ean2(); /*1680*/
			} /*1680*/
			if ($1.addon.length == 5) { /*1681*/
				$k[$j++] = $1.addon; /*1681*/
				$k[$j++] = $1.addopts; /*1681*/
				$0.ean5(); /*1681*/
			} /*1681*/
			$1.addcode = $k[--$j]; /*1682*/
			$k[$j++] = Infinity; /*1683*/
			$aload($1.sbs); /*1683*/
			$k[$j++] = $1.addongap; /*1683*/
			$aload($1.addcode.sbs); /*1683*/
			$1.sbs = $a(); /*1683*/
			$k[$j++] = Infinity; /*1684*/
			$aload($1.bhs); /*1684*/
			$forall($1.addcode.bhs, function() { /*1684*/
				var _3x = $k[--$j]; /*1684*/
				$k[$j++] = _3x - 0.075; /*1684*/
			}); /*1684*/
			$1.bhs = $a(); /*1684*/
			$k[$j++] = Infinity; /*1685*/
			$aload($1.bbs); /*1685*/
			$forall($1.addcode.bbs, function() { /*1685*/
				var _42 = $k[--$j]; /*1685*/
				$k[$j++] = _42 + 0.075; /*1685*/
			}); /*1685*/
			$1.bbs = $a(); /*1685*/
			$k[$j++] = Infinity; /*1686*/
			$aload($1.txt); /*1686*/
			$aload($1.addcode.txt); /*1686*/
			$1.txt = $a(); /*1686*/
			$1.guardrightypos = ($1.height * 72) - 6; /*1687*/
		} /*1687*/
		var _4F = {
			ren: $0.renlinear,
			sbs: $1.sbs,
			bhs: $1.bhs,
			bbs: $1.bbs,
			txt: $1.txt,
			opt: $1.options,
			guardrightpos: 10,
			guardrightypos: $1.guardrightypos,
			borderbottom: 5
		}; /*1700*/
		$k[$j++] = _4F; /*1703*/
		if (!$1.dontdraw) { /*1703*/
			$0.renlinear(); /*1703*/
		} /*1703*/
	};
	$0.upce = function() {
		var $1 = {}; /*1732*/
		$1.options = $k[--$j]; /*1734*/
		$1.barcode = $k[--$j]; /*1735*/
		$1.dontdraw = false; /*1737*/
		$1.includetext = false; /*1738*/
		$1.textfont = "Helvetica"; /*1739*/
		$1.textsize = 12; /*1740*/
		$1.textxoffset = -7; /*1741*/
		$1.textyoffset = -4.5; /*1742*/
		$1.height = 1; /*1743*/
		$1.addongap = 12; /*1744*/
		$1.addontextfont = "unset"; /*1745*/
		$1.addontextsize = "unset"; /*1746*/
		$1.addontextxoffset = "unset"; /*1747*/
		$1.addontextyoffset = "unset"; /*1748*/
		$forall($1.options, function() { /*1759*/
			var _3 = $k[--$j]; /*1759*/
			$1[$k[--$j]] = _3; /*1759*/
		}); /*1759*/
		$1.textfont = "" + $1.textfont; /*1761*/
		$1.textsize = +$1.textsize; /*1762*/
		$1.textxoffset = +$1.textxoffset; /*1763*/
		$1.textyoffset = +$1.textyoffset; /*1764*/
		$1.height = +$1.height; /*1765*/
		$1.addongap = +$1.addongap; /*1766*/
		if ($ne($1.addontextfont, "unset")) { /*1767*/
			$1.addontextfont = "" + $1.addontextfont; /*1767*/
		} /*1767*/
		if ($ne($1.addontextsize, "unset")) { /*1768*/
			$1.addontextsize = +$1.addontextsize; /*1768*/
		} /*1768*/
		if ($ne($1.addontextxoffset, "unset")) { /*1769*/
			$1.addontextxoffset = +$1.addontextxoffset; /*1769*/
		} /*1769*/
		if ($ne($1.addontextyoffset, "unset")) { /*1770*/
			$1.addontextyoffset = +$1.addontextyoffset; /*1770*/
		} /*1770*/
		$search($1.barcode, " "); /*1773*/
		if ($k[--$j]) { /*1779*/
			$1.barcode = $k[--$j]; /*1774*/
			$j--; /*1775*/
			$1.addon = $k[--$j]; /*1776*/
		} else { /*1779*/
			$j--; /*1778*/
			$1.addon = ""; /*1779*/
		} /*1779*/
		if (($1.barcode.length == 11) || ($1.barcode.length == 12)) { /*1821*/
			$forall($1.barcode, function() { /*1789*/
				var _Q = $k[--$j]; /*1786*/
				if ((_Q < 48) || (_Q > 57)) { /*1788*/
					$k[$j++] = "bwipp.upcEupcAbadCharacter"; /*1787*/
					$k[$j++] = "UPC-A must contain only digits"; /*1787*/
					$0.raiseerror(); /*1787*/
				} /*1787*/
			}); /*1787*/
			for (var _R = 0, _S = 1; _R < _S; _R++) { /*1816*/
				var _U = ($1.barcode.length == 12) ? 8 : 7; /*1791*/
				$1.upcecode = $s(_U); /*1791*/
				if ((($get($1.barcode, 3) - 48) <= 2) && $eq($geti($1.barcode, 4, 4), "0000")) { /*1797*/
					$puti($1.upcecode, 0, $geti($1.barcode, 0, 3)); /*1793*/
					$puti($1.upcecode, 3, $geti($1.barcode, 8, 3)); /*1794*/
					$puti($1.upcecode, 6, $geti($1.barcode, 3, 1)); /*1795*/
					break; /*1796*/
				} /*1796*/
				if ($eq($geti($1.barcode, 4, 5), "00000")) { /*1803*/
					$puti($1.upcecode, 0, $geti($1.barcode, 0, 4)); /*1799*/
					$puti($1.upcecode, 4, $geti($1.barcode, 9, 2)); /*1800*/
					$puti($1.upcecode, 6, "3"); /*1801*/
					break; /*1802*/
				} /*1802*/
				if ($eq($geti($1.barcode, 5, 5), "00000")) { /*1809*/
					$puti($1.upcecode, 0, $geti($1.barcode, 0, 5)); /*1805*/
					$puti($1.upcecode, 5, $geti($1.barcode, 10, 1)); /*1806*/
					$puti($1.upcecode, 6, "4"); /*1807*/
					break; /*1808*/
				} /*1808*/
				if ((($get($1.barcode, 10) - 48) >= 5) && $eq($geti($1.barcode, 6, 4), "0000")) { /*1814*/
					$puti($1.upcecode, 0, $geti($1.barcode, 0, 6)); /*1811*/
					$puti($1.upcecode, 6, $geti($1.barcode, 10, 1)); /*1812*/
					break; /*1813*/
				} /*1813*/
				$k[$j++] = "bwipp.upcEupcAnotCompressible"; /*1815*/
				$k[$j++] = "UPC-A cannot be converted to a UPC-E"; /*1815*/
				$0.raiseerror(); /*1815*/
			} /*1815*/
			if ($1.barcode.length == 12) { /*1819*/
				$puti($1.upcecode, 7, $geti($1.barcode, 11, 1)); /*1818*/
			} /*1818*/
			$1.barcode = $1.upcecode; /*1820*/
		} /*1820*/
		if (($1.barcode.length != 7) && ($1.barcode.length != 8)) { /*1826*/
			$k[$j++] = "bwipp.upcEbadLength"; /*1825*/
			$k[$j++] = "UPC-E must be 7 or 8 digits"; /*1825*/
			$0.raiseerror(); /*1825*/
		} /*1825*/
		var _1I = $1.barcode; /*1827*/
		for (var _1J = 0, _1K = _1I.length; _1J < _1K; _1J++) { /*1831*/
			var _1L = $get(_1I, _1J); /*1831*/
			if ((_1L < 48) || (_1L > 57)) { /*1830*/
				$k[$j++] = "bwipp.upcEbadCharacter"; /*1829*/
				$k[$j++] = "UPC-E must contain only digits"; /*1829*/
				$0.raiseerror(); /*1829*/
			} /*1829*/
		} /*1829*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*1834*/
			$k[$j++] = "bwipp.upcEbadAddOnLength"; /*1833*/
			$k[$j++] = "Add-on for UPC-E must be 2 or 5 digits"; /*1833*/
			$0.raiseerror(); /*1833*/
		} /*1833*/
		var _1Q = $get($1.barcode, 0); /*1837*/
		if ((_1Q != 48) && (_1Q != 49)) { /*1839*/
			$k[$j++] = "bwipp.upcEbadNumberSystem"; /*1838*/
			$k[$j++] = "UPC-E must have number system 0 or 1"; /*1838*/
			$0.raiseerror(); /*1838*/
		} /*1838*/
		$1.encs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "1312", "1213", "3112", "111", "111111"]); /*1846*/
		$1.barchars = "0123456789"; /*1849*/
		$1.mirrormaps = $a(["000111", "001011", "001101", "001110", "010011", "011001", "011100", "010101", "010110", "011010"]); /*1854*/
		for (var _1T = 0, _1U = 1; _1T < _1U; _1T++) { /*1884*/
			$1.upcacode = $s(11); /*1858*/
			if (($get($1.barcode, 6) - 48) <= 2) { /*1865*/
				$puti($1.upcacode, 0, $geti($1.barcode, 0, 3)); /*1860*/
				$puti($1.upcacode, 3, $geti($1.barcode, 6, 1)); /*1861*/
				$puti($1.upcacode, 4, "0000"); /*1862*/
				$puti($1.upcacode, 8, $geti($1.barcode, 3, 3)); /*1863*/
				break; /*1864*/
			} /*1864*/
			if (($get($1.barcode, 6) - 48) == 3) { /*1871*/
				$puti($1.upcacode, 0, $geti($1.barcode, 0, 4)); /*1867*/
				$puti($1.upcacode, 4, "00000"); /*1868*/
				$puti($1.upcacode, 9, $geti($1.barcode, 4, 2)); /*1869*/
				break; /*1870*/
			} /*1870*/
			if (($get($1.barcode, 6) - 48) == 4) { /*1877*/
				$puti($1.upcacode, 0, $geti($1.barcode, 0, 5)); /*1873*/
				$puti($1.upcacode, 5, "00000"); /*1874*/
				$puti($1.upcacode, 10, $geti($1.barcode, 5, 1)); /*1875*/
				break; /*1876*/
			} /*1876*/
			if (($get($1.barcode, 6) - 48) >= 5) { /*1883*/
				$puti($1.upcacode, 0, $geti($1.barcode, 0, 6)); /*1879*/
				$puti($1.upcacode, 6, "0000"); /*1880*/
				$puti($1.upcacode, 10, $geti($1.barcode, 6, 1)); /*1881*/
				break; /*1882*/
			} /*1882*/
		} /*1882*/
		$1.checksum = 0; /*1885*/
		for (var _29 = 0; _29 <= 10; _29 += 1) { /*1894*/
			$1.i = _29; /*1887*/
			$1.barchar = $get($1.upcacode, $1.i) - 48; /*1888*/
			if (($1.i % 2) != 0) { /*1892*/
				$1.checksum = $1.checksum + $1.barchar; /*1890*/
			} else { /*1892*/
				$1.checksum = $1.checksum + ($1.barchar * 3); /*1892*/
			} /*1892*/
		} /*1892*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*1895*/
		if ($1.barcode.length == 8) { /*1900*/
			if ($get($1.barcode, 7) != ($1.checksum + 48)) { /*1899*/
				$k[$j++] = "bwipp.upcEbadCheckDigit"; /*1898*/
				$k[$j++] = "Incorrect UPC check digit provided"; /*1898*/
				$0.raiseerror(); /*1898*/
			} /*1898*/
		} /*1898*/
		$1.pad = $s(8); /*1901*/
		$puti($1.pad, 0, $1.barcode); /*1902*/
		$put($1.pad, 7, $1.checksum + 48); /*1903*/
		$1.barcode = $1.pad; /*1904*/
		$1.txt = $a(8); /*1905*/
		$put($1.txt, 0, $a([$geti($1.barcode, 0, 1), $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1906*/
		$1.mirrormap = $get($1.mirrormaps, $1.checksum); /*1909*/
		if ($get($1.barcode, 0) == 48) { /*1923*/
			$1.invt = $s($1.mirrormap.length); /*1913*/
			for (var _2l = 0, _2k = $1.mirrormap.length - 1; _2l <= _2k; _2l += 1) { /*1921*/
				$1.i = _2l; /*1915*/
				if ($get($1.mirrormap, $1.i) == 48) { /*1919*/
					$put($1.invt, $1.i, 49); /*1917*/
				} else { /*1919*/
					$put($1.invt, $1.i, 48); /*1919*/
				} /*1919*/
			} /*1919*/
			$1.mirrormap = $1.invt; /*1922*/
		} /*1922*/
		$1.sbs = $s(33); /*1925*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*1928*/
		for (var _2y = 1; _2y <= 6; _2y += 1) { /*1950*/
			$1.i = _2y; /*1931*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*1933*/
			$j--; /*1934*/
			$1.indx = $k[--$j].length; /*1935*/
			$j -= 2; /*1936*/
			$1.enc = $get($1.encs, $1.indx); /*1937*/
			if ($get($1.mirrormap, $1.i - 1) == 49) { /*1947*/
				$1.enclen = $1.enc.length; /*1939*/
				$1.revenc = $s($1.enclen); /*1940*/
				for (var _3F = 0, _3E = $1.enclen - 1; _3F <= _3E; _3F += 1) { /*1945*/
					$1.j = _3F; /*1942*/
					$1.char = $get($1.enc, $1.j); /*1943*/
					$put($1.revenc, ($1.enclen - $1.j) - 1, $1.char); /*1944*/
				} /*1944*/
				$1.enc = $1.revenc; /*1946*/
			} /*1946*/
			$puti($1.sbs, (($1.i - 1) * 4) + 3, $1.enc); /*1948*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 1) * 7) + 11) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])); /*1949*/
		} /*1949*/
		$put($1.txt, 7, $a([$geti($1.barcode, 7, 1), ((6 * 7) + 18) + $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize - 2])); /*1952*/
		$puti($1.sbs, 27, $get($1.encs, 11)); /*1955*/
		$k[$j++] = Infinity; /*1957*/
		var _3n = $1.sbs; /*1957*/
		for (var _3o = 0, _3p = _3n.length; _3o < _3p; _3o++) { /*1957*/
			$k[$j++] = $get(_3n, _3o) - 48; /*1957*/
		} /*1957*/
		$1.sbs = $a(); /*1957*/
		if ($1.includetext) { /*1964*/
			$k[$j++] = Infinity; /*1959*/
			$k[$j++] = $1.height; /*1959*/
			$k[$j++] = $1.height; /*1959*/
			for (var _3v = 0, _3w = 12; _3v < _3w; _3v++) { /*1959*/
				$k[$j++] = $1.height - 0.075; /*1959*/
			} /*1959*/
			$k[$j++] = $1.height; /*1959*/
			$k[$j++] = $1.height; /*1959*/
			$k[$j++] = $1.height; /*1959*/
			$1.bhs = $a(); /*1959*/
			$k[$j++] = Infinity; /*1960*/
			$k[$j++] = 0; /*1960*/
			$k[$j++] = 0; /*1960*/
			for (var _42 = 0, _43 = 12; _42 < _43; _42++) { /*1960*/
				$k[$j++] = 0.075; /*1960*/
			} /*1960*/
			$k[$j++] = 0; /*1960*/
			$k[$j++] = 0; /*1960*/
			$k[$j++] = 0; /*1960*/
			$1.bbs = $a(); /*1960*/
		} else { /*1964*/
			$k[$j++] = Infinity; /*1962*/
			for (var _45 = 0, _46 = 17; _45 < _46; _45++) { /*1962*/
				$k[$j++] = $1.height; /*1962*/
			} /*1962*/
			$1.bhs = $a(); /*1962*/
			$k[$j++] = Infinity; /*1963*/
			for (var _49 = 0, _4A = 17; _49 < _4A; _49++) { /*1963*/
				$k[$j++] = 0; /*1963*/
			} /*1963*/
			$1.bbs = $a(); /*1963*/
			$1.txt = $a([]); /*1964*/
		} /*1964*/
		$1.guardrightypos = 0; /*1966*/
		if ($ne($1.addon, "")) { /*1987*/
			$k[$j++] = "addopts"; /*1977*/
			$k[$j++] = Infinity; /*1977*/
			$k[$j++] = "dontdraw"; /*1974*/
			$k[$j++] = true; /*1974*/
			$k[$j++] = "includetext"; /*1974*/
			$k[$j++] = true; /*1974*/
			$k[$j++] = "height"; /*1974*/
			$k[$j++] = $1.height - 0.15; /*1974*/
			$k[$j++] = "textxoffset"; /*1974*/
			if ($1.addontextxoffset != "unset") { /*1974*/
				$k[$j++] = $1.addontextxoffset; /*1974*/
			} else { /*1974*/
				$k[$j++] = 51 + $1.addongap; /*1974*/
			} /*1974*/
			if ($1.addontextyoffset != "unset") { /*1975*/
				$k[$j++] = "textyoffset"; /*1975*/
				$k[$j++] = $1.addontextyoffset; /*1975*/
			} /*1975*/
			var _4L = ($1.addontextsize != "unset") ? $1.addontextsize : $1.textsize; /*1976*/
			var _4N = $ne($1.addontextfont, "unset") ? $1.addontextfont : $1.textfont; /*1977*/
			$k[$j++] = "textsize"; /*1977*/
			$k[$j++] = _4L; /*1977*/
			$k[$j++] = "textfont"; /*1977*/
			$k[$j++] = _4N; /*1977*/
			var _4O = $d(); /*1977*/
			$1[$k[--$j]] = _4O; /*1978*/
			if ($1.addon.length == 2) { /*1979*/
				$k[$j++] = $1.addon; /*1979*/
				$k[$j++] = $1.addopts; /*1979*/
				$0.ean2(); /*1979*/
			} /*1979*/
			if ($1.addon.length == 5) { /*1980*/
				$k[$j++] = $1.addon; /*1980*/
				$k[$j++] = $1.addopts; /*1980*/
				$0.ean5(); /*1980*/
			} /*1980*/
			$1.addcode = $k[--$j]; /*1981*/
			$k[$j++] = Infinity; /*1982*/
			$aload($1.sbs); /*1982*/
			$k[$j++] = $1.addongap; /*1982*/
			$aload($1.addcode.sbs); /*1982*/
			$1.sbs = $a(); /*1982*/
			$k[$j++] = Infinity; /*1983*/
			$aload($1.bhs); /*1983*/
			$forall($1.addcode.bhs, function() { /*1983*/
				var _4f = $k[--$j]; /*1983*/
				$k[$j++] = _4f - 0.075; /*1983*/
			}); /*1983*/
			$1.bhs = $a(); /*1983*/
			$k[$j++] = Infinity; /*1984*/
			$aload($1.bbs); /*1984*/
			$forall($1.addcode.bbs, function() { /*1984*/
				var _4k = $k[--$j]; /*1984*/
				$k[$j++] = _4k + 0.075; /*1984*/
			}); /*1984*/
			$1.bbs = $a(); /*1984*/
			$k[$j++] = Infinity; /*1985*/
			$aload($1.txt); /*1985*/
			$aload($1.addcode.txt); /*1985*/
			$1.txt = $a(); /*1985*/
			$1.guardrightypos = ($1.height * 72) - 6; /*1986*/
		} /*1986*/
		var _4x = {
			ren: $0.renlinear,
			sbs: $1.sbs,
			bhs: $1.bhs,
			bbs: $1.bbs,
			txt: $1.txt,
			opt: $1.options,
			guardrightpos: 10,
			guardrightypos: $1.guardrightypos,
			borderbottom: 5
		}; /*1999*/
		$k[$j++] = _4x; /*2002*/
		if (!$1.dontdraw) { /*2002*/
			$0.renlinear(); /*2002*/
		} /*2002*/
	};
	$0.isbn = function() {
		var $1 = {}; /*2030*/
		$1.options = $k[--$j]; /*2032*/
		$1.barcode = $k[--$j]; /*2033*/
		$1.dontdraw = false; /*2035*/
		$1.includetext = false; /*2036*/
		$1.isbntextfont = "OCR-A"; /*2037*/
		$1.isbntextsize = 8; /*2038*/
		$1.isbntextxoffset = "unset"; /*2039*/
		$1.isbntextyoffset = "unset"; /*2040*/
		$1.height = 1; /*2041*/
		$1.addongap = 12; /*2042*/
		$1.legacy = false; /*2043*/
		$forall($1.options, function() { /*2054*/
			var _3 = $k[--$j]; /*2054*/
			$1[$k[--$j]] = _3; /*2054*/
		}); /*2054*/
		$1.isbntextfont = "" + $1.isbntextfont; /*2056*/
		$1.isbntextsize = +$1.isbntextsize; /*2057*/
		if ($ne($1.isbntextxoffset, "unset")) { /*2058*/
			$1.isbntextxoffset = +$1.isbntextxoffset; /*2058*/
		} /*2058*/
		if ($ne($1.isbntextyoffset, "unset")) { /*2059*/
			$1.isbntextyoffset = +$1.isbntextyoffset; /*2059*/
		} /*2059*/
		$1.height = +$1.height; /*2060*/
		$1.addongap = +$1.addongap; /*2061*/
		$search($1.barcode, " "); /*2064*/
		if ($k[--$j]) { /*2070*/
			$1.barcode = $k[--$j]; /*2065*/
			$j--; /*2066*/
			$1.addon = $k[--$j]; /*2067*/
		} else { /*2070*/
			$j--; /*2069*/
			$1.addon = ""; /*2070*/
		} /*2070*/
		if ((($1.barcode.length != 15) && ($1.barcode.length != 17)) && (($1.barcode.length != 11) && ($1.barcode.length != 13))) { /*2077*/
			$k[$j++] = "bwipp.isbnBadLength"; /*2076*/
			$k[$j++] = "ISBN-13 must be 15 or 17 characters including dashes. ISBN-10 must be 11 or 13 characters including dashes"; /*2076*/
			$0.raiseerror(); /*2076*/
		} /*2076*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*2080*/
			$k[$j++] = "bwipp.isbnBadAddOnLength"; /*2079*/
			$k[$j++] = "Add-on for ISBN must be 2 or 5 digits"; /*2079*/
			$0.raiseerror(); /*2079*/
		} /*2079*/
		if ($1.barcode.length >= 15) { /*2144*/
			var _Q = $geti($1.barcode, 0, 4); /*2082*/
			if ($ne(_Q, "978-") && $ne(_Q, "979-")) { /*2084*/
				$k[$j++] = "bwipp.isbn13badPrefix"; /*2083*/
				$k[$j++] = "ISBN-13 prefix must be 978- or 979-"; /*2083*/
				$0.raiseerror(); /*2083*/
			} /*2083*/
			$1.wasdash = false; /*2085*/
			$1.numdash = 0; /*2085*/
			$1.numdigit = 0; /*2085*/
			$forall($geti($1.barcode, 5, 9), function() { /*2099*/
				var _T = $k[--$j]; /*2087*/
				$k[$j++] = _T; /*2094*/
				if (_T == 45) { /*2094*/
					if ($1.wasdash) { /*2091*/
						$k[$j++] = "bwipp.isbn13adjacentDashes"; /*2090*/
						$k[$j++] = "ISBN-13 does not permit adjacent dashes"; /*2090*/
						$0.raiseerror(); /*2090*/
					} /*2090*/
					$1.wasdash = true; /*2092*/
					$1.numdash = $1.numdash + 1; /*2093*/
				} /*2093*/
				var _W = $k[--$j]; /*2095*/
				if ((_W >= 48) && (_W <= 57)) { /*2098*/
					$1.wasdash = false; /*2096*/
					$1.numdigit = $1.numdigit + 1; /*2097*/
				} /*2097*/
			}); /*2097*/
			if (($1.numdash != 2) || ($1.numdigit != 7)) { /*2102*/
				$k[$j++] = "bwipp.isbn13numDashesDigits"; /*2101*/
				$k[$j++] = "Incorrect number of dashes and digits for ISBN-13"; /*2101*/
				$0.raiseerror(); /*2101*/
			} /*2101*/
			var _b = $get($1.barcode, 14); /*2103*/
			if ((_b < 48) || (_b > 57)) { /*2105*/
				$k[$j++] = "bwipp.isbn13character15"; /*2104*/
				$k[$j++] = "ISBN-13 character 15 must be a digit"; /*2104*/
				$0.raiseerror(); /*2104*/
			} /*2104*/
			if ($1.barcode.length == 17) { /*2113*/
				if ($ne($geti($1.barcode, 15, 1), "-")) { /*2109*/
					$k[$j++] = "bwipp.isbn13character16"; /*2108*/
					$k[$j++] = "ISBN-13 penultimate character must be a dash"; /*2108*/
					$0.raiseerror(); /*2108*/
				} /*2108*/
				var _g = $get($1.barcode, 16); /*2110*/
				if ((_g < 48) || (_g > 57)) { /*2112*/
					$k[$j++] = "bwipp.isbn13character17"; /*2111*/
					$k[$j++] = "ISBN-13 final character must be a digit"; /*2111*/
					$0.raiseerror(); /*2111*/
				} /*2111*/
			} /*2111*/
		} else { /*2144*/
			var _i = $get($1.barcode, 0); /*2115*/
			if ((_i < 48) || (_i > 57)) { /*2117*/
				$k[$j++] = "bwipp.isbn10FirstDigit"; /*2116*/
				$k[$j++] = "ISBN-10 first character must be a digit"; /*2116*/
				$0.raiseerror(); /*2116*/
			} /*2116*/
			$1.wasdash = false; /*2118*/
			$1.numdash = 0; /*2118*/
			$1.numdigit = 0; /*2118*/
			$forall($geti($1.barcode, 1, 9), function() { /*2132*/
				var _l = $k[--$j]; /*2120*/
				$k[$j++] = _l; /*2127*/
				if (_l == 45) { /*2127*/
					if ($1.wasdash) { /*2124*/
						$k[$j++] = "bwipp.isbn10adjacentDashes"; /*2123*/
						$k[$j++] = "ISBN-10 does not permit adjacent dashes"; /*2123*/
						$0.raiseerror(); /*2123*/
					} /*2123*/
					$1.wasdash = true; /*2125*/
					$1.numdash = $1.numdash + 1; /*2126*/
				} /*2126*/
				var _o = $k[--$j]; /*2128*/
				if ((_o >= 48) && (_o <= 57)) { /*2131*/
					$1.wasdash = false; /*2129*/
					$1.numdigit = $1.numdigit + 1; /*2130*/
				} /*2130*/
			}); /*2130*/
			if (($1.numdash != 2) || ($1.numdigit != 7)) { /*2135*/
				$k[$j++] = "bwipp.isbn10numDashesDigits"; /*2134*/
				$k[$j++] = "Incorrect number of dashes and digits for ISBN-10"; /*2134*/
				$0.raiseerror(); /*2134*/
			} /*2134*/
			var _t = $get($1.barcode, 10); /*2136*/
			if ((_t < 48) || (_t > 57)) { /*2138*/
				$k[$j++] = "bwipp.isbn10character11"; /*2137*/
				$k[$j++] = "ISBN-10 character 11 must be a digit"; /*2137*/
				$0.raiseerror(); /*2137*/
			} /*2137*/
			if ($1.barcode.length == 13) { /*2146*/
				if ($ne($geti($1.barcode, 11, 1), "-")) { /*2142*/
					$k[$j++] = "bwipp.isbn10character12"; /*2141*/
					$k[$j++] = "ISBN-10 penultimate character must be a dash"; /*2141*/
					$0.raiseerror(); /*2141*/
				} /*2141*/
				var _y = $get($1.barcode, 12); /*2143*/
				if (((_y < 48) || (_y > 57)) && (_y != 88)) { /*2145*/
					$k[$j++] = "bwipp.isbn10character13"; /*2144*/
					$k[$j++] = "ISBN-10 final character must be a digit or X"; /*2144*/
					$0.raiseerror(); /*2144*/
				} /*2144*/
			} /*2144*/
		} /*2144*/
		$1.isbntxt = $1.barcode; /*2149*/
		if ($1.isbntxt.length <= 13) { /*2175*/
			$1.isbn = $s(10); /*2153*/
			$1.checksum = 0; /*2154*/
			$1.i = 0; /*2155*/
			$1.n = 0; /*2155*/
			for (;;) { /*2167*/
				$1.isbnchar = $get($1.isbntxt, $1.i) - 48; /*2157*/
				if ($1.isbnchar != -3) { /*2164*/
					$put($1.isbn, $1.n, $1.isbnchar + 48); /*2159*/
					if ($1.n < 9) { /*2162*/
						$1.checksum = $1.checksum + ((10 - $1.n) * $1.isbnchar); /*2161*/
					} /*2161*/
					$1.n = $1.n + 1; /*2163*/
				} /*2163*/
				$1.i = $1.i + 1; /*2165*/
				if ($1.i == $1.isbntxt.length) { /*2166*/
					break; /*2166*/
				} /*2166*/
			} /*2166*/
			var _1I = (11 - ($1.checksum % 11)) % 11; /*2168*/
			$k[$j++] = "checksum"; /*2168*/
			$k[$j++] = _1I; /*2168*/
			if (_1I == 10) { /*2168*/
				$j--; /*2168*/
				$k[$j++] = 40; /*2168*/
			} /*2168*/
			var _1J = $k[--$j]; /*2168*/
			$1[$k[--$j]] = _1J + 48; /*2168*/
			$1.isbn = $geti($1.isbn, 0, 9); /*2169*/
			if ($1.isbntxt.length == 13) { /*2174*/
				if ($get($1.isbntxt, 12) != $1.checksum) { /*2173*/
					$k[$j++] = "bwipp.isbn10badCheckDigit"; /*2172*/
					$k[$j++] = "Incorrect ISBN-10 check digit provided"; /*2172*/
					$0.raiseerror(); /*2172*/
				} /*2172*/
			} /*2172*/
		} /*2172*/
		if ((!$1.legacy) || ($1.isbntxt.length >= 15)) { /*2211*/
			if ($1.isbntxt.length <= 13) { /*2185*/
				$1.pad = $s(15); /*2181*/
				$puti($1.pad, 0, "978-"); /*2182*/
				$puti($1.pad, 4, $geti($1.isbntxt, 0, 11)); /*2183*/
				$1.isbntxt = $1.pad; /*2184*/
			} /*2184*/
			$1.isbn = $s(13); /*2188*/
			$1.checksum = 0; /*2189*/
			$1.i = 0; /*2190*/
			$1.n = 0; /*2190*/
			for (;;) { /*2202*/
				$1.isbnchar = $get($1.isbntxt, $1.i) - 48; /*2192*/
				if ($1.isbnchar != -3) { /*2199*/
					$put($1.isbn, $1.n, $1.isbnchar + 48); /*2194*/
					if ($1.n < 12) { /*2197*/
						$k[$j++] = "checksum"; /*2196*/
						$k[$j++] = $1.isbnchar; /*2196*/
						if (($1.n % 2) != 0) { /*2196*/
							var _1l = $k[--$j]; /*2196*/
							$k[$j++] = _1l * 3; /*2196*/
						} /*2196*/
						var _1n = $k[--$j]; /*2196*/
						$1[$k[--$j]] = _1n + $1.checksum; /*2196*/
					} /*2196*/
					$1.n = $1.n + 1; /*2198*/
				} /*2198*/
				$1.i = $1.i + 1; /*2200*/
				if ($1.i == $1.isbntxt.length) { /*2201*/
					break; /*2201*/
				} /*2201*/
			} /*2201*/
			$1.checksum = ((10 - ($1.checksum % 10)) % 10) + 48; /*2203*/
			$1.isbn = $geti($1.isbn, 0, 12); /*2204*/
			if ($1.isbntxt.length == 17) { /*2209*/
				if ($get($1.isbntxt, 16) != $1.checksum) { /*2208*/
					$k[$j++] = "bwipp.isbn13badCheckDigit"; /*2207*/
					$k[$j++] = "Incorrect ISBN-13 check digit provided"; /*2207*/
					$0.raiseerror(); /*2207*/
				} /*2207*/
			} /*2207*/
		} /*2207*/
		var _21 = ($1.isbn.length == 12) ? 22 : 18; /*2214*/
		$1.pad = $s(_21); /*2214*/
		$puti($1.pad, 0, "ISBN "); /*2215*/
		$puti($1.pad, 5, $1.isbntxt); /*2216*/
		$put($1.pad, $1.pad.length - 2, 45); /*2217*/
		$put($1.pad, $1.pad.length - 1, $1.checksum); /*2218*/
		$1.isbntxt = $1.pad; /*2219*/
		$1.barcode = $s(12); /*2222*/
		if ($1.isbn.length == 9) { /*2227*/
			$puti($1.barcode, 0, "978"); /*2224*/
			$puti($1.barcode, 3, $1.isbn); /*2225*/
		} else { /*2227*/
			$puti($1.barcode, 0, $1.isbn); /*2227*/
		} /*2227*/
		if ($ne($1.addon, "")) { /*2237*/
			var _2L = $s((12 + $1.addon.length) + 1); /*2232*/
			$puti(_2L, 0, $1.barcode); /*2233*/
			$puti(_2L, 12, " "); /*2234*/
			$puti(_2L, 13, $1.addon); /*2235*/
			$1.barcode = _2L; /*2236*/
		} /*2236*/
		$1.options.dontdraw = true; /*2240*/
		$1.options.addongap = $1.addongap; /*2241*/
		$k[$j++] = "args"; /*2242*/
		$k[$j++] = $1.barcode; /*2242*/
		$k[$j++] = $1.options; /*2242*/
		$0.ean13(); /*2242*/
		var _2T = $k[--$j]; /*2242*/
		$1[$k[--$j]] = _2T; /*2242*/
		if ($1.includetext) { /*2261*/
			if ($1.isbntextxoffset == "unset") { /*2248*/
				$k[$j++] = "isbntextxoffset"; /*2247*/
				if ($1.isbn.length == 9) { /*2247*/
					$k[$j++] = -1; /*2247*/
				} else { /*2247*/
					$k[$j++] = -12; /*2247*/
				} /*2247*/
				var _2Y = $k[--$j]; /*2247*/
				$1[$k[--$j]] = _2Y; /*2247*/
			} /*2247*/
			if ($1.isbntextyoffset == "unset") { /*2251*/
				$1.isbntextyoffset = ($1.height * 72) + 3; /*2250*/
			} /*2250*/
			var _2d = $1.args.txt !== undefined; /*2252*/
			if (_2d) { /*2259*/
				$1.txt = $1.args.txt; /*2253*/
				$1.newtxt = $a($1.txt.length + 1); /*2254*/
				$puti($1.newtxt, 0, $1.txt); /*2255*/
				$put($1.newtxt, $1.newtxt.length - 1, $a([$1.isbntxt, $1.isbntextxoffset, $1.isbntextyoffset, $1.isbntextfont, $1.isbntextsize])); /*2256*/
				$1.args.txt = $1.newtxt; /*2257*/
			} else { /*2259*/
				$1.args.txt = $a([$a([$1.isbntxt, $1.isbntextxoffset, $1.isbntextyoffset, $1.isbntextfont, $1.isbntextsize])]); /*2259*/
			} /*2259*/
		} /*2259*/
		$1.args.opt = $1.options; /*2263*/
		$k[$j++] = $1.args; /*2266*/
		if (!$1.dontdraw) { /*2266*/
			$0.renlinear(); /*2266*/
		} /*2266*/
	};
	$0.ismn = function() {
		var $1 = {}; /*2294*/
		$1.options = $k[--$j]; /*2296*/
		$1.barcode = $k[--$j]; /*2297*/
		$1.dontdraw = false; /*2299*/
		$1.includetext = false; /*2300*/
		$1.ismntextfont = "OCR-A"; /*2301*/
		$1.ismntextsize = 8; /*2302*/
		$1.ismntextxoffset = "unset"; /*2303*/
		$1.ismntextyoffset = "unset"; /*2304*/
		$1.height = 1; /*2305*/
		$1.addongap = 12; /*2306*/
		$1.legacy = false; /*2307*/
		$forall($1.options, function() { /*2318*/
			var _3 = $k[--$j]; /*2318*/
			$1[$k[--$j]] = _3; /*2318*/
		}); /*2318*/
		$1.ismntextfont = "" + $1.ismntextfont; /*2320*/
		$1.ismntextsize = +$1.ismntextsize; /*2321*/
		if ($ne($1.ismntextxoffset, "unset")) { /*2322*/
			$1.ismntextxoffset = +$1.ismntextxoffset; /*2322*/
		} /*2322*/
		if ($ne($1.ismntextyoffset, "unset")) { /*2323*/
			$1.ismntextyoffset = +$1.ismntextyoffset; /*2323*/
		} /*2323*/
		$1.height = +$1.height; /*2324*/
		$1.addongap = +$1.addongap; /*2325*/
		$search($1.barcode, " "); /*2328*/
		if ($k[--$j]) { /*2334*/
			$1.barcode = $k[--$j]; /*2329*/
			$j--; /*2330*/
			$1.addon = $k[--$j]; /*2331*/
		} else { /*2334*/
			$j--; /*2333*/
			$1.addon = ""; /*2334*/
		} /*2334*/
		if ((($1.barcode.length != 15) && ($1.barcode.length != 17)) && (($1.barcode.length != 11) && ($1.barcode.length != 13))) { /*2341*/
			$k[$j++] = "bwipp.ismnBadLength"; /*2340*/
			$k[$j++] = "ISMN-13 must be 15 or 17 characters including dashes. ISMN-10 must be 11 or 13 characters including dashes"; /*2340*/
			$0.raiseerror(); /*2340*/
		} /*2340*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*2344*/
			$k[$j++] = "bwipp.ismnBadAddOnLength"; /*2343*/
			$k[$j++] = "Add-on for ISMN must be 2 or 5 digits"; /*2343*/
			$0.raiseerror(); /*2343*/
		} /*2343*/
		if ($1.barcode.length >= 15) { /*2411*/
			if ($ne($geti($1.barcode, 0, 4), "979-")) { /*2348*/
				$k[$j++] = "bwipp.ismn13badPrefix"; /*2347*/
				$k[$j++] = "ISMN-13 prefix must be 979-"; /*2347*/
				$0.raiseerror(); /*2347*/
			} /*2347*/
			$1.wasdash = false; /*2349*/
			$1.numdash = 0; /*2349*/
			$1.numdigit = 0; /*2349*/
			$forall($geti($1.barcode, 5, 9), function() { /*2363*/
				var _T = $k[--$j]; /*2351*/
				$k[$j++] = _T; /*2358*/
				if (_T == 45) { /*2358*/
					if ($1.wasdash) { /*2355*/
						$k[$j++] = "bwipp.ismn13adjacentDashes"; /*2354*/
						$k[$j++] = "ISMN-13 does not permit adjacent dashes"; /*2354*/
						$0.raiseerror(); /*2354*/
					} /*2354*/
					$1.wasdash = true; /*2356*/
					$1.numdash = $1.numdash + 1; /*2357*/
				} /*2357*/
				var _W = $k[--$j]; /*2359*/
				if ((_W >= 48) && (_W <= 57)) { /*2362*/
					$1.wasdash = false; /*2360*/
					$1.numdigit = $1.numdigit + 1; /*2361*/
				} /*2361*/
			}); /*2361*/
			if (($1.numdash != 2) || ($1.numdigit != 7)) { /*2366*/
				$k[$j++] = "bwipp.ismn13numDashesDigits"; /*2365*/
				$k[$j++] = "Incorrect number of dashes and digits for ISMN-13"; /*2365*/
				$0.raiseerror(); /*2365*/
			} /*2365*/
			var _b = $get($1.barcode, 14); /*2367*/
			if ((_b < 48) || (_b > 57)) { /*2369*/
				$k[$j++] = "bwipp.ismn13character15"; /*2368*/
				$k[$j++] = "ISMN-13 character 15 must be a digit"; /*2368*/
				$0.raiseerror(); /*2368*/
			} /*2368*/
			if ($1.barcode.length == 17) { /*2377*/
				if ($ne($geti($1.barcode, 15, 1), "-")) { /*2373*/
					$k[$j++] = "bwipp.ismn13character16"; /*2372*/
					$k[$j++] = "ISMN-13 penultimate character must be a dash"; /*2372*/
					$0.raiseerror(); /*2372*/
				} /*2372*/
				var _g = $get($1.barcode, 16); /*2374*/
				if ((_g < 48) || (_g > 57)) { /*2376*/
					$k[$j++] = "bwipp.ismn13character17"; /*2375*/
					$k[$j++] = "ISMN-13 final character must be a digit"; /*2375*/
					$0.raiseerror(); /*2375*/
				} /*2375*/
			} /*2375*/
		} else { /*2411*/
			if ($ne($geti($1.barcode, 0, 2), "M-")) { /*2381*/
				$k[$j++] = "bwipp.ismn10badPrefix"; /*2380*/
				$k[$j++] = "ISMN-10 prefix must be M-"; /*2380*/
				$0.raiseerror(); /*2380*/
			} /*2380*/
			var _k = $get($1.barcode, 2); /*2382*/
			if ((_k < 48) || (_k > 57)) { /*2384*/
				$k[$j++] = "bwipp.ismn10character3"; /*2383*/
				$k[$j++] = "ISMN-10 character 3 must be a digit"; /*2383*/
				$0.raiseerror(); /*2383*/
			} /*2383*/
			$1.wasdash = false; /*2385*/
			$1.numdash = 0; /*2385*/
			$1.numdigit = 0; /*2385*/
			$forall($geti($1.barcode, 3, 7), function() { /*2399*/
				var _n = $k[--$j]; /*2387*/
				$k[$j++] = _n; /*2394*/
				if (_n == 45) { /*2394*/
					if ($1.wasdash) { /*2391*/
						$k[$j++] = "bwipp.ismn10adjacentDashes"; /*2390*/
						$k[$j++] = "ISMN-10 does not permit adjacent dashes"; /*2390*/
						$0.raiseerror(); /*2390*/
					} /*2390*/
					$1.wasdash = true; /*2392*/
					$1.numdash = $1.numdash + 1; /*2393*/
				} /*2393*/
				var _q = $k[--$j]; /*2395*/
				if ((_q >= 48) && (_q <= 57)) { /*2398*/
					$1.wasdash = false; /*2396*/
					$1.numdigit = $1.numdigit + 1; /*2397*/
				} /*2397*/
			}); /*2397*/
			if (($1.numdash != 1) || ($1.numdigit != 6)) { /*2402*/
				$k[$j++] = "bwipp.ismn10numDashesDigits"; /*2401*/
				$k[$j++] = "Incorrect number of dashes and digits for ISMN-10"; /*2401*/
				$0.raiseerror(); /*2401*/
			} /*2401*/
			var _v = $get($1.barcode, 10); /*2403*/
			if ((_v < 48) || (_v > 57)) { /*2405*/
				$k[$j++] = "bwipp.ismn10character11"; /*2404*/
				$k[$j++] = "ISMN-10 character 11 must be a digit"; /*2404*/
				$0.raiseerror(); /*2404*/
			} /*2404*/
			if ($1.barcode.length == 13) { /*2413*/
				if ($ne($geti($1.barcode, 11, 1), "-")) { /*2409*/
					$k[$j++] = "bwipp.ismn10character12"; /*2408*/
					$k[$j++] = "ISMN-10 penultimate character must be a dash"; /*2408*/
					$0.raiseerror(); /*2408*/
				} /*2408*/
				var _10 = $get($1.barcode, 12); /*2410*/
				if (((_10 < 48) || (_10 > 57)) && (_10 != 88)) { /*2412*/
					$k[$j++] = "bwipp.ismn10character13"; /*2411*/
					$k[$j++] = "ISMN-10 final character must be a digit or X"; /*2411*/
					$0.raiseerror(); /*2411*/
				} /*2411*/
			} /*2411*/
		} /*2411*/
		$1.ismntxt = $1.barcode; /*2416*/
		$1.legacytxt = ""; /*2419*/
		if ($1.ismntxt.length <= 13) { /*2426*/
			$1.legacytxt = $1.ismntxt; /*2421*/
			$1.pad = $s($1.ismntxt.length + 4); /*2422*/
			$puti($1.pad, 0, "979-0-"); /*2423*/
			$puti($1.pad, 6, $geti($1.ismntxt, 2, $1.ismntxt.length - 2)); /*2424*/
			$1.ismntxt = $1.pad; /*2425*/
		} /*2425*/
		$1.ismn = $s(13); /*2429*/
		$1.checksum = 0; /*2430*/
		$1.i = 0; /*2431*/
		$1.n = 0; /*2431*/
		for (;;) { /*2447*/
			$1.ismnchar = $get($1.ismntxt, $1.i) - 48; /*2433*/
			if ($1.ismnchar != -3) { /*2444*/
				$put($1.ismn, $1.n, $1.ismnchar + 48); /*2435*/
				if ($1.n < 12) { /*2442*/
					if (($1.n % 2) == 0) { /*2440*/
						$1.checksum = $1.ismnchar + $1.checksum; /*2438*/
					} else { /*2440*/
						$1.checksum = ($1.ismnchar * 3) + $1.checksum; /*2440*/
					} /*2440*/
				} /*2440*/
				$1.n = $1.n + 1; /*2443*/
			} /*2443*/
			$1.i = $1.i + 1; /*2445*/
			if ($1.i == $1.ismntxt.length) { /*2446*/
				break; /*2446*/
			} /*2446*/
		} /*2446*/
		$1.checksum = ((10 - ($1.checksum % 10)) % 10) + 48; /*2448*/
		if (($1.barcode.length == 13) || ($1.barcode.length == 17)) { /*2455*/
			var _1X = $1.barcode; /*2452*/
			if ($get(_1X, _1X.length - 1) != $1.checksum) { /*2454*/
				$k[$j++] = "bwipp.ismnBadCheckDigit"; /*2453*/
				$k[$j++] = "Incorrect ISMN check digit provided"; /*2453*/
				$0.raiseerror(); /*2453*/
			} /*2453*/
		} /*2453*/
		if ($1.legacy && $ne($1.legacytxt, "")) { /*2462*/
			$1.ismntxt = $1.legacytxt; /*2459*/
			$1.pad = $s(18); /*2460*/
		} else { /*2462*/
			$1.pad = $s(22); /*2462*/
		} /*2462*/
		$puti($1.pad, 0, "ISMN "); /*2464*/
		$puti($1.pad, 5, $1.ismntxt); /*2465*/
		$put($1.pad, $1.pad.length - 2, 45); /*2466*/
		$put($1.pad, $1.pad.length - 1, $1.checksum); /*2467*/
		$1.ismntxt = $1.pad; /*2468*/
		$1.barcode = $geti($1.ismn, 0, 12); /*2471*/
		if ($ne($1.addon, "")) { /*2480*/
			var _1s = $s((12 + $1.addon.length) + 1); /*2475*/
			$puti(_1s, 0, $1.barcode); /*2476*/
			$puti(_1s, 12, " "); /*2477*/
			$puti(_1s, 13, $1.addon); /*2478*/
			$1.barcode = _1s; /*2479*/
		} /*2479*/
		$1.options.dontdraw = true; /*2483*/
		$1.options.addongap = $1.addongap; /*2484*/
		$k[$j++] = "args"; /*2485*/
		$k[$j++] = $1.barcode; /*2485*/
		$k[$j++] = $1.options; /*2485*/
		$0.ean13(); /*2485*/
		var _20 = $k[--$j]; /*2485*/
		$1[$k[--$j]] = _20; /*2485*/
		if ($1.includetext) { /*2504*/
			if ($1.ismntextxoffset == "unset") { /*2491*/
				$k[$j++] = "ismntextxoffset"; /*2490*/
				if ($1.ismntxt.length == 18) { /*2490*/
					$k[$j++] = -1; /*2490*/
				} else { /*2490*/
					$k[$j++] = -12; /*2490*/
				} /*2490*/
				var _25 = $k[--$j]; /*2490*/
				$1[$k[--$j]] = _25; /*2490*/
			} /*2490*/
			if ($1.ismntextyoffset == "unset") { /*2494*/
				$1.ismntextyoffset = ($1.height * 72) + 3; /*2493*/
			} /*2493*/
			var _2A = $1.args.txt !== undefined; /*2495*/
			if (_2A) { /*2502*/
				$1.txt = $1.args.txt; /*2496*/
				$1.newtxt = $a($1.txt.length + 1); /*2497*/
				$puti($1.newtxt, 0, $1.txt); /*2498*/
				$put($1.newtxt, $1.newtxt.length - 1, $a([$1.ismntxt, $1.ismntextxoffset, $1.ismntextyoffset, $1.ismntextfont, $1.ismntextsize])); /*2499*/
				$1.args.txt = $1.newtxt; /*2500*/
			} else { /*2502*/
				$1.args.txt = $a([$a([$1.ismntxt, $1.ismntextxoffset, $1.ismntextyoffset, $1.ismntextfont, $1.ismntextsize])]); /*2502*/
			} /*2502*/
		} /*2502*/
		$1.args.opt = $1.options; /*2506*/
		$k[$j++] = $1.args; /*2509*/
		if (!$1.dontdraw) { /*2509*/
			$0.renlinear(); /*2509*/
		} /*2509*/
	};
	$0.issn = function() {
		var $1 = {}; /*2537*/
		$1.options = $k[--$j]; /*2539*/
		$1.issntxt = $k[--$j]; /*2540*/
		$1.dontdraw = false; /*2542*/
		$1.includetext = false; /*2543*/
		$1.issntextfont = "OCR-A"; /*2544*/
		$1.issntextsize = 8; /*2545*/
		$1.issntextxoffset = "unset"; /*2546*/
		$1.issntextyoffset = "unset"; /*2547*/
		$1.height = 1; /*2548*/
		$1.addongap = 12; /*2549*/
		$forall($1.options, function() { /*2560*/
			var _3 = $k[--$j]; /*2560*/
			$1[$k[--$j]] = _3; /*2560*/
		}); /*2560*/
		$1.issntextfont = "" + $1.issntextfont; /*2562*/
		$1.issntextsize = +$1.issntextsize; /*2563*/
		if ($ne($1.issntextxoffset, "unset")) { /*2564*/
			$1.issntextxoffset = +$1.issntextxoffset; /*2564*/
		} /*2564*/
		if ($ne($1.issntextyoffset, "unset")) { /*2565*/
			$1.issntextyoffset = +$1.issntextyoffset; /*2565*/
		} /*2565*/
		$1.height = +$1.height; /*2566*/
		$1.addongap = +$1.addongap; /*2567*/
		$search($1.issntxt, " "); /*2570*/
		if ($k[--$j]) { /*2576*/
			$1.issntxt = $k[--$j]; /*2571*/
			$j--; /*2572*/
			$1.seqvar = $k[--$j]; /*2573*/
		} else { /*2576*/
			$j--; /*2575*/
			$1.seqvar = "00"; /*2576*/
		} /*2576*/
		$search($1.seqvar, " "); /*2580*/
		if ($k[--$j]) { /*2586*/
			$1.seqvar = $k[--$j]; /*2581*/
			$j--; /*2582*/
			$1.addon = $k[--$j]; /*2583*/
		} else { /*2586*/
			$j--; /*2585*/
			$1.addon = ""; /*2586*/
		} /*2586*/
		if (($1.issntxt.length != 8) && ($1.issntxt.length != 9)) { /*2592*/
			$k[$j++] = "bwipp.issnBadLength"; /*2591*/
			$k[$j++] = "ISSN must be 8 or 9 characters including dash, in the format XXXX-XXXX"; /*2591*/
			$0.raiseerror(); /*2591*/
		} /*2591*/
		$forall($geti($1.issntxt, 0, 4), function() { /*2597*/
			var _P = $k[--$j]; /*2594*/
			if ((_P < 48) || (_P > 57)) { /*2596*/
				$k[$j++] = "bwipp.issnFirstThroughFourthNotNumeric"; /*2595*/
				$k[$j++] = "ISSN first four characters must be numeral characters"; /*2595*/
				$0.raiseerror(); /*2595*/
			} /*2595*/
		}); /*2595*/
		if ($ne($geti($1.issntxt, 4, 1), "-")) { /*2600*/
			$k[$j++] = "bwipp.issnNeedsDash"; /*2599*/
			$k[$j++] = "ISSN fifth character must be a dash"; /*2599*/
			$0.raiseerror(); /*2599*/
		} /*2599*/
		$forall($geti($1.issntxt, 5, 3), function() { /*2605*/
			var _U = $k[--$j]; /*2602*/
			if ((_U < 48) || (_U > 57)) { /*2604*/
				$k[$j++] = "bwipp.issnSixthThroughEighthNotNumeric"; /*2603*/
				$k[$j++] = "ISSN sixth through eighth characters must be numerals"; /*2603*/
				$0.raiseerror(); /*2603*/
			} /*2603*/
		}); /*2603*/
		if ($1.issntxt.length == 9) { /*2610*/
			var _X = $get($1.issntxt, 8); /*2607*/
			if (((_X < 48) || (_X > 57)) && (_X != 88)) { /*2609*/
				$k[$j++] = "bwipp.issnNinthCharacterBadFormat"; /*2608*/
				$k[$j++] = "ISSN ninth character must be a number or the character X"; /*2608*/
				$0.raiseerror(); /*2608*/
			} /*2608*/
		} /*2608*/
		if ($1.seqvar.length != 2) { /*2613*/
			$k[$j++] = "bwipp.issnBadSequenceVariantLength"; /*2612*/
			$k[$j++] = "Sequence variant for ISSN must be 2 digits"; /*2612*/
			$0.raiseerror(); /*2612*/
		} /*2612*/
		$forall($1.seqvar, function() { /*2618*/
			var _a = $k[--$j]; /*2615*/
			if ((_a < 48) || (_a > 57)) { /*2617*/
				$k[$j++] = "bwipp.issnSequenceVariantBadCharacter"; /*2616*/
				$k[$j++] = "Sequence variant for ISSN must contain only digits"; /*2616*/
				$0.raiseerror(); /*2616*/
			} /*2616*/
		}); /*2616*/
		if ((($1.addon.length != 0) && ($1.addon.length != 2)) && ($1.addon.length != 5)) { /*2621*/
			$k[$j++] = "bwipp.issnBadAddOnLength"; /*2620*/
			$k[$j++] = "Add-on for ISSN must be 2 or 5 digits"; /*2620*/
			$0.raiseerror(); /*2620*/
		} /*2620*/
		$1.issn = $s(8); /*2624*/
		$1.checksum = 0; /*2625*/
		$1.i = 0; /*2626*/
		$1.n = 0; /*2626*/
		for (;;) { /*2638*/
			$1.issnchar = $get($1.issntxt, $1.i) - 48; /*2628*/
			if ($1.issnchar != -3) { /*2635*/
				$put($1.issn, $1.n, $1.issnchar + 48); /*2630*/
				if ($1.n < 7) { /*2633*/
					$1.checksum = $1.checksum + ($1.issnchar * (8 - $1.n)); /*2632*/
				} /*2632*/
				$1.n = $1.n + 1; /*2634*/
			} /*2634*/
			$1.i = $1.i + 1; /*2636*/
			if ($1.i == $1.issntxt.length) { /*2637*/
				break; /*2637*/
			} /*2637*/
		} /*2637*/
		$1.checksum = (11 - ($1.checksum % 11)) % 11; /*2639*/
		var _w = $1.checksum + 48; /*2640*/
		$k[$j++] = "checksum"; /*2640*/
		$k[$j++] = _w; /*2640*/
		if (_w == 58) { /*2640*/
			$j--; /*2640*/
			$k[$j++] = 88; /*2640*/
		} /*2640*/
		var _x = $k[--$j]; /*2640*/
		$1[$k[--$j]] = _x; /*2640*/
		if ($1.issntxt.length == 9) { /*2645*/
			if ($get($1.issntxt, 8) != $1.checksum) { /*2644*/
				$k[$j++] = "bwipp.issnBadCheckDigit"; /*2643*/
				$k[$j++] = "Incorrect ISSN check digit provided"; /*2643*/
				$0.raiseerror(); /*2643*/
			} /*2643*/
		} /*2643*/
		$1.pad = $s(14); /*2648*/
		$puti($1.pad, 0, "ISSN "); /*2649*/
		$puti($1.pad, 5, $1.issntxt); /*2650*/
		$put($1.pad, 13, $1.checksum); /*2651*/
		$1.issntxt = $1.pad; /*2652*/
		$1.barcode = $geti($1.issn, 0, 7); /*2655*/
		$1.barcode = $s(12); /*2658*/
		$puti($1.barcode, 0, "977"); /*2659*/
		$puti($1.barcode, 3, $1.issn); /*2660*/
		$puti($1.barcode, 10, $1.seqvar); /*2661*/
		if ($ne($1.addon, "")) { /*2670*/
			var _1K = $s((12 + $1.addon.length) + 1); /*2665*/
			$puti(_1K, 0, $1.barcode); /*2666*/
			$puti(_1K, 12, " "); /*2667*/
			$puti(_1K, 13, $1.addon); /*2668*/
			$1.barcode = _1K; /*2669*/
		} /*2669*/
		$1.options.dontdraw = true; /*2673*/
		$1.options.addongap = $1.addongap; /*2674*/
		$k[$j++] = "args"; /*2675*/
		$k[$j++] = $1.barcode; /*2675*/
		$k[$j++] = $1.options; /*2675*/
		$0.ean13(); /*2675*/
		var _1S = $k[--$j]; /*2675*/
		$1[$k[--$j]] = _1S; /*2675*/
		if ($1.includetext) { /*2692*/
			if ($1.issntextxoffset == "unset") { /*2679*/
				$1.issntextxoffset = 10; /*2679*/
			} /*2679*/
			if ($1.issntextyoffset == "unset") { /*2682*/
				$1.issntextyoffset = ($1.height * 72) + 3; /*2681*/
			} /*2681*/
			var _1Z = $1.args.txt !== undefined; /*2683*/
			if (_1Z) { /*2690*/
				$1.txt = $1.args.txt; /*2684*/
				$1.newtxt = $a($1.txt.length + 1); /*2685*/
				$puti($1.newtxt, 0, $1.txt); /*2686*/
				$put($1.newtxt, $1.newtxt.length - 1, $a([$1.issntxt, $1.issntextxoffset, $1.issntextyoffset, $1.issntextfont, $1.issntextsize])); /*2687*/
				$1.args.txt = $1.newtxt; /*2688*/
			} else { /*2690*/
				$1.args.txt = $a([$a([$1.issntxt, $1.issntextxoffset, $1.issntextyoffset, $1.issntextfont, $1.issntextsize])]); /*2690*/
			} /*2690*/
		} /*2690*/
		$1.args.opt = $1.options; /*2694*/
		$k[$j++] = $1.args; /*2697*/
		if (!$1.dontdraw) { /*2697*/
			$0.renlinear(); /*2697*/
		} /*2697*/
	};
	$0.code128 = function() {
		var $1 = {}; /*2724*/
		$1.options = $k[--$j]; /*2726*/
		$1.barcode = $k[--$j]; /*2727*/
		$1.dontdraw = false; /*2729*/
		$1.includetext = false; /*2730*/
		$1.textfont = "Courier"; /*2731*/
		$1.textsize = 10; /*2732*/
		$1.textxoffset = 0; /*2733*/
		$1.textyoffset = -8.5; /*2734*/
		$1.height = 1; /*2735*/
		$1.encoding = "auto"; /*2736*/
		$1.raw = false; /*2737*/
		$1.parse = false; /*2738*/
		$1.parsefnc = false; /*2739*/
		$forall($1.options, function() { /*2750*/
			var _3 = $k[--$j]; /*2750*/
			$1[$k[--$j]] = _3; /*2750*/
		}); /*2750*/
		$1.textfont = "" + $1.textfont; /*2752*/
		$1.textsize = +$1.textsize; /*2753*/
		$1.textxoffset = +$1.textxoffset; /*2754*/
		$1.textyoffset = +$1.textyoffset; /*2755*/
		$1.height = +$1.height; /*2756*/
		$1.barlen = $1.barcode.length; /*2779*/
		$1.sta = -1; /*2782*/
		$1.stb = -2; /*2782*/
		$1.stc = -3; /*2782*/
		$1.swa = -4; /*2783*/
		$1.swb = -5; /*2783*/
		$1.swc = -6; /*2783*/
		$1.fn1 = -7; /*2784*/
		$1.fn2 = -8; /*2784*/
		$1.fn3 = -9; /*2784*/
		$1.fn4 = -10; /*2785*/
		$1.sft = -11; /*2785*/
		$1.stp = -12; /*2785*/
		$1.lka = -13; /*2786*/
		$1.lkc = -14; /*2786*/
		$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.fn3, $1.fn3, "96"]), $a([$1.fn2, $1.fn2, "97"]), $a([$1.sft, $1.sft, "98"]), $a([$1.swc, $1.swc, "99"]), $a([$1.swb, $1.fn4, $1.swb]), $a([$1.fn4, $1.swa, $1.swa]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.sta, $1.sta, $1.sta]), $a([$1.stb, $1.stb, $1.stb]), $a([$1.stc, $1.stc, $1.stc]), $a([$1.stp, $1.stp, $1.stp])]); /*2827*/
		$1.charvals = $a([{}, {}, {}]); /*2830*/
		for (var _2R = 0, _2Q = $1.charmaps.length - 1; _2R <= _2Q; _2R += 1) { /*2839*/
			$1.i = _2R; /*2832*/
			$1.encs = $get($1.charmaps, $1.i); /*2833*/
			for (var _2V = 0; _2V <= 2; _2V += 1) { /*2838*/
				$1.j = _2V; /*2835*/
				var _2Y = $get($1.encs, $1.j); /*2836*/
				$k[$j++] = _2Y; /*2836*/
				if ($eq($type(_2Y), "stringtype")) { /*2836*/
					var _2b = $get($k[--$j], 0); /*2836*/
					$k[$j++] = _2b; /*2836*/
				} /*2836*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*2837*/
			} /*2837*/
		} /*2837*/
		$1.seta = $get($1.charvals, 0); /*2840*/
		$1.setb = $get($1.charvals, 1); /*2841*/
		$1.setc = $get($1.charvals, 2); /*2842*/
		$put($1.seta, $1.lka, $get($1.seta, $1.swb)); /*2845*/
		$put($1.seta, $1.lkc, $get($1.seta, $1.swc)); /*2845*/
		$put($1.setb, $1.lka, $get($1.setb, $1.swc)); /*2846*/
		$put($1.setb, $1.lkc, $get($1.setb, $1.swa)); /*2846*/
		$put($1.setc, $1.lka, $get($1.setc, $1.swa)); /*2847*/
		$put($1.setc, $1.lkc, $get($1.setc, $1.swb)); /*2847*/
		if ($1.raw) { /*2849*/
			$1.encoding = "raw"; /*2849*/
		} /*2849*/
		if ($eq($1.encoding, "raw")) { /*2863*/
			$1.cws = $a($1.barlen); /*2852*/
			$1.i = 0; /*2853*/
			$1.j = 0; /*2853*/
			for (;;) { /*2860*/
				if ($1.i == $1.barlen) { /*2855*/
					break; /*2855*/
				} /*2855*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*2856*/
				$put($1.cws, $1.j, $1.cw); /*2857*/
				$1.i = $1.i + 4; /*2858*/
				$1.j = $1.j + 1; /*2859*/
			} /*2859*/
			$1.cws = $geti($1.cws, 0, $1.j); /*2861*/
			$1.text = ""; /*2862*/
		} /*2862*/
		if ($eq($1.encoding, "auto")) { /*3113*/
			var _3e = {
				FNC1: $1.fn1,
				FNC2: $1.fn2,
				FNC3: $1.fn3,
				LNKA: $1.lka,
				LNKC: $1.lkc
			}; /*2873*/
			$1.fncvals = _3e; /*2874*/
			$1.msg = $a($1.barlen); /*2877*/
			$1.text = $s($1.barlen); /*2878*/
			$1.i = 0; /*2879*/
			$1.j = 0; /*2879*/
			for (;;) { /*2895*/
				if ($1.i == $1.barlen) { /*2880*/
					break; /*2880*/
				} /*2880*/
				$1.char = $get($1.barcode, $1.i); /*2881*/
				$put($1.text, $1.j, $1.char); /*2882*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*2891*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*2889*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*2885*/
						$puti($1.text, $1.j, " "); /*2886*/
						$1.i = $1.i + 4; /*2887*/
					} else { /*2889*/
						$1.i = $1.i + 1; /*2889*/
					} /*2889*/
				} /*2889*/
				$put($1.msg, $1.j, $1.char); /*2892*/
				$1.i = $1.i + 1; /*2893*/
				$1.j = $1.j + 1; /*2894*/
			} /*2894*/
			$1.msg = $geti($1.msg, 0, $1.j); /*2896*/
			$1.msglen = $1.msg.length; /*2897*/
			$1.text = $geti($1.text, 0, $1.j); /*2898*/
			$k[$j++] = Infinity; /*2901*/
			for (var _4K = 0, _4L = $1.msglen; _4K < _4L; _4K++) { /*2901*/
				$k[$j++] = 0; /*2901*/
			} /*2901*/
			$k[$j++] = 0; /*2901*/
			$1.numSA = $a(); /*2901*/
			$k[$j++] = Infinity; /*2902*/
			for (var _4O = 0, _4P = $1.msglen; _4O < _4P; _4O++) { /*2902*/
				$k[$j++] = 0; /*2902*/
			} /*2902*/
			$k[$j++] = 0; /*2902*/
			$1.numEA = $a(); /*2902*/
			for (var _4S = $1.msglen - 1; _4S >= 0; _4S -= 1) { /*2912*/
				$1.i = _4S; /*2904*/
				if ($get($1.msg, $1.i) >= 0) { /*2911*/
					if ($get($1.msg, $1.i) >= 128) { /*2909*/
						$put($1.numEA, $1.i, $get($1.numEA, $1.i + 1) + 1); /*2907*/
					} else { /*2909*/
						$put($1.numSA, $1.i, $get($1.numSA, $1.i + 1) + 1); /*2909*/
					} /*2909*/
				} /*2909*/
			} /*2909*/
			$1.ea = false; /*2915*/
			$1.msgtmp = $a([]); /*2915*/
			for (var _4m = 0, _4l = $1.msglen - 1; _4m <= _4l; _4m += 1) { /*2930*/
				$1.i = _4m; /*2917*/
				$1.c = $get($1.msg, $1.i); /*2918*/
				if ((!$xo($1.ea, $1.c < 128)) && ($1.c >= 0)) { /*2928*/
					if ($1.ea) { /*2920*/
						$k[$j++] = $1.numSA; /*2920*/
					} else { /*2920*/
						$k[$j++] = $1.numEA; /*2920*/
					} /*2920*/
					var _4y = $get($k[--$j], $1.i); /*2920*/
					var _51 = ((_4y + $1.i) == $1.msglen) ? 3 : 5; /*2921*/
					if (_4y < _51) { /*2926*/
						$k[$j++] = Infinity; /*2923*/
						$aload($1.msgtmp); /*2923*/
						$k[$j++] = $1.fn4; /*2923*/
						$1.msgtmp = $a(); /*2923*/
					} else { /*2926*/
						$k[$j++] = Infinity; /*2925*/
						$aload($1.msgtmp); /*2925*/
						$k[$j++] = $1.fn4; /*2925*/
						$k[$j++] = $1.fn4; /*2925*/
						$1.msgtmp = $a(); /*2925*/
						$1.ea = !$1.ea; /*2926*/
					} /*2926*/
				} /*2926*/
				$k[$j++] = Infinity; /*2929*/
				$aload($1.msgtmp); /*2929*/
				if ($1.c >= 0) { /*2929*/
					$k[$j++] = $1.c & 127; /*2929*/
				} else { /*2929*/
					$k[$j++] = $1.c; /*2929*/
				} /*2929*/
				$1.msgtmp = $a(); /*2929*/
			} /*2929*/
			$1.msg = $1.msgtmp; /*2931*/
			$1.msglen = $1.msg.length; /*2932*/
			$1.numsscr = function() {
				$1.n = 0; /*2936*/
				$1.s = 0; /*2936*/
				$1.p = $k[--$j]; /*2937*/
				for (;;) { /*2948*/
					if ($1.p >= $1.msglen) { /*2938*/
						break; /*2938*/
					} /*2938*/
					var _5M = $get($1.msg, $1.p); /*2939*/
					var _5O = $get($1.setc, _5M) !== undefined; /*2940*/
					$k[$j++] = _5M; /*2940*/
					if (!_5O) { /*2940*/
						$j--; /*2940*/
						break; /*2940*/
					} /*2940*/
					if ($k[--$j] == $1.fn1) { /*2944*/
						if (($1.s % 2) == 0) { /*2943*/
							$1.s = $1.s + 1; /*2943*/
						} else { /*2943*/
							break; /*2943*/
						} /*2943*/
					} /*2943*/
					$1.n = $1.n + 1; /*2945*/
					$1.s = $1.s + 1; /*2946*/
					$1.p = $1.p + 1; /*2947*/
				} /*2947*/
				$k[$j++] = $1.n; /*2949*/
				$k[$j++] = $1.s; /*2949*/
			}; /*2950*/
			$1.enca = function() {
				$put($1.cws, $1.j, $get($1.seta, $k[--$j])); /*2954*/
				$1.j = $1.j + 1; /*2955*/
			}; /*2956*/
			$1.encb = function() {
				$put($1.cws, $1.j, $get($1.setb, $k[--$j])); /*2958*/
				$1.j = $1.j + 1; /*2959*/
			}; /*2960*/
			$1.encc = function() {
				var _5k = $k[--$j]; /*2962*/
				$k[$j++] = _5k; /*2966*/
				if ($ne($type(_5k), "arraytype")) { /*2965*/
					var _5o = $get($1.setc, $k[--$j]); /*2963*/
					$k[$j++] = _5o; /*2963*/
				} else { /*2965*/
					$aload($k[--$j]); /*2965*/
					var _5q = $k[--$j]; /*2965*/
					var _5r = $k[--$j]; /*2965*/
					$k[$j++] = (_5q - 48) + ((_5r - 48) * 10); /*2965*/
				} /*2965*/
				$put($1.cws, $1.j, $k[--$j]); /*2967*/
				$1.j = $1.j + 1; /*2968*/
			}; /*2969*/
			$1.anotb = function() {
				var _5w = $k[--$j]; /*2972*/
				var _5y = $get($1.seta, _5w) !== undefined; /*2972*/
				var _60 = $get($1.setb, _5w) !== undefined; /*2972*/
				$k[$j++] = _5y && (!_60); /*2972*/
			}; /*2972*/
			$1.bnota = function() {
				var _61 = $k[--$j]; /*2973*/
				var _63 = $get($1.setb, _61) !== undefined; /*2973*/
				var _65 = $get($1.seta, _61) !== undefined; /*2973*/
				$k[$j++] = _63 && (!_65); /*2973*/
			}; /*2973*/
			$k[$j++] = Infinity; /*2976*/
			for (var _67 = 0, _68 = $1.msg.length; _67 < _68; _67++) { /*2976*/
				$k[$j++] = 0; /*2976*/
			} /*2976*/
			$k[$j++] = 9999; /*2976*/
			$1.nextanotb = $a(); /*2976*/
			$k[$j++] = Infinity; /*2977*/
			for (var _6B = 0, _6C = $1.msg.length; _6B < _6C; _6B++) { /*2977*/
				$k[$j++] = 0; /*2977*/
			} /*2977*/
			$k[$j++] = 9999; /*2977*/
			$1.nextbnota = $a(); /*2977*/
			for (var _6F = $1.msg.length - 1; _6F >= 0; _6F -= 1) { /*2990*/
				$1.i = _6F; /*2979*/
				$k[$j++] = $get($1.msg, $1.i); /*2980*/
				if ($1.anotb() == $b) break; /*2980*/
				if ($k[--$j]) { /*2983*/
					$put($1.nextanotb, $1.i, 0); /*2981*/
				} else { /*2983*/
					$put($1.nextanotb, $1.i, $get($1.nextanotb, $1.i + 1) + 1); /*2983*/
				} /*2983*/
				$k[$j++] = $get($1.msg, $1.i); /*2985*/
				if ($1.bnota() == $b) break; /*2985*/
				if ($k[--$j]) { /*2988*/
					$put($1.nextbnota, $1.i, 0); /*2986*/
				} else { /*2988*/
					$put($1.nextbnota, $1.i, $get($1.nextbnota, $1.i + 1) + 1); /*2988*/
				} /*2988*/
			} /*2988*/
			$1.abeforeb = function() {
				var _6c = $k[--$j]; /*2993*/
				$k[$j++] = $lt($get($1.nextanotb, _6c), $get($1.nextbnota, _6c)); /*2993*/
			}; /*2993*/
			$1.bbeforea = function() {
				var _6h = $k[--$j]; /*2994*/
				$k[$j++] = $lt($get($1.nextbnota, _6h), $get($1.nextanotb, _6h)); /*2994*/
			}; /*2994*/
			$1.cws = $a(($1.barcode.length * 2) + 3); /*2996*/
			$1.j = 0; /*2999*/
			if ($1.msglen > 0) { /*3000*/
				$k[$j++] = 0; /*3000*/
				if ($1.numsscr() == $b) return $b; /*3000*/
			} else { /*3000*/
				$k[$j++] = -1; /*3000*/
				$k[$j++] = -1; /*3000*/
			} /*3000*/
			$1.nums = $k[--$j]; /*3000*/
			$1.nchars = $k[--$j]; /*3000*/
			for (;;) { /*3025*/
				if ($1.msglen == 0) { /*3006*/
					$k[$j++] = $1.stb; /*3003*/
					if ($1.enca() == $b) break; /*3003*/
					$1.cset = "setb"; /*3004*/
					break; /*3005*/
				} /*3005*/
				if (($1.msglen == 2) && ($1.nums == 2)) { /*3011*/
					$k[$j++] = $1.stc; /*3008*/
					if ($1.enca() == $b) break; /*3008*/
					$1.cset = "setc"; /*3009*/
					break; /*3010*/
				} /*3010*/
				if ($1.nums >= 4) { /*3016*/
					$k[$j++] = $1.stc; /*3013*/
					if ($1.enca() == $b) break; /*3013*/
					$1.cset = "setc"; /*3014*/
					break; /*3015*/
				} /*3015*/
				$k[$j++] = 0; /*3017*/
				if ($1.abeforeb() == $b) break; /*3017*/
				if ($k[--$j]) { /*3021*/
					$k[$j++] = $1.sta; /*3018*/
					if ($1.enca() == $b) break; /*3018*/
					$1.cset = "seta"; /*3019*/
					break; /*3020*/
				} /*3020*/
				$k[$j++] = $1.stb; /*3022*/
				if ($1.enca() == $b) break; /*3022*/
				$1.cset = "setb"; /*3023*/
				break; /*3024*/
			} /*3024*/
			$1.i = 0; /*3028*/
			for (;;) { /*3111*/
				if ($1.i == $1.msglen) { /*3029*/
					break; /*3029*/
				} /*3029*/
				$k[$j++] = $1.i; /*3031*/
				if ($1.numsscr() == $b) break; /*3031*/
				$1.nums = $k[--$j]; /*3031*/
				$1.nchars = $k[--$j]; /*3031*/
				for (;;) { /*3109*/
					if ((($eq($1.cset, "seta") || $eq($1.cset, "setb")) && ($1.nums >= 4)) && ($get($1.msg, $1.i) != $1.fn1)) { /*3048*/
						if (($1.nums % 2) == 0) { /*3046*/
							$k[$j++] = $1.swc; /*3038*/
							if ($eq($1.cset, "seta")) { /*3038*/
								if ($1.enca() == $b) break; /*3038*/
							} else { /*3038*/
								if ($1.encb() == $b) break; /*3038*/
							} /*3038*/
							$1.cset = "setc"; /*3039*/
							break; /*3040*/
						} else { /*3046*/
							$k[$j++] = $get($1.msg, $1.i); /*3042*/
							if ($eq($1.cset, "seta")) { /*3042*/
								if ($1.enca() == $b) break; /*3042*/
							} else { /*3042*/
								if ($1.encb() == $b) break; /*3042*/
							} /*3042*/
							$1.i = $1.i + 1; /*3043*/
							$k[$j++] = $1.swc; /*3044*/
							if ($eq($1.cset, "seta")) { /*3044*/
								if ($1.enca() == $b) break; /*3044*/
							} else { /*3044*/
								if ($1.encb() == $b) break; /*3044*/
							} /*3044*/
							$1.cset = "setc"; /*3045*/
							break; /*3046*/
						} /*3046*/
					} /*3046*/
					$k[$j++] = $eq($1.cset, "setb"); /*3049*/
					$k[$j++] = $get($1.msg, $1.i); /*3049*/
					if ($1.anotb() == $b) break; /*3049*/
					var _7R = $k[--$j]; /*3049*/
					if (($k[--$j] && _7R)) { /*3061*/
						if ($1.i < ($1.msglen - 1)) { /*3057*/
							$k[$j++] = $1.i + 1; /*3051*/
							if ($1.bbeforea() == $b) break; /*3051*/
							if ($k[--$j]) { /*3056*/
								$k[$j++] = $1.sft; /*3052*/
								if ($1.encb() == $b) break; /*3052*/
								$k[$j++] = $get($1.msg, $1.i); /*3053*/
								if ($1.enca() == $b) break; /*3053*/
								$1.i = $1.i + 1; /*3054*/
								break; /*3055*/
							} /*3055*/
						} /*3055*/
						$k[$j++] = $1.swa; /*3058*/
						if ($1.encb() == $b) break; /*3058*/
						$1.cset = "seta"; /*3059*/
						break; /*3060*/
					} /*3060*/
					$k[$j++] = $eq($1.cset, "seta"); /*3062*/
					$k[$j++] = $get($1.msg, $1.i); /*3062*/
					if ($1.bnota() == $b) break; /*3062*/
					var _7h = $k[--$j]; /*3062*/
					if (($k[--$j] && _7h)) { /*3074*/
						if ($1.i < ($1.msglen - 1)) { /*3070*/
							$k[$j++] = $1.i + 1; /*3064*/
							if ($1.abeforeb() == $b) break; /*3064*/
							if ($k[--$j]) { /*3069*/
								$k[$j++] = $1.sft; /*3065*/
								if ($1.enca() == $b) break; /*3065*/
								$k[$j++] = $get($1.msg, $1.i); /*3066*/
								if ($1.encb() == $b) break; /*3066*/
								$1.i = $1.i + 1; /*3067*/
								break; /*3068*/
							} /*3068*/
						} /*3068*/
						$k[$j++] = $1.swb; /*3071*/
						if ($1.enca() == $b) break; /*3071*/
						$1.cset = "setb"; /*3072*/
						break; /*3073*/
					} /*3073*/
					if ($eq($1.cset, "setc") && ($1.nums < 2)) { /*3084*/
						$k[$j++] = $1.i; /*3076*/
						if ($1.abeforeb() == $b) break; /*3076*/
						if ($k[--$j]) { /*3080*/
							$k[$j++] = $1.swa; /*3077*/
							if ($1.encc() == $b) break; /*3077*/
							$1.cset = "seta"; /*3078*/
							break; /*3079*/
						} /*3079*/
						$k[$j++] = $1.swb; /*3081*/
						if ($1.encc() == $b) break; /*3081*/
						$1.cset = "setb"; /*3082*/
						break; /*3083*/
					} /*3083*/
					if ($eq($1.cset, "seta")) { /*3091*/
						$k[$j++] = $get($1.msg, $1.i); /*3088*/
						if ($1.enca() == $b) break; /*3088*/
						$1.i = $1.i + 1; /*3089*/
						break; /*3090*/
					} /*3090*/
					if ($eq($1.cset, "setb")) { /*3096*/
						$k[$j++] = $get($1.msg, $1.i); /*3093*/
						if ($1.encb() == $b) break; /*3093*/
						$1.i = $1.i + 1; /*3094*/
						break; /*3095*/
					} /*3095*/
					if ($eq($1.cset, "setc")) { /*3106*/
						if ($get($1.msg, $1.i) == $1.fn1) { /*3103*/
							$k[$j++] = $1.fn1; /*3099*/
							if ($1.encc() == $b) break; /*3099*/
							$1.i = $1.i + 1; /*3100*/
						} else { /*3103*/
							$k[$j++] = $geti($1.msg, $1.i, 2); /*3102*/
							if ($1.encc() == $b) break; /*3102*/
							$1.i = $1.i + 2; /*3103*/
						} /*3103*/
						break; /*3105*/
					} /*3105*/
					break; /*3108*/
				} /*3108*/
			} /*3108*/
			$1.cws = $geti($1.cws, 0, $1.j); /*3112*/
		} /*3112*/
		var _8O = $a($1.j + 2); /*3116*/
		$puti(_8O, 0, $1.cws); /*3116*/
		$1.cws = _8O; /*3116*/
		$1.csum = $get($1.cws, 0); /*3117*/
		for (var _8U = 1, _8T = $1.j - 1; _8U <= _8T; _8U += 1) { /*3121*/
			$1.i = _8U; /*3119*/
			$1.csum = $1.csum + ($get($1.cws, $1.i) * $1.i); /*3120*/
		} /*3120*/
		$1.csum = $1.csum % 103; /*3122*/
		$put($1.cws, $1.j, $1.csum); /*3123*/
		$put($1.cws, $1.j + 1, $get($1.seta, $1.stp)); /*3124*/
		$1.encs = $a(["212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213", "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132", "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211", "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313", "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331", "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111", "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214", "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111", "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141", "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141", "114131", "311141", "411131", "211412", "211214", "211232", "2331112"]); /*3144*/
		$1.sbs = $s(($1.cws.length * 6) + 1); /*3147*/
		for (var _8o = 0, _8n = $1.cws.length - 1; _8o <= _8n; _8o += 1) { /*3151*/
			$1.i = _8o; /*3149*/
			$puti($1.sbs, $1.i * 6, $get($1.encs, $get($1.cws, $1.i))); /*3150*/
		} /*3150*/
		$k[$j++] = Infinity; /*3161*/
		$k[$j++] = "ren"; /*3157*/
		$k[$j++] = $0.renlinear; /*3157*/
		$k[$j++] = "sbs"; /*3157*/
		$k[$j++] = Infinity; /*3157*/
		var _8w = $1.sbs; /*3156*/
		for (var _8x = 0, _8y = _8w.length; _8x < _8y; _8x++) { /*3156*/
			$k[$j++] = $get(_8w, _8x) - 48; /*3156*/
		} /*3156*/
		var _90 = $a(); /*3157*/
		$k[$j++] = _90; /*3158*/
		$k[$j++] = "bhs"; /*3158*/
		$k[$j++] = Infinity; /*3158*/
		for (var _92 = 0, _93 = ~~(($1.sbs.length + 1) / 2); _92 < _93; _92++) { /*3157*/
			$k[$j++] = $1.height; /*3157*/
		} /*3157*/
		var _95 = $a(); /*3158*/
		$k[$j++] = _95; /*3159*/
		$k[$j++] = "bbs"; /*3159*/
		$k[$j++] = Infinity; /*3159*/
		for (var _97 = 0, _98 = ~~(($1.sbs.length + 1) / 2); _97 < _98; _97++) { /*3158*/
			$k[$j++] = 0; /*3158*/
		} /*3158*/
		var _99 = $a(); /*3159*/
		$k[$j++] = _99; /*3161*/
		$k[$j++] = "txt"; /*3161*/
		$k[$j++] = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3161*/
		$k[$j++] = "textxalign"; /*3161*/
		$k[$j++] = "center"; /*3161*/
		$k[$j++] = "opt"; /*3161*/
		$k[$j++] = $1.options; /*3161*/
		var _9I = $d(); /*3161*/
		$k[$j++] = _9I; /*3164*/
		if (!$1.dontdraw) { /*3164*/
			$0.renlinear(); /*3164*/
		} /*3164*/
	};
	$0["gs1-128"] = function() {
		var $1 = {}; /*3192*/
		$1.options = $k[--$j]; /*3194*/
		$1.barcode = $k[--$j]; /*3195*/
		$1.dontdraw = false; /*3197*/
		$1.includetext = false; /*3198*/
		$1.textfont = "Courier"; /*3199*/
		$1.textsize = 10; /*3200*/
		$1.textxoffset = 0; /*3201*/
		$1.textyoffset = -8.5; /*3202*/
		$1.height = 0.5; /*3203*/
		$1.linkagea = false; /*3204*/
		$1.linkagec = false; /*3205*/
		$forall($1.options, function() { /*3216*/
			var _3 = $k[--$j]; /*3216*/
			$1[$k[--$j]] = _3; /*3216*/
		}); /*3216*/
		$1.textfont = "" + $1.textfont; /*3218*/
		$1.textsize = +$1.textsize; /*3219*/
		$1.textxoffset = +$1.textxoffset; /*3220*/
		$1.textyoffset = +$1.textyoffset; /*3221*/
		$1.height = +$1.height; /*3222*/
		$1.text = $1.barcode; /*3224*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*3228*/
			$1.out = $s($1.in.length); /*3229*/
			$1.j = 0; /*3230*/
			$k[$j++] = $1.in; /*3244*/
			for (;;) { /*3244*/
				$search($k[--$j], "^"); /*3233*/
				if ($k[--$j]) { /*3242*/
					var _H = $k[--$j]; /*3234*/
					$puti($1.out, $1.j, _H); /*3234*/
					$1.j = (_H.length + $1.j) + 1; /*3235*/
					$j--; /*3236*/
					var _L = $k[--$j]; /*3237*/
					$put($1.out, $1.j - 1, ~~$z($geti(_L, 0, 3))); /*3237*/
					$k[$j++] = $geti(_L, 3, _L.length - 3); /*3238*/
				} else { /*3242*/
					var _Q = $k[--$j]; /*3240*/
					$puti($1.out, $1.j, _Q); /*3240*/
					$1.j = _Q.length + $1.j; /*3241*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*3242*/
					break; /*3242*/
				} /*3242*/
			} /*3242*/
		}; /*3245*/
		$1.ais = $a([]); /*3248*/
		$1.vals = $a([]); /*3249*/
		var _Z = $1.barcode; /*3250*/
		$k[$j++] = $geti(_Z, 1, _Z.length - 1); /*3263*/
		for (;;) { /*3263*/
			var _b = $k[--$j]; /*3252*/
			$k[$j++] = _b; /*3252*/
			if ($eq(_b, "")) { /*3252*/
				break; /*3252*/
			} /*3252*/
			$search($k[--$j], ")"); /*3253*/
			$j--; /*3253*/
			var _d = $k[--$j]; /*3254*/
			var _e = $k[--$j]; /*3254*/
			var _f = $k[--$j]; /*3255*/
			$k[$j++] = _d; /*3255*/
			$search(_f, "("); /*3255*/
			if ($k[--$j]) { /*3258*/
				var _h = $k[--$j]; /*3256*/
				var _i = $k[--$j]; /*3256*/
				var _j = $k[--$j]; /*3256*/
				var _k = $k[--$j]; /*3256*/
				$k[$j++] = _j; /*3256*/
				$k[$j++] = _k; /*3256*/
				$k[$j++] = _h; /*3256*/
			} else { /*3258*/
				var _l = $k[--$j]; /*3258*/
				var _m = $k[--$j]; /*3258*/
				$k[$j++] = ""; /*3258*/
				$k[$j++] = _m; /*3258*/
				$k[$j++] = _l; /*3258*/
			} /*3258*/
			$k[$j++] = Infinity; /*3260*/
			$aload($1.ais); /*3260*/
			var _p = $k[$j - 1 - ($counttomark() + 2)]; /*3260*/
			$k[$j++] = _p; /*3260*/
			$1.ais = $a(); /*3260*/
			$k[$j++] = Infinity; /*3261*/
			$aload($1.vals); /*3261*/
			var _t = $k[$j - 1 - ($counttomark() + 1)]; /*3261*/
			$k[$j++] = _t; /*3261*/
			if ($1.expand() == $b) break; /*3261*/
			$1.vals = $a(); /*3261*/
			$j -= 2; /*3262*/
		} /*3262*/
		$j--; /*3264*/
		$1.aifixed = {}; /*3269*/
		$k[$j++] = Infinity; /*3271*/
		for (var _v = 0; _v <= 4; _v += 1) { /*3271*/
			$k[$j++] = _v; /*3271*/
		} /*3271*/
		var _w = $a(); /*3271*/
		for (var _x = 0, _y = _w.length; _x < _y; _x++) { /*3274*/
			var _11 = $strcpy($s(2), "00"); /*3273*/
			$put(_11, 1, $get(_w, _x) + 48); /*3273*/
			$put($1.aifixed, _11, _11); /*3273*/
		} /*3273*/
		$k[$j++] = Infinity; /*3279*/
		for (var _13 = 11; _13 <= 20; _13 += 1) { /*3276*/
			$k[$j++] = _13; /*3276*/
		} /*3276*/
		$k[$j++] = 23; /*3278*/
		for (var _14 = 31; _14 <= 36; _14 += 1) { /*3278*/
			$k[$j++] = _14; /*3278*/
		} /*3278*/
		$k[$j++] = 41; /*3279*/
		var _15 = $a(); /*3279*/
		for (var _16 = 0, _17 = _15.length; _16 < _17; _16++) { /*3282*/
			var _1A = $cvrs($s(2), $get(_15, _16), 10); /*3281*/
			$put($1.aifixed, _1A, _1A); /*3281*/
		} /*3281*/
		$1.fnc1 = -1; /*3285*/
		$1.c128 = $a([$1.fnc1]); /*3286*/
		for (var _1G = 0, _1F = $1.ais.length - 1; _1G <= _1F; _1G += 1) { /*3302*/
			$1.i = _1G; /*3288*/
			$1.ai = $get($1.ais, $1.i); /*3289*/
			$1.val = $get($1.vals, $1.i); /*3290*/
			var _1Q = $a(($1.c128.length + $1.ai.length) + $1.val.length); /*3291*/
			$puti(_1Q, 0, $1.c128); /*3292*/
			$k[$j++] = _1Q; /*3293*/
			$k[$j++] = _1Q; /*3293*/
			$k[$j++] = $1.c128.length; /*3293*/
			$k[$j++] = $1.ai; /*3293*/
			$k[$j++] = Infinity; /*3293*/
			var _1U = $k[--$j]; /*3293*/
			var _1V = $k[--$j]; /*3293*/
			$k[$j++] = _1U; /*3293*/
			$forall(_1V); /*3293*/
			var _1W = $a(); /*3293*/
			var _1X = $k[--$j]; /*3293*/
			$puti($k[--$j], _1X, _1W); /*3293*/
			var _1Z = $k[--$j]; /*3294*/
			$k[$j++] = _1Z; /*3294*/
			$k[$j++] = _1Z; /*3294*/
			$k[$j++] = $1.c128.length + $1.ai.length; /*3294*/
			$k[$j++] = $1.val; /*3294*/
			$k[$j++] = Infinity; /*3294*/
			var _1d = $k[--$j]; /*3294*/
			var _1e = $k[--$j]; /*3294*/
			$k[$j++] = _1d; /*3294*/
			$forall(_1e); /*3294*/
			var _1f = $a(); /*3294*/
			var _1g = $k[--$j]; /*3294*/
			$puti($k[--$j], _1g, _1f); /*3294*/
			$1.c128 = $k[--$j]; /*3295*/
			var _1o = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*3296*/
			if (($1.i != ($1.ais.length - 1)) && (!_1o)) { /*3301*/
				var _1q = $a($1.c128.length + 1); /*3297*/
				$puti(_1q, 0, $1.c128); /*3298*/
				$put(_1q, $1.c128.length, $1.fnc1); /*3299*/
				$1.c128 = _1q; /*3300*/
			} /*3300*/
		} /*3300*/
		$1.barcode = $s(($1.c128.length + 1) * 5); /*3305*/
		$1.i = 0; /*3306*/
		$1.j = 0; /*3306*/
		for (;;) { /*3316*/
			if ($1.i == $1.c128.length) { /*3307*/
				break; /*3307*/
			} /*3307*/
			var _20 = $get($1.c128, $1.i); /*3308*/
			$k[$j++] = _20; /*3313*/
			if (_20 == $1.fnc1) { /*3312*/
				$j--; /*3309*/
				$puti($1.barcode, $1.j, "^FNC1"); /*3309*/
				$1.j = $1.j + 4; /*3310*/
			} else { /*3312*/
				$put($1.barcode, $1.j, $k[--$j]); /*3312*/
			} /*3312*/
			$1.i = $1.i + 1; /*3314*/
			$1.j = $1.j + 1; /*3315*/
		} /*3315*/
		if ($1.linkagea || $1.linkagec) { /*3320*/
			$k[$j++] = $1.barcode; /*3318*/
			$k[$j++] = $1.j; /*3318*/
			if ($1.linkagea) { /*3318*/
				$k[$j++] = "^LNKA"; /*3318*/
			} else { /*3318*/
				$k[$j++] = "^LNKC"; /*3318*/
			} /*3318*/
			var _2F = $k[--$j]; /*3318*/
			var _2G = $k[--$j]; /*3318*/
			$puti($k[--$j], _2G, _2F); /*3318*/
			$1.j = $1.j + 5; /*3319*/
		} /*3319*/
		$1.barcode = $geti($1.barcode, 0, $1.j); /*3321*/
		$1.options.height = $1.height; /*3324*/
		$1.options.dontdraw = true; /*3325*/
		$1.options.parsefnc = true; /*3326*/
		$k[$j++] = "args"; /*3327*/
		$k[$j++] = $1.barcode; /*3327*/
		$k[$j++] = $1.options; /*3327*/
		$0.code128(); /*3327*/
		var _2S = $k[--$j]; /*3327*/
		$1[$k[--$j]] = _2S; /*3327*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3329*/
		$1.args.textxalign = "center"; /*3330*/
		$1.args.opt = $1.options; /*3331*/
		$k[$j++] = $1.args; /*3334*/
		if (!$1.dontdraw) { /*3334*/
			$0.renlinear(); /*3334*/
		} /*3334*/
	};
	$0.ean14 = function() {
		var $1 = {}; /*3362*/
		$1.options = $k[--$j]; /*3364*/
		$1.barcode = $k[--$j]; /*3365*/
		$1.dontdraw = false; /*3367*/
		$1.includetext = false; /*3368*/
		$1.textfont = "Courier"; /*3369*/
		$1.textsize = 10; /*3370*/
		$1.textxoffset = 0; /*3371*/
		$1.textyoffset = -8.5; /*3372*/
		$1.height = 1; /*3373*/
		$forall($1.options, function() { /*3384*/
			var _3 = $k[--$j]; /*3384*/
			$1[$k[--$j]] = _3; /*3384*/
		}); /*3384*/
		$1.textfont = "" + $1.textfont; /*3386*/
		$1.textsize = +$1.textsize; /*3387*/
		$1.textxoffset = +$1.textxoffset; /*3388*/
		$1.textyoffset = +$1.textyoffset; /*3389*/
		$1.height = +$1.height; /*3390*/
		$1.text = $1.barcode; /*3393*/
		var _B = $1.barcode; /*3394*/
		$k[$j++] = $s(_B.length); /*3395*/
		$k[$j++] = 0; /*3395*/
		$forall(_B, function() { /*3395*/
			var _D = $k[--$j]; /*3395*/
			$k[$j++] = _D; /*3395*/
			if (_D != 32) { /*3395*/
				var _E = $k[--$j]; /*3395*/
				var _F = $k[--$j]; /*3395*/
				var _G = $k[--$j]; /*3395*/
				$put(_G, _F, _E); /*3395*/
				$k[$j++] = _G; /*3395*/
				$k[$j++] = _F + 1; /*3395*/
			} else { /*3395*/
				$j--; /*3395*/
			} /*3395*/
		}); /*3395*/
		var _H = $k[--$j]; /*3396*/
		$1.barcode = $geti($k[--$j], 0, _H); /*3396*/
		$1.hasspace = $1.text.length != $1.barcode.length; /*3397*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*3402*/
			$k[$j++] = "bwipp.ean14badAI"; /*3401*/
			$k[$j++] = "GS1-14 must begin with (01) application identifier"; /*3401*/
			$0.raiseerror(); /*3401*/
		} /*3401*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*3405*/
			$k[$j++] = "bwipp.ean14badLength"; /*3404*/
			$k[$j++] = "GS1-14 must be 13 or 14 digits"; /*3404*/
			$0.raiseerror(); /*3404*/
		} /*3404*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*3410*/
			var _T = $k[--$j]; /*3407*/
			if ((_T < 48) || (_T > 57)) { /*3409*/
				$k[$j++] = "bwipp.ean14badCharacter"; /*3408*/
				$k[$j++] = "GS1-14 must contain only digits"; /*3408*/
				$0.raiseerror(); /*3408*/
			} /*3408*/
		}); /*3408*/
		$1.checksum = 0; /*3413*/
		for (var _U = 0; _U <= 12; _U += 1) { /*3417*/
			$1.i = _U; /*3415*/
			$k[$j++] = "checksum"; /*3416*/
			$k[$j++] = $1.checksum; /*3416*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*3416*/
			if (($1.i % 2) == 0) { /*3416*/
				var _a = $k[--$j]; /*3416*/
				$k[$j++] = _a * 3; /*3416*/
			} /*3416*/
			var _b = $k[--$j]; /*3416*/
			var _c = $k[--$j]; /*3416*/
			$1[$k[--$j]] = _c + _b; /*3416*/
		} /*3416*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*3418*/
		if ($1.barcode.length == 18) { /*3432*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*3422*/
				$k[$j++] = "bwipp.ean14badCheckDigit"; /*3421*/
				$k[$j++] = "Incorrect GS1-14 check digit provided"; /*3421*/
				$0.raiseerror(); /*3421*/
			} /*3421*/
		} else { /*3432*/
			var _j = $s(18); /*3424*/
			$puti(_j, 0, $1.barcode); /*3425*/
			$put(_j, 17, $1.checksum + 48); /*3426*/
			$1.barcode = _j; /*3427*/
			var _o = $1.hasspace ? 2 : 1; /*3428*/
			var _p = $s($1.text.length + _o); /*3428*/
			$puti(_p, _p.length - 2, " "); /*3429*/
			$put(_p, _p.length - 1, $1.checksum + 48); /*3430*/
			$puti(_p, 0, $1.text); /*3431*/
			$1.text = _p; /*3432*/
		} /*3432*/
		$1.gtin = $geti($1.barcode, 4, 14); /*3434*/
		$1.barcode = $s(21); /*3437*/
		$puti($1.barcode, 0, "^FNC101"); /*3438*/
		$puti($1.barcode, 7, $1.gtin); /*3439*/
		$1.options.dontdraw = true; /*3442*/
		$1.options.parsefnc = true; /*3443*/
		$k[$j++] = "args"; /*3444*/
		$k[$j++] = $1.barcode; /*3444*/
		$k[$j++] = $1.options; /*3444*/
		$0.code128(); /*3444*/
		var _12 = $k[--$j]; /*3444*/
		$1[$k[--$j]] = _12; /*3444*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3446*/
		$1.args.textxalign = "center"; /*3447*/
		$1.args.opt = $1.options; /*3448*/
		$k[$j++] = $1.args; /*3451*/
		if (!$1.dontdraw) { /*3451*/
			$0.renlinear(); /*3451*/
		} /*3451*/
	};
	$0.sscc18 = function() {
		var $1 = {}; /*3479*/
		$1.options = $k[--$j]; /*3481*/
		$1.barcode = $k[--$j]; /*3482*/
		$1.dontdraw = false; /*3484*/
		$1.includetext = false; /*3485*/
		$1.textfont = "Courier"; /*3486*/
		$1.textsize = 10; /*3487*/
		$1.textxoffset = 0; /*3488*/
		$1.textyoffset = -8.5; /*3489*/
		$1.height = 1; /*3490*/
		$forall($1.options, function() { /*3501*/
			var _3 = $k[--$j]; /*3501*/
			$1[$k[--$j]] = _3; /*3501*/
		}); /*3501*/
		$1.textfont = "" + $1.textfont; /*3503*/
		$1.textsize = +$1.textsize; /*3504*/
		$1.textxoffset = +$1.textxoffset; /*3505*/
		$1.textyoffset = +$1.textyoffset; /*3506*/
		$1.height = +$1.height; /*3507*/
		$1.text = $1.barcode; /*3510*/
		var _B = $1.barcode; /*3511*/
		$k[$j++] = $s(_B.length); /*3512*/
		$k[$j++] = 0; /*3512*/
		$forall(_B, function() { /*3512*/
			var _D = $k[--$j]; /*3512*/
			$k[$j++] = _D; /*3512*/
			if (_D != 32) { /*3512*/
				var _E = $k[--$j]; /*3512*/
				var _F = $k[--$j]; /*3512*/
				var _G = $k[--$j]; /*3512*/
				$put(_G, _F, _E); /*3512*/
				$k[$j++] = _G; /*3512*/
				$k[$j++] = _F + 1; /*3512*/
			} else { /*3512*/
				$j--; /*3512*/
			} /*3512*/
		}); /*3512*/
		var _H = $k[--$j]; /*3513*/
		$1.barcode = $geti($k[--$j], 0, _H); /*3513*/
		$1.hasspace = $1.text.length != $1.barcode.length; /*3514*/
		if ($ne($geti($1.barcode, 0, 4), "(00)")) { /*3519*/
			$k[$j++] = "bwipp.sscc18badAI"; /*3518*/
			$k[$j++] = "SSCC-18 must begin with (00) application identifier"; /*3518*/
			$0.raiseerror(); /*3518*/
		} /*3518*/
		if (($1.barcode.length != 21) && ($1.barcode.length != 22)) { /*3522*/
			$k[$j++] = "bwipp.sscc18badLength"; /*3521*/
			$k[$j++] = "SSCC-18 must be 17 or 18 digits"; /*3521*/
			$0.raiseerror(); /*3521*/
		} /*3521*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*3527*/
			var _T = $k[--$j]; /*3524*/
			if ((_T < 48) || (_T > 57)) { /*3526*/
				$k[$j++] = "bwipp.sscc18badCharacter"; /*3525*/
				$k[$j++] = "SSCC-18 must contain only digits"; /*3525*/
				$0.raiseerror(); /*3525*/
			} /*3525*/
		}); /*3525*/
		$1.checksum = 0; /*3530*/
		for (var _U = 0; _U <= 16; _U += 1) { /*3534*/
			$1.i = _U; /*3532*/
			$k[$j++] = "checksum"; /*3533*/
			$k[$j++] = $1.checksum; /*3533*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*3533*/
			if (($1.i % 2) == 0) { /*3533*/
				var _a = $k[--$j]; /*3533*/
				$k[$j++] = _a * 3; /*3533*/
			} /*3533*/
			var _b = $k[--$j]; /*3533*/
			var _c = $k[--$j]; /*3533*/
			$1[$k[--$j]] = _c + _b; /*3533*/
		} /*3533*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*3535*/
		if ($1.barcode.length == 22) { /*3549*/
			if ($get($1.barcode, 21) != ($1.checksum + 48)) { /*3539*/
				$k[$j++] = "bwipp.sscc18badCheckDigit"; /*3538*/
				$k[$j++] = "Incorrect SSCC-18 check digit provided"; /*3538*/
				$0.raiseerror(); /*3538*/
			} /*3538*/
		} else { /*3549*/
			var _j = $s(22); /*3541*/
			$puti(_j, 0, $1.barcode); /*3542*/
			$put(_j, 21, $1.checksum + 48); /*3543*/
			$1.barcode = _j; /*3544*/
			var _o = $1.hasspace ? 2 : 1; /*3545*/
			var _p = $s($1.text.length + _o); /*3545*/
			$puti(_p, _p.length - 2, " "); /*3546*/
			$put(_p, _p.length - 1, $1.checksum + 48); /*3547*/
			$puti(_p, 0, $1.text); /*3548*/
			$1.text = _p; /*3549*/
		} /*3549*/
		$1.sscc = $geti($1.barcode, 4, 18); /*3551*/
		$1.barcode = $s(25); /*3554*/
		$puti($1.barcode, 0, "^FNC100"); /*3555*/
		$puti($1.barcode, 7, $1.sscc); /*3556*/
		$1.options.dontdraw = true; /*3559*/
		$1.options.parsefnc = true; /*3560*/
		$k[$j++] = "args"; /*3561*/
		$k[$j++] = $1.barcode; /*3561*/
		$k[$j++] = $1.options; /*3561*/
		$0.code128(); /*3561*/
		var _12 = $k[--$j]; /*3561*/
		$1[$k[--$j]] = _12; /*3561*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3563*/
		$1.args.textxalign = "center"; /*3564*/
		$1.args.opt = $1.options; /*3565*/
		$k[$j++] = $1.args; /*3568*/
		if (!$1.dontdraw) { /*3568*/
			$0.renlinear(); /*3568*/
		} /*3568*/
	};
	$0.code39 = function() {
		var $1 = {}; /*3595*/
		$1.options = $k[--$j]; /*3597*/
		$1.barcode = $k[--$j]; /*3598*/
		$1.dontdraw = false; /*3600*/
		$1.includecheck = false; /*3601*/
		$1.validatecheck = false; /*3602*/
		$1.includetext = false; /*3603*/
		$1.includecheckintext = false; /*3604*/
		$1.hidestars = false; /*3605*/
		$1.textfont = "Courier"; /*3606*/
		$1.textsize = 10; /*3607*/
		$1.textyoffset = -8.5; /*3608*/
		$1.height = 1; /*3609*/
		$forall($1.options, function() { /*3620*/
			var _3 = $k[--$j]; /*3620*/
			$1[$k[--$j]] = _3; /*3620*/
		}); /*3620*/
		$1.textfont = "" + $1.textfont; /*3622*/
		$1.textsize = +$1.textsize; /*3623*/
		$1.textyoffset = +$1.textyoffset; /*3624*/
		$1.height = +$1.height; /*3625*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*3628*/
		$1.charvals = {}; /*3629*/
		for (var _9 = 0; _9 <= 42; _9 += 1) { /*3630*/
			$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*3630*/
		} /*3630*/
		for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*3637*/
			var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*3634*/
			if (!_J) { /*3636*/
				$k[$j++] = "bwipp.code39badCharacter"; /*3635*/
				$k[$j++] = "Code 39 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*3635*/
				$0.raiseerror(); /*3635*/
			} /*3635*/
		} /*3635*/
		$k[$j++] = "barlen"; /*3639*/
		$k[$j++] = $1.barcode.length; /*3639*/
		if ($1.validatecheck) { /*3639*/
			var _M = $k[--$j]; /*3639*/
			$k[$j++] = _M - 1; /*3639*/
		} /*3639*/
		var _N = $k[--$j]; /*3639*/
		$1[$k[--$j]] = _N; /*3639*/
		$1.checksum = 0; /*3641*/
		for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*3645*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _R, 1)) + $1.checksum; /*3644*/
		} /*3644*/
		$1.checksum = $1.checksum % 43; /*3646*/
		if ($1.validatecheck) { /*3653*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*3650*/
				$k[$j++] = "bwipp.code39badCheckDigit"; /*3649*/
				$k[$j++] = "Incorrect Code 39 check digit provided"; /*3649*/
				$0.raiseerror(); /*3649*/
			} /*3649*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*3651*/
			$1.includecheck = true; /*3652*/
		} /*3652*/
		$1.encs = $a(["1113313111", "3113111131", "1133111131", "3133111111", "1113311131", "3113311111", "1133311111", "1113113131", "3113113111", "1133113111", "3111131131", "1131131131", "3131131111", "1111331131", "3111331111", "1131331111", "1111133131", "3111133111", "1131133111", "1111333111", "3111111331", "1131111331", "3131111311", "1111311331", "3111311311", "1131311311", "1111113331", "3111113311", "1131113311", "1111313311", "3311111131", "1331111131", "3331111111", "1311311131", "3311311111", "1331311111", "1311113131", "3311113111", "1331113111", "1313131111", "1313111311", "1311131311", "1113131311", "1311313111"]); /*3666*/
		var _l = $1.includecheck ? 3 : 2; /*3668*/
		$1.sbs = $s(($1.barlen + _l) * 10); /*3668*/
		var _p = $1.includecheck ? 3 : 2; /*3669*/
		$1.txt = $a($1.barlen + _p); /*3669*/
		$puti($1.sbs, 0, $get($1.encs, 43)); /*3672*/
		if (!$1.hidestars) { /*3676*/
			$put($1.txt, 0, $a(["*", 0, $1.textyoffset, $1.textfont, $1.textsize])); /*3674*/
		} else { /*3676*/
			$put($1.txt, 0, $a(["", 0, $1.textyoffset, $1.textfont, $1.textsize])); /*3676*/
		} /*3676*/
		for (var _17 = 0, _16 = $1.barlen - 1; _17 <= _16; _17 += 1) { /*3684*/
			$1.i = _17; /*3680*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*3681*/
			$puti($1.sbs, ($1.i * 10) + 10, $get($1.encs, $1.indx)); /*3682*/
			$put($1.txt, $1.i + 1, $a([$geti($1.barcode, $1.i, 1), ($1.i + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3683*/
		} /*3683*/
		if ($1.includecheck) { /*3705*/
			$puti($1.sbs, ($1.barlen * 10) + 10, $get($1.encs, $1.checksum)); /*3688*/
			if ($1.includecheckintext) { /*3692*/
				$put($1.txt, $1.barlen + 1, $a([$geti($1.barchars, $1.checksum, 1), ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3690*/
			} else { /*3692*/
				$put($1.txt, $1.barlen + 1, $a(["", ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3692*/
			} /*3692*/
			$puti($1.sbs, ($1.barlen * 10) + 20, $get($1.encs, 43)); /*3694*/
			if (!$1.hidestars) { /*3698*/
				$put($1.txt, $1.barlen + 2, $a(["*", ($1.barlen + 2) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3696*/
			} else { /*3698*/
				$put($1.txt, $1.barlen + 2, $a(["", ($1.barlen + 2) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3698*/
			} /*3698*/
		} else { /*3705*/
			$puti($1.sbs, ($1.barlen * 10) + 10, $get($1.encs, 43)); /*3701*/
			if (!$1.hidestars) { /*3705*/
				$put($1.txt, $1.barlen + 1, $a(["*", ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3703*/
			} else { /*3705*/
				$put($1.txt, $1.barlen + 1, $a(["", ($1.barlen + 1) * 16, $1.textyoffset, $1.textfont, $1.textsize])); /*3705*/
			} /*3705*/
		} /*3705*/
		$k[$j++] = Infinity; /*3718*/
		$k[$j++] = "ren"; /*3713*/
		$k[$j++] = $0.renlinear; /*3713*/
		$k[$j++] = "sbs"; /*3713*/
		$k[$j++] = Infinity; /*3713*/
		var _2S = $1.sbs; /*3712*/
		for (var _2T = 0, _2U = _2S.length; _2T < _2U; _2T++) { /*3712*/
			$k[$j++] = $get(_2S, _2T) - 48; /*3712*/
		} /*3712*/
		var _2W = $a(); /*3713*/
		$k[$j++] = _2W; /*3714*/
		$k[$j++] = "bhs"; /*3714*/
		$k[$j++] = Infinity; /*3714*/
		for (var _2Y = 0, _2Z = ~~(($1.sbs.length + 1) / 2); _2Y < _2Z; _2Y++) { /*3713*/
			$k[$j++] = $1.height; /*3713*/
		} /*3713*/
		var _2b = $a(); /*3714*/
		$k[$j++] = _2b; /*3715*/
		$k[$j++] = "bbs"; /*3715*/
		$k[$j++] = Infinity; /*3715*/
		for (var _2d = 0, _2e = ~~(($1.sbs.length + 1) / 2); _2d < _2e; _2d++) { /*3714*/
			$k[$j++] = 0; /*3714*/
		} /*3714*/
		var _2f = $a(); /*3715*/
		$k[$j++] = _2f; /*3717*/
		if ($1.includetext) { /*3717*/
			$k[$j++] = "txt"; /*3716*/
			$k[$j++] = $1.txt; /*3716*/
		} /*3716*/
		$k[$j++] = "opt"; /*3718*/
		$k[$j++] = $1.options; /*3718*/
		var _2j = $d(); /*3718*/
		$k[$j++] = _2j; /*3721*/
		if (!$1.dontdraw) { /*3721*/
			$0.renlinear(); /*3721*/
		} /*3721*/
	};
	$0.code39ext = function() {
		var $1 = {}; /*3749*/
		$1.options = $k[--$j]; /*3751*/
		$1.barcode = $k[--$j]; /*3752*/
		$1.dontdraw = false; /*3754*/
		$1.includetext = false; /*3755*/
		$1.parse = false; /*3756*/
		$forall($1.options, function() { /*3767*/
			var _3 = $k[--$j]; /*3767*/
			$1[$k[--$j]] = _3; /*3767*/
		}); /*3767*/
		$forall($1.barcode, function() { /*3795*/
			if ($k[--$j] >= 128) { /*3794*/
				$k[$j++] = "bwipp.code39extBadCharacter"; /*3793*/
				$k[$j++] = "Code 39 Extended must contain only ASCII characters"; /*3793*/
				$0.raiseerror(); /*3793*/
			} /*3793*/
		}); /*3793*/
		$1.barlen = $1.barcode.length; /*3797*/
		$1.extencs = $a(["%U", "$A", "$B", "$C", "$D", "$E", "$F", "$G", "$H", "$I", "$J", "$K", "$L", "$M", "$N", "$O", "$P", "$Q", "$R", "$S", "$T", "$U", "$V", "$W", "$X", "$Y", "$Z", "%A", "%B", "%C", "%D", "%E", " ", "/A", "/B", "/C", "/D", "/E", "/F", "/G", "/H", "/I", "/J", "/K", "/L", "-", ".", "/O", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "/Z", "%F", "%G", "%H", "%I", "%J", "%V", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "%K", "%L", "%M", "%N", "%O", "%W", "+A", "+B", "+C", "+D", "+E", "+F", "+G", "+H", "+I", "+J", "+K", "+L", "+M", "+N", "+O", "+P", "+Q", "+R", "+S", "+T", "+U", "+V", "+W", "+X", "+Y", "+Z", "%P", "%Q", "%R", "%S", "%T"]); /*3809*/
		$1.newcode = $s($1.barlen * 2); /*3811*/
		$1.newtext = $s($1.barlen * 2); /*3812*/
		$1.j = 0; /*3813*/
		for (var _F = 0, _E = $1.barlen - 1; _F <= _E; _F += 1) { /*3821*/
			$1.i = _F; /*3815*/
			$1.extchar = $get($1.extencs, $get($1.barcode, $1.i)); /*3816*/
			$puti($1.newcode, $1.j, $1.extchar); /*3817*/
			$put($1.newtext, $1.j, $get($1.barcode, $1.i)); /*3818*/
			if ($1.extchar.length != 1) { /*3819*/
				$puti($1.newtext, $1.j + 1, " "); /*3819*/
			} /*3819*/
			$1.j = $1.j + $1.extchar.length; /*3820*/
		} /*3820*/
		$1.newcode = $geti($1.newcode, 0, $1.j); /*3822*/
		$1.newtext = $geti($1.newtext, 0, $1.j); /*3823*/
		$1.options.dontdraw = true; /*3826*/
		$k[$j++] = "args"; /*3827*/
		$k[$j++] = $1.newcode; /*3827*/
		$k[$j++] = $1.options; /*3827*/
		$0.code39(); /*3827*/
		var _h = $k[--$j]; /*3827*/
		$1[$k[--$j]] = _h; /*3827*/
		if ($1.includetext) { /*3839*/
			$1.txt = $1.args.txt; /*3831*/
			for (var _o = 0, _n = $1.newtext.length - 1; _o <= _n; _o += 1) { /*3837*/
				$1.i = _o; /*3833*/
				$1.txtentry = $get($1.txt, $1.i + 1); /*3834*/
				$put($1.txtentry, 0, $geti($1.newtext, $1.i, 1)); /*3835*/
				$put($1.txt, $1.i + 1, $1.txtentry); /*3836*/
			} /*3836*/
			$1.args.txt = $1.txt; /*3838*/
		} /*3838*/
		$1.args.opt = $1.options; /*3840*/
		$k[$j++] = $1.args; /*3843*/
		if (!$1.dontdraw) { /*3843*/
			$0.renlinear(); /*3843*/
		} /*3843*/
	};
	$0.code32 = function() {
		var $1 = {}; /*3871*/
		$1.options = $k[--$j]; /*3873*/
		$1.barcode = $k[--$j]; /*3874*/
		$1.dontdraw = false; /*3876*/
		$1.includetext = false; /*3877*/
		$1.textfont = "Courier"; /*3878*/
		$1.textsize = 10; /*3879*/
		$1.textyoffset = -8.5; /*3880*/
		$1.textxoffset = 0; /*3881*/
		$1.height = 1; /*3882*/
		$forall($1.options, function() { /*3893*/
			var _3 = $k[--$j]; /*3893*/
			$1[$k[--$j]] = _3; /*3893*/
		}); /*3893*/
		$1.textfont = "" + $1.textfont; /*3895*/
		$1.textsize = +$1.textsize; /*3896*/
		$1.textyoffset = +$1.textyoffset; /*3897*/
		$1.height = +$1.height; /*3898*/
		if (($1.barcode.length != 8) && ($1.barcode.length != 9)) { /*3903*/
			$k[$j++] = "bwipp.code32badLength"; /*3902*/
			$k[$j++] = "Italian Pharmacode must be 8 or 9 digits"; /*3902*/
			$0.raiseerror(); /*3902*/
		} /*3902*/
		$forall($1.barcode, function() { /*3908*/
			var _C = $k[--$j]; /*3905*/
			if ((_C < 48) || (_C > 57)) { /*3907*/
				$k[$j++] = "bwipp.code32badCharacter"; /*3906*/
				$k[$j++] = "Italian Pharmacode must contain only digits"; /*3906*/
				$0.raiseerror(); /*3906*/
			} /*3906*/
		}); /*3906*/
		$1.checksum = 0; /*3911*/
		for (var _D = 0; _D <= 7; _D += 1) { /*3916*/
			$1.i = _D; /*3913*/
			$k[$j++] = $get($1.barcode, $1.i) - 48; /*3914*/
			if (($1.i % 2) != 0) { /*3914*/
				var _I = $k[--$j]; /*3914*/
				$k[$j++] = _I * 2; /*3914*/
			} /*3914*/
			var _J = $k[--$j]; /*3914*/
			$k[$j++] = _J; /*3914*/
			if (_J > 9) { /*3914*/
				var _K = $k[--$j]; /*3914*/
				$k[$j++] = _K - 9; /*3914*/
			} /*3914*/
			$1.checksum = $k[--$j] + $1.checksum; /*3915*/
		} /*3915*/
		$1.checksum = $1.checksum % 10; /*3917*/
		if ($1.barcode.length == 9) { /*3922*/
			if ($get($1.barcode, 8) != ($1.checksum + 48)) { /*3921*/
				$k[$j++] = "bwipp.code32badCheckDigit"; /*3920*/
				$k[$j++] = "Incorrect Italian Pharmacode check digit provided"; /*3920*/
				$0.raiseerror(); /*3920*/
			} /*3920*/
		} /*3920*/
		var _S = $s(10); /*3923*/
		$puti(_S, 0, $1.barcode); /*3924*/
		$put(_S, 8, $1.checksum + 48); /*3925*/
		$1.text = _S; /*3926*/
		$1.val = $cvrs($1.barcode, ~~$z($1.text), 32); /*3929*/
		$1.barcode = $s(6); /*3930*/
		for (var _Z = 0; _Z <= 5; _Z += 1) { /*3931*/
			$put($1.barcode, _Z, 48); /*3931*/
		} /*3931*/
		$puti($1.barcode, 6 - $1.val.length, $1.val); /*3932*/
		for (var _e = 0; _e <= 5; _e += 1) { /*3939*/
			var _g = $get($1.barcode, _e); /*3936*/
			$k[$j++] = _e; /*3937*/
			$k[$j++] = _g; /*3937*/
			$k[$j++] = _g; /*3937*/
			for (var _h = 0, _i = "AEIO".length; _h < _i; _h++) { /*3937*/
				if ($k[--$j] >= $get("AEIO", _h)) { /*3937*/
					var _l = $k[--$j]; /*3937*/
					$k[$j++] = _l + 1; /*3937*/
				} /*3937*/
				var _m = $k[--$j]; /*3937*/
				$k[$j++] = _m; /*3937*/
				$k[$j++] = _m; /*3937*/
			} /*3937*/
			$j--; /*3937*/
			var _o = $k[--$j]; /*3938*/
			$put($1.barcode, $k[--$j], _o); /*3938*/
		} /*3938*/
		$puti($1.text, 1, $geti($1.text, 0, 9)); /*3942*/
		$put($1.text, 0, 65); /*3943*/
		$1.options.dontdraw = true; /*3946*/
		$k[$j++] = "args"; /*3947*/
		$k[$j++] = $1.barcode; /*3947*/
		$k[$j++] = $1.options; /*3947*/
		$0.code39(); /*3947*/
		var _x = $k[--$j]; /*3947*/
		$1[$k[--$j]] = _x; /*3947*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*3949*/
		$1.args.textxalign = "center"; /*3950*/
		$1.args.opt = $1.options; /*3951*/
		$k[$j++] = $1.args; /*3954*/
		if (!$1.dontdraw) { /*3954*/
			$0.renlinear(); /*3954*/
		} /*3954*/
	};
	$0.pzn = function() {
		var $1 = {}; /*3982*/
		$1.options = $k[--$j]; /*3984*/
		$1.barcode = $k[--$j]; /*3985*/
		$1.dontdraw = false; /*3987*/
		$1.includetext = false; /*3988*/
		$1.textfont = "Courier"; /*3989*/
		$1.textsize = 10; /*3990*/
		$1.textyoffset = -8.5; /*3991*/
		$1.textxoffset = 0; /*3992*/
		$1.height = 1; /*3993*/
		$1.pzn8 = false; /*3994*/
		$forall($1.options, function() { /*4005*/
			var _3 = $k[--$j]; /*4005*/
			$1[$k[--$j]] = _3; /*4005*/
		}); /*4005*/
		$1.textfont = "" + $1.textfont; /*4007*/
		$1.textsize = +$1.textsize; /*4008*/
		$1.textyoffset = +$1.textyoffset; /*4009*/
		$1.textxoffset = +$1.textxoffset; /*4010*/
		$1.height = +$1.height; /*4011*/
		if ($1.pzn8) { /*4020*/
			if (($1.barcode.length != 7) && ($1.barcode.length != 8)) { /*4017*/
				$k[$j++] = "bwipp.pzn8badLength"; /*4016*/
				$k[$j++] = "PZN8 must be 7 or 8 digits"; /*4016*/
				$0.raiseerror(); /*4016*/
			} /*4016*/
		} else { /*4020*/
			if (($1.barcode.length != 6) && ($1.barcode.length != 7)) { /*4021*/
				$k[$j++] = "bwipp.pzn7badLength"; /*4020*/
				$k[$j++] = "PZN7 must be 6 or 7 digits"; /*4020*/
				$0.raiseerror(); /*4020*/
			} /*4020*/
		} /*4020*/
		$forall($1.barcode, function() { /*4027*/
			var _G = $k[--$j]; /*4024*/
			if ((_G < 48) || (_G > 57)) { /*4026*/
				$k[$j++] = "bwipp.pznBadCharacter"; /*4025*/
				$k[$j++] = "PZN must contain only digits"; /*4025*/
				$0.raiseerror(); /*4025*/
			} /*4025*/
		}); /*4025*/
		var _I = $1.pzn8 ? 9 : 8; /*4030*/
		$1.msglen = _I; /*4030*/
		$1.checksum = 0; /*4031*/
		for (var _L = 0, _K = $1.msglen - 3; _L <= _K; _L += 1) { /*4036*/
			$1.i = _L; /*4033*/
			var _R = $1.pzn8 ? 1 : 2; /*4034*/
			$1.checksum = (($get($1.barcode, $1.i) - 48) * ($1.i + _R)) + $1.checksum; /*4035*/
		} /*4035*/
		$1.checksum = $1.checksum % 11; /*4037*/
		if ($1.checksum == 10) { /*4040*/
			$k[$j++] = "bwipp.pznBadInputSequence"; /*4039*/
			$k[$j++] = "Incorrect PZN input sequence provided"; /*4039*/
			$0.raiseerror(); /*4039*/
		} /*4039*/
		if ($1.barcode.length == ($1.msglen - 1)) { /*4045*/
			if ($get($1.barcode, $1.msglen - 2) != ($1.checksum + 48)) { /*4044*/
				$k[$j++] = "bwipp.pznBadCheckDigit"; /*4043*/
				$k[$j++] = "Incorrect PZN check digit provided"; /*4043*/
				$0.raiseerror(); /*4043*/
			} /*4043*/
		} /*4043*/
		var _c = $s($1.msglen); /*4046*/
		$put(_c, 0, 45); /*4047*/
		$puti(_c, 1, $1.barcode); /*4048*/
		$put(_c, $1.msglen - 1, $1.checksum + 48); /*4049*/
		$1.msg = _c; /*4050*/
		$1.options.dontdraw = true; /*4053*/
		$k[$j++] = "args"; /*4054*/
		$k[$j++] = $1.msg; /*4054*/
		$k[$j++] = $1.options; /*4054*/
		$0.code39(); /*4054*/
		var _j = $k[--$j]; /*4054*/
		$1[$k[--$j]] = _j; /*4054*/
		$1.text = $s($1.msglen + 5); /*4057*/
		$puti($1.text, 0, "PZN - "); /*4058*/
		$puti($1.text, 6, $geti($1.msg, 1, $1.msglen - 1)); /*4059*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4061*/
		$1.args.textxalign = "center"; /*4062*/
		$1.args.opt = $1.options; /*4063*/
		$k[$j++] = $1.args; /*4066*/
		if (!$1.dontdraw) { /*4066*/
			$0.renlinear(); /*4066*/
		} /*4066*/
	};
	$0.code93 = function() {
		var $1 = {}; /*4093*/
		$1.options = $k[--$j]; /*4095*/
		$1.barcode = $k[--$j]; /*4096*/
		$1.dontdraw = false; /*4098*/
		$1.includecheck = false; /*4099*/
		$1.includetext = false; /*4100*/
		$1.textfont = "Courier"; /*4101*/
		$1.textsize = 10; /*4102*/
		$1.textyoffset = -8.5; /*4103*/
		$1.height = 1; /*4104*/
		$1.parsefnc = false; /*4105*/
		$forall($1.options, function() { /*4116*/
			var _3 = $k[--$j]; /*4116*/
			$1[$k[--$j]] = _3; /*4116*/
		}); /*4116*/
		$1.textfont = "" + $1.textfont; /*4118*/
		$1.textsize = +$1.textsize; /*4119*/
		$1.textyoffset = +$1.textyoffset; /*4120*/
		$1.height = +$1.height; /*4121*/
		$1.encs = $a(["131112", "111213", "111312", "111411", "121113", "121212", "121311", "111114", "131211", "141111", "211113", "211212", "211311", "221112", "221211", "231111", "112113", "112212", "112311", "122112", "132111", "111123", "111222", "111321", "121122", "131121", "212112", "212211", "211122", "211221", "221121", "222111", "112122", "112221", "122121", "123111", "121131", "311112", "311211", "321111", "112131", "113121", "211131", "121221", "312111", "311121", "122211", "111141", "1111411"]); /*4134*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*4137*/
		$1.barlen = $1.barcode.length; /*4139*/
		$1.sft1 = -1; /*4142*/
		$1.sft2 = -2; /*4142*/
		$1.sft3 = -3; /*4142*/
		$1.sft4 = -4; /*4142*/
		var _F = {
			"SFT$": $1.sft1,
			"SFT%": $1.sft2,
			"SFT/": $1.sft3,
			"SFT+": $1.sft4
		}; /*4147*/
		$1.fncvals = _F; /*4148*/
		$1.msg = $a($1.barlen); /*4151*/
		$1.i = 0; /*4152*/
		$1.j = 0; /*4152*/
		for (;;) { /*4166*/
			if ($1.i == $1.barlen) { /*4153*/
				break; /*4153*/
			} /*4153*/
			$1.char = $get($1.barcode, $1.i); /*4154*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*4162*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*4160*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*4157*/
					$1.i = $1.i + 4; /*4158*/
				} else { /*4160*/
					$1.i = $1.i + 1; /*4160*/
				} /*4160*/
			} /*4160*/
			$put($1.msg, $1.j, $1.char); /*4163*/
			$1.i = $1.i + 1; /*4164*/
			$1.j = $1.j + 1; /*4165*/
		} /*4165*/
		$1.msg = $geti($1.msg, 0, $1.j); /*4167*/
		$1.msglen = $1.msg.length; /*4168*/
		if ($1.includecheck) { /*4173*/
			$1.sbs = $s(($1.msglen * 6) + 25); /*4171*/
		} else { /*4173*/
			$1.sbs = $s(($1.msglen * 6) + 13); /*4173*/
		} /*4173*/
		$1.txt = $a($1.msglen); /*4175*/
		$puti($1.sbs, 0, $get($1.encs, 47)); /*4178*/
		$1.checksum1 = 0; /*4180*/
		$1.checksum2 = 0; /*4180*/
		for (var _w = 0, _v = $1.msglen - 1; _w <= _v; _w += 1) { /*4199*/
			$1.i = _w; /*4182*/
			var _z = $get($1.msg, $1.i); /*4184*/
			$k[$j++] = _z; /*4193*/
			if (_z < 0) { /*4192*/
				$1.indx = 42 - $k[--$j]; /*4185*/
				$1.char = " "; /*4186*/
			} else { /*4192*/
				var _11 = $s(1); /*4188*/
				$put(_11, 0, $k[--$j]); /*4188*/
				$1.char = _11; /*4188*/
				$search($1.barchars, $1.char); /*4189*/
				$j--; /*4190*/
				$1.indx = $k[--$j].length; /*4191*/
				$j -= 2; /*4192*/
			} /*4192*/
			$1.enc = $get($1.encs, $1.indx); /*4194*/
			$puti($1.sbs, ($1.i * 6) + 6, $1.enc); /*4195*/
			$put($1.txt, $1.i, $a([$1.char, ($1.i * 9) + 9, $1.textyoffset, $1.textfont, $1.textsize])); /*4196*/
			$1.checksum1 = $1.checksum1 + ((((($1.msglen - $1.i) - 1) % 20) + 1) * $1.indx); /*4197*/
			$1.checksum2 = $1.checksum2 + (((($1.msglen - $1.i) % 15) + 1) * $1.indx); /*4198*/
		} /*4198*/
		if ($1.includecheck) { /*4211*/
			$1.checksum1 = $1.checksum1 % 47; /*4203*/
			$1.checksum2 = ($1.checksum2 + $1.checksum1) % 47; /*4204*/
			$puti($1.sbs, ($1.msglen * 6) + 6, $get($1.encs, $1.checksum1)); /*4205*/
			$puti($1.sbs, ($1.msglen * 6) + 12, $get($1.encs, $1.checksum2)); /*4206*/
			$puti($1.sbs, ($1.msglen * 6) + 18, $get($1.encs, 48)); /*4208*/
		} else { /*4211*/
			$puti($1.sbs, ($1.msglen * 6) + 6, $get($1.encs, 48)); /*4211*/
		} /*4211*/
		$k[$j++] = Infinity; /*4223*/
		$k[$j++] = "ren"; /*4218*/
		$k[$j++] = $0.renlinear; /*4218*/
		$k[$j++] = "sbs"; /*4218*/
		$k[$j++] = Infinity; /*4218*/
		var _1o = $1.sbs; /*4217*/
		for (var _1p = 0, _1q = _1o.length; _1p < _1q; _1p++) { /*4217*/
			$k[$j++] = $get(_1o, _1p) - 48; /*4217*/
		} /*4217*/
		var _1s = $a(); /*4218*/
		$k[$j++] = _1s; /*4219*/
		$k[$j++] = "bhs"; /*4219*/
		$k[$j++] = Infinity; /*4219*/
		for (var _1u = 0, _1v = ~~(($1.sbs.length + 1) / 2); _1u < _1v; _1u++) { /*4218*/
			$k[$j++] = $1.height; /*4218*/
		} /*4218*/
		var _1x = $a(); /*4219*/
		$k[$j++] = _1x; /*4220*/
		$k[$j++] = "bbs"; /*4220*/
		$k[$j++] = Infinity; /*4220*/
		for (var _1z = 0, _20 = ~~(($1.sbs.length + 1) / 2); _1z < _20; _1z++) { /*4219*/
			$k[$j++] = 0; /*4219*/
		} /*4219*/
		var _21 = $a(); /*4220*/
		$k[$j++] = _21; /*4222*/
		if ($1.includetext) { /*4222*/
			$k[$j++] = "txt"; /*4221*/
			$k[$j++] = $1.txt; /*4221*/
		} /*4221*/
		$k[$j++] = "opt"; /*4223*/
		$k[$j++] = $1.options; /*4223*/
		var _25 = $d(); /*4223*/
		$k[$j++] = _25; /*4226*/
		if (!$1.dontdraw) { /*4226*/
			$0.renlinear(); /*4226*/
		} /*4226*/
	};
	$0.code93ext = function() {
		var $1 = {}; /*4254*/
		$1.options = $k[--$j]; /*4256*/
		$1.barcode = $k[--$j]; /*4257*/
		$1.dontdraw = false; /*4259*/
		$1.includetext = false; /*4260*/
		$1.parse = false; /*4261*/
		$forall($1.options, function() { /*4272*/
			var _3 = $k[--$j]; /*4272*/
			$1[$k[--$j]] = _3; /*4272*/
		}); /*4272*/
		$1.barlen = $1.barcode.length; /*4295*/
		$1.extencs = $a(["^SFT%U", "^SFT$A", "^SFT$B", "^SFT$C", "^SFT$D", "^SFT$E", "^SFT$F", "^SFT$G", "^SFT$H", "^SFT$I", "^SFT$J", "^SFT$K", "^SFT$L", "^SFT$M", "^SFT$N", "^SFT$O", "^SFT$P", "^SFT$Q", "^SFT$R", "^SFT$S", "^SFT$T", "^SFT$U", "^SFT$V", "^SFT$W", "^SFT$X", "^SFT$Y", "^SFT$Z", "^SFT%A", "^SFT%B", "^SFT%C", "^SFT%D", "^SFT%E", " ", "^SFT/A", "^SFT/B", "^SFT/C", "^SFT/D", "^SFT/E", "^SFT/F", "^SFT/G", "^SFT/H", "^SFT/I", "^SFT/J", "^SFT/K", "^SFT/L", "-", ".", "^SFT/O", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "^SFT/Z", "^SFT%F", "^SFT%G", "^SFT%H", "^SFT%I", "^SFT%J", "^SFT%V", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "^SFT%K", "^SFT%L", "^SFT%M", "^SFT%N", "^SFT%O", "^SFT%W", "^SFT+A", "^SFT+B", "^SFT+C", "^SFT+D", "^SFT+E", "^SFT+F", "^SFT+G", "^SFT+H", "^SFT+I", "^SFT+J", "^SFT+K", "^SFT+L", "^SFT+M", "^SFT+N", "^SFT+O", "^SFT+P", "^SFT+Q", "^SFT+R", "^SFT+S", "^SFT+T", "^SFT+U", "^SFT+V", "^SFT+W", "^SFT+X", "^SFT+Y", "^SFT+Z", "^SFT%P", "^SFT%Q", "^SFT%R", "^SFT%S", "^SFT%T"]); /*4315*/
		$1.newcode = $s($1.barlen * 6); /*4317*/
		$1.newtext = $s($1.barlen * 6); /*4318*/
		$1.j = 0; /*4319*/
		$1.k = 0; /*4319*/
		for (var _D = 0, _C = $1.barlen - 1; _D <= _C; _D += 1) { /*4329*/
			$1.i = _D; /*4321*/
			$1.extchar = $get($1.extencs, $get($1.barcode, $1.i)); /*4322*/
			$1.extlen = $1.extchar.length; /*4323*/
			$puti($1.newcode, $1.j, $1.extchar); /*4324*/
			$put($1.newtext, $1.k, $get($1.barcode, $1.i)); /*4325*/
			if ($1.extlen != 1) { /*4326*/
				$puti($1.newtext, $1.k + 1, " "); /*4326*/
			} /*4326*/
			$1.j = $1.j + $1.extlen; /*4327*/
			var _Z = ($1.extlen == 1) ? 1 : 2; /*4328*/
			$1.k = $1.k + _Z; /*4328*/
		} /*4328*/
		$1.newcode = $geti($1.newcode, 0, $1.j); /*4330*/
		$1.newtext = $geti($1.newtext, 0, $1.k); /*4331*/
		$1.options.dontdraw = true; /*4334*/
		$1.options.parsefnc = true; /*4335*/
		$k[$j++] = "args"; /*4336*/
		$k[$j++] = $1.newcode; /*4336*/
		$k[$j++] = $1.options; /*4336*/
		$0.code93(); /*4336*/
		var _k = $k[--$j]; /*4336*/
		$1[$k[--$j]] = _k; /*4336*/
		if ($1.includetext) { /*4348*/
			$1.txt = $1.args.txt; /*4340*/
			for (var _r = 0, _q = $1.newtext.length - 1; _r <= _q; _r += 1) { /*4346*/
				$1.i = _r; /*4342*/
				$1.txtentry = $get($1.txt, $1.i); /*4343*/
				$put($1.txtentry, 0, $geti($1.newtext, $1.i, 1)); /*4344*/
				$put($1.txt, $1.i, $1.txtentry); /*4345*/
			} /*4345*/
			$1.args.txt = $1.txt; /*4347*/
		} /*4347*/
		$1.args.opt = $1.options; /*4349*/
		$k[$j++] = $1.args; /*4352*/
		if (!$1.dontdraw) { /*4352*/
			$0.renlinear(); /*4352*/
		} /*4352*/
	};
	$0.interleaved2of5 = function() {
		var $1 = {}; /*4379*/
		$1.options = $k[--$j]; /*4381*/
		$1.barcode = $k[--$j]; /*4382*/
		$1.dontdraw = false; /*4384*/
		$1.includecheck = false; /*4385*/
		$1.includetext = false; /*4386*/
		$1.includecheckintext = false; /*4387*/
		$1.textfont = "Courier"; /*4388*/
		$1.textsize = 10; /*4389*/
		$1.textyoffset = -8.5; /*4390*/
		$1.height = 1; /*4391*/
		$forall($1.options, function() { /*4402*/
			var _3 = $k[--$j]; /*4402*/
			$1[$k[--$j]] = _3; /*4402*/
		}); /*4402*/
		$1.textfont = "" + $1.textfont; /*4404*/
		$1.textsize = +$1.textsize; /*4405*/
		$1.textyoffset = +$1.textyoffset; /*4406*/
		$1.height = +$1.height; /*4407*/
		$forall($1.barcode, function() { /*4414*/
			var _A = $k[--$j]; /*4411*/
			if ((_A < 48) || (_A > 57)) { /*4413*/
				$k[$j++] = "bwipp.interleaved2of5badCharacter"; /*4412*/
				$k[$j++] = "Interleaved 2 of 5 must contain only digits"; /*4412*/
				$0.raiseerror(); /*4412*/
			} /*4412*/
		}); /*4412*/
		$1.barlen = $1.barcode.length; /*4416*/
		if (((($1.barlen % 2) == 0) && $1.includecheck) || ((($1.barlen % 2) != 0) && (!$1.includecheck))) { /*4427*/
			$1.pad = $s($1.barlen + 1); /*4422*/
			$put($1.pad, 0, 48); /*4423*/
			$puti($1.pad, 1, $1.barcode); /*4424*/
			$1.barcode = $1.pad; /*4425*/
			$1.barlen = $1.barlen + 1; /*4426*/
		} /*4426*/
		if ($1.includecheck) { /*4446*/
			$1.checksum = 0; /*4431*/
			for (var _Q = 0, _P = $1.barlen - 1; _Q <= _P; _Q += 1) { /*4439*/
				$1.i = _Q; /*4433*/
				if (($1.i % 2) == 0) { /*4437*/
					$1.checksum = $1.checksum + (($get($1.barcode, $1.i) - 48) * 3); /*4435*/
				} else { /*4437*/
					$1.checksum = $1.checksum + ($get($1.barcode, $1.i) - 48); /*4437*/
				} /*4437*/
			} /*4437*/
			$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4440*/
			$1.pad = $s($1.barlen + 1); /*4441*/
			$puti($1.pad, 0, $1.barcode); /*4442*/
			$put($1.pad, $1.barlen, $1.checksum + 48); /*4443*/
			$1.barcode = $1.pad; /*4444*/
			$1.barlen = $1.barlen + 1; /*4445*/
		} /*4445*/
		$1.encs = $a(["11221", "21112", "12112", "22111", "11212", "21211", "12211", "11122", "21121", "12121", "1111", "2111"]); /*4453*/
		$1.barchars = "0123456789"; /*4456*/
		$1.sbs = $s(($1.barlen * 5) + 8); /*4457*/
		$1.txt = $a($1.barlen); /*4458*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*4461*/
		for (var _u = 0, _t = $1.barlen - 1; _u <= _t; _u += 2) { /*4495*/
			$1.i = _u; /*4464*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*4466*/
			$j--; /*4467*/
			$1.indx = $k[--$j].length; /*4468*/
			$j -= 2; /*4469*/
			$1.enca = $get($1.encs, $1.indx); /*4470*/
			$search($1.barchars, $geti($1.barcode, $1.i + 1, 1)); /*4472*/
			$j--; /*4473*/
			$1.indx = $k[--$j].length; /*4474*/
			$j -= 2; /*4475*/
			$1.encb = $get($1.encs, $1.indx); /*4476*/
			$1.intl = $s($1.enca.length * 2); /*4479*/
			for (var _1F = 0, _1E = $1.enca.length - 1; _1F <= _1E; _1F += 1) { /*4486*/
				$1.j = _1F; /*4481*/
				$1.achar = $get($1.enca, $1.j); /*4482*/
				$1.bchar = $get($1.encb, $1.j); /*4483*/
				$put($1.intl, $1.j * 2, $1.achar); /*4484*/
				$put($1.intl, ($1.j * 2) + 1, $1.bchar); /*4485*/
			} /*4485*/
			$puti($1.sbs, ($1.i * 5) + 4, $1.intl); /*4488*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 9) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*4489*/
			if (($1.includecheck && (!$1.includecheckintext)) && (($1.barlen - 2) == $1.i)) { /*4493*/
				$put($1.txt, $1.i + 1, $a([" ", (($1.i + 1) * 9) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*4491*/
			} else { /*4493*/
				$put($1.txt, $1.i + 1, $a([$geti($1.barcode, $1.i + 1, 1), (($1.i + 1) * 9) + 4, $1.textyoffset, $1.textfont, $1.textsize])); /*4493*/
			} /*4493*/
		} /*4493*/
		$puti($1.sbs, ($1.barlen * 5) + 4, $get($1.encs, 11)); /*4498*/
		$k[$j++] = Infinity; /*4511*/
		$k[$j++] = "ren"; /*4504*/
		$k[$j++] = $0.renlinear; /*4504*/
		$k[$j++] = "sbs"; /*4504*/
		$k[$j++] = Infinity; /*4504*/
		var _24 = $1.sbs; /*4503*/
		for (var _25 = 0, _26 = _24.length; _25 < _26; _25++) { /*4503*/
			$k[$j++] = $get(_24, _25) - 48; /*4503*/
		} /*4503*/
		var _28 = $a(); /*4504*/
		$k[$j++] = _28; /*4505*/
		$k[$j++] = "bhs"; /*4505*/
		$k[$j++] = Infinity; /*4505*/
		for (var _2A = 0, _2B = ~~(($1.sbs.length + 1) / 2); _2A < _2B; _2A++) { /*4504*/
			$k[$j++] = $1.height; /*4504*/
		} /*4504*/
		var _2D = $a(); /*4505*/
		$k[$j++] = _2D; /*4506*/
		$k[$j++] = "bbs"; /*4506*/
		$k[$j++] = Infinity; /*4506*/
		for (var _2F = 0, _2G = ~~(($1.sbs.length + 1) / 2); _2F < _2G; _2F++) { /*4505*/
			$k[$j++] = 0; /*4505*/
		} /*4505*/
		var _2H = $a(); /*4506*/
		$k[$j++] = _2H; /*4508*/
		if ($1.includetext) { /*4508*/
			$k[$j++] = "txt"; /*4507*/
			$k[$j++] = $1.txt; /*4507*/
		} /*4507*/
		$k[$j++] = "barratio"; /*4511*/
		$k[$j++] = 2; /*4511*/
		$k[$j++] = "spaceratio"; /*4511*/
		$k[$j++] = 2; /*4511*/
		$k[$j++] = "opt"; /*4511*/
		$k[$j++] = $1.options; /*4511*/
		var _2L = $d(); /*4511*/
		$k[$j++] = _2L; /*4514*/
		if (!$1.dontdraw) { /*4514*/
			$0.renlinear(); /*4514*/
		} /*4514*/
	};
	$0.itf14 = function() {
		var $1 = {}; /*4542*/
		$1.options = $k[--$j]; /*4544*/
		$1.barcode = $k[--$j]; /*4545*/
		$1.dontdraw = false; /*4547*/
		$1.includetext = false; /*4548*/
		$1.includecheckintext = true; /*4549*/
		$1.textfont = "Courier"; /*4550*/
		$1.textsize = 10; /*4551*/
		$1.textxoffset = 0; /*4552*/
		$1.textyoffset = 3; /*4553*/
		$1.height = 0.5; /*4554*/
		$1.showborder = true; /*4555*/
		$1.borderwidth = 4; /*4556*/
		$1.borderleft = 15; /*4557*/
		$1.borderright = 15; /*4558*/
		$forall($1.options, function() { /*4569*/
			var _3 = $k[--$j]; /*4569*/
			$1[$k[--$j]] = _3; /*4569*/
		}); /*4569*/
		$1.textfont = "" + $1.textfont; /*4571*/
		$1.textsize = +$1.textsize; /*4572*/
		$1.textxoffset = +$1.textxoffset; /*4573*/
		$1.textyoffset = +$1.textyoffset; /*4574*/
		$1.height = +$1.height; /*4575*/
		$1.borderwidth = +$1.borderwidth; /*4576*/
		$1.borderleft = +$1.borderleft; /*4577*/
		$1.borderright = +$1.borderright; /*4578*/
		$1.text = $1.barcode; /*4581*/
		var _E = $1.barcode; /*4582*/
		$k[$j++] = $s(_E.length); /*4583*/
		$k[$j++] = 0; /*4583*/
		$forall(_E, function() { /*4583*/
			var _G = $k[--$j]; /*4583*/
			$k[$j++] = _G; /*4583*/
			if (_G != 32) { /*4583*/
				var _H = $k[--$j]; /*4583*/
				var _I = $k[--$j]; /*4583*/
				var _J = $k[--$j]; /*4583*/
				$put(_J, _I, _H); /*4583*/
				$k[$j++] = _J; /*4583*/
				$k[$j++] = _I + 1; /*4583*/
			} else { /*4583*/
				$j--; /*4583*/
			} /*4583*/
		}); /*4583*/
		var _K = $k[--$j]; /*4584*/
		$1.barcode = $geti($k[--$j], 0, _K); /*4584*/
		$1.hasspace = $1.text.length != $1.barcode.length; /*4585*/
		if (($1.barcode.length != 13) && ($1.barcode.length != 14)) { /*4590*/
			$k[$j++] = "bwipp.itf14badLength"; /*4589*/
			$k[$j++] = "ITF-14 must be 13 or 14 digits"; /*4589*/
			$0.raiseerror(); /*4589*/
		} /*4589*/
		$forall($1.barcode, function() { /*4595*/
			var _S = $k[--$j]; /*4592*/
			if ((_S < 48) || (_S > 57)) { /*4594*/
				$k[$j++] = "bwipp.itf14badCharacter"; /*4593*/
				$k[$j++] = "ITF-14 must contain only digits"; /*4593*/
				$0.raiseerror(); /*4593*/
			} /*4593*/
		}); /*4593*/
		$1.checksum = 0; /*4598*/
		for (var _T = 0; _T <= 12; _T += 1) { /*4602*/
			$1.i = _T; /*4600*/
			$k[$j++] = "checksum"; /*4601*/
			$k[$j++] = $1.checksum; /*4601*/
			$k[$j++] = $get($1.barcode, $1.i) - 48; /*4601*/
			if (($1.i % 2) == 0) { /*4601*/
				var _Z = $k[--$j]; /*4601*/
				$k[$j++] = _Z * 3; /*4601*/
			} /*4601*/
			var _a = $k[--$j]; /*4601*/
			var _b = $k[--$j]; /*4601*/
			$1[$k[--$j]] = _b + _a; /*4601*/
		} /*4601*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4603*/
		if ($1.barcode.length == 14) { /*4617*/
			if ($get($1.barcode, 13) != ($1.checksum + 48)) { /*4607*/
				$k[$j++] = "bwipp.itf14badCheckDigit"; /*4606*/
				$k[$j++] = "Incorrect ITF-14 check digit provided"; /*4606*/
				$0.raiseerror(); /*4606*/
			} /*4606*/
		} else { /*4617*/
			var _i = $s(14); /*4609*/
			$puti(_i, 0, $1.barcode); /*4610*/
			$put(_i, 13, $1.checksum + 48); /*4611*/
			$1.barcode = _i; /*4612*/
			var _n = $1.hasspace ? 2 : 1; /*4613*/
			var _o = $s($1.text.length + _n); /*4613*/
			$puti(_o, _o.length - 2, " "); /*4614*/
			$put(_o, _o.length - 1, $1.checksum + 48); /*4615*/
			$puti(_o, 0, $1.text); /*4616*/
			$1.text = _o; /*4617*/
		} /*4617*/
		$1.options.dontdraw = true; /*4621*/
		$1.options.showborder = $1.showborder; /*4622*/
		$1.options.borderwidth = $1.borderwidth; /*4623*/
		$1.options.borderleft = $1.borderleft; /*4624*/
		$1.options.borderright = $1.borderright; /*4625*/
		$1.options.height = $1.height; /*4626*/
		$1.options.textyoffset = $1.textyoffset; /*4627*/
		$k[$j++] = "args"; /*4628*/
		$k[$j++] = $1.barcode; /*4628*/
		$k[$j++] = $1.options; /*4628*/
		$0.interleaved2of5(); /*4628*/
		var _16 = $k[--$j]; /*4628*/
		$1[$k[--$j]] = _16; /*4628*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4630*/
		$1.args.textxalign = "center"; /*4631*/
		$1.args.opt = $1.options; /*4632*/
		$k[$j++] = $1.args; /*4635*/
		if (!$1.dontdraw) { /*4635*/
			$0.renlinear(); /*4635*/
		} /*4635*/
	};
	$0.identcode = function() {
		var $1 = {}; /*4663*/
		$1.options = $k[--$j]; /*4665*/
		$1.barcode = $k[--$j]; /*4666*/
		$1.dontdraw = false; /*4668*/
		$1.includetext = false; /*4669*/
		$1.textfont = "Courier"; /*4670*/
		$1.textsize = 10; /*4671*/
		$1.textxoffset = 0; /*4672*/
		$1.textyoffset = -8.5; /*4673*/
		$1.height = 1; /*4674*/
		$forall($1.options, function() { /*4685*/
			var _3 = $k[--$j]; /*4685*/
			$1[$k[--$j]] = _3; /*4685*/
		}); /*4685*/
		$1.textfont = "" + $1.textfont; /*4687*/
		$1.textsize = +$1.textsize; /*4688*/
		$1.textxoffset = +$1.textxoffset; /*4689*/
		$1.textyoffset = +$1.textyoffset; /*4690*/
		$1.height = +$1.height; /*4691*/
		if (($1.barcode.length != 11) && ($1.barcode.length != 12)) { /*4696*/
			$k[$j++] = "bwipp.identcodeBadLength"; /*4695*/
			$k[$j++] = "Deutsche Post Identcode must be 11 or 12 digits"; /*4695*/
			$0.raiseerror(); /*4695*/
		} /*4695*/
		$forall($1.barcode, function() { /*4701*/
			var _D = $k[--$j]; /*4698*/
			if ((_D < 48) || (_D > 57)) { /*4700*/
				$k[$j++] = "bwipp.identcodeBadCharacter"; /*4699*/
				$k[$j++] = "Deutsche Post Identcode must contain only digits"; /*4699*/
				$0.raiseerror(); /*4699*/
			} /*4699*/
		}); /*4699*/
		$1.checksum = 0; /*4704*/
		for (var _E = 0; _E <= 10; _E += 1) { /*4708*/
			$1.i = _E; /*4706*/
			$k[$j++] = "checksum"; /*4707*/
			$k[$j++] = $1.checksum; /*4707*/
			$k[$j++] = $get($1.barcode, $1.i) - 48; /*4707*/
			if (($1.i % 2) == 0) { /*4707*/
				var _K = $k[--$j]; /*4707*/
				$k[$j++] = _K * 4; /*4707*/
			} else { /*4707*/
				var _L = $k[--$j]; /*4707*/
				$k[$j++] = _L * 9; /*4707*/
			} /*4707*/
			var _M = $k[--$j]; /*4707*/
			var _N = $k[--$j]; /*4707*/
			$1[$k[--$j]] = _N + _M; /*4707*/
		} /*4707*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4709*/
		if ($1.barcode.length == 12) { /*4714*/
			if ($get($1.barcode, 11) != ($1.checksum + 48)) { /*4713*/
				$k[$j++] = "bwipp.identcodeBadCheckDigit"; /*4712*/
				$k[$j++] = "Incorrect Deutsche Post Identcode check digit provided"; /*4712*/
				$0.raiseerror(); /*4712*/
			} /*4712*/
		} /*4712*/
		var _U = $s(12); /*4715*/
		$puti(_U, 0, $1.barcode); /*4716*/
		$put(_U, 11, $1.checksum + 48); /*4717*/
		$1.barcode = _U; /*4718*/
		$1.text = $strcpy($s(16), "  .       .     "); /*4721*/
		$puti($1.text, 0, $geti($1.barcode, 0, 2)); /*4722*/
		$puti($1.text, 3, $geti($1.barcode, 2, 3)); /*4723*/
		$puti($1.text, 7, $geti($1.barcode, 5, 3)); /*4724*/
		$puti($1.text, 11, $geti($1.barcode, 8, 3)); /*4725*/
		$puti($1.text, 15, $geti($1.barcode, 11, 1)); /*4726*/
		$1.options.dontdraw = true; /*4729*/
		$1.options.includecheck = false; /*4730*/
		$k[$j++] = "args"; /*4731*/
		$k[$j++] = $1.barcode; /*4731*/
		$k[$j++] = $1.options; /*4731*/
		$0.interleaved2of5(); /*4731*/
		var _s = $k[--$j]; /*4731*/
		$1[$k[--$j]] = _s; /*4731*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4733*/
		$1.args.textxalign = "center"; /*4734*/
		$1.args.opt = $1.options; /*4735*/
		$k[$j++] = $1.args; /*4738*/
		if (!$1.dontdraw) { /*4738*/
			$0.renlinear(); /*4738*/
		} /*4738*/
	};
	$0.leitcode = function() {
		var $1 = {}; /*4766*/
		$1.options = $k[--$j]; /*4768*/
		$1.barcode = $k[--$j]; /*4769*/
		$1.dontdraw = false; /*4771*/
		$1.includetext = false; /*4772*/
		$1.textfont = "Courier"; /*4773*/
		$1.textsize = 10; /*4774*/
		$1.textxoffset = 0; /*4775*/
		$1.textyoffset = -8.5; /*4776*/
		$1.height = 1; /*4777*/
		$forall($1.options, function() { /*4788*/
			var _3 = $k[--$j]; /*4788*/
			$1[$k[--$j]] = _3; /*4788*/
		}); /*4788*/
		$1.textfont = "" + $1.textfont; /*4790*/
		$1.textsize = +$1.textsize; /*4791*/
		$1.textxoffset = +$1.textxoffset; /*4792*/
		$1.textyoffset = +$1.textyoffset; /*4793*/
		$1.height = +$1.height; /*4794*/
		if (($1.barcode.length != 13) && ($1.barcode.length != 14)) { /*4799*/
			$k[$j++] = "bwipp.leitcodeBadLength"; /*4798*/
			$k[$j++] = "Deutsche Post Leitcode must be 13 or 14 digits"; /*4798*/
			$0.raiseerror(); /*4798*/
		} /*4798*/
		$forall($1.barcode, function() { /*4804*/
			var _D = $k[--$j]; /*4801*/
			if ((_D < 48) || (_D > 57)) { /*4803*/
				$k[$j++] = "bwipp.leitcodeBadCharacter"; /*4802*/
				$k[$j++] = "Deutsche Post Leitcode must contain only digits"; /*4802*/
				$0.raiseerror(); /*4802*/
			} /*4802*/
		}); /*4802*/
		$1.checksum = 0; /*4807*/
		for (var _E = 0; _E <= 12; _E += 1) { /*4811*/
			$1.i = _E; /*4809*/
			$k[$j++] = "checksum"; /*4810*/
			$k[$j++] = $1.checksum; /*4810*/
			$k[$j++] = $get($1.barcode, $1.i) - 48; /*4810*/
			if (($1.i % 2) == 0) { /*4810*/
				var _K = $k[--$j]; /*4810*/
				$k[$j++] = _K * 4; /*4810*/
			} else { /*4810*/
				var _L = $k[--$j]; /*4810*/
				$k[$j++] = _L * 9; /*4810*/
			} /*4810*/
			var _M = $k[--$j]; /*4810*/
			var _N = $k[--$j]; /*4810*/
			$1[$k[--$j]] = _N + _M; /*4810*/
		} /*4810*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4812*/
		if ($1.barcode.length == 14) { /*4817*/
			if ($get($1.barcode, 13) != ($1.checksum + 48)) { /*4816*/
				$k[$j++] = "bwipp.leitcodeBadCheckDigit"; /*4815*/
				$k[$j++] = "Incorrect Deutsche Post Leitcode check digit provided"; /*4815*/
				$0.raiseerror(); /*4815*/
			} /*4815*/
		} /*4815*/
		var _U = $s(14); /*4818*/
		$puti(_U, 0, $1.barcode); /*4819*/
		$put(_U, 13, $1.checksum + 48); /*4820*/
		$1.barcode = _U; /*4821*/
		$1.text = $strcpy($s(18), "     .   .   .    "); /*4824*/
		$puti($1.text, 0, $geti($1.barcode, 0, 5)); /*4825*/
		$puti($1.text, 6, $geti($1.barcode, 5, 3)); /*4826*/
		$puti($1.text, 10, $geti($1.barcode, 8, 3)); /*4827*/
		$puti($1.text, 14, $geti($1.barcode, 11, 2)); /*4828*/
		$puti($1.text, 17, $geti($1.barcode, 13, 1)); /*4829*/
		$1.options.dontdraw = true; /*4832*/
		$1.options.includecheck = false; /*4833*/
		$k[$j++] = "args"; /*4834*/
		$k[$j++] = $1.barcode; /*4834*/
		$k[$j++] = $1.options; /*4834*/
		$0.interleaved2of5(); /*4834*/
		var _s = $k[--$j]; /*4834*/
		$1[$k[--$j]] = _s; /*4834*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*4836*/
		$1.args.textxalign = "center"; /*4837*/
		$1.args.opt = $1.options; /*4838*/
		$k[$j++] = $1.args; /*4841*/
		if (!$1.dontdraw) { /*4841*/
			$0.renlinear(); /*4841*/
		} /*4841*/
	};
	$0.databaromni = function() {
		var $1 = {}; /*4869*/
		$1.options = $k[--$j]; /*4871*/
		$1.barcode = $k[--$j]; /*4872*/
		$1.dontdraw = false; /*4874*/
		$1.height = 33 / 72; /*4875*/
		$1.linkage = false; /*4876*/
		$1.format = "omni"; /*4877*/
		$1.barxmult = 33; /*4878*/
		$forall($1.options, function() { /*4889*/
			var _3 = $k[--$j]; /*4889*/
			$1[$k[--$j]] = _3; /*4889*/
		}); /*4889*/
		if ($eq($1.format, "truncated")) { /*4891*/
			$1.height = 13 / 72; /*4891*/
		} /*4891*/
		$1.height = +$1.height; /*4892*/
		$1.barxmult = ~~$1.barxmult; /*4893*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*4898*/
			$k[$j++] = "bwipp.databaromniBadAI"; /*4897*/
			$k[$j++] = "GS1 DataBar Omnidirectional must begin with (01) application identifier"; /*4897*/
			$0.raiseerror(); /*4897*/
		} /*4897*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*4901*/
			$k[$j++] = "bwipp.databaromniBadLength"; /*4900*/
			$k[$j++] = "GS1 DataBar Omnidirectional must be 13 or 14 digits"; /*4900*/
			$0.raiseerror(); /*4900*/
		} /*4900*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*4906*/
			var _F = $k[--$j]; /*4903*/
			if ((_F < 48) || (_F > 57)) { /*4905*/
				$k[$j++] = "bwipp.databaromniBadCharacter"; /*4904*/
				$k[$j++] = "GS1 DataBar Omnidirectional must contain only digits"; /*4904*/
				$0.raiseerror(); /*4904*/
			} /*4904*/
		}); /*4904*/
		$1.checksum = 0; /*4909*/
		for (var _G = 0; _G <= 12; _G += 1) { /*4913*/
			$1.i = _G; /*4911*/
			$k[$j++] = "checksum"; /*4912*/
			$k[$j++] = $1.checksum; /*4912*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*4912*/
			if (($1.i % 2) == 0) { /*4912*/
				var _M = $k[--$j]; /*4912*/
				$k[$j++] = _M * 3; /*4912*/
			} /*4912*/
			var _N = $k[--$j]; /*4912*/
			var _O = $k[--$j]; /*4912*/
			$1[$k[--$j]] = _O + _N; /*4912*/
		} /*4912*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*4914*/
		if ($1.barcode.length == 18) { /*4919*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*4918*/
				$k[$j++] = "bwipp.databaromniBadCheckDigit"; /*4917*/
				$k[$j++] = "Incorrect GS1 DataBar Omnidirectional check digit provided"; /*4917*/
				$0.raiseerror(); /*4917*/
			} /*4917*/
		} /*4917*/
		var _V = $s(18); /*4920*/
		$puti(_V, 0, $1.barcode); /*4921*/
		$put(_V, 17, $1.checksum + 48); /*4922*/
		$1.barcode = _V; /*4923*/
		$1.txt = $a($1.barcode.length); /*4926*/
		for (var _c = 0, _b = $1.barcode.length - 1; _c <= _b; _c += 1) { /*4930*/
			$1.i = _c; /*4928*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*4929*/
		} /*4929*/
		$1.ncr = function() {
			var _j = $k[--$j]; /*4933*/
			var _k = $k[--$j]; /*4933*/
			var _l = _k - _j; /*4933*/
			if (_j < (_k - _j)) { /*4933*/
				var _ = _l; /*4933*/
				_l = _j; /*4933*/
				_j = _; /*4933*/
			} /*4933*/
			$k[$j++] = _l; /*4940*/
			$k[$j++] = 1; /*4940*/
			$k[$j++] = 1; /*4940*/
			for (var _n = _k, _m = _j + 1; _n >= _m; _n -= 1) { /*4940*/
				var _o = $k[--$j]; /*4936*/
				var _p = $k[--$j]; /*4937*/
				var _q = $k[--$j]; /*4937*/
				$k[$j++] = _q; /*4939*/
				$k[$j++] = _p; /*4939*/
				$k[$j++] = _o * _n; /*4939*/
				if ($le(_p, _q)) { /*4939*/
					var _r = $k[--$j]; /*4938*/
					var _s = $k[--$j]; /*4938*/
					$k[$j++] = _s + 1; /*4938*/
					$k[$j++] = ~~(_r / _s); /*4938*/
				} /*4938*/
			} /*4938*/
			for (;;) { /*4944*/
				var _t = $k[--$j]; /*4942*/
				var _u = $k[--$j]; /*4942*/
				var _v = $k[--$j]; /*4942*/
				$k[$j++] = _v; /*4942*/
				$k[$j++] = _u; /*4942*/
				$k[$j++] = _t; /*4942*/
				if ($gt(_u, _v)) { /*4942*/
					break; /*4942*/
				} /*4942*/
				var _w = $k[--$j]; /*4943*/
				var _x = $k[--$j]; /*4943*/
				$k[$j++] = _x + 1; /*4943*/
				$k[$j++] = ~~(_w / _x); /*4943*/
			} /*4943*/
			var _y = $k[--$j]; /*4945*/
			var _z = $k[--$j]; /*4945*/
			var _10 = $k[--$j]; /*4945*/
			$k[$j++] = _y; /*4945*/
		}; /*4946*/
		$1.getRSSwidths = function() {
			$1.oe = $k[--$j]; /*4949*/
			$1.el = $k[--$j]; /*4950*/
			$1.mw = $k[--$j]; /*4951*/
			$1.nm = $k[--$j]; /*4952*/
			$1.val = $k[--$j]; /*4953*/
			$1.out = $a($1.el); /*4954*/
			$1.mask = 0; /*4955*/
			for (var _1A = 0, _19 = $1.el - 2; _1A <= _19; _1A += 1) { /*4982*/
				$1.bar = _1A; /*4957*/
				$1.ew = 1; /*4958*/
				var _1C = $1.bar; /*4959*/
				$1.mask = $1.mask | ((_1C < 0 ? 1 >>> -_1C : 1 << _1C)); /*4959*/
				for (;;) { /*4978*/
					$k[$j++] = "sval"; /*4960*/
					$k[$j++] = ($1.nm - $1.ew) - 1; /*4960*/
					$k[$j++] = ($1.el - $1.bar) - 2; /*4960*/
					if ($1.ncr() == $b) break; /*4960*/
					var _1H = $k[--$j]; /*4960*/
					$1[$k[--$j]] = _1H; /*4960*/
					if (($1.oe && ($1.mask == 0)) && (((($1.nm - $1.ew) - ($1.el * 2)) + ($1.bar * 2)) >= -2)) { /*4963*/
						$k[$j++] = "sval"; /*4962*/
						$k[$j++] = $1.sval; /*4962*/
						$k[$j++] = (($1.nm - $1.ew) - $1.el) + $1.bar; /*4962*/
						$k[$j++] = ($1.el - $1.bar) - 2; /*4962*/
						if ($1.ncr() == $b) break; /*4962*/
						var _1W = $k[--$j]; /*4962*/
						var _1X = $k[--$j]; /*4962*/
						$1[$k[--$j]] = _1X - _1W; /*4962*/
					} /*4962*/
					if (($1.el - $1.bar) > 2) { /*4972*/
						$1.lval = 0; /*4965*/
						for (var _1h = ((($1.nm - $1.ew) - $1.el) + $1.bar) + 2, _1g = $1.mw + 1; _1h >= _1g; _1h -= 1) { /*4969*/
							$k[$j++] = (($1.nm - _1h) - $1.ew) - 1; /*4967*/
							$k[$j++] = ($1.el - $1.bar) - 3; /*4967*/
							if ($1.ncr() == $b) break; /*4967*/
							$1.lval = $k[--$j] + $1.lval; /*4968*/
						} /*4968*/
						$1.sval = $1.sval - ($1.lval * (($1.el - $1.bar) - 1)); /*4970*/
					} else { /*4972*/
						if (($1.nm - $1.ew) > $1.mw) { /*4972*/
							$1.sval = $1.sval - 1; /*4972*/
						} /*4972*/
					} /*4972*/
					$1.val = $1.val - $1.sval; /*4974*/
					if ($1.val < 0) { /*4975*/
						break; /*4975*/
					} /*4975*/
					$1.ew = $1.ew + 1; /*4976*/
					var _21 = $1.bar; /*4977*/
					$1.mask = $1.mask & (~((_21 < 0 ? 1 >>> -_21 : 1 << _21))); /*4977*/
				} /*4977*/
				$1.val = $1.val + $1.sval; /*4979*/
				$1.nm = $1.nm - $1.ew; /*4980*/
				$put($1.out, $1.bar, $1.ew); /*4981*/
			} /*4981*/
			$put($1.out, $1.el - 1, $1.nm); /*4983*/
			$k[$j++] = $1.out; /*4984*/
		}; /*4985*/
		$k[$j++] = Infinity; /*4990*/
		var _2E = $1.linkage ? 1 : 0; /*4988*/
		$k[$j++] = _2E; /*4989*/
		$forall($geti($1.barcode, 4, 13), function() { /*4989*/
			var _2H = $k[--$j]; /*4989*/
			$k[$j++] = _2H - 48; /*4989*/
		}); /*4989*/
		$1.binval = $a(); /*4990*/
		for (var _2J = 0; _2J <= 12; _2J += 1) { /*4996*/
			$1.i = _2J; /*4993*/
			var _2K = $1.binval; /*4994*/
			var _2L = $1.i; /*4994*/
			$put(_2K, _2L + 1, $get(_2K, _2L + 1) + (($get($1.binval, $1.i) % 4537077) * 10)); /*4994*/
			$put($1.binval, $1.i, ~~($get($1.binval, $1.i) / 4537077)); /*4995*/
		} /*4995*/
		$1.right = $get($1.binval, 13) % 4537077; /*4997*/
		var _2X = $1.binval; /*4998*/
		$put(_2X, 13, ~~($get(_2X, 13) / 4537077)); /*4998*/
		$1.left = 0; /*5000*/
		$1.i = true; /*5001*/
		for (var _2Z = 0; _2Z <= 13; _2Z += 1) { /*5011*/
			$1.j = _2Z; /*5003*/
			var _2c = $get($1.binval, $1.j); /*5004*/
			$k[$j++] = _2c; /*5010*/
			if ((_2c == 0) && $1.i) { /*5009*/
				$j--; /*5006*/
			} else { /*5009*/
				$1.i = false; /*5008*/
				$1.left = $1.left + ($k[--$j] * (~~Math.pow(10, 13 - $1.j))); /*5009*/
			} /*5009*/
		} /*5009*/
		$1.d1 = ~~($1.left / 1597); /*5013*/
		$1.d2 = $1.left % 1597; /*5014*/
		$1.d3 = ~~($1.right / 1597); /*5015*/
		$1.d4 = $1.right % 1597; /*5016*/
		$1.tab164 = $a([160, 0, 12, 4, 8, 1, 161, 1, 960, 161, 10, 6, 6, 3, 80, 10, 2014, 961, 8, 8, 4, 5, 31, 34, 2714, 2015, 6, 10, 3, 6, 10, 70, 2840, 2715, 4, 12, 1, 8, 1, 126]); /*5024*/
		$1.tab154 = $a([335, 0, 5, 10, 2, 7, 4, 84, 1035, 336, 7, 8, 4, 5, 20, 35, 1515, 1036, 9, 6, 6, 3, 48, 10, 1596, 1516, 11, 4, 8, 1, 81, 1]); /*5031*/
		$1.i = 0; /*5033*/
		for (;;) { /*5043*/
			if ($1.d1 <= $get($1.tab164, $1.i)) { /*5041*/
				$forall($geti($1.tab164, $1.i + 1, 7)); /*5035*/
				$1.d1te = $k[--$j]; /*5036*/
				$1.d1to = $k[--$j]; /*5036*/
				$1.d1mwe = $k[--$j]; /*5037*/
				$1.d1mwo = $k[--$j]; /*5037*/
				$1.d1ele = $k[--$j]; /*5038*/
				$1.d1elo = $k[--$j]; /*5038*/
				$1.d1gs = $k[--$j]; /*5039*/
				break; /*5040*/
			} /*5040*/
			$1.i = $1.i + 8; /*5042*/
		} /*5042*/
		$1.i = 0; /*5045*/
		for (;;) { /*5055*/
			if ($1.d2 <= $get($1.tab154, $1.i)) { /*5053*/
				$forall($geti($1.tab154, $1.i + 1, 7)); /*5047*/
				$1.d2te = $k[--$j]; /*5048*/
				$1.d2to = $k[--$j]; /*5048*/
				$1.d2mwe = $k[--$j]; /*5049*/
				$1.d2mwo = $k[--$j]; /*5049*/
				$1.d2ele = $k[--$j]; /*5050*/
				$1.d2elo = $k[--$j]; /*5050*/
				$1.d2gs = $k[--$j]; /*5051*/
				break; /*5052*/
			} /*5052*/
			$1.i = $1.i + 8; /*5054*/
		} /*5054*/
		$1.i = 0; /*5057*/
		for (;;) { /*5067*/
			if ($1.d3 <= $get($1.tab164, $1.i)) { /*5065*/
				$forall($geti($1.tab164, $1.i + 1, 7)); /*5059*/
				$1.d3te = $k[--$j]; /*5060*/
				$1.d3to = $k[--$j]; /*5060*/
				$1.d3mwe = $k[--$j]; /*5061*/
				$1.d3mwo = $k[--$j]; /*5061*/
				$1.d3ele = $k[--$j]; /*5062*/
				$1.d3elo = $k[--$j]; /*5062*/
				$1.d3gs = $k[--$j]; /*5063*/
				break; /*5064*/
			} /*5064*/
			$1.i = $1.i + 8; /*5066*/
		} /*5066*/
		$1.i = 0; /*5069*/
		for (;;) { /*5079*/
			if ($1.d4 <= $get($1.tab154, $1.i)) { /*5077*/
				$forall($geti($1.tab154, $1.i + 1, 7)); /*5071*/
				$1.d4te = $k[--$j]; /*5072*/
				$1.d4to = $k[--$j]; /*5072*/
				$1.d4mwe = $k[--$j]; /*5073*/
				$1.d4mwo = $k[--$j]; /*5073*/
				$1.d4ele = $k[--$j]; /*5074*/
				$1.d4elo = $k[--$j]; /*5074*/
				$1.d4gs = $k[--$j]; /*5075*/
				break; /*5076*/
			} /*5076*/
			$1.i = $1.i + 8; /*5078*/
		} /*5078*/
		$k[$j++] = "d1wo"; /*5081*/
		$k[$j++] = ~~(($1.d1 - $1.d1gs) / $1.d1te); /*5081*/
		$k[$j++] = $1.d1elo; /*5081*/
		$k[$j++] = $1.d1mwo; /*5081*/
		$k[$j++] = 4; /*5081*/
		$k[$j++] = false; /*5081*/
		if ($1.getRSSwidths() == $b) return $b; /*5081*/
		var _3q = $k[--$j]; /*5081*/
		$1[$k[--$j]] = _3q; /*5081*/
		$k[$j++] = "d1we"; /*5082*/
		$k[$j++] = ($1.d1 - $1.d1gs) % $1.d1te; /*5082*/
		$k[$j++] = $1.d1ele; /*5082*/
		$k[$j++] = $1.d1mwe; /*5082*/
		$k[$j++] = 4; /*5082*/
		$k[$j++] = true; /*5082*/
		if ($1.getRSSwidths() == $b) return $b; /*5082*/
		var _3x = $k[--$j]; /*5082*/
		$1[$k[--$j]] = _3x; /*5082*/
		$k[$j++] = "d2wo"; /*5083*/
		$k[$j++] = ($1.d2 - $1.d2gs) % $1.d2to; /*5083*/
		$k[$j++] = $1.d2elo; /*5083*/
		$k[$j++] = $1.d2mwo; /*5083*/
		$k[$j++] = 4; /*5083*/
		$k[$j++] = true; /*5083*/
		if ($1.getRSSwidths() == $b) return $b; /*5083*/
		var _44 = $k[--$j]; /*5083*/
		$1[$k[--$j]] = _44; /*5083*/
		$k[$j++] = "d2we"; /*5084*/
		$k[$j++] = ~~(($1.d2 - $1.d2gs) / $1.d2to); /*5084*/
		$k[$j++] = $1.d2ele; /*5084*/
		$k[$j++] = $1.d2mwe; /*5084*/
		$k[$j++] = 4; /*5084*/
		$k[$j++] = false; /*5084*/
		if ($1.getRSSwidths() == $b) return $b; /*5084*/
		var _4B = $k[--$j]; /*5084*/
		$1[$k[--$j]] = _4B; /*5084*/
		$k[$j++] = "d3wo"; /*5085*/
		$k[$j++] = ~~(($1.d3 - $1.d3gs) / $1.d3te); /*5085*/
		$k[$j++] = $1.d3elo; /*5085*/
		$k[$j++] = $1.d3mwo; /*5085*/
		$k[$j++] = 4; /*5085*/
		$k[$j++] = false; /*5085*/
		if ($1.getRSSwidths() == $b) return $b; /*5085*/
		var _4I = $k[--$j]; /*5085*/
		$1[$k[--$j]] = _4I; /*5085*/
		$k[$j++] = "d3we"; /*5086*/
		$k[$j++] = ($1.d3 - $1.d3gs) % $1.d3te; /*5086*/
		$k[$j++] = $1.d3ele; /*5086*/
		$k[$j++] = $1.d3mwe; /*5086*/
		$k[$j++] = 4; /*5086*/
		$k[$j++] = true; /*5086*/
		if ($1.getRSSwidths() == $b) return $b; /*5086*/
		var _4P = $k[--$j]; /*5086*/
		$1[$k[--$j]] = _4P; /*5086*/
		$k[$j++] = "d4wo"; /*5087*/
		$k[$j++] = ($1.d4 - $1.d4gs) % $1.d4to; /*5087*/
		$k[$j++] = $1.d4elo; /*5087*/
		$k[$j++] = $1.d4mwo; /*5087*/
		$k[$j++] = 4; /*5087*/
		$k[$j++] = true; /*5087*/
		if ($1.getRSSwidths() == $b) return $b; /*5087*/
		var _4W = $k[--$j]; /*5087*/
		$1[$k[--$j]] = _4W; /*5087*/
		$k[$j++] = "d4we"; /*5088*/
		$k[$j++] = ~~(($1.d4 - $1.d4gs) / $1.d4to); /*5088*/
		$k[$j++] = $1.d4ele; /*5088*/
		$k[$j++] = $1.d4mwe; /*5088*/
		$k[$j++] = 4; /*5088*/
		$k[$j++] = false; /*5088*/
		if ($1.getRSSwidths() == $b) return $b; /*5088*/
		var _4d = $k[--$j]; /*5088*/
		$1[$k[--$j]] = _4d; /*5088*/
		$1.d1w = $a(8); /*5090*/
		for (var _4g = 0; _4g <= 3; _4g += 1) { /*5095*/
			$1.i = _4g; /*5092*/
			$put($1.d1w, $1.i * 2, $get($1.d1wo, $1.i)); /*5093*/
			$put($1.d1w, ($1.i * 2) + 1, $get($1.d1we, $1.i)); /*5094*/
		} /*5094*/
		$1.d2w = $a(8); /*5097*/
		for (var _4s = 0; _4s <= 3; _4s += 1) { /*5102*/
			$1.i = _4s; /*5099*/
			$put($1.d2w, 7 - ($1.i * 2), $get($1.d2wo, $1.i)); /*5100*/
			$put($1.d2w, 6 - ($1.i * 2), $get($1.d2we, $1.i)); /*5101*/
		} /*5101*/
		$1.d3w = $a(8); /*5104*/
		for (var _54 = 0; _54 <= 3; _54 += 1) { /*5109*/
			$1.i = _54; /*5106*/
			$put($1.d3w, 7 - ($1.i * 2), $get($1.d3wo, $1.i)); /*5107*/
			$put($1.d3w, 6 - ($1.i * 2), $get($1.d3we, $1.i)); /*5108*/
		} /*5108*/
		$1.d4w = $a(8); /*5111*/
		for (var _5G = 0; _5G <= 3; _5G += 1) { /*5116*/
			$1.i = _5G; /*5113*/
			$put($1.d4w, $1.i * 2, $get($1.d4wo, $1.i)); /*5114*/
			$put($1.d4w, ($1.i * 2) + 1, $get($1.d4we, $1.i)); /*5115*/
		} /*5115*/
		$k[$j++] = Infinity; /*5123*/
		var _5R = $1.d1w; /*5119*/
		for (var _5S = 0, _5T = _5R.length; _5S < _5T; _5S++) { /*5119*/
			$k[$j++] = $get(_5R, _5S); /*5119*/
		} /*5119*/
		var _5V = $1.d2w; /*5120*/
		for (var _5W = 0, _5X = _5V.length; _5W < _5X; _5W++) { /*5120*/
			$k[$j++] = $get(_5V, _5W); /*5120*/
		} /*5120*/
		var _5Z = $1.d3w; /*5121*/
		for (var _5a = 0, _5b = _5Z.length; _5a < _5b; _5a++) { /*5121*/
			$k[$j++] = $get(_5Z, _5a); /*5121*/
		} /*5121*/
		var _5d = $1.d4w; /*5122*/
		for (var _5e = 0, _5f = _5d.length; _5e < _5f; _5e++) { /*5122*/
			$k[$j++] = $get(_5d, _5e); /*5122*/
		} /*5122*/
		$1.widths = $a(); /*5123*/
		$1.checkweights = $a([1, 3, 9, 27, 2, 6, 18, 54, 58, 72, 24, 8, 29, 36, 12, 4, 74, 51, 17, 32, 37, 65, 48, 16, 64, 34, 23, 69, 49, 68, 46, 59]); /*5130*/
		$1.checkwidths = $a([3, 8, 2, 1, 1, 3, 5, 5, 1, 1, 3, 3, 7, 1, 1, 3, 1, 9, 1, 1, 2, 7, 4, 1, 1, 2, 5, 6, 1, 1, 2, 3, 8, 1, 1, 1, 5, 7, 1, 1, 1, 3, 9, 1, 1]); /*5136*/
		$1.checksum = 0; /*5138*/
		for (var _5k = 0; _5k <= 31; _5k += 1) { /*5142*/
			$1.i = _5k; /*5140*/
			$1.checksum = $1.checksum + ($get($1.widths, $1.i) * $get($1.checkweights, $1.i)); /*5141*/
		} /*5141*/
		$1.checksum = $1.checksum % 79; /*5143*/
		if ($1.checksum >= 8) { /*5144*/
			$1.checksum = $1.checksum + 1; /*5144*/
		} /*5144*/
		if ($1.checksum >= 72) { /*5145*/
			$1.checksum = $1.checksum + 1; /*5145*/
		} /*5145*/
		$1.checklt = $geti($1.checkwidths, (~~($1.checksum / 9)) * 5, 5); /*5146*/
		$1.checkrtrev = $geti($1.checkwidths, ($1.checksum % 9) * 5, 5); /*5147*/
		$1.checkrt = $a(5); /*5148*/
		for (var _64 = 0; _64 <= 4; _64 += 1) { /*5152*/
			$1.i = _64; /*5150*/
			$put($1.checkrt, $1.i, $get($1.checkrtrev, 4 - $1.i)); /*5151*/
		} /*5151*/
		if ($eq($1.format, "omni") || $eq($1.format, "truncated")) { /*5271*/
			$k[$j++] = Infinity; /*5160*/
			var _6C = $1.d1w; /*5158*/
			$k[$j++] = 1; /*5158*/
			for (var _6D = 0, _6E = _6C.length; _6D < _6E; _6D++) { /*5158*/
				$k[$j++] = $get(_6C, _6D); /*5158*/
			} /*5158*/
			$forall($1.checklt); /*5158*/
			var _6H = $1.d2w; /*5158*/
			for (var _6I = 0, _6J = _6H.length; _6I < _6J; _6I++) { /*5158*/
				$k[$j++] = $get(_6H, _6I); /*5158*/
			} /*5158*/
			var _6L = $1.d4w; /*5159*/
			for (var _6M = 0, _6N = _6L.length; _6M < _6N; _6M++) { /*5159*/
				$k[$j++] = $get(_6L, _6M); /*5159*/
			} /*5159*/
			var _6P = $1.checkrt; /*5159*/
			for (var _6Q = 0, _6R = _6P.length; _6Q < _6R; _6Q++) { /*5159*/
				$k[$j++] = $get(_6P, _6Q); /*5159*/
			} /*5159*/
			var _6T = $1.d3w; /*5159*/
			for (var _6U = 0, _6V = _6T.length; _6U < _6V; _6U++) { /*5159*/
				$k[$j++] = $get(_6T, _6U); /*5159*/
			} /*5159*/
			$k[$j++] = 1; /*5159*/
			$k[$j++] = 1; /*5159*/
			$1.sbs = $a(); /*5160*/
			$k[$j++] = Infinity; /*5169*/
			$k[$j++] = "ren"; /*5166*/
			$k[$j++] = $0.renlinear; /*5166*/
			$k[$j++] = "sbs"; /*5166*/
			$k[$j++] = $1.sbs; /*5166*/
			$k[$j++] = "bhs"; /*5166*/
			$k[$j++] = Infinity; /*5166*/
			for (var _6a = 0, _6b = ~~(($1.sbs.length + 1) / 2); _6a < _6b; _6a++) { /*5165*/
				$k[$j++] = $1.height; /*5165*/
			} /*5165*/
			var _6d = $a(); /*5166*/
			$k[$j++] = _6d; /*5167*/
			$k[$j++] = "bbs"; /*5167*/
			$k[$j++] = Infinity; /*5167*/
			for (var _6f = 0, _6g = ~~(($1.sbs.length + 1) / 2); _6f < _6g; _6f++) { /*5166*/
				$k[$j++] = 0; /*5166*/
			} /*5166*/
			var _6h = $a(); /*5167*/
			$k[$j++] = _6h; /*5169*/
			$k[$j++] = "txt"; /*5169*/
			$k[$j++] = $1.txt; /*5169*/
			$k[$j++] = "textxalign"; /*5169*/
			$k[$j++] = "center"; /*5169*/
			$k[$j++] = "opt"; /*5169*/
			$k[$j++] = $1.options; /*5169*/
			var _6k = $d(); /*5169*/
			$k[$j++] = _6k; /*5172*/
			if (!$1.dontdraw) { /*5172*/
				$0.renlinear(); /*5172*/
			} /*5172*/
		} else { /*5271*/
			$k[$j++] = Infinity; /*5176*/
			var _6m = $1.d1w; /*5176*/
			$k[$j++] = 1; /*5176*/
			$k[$j++] = 1; /*5176*/
			for (var _6n = 0, _6o = _6m.length; _6n < _6o; _6n++) { /*5176*/
				$k[$j++] = $get(_6m, _6n); /*5176*/
			} /*5176*/
			$forall($1.checklt); /*5176*/
			var _6r = $1.d2w; /*5176*/
			for (var _6s = 0, _6t = _6r.length; _6s < _6t; _6s++) { /*5176*/
				$k[$j++] = $get(_6r, _6s); /*5176*/
			} /*5176*/
			$k[$j++] = 1; /*5176*/
			$k[$j++] = 1; /*5176*/
			$k[$j++] = 0; /*5176*/
			$1.top = $a(); /*5176*/
			$k[$j++] = Infinity; /*5177*/
			var _6w = $1.d4w; /*5177*/
			$k[$j++] = 1; /*5177*/
			$k[$j++] = 1; /*5177*/
			for (var _6x = 0, _6y = _6w.length; _6x < _6y; _6x++) { /*5177*/
				$k[$j++] = $get(_6w, _6x); /*5177*/
			} /*5177*/
			var _70 = $1.checkrt; /*5177*/
			for (var _71 = 0, _72 = _70.length; _71 < _72; _71++) { /*5177*/
				$k[$j++] = $get(_70, _71); /*5177*/
			} /*5177*/
			var _74 = $1.d3w; /*5177*/
			for (var _75 = 0, _76 = _74.length; _75 < _76; _75++) { /*5177*/
				$k[$j++] = $get(_74, _75); /*5177*/
			} /*5177*/
			$k[$j++] = 1; /*5177*/
			$k[$j++] = 1; /*5177*/
			$k[$j++] = 0; /*5177*/
			$1.bot = $a(); /*5177*/
			for (var _79 = 0; _79 <= 24; _79 += 2) { /*5182*/
				$1.i = _79; /*5179*/
				for (var _7D = 0, _7E = $get($1.top, $1.i); _7D < _7E; _7D++) { /*5180*/
					$k[$j++] = 0; /*5180*/
				} /*5180*/
				for (var _7I = 0, _7J = $get($1.top, $1.i + 1); _7I < _7J; _7I++) { /*5181*/
					$k[$j++] = 1; /*5181*/
				} /*5181*/
			} /*5181*/
			$astore($a(50)); /*5183*/
			$1.top = $k[--$j]; /*5183*/
			for (var _7M = 0; _7M <= 24; _7M += 2) { /*5188*/
				$1.i = _7M; /*5185*/
				for (var _7Q = 0, _7R = $get($1.bot, $1.i); _7Q < _7R; _7Q++) { /*5186*/
					$k[$j++] = 1; /*5186*/
				} /*5186*/
				for (var _7V = 0, _7W = $get($1.bot, $1.i + 1); _7V < _7W; _7V++) { /*5187*/
					$k[$j++] = 0; /*5187*/
				} /*5187*/
			} /*5187*/
			$astore($a(50)); /*5189*/
			$1.bot = $k[--$j]; /*5189*/
			if ($eq($1.format, "stacked")) { /*5208*/
				$k[$j++] = Infinity; /*5193*/
				for (var _7a = 0, _7b = 50; _7a < _7b; _7a++) { /*5193*/
					$k[$j++] = 0; /*5193*/
				} /*5193*/
				$1.sep = $a(); /*5193*/
				for (var _7d = 4; _7d <= 45; _7d += 1) { /*5201*/
					$1.i = _7d; /*5195*/
					if ($eq($get($1.top, $1.i), $get($1.bot, $1.i))) { /*5199*/
						$put($1.sep, $1.i, 1 - $get($1.top, $1.i)); /*5197*/
					} else { /*5199*/
						$put($1.sep, $1.i, 1 - $get($1.sep, $1.i - 1)); /*5199*/
					} /*5199*/
				} /*5199*/
				$k[$j++] = Infinity; /*5206*/
				for (var _7u = 0, _7v = 5; _7u < _7v; _7u++) { /*5203*/
					$aload($1.top); /*5203*/
				} /*5203*/
				$aload($1.sep); /*5204*/
				for (var _7y = 0, _7z = 7; _7y < _7z; _7y++) { /*5205*/
					$aload($1.bot); /*5205*/
				} /*5205*/
				$1.pixs = $a(); /*5206*/
				$1.pixy = ~~($1.pixs.length / 50); /*5207*/
			} /*5207*/
			if ($eq($1.format, "stackedomni")) { /*5258*/
				$k[$j++] = Infinity; /*5212*/
				$forall($1.top, function() { /*5212*/
					var _85 = $k[--$j]; /*5212*/
					$k[$j++] = 1 - _85; /*5212*/
				}); /*5212*/
				$1.sep1 = $a(); /*5212*/
				$puti($1.sep1, 0, $a([0, 0, 0, 0])); /*5213*/
				$puti($1.sep1, 46, $a([0, 0, 0, 0])); /*5214*/
				for (var _8B = 18; _8B <= 30; _8B += 1) { /*5227*/
					$1.i = _8B; /*5216*/
					if ($get($1.top, $1.i) == 0) { /*5224*/
						if ($get($1.top, $1.i - 1) == 1) { /*5221*/
							$k[$j++] = 1; /*5219*/
						} else { /*5221*/
							var _8L = ($get($1.sep1, $1.i - 1) == 0) ? 1 : 0; /*5221*/
							$k[$j++] = _8L; /*5221*/
						} /*5221*/
					} else { /*5224*/
						$k[$j++] = 0; /*5224*/
					} /*5224*/
					$put($1.sep1, $1.i, $k[--$j]); /*5226*/
				} /*5226*/
				$k[$j++] = Infinity; /*5228*/
				$k[$j++] = 0; /*5228*/
				$k[$j++] = 0; /*5228*/
				$k[$j++] = 0; /*5228*/
				$k[$j++] = 0; /*5228*/
				for (var _8P = 0, _8Q = 21; _8P < _8Q; _8P++) { /*5228*/
					$k[$j++] = 0; /*5228*/
					$k[$j++] = 1; /*5228*/
				} /*5228*/
				$k[$j++] = 0; /*5228*/
				$k[$j++] = 0; /*5228*/
				$k[$j++] = 0; /*5228*/
				$k[$j++] = 0; /*5228*/
				$1.sep2 = $a(); /*5228*/
				$k[$j++] = Infinity; /*5229*/
				$forall($1.bot, function() { /*5229*/
					var _8T = $k[--$j]; /*5229*/
					$k[$j++] = 1 - _8T; /*5229*/
				}); /*5229*/
				$1.sep3 = $a(); /*5229*/
				$puti($1.sep3, 0, $a([0, 0, 0, 0])); /*5230*/
				$puti($1.sep3, 46, $a([0, 0, 0, 0])); /*5231*/
				for (var _8Z = 19; _8Z <= 31; _8Z += 1) { /*5244*/
					$1.i = _8Z; /*5233*/
					if ($get($1.bot, $1.i) == 0) { /*5241*/
						if ($get($1.bot, $1.i - 1) == 1) { /*5238*/
							$k[$j++] = 1; /*5236*/
						} else { /*5238*/
							var _8j = ($get($1.sep3, $1.i - 1) == 0) ? 1 : 0; /*5238*/
							$k[$j++] = _8j; /*5238*/
						} /*5238*/
					} else { /*5241*/
						$k[$j++] = 0; /*5241*/
					} /*5241*/
					$put($1.sep3, $1.i, $k[--$j]); /*5243*/
				} /*5243*/
				$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*5245*/
				$k[$j++] = true; /*5246*/
				for (var _8o = 0; _8o <= 12; _8o += 1) { /*5246*/
					var _8t = $k[--$j]; /*5246*/
					$k[$j++] = _8t && $eq($get($1.bot, _8o + 19), $get($1.f3, _8o)); /*5246*/
				} /*5246*/
				if ($k[--$j]) { /*5249*/
					$puti($1.sep3, 19, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*5248*/
				} /*5248*/
				$k[$j++] = Infinity; /*5256*/
				for (var _8y = 0, _8z = $1.barxmult; _8y < _8z; _8y++) { /*5251*/
					$aload($1.top); /*5251*/
				} /*5251*/
				$aload($1.sep1); /*5252*/
				$aload($1.sep2); /*5253*/
				$aload($1.sep3); /*5254*/
				for (var _95 = 0, _96 = $1.barxmult; _95 < _96; _95++) { /*5255*/
					$aload($1.bot); /*5255*/
				} /*5255*/
				$1.pixs = $a(); /*5256*/
				$1.pixy = ~~($1.pixs.length / 50); /*5257*/
			} /*5257*/
			var _9E = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: 50,
				pixy: $1.pixy,
				height: $1.pixy / 72,
				width: 50 / 72,
				opt: $1.options
			}; /*5268*/
			$k[$j++] = _9E; /*5271*/
			if (!$1.dontdraw) { /*5271*/
				$0.renmatrix(); /*5271*/
			} /*5271*/
		} /*5271*/
	};
	$0.databarstacked = function() {
		var $1 = {}; /*5301*/
		$1.options = $k[--$j]; /*5303*/
		$1.barcode = $k[--$j]; /*5304*/
		$1.dontdraw = false; /*5306*/
		$forall($1.options, function() { /*5317*/
			var _3 = $k[--$j]; /*5317*/
			$1[$k[--$j]] = _3; /*5317*/
		}); /*5317*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5322*/
			$k[$j++] = "bwipp.databarstackedBadAI"; /*5321*/
			$k[$j++] = "GS1 DataBar Stacked must begin with (01) application identifier"; /*5321*/
			$0.raiseerror(); /*5321*/
		} /*5321*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5325*/
			$k[$j++] = "bwipp.databarstackedBadLength"; /*5324*/
			$k[$j++] = "GS1 DataBar Stacked must be 13 or 14 digits"; /*5324*/
			$0.raiseerror(); /*5324*/
		} /*5324*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*5330*/
			var _C = $k[--$j]; /*5327*/
			if ((_C < 48) || (_C > 57)) { /*5329*/
				$k[$j++] = "bwipp.databarstackedBadCharacter"; /*5328*/
				$k[$j++] = "GS1 DataBar Stacked must contain only digits"; /*5328*/
				$0.raiseerror(); /*5328*/
			} /*5328*/
		}); /*5328*/
		$1.checksum = 0; /*5333*/
		for (var _D = 0; _D <= 12; _D += 1) { /*5337*/
			$1.i = _D; /*5335*/
			$k[$j++] = "checksum"; /*5336*/
			$k[$j++] = $1.checksum; /*5336*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5336*/
			if (($1.i % 2) == 0) { /*5336*/
				var _J = $k[--$j]; /*5336*/
				$k[$j++] = _J * 3; /*5336*/
			} /*5336*/
			var _K = $k[--$j]; /*5336*/
			var _L = $k[--$j]; /*5336*/
			$1[$k[--$j]] = _L + _K; /*5336*/
		} /*5336*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5338*/
		if ($1.barcode.length == 18) { /*5343*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5342*/
				$k[$j++] = "bwipp.databarstackedBadCheckDigit"; /*5341*/
				$k[$j++] = "Incorrect GS1 DataBar Stacked check digit provided"; /*5341*/
				$0.raiseerror(); /*5341*/
			} /*5341*/
		} /*5341*/
		var _S = $s(18); /*5344*/
		$puti(_S, 0, $1.barcode); /*5345*/
		$put(_S, 17, $1.checksum + 48); /*5346*/
		$1.barcode = _S; /*5347*/
		$1.options.dontdraw = true; /*5350*/
		$1.options.format = "stacked"; /*5351*/
		$k[$j++] = "args"; /*5353*/
		$k[$j++] = $1.barcode; /*5353*/
		$k[$j++] = $1.options; /*5353*/
		$0.databaromni(); /*5353*/
		var _Z = $k[--$j]; /*5353*/
		$1[$k[--$j]] = _Z; /*5353*/
		$1.args.opt = $1.options; /*5355*/
		$k[$j++] = $1.args; /*5358*/
		if (!$1.dontdraw) { /*5358*/
			$0.renmatrix(); /*5358*/
		} /*5358*/
	};
	$0.databarstackedomni = function() {
		var $1 = {}; /*5386*/
		$1.options = $k[--$j]; /*5388*/
		$1.barcode = $k[--$j]; /*5389*/
		$1.dontdraw = false; /*5391*/
		$forall($1.options, function() { /*5402*/
			var _3 = $k[--$j]; /*5402*/
			$1[$k[--$j]] = _3; /*5402*/
		}); /*5402*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5407*/
			$k[$j++] = "bwipp.databarstackedomniBadAI"; /*5406*/
			$k[$j++] = "GS1 DataBar Stacked Omnidirectional must begin with (01) application identifier"; /*5406*/
			$0.raiseerror(); /*5406*/
		} /*5406*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5410*/
			$k[$j++] = "bwipp.databarstackedomniBadLength"; /*5409*/
			$k[$j++] = "GS1 DataBar Stacked Omnidirectional must be 13 or 14 digits"; /*5409*/
			$0.raiseerror(); /*5409*/
		} /*5409*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*5415*/
			var _C = $k[--$j]; /*5412*/
			if ((_C < 48) || (_C > 57)) { /*5414*/
				$k[$j++] = "bwipp.databarstackedomniBadCharacter"; /*5413*/
				$k[$j++] = "GS1 DataBar Stacked Omnidirectional must contain only digits"; /*5413*/
				$0.raiseerror(); /*5413*/
			} /*5413*/
		}); /*5413*/
		$1.checksum = 0; /*5418*/
		for (var _D = 0; _D <= 12; _D += 1) { /*5422*/
			$1.i = _D; /*5420*/
			$k[$j++] = "checksum"; /*5421*/
			$k[$j++] = $1.checksum; /*5421*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5421*/
			if (($1.i % 2) == 0) { /*5421*/
				var _J = $k[--$j]; /*5421*/
				$k[$j++] = _J * 3; /*5421*/
			} /*5421*/
			var _K = $k[--$j]; /*5421*/
			var _L = $k[--$j]; /*5421*/
			$1[$k[--$j]] = _L + _K; /*5421*/
		} /*5421*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5423*/
		if ($1.barcode.length == 18) { /*5428*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5427*/
				$k[$j++] = "bwipp.databarstackedomniBadCheckDigit"; /*5426*/
				$k[$j++] = "Incorrect GS1 DataBar Stacked Omnidirectional check digit provided"; /*5426*/
				$0.raiseerror(); /*5426*/
			} /*5426*/
		} /*5426*/
		var _S = $s(18); /*5429*/
		$puti(_S, 0, $1.barcode); /*5430*/
		$put(_S, 17, $1.checksum + 48); /*5431*/
		$1.barcode = _S; /*5432*/
		$1.options.dontdraw = true; /*5435*/
		$1.options.format = "stackedomni"; /*5436*/
		$k[$j++] = "args"; /*5438*/
		$k[$j++] = $1.barcode; /*5438*/
		$k[$j++] = $1.options; /*5438*/
		$0.databaromni(); /*5438*/
		var _Z = $k[--$j]; /*5438*/
		$1[$k[--$j]] = _Z; /*5438*/
		$1.args.opt = $1.options; /*5440*/
		$k[$j++] = $1.args; /*5443*/
		if (!$1.dontdraw) { /*5443*/
			$0.renmatrix(); /*5443*/
		} /*5443*/
	};
	$0.databartruncated = function() {
		var $1 = {}; /*5471*/
		$1.options = $k[--$j]; /*5473*/
		$1.barcode = $k[--$j]; /*5474*/
		$1.dontdraw = false; /*5476*/
		$forall($1.options, function() { /*5487*/
			var _3 = $k[--$j]; /*5487*/
			$1[$k[--$j]] = _3; /*5487*/
		}); /*5487*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5492*/
			$k[$j++] = "bwipp.databartruncatedBadAI"; /*5491*/
			$k[$j++] = "GS1 DataBar Truncated must begin with (01) application identifier"; /*5491*/
			$0.raiseerror(); /*5491*/
		} /*5491*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5495*/
			$k[$j++] = "bwipp.databartruncatedBadLength"; /*5494*/
			$k[$j++] = "GS1 DataBar Truncated must be 13 or 14 digits"; /*5494*/
			$0.raiseerror(); /*5494*/
		} /*5494*/
		$forall($geti($1.barcode, 4, $1.barcode.length - 4), function() { /*5500*/
			var _C = $k[--$j]; /*5497*/
			if ((_C < 48) || (_C > 57)) { /*5499*/
				$k[$j++] = "bwipp.databartruncatedBadCharacter"; /*5498*/
				$k[$j++] = "GS1 DataBar Truncated must contain only digits"; /*5498*/
				$0.raiseerror(); /*5498*/
			} /*5498*/
		}); /*5498*/
		$1.checksum = 0; /*5503*/
		for (var _D = 0; _D <= 12; _D += 1) { /*5507*/
			$1.i = _D; /*5505*/
			$k[$j++] = "checksum"; /*5506*/
			$k[$j++] = $1.checksum; /*5506*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5506*/
			if (($1.i % 2) == 0) { /*5506*/
				var _J = $k[--$j]; /*5506*/
				$k[$j++] = _J * 3; /*5506*/
			} /*5506*/
			var _K = $k[--$j]; /*5506*/
			var _L = $k[--$j]; /*5506*/
			$1[$k[--$j]] = _L + _K; /*5506*/
		} /*5506*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5508*/
		if ($1.barcode.length == 18) { /*5513*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5512*/
				$k[$j++] = "bwipp.databartruncatedBadCheckDigit"; /*5511*/
				$k[$j++] = "Incorrect GS1 DataBar Truncated check digit provided"; /*5511*/
				$0.raiseerror(); /*5511*/
			} /*5511*/
		} /*5511*/
		var _S = $s(18); /*5514*/
		$puti(_S, 0, $1.barcode); /*5515*/
		$put(_S, 17, $1.checksum + 48); /*5516*/
		$1.barcode = _S; /*5517*/
		$1.options.dontdraw = true; /*5520*/
		$1.options.format = "truncated"; /*5521*/
		$k[$j++] = "args"; /*5523*/
		$k[$j++] = $1.barcode; /*5523*/
		$k[$j++] = $1.options; /*5523*/
		$0.databaromni(); /*5523*/
		var _Z = $k[--$j]; /*5523*/
		$1[$k[--$j]] = _Z; /*5523*/
		$1.args.opt = $1.options; /*5525*/
		$k[$j++] = $1.args; /*5528*/
		if (!$1.dontdraw) { /*5528*/
			$0.renlinear(); /*5528*/
		} /*5528*/
	};
	$0.databarlimited = function() {
		var $1 = {}; /*5555*/
		$1.options = $k[--$j]; /*5557*/
		$1.barcode = $k[--$j]; /*5558*/
		$1.dontdraw = false; /*5560*/
		$1.height = 10 / 72; /*5561*/
		$1.linkage = false; /*5562*/
		$forall($1.options, function() { /*5573*/
			var _3 = $k[--$j]; /*5573*/
			$1[$k[--$j]] = _3; /*5573*/
		}); /*5573*/
		$1.height = +$1.height; /*5575*/
		if ($ne($geti($1.barcode, 0, 4), "(01)")) { /*5580*/
			$k[$j++] = "bwipp.databarlimitedBadAI"; /*5579*/
			$k[$j++] = "GS1 DataBar Limited must begin with (01) application identifier"; /*5579*/
			$0.raiseerror(); /*5579*/
		} /*5579*/
		if (($1.barcode.length != 17) && ($1.barcode.length != 18)) { /*5583*/
			$k[$j++] = "bwipp.databarlimitedBadLength"; /*5582*/
			$k[$j++] = "GS1 DataBar Limited must be 13 or 14 digits"; /*5582*/
			$0.raiseerror(); /*5582*/
		} /*5582*/
		var _B = $get($1.barcode, 4); /*5584*/
		if ((_B < 48) || (_B > 49)) { /*5586*/
			$k[$j++] = "bwipp.databarlimitedBadStartDigit"; /*5585*/
			$k[$j++] = "GS1 DataBar Limited must begin with 0 or 1"; /*5585*/
			$0.raiseerror(); /*5585*/
		} /*5585*/
		$forall($geti($1.barcode, 5, $1.barcode.length - 5), function() { /*5591*/
			var _F = $k[--$j]; /*5588*/
			if ((_F < 48) || (_F > 57)) { /*5590*/
				$k[$j++] = "bwipp.databarlimitedBadCharacter"; /*5589*/
				$k[$j++] = "GS1 DataBar Limited must contain only digits"; /*5589*/
				$0.raiseerror(); /*5589*/
			} /*5589*/
		}); /*5589*/
		$1.checksum = 0; /*5594*/
		for (var _G = 0; _G <= 12; _G += 1) { /*5598*/
			$1.i = _G; /*5596*/
			$k[$j++] = "checksum"; /*5597*/
			$k[$j++] = $1.checksum; /*5597*/
			$k[$j++] = $get($1.barcode, $1.i + 4) - 48; /*5597*/
			if (($1.i % 2) == 0) { /*5597*/
				var _M = $k[--$j]; /*5597*/
				$k[$j++] = _M * 3; /*5597*/
			} /*5597*/
			var _N = $k[--$j]; /*5597*/
			var _O = $k[--$j]; /*5597*/
			$1[$k[--$j]] = _O + _N; /*5597*/
		} /*5597*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*5599*/
		if ($1.barcode.length == 18) { /*5604*/
			if ($get($1.barcode, 17) != ($1.checksum + 48)) { /*5603*/
				$k[$j++] = "bwipp.databarlimitedBadCheckDigit"; /*5602*/
				$k[$j++] = "Incorrect GS1 DataBar Limited check digit provided"; /*5602*/
				$0.raiseerror(); /*5602*/
			} /*5602*/
		} /*5602*/
		var _V = $s(18); /*5605*/
		$puti(_V, 0, $1.barcode); /*5606*/
		$put(_V, 17, $1.checksum + 48); /*5607*/
		$1.barcode = _V; /*5608*/
		$k[$j++] = Infinity; /*5613*/
		$forall($geti($1.barcode, 4, 13), function() { /*5612*/
			var _a = $k[--$j]; /*5612*/
			$k[$j++] = _a - 48; /*5612*/
		}); /*5612*/
		$1.binval = $a(); /*5613*/
		if ($1.linkage) { /*5620*/
			$1.linkval = $a([2, 0, 1, 5, 1, 3, 3, 5, 3, 1, 0, 9, 6]); /*5615*/
			for (var _g = 0, _f = $1.binval.length - 1; _g <= _f; _g += 1) { /*5619*/
				$1.i = _g; /*5617*/
				$put($1.binval, $1.i, $get($1.binval, $1.i) + $get($1.linkval, $1.i)); /*5618*/
			} /*5618*/
		} /*5618*/
		$1.txt = $a($1.barcode.length); /*5623*/
		for (var _t = 0, _s = $1.barcode.length - 1; _t <= _s; _t += 1) { /*5627*/
			$1.i = _t; /*5625*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*5626*/
		} /*5626*/
		$1.ncr = function() {
			var _10 = $k[--$j]; /*5630*/
			var _11 = $k[--$j]; /*5630*/
			var _12 = _11 - _10; /*5630*/
			if (_10 < (_11 - _10)) { /*5630*/
				var _ = _12; /*5630*/
				_12 = _10; /*5630*/
				_10 = _; /*5630*/
			} /*5630*/
			$k[$j++] = _12; /*5637*/
			$k[$j++] = 1; /*5637*/
			$k[$j++] = 1; /*5637*/
			for (var _14 = _11, _13 = _10 + 1; _14 >= _13; _14 -= 1) { /*5637*/
				var _15 = $k[--$j]; /*5633*/
				var _16 = $k[--$j]; /*5634*/
				var _17 = $k[--$j]; /*5634*/
				$k[$j++] = _17; /*5636*/
				$k[$j++] = _16; /*5636*/
				$k[$j++] = _15 * _14; /*5636*/
				if ($le(_16, _17)) { /*5636*/
					var _18 = $k[--$j]; /*5635*/
					var _19 = $k[--$j]; /*5635*/
					$k[$j++] = _19 + 1; /*5635*/
					$k[$j++] = ~~(_18 / _19); /*5635*/
				} /*5635*/
			} /*5635*/
			for (;;) { /*5641*/
				var _1A = $k[--$j]; /*5639*/
				var _1B = $k[--$j]; /*5639*/
				var _1C = $k[--$j]; /*5639*/
				$k[$j++] = _1C; /*5639*/
				$k[$j++] = _1B; /*5639*/
				$k[$j++] = _1A; /*5639*/
				if ($gt(_1B, _1C)) { /*5639*/
					break; /*5639*/
				} /*5639*/
				var _1D = $k[--$j]; /*5640*/
				var _1E = $k[--$j]; /*5640*/
				$k[$j++] = _1E + 1; /*5640*/
				$k[$j++] = ~~(_1D / _1E); /*5640*/
			} /*5640*/
			var _1F = $k[--$j]; /*5642*/
			var _1G = $k[--$j]; /*5642*/
			var _1H = $k[--$j]; /*5642*/
			$k[$j++] = _1F; /*5642*/
		}; /*5643*/
		$1.getRSSwidths = function() {
			$1.oe = $k[--$j]; /*5646*/
			$1.el = $k[--$j]; /*5647*/
			$1.mw = $k[--$j]; /*5648*/
			$1.nm = $k[--$j]; /*5649*/
			$1.val = $k[--$j]; /*5650*/
			$1.out = $a($1.el); /*5651*/
			$1.mask = 0; /*5652*/
			for (var _1R = 0, _1Q = $1.el - 2; _1R <= _1Q; _1R += 1) { /*5679*/
				$1.bar = _1R; /*5654*/
				$1.ew = 1; /*5655*/
				var _1T = $1.bar; /*5656*/
				$1.mask = $1.mask | ((_1T < 0 ? 1 >>> -_1T : 1 << _1T)); /*5656*/
				for (;;) { /*5675*/
					$k[$j++] = "sval"; /*5657*/
					$k[$j++] = ($1.nm - $1.ew) - 1; /*5657*/
					$k[$j++] = ($1.el - $1.bar) - 2; /*5657*/
					if ($1.ncr() == $b) break; /*5657*/
					var _1Y = $k[--$j]; /*5657*/
					$1[$k[--$j]] = _1Y; /*5657*/
					if (($1.oe && ($1.mask == 0)) && (((($1.nm - $1.ew) - ($1.el * 2)) + ($1.bar * 2)) >= -2)) { /*5660*/
						$k[$j++] = "sval"; /*5659*/
						$k[$j++] = $1.sval; /*5659*/
						$k[$j++] = (($1.nm - $1.ew) - $1.el) + $1.bar; /*5659*/
						$k[$j++] = ($1.el - $1.bar) - 2; /*5659*/
						if ($1.ncr() == $b) break; /*5659*/
						var _1n = $k[--$j]; /*5659*/
						var _1o = $k[--$j]; /*5659*/
						$1[$k[--$j]] = _1o - _1n; /*5659*/
					} /*5659*/
					if (($1.el - $1.bar) > 2) { /*5669*/
						$1.lval = 0; /*5662*/
						for (var _1y = ((($1.nm - $1.ew) - $1.el) + $1.bar) + 2, _1x = $1.mw + 1; _1y >= _1x; _1y -= 1) { /*5666*/
							$k[$j++] = (($1.nm - _1y) - $1.ew) - 1; /*5664*/
							$k[$j++] = ($1.el - $1.bar) - 3; /*5664*/
							if ($1.ncr() == $b) break; /*5664*/
							$1.lval = $k[--$j] + $1.lval; /*5665*/
						} /*5665*/
						$1.sval = $1.sval - ($1.lval * (($1.el - $1.bar) - 1)); /*5667*/
					} else { /*5669*/
						if (($1.nm - $1.ew) > $1.mw) { /*5669*/
							$1.sval = $1.sval - 1; /*5669*/
						} /*5669*/
					} /*5669*/
					$1.val = $1.val - $1.sval; /*5671*/
					if ($1.val < 0) { /*5672*/
						break; /*5672*/
					} /*5672*/
					$1.ew = $1.ew + 1; /*5673*/
					var _2I = $1.bar; /*5674*/
					$1.mask = $1.mask & (~((_2I < 0 ? 1 >>> -_2I : 1 << _2I))); /*5674*/
				} /*5674*/
				$1.val = $1.val + $1.sval; /*5676*/
				$1.nm = $1.nm - $1.ew; /*5677*/
				$put($1.out, $1.bar, $1.ew); /*5678*/
			} /*5678*/
			$put($1.out, $1.el - 1, $1.nm); /*5680*/
			$k[$j++] = $1.out; /*5681*/
		}; /*5682*/
		for (var _2U = 0; _2U <= 11; _2U += 1) { /*5688*/
			$1.i = _2U; /*5685*/
			var _2V = $1.binval; /*5686*/
			var _2W = $1.i; /*5686*/
			$put(_2V, _2W + 1, $get(_2V, _2W + 1) + (($get($1.binval, $1.i) % 2013571) * 10)); /*5686*/
			$put($1.binval, $1.i, ~~($get($1.binval, $1.i) / 2013571)); /*5687*/
		} /*5687*/
		$1.d2 = $get($1.binval, 12) % 2013571; /*5689*/
		var _2i = $1.binval; /*5690*/
		$put(_2i, 12, ~~($get(_2i, 12) / 2013571)); /*5690*/
		$1.d1 = 0; /*5692*/
		$1.i = true; /*5693*/
		for (var _2k = 0; _2k <= 12; _2k += 1) { /*5703*/
			$1.j = _2k; /*5695*/
			var _2n = $get($1.binval, $1.j); /*5696*/
			$k[$j++] = _2n; /*5702*/
			if ((_2n == 0) && $1.i) { /*5701*/
				$j--; /*5698*/
			} else { /*5701*/
				$1.i = false; /*5700*/
				$1.d1 = $1.d1 + ($k[--$j] * (~~Math.pow(10, 12 - $1.j))); /*5701*/
			} /*5701*/
		} /*5701*/
		$1.tab267 = $a([183063, 0, 17, 9, 6, 3, 6538, 28, 820063, 183064, 13, 13, 5, 4, 875, 728, 1000775, 820064, 9, 17, 3, 6, 28, 6454, 1491020, 1000776, 15, 11, 5, 4, 2415, 203, 1979844, 1491021, 11, 15, 4, 5, 203, 2408, 1996938, 1979845, 19, 7, 8, 1, 17094, 1, 2013570, 1996939, 7, 19, 1, 8, 1, 16632]); /*5713*/
		$1.i = 0; /*5715*/
		for (;;) { /*5725*/
			if ($1.d1 <= $get($1.tab267, $1.i)) { /*5723*/
				$forall($geti($1.tab267, $1.i + 1, 7)); /*5717*/
				$1.d1te = $k[--$j]; /*5718*/
				$1.d1to = $k[--$j]; /*5718*/
				$1.d1mwe = $k[--$j]; /*5719*/
				$1.d1mwo = $k[--$j]; /*5719*/
				$1.d1ele = $k[--$j]; /*5720*/
				$1.d1elo = $k[--$j]; /*5720*/
				$1.d1gs = $k[--$j]; /*5721*/
				break; /*5722*/
			} /*5722*/
			$1.i = $1.i + 8; /*5724*/
		} /*5724*/
		$1.i = 0; /*5727*/
		for (;;) { /*5737*/
			if ($1.d2 <= $get($1.tab267, $1.i)) { /*5735*/
				$forall($geti($1.tab267, $1.i + 1, 7)); /*5729*/
				$1.d2te = $k[--$j]; /*5730*/
				$1.d2to = $k[--$j]; /*5730*/
				$1.d2mwe = $k[--$j]; /*5731*/
				$1.d2mwo = $k[--$j]; /*5731*/
				$1.d2ele = $k[--$j]; /*5732*/
				$1.d2elo = $k[--$j]; /*5732*/
				$1.d2gs = $k[--$j]; /*5733*/
				break; /*5734*/
			} /*5734*/
			$1.i = $1.i + 8; /*5736*/
		} /*5736*/
		$k[$j++] = "d1wo"; /*5739*/
		$k[$j++] = ~~(($1.d1 - $1.d1gs) / $1.d1te); /*5739*/
		$k[$j++] = $1.d1elo; /*5739*/
		$k[$j++] = $1.d1mwo; /*5739*/
		$k[$j++] = 7; /*5739*/
		$k[$j++] = false; /*5739*/
		if ($1.getRSSwidths() == $b) return $b; /*5739*/
		var _3S = $k[--$j]; /*5739*/
		$1[$k[--$j]] = _3S; /*5739*/
		$k[$j++] = "d1we"; /*5740*/
		$k[$j++] = ($1.d1 - $1.d1gs) % $1.d1te; /*5740*/
		$k[$j++] = $1.d1ele; /*5740*/
		$k[$j++] = $1.d1mwe; /*5740*/
		$k[$j++] = 7; /*5740*/
		$k[$j++] = true; /*5740*/
		if ($1.getRSSwidths() == $b) return $b; /*5740*/
		var _3Z = $k[--$j]; /*5740*/
		$1[$k[--$j]] = _3Z; /*5740*/
		$k[$j++] = "d2wo"; /*5741*/
		$k[$j++] = ~~(($1.d2 - $1.d2gs) / $1.d2te); /*5741*/
		$k[$j++] = $1.d2elo; /*5741*/
		$k[$j++] = $1.d2mwo; /*5741*/
		$k[$j++] = 7; /*5741*/
		$k[$j++] = false; /*5741*/
		if ($1.getRSSwidths() == $b) return $b; /*5741*/
		var _3g = $k[--$j]; /*5741*/
		$1[$k[--$j]] = _3g; /*5741*/
		$k[$j++] = "d2we"; /*5742*/
		$k[$j++] = ($1.d2 - $1.d2gs) % $1.d2te; /*5742*/
		$k[$j++] = $1.d2ele; /*5742*/
		$k[$j++] = $1.d2mwe; /*5742*/
		$k[$j++] = 7; /*5742*/
		$k[$j++] = true; /*5742*/
		if ($1.getRSSwidths() == $b) return $b; /*5742*/
		var _3n = $k[--$j]; /*5742*/
		$1[$k[--$j]] = _3n; /*5742*/
		$1.d1w = $a(14); /*5744*/
		for (var _3q = 0; _3q <= 6; _3q += 1) { /*5749*/
			$1.i = _3q; /*5746*/
			$put($1.d1w, $1.i * 2, $get($1.d1wo, $1.i)); /*5747*/
			$put($1.d1w, ($1.i * 2) + 1, $get($1.d1we, $1.i)); /*5748*/
		} /*5748*/
		$1.d2w = $a(14); /*5751*/
		for (var _42 = 0; _42 <= 6; _42 += 1) { /*5756*/
			$1.i = _42; /*5753*/
			$put($1.d2w, $1.i * 2, $get($1.d2wo, $1.i)); /*5754*/
			$put($1.d2w, ($1.i * 2) + 1, $get($1.d2we, $1.i)); /*5755*/
		} /*5755*/
		$k[$j++] = Infinity; /*5761*/
		var _4D = $1.d1w; /*5759*/
		for (var _4E = 0, _4F = _4D.length; _4E < _4F; _4E++) { /*5759*/
			$k[$j++] = $get(_4D, _4E); /*5759*/
		} /*5759*/
		var _4H = $1.d2w; /*5760*/
		for (var _4I = 0, _4J = _4H.length; _4I < _4J; _4I++) { /*5760*/
			$k[$j++] = $get(_4H, _4I); /*5760*/
		} /*5760*/
		$1.widths = $a(); /*5761*/
		$1.checkweights = $a([1, 3, 9, 27, 81, 65, 17, 51, 64, 14, 42, 37, 22, 66, 20, 60, 2, 6, 18, 54, 73, 41, 34, 13, 39, 28, 84, 74]); /*5766*/
		$k[$j++] = Infinity; /*5782*/
		for (var _4N = 0; _4N <= 43; _4N += 1) { /*5769*/
			$k[$j++] = _4N; /*5769*/
		} /*5769*/
		$k[$j++] = 45; /*5771*/
		$k[$j++] = 52; /*5771*/
		$k[$j++] = 57; /*5771*/
		for (var _4O = 63; _4O <= 66; _4O += 1) { /*5771*/
			$k[$j++] = _4O; /*5771*/
		} /*5771*/
		for (var _4P = 73; _4P <= 79; _4P += 1) { /*5772*/
			$k[$j++] = _4P; /*5772*/
		} /*5772*/
		$k[$j++] = 82; /*5774*/
		for (var _4Q = 126; _4Q <= 130; _4Q += 1) { /*5774*/
			$k[$j++] = _4Q; /*5774*/
		} /*5774*/
		$k[$j++] = 132; /*5776*/
		for (var _4R = 141; _4R <= 146; _4R += 1) { /*5776*/
			$k[$j++] = _4R; /*5776*/
		} /*5776*/
		for (var _4S = 210; _4S <= 217; _4S += 1) { /*5777*/
			$k[$j++] = _4S; /*5777*/
		} /*5777*/
		$k[$j++] = 220; /*5779*/
		for (var _4T = 316; _4T <= 320; _4T += 1) { /*5779*/
			$k[$j++] = _4T; /*5779*/
		} /*5779*/
		$k[$j++] = 322; /*5781*/
		$k[$j++] = 323; /*5781*/
		$k[$j++] = 326; /*5781*/
		$k[$j++] = 337; /*5781*/
		$1.checkseq = $a(); /*5782*/
		$1.checksum = 0; /*5784*/
		for (var _4V = 0; _4V <= 27; _4V += 1) { /*5788*/
			$1.i = _4V; /*5786*/
			$1.checksum = $1.checksum + ($get($1.widths, $1.i) * $get($1.checkweights, $1.i)); /*5787*/
		} /*5787*/
		$1.checksum = $1.checksum % 89; /*5789*/
		$1.seq = $get($1.checkseq, $1.checksum); /*5790*/
		$k[$j++] = "swidths"; /*5791*/
		$k[$j++] = ~~($1.seq / 21); /*5791*/
		$k[$j++] = 8; /*5791*/
		$k[$j++] = 3; /*5791*/
		$k[$j++] = 6; /*5791*/
		$k[$j++] = false; /*5791*/
		if ($1.getRSSwidths() == $b) return $b; /*5791*/
		var _4i = $k[--$j]; /*5791*/
		$1[$k[--$j]] = _4i; /*5791*/
		$k[$j++] = "bwidths"; /*5792*/
		$k[$j++] = $1.seq % 21; /*5792*/
		$k[$j++] = 8; /*5792*/
		$k[$j++] = 3; /*5792*/
		$k[$j++] = 6; /*5792*/
		$k[$j++] = false; /*5792*/
		if ($1.getRSSwidths() == $b) return $b; /*5792*/
		var _4l = $k[--$j]; /*5792*/
		$1[$k[--$j]] = _4l; /*5792*/
		$1.checkwidths = $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1]); /*5794*/
		for (var _4o = 0; _4o <= 5; _4o += 1) { /*5799*/
			$1.i = _4o; /*5796*/
			$put($1.checkwidths, $1.i * 2, $get($1.swidths, $1.i)); /*5797*/
			$put($1.checkwidths, ($1.i * 2) + 1, $get($1.bwidths, $1.i)); /*5798*/
		} /*5798*/
		$k[$j++] = Infinity; /*5803*/
		var _4z = $1.d1w; /*5802*/
		$k[$j++] = 1; /*5802*/
		for (var _50 = 0, _51 = _4z.length; _50 < _51; _50++) { /*5802*/
			$k[$j++] = $get(_4z, _50); /*5802*/
		} /*5802*/
		var _53 = $1.checkwidths; /*5802*/
		for (var _54 = 0, _55 = _53.length; _54 < _55; _54++) { /*5802*/
			$k[$j++] = $get(_53, _54); /*5802*/
		} /*5802*/
		var _57 = $1.d2w; /*5802*/
		for (var _58 = 0, _59 = _57.length; _58 < _59; _58++) { /*5802*/
			$k[$j++] = $get(_57, _58); /*5802*/
		} /*5802*/
		$k[$j++] = 1; /*5802*/
		$k[$j++] = 1; /*5802*/
		$1.sbs = $a(); /*5803*/
		$k[$j++] = Infinity; /*5813*/
		$k[$j++] = "ren"; /*5810*/
		$k[$j++] = $0.renlinear; /*5810*/
		$k[$j++] = "sbs"; /*5810*/
		$k[$j++] = $1.sbs; /*5810*/
		$k[$j++] = "bhs"; /*5810*/
		$k[$j++] = Infinity; /*5810*/
		for (var _5E = 0, _5F = ~~(($1.sbs.length + 1) / 2); _5E < _5F; _5E++) { /*5809*/
			$k[$j++] = $1.height; /*5809*/
		} /*5809*/
		var _5H = $a(); /*5810*/
		$k[$j++] = _5H; /*5811*/
		$k[$j++] = "bbs"; /*5811*/
		$k[$j++] = Infinity; /*5811*/
		for (var _5J = 0, _5K = ~~(($1.sbs.length + 1) / 2); _5J < _5K; _5J++) { /*5810*/
			$k[$j++] = 0; /*5810*/
		} /*5810*/
		var _5L = $a(); /*5811*/
		$k[$j++] = _5L; /*5813*/
		$k[$j++] = "txt"; /*5813*/
		$k[$j++] = $1.txt; /*5813*/
		$k[$j++] = "textxalign"; /*5813*/
		$k[$j++] = "center"; /*5813*/
		$k[$j++] = "opt"; /*5813*/
		$k[$j++] = $1.options; /*5813*/
		var _5O = $d(); /*5813*/
		$k[$j++] = _5O; /*5816*/
		if (!$1.dontdraw) { /*5816*/
			$0.renlinear(); /*5816*/
		} /*5816*/
	};
	$0.databarexpanded = function() {
		var $1 = {}; /*5844*/
		$1.options = $k[--$j]; /*5846*/
		$1.barcode = $k[--$j]; /*5847*/
		$1.dontdraw = false; /*5849*/
		$1.height = 34 / 72; /*5850*/
		$1.format = "expanded"; /*5851*/
		$1.segments = -1; /*5852*/
		$1.linkage = false; /*5853*/
		$1.barxmult = 34; /*5854*/
		$forall($1.options, function() { /*5865*/
			var _3 = $k[--$j]; /*5865*/
			$1[$k[--$j]] = _3; /*5865*/
		}); /*5865*/
		$1.height = +$1.height; /*5867*/
		$1.segments = ~~$1.segments; /*5868*/
		$1.barxmult = ~~$1.barxmult; /*5869*/
		if ($1.segments == -1) { /*5873*/
			var _A = $eq($1.format, "expandedstacked") ? 4 : 22; /*5872*/
			$1.segments = _A; /*5872*/
		} /*5872*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*5877*/
			$1.out = $s($1.in.length); /*5878*/
			$1.j = 0; /*5879*/
			$k[$j++] = $1.in; /*5893*/
			for (;;) { /*5893*/
				$search($k[--$j], "^"); /*5882*/
				if ($k[--$j]) { /*5891*/
					var _H = $k[--$j]; /*5883*/
					$puti($1.out, $1.j, _H); /*5883*/
					$1.j = (_H.length + $1.j) + 1; /*5884*/
					$j--; /*5885*/
					var _L = $k[--$j]; /*5886*/
					$put($1.out, $1.j - 1, ~~$z($geti(_L, 0, 3))); /*5886*/
					$k[$j++] = $geti(_L, 3, _L.length - 3); /*5887*/
				} else { /*5891*/
					var _Q = $k[--$j]; /*5889*/
					$puti($1.out, $1.j, _Q); /*5889*/
					$1.j = _Q.length + $1.j; /*5890*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*5891*/
					break; /*5891*/
				} /*5891*/
			} /*5891*/
		}; /*5894*/
		$1.ais = $a([]); /*5897*/
		$1.vals = $a([]); /*5898*/
		var _Z = $1.barcode; /*5899*/
		$k[$j++] = $geti(_Z, 1, _Z.length - 1); /*5912*/
		for (;;) { /*5912*/
			var _b = $k[--$j]; /*5901*/
			$k[$j++] = _b; /*5901*/
			if ($eq(_b, "")) { /*5901*/
				break; /*5901*/
			} /*5901*/
			$search($k[--$j], ")"); /*5902*/
			$j--; /*5902*/
			var _d = $k[--$j]; /*5903*/
			var _e = $k[--$j]; /*5903*/
			var _f = $k[--$j]; /*5904*/
			$k[$j++] = _d; /*5904*/
			$search(_f, "("); /*5904*/
			if ($k[--$j]) { /*5907*/
				var _h = $k[--$j]; /*5905*/
				var _i = $k[--$j]; /*5905*/
				var _j = $k[--$j]; /*5905*/
				var _k = $k[--$j]; /*5905*/
				$k[$j++] = _j; /*5905*/
				$k[$j++] = _k; /*5905*/
				$k[$j++] = _h; /*5905*/
			} else { /*5907*/
				var _l = $k[--$j]; /*5907*/
				var _m = $k[--$j]; /*5907*/
				$k[$j++] = ""; /*5907*/
				$k[$j++] = _m; /*5907*/
				$k[$j++] = _l; /*5907*/
			} /*5907*/
			$k[$j++] = Infinity; /*5909*/
			$aload($1.ais); /*5909*/
			var _p = $k[$j - 1 - ($counttomark() + 2)]; /*5909*/
			$k[$j++] = _p; /*5909*/
			$1.ais = $a(); /*5909*/
			$k[$j++] = Infinity; /*5910*/
			$aload($1.vals); /*5910*/
			var _t = $k[$j - 1 - ($counttomark() + 1)]; /*5910*/
			$k[$j++] = _t; /*5910*/
			if ($1.expand() == $b) break; /*5910*/
			$1.vals = $a(); /*5910*/
			$j -= 2; /*5911*/
		} /*5911*/
		$j--; /*5913*/
		for (;;) { /*6000*/
			if ($1.ais.length == 2) { /*5925*/
				if ($eq($get($1.ais, 0), "01") && $eq($get($1.ais, 1), "3103")) { /*5924*/
					if ($eq($geti($get($1.vals, 0), 0, 1), "9") && ((~~$z($get($1.vals, 1))) <= 32767)) { /*5923*/
						$k[$j++] = "0100"; /*5922*/
						$k[$j++] = false; /*5922*/
						break; /*5922*/
					} /*5922*/
				} /*5922*/
			} /*5922*/
			if ($1.ais.length == 2) { /*5934*/
				if ($eq($get($1.ais, 0), "01") && $eq($get($1.ais, 1), "3202")) { /*5933*/
					if ($eq($geti($get($1.vals, 0), 0, 1), "9") && ((~~$z($get($1.vals, 1))) <= 9999)) { /*5932*/
						$k[$j++] = "0101"; /*5931*/
						$k[$j++] = false; /*5931*/
						break; /*5931*/
					} /*5931*/
				} /*5931*/
			} /*5931*/
			if ($1.ais.length == 2) { /*5943*/
				if ($eq($get($1.ais, 0), "01") && $eq($get($1.ais, 1), "3203")) { /*5942*/
					if ($eq($geti($get($1.vals, 0), 0, 1), "9") && ((~~$z($get($1.vals, 1))) <= 22767)) { /*5941*/
						$k[$j++] = "0101"; /*5940*/
						$k[$j++] = false; /*5940*/
						break; /*5940*/
					} /*5940*/
				} /*5940*/
			} /*5940*/
			var _1Q = $1.ais.length; /*5946*/
			if ((_1Q == 2) || (_1Q == 3)) { /*5976*/
				$k[$j++] = "ai310x"; /*5947*/
				$k[$j++] = false; /*5947*/
				for (var _1R = 3100; _1R <= 3109; _1R += 1) { /*5947*/
					var _1W = $k[--$j]; /*5947*/
					$k[$j++] = _1W || $eq($cvrs($s(4), _1R, 10), $get($1.ais, 1)); /*5947*/
				} /*5947*/
				var _1X = $k[--$j]; /*5947*/
				$1[$k[--$j]] = _1X; /*5947*/
				$k[$j++] = "ai320x"; /*5948*/
				$k[$j++] = false; /*5948*/
				for (var _1Z = 3200; _1Z <= 3209; _1Z += 1) { /*5948*/
					var _1e = $k[--$j]; /*5948*/
					$k[$j++] = _1e || $eq($cvrs($s(4), _1Z, 10), $get($1.ais, 1)); /*5948*/
				} /*5948*/
				var _1f = $k[--$j]; /*5948*/
				$1[$k[--$j]] = _1f; /*5948*/
				if ($1.ais.length == 3) { /*5952*/
					var _1i = $a(["11", "13", "15", "17"]); /*5950*/
					$k[$j++] = "aibad"; /*5950*/
					$k[$j++] = true; /*5950*/
					for (var _1j = 0, _1k = _1i.length; _1j < _1k; _1j++) { /*5950*/
						var _1o = $k[--$j]; /*5950*/
						$k[$j++] = _1o && $ne($get(_1i, _1j), $get($1.ais, 2)); /*5950*/
					} /*5950*/
					var _1p = $k[--$j]; /*5950*/
					$1[$k[--$j]] = _1p; /*5950*/
				} else { /*5952*/
					$1.aibad = false; /*5952*/
				} /*5952*/
				if (($eq($get($1.ais, 0), "01") && ($1.ai310x || $1.ai320x)) && (!$1.aibad)) { /*5975*/
					if ($1.ais.length == 3) { /*5972*/
						$k[$j++] = $eq($geti($get($1.vals, 0), 0, 1), "9") && ((~~$z($get($1.vals, 1))) <= 99999); /*5967*/
						if ($1.vals && ((~~2) <= 999999)) { /*5967*/
							if ($1.ai310x && $eq($get($1.ais, 2), "11")) { /*5959*/
								$k[$j++] = "0111000"; /*5959*/
								$k[$j++] = false; /*5959*/
								break; /*5959*/
							} /*5959*/
							if ($1.ai320x && $eq($get($1.ais, 2), "11")) { /*5960*/
								$k[$j++] = "0111001"; /*5960*/
								$k[$j++] = false; /*5960*/
								break; /*5960*/
							} /*5960*/
							if ($1.ai310x && $eq($get($1.ais, 2), "13")) { /*5961*/
								$k[$j++] = "0111010"; /*5961*/
								$k[$j++] = false; /*5961*/
								break; /*5961*/
							} /*5961*/
							if ($1.ai320x && $eq($get($1.ais, 2), "13")) { /*5962*/
								$k[$j++] = "0111011"; /*5962*/
								$k[$j++] = false; /*5962*/
								break; /*5962*/
							} /*5962*/
							if ($1.ai310x && $eq($get($1.ais, 2), "15")) { /*5963*/
								$k[$j++] = "0111100"; /*5963*/
								$k[$j++] = false; /*5963*/
								break; /*5963*/
							} /*5963*/
							if ($1.ai320x && $eq($get($1.ais, 2), "15")) { /*5964*/
								$k[$j++] = "0111101"; /*5964*/
								$k[$j++] = false; /*5964*/
								break; /*5964*/
							} /*5964*/
							if ($1.ai310x && $eq($get($1.ais, 2), "17")) { /*5965*/
								$k[$j++] = "0111110"; /*5965*/
								$k[$j++] = false; /*5965*/
								break; /*5965*/
							} /*5965*/
							if ($1.ai320x && $eq($get($1.ais, 2), "17")) { /*5966*/
								$k[$j++] = "0111111"; /*5966*/
								$k[$j++] = false; /*5966*/
								break; /*5966*/
							} /*5966*/
						} /*5966*/
					} else { /*5972*/
						if ($eq($geti($get($1.vals, 0), 0, 1), "9") && ((~~$z($get($1.vals, 1))) <= 99999)) { /*5973*/
							if ($1.ai310x) { /*5971*/
								$k[$j++] = "0111000"; /*5971*/
								$k[$j++] = false; /*5971*/
								break; /*5971*/
							} /*5971*/
							if ($1.ai320x) { /*5972*/
								$k[$j++] = "0111001"; /*5972*/
								$k[$j++] = false; /*5972*/
								break; /*5972*/
							} /*5972*/
						} /*5972*/
					} /*5972*/
				} /*5972*/
			} /*5972*/
			if ($1.ais.length >= 2) { /*5984*/
				$k[$j++] = "ai392x"; /*5980*/
				$k[$j++] = false; /*5980*/
				for (var _2Z = 3920; _2Z <= 3923; _2Z += 1) { /*5980*/
					var _2e = $k[--$j]; /*5980*/
					$k[$j++] = _2e || $eq($cvrs($s(4), _2Z, 10), $get($1.ais, 1)); /*5980*/
				} /*5980*/
				var _2f = $k[--$j]; /*5980*/
				$1[$k[--$j]] = _2f; /*5980*/
				if ($eq($get($1.ais, 0), "01") && $1.ai392x) { /*5983*/
					if ($eq($geti($get($1.vals, 0), 0, 1), "9")) { /*5982*/
						$k[$j++] = "01100"; /*5982*/
						$k[$j++] = true; /*5982*/
						break; /*5982*/
					} /*5982*/
				} /*5982*/
			} /*5982*/
			if ($1.ais.length >= 2) { /*5992*/
				$k[$j++] = "ai393x"; /*5988*/
				$k[$j++] = false; /*5988*/
				for (var _2o = 3930; _2o <= 3933; _2o += 1) { /*5988*/
					var _2t = $k[--$j]; /*5988*/
					$k[$j++] = _2t || $eq($cvrs($s(4), _2o, 10), $get($1.ais, 1)); /*5988*/
				} /*5988*/
				var _2u = $k[--$j]; /*5988*/
				$1[$k[--$j]] = _2u; /*5988*/
				if ($eq($get($1.ais, 0), "01") && $1.ai393x) { /*5991*/
					if ($eq($geti($get($1.vals, 0), 0, 1), "9")) { /*5990*/
						$k[$j++] = "01101"; /*5990*/
						$k[$j++] = true; /*5990*/
						break; /*5990*/
					} /*5990*/
				} /*5990*/
			} /*5990*/
			if ($eq($get($1.ais, 0), "01")) { /*5995*/
				$k[$j++] = "1"; /*5995*/
				$k[$j++] = true; /*5995*/
				break; /*5995*/
			} /*5995*/
			$k[$j++] = "00"; /*5998*/
			$k[$j++] = true; /*5998*/
			break; /*5998*/
		} /*5998*/
		$1.gpfallow = $k[--$j]; /*6001*/
		$1.method = $k[--$j]; /*6002*/
		$1.conv12to40 = function() {
			var _37 = $strcpy($s(40), "0000000000000000000000000000000000000000"); /*6005*/
			var _38 = $k[--$j]; /*6006*/
			var _3C = $cvrs($s(10), ~~$z($geti(_38, 0, 3)), 2); /*6006*/
			$puti($geti(_37, 0, 10), 10 - _3C.length, _3C); /*6006*/
			var _3G = $cvrs($s(10), ~~$z($geti(_38, 3, 3)), 2); /*6007*/
			$puti($geti(_37, 10, 10), 10 - _3G.length, _3G); /*6007*/
			var _3K = $cvrs($s(10), ~~$z($geti(_38, 6, 3)), 2); /*6008*/
			$puti($geti(_37, 20, 10), 10 - _3K.length, _3K); /*6008*/
			var _3O = $cvrs($s(10), ~~$z($geti(_38, 9, 3)), 2); /*6009*/
			$puti($geti(_37, 30, 10), 10 - _3O.length, _3O); /*6009*/
			$k[$j++] = _37; /*6010*/
		}; /*6011*/
		$1.conv13to44 = function() {
			var _3Q = $strcpy($s(44), "00000000000000000000000000000000000000000000"); /*6014*/
			var _3R = $k[--$j]; /*6015*/
			var _3V = $cvrs($s(4), ~~$z($geti(_3R, 0, 1)), 2); /*6015*/
			$puti($geti(_3Q, 0, 4), 4 - _3V.length, _3V); /*6015*/
			$k[$j++] = _3Q; /*6016*/
			$k[$j++] = _3Q; /*6016*/
			$k[$j++] = $geti(_3R, 1, 12); /*6016*/
			if ($1.conv12to40() == $b) return $b; /*6016*/
			var _3X = $k[--$j]; /*6016*/
			$puti($k[--$j], 4, _3X); /*6016*/
		}; /*6017*/
		$1.tobin = function() {
			var _3a = $s($k[--$j]); /*6020*/
			$k[$j++] = _3a; /*6020*/
			for (var _3c = 0, _3b = _3a.length - 1; _3c <= _3b; _3c += 1) { /*6020*/
				var _3d = $k[--$j]; /*6020*/
				$put(_3d, _3c, 48); /*6020*/
				$k[$j++] = _3d; /*6020*/
			} /*6020*/
			var _3e = $k[--$j]; /*6021*/
			var _3h = $cvrs($s(_3e.length), $k[--$j], 2); /*6021*/
			$puti(_3e, _3e.length - _3h.length, _3h); /*6021*/
			$k[$j++] = _3e; /*6021*/
		}; /*6022*/
		if ($eq($1.method, "00")) { /*6027*/
			$1.cdf = $a([]); /*6025*/
			$1.gpf = $a([]); /*6026*/
		} /*6026*/
		if ($eq($1.method, "1")) { /*6035*/
			$k[$j++] = "cdf"; /*6030*/
			$k[$j++] = $geti($get($1.vals, 0), 0, 13); /*6030*/
			if ($1.conv13to44() == $b) return $b; /*6030*/
			var _3p = $k[--$j]; /*6030*/
			$1[$k[--$j]] = _3p; /*6030*/
			$k[$j++] = Infinity; /*6031*/
			var _3r = $1.cdf; /*6031*/
			for (var _3s = 0, _3t = _3r.length; _3s < _3t; _3s++) { /*6031*/
				$k[$j++] = $get(_3r, _3s) - 48; /*6031*/
			} /*6031*/
			$1.cdf = $a(); /*6031*/
			$1.gpf = $a([]); /*6032*/
			$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*6033*/
			$1.vals = $geti($1.vals, 1, $1.vals.length - 1); /*6034*/
		} /*6034*/
		if ($eq($1.method, "0100")) { /*6045*/
			$1.cdf = $s(55); /*6038*/
			$k[$j++] = $1.cdf; /*6039*/
			$k[$j++] = 0; /*6039*/
			$k[$j++] = $geti($get($1.vals, 0), 1, 12); /*6039*/
			if ($1.conv12to40() == $b) return $b; /*6039*/
			var _49 = $k[--$j]; /*6039*/
			var _4A = $k[--$j]; /*6039*/
			$puti($k[--$j], _4A, _49); /*6039*/
			$k[$j++] = $1.cdf; /*6040*/
			$k[$j++] = 40; /*6040*/
			$k[$j++] = ~~$z($get($1.vals, 1)); /*6040*/
			$k[$j++] = 15; /*6040*/
			if ($1.tobin() == $b) return $b; /*6040*/
			var _4F = $k[--$j]; /*6040*/
			var _4G = $k[--$j]; /*6040*/
			$puti($k[--$j], _4G, _4F); /*6040*/
			$k[$j++] = Infinity; /*6041*/
			var _4I = $1.cdf; /*6041*/
			for (var _4J = 0, _4K = _4I.length; _4J < _4K; _4J++) { /*6041*/
				$k[$j++] = $get(_4I, _4J) - 48; /*6041*/
			} /*6041*/
			$1.cdf = $a(); /*6041*/
			$1.gpf = $a([]); /*6042*/
			$1.ais = $a([]); /*6043*/
			$1.vals = $a([]); /*6044*/
		} /*6044*/
		if ($eq($1.method, "0101")) { /*6060*/
			$1.cdf = $s(55); /*6048*/
			$k[$j++] = $1.cdf; /*6049*/
			$k[$j++] = 0; /*6049*/
			$k[$j++] = $geti($get($1.vals, 0), 1, 12); /*6049*/
			if ($1.conv12to40() == $b) return $b; /*6049*/
			var _4W = $k[--$j]; /*6049*/
			var _4X = $k[--$j]; /*6049*/
			$puti($k[--$j], _4X, _4W); /*6049*/
			if ($eq($get($1.ais, 1), "3202")) { /*6053*/
				$k[$j++] = ~~$z($get($1.vals, 1)); /*6051*/
				$k[$j++] = 15; /*6051*/
				if ($1.tobin() == $b) return $b; /*6051*/
			} else { /*6053*/
				$k[$j++] = (~~$z($get($1.vals, 1))) + 10000; /*6053*/
				$k[$j++] = 15; /*6053*/
				if ($1.tobin() == $b) return $b; /*6053*/
			} /*6053*/
			$puti($1.cdf, 40, $k[--$j]); /*6055*/
			$k[$j++] = Infinity; /*6056*/
			var _4h = $1.cdf; /*6056*/
			for (var _4i = 0, _4j = _4h.length; _4i < _4j; _4i++) { /*6056*/
				$k[$j++] = $get(_4h, _4i) - 48; /*6056*/
			} /*6056*/
			$1.cdf = $a(); /*6056*/
			$1.gpf = $a([]); /*6057*/
			$1.ais = $a([]); /*6058*/
			$1.vals = $a([]); /*6059*/
		} /*6059*/
		if ($1.method.length == 7) { /*6081*/
			$1.cdf = $s(76); /*6063*/
			$k[$j++] = $1.cdf; /*6064*/
			$k[$j++] = 0; /*6064*/
			$k[$j++] = $geti($get($1.vals, 0), 1, 12); /*6064*/
			if ($1.conv12to40() == $b) return $b; /*6064*/
			var _4v = $k[--$j]; /*6064*/
			var _4w = $k[--$j]; /*6064*/
			$puti($k[--$j], _4w, _4v); /*6064*/
			var _4y = $s(6); /*6065*/
			$puti(_4y, 0, $geti($get($1.ais, 1), 3, 1)); /*6065*/
			$puti(_4y, 1, $geti($get($1.vals, 1), 1, 5)); /*6066*/
			$k[$j++] = ~~$z(_4y); /*6066*/
			$k[$j++] = 20; /*6066*/
			if ($1.tobin() == $b) return $b; /*6066*/
			$puti($1.cdf, 40, $k[--$j]); /*6067*/
			if ($1.ais.length == 3) { /*6074*/
				var _59 = $get($1.vals, 2); /*6069*/
				$k[$j++] = ((~~$z($geti(_59, 0, 2))) * 384) + ((((~~$z($geti(_59, 2, 2))) - 1) * 32) + (~~$z($geti(_59, 4, 2)))); /*6072*/
			} else { /*6074*/
				$k[$j++] = 38400; /*6074*/
			} /*6074*/
			$k[$j++] = 16; /*6076*/
			if ($1.tobin() == $b) return $b; /*6076*/
			$puti($1.cdf, 60, $k[--$j]); /*6076*/
			$k[$j++] = Infinity; /*6077*/
			var _5F = $1.cdf; /*6077*/
			for (var _5G = 0, _5H = _5F.length; _5G < _5H; _5G++) { /*6077*/
				$k[$j++] = $get(_5F, _5G) - 48; /*6077*/
			} /*6077*/
			$1.cdf = $a(); /*6077*/
			$1.gpf = $a([]); /*6078*/
			$1.ais = $a([]); /*6079*/
			$1.vals = $a([]); /*6080*/
		} /*6080*/
		if ($eq($1.method, "01100")) { /*6091*/
			$1.cdf = $s(42); /*6084*/
			$k[$j++] = $1.cdf; /*6085*/
			$k[$j++] = 0; /*6085*/
			$k[$j++] = $geti($get($1.vals, 0), 1, 12); /*6085*/
			if ($1.conv12to40() == $b) return $b; /*6085*/
			var _5T = $k[--$j]; /*6085*/
			var _5U = $k[--$j]; /*6085*/
			$puti($k[--$j], _5U, _5T); /*6085*/
			$k[$j++] = $1.cdf; /*6086*/
			$k[$j++] = 40; /*6086*/
			$k[$j++] = ~~$z($geti($get($1.ais, 1), 3, 1)); /*6086*/
			$k[$j++] = 2; /*6086*/
			if ($1.tobin() == $b) return $b; /*6086*/
			var _5a = $k[--$j]; /*6086*/
			var _5b = $k[--$j]; /*6086*/
			$puti($k[--$j], _5b, _5a); /*6086*/
			$k[$j++] = Infinity; /*6087*/
			var _5d = $1.cdf; /*6087*/
			for (var _5e = 0, _5f = _5d.length; _5e < _5f; _5e++) { /*6087*/
				$k[$j++] = $get(_5d, _5e) - 48; /*6087*/
			} /*6087*/
			$1.cdf = $a(); /*6087*/
			$k[$j++] = Infinity; /*6088*/
			$forall($get($1.vals, 1)); /*6088*/
			$1.gpf = $a(); /*6088*/
			$1.ais = $geti($1.ais, 2, $1.ais.length - 2); /*6089*/
			$1.vals = $geti($1.vals, 2, $1.vals.length - 2); /*6090*/
		} /*6090*/
		if ($eq($1.method, "01101")) { /*6102*/
			$1.cdf = $s(52); /*6094*/
			$k[$j++] = $1.cdf; /*6095*/
			$k[$j++] = 0; /*6095*/
			$k[$j++] = $geti($get($1.vals, 0), 1, 12); /*6095*/
			if ($1.conv12to40() == $b) return $b; /*6095*/
			var _5x = $k[--$j]; /*6095*/
			var _5y = $k[--$j]; /*6095*/
			$puti($k[--$j], _5y, _5x); /*6095*/
			$k[$j++] = $1.cdf; /*6096*/
			$k[$j++] = 40; /*6096*/
			$k[$j++] = ~~$z($geti($get($1.ais, 1), 3, 1)); /*6096*/
			$k[$j++] = 2; /*6096*/
			if ($1.tobin() == $b) return $b; /*6096*/
			var _64 = $k[--$j]; /*6096*/
			var _65 = $k[--$j]; /*6096*/
			$puti($k[--$j], _65, _64); /*6096*/
			$k[$j++] = $1.cdf; /*6097*/
			$k[$j++] = 42; /*6097*/
			$k[$j++] = ~~$z($geti($get($1.vals, 1), 0, 3)); /*6097*/
			$k[$j++] = 10; /*6097*/
			if ($1.tobin() == $b) return $b; /*6097*/
			var _6B = $k[--$j]; /*6097*/
			var _6C = $k[--$j]; /*6097*/
			$puti($k[--$j], _6C, _6B); /*6097*/
			$k[$j++] = Infinity; /*6098*/
			var _6E = $1.cdf; /*6098*/
			for (var _6F = 0, _6G = _6E.length; _6F < _6G; _6F++) { /*6098*/
				$k[$j++] = $get(_6E, _6F) - 48; /*6098*/
			} /*6098*/
			$1.cdf = $a(); /*6098*/
			$k[$j++] = Infinity; /*6099*/
			var _6K = $get($1.vals, 1); /*6099*/
			$forall($geti(_6K, 3, _6K.length - 3)); /*6099*/
			$1.gpf = $a(); /*6099*/
			$1.ais = $geti($1.ais, 2, $1.ais.length - 2); /*6100*/
			$1.vals = $geti($1.vals, 2, $1.vals.length - 2); /*6101*/
		} /*6101*/
		if ($1.gpfallow) { /*6108*/
			$1.vlf = $a(2); /*6106*/
		} else { /*6108*/
			$1.vlf = $a([]); /*6108*/
		} /*6108*/
		$1.aifixed = {}; /*6114*/
		$k[$j++] = Infinity; /*6116*/
		for (var _6W = 0; _6W <= 4; _6W += 1) { /*6116*/
			$k[$j++] = _6W; /*6116*/
		} /*6116*/
		var _6X = $a(); /*6116*/
		for (var _6Y = 0, _6Z = _6X.length; _6Y < _6Z; _6Y++) { /*6119*/
			var _6c = $strcpy($s(2), "00"); /*6118*/
			$put(_6c, 1, $get(_6X, _6Y) + 48); /*6118*/
			$put($1.aifixed, _6c, _6c); /*6118*/
		} /*6118*/
		$k[$j++] = Infinity; /*6124*/
		for (var _6e = 11; _6e <= 20; _6e += 1) { /*6121*/
			$k[$j++] = _6e; /*6121*/
		} /*6121*/
		$k[$j++] = 23; /*6123*/
		for (var _6f = 31; _6f <= 36; _6f += 1) { /*6123*/
			$k[$j++] = _6f; /*6123*/
		} /*6123*/
		$k[$j++] = 41; /*6124*/
		var _6g = $a(); /*6124*/
		for (var _6h = 0, _6i = _6g.length; _6h < _6i; _6h++) { /*6127*/
			var _6l = $cvrs($s(2), $get(_6g, _6h), 10); /*6126*/
			$put($1.aifixed, _6l, _6l); /*6126*/
		} /*6126*/
		$1.fnc1 = -1; /*6129*/
		$1.lnumeric = -2; /*6129*/
		$1.lalphanumeric = -3; /*6129*/
		$1.liso646 = -4; /*6129*/
		$k[$j++] = "numeric"; /*6141*/
		$k[$j++] = Infinity; /*6141*/
		for (var _6n = 0; _6n <= 119; _6n += 1) { /*6140*/
			var _6p = $strcpy($s(2), "00"); /*6133*/
			var _6r = $cvrs($s(2), _6n, 11); /*6133*/
			$puti(_6p, 2 - _6r.length, _6r); /*6134*/
			$k[$j++] = _6n; /*6135*/
			$k[$j++] = _6p; /*6135*/
			if ($get(_6p, 0) == 65) { /*6135*/
				var _6t = $k[--$j]; /*6135*/
				$put(_6t, 0, 94); /*6135*/
				$k[$j++] = _6t; /*6135*/
			} /*6135*/
			var _6u = $k[--$j]; /*6136*/
			$k[$j++] = _6u; /*6136*/
			if ($get(_6u, 1) == 65) { /*6136*/
				var _6w = $k[--$j]; /*6136*/
				$put(_6w, 1, 94); /*6136*/
				$k[$j++] = _6w; /*6136*/
			} /*6136*/
			var _6x = $k[--$j]; /*6137*/
			var _70 = $strcpy($s(7), "0000000"); /*6138*/
			var _72 = $cvrs($s(7), $k[--$j] + 8, 2); /*6138*/
			$puti(_70, 7 - _72.length, _72); /*6139*/
			$k[$j++] = _6x; /*6139*/
			$k[$j++] = _70; /*6139*/
		} /*6139*/
		$k[$j++] = $1.lalphanumeric; /*6141*/
		$k[$j++] = "0000"; /*6141*/
		var _74 = $d(); /*6141*/
		$1[$k[--$j]] = _74; /*6142*/
		$k[$j++] = "alphanumeric"; /*6151*/
		$k[$j++] = Infinity; /*6151*/
		for (var _76 = 48; _76 <= 57; _76 += 1) { /*6145*/
			$k[$j++] = _76; /*6145*/
			$k[$j++] = _76 - 43; /*6145*/
			$k[$j++] = 5; /*6145*/
			if ($1.tobin() == $b) break; /*6145*/
		} /*6145*/
		$k[$j++] = $1.fnc1; /*6147*/
		$k[$j++] = "01111"; /*6147*/
		for (var _78 = 65; _78 <= 90; _78 += 1) { /*6147*/
			$k[$j++] = _78; /*6147*/
			$k[$j++] = _78 - 33; /*6147*/
			$k[$j++] = 6; /*6147*/
			if ($1.tobin() == $b) break; /*6147*/
		} /*6147*/
		$k[$j++] = 42; /*6149*/
		$k[$j++] = "111010"; /*6149*/
		for (var _79 = 44; _79 <= 47; _79 += 1) { /*6149*/
			$k[$j++] = _79; /*6149*/
			$k[$j++] = _79 + 15; /*6149*/
			$k[$j++] = 6; /*6149*/
			if ($1.tobin() == $b) break; /*6149*/
		} /*6149*/
		$k[$j++] = $1.lnumeric; /*6151*/
		$k[$j++] = "000"; /*6151*/
		$k[$j++] = $1.liso646; /*6151*/
		$k[$j++] = "00100"; /*6151*/
		var _7C = $d(); /*6151*/
		$1[$k[--$j]] = _7C; /*6152*/
		$k[$j++] = "iso646"; /*6166*/
		$k[$j++] = Infinity; /*6166*/
		for (var _7E = 48; _7E <= 57; _7E += 1) { /*6155*/
			$k[$j++] = _7E; /*6155*/
			$k[$j++] = _7E - 43; /*6155*/
			$k[$j++] = 5; /*6155*/
			if ($1.tobin() == $b) break; /*6155*/
		} /*6155*/
		$k[$j++] = $1.fnc1; /*6157*/
		$k[$j++] = "01111"; /*6157*/
		for (var _7G = 65; _7G <= 90; _7G += 1) { /*6157*/
			$k[$j++] = _7G; /*6157*/
			$k[$j++] = _7G - 1; /*6157*/
			$k[$j++] = 7; /*6157*/
			if ($1.tobin() == $b) break; /*6157*/
		} /*6157*/
		for (var _7H = 97; _7H <= 122; _7H += 1) { /*6158*/
			$k[$j++] = _7H; /*6158*/
			$k[$j++] = _7H - 7; /*6158*/
			$k[$j++] = 7; /*6158*/
			if ($1.tobin() == $b) break; /*6158*/
		} /*6158*/
		$k[$j++] = 33; /*6161*/
		$k[$j++] = "11101000"; /*6161*/
		$k[$j++] = 34; /*6161*/
		$k[$j++] = "11101001"; /*6161*/
		for (var _7I = 37; _7I <= 47; _7I += 1) { /*6161*/
			$k[$j++] = _7I; /*6161*/
			$k[$j++] = _7I + 197; /*6161*/
			$k[$j++] = 8; /*6161*/
			if ($1.tobin() == $b) break; /*6161*/
		} /*6161*/
		for (var _7J = 58; _7J <= 63; _7J += 1) { /*6162*/
			$k[$j++] = _7J; /*6162*/
			$k[$j++] = _7J + 187; /*6162*/
			$k[$j++] = 8; /*6162*/
			if ($1.tobin() == $b) break; /*6162*/
		} /*6162*/
		$k[$j++] = 95; /*6166*/
		$k[$j++] = "11111011"; /*6166*/
		$k[$j++] = 32; /*6166*/
		$k[$j++] = "11111100"; /*6166*/
		$k[$j++] = $1.lnumeric; /*6166*/
		$k[$j++] = "000"; /*6166*/
		$k[$j++] = $1.lalphanumeric; /*6166*/
		$k[$j++] = "00100"; /*6166*/
		var _7M = $d(); /*6166*/
		$1[$k[--$j]] = _7M; /*6167*/
		for (var _7Q = 0, _7P = $1.ais.length - 1; _7Q <= _7P; _7Q += 1) { /*6185*/
			$1.i = _7Q; /*6171*/
			$1.ai = $get($1.ais, $1.i); /*6172*/
			$1.val = $get($1.vals, $1.i); /*6173*/
			var _7a = $a(($1.gpf.length + $1.ai.length) + $1.val.length); /*6174*/
			$puti(_7a, 0, $1.gpf); /*6175*/
			$k[$j++] = _7a; /*6176*/
			$k[$j++] = _7a; /*6176*/
			$k[$j++] = $1.gpf.length; /*6176*/
			$k[$j++] = $1.ai; /*6176*/
			$k[$j++] = Infinity; /*6176*/
			var _7e = $k[--$j]; /*6176*/
			var _7f = $k[--$j]; /*6176*/
			$k[$j++] = _7e; /*6176*/
			$forall(_7f); /*6176*/
			var _7g = $a(); /*6176*/
			var _7h = $k[--$j]; /*6176*/
			$puti($k[--$j], _7h, _7g); /*6176*/
			var _7j = $k[--$j]; /*6177*/
			$k[$j++] = _7j; /*6177*/
			$k[$j++] = _7j; /*6177*/
			$k[$j++] = $1.gpf.length + $1.ai.length; /*6177*/
			$k[$j++] = $1.val; /*6177*/
			$k[$j++] = Infinity; /*6177*/
			var _7n = $k[--$j]; /*6177*/
			var _7o = $k[--$j]; /*6177*/
			$k[$j++] = _7n; /*6177*/
			$forall(_7o); /*6177*/
			var _7p = $a(); /*6177*/
			var _7q = $k[--$j]; /*6177*/
			$puti($k[--$j], _7q, _7p); /*6177*/
			$1.gpf = $k[--$j]; /*6178*/
			var _7y = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*6179*/
			if (($1.i != ($1.ais.length - 1)) && (!_7y)) { /*6184*/
				var _80 = $a($1.gpf.length + 1); /*6180*/
				$puti(_80, 0, $1.gpf); /*6181*/
				$put(_80, $1.gpf.length, $1.fnc1); /*6182*/
				$1.gpf = _80; /*6183*/
			} /*6183*/
		} /*6183*/
		$1.rembits = function() {
			var _84 = $k[--$j]; /*6189*/
			var _85 = 48; /*6191*/
			var _86 = (~~Math.ceil(_84 / 12)) * 12; /*6191*/
			if (((~~Math.ceil(_84 / 12)) * 12) < 48) { /*6191*/
				var _ = _85; /*6191*/
				_85 = _86; /*6191*/
				_86 = _; /*6191*/
			} /*6191*/
			var _87 = ~~(_86 / 12); /*6192*/
			$k[$j++] = _84; /*6196*/
			$k[$j++] = _86; /*6196*/
			$k[$j++] = _87; /*6196*/
			if ((_87 % $1.segments) == 1) { /*6195*/
				var _89 = $k[--$j]; /*6193*/
				var _8A = $k[--$j]; /*6193*/
				$k[$j++] = (_89 + 1) * 12; /*6193*/
			} else { /*6195*/
				$j--; /*6195*/
			} /*6195*/
			var _8B = $k[--$j]; /*6197*/
			var _8C = $k[--$j]; /*6197*/
			$k[$j++] = _8B - _8C; /*6197*/
		}; /*6198*/
		$1.encode = function() {
			var _8D = $k[--$j]; /*6201*/
			$k[$j++] = _8D; /*6201*/
			if ($ne(_8D, "raw")) { /*6201*/
				var _8E = $k[--$j]; /*6201*/
				var _8G = $get(_8E, $k[--$j]); /*6201*/
				$k[$j++] = _8G; /*6201*/
			} else { /*6201*/
				$j--; /*6201*/
			} /*6201*/
			$k[$j++] = Infinity; /*6202*/
			var _8H = $k[--$j]; /*6202*/
			var _8I = $k[--$j]; /*6202*/
			$k[$j++] = _8H; /*6202*/
			$forall(_8I, function() { /*6202*/
				var _8J = $k[--$j]; /*6202*/
				$k[$j++] = _8J - 48; /*6202*/
			}); /*6202*/
			var _8K = $a(); /*6202*/
			$puti($1.gpfenc, $1.j, _8K); /*6204*/
			$1.j = _8K.length + $1.j; /*6205*/
		}; /*6206*/
		$k[$j++] = Infinity; /*6209*/
		for (var _8P = 0, _8Q = $1.gpf.length; _8P < _8Q; _8P++) { /*6209*/
			$k[$j++] = 0; /*6209*/
		} /*6209*/
		$k[$j++] = 0; /*6209*/
		$k[$j++] = -1; /*6209*/
		$1.numericruns = $a(); /*6209*/
		$k[$j++] = Infinity; /*6210*/
		for (var _8T = 0, _8U = $1.gpf.length; _8T < _8U; _8T++) { /*6210*/
			$k[$j++] = 0; /*6210*/
		} /*6210*/
		$k[$j++] = 0; /*6210*/
		$1.alphanumericruns = $a(); /*6210*/
		$k[$j++] = Infinity; /*6211*/
		for (var _8X = 0, _8Y = $1.gpf.length; _8X < _8Y; _8X++) { /*6211*/
			$k[$j++] = 0; /*6211*/
		} /*6211*/
		$k[$j++] = 9999; /*6211*/
		$1.nextiso646only = $a(); /*6211*/
		for (var _8b = $1.gpf.length - 1; _8b >= 0; _8b -= 1) { /*6233*/
			$1.i = _8b; /*6213*/
			var _8g = $strcpy($s(2), "00"); /*6215*/
			var _8j = $get($1.gpf, $1.i); /*6216*/
			$k[$j++] = $get($1.gpf, $1.i); /*6216*/
			$k[$j++] = _8g; /*6216*/
			$k[$j++] = _8g; /*6216*/
			$k[$j++] = 0; /*6216*/
			$k[$j++] = _8j; /*6216*/
			if (_8j == $1.fnc1) { /*6216*/
				$j--; /*6216*/
				$k[$j++] = 94; /*6216*/
			} /*6216*/
			var _8l = $k[--$j]; /*6216*/
			var _8m = $k[--$j]; /*6216*/
			$put($k[--$j], _8m, _8l); /*6216*/
			if ($1.i < ($1.gpf.length - 1)) { /*6217*/
				var _8q = $k[--$j]; /*6217*/
				var _8t = $get($1.gpf, $1.i + 1); /*6217*/
				$k[$j++] = _8q; /*6217*/
				$k[$j++] = _8q; /*6217*/
				$k[$j++] = 1; /*6217*/
				$k[$j++] = _8t; /*6217*/
				if (_8t == $1.fnc1) { /*6217*/
					$j--; /*6217*/
					$k[$j++] = 94; /*6217*/
				} /*6217*/
				var _8v = $k[--$j]; /*6217*/
				var _8w = $k[--$j]; /*6217*/
				$put($k[--$j], _8w, _8v); /*6217*/
			} /*6217*/
			var _90 = $get($1.numeric, $k[--$j]) !== undefined; /*6218*/
			if (_90) { /*6221*/
				$put($1.numericruns, $1.i, $get($1.numericruns, $1.i + 2) + 2); /*6219*/
			} else { /*6221*/
				$put($1.numericruns, $1.i, 0); /*6221*/
			} /*6221*/
			var _98 = $k[--$j]; /*6223*/
			var _9A = $get($1.alphanumeric, _98) !== undefined; /*6223*/
			$k[$j++] = _98; /*6227*/
			if (_9A) { /*6226*/
				$put($1.alphanumericruns, $1.i, $get($1.alphanumericruns, $1.i + 1) + 1); /*6224*/
			} else { /*6226*/
				$put($1.alphanumericruns, $1.i, 0); /*6226*/
			} /*6226*/
			var _9I = $k[--$j]; /*6228*/
			var _9K = $get($1.iso646, _9I) !== undefined; /*6228*/
			var _9M = $get($1.alphanumeric, _9I) !== undefined; /*6228*/
			if (_9K && (!_9M)) { /*6231*/
				$put($1.nextiso646only, $1.i, 0); /*6229*/
			} else { /*6231*/
				$put($1.nextiso646only, $1.i, $get($1.nextiso646only, $1.i + 1) + 1); /*6231*/
			} /*6231*/
		} /*6231*/
		$1.gpfenc = $a(252); /*6236*/
		$1.i = 0; /*6237*/
		$1.j = 0; /*6237*/
		$1.mode = "numeric"; /*6237*/
		for (;;) { /*6327*/
			if ($1.i == $1.gpf.length) { /*6239*/
				break; /*6239*/
			} /*6239*/
			for (;;) { /*6326*/
				if ($eq($1.mode, "numeric")) { /*6275*/
					if ($1.i <= ($1.gpf.length - 2)) { /*6272*/
						var _9a = $s(2); /*6244*/
						var _9d = $get($1.gpf, $1.i); /*6245*/
						$k[$j++] = _9a; /*6245*/
						$k[$j++] = _9a; /*6245*/
						$k[$j++] = 0; /*6245*/
						$k[$j++] = _9d; /*6245*/
						if (_9d == $1.fnc1) { /*6245*/
							$j--; /*6245*/
							$k[$j++] = 94; /*6245*/
						} /*6245*/
						var _9f = $k[--$j]; /*6245*/
						var _9g = $k[--$j]; /*6245*/
						$put($k[--$j], _9g, _9f); /*6245*/
						var _9i = $k[--$j]; /*6246*/
						var _9l = $get($1.gpf, $1.i + 1); /*6246*/
						$k[$j++] = _9i; /*6246*/
						$k[$j++] = _9i; /*6246*/
						$k[$j++] = 1; /*6246*/
						$k[$j++] = _9l; /*6246*/
						if (_9l == $1.fnc1) { /*6246*/
							$j--; /*6246*/
							$k[$j++] = 94; /*6246*/
						} /*6246*/
						var _9n = $k[--$j]; /*6246*/
						var _9o = $k[--$j]; /*6246*/
						$put($k[--$j], _9o, _9n); /*6246*/
						var _9q = $k[--$j]; /*6247*/
						var _9s = $get($1.numeric, _9q) !== undefined; /*6247*/
						$k[$j++] = _9q; /*6251*/
						if (_9s) { /*6251*/
							$k[$j++] = $1.numeric; /*6248*/
							if ($1.encode() == $b) break; /*6248*/
							$1.i = $1.i + 2; /*6249*/
							break; /*6250*/
						} /*6250*/
						$j--; /*6252*/
						$k[$j++] = $1.lalphanumeric; /*6253*/
						$k[$j++] = $1.numeric; /*6253*/
						if ($1.encode() == $b) break; /*6253*/
						$1.mode = "alphanumeric"; /*6254*/
						break; /*6255*/
					} else { /*6272*/
						var _9z = $get($1.gpf, $1.i); /*6257*/
						if ((_9z < 48) || (_9z > 57)) { /*6261*/
							$k[$j++] = $1.lalphanumeric; /*6258*/
							$k[$j++] = $1.numeric; /*6258*/
							if ($1.encode() == $b) break; /*6258*/
							$1.mode = "alphanumeric"; /*6259*/
							break; /*6260*/
						} /*6260*/
						$k[$j++] = "rem"; /*6262*/
						$k[$j++] = ((((12 + 1) + $1.method.length) + $1.vlf.length) + $1.cdf.length) + $1.j; /*6262*/
						if ($1.rembits() == $b) break; /*6262*/
						var _A6 = $k[--$j]; /*6262*/
						$1[$k[--$j]] = _A6; /*6262*/
						if (($1.rem >= 4) && ($1.rem <= 6)) { /*6272*/
							var _AD = $geti($strcpy($s(6), "000000"), 0, $1.rem); /*6264*/
							var _AI = $cvrs($s(4), $get($1.gpf, $1.i) - 47, 2); /*6265*/
							$puti(_AD, 4 - _AI.length, _AI); /*6266*/
							$k[$j++] = _AD; /*6266*/
							$k[$j++] = "raw"; /*6266*/
							if ($1.encode() == $b) break; /*6266*/
							$1.i = $1.i + 1; /*6267*/
							break; /*6268*/
						} else { /*6272*/
							var _AK = $s(2); /*6270*/
							$put(_AK, 0, $get($1.gpf, $1.i)); /*6270*/
							$put(_AK, 1, 94); /*6270*/
							$k[$j++] = _AK; /*6270*/
							$k[$j++] = $1.numeric; /*6270*/
							if ($1.encode() == $b) break; /*6270*/
							$1.i = $1.i + 1; /*6271*/
							break; /*6272*/
						} /*6272*/
					} /*6272*/
				} /*6272*/
				if ($eq($1.mode, "alphanumeric")) { /*6302*/
					if ($get($1.gpf, $1.i) == $1.fnc1) { /*6283*/
						$k[$j++] = $1.fnc1; /*6279*/
						$k[$j++] = $1.alphanumeric; /*6279*/
						if ($1.encode() == $b) break; /*6279*/
						$1.mode = "numeric"; /*6280*/
						$1.i = $1.i + 1; /*6281*/
						break; /*6282*/
					} /*6282*/
					var _Aa = $get($1.gpf, $1.i); /*6284*/
					var _Ac = $get($1.iso646, _Aa) !== undefined; /*6284*/
					var _Ae = $get($1.alphanumeric, _Aa) !== undefined; /*6284*/
					if (_Ac && (!_Ae)) { /*6288*/
						$k[$j++] = $1.liso646; /*6285*/
						$k[$j++] = $1.alphanumeric; /*6285*/
						if ($1.encode() == $b) break; /*6285*/
						$1.mode = "iso646"; /*6286*/
						break; /*6287*/
					} /*6287*/
					if ($get($1.numericruns, $1.i) >= 6) { /*6293*/
						$k[$j++] = $1.lnumeric; /*6290*/
						$k[$j++] = $1.alphanumeric; /*6290*/
						if ($1.encode() == $b) break; /*6290*/
						$1.mode = "numeric"; /*6291*/
						break; /*6292*/
					} /*6292*/
					var _Ao = $get($1.numericruns, $1.i); /*6294*/
					if ((_Ao >= 4) && ((_Ao + $1.i) == $1.gpf.length)) { /*6298*/
						$k[$j++] = $1.lnumeric; /*6295*/
						$k[$j++] = $1.alphanumeric; /*6295*/
						if ($1.encode() == $b) break; /*6295*/
						$1.mode = "numeric"; /*6296*/
						break; /*6297*/
					} /*6297*/
					$k[$j++] = $get($1.gpf, $1.i); /*6299*/
					$k[$j++] = $1.alphanumeric; /*6299*/
					if ($1.encode() == $b) break; /*6299*/
					$1.i = $1.i + 1; /*6300*/
					break; /*6301*/
				} /*6301*/
				if ($eq($1.mode, "iso646")) { /*6324*/
					if ($get($1.gpf, $1.i) == $1.fnc1) { /*6310*/
						$k[$j++] = $1.fnc1; /*6306*/
						$k[$j++] = $1.iso646; /*6306*/
						if ($1.encode() == $b) break; /*6306*/
						$1.mode = "numeric"; /*6307*/
						$1.i = $1.i + 1; /*6308*/
						break; /*6309*/
					} /*6309*/
					if (($get($1.numericruns, $1.i) >= 4) && ($get($1.nextiso646only, $1.i) >= 10)) { /*6315*/
						$k[$j++] = $1.lnumeric; /*6312*/
						$k[$j++] = $1.iso646; /*6312*/
						if ($1.encode() == $b) break; /*6312*/
						$1.mode = "numeric"; /*6313*/
						break; /*6314*/
					} /*6314*/
					if (($get($1.alphanumericruns, $1.i) >= 5) && ($get($1.nextiso646only, $1.i) >= 10)) { /*6320*/
						$k[$j++] = $1.lalphanumeric; /*6317*/
						$k[$j++] = $1.iso646; /*6317*/
						if ($1.encode() == $b) break; /*6317*/
						$1.mode = "alphanumeric"; /*6318*/
						break; /*6319*/
					} /*6319*/
					$k[$j++] = $get($1.gpf, $1.i); /*6321*/
					$k[$j++] = $1.iso646; /*6321*/
					if ($1.encode() == $b) break; /*6321*/
					$1.i = $1.i + 1; /*6322*/
					break; /*6323*/
				} /*6323*/
			} /*6323*/
		} /*6323*/
		$1.gpf = $geti($1.gpfenc, 0, $1.j); /*6328*/
		var _BY = ((((1 + 12) + $1.method.length) + $1.vlf.length) + $1.cdf.length) + $1.gpf.length; /*6332*/
		$k[$j++] = _BY; /*6332*/
		$k[$j++] = _BY; /*6332*/
		if ($1.rembits() == $b) return $b; /*6332*/
		var _BZ = $k[--$j]; /*6332*/
		$1.pad = $a(_BZ); /*6332*/
		$k[$j++] = _BZ; /*6339*/
		if ($1.vlf.length != 0) { /*6338*/
			var _Bc = $k[--$j]; /*6334*/
			var _Be = ~~(($k[--$j] + _Bc) / 12); /*6335*/
			$put($1.vlf, 0, _Be % 2); /*6335*/
			var _Bg = (_Be <= 14) ? 0 : 1; /*6336*/
			$put($1.vlf, 1, _Bg); /*6336*/
		} else { /*6338*/
			$j -= 2; /*6338*/
		} /*6338*/
		if ($1.pad.length > 0) { /*6348*/
			for (var _Bl = 0, _Bk = $1.pad.length - 1; _Bl <= _Bk; _Bl += 5) { /*6344*/
				$1.i = _Bl; /*6342*/
				var _Bm = $1.pad; /*6343*/
				var _Bn = $1.i; /*6343*/
				var _Bo = $a([0, 0, 1, 0, 0]); /*6343*/
				var _Bp = $1.pad; /*6343*/
				var _Bq = $1.i; /*6343*/
				var _Br = 5; /*6343*/
				var _Bs = _Bp.length - _Bq; /*6343*/
				if ((_Bp.length - _Bq) > 5) { /*6343*/
					var _ = _Br; /*6343*/
					_Br = _Bs; /*6343*/
					_Bs = _; /*6343*/
				} /*6343*/
				$puti(_Bm, _Bn, $geti(_Bo, 0, _Bs)); /*6343*/
			} /*6343*/
			if ($eq($1.mode, "numeric")) { /*6347*/
				$k[$j++] = "pad"; /*6346*/
				$k[$j++] = Infinity; /*6346*/
				$k[$j++] = 0; /*6346*/
				$k[$j++] = 0; /*6346*/
				$k[$j++] = 0; /*6346*/
				$k[$j++] = 0; /*6346*/
				$aload($1.pad); /*6346*/
				var _By = $geti($a(), 0, $1.pad.length); /*6346*/
				$1[$k[--$j]] = _By; /*6346*/
			} /*6346*/
		} /*6346*/
		$k[$j++] = Infinity; /*6358*/
		var _C1 = $1.linkage ? 1 : 0; /*6352*/
		$k[$j++] = _C1; /*6353*/
		$forall($1.method, function() { /*6353*/
			var _C3 = $k[--$j]; /*6353*/
			$k[$j++] = _C3 - 48; /*6353*/
		}); /*6353*/
		$aload($1.vlf); /*6354*/
		$aload($1.cdf); /*6355*/
		$aload($1.gpf); /*6356*/
		$aload($1.pad); /*6357*/
		$1.binval = $a(); /*6358*/
		$1.datalen = ~~($1.binval.length / 12); /*6359*/
		$1.ncr = function() {
			var _CA = $k[--$j]; /*6362*/
			var _CB = $k[--$j]; /*6362*/
			var _CC = _CB - _CA; /*6362*/
			if (_CA < (_CB - _CA)) { /*6362*/
				var _ = _CC; /*6362*/
				_CC = _CA; /*6362*/
				_CA = _; /*6362*/
			} /*6362*/
			$k[$j++] = _CC; /*6369*/
			$k[$j++] = 1; /*6369*/
			$k[$j++] = 1; /*6369*/
			for (var _CE = _CB, _CD = _CA + 1; _CE >= _CD; _CE -= 1) { /*6369*/
				var _CF = $k[--$j]; /*6365*/
				var _CG = $k[--$j]; /*6366*/
				var _CH = $k[--$j]; /*6366*/
				$k[$j++] = _CH; /*6368*/
				$k[$j++] = _CG; /*6368*/
				$k[$j++] = _CF * _CE; /*6368*/
				if ($le(_CG, _CH)) { /*6368*/
					var _CI = $k[--$j]; /*6367*/
					var _CJ = $k[--$j]; /*6367*/
					$k[$j++] = _CJ + 1; /*6367*/
					$k[$j++] = ~~(_CI / _CJ); /*6367*/
				} /*6367*/
			} /*6367*/
			for (;;) { /*6373*/
				var _CK = $k[--$j]; /*6371*/
				var _CL = $k[--$j]; /*6371*/
				var _CM = $k[--$j]; /*6371*/
				$k[$j++] = _CM; /*6371*/
				$k[$j++] = _CL; /*6371*/
				$k[$j++] = _CK; /*6371*/
				if ($gt(_CL, _CM)) { /*6371*/
					break; /*6371*/
				} /*6371*/
				var _CN = $k[--$j]; /*6372*/
				var _CO = $k[--$j]; /*6372*/
				$k[$j++] = _CO + 1; /*6372*/
				$k[$j++] = ~~(_CN / _CO); /*6372*/
			} /*6372*/
			var _CP = $k[--$j]; /*6374*/
			var _CQ = $k[--$j]; /*6374*/
			var _CR = $k[--$j]; /*6374*/
			$k[$j++] = _CP; /*6374*/
		}; /*6375*/
		$1.getRSSwidths = function() {
			$1.oe = $k[--$j]; /*6378*/
			$1.el = $k[--$j]; /*6379*/
			$1.mw = $k[--$j]; /*6380*/
			$1.nm = $k[--$j]; /*6381*/
			$1.val = $k[--$j]; /*6382*/
			$1.out = $a($1.el); /*6383*/
			$1.mask = 0; /*6384*/
			for (var _Cb = 0, _Ca = $1.el - 2; _Cb <= _Ca; _Cb += 1) { /*6411*/
				$1.bar = _Cb; /*6386*/
				$1.ew = 1; /*6387*/
				var _Cd = $1.bar; /*6388*/
				$1.mask = $1.mask | ((_Cd < 0 ? 1 >>> -_Cd : 1 << _Cd)); /*6388*/
				for (;;) { /*6407*/
					$k[$j++] = "sval"; /*6389*/
					$k[$j++] = ($1.nm - $1.ew) - 1; /*6389*/
					$k[$j++] = ($1.el - $1.bar) - 2; /*6389*/
					if ($1.ncr() == $b) break; /*6389*/
					var _Ci = $k[--$j]; /*6389*/
					$1[$k[--$j]] = _Ci; /*6389*/
					if (($1.oe && ($1.mask == 0)) && (((($1.nm - $1.ew) - ($1.el * 2)) + ($1.bar * 2)) >= -2)) { /*6392*/
						$k[$j++] = "sval"; /*6391*/
						$k[$j++] = $1.sval; /*6391*/
						$k[$j++] = (($1.nm - $1.ew) - $1.el) + $1.bar; /*6391*/
						$k[$j++] = ($1.el - $1.bar) - 2; /*6391*/
						if ($1.ncr() == $b) break; /*6391*/
						var _Cx = $k[--$j]; /*6391*/
						var _Cy = $k[--$j]; /*6391*/
						$1[$k[--$j]] = _Cy - _Cx; /*6391*/
					} /*6391*/
					if (($1.el - $1.bar) > 2) { /*6401*/
						$1.lval = 0; /*6394*/
						for (var _D8 = ((($1.nm - $1.ew) - $1.el) + $1.bar) + 2, _D7 = $1.mw + 1; _D8 >= _D7; _D8 -= 1) { /*6398*/
							$k[$j++] = (($1.nm - _D8) - $1.ew) - 1; /*6396*/
							$k[$j++] = ($1.el - $1.bar) - 3; /*6396*/
							if ($1.ncr() == $b) break; /*6396*/
							$1.lval = $k[--$j] + $1.lval; /*6397*/
						} /*6397*/
						$1.sval = $1.sval - ($1.lval * (($1.el - $1.bar) - 1)); /*6399*/
					} else { /*6401*/
						if (($1.nm - $1.ew) > $1.mw) { /*6401*/
							$1.sval = $1.sval - 1; /*6401*/
						} /*6401*/
					} /*6401*/
					$1.val = $1.val - $1.sval; /*6403*/
					if ($1.val < 0) { /*6404*/
						break; /*6404*/
					} /*6404*/
					$1.ew = $1.ew + 1; /*6405*/
					var _DS = $1.bar; /*6406*/
					$1.mask = $1.mask & (~((_DS < 0 ? 1 >>> -_DS : 1 << _DS))); /*6406*/
				} /*6406*/
				$1.val = $1.val + $1.sval; /*6408*/
				$1.nm = $1.nm - $1.ew; /*6409*/
				$put($1.out, $1.bar, $1.ew); /*6410*/
			} /*6410*/
			$put($1.out, $1.el - 1, $1.nm); /*6412*/
			$k[$j++] = $1.out; /*6413*/
		}; /*6414*/
		$1.tab174 = $a([347, 0, 12, 5, 7, 2, 87, 4, 1387, 348, 10, 7, 5, 4, 52, 20, 2947, 1388, 8, 9, 4, 5, 30, 52, 3987, 2948, 6, 11, 3, 6, 10, 104, 4191, 3988, 4, 13, 1, 8, 1, 204]); /*6422*/
		$1.dxw = $a($1.datalen); /*6424*/
		for (var _Dj = 0, _Di = $1.datalen - 1; _Dj <= _Di; _Dj += 1) { /*6465*/
			$1.x = _Dj; /*6428*/
			$1.d = $geti($1.binval, $1.x * 12, 12); /*6430*/
			$k[$j++] = "d"; /*6431*/
			$k[$j++] = 0; /*6431*/
			for (var _Dn = 0; _Dn <= 11; _Dn += 1) { /*6431*/
				$1.j = _Dn; /*6431*/
				var _Ds = $k[--$j]; /*6431*/
				$k[$j++] = _Ds + ((~~Math.pow(2, 11 - $1.j)) * $get($1.d, $1.j)); /*6431*/
			} /*6431*/
			var _Dt = $k[--$j]; /*6431*/
			$1[$k[--$j]] = _Dt; /*6431*/
			$1.j = 0; /*6433*/
			for (;;) { /*6443*/
				if ($le($1.d, $get($1.tab174, $1.j))) { /*6441*/
					$forall($geti($1.tab174, $1.j + 1, 7)); /*6435*/
					$1.dte = $k[--$j]; /*6436*/
					$1.dto = $k[--$j]; /*6436*/
					$1.dmwe = $k[--$j]; /*6437*/
					$1.dmwo = $k[--$j]; /*6437*/
					$1.dele = $k[--$j]; /*6438*/
					$1.delo = $k[--$j]; /*6438*/
					$1.dgs = $k[--$j]; /*6439*/
					break; /*6440*/
				} /*6440*/
				$1.j = $1.j + 8; /*6442*/
			} /*6442*/
			$k[$j++] = "dwo"; /*6445*/
			$k[$j++] = ~~(($1.d - $1.dgs) / $1.dte); /*6445*/
			$k[$j++] = $1.delo; /*6445*/
			$k[$j++] = $1.dmwo; /*6445*/
			$k[$j++] = 4; /*6445*/
			$k[$j++] = true; /*6445*/
			if ($1.getRSSwidths() == $b) break; /*6445*/
			var _EF = $k[--$j]; /*6445*/
			$1[$k[--$j]] = _EF; /*6445*/
			$k[$j++] = "dwe"; /*6446*/
			$k[$j++] = ($1.d - $1.dgs) % $1.dte; /*6446*/
			$k[$j++] = $1.dele; /*6446*/
			$k[$j++] = $1.dmwe; /*6446*/
			$k[$j++] = 4; /*6446*/
			$k[$j++] = false; /*6446*/
			if ($1.getRSSwidths() == $b) break; /*6446*/
			var _EM = $k[--$j]; /*6446*/
			$1[$k[--$j]] = _EM; /*6446*/
			$1.dw = $a(8); /*6448*/
			if (($1.x % 2) == 0) { /*6459*/
				for (var _EQ = 0; _EQ <= 3; _EQ += 1) { /*6454*/
					$1.j = _EQ; /*6451*/
					$put($1.dw, 7 - ($1.j * 2), $get($1.dwo, $1.j)); /*6452*/
					$put($1.dw, 6 - ($1.j * 2), $get($1.dwe, $1.j)); /*6453*/
				} /*6453*/
			} else { /*6459*/
				for (var _Eb = 0; _Eb <= 3; _Eb += 1) { /*6460*/
					$1.j = _Eb; /*6457*/
					$put($1.dw, $1.j * 2, $get($1.dwo, $1.j)); /*6458*/
					$put($1.dw, ($1.j * 2) + 1, $get($1.dwe, $1.j)); /*6459*/
				} /*6459*/
			} /*6459*/
			$put($1.dxw, $1.x, $1.dw); /*6463*/
		} /*6463*/
		$1.finderwidths = $a([1, 8, 4, 1, 1, 1, 1, 4, 8, 1, 3, 6, 4, 1, 1, 1, 1, 4, 6, 3, 3, 4, 6, 1, 1, 1, 1, 6, 4, 3, 3, 2, 8, 1, 1, 1, 1, 8, 2, 3, 2, 6, 5, 1, 1, 1, 1, 5, 6, 2, 2, 2, 9, 1, 1, 1, 1, 9, 2, 2]); /*6474*/
		$1.finderseq = $a([$a([0, 1]), $a([0, 3, 2]), $a([0, 5, 2, 7]), $a([0, 9, 2, 7, 4]), $a([0, 9, 2, 7, 6, 11]), $a([0, 9, 2, 7, 8, 11, 10]), $a([0, 1, 2, 3, 4, 5, 6, 7]), $a([0, 1, 2, 3, 4, 5, 6, 9, 8]), $a([0, 1, 2, 3, 4, 5, 6, 9, 10, 11]), $a([0, 1, 2, 3, 4, 7, 6, 9, 8, 11, 10])]); /*6487*/
		$1.seq = $get($1.finderseq, ~~(($1.datalen - 2) / 2)); /*6489*/
		$1.fxw = $a($1.seq.length); /*6490*/
		for (var _F8 = 0, _F7 = $1.seq.length - 1; _F8 <= _F7; _F8 += 1) { /*6494*/
			$1.x = _F8; /*6492*/
			$put($1.fxw, $1.x, $geti($1.finderwidths, $get($1.seq, $1.x) * 5, 5)); /*6493*/
		} /*6493*/
		$1.checkweights = $a([-1, -1, -1, -1, -1, -1, -1, -1, 77, 96, 32, 81, 27, 9, 3, 1, 20, 60, 180, 118, 143, 7, 21, 63, 205, 209, 140, 117, 39, 13, 145, 189, 193, 157, 49, 147, 19, 57, 171, 91, 132, 44, 85, 169, 197, 136, 186, 62, 185, 133, 188, 142, 4, 12, 36, 108, 50, 87, 29, 80, 97, 173, 128, 113, 150, 28, 84, 41, 123, 158, 52, 156, 166, 196, 206, 139, 187, 203, 138, 46, 76, 17, 51, 153, 37, 111, 122, 155, 146, 119, 110, 107, 106, 176, 129, 43, 16, 48, 144, 10, 30, 90, 59, 177, 164, 125, 112, 178, 200, 137, 116, 109, 70, 210, 208, 202, 184, 130, 179, 115, 190, 204, 68, 93, 31, 151, 191, 134, 148, 22, 66, 198, 172, 94, 71, 2, 40, 154, 192, 64, 162, 54, 18, 6, 120, 149, 25, 75, 14, 42, 126, 167, 175, 199, 207, 69, 23, 78, 26, 79, 103, 98, 83, 38, 114, 131, 182, 124, 159, 53, 88, 170, 127, 183, 61, 161, 55, 165, 73, 8, 24, 72, 5, 15, 89, 100, 174, 58, 160, 194, 135, 45]); /*6521*/
		$k[$j++] = "checkweightseq"; /*6525*/
		$k[$j++] = Infinity; /*6525*/
		$forall($1.seq, function() { /*6524*/
			$aload($geti($1.checkweights, $k[--$j] * 16, 16)); /*6524*/
		}); /*6524*/
		var _FL = $a(); /*6525*/
		$1[$k[--$j]] = $geti(_FL, 8, _FL.length - 8); /*6525*/
		$k[$j++] = Infinity; /*6529*/
		var _FO = $1.dxw; /*6528*/
		for (var _FP = 0, _FQ = _FO.length; _FP < _FQ; _FP++) { /*6528*/
			$forall($get(_FO, _FP)); /*6528*/
		} /*6528*/
		$1.widths = $a(); /*6529*/
		$1.checksum = 0; /*6531*/
		for (var _FV = 0, _FU = $1.widths.length - 1; _FV <= _FU; _FV += 1) { /*6535*/
			$1.i = _FV; /*6533*/
			$1.checksum = $1.checksum + ($get($1.widths, $1.i) * $get($1.checkweightseq, $1.i)); /*6534*/
		} /*6534*/
		$1.checksum = ($1.checksum % 211) + (($1.datalen - 3) * 211); /*6536*/
		$1.i = 0; /*6538*/
		for (;;) { /*6548*/
			if ($1.checksum <= $get($1.tab174, $1.i)) { /*6546*/
				$forall($geti($1.tab174, $1.i + 1, 7)); /*6540*/
				$1.cte = $k[--$j]; /*6541*/
				$1.cto = $k[--$j]; /*6541*/
				$1.cmwe = $k[--$j]; /*6542*/
				$1.cmwo = $k[--$j]; /*6542*/
				$1.cele = $k[--$j]; /*6543*/
				$1.celo = $k[--$j]; /*6543*/
				$1.cgs = $k[--$j]; /*6544*/
				break; /*6545*/
			} /*6545*/
			$1.i = $1.i + 8; /*6547*/
		} /*6547*/
		$k[$j++] = "cwo"; /*6550*/
		$k[$j++] = ~~(($1.checksum - $1.cgs) / $1.cte); /*6550*/
		$k[$j++] = $1.celo; /*6550*/
		$k[$j++] = $1.cmwo; /*6550*/
		$k[$j++] = 4; /*6550*/
		$k[$j++] = true; /*6550*/
		if ($1.getRSSwidths() == $b) return $b; /*6550*/
		var _Fz = $k[--$j]; /*6550*/
		$1[$k[--$j]] = _Fz; /*6550*/
		$k[$j++] = "cwe"; /*6551*/
		$k[$j++] = ($1.checksum - $1.cgs) % $1.cte; /*6551*/
		$k[$j++] = $1.cele; /*6551*/
		$k[$j++] = $1.cmwe; /*6551*/
		$k[$j++] = 4; /*6551*/
		$k[$j++] = false; /*6551*/
		if ($1.getRSSwidths() == $b) return $b; /*6551*/
		var _G6 = $k[--$j]; /*6551*/
		$1[$k[--$j]] = _G6; /*6551*/
		$1.cw = $a(8); /*6553*/
		for (var _G9 = 0; _G9 <= 3; _G9 += 1) { /*6558*/
			$1.i = _G9; /*6555*/
			$put($1.cw, $1.i * 2, $get($1.cwo, $1.i)); /*6556*/
			$put($1.cw, ($1.i * 2) + 1, $get($1.cwe, $1.i)); /*6557*/
		} /*6557*/
		var _GK = $a(22); /*6560*/
		$put(_GK, 0, $1.cw); /*6561*/
		$puti(_GK, 1, $1.dxw); /*6561*/
		$1.dxw = $geti(_GK, 0, $1.datalen + 1); /*6562*/
		$1.datalen = $1.dxw.length; /*6563*/
		$1.rows = $a(~~Math.ceil($1.datalen / $1.segments)); /*6566*/
		$1.numrows = $1.rows.length; /*6567*/
		for (var _GW = 0, _GV = $1.numrows - 1; _GW <= _GV; _GW += 1) { /*6582*/
			$1.r = _GW; /*6569*/
			$k[$j++] = Infinity; /*6570*/
			if ((($1.segments % 4) != 0) && (($1.r % 2) == 1)) { /*6571*/
				$k[$j++] = 0; /*6571*/
			} /*6571*/
			$k[$j++] = 1; /*6579*/
			$k[$j++] = 1; /*6579*/
			for (var _Gb = 0, _Ga = $1.segments - 1; _Gb <= _Ga; _Gb += 1) { /*6579*/
				$1.pos = _Gb + ($1.r * $1.segments); /*6574*/
				if ($1.pos < $1.datalen) { /*6578*/
					$forall($get($1.dxw, $1.pos)); /*6576*/
					if (($1.pos % 2) == 0) { /*6577*/
						$forall($get($1.fxw, ~~($1.pos / 2))); /*6577*/
					} /*6577*/
				} /*6577*/
			} /*6577*/
			var _Gn = $counttomark() + 2; /*6581*/
			$k[$j++] = 1; /*6581*/
			$k[$j++] = 1; /*6581*/
			$astore($a(_Gn)); /*6581*/
			$put($1.rows, $1.r, $k[--$j]); /*6581*/
			$j--; /*6581*/
		} /*6581*/
		if ($ne($1.format, "expandedstacked")) { /*6706*/
			var _Gu = $get($1.rows, 0); /*6587*/
			$1.sbs = $geti(_Gu, 1, _Gu.length - 1); /*6587*/
			$k[$j++] = Infinity; /*6597*/
			$k[$j++] = 1; /*6595*/
			for (var _Gy = 0, _Gx = $1.datalen - 1; _Gy <= _Gx; _Gy += 1) { /*6595*/
				$1.i = _Gy; /*6592*/
				$forall($get($1.dxw, $1.i)); /*6593*/
				if (($1.i % 2) == 0) { /*6594*/
					$forall($get($1.fxw, ~~($1.i / 2))); /*6594*/
				} /*6594*/
			} /*6594*/
			$k[$j++] = 1; /*6596*/
			$k[$j++] = 1; /*6596*/
			$1.sbs = $a(); /*6597*/
			$k[$j++] = Infinity; /*6604*/
			$k[$j++] = "ren"; /*6603*/
			$k[$j++] = $0.renlinear; /*6603*/
			$k[$j++] = "sbs"; /*6603*/
			$k[$j++] = $1.sbs; /*6603*/
			$k[$j++] = "bhs"; /*6603*/
			$k[$j++] = Infinity; /*6603*/
			for (var _H9 = 0, _HA = ~~(($1.sbs.length + 1) / 2); _H9 < _HA; _H9++) { /*6602*/
				$k[$j++] = $1.height; /*6602*/
			} /*6602*/
			var _HC = $a(); /*6603*/
			$k[$j++] = _HC; /*6604*/
			$k[$j++] = "bbs"; /*6604*/
			$k[$j++] = Infinity; /*6604*/
			for (var _HE = 0, _HF = ~~(($1.sbs.length + 1) / 2); _HE < _HF; _HE++) { /*6603*/
				$k[$j++] = 0; /*6603*/
			} /*6603*/
			var _HG = $a(); /*6604*/
			$k[$j++] = _HG; /*6604*/
			$k[$j++] = "opt"; /*6604*/
			$k[$j++] = $1.options; /*6604*/
			var _HI = $d(); /*6604*/
			$k[$j++] = _HI; /*6607*/
			if (!$1.dontdraw) { /*6607*/
				$0.renlinear(); /*6607*/
			} /*6607*/
		} else { /*6706*/
			$1.seps = $a($1.numrows); /*6611*/
			for (var _HO = 0, _HN = $1.numrows - 1; _HO <= _HN; _HO += 1) { /*6667*/
				$1.r = _HO; /*6614*/
				$1.row = $get($1.rows, $1.r); /*6615*/
				$k[$j++] = Infinity; /*6618*/
				for (var _HU = 0, _HT = $1.row.length - 1; _HU <= _HT; _HU += 2) { /*6623*/
					$1.i = _HU; /*6620*/
					for (var _HY = 0, _HZ = $get($1.row, $1.i); _HY < _HZ; _HY++) { /*6621*/
						$k[$j++] = 0; /*6621*/
					} /*6621*/
					if ($1.i < ($1.row.length - 1)) { /*6622*/
						for (var _Hf = 0, _Hg = $get($1.row, $1.i + 1); _Hf < _Hg; _Hf++) { /*6622*/
							$k[$j++] = 1; /*6622*/
						} /*6622*/
					} /*6622*/
				} /*6622*/
				$astore($a($counttomark())); /*6624*/
				$1.row = $k[--$j]; /*6624*/
				$j--; /*6624*/
				$k[$j++] = Infinity; /*6627*/
				$forall($1.row, function() { /*6627*/
					var _Hl = $k[--$j]; /*6627*/
					$k[$j++] = 1 - _Hl; /*6627*/
				}); /*6627*/
				$1.sep = $a(); /*6627*/
				$puti($1.sep, 0, $a([0, 0, 0, 0])); /*6628*/
				$puti($1.sep, $1.row.length - 4, $a([0, 0, 0, 0])); /*6629*/
				$k[$j++] = Infinity; /*6633*/
				for (var _Hu = 19, _Ht = $1.row.length - 13; _Hu <= _Ht; _Hu += 98) { /*6631*/
					$k[$j++] = _Hu; /*6631*/
				} /*6631*/
				for (var _Hx = 68, _Hw = $1.row.length - 13; _Hx <= _Hw; _Hx += 98) { /*6632*/
					$k[$j++] = _Hx; /*6632*/
				} /*6632*/
				$1.finderpos = $a(); /*6633*/
				var _Hz = $1.finderpos; /*6634*/
				for (var _I0 = 0, _I1 = _Hz.length; _I0 < _I1; _I0++) { /*6648*/
					var _I2 = $get(_Hz, _I0); /*6648*/
					for (var _I4 = _I2, _I3 = _I2 + 14; _I4 <= _I3; _I4 += 1) { /*6647*/
						$1.i = _I4; /*6636*/
						if ($get($1.row, $1.i) == 0) { /*6644*/
							if ($get($1.row, $1.i - 1) == 1) { /*6641*/
								$k[$j++] = 1; /*6639*/
							} else { /*6641*/
								var _IE = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*6641*/
								$k[$j++] = _IE; /*6641*/
							} /*6641*/
						} else { /*6644*/
							$k[$j++] = 0; /*6644*/
						} /*6644*/
						$put($1.sep, $1.i, $k[--$j]); /*6646*/
					} /*6646*/
				} /*6646*/
				if ((($1.segments % 4) == 0) && (($1.r % 2) == 1)) { /*6662*/
					if (($get($1.rows, $1.r).length != $get($1.rows, 0).length) && (($1.finderpos.length % 2) == 1)) { /*6660*/
						$k[$j++] = Infinity; /*6654*/
						$k[$j++] = 0; /*6654*/
						$aload($1.row); /*6654*/
						$1.row = $a(); /*6654*/
						$k[$j++] = Infinity; /*6655*/
						$k[$j++] = 0; /*6655*/
						$aload($1.sep); /*6655*/
						$1.sep = $a(); /*6655*/
					} else { /*6660*/
						for (var _IV = $1.row.length - 1; _IV >= 0; _IV -= 1) { /*6657*/
							$k[$j++] = $get($1.row, _IV); /*6657*/
						} /*6657*/
						$astore($1.row); /*6658*/
						$j--; /*6658*/
						for (var _Ia = $1.sep.length - 1; _Ia >= 0; _Ia -= 1) { /*6659*/
							$k[$j++] = $get($1.sep, _Ia); /*6659*/
						} /*6659*/
						$astore($1.sep); /*6660*/
						$j--; /*6660*/
					} /*6660*/
				} /*6660*/
				$put($1.rows, $1.r, $1.row); /*6664*/
				$put($1.seps, $1.r, $1.sep); /*6665*/
			} /*6665*/
			$1.pixx = $get($1.rows, 0).length; /*6670*/
			$k[$j++] = Infinity; /*6671*/
			for (var _In = 0, _Io = $1.pixx; _In < _Io; _In++) { /*6671*/
				$k[$j++] = 0; /*6671*/
			} /*6671*/
			var _Ip = $a(); /*6671*/
			$puti(_Ip, 0, $get($1.rows, $1.numrows - 1)); /*6671*/
			$put($1.rows, $1.numrows - 1, _Ip); /*6672*/
			$k[$j++] = Infinity; /*6673*/
			for (var _Iw = 0, _Ix = $1.pixx; _Iw < _Ix; _Iw++) { /*6673*/
				$k[$j++] = 0; /*6673*/
			} /*6673*/
			var _Iy = $a(); /*6673*/
			$puti(_Iy, 0, $get($1.seps, $1.numrows - 1)); /*6673*/
			$put($1.seps, $1.numrows - 1, _Iy); /*6674*/
			$k[$j++] = "sep"; /*6677*/
			$k[$j++] = Infinity; /*6677*/
			for (var _J5 = 0, _J6 = (~~($1.pixx / 2)) + 1; _J5 < _J6; _J5++) { /*6677*/
				$k[$j++] = 0; /*6677*/
				$k[$j++] = 1; /*6677*/
			} /*6677*/
			var _J9 = $geti($a(), 0, $1.pixx); /*6677*/
			$1[$k[--$j]] = _J9; /*6677*/
			$puti($1.sep, 0, $a([0, 0, 0, 0])); /*6678*/
			$puti($1.sep, $1.pixx - 4, $a([0, 0, 0, 0])); /*6679*/
			$k[$j++] = Infinity; /*6694*/
			for (var _JI = 0, _JH = $1.numrows - 1; _JI <= _JH; _JI += 1) { /*6693*/
				$1.r = _JI; /*6684*/
				if ($1.r != 0) { /*6687*/
					$aload($get($1.seps, $1.r)); /*6686*/
				} /*6686*/
				for (var _JO = 0, _JP = $1.barxmult; _JO < _JP; _JO++) { /*6688*/
					$aload($get($1.rows, $1.r)); /*6688*/
				} /*6688*/
				if ($1.r != ($1.numrows - 1)) { /*6692*/
					$aload($get($1.seps, $1.r)); /*6690*/
					$aload($1.sep); /*6691*/
				} /*6691*/
			} /*6691*/
			$1.pixs = $a(); /*6694*/
			var _Ji = {
				ren: $0.renmatrix,
				pixs: $1.pixs,
				pixx: $1.pixx,
				pixy: ~~($1.pixs.length / $1.pixx),
				height: (~~($1.pixs.length / $1.pixx)) / 72,
				width: $1.pixx / 72,
				opt: $1.options
			}; /*6703*/
			$k[$j++] = _Ji; /*6706*/
			if (!$1.dontdraw) { /*6706*/
				$0.renmatrix(); /*6706*/
			} /*6706*/
		} /*6706*/
	};
	$0.databarexpandedstacked = function() {
		var $1 = {}; /*6736*/
		$1.options = $k[--$j]; /*6738*/
		$1.barcode = $k[--$j]; /*6739*/
		$1.dontdraw = false; /*6741*/
		$forall($1.options, function() { /*6752*/
			var _3 = $k[--$j]; /*6752*/
			$1[$k[--$j]] = _3; /*6752*/
		}); /*6752*/
		$1.options.dontdraw = true; /*6755*/
		$1.options.format = "expandedstacked"; /*6756*/
		$k[$j++] = "args"; /*6758*/
		$k[$j++] = $1.barcode; /*6758*/
		$k[$j++] = $1.options; /*6758*/
		$0.databarexpanded(); /*6758*/
		var _9 = $k[--$j]; /*6758*/
		$1[$k[--$j]] = _9; /*6758*/
		$1.args.opt = $1.options; /*6760*/
		$k[$j++] = $1.args; /*6763*/
		if (!$1.dontdraw) { /*6763*/
			$0.renmatrix(); /*6763*/
		} /*6763*/
	};
	$0.gs1northamericancoupon = function() {
		var $1 = {}; /*6791*/
		$1.options = $k[--$j]; /*6793*/
		$1.barcode = $k[--$j]; /*6794*/
		$1.dontdraw = false; /*6796*/
		$1.includetext = false; /*6798*/
		$1.coupontextfont = "Helvetica"; /*6799*/
		$1.coupontextsize = 9; /*6800*/
		$1.coupontextxoffset = "unset"; /*6801*/
		$1.coupontextyoffset = "unset"; /*6802*/
		$forall($1.options, function() { /*6813*/
			var _3 = $k[--$j]; /*6813*/
			$1[$k[--$j]] = _3; /*6813*/
		}); /*6813*/
		$1.coupontextfont = "" + $1.coupontextfont; /*6815*/
		$1.coupontextsize = +$1.coupontextsize; /*6816*/
		if ($ne($1.coupontextxoffset, "unset")) { /*6817*/
			$1.coupontextxoffset = +$1.coupontextxoffset; /*6817*/
		} /*6817*/
		if ($ne($1.coupontextyoffset, "unset")) { /*6818*/
			$1.coupontextyoffset = +$1.coupontextyoffset; /*6818*/
		} /*6818*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*6822*/
			$1.out = $s($1.in.length); /*6823*/
			$1.j = 0; /*6824*/
			$k[$j++] = $1.in; /*6838*/
			for (;;) { /*6838*/
				$search($k[--$j], "^"); /*6827*/
				if ($k[--$j]) { /*6836*/
					var _H = $k[--$j]; /*6828*/
					$puti($1.out, $1.j, _H); /*6828*/
					$1.j = (_H.length + $1.j) + 1; /*6829*/
					$j--; /*6830*/
					var _L = $k[--$j]; /*6831*/
					$put($1.out, $1.j - 1, ~~$z($geti(_L, 0, 3))); /*6831*/
					$k[$j++] = $geti(_L, 3, _L.length - 3); /*6832*/
				} else { /*6836*/
					var _Q = $k[--$j]; /*6834*/
					$puti($1.out, $1.j, _Q); /*6834*/
					$1.j = _Q.length + $1.j; /*6835*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*6836*/
					break; /*6836*/
				} /*6836*/
			} /*6836*/
		}; /*6839*/
		$1.ais = $a([]); /*6842*/
		$1.vals = $a([]); /*6843*/
		var _Z = $1.barcode; /*6844*/
		$k[$j++] = $geti(_Z, 1, _Z.length - 1); /*6857*/
		for (;;) { /*6857*/
			var _b = $k[--$j]; /*6846*/
			$k[$j++] = _b; /*6846*/
			if ($eq(_b, "")) { /*6846*/
				break; /*6846*/
			} /*6846*/
			$search($k[--$j], ")"); /*6847*/
			$j--; /*6847*/
			var _d = $k[--$j]; /*6848*/
			var _e = $k[--$j]; /*6848*/
			var _f = $k[--$j]; /*6849*/
			$k[$j++] = _d; /*6849*/
			$search(_f, "("); /*6849*/
			if ($k[--$j]) { /*6852*/
				var _h = $k[--$j]; /*6850*/
				var _i = $k[--$j]; /*6850*/
				var _j = $k[--$j]; /*6850*/
				var _k = $k[--$j]; /*6850*/
				$k[$j++] = _j; /*6850*/
				$k[$j++] = _k; /*6850*/
				$k[$j++] = _h; /*6850*/
			} else { /*6852*/
				var _l = $k[--$j]; /*6852*/
				var _m = $k[--$j]; /*6852*/
				$k[$j++] = ""; /*6852*/
				$k[$j++] = _m; /*6852*/
				$k[$j++] = _l; /*6852*/
			} /*6852*/
			$k[$j++] = Infinity; /*6854*/
			$aload($1.ais); /*6854*/
			var _p = $k[$j - 1 - ($counttomark() + 2)]; /*6854*/
			$k[$j++] = _p; /*6854*/
			$1.ais = $a(); /*6854*/
			$k[$j++] = Infinity; /*6855*/
			$aload($1.vals); /*6855*/
			var _t = $k[$j - 1 - ($counttomark() + 1)]; /*6855*/
			$k[$j++] = _t; /*6855*/
			if ($1.expand() == $b) break; /*6855*/
			$1.vals = $a(); /*6855*/
			$j -= 2; /*6856*/
		} /*6856*/
		$j--; /*6858*/
		if ($1.ais.length != 1) { /*6863*/
			$k[$j++] = "bwipp.gs1northamericancouponBadAIStructure"; /*6862*/
			$k[$j++] = "A GS1 North American Coupon should consist of a single AI (8110)"; /*6862*/
			$0.raiseerror(); /*6862*/
		} /*6862*/
		if ($ne($get($1.ais, 0), "8110")) { /*6866*/
			$k[$j++] = "bwipp.gs1northamericancouponBadAIStructure"; /*6865*/
			$k[$j++] = "A GS1 North American Coupon should consist of a single AI (8110)"; /*6865*/
			$0.raiseerror(); /*6865*/
		} /*6865*/
		$1.val = $get($1.vals, 0); /*6869*/
		$1.vli = $get($1.val, 0) - 48; /*6870*/
		if (($1.vli < 0) || ($1.vli > 6)) { /*6873*/
			$k[$j++] = "bwipp.gs1northamericancouponBadVLI"; /*6872*/
			$k[$j++] = "The AI (8110) data should start with a Company Prefix length indicator in the range 0 to 6"; /*6872*/
			$0.raiseerror(); /*6872*/
		} /*6872*/
		$1.gcp = $geti($1.val, 1, $1.vli + 6); /*6874*/
		$1.cod = $geti($1.val, $1.vli + 7, 6); /*6875*/
		$1.coupontext = $s($1.gcp.length + 7); /*6876*/
		$puti($1.coupontext, 0, $1.gcp); /*6877*/
		$puti($1.coupontext, $1.gcp.length, "-"); /*6878*/
		$puti($1.coupontext, $1.gcp.length + 1, $1.cod); /*6879*/
		$1.options.dontdraw = true; /*6882*/
		$k[$j++] = "args"; /*6884*/
		$k[$j++] = $1.barcode; /*6884*/
		$k[$j++] = $1.options; /*6884*/
		$0.databarexpandedstacked(); /*6884*/
		var _1M = $k[--$j]; /*6884*/
		$1[$k[--$j]] = _1M; /*6884*/
		if ($1.includetext) { /*6903*/
			if ($1.coupontextxoffset == "unset") { /*6890*/
				$1.coupontextxoffset = 0; /*6889*/
			} /*6889*/
			if ($1.coupontextyoffset == "unset") { /*6893*/
				$1.coupontextyoffset = ($1.args.height * 72) + 3; /*6892*/
			} /*6892*/
			var _1U = $1.args.txt !== undefined; /*6894*/
			if (_1U) { /*6901*/
				$1.txt = $1.args.txt; /*6895*/
				$1.newtxt = $a($1.txt.length + 1); /*6896*/
				$puti($1.newtxt, 0, $1.txt); /*6897*/
				$put($1.newtxt, $1.newtxt.length - 1, $a([$1.coupontext, $1.coupontextxoffset, $1.coupontextyoffset, $1.coupontextfont, $1.coupontextsize])); /*6898*/
				$1.args.txt = $1.newtxt; /*6899*/
			} else { /*6901*/
				$1.args.txt = $a([$a([$1.coupontext, $1.coupontextxoffset, $1.coupontextyoffset, $1.coupontextfont, $1.coupontextsize])]); /*6901*/
			} /*6901*/
		} /*6901*/
		$1.args.opt = $1.options; /*6905*/
		$k[$j++] = $1.args; /*6908*/
		if (!$1.dontdraw) { /*6908*/
			$0.renmatrix(); /*6908*/
		} /*6908*/
	};
	$0.pharmacode = function() {
		var $1 = {}; /*6935*/
		$1.options = $k[--$j]; /*6937*/
		$1.barcode = $k[--$j]; /*6938*/
		$1.dontdraw = false; /*6940*/
		$1.height = (8 * 2.835) / 72; /*6941*/
		$1.nwidth = 0.5 * 2.835; /*6942*/
		$1.wwidth = 1.5 * 2.835; /*6943*/
		$1.swidth = 1 * 2.835; /*6944*/
		$forall($1.options, function() { /*6955*/
			var _3 = $k[--$j]; /*6955*/
			$1[$k[--$j]] = _3; /*6955*/
		}); /*6955*/
		$1.height = +$1.height; /*6957*/
		$1.nwidth = +$1.nwidth; /*6958*/
		$1.wwidth = +$1.wwidth; /*6959*/
		$1.swidth = +$1.swidth; /*6960*/
		if (($1.barcode.length < 1) || ($1.barcode.length > 6)) { /*6965*/
			$k[$j++] = "bwipp.pharmacodeBadLength"; /*6964*/
			$k[$j++] = "Pharmacode must be 1 to 6 digits"; /*6964*/
			$0.raiseerror(); /*6964*/
		} /*6964*/
		$forall($1.barcode, function() { /*6970*/
			var _C = $k[--$j]; /*6967*/
			if ((_C < 48) || (_C > 57)) { /*6969*/
				$k[$j++] = "bwipp.pharmacodeBadCharacter"; /*6968*/
				$k[$j++] = "Pharmacode must contain only digits"; /*6968*/
				$0.raiseerror(); /*6968*/
			} /*6968*/
		}); /*6968*/
		var _E = ~~$z($1.barcode); /*6971*/
		if ((_E < 3) || (_E > 131070)) { /*6973*/
			$k[$j++] = "bwipp.pharmacodeBadValue"; /*6972*/
			$k[$j++] = "Pharmacode value must be between 3 and 131070"; /*6972*/
			$0.raiseerror(); /*6972*/
		} /*6972*/
		$1.txt = $a($1.barcode.length); /*6976*/
		for (var _J = 0, _I = $1.barcode.length - 1; _J <= _I; _J += 1) { /*6980*/
			$1.i = _J; /*6978*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*6979*/
		} /*6979*/
		$1.barcode = $cvrs($s(17), (~~$z($1.barcode)) + 1, 2); /*6983*/
		$1.barcode = $geti($1.barcode, 1, $1.barcode.length - 1); /*6984*/
		$1.barlen = $1.barcode.length; /*6986*/
		$1.sbs = $a($1.barlen * 2); /*6987*/
		for (var _b = 0, _a = $1.barlen - 1; _b <= _a; _b += 1) { /*6998*/
			$1.i = _b; /*6990*/
			$1.enc = $geti($1.barcode, $1.i, 1); /*6991*/
			if ($eq($1.enc, "0")) { /*6995*/
				$put($1.sbs, $1.i * 2, $1.nwidth); /*6993*/
			} else { /*6995*/
				$put($1.sbs, $1.i * 2, $1.wwidth); /*6995*/
			} /*6995*/
			$put($1.sbs, ($1.i * 2) + 1, $1.swidth); /*6997*/
		} /*6997*/
		$k[$j++] = Infinity; /*7008*/
		$k[$j++] = "ren"; /*7005*/
		$k[$j++] = $0.renlinear; /*7005*/
		$k[$j++] = "sbs"; /*7005*/
		$k[$j++] = $1.sbs; /*7005*/
		$k[$j++] = "bhs"; /*7005*/
		$k[$j++] = Infinity; /*7005*/
		for (var _r = 0, _s = ~~(($1.sbs.length + 1) / 2); _r < _s; _r++) { /*7004*/
			$k[$j++] = $1.height; /*7004*/
		} /*7004*/
		var _u = $a(); /*7005*/
		$k[$j++] = _u; /*7006*/
		$k[$j++] = "bbs"; /*7006*/
		$k[$j++] = Infinity; /*7006*/
		for (var _w = 0, _x = ~~(($1.sbs.length + 1) / 2); _w < _x; _w++) { /*7005*/
			$k[$j++] = 0; /*7005*/
		} /*7005*/
		var _y = $a(); /*7006*/
		$k[$j++] = _y; /*7008*/
		$k[$j++] = "txt"; /*7008*/
		$k[$j++] = $1.txt; /*7008*/
		$k[$j++] = "textxalign"; /*7008*/
		$k[$j++] = "center"; /*7008*/
		$k[$j++] = "opt"; /*7008*/
		$k[$j++] = $1.options; /*7008*/
		var _11 = $d(); /*7008*/
		$k[$j++] = _11; /*7011*/
		if (!$1.dontdraw) { /*7011*/
			$0.renlinear(); /*7011*/
		} /*7011*/
	};
	$0.pharmacode2 = function() {
		var $1 = {}; /*7038*/
		$1.options = $k[--$j]; /*7040*/
		$1.barcode = $k[--$j]; /*7041*/
		$1.dontdraw = false; /*7043*/
		$1.includetext = false; /*7044*/
		$1.height = 4; /*7045*/
		$forall($1.options, function() { /*7056*/
			var _3 = $k[--$j]; /*7056*/
			$1[$k[--$j]] = _3; /*7056*/
		}); /*7056*/
		$1.height = +$1.height; /*7058*/
		if (($1.barcode.length < 1) || ($1.barcode.length > 8)) { /*7063*/
			$k[$j++] = "bwipp.pharmacode2BadLength"; /*7062*/
			$k[$j++] = "Two-track Pharmacode must be 1 to 6 digits"; /*7062*/
			$0.raiseerror(); /*7062*/
		} /*7062*/
		$forall($1.barcode, function() { /*7068*/
			var _9 = $k[--$j]; /*7065*/
			if ((_9 < 48) || (_9 > 57)) { /*7067*/
				$k[$j++] = "bwipp.pharmacode2badCharacter"; /*7066*/
				$k[$j++] = "Two-track Pharmacode must contain only digits"; /*7066*/
				$0.raiseerror(); /*7066*/
			} /*7066*/
		}); /*7066*/
		var _B = ~~$z($1.barcode); /*7069*/
		if ((_B < 4) || (_B > 64570080)) { /*7071*/
			$k[$j++] = "bwipp.pharmacode2badValue"; /*7070*/
			$k[$j++] = "Two-track Pharmacode value must be between 4 and 64570080"; /*7070*/
			$0.raiseerror(); /*7070*/
		} /*7070*/
		$1.txt = $a($1.barcode.length); /*7074*/
		for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*7078*/
			$1.i = _G; /*7076*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*7077*/
		} /*7077*/
		$1.encstr = $s(16); /*7080*/
		$1.bhs = $a(16); /*7081*/
		$1.bbs = $a(16); /*7082*/
		$1.sbs = $a(32); /*7083*/
		$1.bar = (1 / 25.4) * $1.height; /*7084*/
		$1.spc = (1 / 25.4) * 72; /*7085*/
		$1.i = 15; /*7088*/
		$1.val = ~~$z($1.barcode); /*7089*/
		for (;;) { /*7096*/
			if ($1.val == 0) { /*7091*/
				break; /*7091*/
			} /*7091*/
			var _V = $1.val % 3; /*7092*/
			$1.val = ~~(($1.val - $get($a([3, 1, 2]), _V)) / 3); /*7093*/
			$put($1.encstr, $1.i, $get($a([2, 0, 1]), _V)); /*7094*/
			$1.i = $1.i - 1; /*7095*/
		} /*7095*/
		$1.encstr = $geti($1.encstr, $1.i + 1, 15 - $1.i); /*7097*/
		for (var _k = 0, _j = $1.encstr.length - 1; _k <= _j; _k += 1) { /*7105*/
			$1.i = _k; /*7101*/
			var _n = $get($1.encstr, $1.i); /*7102*/
			$put($1.bhs, $1.i, $1.bar * $get($a([1, 1, 2]), _n)); /*7103*/
			$put($1.bbs, $1.i, $get($a([0, $1.bar, 0]), _n)); /*7104*/
		} /*7104*/
		$k[$j++] = Infinity; /*7116*/
		$k[$j++] = "ren"; /*7113*/
		$k[$j++] = $0.renlinear; /*7113*/
		$k[$j++] = "bhs"; /*7113*/
		$k[$j++] = $1.bhs; /*7113*/
		$k[$j++] = "bbs"; /*7113*/
		$k[$j++] = $1.bbs; /*7113*/
		$k[$j++] = "sbs"; /*7113*/
		$k[$j++] = Infinity; /*7113*/
		for (var _11 = 0, _12 = $1.encstr.length * 2; _11 < _12; _11++) { /*7112*/
			$k[$j++] = $1.spc; /*7112*/
		} /*7112*/
		var _14 = $a(); /*7113*/
		$k[$j++] = _14; /*7116*/
		$k[$j++] = "txt"; /*7116*/
		$k[$j++] = $1.txt; /*7116*/
		$k[$j++] = "textxalign"; /*7116*/
		$k[$j++] = "center"; /*7116*/
		$k[$j++] = "textyoffset"; /*7116*/
		$k[$j++] = 4; /*7116*/
		$k[$j++] = "opt"; /*7116*/
		$k[$j++] = $1.options; /*7116*/
		var _17 = $d(); /*7116*/
		$k[$j++] = _17; /*7119*/
		if (!$1.dontdraw) { /*7119*/
			$0.renlinear(); /*7119*/
		} /*7119*/
	};
	$0.code2of5 = function() {
		var $1 = {}; /*7146*/
		$1.options = $k[--$j]; /*7148*/
		$1.barcode = $k[--$j]; /*7149*/
		$1.dontdraw = false; /*7151*/
		$1.includecheck = false; /*7152*/
		$1.validatecheck = false; /*7153*/
		$1.includetext = false; /*7154*/
		$1.includecheckintext = false; /*7155*/
		$1.textfont = "Courier"; /*7156*/
		$1.textsize = 10; /*7157*/
		$1.textyoffset = -8.5; /*7158*/
		$1.height = 1; /*7159*/
		$1.version = "industrial"; /*7160*/
		$forall($1.options, function() { /*7171*/
			var _3 = $k[--$j]; /*7171*/
			$1[$k[--$j]] = _3; /*7171*/
		}); /*7171*/
		$1.textfont = "" + $1.textfont; /*7173*/
		$1.textsize = +$1.textsize; /*7174*/
		$1.textyoffset = +$1.textyoffset; /*7175*/
		$1.height = +$1.height; /*7176*/
		$forall($1.barcode, function() { /*7183*/
			var _A = $k[--$j]; /*7180*/
			if ((_A < 48) || (_A > 57)) { /*7182*/
				$k[$j++] = "bwipp.code2of5badCharacter"; /*7181*/
				$k[$j++] = "Code 25 must contain only digits"; /*7181*/
				$0.raiseerror(); /*7181*/
			} /*7181*/
		}); /*7181*/
		$k[$j++] = "barlen"; /*7185*/
		$k[$j++] = $1.barcode.length; /*7185*/
		if ($1.validatecheck) { /*7185*/
			var _D = $k[--$j]; /*7185*/
			$k[$j++] = _D - 1; /*7185*/
		} /*7185*/
		var _E = $k[--$j]; /*7185*/
		$1[$k[--$j]] = _E; /*7185*/
		$1.checksum = 0; /*7187*/
		for (var _I = 0, _H = $1.barlen - 1; _I <= _H; _I += 1) { /*7191*/
			$1.i = _I; /*7189*/
			$k[$j++] = "checksum"; /*7190*/
			$k[$j++] = $1.checksum; /*7190*/
			$k[$j++] = $get($1.barcode, $1.i) - 48; /*7190*/
			if ((($1.barlen - $1.i) % 2) != 0) { /*7190*/
				var _P = $k[--$j]; /*7190*/
				$k[$j++] = _P * 3; /*7190*/
			} /*7190*/
			var _Q = $k[--$j]; /*7190*/
			var _R = $k[--$j]; /*7190*/
			$1[$k[--$j]] = _R + _Q; /*7190*/
		} /*7190*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*7192*/
		if ($1.validatecheck) { /*7199*/
			if ($get($1.barcode, $1.barlen) != ($1.checksum + 48)) { /*7196*/
				$k[$j++] = "bwipp.code2of5badCheckDigit"; /*7195*/
				$k[$j++] = "Incorrect Code 25 check digit provided"; /*7195*/
				$0.raiseerror(); /*7195*/
			} /*7195*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*7197*/
			$1.includecheck = true; /*7198*/
		} /*7198*/
		var _h = {
			industrial: $a(["1111313111", "3111111131", "1131111131", "3131111111", "1111311131", "3111311111", "1131311111", "1111113131", "3111113111", "1131113111", "313111", "31113"]),
			iata: $a(["1111313111", "3111111131", "1131111131", "3131111111", "1111311131", "3111311111", "1131311111", "1111113131", "3111113111", "1131113111", "1111", "311"]),
			matrix: $a(["113311", "311131", "131131", "331111", "113131", "313111", "133111", "111331", "311311", "131311", "311111", "31111"]),
			coop: $a(["331111", "111331", "113131", "113311", "131131", "131311", "133111", "311131", "311311", "313111", "3131", "133"]),
			datalogic: $a(["113311", "311131", "131131", "331111", "113131", "313111", "133111", "111331", "311311", "131311", "1111", "311"])
		}; /*7223*/
		$1.versions = _h; /*7225*/
		var _k = $get($1.versions, $1.version) !== undefined; /*7226*/
		if (!_k) { /*7228*/
			$k[$j++] = "bwipp.code2of5badVersion"; /*7227*/
			$k[$j++] = "Unrecognised Code 25 version"; /*7227*/
			$0.raiseerror(); /*7227*/
		} /*7227*/
		$1.encs = $get($1.versions, $1.version); /*7229*/
		$1.cs = $get($1.encs, 0).length; /*7231*/
		$k[$j++] = "cw"; /*7232*/
		$k[$j++] = 0; /*7232*/
		$forall($get($1.encs, 0), function() { /*7232*/
			var _s = $k[--$j]; /*7232*/
			var _t = $k[--$j]; /*7232*/
			$k[$j++] = _t + (_s - 48); /*7232*/
		}); /*7232*/
		var _u = $k[--$j]; /*7232*/
		$1[$k[--$j]] = _u; /*7232*/
		var _w = $1.encs; /*7233*/
		$1.ss = $get(_w, _w.length - 2).length; /*7233*/
		var _y = $1.encs; /*7234*/
		$k[$j++] = "sw"; /*7234*/
		$k[$j++] = 0; /*7234*/
		$forall($get(_y, _y.length - 2), function() { /*7234*/
			var _10 = $k[--$j]; /*7234*/
			var _11 = $k[--$j]; /*7234*/
			$k[$j++] = _11 + (_10 - 48); /*7234*/
		}); /*7234*/
		var _12 = $k[--$j]; /*7234*/
		$1[$k[--$j]] = _12; /*7234*/
		$1.barchars = "0123456789"; /*7237*/
		$k[$j++] = "sbs"; /*7239*/
		$k[$j++] = $1.barlen; /*7239*/
		if ($1.includecheck) { /*7239*/
			var _16 = $k[--$j]; /*7239*/
			$k[$j++] = _16 + 1; /*7239*/
		} /*7239*/
		var _1B = $s((($k[--$j] * $1.cs) + $1.ss) + $1.ss); /*7239*/
		$1[$k[--$j]] = _1B; /*7239*/
		$k[$j++] = "txt"; /*7240*/
		$k[$j++] = $1.barlen; /*7240*/
		if ($1.includecheck) { /*7240*/
			var _1F = $k[--$j]; /*7240*/
			$k[$j++] = _1F + 1; /*7240*/
		} /*7240*/
		var _1H = $a($k[--$j]); /*7240*/
		$1[$k[--$j]] = _1H; /*7240*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*7243*/
		for (var _1O = 0, _1N = $1.barlen - 1; _1O <= _1N; _1O += 1) { /*7254*/
			$1.i = _1O; /*7245*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*7247*/
			$j--; /*7248*/
			$1.indx = $k[--$j].length; /*7249*/
			$j -= 2; /*7250*/
			$1.enc = $get($1.encs, $1.indx); /*7251*/
			$puti($1.sbs, ($1.i * $1.cs) + $1.ss, $1.enc); /*7252*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * $1.cw) + $1.sw, $1.textyoffset, $1.textfont, $1.textsize])); /*7253*/
		} /*7253*/
		if ($1.includecheck) { /*7266*/
			$puti($1.sbs, ($1.barlen * $1.cs) + $1.ss, $get($1.encs, $1.checksum)); /*7258*/
			$puti($1.sbs, (($1.barlen * $1.cs) + $1.cs) + $1.ss, $get($1.encs, 11)); /*7259*/
			if ($1.includecheckintext) { /*7263*/
				$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), ($1.barlen * $1.cw) + $1.sw, $1.textyoffset, $1.textfont, $1.textsize])); /*7261*/
			} else { /*7263*/
				$put($1.txt, $1.barlen, $a([" ", ($1.barlen * $1.cw) + $1.sw, $1.textyoffset, $1.textfont, $1.textsize])); /*7263*/
			} /*7263*/
		} else { /*7266*/
			$puti($1.sbs, ($1.barlen * $1.cs) + $1.ss, $get($1.encs, 11)); /*7266*/
		} /*7266*/
		$k[$j++] = Infinity; /*7278*/
		$k[$j++] = "ren"; /*7273*/
		$k[$j++] = $0.renlinear; /*7273*/
		$k[$j++] = "sbs"; /*7273*/
		$k[$j++] = Infinity; /*7273*/
		$forall($1.sbs, function() { /*7272*/
			var _2W = $k[--$j]; /*7272*/
			$k[$j++] = _2W - 48; /*7272*/
		}); /*7272*/
		var _2X = $a(); /*7273*/
		$k[$j++] = _2X; /*7274*/
		$k[$j++] = "bhs"; /*7274*/
		$k[$j++] = Infinity; /*7274*/
		for (var _2Z = 0, _2a = ~~(($1.sbs.length + 1) / 2); _2Z < _2a; _2Z++) { /*7273*/
			$k[$j++] = $1.height; /*7273*/
		} /*7273*/
		var _2c = $a(); /*7274*/
		$k[$j++] = _2c; /*7275*/
		$k[$j++] = "bbs"; /*7275*/
		$k[$j++] = Infinity; /*7275*/
		for (var _2e = 0, _2f = ~~(($1.sbs.length + 1) / 2); _2e < _2f; _2e++) { /*7274*/
			$k[$j++] = 0; /*7274*/
		} /*7274*/
		var _2g = $a(); /*7275*/
		$k[$j++] = _2g; /*7277*/
		if ($1.includetext) { /*7277*/
			$k[$j++] = "txt"; /*7276*/
			$k[$j++] = $1.txt; /*7276*/
		} /*7276*/
		$k[$j++] = "opt"; /*7278*/
		$k[$j++] = $1.options; /*7278*/
		var _2k = $d(); /*7278*/
		$k[$j++] = _2k; /*7281*/
		if (!$1.dontdraw) { /*7281*/
			$0.renlinear(); /*7281*/
		} /*7281*/
	};
	$0.industrial2of5 = function() {
		var $1 = {}; /*7309*/
		$1.options = $k[--$j]; /*7311*/
		$1.barcode = $k[--$j]; /*7312*/
		$1.dontdraw = false; /*7314*/
		$1.includetext = false; /*7315*/
		$1.textfont = "Courier"; /*7316*/
		$1.textsize = 10; /*7317*/
		$1.textxoffset = 0; /*7318*/
		$1.textyoffset = -8.5; /*7319*/
		$1.height = 1; /*7320*/
		$forall($1.options, function() { /*7331*/
			var _3 = $k[--$j]; /*7331*/
			$1[$k[--$j]] = _3; /*7331*/
		}); /*7331*/
		$1.textfont = "" + $1.textfont; /*7333*/
		$1.textsize = +$1.textsize; /*7334*/
		$1.textxoffset = +$1.textxoffset; /*7335*/
		$1.textyoffset = +$1.textyoffset; /*7336*/
		$1.height = +$1.height; /*7337*/
		$1.options.dontdraw = true; /*7340*/
		$1.options.version = "industrial"; /*7341*/
		$k[$j++] = "args"; /*7343*/
		$k[$j++] = $1.barcode; /*7343*/
		$k[$j++] = $1.options; /*7343*/
		$0.code2of5(); /*7343*/
		var _E = $k[--$j]; /*7343*/
		$1[$k[--$j]] = _E; /*7343*/
		$1.args.opt = $1.options; /*7345*/
		$k[$j++] = $1.args; /*7348*/
		if (!$1.dontdraw) { /*7348*/
			$0.renlinear(); /*7348*/
		} /*7348*/
	};
	$0.iata2of5 = function() {
		var $1 = {}; /*7376*/
		$1.options = $k[--$j]; /*7378*/
		$1.barcode = $k[--$j]; /*7379*/
		$1.dontdraw = false; /*7381*/
		$1.includetext = false; /*7382*/
		$1.textfont = "Courier"; /*7383*/
		$1.textsize = 10; /*7384*/
		$1.textxoffset = 0; /*7385*/
		$1.textyoffset = -8.5; /*7386*/
		$1.height = 1; /*7387*/
		$forall($1.options, function() { /*7398*/
			var _3 = $k[--$j]; /*7398*/
			$1[$k[--$j]] = _3; /*7398*/
		}); /*7398*/
		$1.textfont = "" + $1.textfont; /*7400*/
		$1.textsize = +$1.textsize; /*7401*/
		$1.textxoffset = +$1.textxoffset; /*7402*/
		$1.textyoffset = +$1.textyoffset; /*7403*/
		$1.height = +$1.height; /*7404*/
		$1.options.dontdraw = true; /*7407*/
		$1.options.version = "iata"; /*7408*/
		$k[$j++] = "args"; /*7410*/
		$k[$j++] = $1.barcode; /*7410*/
		$k[$j++] = $1.options; /*7410*/
		$0.code2of5(); /*7410*/
		var _E = $k[--$j]; /*7410*/
		$1[$k[--$j]] = _E; /*7410*/
		$1.args.opt = $1.options; /*7412*/
		$k[$j++] = $1.args; /*7415*/
		if (!$1.dontdraw) { /*7415*/
			$0.renlinear(); /*7415*/
		} /*7415*/
	};
	$0.matrix2of5 = function() {
		var $1 = {}; /*7443*/
		$1.options = $k[--$j]; /*7445*/
		$1.barcode = $k[--$j]; /*7446*/
		$1.dontdraw = false; /*7448*/
		$1.includetext = false; /*7449*/
		$1.textfont = "Courier"; /*7450*/
		$1.textsize = 10; /*7451*/
		$1.textxoffset = 0; /*7452*/
		$1.textyoffset = -8.5; /*7453*/
		$1.height = 1; /*7454*/
		$forall($1.options, function() { /*7465*/
			var _3 = $k[--$j]; /*7465*/
			$1[$k[--$j]] = _3; /*7465*/
		}); /*7465*/
		$1.textfont = "" + $1.textfont; /*7467*/
		$1.textsize = +$1.textsize; /*7468*/
		$1.textxoffset = +$1.textxoffset; /*7469*/
		$1.textyoffset = +$1.textyoffset; /*7470*/
		$1.height = +$1.height; /*7471*/
		$1.options.dontdraw = true; /*7474*/
		$1.options.version = "matrix"; /*7475*/
		$k[$j++] = "args"; /*7477*/
		$k[$j++] = $1.barcode; /*7477*/
		$k[$j++] = $1.options; /*7477*/
		$0.code2of5(); /*7477*/
		var _E = $k[--$j]; /*7477*/
		$1[$k[--$j]] = _E; /*7477*/
		$1.args.opt = $1.options; /*7479*/
		$k[$j++] = $1.args; /*7482*/
		if (!$1.dontdraw) { /*7482*/
			$0.renlinear(); /*7482*/
		} /*7482*/
	};
	$0.coop2of5 = function() {
		var $1 = {}; /*7510*/
		$1.options = $k[--$j]; /*7512*/
		$1.barcode = $k[--$j]; /*7513*/
		$1.dontdraw = false; /*7515*/
		$1.includetext = false; /*7516*/
		$1.textfont = "Courier"; /*7517*/
		$1.textsize = 10; /*7518*/
		$1.textxoffset = 0; /*7519*/
		$1.textyoffset = -8.5; /*7520*/
		$1.height = 1; /*7521*/
		$forall($1.options, function() { /*7532*/
			var _3 = $k[--$j]; /*7532*/
			$1[$k[--$j]] = _3; /*7532*/
		}); /*7532*/
		$1.textfont = "" + $1.textfont; /*7534*/
		$1.textsize = +$1.textsize; /*7535*/
		$1.textxoffset = +$1.textxoffset; /*7536*/
		$1.textyoffset = +$1.textyoffset; /*7537*/
		$1.height = +$1.height; /*7538*/
		$1.options.dontdraw = true; /*7541*/
		$1.options.version = "coop"; /*7542*/
		$k[$j++] = "args"; /*7544*/
		$k[$j++] = $1.barcode; /*7544*/
		$k[$j++] = $1.options; /*7544*/
		$0.code2of5(); /*7544*/
		var _E = $k[--$j]; /*7544*/
		$1[$k[--$j]] = _E; /*7544*/
		$1.args.opt = $1.options; /*7546*/
		$k[$j++] = $1.args; /*7549*/
		if (!$1.dontdraw) { /*7549*/
			$0.renlinear(); /*7549*/
		} /*7549*/
	};
	$0.datalogic2of5 = function() {
		var $1 = {}; /*7577*/
		$1.options = $k[--$j]; /*7579*/
		$1.barcode = $k[--$j]; /*7580*/
		$1.dontdraw = false; /*7582*/
		$1.includetext = false; /*7583*/
		$1.textfont = "Courier"; /*7584*/
		$1.textsize = 10; /*7585*/
		$1.textxoffset = 0; /*7586*/
		$1.textyoffset = -8.5; /*7587*/
		$1.height = 1; /*7588*/
		$forall($1.options, function() { /*7599*/
			var _3 = $k[--$j]; /*7599*/
			$1[$k[--$j]] = _3; /*7599*/
		}); /*7599*/
		$1.textfont = "" + $1.textfont; /*7601*/
		$1.textsize = +$1.textsize; /*7602*/
		$1.textxoffset = +$1.textxoffset; /*7603*/
		$1.textyoffset = +$1.textyoffset; /*7604*/
		$1.height = +$1.height; /*7605*/
		$1.options.dontdraw = true; /*7608*/
		$1.options.version = "datalogic"; /*7609*/
		$k[$j++] = "args"; /*7611*/
		$k[$j++] = $1.barcode; /*7611*/
		$k[$j++] = $1.options; /*7611*/
		$0.code2of5(); /*7611*/
		var _E = $k[--$j]; /*7611*/
		$1[$k[--$j]] = _E; /*7611*/
		$1.args.opt = $1.options; /*7613*/
		$k[$j++] = $1.args; /*7616*/
		if (!$1.dontdraw) { /*7616*/
			$0.renlinear(); /*7616*/
		} /*7616*/
	};
	$0.code11 = function() {
		var $1 = {}; /*7643*/
		$1.options = $k[--$j]; /*7645*/
		$1.barcode = $k[--$j]; /*7646*/
		$1.dontdraw = false; /*7648*/
		$1.includecheck = false; /*7649*/
		$1.validatecheck = false; /*7650*/
		$1.includetext = false; /*7651*/
		$1.includecheckintext = false; /*7652*/
		$1.textfont = "Courier"; /*7653*/
		$1.textsize = 10; /*7654*/
		$1.textyoffset = -8.5; /*7655*/
		$1.height = 1; /*7656*/
		$forall($1.options, function() { /*7667*/
			var _3 = $k[--$j]; /*7667*/
			$1[$k[--$j]] = _3; /*7667*/
		}); /*7667*/
		$1.textfont = "" + $1.textfont; /*7669*/
		$1.textsize = +$1.textsize; /*7670*/
		$1.textyoffset = +$1.textyoffset; /*7671*/
		$1.height = +$1.height; /*7672*/
		$1.encs = $a(["111131", "311131", "131131", "331111", "113131", "313111", "133111", "111331", "311311", "311111", "113111", "113311"]); /*7679*/
		$1.barchars = "0123456789-"; /*7682*/
		$1.charvals = {}; /*7683*/
		for (var _A = 0; _A <= 10; _A += 1) { /*7684*/
			$put($1.charvals, $geti($1.barchars, _A, 1), _A); /*7684*/
		} /*7684*/
		for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*7691*/
			var _K = $get($1.charvals, $geti($1.barcode, _G, 1)) !== undefined; /*7688*/
			if (!_K) { /*7690*/
				$k[$j++] = "bwipp.code11badCharacter"; /*7689*/
				$k[$j++] = "Code 11 must contain only digits and dashes"; /*7689*/
				$0.raiseerror(); /*7689*/
			} /*7689*/
		} /*7689*/
		$1.barlen = $1.barcode.length; /*7693*/
		if ($1.validatecheck) { /*7699*/
			if ($1.barlen == 11) { /*7697*/
				$k[$j++] = "bwipp.code11badLength"; /*7696*/
				$k[$j++] = "Code 11 cannot be 11 characters using check digits"; /*7696*/
				$0.raiseerror(); /*7696*/
			} /*7696*/
			var _Q = ($1.barlen <= 10) ? 1 : 2; /*7698*/
			$1.barlen = $1.barlen - _Q; /*7698*/
		} /*7698*/
		$k[$j++] = "numchecks"; /*7701*/
		if ($1.includecheck || $1.validatecheck) { /*7701*/
			var _U = ($1.barlen >= 10) ? 2 : 1; /*7701*/
			$k[$j++] = _U; /*7701*/
		} else { /*7701*/
			$k[$j++] = 0; /*7701*/
		} /*7701*/
		var _V = $k[--$j]; /*7701*/
		$1[$k[--$j]] = _V; /*7701*/
		$1.checksum1 = 0; /*7702*/
		$1.checksum2 = 0; /*7702*/
		for (var _Z = 0, _Y = $1.barlen - 1; _Z <= _Y; _Z += 1) { /*7708*/
			$1.i = _Z; /*7704*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*7705*/
			$1.checksum1 = $1.checksum1 + ((((($1.barlen - $1.i) - 1) % 10) + 1) * $1.indx); /*7706*/
			$1.checksum2 = $1.checksum2 + (((($1.barlen - $1.i) % 9) + 1) * $1.indx); /*7707*/
		} /*7707*/
		$1.checksum1 = $1.checksum1 % 11; /*7709*/
		$1.checksum2 = ($1.checksum2 + $1.checksum1) % 11; /*7710*/
		if ($1.validatecheck) { /*7724*/
			if ($1.numchecks == 1) { /*7719*/
				if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum1)) { /*7715*/
					$k[$j++] = "bwipp.code11badCheckDigit"; /*7714*/
					$k[$j++] = "Incorrect Code 11 check digit provided"; /*7714*/
					$0.raiseerror(); /*7714*/
				} /*7714*/
			} else { /*7719*/
				if (($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum1)) || ($get($1.barcode, $1.barlen + 1) != $get($1.barchars, $1.checksum2))) { /*7720*/
					$k[$j++] = "bwipp.code11badCheckDigits"; /*7719*/
					$k[$j++] = "Incorrect Code 11 check digits provided"; /*7719*/
					$0.raiseerror(); /*7719*/
				} /*7719*/
			} /*7719*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*7722*/
			$1.includecheck = true; /*7723*/
		} /*7723*/
		$1.sbs = $s((($1.barlen + $1.numchecks) * 6) + 12); /*7726*/
		$1.txt = $a($1.barlen + $1.numchecks); /*7727*/
		$puti($1.sbs, 0, $get($1.encs, 11)); /*7730*/
		$1.xpos = 8; /*7732*/
		for (var _1O = 0, _1N = $1.barlen - 1; _1O <= _1N; _1O += 1) { /*7742*/
			$1.i = _1O; /*7734*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*7735*/
			$1.enc = $get($1.encs, $1.indx); /*7736*/
			$puti($1.sbs, ($1.i * 6) + 6, $1.enc); /*7737*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7738*/
			for (var _1k = 0; _1k <= 5; _1k += 1) { /*7741*/
				$1.xpos = ($get($1.enc, _1k) - 48) + $1.xpos; /*7740*/
			} /*7740*/
		} /*7740*/
		if ($1.includecheck) { /*7771*/
			if ($1.barlen >= 10) { /*7768*/
				$puti($1.sbs, ($1.barlen * 6) + 6, $get($1.encs, $1.checksum1)); /*7747*/
				$puti($1.sbs, ($1.barlen * 6) + 12, $get($1.encs, $1.checksum2)); /*7748*/
				if ($1.includecheckintext) { /*7758*/
					$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7750*/
					$1.enc = $get($1.encs, $1.checksum1); /*7751*/
					for (var _2E = 0; _2E <= 5; _2E += 1) { /*7754*/
						$1.xpos = ($get($1.enc, _2E) - 48) + $1.xpos; /*7753*/
					} /*7753*/
					$put($1.txt, $1.barlen + 1, $a([$geti($1.barchars, $1.checksum2, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7755*/
				} else { /*7758*/
					$put($1.txt, $1.barlen, $a(["", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7757*/
					$put($1.txt, $1.barlen + 1, $a(["", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7758*/
				} /*7758*/
				$puti($1.sbs, ($1.barlen * 6) + 18, $get($1.encs, 11)); /*7760*/
			} else { /*7768*/
				$puti($1.sbs, ($1.barlen * 6) + 6, $get($1.encs, $1.checksum1)); /*7762*/
				if ($1.includecheckintext) { /*7766*/
					$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7764*/
				} else { /*7766*/
					$put($1.txt, $1.barlen, $a(["", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7766*/
				} /*7766*/
				$puti($1.sbs, ($1.barlen * 6) + 12, $get($1.encs, 11)); /*7768*/
			} /*7768*/
		} else { /*7771*/
			$puti($1.sbs, ($1.barlen * 6) + 6, $get($1.encs, 11)); /*7771*/
		} /*7771*/
		$k[$j++] = Infinity; /*7783*/
		$k[$j++] = "ren"; /*7778*/
		$k[$j++] = $0.renlinear; /*7778*/
		$k[$j++] = "sbs"; /*7778*/
		$k[$j++] = Infinity; /*7778*/
		var _3F = $1.sbs; /*7777*/
		for (var _3G = 0, _3H = _3F.length; _3G < _3H; _3G++) { /*7777*/
			$k[$j++] = $get(_3F, _3G) - 48; /*7777*/
		} /*7777*/
		var _3J = $a(); /*7778*/
		$k[$j++] = _3J; /*7779*/
		$k[$j++] = "bhs"; /*7779*/
		$k[$j++] = Infinity; /*7779*/
		for (var _3L = 0, _3M = ~~(($1.sbs.length + 1) / 2); _3L < _3M; _3L++) { /*7778*/
			$k[$j++] = $1.height; /*7778*/
		} /*7778*/
		var _3O = $a(); /*7779*/
		$k[$j++] = _3O; /*7780*/
		$k[$j++] = "bbs"; /*7780*/
		$k[$j++] = Infinity; /*7780*/
		for (var _3Q = 0, _3R = ~~(($1.sbs.length + 1) / 2); _3Q < _3R; _3Q++) { /*7779*/
			$k[$j++] = 0; /*7779*/
		} /*7779*/
		var _3S = $a(); /*7780*/
		$k[$j++] = _3S; /*7782*/
		if ($1.includetext) { /*7782*/
			$k[$j++] = "txt"; /*7781*/
			$k[$j++] = $1.txt; /*7781*/
		} /*7781*/
		$k[$j++] = "opt"; /*7783*/
		$k[$j++] = $1.options; /*7783*/
		var _3W = $d(); /*7783*/
		$k[$j++] = _3W; /*7786*/
		if (!$1.dontdraw) { /*7786*/
			$0.renlinear(); /*7786*/
		} /*7786*/
	};
	$0.bc412 = function() {
		var $1 = {}; /*7813*/
		$1.options = $k[--$j]; /*7815*/
		$1.barcode = $k[--$j]; /*7816*/
		$1.dontdraw = false; /*7818*/
		$1.includecheck = false; /*7819*/
		$1.validatecheck = false; /*7820*/
		$1.includetext = false; /*7821*/
		$1.includecheckintext = false; /*7822*/
		$1.includestartstop = false; /*7823*/
		$1.semi = false; /*7824*/
		$1.textfont = "Courier"; /*7825*/
		$1.textsize = 10; /*7826*/
		$1.textyoffset = -8.5; /*7827*/
		$1.height = 1; /*7828*/
		$forall($1.options, function() { /*7839*/
			var _3 = $k[--$j]; /*7839*/
			$1[$k[--$j]] = _3; /*7839*/
		}); /*7839*/
		$1.textfont = "" + $1.textfont; /*7841*/
		$1.textsize = +$1.textsize; /*7842*/
		$1.textyoffset = +$1.textyoffset; /*7843*/
		$1.height = +$1.height; /*7844*/
		if ($1.semi) { /*7849*/
			$1.includecheck = true; /*7847*/
			$1.includestartstop = true; /*7848*/
		} /*7848*/
		$1.barchars = "0R9GLVHA8EZ4NTS1J2Q6C7DYKBUIX3FWP5M"; /*7852*/
		$1.charvals = {}; /*7853*/
		for (var _A = 0; _A <= 34; _A += 1) { /*7854*/
			$put($1.charvals, $geti($1.barchars, _A, 1), _A); /*7854*/
		} /*7854*/
		for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*7861*/
			var _K = $get($1.charvals, $geti($1.barcode, _G, 1)) !== undefined; /*7858*/
			if (!_K) { /*7860*/
				$k[$j++] = "bwipp.bc412badCharacter"; /*7859*/
				$k[$j++] = "BC412 must contain only digits and capital letters except O"; /*7859*/
				$0.raiseerror(); /*7859*/
			} /*7859*/
		} /*7859*/
		$k[$j++] = "barlen"; /*7863*/
		$k[$j++] = $1.barcode.length; /*7863*/
		if ($1.validatecheck) { /*7863*/
			var _N = $k[--$j]; /*7863*/
			$k[$j++] = _N - 1; /*7863*/
		} /*7863*/
		var _O = $k[--$j]; /*7863*/
		$1[$k[--$j]] = _O; /*7863*/
		$1.checksum = 0; /*7865*/
		for (var _S = 0, _R = $1.barlen - 1; _S <= _R; _S += 1) { /*7869*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _S, 1)) + $1.checksum; /*7868*/
		} /*7868*/
		$1.checksum = $1.checksum % 35; /*7870*/
		if ($1.validatecheck) { /*7877*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*7874*/
				$k[$j++] = "bwipp.bc412badCheckDigit"; /*7873*/
				$k[$j++] = "Incorrect BC412 check digit provided"; /*7873*/
				$0.raiseerror(); /*7873*/
			} /*7873*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*7875*/
			$1.includecheck = true; /*7876*/
		} /*7876*/
		$1.encs = $a(["11111115", "13111212", "11131113", "12111213", "12121311", "13131111", "12111312", "11131212", "11121411", "11151111", "15111111", "11111511", "12131211", "13121112", "13111212", "11111214", "12121113", "11111313", "13111113", "11121213", "11141112", "11121312", "11141211", "14121111", "12121212", "11131311", "13121211", "12111411", "14111211", "11111412", "12111114", "14111112", "12141111", "11121114", "12131112", "12", "111"]); /*7889*/
		$1.sbs = $s((($1.barlen + 1) * 8) + 5); /*7891*/
		if ($1.includecheck) { /*7895*/
			$1.txt = $a($1.barlen + 1); /*7893*/
		} else { /*7895*/
			$1.txt = $a($1.barlen); /*7895*/
		} /*7895*/
		if ($1.includestartstop) { /*7905*/
			$puti($1.sbs, 0, $get($1.encs, 35)); /*7900*/
			$1.pos = 2; /*7901*/
			$1.txtpos = 3; /*7902*/
		} else { /*7905*/
			$1.pos = 0; /*7904*/
			$1.txtpos = 0; /*7905*/
		} /*7905*/
		for (var _x = 0, _w = $1.barlen - 1; _x <= _w; _x += 1) { /*7914*/
			$1.i = _x; /*7909*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*7910*/
			$puti($1.sbs, $1.pos, $get($1.encs, $1.indx)); /*7911*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 12) + $1.txtpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7912*/
			$1.pos = $1.pos + 8; /*7913*/
		} /*7913*/
		if ($1.includecheck) { /*7925*/
			$puti($1.sbs, $1.pos, $get($1.encs, $1.checksum)); /*7918*/
			if ($1.includecheckintext) { /*7922*/
				$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), ($1.barlen * 12) + $1.txtpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7920*/
			} else { /*7922*/
				$put($1.txt, $1.barlen, $a(["", ($1.barlen * 12) + $1.txtpos, $1.textyoffset, $1.textfont, $1.textsize])); /*7922*/
			} /*7922*/
			$1.pos = $1.pos + 8; /*7924*/
		} /*7924*/
		if ($1.includestartstop) { /*7931*/
			$puti($1.sbs, $1.pos, $get($1.encs, 36)); /*7929*/
			$1.pos = $1.pos + 2; /*7930*/
		} /*7930*/
		$1.sbs = $geti($1.sbs, 0, $1.pos); /*7934*/
		$k[$j++] = Infinity; /*7943*/
		$k[$j++] = "ren"; /*7938*/
		$k[$j++] = $0.renlinear; /*7938*/
		$k[$j++] = "sbs"; /*7938*/
		$k[$j++] = Infinity; /*7938*/
		$forall($1.sbs, function() { /*7937*/
			var _1v = $k[--$j]; /*7937*/
			$k[$j++] = _1v - 48; /*7937*/
		}); /*7937*/
		var _1w = $a(); /*7938*/
		$k[$j++] = _1w; /*7939*/
		$k[$j++] = "bhs"; /*7939*/
		$k[$j++] = Infinity; /*7939*/
		for (var _1y = 0, _1z = ~~(($1.sbs.length + 1) / 2); _1y < _1z; _1y++) { /*7938*/
			$k[$j++] = $1.height; /*7938*/
		} /*7938*/
		var _21 = $a(); /*7939*/
		$k[$j++] = _21; /*7940*/
		$k[$j++] = "bbs"; /*7940*/
		$k[$j++] = Infinity; /*7940*/
		for (var _23 = 0, _24 = ~~(($1.sbs.length + 1) / 2); _23 < _24; _23++) { /*7939*/
			$k[$j++] = 0; /*7939*/
		} /*7939*/
		var _25 = $a(); /*7940*/
		$k[$j++] = _25; /*7942*/
		if ($1.includetext) { /*7942*/
			$k[$j++] = "txt"; /*7941*/
			$k[$j++] = $1.txt; /*7941*/
		} /*7941*/
		$k[$j++] = "opt"; /*7943*/
		$k[$j++] = $1.options; /*7943*/
		var _29 = $d(); /*7943*/
		$k[$j++] = _29; /*7946*/
		if (!$1.dontdraw) { /*7946*/
			$0.renlinear(); /*7946*/
		} /*7946*/
	};
	$0.rationalizedCodabar = function() {
		var $1 = {}; /*7973*/
		$1.options = $k[--$j]; /*7975*/
		$1.barcode = $k[--$j]; /*7976*/
		$1.dontdraw = false; /*7978*/
		$1.altstartstop = false; /*7979*/
		$1.includecheck = false; /*7980*/
		$1.validatecheck = false; /*7981*/
		$1.includetext = false; /*7982*/
		$1.includecheckintext = false; /*7983*/
		$1.textfont = "Courier"; /*7984*/
		$1.textsize = 10; /*7985*/
		$1.textyoffset = -8.5; /*7986*/
		$1.height = 1; /*7987*/
		$forall($1.options, function() { /*7998*/
			var _3 = $k[--$j]; /*7998*/
			$1[$k[--$j]] = _3; /*7998*/
		}); /*7998*/
		$1.textfont = "" + $1.textfont; /*8000*/
		$1.textsize = +$1.textsize; /*8001*/
		$1.textyoffset = +$1.textyoffset; /*8002*/
		$1.height = +$1.height; /*8003*/
		$1.encs = $a(["11111331", "11113311", "11131131", "33111111", "11311311", "31111311", "13111131", "13113111", "13311111", "31131111", "11133111", "11331111", "31113131", "31311131", "31313111", "11313131", "11331311", "13131131", "11131331", "11133311"]); /*8011*/
		if ($1.altstartstop) { /*8017*/
			$1.barchars = "0123456789-$:/.+TN*E"; /*8015*/
		} else { /*8017*/
			$1.barchars = "0123456789-$:/.+ABCD"; /*8017*/
		} /*8017*/
		$1.charvals = {}; /*8019*/
		for (var _B = 0; _B <= 19; _B += 1) { /*8020*/
			$put($1.charvals, $geti($1.barchars, _B, 1), _B); /*8020*/
		} /*8020*/
		$1.bodyvals = {}; /*8021*/
		for (var _F = 0; _F <= 15; _F += 1) { /*8022*/
			$put($1.bodyvals, $geti($1.barchars, _F, 1), _F); /*8022*/
		} /*8022*/
		$1.ssvals = {}; /*8023*/
		for (var _J = 16; _J <= 19; _J += 1) { /*8024*/
			$put($1.ssvals, $geti($1.barchars, _J, 1), _J); /*8024*/
		} /*8024*/
		var _Q = $get($1.ssvals, $geti($1.barcode, 0, 1)) !== undefined; /*8027*/
		var _V = $get($1.ssvals, $geti($1.barcode, $1.barcode.length - 1, 1)) !== undefined; /*8028*/
		if ((!_Q) || (!_V)) { /*8034*/
			if ($1.altstartstop) { /*8032*/
				$k[$j++] = "bwipp.rationalizedCodabarBadAltStartStop"; /*8030*/
				$k[$j++] = "Codabar start and stop characters must be one of E N T or *"; /*8030*/
				$0.raiseerror(); /*8030*/
			} else { /*8032*/
				$k[$j++] = "bwipp.rationalizedCodabarBadStartStop"; /*8032*/
				$k[$j++] = "Codabar start and stop characters must be one of A B C or D"; /*8032*/
				$0.raiseerror(); /*8032*/
			} /*8032*/
		} /*8032*/
		for (var _Z = 1, _Y = $1.barcode.length - 2; _Z <= _Y; _Z += 1) { /*8039*/
			var _d = $get($1.bodyvals, $geti($1.barcode, _Z, 1)) !== undefined; /*8036*/
			if (!_d) { /*8038*/
				$k[$j++] = "bwipp.rationalizedCodabarBadCharacter"; /*8037*/
				$k[$j++] = "Codabar body must contain only digits and symbols - $ : / . +"; /*8037*/
				$0.raiseerror(); /*8037*/
			} /*8037*/
		} /*8037*/
		$k[$j++] = "barlen"; /*8041*/
		$k[$j++] = $1.barcode.length; /*8041*/
		if ($1.validatecheck) { /*8041*/
			var _g = $k[--$j]; /*8041*/
			$k[$j++] = _g - 1; /*8041*/
		} /*8041*/
		var _h = $k[--$j]; /*8041*/
		$1[$k[--$j]] = _h; /*8041*/
		$1.checksum = 0; /*8043*/
		for (var _l = 0, _k = $1.barlen - 2; _l <= _k; _l += 1) { /*8047*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _l, 1)) + $1.checksum; /*8046*/
		} /*8046*/
		$1.checksum = $get($1.charvals, $geti($1.barcode, $1.barcode.length - 1, 1)) + $1.checksum; /*8049*/
		$1.checksum = (16 - ($1.checksum % 16)) % 16; /*8050*/
		if ($1.validatecheck) { /*8060*/
			if ($get($1.barcode, $1.barlen - 1) != $get($1.barchars, $1.checksum)) { /*8054*/
				$k[$j++] = "bwipp.rationalizedCodabarBadCheckDigit"; /*8053*/
				$k[$j++] = "Incorrect Codabar check digit provided"; /*8053*/
				$0.raiseerror(); /*8053*/
			} /*8053*/
			var _16 = $s($1.barlen); /*8055*/
			$puti(_16, 0, $geti($1.barcode, 0, $1.barlen - 1)); /*8056*/
			$puti(_16, $1.barlen - 1, $geti($1.barcode, $1.barlen, 1)); /*8057*/
			$1.barcode = _16; /*8058*/
			$1.includecheck = true; /*8059*/
		} /*8059*/
		$k[$j++] = "sbs"; /*8062*/
		$k[$j++] = $1.barlen; /*8062*/
		if ($1.includecheck) { /*8062*/
			var _1G = $k[--$j]; /*8062*/
			$k[$j++] = _1G + 1; /*8062*/
		} /*8062*/
		var _1I = $s($k[--$j] * 8); /*8062*/
		$1[$k[--$j]] = _1I; /*8062*/
		$k[$j++] = "txt"; /*8063*/
		$k[$j++] = $1.barlen; /*8063*/
		if ($1.includecheck) { /*8063*/
			var _1M = $k[--$j]; /*8063*/
			$k[$j++] = _1M + 1; /*8063*/
		} /*8063*/
		var _1O = $a($k[--$j]); /*8063*/
		$1[$k[--$j]] = _1O; /*8063*/
		$1.xpos = 0; /*8065*/
		for (var _1S = 0, _1R = $1.barlen - 2; _1S <= _1R; _1S += 1) { /*8075*/
			$1.i = _1S; /*8067*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*8068*/
			$1.enc = $get($1.encs, $1.indx); /*8069*/
			$puti($1.sbs, $1.i * 8, $1.enc); /*8070*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*8071*/
			for (var _1o = 0; _1o <= 7; _1o += 1) { /*8074*/
				$1.xpos = ($get($1.enc, _1o) - 48) + $1.xpos; /*8073*/
			} /*8073*/
		} /*8073*/
		if ($1.includecheck) { /*8099*/
			$puti($1.sbs, ($1.barlen * 8) - 8, $get($1.encs, $1.checksum)); /*8080*/
			if ($1.includecheckintext) { /*8084*/
				$put($1.txt, $1.barlen - 1, $a([$geti($1.barchars, $1.checksum, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*8082*/
			} else { /*8084*/
				$put($1.txt, $1.barlen - 1, $a([" ", $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*8084*/
			} /*8084*/
			for (var _2G = 0; _2G <= 7; _2G += 1) { /*8088*/
				$1.xpos = ($get($get($1.encs, $1.checksum), _2G) - 48) + $1.xpos; /*8087*/
			} /*8087*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.barlen - 1, 1)); /*8090*/
			$1.enc = $get($1.encs, $1.indx); /*8091*/
			$puti($1.sbs, $1.barlen * 8, $1.enc); /*8092*/
			$put($1.txt, $1.barlen, $a([$geti($1.barcode, $1.barlen - 1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*8093*/
		} else { /*8099*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.barlen - 1, 1)); /*8096*/
			$1.enc = $get($1.encs, $1.indx); /*8097*/
			$puti($1.sbs, ($1.barlen * 8) - 8, $1.enc); /*8098*/
			$put($1.txt, $1.barlen - 1, $a([$geti($1.barcode, $1.barlen - 1, 1), $1.xpos, $1.textyoffset, $1.textfont, $1.textsize])); /*8099*/
		} /*8099*/
		$k[$j++] = Infinity; /*8111*/
		$k[$j++] = "ren"; /*8106*/
		$k[$j++] = $0.renlinear; /*8106*/
		$k[$j++] = "sbs"; /*8106*/
		$k[$j++] = Infinity; /*8106*/
		$forall($1.sbs, function() { /*8105*/
			var _33 = $k[--$j]; /*8105*/
			$k[$j++] = _33 - 48; /*8105*/
		}); /*8105*/
		var _34 = $a(); /*8106*/
		$k[$j++] = _34; /*8107*/
		$k[$j++] = "bhs"; /*8107*/
		$k[$j++] = Infinity; /*8107*/
		for (var _36 = 0, _37 = ~~(($1.sbs.length + 1) / 2); _36 < _37; _36++) { /*8106*/
			$k[$j++] = $1.height; /*8106*/
		} /*8106*/
		var _39 = $a(); /*8107*/
		$k[$j++] = _39; /*8108*/
		$k[$j++] = "bbs"; /*8108*/
		$k[$j++] = Infinity; /*8108*/
		for (var _3B = 0, _3C = ~~(($1.sbs.length + 1) / 2); _3B < _3C; _3B++) { /*8107*/
			$k[$j++] = 0; /*8107*/
		} /*8107*/
		var _3D = $a(); /*8108*/
		$k[$j++] = _3D; /*8110*/
		if ($1.includetext) { /*8110*/
			$k[$j++] = "txt"; /*8109*/
			$k[$j++] = $1.txt; /*8109*/
		} /*8109*/
		$k[$j++] = "opt"; /*8111*/
		$k[$j++] = $1.options; /*8111*/
		var _3H = $d(); /*8111*/
		$k[$j++] = _3H; /*8114*/
		if (!$1.dontdraw) { /*8114*/
			$0.renlinear(); /*8114*/
		} /*8114*/
	};
	$0.onecode = function() {
		var $1 = {}; /*8141*/
		$1.options = $k[--$j]; /*8143*/
		$1.barcode = $k[--$j]; /*8144*/
		$1.dontdraw = false; /*8146*/
		$1.height = 0.15; /*8147*/
		$forall($1.options, function() { /*8158*/
			var _3 = $k[--$j]; /*8158*/
			$1[$k[--$j]] = _3; /*8158*/
		}); /*8158*/
		$1.height = +$1.height; /*8160*/
		$1.barlen = $1.barcode.length; /*8162*/
		$k[$j++] = "txtdict"; /*8171*/
		$k[$j++] = Infinity; /*8171*/
		var _9 = $eq($geti($1.barcode, 5, 1), "9") ? 14 : 11; /*8168*/
		$k[$j++] = 2; /*8171*/
		$k[$j++] = 2; /*8171*/
		$k[$j++] = 5; /*8171*/
		$k[$j++] = 5; /*8171*/
		$k[$j++] = _9; /*8171*/
		$k[$j++] = _9; /*8171*/
		$k[$j++] = 20; /*8171*/
		$k[$j++] = 20; /*8171*/
		$k[$j++] = 25; /*8171*/
		$k[$j++] = 25; /*8171*/
		$k[$j++] = 29; /*8171*/
		$k[$j++] = 29; /*8171*/
		var _A = $d(); /*8171*/
		$1[$k[--$j]] = _A; /*8172*/
		$1.txt = $a($1.barlen + 6); /*8173*/
		$1.spacecnt = 0; /*8174*/
		for (var _G = 0, _F = $1.barlen - 1; _G <= _F; _G += 1) { /*8182*/
			$1.i = _G; /*8176*/
			var _J = $get($1.txtdict, $1.i) !== undefined; /*8177*/
			if (_J) { /*8180*/
				$put($1.txt, $1.i + $1.spacecnt, $a([" ", 0, 0, "", 0])); /*8178*/
				$1.spacecnt = $1.spacecnt + 1; /*8179*/
			} /*8179*/
			$put($1.txt, $1.i + $1.spacecnt, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*8181*/
		} /*8181*/
		$1.txt = $geti($1.txt, 0, $1.barcode.length + $1.spacecnt); /*8183*/
		$1.normalize = function() {
			$1.base = $k[--$j]; /*8186*/
			$1.num = $k[--$j]; /*8187*/
			for (var _d = $1.num.length - 1; _d >= 1; _d -= 1) { /*8192*/
				$1.i = _d; /*8189*/
				var _e = $1.num; /*8190*/
				var _f = $1.i; /*8190*/
				$put(_e, _f - 1, $get(_e, _f - 1) + (~~($get($1.num, $1.i) / $1.base))); /*8190*/
				$put($1.num, $1.i, $get($1.num, $1.i) % $1.base); /*8191*/
			} /*8191*/
			for (;;) { /*8198*/
				if ($lt($get($1.num, 0), $1.base)) { /*8194*/
					break; /*8194*/
				} /*8194*/
				$k[$j++] = Infinity; /*8195*/
				$k[$j++] = 0; /*8195*/
				$forall($1.num); /*8195*/
				$1.num = $a(); /*8195*/
				$put($1.num, 0, $get($1.num, 0) + (~~($get($1.num, 1) / $1.base))); /*8196*/
				$put($1.num, 1, $get($1.num, 1) % $1.base); /*8197*/
			} /*8197*/
			$k[$j++] = Infinity; /*8200*/
			$1.i = true; /*8200*/
			var _16 = $1.num; /*8200*/
			for (var _17 = 0, _18 = _16.length; _17 < _18; _17++) { /*8200*/
				var _19 = $get(_16, _17); /*8200*/
				$k[$j++] = _19; /*8200*/
				if ((_19 == 0) && $1.i) { /*8200*/
					$j--; /*8200*/
				} else { /*8200*/
					$1.i = false; /*8200*/
				} /*8200*/
			} /*8200*/
			$1.num = $a(); /*8200*/
			if ($1.num.length == 0) { /*8201*/
				$1.num = $a([0]); /*8201*/
			} /*8201*/
			$k[$j++] = $1.num; /*8202*/
		}; /*8203*/
		$1.bigadd = function() {
			var _1F = $k[--$j]; /*8206*/
			var _1G = $k[--$j]; /*8206*/
			$1.offset = Math.abs(_1F.length - _1G.length); /*8207*/
			if (_1F.length < _1G.length) { /*8208*/
				var _ = _1F; /*8208*/
				_1F = _1G; /*8208*/
				_1G = _; /*8208*/
			} /*8208*/
			$1.a = _1F; /*8209*/
			$1.b = _1G; /*8209*/
			for (var _1J = 0, _1I = $1.b.length - 1; _1J <= _1I; _1J += 1) { /*8212*/
				var _1K = $1.a; /*8211*/
				var _1L = $1.offset; /*8211*/
				$put(_1K, _1J + _1L, $get(_1K, _1J + _1L) + $get($1.b, _1J)); /*8211*/
			} /*8211*/
			$k[$j++] = $1.a; /*8213*/
		}; /*8214*/
		if ($1.barlen == 20) { /*8217*/
			$k[$j++] = $a([0]); /*8217*/
		} /*8217*/
		if ($1.barlen == 25) { /*8218*/
			$k[$j++] = $a([1]); /*8218*/
		} /*8218*/
		if ($1.barlen == 29) { /*8219*/
			$k[$j++] = $a([1, 0, 0, 0, 0, 1]); /*8219*/
		} /*8219*/
		if ($1.barlen == 31) { /*8220*/
			$k[$j++] = $a([1, 0, 0, 0, 1, 0, 0, 0, 0, 1]); /*8220*/
		} /*8220*/
		var _1Y = $k[--$j]; /*8221*/
		$k[$j++] = "binval"; /*8221*/
		$k[$j++] = _1Y; /*8221*/
		$k[$j++] = Infinity; /*8221*/
		$forall($geti($1.barcode, 20, $1.barlen - 20), function() { /*8221*/
			var _1c = $k[--$j]; /*8221*/
			$k[$j++] = _1c - 48; /*8221*/
		}); /*8221*/
		var _1d = $a(); /*8221*/
		$k[$j++] = _1d; /*8221*/
		if ($1.bigadd() == $b) return $b; /*8221*/
		var _1e = $k[--$j]; /*8221*/
		$1[$k[--$j]] = _1e; /*8221*/
		$k[$j++] = Infinity; /*8222*/
		var _1g = $1.binval; /*8222*/
		for (var _1h = 0, _1i = _1g.length; _1h < _1i; _1h++) { /*8222*/
			$k[$j++] = $get(_1g, _1h); /*8222*/
		} /*8222*/
		$k[$j++] = $get($1.barcode, 0) - 48; /*8222*/
		$1.binval = $a(); /*8222*/
		$k[$j++] = "binval"; /*8223*/
		$k[$j++] = Infinity; /*8223*/
		var _1n = $1.binval; /*8223*/
		for (var _1o = 0, _1p = _1n.length; _1o < _1p; _1o++) { /*8223*/
			$k[$j++] = $get(_1n, _1o) * 5; /*8223*/
		} /*8223*/
		var _1r = $a(); /*8223*/
		$k[$j++] = _1r; /*8223*/
		$k[$j++] = $a([$get($1.barcode, 1) - 48]); /*8223*/
		if ($1.bigadd() == $b) return $b; /*8223*/
		$k[$j++] = 10; /*8223*/
		if ($1.normalize() == $b) return $b; /*8223*/
		var _1v = $k[--$j]; /*8223*/
		$1[$k[--$j]] = _1v; /*8223*/
		$k[$j++] = Infinity; /*8224*/
		var _1x = $1.binval; /*8224*/
		for (var _1y = 0, _1z = _1x.length; _1y < _1z; _1y++) { /*8224*/
			$k[$j++] = $get(_1x, _1y); /*8224*/
		} /*8224*/
		$forall($geti($1.barcode, 2, 18), function() { /*8224*/
			var _23 = $k[--$j]; /*8224*/
			$k[$j++] = _23 - 48; /*8224*/
		}); /*8224*/
		$1.binval = $a(); /*8224*/
		$1.bytes = $a(13); /*8227*/
		$k[$j++] = Infinity; /*8228*/
		var _26 = $1.binval; /*8228*/
		for (var _27 = 0, _28 = _26.length; _27 < _28; _27++) { /*8228*/
			$k[$j++] = $get(_26, _27); /*8228*/
		} /*8228*/
		$1.bintmp = $a(); /*8228*/
		for (var _2B = 12; _2B >= 0; _2B -= 1) { /*8238*/
			$1.i = _2B; /*8230*/
			for (var _2E = 0, _2D = $1.bintmp.length - 2; _2E <= _2D; _2E += 1) { /*8235*/
				$1.j = _2E; /*8232*/
				var _2F = $1.bintmp; /*8233*/
				var _2G = $1.j; /*8233*/
				$put(_2F, _2G + 1, $get(_2F, _2G + 1) + (($get($1.bintmp, $1.j) % 256) * 10)); /*8233*/
				$put($1.bintmp, $1.j, ~~($get($1.bintmp, $1.j) / 256)); /*8234*/
			} /*8234*/
			$put($1.bytes, $1.i, $get($1.bintmp, $1.bintmp.length - 1) % 256); /*8236*/
			var _2V = $1.bintmp; /*8237*/
			var _2W = $1.bintmp; /*8237*/
			$put(_2V, _2W.length - 1, ~~($get(_2V, _2W.length - 1) / 256)); /*8237*/
		} /*8237*/
		$1.fcs = 2047; /*8241*/
		$1.dat = $get($1.bytes, 0) << 5; /*8242*/
		for (var _2a = 0, _2b = 6; _2a < _2b; _2a++) { /*8251*/
			if ((($1.fcs ^ $1.dat) & 1024) != 0) { /*8247*/
				$1.fcs = ($1.fcs << 1) ^ 3893; /*8245*/
			} else { /*8247*/
				$1.fcs = $1.fcs << 1; /*8247*/
			} /*8247*/
			$1.fcs = $1.fcs & 2047; /*8249*/
			$1.dat = $1.dat << 1; /*8250*/
		} /*8250*/
		for (var _2i = 1; _2i <= 12; _2i += 1) { /*8263*/
			$1.dat = $get($1.bytes, _2i) << 3; /*8253*/
			for (var _2l = 0, _2m = 8; _2l < _2m; _2l++) { /*8262*/
				if ((($1.fcs ^ $1.dat) & 1024) != 0) { /*8258*/
					$1.fcs = ($1.fcs << 1) ^ 3893; /*8256*/
				} else { /*8258*/
					$1.fcs = $1.fcs << 1; /*8258*/
				} /*8258*/
				$1.fcs = $1.fcs & 2047; /*8260*/
				$1.dat = $1.dat << 1; /*8261*/
			} /*8261*/
		} /*8261*/
		$1.codewords = $a(10); /*8266*/
		for (var _2u = 9; _2u >= 0; _2u -= 1) { /*8281*/
			$1.i = _2u; /*8268*/
			if ($1.i == 9) { /*8272*/
				$1.b = 636; /*8270*/
			} else { /*8272*/
				$1.b = 1365; /*8272*/
			} /*8272*/
			for (var _2y = 0, _2x = $1.binval.length - 2; _2y <= _2x; _2y += 1) { /*8278*/
				$1.j = _2y; /*8275*/
				var _2z = $1.binval; /*8276*/
				var _30 = $1.j; /*8276*/
				$put(_2z, _30 + 1, $get(_2z, _30 + 1) + (($get($1.binval, $1.j) % $1.b) * 10)); /*8276*/
				$put($1.binval, $1.j, ~~($get($1.binval, $1.j) / $1.b)); /*8277*/
			} /*8277*/
			$put($1.codewords, $1.i, $get($1.binval, $1.binval.length - 1) % $1.b); /*8279*/
			var _3I = $1.binval; /*8280*/
			var _3J = $1.binval; /*8280*/
			$put(_3I, _3J.length - 1, ~~($get(_3I, _3J.length - 1) / $1.b)); /*8280*/
		} /*8280*/
		$put($1.codewords, 9, $get($1.codewords, 9) * 2); /*8284*/
		if (($1.fcs & 1024) != 0) { /*8287*/
			$put($1.codewords, 0, $get($1.codewords, 0) + 659); /*8286*/
		} /*8286*/
		$1.tab513 = $a([31, 7936, 47, 7808, 55, 7552, 59, 7040, 61, 6016, 62, 3968, 79, 7744, 87, 7488, 91, 6976, 93, 5952, 94, 3904, 103, 7360, 107, 6848, 109, 5824, 110, 3776, 115, 6592, 117, 5568, 118, 3520, 121, 5056, 122, 3008, 124, 1984, 143, 7712, 151, 7456, 155, 6944, 157, 5920, 158, 3872, 167, 7328, 171, 6816, 173, 5792, 174, 3744, 179, 6560, 181, 5536, 182, 3488, 185, 5024, 186, 2976, 188, 1952, 199, 7264, 203, 6752, 205, 5728, 206, 3680, 211, 6496, 213, 5472, 214, 3424, 217, 4960, 218, 2912, 220, 1888, 227, 6368, 229, 5344, 230, 3296, 233, 4832, 234, 2784, 236, 1760, 241, 4576, 242, 2528, 244, 1504, 248, 992, 271, 7696, 279, 7440, 283, 6928, 285, 5904, 286, 3856, 295, 7312, 299, 6800, 301, 5776, 302, 3728, 307, 6544, 309, 5520, 310, 3472, 313, 5008, 314, 2960, 316, 1936, 327, 7248, 331, 6736, 333, 5712, 334, 3664, 339, 6480, 341, 5456, 342, 3408, 345, 4944, 346, 2896, 348, 1872, 355, 6352, 357, 5328, 358, 3280, 361, 4816, 362, 2768, 364, 1744, 369, 4560, 370, 2512, 372, 1488, 376, 976, 391, 7216, 395, 6704, 397, 5680, 398, 3632, 403, 6448, 405, 5424, 406, 3376, 409, 4912, 410, 2864, 412, 1840, 419, 6320, 421, 5296, 422, 3248, 425, 4784, 426, 2736, 428, 1712, 433, 4528, 434, 2480, 436, 1456, 440, 944, 451, 6256, 453, 5232, 454, 3184, 457, 4720, 458, 2672, 460, 1648, 465, 4464, 466, 2416, 468, 1392, 472, 880, 481, 4336, 482, 2288, 484, 1264, 488, 752, 527, 7688, 535, 7432, 539, 6920, 541, 5896, 542, 3848, 551, 7304, 555, 6792, 557, 5768, 558, 3720, 563, 6536, 565, 5512, 566, 3464, 569, 5000, 570, 2952, 572, 1928, 583, 7240, 587, 6728, 589, 5704, 590, 3656, 595, 6472, 597, 5448, 598, 3400, 601, 4936, 602, 2888, 604, 1864, 611, 6344, 613, 5320, 614, 3272, 617, 4808, 618, 2760, 620, 1736, 625, 4552, 626, 2504, 628, 1480, 632, 968, 647, 7208, 651, 6696, 653, 5672, 654, 3624, 659, 6440, 661, 5416, 662, 3368, 665, 4904, 666, 2856, 668, 1832, 675, 6312, 677, 5288, 678, 3240, 681, 4776, 682, 2728, 684, 1704, 689, 4520, 690, 2472, 692, 1448, 696, 936, 707, 6248, 709, 5224, 710, 3176, 713, 4712, 714, 2664, 716, 1640, 721, 4456, 722, 2408, 724, 1384, 728, 872, 737, 4328, 738, 2280, 740, 1256, 775, 7192, 779, 6680, 781, 5656, 782, 3608, 787, 6424, 789, 5400, 790, 3352, 793, 4888, 794, 2840, 796, 1816, 803, 6296, 805, 5272, 806, 3224, 809, 4760, 810, 2712, 812, 1688, 817, 4504, 818, 2456, 820, 1432, 824, 920, 835, 6232, 837, 5208, 838, 3160, 841, 4696, 842, 2648, 844, 1624, 849, 4440, 850, 2392, 852, 1368, 865, 4312, 866, 2264, 868, 1240, 899, 6200, 901, 5176, 902, 3128, 905, 4664, 906, 2616, 908, 1592, 913, 4408, 914, 2360, 916, 1336, 929, 4280, 930, 2232, 932, 1208, 961, 4216, 962, 2168, 964, 1144, 1039, 7684, 1047, 7428, 1051, 6916, 1053, 5892, 1054, 3844, 1063, 7300, 1067, 6788, 1069, 5764, 1070, 3716, 1075, 6532, 1077, 5508, 1078, 3460, 1081, 4996, 1082, 2948, 1084, 1924, 1095, 7236, 1099, 6724, 1101, 5700, 1102, 3652, 1107, 6468, 1109, 5444, 1110, 3396, 1113, 4932, 1114, 2884, 1116, 1860, 1123, 6340, 1125, 5316, 1126, 3268, 1129, 4804, 1130, 2756, 1132, 1732, 1137, 4548, 1138, 2500, 1140, 1476, 1159, 7204, 1163, 6692, 1165, 5668, 1166, 3620, 1171, 6436, 1173, 5412, 1174, 3364, 1177, 4900, 1178, 2852, 1180, 1828, 1187, 6308, 1189, 5284, 1190, 3236, 1193, 4772, 1194, 2724, 1196, 1700, 1201, 4516, 1202, 2468, 1204, 1444, 1219, 6244, 1221, 5220, 1222, 3172, 1225, 4708, 1226, 2660, 1228, 1636, 1233, 4452, 1234, 2404, 1236, 1380, 1249, 4324, 1250, 2276, 1287, 7188, 1291, 6676, 1293, 5652, 1294, 3604, 1299, 6420, 1301, 5396, 1302, 3348, 1305, 4884, 1306, 2836, 1308, 1812, 1315, 6292, 1317, 5268, 1318, 3220, 1321, 4756, 1322, 2708, 1324, 1684, 1329, 4500, 1330, 2452, 1332, 1428, 1347, 6228, 1349, 5204, 1350, 3156, 1353, 4692, 1354, 2644, 1356, 1620, 1361, 4436, 1362, 2388, 1377, 4308, 1378, 2260, 1411, 6196, 1413, 5172, 1414, 3124, 1417, 4660, 1418, 2612, 1420, 1588, 1425, 4404, 1426, 2356, 1441, 4276, 1442, 2228, 1473, 4212, 1474, 2164, 1543, 7180, 1547, 6668, 1549, 5644, 1550, 3596, 1555, 6412, 1557, 5388, 1558, 3340, 1561, 4876, 1562, 2828, 1564, 1804, 1571, 6284, 1573, 5260, 1574, 3212, 1577, 4748, 1578, 2700, 1580, 1676, 1585, 4492, 1586, 2444, 1603, 6220, 1605, 5196, 1606, 3148, 1609, 4684, 1610, 2636, 1617, 4428, 1618, 2380, 1633, 4300, 1634, 2252, 1667, 6188, 1669, 5164, 1670, 3116, 1673, 4652, 1674, 2604, 1681, 4396, 1682, 2348, 1697, 4268, 1698, 2220, 1729, 4204, 1730, 2156, 1795, 6172, 1797, 5148, 1798, 3100, 1801, 4636, 1802, 2588, 1809, 4380, 1810, 2332, 1825, 4252, 1826, 2204, 1857, 4188, 1858, 2140, 1921, 4156, 1922, 2108, 2063, 7682, 2071, 7426, 2075, 6914, 2077, 5890, 2078, 3842, 2087, 7298, 2091, 6786, 2093, 5762, 2094, 3714, 2099, 6530, 2101, 5506, 2102, 3458, 2105, 4994, 2106, 2946, 2119, 7234, 2123, 6722, 2125, 5698, 2126, 3650, 2131, 6466, 2133, 5442, 2134, 3394, 2137, 4930, 2138, 2882, 2147, 6338, 2149, 5314, 2150, 3266, 2153, 4802, 2154, 2754, 2161, 4546, 2162, 2498, 2183, 7202, 2187, 6690, 2189, 5666, 2190, 3618, 2195, 6434, 2197, 5410, 2198, 3362, 2201, 4898, 2202, 2850, 2211, 6306, 2213, 5282, 2214, 3234, 2217, 4770, 2218, 2722, 2225, 4514, 2226, 2466, 2243, 6242, 2245, 5218, 2246, 3170, 2249, 4706, 2250, 2658, 2257, 4450, 2258, 2402, 2273, 4322, 2311, 7186, 2315, 6674, 2317, 5650, 2318, 3602, 2323, 6418, 2325, 5394, 2326, 3346, 2329, 4882, 2330, 2834, 2339, 6290, 2341, 5266, 2342, 3218, 2345, 4754, 2346, 2706, 2353, 4498, 2354, 2450, 2371, 6226, 2373, 5202, 2374, 3154, 2377, 4690, 2378, 2642, 2385, 4434, 2401, 4306, 2435, 6194, 2437, 5170, 2438, 3122, 2441, 4658, 2442, 2610, 2449, 4402, 2465, 4274, 2497, 4210, 2567, 7178, 2571, 6666, 2573, 5642, 2574, 3594, 2579, 6410, 2581, 5386, 2582, 3338, 2585, 4874, 2586, 2826, 2595, 6282, 2597, 5258, 2598, 3210, 2601, 4746, 2602, 2698, 2609, 4490, 2627, 6218, 2629, 5194, 2630, 3146, 2633, 4682, 2641, 4426, 2657, 4298, 2691, 6186, 2693, 5162, 2694, 3114, 2697, 4650, 2705, 4394, 2721, 4266, 2753, 4202, 2819, 6170, 2821, 5146, 2822, 3098, 2825, 4634, 2833, 4378, 2849, 4250, 2881, 4186, 2945, 4154, 3079, 7174, 3083, 6662, 3085, 5638, 3086, 3590, 3091, 6406, 3093, 5382, 3094, 3334, 3097, 4870, 3107, 6278, 3109, 5254, 3110, 3206, 3113, 4742, 3121, 4486, 3139, 6214, 3141, 5190, 3145, 4678, 3153, 4422, 3169, 4294, 3203, 6182, 3205, 5158, 3209, 4646, 3217, 4390, 3233, 4262, 3265, 4198, 3331, 6166, 3333, 5142, 3337, 4630, 3345, 4374, 3361, 4246, 3393, 4182, 3457, 4150, 3587, 6158, 3589, 5134, 3593, 4622, 3601, 4366, 3617, 4238, 3649, 4174, 3713, 4142, 3841, 4126, 4111, 7681, 4119, 7425, 4123, 6913, 4125, 5889, 4135, 7297, 4139, 6785, 4141, 5761, 4147, 6529, 4149, 5505, 4153, 4993, 4167, 7233, 4171, 6721, 4173, 5697, 4179, 6465, 4181, 5441, 4185, 4929, 4195, 6337, 4197, 5313, 4201, 4801, 4209, 4545, 4231, 7201, 4235, 6689, 4237, 5665, 4243, 6433, 4245, 5409, 4249, 4897, 4259, 6305, 4261, 5281, 4265, 4769, 4273, 4513, 4291, 6241, 4293, 5217, 4297, 4705, 4305, 4449, 4359, 7185, 4363, 6673, 4365, 5649, 4371, 6417, 4373, 5393, 4377, 4881, 4387, 6289, 4389, 5265, 4393, 4753, 4401, 4497, 4419, 6225, 4421, 5201, 4425, 4689, 4483, 6193, 4485, 5169, 4489, 4657, 4615, 7177, 4619, 6665, 4621, 5641, 4627, 6409, 4629, 5385, 4633, 4873, 4643, 6281, 4645, 5257, 4649, 4745, 4675, 6217, 4677, 5193, 4739, 6185, 4741, 5161, 4867, 6169, 4869, 5145, 5127, 7173, 5131, 6661, 5133, 5637, 5139, 6405, 5141, 5381, 5155, 6277, 5157, 5253, 5187, 6213, 5251, 6181, 5379, 6165, 5635, 6157, 6151, 7171, 6155, 6659, 6163, 6403, 6179, 6275, 6211, 5189, 4681, 4433, 4321, 3142, 2634, 2386, 2274, 1612, 1364, 1252, 856, 744, 496]); /*8377*/
		$1.tab213 = $a([3, 6144, 5, 5120, 6, 3072, 9, 4608, 10, 2560, 12, 1536, 17, 4352, 18, 2304, 20, 1280, 24, 768, 33, 4224, 34, 2176, 36, 1152, 40, 640, 48, 384, 65, 4160, 66, 2112, 68, 1088, 72, 576, 80, 320, 96, 192, 129, 4128, 130, 2080, 132, 1056, 136, 544, 144, 288, 257, 4112, 258, 2064, 260, 1040, 264, 528, 513, 4104, 514, 2056, 516, 1032, 1025, 4100, 1026, 2052, 2049, 4098, 4097, 2050, 1028, 520, 272, 160]); /*8386*/
		$1.chars = $a(10); /*8388*/
		for (var _3W = 0; _3W <= 9; _3W += 1) { /*8397*/
			$1.i = _3W; /*8390*/
			var _3Z = $get($1.codewords, $1.i); /*8391*/
			$k[$j++] = _3Z; /*8395*/
			if (_3Z <= 1286) { /*8394*/
				var _3c = $get($1.tab513, $k[--$j]); /*8392*/
				$k[$j++] = _3c; /*8392*/
			} else { /*8394*/
				var _3f = $get($1.tab213, $k[--$j] - 1287); /*8394*/
				$k[$j++] = _3f; /*8394*/
			} /*8394*/
			$put($1.chars, $1.i, $k[--$j]); /*8396*/
		} /*8396*/
		for (var _3j = 9; _3j >= 0; _3j -= 1) { /*8404*/
			$1.i = _3j; /*8400*/
			if (((~~Math.pow(2, $1.i)) & $1.fcs) != 0) { /*8403*/
				$put($1.chars, $1.i, $get($1.chars, $1.i) ^ 8191); /*8402*/
			} /*8402*/
		} /*8402*/
		$1.barmap = $a([7, 2, 4, 3, 1, 10, 0, 0, 9, 12, 2, 8, 5, 5, 6, 11, 8, 9, 3, 1, 0, 1, 5, 12, 2, 5, 1, 8, 4, 4, 9, 11, 6, 3, 8, 10, 3, 9, 7, 6, 5, 11, 1, 4, 8, 5, 2, 12, 9, 10, 0, 2, 7, 1, 6, 7, 3, 6, 4, 9, 0, 3, 8, 6, 6, 4, 2, 7, 1, 1, 9, 9, 7, 10, 5, 2, 4, 0, 3, 8, 6, 2, 0, 4, 8, 11, 1, 0, 9, 8, 3, 12, 2, 6, 7, 7, 5, 1, 4, 10, 1, 12, 6, 9, 7, 3, 8, 0, 5, 8, 9, 7, 4, 6, 2, 10, 3, 4, 0, 5, 8, 4, 5, 7, 7, 11, 1, 9, 6, 0, 9, 6, 0, 6, 4, 8, 2, 1, 3, 2, 5, 9, 8, 12, 4, 11, 6, 1, 9, 5, 7, 4, 3, 3, 1, 2, 0, 7, 2, 0, 1, 3, 4, 1, 6, 10, 3, 5, 8, 7, 9, 4, 2, 11, 5, 6, 0, 8, 7, 12, 4, 2, 8, 1, 5, 10, 3, 0, 9, 3, 0, 9, 6, 5, 2, 4, 7, 8, 1, 7, 5, 0, 4, 5, 2, 3, 0, 10, 6, 12, 9, 2, 3, 11, 1, 6, 8, 8, 7, 9, 5, 4, 0, 11, 1, 5, 2, 2, 9, 1, 4, 12, 8, 3, 6, 6, 7, 0, 3, 7, 4, 7, 7, 5, 0, 12, 1, 11, 2, 9, 9, 0, 6, 8, 5, 3, 3, 10, 8, 2]); /*8421*/
		$1.bbs = $a(65); /*8423*/
		$1.bhs = $a(65); /*8424*/
		for (var _3u = 0; _3u <= 64; _3u += 1) { /*8445*/
			$1.i = _3u; /*8426*/
			$1.dec = ($get($1.chars, $get($1.barmap, $1.i * 4)) & (~~Math.pow(2, $get($1.barmap, ($1.i * 4) + 1)))) != 0; /*8427*/
			$1.asc = ($get($1.chars, $get($1.barmap, ($1.i * 4) + 2)) & (~~Math.pow(2, $get($1.barmap, ($1.i * 4) + 3)))) != 0; /*8428*/
			if ((!$1.dec) && (!$1.asc)) { /*8432*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8430*/
				$put($1.bhs, $1.i, (2 * $1.height) / 8); /*8431*/
			} /*8431*/
			if ((!$1.dec) && $1.asc) { /*8436*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8434*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8435*/
			} /*8435*/
			if ($1.dec && (!$1.asc)) { /*8440*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8438*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8439*/
			} /*8439*/
			if ($1.dec && $1.asc) { /*8444*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8442*/
				$put($1.bhs, $1.i, (8 * $1.height) / 8); /*8443*/
			} /*8443*/
		} /*8443*/
		$k[$j++] = Infinity; /*8458*/
		$k[$j++] = "ren"; /*8453*/
		$k[$j++] = $0.renlinear; /*8453*/
		$k[$j++] = "bbs"; /*8453*/
		$k[$j++] = $1.bbs; /*8453*/
		$k[$j++] = "bhs"; /*8453*/
		$k[$j++] = $1.bhs; /*8453*/
		$k[$j++] = "sbs"; /*8453*/
		$k[$j++] = Infinity; /*8453*/
		for (var _4k = 0, _4l = $1.bhs.length - 1; _4k < _4l; _4k++) { /*8452*/
			$k[$j++] = 1.44; /*8452*/
			$k[$j++] = 1.872; /*8452*/
		} /*8452*/
		$k[$j++] = 1.44; /*8452*/
		var _4m = $a(); /*8453*/
		$k[$j++] = _4m; /*8458*/
		$k[$j++] = "txt"; /*8458*/
		$k[$j++] = $1.txt; /*8458*/
		$k[$j++] = "textxalign"; /*8458*/
		$k[$j++] = "left"; /*8458*/
		$k[$j++] = "textfont"; /*8458*/
		$k[$j++] = "Helvetica"; /*8458*/
		$k[$j++] = "textyoffset"; /*8458*/
		$k[$j++] = 1; /*8458*/
		$k[$j++] = "textxoffset"; /*8458*/
		$k[$j++] = -0.3; /*8458*/
		$k[$j++] = "opt"; /*8458*/
		$k[$j++] = $1.options; /*8458*/
		var _4p = $d(); /*8458*/
		$k[$j++] = _4p; /*8461*/
		if (!$1.dontdraw) { /*8461*/
			$0.renlinear(); /*8461*/
		} /*8461*/
	};
	$0.postnet = function() {
		var $1 = {}; /*8488*/
		$1.options = $k[--$j]; /*8490*/
		$1.barcode = $k[--$j]; /*8491*/
		$1.dontdraw = false; /*8493*/
		$1.includetext = false; /*8494*/
		$1.validatecheck = false; /*8495*/
		$1.includecheckintext = false; /*8496*/
		$1.textfont = "Courier"; /*8497*/
		$1.textsize = 10; /*8498*/
		$1.textyoffset = -8.5; /*8499*/
		$1.height = 0.125; /*8500*/
		$forall($1.options, function() { /*8511*/
			var _3 = $k[--$j]; /*8511*/
			$1[$k[--$j]] = _3; /*8511*/
		}); /*8511*/
		$1.textfont = "" + $1.textfont; /*8513*/
		$1.textsize = +$1.textsize; /*8514*/
		$1.textyoffset = +$1.textyoffset; /*8515*/
		$1.height = +$1.height; /*8516*/
		$k[$j++] = "barlen"; /*8518*/
		$k[$j++] = $1.barcode.length; /*8518*/
		if ($1.validatecheck) { /*8518*/
			var _B = $k[--$j]; /*8518*/
			$k[$j++] = _B - 1; /*8518*/
		} /*8518*/
		var _C = $k[--$j]; /*8518*/
		$1[$k[--$j]] = _C; /*8518*/
		if ((($1.barlen != 5) && ($1.barlen != 9)) && ($1.barlen != 11)) { /*8523*/
			$k[$j++] = "bwipp.postnetBadLength"; /*8522*/
			$k[$j++] = "USPS POSTNET must be 5, 9 or 11 digits excluding check digit"; /*8522*/
			$0.raiseerror(); /*8522*/
		} /*8522*/
		$forall($1.barcode, function() { /*8528*/
			var _I = $k[--$j]; /*8525*/
			if ((_I < 48) || (_I > 57)) { /*8527*/
				$k[$j++] = "bwipp.postnetBadCharacter"; /*8526*/
				$k[$j++] = "USPS POSTNET must contain only digits"; /*8526*/
				$0.raiseerror(); /*8526*/
			} /*8526*/
		}); /*8526*/
		$1.barchars = "0123456789"; /*8531*/
		$1.checksum = 0; /*8533*/
		for (var _L = 0, _K = $1.barlen - 1; _L <= _K; _L += 1) { /*8537*/
			$1.i = _L; /*8535*/
			$1.checksum = $1.checksum + ($get($1.barcode, $1.i) - 48); /*8536*/
		} /*8536*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*8538*/
		if ($1.validatecheck) { /*8544*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*8542*/
				$k[$j++] = "bwipp.postnetBadCheckDigit"; /*8541*/
				$k[$j++] = "Incorrect USPS POSTNET check digit provided"; /*8541*/
				$0.raiseerror(); /*8541*/
			} /*8541*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*8543*/
		} /*8543*/
		$1.encs = $a(["55222", "22255", "22525", "22552", "25225", "25252", "25522", "52225", "52252", "52522", "5", "5"]); /*8551*/
		$1.bhs = $a(($1.barlen * 5) + 7); /*8553*/
		$1.txt = $a($1.barlen + 1); /*8554*/
		$1.enc = $get($1.encs, 10); /*8557*/
		$1.heights = $a($1.enc.length); /*8558*/
		for (var _m = 0, _l = $1.enc.length - 1; _m <= _l; _m += 1) { /*8562*/
			$1.j = _m; /*8560*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8561*/
		} /*8561*/
		$puti($1.bhs, 0, $1.heights); /*8563*/
		for (var _x = 0, _w = $1.barlen - 1; _x <= _w; _x += 1) { /*8575*/
			$1.i = _x; /*8566*/
			$1.enc = $get($1.encs, $get($1.barcode, $1.i) - 48); /*8567*/
			$1.heights = $a($1.enc.length); /*8568*/
			for (var _17 = 0, _16 = $1.enc.length - 1; _17 <= _16; _17 += 1) { /*8572*/
				$1.j = _17; /*8570*/
				$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8571*/
			} /*8571*/
			$puti($1.bhs, ($1.i * 5) + 1, $1.heights); /*8573*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8574*/
		} /*8574*/
		$1.enc = $get($1.encs, $1.checksum); /*8578*/
		$1.heights = $a($1.enc.length); /*8579*/
		for (var _1Y = 0, _1X = $1.enc.length - 1; _1Y <= _1X; _1Y += 1) { /*8583*/
			$1.j = _1Y; /*8581*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8582*/
		} /*8582*/
		$puti($1.bhs, ($1.barlen * 5) + 1, $1.heights); /*8584*/
		if ($1.includecheckintext) { /*8589*/
			$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), (($1.barlen * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8587*/
		} else { /*8589*/
			$put($1.txt, $1.barlen, $a([" ", ((($1.barlen * 5) + 1) * 72) / 25, $1.textyoffset, $1.textfont, $1.textsize])); /*8589*/
		} /*8589*/
		$1.enc = $get($1.encs, 11); /*8593*/
		$1.heights = $a($1.enc.length); /*8594*/
		for (var _26 = 0, _25 = $1.enc.length - 1; _26 <= _25; _26 += 1) { /*8598*/
			$1.j = _26; /*8596*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8597*/
		} /*8597*/
		$puti($1.bhs, ($1.barlen * 5) + 6, $1.heights); /*8599*/
		$k[$j++] = Infinity; /*8610*/
		$k[$j++] = "ren"; /*8606*/
		$k[$j++] = $0.renlinear; /*8606*/
		$k[$j++] = "bhs"; /*8606*/
		$k[$j++] = $1.bhs; /*8606*/
		$k[$j++] = "bbs"; /*8606*/
		$k[$j++] = Infinity; /*8606*/
		for (var _2I = 0, _2J = $1.bhs.length; _2I < _2J; _2I++) { /*8605*/
			$k[$j++] = 0; /*8605*/
		} /*8605*/
		var _2K = $a(); /*8606*/
		$k[$j++] = _2K; /*8607*/
		$k[$j++] = "sbs"; /*8607*/
		$k[$j++] = Infinity; /*8607*/
		for (var _2M = 0, _2N = $1.bhs.length - 1; _2M < _2N; _2M++) { /*8606*/
			$k[$j++] = 1.44; /*8606*/
			$k[$j++] = 1.872; /*8606*/
		} /*8606*/
		$k[$j++] = 1.44; /*8606*/
		var _2O = $a(); /*8607*/
		$k[$j++] = _2O; /*8609*/
		if ($1.includetext) { /*8609*/
			$k[$j++] = "txt"; /*8608*/
			$k[$j++] = $1.txt; /*8608*/
		} /*8608*/
		$k[$j++] = "opt"; /*8610*/
		$k[$j++] = $1.options; /*8610*/
		var _2S = $d(); /*8610*/
		$k[$j++] = _2S; /*8613*/
		if (!$1.dontdraw) { /*8613*/
			$0.renlinear(); /*8613*/
		} /*8613*/
	};
	$0.planet = function() {
		var $1 = {}; /*8640*/
		$1.options = $k[--$j]; /*8642*/
		$1.barcode = $k[--$j]; /*8643*/
		$1.dontdraw = false; /*8645*/
		$1.includetext = false; /*8646*/
		$1.validatecheck = false; /*8647*/
		$1.includecheckintext = false; /*8648*/
		$1.textfont = "Courier"; /*8649*/
		$1.textsize = 10; /*8650*/
		$1.textyoffset = -8.5; /*8651*/
		$1.height = 0.125; /*8652*/
		$forall($1.options, function() { /*8663*/
			var _3 = $k[--$j]; /*8663*/
			$1[$k[--$j]] = _3; /*8663*/
		}); /*8663*/
		$1.textfont = "" + $1.textfont; /*8665*/
		$1.textsize = +$1.textsize; /*8666*/
		$1.textyoffset = +$1.textyoffset; /*8667*/
		$1.height = +$1.height; /*8668*/
		$k[$j++] = "barlen"; /*8670*/
		$k[$j++] = $1.barcode.length; /*8670*/
		if ($1.validatecheck) { /*8670*/
			var _B = $k[--$j]; /*8670*/
			$k[$j++] = _B - 1; /*8670*/
		} /*8670*/
		var _C = $k[--$j]; /*8670*/
		$1[$k[--$j]] = _C; /*8670*/
		if (($1.barlen != 11) && ($1.barlen != 13)) { /*8675*/
			$k[$j++] = "bwipp.planetBadLength"; /*8674*/
			$k[$j++] = "USPS PLANET must be 11 or 13 digits excluding check digit"; /*8674*/
			$0.raiseerror(); /*8674*/
		} /*8674*/
		$forall($1.barcode, function() { /*8680*/
			var _H = $k[--$j]; /*8677*/
			if ((_H < 48) || (_H > 57)) { /*8679*/
				$k[$j++] = "bwipp.planetBadCharacter"; /*8678*/
				$k[$j++] = "USPS PLANET must contain only digits"; /*8678*/
				$0.raiseerror(); /*8678*/
			} /*8678*/
		}); /*8678*/
		$1.barchars = "0123456789"; /*8683*/
		$1.checksum = 0; /*8686*/
		for (var _K = 0, _J = $1.barlen - 1; _K <= _J; _K += 1) { /*8690*/
			$1.i = _K; /*8688*/
			$1.checksum = $1.checksum + ($get($1.barcode, $1.i) - 48); /*8689*/
		} /*8689*/
		$1.checksum = (10 - ($1.checksum % 10)) % 10; /*8691*/
		if ($1.validatecheck) { /*8697*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*8695*/
				$k[$j++] = "bwipp.planetBadCheckDigit"; /*8694*/
				$k[$j++] = "Incorrect USPS PLANET check digit provided"; /*8694*/
				$0.raiseerror(); /*8694*/
			} /*8694*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*8696*/
		} /*8696*/
		$1.encs = $a(["22555", "55522", "55252", "55225", "52552", "52525", "52255", "25552", "25525", "25255", "5", "5"]); /*8704*/
		$1.bhs = $a(($1.barlen * 5) + 7); /*8706*/
		$1.txt = $a($1.barlen + 1); /*8707*/
		$1.enc = $get($1.encs, 10); /*8710*/
		$1.heights = $a($1.enc.length); /*8711*/
		for (var _l = 0, _k = $1.enc.length - 1; _l <= _k; _l += 1) { /*8715*/
			$1.j = _l; /*8713*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8714*/
		} /*8714*/
		$puti($1.bhs, 0, $1.heights); /*8716*/
		for (var _w = 0, _v = $1.barlen - 1; _w <= _v; _w += 1) { /*8728*/
			$1.i = _w; /*8719*/
			$1.enc = $get($1.encs, $get($1.barcode, $1.i) - 48); /*8720*/
			$1.heights = $a($1.enc.length); /*8721*/
			for (var _16 = 0, _15 = $1.enc.length - 1; _16 <= _15; _16 += 1) { /*8725*/
				$1.j = _16; /*8723*/
				$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8724*/
			} /*8724*/
			$puti($1.bhs, ($1.i * 5) + 1, $1.heights); /*8726*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8727*/
		} /*8727*/
		$1.enc = $get($1.encs, $1.checksum); /*8731*/
		$1.heights = $a($1.enc.length); /*8732*/
		for (var _1X = 0, _1W = $1.enc.length - 1; _1X <= _1W; _1X += 1) { /*8736*/
			$1.j = _1X; /*8734*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8735*/
		} /*8735*/
		$puti($1.bhs, ($1.barlen * 5) + 1, $1.heights); /*8737*/
		if ($1.includecheckintext) { /*8742*/
			$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), (($1.barlen * 5) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8740*/
		} else { /*8742*/
			$put($1.txt, $1.barlen, $a([" ", ((($1.barlen * 5) + 1) * 72) / 25, $1.textyoffset, $1.textfont, $1.textsize])); /*8742*/
		} /*8742*/
		$1.enc = $get($1.encs, 11); /*8746*/
		$1.heights = $a($1.enc.length); /*8747*/
		for (var _25 = 0, _24 = $1.enc.length - 1; _25 <= _24; _25 += 1) { /*8751*/
			$1.j = _25; /*8749*/
			$put($1.heights, $1.j, ((~~$z($geti($1.enc, $1.j, 1))) * $1.height) / 5); /*8750*/
		} /*8750*/
		$puti($1.bhs, ($1.barlen * 5) + 6, $1.heights); /*8752*/
		$k[$j++] = Infinity; /*8763*/
		$k[$j++] = "ren"; /*8759*/
		$k[$j++] = $0.renlinear; /*8759*/
		$k[$j++] = "bhs"; /*8759*/
		$k[$j++] = $1.bhs; /*8759*/
		$k[$j++] = "bbs"; /*8759*/
		$k[$j++] = Infinity; /*8759*/
		for (var _2H = 0, _2I = $1.bhs.length; _2H < _2I; _2H++) { /*8758*/
			$k[$j++] = 0; /*8758*/
		} /*8758*/
		var _2J = $a(); /*8759*/
		$k[$j++] = _2J; /*8760*/
		$k[$j++] = "sbs"; /*8760*/
		$k[$j++] = Infinity; /*8760*/
		for (var _2L = 0, _2M = $1.bhs.length - 1; _2L < _2M; _2L++) { /*8759*/
			$k[$j++] = 1.44; /*8759*/
			$k[$j++] = 1.872; /*8759*/
		} /*8759*/
		$k[$j++] = 1.44; /*8759*/
		var _2N = $a(); /*8760*/
		$k[$j++] = _2N; /*8762*/
		if ($1.includetext) { /*8762*/
			$k[$j++] = "txt"; /*8761*/
			$k[$j++] = $1.txt; /*8761*/
		} /*8761*/
		$k[$j++] = "opt"; /*8763*/
		$k[$j++] = $1.options; /*8763*/
		var _2R = $d(); /*8763*/
		$k[$j++] = _2R; /*8766*/
		if (!$1.dontdraw) { /*8766*/
			$0.renlinear(); /*8766*/
		} /*8766*/
	};
	$0.royalmail = function() {
		var $1 = {}; /*8793*/
		$1.options = $k[--$j]; /*8795*/
		$1.barcode = $k[--$j]; /*8796*/
		$1.dontdraw = false; /*8798*/
		$1.includetext = false; /*8799*/
		$1.validatecheck = false; /*8800*/
		$1.includecheckintext = false; /*8801*/
		$1.textfont = "Courier"; /*8802*/
		$1.textsize = 10; /*8803*/
		$1.textyoffset = -8.5; /*8804*/
		$1.height = 0.175; /*8805*/
		$forall($1.options, function() { /*8816*/
			var _3 = $k[--$j]; /*8816*/
			$1[$k[--$j]] = _3; /*8816*/
		}); /*8816*/
		$1.textfont = "" + $1.textfont; /*8818*/
		$1.textsize = +$1.textsize; /*8819*/
		$1.textyoffset = +$1.textyoffset; /*8820*/
		$1.height = +$1.height; /*8821*/
		$1.barchars = "ZUVWXY501234B6789AHCDEFGNIJKLMTOPQRS"; /*8824*/
		$1.charvals = {}; /*8825*/
		for (var _9 = 0; _9 <= 35; _9 += 1) { /*8826*/
			$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*8826*/
		} /*8826*/
		for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*8833*/
			var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*8830*/
			if (!_J) { /*8832*/
				$k[$j++] = "bwipp.royalmailBadCharacter"; /*8831*/
				$k[$j++] = "RM4SCC must contain only capital letters and digits"; /*8831*/
				$0.raiseerror(); /*8831*/
			} /*8831*/
		} /*8831*/
		$k[$j++] = "barlen"; /*8835*/
		$k[$j++] = $1.barcode.length; /*8835*/
		if ($1.validatecheck) { /*8835*/
			var _M = $k[--$j]; /*8835*/
			$k[$j++] = _M - 1; /*8835*/
		} /*8835*/
		var _N = $k[--$j]; /*8835*/
		$1[$k[--$j]] = _N; /*8835*/
		$1.checksumrow = 0; /*8837*/
		$1.checksumcol = 0; /*8838*/
		for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*8844*/
			$1.i = _R; /*8840*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*8841*/
			$1.checksumrow = $1.checksumrow + (~~($1.indx / 6)); /*8842*/
			$1.checksumcol = $1.checksumcol + ($1.indx % 6); /*8843*/
		} /*8843*/
		$1.checksum = (($1.checksumrow % 6) * 6) + ($1.checksumcol % 6); /*8845*/
		if ($1.validatecheck) { /*8851*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*8849*/
				$k[$j++] = "bwipp.royalmailBadCheckDigit"; /*8848*/
				$k[$j++] = "Incorrect RM4SCC check digit provided"; /*8848*/
				$0.raiseerror(); /*8848*/
			} /*8848*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*8850*/
		} /*8850*/
		$1.encs = $a(["3300", "2211", "2301", "2310", "3201", "3210", "1122", "0033", "0123", "0132", "1023", "1032", "1302", "0213", "0303", "0312", "1203", "1212", "1320", "0231", "0321", "0330", "1221", "1230", "3102", "2013", "2103", "2112", "3003", "3012", "3120", "2031", "2121", "2130", "3021", "3030", "2", "3"]); /*8862*/
		$1.encstr = $s(($1.barlen * 4) + 6); /*8864*/
		$1.txt = $a($1.barlen + 1); /*8865*/
		$puti($1.encstr, 0, $get($1.encs, 36)); /*8868*/
		for (var _x = 0, _w = $1.barlen - 1; _x <= _w; _x += 1) { /*8875*/
			$1.i = _x; /*8871*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*8872*/
			$puti($1.encstr, ($1.i * 4) + 1, $get($1.encs, $1.indx)); /*8873*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.i * 4) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8874*/
		} /*8874*/
		$puti($1.encstr, ($1.barlen * 4) + 1, $get($1.encs, $1.checksum)); /*8878*/
		if ($1.includecheckintext) { /*8882*/
			$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum, 1), (($1.barlen * 4) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8880*/
		} else { /*8882*/
			$put($1.txt, $1.barlen, $a([" ", (($1.barlen * 4) + 1) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*8882*/
		} /*8882*/
		$puti($1.encstr, ($1.barlen * 4) + 5, $get($1.encs, 37)); /*8886*/
		$1.bbs = $a($1.encstr.length); /*8888*/
		$1.bhs = $a($1.encstr.length); /*8889*/
		for (var _1p = 0, _1o = $1.encstr.length - 1; _1p <= _1o; _1p += 1) { /*8909*/
			$1.i = _1p; /*8891*/
			$1.enc = $geti($1.encstr, $1.i, 1); /*8892*/
			if ($eq($1.enc, "0")) { /*8896*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8894*/
				$put($1.bhs, $1.i, (2 * $1.height) / 8); /*8895*/
			} /*8895*/
			if ($eq($1.enc, "1")) { /*8900*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8898*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8899*/
			} /*8899*/
			if ($eq($1.enc, "2")) { /*8904*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*8902*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*8903*/
			} /*8903*/
			if ($eq($1.enc, "3")) { /*8908*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*8906*/
				$put($1.bhs, $1.i, (8 * $1.height) / 8); /*8907*/
			} /*8907*/
		} /*8907*/
		$k[$j++] = Infinity; /*8920*/
		$k[$j++] = "ren"; /*8917*/
		$k[$j++] = $0.renlinear; /*8917*/
		$k[$j++] = "bbs"; /*8917*/
		$k[$j++] = $1.bbs; /*8917*/
		$k[$j++] = "bhs"; /*8917*/
		$k[$j++] = $1.bhs; /*8917*/
		$k[$j++] = "sbs"; /*8917*/
		$k[$j++] = Infinity; /*8917*/
		for (var _2O = 0, _2P = $1.bhs.length - 1; _2O < _2P; _2O++) { /*8916*/
			$k[$j++] = 1.44; /*8916*/
			$k[$j++] = 1.872; /*8916*/
		} /*8916*/
		$k[$j++] = 1.44; /*8916*/
		var _2Q = $a(); /*8917*/
		$k[$j++] = _2Q; /*8919*/
		if ($1.includetext) { /*8919*/
			$k[$j++] = "txt"; /*8918*/
			$k[$j++] = $1.txt; /*8918*/
		} /*8918*/
		$k[$j++] = "opt"; /*8920*/
		$k[$j++] = $1.options; /*8920*/
		var _2U = $d(); /*8920*/
		$k[$j++] = _2U; /*8923*/
		if (!$1.dontdraw) { /*8923*/
			$0.renlinear(); /*8923*/
		} /*8923*/
	};
	$0.auspost = function() {
		var $1 = {}; /*8950*/
		$1.options = $k[--$j]; /*8952*/
		$1.barcode = $k[--$j]; /*8953*/
		$1.dontdraw = false; /*8955*/
		$1.includetext = false; /*8956*/
		$1.textfont = "Courier"; /*8957*/
		$1.textsize = 10; /*8958*/
		$1.textyoffset = -8.5; /*8959*/
		$1.height = 0.175; /*8960*/
		$1.custinfoenc = "character"; /*8961*/
		$forall($1.options, function() { /*8972*/
			var _3 = $k[--$j]; /*8972*/
			$1[$k[--$j]] = _3; /*8972*/
		}); /*8972*/
		$1.textfont = "" + $1.textfont; /*8974*/
		$1.textsize = +$1.textsize; /*8975*/
		$1.textyoffset = +$1.textyoffset; /*8976*/
		$1.height = +$1.height; /*8977*/
		$1.encs = $a(["000", "001", "002", "010", "011", "012", "020", "021", "022", "100", "101", "102", "110", "111", "112", "120", "121", "122", "200", "201", "202", "210", "211", "212", "220", "221", "222", "300", "301", "302", "310", "311", "312", "320", "321", "322", "023", "030", "031", "032", "033", "103", "113", "123", "130", "131", "132", "133", "203", "213", "223", "230", "231", "232", "233", "303", "313", "323", "330", "331", "332", "333", "003", "013", "00", "01", "02", "10", "11", "12", "20", "21", "22", "30", "13", "3"]); /*8991*/
		$1.barchars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz #"; /*8994*/
		$1.barlen = $1.barcode.length; /*8996*/
		if ($eq($geti($1.barcode, 0, 2), "11")) { /*8997*/
			$k[$j++] = 37; /*8997*/
		} /*8997*/
		if ($eq($geti($1.barcode, 0, 2), "45")) { /*8998*/
			$k[$j++] = 37; /*8998*/
		} /*8998*/
		if ($eq($geti($1.barcode, 0, 2), "59")) { /*8999*/
			$k[$j++] = 52; /*8999*/
		} /*8999*/
		if ($eq($geti($1.barcode, 0, 2), "62")) { /*9000*/
			$k[$j++] = 67; /*9000*/
		} /*9000*/
		$1.encstr = $s($k[--$j]); /*9001*/
		$1.txt = $a($1.barlen - 2); /*9002*/
		$puti($1.encstr, 0, $get($1.encs, 74)); /*9005*/
		for (var _Q = 0; _Q <= 1; _Q += 1) { /*9012*/
			$1.i = _Q; /*9009*/
			$puti($1.encstr, ($1.i * 2) + 2, $get($1.encs, (~~$z($geti($1.barcode, $1.i, 1))) + 64)); /*9011*/
		} /*9011*/
		for (var _Y = 2; _Y <= 9; _Y += 1) { /*9020*/
			$1.i = _Y; /*9016*/
			$puti($1.encstr, ($1.i * 2) + 2, $get($1.encs, (~~$z($geti($1.barcode, $1.i, 1))) + 64)); /*9018*/
			$put($1.txt, $1.i - 2, $a([$geti($1.barcode, $1.i, 1), ((($1.i - 2) * 2) + 6) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9019*/
		} /*9019*/
		if ($eq($1.custinfoenc, "numeric")) { /*9042*/
			for (var _t = 0, _s = $1.barlen - 11; _t <= _s; _t += 1) { /*9029*/
				$1.i = _t; /*9025*/
				$puti($1.encstr, ($1.i * 2) + 22, $get($1.encs, (~~$z($geti($1.barcode, $1.i + 10, 1))) + 64)); /*9027*/
				$put($1.txt, $1.i + 8, $a([$geti($1.barcode, $1.i + 10, 1), (($1.i * 2) + 22) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9028*/
			} /*9028*/
			$1.ciflen = ($1.barlen - 10) * 2; /*9030*/
		} else { /*9042*/
			for (var _1E = 0, _1D = $1.barlen - 11; _1E <= _1D; _1E += 1) { /*9041*/
				$1.i = _1E; /*9033*/
				$search($1.barchars, $geti($1.barcode, $1.i + 10, 1)); /*9034*/
				$j--; /*9035*/
				$1.indx = $k[--$j].length; /*9036*/
				$j -= 2; /*9037*/
				$1.enc = $get($1.encs, $1.indx); /*9038*/
				$puti($1.encstr, ($1.i * 3) + 22, $1.enc); /*9039*/
				$put($1.txt, $1.i + 8, $a([$geti($1.barcode, $1.i + 10, 1), (($1.i * 3) + 22) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9040*/
			} /*9040*/
			$1.ciflen = ($1.barlen - 10) * 3; /*9042*/
		} /*9042*/
		for (var _1e = 22 + $1.ciflen, _1d = $1.encstr.length - 14; _1e <= _1d; _1e += 1) { /*9048*/
			$puti($1.encstr, _1e, $get($1.encs, 75)); /*9047*/
		} /*9047*/
		$1.rstable = $a(64 * 64); /*9051*/
		$k[$j++] = $1.rstable; /*9052*/
		$k[$j++] = 0; /*9052*/
		$k[$j++] = Infinity; /*9052*/
		for (var _1k = 0, _1l = 64; _1k < _1l; _1k++) { /*9052*/
			$k[$j++] = 0; /*9052*/
		} /*9052*/
		var _1m = $a(); /*9052*/
		var _1n = $k[--$j]; /*9052*/
		$puti($k[--$j], _1n, _1m); /*9052*/
		$k[$j++] = $1.rstable; /*9053*/
		$k[$j++] = 64; /*9053*/
		$k[$j++] = Infinity; /*9053*/
		for (var _1q = 0; _1q <= 63; _1q += 1) { /*9053*/
			$k[$j++] = _1q; /*9053*/
		} /*9053*/
		var _1r = $a(); /*9053*/
		var _1s = $k[--$j]; /*9053*/
		$puti($k[--$j], _1s, _1r); /*9053*/
		$1.prev = 1; /*9054*/
		for (var _1u = 0, _1v = 64; _1u < _1v; _1u++) { /*9069*/
			$1.next = $1.prev << 1; /*9056*/
			if (($1.next & 64) != 0) { /*9059*/
				$1.next = $1.next ^ 67; /*9058*/
			} /*9058*/
			for (var _1z = 0; _1z <= 63; _1z += 1) { /*9067*/
				$1.j = _1z; /*9061*/
				$1.nextcell = function() {
					$k[$j++] = $1.rstable; /*9062*/
					$k[$j++] = (64 * $1.next) + $1.j; /*9062*/
				}; /*9062*/
				if ($1.nextcell() == $b) break; /*9063*/
				var _27 = $k[--$j]; /*9063*/
				$put($k[--$j], _27, $get($1.rstable, (64 * $1.prev) + $1.j) << 1); /*9063*/
				if ($1.nextcell() == $b) break; /*9064*/
				var _29 = $k[--$j]; /*9064*/
				if (($get($k[--$j], _29) & 64) != 0) { /*9066*/
					if ($1.nextcell() == $b) break; /*9065*/
					if ($1.nextcell() == $b) break; /*9065*/
					var _2C = $k[--$j]; /*9065*/
					var _2E = $get($k[--$j], _2C); /*9065*/
					var _2F = $k[--$j]; /*9065*/
					$put($k[--$j], _2F, _2E ^ 67); /*9065*/
				} /*9065*/
			} /*9065*/
			$1.prev = $1.next; /*9068*/
		} /*9068*/
		$1.rscodes = $a((~~(($1.encstr.length - 16) / 3)) + 4); /*9072*/
		$k[$j++] = $1.rscodes; /*9073*/
		$k[$j++] = 0; /*9073*/
		$k[$j++] = Infinity; /*9073*/
		for (var _2L = 0, _2M = 4; _2L < _2M; _2L++) { /*9073*/
			$k[$j++] = 0; /*9073*/
		} /*9073*/
		var _2N = $a(); /*9073*/
		var _2O = $k[--$j]; /*9073*/
		$puti($k[--$j], _2O, _2N); /*9073*/
		for (var _2S = 2, _2R = $1.encstr.length - 16; _2S <= _2R; _2S += 3) { /*9081*/
			$1.i = _2S; /*9075*/
			$put($1.rscodes, ($1.rscodes.length - (~~(($1.i - 2) / 3))) - 1, (((~~$z($geti($1.encstr, $1.i, 1))) * 16) + ((~~$z($geti($1.encstr, $1.i + 1, 1))) * 4)) + (~~$z($geti($1.encstr, $1.i + 2, 1)))); /*9080*/
		} /*9080*/
		for (var _2g = $1.rscodes.length - 5; _2g >= 0; _2g -= 1) { /*9090*/
			$1.i = _2g; /*9083*/
			for (var _2h = 0; _2h <= 4; _2h += 1) { /*9089*/
				$1.j = _2h; /*9085*/
				$put($1.rscodes, $1.i + $1.j, $xo($get($1.rscodes, $1.i + $1.j), $get($1.rstable, (64 * $get($a([48, 17, 29, 30, 1]), $1.j)) + $get($1.rscodes, $1.i + 4)))); /*9088*/
			} /*9088*/
		} /*9088*/
		$1.checkcode = $strcpy($s(12), "000000000000"); /*9091*/
		for (var _2z = 0; _2z <= 3; _2z += 1) { /*9096*/
			$1.i = _2z; /*9093*/
			$1.enc = $cvrs($s(3), $get($1.rscodes, 3 - $1.i), 4); /*9094*/
			$puti($1.checkcode, ($1.i * 3) + (3 - $1.enc.length), $1.enc); /*9095*/
		} /*9095*/
		$puti($1.encstr, $1.encstr.length - 14, $1.checkcode); /*9099*/
		$puti($1.encstr, $1.encstr.length - 2, $get($1.encs, 74)); /*9100*/
		$1.bbs = $a($1.encstr.length); /*9102*/
		$1.bhs = $a($1.encstr.length); /*9103*/
		for (var _3M = 0, _3L = $1.encstr.length - 1; _3M <= _3L; _3M += 1) { /*9123*/
			$1.i = _3M; /*9105*/
			$1.enc = $geti($1.encstr, $1.i, 1); /*9106*/
			if ($eq($1.enc, "0")) { /*9110*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*9108*/
				$put($1.bhs, $1.i, (8 * $1.height) / 8); /*9109*/
			} /*9109*/
			if ($eq($1.enc, "1")) { /*9114*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*9112*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*9113*/
			} /*9113*/
			if ($eq($1.enc, "2")) { /*9118*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*9116*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*9117*/
			} /*9117*/
			if ($eq($1.enc, "3")) { /*9122*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*9120*/
				$put($1.bhs, $1.i, (2 * $1.height) / 8); /*9121*/
			} /*9121*/
		} /*9121*/
		$k[$j++] = Infinity; /*9134*/
		$k[$j++] = "ren"; /*9131*/
		$k[$j++] = $0.renlinear; /*9131*/
		$k[$j++] = "bbs"; /*9131*/
		$k[$j++] = $1.bbs; /*9131*/
		$k[$j++] = "bhs"; /*9131*/
		$k[$j++] = $1.bhs; /*9131*/
		$k[$j++] = "sbs"; /*9131*/
		$k[$j++] = Infinity; /*9131*/
		for (var _3v = 0, _3w = $1.bhs.length - 1; _3v < _3w; _3v++) { /*9130*/
			$k[$j++] = 1.44; /*9130*/
			$k[$j++] = 1.872; /*9130*/
		} /*9130*/
		$k[$j++] = 1.44; /*9130*/
		var _3x = $a(); /*9131*/
		$k[$j++] = _3x; /*9133*/
		if ($1.includetext) { /*9133*/
			$k[$j++] = "txt"; /*9132*/
			$k[$j++] = $1.txt; /*9132*/
		} /*9132*/
		$k[$j++] = "opt"; /*9134*/
		$k[$j++] = $1.options; /*9134*/
		var _41 = $d(); /*9134*/
		$k[$j++] = _41; /*9137*/
		if (!$1.dontdraw) { /*9137*/
			$0.renlinear(); /*9137*/
		} /*9137*/
	};
	$0.kix = function() {
		var $1 = {}; /*9164*/
		$1.options = $k[--$j]; /*9166*/
		$1.barcode = $k[--$j]; /*9167*/
		$1.dontdraw = false; /*9169*/
		$1.includetext = false; /*9170*/
		$1.textfont = "Courier"; /*9171*/
		$1.textsize = 10; /*9172*/
		$1.textyoffset = -8.5; /*9173*/
		$1.height = 0.175; /*9174*/
		$forall($1.options, function() { /*9185*/
			var _3 = $k[--$j]; /*9185*/
			$1[$k[--$j]] = _3; /*9185*/
		}); /*9185*/
		$1.textfont = "" + $1.textfont; /*9187*/
		$1.textsize = +$1.textsize; /*9188*/
		$1.textyoffset = +$1.textyoffset; /*9189*/
		$1.height = +$1.height; /*9190*/
		$1.encs = $a(["0033", "0123", "0132", "1023", "1032", "1122", "0213", "0303", "0312", "1203", "1212", "1302", "0231", "0321", "0330", "1221", "1230", "1320", "2013", "2103", "2112", "3003", "3012", "3102", "2031", "2121", "2130", "3021", "3030", "3120", "2211", "2301", "2310", "3201", "3210", "3300"]); /*9200*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"; /*9203*/
		$1.charvals = {}; /*9204*/
		for (var _A = 0; _A <= 35; _A += 1) { /*9205*/
			$put($1.charvals, $geti($1.barchars, _A, 1), _A); /*9205*/
		} /*9205*/
		for (var _G = 0, _F = $1.barcode.length - 1; _G <= _F; _G += 1) { /*9212*/
			var _K = $get($1.charvals, $geti($1.barcode, _G, 1)) !== undefined; /*9209*/
			if (!_K) { /*9211*/
				$k[$j++] = "bwipp.kixBadCharacter"; /*9210*/
				$k[$j++] = "KIX must contain only capital letters and digits"; /*9210*/
				$0.raiseerror(); /*9210*/
			} /*9210*/
		} /*9210*/
		$1.barlen = $1.barcode.length; /*9214*/
		$1.encstr = $s($1.barlen * 4); /*9215*/
		$1.txt = $a($1.barlen); /*9216*/
		for (var _S = 0, _R = $1.barlen - 1; _S <= _R; _S += 1) { /*9223*/
			$1.i = _S; /*9219*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*9220*/
			$puti($1.encstr, $1.i * 4, $get($1.encs, $1.indx)); /*9221*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 4) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9222*/
		} /*9222*/
		$1.bbs = $a($1.encstr.length); /*9225*/
		$1.bhs = $a($1.encstr.length); /*9226*/
		for (var _t = 0, _s = $1.encstr.length - 1; _t <= _s; _t += 1) { /*9246*/
			$1.i = _t; /*9228*/
			$1.enc = $geti($1.encstr, $1.i, 1); /*9229*/
			if ($eq($1.enc, "0")) { /*9233*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*9231*/
				$put($1.bhs, $1.i, (2 * $1.height) / 8); /*9232*/
			} /*9232*/
			if ($eq($1.enc, "1")) { /*9237*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*9235*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*9236*/
			} /*9236*/
			if ($eq($1.enc, "2")) { /*9241*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*9239*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*9240*/
			} /*9240*/
			if ($eq($1.enc, "3")) { /*9245*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*9243*/
				$put($1.bhs, $1.i, (8 * $1.height) / 8); /*9244*/
			} /*9244*/
		} /*9244*/
		$k[$j++] = Infinity; /*9257*/
		$k[$j++] = "ren"; /*9254*/
		$k[$j++] = $0.renlinear; /*9254*/
		$k[$j++] = "bbs"; /*9254*/
		$k[$j++] = $1.bbs; /*9254*/
		$k[$j++] = "bhs"; /*9254*/
		$k[$j++] = $1.bhs; /*9254*/
		$k[$j++] = "sbs"; /*9254*/
		$k[$j++] = Infinity; /*9254*/
		for (var _1S = 0, _1T = $1.bhs.length - 1; _1S < _1T; _1S++) { /*9253*/
			$k[$j++] = 1.44; /*9253*/
			$k[$j++] = 1.872; /*9253*/
		} /*9253*/
		$k[$j++] = 1.44; /*9253*/
		var _1U = $a(); /*9254*/
		$k[$j++] = _1U; /*9256*/
		if ($1.includetext) { /*9256*/
			$k[$j++] = "txt"; /*9255*/
			$k[$j++] = $1.txt; /*9255*/
		} /*9255*/
		$k[$j++] = "opt"; /*9257*/
		$k[$j++] = $1.options; /*9257*/
		var _1Y = $d(); /*9257*/
		$k[$j++] = _1Y; /*9260*/
		if (!$1.dontdraw) { /*9260*/
			$0.renlinear(); /*9260*/
		} /*9260*/
	};
	$0.japanpost = function() {
		var $1 = {}; /*9287*/
		$1.options = $k[--$j]; /*9289*/
		$1.barcode = $k[--$j]; /*9290*/
		$1.dontdraw = false; /*9292*/
		$1.includetext = false; /*9293*/
		$1.includecheckintext = false; /*9294*/
		$1.textfont = "Courier"; /*9295*/
		$1.textsize = 10; /*9296*/
		$1.textyoffset = -8.5; /*9297*/
		$1.height = 0.175; /*9298*/
		$forall($1.options, function() { /*9309*/
			var _3 = $k[--$j]; /*9309*/
			$1[$k[--$j]] = _3; /*9309*/
		}); /*9309*/
		$1.textfont = "" + $1.textfont; /*9311*/
		$1.textsize = +$1.textsize; /*9312*/
		$1.textyoffset = +$1.textyoffset; /*9313*/
		$1.height = +$1.height; /*9314*/
		$1.encs = $a(["300", "330", "312", "132", "321", "303", "123", "231", "213", "033", "030", "120", "102", "210", "012", "201", "021", "003", "333", "31", "13"]); /*9322*/
		$1.barchars = "0123456789-ABCDEFGHIJKLMNOPQRSTUVWXYZ"; /*9325*/
		$1.barlen = $1.barcode.length; /*9326*/
		$1.encstr = $s(((20 + 1) * 3) + 4); /*9328*/
		$1.digits = $a(20); /*9329*/
		$1.txt = $a($1.barlen + 1); /*9330*/
		$puti($1.encstr, 0, $get($1.encs, 19)); /*9333*/
		$1.checksum = 0; /*9335*/
		$1.j = 0; /*9336*/
		$1.i = 0; /*9336*/
		for (var _K = 0, _J = $1.barlen - 1; _K <= _J; _K += 1) { /*9370*/
			$1.i = _K; /*9338*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*9339*/
			$j--; /*9340*/
			$1.indx = $k[--$j].length; /*9341*/
			$j -= 2; /*9342*/
			if (($1.indx >= 11) && ($1.indx < 37)) { /*9353*/
				if ($1.j > 18) { /*9344*/
					break; /*9344*/
				} /*9344*/
				$1.digit = (~~(($1.indx - 1) / 10)) + 10; /*9348*/
				$puti($1.encstr, ($1.j * 3) + 2, $get($1.encs, $1.digit)); /*9349*/
				$1.checksum = $1.checksum + $1.digit; /*9350*/
				$put($1.digits, $1.j, $1.digit); /*9351*/
				$1.j = $1.j + 1; /*9352*/
			} /*9352*/
			if ($1.j > 19) { /*9354*/
				break; /*9354*/
			} /*9354*/
			$1.digit = 0; /*9355*/
			if ($1.indx == 37) { /*9358*/
				$1.digit = 14; /*9357*/
			} /*9357*/
			if (($1.indx >= 11) && ($1.indx < 37)) { /*9361*/
				$1.digit = ($1.indx - 1) % 10; /*9360*/
			} /*9360*/
			if ($1.indx < 11) { /*9364*/
				$1.digit = $1.indx; /*9363*/
			} /*9363*/
			$puti($1.encstr, ($1.j * 3) + 2, $get($1.encs, $1.digit)); /*9365*/
			$1.checksum = $1.checksum + $1.digit; /*9366*/
			$put($1.digits, $1.j, $1.digit); /*9367*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), (($1.j * 3) + 2) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9368*/
			$1.j = $1.j + 1; /*9369*/
		} /*9369*/
		for (var _19 = $1.j, _18 = 20 - 1; _19 <= _18; _19 += 1) { /*9378*/
			$1.k = _19; /*9374*/
			$puti($1.encstr, ($1.k * 3) + 2, $get($1.encs, 14)); /*9375*/
			$1.checksum = $1.checksum + 14; /*9376*/
			$put($1.digits, $1.k, 14); /*9377*/
		} /*9377*/
		$1.checksum = 19 - ($1.checksum % 19); /*9381*/
		$puti($1.encstr, 2 + (20 * 3), $get($1.encs, $1.checksum)); /*9382*/
		$puti($1.encstr, 2 + (21 * 3), $get($1.encs, 20)); /*9385*/
		$1.checkdigit = " "; /*9386*/
		if ($1.includecheckintext) { /*9389*/
			$1.checkdigit = $geti($1.barchars, $1.checksum, 1); /*9388*/
		} /*9388*/
		$put($1.txt, $1.i + 1, $a([$1.checkdigit, ((20 * 3) + 2) * 3.312, $1.textyoffset, $1.textfont, $1.textsize])); /*9390*/
		$puti($1.encstr, ((20 + 1) * 3) + 2, $get($1.encs, 20)); /*9393*/
		$1.bbs = $a((21 * 3) + 4); /*9395*/
		$1.bhs = $a($1.bbs.length); /*9396*/
		for (var _1i = 0, _1h = $1.bbs.length - 1; _1i <= _1h; _1i += 1) { /*9420*/
			$1.i = _1i; /*9398*/
			$1.enc = $geti($1.encstr, $1.i, 1); /*9399*/
			$1.bunit = 0; /*9400*/
			$1.hunit = 0; /*9401*/
			if ($eq($1.enc, "0")) { /*9405*/
				$1.bunit = 3; /*9403*/
				$1.hunit = 2; /*9404*/
			} /*9404*/
			if ($eq($1.enc, "1")) { /*9409*/
				$1.bunit = 0; /*9407*/
				$1.hunit = 5; /*9408*/
			} /*9408*/
			if ($eq($1.enc, "2")) { /*9413*/
				$1.bunit = 3; /*9411*/
				$1.hunit = 5; /*9412*/
			} /*9412*/
			if ($eq($1.enc, "3")) { /*9417*/
				$1.bunit = 0; /*9415*/
				$1.hunit = 8; /*9416*/
			} /*9416*/
			$put($1.bbs, $1.i, ($1.bunit * $1.height) / 8); /*9418*/
			$put($1.bhs, $1.i, ($1.hunit * $1.height) / 8); /*9419*/
		} /*9419*/
		$k[$j++] = Infinity; /*9431*/
		$k[$j++] = "ren"; /*9428*/
		$k[$j++] = $0.renlinear; /*9428*/
		$k[$j++] = "bbs"; /*9428*/
		$k[$j++] = $1.bbs; /*9428*/
		$k[$j++] = "bhs"; /*9428*/
		$k[$j++] = $1.bhs; /*9428*/
		$k[$j++] = "sbs"; /*9428*/
		$k[$j++] = Infinity; /*9428*/
		for (var _21 = 0, _22 = $1.bhs.length - 1; _21 < _22; _21++) { /*9427*/
			$k[$j++] = 1.44; /*9427*/
			$k[$j++] = 1.872; /*9427*/
		} /*9427*/
		$k[$j++] = 1.44; /*9427*/
		var _23 = $a(); /*9428*/
		$k[$j++] = _23; /*9430*/
		if ($1.includetext) { /*9430*/
			$k[$j++] = "txt"; /*9429*/
			$k[$j++] = $1.txt; /*9429*/
		} /*9429*/
		$k[$j++] = "opt"; /*9431*/
		$k[$j++] = $1.options; /*9431*/
		var _27 = $d(); /*9431*/
		$k[$j++] = _27; /*9434*/
		if (!$1.dontdraw) { /*9434*/
			$0.renlinear(); /*9434*/
		} /*9434*/
	};
	$0.msi = function() {
		var $1 = {}; /*9461*/
		$1.options = $k[--$j]; /*9463*/
		$1.barcode = $k[--$j]; /*9464*/
		$1.dontdraw = false; /*9466*/
		$1.includecheck = false; /*9467*/
		$1.includetext = false; /*9468*/
		$1.includecheckintext = false; /*9469*/
		$1.checktype = "mod10"; /*9470*/
		$1.badmod11 = false; /*9471*/
		$1.textfont = "Courier"; /*9472*/
		$1.textsize = 10; /*9473*/
		$1.textyoffset = -8.5; /*9474*/
		$1.height = 1; /*9475*/
		$forall($1.options, function() { /*9486*/
			var _3 = $k[--$j]; /*9486*/
			$1[$k[--$j]] = _3; /*9486*/
		}); /*9486*/
		$1.textfont = "" + $1.textfont; /*9488*/
		$1.textsize = +$1.textsize; /*9489*/
		$1.textyoffset = +$1.textyoffset; /*9490*/
		$1.height = +$1.height; /*9491*/
		$1.encs = $a(["12121212", "12121221", "12122112", "12122121", "12211212", "12211221", "12212112", "12212121", "21121212", "21121221", "21", "121"]); /*9498*/
		$1.barchars = "0123456789"; /*9501*/
		$1.barlen = $1.barcode.length; /*9503*/
		$1.txtlen = $1.barlen; /*9504*/
		$1.mod10 = function() {
			$1.code = $k[--$j]; /*9507*/
			$k[$j++] = 0; /*9508*/
			$k[$j++] = 0; /*9508*/
			$forall($1.code, function() { /*9508*/
				var _E = $k[--$j]; /*9508*/
				var _F = $k[--$j]; /*9508*/
				var _G = $k[--$j]; /*9508*/
				$k[$j++] = (_E - 48) + (_F * 10); /*9508*/
				$k[$j++] = _G; /*9508*/
			}); /*9508*/
			$j--; /*9508*/
			var _H = $k[--$j]; /*9508*/
			$k[$j++] = _H * 2; /*9509*/
			$k[$j++] = 0; /*9509*/
			for (;;) { /*9509*/
				var _I = $k[--$j]; /*9509*/
				var _J = $k[--$j]; /*9509*/
				var _K = ~~(_J / 10); /*9509*/
				$k[$j++] = _I + (_J % 10); /*9509*/
				$k[$j++] = _K; /*9509*/
				if (_K == 0) { /*9509*/
					$j--; /*9509*/
					break; /*9509*/
				} /*9509*/
				var _L = $k[--$j]; /*9509*/
				var _M = $k[--$j]; /*9509*/
				$k[$j++] = _L; /*9509*/
				$k[$j++] = _M; /*9509*/
			} /*9509*/
			$k[$j++] = 0; /*9510*/
			$k[$j++] = 0; /*9510*/
			$forall($1.code, function() { /*9510*/
				var _O = $k[--$j]; /*9510*/
				var _P = $k[--$j]; /*9510*/
				var _Q = $k[--$j]; /*9510*/
				$k[$j++] = _P + (_O - 48); /*9510*/
				$k[$j++] = _Q; /*9510*/
			}); /*9510*/
			var _R = $k[--$j]; /*9510*/
			var _S = $k[--$j]; /*9510*/
			var _V = $s($1.code.length + 1); /*9512*/
			$puti(_V, 0, $1.code); /*9512*/
			$put(_V, $1.code.length, ((10 - (($k[--$j] + _R) % 10)) % 10) + 48); /*9512*/
			$k[$j++] = _V; /*9512*/
		}; /*9513*/
		$1.mod11 = function() {
			$1.code = $k[--$j]; /*9516*/
			$k[$j++] = $1.code.length - 1; /*9517*/
			$forall($1.code, function() { /*9517*/
				var _b = $k[--$j]; /*9517*/
				var _c = $k[--$j]; /*9517*/
				$k[$j++] = _b - 48; /*9517*/
				$k[$j++] = (_c % 6) + 2; /*9517*/
				$k[$j++] = _c - 1; /*9517*/
			}); /*9517*/
			$j--; /*9517*/
			$k[$j++] = 0; /*9518*/
			for (var _e = 0, _f = $1.code.length; _e < _f; _e++) { /*9518*/
				var _g = $k[--$j]; /*9518*/
				var _h = $k[--$j]; /*9518*/
				var _i = $k[--$j]; /*9518*/
				$k[$j++] = _g + (_i * _h); /*9518*/
			} /*9518*/
			var _k = (11 - ($k[--$j] % 11)) % 11; /*9520*/
			$k[$j++] = _k; /*9524*/
			if ((_k == 10) && $1.badmod11) { /*9523*/
				$j--; /*9521*/
				var _n = $s($1.code.length + 2); /*9521*/
				$puti(_n, 0, $1.code); /*9521*/
				$puti(_n, $1.code.length, "10"); /*9521*/
				$k[$j++] = _n; /*9521*/
			} else { /*9523*/
				var _r = $s($1.code.length + 1); /*9523*/
				$puti(_r, 0, $1.code); /*9523*/
				$put(_r, $1.code.length, $k[--$j] + 48); /*9523*/
				$k[$j++] = _r; /*9523*/
			} /*9523*/
		}; /*9525*/
		$1.ncrmod11 = function() {
			$1.code = $k[--$j]; /*9528*/
			$k[$j++] = $1.code.length - 1; /*9529*/
			$forall($1.code, function() { /*9529*/
				var _y = $k[--$j]; /*9529*/
				var _z = $k[--$j]; /*9529*/
				$k[$j++] = _y - 48; /*9529*/
				$k[$j++] = (_z % 8) + 2; /*9529*/
				$k[$j++] = _z - 1; /*9529*/
			}); /*9529*/
			$j--; /*9529*/
			$k[$j++] = 0; /*9530*/
			for (var _11 = 0, _12 = $1.code.length; _11 < _12; _11++) { /*9530*/
				var _13 = $k[--$j]; /*9530*/
				var _14 = $k[--$j]; /*9530*/
				var _15 = $k[--$j]; /*9530*/
				$k[$j++] = _13 + (_15 * _14); /*9530*/
			} /*9530*/
			var _17 = (11 - ($k[--$j] % 11)) % 11; /*9532*/
			$k[$j++] = _17; /*9536*/
			if ((_17 == 10) && $1.badmod11) { /*9535*/
				$j--; /*9533*/
				var _1A = $s($1.code.length + 2); /*9533*/
				$puti(_1A, 0, $1.code); /*9533*/
				$puti(_1A, $1.code.length, "10"); /*9533*/
				$k[$j++] = _1A; /*9533*/
			} else { /*9535*/
				var _1E = $s($1.code.length + 1); /*9535*/
				$puti(_1E, 0, $1.code); /*9535*/
				$put(_1E, $1.code.length, $k[--$j] + 48); /*9535*/
				$k[$j++] = _1E; /*9535*/
			} /*9535*/
		}; /*9537*/
		if ($1.includecheck) { /*9550*/
			if ($eq($1.checktype, "mod10")) { /*9541*/
				$k[$j++] = $1.barcode; /*9541*/
				if ($1.mod10() == $b) return $b; /*9541*/
			} /*9541*/
			if ($eq($1.checktype, "mod1010")) { /*9542*/
				$k[$j++] = $1.barcode; /*9542*/
				if ($1.mod10() == $b) return $b; /*9542*/
				if ($1.mod10() == $b) return $b; /*9542*/
			} /*9542*/
			if ($eq($1.checktype, "mod11")) { /*9543*/
				$k[$j++] = $1.barcode; /*9543*/
				if ($1.mod11() == $b) return $b; /*9543*/
			} /*9543*/
			if ($eq($1.checktype, "ncrmod11")) { /*9544*/
				$k[$j++] = $1.barcode; /*9544*/
				if ($1.ncrmod11() == $b) return $b; /*9544*/
			} /*9544*/
			if ($eq($1.checktype, "mod1110")) { /*9545*/
				$k[$j++] = $1.barcode; /*9545*/
				if ($1.mod11() == $b) return $b; /*9545*/
				if ($1.mod10() == $b) return $b; /*9545*/
			} /*9545*/
			if ($eq($1.checktype, "ncrmod1110")) { /*9546*/
				$k[$j++] = $1.barcode; /*9546*/
				if ($1.ncrmod11() == $b) return $b; /*9546*/
				if ($1.mod10() == $b) return $b; /*9546*/
			} /*9546*/
			$1.barcode = $k[--$j]; /*9547*/
			$1.barlen = $1.barcode.length; /*9548*/
			if ($1.includecheckintext) { /*9549*/
				$1.txtlen = $1.barlen; /*9549*/
			} /*9549*/
		} /*9549*/
		$1.sbs = $s(($1.barlen * 8) + 5); /*9552*/
		$1.txt = $a($1.barlen); /*9553*/
		$puti($1.sbs, 0, $get($1.encs, 10)); /*9556*/
		for (var _1i = 0, _1h = $1.barlen - 1; _1i <= _1h; _1i += 1) { /*9568*/
			$1.i = _1i; /*9559*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*9561*/
			$j--; /*9562*/
			$1.indx = $k[--$j].length; /*9563*/
			$j -= 2; /*9564*/
			$1.enc = $get($1.encs, $1.indx); /*9565*/
			$puti($1.sbs, ($1.i * 8) + 2, $1.enc); /*9566*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 12) + 3, $1.textyoffset, $1.textfont, $1.textsize])); /*9567*/
		} /*9567*/
		$puti($1.sbs, ($1.barlen * 8) + 2, $get($1.encs, 11)); /*9571*/
		$k[$j++] = Infinity; /*9582*/
		$k[$j++] = "ren"; /*9577*/
		$k[$j++] = $0.renlinear; /*9577*/
		$k[$j++] = "sbs"; /*9577*/
		$k[$j++] = Infinity; /*9577*/
		var _28 = $1.sbs; /*9576*/
		for (var _29 = 0, _2A = _28.length; _29 < _2A; _29++) { /*9576*/
			$k[$j++] = $get(_28, _29) - 48; /*9576*/
		} /*9576*/
		var _2C = $a(); /*9577*/
		$k[$j++] = _2C; /*9578*/
		$k[$j++] = "bhs"; /*9578*/
		$k[$j++] = Infinity; /*9578*/
		for (var _2E = 0, _2F = ~~(($1.sbs.length + 1) / 2); _2E < _2F; _2E++) { /*9577*/
			$k[$j++] = $1.height; /*9577*/
		} /*9577*/
		var _2H = $a(); /*9578*/
		$k[$j++] = _2H; /*9579*/
		$k[$j++] = "bbs"; /*9579*/
		$k[$j++] = Infinity; /*9579*/
		for (var _2J = 0, _2K = ~~(($1.sbs.length + 1) / 2); _2J < _2K; _2J++) { /*9578*/
			$k[$j++] = 0; /*9578*/
		} /*9578*/
		var _2L = $a(); /*9579*/
		$k[$j++] = _2L; /*9581*/
		if ($1.includetext) { /*9581*/
			$k[$j++] = "txt"; /*9580*/
			$k[$j++] = $geti($1.txt, 0, $1.txtlen); /*9580*/
		} /*9580*/
		$k[$j++] = "opt"; /*9582*/
		$k[$j++] = $1.options; /*9582*/
		var _2R = $d(); /*9582*/
		$k[$j++] = _2R; /*9585*/
		if (!$1.dontdraw) { /*9585*/
			$0.renlinear(); /*9585*/
		} /*9585*/
	};
	$0.plessey = function() {
		var $1 = {}; /*9612*/
		$1.options = $k[--$j]; /*9614*/
		$1.barcode = $k[--$j]; /*9615*/
		$1.dontdraw = false; /*9617*/
		$1.includetext = false; /*9618*/
		$1.validatecheck = false; /*9619*/
		$1.includecheckintext = false; /*9620*/
		$1.unidirectional = false; /*9621*/
		$1.textfont = "Courier"; /*9622*/
		$1.textsize = 10; /*9623*/
		$1.textyoffset = -8.5; /*9624*/
		$1.height = 1; /*9625*/
		$forall($1.options, function() { /*9636*/
			var _3 = $k[--$j]; /*9636*/
			$1[$k[--$j]] = _3; /*9636*/
		}); /*9636*/
		$1.textfont = "" + $1.textfont; /*9638*/
		$1.textsize = +$1.textsize; /*9639*/
		$1.textyoffset = +$1.textyoffset; /*9640*/
		$1.height = +$1.height; /*9641*/
		$1.barchars = "0123456789ABCDEF"; /*9644*/
		$1.charvals = {}; /*9645*/
		for (var _9 = 0; _9 <= 15; _9 += 1) { /*9646*/
			$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*9646*/
		} /*9646*/
		for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*9653*/
			var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*9650*/
			if (!_J) { /*9652*/
				$k[$j++] = "bwipp.plesseyBadCharacter"; /*9651*/
				$k[$j++] = "Plessey must contain only digits and letters A B C D E F"; /*9651*/
				$0.raiseerror(); /*9651*/
			} /*9651*/
		} /*9651*/
		$k[$j++] = "barlen"; /*9655*/
		$k[$j++] = $1.barcode.length; /*9655*/
		if ($1.validatecheck) { /*9655*/
			var _M = $k[--$j]; /*9655*/
			$k[$j++] = _M - 2; /*9655*/
		} /*9655*/
		var _N = $k[--$j]; /*9655*/
		$1[$k[--$j]] = _N; /*9655*/
		$1.checkbits = $a(($1.barlen * 4) + 8); /*9658*/
		$puti($1.checkbits, $1.barlen * 4, $a([0, 0, 0, 0, 0, 0, 0, 0])); /*9659*/
		for (var _W = 0, _V = $1.barlen - 1; _W <= _V; _W += 1) { /*9669*/
			$1.i = _W; /*9661*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*9662*/
			$puti($1.checkbits, $1.i * 4, $a([$1.indx & 1, ($1.indx >>> 1) & 1, ($1.indx >>> 2) & 1, $1.indx >>> 3])); /*9668*/
		} /*9668*/
		$1.checksalt = $a([1, 1, 1, 1, 0, 1, 0, 0, 1]); /*9670*/
		for (var _m = 0, _l = ($1.barlen * 4) - 1; _m <= _l; _m += 1) { /*9679*/
			$1.i = _m; /*9672*/
			if ($get($1.checkbits, $1.i) == 1) { /*9678*/
				for (var _q = 0; _q <= 8; _q += 1) { /*9677*/
					$1.j = _q; /*9675*/
					$put($1.checkbits, $1.i + $1.j, $xo($get($1.checkbits, $1.i + $1.j), $get($1.checksalt, $1.j))); /*9676*/
				} /*9676*/
			} /*9676*/
		} /*9676*/
		$1.checkval = 0; /*9680*/
		for (var _11 = 0; _11 <= 7; _11 += 1) { /*9684*/
			$1.i = _11; /*9682*/
			$1.checkval = $1.checkval + ((~~Math.pow(2, $1.i)) * $get($1.checkbits, ($1.barlen * 4) + $1.i)); /*9683*/
		} /*9683*/
		$1.checksum1 = $1.checkval & 15; /*9685*/
		$1.checksum2 = $1.checkval >>> 4; /*9686*/
		if ($1.validatecheck) { /*9693*/
			if (($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum1)) || ($get($1.barcode, $1.barlen + 1) != $get($1.barchars, $1.checksum2))) { /*9691*/
				$k[$j++] = "bwipp.plesseyBadCheckDigits"; /*9690*/
				$k[$j++] = "Incorrect Plessey check digits provided"; /*9690*/
				$0.raiseerror(); /*9690*/
			} /*9690*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*9692*/
		} /*9692*/
		$1.encs = $a(["14141414", "32141414", "14321414", "32321414", "14143214", "32143214", "14323214", "32323214", "14141432", "32141432", "14321432", "32321432", "14143232", "32143232", "14323232", "32323232", "32321432", "541412323", "323"]); /*9702*/
		var _1T = $1.unidirectional ? 27 : 33; /*9704*/
		$1.sbs = $s(($1.barlen * 8) + _1T); /*9704*/
		$1.txt = $a($1.barlen + 2); /*9705*/
		$puti($1.sbs, 0, $get($1.encs, 16)); /*9708*/
		for (var _1c = 0, _1b = $1.barlen - 1; _1c <= _1b; _1c += 1) { /*9715*/
			$1.i = _1c; /*9711*/
			$1.indx = $get($1.charvals, $geti($1.barcode, $1.i, 1)); /*9712*/
			$puti($1.sbs, ($1.i * 8) + 8, $get($1.encs, $1.indx)); /*9713*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), ($1.i * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9714*/
		} /*9714*/
		$puti($1.sbs, ($1.barlen * 8) + 8, $get($1.encs, $1.checksum1)); /*9718*/
		$puti($1.sbs, ($1.barlen * 8) + 16, $get($1.encs, $1.checksum2)); /*9719*/
		if ($1.includecheckintext) { /*9725*/
			$put($1.txt, $1.barlen, $a([$geti($1.barchars, $1.checksum1, 1), ($1.barlen * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9721*/
			$put($1.txt, $1.barlen + 1, $a([$geti($1.barchars, $1.checksum2, 1), (($1.barlen + 1) * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9722*/
		} else { /*9725*/
			$put($1.txt, $1.barlen, $a([" ", ($1.barlen * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9724*/
			$put($1.txt, $1.barlen + 1, $a([" ", (($1.barlen + 1) * 20) + 20, $1.textyoffset, $1.textfont, $1.textsize])); /*9725*/
		} /*9725*/
		var _2k = $1.unidirectional ? 18 : 17; /*9729*/
		$puti($1.sbs, ($1.barlen * 8) + 24, $get($1.encs, _2k)); /*9729*/
		$k[$j++] = Infinity; /*9740*/
		$k[$j++] = "ren"; /*9735*/
		$k[$j++] = $0.renlinear; /*9735*/
		$k[$j++] = "sbs"; /*9735*/
		$k[$j++] = Infinity; /*9735*/
		var _2m = $1.sbs; /*9734*/
		for (var _2n = 0, _2o = _2m.length; _2n < _2o; _2n++) { /*9734*/
			$k[$j++] = $get(_2m, _2n) - 48; /*9734*/
		} /*9734*/
		var _2q = $a(); /*9735*/
		$k[$j++] = _2q; /*9736*/
		$k[$j++] = "bhs"; /*9736*/
		$k[$j++] = Infinity; /*9736*/
		for (var _2s = 0, _2t = ~~(($1.sbs.length + 1) / 2); _2s < _2t; _2s++) { /*9735*/
			$k[$j++] = $1.height; /*9735*/
		} /*9735*/
		var _2v = $a(); /*9736*/
		$k[$j++] = _2v; /*9737*/
		$k[$j++] = "bbs"; /*9737*/
		$k[$j++] = Infinity; /*9737*/
		for (var _2x = 0, _2y = ~~(($1.sbs.length + 1) / 2); _2x < _2y; _2x++) { /*9736*/
			$k[$j++] = 0; /*9736*/
		} /*9736*/
		var _2z = $a(); /*9737*/
		$k[$j++] = _2z; /*9739*/
		if ($1.includetext) { /*9739*/
			$k[$j++] = "txt"; /*9738*/
			$k[$j++] = $1.txt; /*9738*/
		} /*9738*/
		$k[$j++] = "opt"; /*9740*/
		$k[$j++] = $1.options; /*9740*/
		var _33 = $d(); /*9740*/
		$k[$j++] = _33; /*9743*/
		if (!$1.dontdraw) { /*9743*/
			$0.renlinear(); /*9743*/
		} /*9743*/
	};
	$0.telepen = function() {
		var $1 = {}; /*9770*/
		$1.options = $k[--$j]; /*9772*/
		$1.barcode = $k[--$j]; /*9773*/
		$1.numeric = false; /*9775*/
		$1.dontdraw = false; /*9776*/
		$1.includetext = false; /*9777*/
		$1.textfont = "Courier"; /*9778*/
		$1.textsize = 10; /*9779*/
		$1.textyoffset = -8.5; /*9780*/
		$1.height = 1; /*9781*/
		$1.parse = false; /*9782*/
		$forall($1.options, function() { /*9793*/
			var _3 = $k[--$j]; /*9793*/
			$1[$k[--$j]] = _3; /*9793*/
		}); /*9793*/
		$1.textfont = "" + $1.textfont; /*9795*/
		$1.textsize = +$1.textsize; /*9796*/
		$1.textyoffset = +$1.textyoffset; /*9797*/
		$1.height = +$1.height; /*9798*/
		$1.encs = $a(["31313131", "1131313111", "33313111", "1111313131", "3111313111", "11333131", "13133131", "111111313111", "31333111", "1131113131", "33113131", "1111333111", "3111113131", "1113133111", "1311133111", "111111113131", "3131113111", "11313331", "333331", "111131113111", "31113331", "1133113111", "1313113111", "1111113331", "31131331", "113111113111", "3311113111", "1111131331", "311111113111", "1113111331", "1311111331", "11111111113111", "31313311", "1131311131", "33311131", "1111313311", "3111311131", "11333311", "13133311", "111111311131", "31331131", "1131113311", "33113311", "1111331131", "3111113311", "1113131131", "1311131131", "111111113311", "3131111131", "1131131311", "33131311", "111131111131", "3111131311", "1133111131", "1313111131", "111111131311", "3113111311", "113111111131", "3311111131", "111113111311", "311111111131", "111311111311", "131111111311", "11111111111131", "3131311111", "11313133", "333133", "111131311111", "31113133", "1133311111", "1313311111", "1111113133", "313333", "113111311111", "3311311111", "11113333", "311111311111", "11131333", "13111333", "11111111311111", "31311133", "1131331111", "33331111", "1111311133", "3111331111", "11331133", "13131133", "111111331111", "3113131111", "1131111133", "33111133", "111113131111", "3111111133", "111311131111", "131111131111", "111111111133", "31311313", "113131111111", "3331111111", "1111311313", "311131111111", "11331313", "13131313", "11111131111111", "3133111111", "1131111313", "33111313", "111133111111", "3111111313", "111313111111", "131113111111", "111111111313", "313111111111", "1131131113", "33131113", "11113111111111", "3111131113", "113311111111", "131311111111", "111111131113", "3113111113", "11311111111111", "331111111111", "111113111113", "31111111111111", "111311111113", "131111111113", "1111111111111111"]); /*9855*/
		$1.barlen = $1.barcode.length; /*9857*/
		$1.sbs = $s(($1.barlen * 16) + 48); /*9858*/
		$1.txt = $a($1.barlen); /*9859*/
		$1.enc = $get($1.encs, 95); /*9862*/
		$puti($1.sbs, 0, $1.enc); /*9863*/
		$1.l = $1.enc.length; /*9864*/
		$1.checksum = 0; /*9866*/
		$1.i = 0; /*9867*/
		$1.j = 0; /*9867*/
		for (;;) { /*9899*/
			if ($1.i == $1.barlen) { /*9869*/
				break; /*9869*/
			} /*9869*/
			if ($1.numeric) { /*9892*/
				if ($get($1.barcode, $1.i) > 16) { /*9883*/
					$1.np = $geti($1.barcode, $1.i, 2); /*9872*/
					if ($eq($geti($1.np, 1, 1), "X")) { /*9876*/
						$1.indx = (~~$z($geti($1.np, 0, 1))) + 17; /*9874*/
					} else { /*9876*/
						$1.indx = (~~$z($1.np)) + 27; /*9876*/
					} /*9876*/
					$put($1.txt, $1.j, $a([$1.np, ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9878*/
					$1.i = $1.i + 2; /*9879*/
				} else { /*9883*/
					$1.indx = $get($1.barcode, $1.i); /*9881*/
					$put($1.txt, $1.j, $a([" ", ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9882*/
					$1.i = $1.i + 1; /*9883*/
				} /*9883*/
			} else { /*9892*/
				$1.indx = $get($1.barcode, $1.i); /*9886*/
				if (($1.indx >= 32) && ($1.indx <= 126)) { /*9890*/
					$put($1.txt, $1.j, $a([$geti($1.barcode, $1.i, 1), ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9888*/
				} else { /*9890*/
					$put($1.txt, $1.j, $a([" ", ($1.j * 16) + 16, $1.textyoffset, $1.textfont, $1.textsize])); /*9890*/
				} /*9890*/
				$1.i = $1.i + 1; /*9892*/
			} /*9892*/
			$1.checksum = $1.checksum + $1.indx; /*9894*/
			$1.enc = $get($1.encs, $1.indx); /*9895*/
			$puti($1.sbs, $1.l, $1.enc); /*9896*/
			$1.l = $1.l + $1.enc.length; /*9897*/
			$1.j = $1.j + 1; /*9898*/
		} /*9898*/
		$1.checksum = (127 - ($1.checksum % 127)) % 127; /*9902*/
		$1.enc = $get($1.encs, $1.checksum); /*9903*/
		$puti($1.sbs, $1.l, $1.enc); /*9904*/
		$1.l = $1.l + $1.enc.length; /*9905*/
		$1.enc = $get($1.encs, 122); /*9908*/
		$puti($1.sbs, $1.l, $1.enc); /*9909*/
		$1.l = $1.l + $1.enc.length; /*9910*/
		$1.sbs = $geti($1.sbs, 0, $1.l); /*9913*/
		$1.txt = $geti($1.txt, 0, $1.j); /*9914*/
		$k[$j++] = Infinity; /*9925*/
		$k[$j++] = "ren"; /*9920*/
		$k[$j++] = $0.renlinear; /*9920*/
		$k[$j++] = "sbs"; /*9920*/
		$k[$j++] = Infinity; /*9920*/
		$forall($1.sbs, function() { /*9919*/
			var _1n = $k[--$j]; /*9919*/
			$k[$j++] = _1n - 48; /*9919*/
		}); /*9919*/
		var _1o = $a(); /*9920*/
		$k[$j++] = _1o; /*9921*/
		$k[$j++] = "bhs"; /*9921*/
		$k[$j++] = Infinity; /*9921*/
		for (var _1q = 0, _1r = ~~(($1.sbs.length + 1) / 2); _1q < _1r; _1q++) { /*9920*/
			$k[$j++] = $1.height; /*9920*/
		} /*9920*/
		var _1t = $a(); /*9921*/
		$k[$j++] = _1t; /*9922*/
		$k[$j++] = "bbs"; /*9922*/
		$k[$j++] = Infinity; /*9922*/
		for (var _1v = 0, _1w = ~~(($1.sbs.length + 1) / 2); _1v < _1w; _1v++) { /*9921*/
			$k[$j++] = 0; /*9921*/
		} /*9921*/
		var _1x = $a(); /*9922*/
		$k[$j++] = _1x; /*9924*/
		if ($1.includetext) { /*9924*/
			$k[$j++] = "txt"; /*9923*/
			$k[$j++] = $1.txt; /*9923*/
		} /*9923*/
		$k[$j++] = "opt"; /*9925*/
		$k[$j++] = $1.options; /*9925*/
		var _21 = $d(); /*9925*/
		$k[$j++] = _21; /*9928*/
		if (!$1.dontdraw) { /*9928*/
			$0.renlinear(); /*9928*/
		} /*9928*/
	};
	$0.telepennumeric = function() {
		var $1 = {}; /*9956*/
		$1.options = $k[--$j]; /*9958*/
		$1.barcode = $k[--$j]; /*9959*/
		$1.dontdraw = false; /*9961*/
		$1.includetext = false; /*9962*/
		$1.textfont = "Courier"; /*9963*/
		$1.textsize = 10; /*9964*/
		$1.textxoffset = 0; /*9965*/
		$1.textyoffset = -8.5; /*9966*/
		$1.height = 1; /*9967*/
		$forall($1.options, function() { /*9978*/
			var _3 = $k[--$j]; /*9978*/
			$1[$k[--$j]] = _3; /*9978*/
		}); /*9978*/
		$1.textfont = "" + $1.textfont; /*9980*/
		$1.textsize = +$1.textsize; /*9981*/
		$1.textxoffset = +$1.textxoffset; /*9982*/
		$1.textyoffset = +$1.textyoffset; /*9983*/
		$1.height = +$1.height; /*9984*/
		$1.options.dontdraw = true; /*9987*/
		$1.options.numeric = true; /*9988*/
		$k[$j++] = "args"; /*9990*/
		$k[$j++] = $1.barcode; /*9990*/
		$k[$j++] = $1.options; /*9990*/
		$0.telepen(); /*9990*/
		var _E = $k[--$j]; /*9990*/
		$1[$k[--$j]] = _E; /*9990*/
		$1.args.opt = $1.options; /*9992*/
		$k[$j++] = $1.args; /*9995*/
		if (!$1.dontdraw) { /*9995*/
			$0.renlinear(); /*9995*/
		} /*9995*/
	};
	$0.posicode = function() {
		var $1 = {}; /*10022*/
		$1.options = $k[--$j]; /*10024*/
		$1.barcode = $k[--$j]; /*10025*/
		$1.dontdraw = false; /*10027*/
		$1.includetext = false; /*10028*/
		$1.textfont = "Courier"; /*10029*/
		$1.textsize = 10; /*10030*/
		$1.textxoffset = 0; /*10031*/
		$1.textyoffset = -8.5; /*10032*/
		$1.height = 1; /*10033*/
		$1.encoding = "auto"; /*10034*/
		$1.version = "a"; /*10035*/
		$1.checkoffset = 0; /*10036*/
		$1.raw = false; /*10037*/
		$1.parse = false; /*10038*/
		$1.parsefnc = false; /*10039*/
		$forall($1.options, function() { /*10050*/
			var _3 = $k[--$j]; /*10050*/
			$1[$k[--$j]] = _3; /*10050*/
		}); /*10050*/
		$1.textfont = "" + $1.textfont; /*10052*/
		$1.textsize = +$1.textsize; /*10053*/
		$1.textxoffset = +$1.textxoffset; /*10054*/
		$1.textyoffset = +$1.textyoffset; /*10055*/
		$1.encoding = "" + $1.encoding; /*10056*/
		$1.version = "" + $1.version; /*10057*/
		$1.checkoffset = ~~$1.checkoffset; /*10058*/
		$1.height = +$1.height; /*10059*/
		$1.barlen = $1.barcode.length; /*10082*/
		$1.la0 = -1; /*10085*/
		$1.la1 = -2; /*10085*/
		$1.la2 = -3; /*10085*/
		$1.sf0 = -4; /*10086*/
		$1.sf1 = -5; /*10086*/
		$1.sf2 = -6; /*10086*/
		$1.fn1 = -7; /*10087*/
		$1.fn2 = -8; /*10087*/
		$1.fn3 = -9; /*10087*/
		$1.fn4 = -10; /*10087*/
		var _1m = {
			normal: $a([$a(["0", "^", "'"]), $a(["1", ";", 27]), $a(["2", "<", 28]), $a(["3", "=", 29]), $a(["4", ">", 30]), $a(["5", "?", 31]), $a(["6", "@", "!"]), $a(["7", "[", "\""]), $a(["8", 92, "#"]), $a(["9", "]", "&"]), $a(["A", "a", 1]), $a(["B", "b", 2]), $a(["C", "c", 3]), $a(["D", "d", 4]), $a(["E", "e", 5]), $a(["F", "f", 6]), $a(["G", "g", 7]), $a(["H", "h", 8]), $a(["I", "i", 9]), $a(["J", "j", 10]), $a(["K", "k", 11]), $a(["L", "l", 12]), $a(["M", "m", 13]), $a(["N", "n", 14]), $a(["O", "o", 15]), $a(["P", "p", 16]), $a(["Q", "q", 17]), $a(["R", "r", 18]), $a(["S", "s", 19]), $a(["T", "t", 20]), $a(["U", "u", 21]), $a(["V", "v", 22]), $a(["W", "w", 23]), $a(["X", "x", 24]), $a(["Y", "y", 25]), $a(["Z", "z", 26]), $a(["-", "_", 40]), $a([".", "`", 41]), $a([" ", 127, 0]), $a(["$", "{", "*"]), $a(["/", "|", ","]), $a(["+", "}", ":"]), $a(["%", "~", $1.fn1]), $a([$1.la1, $1.la0, $1.fn2]), $a([$1.sf1, $1.sf0, $1.fn3]), $a([$1.sf2, $1.sf2, $1.fn4])]),
			limited: $a([$a(["0", -98, -98]), $a(["1", -98, -98]), $a(["2", -98, -98]), $a(["3", -98, -98]), $a(["4", -98, -98]), $a(["5", -98, -98]), $a(["6", -98, -98]), $a(["7", -98, -98]), $a(["8", -98, -98]), $a(["9", -98, -98]), $a(["A", -98, -98]), $a(["B", -98, -98]), $a(["C", -98, -98]), $a(["D", -98, -98]), $a(["E", -98, -98]), $a(["F", -98, -98]), $a(["G", -98, -98]), $a(["H", -98, -98]), $a(["I", -98, -98]), $a(["J", -98, -98]), $a(["K", -98, -98]), $a(["L", -98, -98]), $a(["M", -98, -98]), $a(["N", -98, -98]), $a(["O", -98, -98]), $a(["P", -98, -98]), $a(["Q", -98, -98]), $a(["R", -98, -98]), $a(["S", -98, -98]), $a(["T", -98, -98]), $a(["U", -98, -98]), $a(["V", -98, -98]), $a(["W", -98, -98]), $a(["X", -98, -98]), $a(["Y", -98, -98]), $a(["Z", -98, -98]), $a(["-", -98, -98]), $a([".", -98, -98])])
		}; /*10125*/
		$k[$j++] = _1m; /*10128*/
		if ($eq($1.version, "a") || $eq($1.version, "b")) { /*10128*/
			$k[$j++] = "normal"; /*10128*/
		} else { /*10128*/
			$k[$j++] = "limited"; /*10128*/
		} /*10128*/
		var _1p = $k[--$j]; /*10128*/
		$1.charmaps = $get($k[--$j], _1p); /*10129*/
		var _1s = $1.charmaps; /*10133*/
		var _1t = $1.charmaps; /*10133*/
		var _1u = $1.charmaps; /*10133*/
		$1.charvals = $a([{}, {}, {}]); /*10134*/
		for (var _1y = 0, _1x = $1.charmaps.length - 1; _1y <= _1x; _1y += 1) { /*10143*/
			$1.i = _1y; /*10136*/
			$1.encs = $get($1.charmaps, $1.i); /*10137*/
			for (var _22 = 0; _22 <= 2; _22 += 1) { /*10142*/
				$1.j = _22; /*10139*/
				var _25 = $get($1.encs, $1.j); /*10140*/
				$k[$j++] = _25; /*10140*/
				if ($eq($type(_25), "stringtype")) { /*10140*/
					var _28 = $get($k[--$j], 0); /*10140*/
					$k[$j++] = _28; /*10140*/
				} /*10140*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*10141*/
			} /*10141*/
		} /*10141*/
		$1.set0 = $get($1.charvals, 0); /*10144*/
		$1.set1 = $get($1.charvals, 1); /*10145*/
		$1.set2 = $get($1.charvals, 2); /*10146*/
		if ($1.raw) { /*10148*/
			$1.encoding = "raw"; /*10148*/
		} /*10148*/
		if ($eq($1.encoding, "raw")) { /*10162*/
			$1.cws = $a($1.barlen); /*10151*/
			$1.i = 0; /*10152*/
			$1.j = 0; /*10152*/
			for (;;) { /*10159*/
				if ($1.i == $1.barlen) { /*10154*/
					break; /*10154*/
				} /*10154*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*10155*/
				$put($1.cws, $1.j, $1.cw); /*10156*/
				$1.i = $1.i + 4; /*10157*/
				$1.j = $1.j + 1; /*10158*/
			} /*10158*/
			$1.cws = $geti($1.cws, 0, $1.j); /*10160*/
			$1.text = ""; /*10161*/
		} /*10161*/
		if ($eq($1.encoding, "auto")) { /*10290*/
			var _2f = {
				FNC1: $1.fn1,
				FNC2: $1.fn2,
				FNC3: $1.fn3
			}; /*10169*/
			$1.fncvals = _2f; /*10171*/
			$1.msg = $a($1.barlen); /*10174*/
			$1.text = $s($1.barlen); /*10175*/
			$1.i = 0; /*10176*/
			$1.j = 0; /*10176*/
			for (;;) { /*10192*/
				if ($1.i == $1.barlen) { /*10177*/
					break; /*10177*/
				} /*10177*/
				$1.char = $get($1.barcode, $1.i); /*10178*/
				$put($1.text, $1.j, $1.char); /*10179*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*10188*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*10186*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*10182*/
						$puti($1.text, $1.j, " "); /*10183*/
						$1.i = $1.i + 4; /*10184*/
					} else { /*10186*/
						$1.i = $1.i + 1; /*10186*/
					} /*10186*/
				} /*10186*/
				$put($1.msg, $1.j, $1.char); /*10189*/
				$1.i = $1.i + 1; /*10190*/
				$1.j = $1.j + 1; /*10191*/
			} /*10191*/
			$1.msg = $geti($1.msg, 0, $1.j); /*10193*/
			$1.msglen = $1.msg.length; /*10194*/
			$1.text = $geti($1.text, 0, $1.j); /*10195*/
			$k[$j++] = Infinity; /*10198*/
			for (var _3L = 0, _3M = $1.msglen; _3L < _3M; _3L++) { /*10198*/
				$k[$j++] = 0; /*10198*/
			} /*10198*/
			$k[$j++] = 0; /*10198*/
			$1.numSA = $a(); /*10198*/
			$k[$j++] = Infinity; /*10199*/
			for (var _3P = 0, _3Q = $1.msglen; _3P < _3Q; _3P++) { /*10199*/
				$k[$j++] = 0; /*10199*/
			} /*10199*/
			$k[$j++] = 0; /*10199*/
			$1.numEA = $a(); /*10199*/
			for (var _3T = $1.msglen - 1; _3T >= 0; _3T -= 1) { /*10209*/
				$1.i = _3T; /*10201*/
				if ($get($1.msg, $1.i) >= 0) { /*10208*/
					if ($get($1.msg, $1.i) >= 128) { /*10206*/
						$put($1.numEA, $1.i, $get($1.numEA, $1.i + 1) + 1); /*10204*/
					} else { /*10206*/
						$put($1.numSA, $1.i, $get($1.numSA, $1.i + 1) + 1); /*10206*/
					} /*10206*/
				} /*10206*/
			} /*10206*/
			$1.ea = false; /*10212*/
			$1.msgtmp = $a([]); /*10212*/
			for (var _3n = 0, _3m = $1.msglen - 1; _3n <= _3m; _3n += 1) { /*10227*/
				$1.i = _3n; /*10214*/
				$1.c = $get($1.msg, $1.i); /*10215*/
				if ((!$xo($1.ea, $1.c < 128)) && ($1.c >= 0)) { /*10225*/
					if ($1.ea) { /*10217*/
						$k[$j++] = $1.numSA; /*10217*/
					} else { /*10217*/
						$k[$j++] = $1.numEA; /*10217*/
					} /*10217*/
					var _3z = $get($k[--$j], $1.i); /*10217*/
					var _42 = ((_3z + $1.i) == $1.msglen) ? 3 : 5; /*10218*/
					if (_3z < _42) { /*10223*/
						$k[$j++] = Infinity; /*10220*/
						$aload($1.msgtmp); /*10220*/
						$k[$j++] = $1.fn4; /*10220*/
						$1.msgtmp = $a(); /*10220*/
					} else { /*10223*/
						$k[$j++] = Infinity; /*10222*/
						$aload($1.msgtmp); /*10222*/
						$k[$j++] = $1.fn4; /*10222*/
						$k[$j++] = $1.fn4; /*10222*/
						$1.msgtmp = $a(); /*10222*/
						$1.ea = !$1.ea; /*10223*/
					} /*10223*/
				} /*10223*/
				$k[$j++] = Infinity; /*10226*/
				$aload($1.msgtmp); /*10226*/
				if ($1.c >= 0) { /*10226*/
					$k[$j++] = $1.c & 127; /*10226*/
				} else { /*10226*/
					$k[$j++] = $1.c; /*10226*/
				} /*10226*/
				$1.msgtmp = $a(); /*10226*/
			} /*10226*/
			$1.msg = $1.msgtmp; /*10228*/
			$1.msglen = $1.msg.length; /*10229*/
			$1.enc = function() {
				var _4I = $k[--$j]; /*10233*/
				$put($1.cws, $1.j, $get(_4I, $k[--$j])); /*10233*/
				$1.j = $1.j + 1; /*10234*/
			}; /*10235*/
			$1.cws = $a($1.msglen * 2); /*10237*/
			$1.i = 0; /*10238*/
			$1.j = 0; /*10238*/
			$1.cset = "set0"; /*10238*/
			for (;;) { /*10288*/
				if ($1.i == $1.msglen) { /*10240*/
					break; /*10240*/
				} /*10240*/
				for (;;) { /*10286*/
					$1.char1 = $get($1.msg, $1.i); /*10245*/
					$k[$j++] = "char2"; /*10246*/
					if (($1.i + 1) < $1.msglen) { /*10246*/
						$k[$j++] = $get($1.msg, $1.i + 1); /*10246*/
					} else { /*10246*/
						$k[$j++] = -99; /*10246*/
					} /*10246*/
					var _4a = $k[--$j]; /*10246*/
					$1[$k[--$j]] = _4a; /*10246*/
					var _4f = $get($1[$1.cset], $1.char1) !== undefined; /*10249*/
					if (_4f) { /*10253*/
						$k[$j++] = $1.char1; /*10250*/
						$k[$j++] = $1[$1.cset]; /*10250*/
						if ($1.enc() == $b) break; /*10250*/
						$1.i = $1.i + 1; /*10251*/
						break; /*10252*/
					} /*10252*/
					var _4m = $get($1.set2, $1.char1) !== undefined; /*10256*/
					if (_4m) { /*10261*/
						$k[$j++] = $1.sf2; /*10257*/
						$k[$j++] = $1[$1.cset]; /*10257*/
						if ($1.enc() == $b) break; /*10257*/
						$k[$j++] = $1.char1; /*10258*/
						$k[$j++] = $1.set2; /*10258*/
						if ($1.enc() == $b) break; /*10258*/
						$1.i = $1.i + 1; /*10259*/
						break; /*10260*/
					} /*10260*/
					var _4w = $get($1[$1.cset], $1.char2) !== undefined; /*10264*/
					if (!_4w) { /*10282*/
						if ($eq($1.cset, "set0")) { /*10270*/
							$k[$j++] = $1.la1; /*10266*/
							$k[$j++] = $1[$1.cset]; /*10266*/
							if ($1.enc() == $b) break; /*10266*/
							$1.cset = "set1"; /*10267*/
						} else { /*10270*/
							$k[$j++] = $1.la0; /*10269*/
							$k[$j++] = $1[$1.cset]; /*10269*/
							if ($1.enc() == $b) break; /*10269*/
							$1.cset = "set0"; /*10270*/
						} /*10270*/
						break; /*10272*/
					} else { /*10282*/
						if ($eq($1.cset, "set0")) { /*10279*/
							$k[$j++] = $1.sf1; /*10275*/
							$k[$j++] = $1[$1.cset]; /*10275*/
							if ($1.enc() == $b) break; /*10275*/
							$k[$j++] = $1.char1; /*10276*/
							$k[$j++] = $1.set1; /*10276*/
							if ($1.enc() == $b) break; /*10276*/
						} else { /*10279*/
							$k[$j++] = $1.sf0; /*10278*/
							$k[$j++] = $1[$1.cset]; /*10278*/
							if ($1.enc() == $b) break; /*10278*/
							$k[$j++] = $1.char1; /*10279*/
							$k[$j++] = $1.set0; /*10279*/
							if ($1.enc() == $b) break; /*10279*/
						} /*10279*/
						$1.i = $1.i + 1; /*10281*/
						break; /*10282*/
					} /*10282*/
					break; /*10285*/
				} /*10285*/
			} /*10285*/
			$1.cws = $geti($1.cws, 0, $1.j); /*10289*/
		} /*10289*/
		var _5N = {
			a: $a(["141112", "131212", "121312", "111412", "131113", "121213", "111313", "121114", "111214", "111115", "181111", "171211", "161311", "151411", "141511", "131611", "121711", "111811", "171112", "161212", "151312", "141412", "131512", "121612", "111712", "161113", "151213", "141313", "131413", "121513", "111613", "151114", "141214", "131314", "121414", "111514", "141115", "131215", "121315", "111415", "131116", "121216", "111316", "121117", "111217", "111118", "1<111112", "111111111;1"]),
			b: $a(["151213", "141313", "131413", "121513", "141214", "131314", "121414", "131215", "121315", "121216", "191212", "181312", "171412", "161512", "151612", "141712", "131812", "121912", "181213", "171313", "161413", "151513", "141613", "131713", "121813", "171214", "161314", "151414", "141514", "131614", "121714", "161215", "151315", "141415", "131515", "121615", "151216", "141316", "131416", "121516", "141217", "131317", "121417", "131218", "121318", "121219", "1<121312", "121212121<1"]),
			limiteda: $a(["111411", "111312", "111213", "111114", "121311", "121212", "121113", "141111", "131211", "131112", "171111", "161211", "151311", "141411", "131511", "121611", "111711", "161112", "151212", "141312", "131412", "121512", "111612", "151113", "141213", "131313", "121413", "111513", "141114", "131214", "121314", "111414", "131115", "121215", "111315", "121116", "111216", "111117", "151111", "1"]),
			limitedb: $a(["121512", "121413", "121314", "121215", "131412", "131313", "131214", "151212", "141312", "141213", "181212", "171312", "161412", "151512", "141612", "131712", "121812", "171213", "161313", "151413", "141513", "131613", "121713", "161214", "151314", "141414", "131514", "121614", "151215", "141315", "131415", "121515", "141216", "131316", "121416", "131217", "121317", "121218", "141212", "1"])
		}; /*10336*/
		$1.encs = $get(_5N, $1.version); /*10339*/
		$1.c2w = $a([$a([495, 330, 210, 126, 70, 35, 15, 5]), $a([165, 120, 84, 56, 35, 20, 10, 4]), $a([45, 36, 28, 21, 15, 10, 6, 3]), $a([9, 8, 7, 6, 5, 4, 3, 2]), $a([1, 1, 1, 1, 1, 1, 1, 1])]); /*10347*/
		$1.v = 0; /*10348*/
		$forall($1.cws, function() { /*10358*/
			$1.cw = $k[--$j]; /*10350*/
			for (var _5Y = 0, _5Z = 6; _5Y < _5Z; _5Y++) { /*10357*/
				if ((($1.cw ^ $1.v) & 1) != 0) { /*10354*/
					$1.v = $1.v ^ 7682; /*10353*/
				} /*10353*/
				$1.v = $1.v >>> 1; /*10355*/
				$1.cw = $1.cw >>> 1; /*10356*/
			} /*10356*/
		}); /*10356*/
		$1.v = $1.v + $1.checkoffset; /*10359*/
		if ($eq($1.version, "limiteda") || $eq($1.version, "limitedb")) { /*10367*/
			$1.v = $1.v & 1023; /*10362*/
			if (($1.v > 824) && ($1.v < 853)) { /*10365*/
				$1.v = $1.v + 292; /*10364*/
			} /*10364*/
		} else { /*10367*/
			$1.v = ($1.v & 1023) + 45; /*10367*/
		} /*10367*/
		$1.d = $a([2, 2, 2, 2, 2, 2]); /*10370*/
		$1.r = 0; /*10371*/
		$1.c = 0; /*10371*/
		$1.w = 0; /*10371*/
		$1.sum = 0; /*10371*/
		for (;;) { /*10390*/
			if ($1.sum == $1.v) { /*10373*/
				break; /*10373*/
			} /*10373*/
			$1.t = $1.sum + $get($get($1.c2w, $1.r), $1.c); /*10374*/
			if ($1.t == $1.v) { /*10379*/
				$1.w = $1.w + 1; /*10376*/
				$put($1.d, $1.r, $1.w + 2); /*10377*/
				$1.sum = $1.t; /*10378*/
			} /*10378*/
			if ($1.t > $1.v) { /*10384*/
				$put($1.d, $1.r, $1.w + 2); /*10381*/
				$1.r = $1.r + 1; /*10382*/
				$1.w = 0; /*10383*/
			} /*10383*/
			if ($1.t < $1.v) { /*10389*/
				$1.c = $1.c + 1; /*10386*/
				$1.w = $1.w + 1; /*10387*/
				$1.sum = $1.t; /*10388*/
			} /*10388*/
		} /*10388*/
		$k[$j++] = 20; /*10391*/
		for (var _6F = 0; _6F <= 4; _6F += 1) { /*10391*/
			var _6I = $k[--$j]; /*10391*/
			$k[$j++] = _6I - $get($1.d, _6F); /*10391*/
		} /*10391*/
		$put($1.d, 5, $k[--$j]); /*10392*/
		if ($eq($1.version, "b") || $eq($1.version, "limitedb")) { /*10395*/
			$k[$j++] = Infinity; /*10394*/
			var _6N = $1.d; /*10394*/
			for (var _6O = 0, _6P = _6N.length; _6O < _6P; _6O++) { /*10394*/
				$k[$j++] = $get(_6N, _6O) + 1; /*10394*/
			} /*10394*/
			$1.d = $a(); /*10394*/
		} /*10394*/
		$1.cbs = $strcpy($s(12), "111111111111"); /*10396*/
		for (var _6U = 5; _6U >= 0; _6U -= 1) { /*10400*/
			$1.i = _6U; /*10398*/
			$put($1.cbs, ((5 - $1.i) * 2) + 1, $get($1.d, $1.i) + 47); /*10399*/
		} /*10399*/
		$1.sbs = $s(($1.cws.length * 6) + 31); /*10403*/
		var _6e = $get($1.encs, $1.encs.length - 2); /*10404*/
		$puti($1.sbs, 0, _6e); /*10405*/
		$1.j = _6e.length; /*10406*/
		for (var _6i = 0, _6h = $1.cws.length - 1; _6i <= _6h; _6i += 1) { /*10411*/
			$1.i = _6i; /*10408*/
			$puti($1.sbs, $1.j, $get($1.encs, $get($1.cws, $1.i))); /*10409*/
			$1.j = $1.j + 6; /*10410*/
		} /*10410*/
		$puti($1.sbs, $1.j, $1.cbs); /*10412*/
		$1.j = $1.j + 12; /*10413*/
		var _6x = $get($1.encs, $1.encs.length - 1); /*10414*/
		$puti($1.sbs, $1.j, _6x); /*10415*/
		$1.j = _6x.length + $1.j; /*10416*/
		$1.sbs = $geti($1.sbs, 0, $1.j); /*10417*/
		$k[$j++] = Infinity; /*10427*/
		$k[$j++] = "ren"; /*10423*/
		$k[$j++] = $0.renlinear; /*10423*/
		$k[$j++] = "sbs"; /*10423*/
		$k[$j++] = Infinity; /*10423*/
		$forall($1.sbs, function() { /*10422*/
			var _75 = $k[--$j]; /*10422*/
			$k[$j++] = _75 - 48; /*10422*/
		}); /*10422*/
		var _76 = $a(); /*10423*/
		$k[$j++] = _76; /*10424*/
		$k[$j++] = "bhs"; /*10424*/
		$k[$j++] = Infinity; /*10424*/
		for (var _78 = 0, _79 = ~~(($1.sbs.length + 1) / 2); _78 < _79; _78++) { /*10423*/
			$k[$j++] = $1.height; /*10423*/
		} /*10423*/
		var _7B = $a(); /*10424*/
		$k[$j++] = _7B; /*10425*/
		$k[$j++] = "bbs"; /*10425*/
		$k[$j++] = Infinity; /*10425*/
		for (var _7D = 0, _7E = ~~(($1.sbs.length + 1) / 2); _7D < _7E; _7D++) { /*10424*/
			$k[$j++] = 0; /*10424*/
		} /*10424*/
		var _7F = $a(); /*10425*/
		$k[$j++] = _7F; /*10427*/
		$k[$j++] = "txt"; /*10427*/
		$k[$j++] = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*10427*/
		$k[$j++] = "textxalign"; /*10427*/
		$k[$j++] = "center"; /*10427*/
		$k[$j++] = "opt"; /*10427*/
		$k[$j++] = $1.options; /*10427*/
		var _7O = $d(); /*10427*/
		$k[$j++] = _7O; /*10430*/
		if (!$1.dontdraw) { /*10430*/
			$0.renlinear(); /*10430*/
		} /*10430*/
	};
	$0.codablockf = function() {
		var $1 = {}; /*10457*/
		$1.options = $k[--$j]; /*10459*/
		$1.barcode = $k[--$j]; /*10460*/
		$1.dontdraw = false; /*10462*/
		$1.rows = -1; /*10463*/
		$1.columns = 8; /*10464*/
		$1.rowheight = 10; /*10465*/
		$1.sepheight = 1; /*10466*/
		$1.parse = false; /*10467*/
		$1.parsefnc = false; /*10468*/
		$forall($1.options, function() { /*10479*/
			var _3 = $k[--$j]; /*10479*/
			$1[$k[--$j]] = _3; /*10479*/
		}); /*10479*/
		$1.rows = ~~$1.rows; /*10481*/
		$1.columns = ~~$1.columns; /*10482*/
		$1.rowheight = ~~$1.rowheight; /*10483*/
		$1.sepheight = ~~$1.sepheight; /*10484*/
		if ((($1.columns >= 4) && ($1.columns <= 62)) && ((($1.rows >= 2) && ($1.rows <= 44)) || ($1.rows == -1))) { /*10487*/
			$1.c = $1.columns; /*10487*/
		} /*10487*/
		$1.barlen = $1.barcode.length; /*10510*/
		$1.swa = -1; /*10513*/
		$1.swb = -2; /*10513*/
		$1.swc = -3; /*10513*/
		$1.sft = -4; /*10513*/
		$1.fn1 = -5; /*10514*/
		$1.fn2 = -6; /*10514*/
		$1.fn3 = -7; /*10514*/
		$1.fn4 = -8; /*10514*/
		$1.sta = -9; /*10515*/
		$1.stp = -10; /*10515*/
		$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.fn3, $1.fn3, "96"]), $a([$1.fn2, $1.fn2, "97"]), $a([$1.sft, $1.sft, "98"]), $a([$1.swc, $1.swc, "99"]), $a([$1.swb, $1.fn4, $1.swb]), $a([$1.fn4, $1.swa, $1.swa]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.sta, $1.sta, $1.sta]), $a([$1.stp, $1.stp, $1.stp])]); /*10555*/
		$1.charvals = $a([{}, {}, {}]); /*10558*/
		for (var _2O = 0, _2N = $1.charmaps.length - 1; _2O <= _2N; _2O += 1) { /*10567*/
			$1.i = _2O; /*10560*/
			$1.encs = $get($1.charmaps, $1.i); /*10561*/
			for (var _2S = 0; _2S <= 2; _2S += 1) { /*10566*/
				$1.j = _2S; /*10563*/
				var _2V = $get($1.encs, $1.j); /*10564*/
				$k[$j++] = _2V; /*10564*/
				if ($eq($type(_2V), "stringtype")) { /*10564*/
					var _2Y = $get($k[--$j], 0); /*10564*/
					$k[$j++] = _2Y; /*10564*/
				} /*10564*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*10565*/
			} /*10565*/
		} /*10565*/
		$1.seta = $get($1.charvals, 0); /*10568*/
		$1.setb = $get($1.charvals, 1); /*10569*/
		$1.setc = $get($1.charvals, 2); /*10570*/
		var _2m = {
			FNC1: $1.fn1,
			FNC3: $1.fn3
		}; /*10575*/
		$1.fncvals = _2m; /*10577*/
		$1.msg = $a($1.barlen); /*10578*/
		$1.i = 0; /*10579*/
		$1.j = 0; /*10579*/
		for (;;) { /*10593*/
			if ($1.i == $1.barlen) { /*10580*/
				break; /*10580*/
			} /*10580*/
			$1.char = $get($1.barcode, $1.i); /*10581*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*10589*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*10587*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*10584*/
					$1.i = $1.i + 4; /*10585*/
				} else { /*10587*/
					$1.i = $1.i + 1; /*10587*/
				} /*10587*/
			} /*10587*/
			$put($1.msg, $1.j, $1.char); /*10590*/
			$1.i = $1.i + 1; /*10591*/
			$1.j = $1.j + 1; /*10592*/
		} /*10592*/
		$1.msg = $geti($1.msg, 0, $1.j); /*10594*/
		$1.msglen = $1.msg.length; /*10595*/
		$1.msgtmp = $a([]); /*10598*/
		$forall($1.msg, function() { /*10602*/
			$1.char = $k[--$j]; /*10600*/
			$k[$j++] = Infinity; /*10601*/
			$aload($1.msgtmp); /*10601*/
			if ($1.char < 128) { /*10601*/
				$k[$j++] = $1.char; /*10601*/
			} else { /*10601*/
				$k[$j++] = $1.fn4; /*10601*/
				$k[$j++] = $1.char & 127; /*10601*/
			} /*10601*/
			$1.msgtmp = $a(); /*10601*/
		}); /*10601*/
		$1.msg = $1.msgtmp; /*10603*/
		$1.msglen = $1.msg.length; /*10604*/
		$1.numsscr = function() {
			$1.n = 0; /*10608*/
			$1.s = 0; /*10608*/
			$1.p = $k[--$j]; /*10609*/
			for (;;) { /*10620*/
				if ($1.p >= $1.msglen) { /*10610*/
					break; /*10610*/
				} /*10610*/
				var _3X = $get($1.msg, $1.p); /*10611*/
				var _3Z = $get($1.setc, _3X) !== undefined; /*10612*/
				$k[$j++] = _3X; /*10612*/
				if (!_3Z) { /*10612*/
					$j--; /*10612*/
					break; /*10612*/
				} /*10612*/
				if ($k[--$j] == $1.fn1) { /*10616*/
					if (($1.s % 2) == 0) { /*10615*/
						$1.s = $1.s + 1; /*10615*/
					} else { /*10615*/
						break; /*10615*/
					} /*10615*/
				} /*10615*/
				$1.n = $1.n + 1; /*10617*/
				$1.s = $1.s + 1; /*10618*/
				$1.p = $1.p + 1; /*10619*/
			} /*10619*/
			$k[$j++] = $1.n; /*10621*/
			$k[$j++] = $1.s; /*10621*/
		}; /*10622*/
		$1.enca = function() {
			$put($1.cws, $1.j, $get($1.seta, $k[--$j])); /*10626*/
			$1.j = $1.j + 1; /*10627*/
		}; /*10628*/
		$1.encb = function() {
			$put($1.cws, $1.j, $get($1.setb, $k[--$j])); /*10630*/
			$1.j = $1.j + 1; /*10631*/
		}; /*10632*/
		$1.encc = function() {
			var _3v = $k[--$j]; /*10634*/
			$k[$j++] = _3v; /*10638*/
			if ($ne($type(_3v), "arraytype")) { /*10637*/
				var _3z = $get($1.setc, $k[--$j]); /*10635*/
				$k[$j++] = _3z; /*10635*/
			} else { /*10637*/
				$aload($k[--$j]); /*10637*/
				var _41 = $k[--$j]; /*10637*/
				var _42 = $k[--$j]; /*10637*/
				$k[$j++] = (_41 - 48) + ((_42 - 48) * 10); /*10637*/
			} /*10637*/
			$put($1.cws, $1.j, $k[--$j]); /*10639*/
			$1.j = $1.j + 1; /*10640*/
		}; /*10641*/
		$1.anotb = function() {
			var _47 = $k[--$j]; /*10644*/
			var _49 = $get($1.seta, _47) !== undefined; /*10644*/
			var _4B = $get($1.setb, _47) !== undefined; /*10644*/
			$k[$j++] = _49 && (!_4B); /*10644*/
		}; /*10644*/
		$1.bnota = function() {
			var _4C = $k[--$j]; /*10645*/
			var _4E = $get($1.setb, _4C) !== undefined; /*10645*/
			var _4G = $get($1.seta, _4C) !== undefined; /*10645*/
			$k[$j++] = _4E && (!_4G); /*10645*/
		}; /*10645*/
		$k[$j++] = Infinity; /*10648*/
		for (var _4I = 0, _4J = $1.msg.length; _4I < _4J; _4I++) { /*10648*/
			$k[$j++] = 0; /*10648*/
		} /*10648*/
		$k[$j++] = 9999; /*10648*/
		$1.nextanotb = $a(); /*10648*/
		$k[$j++] = Infinity; /*10649*/
		for (var _4M = 0, _4N = $1.msg.length; _4M < _4N; _4M++) { /*10649*/
			$k[$j++] = 0; /*10649*/
		} /*10649*/
		$k[$j++] = 9999; /*10649*/
		$1.nextbnota = $a(); /*10649*/
		for (var _4Q = $1.msg.length - 1; _4Q >= 0; _4Q -= 1) { /*10662*/
			$1.i = _4Q; /*10651*/
			$k[$j++] = $get($1.msg, $1.i); /*10652*/
			if ($1.anotb() == $b) break; /*10652*/
			if ($k[--$j]) { /*10655*/
				$put($1.nextanotb, $1.i, 0); /*10653*/
			} else { /*10655*/
				$put($1.nextanotb, $1.i, $get($1.nextanotb, $1.i + 1) + 1); /*10655*/
			} /*10655*/
			$k[$j++] = $get($1.msg, $1.i); /*10657*/
			if ($1.bnota() == $b) break; /*10657*/
			if ($k[--$j]) { /*10660*/
				$put($1.nextbnota, $1.i, 0); /*10658*/
			} else { /*10660*/
				$put($1.nextbnota, $1.i, $get($1.nextbnota, $1.i + 1) + 1); /*10660*/
			} /*10660*/
		} /*10660*/
		$1.abeforeb = function() {
			var _4n = $k[--$j]; /*10665*/
			$k[$j++] = $lt($get($1.nextanotb, _4n), $get($1.nextbnota, _4n)); /*10665*/
		}; /*10665*/
		$1.bbeforea = function() {
			var _4s = $k[--$j]; /*10666*/
			$k[$j++] = $lt($get($1.nextbnota, _4s), $get($1.nextanotb, _4s)); /*10666*/
		}; /*10666*/
		$1.padrow = function() {
			for (var _4y = 0, _4z = $k[--$j]; _4y < _4z; _4y++) { /*10676*/
				for (;;) { /*10675*/
					if ($eq($1.cset, "seta")) { /*10672*/
						$k[$j++] = $1.swc; /*10672*/
						if ($1.enca() == $b) break; /*10672*/
						$1.cset = "setc"; /*10672*/
						break; /*10672*/
					} /*10672*/
					if ($eq($1.cset, "setb")) { /*10673*/
						$k[$j++] = $1.swc; /*10673*/
						if ($1.encb() == $b) break; /*10673*/
						$1.cset = "setc"; /*10673*/
						break; /*10673*/
					} /*10673*/
					if ($eq($1.cset, "setc")) { /*10674*/
						$k[$j++] = $1.swb; /*10674*/
						if ($1.encc() == $b) break; /*10674*/
						$1.cset = "setb"; /*10674*/
						break; /*10674*/
					} /*10674*/
				} /*10674*/
			} /*10674*/
		}; /*10677*/
		$k[$j++] = "cws"; /*10680*/
		$k[$j++] = $1.c + 5; /*10680*/
		if ($1.rows != -1) { /*10680*/
			$k[$j++] = $1.rows; /*10680*/
		} else { /*10680*/
			$k[$j++] = 44; /*10680*/
		} /*10680*/
		var _59 = $k[--$j]; /*10680*/
		var _5B = $a($k[--$j] * _59); /*10680*/
		$1[$k[--$j]] = _5B; /*10680*/
		$1.i = 0; /*10682*/
		$1.j = 0; /*10682*/
		$1.r = 1; /*10682*/
		$1.lastrow = false; /*10683*/
		for (;;) { /*10851*/
			if ($1.lastrow) { /*10685*/
				break; /*10685*/
			} /*10685*/
			$k[$j++] = $1.sta; /*10688*/
			if ($1.enca() == $b) break; /*10688*/
			if ($1.i < $1.msglen) { /*10689*/
				$k[$j++] = $1.i; /*10689*/
				if ($1.numsscr() == $b) break; /*10689*/
			} else { /*10689*/
				$k[$j++] = -1; /*10689*/
				$k[$j++] = -1; /*10689*/
			} /*10689*/
			$1.nums = $k[--$j]; /*10689*/
			$1.nchars = $k[--$j]; /*10689*/
			for (;;) { /*10709*/
				if ($1.msglen == 0) { /*10695*/
					$k[$j++] = $1.swb; /*10692*/
					if ($1.enca() == $b) break; /*10692*/
					$1.cset = "setb"; /*10693*/
					break; /*10694*/
				} /*10694*/
				if ($1.nums >= 2) { /*10700*/
					$k[$j++] = $1.swc; /*10697*/
					if ($1.enca() == $b) break; /*10697*/
					$1.cset = "setc"; /*10698*/
					break; /*10699*/
				} /*10699*/
				$k[$j++] = $1.i; /*10701*/
				if ($1.abeforeb() == $b) break; /*10701*/
				if ($k[--$j]) { /*10705*/
					$k[$j++] = $1.sft; /*10702*/
					if ($1.enca() == $b) break; /*10702*/
					$1.cset = "seta"; /*10703*/
					break; /*10704*/
				} /*10704*/
				$k[$j++] = $1.swb; /*10706*/
				if ($1.enca() == $b) break; /*10706*/
				$1.cset = "setb"; /*10707*/
				break; /*10708*/
			} /*10708*/
			$1.j = $1.j + 1; /*10710*/
			$1.endofrow = false; /*10713*/
			for (;;) { /*10836*/
				$1.rem = ($1.c + 3) - ($1.j % ($1.c + 5)); /*10714*/
				if (($1.i == $1.msglen) || $1.endofrow) { /*10716*/
					break; /*10716*/
				} /*10716*/
				$k[$j++] = $1.i; /*10718*/
				if ($1.numsscr() == $b) break; /*10718*/
				$1.nums = $k[--$j]; /*10718*/
				$1.nchars = $k[--$j]; /*10718*/
				for (;;) { /*10834*/
					if ((($eq($1.cset, "seta") || $eq($1.cset, "setb")) && ($1.nums >= 4)) && ($get($1.msg, $1.i) != $1.fn1)) { /*10756*/
						if ((($1.nums % 2) == 0) && ($1.rem >= 3)) { /*10738*/
							$k[$j++] = $1.swc; /*10726*/
							if ($eq($1.cset, "seta")) { /*10726*/
								if ($1.enca() == $b) break; /*10726*/
							} else { /*10726*/
								if ($1.encb() == $b) break; /*10726*/
							} /*10726*/
							$1.cset = "setc"; /*10727*/
							for (var _5n = 0, _5o = 2; _5n < _5o; _5n++) { /*10736*/
								if ($get($1.msg, $1.i) == $1.fn1) { /*10734*/
									$k[$j++] = $1.fn1; /*10730*/
									if ($1.encc() == $b) break; /*10730*/
									$1.i = $1.i + 1; /*10731*/
								} else { /*10734*/
									$k[$j++] = $geti($1.msg, $1.i, 2); /*10733*/
									if ($1.encc() == $b) break; /*10733*/
									$1.i = $1.i + 2; /*10734*/
								} /*10734*/
							} /*10734*/
							break; /*10737*/
						} /*10737*/
						if ((($1.nums % 2) != 0) && ($1.rem >= 4)) { /*10755*/
							$k[$j++] = $get($1.msg, $1.i); /*10741*/
							if ($eq($1.cset, "seta")) { /*10741*/
								if ($1.enca() == $b) break; /*10741*/
							} else { /*10741*/
								if ($1.encb() == $b) break; /*10741*/
							} /*10741*/
							$1.i = $1.i + 1; /*10742*/
							$k[$j++] = $1.swc; /*10743*/
							if ($eq($1.cset, "seta")) { /*10743*/
								if ($1.enca() == $b) break; /*10743*/
							} else { /*10743*/
								if ($1.encb() == $b) break; /*10743*/
							} /*10743*/
							$1.cset = "setc"; /*10744*/
							for (var _68 = 0, _69 = 2; _68 < _69; _68++) { /*10753*/
								if ($get($1.msg, $1.i) == $1.fn1) { /*10751*/
									$k[$j++] = $1.fn1; /*10747*/
									if ($1.encc() == $b) break; /*10747*/
									$1.i = $1.i + 1; /*10748*/
								} else { /*10751*/
									$k[$j++] = $geti($1.msg, $1.i, 2); /*10750*/
									if ($1.encc() == $b) break; /*10750*/
									$1.i = $1.i + 2; /*10751*/
								} /*10751*/
							} /*10751*/
							break; /*10754*/
						} /*10754*/
					} /*10754*/
					$k[$j++] = $eq($1.cset, "setb"); /*10757*/
					$k[$j++] = $get($1.msg, $1.i); /*10757*/
					if ($1.anotb() == $b) break; /*10757*/
					var _6O = $k[--$j]; /*10757*/
					if (($k[--$j] && _6O) && ($1.rem >= 2)) { /*10772*/
						if ($1.i < ($1.msglen - 1)) { /*10766*/
							$k[$j++] = $1.i + 1; /*10760*/
							if ($1.bbeforea() == $b) break; /*10760*/
							if ($k[--$j]) { /*10765*/
								$k[$j++] = $1.sft; /*10761*/
								if ($1.encb() == $b) break; /*10761*/
								$k[$j++] = $get($1.msg, $1.i); /*10762*/
								if ($1.enca() == $b) break; /*10762*/
								$1.i = $1.i + 1; /*10763*/
								break; /*10764*/
							} /*10764*/
						} /*10764*/
						$k[$j++] = $1.swa; /*10767*/
						if ($1.encb() == $b) break; /*10767*/
						$1.cset = "seta"; /*10768*/
						$k[$j++] = $get($1.msg, $1.i); /*10769*/
						if ($1.enca() == $b) break; /*10769*/
						$1.i = $1.i + 1; /*10770*/
						break; /*10771*/
					} /*10771*/
					$k[$j++] = $eq($1.cset, "seta"); /*10773*/
					$k[$j++] = $get($1.msg, $1.i); /*10773*/
					if ($1.bnota() == $b) break; /*10773*/
					var _6j = $k[--$j]; /*10773*/
					if (($k[--$j] && _6j) && ($1.rem >= 2)) { /*10788*/
						if ($1.i < ($1.msglen - 1)) { /*10782*/
							$k[$j++] = $1.i + 1; /*10776*/
							if ($1.abeforeb() == $b) break; /*10776*/
							if ($k[--$j]) { /*10781*/
								$k[$j++] = $1.sft; /*10777*/
								if ($1.enca() == $b) break; /*10777*/
								$k[$j++] = $get($1.msg, $1.i); /*10778*/
								if ($1.encb() == $b) break; /*10778*/
								$1.i = $1.i + 1; /*10779*/
								break; /*10780*/
							} /*10780*/
						} /*10780*/
						$k[$j++] = $1.swb; /*10783*/
						if ($1.enca() == $b) break; /*10783*/
						$1.cset = "setb"; /*10784*/
						$k[$j++] = $get($1.msg, $1.i); /*10785*/
						if ($1.encb() == $b) break; /*10785*/
						$1.i = $1.i + 1; /*10786*/
						break; /*10787*/
					} /*10787*/
					if (($eq($1.cset, "setc") && ($1.nums < 2)) && ($1.rem >= 2)) { /*10803*/
						$k[$j++] = $1.i; /*10791*/
						if ($1.abeforeb() == $b) break; /*10791*/
						if ($k[--$j]) { /*10797*/
							$k[$j++] = $1.swa; /*10792*/
							if ($1.encc() == $b) break; /*10792*/
							$1.cset = "seta"; /*10793*/
							$k[$j++] = $get($1.msg, $1.i); /*10794*/
							if ($1.enca() == $b) break; /*10794*/
							$1.i = $1.i + 1; /*10795*/
							break; /*10796*/
						} /*10796*/
						$k[$j++] = $1.swb; /*10798*/
						if ($1.encc() == $b) break; /*10798*/
						$1.cset = "setb"; /*10799*/
						$k[$j++] = $get($1.msg, $1.i); /*10800*/
						if ($1.encb() == $b) break; /*10800*/
						$1.i = $1.i + 1; /*10801*/
						break; /*10802*/
					} /*10802*/
					var _7K = $get($1.seta, $get($1.msg, $1.i)) !== undefined; /*10806*/
					if (($eq($1.cset, "seta") && _7K) && ($1.rem >= 1)) { /*10811*/
						$k[$j++] = $get($1.msg, $1.i); /*10808*/
						if ($1.enca() == $b) break; /*10808*/
						$1.i = $1.i + 1; /*10809*/
						break; /*10810*/
					} /*10810*/
					var _7V = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*10812*/
					if (($eq($1.cset, "setb") && _7V) && ($1.rem >= 1)) { /*10817*/
						$k[$j++] = $get($1.msg, $1.i); /*10814*/
						if ($1.encb() == $b) break; /*10814*/
						$1.i = $1.i + 1; /*10815*/
						break; /*10816*/
					} /*10816*/
					if (($eq($1.cset, "setc") && ($1.nums >= 2)) && ($1.rem >= 1)) { /*10828*/
						if ($get($1.msg, $1.i) == $1.fn1) { /*10825*/
							$k[$j++] = $1.fn1; /*10821*/
							if ($1.encc() == $b) break; /*10821*/
							$1.i = $1.i + 1; /*10822*/
						} else { /*10825*/
							$k[$j++] = $geti($1.msg, $1.i, 2); /*10824*/
							if ($1.encc() == $b) break; /*10824*/
							$1.i = $1.i + 2; /*10825*/
						} /*10825*/
						break; /*10827*/
					} /*10827*/
					$1.endofrow = true; /*10831*/
					break; /*10832*/
				} /*10832*/
			} /*10832*/
			if ((((($1.r == $1.rows) || ($1.rows == -1)) && ($1.r > 1)) && ($1.i == $1.msglen)) && ($1.rem >= 2)) { /*10848*/
				$k[$j++] = $1.rem - 2; /*10840*/
				if ($1.padrow() == $b) break; /*10840*/
				$1.j = $1.j + 3; /*10841*/
				$k[$j++] = $1.stp; /*10842*/
				if ($1.enca() == $b) break; /*10842*/
				$1.lastrow = true; /*10843*/
			} else { /*10848*/
				$k[$j++] = $1.rem; /*10845*/
				if ($1.padrow() == $b) break; /*10845*/
				$1.j = $1.j + 1; /*10846*/
				$k[$j++] = $1.stp; /*10847*/
				if ($1.enca() == $b) break; /*10847*/
				$1.r = $1.r + 1; /*10848*/
			} /*10848*/
		} /*10848*/
		$1.cws = $geti($1.cws, 0, $1.j); /*10852*/
		$k[$j++] = Infinity; /*10859*/
		for (var _85 = 64; _85 <= 95; _85 += 1) { /*10856*/
			$k[$j++] = _85; /*10856*/
		} /*10856*/
		for (var _86 = 0; _86 <= 15; _86 += 1) { /*10857*/
			$k[$j++] = _86; /*10857*/
		} /*10857*/
		for (var _87 = 26; _87 <= 63; _87 += 1) { /*10858*/
			$k[$j++] = _87; /*10858*/
		} /*10858*/
		$1.abmap = $a(); /*10859*/
		$k[$j++] = Infinity; /*10860*/
		for (var _89 = 0; _89 <= 85; _89 += 1) { /*10860*/
			$k[$j++] = _89; /*10860*/
		} /*10860*/
		$1.cmap = $a(); /*10860*/
		$1.chkmsg = $a($1.msglen); /*10863*/
		$1.j = 0; /*10864*/
		for (var _8F = 0, _8E = $1.msglen - 1; _8F <= _8E; _8F += 1) { /*10870*/
			$1.i = _8F; /*10866*/
			$1.char = $get($1.msg, $1.i); /*10867*/
			if ($1.char >= 0) { /*10868*/
				$put($1.chkmsg, $1.j, $1.char); /*10868*/
				$1.j = $1.j + 1; /*10868*/
			} /*10868*/
			if (($1.char == $1.fn1) && ($1.i != 0)) { /*10869*/
				$put($1.chkmsg, $1.j, 29); /*10869*/
				$1.j = $1.j + 1; /*10869*/
			} /*10869*/
		} /*10869*/
		$1.t1 = 0; /*10871*/
		$1.t2 = 0; /*10871*/
		$1.k1 = 0; /*10871*/
		$1.k2 = 0; /*10871*/
		for (var _8W = 0, _8V = $1.j - 1; _8W <= _8V; _8W += 1) { /*10878*/
			$1.i = _8W; /*10873*/
			$1.t1 = ($get($1.chkmsg, $1.i) * $1.i) % 86; /*10874*/
			$1.t2 = ($1.t1 + $get($1.chkmsg, $1.i)) % 86; /*10875*/
			$1.k1 = ($1.k1 + $1.t2) % 86; /*10876*/
			$1.k2 = ($1.k2 + $1.t1) % 86; /*10877*/
		} /*10877*/
		$k[$j++] = $1.cws; /*10879*/
		$k[$j++] = $1.cws.length - 4; /*10879*/
		if ($ne($1.cset, "setc")) { /*10879*/
			$k[$j++] = $1.abmap; /*10879*/
		} else { /*10879*/
			$k[$j++] = $1.cmap; /*10879*/
		} /*10879*/
		var _8q = $get($k[--$j], $1.k1); /*10879*/
		var _8r = $k[--$j]; /*10879*/
		$put($k[--$j], _8r, _8q); /*10879*/
		$k[$j++] = $1.cws; /*10880*/
		$k[$j++] = $1.cws.length - 3; /*10880*/
		if ($ne($1.cset, "setc")) { /*10880*/
			$k[$j++] = $1.abmap; /*10880*/
		} else { /*10880*/
			$k[$j++] = $1.cmap; /*10880*/
		} /*10880*/
		var _90 = $get($k[--$j], $1.k2); /*10880*/
		var _91 = $k[--$j]; /*10880*/
		$put($k[--$j], _91, _90); /*10880*/
		var _93 = $1.cws; /*10883*/
		$k[$j++] = _93; /*10883*/
		$k[$j++] = 2; /*10883*/
		if ($get(_93, 2 - 1) != 99) { /*10883*/
			$k[$j++] = $1.abmap; /*10883*/
		} else { /*10883*/
			$k[$j++] = $1.cmap; /*10883*/
		} /*10883*/
		var _99 = $get($k[--$j], $1.r - 2); /*10883*/
		var _9A = $k[--$j]; /*10883*/
		$put($k[--$j], _9A, _99); /*10883*/
		for (var _9E = 1, _9D = $1.r - 1; _9E <= _9D; _9E += 1) { /*10887*/
			$1.i = _9E; /*10885*/
			var _9F = $1.cws; /*10886*/
			var _9G = $1.i; /*10886*/
			var _9H = $1.c; /*10886*/
			$k[$j++] = _9F; /*10886*/
			$k[$j++] = (_9G * (_9H + 5)) + 2; /*10886*/
			if ($get(_9F, ((_9G * (_9H + 5)) + 2) - 1) != 99) { /*10886*/
				$k[$j++] = $1.abmap; /*10886*/
			} else { /*10886*/
				$k[$j++] = $1.cmap; /*10886*/
			} /*10886*/
			var _9N = $get($k[--$j], $1.i + 42); /*10886*/
			var _9O = $k[--$j]; /*10886*/
			$put($k[--$j], _9O, _9N); /*10886*/
		} /*10886*/
		for (var _9S = 0, _9R = $1.r - 1; _9S <= _9R; _9S += 1) { /*10898*/
			$1.rcws = $geti($1.cws, _9S * ($1.c + 5), $1.c + 4); /*10891*/
			$1.csum = $get($1.rcws, 0); /*10892*/
			for (var _9b = 1, _9a = $1.rcws.length - 2; _9b <= _9a; _9b += 1) { /*10896*/
				$1.i = _9b; /*10894*/
				$1.csum = $1.csum + ($get($1.rcws, $1.i) * $1.i); /*10895*/
			} /*10895*/
			$put($1.rcws, $1.rcws.length - 1, $1.csum % 103); /*10897*/
		} /*10897*/
		$1.encs = $a(["212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213", "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132", "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211", "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313", "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331", "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111", "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214", "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111", "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141", "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141", "114131", "311141", "411131", "211412", "2331112"]); /*10917*/
		$1.rowbits = $a($1.r); /*10920*/
		for (var _9p = 0, _9o = $1.r - 1; _9p <= _9o; _9p += 1) { /*10932*/
			$1.i = _9p; /*10922*/
			$k[$j++] = Infinity; /*10927*/
			$forall($geti($1.cws, $1.i * ($1.c + 5), $1.c + 5), function() { /*10926*/
				$forall($get($1.encs, $k[--$j]), function() { /*10925*/
					var _9y = $k[--$j]; /*10925*/
					$k[$j++] = _9y - 48; /*10925*/
				}); /*10925*/
			}); /*10925*/
			$1.sbs = $a(); /*10927*/
			$k[$j++] = Infinity; /*10928*/
			var _A0 = $1.sbs; /*10929*/
			$k[$j++] = 0; /*10929*/
			for (var _A1 = 0, _A2 = _A0.length; _A1 < _A2; _A1++) { /*10929*/
				var _A4 = $k[--$j]; /*10929*/
				var _A5 = (_A4 == 1) ? 0 : 1; /*10929*/
				$k[$j++] = _A4; /*10929*/
				for (var _A6 = 0, _A7 = $get(_A0, _A1); _A6 < _A7; _A6++) { /*10929*/
					$k[$j++] = _A5 /*10929*/
				} /*10929*/
			} /*10929*/
			$astore($a($counttomark() - 1)); /*10930*/
			var _AA = $k[--$j]; /*10930*/
			var _AB = $k[--$j]; /*10930*/
			var _AC = $k[--$j]; /*10930*/
			$put($1.rowbits, $1.i, _AA); /*10931*/
		} /*10931*/
		$1.symwid = ($1.c * 11) + 57; /*10935*/
		$k[$j++] = Infinity; /*10949*/
		for (var _AI = 0, _AJ = $1.symwid * $1.sepheight; _AI < _AJ; _AI++) { /*10937*/
			$k[$j++] = 1; /*10937*/
		} /*10937*/
		for (var _AM = 0, _AL = $1.r - 2; _AM <= _AL; _AM += 1) { /*10946*/
			$1.i = _AM; /*10939*/
			for (var _AO = 0, _AP = $1.rowheight; _AO < _AP; _AO++) { /*10940*/
				$aload($get($1.rowbits, $1.i)); /*10940*/
			} /*10940*/
			for (var _AU = 0, _AV = $1.sepheight; _AU < _AV; _AU++) { /*10945*/
				$k[$j++] = 1; /*10943*/
				$k[$j++] = 1; /*10943*/
				$k[$j++] = 0; /*10943*/
				$k[$j++] = 1; /*10943*/
				$k[$j++] = 0; /*10943*/
				$k[$j++] = 0; /*10943*/
				$k[$j++] = 0; /*10943*/
				$k[$j++] = 0; /*10943*/
				$k[$j++] = 1; /*10943*/
				$k[$j++] = 0; /*10943*/
				$k[$j++] = 0; /*10943*/
				for (var _AX = 0, _AY = $1.symwid - 24; _AX < _AY; _AX++) { /*10943*/
					$k[$j++] = 1; /*10943*/
				} /*10943*/
				$k[$j++] = 1; /*10944*/
				$k[$j++] = 1; /*10944*/
				$k[$j++] = 0; /*10944*/
				$k[$j++] = 0; /*10944*/
				$k[$j++] = 0; /*10944*/
				$k[$j++] = 1; /*10944*/
				$k[$j++] = 1; /*10944*/
				$k[$j++] = 1; /*10944*/
				$k[$j++] = 0; /*10944*/
				$k[$j++] = 1; /*10944*/
				$k[$j++] = 0; /*10944*/
				$k[$j++] = 1; /*10944*/
				$k[$j++] = 1; /*10944*/
			} /*10944*/
		} /*10944*/
		for (var _Aa = 0, _Ab = $1.rowheight; _Aa < _Ab; _Aa++) { /*10947*/
			$aload($get($1.rowbits, $1.r - 1)); /*10947*/
		} /*10947*/
		for (var _Ah = 0, _Ai = $1.symwid * $1.sepheight; _Ah < _Ai; _Ah++) { /*10948*/
			$k[$j++] = 1; /*10948*/
		} /*10948*/
		$1.pixs = $a(); /*10949*/
		var _As = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.symwid,
			pixy: ~~($1.pixs.length / $1.symwid),
			height: (~~($1.pixs.length / $1.symwid)) / 72,
			width: $1.symwid / 72,
			opt: $1.options
		}; /*10959*/
		$k[$j++] = _As; /*10962*/
		if (!$1.dontdraw) { /*10962*/
			$0.renmatrix(); /*10962*/
		} /*10962*/
	};
	$0.code16k = function() {
		var $1 = {}; /*10989*/
		$1.options = $k[--$j]; /*10991*/
		$1.barcode = $k[--$j]; /*10992*/
		$1.dontdraw = false; /*10994*/
		$1.mode = -1; /*10995*/
		$1.pos = -1; /*10996*/
		$1.rows = 0; /*10997*/
		$1.rowheight = 8; /*10998*/
		$1.sepheight = 1; /*10999*/
		$1.encoding = "auto"; /*11000*/
		$1.raw = false; /*11001*/
		$1.parse = false; /*11002*/
		$1.parsefnc = false; /*11003*/
		$forall($1.options, function() { /*11014*/
			var _3 = $k[--$j]; /*11014*/
			$1[$k[--$j]] = _3; /*11014*/
		}); /*11014*/
		$1.mode = ~~$1.mode; /*11016*/
		$1.pos = ~~$1.pos; /*11017*/
		$1.rows = ~~$1.rows; /*11018*/
		$1.rowheight = ~~$1.rowheight; /*11019*/
		$1.sepheight = ~~$1.sepheight; /*11020*/
		if ($1.pos != -1) { /*11022*/
			$1.rows = 16; /*11022*/
		} /*11022*/
		$1.barlen = $1.barcode.length; /*11045*/
		$1.swa = -1; /*11048*/
		$1.swb = -2; /*11048*/
		$1.swc = -3; /*11048*/
		$1.sa1 = -4; /*11049*/
		$1.sb1 = -5; /*11049*/
		$1.sc1 = -6; /*11049*/
		$1.sa2 = -7; /*11050*/
		$1.sb2 = -8; /*11050*/
		$1.sc2 = -9; /*11050*/
		$1.pad = -10; /*11051*/
		$1.sb3 = -11; /*11051*/
		$1.sc3 = -12; /*11051*/
		$1.fn1 = -13; /*11052*/
		$1.fn2 = -14; /*11052*/
		$1.fn3 = -15; /*11052*/
		$1.fn4 = -16; /*11052*/
		$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.fn3, $1.fn3, "96"]), $a([$1.fn2, $1.fn2, "97"]), $a([$1.sb1, $1.sa1, "98"]), $a([$1.swc, $1.swc, "99"]), $a([$1.swb, $1.fn4, $1.swb]), $a([$1.fn4, $1.swa, $1.swa]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.pad, $1.pad, $1.pad]), $a([$1.sb2, $1.sa2, $1.sb1]), $a([$1.sc2, $1.sc2, $1.sb2]), $a([$1.sc3, $1.sc3, $1.sb3])]); /*11093*/
		$1.charvals = $a([{}, {}, {}]); /*11096*/
		for (var _2S = 0, _2R = $1.charmaps.length - 1; _2S <= _2R; _2S += 1) { /*11105*/
			$1.i = _2S; /*11098*/
			$1.encs = $get($1.charmaps, $1.i); /*11099*/
			for (var _2W = 0; _2W <= 2; _2W += 1) { /*11104*/
				$1.j = _2W; /*11101*/
				var _2Z = $get($1.encs, $1.j); /*11102*/
				$k[$j++] = _2Z; /*11102*/
				if ($eq($type(_2Z), "stringtype")) { /*11102*/
					var _2c = $get($k[--$j], 0); /*11102*/
					$k[$j++] = _2c; /*11102*/
				} /*11102*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*11103*/
			} /*11103*/
		} /*11103*/
		$1.seta = $get($1.charvals, 0); /*11106*/
		$1.setb = $get($1.charvals, 1); /*11107*/
		$1.setc = $get($1.charvals, 2); /*11108*/
		if ($1.raw) { /*11110*/
			$1.encoding = "raw"; /*11110*/
		} /*11110*/
		if ($eq($1.encoding, "raw")) { /*11124*/
			$1.cws = $a($1.barlen); /*11113*/
			$1.i = 0; /*11114*/
			$1.j = 0; /*11114*/
			for (;;) { /*11121*/
				if ($1.i == $1.barlen) { /*11116*/
					break; /*11116*/
				} /*11116*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*11117*/
				$put($1.cws, $1.j, $1.cw); /*11118*/
				$1.i = $1.i + 4; /*11119*/
				$1.j = $1.j + 1; /*11120*/
			} /*11120*/
			$1.cws = $geti($1.cws, 0, $1.j); /*11122*/
			$1.text = ""; /*11123*/
		} /*11123*/
		if ($eq($1.encoding, "auto")) { /*11587*/
			var _39 = {
				FNC1: $1.fn1,
				FNC2: $1.fn2,
				FNC3: $1.fn3
			}; /*11131*/
			$1.fncvals = _39; /*11133*/
			$1.msg = $a($1.barlen); /*11134*/
			$1.i = 0; /*11135*/
			$1.j = 0; /*11135*/
			for (;;) { /*11149*/
				if ($1.i == $1.barlen) { /*11136*/
					break; /*11136*/
				} /*11136*/
				$1.char = $get($1.barcode, $1.i); /*11137*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*11145*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*11143*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*11140*/
						$1.i = $1.i + 4; /*11141*/
					} else { /*11143*/
						$1.i = $1.i + 1; /*11143*/
					} /*11143*/
				} /*11143*/
				$put($1.msg, $1.j, $1.char); /*11146*/
				$1.i = $1.i + 1; /*11147*/
				$1.j = $1.j + 1; /*11148*/
			} /*11148*/
			$1.msg = $geti($1.msg, 0, $1.j); /*11150*/
			$1.msglen = $1.msg.length; /*11151*/
			$k[$j++] = Infinity; /*11154*/
			for (var _3f = 0, _3g = $1.msglen; _3f < _3g; _3f++) { /*11154*/
				$k[$j++] = 0; /*11154*/
			} /*11154*/
			$k[$j++] = 0; /*11154*/
			$1.numSA = $a(); /*11154*/
			$k[$j++] = Infinity; /*11155*/
			for (var _3j = 0, _3k = $1.msglen; _3j < _3k; _3j++) { /*11155*/
				$k[$j++] = 0; /*11155*/
			} /*11155*/
			$k[$j++] = 0; /*11155*/
			$1.numEA = $a(); /*11155*/
			for (var _3n = $1.msglen - 1; _3n >= 0; _3n -= 1) { /*11165*/
				$1.i = _3n; /*11157*/
				if ($get($1.msg, $1.i) >= 0) { /*11164*/
					if ($get($1.msg, $1.i) >= 128) { /*11162*/
						$put($1.numEA, $1.i, $get($1.numEA, $1.i + 1) + 1); /*11160*/
					} else { /*11162*/
						$put($1.numSA, $1.i, $get($1.numSA, $1.i + 1) + 1); /*11162*/
					} /*11162*/
				} /*11162*/
			} /*11162*/
			$1.ea = false; /*11168*/
			$1.msgtmp = $a([]); /*11168*/
			for (var _47 = 0, _46 = $1.msglen - 1; _47 <= _46; _47 += 1) { /*11183*/
				$1.i = _47; /*11170*/
				$1.c = $get($1.msg, $1.i); /*11171*/
				if ((!$xo($1.ea, $1.c < 128)) && ($1.c >= 0)) { /*11181*/
					if ($1.ea) { /*11173*/
						$k[$j++] = $1.numSA; /*11173*/
					} else { /*11173*/
						$k[$j++] = $1.numEA; /*11173*/
					} /*11173*/
					var _4J = $get($k[--$j], $1.i); /*11173*/
					var _4M = ((_4J + $1.i) == $1.msglen) ? 3 : 5; /*11174*/
					if (_4J < _4M) { /*11179*/
						$k[$j++] = Infinity; /*11176*/
						$aload($1.msgtmp); /*11176*/
						$k[$j++] = $1.fn4; /*11176*/
						$1.msgtmp = $a(); /*11176*/
					} else { /*11179*/
						$k[$j++] = Infinity; /*11178*/
						$aload($1.msgtmp); /*11178*/
						$k[$j++] = $1.fn4; /*11178*/
						$k[$j++] = $1.fn4; /*11178*/
						$1.msgtmp = $a(); /*11178*/
						$1.ea = !$1.ea; /*11179*/
					} /*11179*/
				} /*11179*/
				$k[$j++] = Infinity; /*11182*/
				$aload($1.msgtmp); /*11182*/
				if ($1.c >= 0) { /*11182*/
					$k[$j++] = $1.c & 127; /*11182*/
				} else { /*11182*/
					$k[$j++] = $1.c; /*11182*/
				} /*11182*/
				$1.msgtmp = $a(); /*11182*/
			} /*11182*/
			$1.msg = $1.msgtmp; /*11184*/
			$1.msglen = $1.msg.length; /*11185*/
			$1.numsscr = function() {
				$1.n = 0; /*11189*/
				$1.s = 0; /*11189*/
				$1.p = $k[--$j]; /*11190*/
				for (;;) { /*11201*/
					if ($1.p >= $1.msglen) { /*11191*/
						break; /*11191*/
					} /*11191*/
					var _4h = $get($1.msg, $1.p); /*11192*/
					var _4j = $get($1.setc, _4h) !== undefined; /*11193*/
					$k[$j++] = _4h; /*11193*/
					if (!_4j) { /*11193*/
						$j--; /*11193*/
						break; /*11193*/
					} /*11193*/
					if ($k[--$j] == $1.fn1) { /*11197*/
						if (($1.s % 2) == 0) { /*11196*/
							$1.s = $1.s + 1; /*11196*/
						} else { /*11196*/
							break; /*11196*/
						} /*11196*/
					} /*11196*/
					$1.n = $1.n + 1; /*11198*/
					$1.s = $1.s + 1; /*11199*/
					$1.p = $1.p + 1; /*11200*/
				} /*11200*/
				$k[$j++] = $1.n; /*11202*/
				$k[$j++] = $1.s; /*11202*/
			}; /*11203*/
			$1.enca = function() {
				$put($1.cws, $1.j, $get($1.seta, $k[--$j])); /*11207*/
				$1.j = $1.j + 1; /*11208*/
			}; /*11209*/
			$1.encb = function() {
				$put($1.cws, $1.j, $get($1.setb, $k[--$j])); /*11211*/
				$1.j = $1.j + 1; /*11212*/
			}; /*11213*/
			$1.encc = function() {
				var _55 = $k[--$j]; /*11215*/
				$k[$j++] = _55; /*11219*/
				if ($ne($type(_55), "arraytype")) { /*11218*/
					var _59 = $get($1.setc, $k[--$j]); /*11216*/
					$k[$j++] = _59; /*11216*/
				} else { /*11218*/
					$aload($k[--$j]); /*11218*/
					var _5B = $k[--$j]; /*11218*/
					var _5C = $k[--$j]; /*11218*/
					$k[$j++] = (_5B - 48) + ((_5C - 48) * 10); /*11218*/
				} /*11218*/
				$put($1.cws, $1.j, $k[--$j]); /*11220*/
				$1.j = $1.j + 1; /*11221*/
			}; /*11222*/
			$1.anotb = function() {
				var _5H = $k[--$j]; /*11225*/
				var _5J = $get($1.seta, _5H) !== undefined; /*11225*/
				var _5L = $get($1.setb, _5H) !== undefined; /*11225*/
				$k[$j++] = _5J && (!_5L); /*11225*/
			}; /*11225*/
			$1.bnota = function() {
				var _5M = $k[--$j]; /*11226*/
				var _5O = $get($1.setb, _5M) !== undefined; /*11226*/
				var _5Q = $get($1.seta, _5M) !== undefined; /*11226*/
				$k[$j++] = _5O && (!_5Q); /*11226*/
			}; /*11226*/
			$k[$j++] = Infinity; /*11229*/
			for (var _5S = 0, _5T = $1.msg.length; _5S < _5T; _5S++) { /*11229*/
				$k[$j++] = 0; /*11229*/
			} /*11229*/
			$k[$j++] = 9999; /*11229*/
			$1.nextanotb = $a(); /*11229*/
			$k[$j++] = Infinity; /*11230*/
			for (var _5W = 0, _5X = $1.msg.length; _5W < _5X; _5W++) { /*11230*/
				$k[$j++] = 0; /*11230*/
			} /*11230*/
			$k[$j++] = 9999; /*11230*/
			$1.nextbnota = $a(); /*11230*/
			for (var _5a = $1.msg.length - 1; _5a >= 0; _5a -= 1) { /*11243*/
				$1.i = _5a; /*11232*/
				$k[$j++] = $get($1.msg, $1.i); /*11233*/
				if ($1.anotb() == $b) break; /*11233*/
				if ($k[--$j]) { /*11236*/
					$put($1.nextanotb, $1.i, 0); /*11234*/
				} else { /*11236*/
					$put($1.nextanotb, $1.i, $get($1.nextanotb, $1.i + 1) + 1); /*11236*/
				} /*11236*/
				$k[$j++] = $get($1.msg, $1.i); /*11238*/
				if ($1.bnota() == $b) break; /*11238*/
				if ($k[--$j]) { /*11241*/
					$put($1.nextbnota, $1.i, 0); /*11239*/
				} else { /*11241*/
					$put($1.nextbnota, $1.i, $get($1.nextbnota, $1.i + 1) + 1); /*11241*/
				} /*11241*/
			} /*11241*/
			$1.abeforeb = function() {
				var _5x = $k[--$j]; /*11246*/
				$k[$j++] = $lt($get($1.nextanotb, _5x), $get($1.nextbnota, _5x)); /*11246*/
			}; /*11246*/
			$1.bbeforea = function() {
				var _62 = $k[--$j]; /*11247*/
				$k[$j++] = $lt($get($1.nextbnota, _62), $get($1.nextanotb, _62)); /*11247*/
			}; /*11247*/
			$1.cws = $a(($1.barcode.length * 2) + 3); /*11249*/
			$1.i = 0; /*11252*/
			$1.j = 0; /*11252*/
			for (;;) { /*11342*/
				if ($1.pos != -1) { /*11263*/
					$put($1.cws, 0, (~~($1.pos / 10)) - 1); /*11257*/
					$put($1.cws, 1, ($1.pos % 10) - 1); /*11258*/
					$1.j = 2; /*11259*/
					$1.cset = "setb"; /*11260*/
					$1.mode = 7; /*11261*/
					break; /*11262*/
				} /*11262*/
				if ($1.msglen == 0) { /*11269*/
					$1.cset = "setb"; /*11266*/
					$1.mode = 1; /*11267*/
					break; /*11268*/
				} /*11268*/
				if ($1.msglen >= 2) { /*11278*/
					$k[$j++] = $get($1.msg, 0) == $1.fn1; /*11272*/
					$k[$j++] = 1; /*11272*/
					if ($1.numsscr() == $b) break; /*11272*/
					var _6J = $k[--$j]; /*11272*/
					var _6K = $k[--$j]; /*11272*/
					if ($k[--$j] && (_6J >= 2)) { /*11277*/
						$1.cset = "setc"; /*11273*/
						$1.mode = 4; /*11274*/
						$1.i = 1; /*11275*/
						break; /*11276*/
					} /*11276*/
				} /*11276*/
				if ($get($1.msg, 0) == $1.fn1) { /*11285*/
					$1.cset = "setb"; /*11281*/
					$1.mode = 3; /*11282*/
					$1.i = 1; /*11283*/
					break; /*11284*/
				} /*11284*/
				if ($1.msglen >= 2) { /*11331*/
					$k[$j++] = 0; /*11288*/
					if ($1.numsscr() == $b) break; /*11288*/
					var _6Q = $k[--$j]; /*11288*/
					var _6R = $k[--$j]; /*11288*/
					if ((_6Q >= 2) && ((_6Q % 2) == 0)) { /*11292*/
						$1.cset = "setc"; /*11289*/
						$1.mode = 2; /*11290*/
						break; /*11291*/
					} /*11291*/
					$k[$j++] = 0; /*11294*/
					if ($1.numsscr() == $b) break; /*11294*/
					var _6S = $k[--$j]; /*11294*/
					var _6T = $k[--$j]; /*11294*/
					if ((_6S >= 3) && ((_6S % 2) == 1)) { /*11300*/
						$k[$j++] = $get($1.msg, 0); /*11295*/
						if ($1.encb() == $b) break; /*11295*/
						$1.cset = "setc"; /*11296*/
						$1.mode = 5; /*11297*/
						$1.i = 1; /*11298*/
						break; /*11299*/
					} /*11299*/
					var _6Z = $get($1.setb, $get($1.msg, 0)) !== undefined; /*11302*/
					$k[$j++] = _6Z; /*11303*/
					$k[$j++] = 1; /*11303*/
					if ($1.numsscr() == $b) break; /*11303*/
					var _6a = $k[--$j]; /*11303*/
					var _6b = $k[--$j]; /*11303*/
					if ($k[--$j] && ((_6a >= 2) && ((_6a % 2) == 0))) { /*11309*/
						$k[$j++] = $get($1.msg, 0); /*11304*/
						if ($1.encb() == $b) break; /*11304*/
						$1.cset = "setc"; /*11305*/
						$1.mode = 5; /*11306*/
						$1.i = 1; /*11307*/
						break; /*11308*/
					} /*11308*/
					var _6i = $get($1.setb, $get($1.msg, 0)) !== undefined; /*11311*/
					$k[$j++] = _6i; /*11312*/
					$k[$j++] = 1; /*11312*/
					if ($1.numsscr() == $b) break; /*11312*/
					var _6j = $k[--$j]; /*11312*/
					var _6k = $k[--$j]; /*11312*/
					if ($k[--$j] && ((_6j >= 3) && ((_6j % 2) == 1))) { /*11319*/
						$k[$j++] = $get($1.msg, 0); /*11313*/
						if ($1.encb() == $b) break; /*11313*/
						$k[$j++] = $get($1.msg, 1); /*11314*/
						if ($1.encb() == $b) break; /*11314*/
						$1.cset = "setc"; /*11315*/
						$1.mode = 6; /*11316*/
						$1.i = 2; /*11317*/
						break; /*11318*/
					} /*11318*/
					var _6t = $get($1.setb, $get($1.msg, 0)) !== undefined; /*11321*/
					var _6x = $get($1.setb, $get($1.msg, 1)) !== undefined; /*11322*/
					$k[$j++] = _6t && _6x; /*11323*/
					$k[$j++] = 2; /*11323*/
					if ($1.numsscr() == $b) break; /*11323*/
					var _6y = $k[--$j]; /*11323*/
					var _6z = $k[--$j]; /*11323*/
					if ($k[--$j] && ((_6y >= 2) && ((_6y % 2) == 0))) { /*11330*/
						$k[$j++] = $get($1.msg, 0); /*11324*/
						if ($1.encb() == $b) break; /*11324*/
						$k[$j++] = $get($1.msg, 1); /*11325*/
						if ($1.encb() == $b) break; /*11325*/
						$1.cset = "setc"; /*11326*/
						$1.mode = 6; /*11327*/
						$1.i = 2; /*11328*/
						break; /*11329*/
					} /*11329*/
				} /*11329*/
				$k[$j++] = 0; /*11333*/
				if ($1.abeforeb() == $b) break; /*11333*/
				if ($k[--$j]) { /*11337*/
					$1.cset = "seta"; /*11334*/
					$1.mode = 0; /*11335*/
					break; /*11336*/
				} /*11336*/
				$1.cset = "setb"; /*11339*/
				$1.mode = 1; /*11340*/
				break; /*11341*/
			} /*11341*/
			for (;;) { /*11585*/
				if ($1.i == $1.msglen) { /*11345*/
					break; /*11345*/
				} /*11345*/
				$k[$j++] = $1.i; /*11347*/
				if ($1.numsscr() == $b) break; /*11347*/
				$1.nums = $k[--$j]; /*11347*/
				$1.nchars = $k[--$j]; /*11347*/
				for (;;) { /*11583*/
					if ($eq($1.cset, "seta")) { /*11424*/
						if ($1.i < ($1.msglen - 1)) { /*11361*/
							$k[$j++] = $get($1.msg, $1.i); /*11354*/
							if ($1.bnota() == $b) break; /*11354*/
							$k[$j++] = $1.i + 1; /*11355*/
							if ($1.abeforeb() == $b) break; /*11355*/
							var _7I = $k[--$j]; /*11355*/
							if (($k[--$j] && _7I)) { /*11360*/
								$k[$j++] = $1.sb1; /*11356*/
								if ($1.enca() == $b) break; /*11356*/
								$k[$j++] = $get($1.msg, $1.i); /*11357*/
								if ($1.encb() == $b) break; /*11357*/
								$1.i = $1.i + 1; /*11358*/
								break; /*11359*/
							} /*11359*/
						} /*11359*/
						if ($1.i < ($1.msglen - 2)) { /*11373*/
							$k[$j++] = $get($1.msg, $1.i); /*11364*/
							if ($1.bnota() == $b) break; /*11364*/
							$k[$j++] = $get($1.msg, $1.i + 1); /*11365*/
							if ($1.bnota() == $b) break; /*11365*/
							var _7X = $k[--$j]; /*11365*/
							var _7Y = $k[--$j]; /*11365*/
							$k[$j++] = $an(_7Y, _7X); /*11366*/
							$k[$j++] = $1.i + 2; /*11366*/
							if ($1.abeforeb() == $b) break; /*11366*/
							var _7a = $k[--$j]; /*11366*/
							if (($k[--$j] && _7a)) { /*11372*/
								$k[$j++] = $1.sb2; /*11367*/
								if ($1.enca() == $b) break; /*11367*/
								$k[$j++] = $get($1.msg, $1.i); /*11368*/
								if ($1.encb() == $b) break; /*11368*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11369*/
								if ($1.encb() == $b) break; /*11369*/
								$1.i = $1.i + 2; /*11370*/
								break; /*11371*/
							} /*11371*/
						} /*11371*/
						$k[$j++] = $get($1.msg, $1.i); /*11375*/
						if ($1.bnota() == $b) break; /*11375*/
						if ($k[--$j]) { /*11379*/
							$k[$j++] = $1.swb; /*11376*/
							if ($1.enca() == $b) break; /*11376*/
							$1.cset = "setb"; /*11377*/
							break; /*11378*/
						} /*11378*/
						if ($1.i < ($1.msglen - 4)) { /*11396*/
							var _7w = $get($1.seta, $get($1.msg, $1.i + 4)) !== undefined; /*11383*/
							if (($1.nums == 4) && _7w) { /*11395*/
								$k[$j++] = $1.sc2; /*11384*/
								if ($1.enca() == $b) break; /*11384*/
								for (var _7y = 0, _7z = 2; _7y < _7z; _7y++) { /*11393*/
									if ($get($1.msg, $1.i) == $1.fn1) { /*11391*/
										$k[$j++] = $1.fn1; /*11387*/
										if ($1.encc() == $b) break; /*11387*/
										$1.i = $1.i + 1; /*11388*/
									} else { /*11391*/
										$k[$j++] = $geti($1.msg, $1.i, 2); /*11390*/
										if ($1.encc() == $b) break; /*11390*/
										$1.i = $1.i + 2; /*11391*/
									} /*11391*/
								} /*11391*/
								break; /*11394*/
							} /*11394*/
						} /*11394*/
						if ($1.i < ($1.msglen - 6)) { /*11413*/
							var _8H = $get($1.seta, $get($1.msg, $1.i + 6)) !== undefined; /*11400*/
							if (($1.nums == 6) && _8H) { /*11412*/
								$k[$j++] = $1.sc3; /*11401*/
								if ($1.enca() == $b) break; /*11401*/
								for (var _8J = 0, _8K = 3; _8J < _8K; _8J++) { /*11410*/
									if ($get($1.msg, $1.i) == $1.fn1) { /*11408*/
										$k[$j++] = $1.fn1; /*11404*/
										if ($1.encc() == $b) break; /*11404*/
										$1.i = $1.i + 1; /*11405*/
									} else { /*11408*/
										$k[$j++] = $geti($1.msg, $1.i, 2); /*11407*/
										if ($1.encc() == $b) break; /*11407*/
										$1.i = $1.i + 2; /*11408*/
									} /*11408*/
								} /*11408*/
								break; /*11411*/
							} /*11411*/
						} /*11411*/
						if (($1.nums >= 4) && (($1.nums % 2) == 0)) { /*11419*/
							$k[$j++] = $1.swc; /*11416*/
							if ($1.enca() == $b) break; /*11416*/
							$1.cset = "setc"; /*11417*/
							break; /*11418*/
						} /*11418*/
						$k[$j++] = $get($1.msg, $1.i); /*11421*/
						if ($1.enca() == $b) break; /*11421*/
						$1.i = $1.i + 1; /*11422*/
						break; /*11423*/
					} /*11423*/
					if ($eq($1.cset, "setb")) { /*11498*/
						if ($1.i < ($1.msglen - 1)) { /*11435*/
							$k[$j++] = $get($1.msg, $1.i); /*11428*/
							if ($1.anotb() == $b) break; /*11428*/
							$k[$j++] = $1.i + 1; /*11429*/
							if ($1.bbeforea() == $b) break; /*11429*/
							var _8j = $k[--$j]; /*11429*/
							if (($k[--$j] && _8j)) { /*11434*/
								$k[$j++] = $1.sa1; /*11430*/
								if ($1.encb() == $b) break; /*11430*/
								$k[$j++] = $get($1.msg, $1.i); /*11431*/
								if ($1.enca() == $b) break; /*11431*/
								$1.i = $1.i + 1; /*11432*/
								break; /*11433*/
							} /*11433*/
						} /*11433*/
						if ($1.i < ($1.msglen - 2)) { /*11447*/
							$k[$j++] = $get($1.msg, $1.i); /*11438*/
							if ($1.anotb() == $b) break; /*11438*/
							$k[$j++] = $get($1.msg, $1.i + 1); /*11439*/
							if ($1.anotb() == $b) break; /*11439*/
							var _8y = $k[--$j]; /*11439*/
							var _8z = $k[--$j]; /*11439*/
							$k[$j++] = $an(_8z, _8y); /*11440*/
							$k[$j++] = $1.i + 2; /*11440*/
							if ($1.bbeforea() == $b) break; /*11440*/
							var _91 = $k[--$j]; /*11440*/
							if (($k[--$j] && _91)) { /*11446*/
								$k[$j++] = $1.sa2; /*11441*/
								if ($1.encb() == $b) break; /*11441*/
								$k[$j++] = $get($1.msg, $1.i); /*11442*/
								if ($1.enca() == $b) break; /*11442*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11443*/
								if ($1.enca() == $b) break; /*11443*/
								$1.i = $1.i + 2; /*11444*/
								break; /*11445*/
							} /*11445*/
						} /*11445*/
						$k[$j++] = $get($1.msg, $1.i); /*11449*/
						if ($1.anotb() == $b) break; /*11449*/
						if ($k[--$j]) { /*11453*/
							$k[$j++] = $1.swa; /*11450*/
							if ($1.encb() == $b) break; /*11450*/
							$1.cset = "seta"; /*11451*/
							break; /*11452*/
						} /*11452*/
						if ($1.i < ($1.msglen - 4)) { /*11470*/
							var _9N = $get($1.setb, $get($1.msg, $1.i + 4)) !== undefined; /*11457*/
							if (($1.nums == 4) && _9N) { /*11469*/
								$k[$j++] = $1.sc2; /*11458*/
								if ($1.encb() == $b) break; /*11458*/
								for (var _9P = 0, _9Q = 2; _9P < _9Q; _9P++) { /*11467*/
									if ($get($1.msg, $1.i) == $1.fn1) { /*11465*/
										$k[$j++] = $1.fn1; /*11461*/
										if ($1.encc() == $b) break; /*11461*/
										$1.i = $1.i + 1; /*11462*/
									} else { /*11465*/
										$k[$j++] = $geti($1.msg, $1.i, 2); /*11464*/
										if ($1.encc() == $b) break; /*11464*/
										$1.i = $1.i + 2; /*11465*/
									} /*11465*/
								} /*11465*/
								break; /*11468*/
							} /*11468*/
						} /*11468*/
						if ($1.i < ($1.msglen - 6)) { /*11487*/
							var _9i = $get($1.setb, $get($1.msg, $1.i + 6)) !== undefined; /*11474*/
							if (($1.nums == 6) && _9i) { /*11486*/
								$k[$j++] = $1.sc3; /*11475*/
								if ($1.encb() == $b) break; /*11475*/
								for (var _9k = 0, _9l = 3; _9k < _9l; _9k++) { /*11484*/
									if ($get($1.msg, $1.i) == $1.fn1) { /*11482*/
										$k[$j++] = $1.fn1; /*11478*/
										if ($1.encc() == $b) break; /*11478*/
										$1.i = $1.i + 1; /*11479*/
									} else { /*11482*/
										$k[$j++] = $geti($1.msg, $1.i, 2); /*11481*/
										if ($1.encc() == $b) break; /*11481*/
										$1.i = $1.i + 2; /*11482*/
									} /*11482*/
								} /*11482*/
								break; /*11485*/
							} /*11485*/
						} /*11485*/
						if (($1.nums >= 4) && (($1.nums % 2) == 0)) { /*11493*/
							$k[$j++] = $1.swc; /*11490*/
							if ($1.encb() == $b) break; /*11490*/
							$1.cset = "setc"; /*11491*/
							break; /*11492*/
						} /*11492*/
						$k[$j++] = $get($1.msg, $1.i); /*11495*/
						if ($1.encb() == $b) break; /*11495*/
						$1.i = $1.i + 1; /*11496*/
						break; /*11497*/
					} /*11497*/
					if ($eq($1.cset, "setc")) { /*11581*/
						if ($1.nums >= 2) { /*11510*/
							if ($get($1.msg, $1.i) == $1.fn1) { /*11507*/
								$k[$j++] = $1.fn1; /*11503*/
								if ($1.encc() == $b) break; /*11503*/
								$1.i = $1.i + 1; /*11504*/
							} else { /*11507*/
								$k[$j++] = $geti($1.msg, $1.i, 2); /*11506*/
								if ($1.encc() == $b) break; /*11506*/
								$1.i = $1.i + 2; /*11507*/
							} /*11507*/
							break; /*11509*/
						} /*11509*/
						if ($1.i < ($1.msglen - 1)) { /*11520*/
							var _AL = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11513*/
							$k[$j++] = _AL; /*11514*/
							$k[$j++] = $1.i + 1; /*11514*/
							if ($1.numsscr() == $b) break; /*11514*/
							var _AN = $k[--$j]; /*11514*/
							var _AO = $k[--$j]; /*11514*/
							if ($k[--$j] && ((_AN >= 2) && ((_AN % 2) == 0))) { /*11519*/
								$k[$j++] = $1.sb1; /*11515*/
								if ($1.encc() == $b) break; /*11515*/
								$k[$j++] = $get($1.msg, $1.i); /*11516*/
								if ($1.encb() == $b) break; /*11516*/
								$1.i = $1.i + 1; /*11517*/
								break; /*11518*/
							} /*11518*/
						} /*11518*/
						if ($1.i < ($1.msglen - 1)) { /*11531*/
							var _Ab = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11523*/
							$k[$j++] = _Ab; /*11524*/
							$k[$j++] = $1.i + 1; /*11524*/
							if ($1.numsscr() == $b) break; /*11524*/
							var _Ad = $k[--$j]; /*11524*/
							var _Ae = $k[--$j]; /*11524*/
							if ($k[--$j] && ((_Ad >= 3) && ((_Ad % 2) == 1))) { /*11530*/
								$k[$j++] = $1.sb2; /*11525*/
								if ($1.encc() == $b) break; /*11525*/
								$k[$j++] = $get($1.msg, $1.i); /*11526*/
								if ($1.encb() == $b) break; /*11526*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11527*/
								if ($1.encb() == $b) break; /*11527*/
								$1.i = $1.i + 2; /*11528*/
								break; /*11529*/
							} /*11529*/
						} /*11529*/
						if ($1.i < ($1.msglen - 2)) { /*11543*/
							var _Au = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11534*/
							var _Az = $get($1.setb, $get($1.msg, $1.i + 1)) !== undefined; /*11535*/
							$k[$j++] = _Au && _Az; /*11536*/
							$k[$j++] = $1.i + 2; /*11536*/
							if ($1.numsscr() == $b) break; /*11536*/
							var _B1 = $k[--$j]; /*11536*/
							var _B2 = $k[--$j]; /*11536*/
							if ($k[--$j] && ((_B1 >= 2) && ((_B1 % 2) == 0))) { /*11542*/
								$k[$j++] = $1.sb2; /*11537*/
								if ($1.encc() == $b) break; /*11537*/
								$k[$j++] = $get($1.msg, $1.i); /*11538*/
								if ($1.encb() == $b) break; /*11538*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11539*/
								if ($1.encb() == $b) break; /*11539*/
								$1.i = $1.i + 2; /*11540*/
								break; /*11541*/
							} /*11541*/
						} /*11541*/
						if ($1.i < ($1.msglen - 3)) { /*11556*/
							var _BI = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11546*/
							var _BN = $get($1.setb, $get($1.msg, $1.i + 1)) !== undefined; /*11547*/
							$k[$j++] = _BI && _BN; /*11548*/
							$k[$j++] = $1.i + 2; /*11548*/
							if ($1.numsscr() == $b) break; /*11548*/
							var _BP = $k[--$j]; /*11548*/
							var _BQ = $k[--$j]; /*11548*/
							if ($k[--$j] && ((_BP >= 3) && ((_BP % 2) == 1))) { /*11555*/
								$k[$j++] = $1.sb3; /*11549*/
								if ($1.encc() == $b) break; /*11549*/
								$k[$j++] = $get($1.msg, $1.i); /*11550*/
								if ($1.encb() == $b) break; /*11550*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11551*/
								if ($1.encb() == $b) break; /*11551*/
								$k[$j++] = $get($1.msg, $1.i + 2); /*11552*/
								if ($1.encb() == $b) break; /*11552*/
								$1.i = $1.i + 3; /*11553*/
								break; /*11554*/
							} /*11554*/
						} /*11554*/
						if ($1.i < ($1.msglen - 3)) { /*11570*/
							var _Bj = $get($1.setb, $get($1.msg, $1.i)) !== undefined; /*11559*/
							var _Bo = $get($1.setb, $get($1.msg, $1.i + 1)) !== undefined; /*11560*/
							var _Bt = $get($1.setb, $get($1.msg, $1.i + 2)) !== undefined; /*11561*/
							$k[$j++] = (_Bj && _Bo) && _Bt; /*11562*/
							$k[$j++] = $1.i + 3; /*11562*/
							if ($1.numsscr() == $b) break; /*11562*/
							var _Bv = $k[--$j]; /*11562*/
							var _Bw = $k[--$j]; /*11562*/
							if ($k[--$j] && ((_Bv >= 2) && ((_Bv % 2) == 0))) { /*11569*/
								$k[$j++] = $1.sb3; /*11563*/
								if ($1.encc() == $b) break; /*11563*/
								$k[$j++] = $get($1.msg, $1.i); /*11564*/
								if ($1.encb() == $b) break; /*11564*/
								$k[$j++] = $get($1.msg, $1.i + 1); /*11565*/
								if ($1.encb() == $b) break; /*11565*/
								$k[$j++] = $get($1.msg, $1.i + 2); /*11566*/
								if ($1.encb() == $b) break; /*11566*/
								$1.i = $1.i + 3; /*11567*/
								break; /*11568*/
							} /*11568*/
						} /*11568*/
						$k[$j++] = $1.i; /*11572*/
						if ($1.abeforeb() == $b) break; /*11572*/
						if ($k[--$j]) { /*11576*/
							$k[$j++] = $1.swa; /*11573*/
							if ($1.encc() == $b) break; /*11573*/
							$1.cset = "seta"; /*11574*/
							break; /*11575*/
						} /*11575*/
						$k[$j++] = $1.swb; /*11578*/
						if ($1.encc() == $b) break; /*11578*/
						$1.cset = "setb"; /*11579*/
						break; /*11580*/
					} /*11580*/
					break; /*11582*/
				} /*11582*/
			} /*11582*/
			$1.cws = $geti($1.cws, 0, $1.j); /*11586*/
		} /*11586*/
		$1.metrics = $a([$a([2, 7]), $a([3, 12]), $a([4, 17]), $a([5, 22]), $a([6, 27]), $a([7, 32]), $a([8, 37]), $a([9, 42]), $a([10, 47]), $a([11, 52]), $a([12, 57]), $a([13, 62]), $a([14, 67]), $a([15, 72]), $a([16, 77])]); /*11607*/
		$1.urows = $1.rows; /*11610*/
		$1.i = 0; /*11611*/
		for (;;) { /*11621*/
			$1.m = $get($1.metrics, $1.i); /*11613*/
			$1.r = $get($1.m, 0); /*11614*/
			$1.dcws = $get($1.m, 1); /*11615*/
			$1.okay = true; /*11616*/
			if (($1.urows != 0) && ($1.urows != $1.r)) { /*11617*/
				$1.okay = false; /*11617*/
			} /*11617*/
			if ($1.cws.length > $1.dcws) { /*11618*/
				$1.okay = false; /*11618*/
			} /*11618*/
			if ($1.okay) { /*11619*/
				break; /*11619*/
			} /*11619*/
			$1.i = $1.i + 1; /*11620*/
		} /*11620*/
		$k[$j++] = Infinity; /*11624*/
		$aload($1.cws); /*11624*/
		for (var _Co = 0, _Cp = $1.dcws - $1.cws.length; _Co < _Cp; _Co++) { /*11624*/
			$k[$j++] = 103; /*11624*/
		} /*11624*/
		$1.cws = $a(); /*11624*/
		$k[$j++] = Infinity; /*11627*/
		$k[$j++] = (($1.r - 2) * 7) + $1.mode; /*11627*/
		$aload($1.cws); /*11627*/
		$1.cws = $a(); /*11627*/
		$k[$j++] = 0; /*11630*/
		for (var _Cx = 0, _Cw = $1.dcws; _Cx <= _Cw; _Cx += 1) { /*11630*/
			var _D0 = $k[--$j]; /*11630*/
			$k[$j++] = _D0 + ((_Cx + 2) * $get($1.cws, _Cx)); /*11630*/
		} /*11630*/
		$1.c1 = $k[--$j] % 107; /*11631*/
		$k[$j++] = 0; /*11632*/
		for (var _D4 = 0, _D3 = $1.dcws; _D4 <= _D3; _D4 += 1) { /*11632*/
			var _D7 = $k[--$j]; /*11632*/
			$k[$j++] = _D7 + ((_D4 + 1) * $get($1.cws, _D4)); /*11632*/
		} /*11632*/
		$1.c2 = ($k[--$j] + ($1.c1 * ($1.dcws + 2))) % 107; /*11633*/
		$k[$j++] = Infinity; /*11634*/
		$aload($1.cws); /*11634*/
		$k[$j++] = $1.c1; /*11634*/
		$k[$j++] = $1.c2; /*11634*/
		$1.cws = $a(); /*11634*/
		$1.encs = $a(["212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213", "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132", "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211", "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313", "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331", "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111", "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214", "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111", "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141", "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141", "114131", "311141", "411131", "211412", "211214", "211232", "211133"]); /*11654*/
		$1.startencs = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "3112", "3211", "2221", "2122", "1411", "1132", "1231", "1114", "3112"]); /*11660*/
		$1.stopencsodd = $a(["3211", "2221", "2122", "1411", "1132", "1231", "1114", "3112", "1132", "1231", "1114", "3112", "3211", "2221", "2122", "1411"]); /*11664*/
		$1.stopencseven = $a(["2122", "1411", "1132", "1231", "1114", "3112", "1132", "1231", "1114", "3112", "3211", "2221", "2122", "1411", "3211", "2221"]); /*11668*/
		if (($1.pos == -1) || (((~~($1.pos / 10)) % 2) == 1)) { /*11672*/
			$1.stopencs = $1.stopencsodd; /*11670*/
		} else { /*11672*/
			$1.stopencs = $1.stopencseven; /*11672*/
		} /*11672*/
		$1.rowbits = $a($1.r); /*11676*/
		for (var _DR = 0, _DQ = $1.r - 1; _DR <= _DQ; _DR += 1) { /*11693*/
			$1.i = _DR; /*11678*/
			$k[$j++] = Infinity; /*11688*/
			$k[$j++] = 10; /*11681*/
			$forall($get($1.startencs, $1.i), function() { /*11681*/
				var _DV = $k[--$j]; /*11681*/
				$k[$j++] = _DV - 48; /*11681*/
			}); /*11681*/
			$k[$j++] = 1; /*11685*/
			$forall($geti($1.cws, $1.i * 5, 5), function() { /*11685*/
				$forall($get($1.encs, $k[--$j]), function() { /*11684*/
					var _Dc = $k[--$j]; /*11684*/
					$k[$j++] = _Dc - 48; /*11684*/
				}); /*11684*/
			}); /*11684*/
			$forall($get($1.stopencs, $1.i), function() { /*11686*/
				var _Dg = $k[--$j]; /*11686*/
				$k[$j++] = _Dg - 48; /*11686*/
			}); /*11686*/
			$k[$j++] = 1; /*11687*/
			$1.sbs = $a(); /*11688*/
			$k[$j++] = Infinity; /*11689*/
			var _Di = $1.sbs; /*11690*/
			$k[$j++] = 1; /*11690*/
			for (var _Dj = 0, _Dk = _Di.length; _Dj < _Dk; _Dj++) { /*11690*/
				var _Dm = $k[--$j]; /*11690*/
				var _Dn = (_Dm == 0) ? 1 : 0; /*11690*/
				$k[$j++] = _Dm; /*11690*/
				for (var _Do = 0, _Dp = $get(_Di, _Dj); _Do < _Dp; _Do++) { /*11690*/
					$k[$j++] = _Dn /*11690*/
				} /*11690*/
			} /*11690*/
			$astore($a($counttomark() - 1)); /*11691*/
			var _Ds = $k[--$j]; /*11691*/
			var _Dt = $k[--$j]; /*11691*/
			var _Du = $k[--$j]; /*11691*/
			$put($1.rowbits, $1.i, _Ds); /*11692*/
		} /*11692*/
		$k[$j++] = Infinity; /*11705*/
		for (var _Dy = 0, _Dz = 81 * $1.sepheight; _Dy < _Dz; _Dy++) { /*11697*/
			$k[$j++] = 1; /*11697*/
		} /*11697*/
		for (var _E2 = 0, _E1 = $1.r - 2; _E2 <= _E1; _E2 += 1) { /*11702*/
			$1.i = _E2; /*11699*/
			for (var _E4 = 0, _E5 = $1.rowheight; _E4 < _E5; _E4++) { /*11700*/
				$aload($get($1.rowbits, $1.i)); /*11700*/
			} /*11700*/
			for (var _EA = 0, _EB = $1.sepheight; _EA < _EB; _EA++) { /*11701*/
				for (var _EC = 0, _ED = 10; _EC < _ED; _EC++) { /*11701*/
					$k[$j++] = 0; /*11701*/
				} /*11701*/
				for (var _EE = 0, _EF = 70; _EE < _EF; _EE++) { /*11701*/
					$k[$j++] = 1; /*11701*/
				} /*11701*/
				$k[$j++] = 0; /*11701*/
			} /*11701*/
		} /*11701*/
		for (var _EH = 0, _EI = $1.rowheight; _EH < _EI; _EH++) { /*11703*/
			$aload($get($1.rowbits, $1.r - 1)); /*11703*/
		} /*11703*/
		for (var _EN = 0, _EO = 81 * $1.sepheight; _EN < _EO; _EN++) { /*11704*/
			$k[$j++] = 1; /*11704*/
		} /*11704*/
		$1.pixs = $a(); /*11705*/
		var _EU = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: 81,
			pixy: ~~($1.pixs.length / 81),
			height: (~~($1.pixs.length / 81)) / 72,
			width: 81 / 72,
			opt: $1.options
		}; /*11715*/
		$k[$j++] = _EU; /*11718*/
		if (!$1.dontdraw) { /*11718*/
			$0.renmatrix(); /*11718*/
		} /*11718*/
	};
	$0.code49 = function() {
		var $1 = {}; /*11745*/
		$1.options = $k[--$j]; /*11747*/
		$1.barcode = $k[--$j]; /*11748*/
		$1.dontdraw = false; /*11750*/
		$1.mode = -1; /*11751*/
		$1.pos = -1; /*11752*/
		$1.rows = 0; /*11753*/
		$1.rowheight = 8; /*11754*/
		$1.sepheight = 1; /*11755*/
		$1.parse = false; /*11756*/
		$1.parsefnc = false; /*11757*/
		$forall($1.options, function() { /*11768*/
			var _3 = $k[--$j]; /*11768*/
			$1[$k[--$j]] = _3; /*11768*/
		}); /*11768*/
		$1.mode = ~~$1.mode; /*11770*/
		$1.pos = ~~$1.pos; /*11771*/
		$1.rows = ~~$1.rows; /*11772*/
		$1.rowheight = ~~$1.rowheight; /*11773*/
		$1.sepheight = ~~$1.sepheight; /*11774*/
		$1.barlen = $1.barcode.length; /*11797*/
		$1.s1 = -1; /*11800*/
		$1.s2 = -2; /*11800*/
		$1.fn1 = -3; /*11800*/
		$1.fn2 = -4; /*11800*/
		$1.fn3 = -5; /*11800*/
		$1.ns = -6; /*11800*/
		var _E = {
			FNC1: $1.fn1,
			FNC2: $1.fn2,
			FNC3: $1.fn3
		}; /*11804*/
		$1.fncvals = _E; /*11805*/
		$1.msg = $a($1.barlen); /*11806*/
		$1.i = 0; /*11807*/
		$1.j = 0; /*11807*/
		for (;;) { /*11821*/
			if ($1.i == $1.barlen) { /*11808*/
				break; /*11808*/
			} /*11808*/
			$1.char = $get($1.barcode, $1.i); /*11809*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*11817*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*11815*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*11812*/
					$1.i = $1.i + 4; /*11813*/
				} else { /*11815*/
					$1.i = $1.i + 1; /*11815*/
				} /*11815*/
			} /*11815*/
			$put($1.msg, $1.j, $1.char); /*11818*/
			$1.i = $1.i + 1; /*11819*/
			$1.j = $1.j + 1; /*11820*/
		} /*11820*/
		$1.msg = $geti($1.msg, 0, $1.j); /*11822*/
		$1.msglen = $1.msg.length; /*11823*/
		$1.charmap = $a(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", $1.s1, $1.s2, $1.fn1, $1.fn2, $1.fn3, $1.ns]); /*11832*/
		$1.charvals = {}; /*11835*/
		for (var _q = 0; _q <= 48; _q += 1) { /*11841*/
			$1.i = _q; /*11837*/
			var _t = $get($1.charmap, $1.i); /*11838*/
			$k[$j++] = _t; /*11839*/
			if ($eq($type(_t), "stringtype")) { /*11839*/
				var _w = $get($k[--$j], 0); /*11839*/
				$k[$j++] = _w; /*11839*/
			} /*11839*/
			$put($1.charvals, $k[--$j], $1.i); /*11840*/
		} /*11840*/
		$1.combos = $a(["1 ", "1A", "1B", "1C", "1D", "1E", "1F", "1G", "1H", "1I", "1J", "1K", "1L", "1M", "1N", "1O", "1P", "1Q", "1R", "1S", "1T", "1U", "1V", "1W", "1X", "1Y", "1Z", "11", "12", "13", "14", "15", "  ", "16", "17", "18", " $", " %", "19", "10", "1-", "1.", "1$", " +", "1/", " -", " .", " /", " 0", " 1", " 2", " 3", " 4", " 5", " 6", " 7", " 8", " 9", "1+", "21", "22", "23", "24", "25", "26", " A", " B", " C", " D", " E", " F", " G", " H", " I", " J", " K", " L", " M", " N", " O", " P", " Q", " R", " S", " T", " U", " V", " W", " X", " Y", " Z", "27", "28", "29", "20", "2-", "2.", "2A", "2B", "2C", "2D", "2E", "2F", "2G", "2H", "2I", "2J", "2K", "2L", "2M", "2N", "2O", "2P", "2Q", "2R", "2S", "2T", "2U", "2V", "2W", "2X", "2Y", "2Z", "2$", "2/", "2+", "2%", "2 "]); /*11853*/
		for (var _11 = 0; _11 <= 127; _11 += 1) { /*11863*/
			$1.i = _11; /*11855*/
			var _14 = $get($1.combos, $1.i); /*11856*/
			$1.c1 = $get(_14, 0); /*11856*/
			$1.c2 = $get(_14, 1); /*11856*/
			if ($1.c1 == 49) { /*11859*/
				$put($1.charvals, $1.i, $a([$get($1.charvals, $1.s1), $get($1.charvals, $1.c2)])); /*11858*/
			} /*11858*/
			if ($1.c1 == 50) { /*11862*/
				$put($1.charvals, $1.i, $a([$get($1.charvals, $1.s2), $get($1.charvals, $1.c2)])); /*11861*/
			} /*11861*/
		} /*11861*/
		$1.encodealpha = function() {
			var _1T = $get($1.charvals, $k[--$j]); /*11866*/
			$k[$j++] = _1T; /*11867*/
			if ($ne($type(_1T), "arraytype")) { /*11867*/
				$astore($a(1)); /*11867*/
			} /*11867*/
			var _1W = $k[--$j]; /*11868*/
			$puti($1.cws, $1.j, _1W); /*11868*/
			$1.j = _1W.length + $1.j; /*11869*/
		}; /*11870*/
		$1.base48 = function() {
			var _1a = $k[--$j]; /*11873*/
			$k[$j++] = 0; /*11873*/
			$forall(_1a, function() { /*11873*/
				var _1b = $k[--$j]; /*11873*/
				var _1c = $k[--$j]; /*11873*/
				$k[$j++] = (_1b - 48) + (_1c * 10); /*11873*/
			}); /*11873*/
			$k[$j++] = Infinity; /*11874*/
			var _1d = $k[--$j]; /*11874*/
			var _1e = $k[--$j]; /*11874*/
			var _1f = $k[--$j]; /*11874*/
			$k[$j++] = _1d; /*11874*/
			$k[$j++] = _1e; /*11874*/
			for (var _1g = 0, _1h = _1f - 1; _1g < _1h; _1g++) { /*11874*/
				var _1i = $k[--$j]; /*11874*/
				$k[$j++] = _1i % 48; /*11874*/
				$k[$j++] = ~~(_1i / 48); /*11874*/
			} /*11874*/
			var _1j = $a(); /*11874*/
			$k[$j++] = _1j; /*11875*/
			$k[$j++] = Infinity; /*11875*/
			var _1k = $k[--$j]; /*11875*/
			var _1l = $k[--$j]; /*11875*/
			$k[$j++] = _1k; /*11875*/
			$k[$j++] = _1l; /*11875*/
			for (var _1m = _1l.length - 1; _1m >= 0; _1m -= 1) { /*11875*/
				var _1n = $k[--$j]; /*11875*/
				$k[$j++] = $get(_1n, _1m); /*11875*/
				$k[$j++] = _1n; /*11875*/
			} /*11875*/
			$j--; /*11875*/
			var _1p = $a(); /*11875*/
			$puti($1.cws, $1.j, _1p); /*11876*/
			$1.j = _1p.length + $1.j; /*11877*/
		}; /*11878*/
		$1.encodenumeric = function() {
			$1.nums = $k[--$j]; /*11881*/
			var _1v = $1.nums.length; /*11882*/
			var _1w = _1v % 5; /*11882*/
			$k[$j++] = "pre"; /*11882*/
			$k[$j++] = _1v; /*11882*/
			$k[$j++] = _1w; /*11882*/
			if (_1w != 2) { /*11882*/
				var _1x = $k[--$j]; /*11882*/
				var _1y = $k[--$j]; /*11882*/
				$k[$j++] = _1y - _1x; /*11882*/
			} else { /*11882*/
				var _1z = $k[--$j]; /*11882*/
				var _20 = $k[--$j]; /*11882*/
				$k[$j++] = (_20 - _1z) - 5; /*11882*/
			} /*11882*/
			var _21 = $k[--$j]; /*11882*/
			$1[$k[--$j]] = _21; /*11882*/
			for (var _25 = 0, _24 = $1.pre - 1; _25 <= _24; _25 += 5) { /*11883*/
				$k[$j++] = 3; /*11883*/
				$k[$j++] = $geti($1.nums, _25, 5); /*11883*/
				if ($1.base48() == $b) break; /*11883*/
			} /*11883*/
			$1.nums = $geti($1.nums, $1.pre, $1.nums.length - $1.pre); /*11884*/
			var _2E = $1.nums.length; /*11886*/
			$k[$j++] = _2E; /*11886*/
			if (_2E == 1) { /*11886*/
				$k[$j++] = $get($1.nums, $1.i); /*11886*/
				if ($1.encodealpha() == $b) return $b; /*11886*/
			} /*11886*/
			var _2I = $k[--$j]; /*11887*/
			$k[$j++] = _2I; /*11887*/
			if (_2I == 3) { /*11887*/
				$k[$j++] = 2; /*11887*/
				$k[$j++] = $1.nums; /*11887*/
				if ($1.base48() == $b) return $b; /*11887*/
			} /*11887*/
			var _2K = $k[--$j]; /*11888*/
			$k[$j++] = _2K; /*11888*/
			if (_2K == 4) { /*11888*/
				$k[$j++] = 3; /*11888*/
				$k[$j++] = Infinity; /*11888*/
				$k[$j++] = 49; /*11888*/
				$k[$j++] = 48; /*11888*/
				$aload($1.nums); /*11888*/
				var _2M = $a(); /*11888*/
				$k[$j++] = _2M; /*11888*/
				if ($1.base48() == $b) return $b; /*11888*/
			} /*11888*/
			if ($k[--$j] == 7) { /*11892*/
				$k[$j++] = 3; /*11890*/
				$k[$j++] = Infinity; /*11890*/
				$k[$j++] = 49; /*11890*/
				$k[$j++] = 48; /*11890*/
				$aload($geti($1.nums, 0, 4)); /*11890*/
				var _2Q = $a(); /*11890*/
				$k[$j++] = _2Q; /*11890*/
				if ($1.base48() == $b) return $b; /*11890*/
				$k[$j++] = 2; /*11891*/
				$k[$j++] = $geti($1.nums, 4, 3); /*11891*/
				if ($1.base48() == $b) return $b; /*11891*/
			} /*11891*/
		}; /*11893*/
		$k[$j++] = Infinity; /*11896*/
		for (var _2U = 0, _2V = $1.msglen; _2U < _2V; _2U++) { /*11896*/
			$k[$j++] = 0; /*11896*/
		} /*11896*/
		$k[$j++] = 0; /*11896*/
		$1.numericruns = $a(); /*11896*/
		for (var _2Y = $1.msglen - 1; _2Y >= 0; _2Y -= 1) { /*11905*/
			$1.i = _2Y; /*11898*/
			var _2b = $get($1.msg, $1.i); /*11899*/
			if ((_2b >= 48) && (_2b <= 57)) { /*11903*/
				$put($1.numericruns, $1.i, $get($1.numericruns, $1.i + 1) + 1); /*11901*/
			} else { /*11903*/
				$put($1.numericruns, $1.i, 0); /*11903*/
			} /*11903*/
		} /*11903*/
		if ($1.mode == -1) { /*11917*/
			for (;;) { /*11916*/
				if ($1.pos != -1) { /*11910*/
					$1.mode = 3; /*11910*/
					break; /*11910*/
				} /*11910*/
				if ($get($1.numericruns, 0) >= 5) { /*11911*/
					$1.mode = 2; /*11911*/
					break; /*11911*/
				} /*11911*/
				var _2q = $get($1.charvals, $get($1.msg, 0)); /*11912*/
				$k[$j++] = _2q; /*11913*/
				if ($ne($type(_2q), "arraytype")) { /*11913*/
					$j--; /*11913*/
					$1.mode = 0; /*11913*/
					break; /*11913*/
				} /*11913*/
				var _2u = ($get($k[--$j], 0) == 43) ? 4 : 5; /*11914*/
				$1.mode = _2u; /*11914*/
				break; /*11915*/
			} /*11915*/
		} /*11915*/
		$1.cws = $a(($1.msglen * 2) + 1); /*11919*/
		$1.method = "alpha"; /*11920*/
		$1.i = -1; /*11920*/
		$1.j = -1; /*11920*/
		if (($1.mode == 0) || ($1.mode == 1)) { /*11923*/
			$1.method = "alpha"; /*11923*/
			$1.i = 0; /*11923*/
			$1.j = 0; /*11923*/
		} /*11923*/
		if ($1.mode == 2) { /*11924*/
			$1.method = "numeric"; /*11924*/
			$1.i = 0; /*11924*/
			$1.j = 0; /*11924*/
		} /*11924*/
		if ($1.mode == 3) { /*11938*/
			$1.posval = $a([12, 22, 13, 23, 33, 14, 24, 34, 44, 15, 25, 35, 45, 55, 16, 26, 36, 46, 56, 66, 17, 27, 37, 47, 57, 67, 77, 18, 28, 38, 48, 58, 68, 78, 88, 19, 29, 39, 49, 59, 69, 79, 89, 99]); /*11935*/
			$k[$j++] = $1.cws; /*11936*/
			$k[$j++] = 0; /*11936*/
			for (var _33 = 0; _33 <= 43; _33 += 1) { /*11936*/
				$k[$j++] = _33; /*11936*/
				if ($get($1.posval, _33) != $1.pos) { /*11936*/
					$j--; /*11936*/
				} /*11936*/
			} /*11936*/
			var _37 = $k[--$j]; /*11936*/
			var _38 = $k[--$j]; /*11936*/
			$put($k[--$j], _38, _37 + 1); /*11936*/
			$1.method = "alpha"; /*11937*/
			$1.i = 0; /*11937*/
			$1.j = 1; /*11937*/
		} /*11937*/
		if (($1.mode == 4) || ($1.mode == 5)) { /*11942*/
			$put($1.cws, 0, $get($get($1.charvals, $get($1.msg, 0)), 1)); /*11940*/
			$1.method = "alpha"; /*11941*/
			$1.i = 1; /*11941*/
			$1.j = 1; /*11941*/
		} /*11941*/
		for (;;) { /*11969*/
			if ($1.i == $1.msglen) { /*11946*/
				break; /*11946*/
			} /*11946*/
			for (;;) { /*11968*/
				if ($eq($1.method, "alpha")) { /*11957*/
					if ($get($1.numericruns, $1.i) >= 5) { /*11953*/
						$k[$j++] = $1.ns; /*11950*/
						if ($1.encodealpha() == $b) break; /*11950*/
						$1.method = "numeric"; /*11951*/
						break; /*11952*/
					} /*11952*/
					$k[$j++] = $get($1.msg, $1.i); /*11954*/
					if ($1.encodealpha() == $b) break; /*11954*/
					$1.i = $1.i + 1; /*11955*/
					break; /*11956*/
				} /*11956*/
				if ($eq($1.method, "numeric")) { /*11967*/
					if ($get($1.numericruns, $1.i) < 5) { /*11963*/
						$k[$j++] = $1.ns; /*11960*/
						if ($1.encodealpha() == $b) break; /*11960*/
						$1.method = "alpha"; /*11961*/
						break; /*11962*/
					} /*11962*/
					$k[$j++] = $geti($1.msg, $1.i, $get($1.numericruns, $1.i)); /*11964*/
					if ($1.encodenumeric() == $b) break; /*11964*/
					$1.i = $1.i + $get($1.numericruns, $1.i); /*11965*/
					break; /*11966*/
				} /*11966*/
			} /*11966*/
		} /*11966*/
		$1.cws = $geti($1.cws, 0, $1.j); /*11970*/
		$1.metrics = $a([$a([2, 9]), $a([3, 16]), $a([4, 23]), $a([5, 30]), $a([6, 37]), $a([7, 42]), $a([8, 49])]); /*11982*/
		$1.urows = $1.rows; /*11985*/
		$1.i = 0; /*11986*/
		for (;;) { /*11996*/
			$1.m = $get($1.metrics, $1.i); /*11988*/
			$1.r = $get($1.m, 0); /*11989*/
			$1.dcws = $get($1.m, 1); /*11990*/
			$1.okay = true; /*11991*/
			if (($1.urows != 0) && ($1.urows != $1.r)) { /*11992*/
				$1.okay = false; /*11992*/
			} /*11992*/
			if ($1.cws.length > $1.dcws) { /*11993*/
				$1.okay = false; /*11993*/
			} /*11993*/
			if ($1.okay) { /*11994*/
				break; /*11994*/
			} /*11994*/
			$1.i = $1.i + 1; /*11995*/
		} /*11995*/
		$k[$j++] = Infinity; /*11999*/
		$aload($1.cws); /*11999*/
		for (var _4B = 0, _4C = $1.dcws - $1.cws.length; _4B < _4C; _4B++) { /*11999*/
			$k[$j++] = 48; /*11999*/
		} /*11999*/
		$1.cws = $a(); /*11999*/
		$1.ccs = $a($1.r * 8); /*12002*/
		$1.j = 0; /*12003*/
		for (var _4I = 0, _4H = $1.r - 2; _4I <= _4H; _4I += 1) { /*12010*/
			$1.i = _4I; /*12005*/
			$1.cc = $geti($1.cws, $1.j, 7); /*12006*/
			$puti($1.ccs, $1.i * 8, $1.cc); /*12007*/
			$k[$j++] = $1.ccs; /*12008*/
			$k[$j++] = ($1.i * 8) + 7; /*12008*/
			$k[$j++] = 0; /*12008*/
			$forall($1.cc, function() { /*12008*/
				var _4S = $k[--$j]; /*12008*/
				var _4T = $k[--$j]; /*12008*/
				$k[$j++] = _4T + _4S; /*12008*/
			}); /*12008*/
			var _4U = $k[--$j]; /*12008*/
			var _4V = $k[--$j]; /*12008*/
			$put($k[--$j], _4V, _4U % 49); /*12008*/
			$1.j = $1.j + 7; /*12009*/
		} /*12009*/
		if ($1.j < $1.dcws) { /*12013*/
			$puti($1.ccs, $1.ccs.length - 8, $geti($1.cws, $1.j, $1.dcws - $1.j)); /*12012*/
		} /*12012*/
		$1.cr7 = (($1.r - 2) * 7) + $1.mode; /*12016*/
		$put($1.ccs, $1.ccs.length - 2, $1.cr7); /*12017*/
		var _4m = $a([1, 9, 31, 26, 2, 12, 17, 23, 37, 18, 22, 6, 27, 44, 15, 43, 39, 11, 13, 5, 41, 33, 36, 8, 4, 32, 3, 19, 40, 25, 29, 10, 24, 30]); /*12021*/
		$k[$j++] = _4m; /*12022*/
		$k[$j++] = _4m; /*12022*/
		$k[$j++] = Infinity; /*12022*/
		var _4n = $k[--$j]; /*12022*/
		var _4p = $geti($k[--$j], 0, 32); /*12022*/
		$k[$j++] = _4n; /*12022*/
		$k[$j++] = 20; /*12022*/
		$aload(_4p); /*12022*/
		$1.weightx = $a(); /*12022*/
		var _4r = $k[--$j]; /*12023*/
		$k[$j++] = _4r; /*12023*/
		$k[$j++] = _4r; /*12023*/
		$k[$j++] = Infinity; /*12023*/
		var _4s = $k[--$j]; /*12023*/
		var _4u = $geti($k[--$j], 1, 32); /*12023*/
		$k[$j++] = _4s; /*12023*/
		$k[$j++] = 16; /*12023*/
		$aload(_4u); /*12023*/
		$1.weighty = $a(); /*12023*/
		$k[$j++] = Infinity; /*12024*/
		var _4w = $k[--$j]; /*12024*/
		var _4y = $geti($k[--$j], 2, 32); /*12024*/
		$k[$j++] = _4w; /*12024*/
		$k[$j++] = 38; /*12024*/
		$aload(_4y); /*12024*/
		$1.weightz = $a(); /*12024*/
		$1.calccheck = function() {
			$1.weights = $k[--$j]; /*12026*/
			$1.score = 0; /*12027*/
			for (var _53 = 0, _52 = (~~((($1.r - 1) * 8) / 2)) - 1; _53 <= _52; _53 += 1) { /*12032*/
				$1.i = _53; /*12029*/
				$1.score = ((($get($1.ccs, $1.i * 2) * 49) + $get($1.ccs, ($1.i * 2) + 1)) * $get($1.weights, $1.i + 1)) + $1.score; /*12031*/
			} /*12031*/
			$k[$j++] = $1.score; /*12033*/
		}; /*12034*/
		$1.lastrow = $geti($1.ccs, $1.ccs.length - 8, 8); /*12035*/
		if ($1.r >= 7) { /*12042*/
			$k[$j++] = $1.cr7 * $get($1.weightz, 0); /*12039*/
			$k[$j++] = $1.weightz; /*12039*/
			if ($1.calccheck() == $b) return $b; /*12039*/
			var _5N = $k[--$j]; /*12039*/
			var _5P = ($k[--$j] + _5N) % 2401; /*12040*/
			$k[$j++] = ~~(_5P / 49); /*12040*/
			$k[$j++] = _5P % 49; /*12040*/
			$astore($a(2)); /*12040*/
			$puti($1.lastrow, 0, $k[--$j]); /*12041*/
		} /*12041*/
		$1.wr1 = ($get($1.lastrow, 0) * 49) + $get($1.lastrow, 1); /*12043*/
		$k[$j++] = $1.cr7 * $get($1.weighty, 0); /*12046*/
		$k[$j++] = $1.weighty; /*12046*/
		if ($1.calccheck() == $b) return $b; /*12046*/
		var _5b = $k[--$j]; /*12046*/
		var _5h = (($k[--$j] + _5b) + ($1.wr1 * $get($1.weighty, ($1.r * 4) - 3))) % 2401; /*12048*/
		$1.wr2 = _5h; /*12048*/
		$k[$j++] = ~~(_5h / 49); /*12049*/
		$k[$j++] = _5h % 49; /*12049*/
		$astore($a(2)); /*12049*/
		$puti($1.lastrow, 2, $k[--$j]); /*12050*/
		$k[$j++] = $1.cr7 * $get($1.weightx, 0); /*12053*/
		$k[$j++] = $1.weightx; /*12053*/
		if ($1.calccheck() == $b) return $b; /*12053*/
		var _5p = $k[--$j]; /*12053*/
		var _5z = ((($k[--$j] + _5p) + ($1.wr1 * $get($1.weightx, ($1.r * 4) - 3))) + ($1.wr2 * $get($1.weightx, ($1.r * 4) - 2))) % 2401; /*12057*/
		$k[$j++] = ~~(_5z / 49); /*12057*/
		$k[$j++] = _5z % 49; /*12057*/
		$astore($a(2)); /*12057*/
		$puti($1.lastrow, 4, $k[--$j]); /*12058*/
		$k[$j++] = 0; /*12061*/
		$forall($geti($1.ccs, $1.ccs.length - 8, 7), function() { /*12061*/
			var _66 = $k[--$j]; /*12061*/
			var _67 = $k[--$j]; /*12061*/
			$k[$j++] = _67 + _66; /*12061*/
		}); /*12061*/
		$put($1.ccs, $1.ccs.length - 1, $k[--$j] % 49); /*12062*/
		$1.patterns = $a([$a(["11521132", "25112131", "14212132", "25121221", "14221222", "12412132", "23321221", "12421222", "21521221", "15112222", "15121312", "13312222", "24221311", "13321312", "11512222", "22421311", "11521312", "25112311", "14212312", "23312311", "12412312", "21512311", "16121131", "14321131", "12521131", "15212131", "15221221", "13412131", "13421221", "11612131", "16112221", "16121311", "14312221", "14321311", "12512221", "12521311", "15212311", "13412311", "11612311", "11131135", "31131133", "51131131", "21122134", "41122132", "21131224", "41131222", "11113135", "31113133", "51113131", "11122225", "31122223", "51122221", "11131315", "31131313", "51131311", "21113224", "41113222", "21122314", "41122312", "11113315", "31113313", "51113311", "12131134", "32131132", "21231133", "41231131", "22122133", "42122131", "11222134", "22131223", "42131221", "11231224", "31231222", "12113134", "32113132", "12122224", "32122222", "12131314", "32131312", "21231313", "41231311", "22113223", "42113221", "11213224", "22122313", "42122311", "11222314", "31222312", "12113314", "32113312", "21213313", "41213311", "13131133", "33131131", "22231132", "11331133", "31331131", "23122132", "12222133", "23131222", "12231223", "32231221", "21331222", "13113133", "33113131", "13122223", "33122221", "11313133", "13131313", "33131311", "11322223", "22231312", "11331313", "31331311", "23113222", "12213223", "23122312", "12222313", "32222311", "21322312", "13113313", "33113311", "22213312", "11313313", "31313311", "14131132", "23231131", "12331132", "21431131", "24122131", "13222132", "24131221", "13231222", "11422132", "22331221", "11431222", "14113132", "14122222", "12313132", "14131312", "12322222", "23231311", "12331312", "21431311", "24113221", "13213222", "24122311", "13222312", "11413222", "22322311", "11422312", "14113312", "23213311", "12313312", "21413311", "15131131", "13331131", "14222131", "14231221", "12422131", "12431221", "15113131", "15122221", "13313131", "15131311", "13322221", "11513131", "13331311", "11522221", "14213221", "14222311", "12413221", "12422311", "15113311", "13313311", "11513311", "11141134", "31141132", "21132133", "41132131", "21141223", "41141221", "11123134", "31123132", "11132224", "31132222", "11141314", "31141312", "21114133", "41114131", "21123223", "41123221", "21132313", "41132311", "11114224", "31114222", "11123314", "31123312", "21114313", "41114311", "12141133", "32141131", "21241132", "22132132", "11232133", "22141222", "11241223", "31241221", "12123133", "32123131", "12132223", "32132221", "12141313", "32141311", "21241312", "22114132", "11214133", "22123222", "11223223", "22132312", "11232313", "31232311", "12114223", "32114221", "12123313", "32123311", "21223312", "22114312", "11214313", "31214311", "13141132", "22241131", "11341132", "23132131", "12232132", "23141221", "12241222", "21341221", "13123132", "13132222", "11323132", "13141312", "11332222", "22241311", "11341312", "23114131", "12214132", "23123221", "12223222", "23132311", "12232312", "21332311", "13114222", "13123312", "11314222", "22223311", "11323312", "23114311", "12214312", "21314311", "14141131", "12341131", "13232131", "13241221", "11432131", "14123131", "14132221", "12323131", "14141311", "12332221", "12341311", "13214131", "13223221", "11414131", "13232311", "11423221", "11432311", "14114221", "14123311", "12314221", "12323311", "13214311", "11414311", "11151133", "31151131", "21142132", "21151222", "11133133", "31133131", "11142223", "31142221", "11151313", "31151311", "21124132", "21133222", "21142312", "11115133", "31115131", "11124223", "31124221", "11133313", "31133311", "21115222", "21124312", "12151132", "21251131", "22142131", "11242132", "22151221", "11251222", "12133132", "12142222", "12151312", "21251311", "22124131", "11224132", "22133221", "11233222", "22142311", "11242312", "12115132", "12124222", "12133312", "21233311", "22115221", "11215222", "22124311", "11224312", "13151131", "12242131", "12251221", "13133131", "13142221", "11333131", "13151311", "11342221", "12224131", "12233221", "12242311", "13115131", "13124221", "11315131", "13133311", "11324221", "11333311", "12215221", "12224311", "11161132", "21152131", "21161221", "11143132", "11152222", "11161312", "21134131", "21143221", "21152311", "11125132", "11134222", "11143312", "21116131", "21125221", "21134311", "12161131", "11252131", "12143131", "12152221", "12161311", "11234131", "11243221", "11252311", "12125131", "12134221", "12143311", "11216131", "11225221", "11234311", "11111236", "31111234", "51111232", "21111325", "41111323", "61111321", "11111416", "31111414", "51111412", "31211143", "51211141", "12111235", "32111233", "52111231", "21211234", "41211232", "22111324", "42111322", "11211325", "31211323", "51211321", "12111415", "32111413", "52111411", "21211414", "41211412", "12211144", "32211142", "21311143", "41311141", "13111234", "33111232", "22211233", "42211231", "11311234", "31311232", "23111323", "43111321", "12211324", "32211322", "21311323", "41311321", "13111414", "33111412", "22211413", "42211411", "11311414", "31311412", "13211143", "33211141", "22311142", "11411143", "31411141", "14111233", "34111231", "23211232", "12311233", "32311231", "21411232", "24111322", "13211323", "33211321", "22311322", "11411323", "31411321", "14111413", "34111411", "23211412", "12311413", "32311411", "21411412", "14211142", "23311141", "12411142", "21511141", "15111232", "24211231", "13311232", "22411231", "11511232", "25111321", "14211322", "23311321", "12411322", "21511321", "15111412", "24211411", "13311412", "22411411", "11511412", "15211141", "13411141", "11611141", "16111231", "14311231", "12511231", "15211321", "13411321", "11611321", "16111411", "14311411", "12511411", "21121144", "41121142", "11112145", "31112143", "51112141", "11121235", "31121233", "51121231", "21112234", "41112232", "21121324", "41121322", "11112325", "31112323", "51112321", "11121415", "31121413", "51121411", "21112414", "41112412", "22121143", "42121141", "11221144", "31221142", "12112144", "32112142", "12121234", "32121232", "21221233", "41221231", "22112233", "42112231", "11212234", "22121323", "42121321", "11221324", "31221322", "12112324", "32112322", "12121414", "32121412", "21221413", "41221411", "22112413", "42112411", "11212414", "31212412", "23121142", "12221143", "32221141", "21321142", "13112143", "33112141", "13121233", "33121231", "11312143", "22221232", "11321233", "31321231", "23112232", "12212233", "23121322", "12221323", "32221321", "21321322", "13112323", "33112321", "13121413", "33121411", "11312323", "22221412", "11321413", "31321411", "23112412", "12212413", "32212411", "21312412", "24121141", "13221142", "22321141", "11421142", "14112142", "14121232", "12312142", "23221231", "12321232", "21421231", "24112231", "13212232", "24121321", "13221322", "11412232", "22321321", "11421322", "14112322", "14121412", "12312322", "23221411", "12321412", "21421411", "24112411", "13212412", "22312411", "11412412", "14221141", "12421141", "15112141", "15121231", "13312141", "13321231", "11512141", "11521231", "14212231", "14221321", "12412231", "12421321", "15112321", "15121411", "13312321", "13321411", "11512321", "11521411", "14212411", "12412411", "21131143", "41131141", "11122144", "31122142", "11131234", "31131232", "21113143", "41113141", "21122233", "41122231", "21131323", "41131321", "11113234", "31113232", "11122324", "31122322", "11131414", "31131412", "21113323", "41113321", "21122413", "41122411", "11113414", "31113412", "22131142", "11231143", "31231141", "12122143", "32122141", "12131233", "32131231", "21231232", "22113142", "11213143", "22122232", "11222233", "22131322", "11231323", "31231321", "12113233", "32113231", "12122323", "32122321", "12131413", "32131411", "21231412", "22113322", "11213323", "22122412", "11222413", "31222411", "12113413", "32113411", "21213412", "23131141", "12231142", "21331141", "13122142", "13131232", "11322142", "22231231", "11331232", "23113141", "12213142", "23122231", "12222232", "23131321", "12231322", "21331321", "13113232", "13122322", "11313232", "13131412", "11322322", "22231411", "11331412", "23113321", "12213322", "23122411", "12222412", "21322411", "13113412", "22213411", "11313412", "13231141", "11431141", "14122141", "14131231", "12322141", "12331231", "13213141", "13222231", "11413141", "13231321", "11422231", "11431321", "14113231", "14122321", "12313231", "14131411", "12322321", "12331411", "13213321", "13222411", "11413321", "11422411", "14113411", "12313411", "21141142", "11132143", "31132141", "11141233", "31141231", "21123142", "21132232", "21141322", "11114143", "31114141", "11123233", "31123231", "11132323", "31132321", "11141413", "31141411", "21114232", "21123322", "21132412", "11114323", "31114321", "11123413", "31123411", "22141141", "11241142", "12132142", "12141232", "21241231", "22123141", "11223142", "22132231", "11232232", "22141321", "11241322", "12114142", "12123232", "12132322", "12141412", "21241411", "22114231", "11214232", "22123321", "11223322", "22132411", "11232412", "12114322", "12123412", "21223411", "12241141", "13132141", "13141231", "11332141", "11341231", "12223141", "12232231", "12241321", "13114141", "13123231", "11314141", "13132321", "11323231", "13141411", "11332321", "11341411", "12214231", "12223321", "12232411", "13114321", "13123411", "11314321", "11323411", "21151141", "11142142", "11151232", "21133141", "21142231", "21151321", "11124142", "11133232", "11142322", "11151412", "21115141", "21124231", "21133321", "21142411", "11115232", "11124322", "11133412", "11251141", "12142141", "12151231", "11233141", "11242231", "11251321", "12124141", "12133231", "12142321", "12151411", "11215141", "11224231", "11233321", "11242411", "12115231", "12124321", "12133411", "11152141", "11161231", "11134141", "11143231", "11152321", "11161411", "11116141", "11125231", "11134321", "11143411", "21111244", "41111242", "11111335", "31111333", "51111331", "21111424", "41111422", "11111515", "31111513", "51111511", "21211153", "41211151", "22111243", "42111241", "11211244", "31211242", "12111334", "32111332", "21211333", "41211331", "22111423", "42111421", "11211424", "31211422", "12111514", "32111512", "21211513", "41211511", "22211152", "11311153", "31311151", "23111242", "12211243", "32211241", "21311242", "13111333", "33111331", "22211332", "11311333", "31311331", "23111422", "12211423", "32211421", "21311422", "13111513", "33111511", "22211512", "11311513", "31311511", "23211151", "12311152", "21411151", "24111241", "13211242", "22311241", "11411242", "14111332", "23211331", "12311332", "21411331", "24111421", "13211422", "22311421", "11411422", "14111512", "23211511", "12311512", "21411511", "13311151", "11511151", "14211241", "12411241", "15111331", "13311331", "11511331", "14211421", "12411421", "15111511", "13311511", "11511511", "31121152", "21112153", "41112151", "21121243", "41121241", "11112244", "31112242", "11121334", "31121332", "21112333", "41112331", "21121423", "41121421", "11112424", "31112422", "11121514", "31121512", "21112513", "41112511", "12121153", "32121151", "21221152", "22112152", "11212153", "22121242", "11221243", "31221241", "12112243", "32112241", "12121333", "32121331", "21221332", "22112332", "11212333", "22121422", "11221423", "31221421", "12112423", "32112421", "12121513", "32121511", "21221512", "22112512", "11212513", "31212511", "13121152", "22221151", "11321152", "23112151", "12212152", "23121241", "12221242", "21321241", "13112242", "13121332", "11312242", "22221331", "11321332", "23112331", "12212332", "23121421", "12221422", "21321421", "13112422", "13121512", "11312422", "22221511", "11321512", "23112511", "12212512", "21312511", "14121151", "12321151", "13212151", "13221241", "11412151", "11421241", "14112241", "14121331", "12312241", "12321331", "13212331", "13221421", "11412331", "11421421", "14112421", "14121511", "12312421", "12321511", "13212511", "11412511", "11131153", "31131151", "21122152", "21131242", "11113153", "31113151", "11122243", "31122241", "11131333", "31131331", "21113242", "21122332", "21131422", "11113333", "31113331", "11122423", "31122421", "11131513", "31131511", "21113422", "21122512", "12131152", "21231151", "22122151", "11222152", "22131241", "11231242", "12113152", "12122242", "12131332", "21231331", "22113241", "11213242", "22122331", "11222332", "22131421", "11231422", "12113332", "12122422", "12131512", "21231511", "22113421", "11213422", "22122511", "11222512", "13131151", "11331151", "12222151", "12231241", "13113151", "13122241", "11313151", "13131331", "11322241", "11331331", "12213241", "12222331", "12231421", "13113331", "13122421", "11313331", "13131511", "11322421", "11331511", "12213421", "12222511", "11141152", "21132151", "21141241", "11123152", "11132242", "11141332", "21114151", "21123241", "21132331", "21141421", "11114242", "11123332", "11132422", "11141512", "21114331", "21123421", "21132511", "12141151", "11232151", "11241241", "12123151", "12132241", "12141331", "11214151", "11223241", "11232331", "11241421", "12114241", "12123331", "12132421", "12141511", "11214331", "11223421", "11232511", "11151151", "11133151", "11142241", "11151331", "11115151", "11124241", "11133331", "11142421", "11151511", "11111254", "31111252", "21111343", "41111341", "11111434", "31111432", "21111523", "41111521", "11111614", "31111612", "31211161", "12111253", "32111251", "21211252", "22111342", "11211343", "31211341", "12111433", "32111431", "21211432", "22111522", "11211523", "31211521", "12111613", "32111611", "21211612", "12211162", "21311161", "13111252", "22211251", "11311252", "23111341", "12211342", "21311341", "13111432", "22211431", "11311432", "23111521", "12211522", "21311521", "13111612", "22211611", "11311612", "13211161", "11411161", "14111251", "12311251", "13211341", "11411341", "14111431", "12311431", "13211521", "11411521", "14111611", "12311611", "21121162", "11112163", "31112161", "11121253", "31121251", "21112252", "21121342", "11112343", "31112341", "11121433", "31121431", "21112432", "21121522", "11112523", "31112521", "11121613", "31121611", "22121161", "11221162", "12112162", "12121252", "21221251", "22112251", "11212252", "22121341", "11221342", "12112342", "12121432", "21221431", "22112431", "11212432", "22121521", "11221522", "12112522", "12121612", "21221611", "12221161", "13112161", "13121251", "11312161", "11321251", "32121115", "52121113", "21221116", "41221114", "61221112", "22112116", "42112114", "31212115", "51212113", "13121116", "33121114", "22221115", "42221113", "11321116", "31321114", "51321112", "23112115", "43112113", "12212116", "32212114", "52212112", "21312115", "41312113", "61312111", "14121115", "34121113", "23221114", "43221112", "12321115", "32321113", "52321111", "21421114", "41421112", "24112114", "13212115", "33212113", "22312114", "42312112", "11412115", "31412113", "51412111", "15121114", "24221113", "13321114", "33321112", "22421113", "42421111", "11521114", "31521112", "25112113", "14212114", "34212112", "23312113", "43312111", "12412114", "32412112", "21512113", "41512111", "16121113", "25221112", "14321113", "34321111", "23421112", "12521113", "32521111", "15212113", "24312112", "13412113", "33412111", "22512112", "11612113", "31612111", "31131115", "51131113", "21122116", "41122114", "61122112", "31113115", "51113113", "12131116", "32131114", "52131112", "21231115", "41231113", "61231111", "22122115", "42122113", "11222116", "31222114", "51222112", "12113116", "32113114", "52113112", "21213115", "41213113", "61213111", "13131115", "33131113", "22231114", "42231112", "11331115", "31331113", "51331111", "23122114", "43122112", "12222115", "32222113", "52222111", "21322114", "41322112", "13113115", "33113113", "22213114", "42213112", "11313115", "31313113", "51313111", "14131114", "34131112", "23231113", "43231111", "12331114", "32331112", "21431113", "41431111", "24122113", "13222114", "33222112", "22322113", "42322111", "11422114", "31422112", "14113114", "34113112", "23213113", "43213111", "12313114", "32313112", "21413113", "41413111", "15131113", "24231112", "13331113", "33331111", "22431112", "25122112", "14222113", "34222111", "23322112", "12422113", "32422111", "21522112", "15113113", "24213112", "13313113", "33313111", "22413112", "11513113", "31513111", "16131112", "25231111", "14331112", "23431111", "15222112", "24322111", "13422112", "22522111", "16113112", "25213111", "14313112", "23413111", "12513112", "21613111", "11141116", "31141114", "51141112", "21132115", "41132113", "61132111", "11123116", "31123114", "51123112", "21114115", "41114113", "61114111", "12141115", "32141113", "52141111", "21241114", "41241112", "22132114", "42132112", "11232115", "31232113", "51232111", "12123115", "32123113", "52123111", "21223114", "41223112", "22114114", "42114112", "11214115", "31214113", "51214111", "13141114", "33141112", "22241113", "42241111", "11341114", "31341112", "23132113", "43132111", "12232114", "32232112", "21332113", "41332111", "13123114", "33123112", "22223113", "42223111", "11323114", "31323112", "23114113", "43114111", "12214114", "32214112", "21314113", "41314111", "14141113", "34141111", "23241112", "12341113", "32341111", "24132112", "13232113", "33232111", "22332112", "11432113", "31432111", "14123113", "34123111", "23223112", "12323113", "32323111", "21423112", "24114112", "13214113", "33214111", "22314112", "11414113", "31414111", "15141112", "24241111", "13341112", "25132111", "14232112", "23332111", "12432112", "15123112", "24223111", "13323112", "22423111", "11523112", "25114111", "14214112", "23314111", "12414112", "21514111", "16141111", "14341111", "15232111", "13432111", "16123111", "14323111", "12523111", "15214111", "13414111", "11614111", "11151115", "31151113", "51151111", "21142114", "41142112", "11133115", "31133113", "51133111", "21124114", "41124112", "11115115", "31115113", "51115111", "12151114", "32151112", "21251113", "41251111", "22142113", "42142111", "11242114", "31242112", "12133114", "32133112", "21233113", "41233111", "22124113", "42124111", "11224114", "31224112", "12115114", "32115112", "21215113", "41215111", "13151113", "33151111", "22251112", "23142112", "12242113", "32242111", "21342112", "13133113", "33133111", "22233112", "11333113", "31333111", "23124112", "12224113", "32224111", "21324112", "13115113", "33115111", "22215112", "11315113", "31315111", "14151112", "23251111", "24142111", "13242112", "22342111", "14133112", "23233111", "12333112", "21433111", "24124111", "13224112", "22324111", "11424112", "14115112", "23215111", "12315112", "21415111", "15151111", "14242111", "15133111", "13333111", "14224111", "12424111", "15115111", "13315111", "11515111", "11161114", "31161112", "21152113", "41152111", "11143114", "31143112", "21134113", "41134111", "11125114", "31125112", "21116113", "41116111", "12161113", "32161111", "22152112", "11252113", "31252111", "12143113", "32143111", "21243112", "22134112", "11234113", "31234111", "12125113", "32125111", "21225112", "22116112", "11216113", "31216111", "13161112", "23152111", "12252112", "13143112", "22243111", "11343112", "23134111", "12234112", "21334111", "13125112", "22225111", "11325112", "23116111", "12216112", "21316111", "14161111", "13252111", "14143111", "12343111", "13234111", "11434111", "14125111", "12325111", "13216111", "11416111", "31111216", "51111214", "31211125", "51211123", "32111215", "52111213", "21211216", "41211214", "61211212", "12211126", "32211124", "52211122", "21311125", "41311123", "61311121", "13111216", "33111214", "22211215", "42211213", "11311216", "31311214", "51311212", "13211125", "33211123", "22311124", "42311122", "11411125", "31411123", "51411121", "14111215", "34111213", "23211214", "43211212", "12311215", "32311213", "52311211", "21411214", "41411212", "14211124", "34211122", "23311123", "43311121", "12411124", "32411122", "21511123", "41511121", "15111214", "24211213", "13311214", "33311212", "22411213", "42411211", "11511214", "31511212", "15211123", "24311122", "13411123", "33411121", "22511122", "11611123", "31611121", "16111213", "25211212", "14311213", "34311211", "23411212", "12511213", "32511211", "21611212", "21121126", "41121124", "61121122", "31112125", "51112123", "31121215", "51121213", "21112216", "41112214", "61112212", "22121125", "42121123", "11221126", "31221124", "51221122", "12112126", "32112124", "52112122", "12121216", "32121214", "52121212", "21221215", "41221213", "61221211", "22112215", "42112213", "11212216", "31212214", "51212212", "23121124", "43121122", "12221125", "32221123", "52221121", "21321124", "41321122", "13112125", "33112123", "13121215", "33121213", "11312125", "22221214", "42221212", "11321215", "31321213", "51321211", "23112214", "43112212", "12212215", "32212213", "52212211", "21312214", "41312212", "24121123", "13221124", "33221122", "22321123", "42321121", "11421124", "31421122", "14112124", "34112122", "14121214", "34121212", "12312124", "23221213", "43221211", "12321214", "32321212", "21421213", "41421211", "24112213", "13212214", "33212212", "22312213", "42312211", "11412214", "31412212", "25121122", "14221123", "34221121", "23321122", "12421123", "32421121", "21521122", "15112123", "15121213", "13312123", "24221212", "13321213", "33321211", "11512123", "22421212", "11521213", "31521211", "25112212", "14212213", "34212211", "23312212", "12412213", "32412211", "21512212", "15221122", "24321121", "13421122", "22521121", "16112122", "16121212", "14312122", "25221211", "14321212", "12512122", "23421211", "12521212", "15212212", "24312211", "13412212", "22512211", "11612212", "21131125", "41131123", "61131121", "11122126", "31122124", "51122122", "11131216", "31131214", "51131212", "21113125", "41113123", "61113121", "21122215", "41122213", "61122211", "11113216", "31113214", "51113212", "22131124", "42131122", "11231125", "31231123", "51231121", "12122125", "32122123", "52122121", "12131215", "32131213", "52131211", "21231214", "41231212", "22113124", "42113122", "11213125", "22122214", "42122212", "11222215", "31222213", "51222211", "12113215", "32113213", "52113211", "21213214", "41213212", "23131123", "43131121", "12231124", "32231122", "21331123", "41331121", "13122124", "33122122", "13131214", "33131212", "11322124", "22231213", "42231211", "11331214", "31331212", "23113123", "43113121", "12213124", "23122213", "43122211", "12222214", "32222212", "21322213", "41322211", "13113214", "33113212", "22213213", "42213211", "11313214", "31313212", "24131122", "13231123", "33231121", "22331122", "11431123", "31431121", "14122123", "34122121", "14131213", "34131211", "12322123", "23231212", "12331213", "32331211", "21431212", "24113122", "13213123", "24122212", "13222213", "33222211", "11413123", "22322212", "11422213", "31422211", "14113213", "34113211", "23213212", "12313213", "32313211", "21413212", "25131121", "14231122", "23331121", "12431122", "15122122", "15131212", "13322122", "24231211", "13331212", "11522122", "22431211", "25113121", "14213122", "25122211", "14222212", "12413122", "23322211", "12422212", "21522211", "15113212", "24213211", "13313212", "22413211", "11513212", "15231121", "13431121", "16122121", "16131211", "14322121", "14331211", "12522121", "15213121", "15222211", "13413121", "13422211", "11613121", "16113211", "14313211", "12513211", "21141124", "41141122", "11132125", "31132123", "51132121", "11141215", "31141213", "51141211", "21123124", "41123122", "21132214", "41132212", "11114125", "31114123", "51114121", "11123215", "31123213", "51123211", "21114214", "41114212", "22141123", "42141121", "11241124", "31241122", "12132124", "32132122", "12141214", "32141212", "21241213", "41241211", "22123123", "42123121", "11223124", "22132213", "42132211", "11232214", "31232212", "12114124", "32114122", "12123214", "32123212", "21223213", "41223211", "22114213", "42114211", "11214214", "31214212", "23141122", "12241123", "32241121", "21341122", "13132123", "33132121", "13141213", "33141211", "11332123", "22241212", "11341213", "31341211", "23123122", "12223123", "23132212", "12232213", "32232211", "21332212", "13114123", "33114121", "13123213", "33123211", "11314123", "22223212", "11323213", "31323211", "23114212", "12214213", "32214211", "21314212", "24141121", "13241122", "22341121", "14132122", "14141212", "12332122", "23241211", "12341212", "24123121", "13223122", "24132211", "13232212", "11423122", "22332211", "11432212", "14114122", "14123212", "12314122", "23223211", "12323212", "21423211", "24114211", "13214212", "22314211", "11414212", "14241121", "15132121", "15141211", "13332121", "13341211", "14223121", "14232211", "12423121", "12432211", "15114121", "15123211", "13314121", "13323211", "11514121", "11523211", "14214211", "12414211", "21151123", "41151121", "11142124", "31142122", "11151214", "31151212", "21133123", "41133121", "21142213", "41142211", "11124124", "31124122", "11133214", "31133212", "21115123", "41115121", "21124213", "41124211", "11115214", "31115212", "22151122", "11251123", "31251121", "12142123", "32142121", "12151213", "32151211", "21251212", "22133122", "11233123", "22142212", "11242213", "31242211", "12124123", "32124121", "12133213", "32133211", "21233212", "22115122", "11215123", "22124212", "11224213", "31224211", "12115213", "32115211", "21215212", "23151121", "12251122", "13142122", "13151212", "11342122", "22251211", "23133121", "12233122", "23142211", "12242212", "21342211", "13124122", "13133212", "11324122", "22233211", "11333212", "23115121", "12215122", "23124211", "12224212", "21324211", "13115212", "22215211", "11315212", "13251121", "14142121", "14151211", "12342121", "13233121", "13242211", "11433121", "14124121", "14133211", "12324121", "12333211", "13215121", "13224211", "11415121", "11424211", "14115211", "12315211", "21161122", "11152123", "31152121", "11161213", "31161211", "21143122", "21152212", "11134123", "31134121", "11143213", "31143211", "21125122", "21134212", "11116123", "31116121", "11125213", "31125211", "22161121", "12152122", "12161212", "22143121", "11243122", "22152211", "11252212", "12134122", "12143212", "21243211", "22125121", "11225122", "22134211", "11234212", "12116122", "12125212", "21225211", "13152121", "13161211", "12243121", "12252211", "13134121", "13143211", "11334121", "11343211", "12225121", "12234211", "13116121", "13125211", "11316121", "11325211", "21111226", "41111224", "61111222", "31111315", "51111313", "21211135", "41211133", "61211131", "22111225", "42111223", "11211226", "31211224", "51211222", "12111316", "32111314", "52111312", "21211315", "41211313", "61211311", "22211134", "42211132", "11311135", "31311133", "51311131", "23111224", "43111222", "12211225", "32211223", "52211221", "21311224", "41311222", "13111315", "33111313", "22211314", "42211312", "11311315", "31311313", "51311311", "23211133", "43211131", "12311134", "32311132", "21411133", "41411131", "24111223", "13211224", "33211222", "22311223", "42311221", "11411224", "31411222", "14111314", "34111312", "23211313", "43211311", "12311314", "32311312", "21411313", "41411311", "24211132", "13311133", "33311131", "22411132", "11511133", "31511131", "25111222", "14211223", "34211221", "23311222", "12411223", "32411221", "21511222", "15111313", "24211312", "13311313", "33311311", "22411312", "11511313", "31511311", "25211131", "14311132", "23411131", "12511132", "21611131", "15211222", "24311221", "13411222", "22511221", "11611222", "16111312", "25211311", "14311312", "23411311", "12511312", "21611311", "31121134", "51121132", "21112135", "41112133", "61112131", "21121225", "41121223", "61121221", "11112226", "31112224", "51112222", "11121316", "31121314", "51121312", "21112315", "41112313", "61112311", "12121135", "32121133", "52121131", "21221134", "41221132", "22112134", "42112132", "11212135", "22121224", "42121222", "11221225", "31221223", "51221221", "12112225", "32112223", "52112221", "12121315", "32121313", "52121311", "21221314", "41221312", "22112314", "42112312", "11212315", "31212313", "51212311", "13121134", "33121132", "22221133", "42221131", "11321134", "31321132", "23112133", "43112131", "12212134", "23121223", "43121221", "12221224", "32221222", "21321223", "41321221", "13112224", "33112222", "13121314", "33121312", "11312224", "22221313", "42221311", "11321314", "31321312", "23112313", "43112311", "12212314", "32212312", "21312313", "41312311", "14121133", "34121131", "23221132", "12321133", "32321131", "21421132", "24112132", "13212133", "24121222", "13221223", "33221221", "11412133", "22321222", "11421223", "31421221", "14112223", "34112221", "14121313", "34121311", "12312223", "23221312", "12321313", "32321311", "21421312", "24112312", "13212313", "33212311", "22312312", "11412313", "31412311", "15121132", "24221131", "13321132", "22421131"]), $a(["22121116", "42121114", "31221115", "51221113", "32112115", "52112113", "21212116", "41212114", "61212112", "23121115", "43121113", "12221116", "32221114", "52221112", "21321115", "41321113", "61321111", "13112116", "33112114", "22212115", "42212113", "11312116", "31312114", "51312112", "24121114", "13221115", "33221113", "22321114", "42321112", "11421115", "31421113", "51421111", "14112115", "34112113", "23212114", "43212112", "12312115", "32312113", "52312111", "21412114", "41412112", "25121113", "14221114", "34221112", "23321113", "43321111", "12421114", "32421112", "21521113", "41521111", "15112114", "24212113", "13312114", "33312112", "22412113", "42412111", "11512114", "31512112", "15221113", "24321112", "13421113", "33421111", "22521112", "16112113", "25212112", "14312113", "34312111", "23412112", "12512113", "32512111", "21612112", "21131116", "41131114", "61131112", "31122115", "51122113", "21113116", "41113114", "61113112", "22131115", "42131113", "11231116", "31231114", "51231112", "12122116", "32122114", "52122112", "21222115", "41222113", "61222111", "22113115", "42113113", "11213116", "31213114", "51213112", "23131114", "43131112", "12231115", "32231113", "52231111", "21331114", "41331112", "13122115", "33122113", "22222114", "42222112", "11322115", "31322113", "51322111", "23113114", "43113112", "12213115", "32213113", "52213111", "21313114", "41313112", "24131113", "13231114", "33231112", "22331113", "42331111", "11431114", "31431112", "14122114", "34122112", "23222113", "43222111", "12322114", "32322112", "21422113", "41422111", "24113113", "13213114", "33213112", "22313113", "42313111", "11413114", "31413112", "25131112", "14231113", "34231111", "23331112", "12431113", "32431111", "15122113", "24222112", "13322113", "33322111", "22422112", "11522113", "31522111", "25113112", "14213113", "34213111", "23313112", "12413113", "32413111", "21513112", "15231112", "24331111", "13431112", "16122112", "25222111", "14322112", "23422111", "12522112", "15213112", "24313111", "13413112", "22513111", "11613112", "21141115", "41141113", "61141111", "11132116", "31132114", "51132112", "21123115", "41123113", "61123111", "11114116", "31114114", "51114112", "22141114", "42141112", "11241115", "31241113", "51241111", "12132115", "32132113", "52132111", "21232114", "41232112", "22123114", "42123112", "11223115", "31223113", "51223111", "12114115", "32114113", "52114111", "21214114", "41214112", "23141113", "43141111", "12241114", "32241112", "21341113", "41341111", "13132114", "33132112", "22232113", "42232111", "11332114", "31332112", "23123113", "43123111", "12223114", "32223112", "21323113", "41323111", "13114114", "33114112", "22214113", "42214111", "11314114", "31314112", "24141112", "13241113", "33241111", "22341112", "14132113", "34132111", "23232112", "12332113", "32332111", "21432112", "24123112", "13223113", "33223111", "22323112", "11423113", "31423111", "14114113", "34114111", "23214112", "12314113", "32314111", "21414112", "25141111", "14241112", "23341111", "15132112", "24232111", "13332112", "22432111", "25123111", "14223112", "23323111", "12423112", "21523111", "15114112", "24214111", "13314112", "22414111", "11514112", "15241111", "16132111", "14332111", "15223111", "13423111", "16114111", "14314111", "12514111", "21151114", "41151112", "11142115", "31142113", "51142111", "21133114", "41133112", "11124115", "31124113", "51124111", "21115114", "41115112", "22151113", "42151111", "11251114", "31251112", "12142114", "32142112", "21242113", "41242111", "22133113", "42133111", "11233114", "31233112", "12124114", "32124112", "21224113", "41224111", "22115113", "42115111", "11215114", "31215112", "23151112", "12251113", "32251111", "13142113", "33142111", "22242112", "11342113", "31342111", "23133112", "12233113", "32233111", "21333112", "13124113", "33124111", "22224112", "11324113", "31324111", "23115112", "12215113", "32215111", "21315112", "24151111", "13251112", "14142112", "23242111", "12342112", "24133111", "13233112", "22333111", "11433112", "14124112", "23224111", "12324112", "21424111", "24115111", "13215112", "22315111", "11415112", "14251111", "15142111", "13342111", "14233111", "12433111", "15124111", "13324111", "11524111", "14215111", "12415111", "21161113", "41161111", "11152114", "31152112", "21143113", "41143111", "11134114", "31134112", "21125113", "41125111", "11116114", "31116112", "22161112", "12152113", "32152111", "21252112", "22143112", "11243113", "31243111", "12134113", "32134111", "21234112", "22125112", "11225113", "31225111", "12116113", "32116111", "21216112", "23161111", "13152112", "22252111", "23143111", "12243112", "21343111", "13134112", "22234111", "11334112", "23125111", "12225112", "21325111", "13116112", "22216111", "11316112", "14152111", "13243111", "14134111", "12334111", "13225111", "11425111", "14116111", "12316111", "41111215", "61111213", "21211126", "41211124", "61211122", "22111216", "42111214", "31211215", "51211213", "22211125", "42211123", "11311126", "31311124", "51311122", "23111215", "43111213", "12211216", "32211214", "52211212", "21311215", "41311213", "61311211", "23211124", "43211122", "12311125", "32311123", "52311121", "21411124", "41411122", "24111214", "13211215", "33211213", "22311214", "42311212", "11411215", "31411213", "51411211", "24211123", "13311124", "33311122", "22411123", "42411121", "11511124", "31511122", "25111213", "14211214", "34211212", "23311213", "43311211", "12411214", "32411212", "21511213", "41511211", "25211122", "14311123", "34311121", "23411122", "12511123", "32511121", "21611122", "15211213", "24311212", "13411213", "33411211", "22511212", "11611213", "31611211", "31121125", "51121123", "21112126", "41112124", "61112122", "21121216", "41121214", "61121212", "31112215", "51112213", "12121126", "32121124", "52121122", "21221125", "41221123", "61221121", "22112125", "42112123", "11212126", "22121215", "42121213", "11221216", "31221214", "51221212", "12112216", "32112214", "52112212", "21212215", "41212213", "61212211", "13121125", "33121123", "22221124", "42221122", "11321125", "31321123", "51321121", "23112124", "43112122", "12212125", "23121214", "43121212", "12221215", "32221213", "52221211", "21321214", "41321212", "13112215", "33112213", "22212214", "42212212", "11312215", "31312213", "51312211", "14121124", "34121122", "23221123", "43221121", "12321124", "32321122", "21421123", "41421121", "24112123", "13212124", "24121213", "13221214", "33221212", "11412124", "22321213", "42321211", "11421214", "31421212", "14112214", "34112212", "23212213", "43212211", "12312214", "32312212", "21412213", "41412211", "15121123", "24221122", "13321123", "33321121", "22421122", "11521123", "31521121", "25112122", "14212123", "25121212", "14221213", "34221211", "12412123", "23321212", "12421213", "32421211", "21521212", "15112213", "24212212", "13312213", "33312211", "22412212", "11512213", "31512211", "16121122", "25221121", "14321122", "23421121", "12521122", "15212122", "15221212", "13412122", "24321211", "13421212", "11612122", "22521211", "16112212", "25212211", "14312212", "23412211", "12512212", "21612211", "11131126", "31131124", "51131122", "21122125", "41122123", "61122121", "21131215", "41131213", "61131211", "11113126", "31113124", "51113122", "11122216", "31122214", "51122212", "21113215", "41113213", "61113211", "12131125", "32131123", "52131121", "21231124", "41231122", "22122124", "42122122", "11222125", "22131214", "42131212", "11231215", "31231213", "51231211", "12113125", "32113123", "52113121", "12122215", "32122213", "52122211", "21222214", "41222212", "22113214", "42113212", "11213215", "31213213", "51213211", "13131124", "33131122", "22231123", "42231121", "11331124", "31331122", "23122123", "43122121", "12222124", "23131213", "43131211", "12231214", "32231212", "21331213", "41331211", "13113124", "33113122", "13122214", "33122212", "11313124", "22222213", "42222211", "11322214", "31322212", "23113213", "43113211", "12213214", "32213212", "21313213", "41313211", "14131123", "34131121", "23231122", "12331123", "32331121", "21431122", "24122122", "13222123", "24131212", "13231213", "33231211", "11422123", "22331212", "11431213", "31431211", "14113123", "34113121", "14122213", "34122211", "12313123", "23222212", "12322213", "32322211", "21422212", "24113212", "13213213", "33213211", "22313212", "11413213", "31413211", "15131122", "24231121", "13331122", "22431121", "25122121", "14222122", "25131211", "14231212", "12422122", "23331211", "12431212", "15113122", "15122212", "13313122", "24222211", "13322212", "11513122", "22422211", "11522212", "25113211", "14213212", "23313211", "12413212", "21513211", "16131121", "14331121", "15222121", "15231211", "13422121", "13431211", "16113121", "16122211", "14313121", "14322211", "12513121", "12522211", "15213211", "13413211", "11613211", "11141125", "31141123", "51141121", "21132124", "41132122", "21141214", "41141212", "11123125", "31123123", "51123121", "11132215", "31132213", "51132211", "21114124", "41114122", "21123214", "41123212", "11114215", "31114213", "51114211", "12141124", "32141122", "21241123", "41241121", "22132123", "42132121", "11232124", "22141213", "42141211", "11241214", "31241212", "12123124", "32123122", "12132214", "32132212", "21232213", "41232211", "22114123", "42114121", "11214124", "22123213", "42123211", "11223214", "31223212", "12114214", "32114212", "21214213", "41214211", "13141123", "33141121", "22241122", "11341123", "31341121", "23132122", "12232123", "23141212", "12241213", "32241211", "21341212", "13123123", "33123121", "13132213", "33132211", "11323123", "22232212", "11332213", "31332211", "23114122", "12214123", "23123212", "12223213", "32223211", "21323212", "13114213", "33114211", "22214212", "11314213", "31314211", "14141122", "23241121", "12341122", "24132121", "13232122", "24141211", "13241212", "11432122", "22341211", "14123122", "14132212", "12323122", "23232211", "12332212", "21432211", "24114121", "13214122", "24123211", "13223212", "11414122", "22323211", "11423212", "14114212", "23214211", "12314212", "21414211", "15141121", "13341121", "14232121", "14241211", "12432121", "15123121", "15132211", "13323121", "13332211", "11523121", "14214121", "14223211", "12414121", "12423211", "15114211", "13314211", "11514211", "11151124", "31151122", "21142123", "41142121", "21151213", "41151211", "11133124", "31133122", "11142214", "31142212", "21124123", "41124121", "21133213", "41133211", "11115124", "31115122", "11124214", "31124212", "21115213", "41115211", "12151123", "32151121", "21251122", "22142122", "11242123", "22151212", "11251213", "31251211", "12133123", "32133121", "12142213", "32142211", "21242212", "22124122", "11224123", "22133212", "11233213", "31233211", "12115123", "32115121", "12124213", "32124211", "21224212", "22115212", "11215213", "31215211", "13151122", "22251121", "23142121", "12242122", "23151211", "12251212", "13133122", "13142212", "11333122", "22242211", "11342212", "23124121", "12224122", "23133211", "12233212", "21333211", "13115122", "13124212", "11315122", "22224211", "11324212", "23115211", "12215212", "21315211", "14151121", "13242121", "13251211", "14133121", "14142211", "12333121", "12342211", "13224121", "13233211", "11424121", "11433211", "14115121", "14124211", "12315121", "12324211", "13215211", "11415211", "11161123", "31161121", "21152122", "21161212", "11143123", "31143121", "11152213", "31152211", "21134122", "21143212", "11125123", "31125121", "11134213", "31134211", "21116122", "21125212", "12161122", "22152121", "11252122", "22161211", "12143122", "12152212", "21252211", "22134121", "11234122", "22143211", "11243212", "12125122", "12134212", "21234211", "22116121", "11216122", "22125211", "11225212", "13161121", "12252121", "13143121", "13152211", "11343121", "12234121", "12243211", "13125121", "13134211", "11325121", "11334211", "12216121", "12225211", "31111225", "51111223", "21111316", "41111314", "61111312", "31211134", "51211132", "12111226", "32111224", "52111222", "21211225", "41211223", "61211221", "22111315", "42111313", "11211316", "31211314", "51211312", "12211135", "32211133", "52211131", "21311134", "41311132", "13111225", "33111223", "22211224", "42211222", "11311225", "31311223", "51311221", "23111314", "43111312", "12211315", "32211313", "52211311", "21311314", "41311312", "13211134", "33211132", "22311133", "42311131", "11411134", "31411132", "14111224", "34111222", "23211223", "43211221", "12311224", "32311222", "21411223", "41411221", "24111313", "13211314", "33211312", "22311313", "42311311", "11411314", "31411312", "14211133", "34211131", "23311132", "12411133", "32411131", "21511132", "15111223", "24211222", "13311223", "33311221", "22411222", "11511223", "31511221", "25111312", "14211313", "34211311", "23311312", "12411313", "32411311", "21511312", "15211132", "24311131", "13411132", "22511131", "11611132", "16111222", "25211221", "14311222", "23411221", "12511222", "21611221", "15211312", "24311311", "13411312", "22511311", "11611312", "21121135", "41121133", "61121131", "11112136", "31112134", "51112132", "11121226", "31121224", "51121222", "21112225", "41112223", "61112221", "21121315", "41121313", "61121311", "11112316", "31112314", "51112312", "22121134", "42121132", "11221135", "31221133", "51221131", "12112135", "32112133", "52112131", "12121225", "32121223", "52121221", "21221224", "41221222", "22112224", "42112222", "11212225", "22121314", "42121312", "11221315", "31221313", "51221311", "12112315", "32112313", "52112311", "21212314", "41212312", "23121133", "43121131", "12221134", "32221132", "21321133", "41321131", "13112134", "33112132", "13121224", "33121222", "11312134", "22221223", "42221221", "11321224", "31321222", "23112223", "43112221", "12212224", "23121313", "43121311", "12221314", "32221312", "21321313", "41321311", "13112314", "33112312", "22212313", "42212311", "11312314", "31312312", "24121132", "13221133", "33221131", "22321132", "11421133", "31421131", "14112133", "34112131", "14121223", "34121221", "12312133", "23221222", "12321223", "32321221", "21421222", "24112222", "13212223", "24121312", "13221313", "33221311", "11412223", "22321312", "11421313", "31421311", "14112313", "34112311", "23212312", "12312313", "32312311", "21412312", "25121131", "14221132", "23321131", "12421132", "21521131", "15112132", "15121222", "13312132", "24221221", "13321222", "11512132", "22421221", "11521222", "25112221", "14212222", "25121311", "14221312", "12412222", "23321311", "12421312", "21521311", "15112312", "24212311", "13312312", "22412311", "11512312", "15221131", "13421131", "16112131", "16121221", "14312131", "14321221", "12512131", "12521221", "15212221", "15221311", "13412221", "13421311", "11612221", "16112311", "14312311", "12512311", "21131134", "41131132", "11122135", "31122133", "51122131", "11131225", "31131223", "51131221", "21113134", "41113132", "21122224", "41122222", "21131314", "41131312", "11113225", "31113223", "51113221", "11122315", "31122313", "51122311", "21113314", "41113312", "22131133", "42131131", "11231134", "31231132", "12122134", "32122132", "12131224", "32131222", "21231223", "41231221", "22113133", "42113131", "11213134", "22122223", "42122221", "11222224", "22131313", "42131311", "11231314", "31231312", "12113224", "32113222", "12122314", "32122312", "21222313", "41222311", "22113313", "42113311", "11213314", "31213312", "23131132", "12231133", "32231131", "21331132", "13122133", "33122131", "13131223", "33131221", "11322133", "22231222", "11331223", "31331221", "23113132", "12213133", "23122222", "12222223", "23131312", "12231313", "32231311", "21331312", "13113223", "33113221", "13122313", "33122311", "11313223", "22222312", "11322313", "31322311", "23113312", "12213313", "32213311", "21313312", "24131131", "13231132", "22331131", "11431132", "14122132", "14131222", "12322132", "23231221", "12331222", "21431221", "24113131", "13213132", "24122221", "13222222", "24131311", "11413132", "13231312", "11422222", "22331311", "11431312", "14113222", "14122312", "12313222", "23222311", "12322312", "21422311", "24113311", "13213312", "22313311", "11413312", "14231131", "12431131", "15122131", "15131221", "13322131", "13331221", "11522131", "14213131", "14222221", "12413131", "14231311", "12422221", "12431311", "15113221", "15122311", "13313221", "13322311", "11513221", "11522311", "14213311", "12413311", "21141133", "41141131", "11132134", "31132132", "11141224", "31141222", "21123133", "41123131", "21132223", "41132221", "21141313", "41141311", "11114134", "31114132", "11123224", "31123222", "11132314", "31132312", "21114223", "41114221", "21123313", "41123311", "11114314", "31114312", "22141132", "11241133", "31241131", "12132133", "32132131", "12141223", "32141221", "21241222", "22123132", "11223133", "22132222", "11232223", "22141312", "11241313", "31241311", "12114133", "32114131", "12123223", "32123221", "12132313", "32132311", "21232312", "22114222", "11214223", "22123312", "11223313", "31223311", "12114313", "32114311", "21214312", "23141131", "12241132", "21341131", "13132132", "13141222", "11332132", "22241221", "11341222", "23123131", "12223132", "23132221", "12232222", "23141311", "12241312", "21341311", "13114132", "13123222", "11314132", "13132312", "11323222", "22232311", "11332312", "23114221", "12214222", "23123311", "12223312", "21323311", "13114312", "22214311", "11314312", "13241131", "14132131", "14141221", "12332131", "12341221", "13223131", "13232221", "11423131", "13241311", "11432221", "14114131", "14123221", "12314131", "14132311", "12323221", "12332311", "13214221", "13223311", "11414221", "11423311", "14114311", "12314311", "21151132", "11142133", "31142131", "11151223", "31151221", "21133132", "21142222", "21151312", "11124133", "31124131", "11133223", "31133221", "11142313", "31142311", "21115132", "21124222", "21133312", "11115223", "31115221", "11124313", "31124311", "22151131", "11251132", "12142132", "12151222", "21251221", "22133131", "11233132", "22142221", "11242222", "22151311", "11251312", "12124132", "12133222", "12142312", "21242311", "22115131", "11215132", "22124221", "11224222", "22133311", "11233312", "12115222", "12124312", "21224311", "12251131", "13142131", "13151221", "11342131", "12233131", "12242221", "12251311", "13124131", "13133221", "11324131", "13142311", "11333221", "11342311", "12215131", "12224221", "12233311", "13115221", "13124311", "11315221", "11324311", "21161131", "11152132", "11161222", "21143131", "21152221", "21161311", "11134132", "11143222", "11152312", "21125131", "21134221", "21143311", "11116132", "11125222", "11134312", "12152131", "12161221", "11243131", "11252221", "12134131", "12143221", "12152311", "11225131", "11234221", "11243311", "12116131", "12125221", "12134311", "21111235", "41111233", "61111231", "11111326", "31111324", "51111322", "21111415", "41111413", "61111411", "21211144", "41211142", "22111234", "42111232", "11211235", "31211233", "51211231", "12111325", "32111323", "52111321", "21211324", "41211322", "22111414", "42111412", "11211415", "31211413", "51211411", "22211143", "42211141", "11311144", "31311142", "23111233", "43111231", "12211234", "32211232", "21311233", "41311231", "13111324", "33111322", "22211323", "42211321", "11311324", "31311322", "23111413", "43111411", "12211414", "32211412", "21311413", "41311411", "23211142", "12311143", "32311141", "21411142", "24111232", "13211233", "33211231", "22311232", "11411233", "31411231", "14111323", "34111321", "23211322", "12311323", "32311321", "21411322", "24111412", "13211413", "33211411", "22311412", "11411413", "31411411", "24211141", "13311142", "22411141", "11511142", "25111231", "14211232", "23311231", "12411232", "21511231", "15111322", "24211321", "13311322", "22411321", "11511322", "25111411", "14211412", "23311411", "12411412", "21511411", "14311141", "12511141", "15211231", "13411231", "11611231", "16111321", "14311321", "12511321", "15211411", "13411411", "11611411", "31121143", "51121141", "21112144", "41112142", "21121234", "41121232", "11112235", "31112233", "51112231", "11121325", "31121323", "51121321", "21112324", "41112322", "21121414", "41121412", "11112415", "31112413", "51112411", "12121144", "32121142", "21221143", "41221141", "22112143", "42112141", "11212144", "22121233", "42121231", "11221234", "31221232", "12112234", "32112232", "12121324", "32121322", "21221323", "41221321", "22112323", "42112321", "11212324", "22121413", "42121411", "11221414", "31221412", "12112414", "32112412", "21212413", "41212411", "13121143", "33121141", "22221142", "11321143", "31321141", "23112142", "12212143", "23121232", "12221233", "32221231", "21321232", "13112233", "33112231", "13121323", "33121321", "11312233", "22221322", "11321323", "31321321", "23112322", "12212323", "23121412", "12221413", "32221411", "21321412", "13112413", "33112411", "22212412", "11312413", "31312411", "14121142", "23221141", "12321142", "21421141", "24112141", "13212142", "24121231", "13221232", "11412142", "22321231", "11421232", "14112232", "14121322", "12312232", "23221321", "12321322", "21421321", "24112321", "13212322", "24121411", "13221412", "11412322", "22321411", "11421412", "14112412", "23212411", "12312412", "21412411", "15121141", "13321141", "11521141", "14212141", "14221231", "12412141", "12421231", "15112231", "15121321", "13312231", "13321321", "11512231", "11521321", "14212321", "14221411", "12412321", "12421411", "15112411", "13312411", "11512411", "11131144", "31131142", "21122143", "41122141", "21131233", "41131231", "11113144", "31113142", "11122234", "31122232", "11131324", "31131322", "21113233", "41113231", "21122323", "41122321", "21131413", "41131411", "11113324", "31113322", "11122414", "31122412", "21113413", "41113411", "12131143", "32131141", "21231142", "22122142", "11222143", "22131232", "11231233", "31231231", "12113143", "32113141", "12122233", "32122231", "12131323", "32131321", "21231322", "22113232", "11213233", "22122322", "11222323", "22131412", "11231413", "31231411", "12113323", "32113321", "12122413", "32122411", "21222412", "22113412", "11213413", "31213411", "13131142", "22231141", "11331142", "23122141", "12222142", "23131231", "12231232", "21331231", "13113142", "13122232", "11313142", "13131322", "11322232", "22231321", "11331322", "23113231", "12213232", "23122321", "12222322", "23131411", "12231412", "21331411", "13113322", "13122412", "11313322", "22222411", "11322412", "23113411", "12213412", "21313411", "14131141", "12331141", "13222141", "13231231", "11422141", "11431231", "14113141", "14122231", "12313141", "14131321", "12322231", "12331321", "13213231", "13222321", "11413231", "13231411", "11422321", "11431411", "14113321", "14122411", "12313321", "12322411", "13213411", "11413411", "11141143", "31141141", "21132142", "21141232", "11123143", "31123141", "11132233", "31132231", "11141323", "31141321", "21114142", "21123232", "21132322", "21141412", "11114233", "31114231", "11123323", "31123321", "11132413", "31132411", "21114322", "21123412", "12141142", "21241141", "22132141", "11232142", "22141231", "11241232", "12123142", "12132232", "12141322", "21241321", "22114141", "11214142", "22123231", "11223232", "22132321", "11232322", "22141411", "11241412", "12114232", "12123322", "12132412", "21232411", "22114321", "11214322", "22123411", "11223412", "13141141", "11341141", "12232141", "12241231", "13123141", "13132231", "11323141", "13141321", "11332231", "11341321", "12214141", "12223231", "12232321", "12241411", "13114231", "13123321", "11314231", "13132411", "11323321", "11332411", "12214321", "12223411", "11151142", "21142141", "21151231", "11133142", "11142232", "11151322", "21124141", "21133231", "21142321", "21151411", "11115142", "11124232", "11133322", "11142412", "21115231", "21124321", "21133411", "12151141", "11242141", "11251231", "12133141", "12142231", "12151321", "11224141", "11233231", "11242321", "11251411", "12115141", "12124231", "12133321", "12142411", "11215231", "11224321", "11233411", "11161141", "11143141", "11152231", "11161321", "11125141", "11134231", "11143321", "11152411", "11111245", "31111243", "51111241", "21111334", "41111332", "11111425", "31111423", "51111421", "21111514", "41111512", "31211152", "12111244", "32111242", "21211243", "41211241", "22111333", "42111331", "11211334", "31211332", "12111424", "32111422", "21211423", "41211421", "22111513", "42111511", "11211514", "31211512", "12211153", "32211151", "21311152", "13111243", "33111241", "22211242", "11311243", "31311241", "23111332", "12211333", "32211331", "21311332", "13111423", "33111421", "22211422", "11311423", "31311421", "23111512", "12211513", "32211511", "21311512", "13211152", "22311151", "11411152", "14111242", "23211241", "12311242", "21411241", "24111331", "13211332", "22311331", "11411332", "14111422", "23211421", "12311422", "21411421", "24111511", "13211512", "22311511", "11411512", "14211151", "12411151", "15111241", "13311241", "11511241", "14211331", "12411331", "15111421", "13311421", "11511421", "14211511", "12411511", "21121153", "41121151", "11112154", "31112152", "11121244", "31121242", "21112243", "41112241", "21121333", "41121331", "11112334", "31112332", "11121424", "31121422", "21112423", "41112421", "21121513", "41121511", "11112514", "31112512", "22121152", "11221153", "31221151", "12112153", "32112151", "12121243", "32121241", "21221242", "22112242", "11212243", "22121332", "11221333", "31221331", "12112333", "32112331", "12121423", "32121421", "21221422", "22112422", "11212423", "22121512", "11221513", "31221511", "12112513", "32112511", "21212512", "23121151", "12221152", "21321151", "13112152", "13121242", "11312152", "22221241", "11321242", "23112241", "12212242", "23121331", "12221332", "21321331", "13112332", "13121422", "11312332", "22221421", "11321422", "23112421", "12212422", "23121511", "12221512", "21321511", "13112512", "22212511", "11312512", "13221151", "11421151", "14112151", "14121241", "12312151", "12321241", "13212241", "13221331", "11412241", "11421331", "14112331", "14121421", "12312331", "12321421", "13212421", "13221511", "11412421", "11421511", "14112511", "12312511", "21131152", "11122153", "31122151", "11131243", "31131241", "21113152", "21122242", "21131332", "11113243", "31113241", "11122333", "31122331", "11131423", "31131421", "21113332", "21122422", "21131512", "11113423", "31113421", "11122513", "31122511", "22131151", "11231152", "12122152", "12131242", "21231241", "22113151", "11213152", "22122241", "11222242", "22131331", "11231332", "12113242", "12122332", "12131422", "21231421", "22113331", "11213332", "22122421", "11222422", "22131511", "11231512", "12113422", "12122512", "21222511", "12231151", "13122151", "13131241", "11322151", "11331241", "12213151", "12222241", "12231331", "13113241", "13122331", "11313241", "13131421", "11322331", "11331421", "12213331", "12222421", "12231511", "13113421", "13122511", "11313421", "11322511", "21141151", "11132152", "11141242", "21123151", "21132241", "21141331", "11114152", "11123242", "11132332", "11141422", "21114241", "21123331", "21132421", "21141511", "11114332", "11123422", "11132512", "11241151", "12132151", "12141241", "11223151", "11232241", "11241331", "12114151", "12123241", "12132331", "12141421", "11214241", "11223331", "11232421", "11241511", "12114331", "12123421", "12132511", "11142151", "11151241", "11124151", "11133241", "11142331", "11151421", "11115241", "11124331", "11133421", "11142511", "21111253", "41111251", "11111344", "31111342", "21111433", "41111431", "11111524", "31111522", "21111613", "41111611", "21211162", "22111252", "11211253", "31211251", "12111343", "32111341", "21211342", "22111432", "11211433", "31211431", "12111523", "32111521", "21211522", "22111612", "11211613", "31211611", "22211161", "11311162", "23111251", "12211252", "21311251", "13111342", "22211341", "11311342", "23111431", "12211432", "21311431", "13111522", "22211521", "11311522", "23111611", "12211612", "21311611", "12311161", "13211251", "11411251", "14111341", "12311341", "13211431", "11411431", "14111521", "12311521", "13211611", "11411611", "31121161", "21112162", "21121252", "11112253", "31112251", "11121343", "31121341", "21112342", "21121432", "11112433", "31112431", "11121523", "31121521", "21112522", "21121612", "12121162", "21221161", "22112161", "11212162", "22121251", "11221252", "12112252", "12121342", "21221341", "22112341", "11212342", "22121431", "11221432", "12112432", "12121522", "21221521", "22112521", "11212522", "22121611", "11221612", "13121161", "11321161", "12212161", "12221251", "13112251", "13121341", "11312251", "11321341", "12212341", "12221431", "13112431", "13121521", "11312431", "11321521", "12212521", "12221611", "11131162", "21122161", "21131251", "11113162"])]); /*12754*/
		$1.parity = $a(["1001", "0101", "1100", "0011", "1010", "0110", "1111", "0000"]); /*12758*/
		$1.rowbits = $a($1.r); /*12761*/
		for (var _6J = 0, _6I = $1.r - 1; _6J <= _6I; _6J += 1) { /*12781*/
			$1.i = _6J; /*12763*/
			$k[$j++] = "p"; /*12764*/
			if ($1.i != ($1.r - 1)) { /*12764*/
				$k[$j++] = $get($1.parity, $1.i); /*12764*/
			} else { /*12764*/
				$k[$j++] = "0000"; /*12764*/
			} /*12764*/
			var _6P = $k[--$j]; /*12764*/
			$1[$k[--$j]] = _6P; /*12764*/
			$1.ccrow = $geti($1.ccs, $1.i * 8, 8); /*12765*/
			$k[$j++] = Infinity; /*12768*/
			for (var _6U = 0; _6U <= 7; _6U += 2) { /*12767*/
				$aload($geti($1.ccrow, _6U, 2)); /*12767*/
				var _6X = $k[--$j]; /*12767*/
				var _6Y = $k[--$j]; /*12767*/
				$k[$j++] = _6X + (_6Y * 49); /*12767*/
			} /*12767*/
			$1.scrow = $a(); /*12768*/
			$k[$j++] = Infinity; /*12776*/
			$k[$j++] = 10; /*12774*/
			$k[$j++] = 1; /*12774*/
			$k[$j++] = 1; /*12774*/
			for (var _6a = 0; _6a <= 3; _6a += 1) { /*12774*/
				$1.j = _6a; /*12772*/
				$forall($get($get($1.patterns, $get($1.p, $1.j) - 48), $get($1.scrow, $1.j)), function() { /*12773*/
					var _6k = $k[--$j]; /*12773*/
					$k[$j++] = _6k - 48; /*12773*/
				}); /*12773*/
			} /*12773*/
			$k[$j++] = 4; /*12775*/
			$k[$j++] = 1; /*12775*/
			$1.sbs = $a(); /*12776*/
			$k[$j++] = Infinity; /*12777*/
			var _6m = $1.sbs; /*12778*/
			$k[$j++] = 1; /*12778*/
			for (var _6n = 0, _6o = _6m.length; _6n < _6o; _6n++) { /*12778*/
				var _6q = $k[--$j]; /*12778*/
				var _6r = (_6q == 0) ? 1 : 0; /*12778*/
				$k[$j++] = _6q; /*12778*/
				for (var _6s = 0, _6t = $get(_6m, _6n); _6s < _6t; _6s++) { /*12778*/
					$k[$j++] = _6r /*12778*/
				} /*12778*/
			} /*12778*/
			$astore($a($counttomark() - 1)); /*12779*/
			var _6w = $k[--$j]; /*12779*/
			var _6x = $k[--$j]; /*12779*/
			var _6y = $k[--$j]; /*12779*/
			$put($1.rowbits, $1.i, _6w); /*12780*/
		} /*12780*/
		$k[$j++] = Infinity; /*12793*/
		for (var _72 = 0, _73 = 81 * $1.sepheight; _72 < _73; _72++) { /*12785*/
			$k[$j++] = 1; /*12785*/
		} /*12785*/
		for (var _76 = 0, _75 = $1.r - 2; _76 <= _75; _76 += 1) { /*12790*/
			$1.i = _76; /*12787*/
			for (var _78 = 0, _79 = $1.rowheight; _78 < _79; _78++) { /*12788*/
				$aload($get($1.rowbits, $1.i)); /*12788*/
			} /*12788*/
			for (var _7E = 0, _7F = $1.sepheight; _7E < _7F; _7E++) { /*12789*/
				for (var _7G = 0, _7H = 10; _7G < _7H; _7G++) { /*12789*/
					$k[$j++] = 0; /*12789*/
				} /*12789*/
				for (var _7I = 0, _7J = 70; _7I < _7J; _7I++) { /*12789*/
					$k[$j++] = 1; /*12789*/
				} /*12789*/
				$k[$j++] = 0; /*12789*/
			} /*12789*/
		} /*12789*/
		for (var _7L = 0, _7M = $1.rowheight; _7L < _7M; _7L++) { /*12791*/
			$aload($get($1.rowbits, $1.r - 1)); /*12791*/
		} /*12791*/
		for (var _7R = 0, _7S = 81 * $1.sepheight; _7R < _7S; _7R++) { /*12792*/
			$k[$j++] = 1; /*12792*/
		} /*12792*/
		$1.pixs = $a(); /*12793*/
		var _7Y = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: 81,
			pixy: ~~($1.pixs.length / 81),
			height: (~~($1.pixs.length / 81)) / 72,
			width: 81 / 72,
			opt: $1.options
		}; /*12803*/
		$k[$j++] = _7Y; /*12806*/
		if (!$1.dontdraw) { /*12806*/
			$0.renmatrix(); /*12806*/
		} /*12806*/
	};
	$0.flattermarken = function() {
		var $1 = {}; /*13093*/
		$1.options = $k[--$j]; /*13095*/
		$1.barcode = $k[--$j]; /*13096*/
		$1.dontdraw = false; /*13098*/
		$1.includetext = false; /*13099*/
		$1.textfont = "Courier"; /*13100*/
		$1.textsize = 10; /*13101*/
		$1.textyoffset = -8.5; /*13102*/
		$1.height = 0.3; /*13103*/
		$forall($1.barcode, function() { /*13110*/
			var _3 = $k[--$j]; /*13107*/
			if ((_3 < 48) || (_3 > 57)) { /*13109*/
				$k[$j++] = "bwipp.flattermarkenBadCharacter"; /*13108*/
				$k[$j++] = "Flattermarken must contain only digits"; /*13108*/
				$0.raiseerror(); /*13108*/
			} /*13108*/
		}); /*13108*/
		$forall($1.options, function() { /*13121*/
			var _5 = $k[--$j]; /*13121*/
			$1[$k[--$j]] = _5; /*13121*/
		}); /*13121*/
		$1.textfont = "" + $1.textfont; /*13123*/
		$1.textsize = +$1.textsize; /*13124*/
		$1.textyoffset = +$1.textyoffset; /*13125*/
		$1.height = +$1.height; /*13126*/
		$forall($1.barcode, function() { /*13133*/
			var _C = $k[--$j]; /*13130*/
			if ((_C < 48) || (_C > 57)) { /*13132*/
				$k[$j++] = "bwipp.flattermarkenBadCharacter"; /*13131*/
				$k[$j++] = "Flattermarken must contain only digits"; /*13131*/
				$0.raiseerror(); /*13131*/
			} /*13131*/
		}); /*13131*/
		$1.encs = $a(["0018", "0117", "0216", "0315", "0414", "0513", "0612", "0711", "0810", "0900"]); /*13139*/
		$1.barchars = "1234567890"; /*13142*/
		$1.barlen = $1.barcode.length; /*13144*/
		$1.sbs = $s($1.barlen * 4); /*13146*/
		$1.txt = $a($1.barlen); /*13147*/
		for (var _L = 0, _K = $1.barlen - 1; _L <= _K; _L += 1) { /*13159*/
			$1.i = _L; /*13150*/
			$search($1.barchars, $geti($1.barcode, $1.i, 1)); /*13152*/
			$j--; /*13153*/
			$1.indx = $k[--$j].length; /*13154*/
			$j -= 2; /*13155*/
			$1.enc = $get($1.encs, $1.indx); /*13156*/
			$puti($1.sbs, $1.i * 4, $1.enc); /*13157*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), $1.i * 9, $1.textyoffset, $1.textfont, $1.textsize])); /*13158*/
		} /*13158*/
		$k[$j++] = Infinity; /*13168*/
		$k[$j++] = "ren"; /*13165*/
		$k[$j++] = $0.renlinear; /*13165*/
		$k[$j++] = "sbs"; /*13165*/
		$k[$j++] = Infinity; /*13165*/
		var _h = $1.sbs; /*13164*/
		for (var _i = 0, _j = _h.length; _i < _j; _i++) { /*13164*/
			$k[$j++] = $get(_h, _i) - 48; /*13164*/
		} /*13164*/
		var _l = $a(); /*13165*/
		$k[$j++] = _l; /*13166*/
		$k[$j++] = "bhs"; /*13166*/
		$k[$j++] = Infinity; /*13166*/
		for (var _n = 0, _o = ~~(($1.sbs.length + 1) / 2); _n < _o; _n++) { /*13165*/
			$k[$j++] = $1.height; /*13165*/
		} /*13165*/
		var _q = $a(); /*13166*/
		$k[$j++] = _q; /*13167*/
		$k[$j++] = "bbs"; /*13167*/
		$k[$j++] = Infinity; /*13167*/
		for (var _s = 0, _t = ~~(($1.sbs.length + 1) / 2); _s < _t; _s++) { /*13166*/
			$k[$j++] = 0; /*13166*/
		} /*13166*/
		var _u = $a(); /*13167*/
		$k[$j++] = _u; /*13168*/
		$k[$j++] = "txt"; /*13168*/
		$k[$j++] = $1.txt; /*13168*/
		$k[$j++] = "opt"; /*13168*/
		$k[$j++] = $1.options; /*13168*/
		var _x = $d(); /*13168*/
		$k[$j++] = _x; /*13171*/
		if (!$1.dontdraw) { /*13171*/
			$0.renlinear(); /*13171*/
		} /*13171*/
	};
	$0.raw = function() {
		var $1 = {}; /*13198*/
		$1.options = $k[--$j]; /*13200*/
		$1.barcode = $k[--$j]; /*13201*/
		$1.dontdraw = false; /*13203*/
		$1.height = 1; /*13204*/
		$forall($1.options, function() { /*13215*/
			var _3 = $k[--$j]; /*13215*/
			$1[$k[--$j]] = _3; /*13215*/
		}); /*13215*/
		$1.height = +$1.height; /*13217*/
		$forall($1.barcode, function() { /*13224*/
			var _7 = $k[--$j]; /*13221*/
			if ((_7 < 49) || (_7 > 57)) { /*13223*/
				$k[$j++] = "bwipp.rawBadCharacter"; /*13222*/
				$k[$j++] = "Raw must contain only digits 1 to 9"; /*13222*/
				$0.raiseerror(); /*13222*/
			} /*13222*/
		}); /*13222*/
		$k[$j++] = Infinity; /*13232*/
		$k[$j++] = "ren"; /*13230*/
		$k[$j++] = $0.renlinear; /*13230*/
		$k[$j++] = "sbs"; /*13230*/
		$k[$j++] = Infinity; /*13230*/
		$forall($1.barcode, function() { /*13229*/
			var _9 = $k[--$j]; /*13229*/
			$k[$j++] = _9 - 48; /*13229*/
		}); /*13229*/
		var _A = $a(); /*13230*/
		$k[$j++] = _A; /*13231*/
		$k[$j++] = "bhs"; /*13231*/
		$k[$j++] = Infinity; /*13231*/
		for (var _C = 0, _D = ~~(($1.barcode.length + 1) / 2); _C < _D; _C++) { /*13230*/
			$k[$j++] = $1.height; /*13230*/
		} /*13230*/
		var _F = $a(); /*13231*/
		$k[$j++] = _F; /*13232*/
		$k[$j++] = "bbs"; /*13232*/
		$k[$j++] = Infinity; /*13232*/
		for (var _H = 0, _I = ~~(($1.barcode.length + 1) / 2); _H < _I; _H++) { /*13231*/
			$k[$j++] = 0; /*13231*/
		} /*13231*/
		var _J = $a(); /*13232*/
		$k[$j++] = _J; /*13232*/
		$k[$j++] = "opt"; /*13232*/
		$k[$j++] = $1.options; /*13232*/
		var _L = $d(); /*13232*/
		$k[$j++] = _L; /*13235*/
		if (!$1.dontdraw) { /*13235*/
			$0.renlinear(); /*13235*/
		} /*13235*/
	};
	$0.daft = function() {
		var $1 = {}; /*13262*/
		$1.options = $k[--$j]; /*13264*/
		$1.barcode = $k[--$j]; /*13265*/
		$1.dontdraw = false; /*13267*/
		$1.height = 0.175; /*13268*/
		$forall($1.options, function() { /*13279*/
			var _3 = $k[--$j]; /*13279*/
			$1[$k[--$j]] = _3; /*13279*/
		}); /*13279*/
		$1.height = +$1.height; /*13281*/
		$forall($1.barcode, function() { /*13287*/
			var _7 = $k[--$j]; /*13284*/
			if ((_7 != 68) && ((_7 != 65) && ((_7 != 70) && (_7 != 84)))) { /*13286*/
				$k[$j++] = "bwipp.daftBadCharacter"; /*13285*/
				$k[$j++] = "DAFT must contain only characters D, A, F and T"; /*13285*/
				$0.raiseerror(); /*13285*/
			} /*13285*/
		}); /*13285*/
		$1.barlen = $1.barcode.length; /*13289*/
		$1.bbs = $a($1.barlen); /*13291*/
		$1.bhs = $a($1.barlen); /*13292*/
		for (var _F = 0, _E = $1.barlen - 1; _F <= _E; _F += 1) { /*13312*/
			$1.i = _F; /*13294*/
			$1.enc = $geti($1.barcode, $1.i, 1); /*13295*/
			if ($eq($1.enc, "D")) { /*13299*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*13297*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*13298*/
			} /*13298*/
			if ($eq($1.enc, "A")) { /*13303*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*13301*/
				$put($1.bhs, $1.i, (5 * $1.height) / 8); /*13302*/
			} /*13302*/
			if ($eq($1.enc, "F")) { /*13307*/
				$put($1.bbs, $1.i, (0 * $1.height) / 8); /*13305*/
				$put($1.bhs, $1.i, (8 * $1.height) / 8); /*13306*/
			} /*13306*/
			if ($eq($1.enc, "T")) { /*13311*/
				$put($1.bbs, $1.i, (3 * $1.height) / 8); /*13309*/
				$put($1.bhs, $1.i, (2 * $1.height) / 8); /*13310*/
			} /*13310*/
		} /*13310*/
		$k[$j++] = Infinity; /*13320*/
		$k[$j++] = "ren"; /*13320*/
		$k[$j++] = $0.renlinear; /*13320*/
		$k[$j++] = "bbs"; /*13320*/
		$k[$j++] = $1.bbs; /*13320*/
		$k[$j++] = "bhs"; /*13320*/
		$k[$j++] = $1.bhs; /*13320*/
		$k[$j++] = "sbs"; /*13320*/
		$k[$j++] = Infinity; /*13320*/
		for (var _o = 0, _p = $1.bhs.length - 1; _o < _p; _o++) { /*13319*/
			$k[$j++] = 1.44; /*13319*/
			$k[$j++] = 1.872; /*13319*/
		} /*13319*/
		$k[$j++] = 1.44; /*13319*/
		var _q = $a(); /*13320*/
		$k[$j++] = _q; /*13320*/
		$k[$j++] = "opt"; /*13320*/
		$k[$j++] = $1.options; /*13320*/
		var _s = $d(); /*13320*/
		$k[$j++] = _s; /*13323*/
		if (!$1.dontdraw) { /*13323*/
			$0.renlinear(); /*13323*/
		} /*13323*/
	};
	$0.symbol = function() {
		var $1 = {}; /*13350*/
		$1.options = $k[--$j]; /*13352*/
		$1.barcode = $k[--$j]; /*13353*/
		$1.dontdraw = false; /*13355*/
		$forall($1.options, function() { /*13366*/
			var _3 = $k[--$j]; /*13366*/
			$1[$k[--$j]] = _3; /*13366*/
		}); /*13366*/
		var _H = {
			fima: function() {
				$1.sbs = $a([2.25, 2.25, 2.25, 11.25, 2.25, 11.25, 2.25, 2.25, 2.25]); /*13370*/
				$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625]); /*13371*/
				$1.bbs = $a([0, 0, 0, 0, 0]); /*13372*/
			},
			fimb: function() {
				$1.sbs = $a([2.25, 6.75, 2.25, 2.25, 2.25, 6.25, 2.25, 2.25, 2.25, 6.75, 2.25]); /*13375*/
				$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625, 0.625]); /*13376*/
				$1.bbs = $a([0, 0, 0, 0, 0, 0]); /*13377*/
			},
			fimc: function() {
				$1.sbs = $a([2.25, 2.25, 2.25, 6.75, 2.25, 6.75, 2.25, 6.75, 2.25, 2.25, 2.25]); /*13380*/
				$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625, 0.625]); /*13381*/
				$1.bbs = $a([0, 0, 0, 0, 0, 0]); /*13382*/
			},
			fimd: function() {
				$1.sbs = $a([2.25, 2.25, 2.25, 2.25, 2.25, 6.75, 2.25, 6.75, 2.25, 2.25, 2.25, 2.25, 2.25]); /*13385*/
				$1.bhs = $a([0.625, 0.625, 0.625, 0.625, 0.625, 0.625, 0.625]); /*13386*/
				$1.bbs = $a([0, 0, 0, 0, 0, 0, 0]); /*13387*/
			}
		}; /*13387*/
		$1.symbols = _H; /*13389*/
		var _K = $get($1.symbols, $1.barcode) !== undefined; /*13392*/
		if (!_K) { /*13394*/
			$k[$j++] = "bwipp.symbolUnknownSymbol"; /*13393*/
			$k[$j++] = "Unknown symbol name provided"; /*13393*/
			$0.raiseerror(); /*13393*/
		} /*13393*/
		$get($1.symbols, $1.barcode)(); /*13396*/
		var _S = {
			ren: $0.renlinear,
			sbs: $1.sbs,
			bhs: $1.bhs,
			bbs: $1.bbs,
			opt: $1.options
		}; /*13404*/
		$k[$j++] = _S; /*13407*/
		if (!$1.dontdraw) { /*13407*/
			$0.renlinear(); /*13407*/
		} /*13407*/
	};
	$0.pdf417 = function() {
		var $1 = {}; /*13434*/
		$1.options = $k[--$j]; /*13436*/
		$1.barcode = $k[--$j]; /*13437*/
		$1.dontdraw = false; /*13439*/
		$1.compact = false; /*13440*/
		$1.eclevel = -1; /*13441*/
		$1.columns = 0; /*13442*/
		$1.rows = 0; /*13443*/
		$1.rowmult = 3; /*13444*/
		$1.encoding = "auto"; /*13445*/
		$1.ccc = false; /*13446*/
		$1.raw = false; /*13447*/
		$1.parse = false; /*13448*/
		$forall($1.options, function() { /*13459*/
			var _3 = $k[--$j]; /*13459*/
			$1[$k[--$j]] = _3; /*13459*/
		}); /*13459*/
		$1.eclevel = ~~$1.eclevel; /*13461*/
		$1.columns = ~~$1.columns; /*13462*/
		$1.rows = ~~$1.rows; /*13463*/
		$1.rowmult = +$1.rowmult; /*13464*/
		if ($1.raw) { /*13487*/
			$1.encoding = "raw"; /*13487*/
		} /*13487*/
		if ($eq($1.encoding, "raw")) { /*13501*/
			$1.datcws = $a($1.barcode.length); /*13491*/
			$1.i = 0; /*13492*/
			$1.j = 0; /*13492*/
			for (;;) { /*13499*/
				if ($1.i == $1.barcode.length) { /*13494*/
					break; /*13494*/
				} /*13494*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*13495*/
				$put($1.datcws, $1.j, $1.cw); /*13496*/
				$1.i = $1.i + 4; /*13497*/
				$1.j = $1.j + 1; /*13498*/
			} /*13498*/
			$1.datcws = $geti($1.datcws, 0, $1.j); /*13500*/
		} /*13500*/
		$k[$j++] = Infinity; /*13503*/
		$forall($1.barcode); /*13503*/
		$1.barcode = $a(); /*13503*/
		$1.barlen = $1.barcode.length; /*13504*/
		if ($1.ccc) { /*13506*/
			$1.encoding = "ccc"; /*13506*/
		} /*13506*/
		$1.encb = function() {
			$1.in = $k[--$j]; /*13509*/
			$1.inlen = $1.in.length; /*13510*/
			$1.out = $a(((~~($1.inlen / 6)) * 5) + ($1.inlen % 6)); /*13511*/
			for (var _b = 0, _a = (~~($1.inlen / 6)) - 1; _b <= _a; _b += 1) { /*13534*/
				$1.k = _b; /*13513*/
				$k[$j++] = Infinity; /*13514*/
				$aload($geti($1.in, $1.k * 6, 3)); /*13514*/
				$1.msbs = $a(); /*13514*/
				$k[$j++] = Infinity; /*13518*/
				$aload($1.msbs); /*13516*/
				var _h = $k[--$j]; /*13516*/
				var _i = $k[--$j]; /*13516*/
				var _j = $k[--$j]; /*13516*/
				$k[$j++] = (_h + (_i * 256)) + (_j * 65536); /*13517*/
				for (var _k = 0, _l = 3; _k < _l; _k++) { /*13517*/
					var _m = $k[--$j]; /*13517*/
					$k[$j++] = _m % 900; /*13517*/
					$k[$j++] = ~~(_m / 900); /*13517*/
				} /*13517*/
				$1.mscs = $a(); /*13518*/
				$k[$j++] = Infinity; /*13519*/
				$aload($geti($1.in, ($1.k * 6) + 3, 3)); /*13519*/
				$1.lsbs = $a(); /*13519*/
				$k[$j++] = Infinity; /*13523*/
				$aload($1.lsbs); /*13521*/
				var _t = $k[--$j]; /*13521*/
				var _u = $k[--$j]; /*13521*/
				var _v = $k[--$j]; /*13521*/
				$k[$j++] = (_t + (_u * 256)) + (_v * 65536); /*13522*/
				for (var _w = 0, _x = 3; _w < _x; _w++) { /*13522*/
					var _y = $k[--$j]; /*13522*/
					$k[$j++] = _y % 900; /*13522*/
					$k[$j++] = ~~(_y / 900); /*13522*/
				} /*13522*/
				$1.lscs = $a(); /*13523*/
				var _11 = $get($1.lscs, 0); /*13524*/
				var _13 = $get($1.mscs, 0); /*13524*/
				$put($1.out, ($1.k * 5) + 4, (_11 + (_13 * 316)) % 900); /*13525*/
				var _17 = $get($1.lscs, 1); /*13526*/
				var _19 = $get($1.mscs, 0); /*13526*/
				var _1B = $get($1.mscs, 1); /*13526*/
				$put($1.out, ($1.k * 5) + 3, ((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) % 900); /*13527*/
				var _1F = $get($1.lscs, 2); /*13528*/
				var _1H = $get($1.mscs, 0); /*13528*/
				var _1J = $get($1.mscs, 1); /*13528*/
				var _1L = $get($1.mscs, 2); /*13528*/
				$put($1.out, ($1.k * 5) + 2, (((((~~(((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) / 900)) + _1F) + (_1H * 20)) + (_1J * 641)) + (_1L * 316)) % 900); /*13529*/
				var _1P = $get($1.lscs, 3); /*13530*/
				var _1R = $get($1.mscs, 1); /*13530*/
				var _1T = $get($1.mscs, 2); /*13530*/
				$put($1.out, ($1.k * 5) + 1, ((((~~((((((~~(((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) / 900)) + _1F) + (_1H * 20)) + (_1J * 641)) + (_1L * 316)) / 900)) + _1P) + (_1R * 20)) + (_1T * 641)) % 900); /*13531*/
				$put($1.out, $1.k * 5, ((~~(((((~~((((((~~(((((~~((_11 + (_13 * 316)) / 900)) + _17) + (_19 * 641)) + (_1B * 316)) / 900)) + _1F) + (_1H * 20)) + (_1J * 641)) + (_1L * 316)) / 900)) + _1P) + (_1R * 20)) + (_1T * 641)) / 900)) + ($get($1.mscs, 2) * 20)) % 900); /*13533*/
			} /*13533*/
			$1.rem = $1.inlen % 6; /*13535*/
			if ($1.rem != 0) { /*13540*/
				$k[$j++] = $1.out; /*13538*/
				$k[$j++] = $1.out.length - $1.rem; /*13538*/
				$k[$j++] = Infinity; /*13538*/
				$aload($geti($1.in, $1.inlen - $1.rem, $1.rem)); /*13538*/
				var _1k = $a(); /*13538*/
				var _1l = $k[--$j]; /*13539*/
				$puti($k[--$j], _1l, _1k); /*13539*/
			} /*13539*/
			$k[$j++] = $1.out; /*13541*/
		}; /*13542*/
		if ($eq($1.encoding, "byte") || $eq($1.encoding, "ccc")) { /*13549*/
			$1.datcws = $a((((~~($1.barlen / 6)) * 5) + ($1.barlen % 6)) + 1); /*13545*/
			var _1v = (($1.barlen % 6) == 0) ? 924 : 901; /*13546*/
			$put($1.datcws, 0, _1v); /*13546*/
			$k[$j++] = $1.datcws; /*13547*/
			$k[$j++] = 1; /*13547*/
			$k[$j++] = $1.barcode; /*13547*/
			if ($1.encb() == $b) return $b; /*13547*/
			var _1y = $k[--$j]; /*13547*/
			var _1z = $k[--$j]; /*13547*/
			$puti($k[--$j], _1z, _1y); /*13547*/
			if ($eq($1.encoding, "ccc")) { /*13548*/
				$k[$j++] = Infinity; /*13548*/
				$k[$j++] = 920; /*13548*/
				$aload($1.datcws); /*13548*/
				$1.datcws = $a(); /*13548*/
			} /*13548*/
		} /*13548*/
		if ($eq($1.encoding, "auto")) { /*13913*/
			$1.T = 0; /*13554*/
			$1.N = 1; /*13554*/
			$1.B = 2; /*13554*/
			$1.A = 0; /*13555*/
			$1.L = 1; /*13555*/
			$1.M = 2; /*13555*/
			$1.P = 3; /*13555*/
			$1.tl = -1; /*13558*/
			$1.nl = -2; /*13558*/
			$1.bl = -3; /*13558*/
			$1.bl6 = -4; /*13558*/
			$1.bs = -5; /*13558*/
			$1.al = -6; /*13561*/
			$1.ll = -7; /*13561*/
			$1.ml = -8; /*13561*/
			$1.pl = -9; /*13561*/
			$1.as = -10; /*13561*/
			$1.ps = -11; /*13561*/
			$1.charmaps = $a([$a(["A", "a", "0", ";"]), $a(["B", "b", "1", "<"]), $a(["C", "c", "2", ">"]), $a(["D", "d", "3", "@"]), $a(["E", "e", "4", "["]), $a(["F", "f", "5", 92]), $a(["G", "g", "6", "]"]), $a(["H", "h", "7", "_"]), $a(["I", "i", "8", "`"]), $a(["J", "j", "9", "~"]), $a(["K", "k", "&", "!"]), $a(["L", "l", 13, 13]), $a(["M", "m", 9, 9]), $a(["N", "n", ",", ","]), $a(["O", "o", ":", ":"]), $a(["P", "p", "#", 10]), $a(["Q", "q", "-", "-"]), $a(["R", "r", ".", "."]), $a(["S", "s", "$", "$"]), $a(["T", "t", "/", "/"]), $a(["U", "u", "+", "\""]), $a(["V", "v", "%", "|"]), $a(["W", "w", "*", "*"]), $a(["X", "x", "=", 40]), $a(["Y", "y", "^", 41]), $a(["Z", "z", $1.pl, "?"]), $a([" ", " ", " ", "{"]), $a([$1.ll, $1.as, $1.ll, "}"]), $a([$1.ml, $1.ml, $1.al, "'"]), $a([$1.ps, $1.ps, $1.ps, $1.al])]); /*13596*/
			$1.charvals = $a([{}, {}, {}, {}]); /*13599*/
			$1.alltext = {}; /*13600*/
			for (var _2o = 0, _2n = $1.charmaps.length - 1; _2o <= _2n; _2o += 1) { /*13610*/
				$1.i = _2o; /*13602*/
				$1.encs = $get($1.charmaps, $1.i); /*13603*/
				for (var _2s = 0; _2s <= 3; _2s += 1) { /*13609*/
					$1.j = _2s; /*13605*/
					var _2v = $get($1.encs, $1.j); /*13606*/
					$k[$j++] = _2v; /*13606*/
					if ($eq($type(_2v), "stringtype")) { /*13606*/
						var _2y = $get($k[--$j], 0); /*13606*/
						$k[$j++] = _2y; /*13606*/
					} /*13606*/
					var _2z = $k[--$j]; /*13607*/
					$put($get($1.charvals, $1.j), _2z, $1.i); /*13607*/
					$put($1.alltext, _2z, -1); /*13608*/
				} /*13608*/
			} /*13608*/
			$1.e = 10000; /*13612*/
			$1.latlen = $a([$a([0, 1, 1, 2]), $a([2, 0, 1, 2]), $a([1, 1, 0, 1]), $a([1, 2, 2, 0])]); /*13620*/
			$1.latseq = $a([$a([$a([]), $a([$1.ll]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.ml, $1.al]), $a([]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.al]), $a([$1.ll]), $a([]), $a([$1.pl])]), $a([$a([$1.al]), $a([$1.al, $1.ll]), $a([$1.al, $1.ml]), $a([])])]); /*13628*/
			$1.shftlen = $a([$a([$1.e, $1.e, $1.e, 1]), $a([1, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, $1.e])]); /*13636*/
			$k[$j++] = Infinity; /*13639*/
			for (var _44 = 0, _45 = $1.barlen; _44 < _45; _44++) { /*13639*/
				$k[$j++] = 0; /*13639*/
			} /*13639*/
			$k[$j++] = 0; /*13639*/
			$1.numdigits = $a(); /*13639*/
			$k[$j++] = Infinity; /*13640*/
			for (var _48 = 0, _49 = $1.barlen; _48 < _49; _48++) { /*13640*/
				$k[$j++] = 0; /*13640*/
			} /*13640*/
			$k[$j++] = 0; /*13640*/
			$1.numtext = $a(); /*13640*/
			$k[$j++] = Infinity; /*13641*/
			for (var _4C = 0, _4D = $1.barlen; _4C < _4D; _4C++) { /*13641*/
				$k[$j++] = 0; /*13641*/
			} /*13641*/
			$k[$j++] = 0; /*13641*/
			$1.numbytes = $a(); /*13641*/
			for (var _4G = $1.barlen - 1; _4G >= 0; _4G -= 1) { /*13653*/
				$1.i = _4G; /*13643*/
				var _4J = $get($1.barcode, $1.i); /*13644*/
				if ((_4J >= 48) && (_4J <= 57)) { /*13646*/
					$put($1.numdigits, $1.i, $get($1.numdigits, $1.i + 1) + 1); /*13645*/
				} /*13645*/
				var _4T = $get($1.alltext, $get($1.barcode, $1.i)) !== undefined; /*13647*/
				if (_4T && ($get($1.numdigits, $1.i) < 13)) { /*13649*/
					$put($1.numtext, $1.i, $get($1.numtext, $1.i + 1) + 1); /*13648*/
				} /*13648*/
				if (($get($1.numtext, $1.i) < 5) && ($get($1.numdigits, $1.i) < 13)) { /*13652*/
					$put($1.numbytes, $1.i, $get($1.numbytes, $1.i + 1) + 1); /*13651*/
				} /*13651*/
			} /*13651*/
			$1.numdigits = $geti($1.numdigits, 0, $1.barlen); /*13654*/
			$1.numtext = $geti($1.numtext, 0, $1.barlen); /*13655*/
			$1.numbytes = $geti($1.numbytes, 0, $1.barlen); /*13656*/
			$1.seq = $a([]); /*13658*/
			$1.seqlen = 0; /*13658*/
			$1.state = $1.T; /*13658*/
			$1.p = 0; /*13658*/
			for (;;) { /*13701*/
				if ($1.p == $1.barlen) { /*13659*/
					break; /*13659*/
				} /*13659*/
				$1.n = $get($1.numdigits, $1.p); /*13660*/
				if ($1.n >= 13) { /*13699*/
					$k[$j++] = Infinity; /*13666*/
					$aload($1.seq); /*13663*/
					$k[$j++] = $1.nl; /*13665*/
					$k[$j++] = Infinity; /*13665*/
					$aload($geti($1.barcode, $1.p, $1.n)); /*13665*/
					var _5A = $a(); /*13665*/
					$k[$j++] = _5A; /*13665*/
					$1.seq = $a(); /*13666*/
					$1.state = $1.N; /*13667*/
					$1.p = $1.p + $1.n; /*13668*/
					$1.seqlen = ($1.seqlen + 1) + $1.n; /*13669*/
				} else { /*13699*/
					$1.t = $get($1.numtext, $1.p); /*13671*/
					if ($1.t >= 5) { /*13699*/
						$k[$j++] = Infinity; /*13677*/
						$aload($1.seq); /*13674*/
						if ($1.state != $1.T) { /*13675*/
							$k[$j++] = $1.tl; /*13675*/
						} /*13675*/
						$k[$j++] = Infinity; /*13676*/
						$aload($geti($1.barcode, $1.p, $1.t)); /*13676*/
						var _5T = $a(); /*13676*/
						$k[$j++] = _5T; /*13676*/
						$1.seq = $a(); /*13677*/
						$1.state = $1.T; /*13678*/
						$1.p = $1.p + $1.t; /*13679*/
						$1.seqlen = ($1.seqlen + 1) + $1.t; /*13680*/
					} else { /*13699*/
						$1.b = $get($1.numbytes, $1.p); /*13682*/
						if (($1.b == 1) && ($1.state == $1.T)) { /*13699*/
							$k[$j++] = Infinity; /*13688*/
							$aload($1.seq); /*13685*/
							$k[$j++] = $1.bs; /*13687*/
							$k[$j++] = $a([$get($1.barcode, $1.p)]); /*13687*/
							$1.seq = $a(); /*13688*/
							$1.p = $1.p + $1.b; /*13689*/
							$1.seqlen = $1.seqlen + 2; /*13690*/
						} else { /*13699*/
							$k[$j++] = Infinity; /*13696*/
							$aload($1.seq); /*13693*/
							var _5s = (($1.b % 6) != 0) ? $1.bl : $1.bl6; /*13694*/
							$k[$j++] = _5s; /*13695*/
							$k[$j++] = Infinity; /*13695*/
							$aload($geti($1.barcode, $1.p, $1.b)); /*13695*/
							var _5x = $a(); /*13695*/
							$k[$j++] = _5x; /*13695*/
							$1.seq = $a(); /*13696*/
							$1.state = $1.B; /*13697*/
							$1.p = $1.p + $1.b; /*13698*/
							$1.seqlen = ($1.seqlen + 1) + $1.b; /*13699*/
						} /*13699*/
					} /*13699*/
				} /*13699*/
			} /*13699*/
			$k[$j++] = "latchcws"; /*13704*/
			$k[$j++] = Infinity; /*13704*/
			$k[$j++] = $1.tl; /*13704*/
			$k[$j++] = 900; /*13704*/
			$k[$j++] = $1.bl; /*13704*/
			$k[$j++] = 901; /*13704*/
			$k[$j++] = $1.bl6; /*13704*/
			$k[$j++] = 924; /*13704*/
			$k[$j++] = $1.nl; /*13704*/
			$k[$j++] = 902; /*13704*/
			$k[$j++] = $1.bs; /*13704*/
			$k[$j++] = 913; /*13704*/
			var _69 = $d(); /*13704*/
			$1[$k[--$j]] = _69; /*13705*/
			$1.enca = function() {
				var _6F = $get($get($1.charvals, $1.A), $k[--$j]); /*13708*/
				$k[$j++] = _6F; /*13708*/
			}; /*13708*/
			$1.encl = function() {
				var _6K = $get($get($1.charvals, $1.L), $k[--$j]); /*13709*/
				$k[$j++] = _6K; /*13709*/
			}; /*13709*/
			$1.encm = function() {
				var _6P = $get($get($1.charvals, $1.M), $k[--$j]); /*13710*/
				$k[$j++] = _6P; /*13710*/
			}; /*13710*/
			$1.encp = function() {
				var _6U = $get($get($1.charvals, $1.P), $k[--$j]); /*13711*/
				$k[$j++] = _6U; /*13711*/
			}; /*13711*/
			$1.textencfuncs = $a(["enca", "encl", "encm", "encp"]); /*13712*/
			$1.addtotext = function() {
				$put($1.text, $1.l, $k[--$j]); /*13715*/
				$1.l = $1.l + 1; /*13716*/
			}; /*13717*/
			$1.enct = function() {
				$1.in = $k[--$j]; /*13721*/
				$1.curlen = $a([$1.e, $1.e, $1.e, $1.e]); /*13723*/
				$put($1.curlen, $1.submode, 0); /*13724*/
				$1.curseq = $a([$a([]), $a([]), $a([]), $a([])]); /*13725*/
				$forall($1.in, function() { /*13795*/
					$1.char = $k[--$j]; /*13730*/
					for (;;) { /*13751*/
						$1.imp = false; /*13734*/
						var _6t = $a([$1.A, $1.L, $1.M, $1.P]); /*13735*/
						for (var _6u = 0, _6v = _6t.length; _6u < _6v; _6u++) { /*13749*/
							$1.x = $get(_6t, _6u); /*13736*/
							var _71 = $a([$1.A, $1.L, $1.M, $1.P]); /*13737*/
							for (var _72 = 0, _73 = _71.length; _72 < _73; _72++) { /*13748*/
								$1.y = $get(_71, _72); /*13738*/
								$1.cost = $get($1.curlen, $1.x) + $get($get($1.latlen, $1.x), $1.y); /*13739*/
								if ($1.cost < $get($1.curlen, $1.y)) { /*13747*/
									$put($1.curlen, $1.y, $1.cost); /*13741*/
									$k[$j++] = $1.curseq; /*13744*/
									$k[$j++] = $1.y; /*13744*/
									$k[$j++] = Infinity; /*13744*/
									$aload($get($1.curseq, $1.x)); /*13743*/
									$aload($get($get($1.latseq, $1.x), $1.y)); /*13744*/
									var _7U = $a(); /*13744*/
									var _7V = $k[--$j]; /*13745*/
									$put($k[--$j], _7V, _7U); /*13745*/
									$1.imp = true; /*13746*/
								} /*13746*/
							} /*13746*/
						} /*13746*/
						if (!$1.imp) { /*13750*/
							break; /*13750*/
						} /*13750*/
					} /*13750*/
					$1.nxtlen = $a([$1.e, $1.e, $1.e, $1.e]); /*13754*/
					$1.nxtseq = $a(4); /*13755*/
					var _7i = $a([$1.A, $1.L, $1.M, $1.P]); /*13757*/
					for (var _7j = 0, _7k = _7i.length; _7j < _7k; _7j++) { /*13790*/
						$1.x = $get(_7i, _7j); /*13758*/
						for (;;) { /*13788*/
							var _7q = $get($get($1.charvals, $1.x), $1.char) !== undefined; /*13762*/
							if (!_7q) { /*13762*/
								break; /*13762*/
							} /*13762*/
							$1.cost = $get($1.curlen, $1.x) + 1; /*13765*/
							if ($1.cost < $get($1.nxtlen, $1.x)) { /*13769*/
								$put($1.nxtlen, $1.x, $1.cost); /*13767*/
								$k[$j++] = $1.nxtseq; /*13768*/
								$k[$j++] = $1.x; /*13768*/
								$k[$j++] = Infinity; /*13768*/
								$aload($get($1.curseq, $1.x)); /*13768*/
								$k[$j++] = $1.char; /*13768*/
								var _87 = $a(); /*13768*/
								var _88 = $k[--$j]; /*13768*/
								$put($k[--$j], _88, _87); /*13768*/
							} /*13768*/
							var _8E = $a([$1.A, $1.L, $1.M, $1.P]); /*13772*/
							for (var _8F = 0, _8G = _8E.length; _8F < _8G; _8F++) { /*13785*/
								$1.y = $get(_8E, _8F); /*13773*/
								if ($ne($1.x, $1.y)) { /*13784*/
									$1.cost = ($get($1.curlen, $1.y) + $get($get($1.shftlen, $1.y), $1.x)) + 1; /*13775*/
									if ($1.cost < $get($1.nxtlen, $1.y)) { /*13783*/
										$put($1.nxtlen, $1.y, $1.cost); /*13777*/
										$k[$j++] = $1.nxtseq; /*13781*/
										$k[$j++] = $1.y; /*13781*/
										$k[$j++] = Infinity; /*13781*/
										$aload($get($1.curseq, $1.y)); /*13779*/
										var _8g = ($1.x == $1.A) ? $1.as : $1.ps; /*13780*/
										$k[$j++] = _8g; /*13781*/
										$k[$j++] = $1.char; /*13781*/
										var _8i = $a(); /*13781*/
										var _8j = $k[--$j]; /*13782*/
										$put($k[--$j], _8j, _8i); /*13782*/
									} /*13782*/
								} /*13782*/
							} /*13782*/
							break; /*13787*/
						} /*13787*/
					} /*13787*/
					$1.curlen = $1.nxtlen; /*13792*/
					$1.curseq = $1.nxtseq; /*13793*/
				}); /*13793*/
				$1.minseq = $1.e; /*13798*/
				var _8s = $a([$1.A, $1.L, $1.M, $1.P]); /*13799*/
				for (var _8t = 0, _8u = _8s.length; _8t < _8u; _8t++) { /*13805*/
					$1.k = $get(_8s, _8t); /*13800*/
					if ($get($1.curlen, $1.k) < $1.minseq) { /*13804*/
						$1.minseq = $get($1.curlen, $1.k); /*13802*/
						$1.txtseq = $get($1.curseq, $1.k); /*13803*/
					} /*13803*/
				} /*13803*/
				$1.text = $a($1.minseq); /*13808*/
				$1.k = 0; /*13809*/
				$1.l = 0; /*13809*/
				for (;;) { /*13829*/
					if ($1.k >= $1.txtseq.length) { /*13810*/
						break; /*13810*/
					} /*13810*/
					$1.char = $get($1.txtseq, $1.k); /*13812*/
					$k[$j++] = $1.char; /*13815*/
					$1[$get($1.textencfuncs, $1.submode)](); /*13815*/
					if ($1.addtotext() == $b) break; /*13815*/
					$1.k = $1.k + 1; /*13816*/
					if (($1.char == $1.as) || ($1.char == $1.ps)) { /*13822*/
						$k[$j++] = $get($1.txtseq, $1.k); /*13820*/
						if ($1.char == $1.as) { /*13820*/
							if ($1.enca() == $b) break; /*13820*/
						} else { /*13820*/
							if ($1.encp() == $b) break; /*13820*/
						} /*13820*/
						if ($1.addtotext() == $b) break; /*13820*/
						$1.k = $1.k + 1; /*13821*/
					} /*13821*/
					if ($1.char == $1.al) { /*13825*/
						$1.submode = $1.A; /*13825*/
					} /*13825*/
					if ($1.char == $1.ll) { /*13826*/
						$1.submode = $1.L; /*13826*/
					} /*13826*/
					if ($1.char == $1.ml) { /*13827*/
						$1.submode = $1.M; /*13827*/
					} /*13827*/
					if ($1.char == $1.pl) { /*13828*/
						$1.submode = $1.P; /*13828*/
					} /*13828*/
				} /*13828*/
				if (($1.text.length % 2) == 1) { /*13839*/
					if ($1.submode == $1.P) { /*13836*/
						$k[$j++] = "pad"; /*13833*/
						$k[$j++] = $1.al; /*13833*/
						if ($1.encp() == $b) return $b; /*13833*/
						var _9j = $k[--$j]; /*13833*/
						$1[$k[--$j]] = _9j; /*13833*/
						$1.submode = $1.A; /*13834*/
					} else { /*13836*/
						$k[$j++] = "pad"; /*13836*/
						$k[$j++] = $1.ps; /*13836*/
						$1[$get($1.textencfuncs, $1.submode)](); /*13836*/
						var _9r = $k[--$j]; /*13836*/
						$1[$k[--$j]] = _9r; /*13836*/
					} /*13836*/
					$k[$j++] = Infinity; /*13838*/
					$aload($1.text); /*13838*/
					$k[$j++] = $1.pad; /*13838*/
					$1.text = $a(); /*13838*/
				} /*13838*/
				$1.out = $a(~~($1.text.length / 2)); /*13841*/
				for (var _A0 = 0, _9z = $1.out.length - 1; _A0 <= _9z; _A0 += 1) { /*13845*/
					$1.k = _A0; /*13843*/
					$put($1.out, $1.k, ($get($1.text, $1.k * 2) * 30) + $get($1.text, ($1.k * 2) + 1)); /*13844*/
				} /*13844*/
				$k[$j++] = $1.out; /*13847*/
			}; /*13849*/
			$1.encn = function() {
				$1.in = $k[--$j]; /*13852*/
				$1.out = $a([]); /*13853*/
				for (var _AE = 0, _AD = $1.in.length - 1; _AE <= _AD; _AE += 44) { /*13881*/
					$1.k = _AE; /*13855*/
					$k[$j++] = Infinity; /*13859*/
					var _AJ = $1.in.length - $1.k; /*13857*/
					$k[$j++] = 1; /*13857*/
					$k[$j++] = $1.in; /*13857*/
					$k[$j++] = $1.k; /*13857*/
					$k[$j++] = _AJ; /*13857*/
					if (_AJ > 44) { /*13857*/
						$j--; /*13857*/
						$k[$j++] = 44; /*13857*/
					} /*13857*/
					var _AK = $k[--$j]; /*13857*/
					var _AL = $k[--$j]; /*13857*/
					$forall($geti($k[--$j], _AL, _AK), function() { /*13858*/
						var _AO = $k[--$j]; /*13858*/
						$k[$j++] = _AO - 48; /*13858*/
					}); /*13858*/
					$1.gmod = $a(); /*13859*/
					$1.cwn = $a([]); /*13860*/
					for (;;) { /*13879*/
						$1.dv = 900; /*13861*/
						$1.gmul = $a([]); /*13862*/
						$1.val = 0; /*13862*/
						for (;;) { /*13874*/
							if ($1.gmod.length == 0) { /*13863*/
								break; /*13863*/
							} /*13863*/
							$1.val = ($1.val * 10) + $get($1.gmod, 0); /*13864*/
							$1.gmod = $geti($1.gmod, 1, $1.gmod.length - 1); /*13865*/
							if ($1.val < $1.dv) { /*13871*/
								if ($1.gmul.length != 0) { /*13869*/
									$k[$j++] = Infinity; /*13868*/
									$aload($1.gmul); /*13868*/
									$k[$j++] = 0; /*13868*/
									$1.gmul = $a(); /*13868*/
								} /*13868*/
							} else { /*13871*/
								$k[$j++] = Infinity; /*13871*/
								$aload($1.gmul); /*13871*/
								$k[$j++] = ~~($1.val / $1.dv); /*13871*/
								$1.gmul = $a(); /*13871*/
							} /*13871*/
							$1.val = $1.val % $1.dv; /*13873*/
						} /*13873*/
						$1.dv = $1.val; /*13875*/
						$k[$j++] = Infinity; /*13876*/
						$k[$j++] = $1.dv; /*13876*/
						$aload($1.cwn); /*13876*/
						$1.cwn = $a(); /*13876*/
						$1.gmod = $1.gmul; /*13877*/
						if ($1.gmul.length == 0) { /*13878*/
							break; /*13878*/
						} /*13878*/
					} /*13878*/
					$k[$j++] = Infinity; /*13880*/
					$aload($1.out); /*13880*/
					$aload($1.cwn); /*13880*/
					$1.out = $a(); /*13880*/
				} /*13880*/
				$k[$j++] = $1.out; /*13882*/
			}; /*13883*/
			$1.encfuncs = $a(["enct", "encn", "encb"]); /*13885*/
			$1.addtocws = function() {
				var _Av = $k[--$j]; /*13888*/
				$puti($1.datcws, $1.j, _Av); /*13888*/
				$1.j = _Av.length + $1.j; /*13889*/
			}; /*13890*/
			$1.state = $1.T; /*13893*/
			$1.submode = $1.A; /*13893*/
			$1.datcws = $a($1.seqlen); /*13894*/
			$1.i = 0; /*13895*/
			$1.j = 0; /*13895*/
			for (;;) { /*13911*/
				if ($1.i >= $1.seq.length) { /*13896*/
					break; /*13896*/
				} /*13896*/
				$1.chars = $get($1.seq, $1.i); /*13897*/
				if ($eq($type($1.chars), "arraytype")) { /*13907*/
					$k[$j++] = $1.chars; /*13899*/
					$1[$get($1.encfuncs, $1.state)](); /*13899*/
					if ($1.addtocws() == $b) break; /*13899*/
				} else { /*13907*/
					$k[$j++] = $a([$get($1.latchcws, $1.chars)]); /*13901*/
					if ($1.addtocws() == $b) break; /*13901*/
					if ($1.chars == $1.tl) { /*13902*/
						$1.state = $1.T; /*13902*/
						$1.submode = $1.A; /*13902*/
					} /*13902*/
					if ($1.chars == $1.nl) { /*13903*/
						$1.state = $1.N; /*13903*/
					} /*13903*/
					if (($1.chars == $1.bl) || ($1.chars == $1.bl6)) { /*13904*/
						$1.state = $1.B; /*13904*/
					} /*13904*/
					if ($1.chars == $1.bs) { /*13908*/
						$1.i = $1.i + 1; /*13906*/
						$k[$j++] = $get($1.seq, $1.i); /*13907*/
						if ($1.encb() == $b) break; /*13907*/
						if ($1.addtocws() == $b) break; /*13907*/
					} /*13907*/
				} /*13907*/
				$1.i = $1.i + 1; /*13910*/
			} /*13910*/
			$1.datcws = $geti($1.datcws, 0, $1.j); /*13912*/
		} /*13912*/
		$1.m = $1.datcws.length; /*13916*/
		if ($1.eclevel == -1) { /*13922*/
			if ($1.m <= 40) { /*13918*/
				$1.eclevel = 2; /*13918*/
			} /*13918*/
			if (($1.m >= 41) && ($1.m <= 160)) { /*13919*/
				$1.eclevel = 3; /*13919*/
			} /*13919*/
			if (($1.m >= 161) && ($1.m <= 320)) { /*13920*/
				$1.eclevel = 4; /*13920*/
			} /*13920*/
			if ($1.m >= 321) { /*13921*/
				$1.eclevel = 5; /*13921*/
			} /*13921*/
		} /*13921*/
		$1.maxeclevel = (~~((Math.log((928 - 1) - $1.m)) / Math.log(2))) - 1; /*13925*/
		if ($1.eclevel > $1.maxeclevel) { /*13926*/
			$1.eclevel = $1.maxeclevel; /*13926*/
		} /*13926*/
		$1.k = ~~Math.pow(2, $1.eclevel + 1); /*13927*/
		if ($1.columns == 0) { /*13930*/
			$1.columns = ~~(Math.round(Math.sqrt(($1.m + $1.k) / 3))); /*13930*/
		} /*13930*/
		if (($1.columns >= 1) && ($1.columns <= 30)) { /*13931*/
			$1.c = $1.columns; /*13931*/
		} /*13931*/
		$1.r = ~~(Math.ceil((($1.m + $1.k) + 1) / $1.columns)); /*13934*/
		if (($1.r < $1.rows) && ($1.rows <= 90)) { /*13935*/
			$1.r = $1.rows; /*13935*/
		} /*13935*/
		if ($1.r < 3) { /*13936*/
			$1.r = 3; /*13936*/
		} /*13936*/
		var _C6 = $1.c; /*13939*/
		var _C7 = $1.r; /*13939*/
		var _C8 = $1.m; /*13939*/
		var _C9 = 8; /*13939*/
		var _CA = (~~((Math.log(((_C6 * _C7) - 1) - _C8)) / Math.log(2))) - 1; /*13939*/
		if (((~~((Math.log(((_C6 * _C7) - 1) - _C8)) / Math.log(2))) - 1) > 8) { /*13939*/
			var _ = _C9; /*13939*/
			_C9 = _CA; /*13939*/
			_CA = _; /*13939*/
		} /*13939*/
		$1.maxeclevel = _CA; /*13939*/
		if ($1.maxeclevel > $1.eclevel) { /*13943*/
			$1.eclevel = $1.maxeclevel; /*13941*/
			$1.k = ~~Math.pow(2, $1.eclevel + 1); /*13942*/
		} /*13942*/
		$1.n = ($1.c * $1.r) - $1.k; /*13946*/
		$1.cws = $a(($1.c * $1.r) + 1); /*13947*/
		$put($1.cws, 0, $1.n); /*13948*/
		$puti($1.cws, 1, $1.datcws); /*13949*/
		$k[$j++] = $1.cws; /*13950*/
		$k[$j++] = $1.m + 1; /*13950*/
		$k[$j++] = Infinity; /*13950*/
		for (var _CT = 0, _CU = ($1.n - $1.m) - 1; _CT < _CU; _CT++) { /*13950*/
			$k[$j++] = 900; /*13950*/
		} /*13950*/
		var _CV = $a(); /*13950*/
		var _CW = $k[--$j]; /*13950*/
		$puti($k[--$j], _CW, _CV); /*13950*/
		$k[$j++] = $1.cws; /*13951*/
		$k[$j++] = $1.n; /*13951*/
		$k[$j++] = Infinity; /*13951*/
		for (var _Cb = 0, _Cc = $1.k; _Cb < _Cc; _Cb++) { /*13951*/
			$k[$j++] = 0; /*13951*/
		} /*13951*/
		$k[$j++] = 0; /*13951*/
		var _Cd = $a(); /*13951*/
		var _Ce = $k[--$j]; /*13951*/
		$puti($k[--$j], _Ce, _Cd); /*13951*/
		$k[$j++] = Infinity; /*13954*/
		$k[$j++] = 1; /*13954*/
		for (var _Cg = 0, _Ch = 928; _Cg < _Ch; _Cg++) { /*13954*/
			var _Ci = $k[--$j]; /*13954*/
			$k[$j++] = _Ci; /*13954*/
			$k[$j++] = (_Ci * 3) % 929; /*13954*/
		} /*13954*/
		$1.rsalog = $a(); /*13954*/
		$1.rslog = $a(929); /*13955*/
		for (var _Cl = 1; _Cl <= 928; _Cl += 1) { /*13956*/
			$put($1.rslog, $get($1.rsalog, _Cl), _Cl); /*13956*/
		} /*13956*/
		$1.rsprod = function() {
			var _Cp = $k[--$j]; /*13960*/
			var _Cq = $k[--$j]; /*13960*/
			$k[$j++] = _Cq; /*13964*/
			$k[$j++] = _Cp; /*13964*/
			if ((_Cp != 0) && (_Cq != 0)) { /*13963*/
				var _Ct = $get($1.rslog, $k[--$j]); /*13961*/
				var _Cy = $get($1.rsalog, (_Ct + $get($1.rslog, $k[--$j])) % 928); /*13961*/
				$k[$j++] = _Cy; /*13961*/
			} else { /*13963*/
				$j -= 2; /*13963*/
				$k[$j++] = 0; /*13963*/
			} /*13963*/
		}; /*13965*/
		$k[$j++] = Infinity; /*13968*/
		$k[$j++] = 1; /*13968*/
		for (var _D0 = 0, _D1 = $1.k; _D0 < _D1; _D0++) { /*13968*/
			$k[$j++] = 0; /*13968*/
		} /*13968*/
		$1.coeffs = $a(); /*13968*/
		for (var _D5 = 1, _D4 = $1.k; _D5 <= _D4; _D5 += 1) { /*13977*/
			$1.i = _D5; /*13970*/
			$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*13971*/
			for (var _DC = $1.i - 1; _DC >= 1; _DC -= 1) { /*13975*/
				$1.j = _DC; /*13973*/
				$k[$j++] = $1.coeffs; /*13974*/
				$k[$j++] = $1.j; /*13974*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*13974*/
				$k[$j++] = $get($1.coeffs, $1.j); /*13974*/
				$k[$j++] = $get($1.rsalog, $1.i); /*13974*/
				if ($1.rsprod() == $b) break; /*13974*/
				var _DO = $k[--$j]; /*13974*/
				var _DP = $k[--$j]; /*13974*/
				var _DQ = $k[--$j]; /*13974*/
				$put($k[--$j], _DQ, (_DP + _DO) % 929); /*13974*/
			} /*13974*/
			$k[$j++] = $1.coeffs; /*13976*/
			$k[$j++] = 0; /*13976*/
			$k[$j++] = $get($1.coeffs, 0); /*13976*/
			$k[$j++] = $get($1.rsalog, $1.i); /*13976*/
			if ($1.rsprod() == $b) break; /*13976*/
			var _DY = $k[--$j]; /*13976*/
			var _DZ = $k[--$j]; /*13976*/
			$put($k[--$j], _DZ, _DY); /*13976*/
		} /*13976*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*13978*/
		for (var _Df = $1.coeffs.length - 1; _Df >= 0; _Df -= 2) { /*13979*/
			var _Dg = $1.coeffs; /*13979*/
			$put(_Dg, _Df, 929 - $get(_Dg, _Df)); /*13979*/
		} /*13979*/
		for (var _Dk = 0, _Dj = $1.n - 1; _Dk <= _Dj; _Dk += 1) { /*13988*/
			$1.t = ($get($1.cws, _Dk) + $get($1.cws, $1.n)) % 929; /*13983*/
			for (var _Ds = 0, _Dr = $1.k - 1; _Ds <= _Dr; _Ds += 1) { /*13987*/
				$1.j = _Ds; /*13985*/
				$put($1.cws, $1.n + $1.j, ($get($1.cws, ($1.n + $1.j) + 1) + (929 - (($1.t * $get($1.coeffs, ($1.k - $1.j) - 1)) % 929))) % 929); /*13986*/
			} /*13986*/
		} /*13986*/
		for (var _E9 = $1.n, _E8 = $1.n + $1.k; _E9 <= _E8; _E9 += 1) { /*13989*/
			$put($1.cws, _E9, (929 - $get($1.cws, _E9)) % 929); /*13989*/
		} /*13989*/
		$1.cws = $geti($1.cws, 0, $1.cws.length - 1); /*13992*/
		$1.clusters = $a([$a([120256, 125680, 128380, 120032, 125560, 128318, 108736, 119920, 108640, 86080, 108592, 86048, 110016, 120560, 125820, 109792, 120440, 125758, 88256, 109680, 88160, 89536, 110320, 120700, 89312, 110200, 120638, 89200, 110140, 89840, 110460, 89720, 110398, 89980, 128506, 119520, 125304, 128190, 107712, 119408, 125244, 107616, 119352, 84032, 107568, 119324, 84000, 107544, 83984, 108256, 119672, 125374, 85184, 108144, 119612, 85088, 108088, 119582, 85040, 108060, 85728, 108408, 119742, 85616, 108348, 85560, 108318, 85880, 108478, 85820, 85790, 107200, 119152, 125116, 107104, 119096, 125086, 83008, 107056, 119068, 82976, 107032, 82960, 82952, 83648, 107376, 119228, 83552, 107320, 119198, 83504, 107292, 83480, 83468, 83824, 107452, 83768, 107422, 83740, 83900, 106848, 118968, 125022, 82496, 106800, 118940, 82464, 106776, 118926, 82448, 106764, 82440, 106758, 82784, 106936, 119006, 82736, 106908, 82712, 106894, 82700, 82694, 106974, 82830, 82240, 106672, 118876, 82208, 106648, 118862, 82192, 106636, 82184, 106630, 82180, 82352, 82328, 82316, 82080, 118830, 106572, 106566, 82050, 117472, 124280, 127678, 103616, 117360, 124220, 103520, 117304, 124190, 75840, 103472, 75808, 104160, 117624, 124350, 76992, 104048, 117564, 76896, 103992, 76848, 76824, 77536, 104312, 117694, 77424, 104252, 77368, 77340, 77688, 104382, 77628, 77758, 121536, 126320, 128700, 121440, 126264, 128670, 111680, 121392, 126236, 111648, 121368, 126222, 111632, 121356, 103104, 117104, 124092, 112320, 103008, 117048, 124062, 112224, 121656, 126366, 93248, 74784, 102936, 117006, 93216, 112152, 93200, 75456, 103280, 117180, 93888, 75360, 103224, 117150, 93792, 112440, 121758, 93744, 75288, 93720, 75632, 103356, 94064, 75576, 103326, 94008, 112542, 93980, 75708, 94140, 75678, 94110, 121184, 126136, 128606, 111168, 121136, 126108, 111136, 121112, 126094, 111120, 121100, 111112, 111108, 102752, 116920, 123998, 111456, 102704, 116892, 91712, 74272, 121244, 116878, 91680, 74256, 102668, 91664, 111372, 102662, 74244, 74592, 102840, 116958, 92000, 74544, 102812, 91952, 111516, 102798, 91928, 74508, 74502, 74680, 102878, 92088, 74652, 92060, 74638, 92046, 92126, 110912, 121008, 126044, 110880, 120984, 126030, 110864, 120972, 110856, 120966, 110852, 110850, 74048, 102576, 116828, 90944, 74016, 102552, 116814, 90912, 111000, 121038, 90896, 73992, 102534, 90888, 110982, 90884, 74160, 102620, 91056, 74136, 102606, 91032, 111054, 91020, 74118, 91014, 91100, 91086, 110752, 120920, 125998, 110736, 120908, 110728, 120902, 110724, 110722, 73888, 102488, 116782, 90528, 73872, 102476, 90512, 110796, 102470, 90504, 73860, 90500, 73858, 73944, 90584, 90572, 90566, 120876, 120870, 110658, 102444, 73800, 90312, 90308, 90306, 101056, 116080, 123580, 100960, 116024, 70720, 100912, 115996, 70688, 100888, 70672, 70664, 71360, 101232, 116156, 71264, 101176, 116126, 71216, 101148, 71192, 71180, 71536, 101308, 71480, 101278, 71452, 71612, 71582, 118112, 124600, 127838, 105024, 118064, 124572, 104992, 118040, 124558, 104976, 118028, 104968, 118022, 100704, 115896, 123486, 105312, 100656, 115868, 79424, 70176, 118172, 115854, 79392, 105240, 100620, 79376, 70152, 79368, 70496, 100792, 115934, 79712, 70448, 118238, 79664, 105372, 100750, 79640, 70412, 79628, 70584, 100830, 79800, 70556, 79772, 70542, 70622, 79838, 122176, 126640, 128860, 122144, 126616, 128846, 122128, 126604, 122120, 126598, 122116, 104768, 117936, 124508, 113472, 104736, 126684, 124494, 113440, 122264, 126670, 113424, 104712, 117894, 113416, 122246, 104706, 69952, 100528, 115804, 78656, 69920, 100504, 115790, 96064, 78624, 104856, 117966, 96032, 113560, 122318, 100486, 96016, 78600, 104838, 96008, 69890, 70064, 100572, 78768, 70040, 100558, 96176, 78744, 104910, 96152, 113614, 70022, 78726, 70108, 78812, 70094, 96220, 78798, 122016, 126552, 128814, 122000, 126540, 121992, 126534, 121988, 121986, 104608, 117848, 124462, 113056, 104592, 126574, 113040, 122060, 117830, 113032, 104580, 113028, 104578, 113026, 69792, 100440, 115758, 78240, 69776, 100428, 95136, 78224, 104652, 100422, 95120, 113100, 69764, 95112, 78212, 69762, 78210, 69848, 100462, 78296, 69836, 95192, 78284, 69830, 95180, 78278, 69870, 95214, 121936, 126508, 121928, 126502, 121924, 121922, 104528, 117804, 112848, 104520, 117798, 112840, 121958, 112836, 104514, 112834, 69712, 100396, 78032, 69704, 100390, 94672, 78024, 104550, 94664, 112870, 69698, 94660, 78018, 94658, 78060, 94700, 94694, 126486, 121890, 117782, 104484, 104482, 69672, 77928, 94440, 69666, 77922, 99680, 68160, 99632, 68128, 99608, 115342, 68112, 99596, 68104, 99590, 68448, 99768, 115422, 68400, 99740, 68376, 99726, 68364, 68358, 68536, 99806, 68508, 68494, 68574, 101696, 116400, 123740, 101664, 116376, 101648, 116364, 101640, 116358, 101636, 67904, 99504, 115292, 72512, 67872, 116444, 115278, 72480, 101784, 116430, 72464, 67848, 99462, 72456, 101766, 67842, 68016, 99548, 72624, 67992, 99534, 72600, 101838, 72588, 67974, 68060, 72668, 68046, 72654, 118432, 124760, 127918, 118416, 124748, 118408, 124742, 118404, 118402, 101536, 116312, 105888, 101520, 116300, 105872, 118476, 116294, 105864, 101508, 105860, 101506, 105858, 67744, 99416, 72096, 67728, 116334, 80800, 72080, 101580, 99398, 80784, 105932, 67716, 80776, 72068, 67714, 72066, 67800, 99438, 72152, 67788, 80856, 72140, 67782, 80844, 72134, 67822, 72174, 80878, 126800, 128940, 126792, 128934, 126788, 126786, 118352, 124716, 122576, 126828, 124710, 122568, 126822, 122564, 118338, 122562, 101456, 116268, 105680, 101448, 116262, 114128, 105672, 118374, 114120, 122598, 101442, 114116, 105666, 114114, 67664, 99372, 71888, 67656, 99366, 80336, 71880, 101478, 97232, 80328, 105702, 67650, 97224, 114150, 71874, 97220, 67692, 71916, 67686, 80364, 71910, 97260, 80358, 97254, 126760, 128918, 126756, 126754, 118312, 124694, 122472, 126774, 122468, 118306, 122466, 101416, 116246, 105576, 101412, 113896, 105572, 101410, 113892, 105570, 113890, 67624, 99350, 71784, 101430, 80104, 71780, 67618, 96744, 80100, 71778, 96740, 80098, 96738, 71798, 96758, 126738, 122420, 122418, 105524, 113780, 113778, 71732, 79988, 96500, 96498, 66880, 66848, 98968, 66832, 66824, 66820, 66992, 66968, 66956, 66950, 67036, 67022, 100000, 99984, 115532, 99976, 115526, 99972, 99970, 66720, 98904, 69024, 100056, 98892, 69008, 100044, 69000, 100038, 68996, 66690, 68994, 66776, 98926, 69080, 100078, 69068, 66758, 69062, 66798, 69102, 116560, 116552, 116548, 116546, 99920, 102096, 116588, 115494, 102088, 116582, 102084, 99906, 102082, 66640, 68816, 66632, 98854, 73168, 68808, 66628, 73160, 68804, 66626, 73156, 68802, 66668, 68844, 66662, 73196, 68838, 73190, 124840, 124836, 124834, 116520, 118632, 124854, 118628, 116514, 118626, 99880, 115478, 101992, 116534, 106216, 101988, 99874, 106212, 101986, 106210, 66600, 98838, 68712, 99894, 72936, 68708, 66594, 81384, 72932, 68706, 81380, 72930, 66614, 68726, 72950, 81398, 128980, 128978, 124820, 126900, 124818, 126898, 116500, 118580, 116498, 122740, 118578, 122738, 99860, 101940, 99858, 106100, 101938, 114420]), $a([128352, 129720, 125504, 128304, 129692, 125472, 128280, 129678, 125456, 128268, 125448, 128262, 125444, 125792, 128440, 129758, 120384, 125744, 128412, 120352, 125720, 128398, 120336, 125708, 120328, 125702, 120324, 120672, 125880, 128478, 110144, 120624, 125852, 110112, 120600, 125838, 110096, 120588, 110088, 120582, 110084, 110432, 120760, 125918, 89664, 110384, 120732, 89632, 110360, 120718, 89616, 110348, 89608, 110342, 89952, 110520, 120798, 89904, 110492, 89880, 110478, 89868, 90040, 110558, 90012, 89998, 125248, 128176, 129628, 125216, 128152, 129614, 125200, 128140, 125192, 128134, 125188, 125186, 119616, 125360, 128220, 119584, 125336, 128206, 119568, 125324, 119560, 125318, 119556, 119554, 108352, 119728, 125404, 108320, 119704, 125390, 108304, 119692, 108296, 119686, 108292, 108290, 85824, 108464, 119772, 85792, 108440, 119758, 85776, 108428, 85768, 108422, 85764, 85936, 108508, 85912, 108494, 85900, 85894, 85980, 85966, 125088, 128088, 129582, 125072, 128076, 125064, 128070, 125060, 125058, 119200, 125144, 128110, 119184, 125132, 119176, 125126, 119172, 119170, 107424, 119256, 125166, 107408, 119244, 107400, 119238, 107396, 107394, 83872, 107480, 119278, 83856, 107468, 83848, 107462, 83844, 83842, 83928, 107502, 83916, 83910, 83950, 125008, 128044, 125000, 128038, 124996, 124994, 118992, 125036, 118984, 125030, 118980, 118978, 106960, 119020, 106952, 119014, 106948, 106946, 82896, 106988, 82888, 106982, 82884, 82882, 82924, 82918, 124968, 128022, 124964, 124962, 118888, 124982, 118884, 118882, 106728, 118902, 106724, 106722, 82408, 106742, 82404, 82402, 124948, 124946, 118836, 118834, 106612, 106610, 124224, 127664, 129372, 124192, 127640, 129358, 124176, 127628, 124168, 127622, 124164, 124162, 117568, 124336, 127708, 117536, 124312, 127694, 117520, 124300, 117512, 124294, 117508, 117506, 104256, 117680, 124380, 104224, 117656, 124366, 104208, 117644, 104200, 117638, 104196, 104194, 77632, 104368, 117724, 77600, 104344, 117710, 77584, 104332, 77576, 104326, 77572, 77744, 104412, 77720, 104398, 77708, 77702, 77788, 77774, 128672, 129880, 93168, 128656, 129868, 92664, 128648, 129862, 92412, 128644, 128642, 124064, 127576, 129326, 126368, 124048, 129902, 126352, 128716, 127558, 126344, 124036, 126340, 124034, 126338, 117152, 124120, 127598, 121760, 117136, 124108, 121744, 126412, 124102, 121736, 117124, 121732, 117122, 121730, 103328, 117208, 124142, 112544, 103312, 117196, 112528, 121804, 117190, 112520, 103300, 112516, 103298, 112514, 75680, 103384, 117230, 94112, 75664, 103372, 94096, 112588, 103366, 94088, 75652, 94084, 75650, 75736, 103406, 94168, 75724, 94156, 75718, 94150, 75758, 128592, 129836, 91640, 128584, 129830, 91388, 128580, 91262, 128578, 123984, 127532, 126160, 123976, 127526, 126152, 128614, 126148, 123970, 126146, 116944, 124012, 121296, 116936, 124006, 121288, 126182, 121284, 116930, 121282, 102864, 116972, 111568, 102856, 116966, 111560, 121318, 111556, 102850, 111554, 74704, 102892, 92112, 74696, 102886, 92104, 111590, 92100, 74690, 92098, 74732, 92140, 74726, 92134, 128552, 129814, 90876, 128548, 90750, 128546, 123944, 127510, 126056, 128566, 126052, 123938, 126050, 116840, 123958, 121064, 116836, 121060, 116834, 121058, 102632, 116854, 111080, 121078, 111076, 102626, 111074, 74216, 102646, 91112, 74212, 91108, 74210, 91106, 74230, 91126, 128532, 90494, 128530, 123924, 126004, 123922, 126002, 116788, 120948, 116786, 120946, 102516, 110836, 102514, 110834, 73972, 90612, 73970, 90610, 128522, 123914, 125978, 116762, 120890, 102458, 110714, 123552, 127320, 129198, 123536, 127308, 123528, 127302, 123524, 123522, 116128, 123608, 127342, 116112, 123596, 116104, 123590, 116100, 116098, 101280, 116184, 123630, 101264, 116172, 101256, 116166, 101252, 101250, 71584, 101336, 116206, 71568, 101324, 71560, 101318, 71556, 71554, 71640, 101358, 71628, 71622, 71662, 127824, 129452, 79352, 127816, 129446, 79100, 127812, 78974, 127810, 123472, 127276, 124624, 123464, 127270, 124616, 127846, 124612, 123458, 124610, 115920, 123500, 118224, 115912, 123494, 118216, 124646, 118212, 115906, 118210, 100816, 115948, 105424, 100808, 115942, 105416, 118246, 105412, 100802, 105410, 70608, 100844, 79824, 70600, 100838, 79816, 105446, 79812, 70594, 79810, 70636, 79852, 70630, 79846, 129960, 95728, 113404, 129956, 95480, 113278, 129954, 95356, 95294, 127784, 129430, 78588, 128872, 129974, 95996, 78462, 128868, 127778, 95870, 128866, 123432, 127254, 124520, 123428, 126696, 128886, 123426, 126692, 124514, 126690, 115816, 123446, 117992, 115812, 122344, 117988, 115810, 122340, 117986, 122338, 100584, 115830, 104936, 100580, 113640, 104932, 100578, 113636, 104930, 113634, 70120, 100598, 78824, 70116, 96232, 78820, 70114, 96228, 78818, 96226, 70134, 78838, 129940, 94968, 113022, 129938, 94844, 94782, 127764, 78206, 128820, 127762, 95102, 128818, 123412, 124468, 123410, 126580, 124466, 126578, 115764, 117876, 115762, 122100, 117874, 122098, 100468, 104692, 100466, 113140, 104690, 113138, 69876, 78324, 69874, 95220, 78322, 95218, 129930, 94588, 94526, 127754, 128794, 123402, 124442, 126522, 115738, 117818, 121978, 100410, 104570, 112890, 69754, 78074, 94714, 94398, 123216, 127148, 123208, 127142, 123204, 123202, 115408, 123244, 115400, 123238, 115396, 115394, 99792, 115436, 99784, 115430, 99780, 99778, 68560, 99820, 68552, 99814, 68548, 68546, 68588, 68582, 127400, 129238, 72444, 127396, 72318, 127394, 123176, 127126, 123752, 123172, 123748, 123170, 123746, 115304, 123190, 116456, 115300, 116452, 115298, 116450, 99560, 115318, 101864, 99556, 101860, 99554, 101858, 68072, 99574, 72680, 68068, 72676, 68066, 72674, 68086, 72694, 129492, 80632, 105854, 129490, 80508, 80446, 127380, 72062, 127924, 127378, 80766, 127922, 123156, 123700, 123154, 124788, 123698, 124786, 115252, 116340, 115250, 118516, 116338, 118514, 99444, 101620, 99442, 105972, 101618, 105970, 67828, 72180, 67826, 80884, 72178, 80882, 97008, 114044, 96888, 113982, 96828, 96798, 129482, 80252, 130010, 97148, 80190, 97086, 127370, 127898, 128954, 123146, 123674, 124730, 126842, 115226, 116282, 118394, 122618, 99386, 101498, 105722, 114170, 67706, 71930, 80378, 96632, 113854, 96572, 96542, 80062, 96702, 96444, 96414, 96350, 123048, 123044, 123042, 115048, 123062, 115044, 115042, 99048, 115062, 99044, 99042, 67048, 99062, 67044, 67042, 67062, 127188, 68990, 127186, 123028, 123316, 123026, 123314, 114996, 115572, 114994, 115570, 98932, 100084, 98930, 100082, 66804, 69108, 66802, 69106, 129258, 73084, 73022, 127178, 127450, 123018, 123290, 123834, 114970, 115514, 116602, 98874, 99962, 102138, 66682, 68858, 73210, 81272, 106174, 81212, 81182, 72894, 81342, 97648, 114364, 97592, 114334, 97564, 97550, 81084, 97724, 81054, 97694, 97464, 114270, 97436, 97422, 80990, 97502, 97372, 97358, 97326, 114868, 114866, 98676, 98674, 66292, 66290, 123098, 114842, 115130, 98618, 99194, 66170, 67322, 69310, 73404, 73374, 81592, 106334, 81564, 81550, 73310, 81630, 97968, 114524, 97944, 114510, 97932, 97926, 81500, 98012, 81486, 97998, 97880, 114478, 97868, 97862, 81454, 97902, 97836, 97830, 69470, 73564, 73550, 81752, 106414, 81740, 81734, 73518, 81774, 81708, 81702]), $a([109536, 120312, 86976, 109040, 120060, 86496, 108792, 119934, 86256, 108668, 86136, 129744, 89056, 110072, 129736, 88560, 109820, 129732, 88312, 109694, 129730, 88188, 128464, 129772, 89592, 128456, 129766, 89340, 128452, 89214, 128450, 125904, 128492, 125896, 128486, 125892, 125890, 120784, 125932, 120776, 125926, 120772, 120770, 110544, 120812, 110536, 120806, 110532, 84928, 108016, 119548, 84448, 107768, 119422, 84208, 107644, 84088, 107582, 84028, 129640, 85488, 108284, 129636, 85240, 108158, 129634, 85116, 85054, 128232, 129654, 85756, 128228, 85630, 128226, 125416, 128246, 125412, 125410, 119784, 125430, 119780, 119778, 108520, 119798, 108516, 108514, 83424, 107256, 119166, 83184, 107132, 83064, 107070, 83004, 82974, 129588, 83704, 107390, 129586, 83580, 83518, 128116, 83838, 128114, 125172, 125170, 119284, 119282, 107508, 107506, 82672, 106876, 82552, 106814, 82492, 82462, 129562, 82812, 82750, 128058, 125050, 119034, 82296, 106686, 82236, 82206, 82366, 82108, 82078, 76736, 103920, 117500, 76256, 103672, 117374, 76016, 103548, 75896, 103486, 75836, 129384, 77296, 104188, 129380, 77048, 104062, 129378, 76924, 76862, 127720, 129398, 77564, 127716, 77438, 127714, 124392, 127734, 124388, 124386, 117736, 124406, 117732, 117730, 104424, 117750, 104420, 104418, 112096, 121592, 126334, 92608, 111856, 121468, 92384, 111736, 121406, 92272, 111676, 92216, 111646, 92188, 75232, 103160, 117118, 93664, 74992, 103036, 93424, 112252, 102974, 93304, 74812, 93244, 74782, 93214, 129332, 75512, 103294, 129908, 129330, 93944, 75388, 129906, 93820, 75326, 93758, 127604, 75646, 128756, 127602, 94078, 128754, 124148, 126452, 124146, 126450, 117236, 121844, 117234, 121842, 103412, 103410, 91584, 111344, 121212, 91360, 111224, 121150, 91248, 111164, 91192, 111134, 91164, 91150, 74480, 102780, 91888, 74360, 102718, 91768, 111422, 91708, 74270, 91678, 129306, 74620, 129850, 92028, 74558, 91966, 127546, 128634, 124026, 126202, 116986, 121338, 102906, 90848, 110968, 121022, 90736, 110908, 90680, 110878, 90652, 90638, 74104, 102590, 91000, 74044, 90940, 74014, 90910, 74174, 91070, 90480, 110780, 90424, 110750, 90396, 90382, 73916, 90556, 73886, 90526, 90296, 110686, 90268, 90254, 73822, 90334, 90204, 90190, 71136, 101112, 116094, 70896, 100988, 70776, 100926, 70716, 70686, 129204, 71416, 101246, 129202, 71292, 71230, 127348, 71550, 127346, 123636, 123634, 116212, 116210, 101364, 101362, 79296, 105200, 118140, 79072, 105080, 118078, 78960, 105020, 78904, 104990, 78876, 78862, 70384, 100732, 79600, 70264, 100670, 79480, 105278, 79420, 70174, 79390, 129178, 70524, 129466, 79740, 70462, 79678, 127290, 127866, 123514, 124666, 115962, 118266, 100858, 113376, 122232, 126654, 95424, 113264, 122172, 95328, 113208, 122142, 95280, 113180, 95256, 113166, 95244, 78560, 104824, 117950, 95968, 78448, 104764, 95856, 113468, 104734, 95800, 78364, 95772, 78350, 95758, 70008, 100542, 78712, 69948, 96120, 78652, 69918, 96060, 78622, 96030, 70078, 78782, 96190, 94912, 113008, 122044, 94816, 112952, 122014, 94768, 112924, 94744, 112910, 94732, 94726, 78192, 104636, 95088, 78136, 104606, 95032, 113054, 95004, 78094, 94990, 69820, 78268, 69790, 95164, 78238, 95134, 94560, 112824, 121950, 94512, 112796, 94488, 112782, 94476, 94470, 78008, 104542, 94648, 77980, 94620, 77966, 94606, 69726, 78046, 94686, 94384, 112732, 94360, 112718, 94348, 94342, 77916, 94428, 77902, 94414, 94296, 112686, 94284, 94278, 77870, 94318, 94252, 94246, 68336, 99708, 68216, 99646, 68156, 68126, 68476, 68414, 127162, 123258, 115450, 99834, 72416, 101752, 116414, 72304, 101692, 72248, 101662, 72220, 72206, 67960, 99518, 72568, 67900, 72508, 67870, 72478, 68030, 72638, 80576, 105840, 118460, 80480, 105784, 118430, 80432, 105756, 80408, 105742, 80396, 80390, 72048, 101564, 80752, 71992, 101534, 80696, 71964, 80668, 71950, 80654, 67772, 72124, 67742, 80828, 72094, 80798, 114016, 122552, 126814, 96832, 113968, 122524, 96800, 113944, 122510, 96784, 113932, 96776, 113926, 96772, 80224, 105656, 118366, 97120, 80176, 105628, 97072, 114076, 105614, 97048, 80140, 97036, 80134, 97030, 71864, 101470, 80312, 71836, 97208, 80284, 71822, 97180, 80270, 97166, 67678, 71902, 80350, 97246, 96576, 113840, 122460, 96544, 113816, 122446, 96528, 113804, 96520, 113798, 96516, 96514, 80048, 105564, 96688, 80024, 105550, 96664, 113870, 96652, 80006, 96646, 71772, 80092, 71758, 96732, 80078, 96718, 96416, 113752, 122414, 96400, 113740, 96392, 113734, 96388, 96386, 79960, 105518, 96472, 79948, 96460, 79942, 96454, 71726, 79982, 96494, 96336, 113708, 96328, 113702, 96324, 96322, 79916, 96364, 79910, 96358, 96296, 113686, 96292, 96290, 79894, 96310, 66936, 99006, 66876, 66846, 67006, 68976, 100028, 68920, 99998, 68892, 68878, 66748, 69052, 66718, 69022, 73056, 102072, 116574, 73008, 102044, 72984, 102030, 72972, 72966, 68792, 99934, 73144, 68764, 73116, 68750, 73102, 66654, 68830, 73182, 81216, 106160, 118620, 81184, 106136, 118606, 81168, 106124, 81160, 106118, 81156, 81154, 72880, 101980, 81328, 72856, 101966, 81304, 106190, 81292, 72838, 81286, 68700, 72924, 68686, 81372, 72910, 81358, 114336, 122712, 126894, 114320, 122700, 114312, 122694, 114308, 114306, 81056, 106072, 118574, 97696, 81040, 106060, 97680, 114380, 106054, 97672, 81028, 97668, 81026, 97666, 72792, 101934, 81112, 72780, 97752, 81100, 72774, 97740, 81094, 97734, 68654, 72814, 81134, 97774, 114256, 122668, 114248, 122662, 114244, 114242, 80976, 106028, 97488, 80968, 106022, 97480, 114278, 97476, 80962, 97474, 72748, 81004, 72742, 97516, 80998, 97510, 114216, 122646, 114212, 114210, 80936, 106006, 97384, 80932, 97380, 80930, 97378, 72726, 80950, 97398, 114196, 114194, 80916, 97332, 80914, 97330, 66236, 66206, 67256, 99166, 67228, 67214, 66142, 67294, 69296, 100188, 69272, 100174, 69260, 69254, 67164, 69340, 67150, 69326, 73376, 102232, 116654, 73360, 102220, 73352, 102214, 73348, 73346, 69208, 100142, 73432, 102254, 73420, 69190, 73414, 67118, 69230, 73454, 106320, 118700, 106312, 118694, 106308, 106306, 73296, 102188, 81616, 106348, 102182, 81608, 73284, 81604, 73282, 81602, 69164, 73324, 69158, 81644, 73318, 81638, 122792, 126934, 122788, 122786, 106280, 118678, 114536, 106276, 114532, 106274, 114530, 73256, 102166, 81512, 73252, 98024, 81508, 73250, 98020, 81506, 98018, 69142, 73270, 81526, 98038, 122772, 122770, 106260, 114484, 106258, 114482, 73236, 81460, 73234, 97908, 81458, 97906, 122762, 106250, 114458, 73226, 81434, 97850, 66396, 66382, 67416, 99246, 67404, 67398, 66350, 67438, 69456, 100268, 69448, 100262, 69444, 69442, 67372, 69484, 67366, 69478, 102312, 116694, 102308, 102306, 69416, 100246, 73576, 102326, 73572, 69410, 73570, 67350, 69430, 73590, 118740, 118738, 102292, 106420, 102290, 106418, 69396, 73524, 69394, 81780, 73522, 81778, 118730, 102282, 106394, 69386, 73498, 81722, 66476, 66470, 67496, 99286, 67492, 67490, 66454, 67510, 100308, 100306, 67476, 69556, 67474, 69554, 116714])]); /*14234*/
		$1.cwtobits = function() {
			var _EM = $get($1.clusters, $k[--$j]); /*14238*/
			$1.v = $get(_EM, $k[--$j]); /*14238*/
			$k[$j++] = Infinity; /*14239*/
			for (var _EP = 0, _EQ = 17; _EP < _EQ; _EP++) { /*14239*/
				$k[$j++] = 0; /*14239*/
			} /*14239*/
			var _ET = $cvrs($s(17), $1.v, 2); /*14239*/
			for (var _EU = 0, _EV = _ET.length; _EU < _EV; _EU++) { /*14239*/
				$k[$j++] = $get(_ET, _EU) - 48; /*14239*/
			} /*14239*/
			var _EX = $a(); /*14239*/
			$k[$j++] = $geti(_EX, _EX.length - 17, 17); /*14240*/
		}; /*14241*/
		if ($1.compact) { /*14247*/
			$1.rwid = (((17 * $1.c) + 17) + 17) + 1; /*14245*/
		} else { /*14247*/
			$1.rwid = ((((17 * $1.c) + 17) + 17) + 17) + 18; /*14247*/
		} /*14247*/
		$1.pixs = $a($1.rwid * $1.r); /*14249*/
		for (var _Eh = 0, _Eg = $1.r - 1; _Eh <= _Eg; _Eh += 1) { /*14279*/
			$1.i = _Eh; /*14252*/
			if (($1.i % 3) == 0) { /*14257*/
				$1.lcw = ((~~($1.i / 3)) * 30) + (~~(($1.r - 1) / 3)); /*14255*/
				$1.rcw = (((~~($1.i / 3)) * 30) + $1.c) - 1; /*14256*/
			} /*14256*/
			if (($1.i % 3) == 1) { /*14261*/
				$1.lcw = (((~~($1.i / 3)) * 30) + ($1.eclevel * 3)) + (($1.r - 1) % 3); /*14259*/
				$1.rcw = ((~~($1.i / 3)) * 30) + (~~(($1.r - 1) / 3)); /*14260*/
			} /*14260*/
			if (($1.i % 3) == 2) { /*14265*/
				$1.lcw = (((~~($1.i / 3)) * 30) + $1.c) - 1; /*14263*/
				$1.rcw = (((~~($1.i / 3)) * 30) + ($1.eclevel * 3)) + (($1.r - 1) % 3); /*14264*/
			} /*14264*/
			$k[$j++] = $1.pixs; /*14275*/
			$k[$j++] = $1.rwid * $1.i; /*14275*/
			$k[$j++] = Infinity; /*14275*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 0; /*14269*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 0; /*14269*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 0; /*14269*/
			$k[$j++] = 1; /*14269*/
			$k[$j++] = 0; /*14269*/
			$k[$j++] = 0; /*14269*/
			$k[$j++] = 0; /*14269*/
			$k[$j++] = $1.lcw; /*14269*/
			$k[$j++] = $1.i % 3; /*14269*/
			if ($1.cwtobits() == $b) break; /*14269*/
			$forall($k[--$j]); /*14269*/
			$forall($geti($1.cws, $1.c * $1.i, $1.c), function() { /*14270*/
				$k[$j++] = $1.i % 3; /*14270*/
				if ($1.cwtobits() == $b) return $b; /*14270*/
				$forall($k[--$j]); /*14270*/
			}); /*14270*/
			if ($1.compact) { /*14275*/
				$k[$j++] = 1; /*14272*/
			} else { /*14275*/
				$k[$j++] = $1.rcw; /*14274*/
				$k[$j++] = $1.i % 3; /*14274*/
				if ($1.cwtobits() == $b) break; /*14274*/
				$forall($k[--$j]); /*14274*/
				$k[$j++] = 1; /*14275*/
				$k[$j++] = 1; /*14275*/
				$k[$j++] = 1; /*14275*/
				$k[$j++] = 1; /*14275*/
				$k[$j++] = 1; /*14275*/
				$k[$j++] = 1; /*14275*/
				$k[$j++] = 1; /*14275*/
				$k[$j++] = 0; /*14275*/
				$k[$j++] = 1; /*14275*/
				$k[$j++] = 0; /*14275*/
				$k[$j++] = 0; /*14275*/
				$k[$j++] = 0; /*14275*/
				$k[$j++] = 1; /*14275*/
				$k[$j++] = 0; /*14275*/
				$k[$j++] = 1; /*14275*/
				$k[$j++] = 0; /*14275*/
				$k[$j++] = 0; /*14275*/
				$k[$j++] = 1; /*14275*/
			} /*14275*/
			var _FG = $a(); /*14275*/
			var _FH = $k[--$j]; /*14277*/
			$puti($k[--$j], _FH, _FG); /*14277*/
		} /*14277*/
		var _FQ = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.rwid,
			pixy: $1.r,
			height: ($1.r / 72) * $1.rowmult,
			width: $1.rwid / 72,
			opt: $1.options
		}; /*14289*/
		$k[$j++] = _FQ; /*14292*/
		if (!$1.dontdraw) { /*14292*/
			$0.renmatrix(); /*14292*/
		} /*14292*/
	};
	$0.pdf417compact = function() {
		var $1 = {}; /*14320*/
		$1.options = $k[--$j]; /*14322*/
		$1.barcode = $k[--$j]; /*14323*/
		$1.dontdraw = false; /*14325*/
		$forall($1.options, function() { /*14336*/
			var _3 = $k[--$j]; /*14336*/
			$1[$k[--$j]] = _3; /*14336*/
		}); /*14336*/
		$1.options.dontdraw = true; /*14339*/
		$1.options.compact = true; /*14340*/
		$k[$j++] = "args"; /*14342*/
		$k[$j++] = $1.barcode; /*14342*/
		$k[$j++] = $1.options; /*14342*/
		$0.pdf417(); /*14342*/
		var _9 = $k[--$j]; /*14342*/
		$1[$k[--$j]] = _9; /*14342*/
		$1.args.opt = $1.options; /*14344*/
		$k[$j++] = $1.args; /*14347*/
		if (!$1.dontdraw) { /*14347*/
			$0.renmatrix(); /*14347*/
		} /*14347*/
	};
	$0.micropdf417 = function() {
		var $1 = {}; /*14374*/
		$1.options = $k[--$j]; /*14376*/
		$1.barcode = $k[--$j]; /*14377*/
		$1.dontdraw = false; /*14379*/
		$1.version = "unset"; /*14380*/
		$1.columns = 0; /*14381*/
		$1.rows = 0; /*14382*/
		$1.rowmult = 2; /*14383*/
		$1.encoding = "auto"; /*14384*/
		$1.cca = false; /*14385*/
		$1.ccb = false; /*14386*/
		$1.raw = false; /*14387*/
		$1.parse = false; /*14388*/
		$forall($1.options, function() { /*14399*/
			var _3 = $k[--$j]; /*14399*/
			$1[$k[--$j]] = _3; /*14399*/
		}); /*14399*/
		if ($ne($1.version, "unset")) { /*14405*/
			$search($1.version, "x"); /*14402*/
			$j--; /*14403*/
			$1.columns = $k[--$j]; /*14403*/
			$j--; /*14404*/
			$1.rows = $k[--$j]; /*14404*/
		} /*14404*/
		$1.columns = ~~$z($1.columns); /*14407*/
		$1.rows = ~~$z($1.rows); /*14408*/
		$1.rowmult = +$1.rowmult; /*14409*/
		if ($1.raw) { /*14432*/
			$1.encoding = "raw"; /*14432*/
		} /*14432*/
		if ($1.cca) { /*14433*/
			$1.encoding = "cca"; /*14433*/
		} /*14433*/
		if ($eq($1.encoding, "raw") || $eq($1.encoding, "cca")) { /*14447*/
			$1.datcws = $a($1.barcode.length); /*14437*/
			$1.i = 0; /*14438*/
			$1.j = 0; /*14438*/
			for (;;) { /*14445*/
				if ($1.i == $1.barcode.length) { /*14440*/
					break; /*14440*/
				} /*14440*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*14441*/
				$put($1.datcws, $1.j, $1.cw); /*14442*/
				$1.i = $1.i + 4; /*14443*/
				$1.j = $1.j + 1; /*14444*/
			} /*14444*/
			$1.datcws = $geti($1.datcws, 0, $1.j); /*14446*/
		} /*14446*/
		$k[$j++] = Infinity; /*14449*/
		$forall($1.barcode); /*14449*/
		$1.barcode = $a(); /*14449*/
		$1.barlen = $1.barcode.length; /*14450*/
		if ($1.ccb) { /*14452*/
			$1.encoding = "ccb"; /*14452*/
		} /*14452*/
		$1.encb = function() {
			$1.in = $k[--$j]; /*14455*/
			$1.inlen = $1.in.length; /*14456*/
			$1.out = $a(((~~($1.inlen / 6)) * 5) + ($1.inlen % 6)); /*14457*/
			for (var _g = 0, _f = (~~($1.inlen / 6)) - 1; _g <= _f; _g += 1) { /*14480*/
				$1.k = _g; /*14459*/
				$k[$j++] = Infinity; /*14460*/
				$aload($geti($1.in, $1.k * 6, 3)); /*14460*/
				$1.msbs = $a(); /*14460*/
				$k[$j++] = Infinity; /*14464*/
				$aload($1.msbs); /*14462*/
				var _m = $k[--$j]; /*14462*/
				var _n = $k[--$j]; /*14462*/
				var _o = $k[--$j]; /*14462*/
				$k[$j++] = (_m + (_n * 256)) + (_o * 65536); /*14463*/
				for (var _p = 0, _q = 3; _p < _q; _p++) { /*14463*/
					var _r = $k[--$j]; /*14463*/
					$k[$j++] = _r % 900; /*14463*/
					$k[$j++] = ~~(_r / 900); /*14463*/
				} /*14463*/
				$1.mscs = $a(); /*14464*/
				$k[$j++] = Infinity; /*14465*/
				$aload($geti($1.in, ($1.k * 6) + 3, 3)); /*14465*/
				$1.lsbs = $a(); /*14465*/
				$k[$j++] = Infinity; /*14469*/
				$aload($1.lsbs); /*14467*/
				var _y = $k[--$j]; /*14467*/
				var _z = $k[--$j]; /*14467*/
				var _10 = $k[--$j]; /*14467*/
				$k[$j++] = (_y + (_z * 256)) + (_10 * 65536); /*14468*/
				for (var _11 = 0, _12 = 3; _11 < _12; _11++) { /*14468*/
					var _13 = $k[--$j]; /*14468*/
					$k[$j++] = _13 % 900; /*14468*/
					$k[$j++] = ~~(_13 / 900); /*14468*/
				} /*14468*/
				$1.lscs = $a(); /*14469*/
				var _16 = $get($1.lscs, 0); /*14470*/
				var _18 = $get($1.mscs, 0); /*14470*/
				$put($1.out, ($1.k * 5) + 4, (_16 + (_18 * 316)) % 900); /*14471*/
				var _1C = $get($1.lscs, 1); /*14472*/
				var _1E = $get($1.mscs, 0); /*14472*/
				var _1G = $get($1.mscs, 1); /*14472*/
				$put($1.out, ($1.k * 5) + 3, ((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) % 900); /*14473*/
				var _1K = $get($1.lscs, 2); /*14474*/
				var _1M = $get($1.mscs, 0); /*14474*/
				var _1O = $get($1.mscs, 1); /*14474*/
				var _1Q = $get($1.mscs, 2); /*14474*/
				$put($1.out, ($1.k * 5) + 2, (((((~~(((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) / 900)) + _1K) + (_1M * 20)) + (_1O * 641)) + (_1Q * 316)) % 900); /*14475*/
				var _1U = $get($1.lscs, 3); /*14476*/
				var _1W = $get($1.mscs, 1); /*14476*/
				var _1Y = $get($1.mscs, 2); /*14476*/
				$put($1.out, ($1.k * 5) + 1, ((((~~((((((~~(((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) / 900)) + _1K) + (_1M * 20)) + (_1O * 641)) + (_1Q * 316)) / 900)) + _1U) + (_1W * 20)) + (_1Y * 641)) % 900); /*14477*/
				$put($1.out, $1.k * 5, ((~~(((((~~((((((~~(((((~~((_16 + (_18 * 316)) / 900)) + _1C) + (_1E * 641)) + (_1G * 316)) / 900)) + _1K) + (_1M * 20)) + (_1O * 641)) + (_1Q * 316)) / 900)) + _1U) + (_1W * 20)) + (_1Y * 641)) / 900)) + ($get($1.mscs, 2) * 20)) % 900); /*14479*/
			} /*14479*/
			$1.rem = $1.inlen % 6; /*14481*/
			if ($1.rem != 0) { /*14486*/
				$k[$j++] = $1.out; /*14484*/
				$k[$j++] = $1.out.length - $1.rem; /*14484*/
				$k[$j++] = Infinity; /*14484*/
				$aload($geti($1.in, $1.inlen - $1.rem, $1.rem)); /*14484*/
				var _1p = $a(); /*14484*/
				var _1q = $k[--$j]; /*14485*/
				$puti($k[--$j], _1q, _1p); /*14485*/
			} /*14485*/
			$k[$j++] = $1.out; /*14487*/
		}; /*14488*/
		if ($eq($1.encoding, "byte") || $eq($1.encoding, "ccb")) { /*14495*/
			$1.datcws = $a((((~~($1.barlen / 6)) * 5) + ($1.barlen % 6)) + 1); /*14491*/
			var _20 = (($1.barlen % 6) == 0) ? 924 : 901; /*14492*/
			$put($1.datcws, 0, _20); /*14492*/
			$k[$j++] = $1.datcws; /*14493*/
			$k[$j++] = 1; /*14493*/
			$k[$j++] = $1.barcode; /*14493*/
			if ($1.encb() == $b) return $b; /*14493*/
			var _23 = $k[--$j]; /*14493*/
			var _24 = $k[--$j]; /*14493*/
			$puti($k[--$j], _24, _23); /*14493*/
			if ($eq($1.encoding, "ccb")) { /*14494*/
				$k[$j++] = Infinity; /*14494*/
				$k[$j++] = 920; /*14494*/
				$aload($1.datcws); /*14494*/
				$1.datcws = $a(); /*14494*/
			} /*14494*/
		} /*14494*/
		if ($eq($1.encoding, "auto")) { /*14859*/
			$1.T = 0; /*14500*/
			$1.N = 1; /*14500*/
			$1.B = 2; /*14500*/
			$1.A = 0; /*14501*/
			$1.L = 1; /*14501*/
			$1.M = 2; /*14501*/
			$1.P = 3; /*14501*/
			$1.tl = -1; /*14504*/
			$1.nl = -2; /*14504*/
			$1.bl = -3; /*14504*/
			$1.bl6 = -4; /*14504*/
			$1.bs = -5; /*14504*/
			$1.al = -6; /*14507*/
			$1.ll = -7; /*14507*/
			$1.ml = -8; /*14507*/
			$1.pl = -9; /*14507*/
			$1.as = -10; /*14507*/
			$1.ps = -11; /*14507*/
			$1.charmaps = $a([$a(["A", "a", "0", ";"]), $a(["B", "b", "1", "<"]), $a(["C", "c", "2", ">"]), $a(["D", "d", "3", "@"]), $a(["E", "e", "4", "["]), $a(["F", "f", "5", 92]), $a(["G", "g", "6", "]"]), $a(["H", "h", "7", "_"]), $a(["I", "i", "8", "`"]), $a(["J", "j", "9", "~"]), $a(["K", "k", "&", "!"]), $a(["L", "l", 13, 13]), $a(["M", "m", 9, 9]), $a(["N", "n", ",", ","]), $a(["O", "o", ":", ":"]), $a(["P", "p", "#", 10]), $a(["Q", "q", "-", "-"]), $a(["R", "r", ".", "."]), $a(["S", "s", "$", "$"]), $a(["T", "t", "/", "/"]), $a(["U", "u", "+", "\""]), $a(["V", "v", "%", "|"]), $a(["W", "w", "*", "*"]), $a(["X", "x", "=", 40]), $a(["Y", "y", "^", 41]), $a(["Z", "z", $1.pl, "?"]), $a([" ", " ", " ", "{"]), $a([$1.ll, $1.as, $1.ll, "}"]), $a([$1.ml, $1.ml, $1.al, "'"]), $a([$1.ps, $1.ps, $1.ps, $1.al])]); /*14542*/
			$1.charvals = $a([{}, {}, {}, {}]); /*14545*/
			$1.alltext = {}; /*14546*/
			for (var _2t = 0, _2s = $1.charmaps.length - 1; _2t <= _2s; _2t += 1) { /*14556*/
				$1.i = _2t; /*14548*/
				$1.encs = $get($1.charmaps, $1.i); /*14549*/
				for (var _2x = 0; _2x <= 3; _2x += 1) { /*14555*/
					$1.j = _2x; /*14551*/
					var _30 = $get($1.encs, $1.j); /*14552*/
					$k[$j++] = _30; /*14552*/
					if ($eq($type(_30), "stringtype")) { /*14552*/
						var _33 = $get($k[--$j], 0); /*14552*/
						$k[$j++] = _33; /*14552*/
					} /*14552*/
					var _34 = $k[--$j]; /*14553*/
					$put($get($1.charvals, $1.j), _34, $1.i); /*14553*/
					$put($1.alltext, _34, -1); /*14554*/
				} /*14554*/
			} /*14554*/
			$1.e = 10000; /*14558*/
			$1.latlen = $a([$a([0, 1, 1, 2]), $a([2, 0, 1, 2]), $a([1, 1, 0, 1]), $a([1, 2, 2, 0])]); /*14566*/
			$1.latseq = $a([$a([$a([]), $a([$1.ll]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.ml, $1.al]), $a([]), $a([$1.ml]), $a([$1.ml, $1.pl])]), $a([$a([$1.al]), $a([$1.ll]), $a([]), $a([$1.pl])]), $a([$a([$1.al]), $a([$1.al, $1.ll]), $a([$1.al, $1.ml]), $a([])])]); /*14574*/
			$1.shftlen = $a([$a([$1.e, $1.e, $1.e, 1]), $a([1, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, 1]), $a([$1.e, $1.e, $1.e, $1.e])]); /*14582*/
			$k[$j++] = Infinity; /*14585*/
			for (var _49 = 0, _4A = $1.barlen; _49 < _4A; _49++) { /*14585*/
				$k[$j++] = 0; /*14585*/
			} /*14585*/
			$k[$j++] = 0; /*14585*/
			$1.numdigits = $a(); /*14585*/
			$k[$j++] = Infinity; /*14586*/
			for (var _4D = 0, _4E = $1.barlen; _4D < _4E; _4D++) { /*14586*/
				$k[$j++] = 0; /*14586*/
			} /*14586*/
			$k[$j++] = 0; /*14586*/
			$1.numtext = $a(); /*14586*/
			$k[$j++] = Infinity; /*14587*/
			for (var _4H = 0, _4I = $1.barlen; _4H < _4I; _4H++) { /*14587*/
				$k[$j++] = 0; /*14587*/
			} /*14587*/
			$k[$j++] = 0; /*14587*/
			$1.numbytes = $a(); /*14587*/
			for (var _4L = $1.barlen - 1; _4L >= 0; _4L -= 1) { /*14599*/
				$1.i = _4L; /*14589*/
				var _4O = $get($1.barcode, $1.i); /*14590*/
				if ((_4O >= 48) && (_4O <= 57)) { /*14592*/
					$put($1.numdigits, $1.i, $get($1.numdigits, $1.i + 1) + 1); /*14591*/
				} /*14591*/
				var _4Y = $get($1.alltext, $get($1.barcode, $1.i)) !== undefined; /*14593*/
				if (_4Y && ($get($1.numdigits, $1.i) < 13)) { /*14595*/
					$put($1.numtext, $1.i, $get($1.numtext, $1.i + 1) + 1); /*14594*/
				} /*14594*/
				if (($get($1.numtext, $1.i) < 5) && ($get($1.numdigits, $1.i) < 13)) { /*14598*/
					$put($1.numbytes, $1.i, $get($1.numbytes, $1.i + 1) + 1); /*14597*/
				} /*14597*/
			} /*14597*/
			$1.numdigits = $geti($1.numdigits, 0, $1.barlen); /*14600*/
			$1.numtext = $geti($1.numtext, 0, $1.barlen); /*14601*/
			$1.numbytes = $geti($1.numbytes, 0, $1.barlen); /*14602*/
			$1.seq = $a([]); /*14604*/
			$1.seqlen = 0; /*14604*/
			$1.state = $1.B; /*14604*/
			$1.p = 0; /*14604*/
			for (;;) { /*14647*/
				if ($1.p == $1.barlen) { /*14605*/
					break; /*14605*/
				} /*14605*/
				$1.n = $get($1.numdigits, $1.p); /*14606*/
				if ($1.n >= 13) { /*14645*/
					$k[$j++] = Infinity; /*14612*/
					$aload($1.seq); /*14609*/
					$k[$j++] = $1.nl; /*14611*/
					$k[$j++] = Infinity; /*14611*/
					$aload($geti($1.barcode, $1.p, $1.n)); /*14611*/
					var _5F = $a(); /*14611*/
					$k[$j++] = _5F; /*14611*/
					$1.seq = $a(); /*14612*/
					$1.state = $1.N; /*14613*/
					$1.p = $1.p + $1.n; /*14614*/
					$1.seqlen = ($1.seqlen + 1) + $1.n; /*14615*/
				} else { /*14645*/
					$1.t = $get($1.numtext, $1.p); /*14617*/
					if ($1.t >= 5) { /*14645*/
						$k[$j++] = Infinity; /*14623*/
						$aload($1.seq); /*14620*/
						if ($1.state != $1.T) { /*14621*/
							$k[$j++] = $1.tl; /*14621*/
						} /*14621*/
						$k[$j++] = Infinity; /*14622*/
						$aload($geti($1.barcode, $1.p, $1.t)); /*14622*/
						var _5Y = $a(); /*14622*/
						$k[$j++] = _5Y; /*14622*/
						$1.seq = $a(); /*14623*/
						$1.state = $1.T; /*14624*/
						$1.p = $1.p + $1.t; /*14625*/
						$1.seqlen = ($1.seqlen + 1) + $1.t; /*14626*/
					} else { /*14645*/
						$1.b = $get($1.numbytes, $1.p); /*14628*/
						if (($1.b == 1) && ($1.state == $1.T)) { /*14645*/
							$k[$j++] = Infinity; /*14634*/
							$aload($1.seq); /*14631*/
							$k[$j++] = $1.bs; /*14633*/
							$k[$j++] = $a([$get($1.barcode, $1.p)]); /*14633*/
							$1.seq = $a(); /*14634*/
							$1.p = $1.p + $1.b; /*14635*/
							$1.seqlen = $1.seqlen + 2; /*14636*/
						} else { /*14645*/
							$k[$j++] = Infinity; /*14642*/
							$aload($1.seq); /*14639*/
							var _5x = (($1.b % 6) != 0) ? $1.bl : $1.bl6; /*14640*/
							$k[$j++] = _5x; /*14641*/
							$k[$j++] = Infinity; /*14641*/
							$aload($geti($1.barcode, $1.p, $1.b)); /*14641*/
							var _62 = $a(); /*14641*/
							$k[$j++] = _62; /*14641*/
							$1.seq = $a(); /*14642*/
							$1.state = $1.B; /*14643*/
							$1.p = $1.p + $1.b; /*14644*/
							$1.seqlen = ($1.seqlen + 1) + $1.b; /*14645*/
						} /*14645*/
					} /*14645*/
				} /*14645*/
			} /*14645*/
			$k[$j++] = "latchcws"; /*14650*/
			$k[$j++] = Infinity; /*14650*/
			$k[$j++] = $1.tl; /*14650*/
			$k[$j++] = 900; /*14650*/
			$k[$j++] = $1.bl; /*14650*/
			$k[$j++] = 901; /*14650*/
			$k[$j++] = $1.bl6; /*14650*/
			$k[$j++] = 924; /*14650*/
			$k[$j++] = $1.nl; /*14650*/
			$k[$j++] = 902; /*14650*/
			$k[$j++] = $1.bs; /*14650*/
			$k[$j++] = 913; /*14650*/
			var _6E = $d(); /*14650*/
			$1[$k[--$j]] = _6E; /*14651*/
			$1.enca = function() {
				var _6K = $get($get($1.charvals, $1.A), $k[--$j]); /*14654*/
				$k[$j++] = _6K; /*14654*/
			}; /*14654*/
			$1.encl = function() {
				var _6P = $get($get($1.charvals, $1.L), $k[--$j]); /*14655*/
				$k[$j++] = _6P; /*14655*/
			}; /*14655*/
			$1.encm = function() {
				var _6U = $get($get($1.charvals, $1.M), $k[--$j]); /*14656*/
				$k[$j++] = _6U; /*14656*/
			}; /*14656*/
			$1.encp = function() {
				var _6Z = $get($get($1.charvals, $1.P), $k[--$j]); /*14657*/
				$k[$j++] = _6Z; /*14657*/
			}; /*14657*/
			$1.textencfuncs = $a(["enca", "encl", "encm", "encp"]); /*14658*/
			$1.addtotext = function() {
				$put($1.text, $1.l, $k[--$j]); /*14661*/
				$1.l = $1.l + 1; /*14662*/
			}; /*14663*/
			$1.enct = function() {
				$1.in = $k[--$j]; /*14667*/
				$1.curlen = $a([$1.e, $1.e, $1.e, $1.e]); /*14669*/
				$put($1.curlen, $1.submode, 0); /*14670*/
				$1.curseq = $a([$a([]), $a([]), $a([]), $a([])]); /*14671*/
				$forall($1.in, function() { /*14741*/
					$1.char = $k[--$j]; /*14676*/
					for (;;) { /*14697*/
						$1.imp = false; /*14680*/
						var _6y = $a([$1.A, $1.L, $1.M, $1.P]); /*14681*/
						for (var _6z = 0, _70 = _6y.length; _6z < _70; _6z++) { /*14695*/
							$1.x = $get(_6y, _6z); /*14682*/
							var _76 = $a([$1.A, $1.L, $1.M, $1.P]); /*14683*/
							for (var _77 = 0, _78 = _76.length; _77 < _78; _77++) { /*14694*/
								$1.y = $get(_76, _77); /*14684*/
								$1.cost = $get($1.curlen, $1.x) + $get($get($1.latlen, $1.x), $1.y); /*14685*/
								if ($1.cost < $get($1.curlen, $1.y)) { /*14693*/
									$put($1.curlen, $1.y, $1.cost); /*14687*/
									$k[$j++] = $1.curseq; /*14690*/
									$k[$j++] = $1.y; /*14690*/
									$k[$j++] = Infinity; /*14690*/
									$aload($get($1.curseq, $1.x)); /*14689*/
									$aload($get($get($1.latseq, $1.x), $1.y)); /*14690*/
									var _7Z = $a(); /*14690*/
									var _7a = $k[--$j]; /*14691*/
									$put($k[--$j], _7a, _7Z); /*14691*/
									$1.imp = true; /*14692*/
								} /*14692*/
							} /*14692*/
						} /*14692*/
						if (!$1.imp) { /*14696*/
							break; /*14696*/
						} /*14696*/
					} /*14696*/
					$1.nxtlen = $a([$1.e, $1.e, $1.e, $1.e]); /*14700*/
					$1.nxtseq = $a(4); /*14701*/
					var _7n = $a([$1.A, $1.L, $1.M, $1.P]); /*14703*/
					for (var _7o = 0, _7p = _7n.length; _7o < _7p; _7o++) { /*14736*/
						$1.x = $get(_7n, _7o); /*14704*/
						for (;;) { /*14734*/
							var _7v = $get($get($1.charvals, $1.x), $1.char) !== undefined; /*14708*/
							if (!_7v) { /*14708*/
								break; /*14708*/
							} /*14708*/
							$1.cost = $get($1.curlen, $1.x) + 1; /*14711*/
							if ($1.cost < $get($1.nxtlen, $1.x)) { /*14715*/
								$put($1.nxtlen, $1.x, $1.cost); /*14713*/
								$k[$j++] = $1.nxtseq; /*14714*/
								$k[$j++] = $1.x; /*14714*/
								$k[$j++] = Infinity; /*14714*/
								$aload($get($1.curseq, $1.x)); /*14714*/
								$k[$j++] = $1.char; /*14714*/
								var _8C = $a(); /*14714*/
								var _8D = $k[--$j]; /*14714*/
								$put($k[--$j], _8D, _8C); /*14714*/
							} /*14714*/
							var _8J = $a([$1.A, $1.L, $1.M, $1.P]); /*14718*/
							for (var _8K = 0, _8L = _8J.length; _8K < _8L; _8K++) { /*14731*/
								$1.y = $get(_8J, _8K); /*14719*/
								if ($ne($1.x, $1.y)) { /*14730*/
									$1.cost = ($get($1.curlen, $1.y) + $get($get($1.shftlen, $1.y), $1.x)) + 1; /*14721*/
									if ($1.cost < $get($1.nxtlen, $1.y)) { /*14729*/
										$put($1.nxtlen, $1.y, $1.cost); /*14723*/
										$k[$j++] = $1.nxtseq; /*14727*/
										$k[$j++] = $1.y; /*14727*/
										$k[$j++] = Infinity; /*14727*/
										$aload($get($1.curseq, $1.y)); /*14725*/
										var _8l = ($1.x == $1.A) ? $1.as : $1.ps; /*14726*/
										$k[$j++] = _8l; /*14727*/
										$k[$j++] = $1.char; /*14727*/
										var _8n = $a(); /*14727*/
										var _8o = $k[--$j]; /*14728*/
										$put($k[--$j], _8o, _8n); /*14728*/
									} /*14728*/
								} /*14728*/
							} /*14728*/
							break; /*14733*/
						} /*14733*/
					} /*14733*/
					$1.curlen = $1.nxtlen; /*14738*/
					$1.curseq = $1.nxtseq; /*14739*/
				}); /*14739*/
				$1.minseq = $1.e; /*14744*/
				var _8x = $a([$1.A, $1.L, $1.M, $1.P]); /*14745*/
				for (var _8y = 0, _8z = _8x.length; _8y < _8z; _8y++) { /*14751*/
					$1.k = $get(_8x, _8y); /*14746*/
					if ($get($1.curlen, $1.k) < $1.minseq) { /*14750*/
						$1.minseq = $get($1.curlen, $1.k); /*14748*/
						$1.txtseq = $get($1.curseq, $1.k); /*14749*/
					} /*14749*/
				} /*14749*/
				$1.text = $a($1.minseq); /*14754*/
				$1.k = 0; /*14755*/
				$1.l = 0; /*14755*/
				for (;;) { /*14775*/
					if ($1.k >= $1.txtseq.length) { /*14756*/
						break; /*14756*/
					} /*14756*/
					$1.char = $get($1.txtseq, $1.k); /*14758*/
					$k[$j++] = $1.char; /*14761*/
					$1[$get($1.textencfuncs, $1.submode)](); /*14761*/
					if ($1.addtotext() == $b) break; /*14761*/
					$1.k = $1.k + 1; /*14762*/
					if (($1.char == $1.as) || ($1.char == $1.ps)) { /*14768*/
						$k[$j++] = $get($1.txtseq, $1.k); /*14766*/
						if ($1.char == $1.as) { /*14766*/
							if ($1.enca() == $b) break; /*14766*/
						} else { /*14766*/
							if ($1.encp() == $b) break; /*14766*/
						} /*14766*/
						if ($1.addtotext() == $b) break; /*14766*/
						$1.k = $1.k + 1; /*14767*/
					} /*14767*/
					if ($1.char == $1.al) { /*14771*/
						$1.submode = $1.A; /*14771*/
					} /*14771*/
					if ($1.char == $1.ll) { /*14772*/
						$1.submode = $1.L; /*14772*/
					} /*14772*/
					if ($1.char == $1.ml) { /*14773*/
						$1.submode = $1.M; /*14773*/
					} /*14773*/
					if ($1.char == $1.pl) { /*14774*/
						$1.submode = $1.P; /*14774*/
					} /*14774*/
				} /*14774*/
				if (($1.text.length % 2) == 1) { /*14785*/
					if ($1.submode == $1.P) { /*14782*/
						$k[$j++] = "pad"; /*14779*/
						$k[$j++] = $1.al; /*14779*/
						if ($1.encp() == $b) return $b; /*14779*/
						var _9o = $k[--$j]; /*14779*/
						$1[$k[--$j]] = _9o; /*14779*/
						$1.submode = $1.A; /*14780*/
					} else { /*14782*/
						$k[$j++] = "pad"; /*14782*/
						$k[$j++] = $1.ps; /*14782*/
						$1[$get($1.textencfuncs, $1.submode)](); /*14782*/
						var _9w = $k[--$j]; /*14782*/
						$1[$k[--$j]] = _9w; /*14782*/
					} /*14782*/
					$k[$j++] = Infinity; /*14784*/
					$aload($1.text); /*14784*/
					$k[$j++] = $1.pad; /*14784*/
					$1.text = $a(); /*14784*/
				} /*14784*/
				$1.out = $a(~~($1.text.length / 2)); /*14787*/
				for (var _A5 = 0, _A4 = $1.out.length - 1; _A5 <= _A4; _A5 += 1) { /*14791*/
					$1.k = _A5; /*14789*/
					$put($1.out, $1.k, ($get($1.text, $1.k * 2) * 30) + $get($1.text, ($1.k * 2) + 1)); /*14790*/
				} /*14790*/
				$k[$j++] = $1.out; /*14793*/
			}; /*14795*/
			$1.encn = function() {
				$1.in = $k[--$j]; /*14798*/
				$1.out = $a([]); /*14799*/
				for (var _AJ = 0, _AI = $1.in.length - 1; _AJ <= _AI; _AJ += 44) { /*14827*/
					$1.k = _AJ; /*14801*/
					$k[$j++] = Infinity; /*14805*/
					var _AO = $1.in.length - $1.k; /*14803*/
					$k[$j++] = 1; /*14803*/
					$k[$j++] = $1.in; /*14803*/
					$k[$j++] = $1.k; /*14803*/
					$k[$j++] = _AO; /*14803*/
					if (_AO > 44) { /*14803*/
						$j--; /*14803*/
						$k[$j++] = 44; /*14803*/
					} /*14803*/
					var _AP = $k[--$j]; /*14803*/
					var _AQ = $k[--$j]; /*14803*/
					$forall($geti($k[--$j], _AQ, _AP), function() { /*14804*/
						var _AT = $k[--$j]; /*14804*/
						$k[$j++] = _AT - 48; /*14804*/
					}); /*14804*/
					$1.gmod = $a(); /*14805*/
					$1.cwn = $a([]); /*14806*/
					for (;;) { /*14825*/
						$1.dv = 900; /*14807*/
						$1.gmul = $a([]); /*14808*/
						$1.val = 0; /*14808*/
						for (;;) { /*14820*/
							if ($1.gmod.length == 0) { /*14809*/
								break; /*14809*/
							} /*14809*/
							$1.val = ($1.val * 10) + $get($1.gmod, 0); /*14810*/
							$1.gmod = $geti($1.gmod, 1, $1.gmod.length - 1); /*14811*/
							if ($1.val < $1.dv) { /*14817*/
								if ($1.gmul.length != 0) { /*14815*/
									$k[$j++] = Infinity; /*14814*/
									$aload($1.gmul); /*14814*/
									$k[$j++] = 0; /*14814*/
									$1.gmul = $a(); /*14814*/
								} /*14814*/
							} else { /*14817*/
								$k[$j++] = Infinity; /*14817*/
								$aload($1.gmul); /*14817*/
								$k[$j++] = ~~($1.val / $1.dv); /*14817*/
								$1.gmul = $a(); /*14817*/
							} /*14817*/
							$1.val = $1.val % $1.dv; /*14819*/
						} /*14819*/
						$1.dv = $1.val; /*14821*/
						$k[$j++] = Infinity; /*14822*/
						$k[$j++] = $1.dv; /*14822*/
						$aload($1.cwn); /*14822*/
						$1.cwn = $a(); /*14822*/
						$1.gmod = $1.gmul; /*14823*/
						if ($1.gmul.length == 0) { /*14824*/
							break; /*14824*/
						} /*14824*/
					} /*14824*/
					$k[$j++] = Infinity; /*14826*/
					$aload($1.out); /*14826*/
					$aload($1.cwn); /*14826*/
					$1.out = $a(); /*14826*/
				} /*14826*/
				$k[$j++] = $1.out; /*14828*/
			}; /*14829*/
			$1.encfuncs = $a(["enct", "encn", "encb"]); /*14831*/
			$1.addtocws = function() {
				var _B0 = $k[--$j]; /*14834*/
				$puti($1.datcws, $1.j, _B0); /*14834*/
				$1.j = _B0.length + $1.j; /*14835*/
			}; /*14836*/
			$1.state = $1.T; /*14839*/
			$1.submode = $1.A; /*14839*/
			$1.datcws = $a($1.seqlen); /*14840*/
			$1.i = 0; /*14841*/
			$1.j = 0; /*14841*/
			for (;;) { /*14857*/
				if ($1.i >= $1.seq.length) { /*14842*/
					break; /*14842*/
				} /*14842*/
				$1.chars = $get($1.seq, $1.i); /*14843*/
				if ($eq($type($1.chars), "arraytype")) { /*14853*/
					$k[$j++] = $1.chars; /*14845*/
					$1[$get($1.encfuncs, $1.state)](); /*14845*/
					if ($1.addtocws() == $b) break; /*14845*/
				} else { /*14853*/
					$k[$j++] = $a([$get($1.latchcws, $1.chars)]); /*14847*/
					if ($1.addtocws() == $b) break; /*14847*/
					if ($1.chars == $1.tl) { /*14848*/
						$1.state = $1.T; /*14848*/
						$1.submode = $1.A; /*14848*/
					} /*14848*/
					if ($1.chars == $1.nl) { /*14849*/
						$1.state = $1.N; /*14849*/
					} /*14849*/
					if (($1.chars == $1.bl) || ($1.chars == $1.bl6)) { /*14850*/
						$1.state = $1.B; /*14850*/
					} /*14850*/
					if ($1.chars == $1.bs) { /*14854*/
						$1.i = $1.i + 1; /*14852*/
						$k[$j++] = $get($1.seq, $1.i); /*14853*/
						if ($1.encb() == $b) break; /*14853*/
						if ($1.addtocws() == $b) break; /*14853*/
					} /*14853*/
				} /*14853*/
				$1.i = $1.i + 1; /*14856*/
			} /*14856*/
			$1.datcws = $geti($1.datcws, 0, $1.j); /*14858*/
		} /*14858*/
		$1.metrics = $a([$a([1, 11, 7, 1, 0, 9]), $a([1, 14, 7, 8, 0, 8]), $a([1, 17, 7, 36, 0, 36]), $a([1, 20, 8, 19, 0, 19]), $a([1, 24, 8, 9, 0, 17]), $a([1, 28, 8, 25, 0, 33]), $a([2, 8, 8, 1, 0, 1]), $a([2, 11, 9, 1, 0, 9]), $a([2, 14, 9, 8, 0, 8]), $a([2, 17, 10, 36, 0, 36]), $a([2, 20, 11, 19, 0, 19]), $a([2, 23, 13, 9, 0, 17]), $a([2, 26, 15, 27, 0, 35]), $a([3, 6, 12, 1, 1, 1]), $a([3, 8, 14, 7, 7, 7]), $a([3, 10, 16, 15, 15, 15]), $a([3, 12, 18, 25, 25, 25]), $a([3, 15, 21, 37, 37, 37]), $a([3, 20, 26, 1, 17, 33]), $a([3, 26, 32, 1, 9, 17]), $a([3, 32, 38, 21, 29, 37]), $a([3, 38, 44, 15, 31, 47]), $a([3, 44, 50, 1, 25, 49]), $a([4, 4, 8, 47, 19, 43]), $a([4, 6, 12, 1, 1, 1]), $a([4, 8, 14, 7, 7, 7]), $a([4, 10, 16, 15, 15, 15]), $a([4, 12, 18, 25, 25, 25]), $a([4, 15, 21, 37, 37, 37]), $a([4, 20, 26, 1, 17, 33]), $a([4, 26, 32, 1, 9, 17]), $a([4, 32, 38, 21, 29, 37]), $a([4, 38, 44, 15, 31, 47]), $a([4, 44, 50, 1, 25, 49])]); /*14898*/
		$1.ccametrics = $a([$a([2, 5, 4, 39, 0, 19]), $a([2, 6, 4, 1, 0, 33]), $a([2, 7, 5, 32, 0, 12]), $a([2, 8, 5, 8, 0, 40]), $a([2, 9, 6, 14, 0, 46]), $a([2, 10, 6, 43, 0, 23]), $a([2, 12, 7, 20, 0, 52]), $a([3, 4, 4, 11, 43, 23]), $a([3, 5, 5, 1, 33, 13]), $a([3, 6, 6, 5, 37, 17]), $a([3, 7, 7, 15, 47, 27]), $a([3, 8, 7, 21, 1, 33]), $a([4, 3, 4, 40, 20, 52]), $a([4, 4, 5, 43, 23, 3]), $a([4, 5, 6, 46, 26, 6]), $a([4, 6, 7, 34, 14, 46]), $a([4, 7, 8, 29, 9, 41])]); /*14920*/
		if ($1.cca) { /*14921*/
			$1.metrics = $1.ccametrics; /*14921*/
		} /*14921*/
		$1.urows = $1.rows; /*14924*/
		$1.ucols = $1.columns; /*14925*/
		$1.i = 0; /*14926*/
		for (;;) { /*14942*/
			$1.m = $get($1.metrics, $1.i); /*14928*/
			$1.c = $get($1.m, 0); /*14929*/
			$1.r = $get($1.m, 1); /*14930*/
			$1.k = $get($1.m, 2); /*14931*/
			$1.rapl = $get($1.m, 3); /*14932*/
			$1.rapc = $get($1.m, 4); /*14933*/
			$1.rapr = $get($1.m, 5); /*14934*/
			$1.ncws = ($1.r * $1.c) - $1.k; /*14935*/
			$1.okay = true; /*14936*/
			if ($1.datcws.length > $1.ncws) { /*14937*/
				$1.okay = false; /*14937*/
			} /*14937*/
			if (($1.urows != 0) && ($1.urows != $1.r)) { /*14938*/
				$1.okay = false; /*14938*/
			} /*14938*/
			if (($1.ucols != 0) && ($1.ucols != $1.c)) { /*14939*/
				$1.okay = false; /*14939*/
			} /*14939*/
			if ($1.okay) { /*14940*/
				break; /*14940*/
			} /*14940*/
			$1.i = $1.i + 1; /*14941*/
		} /*14941*/
		$1.m = $1.datcws.length; /*14943*/
		$1.n = ($1.c * $1.r) - $1.k; /*14946*/
		$1.cws = $a(($1.c * $1.r) + 1); /*14947*/
		$puti($1.cws, 0, $1.datcws); /*14948*/
		$k[$j++] = $1.cws; /*14949*/
		$k[$j++] = $1.m; /*14949*/
		$k[$j++] = Infinity; /*14949*/
		for (var _DK = 0, _DL = $1.n - $1.m; _DK < _DL; _DK++) { /*14949*/
			$k[$j++] = 900; /*14949*/
		} /*14949*/
		var _DM = $a(); /*14949*/
		var _DN = $k[--$j]; /*14949*/
		$puti($k[--$j], _DN, _DM); /*14949*/
		$k[$j++] = $1.cws; /*14950*/
		$k[$j++] = $1.n; /*14950*/
		$k[$j++] = Infinity; /*14950*/
		for (var _DS = 0, _DT = $1.k; _DS < _DT; _DS++) { /*14950*/
			$k[$j++] = 0; /*14950*/
		} /*14950*/
		$k[$j++] = 0; /*14950*/
		var _DU = $a(); /*14950*/
		var _DV = $k[--$j]; /*14950*/
		$puti($k[--$j], _DV, _DU); /*14950*/
		$k[$j++] = Infinity; /*14953*/
		$k[$j++] = 1; /*14953*/
		for (var _DX = 0, _DY = 928; _DX < _DY; _DX++) { /*14953*/
			var _DZ = $k[--$j]; /*14953*/
			$k[$j++] = _DZ; /*14953*/
			$k[$j++] = (_DZ * 3) % 929; /*14953*/
		} /*14953*/
		$1.rsalog = $a(); /*14953*/
		$1.rslog = $a(929); /*14954*/
		for (var _Dc = 1; _Dc <= 928; _Dc += 1) { /*14955*/
			$put($1.rslog, $get($1.rsalog, _Dc), _Dc); /*14955*/
		} /*14955*/
		$1.rsprod = function() {
			var _Dg = $k[--$j]; /*14959*/
			var _Dh = $k[--$j]; /*14959*/
			$k[$j++] = _Dh; /*14963*/
			$k[$j++] = _Dg; /*14963*/
			if ((_Dg != 0) && (_Dh != 0)) { /*14962*/
				var _Dk = $get($1.rslog, $k[--$j]); /*14960*/
				var _Dp = $get($1.rsalog, (_Dk + $get($1.rslog, $k[--$j])) % 928); /*14960*/
				$k[$j++] = _Dp; /*14960*/
			} else { /*14962*/
				$j -= 2; /*14962*/
				$k[$j++] = 0; /*14962*/
			} /*14962*/
		}; /*14964*/
		$k[$j++] = Infinity; /*14967*/
		$k[$j++] = 1; /*14967*/
		for (var _Dr = 0, _Ds = $1.k; _Dr < _Ds; _Dr++) { /*14967*/
			$k[$j++] = 0; /*14967*/
		} /*14967*/
		$1.coeffs = $a(); /*14967*/
		for (var _Dw = 1, _Dv = $1.k; _Dw <= _Dv; _Dw += 1) { /*14976*/
			$1.i = _Dw; /*14969*/
			$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*14970*/
			for (var _E3 = $1.i - 1; _E3 >= 1; _E3 -= 1) { /*14974*/
				$1.j = _E3; /*14972*/
				$k[$j++] = $1.coeffs; /*14973*/
				$k[$j++] = $1.j; /*14973*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*14973*/
				$k[$j++] = $get($1.coeffs, $1.j); /*14973*/
				$k[$j++] = $get($1.rsalog, $1.i); /*14973*/
				if ($1.rsprod() == $b) break; /*14973*/
				var _EF = $k[--$j]; /*14973*/
				var _EG = $k[--$j]; /*14973*/
				var _EH = $k[--$j]; /*14973*/
				$put($k[--$j], _EH, (_EG + _EF) % 929); /*14973*/
			} /*14973*/
			$k[$j++] = $1.coeffs; /*14975*/
			$k[$j++] = 0; /*14975*/
			$k[$j++] = $get($1.coeffs, 0); /*14975*/
			$k[$j++] = $get($1.rsalog, $1.i); /*14975*/
			if ($1.rsprod() == $b) break; /*14975*/
			var _EP = $k[--$j]; /*14975*/
			var _EQ = $k[--$j]; /*14975*/
			$put($k[--$j], _EQ, _EP); /*14975*/
		} /*14975*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*14977*/
		for (var _EW = $1.coeffs.length - 1; _EW >= 0; _EW -= 2) { /*14978*/
			var _EX = $1.coeffs; /*14978*/
			$put(_EX, _EW, 929 - $get(_EX, _EW)); /*14978*/
		} /*14978*/
		for (var _Eb = 0, _Ea = $1.n - 1; _Eb <= _Ea; _Eb += 1) { /*14987*/
			$1.t = ($get($1.cws, _Eb) + $get($1.cws, $1.n)) % 929; /*14982*/
			for (var _Ej = 0, _Ei = $1.k - 1; _Ej <= _Ei; _Ej += 1) { /*14986*/
				$1.j = _Ej; /*14984*/
				$put($1.cws, $1.n + $1.j, ($get($1.cws, ($1.n + $1.j) + 1) + (929 - (($1.t * $get($1.coeffs, ($1.k - $1.j) - 1)) % 929))) % 929); /*14985*/
			} /*14985*/
		} /*14985*/
		for (var _F0 = $1.n, _Ez = $1.n + $1.k; _F0 <= _Ez; _F0 += 1) { /*14988*/
			$put($1.cws, _F0, (929 - $get($1.cws, _F0)) % 929); /*14988*/
		} /*14988*/
		$1.cws = $geti($1.cws, 0, $1.cws.length - 1); /*14991*/
		$1.clusters = $a([$a([120256, 125680, 128380, 120032, 125560, 128318, 108736, 119920, 108640, 86080, 108592, 86048, 110016, 120560, 125820, 109792, 120440, 125758, 88256, 109680, 88160, 89536, 110320, 120700, 89312, 110200, 120638, 89200, 110140, 89840, 110460, 89720, 110398, 89980, 128506, 119520, 125304, 128190, 107712, 119408, 125244, 107616, 119352, 84032, 107568, 119324, 84000, 107544, 83984, 108256, 119672, 125374, 85184, 108144, 119612, 85088, 108088, 119582, 85040, 108060, 85728, 108408, 119742, 85616, 108348, 85560, 108318, 85880, 108478, 85820, 85790, 107200, 119152, 125116, 107104, 119096, 125086, 83008, 107056, 119068, 82976, 107032, 82960, 82952, 83648, 107376, 119228, 83552, 107320, 119198, 83504, 107292, 83480, 83468, 83824, 107452, 83768, 107422, 83740, 83900, 106848, 118968, 125022, 82496, 106800, 118940, 82464, 106776, 118926, 82448, 106764, 82440, 106758, 82784, 106936, 119006, 82736, 106908, 82712, 106894, 82700, 82694, 106974, 82830, 82240, 106672, 118876, 82208, 106648, 118862, 82192, 106636, 82184, 106630, 82180, 82352, 82328, 82316, 82080, 118830, 106572, 106566, 82050, 117472, 124280, 127678, 103616, 117360, 124220, 103520, 117304, 124190, 75840, 103472, 75808, 104160, 117624, 124350, 76992, 104048, 117564, 76896, 103992, 76848, 76824, 77536, 104312, 117694, 77424, 104252, 77368, 77340, 77688, 104382, 77628, 77758, 121536, 126320, 128700, 121440, 126264, 128670, 111680, 121392, 126236, 111648, 121368, 126222, 111632, 121356, 103104, 117104, 124092, 112320, 103008, 117048, 124062, 112224, 121656, 126366, 93248, 74784, 102936, 117006, 93216, 112152, 93200, 75456, 103280, 117180, 93888, 75360, 103224, 117150, 93792, 112440, 121758, 93744, 75288, 93720, 75632, 103356, 94064, 75576, 103326, 94008, 112542, 93980, 75708, 94140, 75678, 94110, 121184, 126136, 128606, 111168, 121136, 126108, 111136, 121112, 126094, 111120, 121100, 111112, 111108, 102752, 116920, 123998, 111456, 102704, 116892, 91712, 74272, 121244, 116878, 91680, 74256, 102668, 91664, 111372, 102662, 74244, 74592, 102840, 116958, 92000, 74544, 102812, 91952, 111516, 102798, 91928, 74508, 74502, 74680, 102878, 92088, 74652, 92060, 74638, 92046, 92126, 110912, 121008, 126044, 110880, 120984, 126030, 110864, 120972, 110856, 120966, 110852, 110850, 74048, 102576, 116828, 90944, 74016, 102552, 116814, 90912, 111000, 121038, 90896, 73992, 102534, 90888, 110982, 90884, 74160, 102620, 91056, 74136, 102606, 91032, 111054, 91020, 74118, 91014, 91100, 91086, 110752, 120920, 125998, 110736, 120908, 110728, 120902, 110724, 110722, 73888, 102488, 116782, 90528, 73872, 102476, 90512, 110796, 102470, 90504, 73860, 90500, 73858, 73944, 90584, 90572, 90566, 120876, 120870, 110658, 102444, 73800, 90312, 90308, 90306, 101056, 116080, 123580, 100960, 116024, 70720, 100912, 115996, 70688, 100888, 70672, 70664, 71360, 101232, 116156, 71264, 101176, 116126, 71216, 101148, 71192, 71180, 71536, 101308, 71480, 101278, 71452, 71612, 71582, 118112, 124600, 127838, 105024, 118064, 124572, 104992, 118040, 124558, 104976, 118028, 104968, 118022, 100704, 115896, 123486, 105312, 100656, 115868, 79424, 70176, 118172, 115854, 79392, 105240, 100620, 79376, 70152, 79368, 70496, 100792, 115934, 79712, 70448, 118238, 79664, 105372, 100750, 79640, 70412, 79628, 70584, 100830, 79800, 70556, 79772, 70542, 70622, 79838, 122176, 126640, 128860, 122144, 126616, 128846, 122128, 126604, 122120, 126598, 122116, 104768, 117936, 124508, 113472, 104736, 126684, 124494, 113440, 122264, 126670, 113424, 104712, 117894, 113416, 122246, 104706, 69952, 100528, 115804, 78656, 69920, 100504, 115790, 96064, 78624, 104856, 117966, 96032, 113560, 122318, 100486, 96016, 78600, 104838, 96008, 69890, 70064, 100572, 78768, 70040, 100558, 96176, 78744, 104910, 96152, 113614, 70022, 78726, 70108, 78812, 70094, 96220, 78798, 122016, 126552, 128814, 122000, 126540, 121992, 126534, 121988, 121986, 104608, 117848, 124462, 113056, 104592, 126574, 113040, 122060, 117830, 113032, 104580, 113028, 104578, 113026, 69792, 100440, 115758, 78240, 69776, 100428, 95136, 78224, 104652, 100422, 95120, 113100, 69764, 95112, 78212, 69762, 78210, 69848, 100462, 78296, 69836, 95192, 78284, 69830, 95180, 78278, 69870, 95214, 121936, 126508, 121928, 126502, 121924, 121922, 104528, 117804, 112848, 104520, 117798, 112840, 121958, 112836, 104514, 112834, 69712, 100396, 78032, 69704, 100390, 94672, 78024, 104550, 94664, 112870, 69698, 94660, 78018, 94658, 78060, 94700, 94694, 126486, 121890, 117782, 104484, 104482, 69672, 77928, 94440, 69666, 77922, 99680, 68160, 99632, 68128, 99608, 115342, 68112, 99596, 68104, 99590, 68448, 99768, 115422, 68400, 99740, 68376, 99726, 68364, 68358, 68536, 99806, 68508, 68494, 68574, 101696, 116400, 123740, 101664, 116376, 101648, 116364, 101640, 116358, 101636, 67904, 99504, 115292, 72512, 67872, 116444, 115278, 72480, 101784, 116430, 72464, 67848, 99462, 72456, 101766, 67842, 68016, 99548, 72624, 67992, 99534, 72600, 101838, 72588, 67974, 68060, 72668, 68046, 72654, 118432, 124760, 127918, 118416, 124748, 118408, 124742, 118404, 118402, 101536, 116312, 105888, 101520, 116300, 105872, 118476, 116294, 105864, 101508, 105860, 101506, 105858, 67744, 99416, 72096, 67728, 116334, 80800, 72080, 101580, 99398, 80784, 105932, 67716, 80776, 72068, 67714, 72066, 67800, 99438, 72152, 67788, 80856, 72140, 67782, 80844, 72134, 67822, 72174, 80878, 126800, 128940, 126792, 128934, 126788, 126786, 118352, 124716, 122576, 126828, 124710, 122568, 126822, 122564, 118338, 122562, 101456, 116268, 105680, 101448, 116262, 114128, 105672, 118374, 114120, 122598, 101442, 114116, 105666, 114114, 67664, 99372, 71888, 67656, 99366, 80336, 71880, 101478, 97232, 80328, 105702, 67650, 97224, 114150, 71874, 97220, 67692, 71916, 67686, 80364, 71910, 97260, 80358, 97254, 126760, 128918, 126756, 126754, 118312, 124694, 122472, 126774, 122468, 118306, 122466, 101416, 116246, 105576, 101412, 113896, 105572, 101410, 113892, 105570, 113890, 67624, 99350, 71784, 101430, 80104, 71780, 67618, 96744, 80100, 71778, 96740, 80098, 96738, 71798, 96758, 126738, 122420, 122418, 105524, 113780, 113778, 71732, 79988, 96500, 96498, 66880, 66848, 98968, 66832, 66824, 66820, 66992, 66968, 66956, 66950, 67036, 67022, 100000, 99984, 115532, 99976, 115526, 99972, 99970, 66720, 98904, 69024, 100056, 98892, 69008, 100044, 69000, 100038, 68996, 66690, 68994, 66776, 98926, 69080, 100078, 69068, 66758, 69062, 66798, 69102, 116560, 116552, 116548, 116546, 99920, 102096, 116588, 115494, 102088, 116582, 102084, 99906, 102082, 66640, 68816, 66632, 98854, 73168, 68808, 66628, 73160, 68804, 66626, 73156, 68802, 66668, 68844, 66662, 73196, 68838, 73190, 124840, 124836, 124834, 116520, 118632, 124854, 118628, 116514, 118626, 99880, 115478, 101992, 116534, 106216, 101988, 99874, 106212, 101986, 106210, 66600, 98838, 68712, 99894, 72936, 68708, 66594, 81384, 72932, 68706, 81380, 72930, 66614, 68726, 72950, 81398, 128980, 128978, 124820, 126900, 124818, 126898, 116500, 118580, 116498, 122740, 118578, 122738, 99860, 101940, 99858, 106100, 101938, 114420]), $a([128352, 129720, 125504, 128304, 129692, 125472, 128280, 129678, 125456, 128268, 125448, 128262, 125444, 125792, 128440, 129758, 120384, 125744, 128412, 120352, 125720, 128398, 120336, 125708, 120328, 125702, 120324, 120672, 125880, 128478, 110144, 120624, 125852, 110112, 120600, 125838, 110096, 120588, 110088, 120582, 110084, 110432, 120760, 125918, 89664, 110384, 120732, 89632, 110360, 120718, 89616, 110348, 89608, 110342, 89952, 110520, 120798, 89904, 110492, 89880, 110478, 89868, 90040, 110558, 90012, 89998, 125248, 128176, 129628, 125216, 128152, 129614, 125200, 128140, 125192, 128134, 125188, 125186, 119616, 125360, 128220, 119584, 125336, 128206, 119568, 125324, 119560, 125318, 119556, 119554, 108352, 119728, 125404, 108320, 119704, 125390, 108304, 119692, 108296, 119686, 108292, 108290, 85824, 108464, 119772, 85792, 108440, 119758, 85776, 108428, 85768, 108422, 85764, 85936, 108508, 85912, 108494, 85900, 85894, 85980, 85966, 125088, 128088, 129582, 125072, 128076, 125064, 128070, 125060, 125058, 119200, 125144, 128110, 119184, 125132, 119176, 125126, 119172, 119170, 107424, 119256, 125166, 107408, 119244, 107400, 119238, 107396, 107394, 83872, 107480, 119278, 83856, 107468, 83848, 107462, 83844, 83842, 83928, 107502, 83916, 83910, 83950, 125008, 128044, 125000, 128038, 124996, 124994, 118992, 125036, 118984, 125030, 118980, 118978, 106960, 119020, 106952, 119014, 106948, 106946, 82896, 106988, 82888, 106982, 82884, 82882, 82924, 82918, 124968, 128022, 124964, 124962, 118888, 124982, 118884, 118882, 106728, 118902, 106724, 106722, 82408, 106742, 82404, 82402, 124948, 124946, 118836, 118834, 106612, 106610, 124224, 127664, 129372, 124192, 127640, 129358, 124176, 127628, 124168, 127622, 124164, 124162, 117568, 124336, 127708, 117536, 124312, 127694, 117520, 124300, 117512, 124294, 117508, 117506, 104256, 117680, 124380, 104224, 117656, 124366, 104208, 117644, 104200, 117638, 104196, 104194, 77632, 104368, 117724, 77600, 104344, 117710, 77584, 104332, 77576, 104326, 77572, 77744, 104412, 77720, 104398, 77708, 77702, 77788, 77774, 128672, 129880, 93168, 128656, 129868, 92664, 128648, 129862, 92412, 128644, 128642, 124064, 127576, 129326, 126368, 124048, 129902, 126352, 128716, 127558, 126344, 124036, 126340, 124034, 126338, 117152, 124120, 127598, 121760, 117136, 124108, 121744, 126412, 124102, 121736, 117124, 121732, 117122, 121730, 103328, 117208, 124142, 112544, 103312, 117196, 112528, 121804, 117190, 112520, 103300, 112516, 103298, 112514, 75680, 103384, 117230, 94112, 75664, 103372, 94096, 112588, 103366, 94088, 75652, 94084, 75650, 75736, 103406, 94168, 75724, 94156, 75718, 94150, 75758, 128592, 129836, 91640, 128584, 129830, 91388, 128580, 91262, 128578, 123984, 127532, 126160, 123976, 127526, 126152, 128614, 126148, 123970, 126146, 116944, 124012, 121296, 116936, 124006, 121288, 126182, 121284, 116930, 121282, 102864, 116972, 111568, 102856, 116966, 111560, 121318, 111556, 102850, 111554, 74704, 102892, 92112, 74696, 102886, 92104, 111590, 92100, 74690, 92098, 74732, 92140, 74726, 92134, 128552, 129814, 90876, 128548, 90750, 128546, 123944, 127510, 126056, 128566, 126052, 123938, 126050, 116840, 123958, 121064, 116836, 121060, 116834, 121058, 102632, 116854, 111080, 121078, 111076, 102626, 111074, 74216, 102646, 91112, 74212, 91108, 74210, 91106, 74230, 91126, 128532, 90494, 128530, 123924, 126004, 123922, 126002, 116788, 120948, 116786, 120946, 102516, 110836, 102514, 110834, 73972, 90612, 73970, 90610, 128522, 123914, 125978, 116762, 120890, 102458, 110714, 123552, 127320, 129198, 123536, 127308, 123528, 127302, 123524, 123522, 116128, 123608, 127342, 116112, 123596, 116104, 123590, 116100, 116098, 101280, 116184, 123630, 101264, 116172, 101256, 116166, 101252, 101250, 71584, 101336, 116206, 71568, 101324, 71560, 101318, 71556, 71554, 71640, 101358, 71628, 71622, 71662, 127824, 129452, 79352, 127816, 129446, 79100, 127812, 78974, 127810, 123472, 127276, 124624, 123464, 127270, 124616, 127846, 124612, 123458, 124610, 115920, 123500, 118224, 115912, 123494, 118216, 124646, 118212, 115906, 118210, 100816, 115948, 105424, 100808, 115942, 105416, 118246, 105412, 100802, 105410, 70608, 100844, 79824, 70600, 100838, 79816, 105446, 79812, 70594, 79810, 70636, 79852, 70630, 79846, 129960, 95728, 113404, 129956, 95480, 113278, 129954, 95356, 95294, 127784, 129430, 78588, 128872, 129974, 95996, 78462, 128868, 127778, 95870, 128866, 123432, 127254, 124520, 123428, 126696, 128886, 123426, 126692, 124514, 126690, 115816, 123446, 117992, 115812, 122344, 117988, 115810, 122340, 117986, 122338, 100584, 115830, 104936, 100580, 113640, 104932, 100578, 113636, 104930, 113634, 70120, 100598, 78824, 70116, 96232, 78820, 70114, 96228, 78818, 96226, 70134, 78838, 129940, 94968, 113022, 129938, 94844, 94782, 127764, 78206, 128820, 127762, 95102, 128818, 123412, 124468, 123410, 126580, 124466, 126578, 115764, 117876, 115762, 122100, 117874, 122098, 100468, 104692, 100466, 113140, 104690, 113138, 69876, 78324, 69874, 95220, 78322, 95218, 129930, 94588, 94526, 127754, 128794, 123402, 124442, 126522, 115738, 117818, 121978, 100410, 104570, 112890, 69754, 78074, 94714, 94398, 123216, 127148, 123208, 127142, 123204, 123202, 115408, 123244, 115400, 123238, 115396, 115394, 99792, 115436, 99784, 115430, 99780, 99778, 68560, 99820, 68552, 99814, 68548, 68546, 68588, 68582, 127400, 129238, 72444, 127396, 72318, 127394, 123176, 127126, 123752, 123172, 123748, 123170, 123746, 115304, 123190, 116456, 115300, 116452, 115298, 116450, 99560, 115318, 101864, 99556, 101860, 99554, 101858, 68072, 99574, 72680, 68068, 72676, 68066, 72674, 68086, 72694, 129492, 80632, 105854, 129490, 80508, 80446, 127380, 72062, 127924, 127378, 80766, 127922, 123156, 123700, 123154, 124788, 123698, 124786, 115252, 116340, 115250, 118516, 116338, 118514, 99444, 101620, 99442, 105972, 101618, 105970, 67828, 72180, 67826, 80884, 72178, 80882, 97008, 114044, 96888, 113982, 96828, 96798, 129482, 80252, 130010, 97148, 80190, 97086, 127370, 127898, 128954, 123146, 123674, 124730, 126842, 115226, 116282, 118394, 122618, 99386, 101498, 105722, 114170, 67706, 71930, 80378, 96632, 113854, 96572, 96542, 80062, 96702, 96444, 96414, 96350, 123048, 123044, 123042, 115048, 123062, 115044, 115042, 99048, 115062, 99044, 99042, 67048, 99062, 67044, 67042, 67062, 127188, 68990, 127186, 123028, 123316, 123026, 123314, 114996, 115572, 114994, 115570, 98932, 100084, 98930, 100082, 66804, 69108, 66802, 69106, 129258, 73084, 73022, 127178, 127450, 123018, 123290, 123834, 114970, 115514, 116602, 98874, 99962, 102138, 66682, 68858, 73210, 81272, 106174, 81212, 81182, 72894, 81342, 97648, 114364, 97592, 114334, 97564, 97550, 81084, 97724, 81054, 97694, 97464, 114270, 97436, 97422, 80990, 97502, 97372, 97358, 97326, 114868, 114866, 98676, 98674, 66292, 66290, 123098, 114842, 115130, 98618, 99194, 66170, 67322, 69310, 73404, 73374, 81592, 106334, 81564, 81550, 73310, 81630, 97968, 114524, 97944, 114510, 97932, 97926, 81500, 98012, 81486, 97998, 97880, 114478, 97868, 97862, 81454, 97902, 97836, 97830, 69470, 73564, 73550, 81752, 106414, 81740, 81734, 73518, 81774, 81708, 81702]), $a([109536, 120312, 86976, 109040, 120060, 86496, 108792, 119934, 86256, 108668, 86136, 129744, 89056, 110072, 129736, 88560, 109820, 129732, 88312, 109694, 129730, 88188, 128464, 129772, 89592, 128456, 129766, 89340, 128452, 89214, 128450, 125904, 128492, 125896, 128486, 125892, 125890, 120784, 125932, 120776, 125926, 120772, 120770, 110544, 120812, 110536, 120806, 110532, 84928, 108016, 119548, 84448, 107768, 119422, 84208, 107644, 84088, 107582, 84028, 129640, 85488, 108284, 129636, 85240, 108158, 129634, 85116, 85054, 128232, 129654, 85756, 128228, 85630, 128226, 125416, 128246, 125412, 125410, 119784, 125430, 119780, 119778, 108520, 119798, 108516, 108514, 83424, 107256, 119166, 83184, 107132, 83064, 107070, 83004, 82974, 129588, 83704, 107390, 129586, 83580, 83518, 128116, 83838, 128114, 125172, 125170, 119284, 119282, 107508, 107506, 82672, 106876, 82552, 106814, 82492, 82462, 129562, 82812, 82750, 128058, 125050, 119034, 82296, 106686, 82236, 82206, 82366, 82108, 82078, 76736, 103920, 117500, 76256, 103672, 117374, 76016, 103548, 75896, 103486, 75836, 129384, 77296, 104188, 129380, 77048, 104062, 129378, 76924, 76862, 127720, 129398, 77564, 127716, 77438, 127714, 124392, 127734, 124388, 124386, 117736, 124406, 117732, 117730, 104424, 117750, 104420, 104418, 112096, 121592, 126334, 92608, 111856, 121468, 92384, 111736, 121406, 92272, 111676, 92216, 111646, 92188, 75232, 103160, 117118, 93664, 74992, 103036, 93424, 112252, 102974, 93304, 74812, 93244, 74782, 93214, 129332, 75512, 103294, 129908, 129330, 93944, 75388, 129906, 93820, 75326, 93758, 127604, 75646, 128756, 127602, 94078, 128754, 124148, 126452, 124146, 126450, 117236, 121844, 117234, 121842, 103412, 103410, 91584, 111344, 121212, 91360, 111224, 121150, 91248, 111164, 91192, 111134, 91164, 91150, 74480, 102780, 91888, 74360, 102718, 91768, 111422, 91708, 74270, 91678, 129306, 74620, 129850, 92028, 74558, 91966, 127546, 128634, 124026, 126202, 116986, 121338, 102906, 90848, 110968, 121022, 90736, 110908, 90680, 110878, 90652, 90638, 74104, 102590, 91000, 74044, 90940, 74014, 90910, 74174, 91070, 90480, 110780, 90424, 110750, 90396, 90382, 73916, 90556, 73886, 90526, 90296, 110686, 90268, 90254, 73822, 90334, 90204, 90190, 71136, 101112, 116094, 70896, 100988, 70776, 100926, 70716, 70686, 129204, 71416, 101246, 129202, 71292, 71230, 127348, 71550, 127346, 123636, 123634, 116212, 116210, 101364, 101362, 79296, 105200, 118140, 79072, 105080, 118078, 78960, 105020, 78904, 104990, 78876, 78862, 70384, 100732, 79600, 70264, 100670, 79480, 105278, 79420, 70174, 79390, 129178, 70524, 129466, 79740, 70462, 79678, 127290, 127866, 123514, 124666, 115962, 118266, 100858, 113376, 122232, 126654, 95424, 113264, 122172, 95328, 113208, 122142, 95280, 113180, 95256, 113166, 95244, 78560, 104824, 117950, 95968, 78448, 104764, 95856, 113468, 104734, 95800, 78364, 95772, 78350, 95758, 70008, 100542, 78712, 69948, 96120, 78652, 69918, 96060, 78622, 96030, 70078, 78782, 96190, 94912, 113008, 122044, 94816, 112952, 122014, 94768, 112924, 94744, 112910, 94732, 94726, 78192, 104636, 95088, 78136, 104606, 95032, 113054, 95004, 78094, 94990, 69820, 78268, 69790, 95164, 78238, 95134, 94560, 112824, 121950, 94512, 112796, 94488, 112782, 94476, 94470, 78008, 104542, 94648, 77980, 94620, 77966, 94606, 69726, 78046, 94686, 94384, 112732, 94360, 112718, 94348, 94342, 77916, 94428, 77902, 94414, 94296, 112686, 94284, 94278, 77870, 94318, 94252, 94246, 68336, 99708, 68216, 99646, 68156, 68126, 68476, 68414, 127162, 123258, 115450, 99834, 72416, 101752, 116414, 72304, 101692, 72248, 101662, 72220, 72206, 67960, 99518, 72568, 67900, 72508, 67870, 72478, 68030, 72638, 80576, 105840, 118460, 80480, 105784, 118430, 80432, 105756, 80408, 105742, 80396, 80390, 72048, 101564, 80752, 71992, 101534, 80696, 71964, 80668, 71950, 80654, 67772, 72124, 67742, 80828, 72094, 80798, 114016, 122552, 126814, 96832, 113968, 122524, 96800, 113944, 122510, 96784, 113932, 96776, 113926, 96772, 80224, 105656, 118366, 97120, 80176, 105628, 97072, 114076, 105614, 97048, 80140, 97036, 80134, 97030, 71864, 101470, 80312, 71836, 97208, 80284, 71822, 97180, 80270, 97166, 67678, 71902, 80350, 97246, 96576, 113840, 122460, 96544, 113816, 122446, 96528, 113804, 96520, 113798, 96516, 96514, 80048, 105564, 96688, 80024, 105550, 96664, 113870, 96652, 80006, 96646, 71772, 80092, 71758, 96732, 80078, 96718, 96416, 113752, 122414, 96400, 113740, 96392, 113734, 96388, 96386, 79960, 105518, 96472, 79948, 96460, 79942, 96454, 71726, 79982, 96494, 96336, 113708, 96328, 113702, 96324, 96322, 79916, 96364, 79910, 96358, 96296, 113686, 96292, 96290, 79894, 96310, 66936, 99006, 66876, 66846, 67006, 68976, 100028, 68920, 99998, 68892, 68878, 66748, 69052, 66718, 69022, 73056, 102072, 116574, 73008, 102044, 72984, 102030, 72972, 72966, 68792, 99934, 73144, 68764, 73116, 68750, 73102, 66654, 68830, 73182, 81216, 106160, 118620, 81184, 106136, 118606, 81168, 106124, 81160, 106118, 81156, 81154, 72880, 101980, 81328, 72856, 101966, 81304, 106190, 81292, 72838, 81286, 68700, 72924, 68686, 81372, 72910, 81358, 114336, 122712, 126894, 114320, 122700, 114312, 122694, 114308, 114306, 81056, 106072, 118574, 97696, 81040, 106060, 97680, 114380, 106054, 97672, 81028, 97668, 81026, 97666, 72792, 101934, 81112, 72780, 97752, 81100, 72774, 97740, 81094, 97734, 68654, 72814, 81134, 97774, 114256, 122668, 114248, 122662, 114244, 114242, 80976, 106028, 97488, 80968, 106022, 97480, 114278, 97476, 80962, 97474, 72748, 81004, 72742, 97516, 80998, 97510, 114216, 122646, 114212, 114210, 80936, 106006, 97384, 80932, 97380, 80930, 97378, 72726, 80950, 97398, 114196, 114194, 80916, 97332, 80914, 97330, 66236, 66206, 67256, 99166, 67228, 67214, 66142, 67294, 69296, 100188, 69272, 100174, 69260, 69254, 67164, 69340, 67150, 69326, 73376, 102232, 116654, 73360, 102220, 73352, 102214, 73348, 73346, 69208, 100142, 73432, 102254, 73420, 69190, 73414, 67118, 69230, 73454, 106320, 118700, 106312, 118694, 106308, 106306, 73296, 102188, 81616, 106348, 102182, 81608, 73284, 81604, 73282, 81602, 69164, 73324, 69158, 81644, 73318, 81638, 122792, 126934, 122788, 122786, 106280, 118678, 114536, 106276, 114532, 106274, 114530, 73256, 102166, 81512, 73252, 98024, 81508, 73250, 98020, 81506, 98018, 69142, 73270, 81526, 98038, 122772, 122770, 106260, 114484, 106258, 114482, 73236, 81460, 73234, 97908, 81458, 97906, 122762, 106250, 114458, 73226, 81434, 97850, 66396, 66382, 67416, 99246, 67404, 67398, 66350, 67438, 69456, 100268, 69448, 100262, 69444, 69442, 67372, 69484, 67366, 69478, 102312, 116694, 102308, 102306, 69416, 100246, 73576, 102326, 73572, 69410, 73570, 67350, 69430, 73590, 118740, 118738, 102292, 106420, 102290, 106418, 69396, 73524, 69394, 81780, 73522, 81778, 118730, 102282, 106394, 69386, 73498, 81722, 66476, 66470, 67496, 99286, 67492, 67490, 66454, 67510, 100308, 100306, 67476, 69556, 67474, 69554, 116714])]); /*15233*/
		$1.raps = $a([$a([802, 930, 946, 818, 882, 890, 826, 954, 922, 986, 970, 906, 778, 794, 786, 914, 978, 982, 980, 916, 948, 932, 934, 942, 940, 936, 808, 812, 814, 806, 822, 950, 918, 790, 788, 820, 884, 868, 870, 878, 876, 872, 840, 856, 860, 862, 846, 844, 836, 838, 834, 866]), $a([718, 590, 622, 558, 550, 566, 534, 530, 538, 570, 562, 546, 610, 626, 634, 762, 754, 758, 630, 628, 612, 614, 582, 578, 706, 738, 742, 740, 748, 620, 556, 552, 616, 744, 712, 716, 708, 710, 646, 654, 652, 668, 664, 696, 688, 656, 720, 592, 600, 604, 732, 734])]); /*15248*/
		$1.cwtobits = function() {
			var _FG = $get($1.clusters, $k[--$j]); /*15252*/
			$1.v = $get(_FG, $k[--$j]); /*15252*/
			$k[$j++] = Infinity; /*15253*/
			for (var _FJ = 0, _FK = 17; _FJ < _FK; _FJ++) { /*15253*/
				$k[$j++] = 0; /*15253*/
			} /*15253*/
			var _FN = $cvrs($s(17), $1.v, 2); /*15253*/
			for (var _FO = 0, _FP = _FN.length; _FO < _FP; _FO++) { /*15253*/
				$k[$j++] = $get(_FN, _FO) - 48; /*15253*/
			} /*15253*/
			var _FR = $a(); /*15253*/
			$k[$j++] = $geti(_FR, _FR.length - 17, 17); /*15254*/
		}; /*15255*/
		$1.raptobits = function() {
			var _FV = $get($1.raps, $k[--$j]); /*15259*/
			$1.v = $get(_FV, $k[--$j]); /*15259*/
			$k[$j++] = Infinity; /*15260*/
			for (var _FY = 0, _FZ = 10; _FY < _FZ; _FY++) { /*15260*/
				$k[$j++] = 0; /*15260*/
			} /*15260*/
			var _Fc = $cvrs($s(10), $1.v, 2); /*15260*/
			for (var _Fd = 0, _Fe = _Fc.length; _Fd < _Fe; _Fd++) { /*15260*/
				$k[$j++] = $get(_Fc, _Fd) - 48; /*15260*/
			} /*15260*/
			var _Fg = $a(); /*15260*/
			$k[$j++] = $geti(_Fg, _Fg.length - 10, 10); /*15261*/
		}; /*15262*/
		$1.rwid = $get($a([38, 55, 82, 99]), $1.c - 1); /*15265*/
		if (($1.c == 3) && $1.cca) { /*15266*/
			$1.rwid = 72; /*15266*/
		} /*15266*/
		$1.pixs = $a($1.rwid * $1.r); /*15267*/
		for (var _Fs = 0, _Fr = $1.r - 1; _Fs <= _Fr; _Fs += 1) { /*15305*/
			$1.i = _Fs; /*15270*/
			$1.clst = (($1.i + $1.rapl) - 1) % 3; /*15271*/
			$k[$j++] = $1.pixs; /*15303*/
			$k[$j++] = $1.rwid * $1.i; /*15303*/
			$k[$j++] = Infinity; /*15303*/
			if ($1.c == 1) { /*15277*/
				$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*15274*/
				$k[$j++] = 0; /*15274*/
				if ($1.raptobits() == $b) break; /*15274*/
				$aload($k[--$j]); /*15274*/
				$k[$j++] = $get($1.cws, $1.i); /*15275*/
				$k[$j++] = $1.clst; /*15275*/
				if ($1.cwtobits() == $b) break; /*15275*/
				$aload($k[--$j]); /*15275*/
				$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*15276*/
				$k[$j++] = 0; /*15276*/
				if ($1.raptobits() == $b) break; /*15276*/
				$aload($k[--$j]); /*15276*/
			} /*15276*/
			if ($1.c == 2) { /*15283*/
				$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*15279*/
				$k[$j++] = 0; /*15279*/
				if ($1.raptobits() == $b) break; /*15279*/
				$aload($k[--$j]); /*15279*/
				$k[$j++] = $get($1.cws, $1.i * 2); /*15280*/
				$k[$j++] = $1.clst; /*15280*/
				if ($1.cwtobits() == $b) break; /*15280*/
				$aload($k[--$j]); /*15280*/
				$k[$j++] = $get($1.cws, ($1.i * 2) + 1); /*15281*/
				$k[$j++] = $1.clst; /*15281*/
				if ($1.cwtobits() == $b) break; /*15281*/
				$aload($k[--$j]); /*15281*/
				$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*15282*/
				$k[$j++] = 0; /*15282*/
				if ($1.raptobits() == $b) break; /*15282*/
				$aload($k[--$j]); /*15282*/
			} /*15282*/
			if ($1.c == 3) { /*15293*/
				if (!$1.cca) { /*15287*/
					$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*15286*/
					$k[$j++] = 0; /*15286*/
					if ($1.raptobits() == $b) break; /*15286*/
					$aload($k[--$j]); /*15286*/
				} /*15286*/
				$k[$j++] = $get($1.cws, $1.i * 3); /*15288*/
				$k[$j++] = $1.clst; /*15288*/
				if ($1.cwtobits() == $b) break; /*15288*/
				$aload($k[--$j]); /*15288*/
				$k[$j++] = (($1.i + $1.rapc) - 1) % 52; /*15289*/
				$k[$j++] = 1; /*15289*/
				if ($1.raptobits() == $b) break; /*15289*/
				$aload($k[--$j]); /*15289*/
				$k[$j++] = $get($1.cws, ($1.i * 3) + 1); /*15290*/
				$k[$j++] = $1.clst; /*15290*/
				if ($1.cwtobits() == $b) break; /*15290*/
				$aload($k[--$j]); /*15290*/
				$k[$j++] = $get($1.cws, ($1.i * 3) + 2); /*15291*/
				$k[$j++] = $1.clst; /*15291*/
				if ($1.cwtobits() == $b) break; /*15291*/
				$aload($k[--$j]); /*15291*/
				$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*15292*/
				$k[$j++] = 0; /*15292*/
				if ($1.raptobits() == $b) break; /*15292*/
				$aload($k[--$j]); /*15292*/
			} /*15292*/
			if ($1.c == 4) { /*15302*/
				$k[$j++] = (($1.i + $1.rapl) - 1) % 52; /*15295*/
				$k[$j++] = 0; /*15295*/
				if ($1.raptobits() == $b) break; /*15295*/
				$aload($k[--$j]); /*15295*/
				$k[$j++] = $get($1.cws, $1.i * 4); /*15296*/
				$k[$j++] = $1.clst; /*15296*/
				if ($1.cwtobits() == $b) break; /*15296*/
				$aload($k[--$j]); /*15296*/
				$k[$j++] = $get($1.cws, ($1.i * 4) + 1); /*15297*/
				$k[$j++] = $1.clst; /*15297*/
				if ($1.cwtobits() == $b) break; /*15297*/
				$aload($k[--$j]); /*15297*/
				$k[$j++] = (($1.i + $1.rapc) - 1) % 52; /*15298*/
				$k[$j++] = 1; /*15298*/
				if ($1.raptobits() == $b) break; /*15298*/
				$aload($k[--$j]); /*15298*/
				$k[$j++] = $get($1.cws, ($1.i * 4) + 2); /*15299*/
				$k[$j++] = $1.clst; /*15299*/
				if ($1.cwtobits() == $b) break; /*15299*/
				$aload($k[--$j]); /*15299*/
				$k[$j++] = $get($1.cws, ($1.i * 4) + 3); /*15300*/
				$k[$j++] = $1.clst; /*15300*/
				if ($1.cwtobits() == $b) break; /*15300*/
				$aload($k[--$j]); /*15300*/
				$k[$j++] = (($1.i + $1.rapr) - 1) % 52; /*15301*/
				$k[$j++] = 0; /*15301*/
				if ($1.raptobits() == $b) break; /*15301*/
				$aload($k[--$j]); /*15301*/
			} /*15301*/
			$k[$j++] = 1; /*15303*/
			var _HL = $a(); /*15303*/
			var _HM = $k[--$j]; /*15304*/
			$puti($k[--$j], _HM, _HL); /*15304*/
		} /*15304*/
		var _HV = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.rwid,
			pixy: $1.r,
			height: ($1.r / 72) * $1.rowmult,
			width: $1.rwid / 72,
			opt: $1.options
		}; /*15315*/
		$k[$j++] = _HV; /*15318*/
		if (!$1.dontdraw) { /*15318*/
			$0.renmatrix(); /*15318*/
		} /*15318*/
	};
	$0.datamatrix = function() {
		var $1 = {}; /*15343*/
		$1.options = $k[--$j]; /*15345*/
		$1.barcode = $k[--$j]; /*15346*/
		$1.dontdraw = false; /*15348*/
		$1.columns = 0; /*15349*/
		$1.rows = 0; /*15350*/
		$1.format = "square"; /*15351*/
		$1.version = "unset"; /*15352*/
		$1.parse = false; /*15353*/
		$1.parsefnc = false; /*15354*/
		$1.encoding = "auto"; /*15355*/
		$1.raw = false; /*15356*/
		$1.dmre = false; /*15357*/
		$forall($1.options, function() { /*15368*/
			var _3 = $k[--$j]; /*15368*/
			$1[$k[--$j]] = _3; /*15368*/
		}); /*15368*/
		if ($ne($1.version, "unset")) { /*15374*/
			$search($1.version, "x"); /*15371*/
			$j--; /*15372*/
			$1.rows = $k[--$j]; /*15372*/
			$j--; /*15373*/
			$1.columns = $k[--$j]; /*15373*/
		} /*15373*/
		$1.columns = ~~$z($1.columns); /*15376*/
		$1.rows = ~~$z($1.rows); /*15377*/
		$k[$j++] = Infinity; /*15447*/
		$k[$j++] = $a([10, 10, 1, 1, 5, 1]); /*15431*/
		$k[$j++] = $a([12, 12, 1, 1, 7, 1]); /*15431*/
		$k[$j++] = $a([14, 14, 1, 1, 10, 1]); /*15431*/
		$k[$j++] = $a([16, 16, 1, 1, 12, 1]); /*15431*/
		$k[$j++] = $a([18, 18, 1, 1, 14, 1]); /*15431*/
		$k[$j++] = $a([20, 20, 1, 1, 18, 1]); /*15431*/
		$k[$j++] = $a([22, 22, 1, 1, 20, 1]); /*15431*/
		$k[$j++] = $a([24, 24, 1, 1, 24, 1]); /*15431*/
		$k[$j++] = $a([26, 26, 1, 1, 28, 1]); /*15431*/
		$k[$j++] = $a([32, 32, 2, 2, 36, 1]); /*15431*/
		$k[$j++] = $a([36, 36, 2, 2, 42, 1]); /*15431*/
		$k[$j++] = $a([40, 40, 2, 2, 48, 1]); /*15431*/
		$k[$j++] = $a([44, 44, 2, 2, 56, 1]); /*15431*/
		$k[$j++] = $a([48, 48, 2, 2, 68, 1]); /*15431*/
		$k[$j++] = $a([52, 52, 2, 2, 84, 2]); /*15431*/
		$k[$j++] = $a([64, 64, 4, 4, 112, 2]); /*15431*/
		$k[$j++] = $a([72, 72, 4, 4, 144, 4]); /*15431*/
		$k[$j++] = $a([80, 80, 4, 4, 192, 4]); /*15431*/
		$k[$j++] = $a([88, 88, 4, 4, 224, 4]); /*15431*/
		$k[$j++] = $a([96, 96, 4, 4, 272, 4]); /*15431*/
		$k[$j++] = $a([104, 104, 4, 4, 336, 6]); /*15431*/
		$k[$j++] = $a([120, 120, 6, 6, 408, 6]); /*15431*/
		$k[$j++] = $a([132, 132, 6, 6, 496, 8]); /*15431*/
		$k[$j++] = $a([144, 144, 6, 6, 620, 10]); /*15431*/
		$k[$j++] = $a([8, 18, 1, 1, 7, 1]); /*15431*/
		$k[$j++] = $a([8, 32, 1, 2, 11, 1]); /*15431*/
		if ($1.dmre) { /*15431*/
			$k[$j++] = $a([8, 48, 1, 2, 15, 1]); /*15431*/
		} /*15431*/
		if ($1.dmre) { /*15432*/
			$k[$j++] = $a([8, 64, 1, 4, 18, 1]); /*15432*/
		} /*15432*/
		$k[$j++] = $a([12, 26, 1, 1, 14, 1]); /*15435*/
		$k[$j++] = $a([12, 36, 1, 2, 18, 1]); /*15435*/
		if ($1.dmre) { /*15435*/
			$k[$j++] = $a([12, 64, 1, 4, 27, 1]); /*15435*/
		} /*15435*/
		$k[$j++] = $a([16, 36, 1, 2, 24, 1]); /*15438*/
		$k[$j++] = $a([16, 48, 1, 2, 28, 1]); /*15438*/
		if ($1.dmre) { /*15438*/
			$k[$j++] = $a([16, 64, 1, 4, 36, 1]); /*15438*/
		} /*15438*/
		if ($1.dmre) { /*15439*/
			$k[$j++] = $a([24, 32, 1, 2, 28, 1]); /*15439*/
		} /*15439*/
		if ($1.dmre) { /*15440*/
			$k[$j++] = $a([24, 36, 1, 2, 33, 1]); /*15440*/
		} /*15440*/
		if ($1.dmre) { /*15441*/
			$k[$j++] = $a([24, 48, 1, 2, 41, 1]); /*15441*/
		} /*15441*/
		if ($1.dmre) { /*15442*/
			$k[$j++] = $a([24, 64, 1, 4, 46, 1]); /*15442*/
		} /*15442*/
		if ($1.dmre) { /*15443*/
			$k[$j++] = $a([26, 32, 1, 2, 32, 1]); /*15443*/
		} /*15443*/
		if ($1.dmre) { /*15444*/
			$k[$j++] = $a([26, 40, 1, 2, 38, 1]); /*15444*/
		} /*15444*/
		if ($1.dmre) { /*15445*/
			$k[$j++] = $a([26, 48, 1, 2, 42, 1]); /*15445*/
		} /*15445*/
		if ($1.dmre) { /*15446*/
			$k[$j++] = $a([26, 64, 1, 4, 50, 1]); /*15446*/
		} /*15446*/
		$1.metrics = $a(); /*15447*/
		$1.urows = $1.rows; /*15450*/
		$1.ucols = $1.columns; /*15451*/
		$1.fullcws = $a([]); /*15452*/
		var _17 = $1.metrics; /*15453*/
		for (var _18 = 0, _19 = _17.length; _18 < _19; _18++) { /*15470*/
			$1.m = $get(_17, _18); /*15454*/
			$1.rows = $get($1.m, 0); /*15455*/
			$1.cols = $get($1.m, 1); /*15456*/
			$1.regh = $get($1.m, 2); /*15457*/
			$1.regv = $get($1.m, 3); /*15458*/
			$1.rscw = $get($1.m, 4); /*15459*/
			$1.rsbl = $get($1.m, 5); /*15460*/
			$1.mrows = $1.rows - (2 * $1.regh); /*15461*/
			$1.mcols = $1.cols - (2 * $1.regv); /*15462*/
			$1.ncws = (~~(($1.mrows * $1.mcols) / 8)) - $1.rscw; /*15463*/
			$1.okay = true; /*15464*/
			if (($1.urows != 0) && ($1.urows != $1.rows)) { /*15465*/
				$1.okay = false; /*15465*/
			} /*15465*/
			if (($1.ucols != 0) && ($1.ucols != $1.cols)) { /*15466*/
				$1.okay = false; /*15466*/
			} /*15466*/
			if ($eq($1.format, "square") && $ne($1.rows, $1.cols)) { /*15467*/
				$1.okay = false; /*15467*/
			} /*15467*/
			if ($eq($1.format, "rectangle") && $eq($1.rows, $1.cols)) { /*15468*/
				$1.okay = false; /*15468*/
			} /*15468*/
			if ($1.okay) { /*15469*/
				$k[$j++] = Infinity; /*15469*/
				$aload($1.fullcws); /*15469*/
				$k[$j++] = $1.ncws; /*15469*/
				$1.fullcws = $a(); /*15469*/
			} /*15469*/
		} /*15469*/
		$k[$j++] = Infinity; /*15471*/
		for (var _1k = 0, _1l = 1558; _1k < _1l; _1k++) { /*15471*/
			$k[$j++] = 10000; /*15471*/
		} /*15471*/
		$1.numremcws = $a(); /*15471*/
		var _1n = $1.fullcws; /*15472*/
		for (var _1o = 0, _1p = _1n.length; _1o < _1p; _1o++) { /*15472*/
			$put($1.numremcws, $get(_1n, _1o) - 1, 1); /*15472*/
		} /*15472*/
		for (var _1s = 1556; _1s >= 0; _1s -= 1) { /*15478*/
			$1.i = _1s; /*15474*/
			if ($get($1.numremcws, $1.i) != 1) { /*15477*/
				$put($1.numremcws, $1.i, $get($1.numremcws, $1.i + 1) + 1); /*15476*/
			} /*15476*/
		} /*15476*/
		if ($1.raw) { /*15480*/
			$1.encoding = "raw"; /*15480*/
		} /*15480*/
		if ($eq($1.encoding, "raw")) { /*15493*/
			$1.cws = $a($1.barcode.length); /*15483*/
			$1.i = 0; /*15484*/
			$1.j = 0; /*15484*/
			for (;;) { /*15491*/
				if ($1.i == $1.barcode.length) { /*15486*/
					break; /*15486*/
				} /*15486*/
				$1.cw = ~~$z($geti($1.barcode, $1.i + 1, 3)); /*15487*/
				$put($1.cws, $1.j, $1.cw); /*15488*/
				$1.i = $1.i + 4; /*15489*/
				$1.j = $1.j + 1; /*15490*/
			} /*15490*/
			$1.cws = $geti($1.cws, 0, $1.j); /*15492*/
		} /*15492*/
		if ($eq($1.encoding, "auto")) { /*15978*/
			$1.mac05comp = false; /*15498*/
			$1.mac06comp = false; /*15499*/
			if ($1.barcode.length >= 9) { /*15508*/
				var _2L = $geti($1.barcode, 0, 7); /*15501*/
				if ((($eq(_2L, "[)>03605035")) || ($eq(_2L, "[)>03606035"))) && $eq($geti($1.barcode, $1.barcode.length - 2, 2), "036004")) { /*15507*/
					if ($get($1.barcode, 5) == 53) { /*15505*/
						$k[$j++] = "mac05comp"; /*15505*/
					} else { /*15505*/
						$k[$j++] = "mac06comp"; /*15505*/
					} /*15505*/
					$1[$k[--$j]] = true; /*15505*/
					$1.barcode = $geti($1.barcode, 7, $1.barcode.length - 9); /*15506*/
				} /*15506*/
			} /*15506*/
			$1.barlen = $1.barcode.length; /*15509*/
			$1.fnc1 = -1; /*15512*/
			$1.prog = -2; /*15512*/
			$1.m05 = -3; /*15512*/
			$1.m06 = -4; /*15512*/
			var _2a = {
				FNC1: $1.fnc1,
				PROG: $1.prog,
				MAC5: $1.m05,
				MAC6: $1.m06
			}; /*15517*/
			$1.fncvals = _2a; /*15518*/
			$1.msg = $a($1.barlen); /*15519*/
			$1.i = 0; /*15520*/
			$1.j = 0; /*15520*/
			for (;;) { /*15534*/
				if ($1.i == $1.barlen) { /*15521*/
					break; /*15521*/
				} /*15521*/
				$1.char = $get($1.barcode, $1.i); /*15522*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*15530*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*15528*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*15525*/
						$1.i = $1.i + 4; /*15526*/
					} else { /*15528*/
						$1.i = $1.i + 1; /*15528*/
					} /*15528*/
				} /*15528*/
				$put($1.msg, $1.j, $1.char); /*15531*/
				$1.i = $1.i + 1; /*15532*/
				$1.j = $1.j + 1; /*15533*/
			} /*15533*/
			$1.msg = $geti($1.msg, 0, $1.j); /*15535*/
			if ($1.mac05comp) { /*15538*/
				$k[$j++] = Infinity; /*15538*/
				$k[$j++] = $1.m05; /*15538*/
				$aload($1.msg); /*15538*/
				$1.msg = $a(); /*15538*/
			} /*15538*/
			if ($1.mac06comp) { /*15539*/
				$k[$j++] = Infinity; /*15539*/
				$k[$j++] = $1.m06; /*15539*/
				$aload($1.msg); /*15539*/
				$1.msg = $a(); /*15539*/
			} /*15539*/
			$1.msglen = $1.msg.length; /*15541*/
			$1.lC = -5; /*15544*/
			$1.lB = -6; /*15544*/
			$1.lX = -7; /*15544*/
			$1.lT = -8; /*15544*/
			$1.lE = -9; /*15544*/
			$1.unl = -10; /*15544*/
			$1.sapp = -11; /*15545*/
			$1.usft = -12; /*15545*/
			$1.sft1 = -13; /*15545*/
			$1.sft2 = -14; /*15545*/
			$1.sft3 = -15; /*15545*/
			$1.eci = -16; /*15545*/
			$1.pad = -17; /*15545*/
			$1.unlcw = 254; /*15546*/
			$k[$j++] = "Avals"; /*15555*/
			$k[$j++] = Infinity; /*15555*/
			for (var _3D = 0; _3D <= 128; _3D += 1) { /*15549*/
				$k[$j++] = _3D; /*15549*/
				$k[$j++] = _3D + 1; /*15549*/
			} /*15549*/
			$k[$j++] = $1.pad; /*15554*/
			$k[$j++] = 129; /*15554*/
			for (var _3F = 0; _3F <= 99; _3F += 1) { /*15554*/
				var _3H = $cvrs($s(2), _3F, 10); /*15552*/
				var _3J = $strcpy($s(2), "00"); /*15552*/
				$puti(_3J, 2 - _3H.length, _3H); /*15552*/
				$k[$j++] = _3J; /*15553*/
				$k[$j++] = _3F + 130; /*15553*/
			} /*15553*/
			var _3W = $a([$1.lC, $1.lB, $1.fnc1, $1.sapp, $1.prog, $1.usft, $1.m05, $1.m06, $1.lX, $1.lT, $1.lE, $1.eci]); /*15555*/
			$k[$j++] = 229; /*15555*/
			for (var _3X = 0, _3Y = _3W.length; _3X < _3Y; _3X++) { /*15555*/
				var _3b = $k[--$j] + 1; /*15555*/
				$k[$j++] = $get(_3W, _3X); /*15555*/
				$k[$j++] = _3b; /*15555*/
				$k[$j++] = _3b; /*15555*/
			} /*15555*/
			$j--; /*15555*/
			var _3c = $d(); /*15555*/
			$1[$k[--$j]] = _3c; /*15556*/
			$k[$j++] = "Avals"; /*15558*/
			$k[$j++] = Infinity; /*15558*/
			$forall($1.Avals, function() { /*15558*/
				$k[$j++] = Infinity; /*15558*/
				var _3f = $k[--$j]; /*15558*/
				var _3g = $k[--$j]; /*15558*/
				$k[$j++] = _3f; /*15558*/
				$k[$j++] = _3g; /*15558*/
				var _3h = $a(); /*15558*/
				$k[$j++] = _3h; /*15558*/
			}); /*15558*/
			var _3i = $d(); /*15558*/
			$1[$k[--$j]] = _3i; /*15559*/
			$k[$j++] = "CNvals"; /*15567*/
			$k[$j++] = Infinity; /*15567*/
			$k[$j++] = $1.sft1; /*15566*/
			$k[$j++] = 0; /*15566*/
			$k[$j++] = $1.sft2; /*15566*/
			$k[$j++] = 1; /*15566*/
			$k[$j++] = $1.sft3; /*15566*/
			$k[$j++] = 2; /*15566*/
			$k[$j++] = 32; /*15566*/
			$k[$j++] = 3; /*15566*/
			for (var _3n = 48; _3n <= 57; _3n += 1) { /*15566*/
				$k[$j++] = _3n; /*15566*/
				$k[$j++] = _3n - 44; /*15566*/
			} /*15566*/
			for (var _3o = 65; _3o <= 90; _3o += 1) { /*15567*/
				$k[$j++] = _3o; /*15567*/
				$k[$j++] = _3o - 51; /*15567*/
			} /*15567*/
			var _3p = $d(); /*15567*/
			$1[$k[--$j]] = _3p; /*15568*/
			$k[$j++] = "C1vals"; /*15569*/
			$k[$j++] = Infinity; /*15569*/
			for (var _3r = 0; _3r <= 31; _3r += 1) { /*15569*/
				$k[$j++] = _3r; /*15569*/
				$k[$j++] = _3r; /*15569*/
			} /*15569*/
			var _3s = $d(); /*15569*/
			$1[$k[--$j]] = _3s; /*15569*/
			$k[$j++] = "C2vals"; /*15575*/
			$k[$j++] = Infinity; /*15575*/
			for (var _3u = 33; _3u <= 47; _3u += 1) { /*15571*/
				$k[$j++] = _3u; /*15571*/
				$k[$j++] = _3u - 33; /*15571*/
			} /*15571*/
			for (var _3v = 58; _3v <= 64; _3v += 1) { /*15572*/
				$k[$j++] = _3v; /*15572*/
				$k[$j++] = _3v - 43; /*15572*/
			} /*15572*/
			for (var _3w = 91; _3w <= 95; _3w += 1) { /*15573*/
				$k[$j++] = _3w; /*15573*/
				$k[$j++] = _3w - 69; /*15573*/
			} /*15573*/
			$k[$j++] = $1.fnc1; /*15575*/
			$k[$j++] = 27; /*15575*/
			$k[$j++] = $1.usft; /*15575*/
			$k[$j++] = 30; /*15575*/
			var _3z = $d(); /*15575*/
			$1[$k[--$j]] = _3z; /*15576*/
			$k[$j++] = "C3vals"; /*15577*/
			$k[$j++] = Infinity; /*15577*/
			for (var _41 = 96; _41 <= 127; _41 += 1) { /*15577*/
				$k[$j++] = _41; /*15577*/
				$k[$j++] = _41 - 96; /*15577*/
			} /*15577*/
			var _42 = $d(); /*15577*/
			$1[$k[--$j]] = _42; /*15577*/
			$k[$j++] = "Cvals"; /*15582*/
			$k[$j++] = Infinity; /*15582*/
			$forall($1.CNvals, function() { /*15579*/
				$k[$j++] = Infinity; /*15579*/
				var _45 = $k[--$j]; /*15579*/
				var _46 = $k[--$j]; /*15579*/
				$k[$j++] = _45; /*15579*/
				$k[$j++] = _46; /*15579*/
				var _47 = $a(); /*15579*/
				$k[$j++] = _47; /*15579*/
			}); /*15579*/
			$forall($1.C1vals, function() { /*15580*/
				$k[$j++] = Infinity; /*15580*/
				var _49 = $k[--$j]; /*15580*/
				var _4A = $k[--$j]; /*15580*/
				$k[$j++] = _49; /*15580*/
				$k[$j++] = $get($1.CNvals, $1.sft1); /*15580*/
				$k[$j++] = _4A; /*15580*/
				var _4E = $a(); /*15580*/
				$k[$j++] = _4E; /*15580*/
			}); /*15580*/
			$forall($1.C2vals, function() { /*15581*/
				$k[$j++] = Infinity; /*15581*/
				var _4G = $k[--$j]; /*15581*/
				var _4H = $k[--$j]; /*15581*/
				$k[$j++] = _4G; /*15581*/
				$k[$j++] = $get($1.CNvals, $1.sft2); /*15581*/
				$k[$j++] = _4H; /*15581*/
				var _4L = $a(); /*15581*/
				$k[$j++] = _4L; /*15581*/
			}); /*15581*/
			$forall($1.C3vals, function() { /*15582*/
				$k[$j++] = Infinity; /*15582*/
				var _4N = $k[--$j]; /*15582*/
				var _4O = $k[--$j]; /*15582*/
				$k[$j++] = _4N; /*15582*/
				$k[$j++] = $get($1.CNvals, $1.sft3); /*15582*/
				$k[$j++] = _4O; /*15582*/
				var _4S = $a(); /*15582*/
				$k[$j++] = _4S; /*15582*/
			}); /*15582*/
			var _4T = $d(); /*15582*/
			$1[$k[--$j]] = _4T; /*15583*/
			$k[$j++] = "TNvals"; /*15591*/
			$k[$j++] = Infinity; /*15591*/
			$k[$j++] = $1.sft1; /*15590*/
			$k[$j++] = 0; /*15590*/
			$k[$j++] = $1.sft2; /*15590*/
			$k[$j++] = 1; /*15590*/
			$k[$j++] = $1.sft3; /*15590*/
			$k[$j++] = 2; /*15590*/
			$k[$j++] = 32; /*15590*/
			$k[$j++] = 3; /*15590*/
			for (var _4Y = 48; _4Y <= 57; _4Y += 1) { /*15590*/
				$k[$j++] = _4Y; /*15590*/
				$k[$j++] = _4Y - 44; /*15590*/
			} /*15590*/
			for (var _4Z = 97; _4Z <= 122; _4Z += 1) { /*15591*/
				$k[$j++] = _4Z; /*15591*/
				$k[$j++] = _4Z - 83; /*15591*/
			} /*15591*/
			var _4a = $d(); /*15591*/
			$1[$k[--$j]] = _4a; /*15592*/
			$k[$j++] = "T1vals"; /*15593*/
			$k[$j++] = Infinity; /*15593*/
			for (var _4c = 0; _4c <= 31; _4c += 1) { /*15593*/
				$k[$j++] = _4c; /*15593*/
				$k[$j++] = _4c; /*15593*/
			} /*15593*/
			var _4d = $d(); /*15593*/
			$1[$k[--$j]] = _4d; /*15593*/
			$k[$j++] = "T2vals"; /*15599*/
			$k[$j++] = Infinity; /*15599*/
			for (var _4f = 33; _4f <= 47; _4f += 1) { /*15595*/
				$k[$j++] = _4f; /*15595*/
				$k[$j++] = _4f - 33; /*15595*/
			} /*15595*/
			for (var _4g = 58; _4g <= 64; _4g += 1) { /*15596*/
				$k[$j++] = _4g; /*15596*/
				$k[$j++] = _4g - 43; /*15596*/
			} /*15596*/
			for (var _4h = 91; _4h <= 95; _4h += 1) { /*15597*/
				$k[$j++] = _4h; /*15597*/
				$k[$j++] = _4h - 69; /*15597*/
			} /*15597*/
			$k[$j++] = $1.fnc1; /*15599*/
			$k[$j++] = 27; /*15599*/
			$k[$j++] = $1.usft; /*15599*/
			$k[$j++] = 30; /*15599*/
			var _4k = $d(); /*15599*/
			$1[$k[--$j]] = _4k; /*15600*/
			$k[$j++] = "T3vals"; /*15604*/
			$k[$j++] = Infinity; /*15604*/
			$k[$j++] = 96; /*15603*/
			$k[$j++] = 0; /*15603*/
			for (var _4m = 65; _4m <= 90; _4m += 1) { /*15603*/
				$k[$j++] = _4m; /*15603*/
				$k[$j++] = _4m - 64; /*15603*/
			} /*15603*/
			for (var _4n = 123; _4n <= 127; _4n += 1) { /*15604*/
				$k[$j++] = _4n; /*15604*/
				$k[$j++] = _4n - 96; /*15604*/
			} /*15604*/
			var _4o = $d(); /*15604*/
			$1[$k[--$j]] = _4o; /*15605*/
			$k[$j++] = "Tvals"; /*15610*/
			$k[$j++] = Infinity; /*15610*/
			$forall($1.TNvals, function() { /*15607*/
				$k[$j++] = Infinity; /*15607*/
				var _4r = $k[--$j]; /*15607*/
				var _4s = $k[--$j]; /*15607*/
				$k[$j++] = _4r; /*15607*/
				$k[$j++] = _4s; /*15607*/
				var _4t = $a(); /*15607*/
				$k[$j++] = _4t; /*15607*/
			}); /*15607*/
			$forall($1.T1vals, function() { /*15608*/
				$k[$j++] = Infinity; /*15608*/
				var _4v = $k[--$j]; /*15608*/
				var _4w = $k[--$j]; /*15608*/
				$k[$j++] = _4v; /*15608*/
				$k[$j++] = $get($1.TNvals, $1.sft1); /*15608*/
				$k[$j++] = _4w; /*15608*/
				var _50 = $a(); /*15608*/
				$k[$j++] = _50; /*15608*/
			}); /*15608*/
			$forall($1.T2vals, function() { /*15609*/
				$k[$j++] = Infinity; /*15609*/
				var _52 = $k[--$j]; /*15609*/
				var _53 = $k[--$j]; /*15609*/
				$k[$j++] = _52; /*15609*/
				$k[$j++] = $get($1.TNvals, $1.sft2); /*15609*/
				$k[$j++] = _53; /*15609*/
				var _57 = $a(); /*15609*/
				$k[$j++] = _57; /*15609*/
			}); /*15609*/
			$forall($1.T3vals, function() { /*15610*/
				$k[$j++] = Infinity; /*15610*/
				var _59 = $k[--$j]; /*15610*/
				var _5A = $k[--$j]; /*15610*/
				$k[$j++] = _59; /*15610*/
				$k[$j++] = $get($1.TNvals, $1.sft3); /*15610*/
				$k[$j++] = _5A; /*15610*/
				var _5E = $a(); /*15610*/
				$k[$j++] = _5E; /*15610*/
			}); /*15610*/
			var _5F = $d(); /*15610*/
			$1[$k[--$j]] = _5F; /*15611*/
			for (var _5H = 128; _5H <= 255; _5H += 1) { /*15619*/
				$1.i = _5H; /*15615*/
				$k[$j++] = $1.Avals; /*15616*/
				$k[$j++] = $1.i; /*15616*/
				$k[$j++] = Infinity; /*15616*/
				$aload($get($1.Avals, $1.usft)); /*15616*/
				$aload($get($1.Avals, $1.i - 128)); /*15616*/
				var _5Q = $a(); /*15616*/
				var _5R = $k[--$j]; /*15616*/
				$put($k[--$j], _5R, _5Q); /*15616*/
				$k[$j++] = $1.Cvals; /*15617*/
				$k[$j++] = $1.i; /*15617*/
				$k[$j++] = Infinity; /*15617*/
				$aload($get($1.Cvals, $1.usft)); /*15617*/
				$aload($get($1.Cvals, $1.i - 128)); /*15617*/
				var _5b = $a(); /*15617*/
				var _5c = $k[--$j]; /*15617*/
				$put($k[--$j], _5c, _5b); /*15617*/
				$k[$j++] = $1.Tvals; /*15618*/
				$k[$j++] = $1.i; /*15618*/
				$k[$j++] = Infinity; /*15618*/
				$aload($get($1.Tvals, $1.usft)); /*15618*/
				$aload($get($1.Tvals, $1.i - 128)); /*15618*/
				var _5m = $a(); /*15618*/
				var _5n = $k[--$j]; /*15618*/
				$put($k[--$j], _5n, _5m); /*15618*/
			} /*15618*/
			$k[$j++] = "Xvals"; /*15627*/
			$k[$j++] = Infinity; /*15627*/
			$k[$j++] = 13; /*15626*/
			$k[$j++] = 0; /*15626*/
			$k[$j++] = 42; /*15626*/
			$k[$j++] = 1; /*15626*/
			$k[$j++] = 62; /*15626*/
			$k[$j++] = 2; /*15626*/
			$k[$j++] = 32; /*15626*/
			$k[$j++] = 3; /*15626*/
			for (var _5p = 48; _5p <= 57; _5p += 1) { /*15626*/
				$k[$j++] = _5p; /*15626*/
				$k[$j++] = _5p - 44; /*15626*/
			} /*15626*/
			for (var _5q = 65; _5q <= 90; _5q += 1) { /*15627*/
				$k[$j++] = _5q; /*15627*/
				$k[$j++] = _5q - 51; /*15627*/
			} /*15627*/
			var _5r = $d(); /*15627*/
			$1[$k[--$j]] = _5r; /*15628*/
			$k[$j++] = "Xvals"; /*15630*/
			$k[$j++] = Infinity; /*15630*/
			$forall($1.Xvals, function() { /*15630*/
				$k[$j++] = Infinity; /*15630*/
				var _5u = $k[--$j]; /*15630*/
				var _5v = $k[--$j]; /*15630*/
				$k[$j++] = _5u; /*15630*/
				$k[$j++] = _5v; /*15630*/
				var _5w = $a(); /*15630*/
				$k[$j++] = _5w; /*15630*/
			}); /*15630*/
			var _5x = $d(); /*15630*/
			$1[$k[--$j]] = _5x; /*15631*/
			$k[$j++] = "Evals"; /*15636*/
			$k[$j++] = Infinity; /*15636*/
			for (var _5z = 64; _5z <= 94; _5z += 1) { /*15634*/
				$k[$j++] = _5z; /*15634*/
				$k[$j++] = _5z - 64; /*15634*/
			} /*15634*/
			$k[$j++] = $1.unl; /*15636*/
			$k[$j++] = 31; /*15636*/
			for (var _61 = 32; _61 <= 63; _61 += 1) { /*15636*/
				$k[$j++] = _61; /*15636*/
				$k[$j++] = _61; /*15636*/
			} /*15636*/
			var _62 = $d(); /*15636*/
			$1[$k[--$j]] = _62; /*15637*/
			$k[$j++] = "Evals"; /*15639*/
			$k[$j++] = Infinity; /*15639*/
			$forall($1.Evals, function() { /*15639*/
				$k[$j++] = Infinity; /*15639*/
				var _65 = $k[--$j]; /*15639*/
				var _66 = $k[--$j]; /*15639*/
				$k[$j++] = _65; /*15639*/
				$k[$j++] = _66; /*15639*/
				var _67 = $a(); /*15639*/
				$k[$j++] = _67; /*15639*/
			}); /*15639*/
			var _68 = $d(); /*15639*/
			$1[$k[--$j]] = _68; /*15640*/
			$k[$j++] = "Bvals"; /*15643*/
			$k[$j++] = Infinity; /*15643*/
			for (var _6A = 0; _6A <= 255; _6A += 1) { /*15643*/
				$k[$j++] = _6A; /*15643*/
				$k[$j++] = _6A; /*15643*/
			} /*15643*/
			var _6B = $d(); /*15643*/
			$1[$k[--$j]] = _6B; /*15644*/
			$k[$j++] = "Bvals"; /*15646*/
			$k[$j++] = Infinity; /*15646*/
			$forall($1.Bvals, function() { /*15646*/
				$k[$j++] = Infinity; /*15646*/
				var _6E = $k[--$j]; /*15646*/
				var _6F = $k[--$j]; /*15646*/
				$k[$j++] = _6E; /*15646*/
				$k[$j++] = _6F; /*15646*/
				var _6G = $a(); /*15646*/
				$k[$j++] = _6G; /*15646*/
			}); /*15646*/
			var _6H = $d(); /*15646*/
			$1[$k[--$j]] = _6H; /*15647*/
			$1.encvals = $a([$1.Avals, $1.Cvals, $1.Tvals, $1.Xvals, $1.Evals, $1.Bvals]); /*15649*/
			$k[$j++] = Infinity; /*15651*/
			for (var _6R = 0, _6S = $1.msglen; _6R < _6S; _6R++) { /*15651*/
				$k[$j++] = 0; /*15651*/
			} /*15651*/
			$k[$j++] = 0; /*15651*/
			$1.numD = $a(); /*15651*/
			$k[$j++] = Infinity; /*15652*/
			for (var _6V = 0, _6W = $1.msglen; _6V < _6W; _6V++) { /*15652*/
				$k[$j++] = 0; /*15652*/
			} /*15652*/
			$k[$j++] = 9999; /*15652*/
			$1.nextXterm = $a(); /*15652*/
			$k[$j++] = Infinity; /*15653*/
			for (var _6Z = 0, _6a = $1.msglen; _6Z < _6a; _6Z++) { /*15653*/
				$k[$j++] = 0; /*15653*/
			} /*15653*/
			$k[$j++] = 9999; /*15653*/
			$1.nextNonX = $a(); /*15653*/
			for (var _6d = $1.msglen - 1; _6d >= 0; _6d -= 1) { /*15670*/
				$1.i = _6d; /*15655*/
				$1.barchar = $get($1.msg, $1.i); /*15656*/
				if (($1.barchar >= 48) && ($1.barchar <= 57)) { /*15659*/
					$put($1.numD, $1.i, $get($1.numD, $1.i + 1) + 1); /*15658*/
				} /*15658*/
				if ((($1.barchar == 13) || ($1.barchar == 42)) || ($1.barchar == 62)) { /*15663*/
					$put($1.nextXterm, $1.i, 0); /*15661*/
				} else { /*15663*/
					$put($1.nextXterm, $1.i, $get($1.nextXterm, $1.i + 1) + 1); /*15663*/
				} /*15663*/
				var _70 = $get($1.Xvals, $1.barchar) !== undefined; /*15665*/
				if (!_70) { /*15668*/
					$put($1.nextNonX, $1.i, 0); /*15666*/
				} else { /*15668*/
					$put($1.nextNonX, $1.i, $get($1.nextNonX, $1.i + 1) + 1); /*15668*/
				} /*15668*/
			} /*15668*/
			$k[$j++] = Infinity; /*15671*/
			var _78 = $1.nextXterm; /*15671*/
			for (var _79 = 0, _7A = _78.length; _79 < _7A; _79++) { /*15671*/
				var _7B = $get(_78, _79); /*15671*/
				$k[$j++] = _7B; /*15671*/
				if (_7B > 10000) { /*15671*/
					$j--; /*15671*/
					$k[$j++] = 10000; /*15671*/
				} /*15671*/
			} /*15671*/
			$1.nextXterm = $a(); /*15671*/
			$k[$j++] = Infinity; /*15672*/
			var _7D = $1.nextNonX; /*15672*/
			for (var _7E = 0, _7F = _7D.length; _7E < _7F; _7E++) { /*15672*/
				var _7G = $get(_7D, _7E); /*15672*/
				$k[$j++] = _7G; /*15672*/
				if (_7G > 10000) { /*15672*/
					$j--; /*15672*/
					$k[$j++] = 10000; /*15672*/
				} /*15672*/
			} /*15672*/
			$1.nextNonX = $a(); /*15672*/
			$1.isD = function() {
				$k[$j++] = ($1.char >= 48) && ($1.char <= 57); /*15674*/
			}; /*15674*/
			$1.isC = function() {
				var _7M = $get($1.CNvals, $1.char) !== undefined; /*15675*/
				$k[$j++] = _7M; /*15675*/
			}; /*15675*/
			$1.isT = function() {
				var _7P = $get($1.TNvals, $1.char) !== undefined; /*15676*/
				$k[$j++] = _7P; /*15676*/
			}; /*15676*/
			$1.isX = function() {
				var _7S = $get($1.Xvals, $1.char) !== undefined; /*15677*/
				$k[$j++] = _7S; /*15677*/
			}; /*15677*/
			$1.isE = function() {
				var _7V = $get($1.Evals, $1.char) !== undefined; /*15678*/
				$k[$j++] = _7V; /*15678*/
			}; /*15678*/
			$1.isEA = function() {
				$k[$j++] = $1.char > 127; /*15679*/
			}; /*15679*/
			$1.isFN = function() {
				$k[$j++] = $1.char < 0; /*15680*/
			}; /*15680*/
			$1.XtermFirst = function() {
				var _7Y = $k[--$j]; /*15681*/
				$k[$j++] = $lt($get($1.nextXterm, _7Y), $get($1.nextNonX, _7Y)); /*15681*/
			}; /*15681*/
			$1.A = 0; /*15683*/
			$1.C = 1; /*15683*/
			$1.T = 2; /*15683*/
			$1.X = 3; /*15683*/
			$1.E = 4; /*15683*/
			$1.B = 5; /*15683*/
			$1.lookup = function() {
				$1.ac = 1; /*15686*/
				$1.cc = 2; /*15686*/
				$1.tc = 2; /*15686*/
				$1.xc = 2; /*15686*/
				$1.ec = 2; /*15686*/
				$1.bc = 2.25; /*15686*/
				if ($1.mode == $1.A) { /*15687*/
					$1.ac = 0; /*15687*/
					$1.cc = 1; /*15687*/
					$1.tc = 1; /*15687*/
					$1.xc = 1; /*15687*/
					$1.ec = 1; /*15687*/
					$1.bc = 1.25; /*15687*/
				} /*15687*/
				if ($1.mode == $1.C) { /*15688*/
					$1.cc = 0; /*15688*/
				} /*15688*/
				if ($1.mode == $1.T) { /*15689*/
					$1.tc = 0; /*15689*/
				} /*15689*/
				if ($1.mode == $1.X) { /*15690*/
					$1.xc = 0; /*15690*/
				} /*15690*/
				if ($1.mode == $1.E) { /*15691*/
					$1.ec = 0; /*15691*/
				} /*15691*/
				if ($1.mode == $1.B) { /*15692*/
					$1.bc = 0; /*15692*/
				} /*15692*/
				for (var _7p = 0, _7q = 1; _7p < _7q; _7p++) { /*15725*/
					$1.k = 0; /*15694*/
					for (;;) { /*15724*/
						if (($1.i + $1.k) == $1.msglen) { /*15703*/
							var _7u = $a(["ac", "cc", "tc", "xc", "ec", "bc"]); /*15696*/
							for (var _7v = 0, _7w = _7u.length; _7v < _7w; _7v++) { /*15696*/
								var _7x = $get(_7u, _7v); /*15696*/
								$1[_7x] = Math.ceil($1[_7x]); /*15696*/
							} /*15696*/
							var _84 = $a([$1.cc, $1.tc, $1.xc, $1.ec, $1.bc]); /*15697*/
							$k[$j++] = true; /*15697*/
							for (var _85 = 0, _86 = _84.length; _85 < _86; _85++) { /*15697*/
								var _89 = $k[--$j]; /*15697*/
								$k[$j++] = _89 && ($1.ac <= $get(_84, _85)); /*15697*/
							} /*15697*/
							if ($k[--$j]) { /*15697*/
								$k[$j++] = $1.A; /*15697*/
								break; /*15697*/
							} /*15697*/
							var _8H = $a([$1.ac, $1.cc, $1.tc, $1.xc, $1.ec]); /*15698*/
							$k[$j++] = true; /*15698*/
							for (var _8I = 0, _8J = _8H.length; _8I < _8J; _8I++) { /*15698*/
								var _8M = $k[--$j]; /*15698*/
								$k[$j++] = _8M && ($1.bc < $get(_8H, _8I)); /*15698*/
							} /*15698*/
							if ($k[--$j]) { /*15698*/
								$k[$j++] = $1.B; /*15698*/
								break; /*15698*/
							} /*15698*/
							var _8U = $a([$1.ac, $1.cc, $1.tc, $1.xc, $1.bc]); /*15699*/
							$k[$j++] = true; /*15699*/
							for (var _8V = 0, _8W = _8U.length; _8V < _8W; _8V++) { /*15699*/
								var _8Z = $k[--$j]; /*15699*/
								$k[$j++] = _8Z && ($1.ec < $get(_8U, _8V)); /*15699*/
							} /*15699*/
							if ($k[--$j]) { /*15699*/
								$k[$j++] = $1.E; /*15699*/
								break; /*15699*/
							} /*15699*/
							var _8h = $a([$1.ac, $1.cc, $1.xc, $1.ec, $1.bc]); /*15700*/
							$k[$j++] = true; /*15700*/
							for (var _8i = 0, _8j = _8h.length; _8i < _8j; _8i++) { /*15700*/
								var _8m = $k[--$j]; /*15700*/
								$k[$j++] = _8m && ($1.tc < $get(_8h, _8i)); /*15700*/
							} /*15700*/
							if ($k[--$j]) { /*15700*/
								$k[$j++] = $1.T; /*15700*/
								break; /*15700*/
							} /*15700*/
							var _8u = $a([$1.ac, $1.cc, $1.tc, $1.ec, $1.bc]); /*15701*/
							$k[$j++] = true; /*15701*/
							for (var _8v = 0, _8w = _8u.length; _8v < _8w; _8v++) { /*15701*/
								var _8z = $k[--$j]; /*15701*/
								$k[$j++] = _8z && ($1.xc < $get(_8u, _8v)); /*15701*/
							} /*15701*/
							if ($k[--$j]) { /*15701*/
								$k[$j++] = $1.X; /*15701*/
								break; /*15701*/
							} /*15701*/
							$k[$j++] = $1.C; /*15702*/
							break; /*15702*/
						} /*15702*/
						$1.char = $get($1.msg, $1.i + $1.k); /*15704*/
						$k[$j++] = "ac"; /*15705*/
						$k[$j++] = $1.ac; /*15705*/
						if ($1.isD() == $b) break; /*15705*/
						if ($k[--$j]) { /*15705*/
							var _99 = $k[--$j]; /*15705*/
							$k[$j++] = _99 + (1 / 2); /*15705*/
						} else { /*15705*/
							if ($1.isEA() == $b) break; /*15705*/
							if ($k[--$j]) { /*15705*/
								var _9B = $k[--$j]; /*15705*/
								$k[$j++] = Math.ceil(_9B) + 2; /*15705*/
							} else { /*15705*/
								var _9C = $k[--$j]; /*15705*/
								$k[$j++] = Math.ceil(_9C) + 1; /*15705*/
							} /*15705*/
						} /*15705*/
						var _9D = $k[--$j]; /*15705*/
						$1[$k[--$j]] = _9D; /*15705*/
						$k[$j++] = "cc"; /*15706*/
						$k[$j++] = $1.cc; /*15706*/
						if ($1.isC() == $b) break; /*15706*/
						if ($k[--$j]) { /*15706*/
							var _9H = $k[--$j]; /*15706*/
							$k[$j++] = _9H + (2 / 3); /*15706*/
						} else { /*15706*/
							if ($1.isEA() == $b) break; /*15706*/
							if ($k[--$j]) { /*15706*/
								var _9J = $k[--$j]; /*15706*/
								$k[$j++] = _9J + (8 / 3); /*15706*/
							} else { /*15706*/
								var _9K = $k[--$j]; /*15706*/
								$k[$j++] = _9K + (4 / 3); /*15706*/
							} /*15706*/
						} /*15706*/
						var _9L = $k[--$j]; /*15706*/
						$1[$k[--$j]] = _9L; /*15706*/
						$k[$j++] = "tc"; /*15707*/
						$k[$j++] = $1.tc; /*15707*/
						if ($1.isT() == $b) break; /*15707*/
						if ($k[--$j]) { /*15707*/
							var _9P = $k[--$j]; /*15707*/
							$k[$j++] = _9P + (2 / 3); /*15707*/
						} else { /*15707*/
							if ($1.isEA() == $b) break; /*15707*/
							if ($k[--$j]) { /*15707*/
								var _9R = $k[--$j]; /*15707*/
								$k[$j++] = _9R + (8 / 3); /*15707*/
							} else { /*15707*/
								var _9S = $k[--$j]; /*15707*/
								$k[$j++] = _9S + (4 / 3); /*15707*/
							} /*15707*/
						} /*15707*/
						var _9T = $k[--$j]; /*15707*/
						$1[$k[--$j]] = _9T; /*15707*/
						$k[$j++] = "xc"; /*15708*/
						$k[$j++] = $1.xc; /*15708*/
						if ($1.isX() == $b) break; /*15708*/
						if ($k[--$j]) { /*15708*/
							var _9X = $k[--$j]; /*15708*/
							$k[$j++] = _9X + (2 / 3); /*15708*/
						} else { /*15708*/
							if ($1.isEA() == $b) break; /*15708*/
							if ($k[--$j]) { /*15708*/
								var _9Z = $k[--$j]; /*15708*/
								$k[$j++] = _9Z + (13 / 3); /*15708*/
							} else { /*15708*/
								var _9a = $k[--$j]; /*15708*/
								$k[$j++] = _9a + (10 / 3); /*15708*/
							} /*15708*/
						} /*15708*/
						var _9b = $k[--$j]; /*15708*/
						$1[$k[--$j]] = _9b; /*15708*/
						$k[$j++] = "ec"; /*15709*/
						$k[$j++] = $1.ec; /*15709*/
						if ($1.isE() == $b) break; /*15709*/
						if ($k[--$j]) { /*15709*/
							var _9f = $k[--$j]; /*15709*/
							$k[$j++] = _9f + (3 / 4); /*15709*/
						} else { /*15709*/
							if ($1.isEA() == $b) break; /*15709*/
							if ($k[--$j]) { /*15709*/
								var _9h = $k[--$j]; /*15709*/
								$k[$j++] = _9h + (17 / 4); /*15709*/
							} else { /*15709*/
								var _9i = $k[--$j]; /*15709*/
								$k[$j++] = _9i + (13 / 4); /*15709*/
							} /*15709*/
						} /*15709*/
						var _9j = $k[--$j]; /*15709*/
						$1[$k[--$j]] = _9j; /*15709*/
						$k[$j++] = "bc"; /*15710*/
						$k[$j++] = $1.bc; /*15710*/
						if ($1.isFN() == $b) break; /*15710*/
						if ($k[--$j]) { /*15710*/
							var _9n = $k[--$j]; /*15710*/
							$k[$j++] = _9n + 4; /*15710*/
						} else { /*15710*/
							var _9o = $k[--$j]; /*15710*/
							$k[$j++] = _9o + 1; /*15710*/
						} /*15710*/
						var _9p = $k[--$j]; /*15710*/
						$1[$k[--$j]] = _9p; /*15710*/
						if ($1.k >= 4) { /*15722*/
							var _9x = $a([$1.cc, $1.tc, $1.xc, $1.ec, $1.bc]); /*15712*/
							$k[$j++] = true; /*15712*/
							for (var _9y = 0, _9z = _9x.length; _9y < _9z; _9y++) { /*15712*/
								var _A2 = $k[--$j]; /*15712*/
								$k[$j++] = _A2 && (($1.ac + 1) <= $get(_9x, _9y)); /*15712*/
							} /*15712*/
							if ($k[--$j]) { /*15712*/
								$k[$j++] = $1.A; /*15712*/
								break; /*15712*/
							} /*15712*/
							if (($1.bc + 1) <= $1.ac) { /*15713*/
								$k[$j++] = $1.B; /*15713*/
								break; /*15713*/
							} /*15713*/
							var _AC = $a([$1.cc, $1.tc, $1.xc, $1.ec]); /*15714*/
							$k[$j++] = true; /*15714*/
							for (var _AD = 0, _AE = _AC.length; _AD < _AE; _AD++) { /*15714*/
								var _AH = $k[--$j]; /*15714*/
								$k[$j++] = _AH && (($1.bc + 1) < $get(_AC, _AD)); /*15714*/
							} /*15714*/
							if ($k[--$j]) { /*15714*/
								$k[$j++] = $1.B; /*15714*/
								break; /*15714*/
							} /*15714*/
							var _AP = $a([$1.ac, $1.cc, $1.tc, $1.xc, $1.bc]); /*15715*/
							$k[$j++] = true; /*15715*/
							for (var _AQ = 0, _AR = _AP.length; _AQ < _AR; _AQ++) { /*15715*/
								var _AU = $k[--$j]; /*15715*/
								$k[$j++] = _AU && (($1.ec + 1) < $get(_AP, _AQ)); /*15715*/
							} /*15715*/
							if ($k[--$j]) { /*15715*/
								$k[$j++] = $1.E; /*15715*/
								break; /*15715*/
							} /*15715*/
							var _Ac = $a([$1.ac, $1.cc, $1.xc, $1.ec, $1.bc]); /*15716*/
							$k[$j++] = true; /*15716*/
							for (var _Ad = 0, _Ae = _Ac.length; _Ad < _Ae; _Ad++) { /*15716*/
								var _Ah = $k[--$j]; /*15716*/
								$k[$j++] = _Ah && (($1.tc + 1) < $get(_Ac, _Ad)); /*15716*/
							} /*15716*/
							if ($k[--$j]) { /*15716*/
								$k[$j++] = $1.T; /*15716*/
								break; /*15716*/
							} /*15716*/
							var _Ap = $a([$1.ac, $1.cc, $1.tc, $1.ec, $1.bc]); /*15717*/
							$k[$j++] = true; /*15717*/
							for (var _Aq = 0, _Ar = _Ap.length; _Aq < _Ar; _Aq++) { /*15717*/
								var _Au = $k[--$j]; /*15717*/
								$k[$j++] = _Au && (($1.xc + 1) < $get(_Ap, _Aq)); /*15717*/
							} /*15717*/
							if ($k[--$j]) { /*15717*/
								$k[$j++] = $1.X; /*15717*/
								break; /*15717*/
							} /*15717*/
							var _B1 = $a([$1.ac, $1.tc, $1.ec, $1.bc]); /*15718*/
							$k[$j++] = true; /*15718*/
							for (var _B2 = 0, _B3 = _B1.length; _B2 < _B3; _B2++) { /*15718*/
								var _B6 = $k[--$j]; /*15718*/
								$k[$j++] = _B6 && (($1.cc + 1) < $get(_B1, _B2)); /*15718*/
							} /*15718*/
							if ($k[--$j]) { /*15721*/
								if ($1.cc < $1.xc) { /*15719*/
									$k[$j++] = $1.C; /*15719*/
									break; /*15719*/
								} /*15719*/
								if ($1.cc == $1.xc) { /*15720*/
									$k[$j++] = ($1.i + $1.k) + 1; /*15720*/
									if ($1.XtermFirst() == $b) break; /*15720*/
									if ($k[--$j]) { /*15720*/
										$k[$j++] = $1.X; /*15720*/
										break; /*15720*/
									} else { /*15720*/
										$k[$j++] = $1.C; /*15720*/
										break; /*15720*/
									} /*15720*/
								} /*15720*/
							} /*15720*/
						} /*15720*/
						$1.k = $1.k + 1; /*15723*/
					} /*15723*/
				} /*15723*/
			}; /*15726*/
			$1.addtocws = function() {
				var _BJ = $k[--$j]; /*15729*/
				$puti($1.cws, $1.j, _BJ); /*15729*/
				$1.j = _BJ.length + $1.j; /*15730*/
			}; /*15731*/
			$1.encA = function() {
				for (var _BN = 0, _BO = 1; _BN < _BO; _BN++) { /*15749*/
					if ($get($1.numD, $1.i) >= 2) { /*15739*/
						var _BS = $s(2); /*15736*/
						$put(_BS, 0, $get($1.msg, $1.i)); /*15736*/
						$put(_BS, 1, $get($1.msg, $1.i + 1)); /*15736*/
						$k[$j++] = $get($1.Avals, _BS); /*15736*/
						if ($1.addtocws() == $b) break; /*15736*/
						$1.i = $1.i + 2; /*15737*/
						break; /*15738*/
					} /*15738*/
					$k[$j++] = "newmode"; /*15740*/
					if ($1.lookup() == $b) break; /*15740*/
					var _Bc = $k[--$j]; /*15740*/
					$1[$k[--$j]] = _Bc; /*15740*/
					if ($1.newmode != $1.mode) { /*15745*/
						$k[$j++] = $get($1.Avals, $get($a([-1, $1.lC, $1.lT, $1.lX, $1.lE, $1.lB]), $1.newmode)); /*15742*/
						if ($1.addtocws() == $b) break; /*15742*/
						$1.mode = $1.newmode; /*15743*/
						break; /*15744*/
					} /*15744*/
					$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15746*/
					if ($1.addtocws() == $b) break; /*15746*/
					$1.i = $1.i + 1; /*15747*/
					break; /*15748*/
				} /*15748*/
			}; /*15750*/
			$1.CTXvalstocws = function() {
				$1.in = $k[--$j]; /*15753*/
				$k[$j++] = Infinity; /*15754*/
				for (var _C0 = 0, _Bz = $1.in.length - 1; _C0 <= _Bz; _C0 += 3) { /*15758*/
					$k[$j++] = 0; /*15756*/
					$forall($geti($1.in, _C0, 3), function() { /*15756*/
						var _C3 = $k[--$j]; /*15756*/
						var _C4 = $k[--$j]; /*15756*/
						$k[$j++] = (_C4 + _C3) * 40; /*15756*/
					}); /*15756*/
					var _C6 = (~~($k[--$j] / 40)) + 1; /*15757*/
					$k[$j++] = ~~(_C6 / 256); /*15757*/
					$k[$j++] = _C6 % 256; /*15757*/
				} /*15757*/
				$astore($a($counttomark())); /*15759*/
				var _C9 = $k[--$j]; /*15759*/
				var _CA = $k[--$j]; /*15759*/
				$k[$j++] = _C9; /*15759*/
			}; /*15760*/
			$1.encCTX = function() {
				$1.p = 0; /*15763*/
				$1.ctxvals = $a(2500); /*15764*/
				$1.done = false; /*15765*/
				for (;;) { /*15842*/
					if ($1.i == $1.msglen) { /*15769*/
						break; /*15769*/
					} /*15769*/
					var _CK = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)) !== undefined; /*15770*/
					if (!_CK) { /*15770*/
						break; /*15770*/
					} /*15770*/
					if (($1.p % 3) == 0) { /*15837*/
						$k[$j++] = "newmode"; /*15772*/
						if ($1.lookup() == $b) break; /*15772*/
						var _CM = $k[--$j]; /*15772*/
						$1[$k[--$j]] = _CM; /*15772*/
						if ($ne($1.newmode, $1.mode)) { /*15782*/
							$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*15774*/
							if ($1.CTXvalstocws() == $b) break; /*15774*/
							if ($1.addtocws() == $b) break; /*15774*/
							$k[$j++] = $a([$1.unlcw]); /*15775*/
							if ($1.addtocws() == $b) break; /*15775*/
							if ($1.newmode != $1.A) { /*15778*/
								$k[$j++] = $get($1.Avals, $get($a([-1, $1.lC, $1.lT, $1.lX, $1.lE, $1.lB]), $1.newmode)); /*15777*/
								if ($1.addtocws() == $b) break; /*15777*/
							} /*15777*/
							$1.mode = $1.newmode; /*15779*/
							$1.done = true; /*15780*/
							break; /*15781*/
						} /*15781*/
						if (($1.msglen - $1.i) <= 3) { /*15836*/
							$1.remcws = $get($1.numremcws, $1.j + ((~~($1.p / 3)) * 2)); /*15784*/
							$k[$j++] = Infinity; /*15793*/
							$forall($geti($1.msg, $1.i, $1.msglen - $1.i), function() { /*15792*/
								var _Ct = $k[--$j]; /*15787*/
								var _Cx = $get($get($1.encvals, $1.mode), _Ct) !== undefined; /*15787*/
								$k[$j++] = _Ct; /*15791*/
								if (_Cx) { /*15790*/
									$aload($get($get($1.encvals, $1.mode), $k[--$j])); /*15788*/
								} else { /*15790*/
									$j--; /*15790*/
									$k[$j++] = -1; /*15790*/
									$k[$j++] = -1; /*15790*/
									$k[$j++] = -1; /*15790*/
									$k[$j++] = -1; /*15790*/
								} /*15790*/
							}); /*15790*/
							$1.remvals = $a(); /*15793*/
							if (($1.remcws == 2) && ($1.remvals.length == 3)) { /*15804*/
								$k[$j++] = Infinity; /*15798*/
								$aload($geti($1.ctxvals, 0, $1.p)); /*15797*/
								$aload($1.remvals); /*15798*/
								var _DA = $a(); /*15798*/
								$k[$j++] = _DA; /*15799*/
								if ($1.CTXvalstocws() == $b) break; /*15799*/
								if ($1.addtocws() == $b) break; /*15799*/
								$1.mode = $1.A; /*15800*/
								$1.i = $1.msglen; /*15801*/
								$1.done = true; /*15802*/
								break; /*15803*/
							} /*15803*/
							if ((($1.remcws == 2) && ($1.remvals.length == 2)) && ($1.mode != $1.X)) { /*15816*/
								$k[$j++] = Infinity; /*15810*/
								$aload($geti($1.ctxvals, 0, $1.p)); /*15808*/
								$aload($1.remvals); /*15809*/
								$aload($get($get($1.encvals, $1.mode), $1.sft1)); /*15810*/
								var _DQ = $a(); /*15810*/
								$k[$j++] = _DQ; /*15811*/
								if ($1.CTXvalstocws() == $b) break; /*15811*/
								if ($1.addtocws() == $b) break; /*15811*/
								$1.mode = $1.A; /*15812*/
								$1.i = $1.msglen; /*15813*/
								$1.done = true; /*15814*/
								break; /*15815*/
							} /*15815*/
							if (($1.remcws == 2) && ($1.remvals.length == 1)) { /*15826*/
								$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*15819*/
								if ($1.CTXvalstocws() == $b) break; /*15819*/
								if ($1.addtocws() == $b) break; /*15819*/
								$k[$j++] = $a([$1.unlcw]); /*15820*/
								if ($1.addtocws() == $b) break; /*15820*/
								$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15821*/
								if ($1.addtocws() == $b) break; /*15821*/
								$1.mode = $1.A; /*15822*/
								$1.i = $1.msglen; /*15823*/
								$1.done = true; /*15824*/
								break; /*15825*/
							} /*15825*/
							if (($1.remcws == 1) && ($1.remvals.length == 1)) { /*15835*/
								$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*15829*/
								if ($1.CTXvalstocws() == $b) break; /*15829*/
								if ($1.addtocws() == $b) break; /*15829*/
								$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15830*/
								if ($1.addtocws() == $b) break; /*15830*/
								$1.mode = $1.A; /*15831*/
								$1.i = $1.msglen; /*15832*/
								$1.done = true; /*15833*/
								break; /*15834*/
							} /*15834*/
						} /*15834*/
					} /*15834*/
					var _Dz = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)); /*15838*/
					$puti($1.ctxvals, $1.p, _Dz); /*15839*/
					$1.p = _Dz.length + $1.p; /*15840*/
					$1.i = $1.i + 1; /*15841*/
				} /*15841*/
				if (!$1.done) { /*15866*/
					for (;;) { /*15850*/
						if (($1.p % 3) == 0) { /*15847*/
							break; /*15847*/
						} /*15847*/
						$1.i = $1.i - 1; /*15848*/
						$1.p = $1.p - $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)).length; /*15849*/
					} /*15849*/
					$k[$j++] = Infinity; /*15852*/
					$aload($geti($1.ctxvals, 0, $1.p)); /*15852*/
					var _EI = $a(); /*15852*/
					$k[$j++] = _EI; /*15853*/
					if ($1.CTXvalstocws() == $b) return $b; /*15853*/
					if ($1.addtocws() == $b) return $b; /*15853*/
					$k[$j++] = $a([$1.unlcw]); /*15854*/
					if ($1.addtocws() == $b) return $b; /*15854*/
					$1.mode = $1.A; /*15855*/
					if ($1.i != $1.msglen) { /*15865*/
						if ($get($1.numD, $1.i) >= 2) { /*15863*/
							var _ER = $s(2); /*15859*/
							$put(_ER, 0, $get($1.msg, $1.i)); /*15859*/
							$put(_ER, 1, $get($1.msg, $1.i + 1)); /*15859*/
							$k[$j++] = $get($1.Avals, _ER); /*15859*/
							if ($1.addtocws() == $b) return $b; /*15859*/
							$1.i = $1.i + 2; /*15860*/
						} else { /*15863*/
							$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15862*/
							if ($1.addtocws() == $b) return $b; /*15862*/
							$1.i = $1.i + 1; /*15863*/
						} /*15863*/
					} /*15863*/
				} /*15863*/
			}; /*15868*/
			$1.Evalstocws = function() {
				$1.in = $k[--$j]; /*15871*/
				$1.inlen = $1.in.length; /*15872*/
				$1.outlen = ~~(Math.ceil(($1.in.length / 4) * 3)); /*15873*/
				$k[$j++] = Infinity; /*15874*/
				$aload($1.in); /*15874*/
				$k[$j++] = 0; /*15874*/
				$k[$j++] = 0; /*15874*/
				$k[$j++] = 0; /*15874*/
				$1.in = $a(); /*15874*/
				$k[$j++] = Infinity; /*15875*/
				for (var _Eo = 0, _En = $1.inlen - 1; _Eo <= _En; _Eo += 4) { /*15881*/
					$k[$j++] = 0; /*15877*/
					$forall($geti($1.in, _Eo, 4), function() { /*15877*/
						var _Er = $k[--$j]; /*15877*/
						var _Es = $k[--$j]; /*15877*/
						$k[$j++] = $or(_Es, _Er) << 6; /*15877*/
					}); /*15877*/
					var _Eu = $k[--$j] >>> 6; /*15878*/
					$k[$j++] = (_Eu >>> 16) & 255; /*15880*/
					$k[$j++] = (_Eu >>> 8) & 255; /*15880*/
					$k[$j++] = _Eu & 255; /*15880*/
				} /*15880*/
				$astore($a($counttomark())); /*15882*/
				var _Ex = $k[--$j]; /*15882*/
				var _Ey = $k[--$j]; /*15882*/
				$k[$j++] = $geti(_Ex, 0, $1.outlen); /*15883*/
			}; /*15884*/
			$1.encE = function() {
				$1.p = 0; /*15887*/
				$1.edifactvals = $a(2100); /*15888*/
				for (;;) { /*15917*/
					if ($1.i == $1.msglen) { /*15892*/
						break; /*15892*/
					} /*15892*/
					var _F8 = $get($1.Evals, $get($1.msg, $1.i)) !== undefined; /*15893*/
					if (!_F8) { /*15893*/
						break; /*15893*/
					} /*15893*/
					if (($1.p % 4) == 0) { /*15912*/
						if (($1.msglen - $1.i) <= 2) { /*15910*/
							$1.remcws = $get($1.numremcws, $1.j + ((~~($1.p / 4)) * 3)); /*15896*/
							$k[$j++] = Infinity; /*15901*/
							$forall($geti($1.msg, $1.i, $1.msglen - $1.i), function() { /*15900*/
								$aload($get($1.Avals, $k[--$j])); /*15899*/
							}); /*15899*/
							$1.remvals = $a(); /*15901*/
							if ((($1.remcws == 1) || ($1.remcws == 2)) && ($1.remvals.length <= $1.remcws)) { /*15909*/
								$k[$j++] = $geti($1.edifactvals, 0, $1.p); /*15904*/
								if ($1.Evalstocws() == $b) break; /*15904*/
								if ($1.addtocws() == $b) break; /*15904*/
								$k[$j++] = $1.remvals; /*15905*/
								if ($1.addtocws() == $b) break; /*15905*/
								$1.mode = $1.A; /*15906*/
								$1.i = $1.msglen; /*15907*/
								break; /*15908*/
							} /*15908*/
						} /*15908*/
						if ($1.lookup() == $b) break; /*15911*/
						if ($k[--$j] != $1.mode) { /*15911*/
							break; /*15911*/
						} /*15911*/
					} /*15911*/
					var _Ff = $get($1.Evals, $get($1.msg, $1.i)); /*15913*/
					$puti($1.edifactvals, $1.p, _Ff); /*15914*/
					$1.p = _Ff.length + $1.p; /*15915*/
					$1.i = $1.i + 1; /*15916*/
				} /*15916*/
				if ($1.mode != $1.A) { /*15939*/
					$1.remcws = $get($1.numremcws, ($1.j + ((~~($1.p / 4)) * 3)) - 1) - 1; /*15921*/
					if (((($1.p % 4) != 0) || ($1.i != $1.msglen)) || ($1.remcws >= 3)) { /*15926*/
						var _Fw = $get($1.Evals, $1.unl); /*15923*/
						$puti($1.edifactvals, $1.p, _Fw); /*15924*/
						$1.p = _Fw.length + $1.p; /*15925*/
					} /*15925*/
					$k[$j++] = $geti($1.edifactvals, 0, $1.p); /*15927*/
					if ($1.Evalstocws() == $b) return $b; /*15927*/
					if ($1.addtocws() == $b) return $b; /*15927*/
					$1.mode = $1.A; /*15928*/
					if ($1.i != $1.msglen) { /*15938*/
						if ($get($1.numD, $1.i) >= 2) { /*15936*/
							var _G9 = $s(2); /*15932*/
							$put(_G9, 0, $get($1.msg, $1.i)); /*15932*/
							$put(_G9, 1, $get($1.msg, $1.i + 1)); /*15932*/
							$k[$j++] = $get($1.Avals, _G9); /*15932*/
							if ($1.addtocws() == $b) return $b; /*15932*/
							$1.i = $1.i + 2; /*15933*/
						} else { /*15936*/
							$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*15935*/
							if ($1.addtocws() == $b) return $b; /*15935*/
							$1.i = $1.i + 1; /*15936*/
						} /*15936*/
					} /*15936*/
				} /*15936*/
			}; /*15941*/
			$1.encB = function() {
				$1.p = 0; /*15944*/
				$1.bvals = $a(1558); /*15944*/
				for (;;) { /*15950*/
					if ($1.i == $1.msglen) { /*15945*/
						break; /*15945*/
					} /*15945*/
					if ($1.lookup() == $b) break; /*15946*/
					if ($k[--$j] != $1.mode) { /*15946*/
						break; /*15946*/
					} /*15946*/
					$put($1.bvals, $1.p, $get($1.msg, $1.i)); /*15947*/
					$1.p = $1.p + 1; /*15948*/
					$1.i = $1.i + 1; /*15949*/
				} /*15949*/
				$1.remcws = $get($1.numremcws, $1.j + $1.p) - 1; /*15951*/
				$k[$j++] = Infinity; /*15959*/
				if (($1.remcws == 0) && ($1.i == $1.msglen)) { /*15956*/
					$k[$j++] = 0; /*15954*/
				} else { /*15956*/
					if ($1.p < 250) { /*15956*/
						$k[$j++] = $1.p; /*15956*/
					} else { /*15956*/
						$k[$j++] = (~~($1.p / 250)) + 249; /*15956*/
						$k[$j++] = $1.p % 250; /*15956*/
					} /*15956*/
				} /*15956*/
				$aload($geti($1.bvals, 0, $1.p)); /*15958*/
				$1.bvals = $a(); /*15959*/
				for (var _Gs = 0, _Gr = $1.bvals.length - 1; _Gs <= _Gr; _Gs += 1) { /*15965*/
					$1.p = _Gs; /*15961*/
					var _Gy = ((((($1.j + $1.p) + 1) * 149) % 255) + 1) + $get($1.bvals, $1.p); /*15963*/
					$k[$j++] = _Gy; /*15963*/
					if (_Gy >= 256) { /*15963*/
						var _Gz = $k[--$j]; /*15963*/
						$k[$j++] = _Gz - 256; /*15963*/
					} /*15963*/
					$put($1.bvals, $1.p, $k[--$j]); /*15964*/
				} /*15964*/
				$k[$j++] = $1.bvals; /*15966*/
				if ($1.addtocws() == $b) return $b; /*15966*/
				$1.mode = $1.A; /*15967*/
			}; /*15968*/
			$1.cws = $a(1558); /*15971*/
			$1.mode = $1.A; /*15972*/
			$1.i = 0; /*15972*/
			$1.j = 0; /*15972*/
			for (;;) { /*15975*/
				if ($1.i >= $1.msglen) { /*15973*/
					break; /*15973*/
				} /*15973*/
				$1[$get($a(["encA", "encCTX", "encCTX", "encCTX", "encE", "encB"]), $1.mode)](); /*15974*/
			} /*15974*/
			$1.cws = $geti($1.cws, 0, $1.j); /*15976*/
		} /*15976*/
		$1.datlen = $1.cws.length; /*15981*/
		$1.remcws = $get($1.numremcws, $1.j - 1) - 1; /*15982*/
		if ($1.remcws > 0) { /*15991*/
			$k[$j++] = Infinity; /*15984*/
			$aload($1.cws); /*15984*/
			for (var _HN = 0, _HO = $1.remcws; _HN < _HO; _HN++) { /*15984*/
				$k[$j++] = 129; /*15984*/
			} /*15984*/
			$1.cws = $a(); /*15984*/
			for (var _HU = $1.datlen + 1, _HT = ($1.datlen + $1.remcws) - 1; _HU <= _HT; _HU += 1) { /*15990*/
				$1.i = _HU; /*15986*/
				var _HW = (((($1.i + 1) * 149) % 253) + 1) + 129; /*15988*/
				$k[$j++] = _HW; /*15988*/
				if (_HW > 254) { /*15988*/
					var _HX = $k[--$j]; /*15988*/
					$k[$j++] = _HX - 254; /*15988*/
				} /*15988*/
				$put($1.cws, $1.i, $k[--$j]); /*15989*/
			} /*15989*/
		} /*15989*/
		$1.i = 0; /*15994*/
		for (;;) { /*16015*/
			$1.m = $get($1.metrics, $1.i); /*15995*/
			$1.rows = $get($1.m, 0); /*15996*/
			$1.cols = $get($1.m, 1); /*15997*/
			$1.regh = $get($1.m, 2); /*15998*/
			$1.regv = $get($1.m, 3); /*15999*/
			$1.rscw = $get($1.m, 4); /*16000*/
			$1.rsbl = $get($1.m, 5); /*16001*/
			$1.mrows = $1.rows - (2 * $1.regh); /*16002*/
			$1.mcols = $1.cols - (2 * $1.regv); /*16003*/
			$1.rrows = ~~($1.mrows / $1.regh); /*16004*/
			$1.rcols = ~~($1.mcols / $1.regv); /*16005*/
			$1.ncws = (~~(($1.mrows * $1.mcols) / 8)) - $1.rscw; /*16006*/
			$1.okay = true; /*16007*/
			if ($1.cws.length != $1.ncws) { /*16008*/
				$1.okay = false; /*16008*/
			} /*16008*/
			if (($1.urows != 0) && ($1.urows != $1.rows)) { /*16009*/
				$1.okay = false; /*16009*/
			} /*16009*/
			if (($1.ucols != 0) && ($1.ucols != $1.cols)) { /*16010*/
				$1.okay = false; /*16010*/
			} /*16010*/
			if ($eq($1.format, "square") && $ne($1.rows, $1.cols)) { /*16011*/
				$1.okay = false; /*16011*/
			} /*16011*/
			if ($eq($1.format, "rectangle") && $eq($1.rows, $1.cols)) { /*16012*/
				$1.okay = false; /*16012*/
			} /*16012*/
			if ($1.okay) { /*16013*/
				break; /*16013*/
			} /*16013*/
			$1.i = $1.i + 1; /*16014*/
		} /*16014*/
		$1.cwbs = $a($1.rsbl); /*16018*/
		$1.ecbs = $a($1.rsbl); /*16019*/
		for (var _IN = 0, _IM = $1.rsbl - 1; _IN <= _IM; _IN += 1) { /*16034*/
			$1.i = _IN; /*16021*/
			if ($1.cws.length != 1558) { /*16025*/
				$1.cwbsize = ~~($1.cws.length / $1.rsbl); /*16023*/
			} else { /*16025*/
				if ($1.i <= 7) { /*16025*/
					$1.cwbsize = 156; /*16025*/
				} else { /*16025*/
					$1.cwbsize = 155; /*16025*/
				} /*16025*/
			} /*16025*/
			$1.cwb = $a($1.cwbsize); /*16027*/
			for (var _IW = 0, _IV = $1.cwbsize - 1; _IW <= _IV; _IW += 1) { /*16031*/
				$1.j = _IW; /*16029*/
				$put($1.cwb, $1.j, $get($1.cws, ($1.j * $1.rsbl) + $1.i)); /*16030*/
			} /*16030*/
			$put($1.cwbs, $1.i, $1.cwb); /*16032*/
			$k[$j++] = $1.ecbs; /*16033*/
			$k[$j++] = $1.i; /*16033*/
			$k[$j++] = Infinity; /*16033*/
			for (var _Il = 0, _Im = ~~($1.rscw / $1.rsbl); _Il < _Im; _Il++) { /*16033*/
				$k[$j++] = 0; /*16033*/
			} /*16033*/
			var _In = $a(); /*16033*/
			var _Io = $k[--$j]; /*16033*/
			$put($k[--$j], _Io, _In); /*16033*/
		} /*16033*/
		$k[$j++] = Infinity; /*16037*/
		$k[$j++] = 1; /*16037*/
		for (var _Iq = 0, _Ir = 255; _Iq < _Ir; _Iq++) { /*16037*/
			var _Is = $k[--$j]; /*16037*/
			var _It = _Is * 2; /*16037*/
			$k[$j++] = _Is; /*16037*/
			$k[$j++] = _It; /*16037*/
			if (_It >= 256) { /*16037*/
				var _Iu = $k[--$j]; /*16037*/
				$k[$j++] = _Iu ^ 301; /*16037*/
			} /*16037*/
		} /*16037*/
		$1.rsalog = $a(); /*16037*/
		$1.rslog = $a(256); /*16038*/
		for (var _Ix = 1; _Ix <= 255; _Ix += 1) { /*16039*/
			$put($1.rslog, $get($1.rsalog, _Ix), _Ix); /*16039*/
		} /*16039*/
		$1.rsprod = function() {
			var _J1 = $k[--$j]; /*16043*/
			var _J2 = $k[--$j]; /*16043*/
			$k[$j++] = _J2; /*16047*/
			$k[$j++] = _J1; /*16047*/
			if ((_J1 != 0) && (_J2 != 0)) { /*16046*/
				var _J5 = $get($1.rslog, $k[--$j]); /*16044*/
				var _JA = $get($1.rsalog, (_J5 + $get($1.rslog, $k[--$j])) % 255); /*16044*/
				$k[$j++] = _JA; /*16044*/
			} else { /*16046*/
				$j -= 2; /*16046*/
				$k[$j++] = 0; /*16046*/
			} /*16046*/
		}; /*16048*/
		$k[$j++] = Infinity; /*16051*/
		$k[$j++] = 1; /*16051*/
		for (var _JD = 0, _JE = ~~($1.rscw / $1.rsbl); _JD < _JE; _JD++) { /*16051*/
			$k[$j++] = 0; /*16051*/
		} /*16051*/
		$1.coeffs = $a(); /*16051*/
		for (var _JJ = 1, _JI = ~~($1.rscw / $1.rsbl); _JJ <= _JI; _JJ += 1) { /*16060*/
			$1.i = _JJ; /*16053*/
			$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*16054*/
			for (var _JQ = $1.i - 1; _JQ >= 1; _JQ -= 1) { /*16058*/
				$1.j = _JQ; /*16056*/
				$k[$j++] = $1.coeffs; /*16057*/
				$k[$j++] = $1.j; /*16057*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*16057*/
				$k[$j++] = $get($1.coeffs, $1.j); /*16057*/
				$k[$j++] = $get($1.rsalog, $1.i); /*16057*/
				if ($1.rsprod() == $b) break; /*16057*/
				var _Jc = $k[--$j]; /*16057*/
				var _Jd = $k[--$j]; /*16057*/
				var _Je = $k[--$j]; /*16057*/
				$put($k[--$j], _Je, $xo(_Jd, _Jc)); /*16057*/
			} /*16057*/
			$k[$j++] = $1.coeffs; /*16059*/
			$k[$j++] = 0; /*16059*/
			$k[$j++] = $get($1.coeffs, 0); /*16059*/
			$k[$j++] = $get($1.rsalog, $1.i); /*16059*/
			if ($1.rsprod() == $b) break; /*16059*/
			var _Jm = $k[--$j]; /*16059*/
			var _Jn = $k[--$j]; /*16059*/
			$put($k[--$j], _Jn, _Jm); /*16059*/
		} /*16059*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*16061*/
		for (var _Ju = 0, _Jt = $1.cwbs.length - 1; _Ju <= _Jt; _Ju += 1) { /*16077*/
			$1.i = _Ju; /*16065*/
			$1.cwb = $get($1.cwbs, $1.i); /*16066*/
			$1.ecb = $get($1.ecbs, $1.i); /*16067*/
			for (var _K3 = 0, _K2 = $1.cwb.length - 1; _K3 <= _K2; _K3 += 1) { /*16076*/
				$1.t = $xo($get($1.cwb, _K3), $get($1.ecb, 0)); /*16069*/
				for (var _K9 = $1.ecb.length - 1; _K9 >= 0; _K9 -= 1) { /*16075*/
					$1.j = _K9; /*16071*/
					$1.p = ($1.ecb.length - $1.j) - 1; /*16072*/
					$k[$j++] = $1.ecb; /*16073*/
					$k[$j++] = $1.p; /*16073*/
					$k[$j++] = $1.t; /*16073*/
					$k[$j++] = $get($1.coeffs, $1.j); /*16073*/
					if ($1.rsprod() == $b) break; /*16073*/
					var _KI = $k[--$j]; /*16073*/
					var _KJ = $k[--$j]; /*16073*/
					$put($k[--$j], _KJ, _KI); /*16073*/
					if ($1.j > 0) { /*16074*/
						$put($1.ecb, $1.p, $xo($get($1.ecb, $1.p + 1), $get($1.ecb, $1.p))); /*16074*/
					} /*16074*/
				} /*16074*/
			} /*16074*/
		} /*16074*/
		if ($1.ncws == 1558) { /*16082*/
			$k[$j++] = Infinity; /*16081*/
			$forall($geti($1.ecbs, 8, 2)); /*16081*/
			$forall($geti($1.ecbs, 0, 8)); /*16081*/
			$1.ecbs = $a(); /*16081*/
		} /*16081*/
		$k[$j++] = Infinity; /*16085*/
		var _Ka = $1.cws; /*16085*/
		for (var _Kb = 0, _Kc = _Ka.length; _Kb < _Kc; _Kb++) { /*16085*/
			$k[$j++] = $get(_Ka, _Kb); /*16085*/
		} /*16085*/
		for (var _Kf = 0, _Kg = $1.rscw; _Kf < _Kg; _Kf++) { /*16085*/
			$k[$j++] = 0; /*16085*/
		} /*16085*/
		$1.cws = $a(); /*16085*/
		for (var _Kk = 0, _Kj = $1.rscw - 1; _Kk <= _Kj; _Kk += 1) { /*16089*/
			$1.i = _Kk; /*16087*/
			$put($1.cws, $1.ncws + $1.i, $get($get($1.ecbs, $1.i % $1.rsbl), ~~($1.i / $1.rsbl))); /*16088*/
		} /*16088*/
		$1.module = function() {
			var _Kv = $k[--$j]; /*16094*/
			var _Kw = $k[--$j]; /*16094*/
			var _Kx = $k[--$j]; /*16094*/
			var _L0 = $strcpy($s(8), "00000000"); /*16095*/
			var _L2 = $cvrs($s(8), $k[--$j], 2); /*16095*/
			$puti(_L0, 8 - _L2.length, _L2); /*16096*/
			$k[$j++] = _Kx; /*16097*/
			$k[$j++] = _Kw; /*16097*/
			$k[$j++] = _Kv; /*16097*/
			$k[$j++] = _L0; /*16097*/
			for (var _L3 = 7; _L3 >= 0; _L3 -= 1) { /*16097*/
				var _L4 = $k[--$j]; /*16097*/
				$k[$j++] = $get(_L4, _L3) - 48; /*16097*/
				$k[$j++] = _L4; /*16097*/
			} /*16097*/
			$j--; /*16097*/
			var _L6 = $k[--$j]; /*16098*/
			var _L7 = $k[--$j]; /*16098*/
			var _L8 = $k[--$j]; /*16098*/
			var _L9 = $k[--$j]; /*16098*/
			var _LA = $k[--$j]; /*16098*/
			var _LB = $k[--$j]; /*16098*/
			var _LC = $k[--$j]; /*16098*/
			var _LD = $k[--$j]; /*16098*/
			var _LE = $k[--$j]; /*16098*/
			var _LF = $k[--$j]; /*16098*/
			var _LG = $k[--$j]; /*16098*/
			$k[$j++] = _LD; /*16115*/
			$k[$j++] = _LC; /*16115*/
			$k[$j++] = _LB; /*16115*/
			$k[$j++] = _LA; /*16115*/
			$k[$j++] = _L9; /*16115*/
			$k[$j++] = _L8; /*16115*/
			$k[$j++] = _L7; /*16115*/
			$k[$j++] = _L6; /*16115*/
			$k[$j++] = _LG; /*16115*/
			$k[$j++] = _LF; /*16115*/
			$forall(_LE, function() { /*16115*/
				$k[--$j](); /*16101*/
				var _LI = $k[--$j]; /*16102*/
				var _LJ = $k[--$j]; /*16102*/
				$k[$j++] = _LJ; /*16105*/
				$k[$j++] = _LI; /*16105*/
				if (_LJ < 0) { /*16105*/
					var _LK = $k[--$j]; /*16103*/
					var _LL = $k[--$j]; /*16103*/
					$k[$j++] = _LL + $1.mrows; /*16104*/
					$k[$j++] = _LK + (4 - (($1.mrows + 4) % 8)); /*16104*/
				} /*16104*/
				var _LO = $k[--$j]; /*16106*/
				$k[$j++] = _LO; /*16109*/
				if (_LO < 0) { /*16109*/
					var _LQ = $k[--$j]; /*16107*/
					var _LR = $k[--$j]; /*16107*/
					$k[$j++] = _LR + (4 - (($1.mcols + 4) % 8)); /*16108*/
					$k[$j++] = _LQ + $1.mcols; /*16108*/
				} /*16108*/
				var _LT = $k[--$j]; /*16110*/
				var _LU = $k[--$j]; /*16110*/
				$k[$j++] = _LU; /*16112*/
				$k[$j++] = _LT; /*16112*/
				if (_LU >= $1.mrows) { /*16112*/
					var _LW = $k[--$j]; /*16111*/
					var _LX = $k[--$j]; /*16111*/
					$k[$j++] = _LX - $1.mrows; /*16111*/
					$k[$j++] = _LW; /*16111*/
				} /*16111*/
				var _LZ = $k[--$j]; /*16113*/
				var _La = $k[--$j]; /*16113*/
				var _Ld = $k[--$j]; /*16114*/
				var _Le = $k[--$j]; /*16114*/
				$put($1.mmat, _LZ + (_La * $1.mcols), $k[--$j]); /*16114*/
				$k[$j++] = _Le; /*16114*/
				$k[$j++] = _Ld; /*16114*/
			}); /*16114*/
		}; /*16116*/
		var _Lw = $a([function() {
			var _Lg = $k[--$j]; /*16120*/
			var _Lh = $k[--$j]; /*16120*/
			$k[$j++] = _Lh; /*16120*/
			$k[$j++] = _Lg; /*16120*/
			$k[$j++] = _Lh - 2; /*16120*/
			$k[$j++] = _Lg - 2; /*16120*/
		}, function() {
			var _Li = $k[--$j]; /*16120*/
			var _Lj = $k[--$j]; /*16120*/
			$k[$j++] = _Lj; /*16120*/
			$k[$j++] = _Li; /*16120*/
			$k[$j++] = _Lj - 2; /*16120*/
			$k[$j++] = _Li - 1; /*16120*/
		}, function() {
			var _Lk = $k[--$j]; /*16121*/
			var _Ll = $k[--$j]; /*16121*/
			$k[$j++] = _Ll; /*16121*/
			$k[$j++] = _Lk; /*16121*/
			$k[$j++] = _Ll - 1; /*16121*/
			$k[$j++] = _Lk - 2; /*16121*/
		}, function() {
			var _Lm = $k[--$j]; /*16121*/
			var _Ln = $k[--$j]; /*16121*/
			$k[$j++] = _Ln; /*16121*/
			$k[$j++] = _Lm; /*16121*/
			$k[$j++] = _Ln - 1; /*16121*/
			$k[$j++] = _Lm - 1; /*16121*/
		}, function() {
			var _Lo = $k[--$j]; /*16122*/
			var _Lp = $k[--$j]; /*16122*/
			$k[$j++] = _Lp; /*16122*/
			$k[$j++] = _Lo; /*16122*/
			$k[$j++] = _Lp - 1; /*16122*/
			$k[$j++] = _Lo; /*16122*/
		}, function() {
			var _Lq = $k[--$j]; /*16122*/
			var _Lr = $k[--$j]; /*16122*/
			$k[$j++] = _Lr; /*16122*/
			$k[$j++] = _Lq; /*16122*/
			$k[$j++] = _Lr; /*16122*/
			$k[$j++] = _Lq - 2; /*16122*/
		}, function() {
			var _Ls = $k[--$j]; /*16123*/
			var _Lt = $k[--$j]; /*16123*/
			$k[$j++] = _Lt; /*16123*/
			$k[$j++] = _Ls; /*16123*/
			$k[$j++] = _Lt; /*16123*/
			$k[$j++] = _Ls - 1; /*16123*/
		}, function() {
			var _Lu = $k[--$j]; /*16123*/
			var _Lv = $k[--$j]; /*16123*/
			$k[$j++] = _Lv; /*16123*/
			$k[$j++] = _Lu; /*16123*/
			$k[$j++] = _Lv; /*16123*/
			$k[$j++] = _Lu; /*16123*/
		}]); /*16123*/
		$1.dmn = _Lw; /*16124*/
		var _M5 = $a([function() {
			$k[$j++] = $1.mrows - 1; /*16127*/
			$k[$j++] = 0; /*16127*/
		}, function() {
			$k[$j++] = $1.mrows - 1; /*16127*/
			$k[$j++] = 1; /*16127*/
		}, function() {
			$k[$j++] = $1.mrows - 1; /*16128*/
			$k[$j++] = 2; /*16128*/
		}, function() {
			$k[$j++] = 0; /*16128*/
			$k[$j++] = $1.mcols - 2; /*16128*/
		}, function() {
			$k[$j++] = 0; /*16129*/
			$k[$j++] = $1.mcols - 1; /*16129*/
		}, function() {
			$k[$j++] = 1; /*16129*/
			$k[$j++] = $1.mcols - 1; /*16129*/
		}, function() {
			$k[$j++] = 2; /*16130*/
			$k[$j++] = $1.mcols - 1; /*16130*/
		}, function() {
			$k[$j++] = 3; /*16130*/
			$k[$j++] = $1.mcols - 1; /*16130*/
		}]); /*16130*/
		$1.dmc1 = _M5; /*16131*/
		var _ME = $a([function() {
			$k[$j++] = $1.mrows - 3; /*16134*/
			$k[$j++] = 0; /*16134*/
		}, function() {
			$k[$j++] = $1.mrows - 2; /*16134*/
			$k[$j++] = 0; /*16134*/
		}, function() {
			$k[$j++] = $1.mrows - 1; /*16135*/
			$k[$j++] = 0; /*16135*/
		}, function() {
			$k[$j++] = 0; /*16135*/
			$k[$j++] = $1.mcols - 4; /*16135*/
		}, function() {
			$k[$j++] = 0; /*16136*/
			$k[$j++] = $1.mcols - 3; /*16136*/
		}, function() {
			$k[$j++] = 0; /*16136*/
			$k[$j++] = $1.mcols - 2; /*16136*/
		}, function() {
			$k[$j++] = 0; /*16137*/
			$k[$j++] = $1.mcols - 1; /*16137*/
		}, function() {
			$k[$j++] = 1; /*16137*/
			$k[$j++] = $1.mcols - 1; /*16137*/
		}]); /*16137*/
		$1.dmc2 = _ME; /*16138*/
		var _MN = $a([function() {
			$k[$j++] = $1.mrows - 3; /*16141*/
			$k[$j++] = 0; /*16141*/
		}, function() {
			$k[$j++] = $1.mrows - 2; /*16141*/
			$k[$j++] = 0; /*16141*/
		}, function() {
			$k[$j++] = $1.mrows - 1; /*16142*/
			$k[$j++] = 0; /*16142*/
		}, function() {
			$k[$j++] = 0; /*16142*/
			$k[$j++] = $1.mcols - 2; /*16142*/
		}, function() {
			$k[$j++] = 0; /*16143*/
			$k[$j++] = $1.mcols - 1; /*16143*/
		}, function() {
			$k[$j++] = 1; /*16143*/
			$k[$j++] = $1.mcols - 1; /*16143*/
		}, function() {
			$k[$j++] = 2; /*16144*/
			$k[$j++] = $1.mcols - 1; /*16144*/
		}, function() {
			$k[$j++] = 3; /*16144*/
			$k[$j++] = $1.mcols - 1; /*16144*/
		}]); /*16144*/
		$1.dmc3 = _MN; /*16145*/
		var _MX = $a([function() {
			$k[$j++] = $1.mrows - 1; /*16148*/
			$k[$j++] = 0; /*16148*/
		}, function() {
			$k[$j++] = $1.mrows - 1; /*16148*/
			$k[$j++] = $1.mcols - 1; /*16148*/
		}, function() {
			$k[$j++] = 0; /*16149*/
			$k[$j++] = $1.mcols - 3; /*16149*/
		}, function() {
			$k[$j++] = 0; /*16149*/
			$k[$j++] = $1.mcols - 2; /*16149*/
		}, function() {
			$k[$j++] = 0; /*16150*/
			$k[$j++] = $1.mcols - 1; /*16150*/
		}, function() {
			$k[$j++] = 1; /*16150*/
			$k[$j++] = $1.mcols - 3; /*16150*/
		}, function() {
			$k[$j++] = 1; /*16151*/
			$k[$j++] = $1.mcols - 2; /*16151*/
		}, function() {
			$k[$j++] = 1; /*16151*/
			$k[$j++] = $1.mcols - 1; /*16151*/
		}]); /*16151*/
		$1.dmc4 = _MX; /*16152*/
		$k[$j++] = Infinity; /*16154*/
		for (var _Ma = 0, _Mb = $1.mrows * $1.mcols; _Ma < _Mb; _Ma++) { /*16154*/
			$k[$j++] = -1; /*16154*/
		} /*16154*/
		$1.mmat = $a(); /*16154*/
		for (var _Me = $1.cws.length - 1; _Me >= 0; _Me -= 1) { /*16155*/
			$k[$j++] = $get($1.cws, _Me); /*16155*/
		} /*16155*/
		$k[$j++] = 4; /*16195*/
		$k[$j++] = 0; /*16195*/
		for (;;) { /*16195*/
			var _Mh = $k[--$j]; /*16158*/
			var _Mi = $k[--$j]; /*16158*/
			$k[$j++] = _Mi; /*16160*/
			$k[$j++] = _Mh; /*16160*/
			if ((_Mh == 0) && (_Mi == $1.mrows)) { /*16160*/
				$k[$j++] = $1.dmc1; /*16159*/
				if ($1.module() == $b) break; /*16159*/
			} /*16159*/
			var _Ml = $k[--$j]; /*16161*/
			var _Mm = $k[--$j]; /*16161*/
			$k[$j++] = _Mm; /*16163*/
			$k[$j++] = _Ml; /*16163*/
			if (((_Ml == 0) && (_Mm == ($1.mrows - 2))) && (($1.mcols % 4) != 0)) { /*16163*/
				$k[$j++] = $1.dmc2; /*16162*/
				if ($1.module() == $b) break; /*16162*/
			} /*16162*/
			var _Mq = $k[--$j]; /*16164*/
			var _Mr = $k[--$j]; /*16164*/
			$k[$j++] = _Mr; /*16166*/
			$k[$j++] = _Mq; /*16166*/
			if (((_Mq == 0) && (_Mr == ($1.mrows - 2))) && (($1.mcols % 8) == 4)) { /*16166*/
				$k[$j++] = $1.dmc3; /*16165*/
				if ($1.module() == $b) break; /*16165*/
			} /*16165*/
			var _Mv = $k[--$j]; /*16167*/
			var _Mw = $k[--$j]; /*16167*/
			$k[$j++] = _Mw; /*16169*/
			$k[$j++] = _Mv; /*16169*/
			if (((_Mv == 2) && (_Mw == ($1.mrows + 4))) && (($1.mcols % 8) == 0)) { /*16169*/
				$k[$j++] = $1.dmc4; /*16168*/
				if ($1.module() == $b) break; /*16168*/
			} /*16168*/
			for (;;) { /*16179*/
				var _N0 = $k[--$j]; /*16172*/
				var _N1 = $k[--$j]; /*16172*/
				$k[$j++] = _N1; /*16176*/
				$k[$j++] = _N0; /*16176*/
				if ((_N0 >= 0) && (_N1 < $1.mrows)) { /*16176*/
					var _N3 = $k[--$j]; /*16173*/
					var _N4 = $k[--$j]; /*16173*/
					$k[$j++] = _N4; /*16175*/
					$k[$j++] = _N3; /*16175*/
					if ($get($1.mmat, _N3 + (_N4 * $1.mcols)) == -1) { /*16175*/
						$k[$j++] = $1.dmn; /*16174*/
						if ($1.module() == $b) break; /*16174*/
					} /*16174*/
				} /*16174*/
				var _N9 = $k[--$j]; /*16177*/
				var _NA = $k[--$j]; /*16177*/
				$k[$j++] = _NA - 2; /*16178*/
				$k[$j++] = _N9 + 2; /*16178*/
				if (!(((_N9 + 2) < $1.mcols) && ((_NA - 2) >= 0))) { /*16178*/
					break; /*16178*/
				} /*16178*/
			} /*16178*/
			var _NC = $k[--$j]; /*16180*/
			var _ND = $k[--$j]; /*16180*/
			$k[$j++] = _ND + 1; /*16190*/
			$k[$j++] = _NC + 3; /*16190*/
			for (;;) { /*16190*/
				var _NE = $k[--$j]; /*16183*/
				var _NF = $k[--$j]; /*16183*/
				$k[$j++] = _NF; /*16187*/
				$k[$j++] = _NE; /*16187*/
				if ((_NE < $1.mcols) && (_NF >= 0)) { /*16187*/
					var _NH = $k[--$j]; /*16184*/
					var _NI = $k[--$j]; /*16184*/
					$k[$j++] = _NI; /*16186*/
					$k[$j++] = _NH; /*16186*/
					if ($get($1.mmat, _NH + (_NI * $1.mcols)) == -1) { /*16186*/
						$k[$j++] = $1.dmn; /*16185*/
						if ($1.module() == $b) break; /*16185*/
					} /*16185*/
				} /*16185*/
				var _NN = $k[--$j]; /*16188*/
				var _NO = $k[--$j]; /*16188*/
				$k[$j++] = _NO + 2; /*16189*/
				$k[$j++] = _NN - 2; /*16189*/
				if (!(((_NN - 2) >= 0) && ((_NO + 2) < $1.mrows))) { /*16189*/
					break; /*16189*/
				} /*16189*/
			} /*16189*/
			var _NQ = $k[--$j]; /*16191*/
			var _NR = $k[--$j]; /*16191*/
			$k[$j++] = _NR + 3; /*16193*/
			$k[$j++] = _NQ + 1; /*16193*/
			if (!(((_NQ + 1) < $1.mcols) || ((_NR + 3) < $1.mrows))) { /*16193*/
				$j -= 2; /*16193*/
				break; /*16193*/
			} /*16193*/
		} /*16193*/
		if ($get($1.mmat, ($1.mrows * $1.mcols) - 1) == -1) { /*16201*/
			$puti($1.mmat, ($1.mrows * ($1.mcols - 1)) - 2, $a([1, 0])); /*16199*/
			$puti($1.mmat, ($1.mrows * $1.mcols) - 2, $a([0, 1])); /*16200*/
		} /*16200*/
		$1.pixs = $a($1.rows * $1.cols); /*16204*/
		$1.cwpos = 0; /*16205*/
		for (var _Nl = 0, _Nk = $1.rows - 1; _Nl <= _Nk; _Nl += 1) { /*16221*/
			$1.i = _Nl; /*16207*/
			if (($1.i % ($1.rrows + 2)) == 0) { /*16208*/
				$k[$j++] = $1.pixs; /*16208*/
				$k[$j++] = $1.i * $1.cols; /*16208*/
				$k[$j++] = Infinity; /*16208*/
				for (var _Ns = 0, _Nt = ~~($1.cols / 2); _Ns < _Nt; _Ns++) { /*16208*/
					$k[$j++] = 1; /*16208*/
					$k[$j++] = 0; /*16208*/
				} /*16208*/
				var _Nu = $a(); /*16208*/
				var _Nv = $k[--$j]; /*16208*/
				$puti($k[--$j], _Nv, _Nu); /*16208*/
			} /*16208*/
			if (($1.i % ($1.rrows + 2)) == ($1.rrows + 1)) { /*16209*/
				$k[$j++] = $1.pixs; /*16209*/
				$k[$j++] = $1.i * $1.cols; /*16209*/
				$k[$j++] = Infinity; /*16209*/
				for (var _O4 = 0, _O5 = $1.cols; _O4 < _O5; _O4++) { /*16209*/
					$k[$j++] = 1; /*16209*/
				} /*16209*/
				var _O6 = $a(); /*16209*/
				var _O7 = $k[--$j]; /*16209*/
				$puti($k[--$j], _O7, _O6); /*16209*/
			} /*16209*/
			if ((($1.i % ($1.rrows + 2)) != 0) && (($1.i % ($1.rrows + 2)) != ($1.rrows + 1))) { /*16220*/
				for (var _OG = 0, _OF = $1.cols - 1; _OG <= _OF; _OG += 1) { /*16219*/
					$1.j = _OG; /*16212*/
					if (($1.j % ($1.rcols + 2)) == 0) { /*16213*/
						$put($1.pixs, ($1.i * $1.cols) + $1.j, 1); /*16213*/
					} /*16213*/
					if (($1.j % ($1.rcols + 2)) == ($1.rcols + 1)) { /*16214*/
						$put($1.pixs, ($1.i * $1.cols) + $1.j, $1.i % 2); /*16214*/
					} /*16214*/
					if ((($1.j % ($1.rcols + 2)) != 0) && (($1.j % ($1.rcols + 2)) != ($1.rcols + 1))) { /*16218*/
						$put($1.pixs, ($1.i * $1.cols) + $1.j, $get($1.mmat, $1.cwpos)); /*16216*/
						$1.cwpos = $1.cwpos + 1; /*16217*/
					} /*16217*/
				} /*16217*/
			} /*16217*/
		} /*16217*/
		var _Oo = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.cols,
			pixy: $1.rows,
			height: ($1.rows * 2) / 72,
			width: ($1.cols * 2) / 72,
			opt: $1.options
		}; /*16231*/
		$k[$j++] = _Oo; /*16234*/
		if (!$1.dontdraw) { /*16234*/
			$0.renmatrix(); /*16234*/
		} /*16234*/
	};
	$0.datamatrixrectangular = function() {
		var $1 = {}; /*16260*/
		$1.options = $k[--$j]; /*16262*/
		$1.barcode = $k[--$j]; /*16263*/
		$1.dontdraw = false; /*16265*/
		$forall($1.options, function() { /*16276*/
			var _3 = $k[--$j]; /*16276*/
			$1[$k[--$j]] = _3; /*16276*/
		}); /*16276*/
		$1.options.dontdraw = true; /*16279*/
		$1.options.format = "rectangle"; /*16280*/
		$k[$j++] = "args"; /*16282*/
		$k[$j++] = $1.barcode; /*16282*/
		$k[$j++] = $1.options; /*16282*/
		$0.datamatrix(); /*16282*/
		var _9 = $k[--$j]; /*16282*/
		$1[$k[--$j]] = _9; /*16282*/
		$1.args.opt = $1.options; /*16284*/
		$k[$j++] = $1.args; /*16287*/
		if (!$1.dontdraw) { /*16287*/
			$0.renmatrix(); /*16287*/
		} /*16287*/
	};
	$0.qrcode = function() {
		var $1 = {}; /*16314*/
		$1.options = $k[--$j]; /*16316*/
		$1.barcode = $k[--$j]; /*16317*/
		$1.dontdraw = false; /*16319*/
		$1.format = "full"; /*16320*/
		$1.version = "unset"; /*16321*/
		$1.eclevel = "unset"; /*16322*/
		$1.parse = false; /*16323*/
		$1.parsefnc = false; /*16324*/
		$1.mask = -1; /*16325*/
		$forall($1.options, function() { /*16336*/
			var _3 = $k[--$j]; /*16336*/
			$1[$k[--$j]] = _3; /*16336*/
		}); /*16336*/
		$1.mask = ~~$1.mask; /*16338*/
		$1.barlen = $1.barcode.length; /*16361*/
		$1.fn1 = -1; /*16364*/
		var _8 = {
			FNC1: $1.fn1
		}; /*16366*/
		$1.fncvals = _8; /*16367*/
		$1.msg = $a($1.barlen); /*16368*/
		$1.i = 0; /*16369*/
		$1.j = 0; /*16369*/
		for (;;) { /*16383*/
			if ($1.i == $1.barlen) { /*16370*/
				break; /*16370*/
			} /*16370*/
			$1.char = $get($1.barcode, $1.i); /*16371*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*16379*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*16377*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*16374*/
					$1.i = $1.i + 4; /*16375*/
				} else { /*16377*/
					$1.i = $1.i + 1; /*16377*/
				} /*16377*/
			} /*16377*/
			$put($1.msg, $1.j, $1.char); /*16380*/
			$1.i = $1.i + 1; /*16381*/
			$1.j = $1.j + 1; /*16382*/
		} /*16382*/
		$1.msg = $geti($1.msg, 0, $1.j); /*16384*/
		$1.msglen = $1.msg.length; /*16385*/
		$1.fnc1first = false; /*16388*/
		if ($1.msglen > 0) { /*16395*/
			if ($get($1.msg, 0) == $1.fn1) { /*16394*/
				$1.fnc1first = true; /*16391*/
				$k[$j++] = Infinity; /*16392*/
				$forall($geti($1.msg, 1, $1.msglen - 1), function() { /*16392*/
					var _k = $k[--$j]; /*16392*/
					$k[$j++] = _k; /*16392*/
					if (_k == 37) { /*16392*/
						var _l = $k[--$j]; /*16392*/
						$k[$j++] = _l; /*16392*/
						$k[$j++] = _l; /*16392*/
					} /*16392*/
				}); /*16392*/
				$1.msg = $a(); /*16392*/
				$1.msglen = $1.msg.length; /*16393*/
			} /*16393*/
		} /*16393*/
		if ($eq($1.eclevel, "unset")) { /*16398*/
			$k[$j++] = "eclevel"; /*16398*/
			if ($eq($1.format, "full")) { /*16398*/
				$k[$j++] = "M"; /*16398*/
			} else { /*16398*/
				$k[$j++] = "L"; /*16398*/
			} /*16398*/
			var _q = $k[--$j]; /*16398*/
			$1[$k[--$j]] = _q; /*16398*/
		} /*16398*/
		$1.N = 0; /*16401*/
		$1.A = 1; /*16401*/
		$1.B = 2; /*16401*/
		$1.K = 3; /*16401*/
		$k[$j++] = "Nexcl"; /*16406*/
		$k[$j++] = Infinity; /*16406*/
		$k[$j++] = Infinity; /*16405*/
		for (var _s = 48; _s <= 57; _s += 1) { /*16405*/
			$k[$j++] = _s; /*16405*/
		} /*16405*/
		var _t = $a(); /*16405*/
		for (var _u = 0, _v = _t.length; _u < _v; _u++) { /*16406*/
			$k[$j++] = $get(_t, _u); /*16406*/
			$k[$j++] = -1; /*16406*/
		} /*16406*/
		var _x = $d(); /*16406*/
		$1[$k[--$j]] = _x; /*16407*/
		$k[$j++] = "Aexcl"; /*16414*/
		$k[$j++] = Infinity; /*16414*/
		$k[$j++] = Infinity; /*16413*/
		$k[$j++] = 32; /*16412*/
		$k[$j++] = 36; /*16412*/
		$k[$j++] = 37; /*16412*/
		$k[$j++] = 42; /*16412*/
		$k[$j++] = 43; /*16412*/
		$k[$j++] = 45; /*16412*/
		$k[$j++] = 46; /*16412*/
		$k[$j++] = 47; /*16412*/
		$k[$j++] = 58; /*16412*/
		for (var _z = 65; _z <= 90; _z += 1) { /*16412*/
			$k[$j++] = _z; /*16412*/
		} /*16412*/
		$k[$j++] = $1.fn1; /*16413*/
		var _11 = $a(); /*16413*/
		for (var _12 = 0, _13 = _11.length; _12 < _13; _12++) { /*16414*/
			$k[$j++] = $get(_11, _12); /*16414*/
			$k[$j++] = -1; /*16414*/
		} /*16414*/
		var _15 = $d(); /*16414*/
		$1[$k[--$j]] = _15; /*16415*/
		$k[$j++] = "Bexcl"; /*16424*/
		$k[$j++] = Infinity; /*16424*/
		$k[$j++] = Infinity; /*16423*/
		for (var _17 = 0; _17 <= 31; _17 += 1) { /*16419*/
			$k[$j++] = _17; /*16419*/
		} /*16419*/
		$k[$j++] = 33; /*16421*/
		$k[$j++] = 34; /*16421*/
		$k[$j++] = 35; /*16421*/
		$k[$j++] = 38; /*16421*/
		$k[$j++] = 39; /*16421*/
		$k[$j++] = 40; /*16421*/
		$k[$j++] = 41; /*16421*/
		$k[$j++] = 44; /*16421*/
		for (var _18 = 59; _18 <= 64; _18 += 1) { /*16421*/
			$k[$j++] = _18; /*16421*/
		} /*16421*/
		for (var _19 = 91; _19 <= 127; _19 += 1) { /*16422*/
			$k[$j++] = _19; /*16422*/
		} /*16422*/
		for (var _1A = 160; _1A <= 223; _1A += 1) { /*16423*/
			$k[$j++] = _1A; /*16423*/
		} /*16423*/
		var _1B = $a(); /*16423*/
		for (var _1C = 0, _1D = _1B.length; _1C < _1D; _1C++) { /*16424*/
			$k[$j++] = $get(_1B, _1C); /*16424*/
			$k[$j++] = -1; /*16424*/
		} /*16424*/
		var _1F = $d(); /*16424*/
		$1[$k[--$j]] = _1F; /*16425*/
		$k[$j++] = "Kexcl"; /*16431*/
		$k[$j++] = Infinity; /*16431*/
		$k[$j++] = Infinity; /*16430*/
		for (var _1H = 129; _1H <= 159; _1H += 1) { /*16429*/
			$k[$j++] = _1H; /*16429*/
		} /*16429*/
		for (var _1I = 224; _1I <= 235; _1I += 1) { /*16430*/
			$k[$j++] = _1I; /*16430*/
		} /*16430*/
		var _1J = $a(); /*16430*/
		for (var _1K = 0, _1L = _1J.length; _1K < _1L; _1K++) { /*16431*/
			$k[$j++] = $get(_1J, _1K); /*16431*/
			$k[$j++] = -1; /*16431*/
		} /*16431*/
		var _1N = $d(); /*16431*/
		$1[$k[--$j]] = _1N; /*16432*/
		$1.mids = $a([$a(["0001", "0010", "0100", "1000"]), $a(["0001", "0010", "0100", "1000"]), $a(["0001", "0010", "0100", "1000"]), $a(["", -1, -1, -1]), $a(["0", "1", -1, -1]), $a(["00", "01", "10", "11"]), $a(["000", "001", "010", "011"])]); /*16442*/
		$1.cclens = $a([$a([10, 9, 8, 8]), $a([12, 11, 16, 10]), $a([14, 13, 16, 12]), $a([3, -1, -1, -1]), $a([4, 3, -1, -1]), $a([5, 4, 4, 3]), $a([6, 5, 5, 4])]); /*16452*/
		$1.termlens = $a([4, 4, 4, 3, 5, 7, 9]); /*16454*/
		$1.tobin = function() {
			var _1h = $s($k[--$j]); /*16458*/
			$k[$j++] = _1h; /*16458*/
			for (var _1j = 0, _1i = _1h.length - 1; _1j <= _1i; _1j += 1) { /*16458*/
				var _1k = $k[--$j]; /*16458*/
				$put(_1k, _1j, 48); /*16458*/
				$k[$j++] = _1k; /*16458*/
			} /*16458*/
			var _1l = $k[--$j]; /*16459*/
			var _1o = $cvrs($s(_1l.length), $k[--$j], 2); /*16459*/
			$puti(_1l, _1l.length - _1o.length, _1o); /*16459*/
			$k[$j++] = _1l; /*16459*/
		}; /*16460*/
		$1.charmap = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:"; /*16463*/
		$1.charvals = {}; /*16464*/
		for (var _1p = 0; _1p <= 44; _1p += 1) { /*16465*/
			$put($1.charvals, $get($1.charmap, _1p), _1p); /*16465*/
		} /*16465*/
		$1.encA = function() {
			$1.in = $k[--$j]; /*16468*/
			if ($1.fnc1first) { /*16471*/
				$k[$j++] = Infinity; /*16470*/
				$forall($1.in, function() { /*16470*/
					var _1w = $k[--$j]; /*16470*/
					$k[$j++] = _1w; /*16470*/
					if (_1w == -1) { /*16470*/
						$j--; /*16470*/
						$k[$j++] = 37; /*16470*/
					} /*16470*/
				}); /*16470*/
				$1.in = $a(); /*16470*/
			} /*16470*/
			$1.out = $s((~~(($1.in.length * 11) / 2)) + 1); /*16472*/
			$1.k = 0; /*16473*/
			$1.m = 0; /*16473*/
			for (;;) { /*16484*/
				if ($1.k == $1.in.length) { /*16474*/
					break; /*16474*/
				} /*16474*/
				if ($1.k < ($1.in.length - 1)) { /*16480*/
					$k[$j++] = ($get($1.charvals, $get($1.in, $1.k)) * 45) + $get($1.charvals, $get($1.in, $1.k + 1)); /*16476*/
					$k[$j++] = 11; /*16476*/
					if ($1.tobin() == $b) break; /*16476*/
					$1.k = $1.k + 2; /*16477*/
				} else { /*16480*/
					$k[$j++] = $get($1.charvals, $get($1.in, $1.k)); /*16479*/
					$k[$j++] = 6; /*16479*/
					if ($1.tobin() == $b) break; /*16479*/
					$1.k = $1.k + 1; /*16480*/
				} /*16480*/
				var _2L = $k[--$j]; /*16482*/
				$puti($1.out, $1.m, _2L); /*16482*/
				$1.m = _2L.length + $1.m; /*16483*/
			} /*16483*/
			$k[$j++] = $geti($1.out, 0, $1.m); /*16485*/
		}; /*16486*/
		$1.encN = function() {
			$1.in = $k[--$j]; /*16489*/
			$1.out = $s((~~(($1.in.length * 10) / 3)) + 1); /*16490*/
			$1.k = 0; /*16491*/
			$1.m = 0; /*16491*/
			for (;;) { /*16507*/
				if ($1.k == $1.in.length) { /*16492*/
					break; /*16492*/
				} /*16492*/
				if ($1.k < ($1.in.length - 2)) { /*16502*/
					$k[$j++] = 0; /*16494*/
					$forall($geti($1.in, $1.k, 3), function() { /*16494*/
						var _2c = $k[--$j]; /*16494*/
						var _2d = $k[--$j]; /*16494*/
						$k[$j++] = _2c + ((_2d * 10) - 48); /*16494*/
					}); /*16494*/
					$k[$j++] = 10; /*16494*/
					if ($1.tobin() == $b) break; /*16494*/
					$1.k = $1.k + 3; /*16495*/
				} else { /*16502*/
					if ($1.k == ($1.in.length - 2)) { /*16502*/
						$k[$j++] = 0; /*16498*/
						$forall($geti($1.in, $1.k, 2), function() { /*16498*/
							var _2k = $k[--$j]; /*16498*/
							var _2l = $k[--$j]; /*16498*/
							$k[$j++] = _2k + ((_2l * 10) - 48); /*16498*/
						}); /*16498*/
						$k[$j++] = 7; /*16498*/
						if ($1.tobin() == $b) break; /*16498*/
						$1.k = $1.k + 2; /*16499*/
					} else { /*16502*/
						$k[$j++] = 0; /*16501*/
						$forall($geti($1.in, $1.k, 1), function() { /*16501*/
							var _2q = $k[--$j]; /*16501*/
							var _2r = $k[--$j]; /*16501*/
							$k[$j++] = _2q + ((_2r * 10) - 48); /*16501*/
						}); /*16501*/
						$k[$j++] = 4; /*16501*/
						if ($1.tobin() == $b) break; /*16501*/
						$1.k = $1.k + 1; /*16502*/
					} /*16502*/
				} /*16502*/
				var _2t = $k[--$j]; /*16505*/
				$puti($1.out, $1.m, _2t); /*16505*/
				$1.m = _2t.length + $1.m; /*16506*/
			} /*16506*/
			$k[$j++] = $geti($1.out, 0, $1.m); /*16508*/
		}; /*16509*/
		$1.encB = function() {
			$1.in = $k[--$j]; /*16512*/
			if ($1.fnc1first) { /*16515*/
				$k[$j++] = Infinity; /*16514*/
				$forall($1.in, function() { /*16514*/
					var _33 = $k[--$j]; /*16514*/
					$k[$j++] = _33; /*16514*/
					if (_33 == -1) { /*16514*/
						$j--; /*16514*/
						$k[$j++] = 29; /*16514*/
					} /*16514*/
				}); /*16514*/
				$1.in = $a(); /*16514*/
			} /*16514*/
			$1.out = $s($1.in.length * 8); /*16516*/
			for (var _39 = 0, _38 = $1.in.length - 1; _39 <= _38; _39 += 1) { /*16521*/
				$1.k = _39; /*16518*/
				$k[$j++] = ~~$z($get($1.in, $1.k)); /*16519*/
				$k[$j++] = 8; /*16519*/
				if ($1.tobin() == $b) break; /*16519*/
				$puti($1.out, $1.k * 8, $k[--$j]); /*16520*/
			} /*16520*/
			$k[$j++] = $1.out; /*16522*/
		}; /*16523*/
		$1.encK = function() {
			$1.in = $k[--$j]; /*16526*/
			$1.out = $s((~~($1.in.length / 2)) * 13); /*16527*/
			$1.k = 0; /*16528*/
			$1.m = 0; /*16528*/
			for (;;) { /*16536*/
				if ($1.k == $1.in.length) { /*16529*/
					break; /*16529*/
				} /*16529*/
				var _3S = ($get($1.in, $1.k) * 256) + $get($1.in, $1.k + 1); /*16531*/
				$k[$j++] = _3S; /*16531*/
				if (_3S < 57408) { /*16531*/
					$k[$j++] = 33088; /*16531*/
				} else { /*16531*/
					$k[$j++] = 49472; /*16531*/
				} /*16531*/
				var _3T = $k[--$j]; /*16531*/
				var _3V = $k[--$j] - _3T; /*16532*/
				$k[$j++] = ((_3V >>> 8) * 192) + (_3V & 255); /*16533*/
				$k[$j++] = 13; /*16533*/
				if ($1.tobin() == $b) break; /*16533*/
				var _3W = $k[--$j]; /*16533*/
				$puti($1.out, $1.m, _3W); /*16533*/
				$1.m = _3W.length + $1.m; /*16534*/
				$1.k = $1.k + 2; /*16535*/
			} /*16535*/
			$k[$j++] = $1.out; /*16537*/
		}; /*16538*/
		$1.encfuncs = $a(["encN", "encA", "encB", "encK"]); /*16540*/
		$1.addtobits = function() {
			var _3d = $k[--$j]; /*16543*/
			$puti($1.bits, $1.j, _3d); /*16543*/
			$1.j = _3d.length + $1.j; /*16544*/
		}; /*16545*/
		$k[$j++] = Infinity; /*16547*/
		for (var _3i = 0, _3j = $1.msglen; _3i < _3j; _3i++) { /*16547*/
			$k[$j++] = 0; /*16547*/
		} /*16547*/
		$k[$j++] = 0; /*16547*/
		$1.numNs = $a(); /*16547*/
		$k[$j++] = Infinity; /*16548*/
		for (var _3m = 0, _3n = $1.msglen; _3m < _3n; _3m++) { /*16548*/
			$k[$j++] = 0; /*16548*/
		} /*16548*/
		$k[$j++] = 0; /*16548*/
		$1.numAs = $a(); /*16548*/
		$k[$j++] = Infinity; /*16549*/
		for (var _3q = 0, _3r = $1.msglen; _3q < _3r; _3q++) { /*16549*/
			$k[$j++] = 0; /*16549*/
		} /*16549*/
		$k[$j++] = 0; /*16549*/
		$1.numBs = $a(); /*16549*/
		$k[$j++] = Infinity; /*16550*/
		for (var _3u = 0, _3v = $1.msglen; _3u < _3v; _3u++) { /*16550*/
			$k[$j++] = 0; /*16550*/
		} /*16550*/
		$k[$j++] = -1; /*16550*/
		$1.numKs = $a(); /*16550*/
		$k[$j++] = Infinity; /*16551*/
		for (var _3y = 0, _3z = $1.msglen; _3y < _3z; _3y++) { /*16551*/
			$k[$j++] = 0; /*16551*/
		} /*16551*/
		$k[$j++] = 9999; /*16551*/
		$1.nextNs = $a(); /*16551*/
		$k[$j++] = Infinity; /*16552*/
		for (var _42 = 0, _43 = $1.msglen; _42 < _43; _42++) { /*16552*/
			$k[$j++] = 0; /*16552*/
		} /*16552*/
		$k[$j++] = 9999; /*16552*/
		$1.nextBs = $a(); /*16552*/
		$k[$j++] = Infinity; /*16553*/
		for (var _46 = 0, _47 = $1.msglen; _46 < _47; _46++) { /*16553*/
			$k[$j++] = 0; /*16553*/
		} /*16553*/
		$k[$j++] = 9999; /*16553*/
		$1.nextAs = $a(); /*16553*/
		$k[$j++] = Infinity; /*16554*/
		for (var _4A = 0, _4B = $1.msglen; _4A < _4B; _4A++) { /*16554*/
			$k[$j++] = 0; /*16554*/
		} /*16554*/
		$k[$j++] = 9999; /*16554*/
		$1.nextKs = $a(); /*16554*/
		for (var _4E = $1.msglen - 1; _4E >= 0; _4E -= 1) { /*16582*/
			$1.i = _4E; /*16556*/
			$1.barchar = $get($1.msg, $1.i); /*16557*/
			var _4K = $get($1.Kexcl, $1.barchar) !== undefined; /*16558*/
			if (_4K) { /*16562*/
				$put($1.nextKs, $1.i, 0); /*16559*/
				$put($1.numKs, $1.i, $get($1.numKs, $1.i + 1) + 1); /*16560*/
			} else { /*16562*/
				$put($1.nextKs, $1.i, $get($1.nextKs, $1.i + 1) + 1); /*16562*/
			} /*16562*/
			var _4Z = $get($1.Nexcl, $1.barchar) !== undefined; /*16564*/
			if (_4Z) { /*16568*/
				$put($1.nextNs, $1.i, 0); /*16565*/
				$put($1.numNs, $1.i, $get($1.numNs, $1.i + 1) + 1); /*16566*/
			} else { /*16568*/
				$put($1.nextNs, $1.i, $get($1.nextNs, $1.i + 1) + 1); /*16568*/
			} /*16568*/
			var _4o = $get($1.Bexcl, $1.barchar) !== undefined; /*16570*/
			if (_4o) { /*16574*/
				$put($1.nextBs, $1.i, 0); /*16571*/
				$put($1.numBs, $1.i, $get($1.numBs, $1.i + 1) + 1); /*16572*/
			} else { /*16574*/
				$put($1.nextBs, $1.i, $get($1.nextBs, $1.i + 1) + 1); /*16574*/
			} /*16574*/
			var _53 = $get($1.Aexcl, $1.barchar) !== undefined; /*16576*/
			if (_53) { /*16580*/
				$put($1.nextAs, $1.i, 0); /*16577*/
				$put($1.numAs, $1.i, $get($1.numAs, $1.i + 1) + 1); /*16578*/
			} else { /*16580*/
				$put($1.nextAs, $1.i, $get($1.nextAs, $1.i + 1) + 1); /*16580*/
			} /*16580*/
		} /*16580*/
		$k[$j++] = Infinity; /*16583*/
		var _5G = $1.numKs; /*16583*/
		for (var _5H = 0, _5I = _5G.length; _5H < _5I; _5H++) { /*16583*/
			$k[$j++] = ~~(($get(_5G, _5H) + 1) / 2); /*16583*/
		} /*16583*/
		$1.numKs = $a(); /*16583*/
		$1.KbeforeB = function() {
			var _5O = $get($k[--$j], $1.ver); /*16585*/
			$k[$j++] = $ge($1.numK, _5O) && ($get($1.nextBs, ($1.numK * 2) + $1.i) == 0); /*16585*/
		}; /*16585*/
		$1.KbeforeA = function() {
			var _5W = $get($k[--$j], $1.ver); /*16586*/
			$k[$j++] = $ge($1.numK, _5W) && ($get($1.nextAs, ($1.numK * 2) + $1.i) == 0); /*16586*/
		}; /*16586*/
		$1.KbeforeN = function() {
			var _5e = $get($k[--$j], $1.ver); /*16587*/
			$k[$j++] = $ge($1.numK, _5e) && ($get($1.nextNs, ($1.numK * 2) + $1.i) == 0); /*16587*/
		}; /*16587*/
		$1.KbeforeE = function() {
			var _5m = $get($k[--$j], $1.ver); /*16588*/
			$k[$j++] = $ge($1.numK, _5m) && ((($1.numK * 2) + $1.i) == $1.msglen); /*16588*/
		}; /*16588*/
		$1.AbeforeK = function() {
			var _5t = $get($k[--$j], $1.ver); /*16589*/
			$k[$j++] = $ge($1.numA, _5t) && ($get($1.nextKs, $1.numA + $1.i) == 0); /*16589*/
		}; /*16589*/
		$1.AbeforeB = function() {
			var _61 = $get($k[--$j], $1.ver); /*16590*/
			$k[$j++] = $ge($1.numA, _61) && ($get($1.nextBs, $1.numA + $1.i) == 0); /*16590*/
		}; /*16590*/
		$1.AbeforeN = function() {
			var _69 = $get($k[--$j], $1.ver); /*16591*/
			$k[$j++] = $ge($1.numA, _69) && ($get($1.nextNs, $1.numA + $1.i) == 0); /*16591*/
		}; /*16591*/
		$1.AbeforeE = function() {
			var _6H = $get($k[--$j], $1.ver); /*16592*/
			$k[$j++] = $ge($1.numA, _6H) && (($1.numA + $1.i) == $1.msglen); /*16592*/
		}; /*16592*/
		$1.NbeforeK = function() {
			var _6O = $get($k[--$j], $1.ver); /*16593*/
			$k[$j++] = $ge($1.numN, _6O) && ($get($1.nextKs, $1.numN + $1.i) == 0); /*16593*/
		}; /*16593*/
		$1.NbeforeB = function() {
			var _6W = $get($k[--$j], $1.ver); /*16594*/
			$k[$j++] = $ge($1.numN, _6W) && ($get($1.nextBs, $1.numN + $1.i) == 0); /*16594*/
		}; /*16594*/
		$1.NbeforeA = function() {
			var _6e = $get($k[--$j], $1.ver); /*16595*/
			$k[$j++] = $ge($1.numN, _6e) && ($get($1.nextAs, $1.numN + $1.i) == 0); /*16595*/
		}; /*16595*/
		$1.NbeforeE = function() {
			var _6m = $get($k[--$j], $1.ver); /*16596*/
			$k[$j++] = $ge($1.numN, _6m) && (($1.numN + $1.i) == $1.msglen); /*16596*/
		}; /*16596*/
		$1.msgbits = $a([-1, -1, -1, -1, -1, -1, -1]); /*16599*/
		$1.v1to9 = 0; /*16600*/
		$1.v10to26 = 1; /*16600*/
		$1.v27to40 = 2; /*16600*/
		$1.vM1 = 3; /*16600*/
		$1.vM2 = 4; /*16600*/
		$1.vM3 = 5; /*16600*/
		$1.vM4 = 6; /*16600*/
		$1.e = 10000; /*16601*/
		var _6y = $a([$1.v1to9, $1.v10to26, $1.v27to40, $1.vM1, $1.vM2, $1.vM3, $1.vM4]); /*16602*/
		for (var _6z = 0, _70 = _6y.length; _6z < _70; _6z++) { /*16719*/
			$1.ver = $get(_6y, _6z); /*16603*/
			$1.mode = -1; /*16606*/
			$1.seq = $a([]); /*16606*/
			$1.i = 0; /*16606*/
			for (;;) { /*16693*/
				if ($1.i >= $1.msglen) { /*16607*/
					break; /*16607*/
				} /*16607*/
				$1.numK = $get($1.numKs, $1.i); /*16608*/
				$1.numB = $get($1.numBs, $1.i); /*16609*/
				$1.numA = $get($1.numAs, $1.i); /*16610*/
				$1.numN = $get($1.numNs, $1.i); /*16611*/
				if (($1.ver == $1.vM1) && ($1.numA >= 1)) { /*16612*/
					$1.seq = -1; /*16612*/
					break; /*16612*/
				} /*16612*/
				if (($1.ver == $1.vM1) && ($1.numB >= 1)) { /*16613*/
					$1.seq = -1; /*16613*/
					break; /*16613*/
				} /*16613*/
				if (($1.ver == $1.vM1) && ($1.numK >= 1)) { /*16614*/
					$1.seq = -1; /*16614*/
					break; /*16614*/
				} /*16614*/
				if (($1.ver == $1.vM2) && ($1.numB >= 1)) { /*16615*/
					$1.seq = -1; /*16615*/
					break; /*16615*/
				} /*16615*/
				if (($1.ver == $1.vM2) && ($1.numK >= 1)) { /*16616*/
					$1.seq = -1; /*16616*/
					break; /*16616*/
				} /*16616*/
				for (;;) { /*16674*/
					if ($1.mode == -1) { /*16635*/
						$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16619*/
						if ($1.KbeforeA() == $b) break; /*16619*/
						if ($k[--$j]) { /*16619*/
							$k[$j++] = $1.K; /*16619*/
							break; /*16619*/
						} /*16619*/
						$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16620*/
						if ($1.KbeforeN() == $b) break; /*16620*/
						if ($k[--$j]) { /*16620*/
							$k[$j++] = $1.K; /*16620*/
							break; /*16620*/
						} /*16620*/
						$k[$j++] = $a([5, 5, 6, $1.e, $1.e, 2, 3]); /*16621*/
						if ($1.KbeforeB() == $b) break; /*16621*/
						if ($k[--$j]) { /*16621*/
							$k[$j++] = $1.K; /*16621*/
							break; /*16621*/
						} /*16621*/
						$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16622*/
						if ($1.KbeforeE() == $b) break; /*16622*/
						if ($k[--$j]) { /*16622*/
							$k[$j++] = $1.K; /*16622*/
							break; /*16622*/
						} /*16622*/
						if ($1.numK >= 1) { /*16623*/
							$k[$j++] = $1.B; /*16623*/
							break; /*16623*/
						} /*16623*/
						$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16624*/
						if ($1.AbeforeB() == $b) break; /*16624*/
						if ($k[--$j]) { /*16624*/
							$k[$j++] = $1.A; /*16624*/
							break; /*16624*/
						} /*16624*/
						$k[$j++] = $a([1, 1, 1, $1.e, 1, 1, 1]); /*16625*/
						if ($1.AbeforeE() == $b) break; /*16625*/
						if ($k[--$j]) { /*16625*/
							$k[$j++] = $1.A; /*16625*/
							break; /*16625*/
						} /*16625*/
						if ($1.numA >= 1) { /*16628*/
							var _85 = ($1.ver != $1.vM2) ? $1.B : $1.A; /*16627*/
							$k[$j++] = _85; /*16627*/
							break; /*16627*/
						} /*16627*/
						$k[$j++] = $a([4, 4, 5, $1.e, $1.e, 2, 3]); /*16629*/
						if ($1.NbeforeB() == $b) break; /*16629*/
						if ($k[--$j]) { /*16629*/
							$k[$j++] = $1.N; /*16629*/
							break; /*16629*/
						} /*16629*/
						$k[$j++] = $a([1, 1, 1, $1.e, $1.e, 1, 1]); /*16630*/
						if ($1.NbeforeB() == $b) break; /*16630*/
						if ($k[--$j]) { /*16630*/
							$k[$j++] = $1.B; /*16630*/
							break; /*16630*/
						} /*16630*/
						$k[$j++] = $a([7, 8, 9, $1.e, 3, 4, 5]); /*16631*/
						if ($1.NbeforeA() == $b) break; /*16631*/
						if ($k[--$j]) { /*16631*/
							$k[$j++] = $1.N; /*16631*/
							break; /*16631*/
						} /*16631*/
						$k[$j++] = $a([1, 1, 1, $1.e, 1, 1, 1]); /*16632*/
						if ($1.NbeforeA() == $b) break; /*16632*/
						if ($k[--$j]) { /*16632*/
							$k[$j++] = $1.A; /*16632*/
							break; /*16632*/
						} /*16632*/
						if ($1.numN >= 1) { /*16633*/
							$k[$j++] = $1.N; /*16633*/
							break; /*16633*/
						} /*16633*/
						$k[$j++] = $1.B; /*16634*/
						break; /*16634*/
					} /*16634*/
					if ($1.mode == $1.B) { /*16650*/
						$k[$j++] = $a([9, 12, 13, $1.e, $1.e, 4, 5]); /*16637*/
						if ($1.KbeforeB() == $b) break; /*16637*/
						if ($k[--$j]) { /*16637*/
							$k[$j++] = $1.K; /*16637*/
							break; /*16637*/
						} /*16637*/
						$k[$j++] = $a([9, 10, 12, $1.e, $1.e, 4, 5]); /*16638*/
						if ($1.KbeforeA() == $b) break; /*16638*/
						if ($k[--$j]) { /*16638*/
							$k[$j++] = $1.K; /*16638*/
							break; /*16638*/
						} /*16638*/
						$k[$j++] = $a([9, 10, 11, $1.e, $1.e, 5, 6]); /*16639*/
						if ($1.KbeforeN() == $b) break; /*16639*/
						if ($k[--$j]) { /*16639*/
							$k[$j++] = $1.K; /*16639*/
							break; /*16639*/
						} /*16639*/
						$k[$j++] = $a([4, 5, 6, $1.e, $1.e, 2, 3]); /*16640*/
						if ($1.KbeforeE() == $b) break; /*16640*/
						if ($k[--$j]) { /*16640*/
							$k[$j++] = $1.K; /*16640*/
							break; /*16640*/
						} /*16640*/
						$k[$j++] = $a([11, 12, 14, $1.e, $1.e, 5, 7]); /*16641*/
						if ($1.AbeforeK() == $b) break; /*16641*/
						if ($k[--$j]) { /*16641*/
							$k[$j++] = $1.A; /*16641*/
							break; /*16641*/
						} /*16641*/
						$k[$j++] = $a([11, 15, 16, $1.e, $1.e, 6, 7]); /*16642*/
						if ($1.AbeforeB() == $b) break; /*16642*/
						if ($k[--$j]) { /*16642*/
							$k[$j++] = $1.A; /*16642*/
							break; /*16642*/
						} /*16642*/
						$k[$j++] = $a([12, 13, 15, $1.e, $1.e, 6, 8]); /*16643*/
						if ($1.AbeforeN() == $b) break; /*16643*/
						if ($k[--$j]) { /*16643*/
							$k[$j++] = $1.A; /*16643*/
							break; /*16643*/
						} /*16643*/
						$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16644*/
						if ($1.AbeforeE() == $b) break; /*16644*/
						if ($k[--$j]) { /*16644*/
							$k[$j++] = $1.A; /*16644*/
							break; /*16644*/
						} /*16644*/
						$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16645*/
						if ($1.NbeforeK() == $b) break; /*16645*/
						if ($k[--$j]) { /*16645*/
							$k[$j++] = $1.N; /*16645*/
							break; /*16645*/
						} /*16645*/
						$k[$j++] = $a([6, 8, 9, $1.e, $1.e, 3, 4]); /*16646*/
						if ($1.NbeforeB() == $b) break; /*16646*/
						if ($k[--$j]) { /*16646*/
							$k[$j++] = $1.N; /*16646*/
							break; /*16646*/
						} /*16646*/
						$k[$j++] = $a([6, 7, 8, $1.e, $1.e, 3, 4]); /*16647*/
						if ($1.NbeforeA() == $b) break; /*16647*/
						if ($k[--$j]) { /*16647*/
							$k[$j++] = $1.N; /*16647*/
							break; /*16647*/
						} /*16647*/
						$k[$j++] = $a([3, 4, 5, $1.e, $1.e, 2, 3]); /*16648*/
						if ($1.NbeforeE() == $b) break; /*16648*/
						if ($k[--$j]) { /*16648*/
							$k[$j++] = $1.N; /*16648*/
							break; /*16648*/
						} /*16648*/
						$k[$j++] = $1.B; /*16649*/
						break; /*16649*/
					} /*16649*/
					if ($1.mode == $1.A) { /*16659*/
						if ($1.numK >= 1) { /*16652*/
							$k[$j++] = $1.K; /*16652*/
							break; /*16652*/
						} /*16652*/
						if ($1.numB >= 1) { /*16653*/
							$k[$j++] = $1.B; /*16653*/
							break; /*16653*/
						} /*16653*/
						$k[$j++] = $a([13, 15, 17, $1.e, 5, 7, 9]); /*16654*/
						if ($1.NbeforeA() == $b) break; /*16654*/
						if ($k[--$j]) { /*16654*/
							$k[$j++] = $1.N; /*16654*/
							break; /*16654*/
						} /*16654*/
						$k[$j++] = $a([13, 17, 18, $1.e, $1.e, 7, 9]); /*16655*/
						if ($1.NbeforeB() == $b) break; /*16655*/
						if ($k[--$j]) { /*16655*/
							$k[$j++] = $1.N; /*16655*/
							break; /*16655*/
						} /*16655*/
						$k[$j++] = $a([7, 8, 9, $1.e, 3, 4, 5]); /*16656*/
						if ($1.NbeforeE() == $b) break; /*16656*/
						if ($k[--$j]) { /*16656*/
							$k[$j++] = $1.N; /*16656*/
							break; /*16656*/
						} /*16656*/
						if (($1.numA >= 1) || ($1.numN >= 1)) { /*16657*/
							$k[$j++] = $1.A; /*16657*/
							break; /*16657*/
						} /*16657*/
						$k[$j++] = $1.B; /*16658*/
						break; /*16658*/
					} /*16658*/
					if ($1.mode == $1.N) { /*16666*/
						if ($1.numK >= 1) { /*16661*/
							$k[$j++] = $1.K; /*16661*/
							break; /*16661*/
						} /*16661*/
						if ($1.numB >= 1) { /*16662*/
							$k[$j++] = $1.B; /*16662*/
							break; /*16662*/
						} /*16662*/
						if ($1.numA >= 1) { /*16663*/
							$k[$j++] = $1.A; /*16663*/
							break; /*16663*/
						} /*16663*/
						if ($1.numN >= 1) { /*16664*/
							$k[$j++] = $1.N; /*16664*/
							break; /*16664*/
						} /*16664*/
						$k[$j++] = $1.B; /*16665*/
						break; /*16665*/
					} /*16665*/
					if ($1.mode == $1.K) { /*16673*/
						if ($1.numB >= 1) { /*16668*/
							$k[$j++] = $1.B; /*16668*/
							break; /*16668*/
						} /*16668*/
						if ($1.numA >= 1) { /*16669*/
							$k[$j++] = $1.A; /*16669*/
							break; /*16669*/
						} /*16669*/
						if ($1.numN >= 1) { /*16670*/
							$k[$j++] = $1.N; /*16670*/
							break; /*16670*/
						} /*16670*/
						if ($1.numK >= 1) { /*16671*/
							$k[$j++] = $1.K; /*16671*/
							break; /*16671*/
						} /*16671*/
						$k[$j++] = $1.B; /*16672*/
						break; /*16672*/
					} /*16672*/
				} /*16672*/
				var _AB = $k[--$j]; /*16675*/
				$k[$j++] = _AB; /*16675*/
				if ((_AB == $1.K) && $1.fnc1first) { /*16675*/
					$j--; /*16675*/
					$k[$j++] = $1.B; /*16675*/
				} /*16675*/
				var _AF = $k[--$j]; /*16676*/
				$k[$j++] = _AF; /*16691*/
				if (_AF == $1.mode) { /*16690*/
					$j--; /*16677*/
					var _AL = ($1.mode == $1.K) ? 2 : 1; /*16678*/
					$1.dat = $geti($1.msg, $1.i, _AL); /*16678*/
					$k[$j++] = Infinity; /*16682*/
					$aload($1.seq); /*16680*/
					$k[$j++] = Infinity; /*16681*/
					var _AO = $k[--$j]; /*16681*/
					var _AP = $k[--$j]; /*16681*/
					$k[$j++] = _AO; /*16681*/
					$aload(_AP); /*16681*/
					$aload($1.dat); /*16681*/
					var _AR = $a(); /*16681*/
					$k[$j++] = _AR; /*16681*/
					$1.seq = $a(); /*16682*/
				} else { /*16690*/
					$1.mode = $k[--$j]; /*16684*/
					if ($1.mode == $1.K) { /*16685*/
						$k[$j++] = $1.K; /*16685*/
						$k[$j++] = $geti($1.msg, $1.i, $1.numK * 2); /*16685*/
					} /*16685*/
					if ($1.mode == $1.B) { /*16686*/
						$k[$j++] = $1.B; /*16686*/
						$k[$j++] = $geti($1.msg, $1.i, $1.numB); /*16686*/
					} /*16686*/
					if ($1.mode == $1.A) { /*16687*/
						$k[$j++] = $1.A; /*16687*/
						$k[$j++] = $geti($1.msg, $1.i, $1.numA); /*16687*/
					} /*16687*/
					if ($1.mode == $1.N) { /*16688*/
						$k[$j++] = $1.N; /*16688*/
						$k[$j++] = $geti($1.msg, $1.i, $1.numN); /*16688*/
					} /*16688*/
					$1.dat = $k[--$j]; /*16689*/
					$1.sw = $k[--$j]; /*16689*/
					$k[$j++] = Infinity; /*16690*/
					$aload($1.seq); /*16690*/
					$k[$j++] = $1.sw; /*16690*/
					$k[$j++] = $1.dat; /*16690*/
					$1.seq = $a(); /*16690*/
				} /*16690*/
				$1.i = $1.i + $1.dat.length; /*16692*/
			} /*16692*/
			for (;;) { /*16718*/
				if ($1.seq == -1) { /*16697*/
					break; /*16697*/
				} /*16697*/
				$1.bits = $s(23648); /*16698*/
				$1.j = 0; /*16699*/
				if ($1.fnc1first) { /*16700*/
					$k[$j++] = "0101"; /*16700*/
					if ($1.addtobits() == $b) break; /*16700*/
				} /*16700*/
				$1.abort = false; /*16701*/
				for (var _B9 = 0, _B8 = $1.seq.length - 1; _B9 <= _B8; _B9 += 2) { /*16713*/
					$1.i = _B9; /*16703*/
					$1.mode = $get($1.seq, $1.i); /*16704*/
					$k[$j++] = $get($get($1.mids, $1.ver), $1.mode); /*16705*/
					if ($1.addtobits() == $b) break; /*16705*/
					$1.cclen = $get($get($1.cclens, $1.ver), $1.mode); /*16706*/
					$1.chars = $get($1.seq, $1.i + 1); /*16707*/
					if ($1.chars.length >= (~~Math.pow(2, $1.cclen))) { /*16710*/
						$1.abort = true; /*16709*/
						break; /*16709*/
					} /*16709*/
					$k[$j++] = $1.chars.length; /*16711*/
					if ($1.mode == $1.K) { /*16711*/
						var _BV = $k[--$j]; /*16711*/
						$k[$j++] = ~~(_BV / 2); /*16711*/
					} /*16711*/
					$k[$j++] = $1.cclen; /*16711*/
					if ($1.tobin() == $b) break; /*16711*/
					if ($1.addtobits() == $b) break; /*16711*/
					$k[$j++] = $1.chars; /*16712*/
					$1[$get($1.encfuncs, $1.mode)](); /*16712*/
					if ($1.addtobits() == $b) break; /*16712*/
				} /*16712*/
				if ($1.abort) { /*16714*/
					break; /*16714*/
				} /*16714*/
				$1.bits = $geti($1.bits, 0, $1.j); /*16715*/
				$put($1.msgbits, $1.ver, $1.bits); /*16716*/
				break; /*16717*/
			} /*16717*/
		} /*16717*/
		$1.metrics = $a([$a(["micro", "M1", $1.vM1, 11, 98, 99, 36, $a([2, 99, 99, 99]), $a([1, 0, -1, -1, -1, -1, -1, -1])]), $a(["micro", "M2", $1.vM2, 13, 98, 99, 80, $a([5, 6, 99, 99]), $a([1, 0, 1, 0, -1, -1, -1, -1])]), $a(["micro", "M3", $1.vM3, 15, 98, 99, 132, $a([6, 8, 99, 99]), $a([1, 0, 1, 0, -1, -1, -1, -1])]), $a(["micro", "M4", $1.vM4, 17, 98, 99, 192, $a([8, 10, 14, 99]), $a([1, 0, 1, 0, 1, 0, -1, -1])]), $a(["full", "1", $1.v1to9, 21, 98, 99, 208, $a([7, 10, 13, 17]), $a([1, 0, 1, 0, 1, 0, 1, 0])]), $a(["full", "2", $1.v1to9, 25, 18, 99, 359, $a([10, 16, 22, 28]), $a([1, 0, 1, 0, 1, 0, 1, 0])]), $a(["full", "3", $1.v1to9, 29, 22, 99, 567, $a([15, 26, 36, 44]), $a([1, 0, 1, 0, 2, 0, 2, 0])]), $a(["full", "4", $1.v1to9, 33, 26, 99, 807, $a([20, 36, 52, 64]), $a([1, 0, 2, 0, 2, 0, 4, 0])]), $a(["full", "5", $1.v1to9, 37, 30, 99, 1079, $a([26, 48, 72, 88]), $a([1, 0, 2, 0, 2, 2, 2, 2])]), $a(["full", "6", $1.v1to9, 41, 34, 99, 1383, $a([36, 64, 96, 112]), $a([2, 0, 4, 0, 4, 0, 4, 0])]), $a(["full", "7", $1.v1to9, 45, 22, 38, 1568, $a([40, 72, 108, 130]), $a([2, 0, 4, 0, 2, 4, 4, 1])]), $a(["full", "8", $1.v1to9, 49, 24, 42, 1936, $a([48, 88, 132, 156]), $a([2, 0, 2, 2, 4, 2, 4, 2])]), $a(["full", "9", $1.v1to9, 53, 26, 46, 2336, $a([60, 110, 160, 192]), $a([2, 0, 3, 2, 4, 4, 4, 4])]), $a(["full", "10", $1.v10to26, 57, 28, 50, 2768, $a([72, 130, 192, 224]), $a([2, 2, 4, 1, 6, 2, 6, 2])]), $a(["full", "11", $1.v10to26, 61, 30, 54, 3232, $a([80, 150, 224, 264]), $a([4, 0, 1, 4, 4, 4, 3, 8])]), $a(["full", "12", $1.v10to26, 65, 32, 58, 3728, $a([96, 176, 260, 308]), $a([2, 2, 6, 2, 4, 6, 7, 4])]), $a(["full", "13", $1.v10to26, 69, 34, 62, 4256, $a([104, 198, 288, 352]), $a([4, 0, 8, 1, 8, 4, 12, 4])]), $a(["full", "14", $1.v10to26, 73, 26, 46, 4651, $a([120, 216, 320, 384]), $a([3, 1, 4, 5, 11, 5, 11, 5])]), $a(["full", "15", $1.v10to26, 77, 26, 48, 5243, $a([132, 240, 360, 432]), $a([5, 1, 5, 5, 5, 7, 11, 7])]), $a(["full", "16", $1.v10to26, 81, 26, 50, 5867, $a([144, 280, 408, 480]), $a([5, 1, 7, 3, 15, 2, 3, 13])]), $a(["full", "17", $1.v10to26, 85, 30, 54, 6523, $a([168, 308, 448, 532]), $a([1, 5, 10, 1, 1, 15, 2, 17])]), $a(["full", "18", $1.v10to26, 89, 30, 56, 7211, $a([180, 338, 504, 588]), $a([5, 1, 9, 4, 17, 1, 2, 19])]), $a(["full", "19", $1.v10to26, 93, 30, 58, 7931, $a([196, 364, 546, 650]), $a([3, 4, 3, 11, 17, 4, 9, 16])]), $a(["full", "20", $1.v10to26, 97, 34, 62, 8683, $a([224, 416, 600, 700]), $a([3, 5, 3, 13, 15, 5, 15, 10])]), $a(["full", "21", $1.v10to26, 101, 28, 50, 9252, $a([224, 442, 644, 750]), $a([4, 4, 17, 0, 17, 6, 19, 6])]), $a(["full", "22", $1.v10to26, 105, 26, 50, 10068, $a([252, 476, 690, 816]), $a([2, 7, 17, 0, 7, 16, 34, 0])]), $a(["full", "23", $1.v10to26, 109, 30, 54, 10916, $a([270, 504, 750, 900]), $a([4, 5, 4, 14, 11, 14, 16, 14])]), $a(["full", "24", $1.v10to26, 113, 28, 54, 11796, $a([300, 560, 810, 960]), $a([6, 4, 6, 14, 11, 16, 30, 2])]), $a(["full", "25", $1.v10to26, 117, 32, 58, 12708, $a([312, 588, 870, 1050]), $a([8, 4, 8, 13, 7, 22, 22, 13])]), $a(["full", "26", $1.v10to26, 121, 30, 58, 13652, $a([336, 644, 952, 1110]), $a([10, 2, 19, 4, 28, 6, 33, 4])]), $a(["full", "27", $1.v27to40, 125, 34, 62, 14628, $a([360, 700, 1020, 1200]), $a([8, 4, 22, 3, 8, 26, 12, 28])]), $a(["full", "28", $1.v27to40, 129, 26, 50, 15371, $a([390, 728, 1050, 1260]), $a([3, 10, 3, 23, 4, 31, 11, 31])]), $a(["full", "29", $1.v27to40, 133, 30, 54, 16411, $a([420, 784, 1140, 1350]), $a([7, 7, 21, 7, 1, 37, 19, 26])]), $a(["full", "30", $1.v27to40, 137, 26, 52, 17483, $a([450, 812, 1200, 1440]), $a([5, 10, 19, 10, 15, 25, 23, 25])]), $a(["full", "31", $1.v27to40, 141, 30, 56, 18587, $a([480, 868, 1290, 1530]), $a([13, 3, 2, 29, 42, 1, 23, 28])]), $a(["full", "32", $1.v27to40, 145, 34, 60, 19723, $a([510, 924, 1350, 1620]), $a([17, 0, 10, 23, 10, 35, 19, 35])]), $a(["full", "33", $1.v27to40, 149, 30, 58, 20891, $a([540, 980, 1440, 1710]), $a([17, 1, 14, 21, 29, 19, 11, 46])]), $a(["full", "34", $1.v27to40, 153, 34, 62, 22091, $a([570, 1036, 1530, 1800]), $a([13, 6, 14, 23, 44, 7, 59, 1])]), $a(["full", "35", $1.v27to40, 157, 30, 54, 23008, $a([570, 1064, 1590, 1890]), $a([12, 7, 12, 26, 39, 14, 22, 41])]), $a(["full", "36", $1.v27to40, 161, 24, 50, 24272, $a([600, 1120, 1680, 1980]), $a([6, 14, 6, 34, 46, 10, 2, 64])]), $a(["full", "37", $1.v27to40, 165, 28, 54, 25568, $a([630, 1204, 1770, 2100]), $a([17, 4, 29, 14, 49, 10, 24, 46])]), $a(["full", "38", $1.v27to40, 169, 32, 58, 26896, $a([660, 1260, 1860, 2220]), $a([4, 18, 13, 32, 48, 14, 42, 32])]), $a(["full", "39", $1.v27to40, 173, 26, 54, 28256, $a([720, 1316, 1950, 2310]), $a([20, 4, 40, 7, 43, 22, 10, 67])]), $a(["full", "40", $1.v27to40, 177, 30, 58, 29648, $a([750, 1372, 2040, 2430]), $a([19, 6, 18, 31, 34, 34, 20, 61])])]); /*16769*/
		$k[$j++] = "eclval"; /*16770*/
		$search("LMQH", $1.eclevel); /*16770*/
		$j--; /*16770*/
		var _Eb = $k[--$j]; /*16770*/
		var _Ec = $k[--$j]; /*16770*/
		var _Ed = $k[--$j]; /*16770*/
		$1[$k[--$j]] = _Eb.length; /*16770*/
		for (var _Ef = 0; _Ef <= 43; _Ef += 1) { /*16807*/
			$1.i = _Ef; /*16772*/
			$1.m = $get($1.metrics, $1.i); /*16773*/
			$1.frmt = $get($1.m, 0); /*16774*/
			$1.vers = $get($1.m, 1); /*16775*/
			$1.vergrp = $get($1.m, 2); /*16776*/
			$1.size = $get($1.m, 3); /*16777*/
			$1.asp2 = $get($1.m, 4); /*16778*/
			$1.asp3 = $get($1.m, 5); /*16779*/
			$1.nmod = $get($1.m, 6); /*16780*/
			$1.ncws = ~~($1.nmod / 8); /*16781*/
			$1.rbit = $1.nmod % 8; /*16782*/
			$1.lc4b = false; /*16783*/
			if (($1.size == 11) || ($1.size == 15)) { /*16788*/
				$1.ncws = $1.ncws + 1; /*16785*/
				$1.rbit = 0; /*16786*/
				$1.lc4b = true; /*16787*/
			} /*16787*/
			$1.ecws = $get($get($1.m, 7), $1.eclval); /*16789*/
			$1.dcws = $1.ncws - $1.ecws; /*16790*/
			var _FA = $1.lc4b ? 4 : 0; /*16791*/
			$1.dmod = ($1.dcws * 8) - _FA; /*16791*/
			$1.ecb1 = $get($get($1.m, 8), $1.eclval * 2); /*16792*/
			$1.ecb2 = $get($get($1.m, 8), ($1.eclval * 2) + 1); /*16793*/
			$1.okay = true; /*16794*/
			if ($ne($1.format, "any") && $ne($1.format, $1.frmt)) { /*16795*/
				$1.okay = false; /*16795*/
			} /*16795*/
			if ($eq($1.frmt, "micro") && $1.fnc1first) { /*16796*/
				$1.okay = false; /*16796*/
			} /*16796*/
			if ($ne($1.version, "unset") && $ne($1.version, $1.vers)) { /*16797*/
				$1.okay = false; /*16797*/
			} /*16797*/
			if (($1.ecb1 == -1) || ($1.ecb2 == -1)) { /*16798*/
				$1.okay = false; /*16798*/
			} /*16798*/
			$1.verbits = $get($1.msgbits, $1.vergrp); /*16799*/
			if ($1.verbits == -1) { /*16803*/
				$1.okay = false; /*16801*/
			} else { /*16803*/
				if ($1.verbits.length > $1.dmod) { /*16803*/
					$1.okay = false; /*16803*/
				} /*16803*/
			} /*16803*/
			$1.term = $geti("000000000", 0, $get($1.termlens, $1.vergrp)); /*16805*/
			if ($1.okay) { /*16806*/
				break; /*16806*/
			} /*16806*/
		} /*16806*/
		if (!$1.okay) { /*16811*/
			$k[$j++] = "bwipp.qrcodeNoValidSymbol"; /*16810*/
			$k[$j++] = "No valid symbol available"; /*16810*/
			$0.raiseerror(); /*16810*/
		} /*16810*/
		$1.format = $1.frmt; /*16813*/
		$1.version = $1.vers; /*16814*/
		$1.msgbits = $1.verbits; /*16815*/
		$1.dcpb = ~~($1.dcws / ($1.ecb1 + $1.ecb2)); /*16816*/
		$1.ecpb = (~~($1.ncws / ($1.ecb1 + $1.ecb2))) - $1.dcpb; /*16817*/
		var _Fp = $1.term; /*16820*/
		var _Fq = $1.dmod; /*16820*/
		var _Fr = $1.msgbits; /*16820*/
		var _Fs = $1.term; /*16820*/
		var _Ft = _Fs.length; /*16820*/
		var _Fu = _Fq - _Fr.length; /*16820*/
		if ((_Fq - _Fr.length) > _Fs.length) { /*16820*/
			var _ = _Ft; /*16820*/
			_Ft = _Fu; /*16820*/
			_Fu = _; /*16820*/
		} /*16820*/
		$1.term = $geti(_Fp, 0, _Fu); /*16820*/
		var _Fy = $s($1.msgbits.length + $1.term.length); /*16821*/
		$puti(_Fy, 0, $1.msgbits); /*16822*/
		$puti(_Fy, $1.msgbits.length, $1.term); /*16823*/
		$1.msgbits = _Fy; /*16824*/
		$1.pad = $s($1.dmod); /*16827*/
		for (var _G6 = 0, _G5 = $1.pad.length - 1; _G6 <= _G5; _G6 += 1) { /*16828*/
			$put($1.pad, _G6, 48); /*16828*/
		} /*16828*/
		$puti($1.pad, 0, $1.msgbits); /*16829*/
		$1.padstrs = $a(["11101100", "00010001"]); /*16830*/
		$1.padnum = 0; /*16831*/
		var _GE = $1.lc4b ? 5 : 1; /*16832*/
		for (var _GG = ~~(Math.ceil($1.msgbits.length / 8) * 8), _GF = $1.dmod - _GE; _GG <= _GF; _GG += 8) { /*16835*/
			$puti($1.pad, _GG, $get($1.padstrs, $1.padnum)); /*16833*/
			$1.padnum = ($1.padnum + 1) % 2; /*16834*/
		} /*16834*/
		$1.cws = $a($1.dcws); /*16838*/
		for (var _GQ = 0, _GP = $1.cws.length - 1; _GQ <= _GP; _GQ += 1) { /*16850*/
			$1.c = _GQ; /*16840*/
			$1.bpcw = 8; /*16841*/
			if ($1.lc4b && ($1.c == ($1.cws.length - 1))) { /*16842*/
				$1.bpcw = 4; /*16842*/
			} /*16842*/
			$1.cwb = $geti($1.pad, $1.c * 8, $1.bpcw); /*16843*/
			$1.cw = 0; /*16844*/
			for (var _Ga = 0, _GZ = $1.bpcw - 1; _Ga <= _GZ; _Ga += 1) { /*16848*/
				$1.i = _Ga; /*16846*/
				$1.cw = $1.cw + ((~~(Math.pow(2, ($1.bpcw - $1.i) - 1))) * ($get($1.cwb, $1.i) - 48)); /*16847*/
			} /*16847*/
			$put($1.cws, $1.c, $1.cw); /*16849*/
		} /*16849*/
		if ($1.lc4b) { /*16853*/
			var _Gl = $1.cws; /*16853*/
			var _Gm = $1.cws; /*16853*/
			$put(_Gl, _Gm.length - 1, $get(_Gl, _Gm.length - 1) << 4); /*16853*/
		} /*16853*/
		$k[$j++] = Infinity; /*16856*/
		$k[$j++] = 1; /*16856*/
		for (var _Go = 0, _Gp = 255; _Go < _Gp; _Go++) { /*16856*/
			var _Gq = $k[--$j]; /*16856*/
			var _Gr = _Gq * 2; /*16856*/
			$k[$j++] = _Gq; /*16856*/
			$k[$j++] = _Gr; /*16856*/
			if (_Gr >= 256) { /*16856*/
				var _Gs = $k[--$j]; /*16856*/
				$k[$j++] = _Gs ^ 285; /*16856*/
			} /*16856*/
		} /*16856*/
		$1.rsalog = $a(); /*16856*/
		$1.rslog = $a(256); /*16857*/
		for (var _Gv = 1; _Gv <= 255; _Gv += 1) { /*16858*/
			$put($1.rslog, $get($1.rsalog, _Gv), _Gv); /*16858*/
		} /*16858*/
		$1.rsprod = function() {
			var _Gz = $k[--$j]; /*16862*/
			var _H0 = $k[--$j]; /*16862*/
			$k[$j++] = _H0; /*16866*/
			$k[$j++] = _Gz; /*16866*/
			if ((_Gz != 0) && (_H0 != 0)) { /*16865*/
				var _H3 = $get($1.rslog, $k[--$j]); /*16863*/
				var _H8 = $get($1.rsalog, (_H3 + $get($1.rslog, $k[--$j])) % 255); /*16863*/
				$k[$j++] = _H8; /*16863*/
			} else { /*16865*/
				$j -= 2; /*16865*/
				$k[$j++] = 0; /*16865*/
			} /*16865*/
		}; /*16867*/
		$k[$j++] = Infinity; /*16870*/
		$k[$j++] = 1; /*16870*/
		for (var _HA = 0, _HB = $1.ecpb; _HA < _HB; _HA++) { /*16870*/
			$k[$j++] = 0; /*16870*/
		} /*16870*/
		$1.coeffs = $a(); /*16870*/
		for (var _HF = 0, _HE = $1.ecpb - 1; _HF <= _HE; _HF += 1) { /*16879*/
			$1.i = _HF; /*16872*/
			$put($1.coeffs, $1.i + 1, $get($1.coeffs, $1.i)); /*16873*/
			for (var _HM = $1.i; _HM >= 1; _HM -= 1) { /*16877*/
				$1.j = _HM; /*16875*/
				$k[$j++] = $1.coeffs; /*16876*/
				$k[$j++] = $1.j; /*16876*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*16876*/
				$k[$j++] = $get($1.coeffs, $1.j); /*16876*/
				$k[$j++] = $get($1.rsalog, $1.i); /*16876*/
				if ($1.rsprod() == $b) break; /*16876*/
				var _HY = $k[--$j]; /*16876*/
				var _HZ = $k[--$j]; /*16876*/
				var _Ha = $k[--$j]; /*16876*/
				$put($k[--$j], _Ha, $xo(_HZ, _HY)); /*16876*/
			} /*16876*/
			$k[$j++] = $1.coeffs; /*16878*/
			$k[$j++] = 0; /*16878*/
			$k[$j++] = $get($1.coeffs, 0); /*16878*/
			$k[$j++] = $get($1.rsalog, $1.i); /*16878*/
			if ($1.rsprod() == $b) break; /*16878*/
			var _Hi = $k[--$j]; /*16878*/
			var _Hj = $k[--$j]; /*16878*/
			$put($k[--$j], _Hj, _Hi); /*16878*/
		} /*16878*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*16880*/
		$1.rscodes = function() {
			$1.rscws = $k[--$j]; /*16884*/
			$1.rsnd = $1.rscws.length; /*16885*/
			$k[$j++] = Infinity; /*16886*/
			$forall($1.rscws); /*16886*/
			for (var _Hs = 0, _Ht = $1.ecpb; _Hs < _Ht; _Hs++) { /*16886*/
				$k[$j++] = 0; /*16886*/
			} /*16886*/
			$1.rscws = $a(); /*16886*/
			for (var _Hx = 0, _Hw = $1.rsnd - 1; _Hx <= _Hw; _Hx += 1) { /*16894*/
				$1.m = _Hx; /*16888*/
				$1.k = $get($1.rscws, $1.m); /*16889*/
				for (var _I3 = 0, _I2 = $1.ecpb - 1; _I3 <= _I2; _I3 += 1) { /*16893*/
					$1.j = _I3; /*16891*/
					$k[$j++] = $1.rscws; /*16892*/
					$k[$j++] = ($1.m + $1.j) + 1; /*16892*/
					$k[$j++] = $get($1.coeffs, ($1.ecpb - $1.j) - 1); /*16892*/
					$k[$j++] = $1.k; /*16892*/
					if ($1.rsprod() == $b) break; /*16892*/
					var _IG = $k[--$j]; /*16892*/
					var _IH = $k[--$j]; /*16892*/
					$put($k[--$j], _IH, $xo(_IG, $get($1.rscws, ($1.m + $1.j) + 1))); /*16892*/
				} /*16892*/
			} /*16892*/
			$k[$j++] = $geti($1.rscws, $1.rsnd, $1.ecpb); /*16895*/
		}; /*16896*/
		$1.dcwsb = $a($1.ecb1 + $1.ecb2); /*16899*/
		$1.ecwsb = $a($1.ecb1 + $1.ecb2); /*16900*/
		for (var _IV = 0, _IU = $1.ecb1 - 1; _IV <= _IU; _IV += 1) { /*16905*/
			$1.i = _IV; /*16902*/
			$put($1.dcwsb, $1.i, $geti($1.cws, $1.i * $1.dcpb, $1.dcpb)); /*16903*/
			$k[$j++] = $1.ecwsb; /*16904*/
			$k[$j++] = $1.i; /*16904*/
			$k[$j++] = $get($1.dcwsb, $1.i); /*16904*/
			if ($1.rscodes() == $b) break; /*16904*/
			var _Ii = $k[--$j]; /*16904*/
			var _Ij = $k[--$j]; /*16904*/
			$put($k[--$j], _Ij, _Ii); /*16904*/
		} /*16904*/
		for (var _In = 0, _Im = $1.ecb2 - 1; _In <= _Im; _In += 1) { /*16910*/
			$1.i = _In; /*16907*/
			$put($1.dcwsb, $1.ecb1 + $1.i, $geti($1.cws, ($1.ecb1 * $1.dcpb) + ($1.i * ($1.dcpb + 1)), $1.dcpb + 1)); /*16908*/
			$k[$j++] = $1.ecwsb; /*16909*/
			$k[$j++] = $1.ecb1 + $1.i; /*16909*/
			$k[$j++] = $get($1.dcwsb, $1.ecb1 + $1.i); /*16909*/
			if ($1.rscodes() == $b) break; /*16909*/
			var _J5 = $k[--$j]; /*16909*/
			var _J6 = $k[--$j]; /*16909*/
			$put($k[--$j], _J6, _J5); /*16909*/
		} /*16909*/
		$1.cws = $a($1.ncws); /*16913*/
		$1.cw = 0; /*16914*/
		for (var _JC = 0, _JB = $1.dcpb; _JC <= _JB; _JC += 1) { /*16924*/
			$1.i = _JC; /*16916*/
			for (var _JG = 0, _JF = ($1.ecb1 + $1.ecb2) - 1; _JG <= _JF; _JG += 1) { /*16923*/
				$1.j = _JG; /*16918*/
				if ($1.i < $get($1.dcwsb, $1.j).length) { /*16922*/
					$put($1.cws, $1.cw, $get($get($1.dcwsb, $1.j), $1.i)); /*16920*/
					$1.cw = $1.cw + 1; /*16921*/
				} /*16921*/
			} /*16921*/
		} /*16921*/
		for (var _JV = 0, _JU = $1.ecpb - 1; _JV <= _JU; _JV += 1) { /*16932*/
			$1.i = _JV; /*16926*/
			for (var _JZ = 0, _JY = ($1.ecb1 + $1.ecb2) - 1; _JZ <= _JY; _JZ += 1) { /*16931*/
				$1.j = _JZ; /*16928*/
				$put($1.cws, $1.cw, $get($get($1.ecwsb, $1.j), $1.i)); /*16929*/
				$1.cw = $1.cw + 1; /*16930*/
			} /*16930*/
		} /*16930*/
		if ($1.rbit > 0) { /*16940*/
			$1.pad = $a($1.cws.length + 1); /*16936*/
			$puti($1.pad, 0, $1.cws); /*16937*/
			$put($1.pad, $1.pad.length - 1, 0); /*16938*/
			$1.cws = $1.pad; /*16939*/
		} /*16939*/
		if ($1.lc4b) { /*16951*/
			var _Jr = $1.cws; /*16944*/
			var _Js = $1.dcws; /*16944*/
			$put(_Jr, _Js - 1, $get(_Jr, _Js - 1) >>> 4); /*16944*/
			for (var _Jx = $1.dcws - 1, _Jw = $1.ncws - 2; _Jx <= _Jw; _Jx += 1) { /*16949*/
				$1.i = _Jx; /*16946*/
				$put($1.cws, $1.i, ($get($1.cws, $1.i) & 15) << 4); /*16947*/
				$put($1.cws, $1.i, (($get($1.cws, $1.i + 1) >>> 4) & 15) | $get($1.cws, $1.i)); /*16948*/
			} /*16948*/
			$put($1.cws, $1.ncws - 1, ($get($1.cws, $1.ncws - 1) & 15) << 4); /*16950*/
		} /*16950*/
		$k[$j++] = Infinity; /*16954*/
		for (var _KI = 0, _KJ = $1.size * $1.size; _KI < _KJ; _KI++) { /*16954*/
			$k[$j++] = -1; /*16954*/
		} /*16954*/
		$1.pixs = $a(); /*16954*/
		$1.qmv = function() {
			var _KM = $k[--$j]; /*16955*/
			var _KN = $k[--$j]; /*16955*/
			$k[$j++] = _KN + (_KM * $1.size); /*16955*/
		}; /*16955*/
		$1.fpat = $a([$a([1, 1, 1, 1, 1, 1, 1, 0]), $a([1, 0, 0, 0, 0, 0, 1, 0]), $a([1, 0, 1, 1, 1, 0, 1, 0]), $a([1, 0, 1, 1, 1, 0, 1, 0]), $a([1, 0, 1, 1, 1, 0, 1, 0]), $a([1, 0, 0, 0, 0, 0, 1, 0]), $a([1, 1, 1, 1, 1, 1, 1, 0]), $a([0, 0, 0, 0, 0, 0, 0, 0])]); /*16967*/
		for (var _KZ = 0, _KY = $1.fpat.length - 1; _KZ <= _KY; _KZ += 1) { /*16979*/
			$1.y = _KZ; /*16969*/
			for (var _Kd = 0, _Kc = $get($1.fpat, 0).length - 1; _Kd <= _Kc; _Kd += 1) { /*16978*/
				$1.x = _Kd; /*16971*/
				$1.fpb = $get($get($1.fpat, $1.y), $1.x); /*16972*/
				$k[$j++] = $1.pixs; /*16973*/
				$k[$j++] = $1.x; /*16973*/
				$k[$j++] = $1.y; /*16973*/
				if ($1.qmv() == $b) break; /*16973*/
				var _Kn = $k[--$j]; /*16973*/
				$put($k[--$j], _Kn, $1.fpb); /*16973*/
				if ($eq($1.format, "full")) { /*16977*/
					$k[$j++] = $1.pixs; /*16975*/
					$k[$j++] = ($1.size - $1.x) - 1; /*16975*/
					$k[$j++] = $1.y; /*16975*/
					if ($1.qmv() == $b) break; /*16975*/
					var _Kv = $k[--$j]; /*16975*/
					$put($k[--$j], _Kv, $1.fpb); /*16975*/
					$k[$j++] = $1.pixs; /*16976*/
					$k[$j++] = $1.x; /*16976*/
					$k[$j++] = ($1.size - $1.y) - 1; /*16976*/
					if ($1.qmv() == $b) break; /*16976*/
					var _L2 = $k[--$j]; /*16976*/
					$put($k[--$j], _L2, $1.fpb); /*16976*/
				} /*16976*/
			} /*16976*/
		} /*16976*/
		$1.algnpat = $a([$a([1, 1, 1, 1, 1]), $a([1, 0, 0, 0, 1]), $a([1, 0, 1, 0, 1]), $a([1, 0, 0, 0, 1]), $a([1, 1, 1, 1, 1])]); /*16988*/
		$1.putalgnpat = function() {
			$1.py = $k[--$j]; /*16990*/
			$1.px = $k[--$j]; /*16991*/
			for (var _LC = 0; _LC <= 4; _LC += 1) { /*16998*/
				$1.pb = _LC; /*16993*/
				for (var _LD = 0; _LD <= 4; _LD += 1) { /*16997*/
					$1.pa = _LD; /*16995*/
					$k[$j++] = $1.pixs; /*16996*/
					$k[$j++] = $1.px + $1.pa; /*16996*/
					$k[$j++] = $1.py + $1.pb; /*16996*/
					if ($1.qmv() == $b) break; /*16996*/
					var _LO = $k[--$j]; /*16996*/
					$put($k[--$j], _LO, $get($get($1.algnpat, $1.pb), $1.pa)); /*16996*/
				} /*16996*/
			} /*16996*/
		}; /*16999*/
		for (var _LV = $1.asp2 - 2, _LW = $1.asp3 - $1.asp2, _LU = $1.size - 13; _LW < 0 ? _LV >= _LU : _LV <= _LU; _LV += _LW) { /*17004*/
			$1.i = _LV; /*17001*/
			$k[$j++] = $1.i; /*17002*/
			$k[$j++] = 4; /*17002*/
			if ($1.putalgnpat() == $b) break; /*17002*/
			$k[$j++] = 4; /*17003*/
			$k[$j++] = $1.i; /*17003*/
			if ($1.putalgnpat() == $b) break; /*17003*/
		} /*17003*/
		for (var _Le = $1.asp2 - 2, _Lf = $1.asp3 - $1.asp2, _Ld = $1.size - 9; _Lf < 0 ? _Le >= _Ld : _Le <= _Ld; _Le += _Lf) { /*17011*/
			$1.x = _Le; /*17006*/
			for (var _Ll = $1.asp2 - 2, _Lm = $1.asp3 - $1.asp2, _Lk = $1.size - 9; _Lm < 0 ? _Ll >= _Lk : _Ll <= _Lk; _Ll += _Lm) { /*17010*/
				$1.y = _Ll; /*17008*/
				$k[$j++] = $1.x; /*17009*/
				$k[$j++] = $1.y; /*17009*/
				if ($1.putalgnpat() == $b) break; /*17009*/
			} /*17009*/
		} /*17009*/
		if ($eq($1.format, "full")) { /*17024*/
			for (var _Ls = 8, _Lr = $1.size - 9; _Ls <= _Lr; _Ls += 1) { /*17019*/
				$1.i = _Ls; /*17016*/
				$k[$j++] = $1.pixs; /*17017*/
				$k[$j++] = $1.i; /*17017*/
				$k[$j++] = 6; /*17017*/
				if ($1.qmv() == $b) break; /*17017*/
				var _Lw = $k[--$j]; /*17017*/
				$put($k[--$j], _Lw, ($1.i + 1) % 2); /*17017*/
				$k[$j++] = $1.pixs; /*17018*/
				$k[$j++] = 6; /*17018*/
				$k[$j++] = $1.i; /*17018*/
				if ($1.qmv() == $b) break; /*17018*/
				var _M1 = $k[--$j]; /*17018*/
				$put($k[--$j], _M1, ($1.i + 1) % 2); /*17018*/
			} /*17018*/
		} else { /*17024*/
			for (var _M5 = 8, _M4 = $1.size - 1; _M5 <= _M4; _M5 += 1) { /*17025*/
				$1.i = _M5; /*17022*/
				$k[$j++] = $1.pixs; /*17023*/
				$k[$j++] = $1.i; /*17023*/
				$k[$j++] = 0; /*17023*/
				if ($1.qmv() == $b) break; /*17023*/
				var _M9 = $k[--$j]; /*17023*/
				$put($k[--$j], _M9, ($1.i + 1) % 2); /*17023*/
				$k[$j++] = $1.pixs; /*17024*/
				$k[$j++] = 0; /*17024*/
				$k[$j++] = $1.i; /*17024*/
				if ($1.qmv() == $b) break; /*17024*/
				var _ME = $k[--$j]; /*17024*/
				$put($k[--$j], _ME, ($1.i + 1) % 2); /*17024*/
			} /*17024*/
		} /*17024*/
		if ($eq($1.format, "full")) { /*17042*/
			$1.formatmap = $a([$a([$a([0, 8]), $a([8, $1.size - 1])]), $a([$a([1, 8]), $a([8, $1.size - 2])]), $a([$a([2, 8]), $a([8, $1.size - 3])]), $a([$a([3, 8]), $a([8, $1.size - 4])]), $a([$a([4, 8]), $a([8, $1.size - 5])]), $a([$a([5, 8]), $a([8, $1.size - 6])]), $a([$a([7, 8]), $a([8, $1.size - 7])]), $a([$a([8, 8]), $a([$1.size - 8, 8])]), $a([$a([8, 7]), $a([$1.size - 7, 8])]), $a([$a([8, 5]), $a([$1.size - 6, 8])]), $a([$a([8, 4]), $a([$1.size - 5, 8])]), $a([$a([8, 3]), $a([$1.size - 4, 8])]), $a([$a([8, 2]), $a([$1.size - 3, 8])]), $a([$a([8, 1]), $a([$1.size - 2, 8])]), $a([$a([8, 0]), $a([$1.size - 1, 8])])]); /*17036*/
		} else { /*17042*/
			$1.formatmap = $a([$a([$a([1, 8])]), $a([$a([2, 8])]), $a([$a([3, 8])]), $a([$a([4, 8])]), $a([$a([5, 8])]), $a([$a([6, 8])]), $a([$a([7, 8])]), $a([$a([8, 8])]), $a([$a([8, 7])]), $a([$a([8, 6])]), $a([$a([8, 5])]), $a([$a([8, 4])]), $a([$a([8, 3])]), $a([$a([8, 2])]), $a([$a([8, 1])])]); /*17042*/
		} /*17042*/
		var _Nl = $1.formatmap; /*17044*/
		for (var _Nm = 0, _Nn = _Nl.length; _Nm < _Nn; _Nm++) { /*17046*/
			$forall($get(_Nl, _Nm), function() { /*17045*/
				$forall($k[--$j]); /*17045*/
				if ($1.qmv() == $b) return $b; /*17045*/
				$put($1.pixs, $k[--$j], 0); /*17045*/
			}); /*17045*/
		} /*17045*/
		if ($1.size >= 45) { /*17062*/
			$1.versionmap = $a([$a([$a([$1.size - 9, 5]), $a([5, $1.size - 9])]), $a([$a([$1.size - 10, 5]), $a([5, $1.size - 10])]), $a([$a([$1.size - 11, 5]), $a([5, $1.size - 11])]), $a([$a([$1.size - 9, 4]), $a([4, $1.size - 9])]), $a([$a([$1.size - 10, 4]), $a([4, $1.size - 10])]), $a([$a([$1.size - 11, 4]), $a([4, $1.size - 11])]), $a([$a([$1.size - 9, 3]), $a([3, $1.size - 9])]), $a([$a([$1.size - 10, 3]), $a([3, $1.size - 10])]), $a([$a([$1.size - 11, 3]), $a([3, $1.size - 11])]), $a([$a([$1.size - 9, 2]), $a([2, $1.size - 9])]), $a([$a([$1.size - 10, 2]), $a([2, $1.size - 10])]), $a([$a([$1.size - 11, 2]), $a([2, $1.size - 11])]), $a([$a([$1.size - 9, 1]), $a([1, $1.size - 9])]), $a([$a([$1.size - 10, 1]), $a([1, $1.size - 10])]), $a([$a([$1.size - 11, 1]), $a([1, $1.size - 11])]), $a([$a([$1.size - 9, 0]), $a([0, $1.size - 9])]), $a([$a([$1.size - 10, 0]), $a([0, $1.size - 10])]), $a([$a([$1.size - 11, 0]), $a([0, $1.size - 11])])]); /*17060*/
		} else { /*17062*/
			$1.versionmap = $a([]); /*17062*/
		} /*17062*/
		var _PN = $1.versionmap; /*17064*/
		for (var _PO = 0, _PP = _PN.length; _PO < _PP; _PO++) { /*17066*/
			$forall($get(_PN, _PO), function() { /*17065*/
				$forall($k[--$j]); /*17065*/
				if ($1.qmv() == $b) return $b; /*17065*/
				$put($1.pixs, $k[--$j], 0); /*17065*/
			}); /*17065*/
		} /*17065*/
		if ($eq($1.format, "full")) { /*17071*/
			$k[$j++] = $1.pixs; /*17070*/
			$k[$j++] = 8; /*17070*/
			$k[$j++] = $1.size - 8; /*17070*/
			if ($1.qmv() == $b) return $b; /*17070*/
			var _PX = $k[--$j]; /*17070*/
			$put($k[--$j], _PX, 0); /*17070*/
		} /*17070*/
		if ($eq($1.format, "full")) { /*17091*/
			var _Pr = $a([function() {
				var _Pa = $k[--$j]; /*17076*/
				var _Pb = $k[--$j]; /*17076*/
				$k[$j++] = (_Pb + _Pa) % 2; /*17076*/
			}, function() {
				var _Pc = $k[--$j]; /*17077*/
				var _Pd = $k[--$j]; /*17077*/
				$k[$j++] = _Pc % 2; /*17077*/
			}, function() {
				$j--; /*17078*/
				var _Pe = $k[--$j]; /*17078*/
				$k[$j++] = _Pe % 3; /*17078*/
			}, function() {
				var _Pf = $k[--$j]; /*17079*/
				var _Pg = $k[--$j]; /*17079*/
				$k[$j++] = (_Pg + _Pf) % 3; /*17079*/
			}, function() {
				var _Ph = $k[--$j]; /*17080*/
				var _Pi = $k[--$j]; /*17080*/
				$k[$j++] = ((~~(_Ph / 2)) + (~~(_Pi / 3))) % 2; /*17080*/
			}, function() {
				var _Pj = $k[--$j]; /*17081*/
				var _Pl = $k[--$j] * _Pj; /*17081*/
				$k[$j++] = (_Pl % 2) + (_Pl % 3); /*17081*/
			}, function() {
				var _Pm = $k[--$j]; /*17082*/
				var _Po = $k[--$j] * _Pm; /*17082*/
				$k[$j++] = ((_Po % 2) + (_Po % 3)) % 2; /*17082*/
			}, function() {
				var _Pp = $k[--$j]; /*17083*/
				var _Pq = $k[--$j]; /*17083*/
				$k[$j++] = (((_Pq * _Pp) % 3) + ((_Pq + _Pp) % 2)) % 2; /*17083*/
			}]); /*17083*/
			$1.maskfuncs = _Pr; /*17084*/
		} else { /*17091*/
			var _Q1 = $a([function() {
				var _Ps = $k[--$j]; /*17087*/
				var _Pt = $k[--$j]; /*17087*/
				$k[$j++] = _Ps % 2; /*17087*/
			}, function() {
				var _Pu = $k[--$j]; /*17088*/
				var _Pv = $k[--$j]; /*17088*/
				$k[$j++] = ((~~(_Pu / 2)) + (~~(_Pv / 3))) % 2; /*17088*/
			}, function() {
				var _Pw = $k[--$j]; /*17089*/
				var _Py = $k[--$j] * _Pw; /*17089*/
				$k[$j++] = ((_Py % 2) + (_Py % 3)) % 2; /*17089*/
			}, function() {
				var _Pz = $k[--$j]; /*17090*/
				var _Q0 = $k[--$j]; /*17090*/
				$k[$j++] = (((_Q0 * _Pz) % 3) + ((_Q0 + _Pz) % 2)) % 2; /*17090*/
			}]); /*17090*/
			$1.maskfuncs = _Q1; /*17091*/
		} /*17091*/
		if ($1.mask != -1) { /*17096*/
			$1.maskfuncs = $a([$get($1.maskfuncs, $1.mask - 1)]); /*17094*/
			$1.bestmaskval = $1.mask - 1; /*17095*/
		} /*17095*/
		$1.masks = $a($1.maskfuncs.length); /*17097*/
		for (var _QC = 0, _QB = $1.masks.length - 1; _QC <= _QB; _QC += 1) { /*17111*/
			$1.m = _QC; /*17099*/
			$1.mask = $a($1.size * $1.size); /*17100*/
			for (var _QI = 0, _QH = $1.size - 1; _QI <= _QH; _QI += 1) { /*17109*/
				$1.j = _QI; /*17102*/
				for (var _QL = 0, _QK = $1.size - 1; _QL <= _QK; _QL += 1) { /*17108*/
					$1.i = _QL; /*17104*/
					$k[$j++] = $1.i; /*17105*/
					$k[$j++] = $1.j; /*17105*/
					$get($1.maskfuncs, $1.m)(); /*17105*/
					var _QR = $k[--$j]; /*17105*/
					$k[$j++] = _QR == 0; /*17106*/
					$k[$j++] = $1.pixs; /*17106*/
					$k[$j++] = $1.i; /*17106*/
					$k[$j++] = $1.j; /*17106*/
					if ($1.qmv() == $b) break; /*17106*/
					var _QV = $k[--$j]; /*17106*/
					var _QX = $get($k[--$j], _QV); /*17106*/
					var _QZ = ($k[--$j] && (_QX == -1)) ? 1 : 0; /*17106*/
					$k[$j++] = _QZ; /*17107*/
					$k[$j++] = $1.mask; /*17107*/
					$k[$j++] = $1.i; /*17107*/
					$k[$j++] = $1.j; /*17107*/
					if ($1.qmv() == $b) break; /*17107*/
					var _Qd = $k[--$j]; /*17107*/
					var _Qe = $k[--$j]; /*17107*/
					$put(_Qe, _Qd, $k[--$j]); /*17107*/
				} /*17107*/
			} /*17107*/
			$put($1.masks, $1.m, $1.mask); /*17110*/
		} /*17110*/
		$1.posx = $1.size - 1; /*17114*/
		$1.posy = $1.size - 1; /*17115*/
		$1.dir = -1; /*17116*/
		$1.col = 1; /*17117*/
		$1.num = 0; /*17118*/
		for (;;) { /*17141*/
			if ($1.posx < 0) { /*17120*/
				break; /*17120*/
			} /*17120*/
			$k[$j++] = $1.pixs; /*17121*/
			$k[$j++] = $1.posx; /*17121*/
			$k[$j++] = $1.posy; /*17121*/
			if ($1.qmv() == $b) break; /*17121*/
			var _Qp = $k[--$j]; /*17121*/
			if ($get($k[--$j], _Qp) == -1) { /*17125*/
				var _Qu = $get($1.cws, ~~($1.num / 8)); /*17122*/
				var _Qw = -(7 - ($1.num % 8)); /*17122*/
				$k[$j++] = ((_Qw < 0 ? _Qu >>> -_Qw : _Qu << _Qw)) & 1; /*17123*/
				$k[$j++] = $1.pixs; /*17123*/
				$k[$j++] = $1.posx; /*17123*/
				$k[$j++] = $1.posy; /*17123*/
				if ($1.qmv() == $b) break; /*17123*/
				var _R0 = $k[--$j]; /*17123*/
				var _R1 = $k[--$j]; /*17123*/
				$put(_R1, _R0, $k[--$j]); /*17123*/
				$1.num = $1.num + 1; /*17124*/
			} /*17124*/
			if ($1.col == 1) { /*17138*/
				$1.col = 0; /*17127*/
				$1.posx = $1.posx - 1; /*17128*/
			} else { /*17138*/
				$1.col = 1; /*17130*/
				$1.posx = $1.posx + 1; /*17131*/
				$1.posy = $1.posy + $1.dir; /*17132*/
				if (($1.posy < 0) || ($1.posy >= $1.size)) { /*17139*/
					$1.dir = $1.dir * -1; /*17134*/
					$1.posy = $1.posy + $1.dir; /*17135*/
					$1.posx = $1.posx - 2; /*17136*/
					if ($eq($1.format, "full") && ($1.posx == 6)) { /*17138*/
						$1.posx = $1.posx - 1; /*17138*/
					} /*17138*/
				} /*17138*/
			} /*17138*/
		} /*17138*/
		$1.evalfulln1n3 = function() {
			$1.scrle = $k[--$j]; /*17145*/
			$k[$j++] = "scr1"; /*17147*/
			$k[$j++] = 0; /*17147*/
			$forall($1.scrle, function() { /*17147*/
				var _RL = $k[--$j]; /*17147*/
				$k[$j++] = _RL; /*17147*/
				if (_RL >= 5) { /*17147*/
					var _RM = $k[--$j]; /*17147*/
					var _RO = ($k[--$j] + _RM) - 2; /*17147*/
					$k[$j++] = _RO; /*17147*/
					$k[$j++] = _RO; /*17147*/
				} /*17147*/
				$j--; /*17147*/
			}); /*17147*/
			var _RP = $k[--$j]; /*17147*/
			$1[$k[--$j]] = _RP; /*17147*/
			$1.scr3 = 0; /*17149*/
			for (var _RT = 3, _RS = $1.scrle.length - 3; _RT <= _RS; _RT += 2) { /*17164*/
				$1.j = _RT; /*17151*/
				if (($get($1.scrle, $1.j) % 3) == 0) { /*17163*/
					$1.fact = ~~($get($1.scrle, $1.j) / 3); /*17153*/
					$forall($geti($1.scrle, $1.j - 2, 5), function() { /*17154*/
						var _Re = $k[--$j]; /*17154*/
						$k[$j++] = _Re == $1.fact; /*17154*/
					}); /*17154*/
					var _Rf = $k[--$j]; /*17154*/
					var _Rg = $k[--$j]; /*17154*/
					var _Rh = $k[--$j]; /*17154*/
					var _Ri = $k[--$j]; /*17154*/
					if ($k[--$j] && (_Ri && (_Rg && _Rf))) { /*17162*/
						if (($1.j == 3) || (($1.j + 4) >= $1.scrle.length)) { /*17159*/
							$1.scr3 = $1.scr3 + 40; /*17156*/
						} else { /*17159*/
							if (($get($1.scrle, $1.j - 3) >= 4) || ($get($1.scrle, $1.j + 3) >= 4)) { /*17160*/
								$1.scr3 = $1.scr3 + 40; /*17159*/
							} /*17159*/
						} /*17159*/
					} /*17159*/
				} /*17159*/
			} /*17159*/
			$k[$j++] = $1.scr1; /*17165*/
			$k[$j++] = $1.scr3; /*17165*/
		}; /*17166*/
		$1.evalfull = function() {
			$1.sym = $k[--$j]; /*17170*/
			$1.n1 = 0; /*17172*/
			$1.n2 = 0; /*17172*/
			$1.n3 = 0; /*17172*/
			$1.rle = $a($1.size + 1); /*17173*/
			$1.lastpairs = $a($1.size); /*17174*/
			$1.thispairs = $a($1.size); /*17175*/
			$1.sizeadd1 = $1.size + 1; /*17176*/
			for (var _S7 = 0, _S6 = $1.size - 1; _S7 <= _S6; _S7 += 1) { /*17215*/
				$1.i = _S7; /*17178*/
				$k[$j++] = Infinity; /*17181*/
				var _S9 = $1.size; /*17182*/
				$k[$j++] = 0; /*17184*/
				$k[$j++] = 0; /*17184*/
				for (var _SB = $1.i, _SC = _S9, _SA = (_S9 * _S9) - 1; _SC < 0 ? _SB >= _SA : _SB <= _SA; _SB += _SC) { /*17184*/
					var _SE = $get($1.sym, _SB); /*17183*/
					var _SF = $k[--$j]; /*17183*/
					$k[$j++] = _SE; /*17183*/
					if ($eq(_SF, _SE)) { /*17183*/
						var _SG = $k[--$j]; /*17183*/
						var _SH = $k[--$j]; /*17183*/
						$k[$j++] = _SH + 1; /*17183*/
						$k[$j++] = _SG; /*17183*/
					} else { /*17183*/
						var _SI = $k[--$j]; /*17183*/
						$k[$j++] = 1; /*17183*/
						$k[$j++] = _SI; /*17183*/
					} /*17183*/
				} /*17183*/
				$j--; /*17185*/
				var _SK = $counttomark() + 2; /*17186*/
				$astore($geti($1.rle, 0, _SK - 2)); /*17186*/
				if ($1.evalfulln1n3() == $b) break; /*17187*/
				$1.n3 = $k[--$j] + $1.n3; /*17187*/
				$1.n1 = $k[--$j] + $1.n1; /*17187*/
				$j--; /*17188*/
				$1.symrow = $geti($1.sym, $1.i * $1.size, $1.size); /*17191*/
				$k[$j++] = Infinity; /*17192*/
				$k[$j++] = 0; /*17195*/
				$k[$j++] = 0; /*17195*/
				$forall($1.symrow, function() { /*17195*/
					var _SW = $k[--$j]; /*17194*/
					var _SX = $k[--$j]; /*17194*/
					$k[$j++] = _SW; /*17194*/
					if ($eq(_SX, _SW)) { /*17194*/
						var _SY = $k[--$j]; /*17194*/
						var _SZ = $k[--$j]; /*17194*/
						$k[$j++] = _SZ + 1; /*17194*/
						$k[$j++] = _SY; /*17194*/
					} else { /*17194*/
						var _Sa = $k[--$j]; /*17194*/
						$k[$j++] = 1; /*17194*/
						$k[$j++] = _Sa; /*17194*/
					} /*17194*/
				}); /*17194*/
				$j--; /*17196*/
				var _Sc = $counttomark() + 2; /*17197*/
				$astore($geti($1.rle, 0, _Sc - 2)); /*17197*/
				if ($1.evalfulln1n3() == $b) break; /*17198*/
				$1.n3 = $k[--$j] + $1.n3; /*17198*/
				$1.n1 = $k[--$j] + $1.n1; /*17198*/
				$j--; /*17199*/
				var _Si = $1.thispairs; /*17202*/
				$1.thispairs = $1.lastpairs; /*17202*/
				$1.lastpairs = _Si; /*17202*/
				var _Sm = ($get($1.symrow, 0) == 1) ? 0 : 1; /*17203*/
				$k[$j++] = _Sm; /*17204*/
				$forall($1.symrow, function() { /*17204*/
					var _So = $k[--$j]; /*17204*/
					var _Sp = $k[--$j]; /*17204*/
					$k[$j++] = _Sp + _So; /*17204*/
					$k[$j++] = _So; /*17204*/
				}); /*17204*/
				$j--; /*17205*/
				$astore($1.thispairs); /*17206*/
				$j--; /*17206*/
				if ($1.i > 0) { /*17213*/
					$k[$j++] = Infinity; /*17208*/
					$aload($1.lastpairs); /*17209*/
					$aload($1.thispairs); /*17209*/
					$k[$j++] = $1.n2; /*17210*/
					for (var _Sw = 0, _Sx = $1.size; _Sw < _Sx; _Sw++) { /*17210*/
						var _Sy = $k[--$j]; /*17210*/
						var _Sz = $k[--$j]; /*17210*/
						$k[$j++] = _Sy; /*17210*/
						$k[$j++] = _Sz; /*17210*/
						var _T1 = $k[$j - 1 - $1.sizeadd1]; /*17210*/
						if ((($k[--$j] + _T1) & 3) == 0) { /*17210*/
							var _T3 = $k[--$j]; /*17210*/
							$k[$j++] = _T3 + 3; /*17210*/
						} /*17210*/
					} /*17210*/
					$1.n2 = $k[--$j]; /*17211*/
					$cleartomark(); /*17212*/
				} /*17212*/
			} /*17212*/
			$k[$j++] = "dark"; /*17218*/
			$k[$j++] = 0; /*17218*/
			$forall($1.sym, function() { /*17218*/
				var _T6 = $k[--$j]; /*17218*/
				var _T7 = $k[--$j]; /*17218*/
				$k[$j++] = _T7 + _T6; /*17218*/
			}); /*17218*/
			var _T8 = $k[--$j]; /*17218*/
			$1[$k[--$j]] = _T8; /*17218*/
			var _TB = $1.size; /*17219*/
			$1.n4 = (~~((Math.abs((($1.dark * 100) / (_TB * _TB)) - 50)) / 5)) * 10; /*17219*/
			$k[$j++] = (($1.n1 + $1.n2) + $1.n3) + $1.n4; /*17221*/
		}; /*17222*/
		$1.evalmicro = function() {
			$1.sym = $k[--$j]; /*17226*/
			$1.dkrhs = 0; /*17227*/
			$1.dkbot = 0; /*17227*/
			for (var _TJ = 1, _TI = $1.size - 1; _TJ <= _TI; _TJ += 1) { /*17232*/
				$1.i = _TJ; /*17229*/
				$k[$j++] = "dkrhs"; /*17230*/
				$k[$j++] = $1.dkrhs; /*17230*/
				$k[$j++] = $1.sym; /*17230*/
				$k[$j++] = $1.size - 1; /*17230*/
				$k[$j++] = $1.i; /*17230*/
				if ($1.qmv() == $b) break; /*17230*/
				var _TO = $k[--$j]; /*17230*/
				var _TQ = $get($k[--$j], _TO); /*17230*/
				var _TR = $k[--$j]; /*17230*/
				$1[$k[--$j]] = _TR + _TQ; /*17230*/
				$k[$j++] = "dkbot"; /*17231*/
				$k[$j++] = $1.dkbot; /*17231*/
				$k[$j++] = $1.sym; /*17231*/
				$k[$j++] = $1.i; /*17231*/
				$k[$j++] = $1.size - 1; /*17231*/
				if ($1.qmv() == $b) break; /*17231*/
				var _TX = $k[--$j]; /*17231*/
				var _TZ = $get($k[--$j], _TX); /*17231*/
				var _Ta = $k[--$j]; /*17231*/
				$1[$k[--$j]] = _Ta + _TZ; /*17231*/
			} /*17231*/
			if ($1.dkrhs <= $1.dkbot) { /*17236*/
				$k[$j++] = -(($1.dkrhs * 16) + $1.dkbot); /*17234*/
			} else { /*17236*/
				$k[$j++] = -(($1.dkbot * 16) + $1.dkrhs); /*17236*/
			} /*17236*/
		}; /*17238*/
		$1.bestscore = 999999999; /*17241*/
		for (var _Tk = 0, _Tj = $1.masks.length - 1; _Tk <= _Tj; _Tk += 1) { /*17263*/
			$1.m = _Tk; /*17243*/
			$1.masksym = $a($1.size * $1.size); /*17244*/
			for (var _Tr = 0, _Tq = ($1.size * $1.size) - 1; _Tr <= _Tq; _Tr += 1) { /*17248*/
				$1.i = _Tr; /*17246*/
				$put($1.masksym, $1.i, $xo($get($1.pixs, $1.i), $get($get($1.masks, $1.m), $1.i))); /*17247*/
			} /*17247*/
			if ($1.masks.length != 1) { /*17261*/
				if ($eq($1.format, "full")) { /*17253*/
					$k[$j++] = $1.masksym; /*17251*/
					if ($1.evalfull() == $b) break; /*17251*/
					$1.score = $k[--$j]; /*17251*/
				} else { /*17253*/
					$k[$j++] = $1.masksym; /*17253*/
					if ($1.evalmicro() == $b) break; /*17253*/
					$1.score = $k[--$j]; /*17253*/
				} /*17253*/
				if ($1.score < $1.bestscore) { /*17259*/
					$1.bestsym = $1.masksym; /*17256*/
					$1.bestmaskval = $1.m; /*17257*/
					$1.bestscore = $1.score; /*17258*/
				} /*17258*/
			} else { /*17261*/
				$1.bestsym = $1.masksym; /*17261*/
			} /*17261*/
		} /*17261*/
		$1.pixs = $1.bestsym; /*17264*/
		if ($eq($1.format, "full")) { /*17269*/
			$k[$j++] = $1.pixs; /*17268*/
			$k[$j++] = 8; /*17268*/
			$k[$j++] = $1.size - 8; /*17268*/
			if ($1.qmv() == $b) return $b; /*17268*/
			var _UI = $k[--$j]; /*17268*/
			$put($k[--$j], _UI, 1); /*17268*/
		} /*17268*/
		if ($eq($1.format, "full")) { /*17289*/
			$1.fmtvals = $a([21522, 20773, 24188, 23371, 17913, 16590, 20375, 19104, 30660, 29427, 32170, 30877, 26159, 25368, 27713, 26998, 5769, 5054, 7399, 6608, 1890, 597, 3340, 2107, 13663, 12392, 16177, 14854, 9396, 8579, 11994, 11245]); /*17278*/
			$k[$j++] = "ecid"; /*17279*/
			$search("MLHQ", $1.eclevel); /*17279*/
			$j--; /*17279*/
			var _UN = $k[--$j]; /*17279*/
			var _UO = $k[--$j]; /*17279*/
			var _UP = $k[--$j]; /*17279*/
			$1[$k[--$j]] = _UN.length; /*17279*/
			$1.fmtval = $get($1.fmtvals, ($1.ecid << 3) + $1.bestmaskval); /*17280*/
		} else { /*17289*/
			$1.fmtvals = $a([17477, 16754, 20011, 19228, 21934, 20633, 24512, 23287, 26515, 25252, 28157, 26826, 30328, 29519, 31766, 31009, 1758, 1001, 3248, 2439, 5941, 4610, 7515, 6252, 9480, 8255, 12134, 10833, 13539, 12756, 16013, 15290]); /*17287*/
			$1.symid = $get($get($a([$a([0]), $a([1, 2]), $a([3, 4]), $a([5, 6, 7])]), ~~(($1.size - 11) / 2)), $1.eclval); /*17288*/
			$1.fmtval = $get($1.fmtvals, ($1.symid << 2) + $1.bestmaskval); /*17289*/
		} /*17289*/
		for (var _Ul = 0, _Uk = $1.formatmap.length - 1; _Ul <= _Uk; _Ul += 1) { /*17296*/
			$1.i = _Ul; /*17292*/
			$forall($get($1.formatmap, $1.i), function() { /*17295*/
				var _Uq = $k[--$j]; /*17294*/
				$k[$j++] = $1.pixs; /*17294*/
				$forall(_Uq); /*17294*/
				if ($1.qmv() == $b) return $b; /*17294*/
				var _Ur = $1.fmtval; /*17294*/
				var _Ut = -(14 - $1.i); /*17294*/
				var _Uu = $k[--$j]; /*17294*/
				$put($k[--$j], _Uu, ((_Ut < 0 ? _Ur >>> -_Ut : _Ur << _Ut)) & 1); /*17294*/
			}); /*17294*/
		} /*17294*/
		if ($1.size >= 45) { /*17314*/
			$1.vervals = $a([31892, 34236, 39577, 42195, 48118, 51042, 55367, 58893, 63784, 68472, 70749, 76311, 79154, 84390, 87683, 92361, 96236, 102084, 102881, 110507, 110734, 117786, 119615, 126325, 127568, 133589, 136957, 141498, 145311, 150283, 152622, 158308, 161089, 167017]); /*17306*/
			$1.verval = $get($1.vervals, (~~(($1.size - 17) / 4)) - 7); /*17307*/
			for (var _V3 = 0, _V2 = $1.versionmap.length - 1; _V3 <= _V2; _V3 += 1) { /*17313*/
				$1.i = _V3; /*17309*/
				$forall($get($1.versionmap, $1.i), function() { /*17312*/
					var _V8 = $k[--$j]; /*17311*/
					$k[$j++] = $1.pixs; /*17311*/
					$forall(_V8); /*17311*/
					if ($1.qmv() == $b) return $b; /*17311*/
					var _V9 = $1.verval; /*17311*/
					var _VB = -(17 - $1.i); /*17311*/
					var _VC = $k[--$j]; /*17311*/
					$put($k[--$j], _VC, ((_VB < 0 ? _V9 >>> -_VB : _V9 << _VB)) & 1); /*17311*/
				}); /*17311*/
			} /*17311*/
		} /*17311*/
		var _VK = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.size,
			pixy: $1.size,
			height: ($1.size * 2) / 72,
			width: ($1.size * 2) / 72,
			opt: $1.options
		}; /*17324*/
		$k[$j++] = _VK; /*17327*/
		if (!$1.dontdraw) { /*17327*/
			$0.renmatrix(); /*17327*/
		} /*17327*/
	};
	$0.microqrcode = function() {
		var $1 = {}; /*17355*/
		$1.options = $k[--$j]; /*17357*/
		$1.barcode = $k[--$j]; /*17358*/
		$1.dontdraw = false; /*17360*/
		$forall($1.options, function() { /*17371*/
			var _3 = $k[--$j]; /*17371*/
			$1[$k[--$j]] = _3; /*17371*/
		}); /*17371*/
		$1.options.dontdraw = true; /*17374*/
		$1.options.format = "micro"; /*17375*/
		$k[$j++] = "args"; /*17377*/
		$k[$j++] = $1.barcode; /*17377*/
		$k[$j++] = $1.options; /*17377*/
		$0.qrcode(); /*17377*/
		var _9 = $k[--$j]; /*17377*/
		$1[$k[--$j]] = _9; /*17377*/
		$1.args.opt = $1.options; /*17379*/
		$k[$j++] = $1.args; /*17382*/
		if (!$1.dontdraw) { /*17382*/
			$0.renmatrix(); /*17382*/
		} /*17382*/
	};
	$0.maxicode = function() {
		var $1 = {}; /*17409*/
		$1.options = $k[--$j]; /*17411*/
		$1.barcode = $k[--$j]; /*17412*/
		$1.dontdraw = false; /*17414*/
		$1.mode = -1; /*17415*/
		$1.sam = -1; /*17416*/
		$1.parse = false; /*17417*/
		$forall($1.options, function() { /*17428*/
			var _3 = $k[--$j]; /*17428*/
			$1[$k[--$j]] = _3; /*17428*/
		}); /*17428*/
		$1.mode = ~~$1.mode; /*17430*/
		$1.sam = ~~$1.sam; /*17431*/
		$1.msg = $1.barcode; /*17454*/
		$1.msglen = $1.msg.length; /*17455*/
		if (($1.mode == 2) || ($1.mode == 3)) { /*17481*/
			if ($eq($geti($1.msg, 0, 7), "\x5b\x29\x3e\x1e\x30\x31\x1d")) { /*17465*/
				$1.fid = $geti($1.msg, 0, 9); /*17462*/
				$1.msg = $geti($1.msg, 9, $1.msglen - 9); /*17463*/
			} else { /*17465*/
				$1.fid = ""; /*17465*/
			} /*17465*/
			$search($1.msg, "\x1d"); /*17469*/
			$j--; /*17469*/
			$1.pcode = $k[--$j]; /*17469*/
			$j--; /*17470*/
			$search($k[--$j], "\x1d"); /*17470*/
			$j--; /*17470*/
			$1.ccode = $k[--$j]; /*17470*/
			$j--; /*17471*/
			$search($k[--$j], "\x1d"); /*17471*/
			$j--; /*17471*/
			$1.scode = $k[--$j]; /*17471*/
			$j--; /*17472*/
			$1.msg = $k[--$j]; /*17472*/
			var _R = $s($1.msg.length + $1.fid.length); /*17475*/
			$puti(_R, 0, $1.fid); /*17476*/
			$puti(_R, $1.fid.length, $1.msg); /*17477*/
			$1.msg = _R; /*17478*/
			$1.msglen = $1.msg.length; /*17479*/
		} /*17479*/
		$1.eci = -1; /*17484*/
		$1.pad = -2; /*17484*/
		$1.ns = -3; /*17484*/
		$1.la = -4; /*17485*/
		$1.lb = -5; /*17485*/
		$1.sa = -6; /*17486*/
		$1.sb = -7; /*17486*/
		$1.sc = -8; /*17486*/
		$1.sd = -9; /*17486*/
		$1.se = -10; /*17486*/
		$1.sa2 = -11; /*17487*/
		$1.sa3 = -12; /*17487*/
		$1.lkc = -13; /*17488*/
		$1.lkd = -14; /*17488*/
		$1.lke = -15; /*17488*/
		$1.pd2 = -16; /*17489*/
		$1.pd3 = -17; /*17489*/
		$1.charmaps = $a([$a([13, "`", 192, 224, 0]), $a(["A", "a", 193, 225, 1]), $a(["B", "b", 194, 226, 2]), $a(["C", "c", 195, 227, 3]), $a(["D", "d", 196, 228, 4]), $a(["E", "e", 197, 229, 5]), $a(["F", "f", 198, 230, 6]), $a(["G", "g", 199, 231, 7]), $a(["H", "h", 200, 232, 8]), $a(["I", "i", 201, 233, 9]), $a(["J", "j", 202, 234, 10]), $a(["K", "k", 203, 235, 11]), $a(["L", "l", 204, 236, 12]), $a(["M", "m", 205, 237, 13]), $a(["N", "n", 206, 238, 14]), $a(["O", "o", 207, 239, 15]), $a(["P", "p", 208, 240, 16]), $a(["Q", "q", 209, 241, 17]), $a(["R", "r", 210, 242, 18]), $a(["S", "s", 211, 243, 19]), $a(["T", "t", 212, 244, 20]), $a(["U", "u", 213, 245, 21]), $a(["V", "v", 214, 246, 22]), $a(["W", "w", 215, 247, 23]), $a(["X", "x", 216, 248, 24]), $a(["Y", "y", 217, 249, 25]), $a(["Z", "z", 218, 250, 26]), $a([$1.eci, $1.eci, $1.eci, $1.eci, $1.eci]), $a([28, 28, 28, 28, $1.pad]), $a([29, 29, 29, 29, $1.pad]), $a([30, 30, 30, 30, 27]), $a([$1.ns, $1.ns, $1.ns, $1.ns, $1.ns]), $a([" ", "{", 219, 251, 28]), $a([$1.pad, $1.pad, 220, 252, 29]), $a(["\"", "}", 221, 253, 30]), $a(["#", "~", 222, 254, 31]), $a(["$", 127, 223, 255, 159]), $a(["%", ";", 170, 161, 160]), $a(["&", "<", 172, 168, 162]), $a(["'", "=", 177, 171, 163]), $a([40, ">", 178, 175, 164]), $a([41, "?", 179, 176, 165]), $a(["*", "[", 181, 180, 166]), $a(["+", 92, 185, 183, 167]), $a([",", "]", 186, 184, 169]), $a(["-", "^", 188, 187, 173]), $a([".", "_", 189, 191, 174]), $a(["/", " ", 190, 138, 182]), $a(["0", ",", 128, 139, 149]), $a(["1", ".", 129, 140, 150]), $a(["2", "/", 130, 141, 151]), $a(["3", ":", 131, 142, 152]), $a(["4", "@", 132, 143, 153]), $a(["5", "!", 133, 144, 154]), $a(["6", "|", 134, 145, 155]), $a(["7", $1.pd2, 135, 146, 156]), $a(["8", $1.sa2, 136, 147, 157]), $a(["9", $1.sa3, 137, 148, 158]), $a([":", $1.pd3, $1.la, $1.la, $1.la]), $a([$1.sb, $1.sa, " ", " ", " "]), $a([$1.sc, $1.sc, $1.lkc, $1.sc, $1.sc]), $a([$1.sd, $1.sd, $1.sd, $1.lkd, $1.sd]), $a([$1.se, $1.se, $1.se, $1.se, $1.lke]), $a([$1.lb, $1.la, $1.lb, $1.lb, $1.lb])]); /*17558*/
		$1.charvals = $a([{}, {}, {}, {}, {}]); /*17561*/
		for (var _2J = 0, _2I = $1.charmaps.length - 1; _2J <= _2I; _2J += 1) { /*17570*/
			$1.i = _2J; /*17563*/
			$1.encs = $get($1.charmaps, $1.i); /*17564*/
			for (var _2N = 0; _2N <= 4; _2N += 1) { /*17569*/
				$1.j = _2N; /*17566*/
				var _2Q = $get($1.encs, $1.j); /*17567*/
				$k[$j++] = _2Q; /*17567*/
				if ($eq($type(_2Q), "stringtype")) { /*17567*/
					var _2T = $get($k[--$j], 0); /*17567*/
					$k[$j++] = _2T; /*17567*/
				} /*17567*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*17568*/
			} /*17568*/
		} /*17568*/
		$1.seta = $get($1.charvals, 0); /*17571*/
		$1.setb = $get($1.charvals, 1); /*17572*/
		$1.setc = $get($1.charvals, 2); /*17573*/
		$1.setd = $get($1.charvals, 3); /*17574*/
		$1.sete = $get($1.charvals, 4); /*17575*/
		$k[$j++] = Infinity; /*17578*/
		for (var _2k = 0, _2l = $1.msglen + 1; _2k < _2l; _2k++) { /*17578*/
			$k[$j++] = 0; /*17578*/
		} /*17578*/
		$1.nseq = $a(); /*17578*/
		for (var _2o = $1.msglen - 1; _2o >= 0; _2o -= 1) { /*17586*/
			$1.i = _2o; /*17580*/
			var _2r = $get($1.msg, $1.i); /*17581*/
			if ((_2r >= 48) && (_2r <= 57)) { /*17584*/
				$put($1.nseq, $1.i, $get($1.nseq, $1.i + 1) + 1); /*17582*/
			} else { /*17584*/
				$put($1.nseq, $1.i, 0); /*17584*/
			} /*17584*/
		} /*17584*/
		$1.nseq = $geti($1.nseq, 0, $1.msglen); /*17587*/
		$1.prefixinset = function() {
			$k[$j++] = 0; /*17594*/
			for (;;) { /*17594*/
				var _32 = $k[--$j]; /*17592*/
				var _33 = $k[--$j]; /*17592*/
				$k[$j++] = _33; /*17592*/
				$k[$j++] = _32; /*17592*/
				if (_32 >= _33.length) { /*17592*/
					break; /*17592*/
				} /*17592*/
				var _34 = $k[--$j]; /*17593*/
				var _35 = $k[--$j]; /*17593*/
				var _37 = $k[--$j]; /*17593*/
				var _38 = $get(_37, $get(_35, _34)) !== undefined; /*17593*/
				$k[$j++] = _37; /*17593*/
				$k[$j++] = _35; /*17593*/
				$k[$j++] = _34; /*17593*/
				if (_38) { /*17593*/
					var _39 = $k[--$j]; /*17593*/
					$k[$j++] = _39 + 1; /*17593*/
				} else { /*17593*/
					break; /*17593*/
				} /*17593*/
			} /*17593*/
			var _3A = $k[--$j]; /*17595*/
			var _3B = $k[--$j]; /*17595*/
			var _3C = $k[--$j]; /*17595*/
			$k[$j++] = _3A; /*17595*/
		}; /*17596*/
		$1.enc = function() {
			var _3D = $k[--$j]; /*17599*/
			$put($1.out, $1.j, $get(_3D, $k[--$j])); /*17599*/
			$1.j = $1.j + 1; /*17600*/
		}; /*17601*/
		$1.out = $a(144); /*17603*/
		$1.i = 0; /*17604*/
		$1.j = 0; /*17604*/
		$1.cset = "seta"; /*17604*/
		for (;;) { /*17727*/
			if ($1.i == $1.msglen) { /*17613*/
				if ($ne($1.cset, "seta") && $ne($1.cset, "setb")) { /*17611*/
					$k[$j++] = $1.la; /*17609*/
					$k[$j++] = $1[$1.cset]; /*17609*/
					if ($1.enc() == $b) break; /*17609*/
					$1.cset = "seta"; /*17610*/
				} /*17610*/
				break; /*17612*/
			} /*17612*/
			for (;;) { /*17726*/
				if ($get($1.nseq, $1.i) >= 9) { /*17624*/
					$k[$j++] = ~~$z($geti($1.msg, $1.i, 9)); /*17618*/
					for (var _3X = 0, _3Y = 4; _3X < _3Y; _3X++) { /*17618*/
						var _3Z = $k[--$j]; /*17618*/
						$k[$j++] = _3Z & 63; /*17618*/
						$k[$j++] = _3Z >>> 6; /*17618*/
					} /*17618*/
					$k[$j++] = $get($1[$1.cset], $1.ns); /*17619*/
					for (var _3e = 0; _3e <= 10; _3e += 2) { /*17619*/
						var _3f = $k[$j - 1 - _3e]; /*17619*/
						$k[$j++] = _3f; /*17619*/
					} /*17619*/
					$astore($a(6)); /*17619*/
					var _3h = $k[--$j]; /*17619*/
					var _3i = $k[--$j]; /*17619*/
					var _3j = $k[--$j]; /*17619*/
					var _3k = $k[--$j]; /*17619*/
					var _3l = $k[--$j]; /*17619*/
					var _3m = $k[--$j]; /*17619*/
					var _3n = $k[--$j]; /*17619*/
					$k[$j++] = _3h; /*17619*/
					$k[$j++] = _3n; /*17619*/
					$k[$j++] = _3m; /*17619*/
					$k[$j++] = _3l; /*17619*/
					$k[$j++] = _3k; /*17619*/
					$k[$j++] = _3j; /*17619*/
					$k[$j++] = _3i; /*17619*/
					for (var _3o = 0, _3p = 6; _3o < _3p; _3o++) { /*17619*/
						$j--; /*17619*/
					} /*17619*/
					$puti($1.out, $1.j, $k[--$j]); /*17620*/
					$1.i = $1.i + 9; /*17621*/
					$1.j = $1.j + 6; /*17622*/
					break; /*17623*/
				} /*17623*/
				$1.char1 = $get($1.msg, $1.i); /*17627*/
				$k[$j++] = "char2"; /*17628*/
				if (($1.i + 1) < $1.msglen) { /*17628*/
					$k[$j++] = $get($1.msg, $1.i + 1); /*17628*/
				} else { /*17628*/
					$k[$j++] = -99; /*17628*/
				} /*17628*/
				var _43 = $k[--$j]; /*17628*/
				$1[$k[--$j]] = _43; /*17628*/
				$k[$j++] = "char3"; /*17629*/
				if (($1.i + 2) < $1.msglen) { /*17629*/
					$k[$j++] = $get($1.msg, $1.i + 2); /*17629*/
				} else { /*17629*/
					$k[$j++] = -99; /*17629*/
				} /*17629*/
				var _4A = $k[--$j]; /*17629*/
				$1[$k[--$j]] = _4A; /*17629*/
				var _4F = $get($1[$1.cset], $1.char1) !== undefined; /*17632*/
				if (_4F) { /*17636*/
					$k[$j++] = $1.char1; /*17633*/
					$k[$j++] = $1[$1.cset]; /*17633*/
					if ($1.enc() == $b) break; /*17633*/
					$1.i = $1.i + 1; /*17634*/
					break; /*17635*/
				} /*17635*/
				var _4N = $get($1.setb, $1.char1) !== undefined; /*17639*/
				if ($eq($1.cset, "seta") && _4N) { /*17649*/
					var _4Q = $get($1.setb, $1.char2) !== undefined; /*17640*/
					if (_4Q) { /*17646*/
						$k[$j++] = $1.lb; /*17641*/
						$k[$j++] = $1.seta; /*17641*/
						if ($1.enc() == $b) break; /*17641*/
						$1.cset = "setb"; /*17642*/
					} else { /*17646*/
						$k[$j++] = $1.sb; /*17644*/
						$k[$j++] = $1.seta; /*17644*/
						if ($1.enc() == $b) break; /*17644*/
						$k[$j++] = $1.char1; /*17645*/
						$k[$j++] = $1.setb; /*17645*/
						if ($1.enc() == $b) break; /*17645*/
						$1.i = $1.i + 1; /*17646*/
					} /*17646*/
					break; /*17648*/
				} /*17648*/
				var _4b = $get($1.seta, $1.char1) !== undefined; /*17652*/
				if ($eq($1.cset, "setb") && _4b) { /*17677*/
					var _4c = $1.seta; /*17653*/
					var _4d = $1.msg; /*17653*/
					var _4e = $1.i; /*17653*/
					var _4f = $1.msglen; /*17653*/
					var _4g = $1.i; /*17653*/
					var _4h = _4f - _4g; /*17653*/
					var _4i = 4; /*17653*/
					if (4 > (_4f - _4g)) { /*17653*/
						var _ = _4h; /*17653*/
						_4h = _4i; /*17653*/
						_4i = _; /*17653*/
					} /*17653*/
					$k[$j++] = "p"; /*17653*/
					$k[$j++] = _4c; /*17653*/
					$k[$j++] = $geti(_4d, _4e, _4i); /*17653*/
					if ($1.prefixinset() == $b) break; /*17653*/
					var _4k = $k[--$j]; /*17653*/
					$1[$k[--$j]] = _4k; /*17653*/
					if ($1.p == 1) { /*17658*/
						$k[$j++] = $1.sa; /*17655*/
						$k[$j++] = $1.setb; /*17655*/
						if ($1.enc() == $b) break; /*17655*/
						$k[$j++] = $1.char1; /*17656*/
						$k[$j++] = $1.seta; /*17656*/
						if ($1.enc() == $b) break; /*17656*/
						$1.i = $1.i + 1; /*17657*/
					} /*17657*/
					if ($1.p == 2) { /*17664*/
						$k[$j++] = $1.sa2; /*17660*/
						$k[$j++] = $1.setb; /*17660*/
						if ($1.enc() == $b) break; /*17660*/
						$k[$j++] = $1.char1; /*17661*/
						$k[$j++] = $1.seta; /*17661*/
						if ($1.enc() == $b) break; /*17661*/
						$k[$j++] = $1.char2; /*17662*/
						$k[$j++] = $1.seta; /*17662*/
						if ($1.enc() == $b) break; /*17662*/
						$1.i = $1.i + 2; /*17663*/
					} /*17663*/
					if ($1.p == 3) { /*17671*/
						$k[$j++] = $1.sa3; /*17666*/
						$k[$j++] = $1.setb; /*17666*/
						if ($1.enc() == $b) break; /*17666*/
						$k[$j++] = $1.char1; /*17667*/
						$k[$j++] = $1.seta; /*17667*/
						if ($1.enc() == $b) break; /*17667*/
						$k[$j++] = $1.char2; /*17668*/
						$k[$j++] = $1.seta; /*17668*/
						if ($1.enc() == $b) break; /*17668*/
						$k[$j++] = $1.char3; /*17669*/
						$k[$j++] = $1.seta; /*17669*/
						if ($1.enc() == $b) break; /*17669*/
						$1.i = $1.i + 3; /*17670*/
					} /*17670*/
					if ($1.p >= 4) { /*17675*/
						$k[$j++] = $1.la; /*17673*/
						$k[$j++] = $1.setb; /*17673*/
						if ($1.enc() == $b) break; /*17673*/
						$1.cset = "seta"; /*17674*/
					} /*17674*/
					break; /*17676*/
				} /*17676*/
				var _5F = $get($1.seta, $1.char1) !== undefined; /*17680*/
				if (_5F) { /*17684*/
					$k[$j++] = $1.la; /*17681*/
					$k[$j++] = $1[$1.cset]; /*17681*/
					if ($1.enc() == $b) break; /*17681*/
					$1.cset = "seta"; /*17682*/
					break; /*17683*/
				} /*17683*/
				var _5L = $get($1.setb, $1.char1) !== undefined; /*17685*/
				if (_5L) { /*17689*/
					$k[$j++] = $1.lb; /*17686*/
					$k[$j++] = $1[$1.cset]; /*17686*/
					if ($1.enc() == $b) break; /*17686*/
					$1.cset = "setb"; /*17687*/
					break; /*17688*/
				} /*17688*/
				var _5R = $get($1.setc, $1.char1) !== undefined; /*17692*/
				if (_5R) { /*17692*/
					$1.setx = "setc"; /*17692*/
					$1.sx = $1.sc; /*17692*/
					$1.lkx = $1.lkc; /*17692*/
				} /*17692*/
				var _5W = $get($1.setd, $1.char1) !== undefined; /*17693*/
				if (_5W) { /*17693*/
					$1.setx = "setd"; /*17693*/
					$1.sx = $1.sd; /*17693*/
					$1.lkx = $1.lkd; /*17693*/
				} /*17693*/
				var _5b = $get($1.sete, $1.char1) !== undefined; /*17694*/
				if (_5b) { /*17694*/
					$1.setx = "sete"; /*17694*/
					$1.sx = $1.se; /*17694*/
					$1.lkx = $1.lke; /*17694*/
				} /*17694*/
				var _5f = $1[$1.setx]; /*17697*/
				var _5g = $1.msg; /*17697*/
				var _5h = $1.i; /*17697*/
				var _5i = $1.msglen; /*17697*/
				var _5j = $1.i; /*17697*/
				var _5k = _5i - _5j; /*17697*/
				var _5l = 4; /*17697*/
				if (4 > (_5i - _5j)) { /*17697*/
					var _ = _5k; /*17697*/
					_5k = _5l; /*17697*/
					_5l = _; /*17697*/
				} /*17697*/
				$k[$j++] = "p"; /*17697*/
				$k[$j++] = _5f; /*17697*/
				$k[$j++] = $geti(_5g, _5h, _5l); /*17697*/
				if ($1.prefixinset() == $b) break; /*17697*/
				var _5n = $k[--$j]; /*17697*/
				$1[$k[--$j]] = _5n; /*17697*/
				if ($1.p == 1) { /*17702*/
					$k[$j++] = $1.sx; /*17699*/
					$k[$j++] = $1[$1.cset]; /*17699*/
					if ($1.enc() == $b) break; /*17699*/
					$k[$j++] = $1.char1; /*17700*/
					$k[$j++] = $1[$1.setx]; /*17700*/
					if ($1.enc() == $b) break; /*17700*/
					$1.i = $1.i + 1; /*17701*/
				} /*17701*/
				if ($1.p == 2) { /*17709*/
					$k[$j++] = $1.sx; /*17704*/
					$k[$j++] = $1[$1.cset]; /*17704*/
					if ($1.enc() == $b) break; /*17704*/
					$k[$j++] = $1.char1; /*17705*/
					$k[$j++] = $1[$1.setx]; /*17705*/
					if ($1.enc() == $b) break; /*17705*/
					$k[$j++] = $1.sx; /*17706*/
					$k[$j++] = $1[$1.cset]; /*17706*/
					if ($1.enc() == $b) break; /*17706*/
					$k[$j++] = $1.char2; /*17707*/
					$k[$j++] = $1[$1.setx]; /*17707*/
					if ($1.enc() == $b) break; /*17707*/
					$1.i = $1.i + 2; /*17708*/
				} /*17708*/
				if ($1.p == 3) { /*17718*/
					$k[$j++] = $1.sx; /*17711*/
					$k[$j++] = $1[$1.cset]; /*17711*/
					if ($1.enc() == $b) break; /*17711*/
					$k[$j++] = $1.char1; /*17712*/
					$k[$j++] = $1[$1.setx]; /*17712*/
					if ($1.enc() == $b) break; /*17712*/
					$k[$j++] = $1.sx; /*17713*/
					$k[$j++] = $1[$1.cset]; /*17713*/
					if ($1.enc() == $b) break; /*17713*/
					$k[$j++] = $1.char2; /*17714*/
					$k[$j++] = $1[$1.setx]; /*17714*/
					if ($1.enc() == $b) break; /*17714*/
					$k[$j++] = $1.sx; /*17715*/
					$k[$j++] = $1[$1.cset]; /*17715*/
					if ($1.enc() == $b) break; /*17715*/
					$k[$j++] = $1.char3; /*17716*/
					$k[$j++] = $1[$1.setx]; /*17716*/
					if ($1.enc() == $b) break; /*17716*/
					$1.i = $1.i + 3; /*17717*/
				} /*17717*/
				if ($1.p >= 4) { /*17723*/
					$k[$j++] = $1.sx; /*17720*/
					$k[$j++] = $1[$1.cset]; /*17720*/
					if ($1.enc() == $b) break; /*17720*/
					$k[$j++] = $1.lkx; /*17721*/
					$k[$j++] = $1[$1.setx]; /*17721*/
					if ($1.enc() == $b) break; /*17721*/
					$1.cset = $1.setx; /*17722*/
				} /*17722*/
				break; /*17725*/
			} /*17725*/
		} /*17725*/
		$1.encmsg = $geti($1.out, 0, $1.j); /*17728*/
		$1.padval = $get($1[$1.cset], $1.pad); /*17729*/
		$1.sami = $a([]); /*17732*/
		if ($1.sam != -1) { /*17737*/
			$1.sami = $a(2); /*17734*/
			$put($1.sami, 0, $get($1.seta, $1.pad)); /*17735*/
			$put($1.sami, 1, (((~~($1.sam / 10)) - 1) * 8) + (($1.sam % 10) - 1)); /*17736*/
		} /*17736*/
		$k[$j++] = Infinity; /*17738*/
		$aload($1.sami); /*17738*/
		$aload($1.encmsg); /*17738*/
		$1.encmsg = $a(); /*17738*/
		if (($1.mode == 2) || ($1.mode == 3)) { /*17793*/
			var _70 = $strcpy($s(4), "0000"); /*17744*/
			var _73 = $cvrs($s(4), ~~$1.mode, 2); /*17744*/
			$puti(_70, 4 - _73.length, _73); /*17744*/
			$1.mdb = _70; /*17744*/
			var _75 = $strcpy($s(10), "0000000000"); /*17745*/
			var _78 = $cvrs($s(10), ~~$z($1.ccode), 2); /*17745*/
			$puti(_75, 10 - _78.length, _78); /*17745*/
			$1.ccb = _75; /*17745*/
			var _7A = $strcpy($s(10), "0000000000"); /*17746*/
			var _7D = $cvrs($s(10), ~~$z($1.scode), 2); /*17746*/
			$puti(_7A, 10 - _7D.length, _7D); /*17746*/
			$1.scb = _7A; /*17746*/
			$1.pcb = $strcpy($s(36), "000000000000000000000000000000000000"); /*17747*/
			if ($1.mode == 2) { /*17760*/
				var _7K = $cvrs($s(6), $1.pcode.length, 2); /*17750*/
				$puti($1.pcb, 6 - _7K.length, _7K); /*17750*/
				var _7O = $cvrs($s(30), ~~$z($1.pcode), 2); /*17751*/
				$puti($1.pcb, 36 - _7O.length, _7O); /*17751*/
			} else { /*17760*/
				$k[$j++] = Infinity; /*17757*/
				var _7Q = $strcpy($s(6), "      "); /*17755*/
				$k[$j++] = _7Q; /*17755*/
				$k[$j++] = _7Q; /*17755*/
				$k[$j++] = 0; /*17755*/
				if ($1.pcode.length > 6) { /*17755*/
					$k[$j++] = $geti($1.pcode, 0, 6); /*17755*/
				} else { /*17755*/
					$k[$j++] = $1.pcode; /*17755*/
				} /*17755*/
				var _7V = $k[--$j]; /*17755*/
				var _7W = $k[--$j]; /*17755*/
				$puti($k[--$j], _7W, _7V); /*17755*/
				$forall($k[--$j], function() { /*17756*/
					var _7b = $get($1.seta, $k[--$j]); /*17756*/
					$k[$j++] = _7b; /*17756*/
				}); /*17756*/
				$1.pccw = $a(); /*17757*/
				for (var _7d = 0; _7d <= 5; _7d += 1) { /*17761*/
					$1.i = _7d; /*17759*/
					var _7j = $cvrs($s(6), $get($1.pccw, $1.i), 2); /*17760*/
					$puti($1.pcb, ((6 * $1.i) + 6) - _7j.length, _7j); /*17760*/
				} /*17760*/
			} /*17760*/
			$1.scm = $s(60); /*17765*/
			$puti($1.scm, 2, $1.mdb); /*17766*/
			$puti($1.scm, 38, $geti($1.pcb, 0, 4)); /*17767*/
			$puti($1.scm, 30, $geti($1.pcb, 4, 6)); /*17768*/
			$puti($1.scm, 24, $geti($1.pcb, 10, 6)); /*17769*/
			$puti($1.scm, 18, $geti($1.pcb, 16, 6)); /*17770*/
			$puti($1.scm, 12, $geti($1.pcb, 22, 6)); /*17771*/
			$puti($1.scm, 6, $geti($1.pcb, 28, 6)); /*17772*/
			$puti($1.scm, 0, $geti($1.pcb, 34, 2)); /*17773*/
			$puti($1.scm, 52, $geti($1.ccb, 0, 2)); /*17774*/
			$puti($1.scm, 42, $geti($1.ccb, 2, 6)); /*17775*/
			$puti($1.scm, 36, $geti($1.ccb, 8, 2)); /*17776*/
			$puti($1.scm, 54, $geti($1.scb, 0, 6)); /*17777*/
			$puti($1.scm, 48, $geti($1.scb, 6, 4)); /*17778*/
			$1.pri = $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]); /*17781*/
			for (var _8P = 0; _8P <= 59; _8P += 1) { /*17787*/
				$1.i = _8P; /*17783*/
				$1.ps = ~~($1.i / 6); /*17784*/
				$1.ep = (~~(Math.pow(2, 5 - ($1.i % 6)))) * ($get($1.scm, $1.i) - 48); /*17785*/
				$put($1.pri, $1.ps, $get($1.pri, $1.ps) + $1.ep); /*17786*/
			} /*17786*/
			$k[$j++] = Infinity; /*17790*/
			for (var _8b = 0, _8c = 84; _8b < _8c; _8b++) { /*17790*/
				$k[$j++] = $1.padval; /*17790*/
			} /*17790*/
			$1.sec = $a(); /*17790*/
			$puti($1.sec, 0, $1.encmsg); /*17791*/
		} /*17791*/
		if (((($1.mode == 4) || ($1.mode == 5)) || ($1.mode == 6)) || ($1.mode == -1)) { /*17812*/
			if ($1.mode == -1) { /*17801*/
				var _8n = ($1.encmsg.length <= 77) ? 5 : 4; /*17800*/
				$1.mode = _8n; /*17800*/
			} /*17800*/
			$k[$j++] = Infinity; /*17804*/
			var _8p = ($1.mode == 5) ? 78 : 94; /*17804*/
			for (var _8q = 0, _8r = _8p; _8q < _8r; _8q++) { /*17804*/
				$k[$j++] = $1.padval; /*17804*/
			} /*17804*/
			$1.cws = $a(); /*17804*/
			$put($1.cws, 0, $1.mode); /*17805*/
			$puti($1.cws, 1, $1.encmsg); /*17806*/
			$1.pri = $geti($1.cws, 0, 10); /*17809*/
			$1.sec = $geti($1.cws, 10, $1.cws.length - 10); /*17810*/
		} /*17810*/
		$k[$j++] = Infinity; /*17815*/
		$k[$j++] = 1; /*17815*/
		for (var _93 = 0, _94 = 63; _93 < _94; _93++) { /*17815*/
			var _95 = $k[--$j]; /*17815*/
			var _96 = _95 * 2; /*17815*/
			$k[$j++] = _95; /*17815*/
			$k[$j++] = _96; /*17815*/
			if (_96 >= 64) { /*17815*/
				var _97 = $k[--$j]; /*17815*/
				$k[$j++] = _97 ^ 67; /*17815*/
			} /*17815*/
		} /*17815*/
		$1.rsalog = $a(); /*17815*/
		$1.rslog = $a(64); /*17816*/
		for (var _9A = 1; _9A <= 63; _9A += 1) { /*17817*/
			$put($1.rslog, $get($1.rsalog, _9A), _9A); /*17817*/
		} /*17817*/
		$1.rsprod = function() {
			var _9E = $k[--$j]; /*17821*/
			var _9F = $k[--$j]; /*17821*/
			$k[$j++] = _9F; /*17825*/
			$k[$j++] = _9E; /*17825*/
			if ((_9E != 0) && (_9F != 0)) { /*17824*/
				var _9I = $get($1.rslog, $k[--$j]); /*17822*/
				var _9N = $get($1.rsalog, (_9I + $get($1.rslog, $k[--$j])) % 63); /*17822*/
				$k[$j++] = _9N; /*17822*/
			} else { /*17824*/
				$j -= 2; /*17824*/
				$k[$j++] = 0; /*17824*/
			} /*17824*/
		}; /*17826*/
		$1.rscodes = function() {
			$1.rsnum = $k[--$j]; /*17831*/
			$1.cwb = $k[--$j]; /*17832*/
			$k[$j++] = Infinity; /*17835*/
			$k[$j++] = 1; /*17835*/
			for (var _9R = 0, _9S = $1.rsnum; _9R < _9S; _9R++) { /*17835*/
				$k[$j++] = 0; /*17835*/
			} /*17835*/
			$1.coeffs = $a(); /*17835*/
			for (var _9W = 1, _9V = $1.rsnum; _9W <= _9V; _9W += 1) { /*17844*/
				$1.i = _9W; /*17837*/
				$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*17838*/
				for (var _9d = $1.i - 1; _9d >= 1; _9d -= 1) { /*17842*/
					$1.j = _9d; /*17840*/
					$k[$j++] = $1.coeffs; /*17841*/
					$k[$j++] = $1.j; /*17841*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*17841*/
					$k[$j++] = $get($1.coeffs, $1.j); /*17841*/
					$k[$j++] = $get($1.rsalog, $1.i); /*17841*/
					if ($1.rsprod() == $b) break; /*17841*/
					var _9p = $k[--$j]; /*17841*/
					var _9q = $k[--$j]; /*17841*/
					var _9r = $k[--$j]; /*17841*/
					$put($k[--$j], _9r, $xo(_9q, _9p)); /*17841*/
				} /*17841*/
				$k[$j++] = $1.coeffs; /*17843*/
				$k[$j++] = 0; /*17843*/
				$k[$j++] = $get($1.coeffs, 0); /*17843*/
				$k[$j++] = $get($1.rsalog, $1.i); /*17843*/
				if ($1.rsprod() == $b) break; /*17843*/
				var _9z = $k[--$j]; /*17843*/
				var _A0 = $k[--$j]; /*17843*/
				$put($k[--$j], _A0, _9z); /*17843*/
			} /*17843*/
			$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*17845*/
			$k[$j++] = Infinity; /*17848*/
			for (var _A6 = 0, _A7 = $1.rsnum; _A6 < _A7; _A6++) { /*17848*/
				$k[$j++] = 0; /*17848*/
			} /*17848*/
			$1.ecb = $a(); /*17848*/
			for (var _AB = 0, _AA = $1.cwb.length - 1; _AB <= _AA; _AB += 1) { /*17857*/
				$1.t = $xo($get($1.cwb, _AB), $get($1.ecb, 0)); /*17850*/
				for (var _AH = $1.ecb.length - 1; _AH >= 0; _AH -= 1) { /*17856*/
					$1.i = _AH; /*17852*/
					$1.p = ($1.ecb.length - $1.i) - 1; /*17853*/
					$k[$j++] = $1.ecb; /*17854*/
					$k[$j++] = $1.p; /*17854*/
					$k[$j++] = $1.t; /*17854*/
					$k[$j++] = $get($1.coeffs, $1.i); /*17854*/
					if ($1.rsprod() == $b) break; /*17854*/
					var _AQ = $k[--$j]; /*17854*/
					var _AR = $k[--$j]; /*17854*/
					$put($k[--$j], _AR, _AQ); /*17854*/
					if ($1.i > 0) { /*17855*/
						$put($1.ecb, $1.p, $xo($get($1.ecb, $1.p + 1), $get($1.ecb, $1.p))); /*17855*/
					} /*17855*/
				} /*17855*/
			} /*17855*/
			$k[$j++] = $1.ecb; /*17859*/
		}; /*17861*/
		$k[$j++] = Infinity; /*17864*/
		for (var _Af = 0, _Ae = $1.sec.length - 1; _Af <= _Ae; _Af += 2) { /*17864*/
			$k[$j++] = $get($1.sec, _Af); /*17864*/
		} /*17864*/
		$1.seco = $a(); /*17864*/
		$k[$j++] = Infinity; /*17865*/
		for (var _Al = 1, _Ak = $1.sec.length - 1; _Al <= _Ak; _Al += 2) { /*17865*/
			$k[$j++] = $get($1.sec, _Al); /*17865*/
		} /*17865*/
		$1.sece = $a(); /*17865*/
		var _Aq = ($1.sec.length == 84) ? 20 : 28; /*17868*/
		$1.scodes = _Aq; /*17868*/
		$k[$j++] = "secochk"; /*17869*/
		$k[$j++] = $1.seco; /*17869*/
		$k[$j++] = $1.scodes; /*17869*/
		if ($1.rscodes() == $b) return $b; /*17869*/
		var _At = $k[--$j]; /*17869*/
		$1[$k[--$j]] = _At; /*17869*/
		$k[$j++] = "secechk"; /*17870*/
		$k[$j++] = $1.sece; /*17870*/
		$k[$j++] = $1.scodes; /*17870*/
		if ($1.rscodes() == $b) return $b; /*17870*/
		var _Ax = $k[--$j]; /*17870*/
		$1[$k[--$j]] = _Ax; /*17870*/
		$k[$j++] = Infinity; /*17873*/
		for (var _B1 = 0, _B0 = $1.scodes - 1; _B1 <= _B0; _B1 += 1) { /*17873*/
			$k[$j++] = $get($1.secochk, _B1); /*17873*/
			$k[$j++] = $get($1.secechk, _B1); /*17873*/
		} /*17873*/
		$1.secchk = $a(); /*17873*/
		$k[$j++] = Infinity; /*17881*/
		$aload($1.pri); /*17877*/
		$k[$j++] = $1.pri; /*17878*/
		$k[$j++] = 10; /*17878*/
		if ($1.rscodes() == $b) return $b; /*17878*/
		$aload($k[--$j]); /*17878*/
		$aload($1.sec); /*17879*/
		$aload($1.secchk); /*17880*/
		$1.codewords = $a(); /*17881*/
		$k[$j++] = Infinity; /*17884*/
		for (var _BD = 0, _BE = 864; _BD < _BE; _BD++) { /*17884*/
			$k[$j++] = 0; /*17884*/
		} /*17884*/
		$1.mods = $a(); /*17884*/
		for (var _BG = 0; _BG <= 143; _BG += 1) { /*17889*/
			$1.i = _BG; /*17886*/
			$k[$j++] = Infinity; /*17887*/
			var _BL = $cvrs($s(6), $get($1.codewords, $1.i), 2); /*17887*/
			for (var _BM = 0, _BN = _BL.length; _BM < _BN; _BM++) { /*17887*/
				$k[$j++] = $get(_BL, _BM) - 48; /*17887*/
			} /*17887*/
			$1.cw = $a(); /*17887*/
			$puti($1.mods, (6 * $1.i) + (6 - $1.cw.length), $1.cw); /*17888*/
		} /*17888*/
		$1.modmap = $a([469, 529, 286, 316, 347, 346, 673, 672, 703, 702, 647, 676, 283, 282, 313, 312, 370, 610, 618, 379, 378, 409, 408, 439, 705, 704, 559, 589, 588, 619, 458, 518, 640, 701, 675, 674, 285, 284, 315, 314, 310, 340, 531, 289, 288, 319, 349, 348, 456, 486, 517, 516, 471, 470, 369, 368, 399, 398, 429, 428, 549, 548, 579, 578, 609, 608, 649, 648, 679, 678, 709, 708, 639, 638, 669, 668, 699, 698, 279, 278, 309, 308, 339, 338, 381, 380, 411, 410, 441, 440, 561, 560, 591, 590, 621, 620, 547, 546, 577, 576, 607, 606, 367, 366, 397, 396, 427, 426, 291, 290, 321, 320, 351, 350, 651, 650, 681, 680, 711, 710, 1, 0, 31, 30, 61, 60, 3, 2, 33, 32, 63, 62, 5, 4, 35, 34, 65, 64, 7, 6, 37, 36, 67, 66, 9, 8, 39, 38, 69, 68, 11, 10, 41, 40, 71, 70, 13, 12, 43, 42, 73, 72, 15, 14, 45, 44, 75, 74, 17, 16, 47, 46, 77, 76, 19, 18, 49, 48, 79, 78, 21, 20, 51, 50, 81, 80, 23, 22, 53, 52, 83, 82, 25, 24, 55, 54, 85, 84, 27, 26, 57, 56, 87, 86, 117, 116, 147, 146, 177, 176, 115, 114, 145, 144, 175, 174, 113, 112, 143, 142, 173, 172, 111, 110, 141, 140, 171, 170, 109, 108, 139, 138, 169, 168, 107, 106, 137, 136, 167, 166, 105, 104, 135, 134, 165, 164, 103, 102, 133, 132, 163, 162, 101, 100, 131, 130, 161, 160, 99, 98, 129, 128, 159, 158, 97, 96, 127, 126, 157, 156, 95, 94, 125, 124, 155, 154, 93, 92, 123, 122, 153, 152, 91, 90, 121, 120, 151, 150, 181, 180, 211, 210, 241, 240, 183, 182, 213, 212, 243, 242, 185, 184, 215, 214, 245, 244, 187, 186, 217, 216, 247, 246, 189, 188, 219, 218, 249, 248, 191, 190, 221, 220, 251, 250, 193, 192, 223, 222, 253, 252, 195, 194, 225, 224, 255, 254, 197, 196, 227, 226, 257, 256, 199, 198, 229, 228, 259, 258, 201, 200, 231, 230, 261, 260, 203, 202, 233, 232, 263, 262, 205, 204, 235, 234, 265, 264, 207, 206, 237, 236, 267, 266, 297, 296, 327, 326, 357, 356, 295, 294, 325, 324, 355, 354, 293, 292, 323, 322, 353, 352, 277, 276, 307, 306, 337, 336, 275, 274, 305, 304, 335, 334, 273, 272, 303, 302, 333, 332, 271, 270, 301, 300, 331, 330, 361, 360, 391, 390, 421, 420, 363, 362, 393, 392, 423, 422, 365, 364, 395, 394, 425, 424, 383, 382, 413, 412, 443, 442, 385, 384, 415, 414, 445, 444, 387, 386, 417, 416, 447, 446, 477, 476, 507, 506, 537, 536, 475, 474, 505, 504, 535, 534, 473, 472, 503, 502, 533, 532, 455, 454, 485, 484, 515, 514, 453, 452, 483, 482, 513, 512, 451, 450, 481, 480, 511, 510, 541, 540, 571, 570, 601, 600, 543, 542, 573, 572, 603, 602, 545, 544, 575, 574, 605, 604, 563, 562, 593, 592, 623, 622, 565, 564, 595, 594, 625, 624, 567, 566, 597, 596, 627, 626, 657, 656, 687, 686, 717, 716, 655, 654, 685, 684, 715, 714, 653, 652, 683, 682, 713, 712, 637, 636, 667, 666, 697, 696, 635, 634, 665, 664, 695, 694, 633, 632, 663, 662, 693, 692, 631, 630, 661, 660, 691, 690, 721, 720, 751, 750, 781, 780, 723, 722, 753, 752, 783, 782, 725, 724, 755, 754, 785, 784, 727, 726, 757, 756, 787, 786, 729, 728, 759, 758, 789, 788, 731, 730, 761, 760, 791, 790, 733, 732, 763, 762, 793, 792, 735, 734, 765, 764, 795, 794, 737, 736, 767, 766, 797, 796, 739, 738, 769, 768, 799, 798, 741, 740, 771, 770, 801, 800, 743, 742, 773, 772, 803, 802, 745, 744, 775, 774, 805, 804, 747, 746, 777, 776, 807, 806, 837, 836, 867, 866, 897, 896, 835, 834, 865, 864, 895, 894, 833, 832, 863, 862, 893, 892, 831, 830, 861, 860, 891, 890, 829, 828, 859, 858, 889, 888, 827, 826, 857, 856, 887, 886, 825, 824, 855, 854, 885, 884, 823, 822, 853, 852, 883, 882, 821, 820, 851, 850, 881, 880, 819, 818, 849, 848, 879, 878, 817, 816, 847, 846, 877, 876, 815, 814, 845, 844, 875, 874, 813, 812, 843, 842, 873, 872, 811, 810, 841, 840, 871, 870, 901, 900, 931, 930, 961, 960, 903, 902, 933, 932, 963, 962, 905, 904, 935, 934, 965, 964, 907, 906, 937, 936, 967, 966, 909, 908, 939, 938, 969, 968, 911, 910, 941, 940, 971, 970, 913, 912, 943, 942, 973, 972, 915, 914, 945, 944, 975, 974, 917, 916, 947, 946, 977, 976, 919, 918, 949, 948, 979, 978, 921, 920, 951, 950, 981, 980, 923, 922, 953, 952, 983, 982, 925, 924, 955, 954, 985, 984, 927, 926, 957, 956, 987, 986, 58, 89, 88, 118, 149, 148, 178, 209, 208, 238, 269, 268, 298, 329, 328, 358, 389, 388, 418, 449, 448, 478, 509, 508, 538, 569, 568, 598, 629, 628, 658, 689, 688, 718, 749, 748, 778, 809, 808, 838, 869, 868, 898, 929, 928, 958, 989, 988]); /*17937*/
		$1.pixs = $a(864); /*17940*/
		$1.j = 0; /*17941*/
		for (var _BY = 0, _BX = $1.mods.length - 1; _BY <= _BX; _BY += 1) { /*17948*/
			$1.i = _BY; /*17943*/
			if ($get($1.mods, $1.i) == 1) { /*17947*/
				$put($1.pixs, $1.j, $get($1.modmap, $1.i)); /*17945*/
				$1.j = $1.j + 1; /*17946*/
			} /*17946*/
		} /*17946*/
		$k[$j++] = Infinity; /*17949*/
		$forall($geti($1.pixs, 0, $1.j)); /*17949*/
		$k[$j++] = 28; /*17949*/
		$k[$j++] = 29; /*17949*/
		$k[$j++] = 280; /*17949*/
		$k[$j++] = 281; /*17949*/
		$k[$j++] = 311; /*17949*/
		$k[$j++] = 457; /*17949*/
		$k[$j++] = 488; /*17949*/
		$k[$j++] = 500; /*17949*/
		$k[$j++] = 530; /*17949*/
		$k[$j++] = 670; /*17949*/
		$k[$j++] = 700; /*17949*/
		$k[$j++] = 677; /*17949*/
		$k[$j++] = 707; /*17949*/
		$1.pixs = $a(); /*17949*/
		var _Bo = {
			ren: $0.renmaximatrix,
			pixs: $1.pixs,
			opt: $1.options
		}; /*17955*/
		$k[$j++] = _Bo; /*17958*/
		if (!$1.dontdraw) { /*17958*/
			$0.renmaximatrix(); /*17958*/
		} /*17958*/
	};
	$0.azteccode = function() {
		var $1 = {}; /*17985*/
		$1.options = $k[--$j]; /*17987*/
		$1.barcode = $k[--$j]; /*17988*/
		$1.dontdraw = false; /*17990*/
		$1.format = "unset"; /*17991*/
		$1.readerinit = false; /*17992*/
		$1.layers = -1; /*17993*/
		$1.eclevel = 23; /*17994*/
		$1.ecaddchars = 3; /*17995*/
		$1.raw = false; /*17996*/
		$1.parse = false; /*17997*/
		$forall($1.options, function() { /*18008*/
			var _3 = $k[--$j]; /*18008*/
			$1[$k[--$j]] = _3; /*18008*/
		}); /*18008*/
		$1.layers = ~~$1.layers; /*18010*/
		$1.eclevel = +$1.eclevel; /*18011*/
		$1.ecaddchars = ~~$1.ecaddchars; /*18012*/
		$1.msgbits = ""; /*18036*/
		if ($ne($1.format, "rune") && $1.raw) { /*18037*/
			$1.msgbits = $1.barcode; /*18037*/
		} /*18037*/
		if ($ne($1.format, "rune") && (!$1.raw)) { /*18334*/
			$1.U = 0; /*18041*/
			$1.L = 1; /*18041*/
			$1.M = 2; /*18041*/
			$1.P = 3; /*18041*/
			$1.D = 4; /*18041*/
			$1.B = 5; /*18041*/
			$1.lu = -1; /*18044*/
			$1.ll = -2; /*18044*/
			$1.lm = -3; /*18044*/
			$1.lp = -4; /*18045*/
			$1.ld = -5; /*18045*/
			$1.su = -6; /*18045*/
			$1.sp = -7; /*18046*/
			$1.sb = -8; /*18046*/
			$1.fl = -9; /*18046*/
			$1.p2 = -10; /*18047*/
			$1.p3 = -11; /*18047*/
			$1.p4 = -12; /*18047*/
			$1.p5 = -13; /*18047*/
			$1.charmaps = $a([$a([$1.sp, $1.sp, $1.sp, $1.fl, $1.sp]), $a([32, 32, 32, 13, 32]), $a(["A", "a", 1, $1.p2, "0"]), $a(["B", "b", 2, $1.p3, "1"]), $a(["C", "c", 3, $1.p4, "2"]), $a(["D", "d", 4, $1.p5, "3"]), $a(["E", "e", 5, "!", "4"]), $a(["F", "f", 6, "\"", "5"]), $a(["G", "g", 7, "#", "6"]), $a(["H", "h", 8, "$", "7"]), $a(["I", "i", 9, "%", "8"]), $a(["J", "j", 10, "&", "9"]), $a(["K", "k", 11, "'", ","]), $a(["L", "l", 12, 40, "."]), $a(["M", "m", 13, 41, $1.lu]), $a(["N", "n", 27, "*", $1.su]), $a(["O", "o", 28, "+", -99]), $a(["P", "p", 29, ",", -99]), $a(["Q", "q", 30, "-", -99]), $a(["R", "r", 31, ".", -99]), $a(["S", "s", "@", "/", -99]), $a(["T", "t", 92, ":", -99]), $a(["U", "u", "^", ";", -99]), $a(["V", "v", "_", "<", -99]), $a(["W", "w", "`", "=", -99]), $a(["X", "x", "|", ">", -99]), $a(["Y", "y", "~", "?", -99]), $a(["Z", "z", 127, "[", -99]), $a([$1.ll, $1.su, $1.ll, "]", -99]), $a([$1.lm, $1.lm, $1.lu, "{", -99]), $a([$1.ld, $1.ld, $1.lp, "}", -99]), $a([$1.sb, $1.sb, $1.sb, $1.lu, -99])]); /*18084*/
			$1.charvals = $a([{}, {}, {}, {}, {}]); /*18087*/
			for (var _1B = 0, _1A = $1.charmaps.length - 1; _1B <= _1A; _1B += 1) { /*18096*/
				$1.i = _1B; /*18089*/
				$1.encs = $get($1.charmaps, $1.i); /*18090*/
				for (var _1F = 0; _1F <= 4; _1F += 1) { /*18095*/
					$1.j = _1F; /*18092*/
					var _1I = $get($1.encs, $1.j); /*18093*/
					$k[$j++] = _1I; /*18093*/
					if ($eq($type(_1I), "stringtype")) { /*18093*/
						var _1L = $get($k[--$j], 0); /*18093*/
						$k[$j++] = _1L; /*18093*/
					} /*18093*/
					$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*18094*/
				} /*18094*/
			} /*18094*/
			var _1V = {
				"\x0d\x0a": $1.p2,
				". ": $1.p3,
				", ": $1.p4,
				": ": $1.p5
			}; /*18103*/
			$1.pcomp = _1V; /*18104*/
			$1.e = 10000; /*18106*/
			$1.latlen = $a([$a([0, 5, 5, 10, 5, 10]), $a([9, 0, 5, 10, 5, 10]), $a([5, 5, 0, 5, 10, 10]), $a([5, 10, 10, 0, 10, 15]), $a([4, 9, 9, 14, 0, 14]), $a([0, 0, 0, 0, 0, 0])]); /*18116*/
			$1.latseq = $a([$a([$a([]), $a([$1.ll]), $a([$1.lm]), $a([$1.lm, $1.lp]), $a([$1.ld]), $a([$1.sb])]), $a([$a([$1.ld, $1.lu]), $a([]), $a([$1.lm]), $a([$1.lm, $1.lp]), $a([$1.ld]), $a([$1.sb])]), $a([$a([$1.lu]), $a([$1.ll]), $a([]), $a([$1.lp]), $a([$1.lu, $1.ld]), $a([$1.sb])]), $a([$a([$1.lu]), $a([$1.lu, $1.ll]), $a([$1.lu, $1.lm]), $a([]), $a([$1.lu, $1.ld]), $a([$1.lu, $1.sb])]), $a([$a([$1.lu]), $a([$1.lu, $1.ll]), $a([$1.lu, $1.lm]), $a([$1.lu, $1.lm, $1.lp]), $a([]), $a([$1.lu, $1.sb])]), $a([$a([$1.lu]), $a([$1.ll]), $a([$1.lm]), $a([]), $a([]), $a([])])]); /*18126*/
			$1.shftlen = $a([$a([$1.e, $1.e, $1.e, 5, $1.e]), $a([5, $1.e, $1.e, 5, $1.e]), $a([$1.e, $1.e, $1.e, 5, $1.e]), $a([$1.e, $1.e, $1.e, $1.e, $1.e]), $a([4, $1.e, $1.e, 4, $1.e])]); /*18135*/
			$1.charsize = $a([5, 5, 5, 5, 4, 8]); /*18138*/
			$1.curlen = $a([0, $1.e, $1.e, $1.e, $1.e, $1.e]); /*18141*/
			$1.curseq = $a([$a([]), $a([]), $a([]), $a([]), $a([]), $a([])]); /*18142*/
			$1.backto = $1.U; /*18144*/
			$1.lastchar = ""; /*18145*/
			$forall($1.barcode, function() { /*18241*/
				$1.char = $k[--$j]; /*18150*/
				for (;;) { /*18176*/
					$1.imp = false; /*18154*/
					var _3l = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*18155*/
					for (var _3m = 0, _3n = _3l.length; _3m < _3n; _3m++) { /*18174*/
						$1.x = $get(_3l, _3m); /*18156*/
						var _3v = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*18157*/
						for (var _3w = 0, _3x = _3v.length; _3w < _3x; _3w++) { /*18173*/
							$1.y = $get(_3v, _3w); /*18158*/
							if (($1.x != $1.B) || ($1.y == $1.backto)) { /*18172*/
								$1.cost = $get($1.curlen, $1.x) + $get($get($1.latlen, $1.x), $1.y); /*18160*/
								if ($1.cost < $get($1.curlen, $1.y)) { /*18171*/
									$put($1.curlen, $1.y, $1.cost); /*18162*/
									$k[$j++] = $1.curseq; /*18165*/
									$k[$j++] = $1.y; /*18165*/
									$k[$j++] = Infinity; /*18165*/
									$aload($get($1.curseq, $1.x)); /*18164*/
									$aload($get($get($1.latseq, $1.x), $1.y)); /*18165*/
									var _4S = $a(); /*18165*/
									var _4T = $k[--$j]; /*18166*/
									$put($k[--$j], _4T, _4S); /*18166*/
									if ($1.y == $1.B) { /*18169*/
										$k[$j++] = "backto"; /*18168*/
										if (($1.x == $1.P) || ($1.x == $1.D)) { /*18168*/
											$k[$j++] = $1.U; /*18168*/
										} else { /*18168*/
											$k[$j++] = $1.x; /*18168*/
										} /*18168*/
										var _4d = $k[--$j]; /*18168*/
										$1[$k[--$j]] = _4d; /*18168*/
									} /*18168*/
									$1.imp = true; /*18170*/
								} /*18170*/
							} /*18170*/
						} /*18170*/
					} /*18170*/
					if (!$1.imp) { /*18175*/
						break; /*18175*/
					} /*18175*/
				} /*18175*/
				$1.nxtlen = $a([$1.e, $1.e, $1.e, $1.e, $1.e, $1.e]); /*18179*/
				$1.nxtseq = $a(6); /*18180*/
				var _4u = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*18182*/
				for (var _4v = 0, _4w = _4u.length; _4v < _4w; _4v++) { /*18217*/
					$1.x = $get(_4u, _4v); /*18183*/
					for (;;) { /*18215*/
						if ($1.x != $1.B) { /*18188*/
							var _54 = $get($get($1.charvals, $1.x), $1.char) !== undefined; /*18188*/
							if (!_54) { /*18188*/
								break; /*18188*/
							} /*18188*/
						} /*18188*/
						$1.cost = $get($1.curlen, $1.x) + $get($1.charsize, $1.x); /*18191*/
						if ($1.cost < $get($1.nxtlen, $1.x)) { /*18195*/
							$put($1.nxtlen, $1.x, $1.cost); /*18193*/
							$k[$j++] = $1.nxtseq; /*18194*/
							$k[$j++] = $1.x; /*18194*/
							$k[$j++] = Infinity; /*18194*/
							$aload($get($1.curseq, $1.x)); /*18194*/
							$k[$j++] = $1.char; /*18194*/
							var _5O = $a(); /*18194*/
							var _5P = $k[--$j]; /*18194*/
							$put($k[--$j], _5P, _5O); /*18194*/
						} /*18194*/
						if ($1.x == $1.B) { /*18198*/
							break; /*18198*/
						} /*18198*/
						var _5Y = $a([$1.U, $1.L, $1.M, $1.P, $1.D]); /*18199*/
						for (var _5Z = 0, _5a = _5Y.length; _5Z < _5a; _5Z++) { /*18212*/
							$1.y = $get(_5Y, _5Z); /*18200*/
							if ($ne($1.x, $1.y)) { /*18211*/
								$1.cost = ($get($1.curlen, $1.y) + $get($get($1.shftlen, $1.y), $1.x)) + $get($1.charsize, $1.x); /*18202*/
								if ($1.cost < $get($1.nxtlen, $1.y)) { /*18210*/
									$put($1.nxtlen, $1.y, $1.cost); /*18204*/
									$k[$j++] = $1.nxtseq; /*18208*/
									$k[$j++] = $1.y; /*18208*/
									$k[$j++] = Infinity; /*18208*/
									$aload($get($1.curseq, $1.y)); /*18206*/
									var _63 = ($1.x == $1.U) ? $1.su : $1.sp; /*18207*/
									$k[$j++] = _63; /*18208*/
									$k[$j++] = $1.char; /*18208*/
									var _65 = $a(); /*18208*/
									var _66 = $k[--$j]; /*18209*/
									$put($k[--$j], _66, _65); /*18209*/
								} /*18209*/
							} /*18209*/
						} /*18209*/
						break; /*18214*/
					} /*18214*/
				} /*18214*/
				if ($ne($1.lastchar, "")) { /*18228*/
					var _69 = $s(2); /*18221*/
					$put(_69, 0, $1.lastchar); /*18221*/
					$put(_69, 1, $1.char); /*18221*/
					$1.pchars = _69; /*18221*/
					var _6E = $get($1.pcomp, $1.pchars) !== undefined; /*18222*/
					if (_6E) { /*18227*/
						if ($lt($get($1.curlen, $1.P), $get($1.nxtlen, $1.P))) { /*18226*/
							$put($1.nxtlen, $1.P, $get($1.curlen, $1.P)); /*18224*/
							$k[$j++] = $1.nxtseq; /*18225*/
							$k[$j++] = $1.P; /*18225*/
							$k[$j++] = Infinity; /*18225*/
							$aload($get($1.curseq, $1.P)); /*18225*/
							$j--; /*18225*/
							$k[$j++] = $get($1.pcomp, $1.pchars); /*18225*/
							var _6Y = $a(); /*18225*/
							var _6Z = $k[--$j]; /*18225*/
							$put($k[--$j], _6Z, _6Y); /*18225*/
						} /*18225*/
					} /*18225*/
				} /*18225*/
				$1.numbytes = 0; /*18231*/
				$forall($get($1.nxtseq, $1.B), function() { /*18234*/
					if ($k[--$j] == $1.sb) { /*18233*/
						$k[$j++] = 0; /*18233*/
					} else { /*18233*/
						$k[$j++] = $1.numbytes + 1; /*18233*/
					} /*18233*/
					$1.numbytes = $k[--$j]; /*18233*/
				}); /*18233*/
				if ($1.numbytes == 32) { /*18235*/
					$put($1.nxtlen, $1.B, $get($1.nxtlen, $1.B) + 11); /*18235*/
				} /*18235*/
				$1.curlen = $1.nxtlen; /*18237*/
				$1.curseq = $1.nxtseq; /*18238*/
				$1.lastchar = $1.char; /*18239*/
			}); /*18239*/
			$1.minseq = $1.e; /*18244*/
			var _6y = $a([$1.U, $1.L, $1.M, $1.P, $1.D, $1.B]); /*18245*/
			for (var _6z = 0, _70 = _6y.length; _6z < _70; _6z++) { /*18251*/
				$1.i = $get(_6y, _6z); /*18246*/
				if ($get($1.curlen, $1.i) < $1.minseq) { /*18250*/
					$1.minseq = $get($1.curlen, $1.i); /*18248*/
					$1.seq = $get($1.curseq, $1.i); /*18249*/
				} /*18249*/
			} /*18249*/
			$1.tobin = function() {
				var _7D = $s($k[--$j]); /*18255*/
				$k[$j++] = _7D; /*18255*/
				for (var _7F = 0, _7E = _7D.length - 1; _7F <= _7E; _7F += 1) { /*18255*/
					var _7G = $k[--$j]; /*18255*/
					$put(_7G, _7F, 48); /*18255*/
					$k[$j++] = _7G; /*18255*/
				} /*18255*/
				var _7H = $k[--$j]; /*18256*/
				var _7K = $cvrs($s(_7H.length), $k[--$j], 2); /*18256*/
				$puti(_7H, _7H.length - _7K.length, _7K); /*18256*/
				$k[$j++] = _7H; /*18256*/
			}; /*18257*/
			$1.encu = function() {
				var _7P = $get($get($1.charvals, $1.U), $k[--$j]); /*18258*/
				$k[$j++] = _7P; /*18258*/
				$k[$j++] = 5; /*18258*/
				if ($1.tobin() == $b) return $b; /*18258*/
			}; /*18258*/
			$1.encl = function() {
				var _7U = $get($get($1.charvals, $1.L), $k[--$j]); /*18259*/
				$k[$j++] = _7U; /*18259*/
				$k[$j++] = 5; /*18259*/
				if ($1.tobin() == $b) return $b; /*18259*/
			}; /*18259*/
			$1.encm = function() {
				var _7Z = $get($get($1.charvals, $1.M), $k[--$j]); /*18260*/
				$k[$j++] = _7Z; /*18260*/
				$k[$j++] = 5; /*18260*/
				if ($1.tobin() == $b) return $b; /*18260*/
			}; /*18260*/
			$1.encp = function() {
				var _7e = $get($get($1.charvals, $1.P), $k[--$j]); /*18261*/
				$k[$j++] = _7e; /*18261*/
				$k[$j++] = 5; /*18261*/
				if ($1.tobin() == $b) return $b; /*18261*/
			}; /*18261*/
			$1.encd = function() {
				var _7j = $get($get($1.charvals, $1.D), $k[--$j]); /*18262*/
				$k[$j++] = _7j; /*18262*/
				$k[$j++] = 4; /*18262*/
				if ($1.tobin() == $b) return $b; /*18262*/
			}; /*18262*/
			$1.encfuncs = $a(["encu", "encl", "encm", "encp", "encd"]); /*18263*/
			$1.addtomsgbits = function() {
				$1.v = $k[--$j]; /*18265*/
				$puti($1.msgbits, $1.j, $1.v); /*18266*/
				$1.j = $1.j + $1.v.length; /*18267*/
			}; /*18268*/
			$1.state = $1.U; /*18271*/
			$1.msgbits = $s($1.minseq); /*18272*/
			$1.i = 0; /*18273*/
			$1.j = 0; /*18273*/
			for (;;) { /*18332*/
				if ($1.i >= $1.seq.length) { /*18274*/
					break; /*18274*/
				} /*18274*/
				if ($1.state != $1.B) { /*18327*/
					$1.char = $get($1.seq, $1.i); /*18278*/
					$k[$j++] = $1.char; /*18281*/
					$1[$get($1.encfuncs, $1.state)](); /*18281*/
					if ($1.addtomsgbits() == $b) break; /*18281*/
					$1.i = $1.i + 1; /*18282*/
					if (($1.char == $1.su) || ($1.char == $1.sp)) { /*18288*/
						$k[$j++] = $get($1.seq, $1.i); /*18286*/
						if ($1.char == $1.su) { /*18286*/
							if ($1.encu() == $b) break; /*18286*/
						} else { /*18286*/
							if ($1.encp() == $b) break; /*18286*/
						} /*18286*/
						if ($1.addtomsgbits() == $b) break; /*18286*/
						$1.i = $1.i + 1; /*18287*/
					} /*18287*/
					if ($1.char == $1.lu) { /*18291*/
						$1.state = $1.U; /*18291*/
					} /*18291*/
					if ($1.char == $1.ll) { /*18292*/
						$1.state = $1.L; /*18292*/
					} /*18292*/
					if ($1.char == $1.lm) { /*18293*/
						$1.state = $1.M; /*18293*/
					} /*18293*/
					if ($1.char == $1.lp) { /*18294*/
						$1.state = $1.P; /*18294*/
					} /*18294*/
					if ($1.char == $1.ld) { /*18295*/
						$1.state = $1.D; /*18295*/
					} /*18295*/
					if ($1.char == $1.sb) { /*18296*/
						$1.state = $1.B; /*18296*/
					} /*18296*/
				} else { /*18327*/
					$1.numbytes = 0; /*18301*/
					for (;;) { /*18305*/
						if (($1.i + $1.numbytes) >= $1.seq.length) { /*18302*/
							break; /*18302*/
						} /*18302*/
						if ($get($1.seq, $1.i + $1.numbytes) < 0) { /*18303*/
							break; /*18303*/
						} /*18303*/
						$1.numbytes = $1.numbytes + 1; /*18304*/
					} /*18304*/
					if ($1.numbytes <= 31) { /*18312*/
						$k[$j++] = $1.numbytes; /*18309*/
						$k[$j++] = 5; /*18309*/
						if ($1.tobin() == $b) break; /*18309*/
						if ($1.addtomsgbits() == $b) break; /*18309*/
					} else { /*18312*/
						$k[$j++] = 0; /*18311*/
						$k[$j++] = 5; /*18311*/
						if ($1.tobin() == $b) break; /*18311*/
						if ($1.addtomsgbits() == $b) break; /*18311*/
						$k[$j++] = $1.numbytes - 31; /*18312*/
						$k[$j++] = 11; /*18312*/
						if ($1.tobin() == $b) break; /*18312*/
						if ($1.addtomsgbits() == $b) break; /*18312*/
					} /*18312*/
					for (var _8l = 0, _8m = $1.numbytes; _8l < _8m; _8l++) { /*18319*/
						$k[$j++] = $get($1.seq, $1.i); /*18317*/
						$k[$j++] = 8; /*18317*/
						if ($1.tobin() == $b) break; /*18317*/
						if ($1.addtomsgbits() == $b) break; /*18317*/
						$1.i = $1.i + 1; /*18318*/
					} /*18318*/
					if ($1.i < $1.seq.length) { /*18328*/
						$1.char = $get($1.seq, $1.i); /*18323*/
						$1.i = $1.i + 1; /*18324*/
						if ($1.char == $1.lu) { /*18325*/
							$1.state = $1.U; /*18325*/
						} /*18325*/
						if ($1.char == $1.ll) { /*18326*/
							$1.state = $1.L; /*18326*/
						} /*18326*/
						if ($1.char == $1.lm) { /*18327*/
							$1.state = $1.M; /*18327*/
						} /*18327*/
					} /*18327*/
				} /*18327*/
			} /*18327*/
		} /*18327*/
		$1.metrics = $a([$a(["rune", 0, 0, 0, 6]), $a(["compact", 1, 1, 17, 6]), $a(["full", 1, 1, 21, 6]), $a(["compact", 2, 0, 40, 6]), $a(["full", 2, 1, 48, 6]), $a(["compact", 3, 0, 51, 8]), $a(["full", 3, 1, 60, 8]), $a(["compact", 4, 0, 76, 8]), $a(["full", 4, 1, 88, 8]), $a(["full", 5, 1, 120, 8]), $a(["full", 6, 1, 156, 8]), $a(["full", 7, 1, 196, 8]), $a(["full", 8, 1, 240, 8]), $a(["full", 9, 1, 230, 10]), $a(["full", 10, 1, 272, 10]), $a(["full", 11, 1, 316, 10]), $a(["full", 12, 1, 364, 10]), $a(["full", 13, 1, 416, 10]), $a(["full", 14, 1, 470, 10]), $a(["full", 15, 1, 528, 10]), $a(["full", 16, 1, 588, 10]), $a(["full", 17, 1, 652, 10]), $a(["full", 18, 1, 720, 10]), $a(["full", 19, 1, 790, 10]), $a(["full", 20, 1, 864, 10]), $a(["full", 21, 1, 940, 10]), $a(["full", 22, 1, 1020, 10]), $a(["full", 23, 0, 920, 12]), $a(["full", 24, 0, 992, 12]), $a(["full", 25, 0, 1066, 12]), $a(["full", 26, 0, 1144, 12]), $a(["full", 27, 0, 1224, 12]), $a(["full", 28, 0, 1306, 12]), $a(["full", 29, 0, 1392, 12]), $a(["full", 30, 0, 1480, 12]), $a(["full", 31, 0, 1570, 12]), $a(["full", 32, 0, 1664, 12])]); /*18351*/
		$1.i = 0; /*18353*/
		for (;;) { /*18371*/
			$1.m = $get($1.metrics, $1.i); /*18355*/
			$1.frmt = $get($1.m, 0); /*18356*/
			$1.mlyr = $get($1.m, 1); /*18357*/
			$1.icap = $get($1.m, 2); /*18358*/
			$1.ncws = $get($1.m, 3); /*18359*/
			$1.bpcw = $get($1.m, 4); /*18360*/
			$1.numecw = ~~(Math.ceil((($1.ncws * $1.eclevel) / 100) + $1.ecaddchars)); /*18361*/
			if ($1.msgbits.length == 0) { /*18362*/
				$1.numecw = 0; /*18362*/
			} /*18362*/
			$1.numdcw = $1.ncws - $1.numecw; /*18363*/
			$1.okay = true; /*18364*/
			if ($ne($1.format, "unset") && $ne($1.format, $1.frmt)) { /*18365*/
				$1.okay = false; /*18365*/
			} /*18365*/
			if ($1.readerinit && ($1.icap != 1)) { /*18366*/
				$1.okay = false; /*18366*/
			} /*18366*/
			if (($1.layers != -1) && ($1.layers != $1.mlyr)) { /*18367*/
				$1.okay = false; /*18367*/
			} /*18367*/
			if ((~~Math.ceil($1.msgbits.length / $1.bpcw)) > $1.numdcw) { /*18368*/
				$1.okay = false; /*18368*/
			} /*18368*/
			if ($1.okay) { /*18369*/
				break; /*18369*/
			} /*18369*/
			$1.i = $1.i + 1; /*18370*/
		} /*18370*/
		$1.layers = $1.mlyr; /*18372*/
		$1.format = $1.frmt; /*18373*/
		$1.allzero = function() {
			var _AG = $k[--$j]; /*18376*/
			$k[$j++] = $eq(_AG, $geti("000000000000", 0, _AG.length)); /*18376*/
		}; /*18376*/
		$1.allones = function() {
			var _AI = $k[--$j]; /*18377*/
			$k[$j++] = $eq(_AI, $geti("111111111111", 0, _AI.length)); /*18377*/
		}; /*18377*/
		$1.cws = $a($1.ncws); /*18378*/
		$1.m = 0; /*18379*/
		$1.c = 0; /*18379*/
		for (;;) { /*18406*/
			if ($1.msgbits.length <= $1.m) { /*18381*/
				break; /*18381*/
			} /*18381*/
			if (($1.msgbits.length - $1.m) >= $1.bpcw) { /*18395*/
				$1.cwb = $geti($1.msgbits, $1.m, $1.bpcw - 1); /*18383*/
				$1.cwf = $geti($1.msgbits, ($1.m + $1.bpcw) - 1, 1); /*18384*/
				$k[$j++] = $1.cwb; /*18385*/
				if ($1.allzero() == $b) break; /*18385*/
				if ($k[--$j]) { /*18385*/
					$1.cwf = "1"; /*18385*/
					$1.m = $1.m - 1; /*18385*/
				} /*18385*/
				$k[$j++] = $1.cwb; /*18386*/
				if ($1.allones() == $b) break; /*18386*/
				if ($k[--$j]) { /*18386*/
					$1.cwf = "0"; /*18386*/
					$1.m = $1.m - 1; /*18386*/
				} /*18386*/
				var _Af = $s(12); /*18388*/
				$puti(_Af, 0, $1.cwb); /*18388*/
				$puti(_Af, $1.bpcw - 1, $1.cwf); /*18389*/
				$1.cwb = $geti(_Af, 0, $1.bpcw); /*18391*/
			} else { /*18395*/
				$1.cwb = $geti($1.msgbits, $1.m, $1.msgbits.length - $1.m); /*18393*/
				var _Ar = $strcpy($s(12), "111111111111"); /*18394*/
				$puti(_Ar, 0, $1.cwb); /*18394*/
				$1.cwb = $geti(_Ar, 0, $1.bpcw); /*18394*/
				$k[$j++] = $1.cwb; /*18395*/
				if ($1.allones() == $b) break; /*18395*/
				if ($k[--$j]) { /*18395*/
					$puti($1.cwb, $1.cwb.length - 1, "0"); /*18395*/
				} /*18395*/
			} /*18395*/
			$1.cw = 0; /*18398*/
			for (var _B1 = 0, _B0 = $1.bpcw - 1; _B1 <= _B0; _B1 += 1) { /*18402*/
				$1.i = _B1; /*18400*/
				$1.cw = $1.cw + ((~~(Math.pow(2, ($1.bpcw - $1.i) - 1))) * ($get($1.cwb, $1.i) - 48)); /*18401*/
			} /*18401*/
			$put($1.cws, $1.c, $1.cw); /*18403*/
			$1.m = $1.m + $1.bpcw; /*18404*/
			$1.c = $1.c + 1; /*18405*/
		} /*18405*/
		$1.cws = $geti($1.cws, 0, $1.c); /*18407*/
		$1.rscodes = function() {
			$1.rspm = $k[--$j]; /*18412*/
			$1.rsgf = $k[--$j]; /*18413*/
			$1.rsnc = $k[--$j]; /*18414*/
			$1.rscws = $k[--$j]; /*18415*/
			$k[$j++] = Infinity; /*18418*/
			$k[$j++] = 1; /*18418*/
			for (var _BM = 0, _BN = $1.rsgf - 1; _BM < _BN; _BM++) { /*18418*/
				var _BO = $k[--$j]; /*18418*/
				var _BP = _BO * 2; /*18418*/
				$k[$j++] = _BO; /*18418*/
				$k[$j++] = _BP; /*18418*/
				if (_BP >= $1.rsgf) { /*18418*/
					var _BS = $k[--$j]; /*18418*/
					$k[$j++] = $xo(_BS, $1.rspm); /*18418*/
				} /*18418*/
			} /*18418*/
			$1.rsalog = $a(); /*18418*/
			$1.rslog = $a($1.rsgf); /*18419*/
			for (var _BY = 1, _BX = $1.rsgf - 1; _BY <= _BX; _BY += 1) { /*18420*/
				$put($1.rslog, $get($1.rsalog, _BY), _BY); /*18420*/
			} /*18420*/
			$1.rsprod = function() {
				var _Bc = $k[--$j]; /*18424*/
				var _Bd = $k[--$j]; /*18424*/
				$k[$j++] = _Bd; /*18428*/
				$k[$j++] = _Bc; /*18428*/
				if ((_Bc != 0) && (_Bd != 0)) { /*18427*/
					var _Bg = $get($1.rslog, $k[--$j]); /*18425*/
					var _Bm = $get($1.rsalog, (_Bg + $get($1.rslog, $k[--$j])) % ($1.rsgf - 1)); /*18425*/
					$k[$j++] = _Bm; /*18425*/
				} else { /*18427*/
					$j -= 2; /*18427*/
					$k[$j++] = 0; /*18427*/
				} /*18427*/
			}; /*18429*/
			$k[$j++] = Infinity; /*18432*/
			$k[$j++] = 1; /*18432*/
			for (var _Bo = 0, _Bp = $1.rsnc; _Bo < _Bp; _Bo++) { /*18432*/
				$k[$j++] = 0; /*18432*/
			} /*18432*/
			$1.coeffs = $a(); /*18432*/
			for (var _Bt = 1, _Bs = $1.rsnc; _Bt <= _Bs; _Bt += 1) { /*18441*/
				$1.i = _Bt; /*18434*/
				$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*18435*/
				for (var _C0 = $1.i - 1; _C0 >= 1; _C0 -= 1) { /*18439*/
					$1.j = _C0; /*18437*/
					$k[$j++] = $1.coeffs; /*18438*/
					$k[$j++] = $1.j; /*18438*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*18438*/
					$k[$j++] = $get($1.coeffs, $1.j); /*18438*/
					$k[$j++] = $get($1.rsalog, $1.i); /*18438*/
					if ($1.rsprod() == $b) break; /*18438*/
					var _CC = $k[--$j]; /*18438*/
					var _CD = $k[--$j]; /*18438*/
					var _CE = $k[--$j]; /*18438*/
					$put($k[--$j], _CE, $xo(_CD, _CC)); /*18438*/
				} /*18438*/
				$k[$j++] = $1.coeffs; /*18440*/
				$k[$j++] = 0; /*18440*/
				$k[$j++] = $get($1.coeffs, 0); /*18440*/
				$k[$j++] = $get($1.rsalog, $1.i); /*18440*/
				if ($1.rsprod() == $b) break; /*18440*/
				var _CM = $k[--$j]; /*18440*/
				var _CN = $k[--$j]; /*18440*/
				$put($k[--$j], _CN, _CM); /*18440*/
			} /*18440*/
			$1.nd = $1.rscws.length; /*18444*/
			$k[$j++] = Infinity; /*18445*/
			$forall($1.rscws); /*18445*/
			for (var _CS = 0, _CT = $1.rsnc; _CS < _CT; _CS++) { /*18445*/
				$k[$j++] = 0; /*18445*/
			} /*18445*/
			$k[$j++] = 0; /*18445*/
			$1.rscws = $a(); /*18445*/
			for (var _CX = 0, _CW = $1.nd - 1; _CX <= _CW; _CX += 1) { /*18452*/
				$1.k = $xo($get($1.rscws, _CX), $get($1.rscws, $1.nd)); /*18447*/
				for (var _Cf = 0, _Ce = $1.rsnc - 1; _Cf <= _Ce; _Cf += 1) { /*18451*/
					$1.j = _Cf; /*18449*/
					$k[$j++] = $1.rscws; /*18450*/
					$k[$j++] = $1.nd + $1.j; /*18450*/
					$k[$j++] = $get($1.rscws, ($1.nd + $1.j) + 1); /*18450*/
					$k[$j++] = $1.k; /*18450*/
					$k[$j++] = $get($1.coeffs, ($1.rsnc - $1.j) - 1); /*18450*/
					if ($1.rsprod() == $b) break; /*18450*/
					var _Cs = $k[--$j]; /*18450*/
					var _Ct = $k[--$j]; /*18450*/
					var _Cu = $k[--$j]; /*18450*/
					$put($k[--$j], _Cu, $xo(_Ct, _Cs)); /*18450*/
				} /*18450*/
			} /*18450*/
			$k[$j++] = $geti($1.rscws, 0, $1.rscws.length - 1); /*18455*/
		}; /*18457*/
		if ($eq($1.format, "full")) { /*18470*/
			$1.mode = (($1.layers - 1) << 11) + ($1.cws.length - 1); /*18461*/
			if ($1.readerinit) { /*18462*/
				$1.mode = $1.mode | 1024; /*18462*/
			} /*18462*/
			$1.mode = $a([($1.mode & 61440) >>> 12, ($1.mode & 3840) >>> 8, ($1.mode & 240) >>> 4, $1.mode & 15]); /*18468*/
			$k[$j++] = "mode"; /*18469*/
			$k[$j++] = $1.mode; /*18469*/
			$k[$j++] = 6; /*18469*/
			$k[$j++] = 16; /*18469*/
			$k[$j++] = 19; /*18469*/
			if ($1.rscodes() == $b) return $b; /*18469*/
			var _DA = $k[--$j]; /*18469*/
			$1[$k[--$j]] = _DA; /*18469*/
		} /*18469*/
		if ($eq($1.format, "compact")) { /*18479*/
			$1.mode = (($1.layers - 1) << 6) + ($1.cws.length - 1); /*18472*/
			if ($1.readerinit) { /*18473*/
				$1.mode = $1.mode | 32; /*18473*/
			} /*18473*/
			$1.mode = $a([($1.mode & 240) >>> 4, $1.mode & 15]); /*18477*/
			$k[$j++] = "mode"; /*18478*/
			$k[$j++] = $1.mode; /*18478*/
			$k[$j++] = 5; /*18478*/
			$k[$j++] = 16; /*18478*/
			$k[$j++] = 19; /*18478*/
			if ($1.rscodes() == $b) return $b; /*18478*/
			var _DL = $k[--$j]; /*18478*/
			$1[$k[--$j]] = _DL; /*18478*/
		} /*18478*/
		if ($eq($1.format, "rune")) { /*18488*/
			$1.mode = ~~$z($1.barcode); /*18481*/
			$1.mode = $a([($1.mode & 240) >>> 4, $1.mode & 15]); /*18485*/
			$k[$j++] = "mode"; /*18486*/
			$k[$j++] = $1.mode; /*18486*/
			$k[$j++] = 5; /*18486*/
			$k[$j++] = 16; /*18486*/
			$k[$j++] = 19; /*18486*/
			if ($1.rscodes() == $b) return $b; /*18486*/
			var _DT = $k[--$j]; /*18486*/
			$1[$k[--$j]] = _DT; /*18486*/
			$k[$j++] = Infinity; /*18487*/
			var _DV = $1.mode; /*18487*/
			for (var _DW = 0, _DX = _DV.length; _DW < _DX; _DW++) { /*18487*/
				$k[$j++] = $get(_DV, _DW) ^ 10; /*18487*/
			} /*18487*/
			$1.mode = $a(); /*18487*/
		} /*18487*/
		$1.modebits = $s($1.mode.length * 4); /*18489*/
		for (var _De = 0, _Dd = $1.modebits.length - 1; _De <= _Dd; _De += 1) { /*18490*/
			$puti($1.modebits, _De, "0"); /*18490*/
		} /*18490*/
		for (var _Di = 0, _Dh = $1.mode.length - 1; _Di <= _Dh; _Di += 1) { /*18494*/
			$1.i = _Di; /*18492*/
			var _Do = $cvrs($s(4), $get($1.mode, $1.i), 2); /*18493*/
			$puti($1.modebits, (4 - _Do.length) + (4 * $1.i), _Do); /*18493*/
		} /*18493*/
		$1.rsparams = $a([$a([]), $a([]), $a([]), $a([]), $a([]), $a([]), $a([64, 67]), $a([]), $a([256, 301]), $a([]), $a([1024, 1033]), $a([]), $a([4096, 4201])]); /*18506*/
		$k[$j++] = "cws"; /*18507*/
		$k[$j++] = $1.cws; /*18507*/
		$k[$j++] = $1.ncws - $1.cws.length; /*18507*/
		$forall($get($1.rsparams, $1.bpcw)); /*18507*/
		if ($1.rscodes() == $b) return $b; /*18507*/
		var _EA = $k[--$j]; /*18507*/
		$1[$k[--$j]] = _EA; /*18507*/
		if ($eq($1.format, "full")) { /*18511*/
			$1.databits = $s((($1.layers * $1.layers) * 16) + ($1.layers * 112)); /*18509*/
		} else { /*18511*/
			$1.databits = $s((($1.layers * $1.layers) * 16) + ($1.layers * 88)); /*18511*/
		} /*18511*/
		for (var _EN = 0, _EM = $1.databits.length - 1; _EN <= _EM; _EN += 1) { /*18513*/
			$puti($1.databits, _EN, "0"); /*18513*/
		} /*18513*/
		for (var _ER = 0, _EQ = $1.ncws - 1; _ER <= _EQ; _ER += 1) { /*18519*/
			$1.i = _ER; /*18515*/
			var _EY = $cvrs($s($1.bpcw), $get($1.cws, $1.i), 2); /*18516*/
			$puti($1.databits, (($1.bpcw - _EY.length) + ($1.bpcw * $1.i)) + ($1.databits.length - ($1.ncws * $1.bpcw)), _EY); /*18518*/
		} /*18518*/
		$1.cmv = function() {
			var _Eg = $k[--$j]; /*18522*/
			var _Eh = $k[--$j]; /*18522*/
			$k[$j++] = (_Eh - (_Eg * $1.size)) + $1.mid; /*18522*/
		}; /*18522*/
		$1.lmv = function() {
			$1.lbit = $k[--$j]; /*18526*/
			$1.llyr = $k[--$j]; /*18527*/
			$1.lwid = $1.fw + ($1.llyr * 4); /*18528*/
			$1.ldir = ~~((~~($1.lbit / 2)) / $1.lwid); /*18529*/
			if ($1.ldir == 0) { /*18534*/
				$k[$j++] = ((-(~~(($1.lwid - 1) / 2))) + 1) + ((~~($1.lbit / 2)) % $1.lwid); /*18533*/
				$k[$j++] = ((~~(($1.fw - 1) / 2)) + ($1.llyr * 2)) + ($1.lbit % 2); /*18533*/
				if ($1.cmv() == $b) return $b; /*18533*/
			} /*18533*/
			if ($1.ldir == 1) { /*18539*/
				$k[$j++] = ((~~($1.fw / 2)) + ($1.llyr * 2)) + ($1.lbit % 2); /*18538*/
				$k[$j++] = ((~~(($1.lwid - 1) / 2)) - 1) - ((~~($1.lbit / 2)) % $1.lwid); /*18538*/
				if ($1.cmv() == $b) return $b; /*18538*/
			} /*18538*/
			if ($1.ldir == 2) { /*18544*/
				$k[$j++] = -(((-(~~($1.lwid / 2))) + 1) + ((~~($1.lbit / 2)) % $1.lwid)); /*18543*/
				$k[$j++] = -(((~~($1.fw / 2)) + ($1.llyr * 2)) + ($1.lbit % 2)); /*18543*/
				if ($1.cmv() == $b) return $b; /*18543*/
			} /*18543*/
			if ($1.ldir == 3) { /*18549*/
				$k[$j++] = -(((~~(($1.fw - 1) / 2)) + ($1.llyr * 2)) + ($1.lbit % 2)); /*18548*/
				$k[$j++] = -(((~~($1.lwid / 2)) - 1) - ((~~($1.lbit / 2)) % $1.lwid)); /*18548*/
				if ($1.cmv() == $b) return $b; /*18548*/
			} /*18548*/
		}; /*18550*/
		if ($eq($1.format, "full")) { /*18554*/
			$1.fw = 12; /*18554*/
		} else { /*18554*/
			$1.fw = 9; /*18554*/
		} /*18554*/
		$1.size = ($1.fw + ($1.layers * 4)) + 2; /*18555*/
		$k[$j++] = Infinity; /*18556*/
		for (var _FM = 0, _FN = $1.size * $1.size; _FM < _FN; _FM++) { /*18556*/
			$k[$j++] = -1; /*18556*/
		} /*18556*/
		$1.pixs = $a(); /*18556*/
		$1.mid = ((~~(($1.size - 1) / 2)) * $1.size) + (~~(($1.size - 1) / 2)); /*18557*/
		$1.i = 0; /*18560*/
		for (var _FU = 1, _FT = $1.layers; _FU <= _FT; _FU += 1) { /*18568*/
			$1.layer = _FU; /*18562*/
			for (var _FY = 0, _FX = (($1.fw + ($1.layer * 4)) * 8) - 1; _FY <= _FX; _FY += 1) { /*18567*/
				$1.pos = _FY; /*18564*/
				$k[$j++] = $1.pixs; /*18565*/
				$k[$j++] = $1.layer; /*18565*/
				$k[$j++] = $1.pos; /*18565*/
				if ($1.lmv() == $b) break; /*18565*/
				var _Fg = $k[--$j]; /*18565*/
				$put($k[--$j], _Fg, $get($1.databits, ($1.databits.length - $1.i) - 1) - 48); /*18565*/
				$1.i = $1.i + 1; /*18566*/
			} /*18566*/
		} /*18566*/
		if ($eq($1.format, "full")) { /*18595*/
			$1.fw = 13; /*18572*/
			$1.size = (($1.fw + ($1.layers * 4)) + 2) + ((~~((($1.layers + 10.5) / 7.5) - 1)) * 2); /*18573*/
			$1.mid = ~~(($1.size * $1.size) / 2); /*18574*/
			$k[$j++] = Infinity; /*18575*/
			for (var _Fr = 0, _Fs = $1.size * $1.size; _Fr < _Fs; _Fr++) { /*18575*/
				$k[$j++] = -2; /*18575*/
			} /*18575*/
			$1.npixs = $a(); /*18575*/
			for (var _Fw = 0, _Fv = ~~($1.size / 2); _Fw <= _Fv; _Fw += 16) { /*18585*/
				$1.i = _Fw; /*18577*/
				for (var _Fz = 0, _Fy = $1.size - 1; _Fz <= _Fy; _Fz += 1) { /*18584*/
					$1.j = _Fz; /*18579*/
					$k[$j++] = $1.npixs; /*18580*/
					$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18580*/
					$k[$j++] = $1.i; /*18580*/
					if ($1.cmv() == $b) break; /*18580*/
					var _G8 = $k[--$j]; /*18580*/
					$puti($k[--$j], _G8, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18580*/
					$k[$j++] = $1.npixs; /*18581*/
					$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18581*/
					$k[$j++] = -$1.i; /*18581*/
					if ($1.cmv() == $b) break; /*18581*/
					var _GI = $k[--$j]; /*18581*/
					$puti($k[--$j], _GI, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18581*/
					$k[$j++] = $1.npixs; /*18582*/
					$k[$j++] = $1.i; /*18582*/
					$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18582*/
					if ($1.cmv() == $b) break; /*18582*/
					var _GS = $k[--$j]; /*18582*/
					$puti($k[--$j], _GS, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18582*/
					$k[$j++] = $1.npixs; /*18583*/
					$k[$j++] = -$1.i; /*18583*/
					$k[$j++] = (-(~~($1.size / 2))) + $1.j; /*18583*/
					if ($1.cmv() == $b) break; /*18583*/
					var _Gc = $k[--$j]; /*18583*/
					$puti($k[--$j], _Gc, $a([((((~~($1.size / 2)) + $1.j) + $1.i) + 1) % 2])); /*18583*/
				} /*18583*/
			} /*18583*/
			$1.j = 0; /*18586*/
			for (var _Gg = 0, _Gf = $1.npixs.length - 1; _Gg <= _Gf; _Gg += 1) { /*18593*/
				$1.i = _Gg; /*18588*/
				if ($get($1.npixs, $1.i) == -2) { /*18592*/
					$put($1.npixs, $1.i, $get($1.pixs, $1.j)); /*18590*/
					$1.j = $1.j + 1; /*18591*/
				} /*18591*/
			} /*18591*/
			$1.pixs = $1.npixs; /*18594*/
		} /*18594*/
		$1.fw = ~~($1.fw / 2); /*18598*/
		for (var _Gv = -$1.fw, _Gu = $1.fw; _Gv <= _Gu; _Gv += 1) { /*18607*/
			$1.i = _Gv; /*18600*/
			for (var _Gz = -$1.fw, _Gy = $1.fw; _Gz <= _Gy; _Gz += 1) { /*18606*/
				$1.j = _Gz; /*18602*/
				$k[$j++] = $1.pixs; /*18603*/
				$k[$j++] = $1.i; /*18603*/
				$k[$j++] = $1.j; /*18603*/
				if ($1.cmv() == $b) break; /*18603*/
				if (Math.abs($1.i) > Math.abs($1.j)) { /*18604*/
					$k[$j++] = Math.abs($1.i); /*18604*/
				} else { /*18604*/
					$k[$j++] = Math.abs($1.j); /*18604*/
				} /*18604*/
				var _H7 = $k[--$j]; /*18604*/
				var _H8 = $k[--$j]; /*18605*/
				$put($k[--$j], _H8, (_H7 + 1) % 2); /*18605*/
			} /*18605*/
		} /*18605*/
		var _Hk = $a([$a([-($1.fw + 1), $1.fw, 1]), $a([-($1.fw + 1), $1.fw + 1, 1]), $a([-$1.fw, $1.fw + 1, 1]), $a([$1.fw + 1, $1.fw + 1, 1]), $a([$1.fw + 1, $1.fw, 1]), $a([$1.fw + 1, -$1.fw, 1]), $a([$1.fw, $1.fw + 1, 0]), $a([$1.fw + 1, -($1.fw + 1), 0]), $a([$1.fw, -($1.fw + 1), 0]), $a([-$1.fw, -($1.fw + 1), 0]), $a([-($1.fw + 1), -($1.fw + 1), 0]), $a([-($1.fw + 1), -$1.fw, 0])]); /*18615*/
		for (var _Hl = 0, _Hm = _Hk.length; _Hl < _Hm; _Hl++) { /*18616*/
			$k[$j++] = $1.pixs; /*18616*/
			$forall($get(_Hk, _Hl)); /*18616*/
			var _Hp = $k[--$j]; /*18616*/
			var _Hq = $k[--$j]; /*18616*/
			var _Hr = $k[--$j]; /*18616*/
			$k[$j++] = _Hp; /*18616*/
			$k[$j++] = _Hr; /*18616*/
			$k[$j++] = _Hq; /*18616*/
			if ($1.cmv() == $b) return $b; /*18616*/
			var _Hs = $k[--$j]; /*18616*/
			var _Ht = $k[--$j]; /*18616*/
			$put($k[--$j], _Hs, _Ht); /*18616*/
		} /*18616*/
		if ($eq($1.format, "full")) { /*18632*/
			$1.modemap = $a([$a([-5, 7]), $a([-4, 7]), $a([-3, 7]), $a([-2, 7]), $a([-1, 7]), $a([1, 7]), $a([2, 7]), $a([3, 7]), $a([4, 7]), $a([5, 7]), $a([7, 5]), $a([7, 4]), $a([7, 3]), $a([7, 2]), $a([7, 1]), $a([7, -1]), $a([7, -2]), $a([7, -3]), $a([7, -4]), $a([7, -5]), $a([5, -7]), $a([4, -7]), $a([3, -7]), $a([2, -7]), $a([1, -7]), $a([-1, -7]), $a([-2, -7]), $a([-3, -7]), $a([-4, -7]), $a([-5, -7]), $a([-7, -5]), $a([-7, -4]), $a([-7, -3]), $a([-7, -2]), $a([-7, -1]), $a([-7, 1]), $a([-7, 2]), $a([-7, 3]), $a([-7, 4]), $a([-7, 5])]); /*18625*/
		} else { /*18632*/
			$1.modemap = $a([$a([-3, 5]), $a([-2, 5]), $a([-1, 5]), $a([0, 5]), $a([1, 5]), $a([2, 5]), $a([3, 5]), $a([5, 3]), $a([5, 2]), $a([5, 1]), $a([5, 0]), $a([5, -1]), $a([5, -2]), $a([5, -3]), $a([3, -5]), $a([2, -5]), $a([1, -5]), $a([0, -5]), $a([-1, -5]), $a([-2, -5]), $a([-3, -5]), $a([-5, -3]), $a([-5, -2]), $a([-5, -1]), $a([-5, 0]), $a([-5, 1]), $a([-5, 2]), $a([-5, 3])]); /*18632*/
		} /*18632*/
		for (var _J6 = 0, _J5 = $1.modemap.length - 1; _J6 <= _J5; _J6 += 1) { /*18637*/
			$1.i = _J6; /*18635*/
			$k[$j++] = $1.pixs; /*18636*/
			$forall($get($1.modemap, $1.i)); /*18636*/
			if ($1.cmv() == $b) break; /*18636*/
			var _JE = $k[--$j]; /*18636*/
			$put($k[--$j], _JE, $get($1.modebits, $1.i) - 48); /*18636*/
		} /*18636*/
		var _JM = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.size,
			pixy: $1.size,
			height: ($1.size * 2) / 72,
			width: ($1.size * 2) / 72,
			opt: $1.options
		}; /*18646*/
		$k[$j++] = _JM; /*18649*/
		if (!$1.dontdraw) { /*18649*/
			$0.renmatrix(); /*18649*/
		} /*18649*/
	};
	$0.azteccodecompact = function() {
		var $1 = {}; /*18677*/
		$1.options = $k[--$j]; /*18679*/
		$1.barcode = $k[--$j]; /*18680*/
		$1.dontdraw = false; /*18682*/
		$forall($1.options, function() { /*18693*/
			var _3 = $k[--$j]; /*18693*/
			$1[$k[--$j]] = _3; /*18693*/
		}); /*18693*/
		$1.options.dontdraw = true; /*18696*/
		$1.options.format = "compact"; /*18697*/
		$k[$j++] = "args"; /*18699*/
		$k[$j++] = $1.barcode; /*18699*/
		$k[$j++] = $1.options; /*18699*/
		$0.azteccode(); /*18699*/
		var _9 = $k[--$j]; /*18699*/
		$1[$k[--$j]] = _9; /*18699*/
		$1.args.opt = $1.options; /*18701*/
		$k[$j++] = $1.args; /*18704*/
		if (!$1.dontdraw) { /*18704*/
			$0.renmatrix(); /*18704*/
		} /*18704*/
	};
	$0.aztecrune = function() {
		var $1 = {}; /*18732*/
		$1.options = $k[--$j]; /*18734*/
		$1.barcode = $k[--$j]; /*18735*/
		$1.dontdraw = false; /*18737*/
		$forall($1.options, function() { /*18748*/
			var _3 = $k[--$j]; /*18748*/
			$1[$k[--$j]] = _3; /*18748*/
		}); /*18748*/
		$1.options.dontdraw = true; /*18751*/
		$1.options.format = "rune"; /*18752*/
		$k[$j++] = "args"; /*18754*/
		$k[$j++] = $1.barcode; /*18754*/
		$k[$j++] = $1.options; /*18754*/
		$0.azteccode(); /*18754*/
		var _9 = $k[--$j]; /*18754*/
		$1[$k[--$j]] = _9; /*18754*/
		$1.args.opt = $1.options; /*18756*/
		$k[$j++] = $1.args; /*18759*/
		if (!$1.dontdraw) { /*18759*/
			$0.renmatrix(); /*18759*/
		} /*18759*/
	};
	$0.codeone = function() {
		var $1 = {}; /*18786*/
		$1.options = $k[--$j]; /*18788*/
		$1.barcode = $k[--$j]; /*18789*/
		$1.dontdraw = false; /*18791*/
		$1.version = "unset"; /*18792*/
		$1.parse = false; /*18793*/
		$1.parsefnc = false; /*18794*/
		$forall($1.options, function() { /*18805*/
			var _3 = $k[--$j]; /*18805*/
			$1[$k[--$j]] = _3; /*18805*/
		}); /*18805*/
		$1.barlen = $1.barcode.length; /*18828*/
		$1.stype = $eq($geti($1.version, 0, 1), "S"); /*18830*/
		if ($1.stype) { /*19420*/
			$1.vals = $a(["1", "1010", "1100100", "1111101000", "10011100010000", "11000011010100000", "11110100001001000000", "100110001001011010000000", "101111101011110000100000000", "111011100110101100101000000000", "1001010100000010111110010000000000", "1011101001000011101101110100000000000", "1110100011010100101001010001000000000000", "10010001100001001110011100101010000000000000", "10110101111001100010000011110100100000000000000", "11100011010111111010100100110001101000000000000000", "100011100001101111001001101111110000010000000000000000", "101100011010001010111100001011101100010100000000000000000"]); /*18852*/
			$1.normalize = function() {
				$1.base = $k[--$j]; /*18855*/
				$1.num = $k[--$j]; /*18856*/
				for (var _D = $1.num.length - 1; _D >= 1; _D -= 1) { /*18861*/
					$1.i = _D; /*18858*/
					var _E = $1.num; /*18859*/
					var _F = $1.i; /*18859*/
					$put(_E, _F - 1, $get(_E, _F - 1) + (~~($get($1.num, $1.i) / $1.base))); /*18859*/
					$put($1.num, $1.i, $get($1.num, $1.i) % $1.base); /*18860*/
				} /*18860*/
				for (;;) { /*18867*/
					if ($lt($get($1.num, 0), $1.base)) { /*18863*/
						break; /*18863*/
					} /*18863*/
					$k[$j++] = Infinity; /*18864*/
					$k[$j++] = 0; /*18864*/
					$forall($1.num); /*18864*/
					$1.num = $a(); /*18864*/
					$put($1.num, 0, $get($1.num, 0) + (~~($get($1.num, 1) / $1.base))); /*18865*/
					$put($1.num, 1, $get($1.num, 1) % $1.base); /*18866*/
				} /*18866*/
				$k[$j++] = Infinity; /*18869*/
				$1.i = true; /*18869*/
				var _g = $1.num; /*18869*/
				for (var _h = 0, _i = _g.length; _h < _i; _h++) { /*18869*/
					var _j = $get(_g, _h); /*18869*/
					$k[$j++] = _j; /*18869*/
					if ((_j == 0) && $1.i) { /*18869*/
						$j--; /*18869*/
					} else { /*18869*/
						$1.i = false; /*18869*/
					} /*18869*/
				} /*18869*/
				$1.num = $a(); /*18869*/
				if ($1.num.length == 0) { /*18870*/
					$1.num = $a([0]); /*18870*/
				} /*18870*/
				$k[$j++] = $1.num; /*18871*/
			}; /*18872*/
			$1.bigadd = function() {
				var _p = $k[--$j]; /*18875*/
				var _q = $k[--$j]; /*18875*/
				$1.offset = Math.abs(_p.length - _q.length); /*18876*/
				if (_p.length < _q.length) { /*18877*/
					var _ = _p; /*18877*/
					_p = _q; /*18877*/
					_q = _; /*18877*/
				} /*18877*/
				$1.a = _p; /*18878*/
				$1.b = _q; /*18878*/
				for (var _t = 0, _s = $1.b.length - 1; _t <= _s; _t += 1) { /*18881*/
					var _u = $1.a; /*18880*/
					var _v = $1.offset; /*18880*/
					$put(_u, _t + _v, $get(_u, _t + _v) + $get($1.b, _t)); /*18880*/
				} /*18880*/
				$k[$j++] = $1.a; /*18882*/
			}; /*18883*/
			$1.v = $a([1]); /*18886*/
			for (var _13 = 0, _12 = $1.barlen - 1; _13 <= _12; _13 += 1) { /*18891*/
				$1.i = _13; /*18888*/
				$k[$j++] = Infinity; /*18889*/
				$forall($get($1.vals, $1.i), function() { /*18889*/
					var _17 = $k[--$j]; /*18889*/
					$k[$j++] = (_17 - 48) * ($get($1.barcode, ($1.barlen - $1.i) - 1) - 48); /*18889*/
				}); /*18889*/
				var _1C = $a(); /*18889*/
				$k[$j++] = _1C; /*18890*/
				$k[$j++] = $1.v; /*18890*/
				if ($1.bigadd() == $b) break; /*18890*/
				$1.v = $k[--$j]; /*18890*/
			} /*18890*/
			$k[$j++] = "v"; /*18892*/
			$k[$j++] = $1.v; /*18892*/
			$k[$j++] = 2; /*18892*/
			if ($1.normalize() == $b) return $b; /*18892*/
			var _1G = $k[--$j]; /*18892*/
			$1[$k[--$j]] = _1G; /*18892*/
			$k[$j++] = Infinity; /*18895*/
			for (var _1J = 0, _1K = (5 - ($1.v.length % 5)) % 5; _1J < _1K; _1J++) { /*18895*/
				$k[$j++] = 0; /*18895*/
			} /*18895*/
			$aload($1.v); /*18895*/
			$1.v = $a(); /*18895*/
			$1.cws = $a(~~($1.v.length / 5)); /*18896*/
			for (var _1R = 0, _1Q = $1.cws.length - 1; _1R <= _1Q; _1R += 1) { /*18902*/
				$1.i = _1R; /*18898*/
				$k[$j++] = 0; /*18900*/
				$forall($geti($1.v, $1.i * 5, 5), function() { /*18900*/
					var _1V = $k[--$j]; /*18900*/
					var _1W = $k[--$j]; /*18900*/
					$k[$j++] = (_1W + _1V) * 2; /*18900*/
				}); /*18900*/
				$put($1.cws, $1.i, ~~($k[--$j] / 2)); /*18901*/
			} /*18901*/
			$1.metrics = $a([$a(["S-10", 8, 11, 10, 4, 4, 1, 99, 99, 99]), $a(["S-20", 8, 21, 20, 8, 8, 1, 99, 99, 99]), $a(["S-30", 8, 31, 30, 12, 12, 1, 99, 99, 99])]); /*18910*/
		} else { /*19420*/
			$1.fnc1 = -1; /*18915*/
			$1.fnc3 = -2; /*18915*/
			var _1g = {
				FNC1: $1.fnc1,
				FNC3: $1.fnc3
			}; /*18918*/
			$1.fncvals = _1g; /*18919*/
			$1.msg = $a($1.barlen); /*18920*/
			$1.i = 0; /*18921*/
			$1.j = 0; /*18921*/
			for (;;) { /*18935*/
				if ($1.i == $1.barlen) { /*18922*/
					break; /*18922*/
				} /*18922*/
				$1.char = $get($1.barcode, $1.i); /*18923*/
				if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*18931*/
					if ($get($1.barcode, $1.i + 1) != 94) { /*18929*/
						$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*18926*/
						$1.i = $1.i + 4; /*18927*/
					} else { /*18929*/
						$1.i = $1.i + 1; /*18929*/
					} /*18929*/
				} /*18929*/
				$put($1.msg, $1.j, $1.char); /*18932*/
				$1.i = $1.i + 1; /*18933*/
				$1.j = $1.j + 1; /*18934*/
			} /*18934*/
			$1.msg = $geti($1.msg, 0, $1.j); /*18936*/
			$1.msglen = $1.msg.length; /*18937*/
			$1.metrics = $a([$a(["A", 16, 18, 16, 10, 10, 1, 4, 99, 6]), $a(["B", 22, 22, 20, 19, 16, 1, 4, 99, 8]), $a(["C", 28, 32, 28, 44, 26, 1, 4, 22, 11]), $a(["D", 40, 42, 36, 91, 44, 1, 4, 16, 16]), $a(["E", 52, 54, 48, 182, 70, 1, 4, 22, 22]), $a(["F", 70, 76, 68, 370, 140, 2, 4, 22, 31]), $a(["G", 104, 98, 88, 732, 280, 4, 6, 21, 47]), $a(["H", 148, 134, 120, 1480, 560, 8, 6, 20, 69]), $a(["T-16", 16, 17, 16, 10, 10, 1, 99, 99, 99]), $a(["T-32", 16, 33, 32, 24, 16, 1, 99, 99, 99]), $a(["T-48", 16, 49, 48, 38, 22, 1, 99, 99, 99])]); /*18953*/
			$1.fullcws = $a([]); /*18956*/
			var _2O = $1.metrics; /*18957*/
			for (var _2P = 0, _2Q = _2O.length; _2P < _2Q; _2P++) { /*18968*/
				$1.m = $get(_2O, _2P); /*18958*/
				$1.vers = $get($1.m, 0); /*18959*/
				$1.dcws = $get($1.m, 4); /*18960*/
				$1.okay = true; /*18961*/
				if ($eq($1.version, "unset")) { /*18965*/
					if ($1.vers.length != 1) { /*18963*/
						$1.okay = false; /*18963*/
					} /*18963*/
				} else { /*18965*/
					if ($ne($1.version, $1.vers)) { /*18965*/
						$1.okay = false; /*18965*/
					} /*18965*/
				} /*18965*/
				if ($1.okay) { /*18967*/
					$k[$j++] = Infinity; /*18967*/
					$aload($1.fullcws); /*18967*/
					$k[$j++] = $1.dcws; /*18967*/
					$1.fullcws = $a(); /*18967*/
				} /*18967*/
			} /*18967*/
			$k[$j++] = Infinity; /*18969*/
			for (var _2e = 0, _2f = 1480; _2e < _2f; _2e++) { /*18969*/
				$k[$j++] = 10000; /*18969*/
			} /*18969*/
			$1.numremcws = $a(); /*18969*/
			var _2h = $1.fullcws; /*18970*/
			for (var _2i = 0, _2j = _2h.length; _2i < _2j; _2i++) { /*18970*/
				$put($1.numremcws, $get(_2h, _2i) - 1, 1); /*18970*/
			} /*18970*/
			for (var _2m = 1478; _2m >= 0; _2m -= 1) { /*18976*/
				$1.i = _2m; /*18972*/
				if ($get($1.numremcws, $1.i) != 1) { /*18975*/
					$put($1.numremcws, $1.i, $get($1.numremcws, $1.i + 1) + 1); /*18974*/
				} /*18974*/
			} /*18974*/
			$1.lC = -5; /*18979*/
			$1.lB = -6; /*18979*/
			$1.lX = -7; /*18979*/
			$1.lT = -8; /*18979*/
			$1.lD = -9; /*18979*/
			$1.unl = -10; /*18979*/
			$1.fnc2 = -11; /*18980*/
			$1.fnc4 = -12; /*18980*/
			$1.sft1 = -13; /*18980*/
			$1.sft2 = -14; /*18980*/
			$1.sft3 = -15; /*18980*/
			$1.eci = -16; /*18980*/
			$1.pad = -17; /*18980*/
			$1.fnc1lD = -18; /*18980*/
			$1.unlcw = 255; /*18981*/
			$k[$j++] = "Avals"; /*18992*/
			$k[$j++] = Infinity; /*18992*/
			for (var _2v = 0; _2v <= 128; _2v += 1) { /*18984*/
				$k[$j++] = _2v; /*18984*/
				$k[$j++] = _2v + 1; /*18984*/
			} /*18984*/
			$k[$j++] = $1.pad; /*18989*/
			$k[$j++] = 129; /*18989*/
			for (var _2x = 0; _2x <= 99; _2x += 1) { /*18989*/
				var _2z = $cvrs($s(2), _2x, 10); /*18987*/
				var _31 = $strcpy($s(2), "00"); /*18987*/
				$puti(_31, 2 - _2z.length, _2z); /*18987*/
				$k[$j++] = _31; /*18988*/
				$k[$j++] = _2x + 130; /*18988*/
			} /*18988*/
			var _39 = $a([$1.lC, $1.lB, $1.fnc1, $1.fnc2, $1.fnc3, $1.fnc4, $1.fnc1lD]); /*18990*/
			$k[$j++] = 229; /*18990*/
			for (var _3A = 0, _3B = _39.length; _3A < _3B; _3A++) { /*18990*/
				var _3E = $k[--$j] + 1; /*18990*/
				$k[$j++] = $get(_39, _3A); /*18990*/
				$k[$j++] = _3E; /*18990*/
				$k[$j++] = _3E; /*18990*/
			} /*18990*/
			$j--; /*18990*/
			$k[$j++] = $1.lX; /*18992*/
			$k[$j++] = 238; /*18992*/
			$k[$j++] = $1.lT; /*18992*/
			$k[$j++] = 239; /*18992*/
			var _3H = $d(); /*18992*/
			$1[$k[--$j]] = _3H; /*18994*/
			$k[$j++] = "Avals"; /*18996*/
			$k[$j++] = Infinity; /*18996*/
			$forall($1.Avals, function() { /*18996*/
				$k[$j++] = Infinity; /*18996*/
				var _3K = $k[--$j]; /*18996*/
				var _3L = $k[--$j]; /*18996*/
				$k[$j++] = _3K; /*18996*/
				$k[$j++] = _3L; /*18996*/
				var _3M = $a(); /*18996*/
				$k[$j++] = _3M; /*18996*/
			}); /*18996*/
			var _3N = $d(); /*18996*/
			$1[$k[--$j]] = _3N; /*18997*/
			$k[$j++] = "CNvals"; /*19005*/
			$k[$j++] = Infinity; /*19005*/
			$k[$j++] = $1.sft1; /*19004*/
			$k[$j++] = 0; /*19004*/
			$k[$j++] = $1.sft2; /*19004*/
			$k[$j++] = 1; /*19004*/
			$k[$j++] = $1.sft3; /*19004*/
			$k[$j++] = 2; /*19004*/
			$k[$j++] = 32; /*19004*/
			$k[$j++] = 3; /*19004*/
			for (var _3S = 48; _3S <= 57; _3S += 1) { /*19004*/
				$k[$j++] = _3S; /*19004*/
				$k[$j++] = _3S - 44; /*19004*/
			} /*19004*/
			for (var _3T = 65; _3T <= 90; _3T += 1) { /*19005*/
				$k[$j++] = _3T; /*19005*/
				$k[$j++] = _3T - 51; /*19005*/
			} /*19005*/
			var _3U = $d(); /*19005*/
			$1[$k[--$j]] = _3U; /*19006*/
			$k[$j++] = "C1vals"; /*19007*/
			$k[$j++] = Infinity; /*19007*/
			for (var _3W = 0; _3W <= 31; _3W += 1) { /*19007*/
				$k[$j++] = _3W; /*19007*/
				$k[$j++] = _3W; /*19007*/
			} /*19007*/
			var _3X = $d(); /*19007*/
			$1[$k[--$j]] = _3X; /*19007*/
			$k[$j++] = "C2vals"; /*19016*/
			$k[$j++] = Infinity; /*19016*/
			for (var _3Z = 33; _3Z <= 47; _3Z += 1) { /*19009*/
				$k[$j++] = _3Z; /*19009*/
				$k[$j++] = _3Z - 33; /*19009*/
			} /*19009*/
			for (var _3a = 58; _3a <= 64; _3a += 1) { /*19010*/
				$k[$j++] = _3a; /*19010*/
				$k[$j++] = _3a - 43; /*19010*/
			} /*19010*/
			for (var _3b = 91; _3b <= 95; _3b += 1) { /*19011*/
				$k[$j++] = _3b; /*19011*/
				$k[$j++] = _3b - 69; /*19011*/
			} /*19011*/
			$k[$j++] = $1.fnc1; /*19016*/
			$k[$j++] = 27; /*19016*/
			$k[$j++] = $1.fnc2; /*19016*/
			$k[$j++] = 28; /*19016*/
			$k[$j++] = $1.fnc3; /*19016*/
			$k[$j++] = 29; /*19016*/
			$k[$j++] = $1.fnc4; /*19016*/
			$k[$j++] = 30; /*19016*/
			$k[$j++] = $1.pad; /*19016*/
			$k[$j++] = 31; /*19016*/
			var _3h = $d(); /*19016*/
			$1[$k[--$j]] = _3h; /*19017*/
			$k[$j++] = "C3vals"; /*19018*/
			$k[$j++] = Infinity; /*19018*/
			for (var _3j = 96; _3j <= 127; _3j += 1) { /*19018*/
				$k[$j++] = _3j; /*19018*/
				$k[$j++] = _3j - 96; /*19018*/
			} /*19018*/
			var _3k = $d(); /*19018*/
			$1[$k[--$j]] = _3k; /*19018*/
			$k[$j++] = "Cvals"; /*19023*/
			$k[$j++] = Infinity; /*19023*/
			$forall($1.CNvals, function() { /*19020*/
				$k[$j++] = Infinity; /*19020*/
				var _3n = $k[--$j]; /*19020*/
				var _3o = $k[--$j]; /*19020*/
				$k[$j++] = _3n; /*19020*/
				$k[$j++] = _3o; /*19020*/
				var _3p = $a(); /*19020*/
				$k[$j++] = _3p; /*19020*/
			}); /*19020*/
			$forall($1.C1vals, function() { /*19021*/
				$k[$j++] = Infinity; /*19021*/
				var _3r = $k[--$j]; /*19021*/
				var _3s = $k[--$j]; /*19021*/
				$k[$j++] = _3r; /*19021*/
				$k[$j++] = $get($1.CNvals, $1.sft1); /*19021*/
				$k[$j++] = _3s; /*19021*/
				var _3w = $a(); /*19021*/
				$k[$j++] = _3w; /*19021*/
			}); /*19021*/
			$forall($1.C2vals, function() { /*19022*/
				$k[$j++] = Infinity; /*19022*/
				var _3y = $k[--$j]; /*19022*/
				var _3z = $k[--$j]; /*19022*/
				$k[$j++] = _3y; /*19022*/
				$k[$j++] = $get($1.CNvals, $1.sft2); /*19022*/
				$k[$j++] = _3z; /*19022*/
				var _43 = $a(); /*19022*/
				$k[$j++] = _43; /*19022*/
			}); /*19022*/
			$forall($1.C3vals, function() { /*19023*/
				$k[$j++] = Infinity; /*19023*/
				var _45 = $k[--$j]; /*19023*/
				var _46 = $k[--$j]; /*19023*/
				$k[$j++] = _45; /*19023*/
				$k[$j++] = $get($1.CNvals, $1.sft3); /*19023*/
				$k[$j++] = _46; /*19023*/
				var _4A = $a(); /*19023*/
				$k[$j++] = _4A; /*19023*/
			}); /*19023*/
			var _4B = $d(); /*19023*/
			$1[$k[--$j]] = _4B; /*19024*/
			$k[$j++] = "TNvals"; /*19032*/
			$k[$j++] = Infinity; /*19032*/
			$k[$j++] = $1.sft1; /*19031*/
			$k[$j++] = 0; /*19031*/
			$k[$j++] = $1.sft2; /*19031*/
			$k[$j++] = 1; /*19031*/
			$k[$j++] = $1.sft3; /*19031*/
			$k[$j++] = 2; /*19031*/
			$k[$j++] = 32; /*19031*/
			$k[$j++] = 3; /*19031*/
			for (var _4G = 48; _4G <= 57; _4G += 1) { /*19031*/
				$k[$j++] = _4G; /*19031*/
				$k[$j++] = _4G - 44; /*19031*/
			} /*19031*/
			for (var _4H = 97; _4H <= 122; _4H += 1) { /*19032*/
				$k[$j++] = _4H; /*19032*/
				$k[$j++] = _4H - 83; /*19032*/
			} /*19032*/
			var _4I = $d(); /*19032*/
			$1[$k[--$j]] = _4I; /*19033*/
			$k[$j++] = "T1vals"; /*19034*/
			$k[$j++] = Infinity; /*19034*/
			for (var _4K = 0; _4K <= 31; _4K += 1) { /*19034*/
				$k[$j++] = _4K; /*19034*/
				$k[$j++] = _4K; /*19034*/
			} /*19034*/
			var _4L = $d(); /*19034*/
			$1[$k[--$j]] = _4L; /*19034*/
			$k[$j++] = "T2vals"; /*19043*/
			$k[$j++] = Infinity; /*19043*/
			for (var _4N = 33; _4N <= 47; _4N += 1) { /*19036*/
				$k[$j++] = _4N; /*19036*/
				$k[$j++] = _4N - 33; /*19036*/
			} /*19036*/
			for (var _4O = 58; _4O <= 64; _4O += 1) { /*19037*/
				$k[$j++] = _4O; /*19037*/
				$k[$j++] = _4O - 43; /*19037*/
			} /*19037*/
			for (var _4P = 91; _4P <= 95; _4P += 1) { /*19038*/
				$k[$j++] = _4P; /*19038*/
				$k[$j++] = _4P - 69; /*19038*/
			} /*19038*/
			$k[$j++] = $1.fnc1; /*19043*/
			$k[$j++] = 27; /*19043*/
			$k[$j++] = $1.fnc2; /*19043*/
			$k[$j++] = 28; /*19043*/
			$k[$j++] = $1.fnc3; /*19043*/
			$k[$j++] = 29; /*19043*/
			$k[$j++] = $1.fnc4; /*19043*/
			$k[$j++] = 30; /*19043*/
			$k[$j++] = $1.pad; /*19043*/
			$k[$j++] = 31; /*19043*/
			var _4V = $d(); /*19043*/
			$1[$k[--$j]] = _4V; /*19044*/
			$k[$j++] = "T3vals"; /*19048*/
			$k[$j++] = Infinity; /*19048*/
			$k[$j++] = 96; /*19047*/
			$k[$j++] = 0; /*19047*/
			for (var _4X = 65; _4X <= 90; _4X += 1) { /*19047*/
				$k[$j++] = _4X; /*19047*/
				$k[$j++] = _4X - 64; /*19047*/
			} /*19047*/
			for (var _4Y = 123; _4Y <= 127; _4Y += 1) { /*19048*/
				$k[$j++] = _4Y; /*19048*/
				$k[$j++] = _4Y - 96; /*19048*/
			} /*19048*/
			var _4Z = $d(); /*19048*/
			$1[$k[--$j]] = _4Z; /*19049*/
			$k[$j++] = "Tvals"; /*19054*/
			$k[$j++] = Infinity; /*19054*/
			$forall($1.TNvals, function() { /*19051*/
				$k[$j++] = Infinity; /*19051*/
				var _4c = $k[--$j]; /*19051*/
				var _4d = $k[--$j]; /*19051*/
				$k[$j++] = _4c; /*19051*/
				$k[$j++] = _4d; /*19051*/
				var _4e = $a(); /*19051*/
				$k[$j++] = _4e; /*19051*/
			}); /*19051*/
			$forall($1.T1vals, function() { /*19052*/
				$k[$j++] = Infinity; /*19052*/
				var _4g = $k[--$j]; /*19052*/
				var _4h = $k[--$j]; /*19052*/
				$k[$j++] = _4g; /*19052*/
				$k[$j++] = $get($1.TNvals, $1.sft1); /*19052*/
				$k[$j++] = _4h; /*19052*/
				var _4l = $a(); /*19052*/
				$k[$j++] = _4l; /*19052*/
			}); /*19052*/
			$forall($1.T2vals, function() { /*19053*/
				$k[$j++] = Infinity; /*19053*/
				var _4n = $k[--$j]; /*19053*/
				var _4o = $k[--$j]; /*19053*/
				$k[$j++] = _4n; /*19053*/
				$k[$j++] = $get($1.TNvals, $1.sft2); /*19053*/
				$k[$j++] = _4o; /*19053*/
				var _4s = $a(); /*19053*/
				$k[$j++] = _4s; /*19053*/
			}); /*19053*/
			$forall($1.T3vals, function() { /*19054*/
				$k[$j++] = Infinity; /*19054*/
				var _4u = $k[--$j]; /*19054*/
				var _4v = $k[--$j]; /*19054*/
				$k[$j++] = _4u; /*19054*/
				$k[$j++] = $get($1.TNvals, $1.sft3); /*19054*/
				$k[$j++] = _4v; /*19054*/
				var _4z = $a(); /*19054*/
				$k[$j++] = _4z; /*19054*/
			}); /*19054*/
			var _50 = $d(); /*19054*/
			$1[$k[--$j]] = _50; /*19055*/
			for (var _52 = 128; _52 <= 255; _52 += 1) { /*19063*/
				$1.i = _52; /*19059*/
				$k[$j++] = $1.Avals; /*19060*/
				$k[$j++] = $1.i; /*19060*/
				$k[$j++] = Infinity; /*19060*/
				$aload($get($1.Avals, $1.fnc4)); /*19060*/
				$aload($get($1.Avals, $1.i - 128)); /*19060*/
				var _5B = $a(); /*19060*/
				var _5C = $k[--$j]; /*19060*/
				$put($k[--$j], _5C, _5B); /*19060*/
				$k[$j++] = $1.Cvals; /*19061*/
				$k[$j++] = $1.i; /*19061*/
				$k[$j++] = Infinity; /*19061*/
				$aload($get($1.Cvals, $1.fnc4)); /*19061*/
				$aload($get($1.Cvals, $1.i - 128)); /*19061*/
				var _5M = $a(); /*19061*/
				var _5N = $k[--$j]; /*19061*/
				$put($k[--$j], _5N, _5M); /*19061*/
				$k[$j++] = $1.Tvals; /*19062*/
				$k[$j++] = $1.i; /*19062*/
				$k[$j++] = Infinity; /*19062*/
				$aload($get($1.Tvals, $1.fnc4)); /*19062*/
				$aload($get($1.Tvals, $1.i - 128)); /*19062*/
				var _5X = $a(); /*19062*/
				var _5Y = $k[--$j]; /*19062*/
				$put($k[--$j], _5Y, _5X); /*19062*/
			} /*19062*/
			$k[$j++] = "Xvals"; /*19071*/
			$k[$j++] = Infinity; /*19071*/
			$k[$j++] = 13; /*19070*/
			$k[$j++] = 0; /*19070*/
			$k[$j++] = 42; /*19070*/
			$k[$j++] = 1; /*19070*/
			$k[$j++] = 62; /*19070*/
			$k[$j++] = 2; /*19070*/
			$k[$j++] = 32; /*19070*/
			$k[$j++] = 3; /*19070*/
			for (var _5a = 48; _5a <= 57; _5a += 1) { /*19070*/
				$k[$j++] = _5a; /*19070*/
				$k[$j++] = _5a - 44; /*19070*/
			} /*19070*/
			for (var _5b = 65; _5b <= 90; _5b += 1) { /*19071*/
				$k[$j++] = _5b; /*19071*/
				$k[$j++] = _5b - 51; /*19071*/
			} /*19071*/
			var _5c = $d(); /*19071*/
			$1[$k[--$j]] = _5c; /*19072*/
			$k[$j++] = "Xvals"; /*19074*/
			$k[$j++] = Infinity; /*19074*/
			$forall($1.Xvals, function() { /*19074*/
				$k[$j++] = Infinity; /*19074*/
				var _5f = $k[--$j]; /*19074*/
				var _5g = $k[--$j]; /*19074*/
				$k[$j++] = _5f; /*19074*/
				$k[$j++] = _5g; /*19074*/
				var _5h = $a(); /*19074*/
				$k[$j++] = _5h; /*19074*/
			}); /*19074*/
			var _5i = $d(); /*19074*/
			$1[$k[--$j]] = _5i; /*19075*/
			$k[$j++] = "Bvals"; /*19078*/
			$k[$j++] = Infinity; /*19078*/
			for (var _5k = 0; _5k <= 255; _5k += 1) { /*19078*/
				$k[$j++] = _5k; /*19078*/
				$k[$j++] = _5k; /*19078*/
			} /*19078*/
			var _5l = $d(); /*19078*/
			$1[$k[--$j]] = _5l; /*19079*/
			$k[$j++] = "Bvals"; /*19081*/
			$k[$j++] = Infinity; /*19081*/
			$forall($1.Bvals, function() { /*19081*/
				$k[$j++] = Infinity; /*19081*/
				var _5o = $k[--$j]; /*19081*/
				var _5p = $k[--$j]; /*19081*/
				$k[$j++] = _5o; /*19081*/
				$k[$j++] = _5p; /*19081*/
				var _5q = $a(); /*19081*/
				$k[$j++] = _5q; /*19081*/
			}); /*19081*/
			var _5r = $d(); /*19081*/
			$1[$k[--$j]] = _5r; /*19082*/
			$1.encvals = $a([$1.Avals, $1.Cvals, $1.Tvals, $1.Xvals, -1, $1.Bvals]); /*19084*/
			$k[$j++] = Infinity; /*19086*/
			for (var _60 = 0, _61 = $1.msglen; _60 < _61; _60++) { /*19086*/
				$k[$j++] = 0; /*19086*/
			} /*19086*/
			$k[$j++] = 0; /*19086*/
			$1.numD = $a(); /*19086*/
			$k[$j++] = Infinity; /*19087*/
			for (var _64 = 0, _65 = $1.msglen; _64 < _65; _64++) { /*19087*/
				$k[$j++] = 0; /*19087*/
			} /*19087*/
			$k[$j++] = 9999; /*19087*/
			$1.nextXterm = $a(); /*19087*/
			$k[$j++] = Infinity; /*19088*/
			for (var _68 = 0, _69 = $1.msglen; _68 < _69; _68++) { /*19088*/
				$k[$j++] = 0; /*19088*/
			} /*19088*/
			$k[$j++] = 9999; /*19088*/
			$1.nextNonX = $a(); /*19088*/
			for (var _6C = $1.msglen - 1; _6C >= 0; _6C -= 1) { /*19105*/
				$1.i = _6C; /*19090*/
				$1.barchar = $get($1.msg, $1.i); /*19091*/
				if (($1.barchar >= 48) && ($1.barchar <= 57)) { /*19094*/
					$put($1.numD, $1.i, $get($1.numD, $1.i + 1) + 1); /*19093*/
				} /*19093*/
				if ((($1.barchar == 13) || ($1.barchar == 42)) || ($1.barchar == 62)) { /*19098*/
					$put($1.nextXterm, $1.i, 0); /*19096*/
				} else { /*19098*/
					$put($1.nextXterm, $1.i, $get($1.nextXterm, $1.i + 1) + 1); /*19098*/
				} /*19098*/
				var _6Z = $get($1.Xvals, $1.barchar) !== undefined; /*19100*/
				if (!_6Z) { /*19103*/
					$put($1.nextNonX, $1.i, 0); /*19101*/
				} else { /*19103*/
					$put($1.nextNonX, $1.i, $get($1.nextNonX, $1.i + 1) + 1); /*19103*/
				} /*19103*/
			} /*19103*/
			$k[$j++] = Infinity; /*19106*/
			var _6h = $1.nextXterm; /*19106*/
			for (var _6i = 0, _6j = _6h.length; _6i < _6j; _6i++) { /*19106*/
				var _6k = $get(_6h, _6i); /*19106*/
				$k[$j++] = _6k; /*19106*/
				if (_6k > 10000) { /*19106*/
					$j--; /*19106*/
					$k[$j++] = 10000; /*19106*/
				} /*19106*/
			} /*19106*/
			$1.nextXterm = $a(); /*19106*/
			$k[$j++] = Infinity; /*19107*/
			var _6m = $1.nextNonX; /*19107*/
			for (var _6n = 0, _6o = _6m.length; _6n < _6o; _6n++) { /*19107*/
				var _6p = $get(_6m, _6n); /*19107*/
				$k[$j++] = _6p; /*19107*/
				if (_6p > 10000) { /*19107*/
					$j--; /*19107*/
					$k[$j++] = 10000; /*19107*/
				} /*19107*/
			} /*19107*/
			$1.nextNonX = $a(); /*19107*/
			$1.isD = function() {
				$k[$j++] = ($1.char >= 48) && ($1.char <= 57); /*19109*/
			}; /*19109*/
			$1.isC = function() {
				var _6v = $get($1.CNvals, $1.char) !== undefined; /*19110*/
				$k[$j++] = _6v; /*19110*/
			}; /*19110*/
			$1.isT = function() {
				var _6y = $get($1.TNvals, $1.char) !== undefined; /*19111*/
				$k[$j++] = _6y; /*19111*/
			}; /*19111*/
			$1.isX = function() {
				var _71 = $get($1.Xvals, $1.char) !== undefined; /*19112*/
				$k[$j++] = _71; /*19112*/
			}; /*19112*/
			$1.isEA = function() {
				$k[$j++] = $1.char > 127; /*19113*/
			}; /*19113*/
			$1.isFN = function() {
				$k[$j++] = $1.char < 0; /*19114*/
			}; /*19114*/
			$1.XtermFirst = function() {
				var _74 = $k[--$j]; /*19115*/
				$k[$j++] = $lt($get($1.nextXterm, _74), $get($1.nextNonX, _74)); /*19115*/
			}; /*19115*/
			$1.A = 0; /*19117*/
			$1.C = 1; /*19117*/
			$1.T = 2; /*19117*/
			$1.X = 3; /*19117*/
			$1.D = 4; /*19117*/
			$1.B = 5; /*19117*/
			$1.lookup = function() {
				$1.ac = 1; /*19120*/
				$1.cc = 2; /*19120*/
				$1.tc = 2; /*19120*/
				$1.xc = 2; /*19120*/
				$1.bc = 3; /*19120*/
				if ($1.mode == $1.A) { /*19121*/
					$1.ac = 0; /*19121*/
					$1.cc = 1; /*19121*/
					$1.tc = 1; /*19121*/
					$1.xc = 1; /*19121*/
					$1.bc = 2; /*19121*/
				} /*19121*/
				if ($1.mode == $1.C) { /*19122*/
					$1.cc = 0; /*19122*/
				} /*19122*/
				if ($1.mode == $1.T) { /*19123*/
					$1.tc = 0; /*19123*/
				} /*19123*/
				if ($1.mode == $1.X) { /*19124*/
					$1.xc = 0; /*19124*/
				} /*19124*/
				if ($1.mode == $1.B) { /*19125*/
					$1.bc = 0; /*19125*/
				} /*19125*/
				for (var _7J = 0, _7K = 1; _7J < _7K; _7J++) { /*19153*/
					$1.k = 0; /*19127*/
					for (;;) { /*19152*/
						if (($1.i + $1.k) == $1.msglen) { /*19134*/
							var _7S = $a([$1.ac, $1.cc, $1.tc, $1.xc]); /*19129*/
							$k[$j++] = true; /*19129*/
							for (var _7T = 0, _7U = _7S.length; _7T < _7U; _7T++) { /*19129*/
								var _7X = $k[--$j]; /*19129*/
								$k[$j++] = _7X && ($1.bc <= Math.ceil($get(_7S, _7T))); /*19129*/
							} /*19129*/
							if ($k[--$j]) { /*19129*/
								$k[$j++] = $1.B; /*19129*/
								break; /*19129*/
							} /*19129*/
							var _7e = $a([$1.cc, $1.tc, $1.xc, $1.bc]); /*19130*/
							$k[$j++] = true; /*19130*/
							for (var _7f = 0, _7g = _7e.length; _7f < _7g; _7f++) { /*19130*/
								var _7j = $k[--$j]; /*19130*/
								$k[$j++] = _7j && ($1.ac <= Math.ceil($get(_7e, _7f))); /*19130*/
							} /*19130*/
							if ($k[--$j]) { /*19130*/
								$k[$j++] = $1.A; /*19130*/
								break; /*19130*/
							} /*19130*/
							var _7o = $a([$1.tc, $1.xc]); /*19131*/
							$k[$j++] = true; /*19131*/
							for (var _7p = 0, _7q = _7o.length; _7p < _7q; _7p++) { /*19131*/
								var _7t = $k[--$j]; /*19131*/
								$k[$j++] = _7t && (Math.ceil($1.cc) <= Math.ceil($get(_7o, _7p))); /*19131*/
							} /*19131*/
							if ($k[--$j]) { /*19131*/
								$k[$j++] = $1.C; /*19131*/
								break; /*19131*/
							} /*19131*/
							var _7x = $a([$1.xc]); /*19132*/
							$k[$j++] = true; /*19132*/
							for (var _7y = 0, _7z = _7x.length; _7y < _7z; _7y++) { /*19132*/
								var _82 = $k[--$j]; /*19132*/
								$k[$j++] = _82 && (Math.ceil($1.tc) <= Math.ceil($get(_7x, _7y))); /*19132*/
							} /*19132*/
							if ($k[--$j]) { /*19132*/
								$k[$j++] = $1.T; /*19132*/
								break; /*19132*/
							} /*19132*/
							$k[$j++] = $1.X; /*19133*/
							break; /*19133*/
						} /*19133*/
						$1.char = $get($1.msg, $1.i + $1.k); /*19135*/
						$k[$j++] = "ac"; /*19136*/
						$k[$j++] = $1.ac; /*19136*/
						if ($1.isD() == $b) break; /*19136*/
						if ($k[--$j]) { /*19136*/
							var _8C = $k[--$j]; /*19136*/
							$k[$j++] = _8C + (1 / 2); /*19136*/
						} else { /*19136*/
							if ($1.isEA() == $b) break; /*19136*/
							if ($k[--$j]) { /*19136*/
								var _8E = $k[--$j]; /*19136*/
								$k[$j++] = Math.ceil(_8E) + 2; /*19136*/
							} else { /*19136*/
								var _8F = $k[--$j]; /*19136*/
								$k[$j++] = Math.ceil(_8F) + 1; /*19136*/
							} /*19136*/
						} /*19136*/
						var _8G = $k[--$j]; /*19136*/
						$1[$k[--$j]] = _8G; /*19136*/
						$k[$j++] = "cc"; /*19137*/
						$k[$j++] = $1.cc; /*19137*/
						if ($1.isC() == $b) break; /*19137*/
						if ($k[--$j]) { /*19137*/
							var _8K = $k[--$j]; /*19137*/
							$k[$j++] = _8K + (2 / 3); /*19137*/
						} else { /*19137*/
							if ($1.isEA() == $b) break; /*19137*/
							if ($k[--$j]) { /*19137*/
								var _8M = $k[--$j]; /*19137*/
								$k[$j++] = _8M + (8 / 3); /*19137*/
							} else { /*19137*/
								var _8N = $k[--$j]; /*19137*/
								$k[$j++] = _8N + (4 / 3); /*19137*/
							} /*19137*/
						} /*19137*/
						var _8O = $k[--$j]; /*19137*/
						$1[$k[--$j]] = _8O; /*19137*/
						$k[$j++] = "tc"; /*19138*/
						$k[$j++] = $1.tc; /*19138*/
						if ($1.isT() == $b) break; /*19138*/
						if ($k[--$j]) { /*19138*/
							var _8S = $k[--$j]; /*19138*/
							$k[$j++] = _8S + (2 / 3); /*19138*/
						} else { /*19138*/
							if ($1.isEA() == $b) break; /*19138*/
							if ($k[--$j]) { /*19138*/
								var _8U = $k[--$j]; /*19138*/
								$k[$j++] = _8U + (8 / 3); /*19138*/
							} else { /*19138*/
								var _8V = $k[--$j]; /*19138*/
								$k[$j++] = _8V + (4 / 3); /*19138*/
							} /*19138*/
						} /*19138*/
						var _8W = $k[--$j]; /*19138*/
						$1[$k[--$j]] = _8W; /*19138*/
						$k[$j++] = "xc"; /*19139*/
						$k[$j++] = $1.xc; /*19139*/
						if ($1.isX() == $b) break; /*19139*/
						if ($k[--$j]) { /*19139*/
							var _8a = $k[--$j]; /*19139*/
							$k[$j++] = _8a + (2 / 3); /*19139*/
						} else { /*19139*/
							if ($1.isEA() == $b) break; /*19139*/
							if ($k[--$j]) { /*19139*/
								var _8c = $k[--$j]; /*19139*/
								$k[$j++] = _8c + (13 / 3); /*19139*/
							} else { /*19139*/
								var _8d = $k[--$j]; /*19139*/
								$k[$j++] = _8d + (10 / 3); /*19139*/
							} /*19139*/
						} /*19139*/
						var _8e = $k[--$j]; /*19139*/
						$1[$k[--$j]] = _8e; /*19139*/
						$k[$j++] = "bc"; /*19140*/
						$k[$j++] = $1.bc; /*19140*/
						if ($1.isFN() == $b) break; /*19140*/
						if ($k[--$j]) { /*19140*/
							var _8i = $k[--$j]; /*19140*/
							$k[$j++] = _8i + 3; /*19140*/
						} else { /*19140*/
							var _8j = $k[--$j]; /*19140*/
							$k[$j++] = _8j + 1; /*19140*/
						} /*19140*/
						var _8k = $k[--$j]; /*19140*/
						$1[$k[--$j]] = _8k; /*19140*/
						if ($1.k >= 3) { /*19150*/
							var _8r = $a([$1.ac, $1.cc, $1.tc, $1.xc]); /*19142*/
							$k[$j++] = true; /*19142*/
							for (var _8s = 0, _8t = _8r.length; _8s < _8t; _8s++) { /*19142*/
								var _8w = $k[--$j]; /*19142*/
								$k[$j++] = _8w && (($1.bc + 1) <= Math.ceil($get(_8r, _8s))); /*19142*/
							} /*19142*/
							if ($k[--$j]) { /*19142*/
								$k[$j++] = $1.B; /*19142*/
								break; /*19142*/
							} /*19142*/
							var _93 = $a([$1.cc, $1.tc, $1.xc, $1.bc]); /*19143*/
							$k[$j++] = true; /*19143*/
							for (var _94 = 0, _95 = _93.length; _94 < _95; _94++) { /*19143*/
								var _98 = $k[--$j]; /*19143*/
								$k[$j++] = _98 && (($1.ac + 1) <= Math.ceil($get(_93, _94))); /*19143*/
							} /*19143*/
							if ($k[--$j]) { /*19143*/
								$k[$j++] = $1.A; /*19143*/
								break; /*19143*/
							} /*19143*/
							var _9F = $a([$1.ac, $1.cc, $1.xc, $1.bc]); /*19144*/
							$k[$j++] = true; /*19144*/
							for (var _9G = 0, _9H = _9F.length; _9G < _9H; _9G++) { /*19144*/
								var _9K = $k[--$j]; /*19144*/
								$k[$j++] = _9K && (($1.tc + 1) <= Math.ceil($get(_9F, _9G))); /*19144*/
							} /*19144*/
							if ($k[--$j]) { /*19144*/
								$k[$j++] = $1.T; /*19144*/
								break; /*19144*/
							} /*19144*/
							var _9P = $a([$1.ac, $1.tc]); /*19145*/
							$k[$j++] = true; /*19145*/
							for (var _9Q = 0, _9R = _9P.length; _9Q < _9R; _9Q++) { /*19145*/
								var _9U = $k[--$j]; /*19145*/
								$k[$j++] = _9U && (($1.cc + 1) <= Math.ceil($get(_9P, _9Q))); /*19145*/
							} /*19145*/
							if ($k[--$j]) { /*19148*/
								if (Math.ceil($1.cc) < Math.ceil($1.xc)) { /*19146*/
									$k[$j++] = $1.C; /*19146*/
									break; /*19146*/
								} /*19146*/
								if ($1.cc == $1.xc) { /*19147*/
									$k[$j++] = ($1.i + $1.k) + 1; /*19147*/
									if ($1.XtermFirst() == $b) break; /*19147*/
									if ($k[--$j]) { /*19147*/
										$k[$j++] = $1.X; /*19147*/
										break; /*19147*/
									} else { /*19147*/
										$k[$j++] = $1.C; /*19147*/
										break; /*19147*/
									} /*19147*/
								} /*19147*/
							} /*19147*/
							var _9k = $a([$1.ac, $1.cc, $1.tc, $1.bc]); /*19149*/
							$k[$j++] = true; /*19149*/
							for (var _9l = 0, _9m = _9k.length; _9l < _9m; _9l++) { /*19149*/
								var _9p = $k[--$j]; /*19149*/
								$k[$j++] = _9p && (($1.xc + 1) < $get(_9k, _9l)); /*19149*/
							} /*19149*/
							if ($k[--$j]) { /*19149*/
								$k[$j++] = $1.X; /*19149*/
								break; /*19149*/
							} /*19149*/
						} /*19149*/
						$1.k = $1.k + 1; /*19151*/
					} /*19151*/
				} /*19151*/
			}; /*19154*/
			$1.addtocws = function() {
				var _9t = $k[--$j]; /*19157*/
				$puti($1.cws, $1.j, _9t); /*19157*/
				$1.j = _9t.length + $1.j; /*19158*/
			}; /*19159*/
			$1.tobin = function() {
				var _9y = $s($k[--$j]); /*19162*/
				$k[$j++] = _9y; /*19162*/
				for (var _A0 = 0, _9z = _9y.length - 1; _A0 <= _9z; _A0 += 1) { /*19162*/
					var _A1 = $k[--$j]; /*19162*/
					$put(_A1, _A0, 48); /*19162*/
					$k[$j++] = _A1; /*19162*/
				} /*19162*/
				var _A2 = $k[--$j]; /*19163*/
				var _A5 = $cvrs($s(_A2.length), $k[--$j], 2); /*19163*/
				$puti(_A2, _A2.length - _A5.length, _A5); /*19163*/
				$k[$j++] = _A2; /*19164*/
				$k[$j++] = Infinity; /*19164*/
				var _A6 = $k[--$j]; /*19164*/
				var _A7 = $k[--$j]; /*19164*/
				$k[$j++] = _A6; /*19164*/
				$forall(_A7, function() { /*19164*/
					var _A8 = $k[--$j]; /*19164*/
					$k[$j++] = _A8 - 48; /*19164*/
				}); /*19164*/
				var _A9 = $a(); /*19164*/
				$k[$j++] = _A9; /*19164*/
			}; /*19165*/
			$1.encA = function() {
				for (var _AA = 0, _AB = 1; _AA < _AB; _AA++) { /*19209*/
					if ($get($1.numD, $1.i) >= 21) { /*19173*/
						$1.Dbits = $a([1, 1, 1, 1]); /*19170*/
						$1.mode = $1.D; /*19171*/
						break; /*19172*/
					} /*19172*/
					var _AJ = $get($1.numD, $1.i); /*19174*/
					if ((_AJ >= 13) && ((_AJ + $1.i) == $1.msglen)) { /*19178*/
						$1.Dbits = $a([1, 1, 1, 1]); /*19175*/
						$1.mode = $1.D; /*19176*/
						break; /*19177*/
					} /*19177*/
					if ($get($1.numD, $1.i) >= 2) { /*19183*/
						var _AR = $s(2); /*19180*/
						$put(_AR, 0, $get($1.msg, $1.i)); /*19180*/
						$put(_AR, 1, $get($1.msg, $1.i + 1)); /*19180*/
						$k[$j++] = $get($1.Avals, _AR); /*19180*/
						if ($1.addtocws() == $b) break; /*19180*/
						$1.i = $1.i + 2; /*19181*/
						break; /*19182*/
					} /*19182*/
					if ($get($1.msg, $1.i) == $1.fnc1) { /*19199*/
						if ($get($1.numD, $1.i + 1) >= 15) { /*19191*/
							$k[$j++] = $get($1.Avals, $1.fnc1lD); /*19186*/
							if ($1.addtocws() == $b) break; /*19186*/
							$1.i = $1.i + 1; /*19187*/
							$1.Dbits = $a([]); /*19188*/
							$1.mode = $1.D; /*19189*/
							break; /*19190*/
						} /*19190*/
						var _Aq = $get($1.numD, $1.i + 1); /*19192*/
						if ((_Aq >= 7) && (((_Aq + $1.i) + 1) == $1.msglen)) { /*19198*/
							$k[$j++] = $get($1.Avals, $1.fnc1lD); /*19193*/
							if ($1.addtocws() == $b) break; /*19193*/
							$1.i = $1.i + 1; /*19194*/
							$1.Dbits = $a([]); /*19195*/
							$1.mode = $1.D; /*19196*/
							break; /*19197*/
						} /*19197*/
					} /*19197*/
					$k[$j++] = "newmode"; /*19200*/
					if ($1.lookup() == $b) break; /*19200*/
					var _Az = $k[--$j]; /*19200*/
					$1[$k[--$j]] = _Az; /*19200*/
					if ($1.newmode != $1.mode) { /*19205*/
						$k[$j++] = $get($1.Avals, $get($a([-1, $1.lC, $1.lT, $1.lX, $1.lD, $1.lB]), $1.newmode)); /*19202*/
						if ($1.addtocws() == $b) break; /*19202*/
						$1.mode = $1.newmode; /*19203*/
						break; /*19204*/
					} /*19204*/
					$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*19206*/
					if ($1.addtocws() == $b) break; /*19206*/
					$1.i = $1.i + 1; /*19207*/
					break; /*19208*/
				} /*19208*/
			}; /*19210*/
			$1.CTXvalstocws = function() {
				$1.in = $k[--$j]; /*19213*/
				$k[$j++] = Infinity; /*19214*/
				for (var _BN = 0, _BM = $1.in.length - 1; _BN <= _BM; _BN += 3) { /*19218*/
					$k[$j++] = 0; /*19216*/
					$forall($geti($1.in, _BN, 3), function() { /*19216*/
						var _BQ = $k[--$j]; /*19216*/
						var _BR = $k[--$j]; /*19216*/
						$k[$j++] = (_BR + _BQ) * 40; /*19216*/
					}); /*19216*/
					var _BT = (~~($k[--$j] / 40)) + 1; /*19217*/
					$k[$j++] = ~~(_BT / 256); /*19217*/
					$k[$j++] = _BT % 256; /*19217*/
				} /*19217*/
				$astore($a($counttomark())); /*19219*/
				var _BW = $k[--$j]; /*19219*/
				var _BX = $k[--$j]; /*19219*/
				$k[$j++] = _BW; /*19219*/
			}; /*19220*/
			$1.encCTX = function() {
				$1.p = 0; /*19223*/
				$1.ctxvals = $a(2220); /*19224*/
				for (;;) { /*19302*/
					if ($1.i == $1.msglen) { /*19228*/
						break; /*19228*/
					} /*19228*/
					var _Bh = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)) !== undefined; /*19229*/
					if (!_Bh) { /*19229*/
						break; /*19229*/
					} /*19229*/
					if (($1.p % 3) == 0) { /*19297*/
						if ($get($1.numD, $1.i) >= 12) { /*19235*/
							$k[$j++] = $a([$1.unlcw]); /*19232*/
							if ($1.addtocws() == $b) break; /*19232*/
							$1.mode = $1.A; /*19233*/
							break; /*19234*/
						} /*19234*/
						var _Br = $get($1.numD, $1.i); /*19236*/
						if ((_Br >= 8) && ((_Br + $1.i) == $1.msglen)) { /*19240*/
							$k[$j++] = $a([$1.unlcw]); /*19237*/
							if ($1.addtocws() == $b) break; /*19237*/
							$1.mode = $1.A; /*19238*/
							break; /*19239*/
						} /*19239*/
						if ($1.lookup() == $b) break; /*19241*/
						if ($k[--$j] != $1.mode) { /*19246*/
							$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*19242*/
							if ($1.CTXvalstocws() == $b) break; /*19242*/
							if ($1.addtocws() == $b) break; /*19242*/
							$k[$j++] = $a([$1.unlcw]); /*19243*/
							if ($1.addtocws() == $b) break; /*19243*/
							$1.mode = $1.A; /*19244*/
							break; /*19245*/
						} /*19245*/
						if (($1.msglen - $1.i) <= 3) { /*19296*/
							$1.remcws = $get($1.numremcws, $1.j + ((~~($1.p / 3)) * 2)); /*19248*/
							$k[$j++] = Infinity; /*19257*/
							$forall($geti($1.msg, $1.i, $1.msglen - $1.i), function() { /*19256*/
								var _CG = $k[--$j]; /*19251*/
								var _CK = $get($get($1.encvals, $1.mode), _CG) !== undefined; /*19251*/
								$k[$j++] = _CG; /*19255*/
								if (_CK) { /*19254*/
									$aload($get($get($1.encvals, $1.mode), $k[--$j])); /*19252*/
								} else { /*19254*/
									$j--; /*19254*/
									$k[$j++] = -1; /*19254*/
									$k[$j++] = -1; /*19254*/
									$k[$j++] = -1; /*19254*/
									$k[$j++] = -1; /*19254*/
								} /*19254*/
							}); /*19254*/
							$1.remvals = $a(); /*19257*/
							if (($1.remcws == 2) && ($1.remvals.length == 3)) { /*19267*/
								$k[$j++] = Infinity; /*19262*/
								$aload($geti($1.ctxvals, 0, $1.p)); /*19261*/
								$aload($1.remvals); /*19262*/
								var _CX = $a(); /*19262*/
								$k[$j++] = _CX; /*19263*/
								if ($1.CTXvalstocws() == $b) break; /*19263*/
								if ($1.addtocws() == $b) break; /*19263*/
								$1.mode = $1.A; /*19264*/
								$1.i = $1.msglen; /*19265*/
								break; /*19266*/
							} /*19266*/
							if ((($1.remcws == 2) && ($1.remvals.length == 2)) && ($1.mode != $1.X)) { /*19278*/
								$k[$j++] = Infinity; /*19273*/
								$aload($geti($1.ctxvals, 0, $1.p)); /*19271*/
								$aload($1.remvals); /*19272*/
								$aload($get($get($1.encvals, $1.mode), $1.sft1)); /*19273*/
								var _Cn = $a(); /*19273*/
								$k[$j++] = _Cn; /*19274*/
								if ($1.CTXvalstocws() == $b) break; /*19274*/
								if ($1.addtocws() == $b) break; /*19274*/
								$1.mode = $1.A; /*19275*/
								$1.i = $1.msglen; /*19276*/
								break; /*19277*/
							} /*19277*/
							if (($1.remcws == 2) && ($1.remvals.length == 1)) { /*19287*/
								$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*19281*/
								if ($1.CTXvalstocws() == $b) break; /*19281*/
								if ($1.addtocws() == $b) break; /*19281*/
								$k[$j++] = $a([$1.unlcw]); /*19282*/
								if ($1.addtocws() == $b) break; /*19282*/
								$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*19283*/
								if ($1.addtocws() == $b) break; /*19283*/
								$1.mode = $1.A; /*19284*/
								$1.i = $1.msglen; /*19285*/
								break; /*19286*/
							} /*19286*/
							if (($1.remcws == 1) && ($1.remvals.length == 1)) { /*19295*/
								$k[$j++] = $geti($1.ctxvals, 0, $1.p); /*19290*/
								if ($1.CTXvalstocws() == $b) break; /*19290*/
								if ($1.addtocws() == $b) break; /*19290*/
								$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*19291*/
								if ($1.addtocws() == $b) break; /*19291*/
								$1.mode = $1.A; /*19292*/
								$1.i = $1.msglen; /*19293*/
								break; /*19294*/
							} /*19294*/
						} /*19294*/
					} /*19294*/
					var _DM = $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)); /*19298*/
					$puti($1.ctxvals, $1.p, _DM); /*19299*/
					$1.p = _DM.length + $1.p; /*19300*/
					$1.i = $1.i + 1; /*19301*/
				} /*19301*/
				if ($1.mode != $1.A) { /*19326*/
					for (;;) { /*19310*/
						if (($1.p % 3) == 0) { /*19307*/
							break; /*19307*/
						} /*19307*/
						$1.i = $1.i - 1; /*19308*/
						$1.p = $1.p - $get($get($1.encvals, $1.mode), $get($1.msg, $1.i)).length; /*19309*/
					} /*19309*/
					$k[$j++] = Infinity; /*19312*/
					$aload($geti($1.ctxvals, 0, $1.p)); /*19312*/
					var _Dg = $a(); /*19312*/
					$k[$j++] = _Dg; /*19313*/
					if ($1.CTXvalstocws() == $b) return $b; /*19313*/
					if ($1.addtocws() == $b) return $b; /*19313*/
					$k[$j++] = $a([$1.unlcw]); /*19314*/
					if ($1.addtocws() == $b) return $b; /*19314*/
					$1.mode = $1.A; /*19315*/
					if ($1.i != $1.msglen) { /*19325*/
						if ($get($1.numD, $1.i) >= 2) { /*19323*/
							var _Dp = $s(2); /*19319*/
							$put(_Dp, 0, $get($1.msg, $1.i)); /*19319*/
							$put(_Dp, 1, $get($1.msg, $1.i + 1)); /*19319*/
							$k[$j++] = $get($1.Avals, _Dp); /*19319*/
							if ($1.addtocws() == $b) return $b; /*19319*/
							$1.i = $1.i + 2; /*19320*/
						} else { /*19323*/
							$k[$j++] = $get($1.Avals, $get($1.msg, $1.i)); /*19322*/
							if ($1.addtocws() == $b) return $b; /*19322*/
							$1.i = $1.i + 1; /*19323*/
						} /*19323*/
					} /*19323*/
				} /*19323*/
			}; /*19328*/
			$1.encD = function() {
				for (;;) { /*19381*/
					if ($get($1.numD, $1.i) < 3) { /*19371*/
						$1.Drem = (8 - ($1.Dbits.length % 8)) % 8; /*19336*/
						$1.remcws = $get($1.numremcws, $1.j + (~~($1.Dbits.length / 8))); /*19337*/
						if ((($get($1.numremcws, ($1.j + (~~($1.Dbits.length / 8))) - 1) - 1) == 0) && ($1.i == $1.msglen)) { /*19341*/
							break; /*19341*/
						} /*19341*/
						if (((($1.i == ($1.msglen - 1)) && ($get($1.numD, $1.i) == 1)) && ($1.remcws == 1)) && ($1.Drem == 0)) { /*19345*/
							break; /*19345*/
						} /*19345*/
						if (!(((($1.i == ($1.msglen - 1)) && ($get($1.numD, $1.i) == 1)) && ($1.remcws == 1)) && (($1.Drem == 4) || ($1.Drem == 6)))) { /*19352*/
							$k[$j++] = Infinity; /*19350*/
							$aload($1.Dbits); /*19350*/
							$k[$j++] = 1; /*19350*/
							$k[$j++] = 1; /*19350*/
							$k[$j++] = 1; /*19350*/
							$k[$j++] = 1; /*19350*/
							$k[$j++] = 1; /*19350*/
							$k[$j++] = 1; /*19350*/
							$1.Dbits = $a(); /*19350*/
							$1.Drem = (8 - ($1.Dbits.length % 8)) % 8; /*19351*/
						} /*19351*/
						if (($1.Drem == 4) || ($1.Drem == 6)) { /*19363*/
							if ($get($1.numD, $1.i) >= 1) { /*19360*/
								$k[$j++] = Infinity; /*19357*/
								$aload($1.Dbits); /*19357*/
								$k[$j++] = ($get($1.msg, $1.i) - 48) + 1; /*19357*/
								$k[$j++] = 4; /*19357*/
								if ($1.tobin() == $b) break; /*19357*/
								$aload($k[--$j]); /*19357*/
								$1.Dbits = $a(); /*19357*/
								$1.i = $1.i + 1; /*19358*/
							} else { /*19360*/
								$k[$j++] = Infinity; /*19360*/
								$aload($1.Dbits); /*19360*/
								$k[$j++] = 1; /*19360*/
								$k[$j++] = 1; /*19360*/
								$k[$j++] = 1; /*19360*/
								$k[$j++] = 1; /*19360*/
								$1.Dbits = $a(); /*19360*/
							} /*19360*/
							$1.Drem = $1.Drem - 4; /*19362*/
						} /*19362*/
						if ($1.Drem == 2) { /*19367*/
							$k[$j++] = Infinity; /*19365*/
							$aload($1.Dbits); /*19365*/
							$k[$j++] = 0; /*19365*/
							$k[$j++] = 1; /*19365*/
							$1.Dbits = $a(); /*19365*/
							$1.Drem = 0; /*19366*/
						} /*19366*/
						break; /*19369*/
					} /*19369*/
					$k[$j++] = Infinity; /*19378*/
					$aload($1.Dbits); /*19375*/
					$k[$j++] = 0; /*19376*/
					$forall($geti($1.msg, $1.i, 3), function() { /*19376*/
						var _Ex = $k[--$j]; /*19376*/
						var _Ey = $k[--$j]; /*19376*/
						$k[$j++] = (_Ey + (_Ex - 48)) * 10; /*19376*/
					}); /*19376*/
					var _Ez = $k[--$j]; /*19376*/
					$k[$j++] = (~~(_Ez / 10)) + 1; /*19377*/
					$k[$j++] = 10; /*19377*/
					if ($1.tobin() == $b) break; /*19377*/
					$aload($k[--$j]); /*19377*/
					$1.Dbits = $a(); /*19378*/
					$1.i = $1.i + 3; /*19379*/
				} /*19379*/
				$k[$j++] = Infinity; /*19383*/
				for (var _F5 = 0, _F4 = $1.Dbits.length - 1; _F5 <= _F4; _F5 += 8) { /*19386*/
					$k[$j++] = 0; /*19385*/
					$forall($geti($1.Dbits, _F5, 8), function() { /*19385*/
						var _F8 = $k[--$j]; /*19385*/
						var _F9 = $k[--$j]; /*19385*/
						$k[$j++] = (_F9 + _F8) * 2; /*19385*/
					}); /*19385*/
					var _FA = $k[--$j]; /*19385*/
					$k[$j++] = ~~(_FA / 2); /*19385*/
				} /*19385*/
				$astore($a($counttomark())); /*19387*/
				var _FD = $k[--$j]; /*19387*/
				var _FE = $k[--$j]; /*19387*/
				$k[$j++] = _FD; /*19387*/
				if ($1.addtocws() == $b) return $b; /*19387*/
				$1.mode = $1.A; /*19388*/
			}; /*19390*/
			$1.encB = function() {
				$1.p = 0; /*19393*/
				$1.bvals = $a(1480); /*19393*/
				for (;;) { /*19400*/
					if ($1.i == $1.msglen) { /*19394*/
						break; /*19394*/
					} /*19394*/
					if ($get($1.msg, $1.i) < 0) { /*19395*/
						break; /*19395*/
					} /*19395*/
					if ($1.lookup() == $b) break; /*19396*/
					if ($k[--$j] != $1.mode) { /*19396*/
						break; /*19396*/
					} /*19396*/
					$put($1.bvals, $1.p, $get($1.msg, $1.i)); /*19397*/
					$1.p = $1.p + 1; /*19398*/
					$1.i = $1.i + 1; /*19399*/
				} /*19399*/
				$1.remcws = $get($1.numremcws, $1.j + $1.p) - 1; /*19401*/
				$k[$j++] = Infinity; /*19409*/
				if (($1.remcws == 0) && ($1.i == $1.msglen)) { /*19406*/
					$k[$j++] = 0; /*19404*/
				} else { /*19406*/
					if ($1.p < 250) { /*19406*/
						$k[$j++] = $1.p; /*19406*/
					} else { /*19406*/
						$k[$j++] = (~~($1.p / 250)) + 249; /*19406*/
						$k[$j++] = $1.p % 250; /*19406*/
					} /*19406*/
				} /*19406*/
				$aload($geti($1.bvals, 0, $1.p)); /*19408*/
				$1.bvals = $a(); /*19409*/
				$k[$j++] = $1.bvals; /*19410*/
				if ($1.addtocws() == $b) return $b; /*19410*/
				$1.mode = $1.A; /*19411*/
			}; /*19412*/
			$1.cws = $a(1480); /*19415*/
			$1.mode = $1.A; /*19416*/
			$1.i = 0; /*19416*/
			$1.j = 0; /*19416*/
			for (;;) { /*19419*/
				if ($1.i >= $1.msglen) { /*19417*/
					break; /*19417*/
				} /*19417*/
				$1[$get($a(["encA", "encCTX", "encCTX", "encCTX", "encD", "encB"]), $1.mode)](); /*19418*/
			} /*19418*/
			$1.cws = $geti($1.cws, 0, $1.j); /*19420*/
		} /*19420*/
		$1.i = 0; /*19425*/
		for (;;) { /*19445*/
			$1.m = $get($1.metrics, $1.i); /*19427*/
			$1.vers = $get($1.m, 0); /*19428*/
			$1.rows = $get($1.m, 1); /*19429*/
			$1.cols = $get($1.m, 2); /*19430*/
			$1.dcol = $get($1.m, 3); /*19431*/
			$1.dcws = $get($1.m, 4); /*19432*/
			$1.rscw = $get($1.m, 5); /*19433*/
			$1.rsbl = $get($1.m, 6); /*19434*/
			$1.riso = $get($1.m, 7); /*19435*/
			$1.risi = $get($1.m, 8); /*19436*/
			$1.risl = $get($1.m, 9); /*19437*/
			$1.dcpb = ~~($1.dcws / $1.rsbl); /*19438*/
			$1.ecpb = ~~($1.rscw / $1.rsbl); /*19439*/
			$1.okay = true; /*19440*/
			if ($ne($1.version, "unset") && $ne($1.version, $1.vers)) { /*19441*/
				$1.okay = false; /*19441*/
			} /*19441*/
			if ($1.cws.length > $1.dcws) { /*19442*/
				$1.okay = false; /*19442*/
			} /*19442*/
			if ($1.okay) { /*19443*/
				break; /*19443*/
			} /*19443*/
			$1.i = $1.i + 1; /*19444*/
		} /*19444*/
		if (!$1.stype) { /*19451*/
			$k[$j++] = Infinity; /*19449*/
			$aload($1.cws); /*19449*/
			for (var _GZ = 0, _Ga = $1.dcws - $1.cws.length; _GZ < _Ga; _GZ++) { /*19449*/
				$k[$j++] = 129; /*19449*/
			} /*19449*/
			$1.cws = $a(); /*19449*/
		} else { /*19451*/
			$k[$j++] = Infinity; /*19451*/
			for (var _Ge = 0, _Gf = $1.dcws - $1.cws.length; _Ge < _Gf; _Ge++) { /*19451*/
				$k[$j++] = 0; /*19451*/
			} /*19451*/
			$aload($1.cws); /*19451*/
			$1.cws = $a(); /*19451*/
		} /*19451*/
		$1.cwbs = $a($1.rsbl); /*19455*/
		$1.ecbs = $a($1.rsbl); /*19456*/
		for (var _Go = 0, _Gn = $1.rsbl - 1; _Go <= _Gn; _Go += 1) { /*19465*/
			$1.i = _Go; /*19458*/
			$1.cwb = $a($1.dcpb); /*19459*/
			for (var _Gt = 0, _Gs = $1.dcpb - 1; _Gt <= _Gs; _Gt += 1) { /*19463*/
				$1.j = _Gt; /*19461*/
				$put($1.cwb, $1.j, $get($1.cws, ($1.j * $1.rsbl) + $1.i)); /*19462*/
			} /*19462*/
			$put($1.cwbs, $1.i, $1.cwb); /*19464*/
		} /*19464*/
		var _H5 = $1.stype ? 32 : 256; /*19468*/
		$1.gf = _H5; /*19468*/
		$1["gf-1"] = $1.gf - 1; /*19469*/
		var _H8 = $1.stype ? 37 : 301; /*19470*/
		$1.pm = _H8; /*19470*/
		$k[$j++] = Infinity; /*19471*/
		$k[$j++] = 1; /*19471*/
		for (var _HA = 0, _HB = $1["gf-1"]; _HA < _HB; _HA++) { /*19471*/
			var _HC = $k[--$j]; /*19471*/
			var _HD = _HC * 2; /*19471*/
			$k[$j++] = _HC; /*19471*/
			$k[$j++] = _HD; /*19471*/
			if (_HD >= $1.gf) { /*19471*/
				var _HG = $k[--$j]; /*19471*/
				$k[$j++] = _HG ^ $1.pm; /*19471*/
			} /*19471*/
		} /*19471*/
		$1.rsalog = $a(); /*19471*/
		$1.rslog = $a($1.gf); /*19472*/
		for (var _HM = 1, _HL = $1["gf-1"]; _HM <= _HL; _HM += 1) { /*19473*/
			$put($1.rslog, $get($1.rsalog, _HM), _HM); /*19473*/
		} /*19473*/
		$1.rsprod = function() {
			var _HQ = $k[--$j]; /*19475*/
			var _HR = $k[--$j]; /*19475*/
			$k[$j++] = _HR; /*19479*/
			$k[$j++] = _HQ; /*19479*/
			if ((_HQ != 0) && (_HR != 0)) { /*19478*/
				var _HU = $get($1.rslog, $k[--$j]); /*19476*/
				var _Ha = $get($1.rsalog, (_HU + $get($1.rslog, $k[--$j])) % $1["gf-1"]); /*19476*/
				$k[$j++] = _Ha; /*19476*/
			} else { /*19478*/
				$j -= 2; /*19478*/
				$k[$j++] = 0; /*19478*/
			} /*19478*/
		}; /*19480*/
		$k[$j++] = Infinity; /*19483*/
		$k[$j++] = 1; /*19483*/
		for (var _Hc = 0, _Hd = $1.ecpb; _Hc < _Hd; _Hc++) { /*19483*/
			$k[$j++] = 0; /*19483*/
		} /*19483*/
		$1.coeffs = $a(); /*19483*/
		for (var _Hh = 0, _Hg = $1.ecpb - 1; _Hh <= _Hg; _Hh += 1) { /*19492*/
			$1.i = _Hh; /*19485*/
			$put($1.coeffs, $1.i + 1, $get($1.coeffs, $1.i)); /*19486*/
			for (var _Ho = $1.i; _Ho >= 1; _Ho -= 1) { /*19490*/
				$1.j = _Ho; /*19488*/
				$k[$j++] = $1.coeffs; /*19489*/
				$k[$j++] = $1.j; /*19489*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*19489*/
				$k[$j++] = $get($1.coeffs, $1.j); /*19489*/
				$k[$j++] = $get($1.rsalog, $1.i); /*19489*/
				if ($1.rsprod() == $b) break; /*19489*/
				var _I0 = $k[--$j]; /*19489*/
				var _I1 = $k[--$j]; /*19489*/
				var _I2 = $k[--$j]; /*19489*/
				$put($k[--$j], _I2, $xo(_I1, _I0)); /*19489*/
			} /*19489*/
			$k[$j++] = $1.coeffs; /*19491*/
			$k[$j++] = 0; /*19491*/
			$k[$j++] = $get($1.coeffs, 0); /*19491*/
			$k[$j++] = $get($1.rsalog, $1.i); /*19491*/
			if ($1.rsprod() == $b) break; /*19491*/
			var _IA = $k[--$j]; /*19491*/
			var _IB = $k[--$j]; /*19491*/
			$put($k[--$j], _IB, _IA); /*19491*/
		} /*19491*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*19493*/
		for (var _II = 0, _IH = $1.cwbs.length - 1; _II <= _IH; _II += 1) { /*19508*/
			$1.i = _II; /*19497*/
			$k[$j++] = Infinity; /*19498*/
			$aload($get($1.cwbs, $1.i)); /*19498*/
			for (var _IN = 0, _IO = $1.ecpb; _IN < _IO; _IN++) { /*19498*/
				$k[$j++] = 0; /*19498*/
			} /*19498*/
			$1.rscws = $a(); /*19498*/
			for (var _IS = 0, _IR = $1.dcpb - 1; _IS <= _IR; _IS += 1) { /*19506*/
				$1.m = _IS; /*19500*/
				$1.k = $get($1.rscws, $1.m); /*19501*/
				for (var _IY = 0, _IX = $1.ecpb - 1; _IY <= _IX; _IY += 1) { /*19505*/
					$1.j = _IY; /*19503*/
					$k[$j++] = $1.rscws; /*19504*/
					$k[$j++] = ($1.m + $1.j) + 1; /*19504*/
					$k[$j++] = $get($1.coeffs, ($1.ecpb - $1.j) - 1); /*19504*/
					$k[$j++] = $1.k; /*19504*/
					if ($1.rsprod() == $b) break; /*19504*/
					var _Il = $k[--$j]; /*19504*/
					var _Im = $k[--$j]; /*19504*/
					$put($k[--$j], _Im, $xo(_Il, $get($1.rscws, ($1.m + $1.j) + 1))); /*19504*/
				} /*19504*/
			} /*19504*/
			$put($1.ecbs, $1.i, $geti($1.rscws, $1.dcpb, $1.ecpb)); /*19507*/
		} /*19507*/
		$k[$j++] = Infinity; /*19511*/
		$aload($1.cws); /*19511*/
		for (var _Iw = 0, _Ix = $1.rscw; _Iw < _Ix; _Iw++) { /*19511*/
			$k[$j++] = 0; /*19511*/
		} /*19511*/
		$1.cws = $a(); /*19511*/
		for (var _J1 = 0, _J0 = $1.rscw - 1; _J1 <= _J0; _J1 += 1) { /*19515*/
			$1.i = _J1; /*19513*/
			$put($1.cws, $1.dcws + $1.i, $get($get($1.ecbs, $1.i % $1.rsbl), ~~($1.i / $1.rsbl))); /*19514*/
		} /*19514*/
		var _JF = $1.stype ? 5 : 8; /*19518*/
		$1.mmat = $a(($1.dcws + $1.rscw) * _JF); /*19518*/
		$1.r = 0; /*19519*/
		$1.c = 0; /*19519*/
		var _JI = $1.stype ? 2 : 1; /*19520*/
		for (var _JL = 0, _JM = _JI, _JK = $1.cws.length - 1; _JM < 0 ? _JL >= _JK : _JL <= _JK; _JL += _JM) { /*19541*/
			$1.i = _JL; /*19521*/
			if (!$1.stype) { /*19535*/
				var _JP = $strcpy($s(8), "00000000"); /*19523*/
				var _JU = $cvrs($s(8), $get($1.cws, $1.i), 2); /*19523*/
				$puti(_JP, 8 - _JU.length, _JU); /*19524*/
				$k[$j++] = _JP; /*19524*/
				$k[$j++] = Infinity; /*19524*/
				var _JV = $k[--$j]; /*19524*/
				var _JW = $k[--$j]; /*19524*/
				$k[$j++] = _JV; /*19524*/
				$forall(_JW, function() { /*19524*/
					var _JX = $k[--$j]; /*19524*/
					$k[$j++] = _JX - 48; /*19524*/
				}); /*19524*/
				var _JY = $a(); /*19524*/
				$1.top = $geti(_JY, 0, 4); /*19525*/
				$1.bot = $geti(_JY, 4, 4); /*19526*/
			} else { /*19535*/
				var _Jc = $strcpy($s(5), "00000"); /*19528*/
				var _Jh = $cvrs($s(5), $get($1.cws, $1.i), 2); /*19528*/
				$puti(_Jc, 5 - _Jh.length, _Jh); /*19529*/
				$k[$j++] = _Jc; /*19529*/
				$k[$j++] = Infinity; /*19529*/
				var _Ji = $k[--$j]; /*19529*/
				var _Jj = $k[--$j]; /*19529*/
				$k[$j++] = _Ji; /*19529*/
				$forall(_Jj, function() { /*19529*/
					var _Jk = $k[--$j]; /*19529*/
					$k[$j++] = _Jk - 48; /*19529*/
				}); /*19529*/
				$1.c1 = $a(); /*19530*/
				var _Jn = $strcpy($s(5), "00000"); /*19531*/
				var _Js = $cvrs($s(5), $get($1.cws, $1.i + 1), 2); /*19531*/
				$puti(_Jn, 5 - _Js.length, _Js); /*19532*/
				$k[$j++] = _Jn; /*19532*/
				$k[$j++] = Infinity; /*19532*/
				var _Jt = $k[--$j]; /*19532*/
				var _Ju = $k[--$j]; /*19532*/
				$k[$j++] = _Jt; /*19532*/
				$forall(_Ju, function() { /*19532*/
					var _Jv = $k[--$j]; /*19532*/
					$k[$j++] = _Jv - 48; /*19532*/
				}); /*19532*/
				$1.c2 = $a(); /*19533*/
				$k[$j++] = Infinity; /*19534*/
				$aload($geti($1.c1, 0, 3)); /*19534*/
				$aload($geti($1.c2, 0, 2)); /*19534*/
				$1.top = $a(); /*19534*/
				$k[$j++] = Infinity; /*19535*/
				$aload($geti($1.c1, 3, 2)); /*19535*/
				$aload($geti($1.c2, 2, 3)); /*19535*/
				$1.bot = $a(); /*19535*/
			} /*19535*/
			$puti($1.mmat, ($1.r * $1.dcol) + $1.c, $1.top); /*19537*/
			$puti($1.mmat, (($1.r + 1) * $1.dcol) + $1.c, $1.bot); /*19538*/
			$1.c = $1.c + $1.top.length; /*19539*/
			if ($1.c == $1.dcol) { /*19540*/
				$1.c = 0; /*19540*/
				$1.r = $1.r + 2; /*19540*/
			} /*19540*/
		} /*19540*/
		$1.mmv = function() {
			var _KN = $k[--$j]; /*19544*/
			var _KO = $k[--$j]; /*19544*/
			$k[$j++] = _KO + (_KN * $1.cols); /*19544*/
		}; /*19544*/
		$k[$j++] = Infinity; /*19545*/
		for (var _KR = 0, _KS = $1.rows * $1.cols; _KR < _KS; _KR++) { /*19545*/
			$k[$j++] = -1; /*19545*/
		} /*19545*/
		$1.pixs = $a(); /*19545*/
		var _Ky = $a([function() {
			for (var _KV = 0, _KW = $1.cols; _KV < _KW; _KV++) { /*19549*/
				$k[$j++] = 0; /*19549*/
			} /*19549*/
		}, function() {
			for (var _KY = 0, _KZ = $1.cols; _KY < _KZ; _KY++) { /*19550*/
				$k[$j++] = 1; /*19550*/
			} /*19550*/
		}, function() {
			$k[$j++] = 0; /*19551*/
			for (var _Kb = 0, _Kc = $1.cols - 2; _Kb < _Kc; _Kb++) { /*19551*/
				$k[$j++] = 1; /*19551*/
			} /*19551*/
			$k[$j++] = 0; /*19551*/
		}, function() {
			$k[$j++] = 0; /*19552*/
			$k[$j++] = 1; /*19552*/
			for (var _Ke = 0, _Kf = $1.cols - 4; _Ke < _Kf; _Ke++) { /*19552*/
				$k[$j++] = 0; /*19552*/
			} /*19552*/
			$k[$j++] = 1; /*19552*/
			$k[$j++] = 0; /*19552*/
		}, function() {
			for (var _Kh = 0, _Ki = ~~(($1.cols - 1) / 2); _Kh < _Ki; _Kh++) { /*19553*/
				$k[$j++] = -1; /*19553*/
			} /*19553*/
			$k[$j++] = 1; /*19553*/
			for (var _Kk = 0, _Kl = ~~(($1.cols - 1) / 2); _Kk < _Kl; _Kk++) { /*19553*/
				$k[$j++] = -1; /*19553*/
			} /*19553*/
		}, function() {
			for (var _Kn = 0, _Ko = ~~(($1.cols - 1) / 2); _Kn < _Ko; _Kn++) { /*19554*/
				$k[$j++] = -1; /*19554*/
			} /*19554*/
			$k[$j++] = 0; /*19554*/
			for (var _Kq = 0, _Kr = ~~(($1.cols - 1) / 2); _Kq < _Kr; _Kq++) { /*19554*/
				$k[$j++] = -1; /*19554*/
			} /*19554*/
		}, function() {
			$k[$j++] = 1; /*19555*/
			for (var _Kt = 0, _Ku = $1.cols - 2; _Kt < _Ku; _Kt++) { /*19555*/
				$k[$j++] = 0; /*19555*/
			} /*19555*/
			$k[$j++] = 1; /*19555*/
		}, function() {
			$k[$j++] = 1; /*19556*/
			$k[$j++] = 0; /*19556*/
			for (var _Kw = 0, _Kx = $1.cols - 4; _Kw < _Kx; _Kw++) { /*19556*/
				$k[$j++] = 1; /*19556*/
			} /*19556*/
			$k[$j++] = 0; /*19556*/
			$k[$j++] = 1; /*19556*/
		}]); /*19556*/
		$1.artifact = _Ky; /*19557*/
		var _Kz = {
			A: "121343",
			B: "12134343",
			C: "12121343",
			D: "1213434343",
			E: "1212134343",
			F: "1212121343",
			G: "121213434343",
			H: "121212134343",
			S: "56661278",
			T: "5666666666127878"
		}; /*19568*/
		$1.cpat = $get(_Kz, $geti($1.vers, 0, 1)); /*19569*/
		$k[$j++] = $1.pixs; /*19570*/
		$k[$j++] = 0; /*19570*/
		$k[$j++] = ~~(($1.rows - $1.cpat.length) / 2); /*19570*/
		if ($1.mmv() == $b) return $b; /*19570*/
		$k[$j++] = Infinity; /*19571*/
		$forall($1.cpat, function() { /*19571*/
			$get($1.artifact, $k[--$j] - 49)(); /*19571*/
		}); /*19571*/
		var _LA = $a(); /*19571*/
		var _LB = $k[--$j]; /*19571*/
		$puti($k[--$j], _LB, _LA); /*19571*/
		for (var _LF = 0, _LE = $1.risl - 1; _LF <= _LE; _LF += 1) { /*19586*/
			$1.i = _LF; /*19575*/
			for (var _LK = $1.riso, _LL = $1.risi, _LJ = $1.cols - 1; _LL < 0 ? _LK >= _LJ : _LK <= _LJ; _LK += _LL) { /*19585*/
				$1.j = _LK; /*19577*/
				var _LN = (($1.i % 12) == 0) ? 1 : 0; /*19578*/
				var _LO = $a([1, _LN]); /*19578*/
				$k[$j++] = _LO; /*19579*/
				$k[$j++] = _LO; /*19579*/
				$k[$j++] = $1.pixs; /*19579*/
				$k[$j++] = $1.j; /*19579*/
				$k[$j++] = $1.i; /*19579*/
				if ($1.mmv() == $b) break; /*19579*/
				var _LS = $k[--$j]; /*19580*/
				var _LT = $k[--$j]; /*19580*/
				$puti(_LT, _LS, $k[--$j]); /*19580*/
				if ($1.i != ($1.risl - 1)) { /*19584*/
					$k[$j++] = $1.pixs; /*19582*/
					$k[$j++] = ($1.cols - $1.j) - 2; /*19582*/
					$k[$j++] = ($1.rows - $1.i) - 1; /*19582*/
					if ($1.mmv() == $b) break; /*19582*/
					var _Lc = $k[--$j]; /*19583*/
					var _Ld = $k[--$j]; /*19583*/
					$puti(_Ld, _Lc, $k[--$j]); /*19583*/
				} else { /*19584*/
					$j--; /*19584*/
				} /*19584*/
			} /*19584*/
		} /*19584*/
		var _MI = {
			A: $a([$a([12, 5])]),
			B: $a([$a([16, 7])]),
			C: $a([$a([26, 12])]),
			D: $a([]),
			E: $a([$a([26, 23])]),
			F: $a([$a([26, 32]), $a([70, 32]), $a([26, 34]), $a([70, 34])]),
			G: $a([$a([27, 48]), $a([69, 48])]),
			H: $a([$a([26, 70]), $a([66, 70]), $a([106, 70]), $a([26, 72]), $a([66, 72]), $a([106, 72])]),
			"S-10": $a([]),
			"S-20": $a([$a([10, 4])]),
			"S-30": $a([$a([15, 4]), $a([15, 6])]),
			"T-16": $a([$a([8, 10])]),
			"T-32": $a([$a([16, 10]), $a([16, 12])]),
			"T-48": $a([$a([24, 10]), $a([24, 12]), $a([24, 14])])
		}; /*19603*/
		$forall($get(_MI, $1.vers), function() { /*19604*/
			var _MM = $k[--$j]; /*19604*/
			$k[$j++] = $1.pixs; /*19604*/
			$aload(_MM); /*19604*/
			if ($1.mmv() == $b) return $b; /*19604*/
			var _MN = $k[--$j]; /*19604*/
			$put($k[--$j], _MN, 1); /*19604*/
		}); /*19604*/
		$1.j = 0; /*19607*/
		for (var _MR = 0, _MQ = $1.pixs.length - 1; _MR <= _MQ; _MR += 1) { /*19614*/
			$1.i = _MR; /*19609*/
			if ($get($1.pixs, $1.i) == -1) { /*19613*/
				$put($1.pixs, $1.i, $get($1.mmat, $1.j)); /*19611*/
				$1.j = $1.j + 1; /*19612*/
			} /*19612*/
		} /*19612*/
		var _Mh = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.cols,
			pixy: $1.rows,
			height: ($1.rows / 72) * 2,
			width: ($1.cols / 72) * 2,
			opt: $1.options
		}; /*19624*/
		$k[$j++] = _Mh; /*19627*/
		if (!$1.dontdraw) { /*19627*/
			$0.renmatrix(); /*19627*/
		} /*19627*/
	};
	$0.hanxin = function() {
		var $1 = {}; /*19654*/
		$1.options = $k[--$j]; /*19656*/
		$1.barcode = $k[--$j]; /*19657*/
		$1.dontdraw = false; /*19659*/
		$1.version = "unset"; /*19660*/
		$1.eclevel = "unset"; /*19661*/
		$1.parse = false; /*19662*/
		$1.parsefnc = false; /*19663*/
		$1.mask = -1; /*19664*/
		$forall($1.options, function() { /*19675*/
			var _3 = $k[--$j]; /*19675*/
			$1[$k[--$j]] = _3; /*19675*/
		}); /*19675*/
		$1.mask = ~~$1.mask; /*19677*/
		$1.barlen = $1.barcode.length; /*19700*/
		var _7 = {

		}; /*19705*/
		$1.fncvals = _7; /*19705*/
		$1.msg = $a($1.barlen); /*19706*/
		$1.i = 0; /*19707*/
		$1.j = 0; /*19707*/
		for (;;) { /*19721*/
			if ($1.i == $1.barlen) { /*19708*/
				break; /*19708*/
			} /*19708*/
			$1.char = $get($1.barcode, $1.i); /*19709*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*19717*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*19715*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*19712*/
					$1.i = $1.i + 4; /*19713*/
				} else { /*19715*/
					$1.i = $1.i + 1; /*19715*/
				} /*19715*/
			} /*19715*/
			$put($1.msg, $1.j, $1.char); /*19718*/
			$1.i = $1.i + 1; /*19719*/
			$1.j = $1.j + 1; /*19720*/
		} /*19720*/
		$1.msg = $geti($1.msg, 0, $1.j); /*19722*/
		$1.msglen = $1.msg.length; /*19723*/
		if ($eq($1.eclevel, "unset")) { /*19726*/
			$1.eclevel = "L2"; /*19726*/
		} /*19726*/
		$1.tobin = function() {
			var _e = $s($k[--$j]); /*19729*/
			$k[$j++] = _e; /*19729*/
			for (var _g = 0, _f = _e.length - 1; _g <= _f; _g += 1) { /*19729*/
				var _h = $k[--$j]; /*19729*/
				$put(_h, _g, 48); /*19729*/
				$k[$j++] = _h; /*19729*/
			} /*19729*/
			var _i = $k[--$j]; /*19730*/
			var _l = $cvrs($s(_i.length), $k[--$j], 2); /*19730*/
			$puti(_i, _i.length - _l.length, _l); /*19731*/
			$k[$j++] = _i; /*19731*/
		}; /*19732*/
		$1.bits = $s((4 + 13) + ($1.msglen * 8)); /*19735*/
		$puti($1.bits, 0, "0011"); /*19736*/
		$k[$j++] = $1.bits; /*19737*/
		$k[$j++] = 4; /*19737*/
		$k[$j++] = $1.msglen; /*19737*/
		$k[$j++] = 13; /*19737*/
		if ($1.tobin() == $b) return $b; /*19737*/
		var _r = $k[--$j]; /*19737*/
		var _s = $k[--$j]; /*19737*/
		$puti($k[--$j], _s, _r); /*19737*/
		for (var _w = 0, _v = $1.msglen - 1; _w <= _v; _w += 1) { /*19741*/
			$1.i = _w; /*19739*/
			$k[$j++] = $1.bits; /*19740*/
			$k[$j++] = 17 + ($1.i * 8); /*19740*/
			$k[$j++] = $get($1.msg, $1.i); /*19740*/
			$k[$j++] = 8; /*19740*/
			if ($1.tobin() == $b) break; /*19740*/
			var _12 = $k[--$j]; /*19740*/
			var _13 = $k[--$j]; /*19740*/
			$puti($k[--$j], _13, _12); /*19740*/
		} /*19740*/
		$1.metrics = $a([$a(["1", 23, -1, 0, 205, $a([1, 21, 4]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 17, 8]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 13, 12]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 9, 16]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["2", 25, -1, 0, 301, $a([1, 31, 6]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 25, 12]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 19, 18]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 15, 22]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["3", 27, -1, 0, 405, $a([1, 42, 8]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 34, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 26, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["4", 29, 14, 1, 439, $a([1, 46, 8]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 38, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 30, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 22, 32]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["5", 31, 16, 1, 555, $a([1, 57, 12]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 49, 20]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 37, 32]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 14, 20]), $a([1, 13, 22]), $a([0, -1, -1])]), $a(["6", 33, 16, 1, 675, $a([1, 70, 14]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 58, 26]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 24, 20]), $a([1, 22, 18]), $a([0, -1, -1]), $a([1, 16, 24]), $a([1, 18, 26]), $a([0, -1, -1])]), $a(["7", 35, 17, 1, 805, $a([1, 84, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 26, 22]), $a([1, 28, 24]), $a([0, -1, -1]), $a([2, 14, 20]), $a([1, 12, 20]), $a([0, -1, -1])]), $a(["8", 37, 18, 1, 943, $a([1, 99, 18]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 40, 18]), $a([1, 41, 18]), $a([0, -1, -1]), $a([1, 31, 26]), $a([1, 32, 28]), $a([0, -1, -1]), $a([2, 16, 24]), $a([1, 15, 22]), $a([0, -1, -1])]), $a(["9", 39, 19, 1, 1089, $a([1, 114, 22]), $a([0, -1, -1]), $a([0, -1, -1]), $a([2, 48, 20]), $a([0, -1, -1]), $a([0, -1, -1]), $a([2, 24, 20]), $a([1, 26, 22]), $a([0, -1, -1]), $a([2, 18, 28]), $a([1, 18, 26]), $a([0, -1, -1])]), $a(["10", 41, 20, 1, 1243, $a([1, 131, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 52, 22]), $a([1, 57, 24]), $a([0, -1, -1]), $a([2, 27, 24]), $a([1, 29, 24]), $a([0, -1, -1]), $a([2, 21, 32]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["11", 43, 14, 2, 1289, $a([1, 135, 26]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 56, 24]), $a([1, 57, 24]), $a([0, -1, -1]), $a([2, 28, 24]), $a([1, 31, 26]), $a([0, -1, -1]), $a([2, 22, 32]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["12", 45, 15, 2, 1455, $a([1, 153, 28]), $a([0, -1, -1]), $a([0, -1, -1]), $a([1, 62, 26]), $a([1, 65, 28]), $a([0, -1, -1]), $a([2, 32, 28]), $a([1, 33, 28]), $a([0, -1, -1]), $a([3, 17, 26]), $a([1, 22, 30]), $a([0, -1, -1])]), $a(["13", 47, 16, 2, 1629, $a([1, 86, 16]), $a([1, 85, 16]), $a([0, -1, -1]), $a([1, 71, 30]), $a([1, 72, 30]), $a([0, -1, -1]), $a([2, 37, 32]), $a([1, 35, 30]), $a([0, -1, -1]), $a([3, 20, 30]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["14", 49, 16, 2, 1805, $a([1, 94, 18]), $a([1, 95, 18]), $a([0, -1, -1]), $a([2, 51, 22]), $a([1, 55, 24]), $a([0, -1, -1]), $a([3, 30, 26]), $a([1, 31, 26]), $a([0, -1, -1]), $a([4, 18, 28]), $a([1, 17, 24]), $a([0, -1, -1])]), $a(["15", 51, 17, 2, 1995, $a([1, 104, 20]), $a([1, 105, 20]), $a([0, -1, -1]), $a([2, 57, 24]), $a([1, 61, 26]), $a([0, -1, -1]), $a([3, 33, 28]), $a([1, 36, 30]), $a([0, -1, -1]), $a([4, 20, 30]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["16", 53, 17, 2, 2187, $a([1, 115, 22]), $a([1, 114, 22]), $a([0, -1, -1]), $a([2, 65, 28]), $a([1, 61, 26]), $a([0, -1, -1]), $a([3, 38, 32]), $a([1, 33, 30]), $a([0, -1, -1]), $a([5, 19, 28]), $a([1, 14, 24]), $a([0, -1, -1])]), $a(["17", 55, 18, 2, 2393, $a([1, 126, 24]), $a([1, 125, 24]), $a([0, -1, -1]), $a([2, 70, 30]), $a([1, 69, 30]), $a([0, -1, -1]), $a([4, 33, 28]), $a([1, 29, 26]), $a([0, -1, -1]), $a([5, 20, 30]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["18", 57, 19, 2, 2607, $a([1, 136, 26]), $a([1, 137, 26]), $a([0, -1, -1]), $a([3, 56, 24]), $a([1, 59, 26]), $a([0, -1, -1]), $a([5, 35, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([6, 18, 28]), $a([1, 21, 28]), $a([0, -1, -1])]), $a(["19", 59, 20, 2, 2829, $a([1, 148, 28]), $a([1, 149, 28]), $a([0, -1, -1]), $a([3, 61, 26]), $a([1, 64, 28]), $a([0, -1, -1]), $a([7, 24, 20]), $a([1, 23, 22]), $a([0, -1, -1]), $a([6, 20, 30]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["20", 61, 20, 2, 3053, $a([3, 107, 20]), $a([0, -1, -1]), $a([0, -1, -1]), $a([3, 65, 28]), $a([1, 72, 30]), $a([0, -1, -1]), $a([7, 26, 22]), $a([1, 23, 22]), $a([0, -1, -1]), $a([7, 19, 28]), $a([1, 20, 32]), $a([0, -1, -1])]), $a(["21", 63, 21, 2, 3291, $a([3, 115, 22]), $a([0, -1, -1]), $a([0, -1, -1]), $a([4, 56, 24]), $a([1, 63, 28]), $a([0, -1, -1]), $a([7, 28, 24]), $a([1, 25, 22]), $a([0, -1, -1]), $a([8, 18, 28]), $a([1, 21, 22]), $a([0, -1, -1])]), $a(["22", 65, 16, 3, 3383, $a([2, 116, 22]), $a([1, 122, 24]), $a([0, -1, -1]), $a([4, 56, 24]), $a([1, 72, 30]), $a([0, -1, -1]), $a([7, 28, 24]), $a([1, 32, 26]), $a([0, -1, -1]), $a([8, 18, 28]), $a([1, 24, 30]), $a([0, -1, -1])]), $a(["23", 67, 17, 3, 3631, $a([3, 127, 24]), $a([0, -1, -1]), $a([0, -1, -1]), $a([5, 51, 22]), $a([1, 62, 26]), $a([0, -1, -1]), $a([7, 30, 26]), $a([1, 35, 26]), $a([0, -1, -1]), $a([8, 20, 30]), $a([1, 21, 32]), $a([0, -1, -1])]), $a(["24", 69, 17, 3, 3887, $a([2, 135, 26]), $a([1, 137, 26]), $a([0, -1, -1]), $a([5, 56, 24]), $a([1, 59, 26]), $a([0, -1, -1]), $a([7, 33, 28]), $a([1, 30, 28]), $a([0, -1, -1]), $a([11, 16, 24]), $a([1, 19, 26]), $a([0, -1, -1])]), $a(["25", 71, 18, 3, 4151, $a([3, 105, 20]), $a([1, 121, 22]), $a([0, -1, -1]), $a([5, 61, 26]), $a([1, 57, 26]), $a([0, -1, -1]), $a([9, 28, 24]), $a([1, 28, 22]), $a([0, -1, -1]), $a([10, 19, 28]), $a([1, 18, 30]), $a([0, -1, -1])]), $a(["26", 73, 18, 3, 4423, $a([2, 157, 30]), $a([1, 150, 28]), $a([0, -1, -1]), $a([5, 65, 28]), $a([1, 61, 26]), $a([0, -1, -1]), $a([8, 33, 28]), $a([1, 34, 30]), $a([0, -1, -1]), $a([10, 19, 28]), $a([2, 15, 26]), $a([0, -1, -1])]), $a(["27", 75, 19, 3, 4703, $a([3, 126, 24]), $a([1, 115, 22]), $a([0, -1, -1]), $a([7, 51, 22]), $a([1, 54, 22]), $a([0, -1, -1]), $a([8, 35, 30]), $a([1, 37, 30]), $a([0, -1, -1]), $a([15, 15, 22]), $a([1, 10, 22]), $a([0, -1, -1])]), $a(["28", 77, 19, 3, 4991, $a([4, 105, 20]), $a([1, 103, 20]), $a([0, -1, -1]), $a([7, 56, 24]), $a([1, 45, 18]), $a([0, -1, -1]), $a([10, 31, 26]), $a([1, 27, 26]), $a([0, -1, -1]), $a([10, 17, 26]), $a([3, 20, 28]), $a([1, 21, 28])]), $a(["29", 79, 20, 3, 5287, $a([3, 139, 26]), $a([1, 137, 28]), $a([0, -1, -1]), $a([6, 66, 28]), $a([1, 66, 30]), $a([0, -1, -1]), $a([9, 36, 30]), $a([1, 34, 32]), $a([0, -1, -1]), $a([13, 19, 28]), $a([1, 17, 32]), $a([0, -1, -1])]), $a(["30", 81, 20, 3, 5591, $a([6, 84, 16]), $a([1, 82, 16]), $a([0, -1, -1]), $a([6, 70, 30]), $a([1, 68, 30]), $a([0, -1, -1]), $a([7, 35, 30]), $a([3, 33, 28]), $a([1, 32, 28]), $a([13, 20, 30]), $a([1, 20, 28]), $a([0, -1, -1])]), $a(["31", 83, 21, 3, 5903, $a([5, 105, 20]), $a([1, 94, 18]), $a([0, -1, -1]), $a([6, 74, 32]), $a([1, 71, 30]), $a([0, -1, -1]), $a([11, 33, 28]), $a([1, 34, 32]), $a([0, -1, -1]), $a([13, 19, 28]), $a([3, 16, 26]), $a([0, -1, -1])]), $a(["32", 85, 17, 4, 6033, $a([4, 127, 24]), $a([1, 126, 24]), $a([0, -1, -1]), $a([7, 66, 28]), $a([1, 66, 30]), $a([0, -1, -1]), $a([12, 30, 24]), $a([1, 24, 28]), $a([1, 24, 30]), $a([15, 19, 28]), $a([1, 17, 32]), $a([0, -1, -1])]), $a(["33", 87, 17, 4, 6353, $a([7, 84, 16]), $a([1, 78, 16]), $a([0, -1, -1]), $a([7, 70, 30]), $a([1, 66, 28]), $a([0, -1, -1]), $a([12, 33, 28]), $a([1, 32, 30]), $a([0, -1, -1]), $a([14, 21, 32]), $a([1, 24, 28]), $a([0, -1, -1])]), $a(["34", 89, 18, 4, 6689, $a([5, 117, 22]), $a([1, 117, 24]), $a([0, -1, -1]), $a([8, 66, 28]), $a([1, 58, 26]), $a([0, -1, -1]), $a([11, 38, 32]), $a([1, 34, 32]), $a([0, -1, -1]), $a([15, 20, 30]), $a([2, 17, 26]), $a([0, -1, -1])]), $a(["35", 91, 18, 4, 7025, $a([4, 148, 28]), $a([1, 146, 28]), $a([0, -1, -1]), $a([8, 68, 30]), $a([1, 70, 24]), $a([0, -1, -1]), $a([10, 36, 32]), $a([3, 38, 28]), $a([0, -1, -1]), $a([16, 19, 28]), $a([3, 16, 26]), $a([0, -1, -1])]), $a(["36", 93, 19, 4, 7377, $a([4, 126, 24]), $a([2, 135, 26]), $a([0, -1, -1]), $a([8, 70, 28]), $a([2, 43, 26]), $a([0, -1, -1]), $a([13, 32, 28]), $a([2, 41, 30]), $a([0, -1, -1]), $a([17, 19, 28]), $a([3, 15, 26]), $a([0, -1, -1])]), $a(["37", 95, 19, 4, 7729, $a([5, 136, 26]), $a([1, 132, 24]), $a([0, -1, -1]), $a([5, 67, 30]), $a([4, 68, 28]), $a([1, 69, 28]), $a([14, 35, 30]), $a([1, 32, 24]), $a([0, -1, -1]), $a([18, 18, 26]), $a([3, 16, 28]), $a([1, 14, 28])]), $a(["38", 97, 19, 4, 8089, $a([3, 142, 26]), $a([3, 141, 28]), $a([0, -1, -1]), $a([8, 70, 30]), $a([1, 73, 32]), $a([1, 74, 32]), $a([12, 34, 30]), $a([3, 34, 26]), $a([1, 35, 28]), $a([18, 21, 32]), $a([1, 27, 30]), $a([0, -1, -1])]), $a(["39", 99, 20, 4, 8465, $a([5, 116, 22]), $a([2, 103, 20]), $a([1, 102, 20]), $a([9, 74, 32]), $a([1, 74, 30]), $a([0, -1, -1]), $a([14, 34, 28]), $a([2, 32, 32]), $a([1, 32, 30]), $a([19, 21, 32]), $a([1, 25, 26]), $a([0, -1, -1])]), $a(["40", 101, 20, 4, 8841, $a([7, 116, 22]), $a([1, 117, 22]), $a([0, -1, -1]), $a([11, 65, 28]), $a([1, 58, 24]), $a([0, -1, -1]), $a([15, 38, 32]), $a([1, 27, 28]), $a([0, -1, -1]), $a([20, 20, 30]), $a([1, 20, 32]), $a([1, 21, 32])]), $a(["41", 103, 17, 5, 9009, $a([6, 136, 26]), $a([1, 130, 24]), $a([0, -1, -1]), $a([11, 66, 28]), $a([1, 62, 30]), $a([0, -1, -1]), $a([14, 34, 28]), $a([3, 34, 32]), $a([1, 30, 30]), $a([18, 20, 30]), $a([3, 20, 28]), $a([2, 15, 26])]), $a(["42", 105, 17, 5, 9401, $a([5, 105, 20]), $a([2, 115, 22]), $a([2, 116, 22]), $a([10, 75, 32]), $a([1, 73, 32]), $a([0, -1, -1]), $a([16, 38, 32]), $a([1, 27, 28]), $a([0, -1, -1]), $a([22, 19, 28]), $a([2, 16, 30]), $a([1, 19, 30])]), $a(["43", 107, 18, 5, 9799, $a([6, 147, 28]), $a([1, 146, 28]), $a([0, -1, -1]), $a([11, 66, 28]), $a([2, 65, 30]), $a([0, -1, -1]), $a([18, 33, 28]), $a([2, 33, 30]), $a([0, -1, -1]), $a([22, 21, 32]), $a([1, 28, 30]), $a([0, -1, -1])]), $a(["44", 109, 18, 5, 10207, $a([6, 116, 22]), $a([3, 125, 24]), $a([0, -1, -1]), $a([11, 75, 32]), $a([1, 68, 30]), $a([0, -1, -1]), $a([13, 35, 28]), $a([6, 34, 32]), $a([1, 30, 30]), $a([23, 21, 32]), $a([1, 26, 30]), $a([0, -1, -1])]), $a(["45", 111, 18, 5, 10623, $a([7, 105, 20]), $a([4, 95, 18]), $a([0, -1, -1]), $a([12, 67, 28]), $a([1, 63, 30]), $a([1, 62, 32]), $a([21, 31, 26]), $a([2, 33, 32]), $a([0, -1, -1]), $a([23, 21, 32]), $a([2, 24, 30]), $a([0, -1, -1])]), $a(["46", 113, 19, 5, 11045, $a([10, 116, 22]), $a([0, -1, -1]), $a([0, -1, -1]), $a([12, 74, 32]), $a([1, 78, 30]), $a([0, -1, -1]), $a([18, 37, 32]), $a([1, 39, 30]), $a([1, 41, 28]), $a([25, 21, 32]), $a([1, 27, 28]), $a([0, -1, -1])]), $a(["47", 115, 19, 5, 11477, $a([5, 126, 24]), $a([4, 115, 22]), $a([1, 114, 22]), $a([12, 67, 28]), $a([2, 66, 32]), $a([1, 68, 30]), $a([21, 35, 30]), $a([1, 39, 30]), $a([0, -1, -1]), $a([26, 21, 32]), $a([1, 28, 28]), $a([0, -1, -1])]), $a(["48", 117, 19, 5, 11917, $a([9, 126, 24]), $a([1, 117, 22]), $a([0, -1, -1]), $a([13, 75, 32]), $a([1, 68, 30]), $a([0, -1, -1]), $a([20, 35, 30]), $a([3, 35, 28]), $a([0, -1, -1]), $a([27, 21, 32]), $a([1, 28, 30]), $a([0, -1, -1])]), $a(["49", 119, 17, 6, 12111, $a([9, 126, 24]), $a([1, 137, 26]), $a([0, -1, -1]), $a([13, 71, 30]), $a([2, 68, 32]), $a([0, -1, -1]), $a([20, 37, 32]), $a([1, 39, 28]), $a([1, 38, 28]), $a([24, 20, 32]), $a([5, 25, 28]), $a([0, -1, -1])]), $a(["50", 121, 17, 6, 12559, $a([8, 147, 28]), $a([1, 141, 28]), $a([0, -1, -1]), $a([10, 73, 32]), $a([4, 74, 30]), $a([1, 73, 30]), $a([16, 36, 32]), $a([6, 39, 30]), $a([1, 37, 30]), $a([27, 21, 32]), $a([3, 20, 26]), $a([0, -1, -1])]), $a(["51", 123, 18, 6, 13025, $a([9, 137, 26]), $a([1, 135, 26]), $a([0, -1, -1]), $a([12, 70, 30]), $a([4, 75, 32]), $a([0, -1, -1]), $a([24, 35, 30]), $a([1, 40, 28]), $a([0, -1, -1]), $a([23, 20, 32]), $a([8, 24, 30]), $a([0, -1, -1])]), $a(["52", 125, 18, 6, 13489, $a([14, 95, 18]), $a([1, 86, 18]), $a([0, -1, -1]), $a([13, 73, 32]), $a([3, 77, 30]), $a([0, -1, -1]), $a([24, 35, 30]), $a([2, 35, 28]), $a([0, -1, -1]), $a([26, 21, 32]), $a([5, 21, 30]), $a([1, 23, 30])]), $a(["53", 127, 18, 6, 13961, $a([9, 147, 28]), $a([1, 142, 28]), $a([0, -1, -1]), $a([10, 73, 30]), $a([6, 70, 32]), $a([1, 71, 32]), $a([25, 35, 30]), $a([2, 34, 26]), $a([0, -1, -1]), $a([29, 21, 32]), $a([4, 22, 30]), $a([0, -1, -1])]), $a(["54", 129, 18, 6, 14441, $a([11, 126, 24]), $a([1, 131, 24]), $a([0, -1, -1]), $a([16, 74, 32]), $a([1, 79, 30]), $a([0, -1, -1]), $a([25, 38, 32]), $a([1, 25, 30]), $a([0, -1, -1]), $a([33, 21, 32]), $a([1, 28, 28]), $a([0, -1, -1])]), $a(["55", 131, 19, 6, 14939, $a([14, 105, 20]), $a([1, 99, 18]), $a([0, -1, -1]), $a([19, 65, 28]), $a([1, 72, 28]), $a([0, -1, -1]), $a([24, 37, 32]), $a([2, 40, 30]), $a([1, 41, 30]), $a([31, 21, 32]), $a([4, 24, 32]), $a([0, -1, -1])]), $a(["56", 133, 19, 6, 15435, $a([10, 147, 28]), $a([1, 151, 28]), $a([0, -1, -1]), $a([15, 71, 30]), $a([3, 71, 32]), $a([1, 73, 32]), $a([24, 37, 32]), $a([3, 38, 30]), $a([1, 39, 30]), $a([36, 19, 30]), $a([3, 29, 26]), $a([0, -1, -1])]), $a(["57", 135, 19, 6, 15939, $a([15, 105, 20]), $a([1, 99, 18]), $a([0, -1, -1]), $a([19, 70, 30]), $a([1, 64, 28]), $a([0, -1, -1]), $a([27, 38, 32]), $a([2, 25, 26]), $a([0, -1, -1]), $a([38, 20, 30]), $a([2, 18, 28]), $a([0, -1, -1])]), $a(["58", 137, 17, 7, 16171, $a([14, 105, 20]), $a([1, 113, 22]), $a([1, 114, 22]), $a([17, 67, 30]), $a([3, 92, 32]), $a([0, -1, -1]), $a([30, 35, 30]), $a([1, 41, 30]), $a([0, -1, -1]), $a([36, 21, 32]), $a([1, 26, 30]), $a([1, 27, 30])]), $a(["59", 139, 17, 7, 16691, $a([11, 146, 28]), $a([1, 146, 26]), $a([0, -1, -1]), $a([20, 70, 30]), $a([1, 60, 26]), $a([0, -1, -1]), $a([29, 38, 32]), $a([1, 24, 32]), $a([0, -1, -1]), $a([40, 20, 30]), $a([2, 17, 26]), $a([0, -1, -1])]), $a(["60", 141, 18, 7, 17215, $a([3, 137, 26]), $a([1, 136, 26]), $a([10, 126, 24]), $a([22, 65, 28]), $a([1, 75, 30]), $a([0, -1, -1]), $a([30, 37, 32]), $a([1, 51, 30]), $a([0, -1, -1]), $a([42, 20, 30]), $a([1, 21, 30]), $a([0, -1, -1])]), $a(["61", 143, 18, 7, 17751, $a([12, 126, 24]), $a([2, 118, 22]), $a([1, 116, 22]), $a([19, 74, 32]), $a([1, 74, 30]), $a([1, 72, 28]), $a([30, 38, 32]), $a([2, 29, 30]), $a([0, -1, -1]), $a([39, 20, 32]), $a([2, 37, 26]), $a([1, 38, 26])]), $a(["62", 145, 18, 7, 18295, $a([12, 126, 24]), $a([3, 136, 26]), $a([0, -1, -1]), $a([21, 70, 30]), $a([2, 65, 28]), $a([0, -1, -1]), $a([34, 35, 30]), $a([1, 44, 32]), $a([0, -1, -1]), $a([42, 20, 30]), $a([2, 19, 28]), $a([2, 18, 28])]), $a(["63", 147, 18, 7, 18847, $a([12, 126, 24]), $a([3, 117, 22]), $a([1, 116, 22]), $a([25, 61, 26]), $a([2, 62, 28]), $a([0, -1, -1]), $a([34, 35, 30]), $a([1, 40, 32]), $a([1, 41, 32]), $a([45, 20, 30]), $a([1, 20, 32]), $a([1, 21, 32])]), $a(["64", 149, 19, 7, 19403, $a([15, 105, 20]), $a([2, 115, 22]), $a([2, 116, 22]), $a([25, 65, 28]), $a([1, 72, 28]), $a([0, -1, -1]), $a([18, 35, 30]), $a([17, 37, 32]), $a([1, 50, 32]), $a([42, 20, 30]), $a([6, 19, 28]), $a([1, 15, 28])]), $a(["65", 151, 19, 7, 19971, $a([19, 105, 20]), $a([1, 101, 20]), $a([0, -1, -1]), $a([33, 51, 22]), $a([1, 65, 22]), $a([0, -1, -1]), $a([40, 33, 28]), $a([1, 28, 28]), $a([0, -1, -1]), $a([49, 20, 30]), $a([1, 18, 28]), $a([0, -1, -1])]), $a(["66", 153, 17, 8, 20229, $a([18, 105, 20]), $a([2, 117, 22]), $a([0, -1, -1]), $a([26, 65, 28]), $a([1, 80, 30]), $a([0, -1, -1]), $a([35, 35, 30]), $a([3, 35, 28]), $a([1, 36, 28]), $a([52, 18, 28]), $a([2, 38, 30]), $a([0, -1, -1])]), $a(["67", 155, 17, 8, 20805, $a([26, 84, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([26, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([45, 31, 26]), $a([1, 9, 26]), $a([0, -1, -1]), $a([52, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["68", 157, 17, 8, 21389, $a([16, 126, 24]), $a([1, 114, 22]), $a([1, 115, 22]), $a([23, 70, 30]), $a([3, 65, 28]), $a([1, 66, 28]), $a([40, 35, 30]), $a([1, 43, 30]), $a([0, -1, -1]), $a([46, 20, 30]), $a([7, 19, 28]), $a([1, 16, 28])]), $a(["69", 159, 18, 8, 21993, $a([19, 116, 22]), $a([1, 105, 22]), $a([0, -1, -1]), $a([20, 70, 30]), $a([7, 66, 28]), $a([1, 63, 28]), $a([40, 35, 30]), $a([1, 42, 32]), $a([1, 43, 32]), $a([54, 20, 30]), $a([1, 19, 30]), $a([0, -1, -1])]), $a(["70", 161, 18, 8, 22593, $a([17, 126, 24]), $a([2, 115, 22]), $a([0, -1, -1]), $a([24, 70, 30]), $a([4, 74, 32]), $a([0, -1, -1]), $a([48, 31, 26]), $a([2, 18, 26]), $a([0, -1, -1]), $a([54, 19, 28]), $a([6, 15, 26]), $a([1, 14, 26])]), $a(["71", 163, 18, 8, 23201, $a([29, 84, 16]), $a([0, -1, -1]), $a([0, -1, -1]), $a([29, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([6, 34, 30]), $a([3, 36, 30]), $a([38, 33, 28]), $a([58, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["72", 165, 18, 8, 23817, $a([16, 147, 28]), $a([1, 149, 28]), $a([0, -1, -1]), $a([31, 66, 28]), $a([1, 37, 26]), $a([0, -1, -1]), $a([48, 33, 28]), $a([1, 23, 26]), $a([0, -1, -1]), $a([53, 20, 30]), $a([6, 19, 28]), $a([1, 17, 28])]), $a(["73", 167, 19, 8, 24453, $a([20, 115, 22]), $a([2, 134, 24]), $a([0, -1, -1]), $a([29, 66, 28]), $a([2, 56, 26]), $a([2, 57, 26]), $a([45, 36, 30]), $a([2, 15, 28]), $a([0, -1, -1]), $a([59, 20, 30]), $a([2, 21, 32]), $a([0, -1, -1])]), $a(["74", 169, 19, 8, 25085, $a([17, 147, 28]), $a([1, 134, 26]), $a([0, -1, -1]), $a([26, 70, 30]), $a([5, 75, 32]), $a([0, -1, -1]), $a([47, 35, 30]), $a([1, 48, 32]), $a([0, -1, -1]), $a([64, 18, 28]), $a([2, 33, 30]), $a([1, 35, 30])]), $a(["75", 171, 17, 9, 25373, $a([22, 115, 22]), $a([1, 133, 24]), $a([0, -1, -1]), $a([33, 65, 28]), $a([1, 74, 28]), $a([0, -1, -1]), $a([43, 36, 30]), $a([5, 27, 28]), $a([1, 30, 28]), $a([57, 20, 30]), $a([5, 21, 32]), $a([1, 24, 32])]), $a(["76", 173, 17, 9, 26021, $a([18, 136, 26]), $a([2, 142, 26]), $a([0, -1, -1]), $a([33, 66, 28]), $a([2, 49, 26]), $a([0, -1, -1]), $a([48, 35, 30]), $a([2, 38, 28]), $a([0, -1, -1]), $a([64, 20, 30]), $a([1, 20, 32]), $a([0, -1, -1])]), $a(["77", 175, 17, 9, 26677, $a([19, 126, 24]), $a([2, 135, 26]), $a([1, 136, 26]), $a([32, 66, 28]), $a([2, 55, 26]), $a([2, 56, 26]), $a([49, 36, 30]), $a([2, 18, 32]), $a([0, -1, -1]), $a([65, 18, 28]), $a([5, 27, 30]), $a([1, 29, 30])]), $a(["78", 177, 18, 9, 27335, $a([20, 137, 26]), $a([1, 130, 26]), $a([0, -1, -1]), $a([30, 75, 32]), $a([2, 71, 32]), $a([0, -1, -1]), $a([46, 35, 30]), $a([6, 39, 32]), $a([0, -1, -1]), $a([3, 12, 30]), $a([70, 19, 28]), $a([0, -1, -1])]), $a(["79", 179, 18, 9, 28007, $a([20, 147, 28]), $a([0, -1, -1]), $a([0, -1, -1]), $a([35, 70, 30]), $a([0, -1, -1]), $a([0, -1, -1]), $a([49, 35, 30]), $a([5, 35, 28]), $a([0, -1, -1]), $a([70, 20, 30]), $a([0, -1, -1]), $a([0, -1, -1])]), $a(["80", 181, 18, 9, 28687, $a([21, 136, 26]), $a([1, 155, 28]), $a([0, -1, -1]), $a([34, 70, 30]), $a([1, 64, 28]), $a([1, 65, 28]), $a([54, 35, 30]), $a([1, 45, 30]), $a([0, -1, -1]), $a([68, 20, 30]), $a([3, 18, 28]), $a([1, 19, 28])]), $a(["81", 183, 18, 9, 29375, $a([19, 126, 24]), $a([5, 115, 22]), $a([1, 114, 22]), $a([33, 70, 30]), $a([3, 65, 28]), $a([1, 64, 28]), $a([52, 35, 30]), $a([3, 41, 32]), $a([1, 40, 32]), $a([67, 20, 30]), $a([5, 21, 32]), $a([1, 24, 32])]), $a(["82", 185, 18, 9, 30071, $a([2, 150, 28]), $a([21, 136, 26]), $a([0, -1, -1]), $a([32, 70, 30]), $a([6, 65, 28]), $a([0, -1, -1]), $a([52, 38, 32]), $a([2, 27, 32]), $a([0, -1, -1]), $a([73, 20, 30]), $a([2, 22, 32]), $a([0, -1, -1])]), $a(["83", 187, 17, 10, 30387, $a([21, 126, 24]), $a([4, 136, 26]), $a([0, -1, -1]), $a([30, 74, 32]), $a([6, 73, 30]), $a([0, -1, -1]), $a([54, 35, 30]), $a([4, 40, 32]), $a([0, -1, -1]), $a([75, 20, 30]), $a([1, 20, 28]), $a([0, -1, -1])]), $a(["84", 189, 17, 10, 31091, $a([30, 105, 20]), $a([1, 114, 22]), $a([0, -1, -1]), $a([3, 45, 22]), $a([55, 47, 20]), $a([0, -1, -1]), $a([2, 26, 26]), $a([62, 33, 28]), $a([0, -1, -1]), $a([79, 18, 28]), $a([4, 33, 30]), $a([0, -1, -1])])]); /*20082*/
		$1.eclval = $get($1.eclevel, 1) - 49; /*20084*/
		for (var _Ik = 0; _Ik <= 83; _Ik += 1) { /*20104*/
			$1.i = _Ik; /*20086*/
			$1.m = $get($1.metrics, $1.i); /*20087*/
			$1.vers = $get($1.m, 0); /*20088*/
			$1.size = $get($1.m, 1); /*20089*/
			$1.alnk = $get($1.m, 2); /*20090*/
			$1.alnn = $get($1.m, 3); /*20091*/
			$1.alnr = $1.size - ($1.alnk * $1.alnn); /*20092*/
			$1.nmod = $get($1.m, 4); /*20093*/
			$1.ncws = ~~($1.nmod / 8); /*20094*/
			$1.rbit = $1.nmod % 8; /*20095*/
			$1.ecbs = $geti($1.m, 5 + ($1.eclval * 3), 3); /*20096*/
			$k[$j++] = "ecws"; /*20097*/
			$k[$j++] = 0; /*20097*/
			$forall($1.ecbs, function() { /*20097*/
				var _J7 = $k[--$j]; /*20097*/
				var _JA = $k[--$j]; /*20097*/
				$k[$j++] = _JA + ($get(_J7, 0) * $get(_J7, 2)); /*20097*/
			}); /*20097*/
			var _JB = $k[--$j]; /*20097*/
			$1[$k[--$j]] = _JB; /*20097*/
			$1.dcws = $1.ncws - $1.ecws; /*20098*/
			$1.dmod = $1.dcws * 8; /*20099*/
			$1.okay = true; /*20100*/
			if ($ne($1.version, "unset") && $ne($1.version, $1.vers)) { /*20101*/
				$1.okay = false; /*20101*/
			} /*20101*/
			if ($1.bits.length > $1.dmod) { /*20102*/
				$1.okay = false; /*20102*/
			} /*20102*/
			if ($1.okay) { /*20103*/
				break; /*20103*/
			} /*20103*/
		} /*20103*/
		if (!$1.okay) { /*20108*/
			$k[$j++] = "bwipp.hanxinNoValidSymbol"; /*20107*/
			$k[$j++] = "No valid symbol available"; /*20107*/
			$0.raiseerror(); /*20107*/
		} /*20107*/
		$1.version = $1.vers; /*20110*/
		$1.msgbits = $1.bits; /*20111*/
		$1.e1nb = $get($get($1.ecbs, 0), 0); /*20112*/
		$1.e2nb = $get($get($1.ecbs, 1), 0); /*20112*/
		$1.e3nb = $get($get($1.ecbs, 2), 0); /*20112*/
		$1.e1dcws = $get($get($1.ecbs, 0), 1); /*20113*/
		$1.e2dcws = $get($get($1.ecbs, 1), 1); /*20113*/
		$1.e3dcws = $get($get($1.ecbs, 2), 1); /*20113*/
		$1.e1ecws = $get($get($1.ecbs, 0), 2); /*20114*/
		$1.e2ecws = $get($get($1.ecbs, 1), 2); /*20114*/
		$1.e3ecws = $get($get($1.ecbs, 2), 2); /*20114*/
		$1.pad = $s($1.dmod); /*20117*/
		for (var _Ju = 0, _Jt = $1.pad.length - 1; _Ju <= _Jt; _Ju += 1) { /*20118*/
			$put($1.pad, _Ju, 48); /*20118*/
		} /*20118*/
		$puti($1.pad, 0, $1.msgbits); /*20119*/
		$1.cws = $a($1.dcws); /*20122*/
		for (var _K2 = 0, _K1 = $1.cws.length - 1; _K2 <= _K1; _K2 += 1) { /*20132*/
			$1.c = _K2; /*20124*/
			$1.cwb = $geti($1.pad, $1.c * 8, 8); /*20125*/
			$1.cw = 0; /*20126*/
			for (var _K6 = 0; _K6 <= 7; _K6 += 1) { /*20130*/
				$1.i = _K6; /*20128*/
				$1.cw = $1.cw + ((~~(Math.pow(2, (8 - $1.i) - 1))) * ($get($1.cwb, $1.i) - 48)); /*20129*/
			} /*20129*/
			$put($1.cws, $1.c, $1.cw); /*20131*/
		} /*20131*/
		$1.rscodes = function() {
			$1.rspm = $k[--$j]; /*20136*/
			$1.rsgf = $k[--$j]; /*20137*/
			$1.rsnc = $k[--$j]; /*20138*/
			$1.rscws = $k[--$j]; /*20139*/
			$k[$j++] = Infinity; /*20142*/
			$k[$j++] = 1; /*20142*/
			for (var _KK = 0, _KL = $1.rsgf - 1; _KK < _KL; _KK++) { /*20142*/
				var _KM = $k[--$j]; /*20142*/
				var _KN = _KM * 2; /*20142*/
				$k[$j++] = _KM; /*20142*/
				$k[$j++] = _KN; /*20142*/
				if (_KN >= $1.rsgf) { /*20142*/
					var _KQ = $k[--$j]; /*20142*/
					$k[$j++] = $xo(_KQ, $1.rspm); /*20142*/
				} /*20142*/
			} /*20142*/
			$1.rsalog = $a(); /*20142*/
			$1.rslog = $a($1.rsgf); /*20143*/
			for (var _KW = 1, _KV = $1.rsgf - 1; _KW <= _KV; _KW += 1) { /*20144*/
				$put($1.rslog, $get($1.rsalog, _KW), _KW); /*20144*/
			} /*20144*/
			$1.rsprod = function() {
				var _Ka = $k[--$j]; /*20148*/
				var _Kb = $k[--$j]; /*20148*/
				$k[$j++] = _Kb; /*20152*/
				$k[$j++] = _Ka; /*20152*/
				if ((_Ka != 0) && (_Kb != 0)) { /*20151*/
					var _Ke = $get($1.rslog, $k[--$j]); /*20149*/
					var _Kk = $get($1.rsalog, (_Ke + $get($1.rslog, $k[--$j])) % ($1.rsgf - 1)); /*20149*/
					$k[$j++] = _Kk; /*20149*/
				} else { /*20151*/
					$j -= 2; /*20151*/
					$k[$j++] = 0; /*20151*/
				} /*20151*/
			}; /*20153*/
			$k[$j++] = Infinity; /*20156*/
			$k[$j++] = 1; /*20156*/
			for (var _Km = 0, _Kn = $1.rsnc; _Km < _Kn; _Km++) { /*20156*/
				$k[$j++] = 0; /*20156*/
			} /*20156*/
			$1.coeffs = $a(); /*20156*/
			for (var _Kr = 1, _Kq = $1.rsnc; _Kr <= _Kq; _Kr += 1) { /*20165*/
				$1.i = _Kr; /*20158*/
				$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*20159*/
				for (var _Ky = $1.i - 1; _Ky >= 1; _Ky -= 1) { /*20163*/
					$1.j = _Ky; /*20161*/
					$k[$j++] = $1.coeffs; /*20162*/
					$k[$j++] = $1.j; /*20162*/
					$k[$j++] = $get($1.coeffs, $1.j - 1); /*20162*/
					$k[$j++] = $get($1.coeffs, $1.j); /*20162*/
					$k[$j++] = $get($1.rsalog, $1.i); /*20162*/
					if ($1.rsprod() == $b) break; /*20162*/
					var _LA = $k[--$j]; /*20162*/
					var _LB = $k[--$j]; /*20162*/
					var _LC = $k[--$j]; /*20162*/
					$put($k[--$j], _LC, $xo(_LB, _LA)); /*20162*/
				} /*20162*/
				$k[$j++] = $1.coeffs; /*20164*/
				$k[$j++] = 0; /*20164*/
				$k[$j++] = $get($1.coeffs, 0); /*20164*/
				$k[$j++] = $get($1.rsalog, $1.i); /*20164*/
				if ($1.rsprod() == $b) break; /*20164*/
				var _LK = $k[--$j]; /*20164*/
				var _LL = $k[--$j]; /*20164*/
				$put($k[--$j], _LL, _LK); /*20164*/
			} /*20164*/
			$1.nd = $1.rscws.length; /*20168*/
			$k[$j++] = Infinity; /*20169*/
			$forall($1.rscws); /*20169*/
			for (var _LQ = 0, _LR = $1.rsnc; _LQ < _LR; _LQ++) { /*20169*/
				$k[$j++] = 0; /*20169*/
			} /*20169*/
			$k[$j++] = 0; /*20169*/
			$1.rscws = $a(); /*20169*/
			for (var _LV = 0, _LU = $1.nd - 1; _LV <= _LU; _LV += 1) { /*20176*/
				$1.k = $xo($get($1.rscws, _LV), $get($1.rscws, $1.nd)); /*20171*/
				for (var _Ld = 0, _Lc = $1.rsnc - 1; _Ld <= _Lc; _Ld += 1) { /*20175*/
					$1.j = _Ld; /*20173*/
					$k[$j++] = $1.rscws; /*20174*/
					$k[$j++] = $1.nd + $1.j; /*20174*/
					$k[$j++] = $get($1.rscws, ($1.nd + $1.j) + 1); /*20174*/
					$k[$j++] = $1.k; /*20174*/
					$k[$j++] = $get($1.coeffs, ($1.rsnc - $1.j) - 1); /*20174*/
					if ($1.rsprod() == $b) break; /*20174*/
					var _Lq = $k[--$j]; /*20174*/
					var _Lr = $k[--$j]; /*20174*/
					var _Ls = $k[--$j]; /*20174*/
					$put($k[--$j], _Ls, $xo(_Lr, _Lq)); /*20174*/
				} /*20174*/
			} /*20174*/
			$k[$j++] = $geti($1.rscws, 0, $1.rscws.length - 1); /*20179*/
		}; /*20181*/
		$1.dcwsb = $a(($1.e1nb + $1.e2nb) + $1.e3nb); /*20184*/
		$1.ecwsb = $a($1.dcwsb.length); /*20185*/
		$1.in = 0; /*20186*/
		$1.out = 0; /*20186*/
		for (var _M4 = 0, _M5 = $1.e1nb; _M4 < _M5; _M4++) { /*20192*/
			$k[$j++] = $geti($1.cws, $1.in, $1.e1dcws); /*20188*/
			$k[$j++] = $1.e1ecws; /*20188*/
			$k[$j++] = 256; /*20188*/
			$k[$j++] = 355; /*20188*/
			if ($1.rscodes() == $b) break; /*20188*/
			var _MB = $k[--$j]; /*20189*/
			$put($1.dcwsb, $1.out, $geti(_MB, 0, $1.e1dcws)); /*20189*/
			$put($1.ecwsb, $1.out, $geti(_MB, $1.e1dcws, $1.e1ecws)); /*20190*/
			$1.in = $1.in + $1.e1dcws; /*20191*/
			$1.out = $1.out + 1; /*20191*/
		} /*20191*/
		for (var _MP = 0, _MQ = $1.e2nb; _MP < _MQ; _MP++) { /*20198*/
			$k[$j++] = $geti($1.cws, $1.in, $1.e2dcws); /*20194*/
			$k[$j++] = $1.e2ecws; /*20194*/
			$k[$j++] = 256; /*20194*/
			$k[$j++] = 355; /*20194*/
			if ($1.rscodes() == $b) break; /*20194*/
			var _MW = $k[--$j]; /*20195*/
			$put($1.dcwsb, $1.out, $geti(_MW, 0, $1.e2dcws)); /*20195*/
			$put($1.ecwsb, $1.out, $geti(_MW, $1.e2dcws, $1.e2ecws)); /*20196*/
			$1.in = $1.in + $1.e2dcws; /*20197*/
			$1.out = $1.out + 1; /*20197*/
		} /*20197*/
		for (var _Mk = 0, _Ml = $1.e3nb; _Mk < _Ml; _Mk++) { /*20204*/
			$k[$j++] = $geti($1.cws, $1.in, $1.e3dcws); /*20200*/
			$k[$j++] = $1.e3ecws; /*20200*/
			$k[$j++] = 256; /*20200*/
			$k[$j++] = 355; /*20200*/
			if ($1.rscodes() == $b) break; /*20200*/
			var _Mr = $k[--$j]; /*20201*/
			$put($1.dcwsb, $1.out, $geti(_Mr, 0, $1.e3dcws)); /*20201*/
			$put($1.ecwsb, $1.out, $geti(_Mr, $1.e3dcws, $1.e3ecws)); /*20202*/
			$1.in = $1.in + $1.e3dcws; /*20203*/
			$1.out = $1.out + 1; /*20203*/
		} /*20203*/
		$1.cws = $a($1.ncws); /*20207*/
		$1.cw = 0; /*20208*/
		for (var _N8 = 0, _N7 = $1.dcwsb.length - 1; _N8 <= _N7; _N8 += 1) { /*20213*/
			$1.i = _N8; /*20210*/
			var _NB = $get($1.dcwsb, $1.i); /*20211*/
			$puti($1.cws, $1.cw, _NB); /*20211*/
			$1.cw = _NB.length + $1.cw; /*20211*/
			var _NH = $get($1.ecwsb, $1.i); /*20212*/
			$puti($1.cws, $1.cw, _NH); /*20212*/
			$1.cw = _NH.length + $1.cw; /*20212*/
		} /*20212*/
		$k[$j++] = Infinity; /*20220*/
		var _NL = $1.ncws; /*20217*/
		var _NM = 12; /*20217*/
		var _NN = _NL - 1; /*20217*/
		if ((_NL - 1) > 12) { /*20217*/
			var _ = _NM; /*20217*/
			_NM = _NN; /*20217*/
			_NN = _; /*20217*/
		} /*20217*/
		for (var _NP = 0, _NO = _NN; _NP <= _NO; _NP += 1) { /*20219*/
			for (var _NS = _NP, _NR = $1.ncws - 1; _NS <= _NR; _NS += 13) { /*20218*/
				$k[$j++] = _NS; /*20218*/
				if (_NS < $1.ncws) { /*20218*/
					var _NW = $get($1.cws, $k[--$j]); /*20218*/
					$k[$j++] = _NW; /*20218*/
				} else { /*20218*/
					$j--; /*20218*/
				} /*20218*/
			} /*20218*/
		} /*20218*/
		$1.cws = $a(); /*20220*/
		if ($1.rbit > 0) { /*20228*/
			$1.pad = $a($1.cws.length + 1); /*20224*/
			$puti($1.pad, 0, $1.cws); /*20225*/
			$put($1.pad, $1.pad.length - 1, 0); /*20226*/
			$1.cws = $1.pad; /*20227*/
		} /*20227*/
		$k[$j++] = Infinity; /*20231*/
		for (var _Ni = 0, _Nj = $1.size * $1.size; _Ni < _Nj; _Ni++) { /*20231*/
			$k[$j++] = -1; /*20231*/
		} /*20231*/
		$1.pixs = $a(); /*20231*/
		$1.qmv = function() {
			var _Nm = $k[--$j]; /*20232*/
			var _Nn = $k[--$j]; /*20232*/
			$k[$j++] = _Nn + (_Nm * $1.size); /*20232*/
		}; /*20232*/
		if ($1.alnn != 0) { /*20291*/
			$1.trmv = function() {
				var _Nq = $k[--$j]; /*20236*/
				var _Ns = $k[--$j]; /*20236*/
				$k[$j++] = (((_Nq * $1.size) + $1.size) - 1) - _Ns; /*20236*/
			}; /*20236*/
			$1.aplot = function() {
				var _Nt = $k[--$j]; /*20238*/
				var _Nu = $k[--$j]; /*20238*/
				var _Nv = $k[--$j]; /*20238*/
				$k[$j++] = _Nt; /*20238*/
				$k[$j++] = _Nv; /*20238*/
				$k[$j++] = _Nu; /*20238*/
				$k[$j++] = _Nt; /*20238*/
				$k[$j++] = _Nu; /*20238*/
				$k[$j++] = _Nv; /*20238*/
				if ($1.trmv() == $b) return $b; /*20238*/
				var _Nx = $k[--$j]; /*20238*/
				$put($1.pixs, _Nx, $k[--$j]); /*20238*/
				if ($1.trmv() == $b) return $b; /*20239*/
				var _O0 = $k[--$j]; /*20239*/
				$put($1.pixs, _O0, $k[--$j]); /*20239*/
			}; /*20240*/
			$1.i = 0; /*20241*/
			$1.stag = 0; /*20241*/
			for (;;) { /*20263*/
				if ($1.i >= $1.size) { /*20242*/
					break; /*20242*/
				} /*20242*/
				for (var _O6 = 0, _O5 = $1.size - 1; _O6 <= _O5; _O6 += 1) { /*20256*/
					$1.j = _O6; /*20244*/
					if (($1.j + $1.alnr) < $1.size) { /*20250*/
						$k[$j++] = (((((~~($1.j / $1.alnk)) + $1.stag) % 2) == 0) && (!(($1.i == 0) && ($1.j < $1.alnk)))) || (($1.j % $1.alnk) == 0); /*20248*/
					} else { /*20250*/
						$k[$j++] = (($1.alnn + $1.stag) % 2) == 0; /*20250*/
					} /*20250*/
					if ($k[--$j]) { /*20255*/
						$k[$j++] = $1.j; /*20253*/
						$k[$j++] = $1.i; /*20253*/
						$k[$j++] = 1; /*20253*/
						if ($1.aplot() == $b) break; /*20253*/
						var _ON = $1.j; /*20254*/
						var _OO = $1.i; /*20254*/
						$k[$j++] = _ON + 1; /*20254*/
						$k[$j++] = _OO + 1; /*20254*/
						if (((_OO + 1) < $1.size) && ((_ON + 1) < $1.size)) { /*20254*/
							$k[$j++] = 0; /*20254*/
							if ($1.aplot() == $b) break; /*20254*/
						} else { /*20254*/
							$j -= 2; /*20254*/
						} /*20254*/
					} /*20254*/
				} /*20254*/
				if (($1.i + $1.alnr) == $1.size) { /*20260*/
					$1.i = ($1.i + $1.alnr) - 1; /*20258*/
				} else { /*20260*/
					$1.i = $1.i + $1.alnk; /*20260*/
				} /*20260*/
				$1.stag = 1 - $1.stag; /*20262*/
			} /*20262*/
			for (var _Od = $1.alnk, _Oe = $1.alnk, _Oc = $1.size - 2; _Oe < 0 ? _Od >= _Oc : _Od <= _Oc; _Od += _Oe) { /*20290*/
				$1.i = _Od; /*20265*/
				if (((~~($1.i / $1.alnk)) % 2) != 0) { /*20277*/
					$k[$j++] = $1.pixs; /*20267*/
					$k[$j++] = 0; /*20267*/
					$k[$j++] = $1.i - 1; /*20267*/
					if ($1.trmv() == $b) break; /*20267*/
					var _Oj = $k[--$j]; /*20267*/
					$put($k[--$j], _Oj, 0); /*20267*/
					$k[$j++] = $1.pixs; /*20268*/
					$k[$j++] = 0; /*20268*/
					$k[$j++] = $1.i + 1; /*20268*/
					if ($1.trmv() == $b) break; /*20268*/
					var _On = $k[--$j]; /*20268*/
					$put($k[--$j], _On, 0); /*20268*/
					$k[$j++] = $1.pixs; /*20269*/
					$k[$j++] = 1; /*20269*/
					$k[$j++] = $1.i - 1; /*20269*/
					if ($1.trmv() == $b) break; /*20269*/
					var _Or = $k[--$j]; /*20269*/
					$put($k[--$j], _Or, 0); /*20269*/
					$k[$j++] = $1.pixs; /*20270*/
					$k[$j++] = 1; /*20270*/
					$k[$j++] = $1.i; /*20270*/
					if ($1.trmv() == $b) break; /*20270*/
					var _Ov = $k[--$j]; /*20270*/
					$put($k[--$j], _Ov, 0); /*20270*/
					$k[$j++] = $1.pixs; /*20271*/
					$k[$j++] = 1; /*20271*/
					$k[$j++] = $1.i + 1; /*20271*/
					if ($1.trmv() == $b) break; /*20271*/
					var _Oz = $k[--$j]; /*20271*/
					$put($k[--$j], _Oz, 0); /*20271*/
					$k[$j++] = $1.pixs; /*20272*/
					$k[$j++] = $1.i - 1; /*20272*/
					$k[$j++] = 0; /*20272*/
					if ($1.trmv() == $b) break; /*20272*/
					var _P3 = $k[--$j]; /*20272*/
					$put($k[--$j], _P3, 0); /*20272*/
					$k[$j++] = $1.pixs; /*20273*/
					$k[$j++] = $1.i + 1; /*20273*/
					$k[$j++] = 0; /*20273*/
					if ($1.trmv() == $b) break; /*20273*/
					var _P7 = $k[--$j]; /*20273*/
					$put($k[--$j], _P7, 0); /*20273*/
					$k[$j++] = $1.pixs; /*20274*/
					$k[$j++] = $1.i - 1; /*20274*/
					$k[$j++] = 1; /*20274*/
					if ($1.trmv() == $b) break; /*20274*/
					var _PB = $k[--$j]; /*20274*/
					$put($k[--$j], _PB, 0); /*20274*/
					$k[$j++] = $1.pixs; /*20275*/
					$k[$j++] = $1.i; /*20275*/
					$k[$j++] = 1; /*20275*/
					if ($1.trmv() == $b) break; /*20275*/
					var _PF = $k[--$j]; /*20275*/
					$put($k[--$j], _PF, 0); /*20275*/
					$k[$j++] = $1.pixs; /*20276*/
					$k[$j++] = $1.i + 1; /*20276*/
					$k[$j++] = 1; /*20276*/
					if ($1.trmv() == $b) break; /*20276*/
					var _PJ = $k[--$j]; /*20276*/
					$put($k[--$j], _PJ, 0); /*20276*/
				} /*20276*/
				$k[$j++] = $1.pixs; /*20278*/
				$k[$j++] = $1.size - 1; /*20278*/
				$k[$j++] = $1.i - 1; /*20278*/
				if ($1.trmv() == $b) break; /*20278*/
				var _PO = $k[--$j]; /*20278*/
				if ($get($k[--$j], _PO) != 1) { /*20289*/
					$k[$j++] = $1.pixs; /*20279*/
					$k[$j++] = $1.size - 1; /*20279*/
					$k[$j++] = $1.i - 1; /*20279*/
					if ($1.trmv() == $b) break; /*20279*/
					var _PU = $k[--$j]; /*20279*/
					$put($k[--$j], _PU, 0); /*20279*/
					$k[$j++] = $1.pixs; /*20280*/
					$k[$j++] = $1.size - 2; /*20280*/
					$k[$j++] = $1.i - 1; /*20280*/
					if ($1.trmv() == $b) break; /*20280*/
					var _PZ = $k[--$j]; /*20280*/
					$put($k[--$j], _PZ, 0); /*20280*/
					$k[$j++] = $1.pixs; /*20281*/
					$k[$j++] = $1.size - 2; /*20281*/
					$k[$j++] = $1.i; /*20281*/
					if ($1.trmv() == $b) break; /*20281*/
					var _Pe = $k[--$j]; /*20281*/
					$put($k[--$j], _Pe, 0); /*20281*/
					$k[$j++] = $1.pixs; /*20282*/
					$k[$j++] = $1.size - 2; /*20282*/
					$k[$j++] = $1.i + 1; /*20282*/
					if ($1.trmv() == $b) break; /*20282*/
					var _Pj = $k[--$j]; /*20282*/
					$put($k[--$j], _Pj, 0); /*20282*/
					$k[$j++] = $1.pixs; /*20283*/
					$k[$j++] = $1.size - 1; /*20283*/
					$k[$j++] = $1.i + 1; /*20283*/
					if ($1.trmv() == $b) break; /*20283*/
					var _Po = $k[--$j]; /*20283*/
					$put($k[--$j], _Po, 0); /*20283*/
					$k[$j++] = $1.pixs; /*20284*/
					$k[$j++] = $1.i - 1; /*20284*/
					$k[$j++] = $1.size - 1; /*20284*/
					if ($1.trmv() == $b) break; /*20284*/
					var _Pt = $k[--$j]; /*20284*/
					$put($k[--$j], _Pt, 0); /*20284*/
					$k[$j++] = $1.pixs; /*20285*/
					$k[$j++] = $1.i - 1; /*20285*/
					$k[$j++] = $1.size - 2; /*20285*/
					if ($1.trmv() == $b) break; /*20285*/
					var _Py = $k[--$j]; /*20285*/
					$put($k[--$j], _Py, 0); /*20285*/
					$k[$j++] = $1.pixs; /*20286*/
					$k[$j++] = $1.i; /*20286*/
					$k[$j++] = $1.size - 2; /*20286*/
					if ($1.trmv() == $b) break; /*20286*/
					var _Q3 = $k[--$j]; /*20286*/
					$put($k[--$j], _Q3, 0); /*20286*/
					$k[$j++] = $1.pixs; /*20287*/
					$k[$j++] = $1.i + 1; /*20287*/
					$k[$j++] = $1.size - 2; /*20287*/
					if ($1.trmv() == $b) break; /*20287*/
					var _Q8 = $k[--$j]; /*20287*/
					$put($k[--$j], _Q8, 0); /*20287*/
					$k[$j++] = $1.pixs; /*20288*/
					$k[$j++] = $1.i + 1; /*20288*/
					$k[$j++] = $1.size - 1; /*20288*/
					if ($1.trmv() == $b) break; /*20288*/
					var _QD = $k[--$j]; /*20288*/
					$put($k[--$j], _QD, 0); /*20288*/
				} /*20288*/
			} /*20288*/
		} /*20288*/
		$1.fpat = $a([$a([1, 1, 1, 1, 1, 1, 1, 0]), $a([1, 0, 0, 0, 0, 0, 0, 0]), $a([1, 0, 1, 1, 1, 1, 1, 0]), $a([1, 0, 1, 0, 0, 0, 0, 0]), $a([1, 0, 1, 0, 1, 1, 1, 0]), $a([1, 0, 1, 0, 1, 1, 1, 0]), $a([1, 0, 1, 0, 1, 1, 1, 0]), $a([0, 0, 0, 0, 0, 0, 0, 0])]); /*20303*/
		$1.fpat2 = $a([$a([1, 1, 1, 0, 1, 0, 1, 0]), $a([1, 1, 1, 0, 1, 0, 1, 0]), $a([1, 1, 1, 0, 1, 0, 1, 0]), $a([0, 0, 0, 0, 1, 0, 1, 0]), $a([1, 1, 1, 1, 1, 0, 1, 0]), $a([0, 0, 0, 0, 0, 0, 1, 0]), $a([1, 1, 1, 1, 1, 1, 1, 0]), $a([0, 0, 0, 0, 0, 0, 0, 0])]); /*20313*/
		for (var _QZ = 0, _QY = $1.fpat.length - 1; _QZ <= _QY; _QZ += 1) { /*20325*/
			$1.y = _QZ; /*20315*/
			for (var _Qd = 0, _Qc = $get($1.fpat, 0).length - 1; _Qd <= _Qc; _Qd += 1) { /*20324*/
				$1.x = _Qd; /*20317*/
				$1.fpb = $get($get($1.fpat, $1.y), $1.x); /*20318*/
				$1.fpb2 = $get($get($1.fpat2, $1.y), $1.x); /*20319*/
				$k[$j++] = $1.pixs; /*20320*/
				$k[$j++] = $1.x; /*20320*/
				$k[$j++] = $1.y; /*20320*/
				if ($1.qmv() == $b) break; /*20320*/
				var _Qs = $k[--$j]; /*20320*/
				$put($k[--$j], _Qs, $1.fpb); /*20320*/
				$k[$j++] = $1.pixs; /*20321*/
				$k[$j++] = ($1.size - $1.x) - 1; /*20321*/
				$k[$j++] = $1.y; /*20321*/
				if ($1.qmv() == $b) break; /*20321*/
				var _Qz = $k[--$j]; /*20321*/
				$put($k[--$j], _Qz, $1.fpb); /*20321*/
				$k[$j++] = $1.pixs; /*20322*/
				$k[$j++] = ($1.size - $1.x) - 1; /*20322*/
				$k[$j++] = ($1.size - $1.y) - 1; /*20322*/
				if ($1.qmv() == $b) break; /*20322*/
				var _R7 = $k[--$j]; /*20322*/
				$put($k[--$j], _R7, $1.fpb); /*20322*/
				$k[$j++] = $1.pixs; /*20323*/
				$k[$j++] = $1.x; /*20323*/
				$k[$j++] = ($1.size - $1.y) - 1; /*20323*/
				if ($1.qmv() == $b) break; /*20323*/
				var _RE = $k[--$j]; /*20323*/
				$put($k[--$j], _RE, $1.fpb2); /*20323*/
			} /*20323*/
		} /*20323*/
		$1.functionmap = $a([$a([$a([0, 8]), $a([$1.size - 1, $1.size - 9])]), $a([$a([1, 8]), $a([$1.size - 2, $1.size - 9])]), $a([$a([2, 8]), $a([$1.size - 3, $1.size - 9])]), $a([$a([3, 8]), $a([$1.size - 4, $1.size - 9])]), $a([$a([4, 8]), $a([$1.size - 5, $1.size - 9])]), $a([$a([5, 8]), $a([$1.size - 6, $1.size - 9])]), $a([$a([6, 8]), $a([$1.size - 7, $1.size - 9])]), $a([$a([7, 8]), $a([$1.size - 8, $1.size - 9])]), $a([$a([8, 8]), $a([$1.size - 9, $1.size - 9])]), $a([$a([8, 7]), $a([$1.size - 9, $1.size - 8])]), $a([$a([8, 6]), $a([$1.size - 9, $1.size - 7])]), $a([$a([8, 5]), $a([$1.size - 9, $1.size - 6])]), $a([$a([8, 4]), $a([$1.size - 9, $1.size - 5])]), $a([$a([8, 3]), $a([$1.size - 9, $1.size - 4])]), $a([$a([8, 2]), $a([$1.size - 9, $1.size - 3])]), $a([$a([8, 1]), $a([$1.size - 9, $1.size - 2])]), $a([$a([8, 0]), $a([$1.size - 9, $1.size - 1])]), $a([$a([$1.size - 9, 0]), $a([8, $1.size - 1])]), $a([$a([$1.size - 9, 1]), $a([8, $1.size - 2])]), $a([$a([$1.size - 9, 2]), $a([8, $1.size - 3])]), $a([$a([$1.size - 9, 3]), $a([8, $1.size - 4])]), $a([$a([$1.size - 9, 4]), $a([8, $1.size - 5])]), $a([$a([$1.size - 9, 5]), $a([8, $1.size - 6])]), $a([$a([$1.size - 9, 6]), $a([8, $1.size - 7])]), $a([$a([$1.size - 9, 7]), $a([8, $1.size - 8])]), $a([$a([$1.size - 9, 8]), $a([8, $1.size - 9])]), $a([$a([$1.size - 8, 8]), $a([7, $1.size - 9])]), $a([$a([$1.size - 7, 8]), $a([6, $1.size - 9])]), $a([$a([$1.size - 6, 8]), $a([5, $1.size - 9])]), $a([$a([$1.size - 5, 8]), $a([4, $1.size - 9])]), $a([$a([$1.size - 4, 8]), $a([3, $1.size - 9])]), $a([$a([$1.size - 3, 8]), $a([2, $1.size - 9])]), $a([$a([$1.size - 2, 8]), $a([1, $1.size - 9])]), $a([$a([$1.size - 1, 8]), $a([0, $1.size - 9])])]); /*20347*/
		var _U1 = $1.functionmap; /*20348*/
		for (var _U2 = 0, _U3 = _U1.length; _U2 < _U3; _U2++) { /*20350*/
			$forall($get(_U1, _U2), function() { /*20349*/
				$forall($k[--$j]); /*20349*/
				if ($1.qmv() == $b) return $b; /*20349*/
				$put($1.pixs, $k[--$j], 0); /*20349*/
			}); /*20349*/
		} /*20349*/
		var _UE = $a([function() {
			$j -= 2; /*20353*/
			$k[$j++] = 1; /*20353*/
		}, function() {
			var _U8 = $k[--$j]; /*20354*/
			var _U9 = $k[--$j]; /*20354*/
			$k[$j++] = (_U9 + _U8) % 2; /*20354*/
		}, function() {
			var _UA = $k[--$j]; /*20355*/
			var _UB = $k[--$j]; /*20355*/
			$k[$j++] = (((_UA + _UB) % 3) + (_UB % 3)) % 2; /*20355*/
		}, function() {
			var _UC = $k[--$j]; /*20356*/
			var _UD = $k[--$j]; /*20356*/
			$k[$j++] = ((_UD % _UC) + ((_UC % _UD) + ((_UC % 3) + (_UD % 3)))) % 2; /*20357*/
		}]); /*20357*/
		$1.maskfuncs = _UE; /*20358*/
		if ($1.mask != -1) { /*20362*/
			$1.maskfuncs = $a([$get($1.maskfuncs, $1.mask - 1)]); /*20360*/
			$1.bestmaskval = $1.mask - 1; /*20361*/
		} /*20361*/
		$1.masks = $a($1.maskfuncs.length); /*20363*/
		for (var _UP = 0, _UO = $1.masks.length - 1; _UP <= _UO; _UP += 1) { /*20377*/
			$1.m = _UP; /*20365*/
			$1.mask = $a($1.size * $1.size); /*20366*/
			for (var _UV = 0, _UU = $1.size - 1; _UV <= _UU; _UV += 1) { /*20375*/
				$1.j = _UV; /*20368*/
				for (var _UY = 0, _UX = $1.size - 1; _UY <= _UX; _UY += 1) { /*20374*/
					$1.i = _UY; /*20370*/
					$k[$j++] = $1.i + 1; /*20371*/
					$k[$j++] = $1.j + 1; /*20371*/
					$get($1.maskfuncs, $1.m)(); /*20371*/
					var _Ue = $k[--$j]; /*20371*/
					$k[$j++] = _Ue == 0; /*20372*/
					$k[$j++] = $1.pixs; /*20372*/
					$k[$j++] = $1.i; /*20372*/
					$k[$j++] = $1.j; /*20372*/
					if ($1.qmv() == $b) break; /*20372*/
					var _Ui = $k[--$j]; /*20372*/
					var _Uk = $get($k[--$j], _Ui); /*20372*/
					var _Um = ($k[--$j] && (_Uk == -1)) ? 1 : 0; /*20372*/
					$k[$j++] = _Um; /*20373*/
					$k[$j++] = $1.mask; /*20373*/
					$k[$j++] = $1.i; /*20373*/
					$k[$j++] = $1.j; /*20373*/
					if ($1.qmv() == $b) break; /*20373*/
					var _Uq = $k[--$j]; /*20373*/
					var _Ur = $k[--$j]; /*20373*/
					$put(_Ur, _Uq, $k[--$j]); /*20373*/
				} /*20373*/
			} /*20373*/
			$put($1.masks, $1.m, $1.mask); /*20376*/
		} /*20376*/
		$1.posx = 0; /*20380*/
		$1.posy = 0; /*20381*/
		$1.num = 0; /*20382*/
		for (;;) { /*20392*/
			if ($1.posy == $1.size) { /*20384*/
				break; /*20384*/
			} /*20384*/
			$k[$j++] = $1.pixs; /*20385*/
			$k[$j++] = $1.posx; /*20385*/
			$k[$j++] = $1.posy; /*20385*/
			if ($1.qmv() == $b) break; /*20385*/
			var _V1 = $k[--$j]; /*20385*/
			if ($get($k[--$j], _V1) == -1) { /*20389*/
				var _V6 = $get($1.cws, ~~($1.num / 8)); /*20386*/
				var _V8 = -(7 - ($1.num % 8)); /*20386*/
				$k[$j++] = ((_V8 < 0 ? _V6 >>> -_V8 : _V6 << _V8)) & 1; /*20387*/
				$k[$j++] = $1.pixs; /*20387*/
				$k[$j++] = $1.posx; /*20387*/
				$k[$j++] = $1.posy; /*20387*/
				if ($1.qmv() == $b) break; /*20387*/
				var _VC = $k[--$j]; /*20387*/
				var _VD = $k[--$j]; /*20387*/
				$put(_VD, _VC, $k[--$j]); /*20387*/
				$1.num = $1.num + 1; /*20388*/
			} /*20388*/
			$1.posx = $1.posx + 1; /*20390*/
			if ($1.posx == $1.size) { /*20391*/
				$1.posx = 0; /*20391*/
				$1.posy = $1.posy + 1; /*20391*/
			} /*20391*/
		} /*20391*/
		$1.evalfulln1n3 = function() {
			$1.scrle = $k[--$j]; /*20396*/
			$k[$j++] = "scr1"; /*20398*/
			$k[$j++] = 0; /*20398*/
			$forall($1.scrle, function() { /*20398*/
				var _VM = $k[--$j]; /*20398*/
				$k[$j++] = _VM; /*20398*/
				if (_VM >= 3) { /*20398*/
					var _VN = $k[--$j]; /*20398*/
					var _VP = $k[--$j] + (_VN * 4); /*20398*/
					$k[$j++] = _VP; /*20398*/
					$k[$j++] = _VP; /*20398*/
				} /*20398*/
				$j--; /*20398*/
			}); /*20398*/
			var _VQ = $k[--$j]; /*20398*/
			$1[$k[--$j]] = _VQ; /*20398*/
			$1.scr3 = 0; /*20399*/
			for (var _VU = 5, _VT = $1.scrle.length - 1; _VU <= _VT; _VU += 2) { /*20415*/
				$1.j = _VU; /*20402*/
				if (($get($1.scrle, $1.j) % 3) == 0) { /*20414*/
					$1.fact = ~~($get($1.scrle, $1.j) / 3); /*20404*/
					$forall($geti($1.scrle, $1.j - 4, 4), function() { /*20405*/
						var _Vf = $k[--$j]; /*20405*/
						$k[$j++] = _Vf == $1.fact; /*20405*/
					}); /*20405*/
					var _Vg = $k[--$j]; /*20405*/
					var _Vh = $k[--$j]; /*20405*/
					var _Vi = $k[--$j]; /*20405*/
					if ($k[--$j] && (_Vi && (_Vh && _Vg))) { /*20413*/
						if (($1.j == 5) || (($1.j + 2) >= $1.scrle.length)) { /*20410*/
							$1.scr3 = $1.scr3 + 50; /*20407*/
						} else { /*20410*/
							if (($get($1.scrle, $1.j - 5) >= 3) || ($get($1.scrle, $1.j + 1) >= 3)) { /*20411*/
								$1.scr3 = $1.scr3 + 50; /*20410*/
							} /*20410*/
						} /*20410*/
					} /*20410*/
				} /*20410*/
			} /*20410*/
			for (var _Vx = 1, _Vw = $1.scrle.length - 5; _Vx <= _Vw; _Vx += 2) { /*20431*/
				$1.j = _Vx; /*20418*/
				if (($get($1.scrle, $1.j) % 3) == 0) { /*20430*/
					$1.fact = ~~($get($1.scrle, $1.j) / 3); /*20420*/
					$forall($geti($1.scrle, $1.j + 1, 4), function() { /*20421*/
						var _W8 = $k[--$j]; /*20421*/
						$k[$j++] = _W8 == $1.fact; /*20421*/
					}); /*20421*/
					var _W9 = $k[--$j]; /*20421*/
					var _WA = $k[--$j]; /*20421*/
					var _WB = $k[--$j]; /*20421*/
					if ($k[--$j] && (_WB && (_WA && _W9))) { /*20429*/
						if (($1.j == 1) || (($1.j + 6) >= $1.scrle.length)) { /*20426*/
							$1.scr3 = $1.scr3 + 50; /*20423*/
						} else { /*20426*/
							if (($get($1.scrle, $1.j - 1) >= 3) || ($get($1.scrle, $1.j + 5) >= 3)) { /*20427*/
								$1.scr3 = $1.scr3 + 50; /*20426*/
							} /*20426*/
						} /*20426*/
					} /*20426*/
				} /*20426*/
			} /*20426*/
			$k[$j++] = $1.scr1; /*20432*/
			$k[$j++] = $1.scr3; /*20432*/
		}; /*20433*/
		$1.evalfull = function() {
			$1.sym = $k[--$j]; /*20437*/
			$1.n1 = 0; /*20439*/
			$1.n3 = 0; /*20439*/
			$1.rle = $a($1.size + 1); /*20440*/
			$1.lastpairs = $a($1.size); /*20441*/
			$1.thispairs = $a($1.size); /*20442*/
			$1.sizeadd1 = $1.size + 1; /*20443*/
			for (var _Wa = 0, _WZ = $1.size - 1; _Wa <= _WZ; _Wa += 1) { /*20468*/
				$1.i = _Wa; /*20445*/
				$k[$j++] = Infinity; /*20448*/
				var _Wc = $1.size; /*20449*/
				$k[$j++] = 0; /*20451*/
				$k[$j++] = 0; /*20451*/
				for (var _We = $1.i, _Wf = _Wc, _Wd = (_Wc * _Wc) - 1; _Wf < 0 ? _We >= _Wd : _We <= _Wd; _We += _Wf) { /*20451*/
					var _Wh = $get($1.sym, _We); /*20450*/
					var _Wi = $k[--$j]; /*20450*/
					$k[$j++] = _Wh; /*20450*/
					if ($eq(_Wi, _Wh)) { /*20450*/
						var _Wj = $k[--$j]; /*20450*/
						var _Wk = $k[--$j]; /*20450*/
						$k[$j++] = _Wk + 1; /*20450*/
						$k[$j++] = _Wj; /*20450*/
					} else { /*20450*/
						var _Wl = $k[--$j]; /*20450*/
						$k[$j++] = 1; /*20450*/
						$k[$j++] = _Wl; /*20450*/
					} /*20450*/
				} /*20450*/
				$j--; /*20452*/
				var _Wn = $counttomark() + 2; /*20453*/
				$astore($geti($1.rle, 0, _Wn - 2)); /*20453*/
				if ($1.evalfulln1n3() == $b) break; /*20454*/
				$1.n3 = $k[--$j] + $1.n3; /*20454*/
				$1.n1 = $k[--$j] + $1.n1; /*20454*/
				$j--; /*20455*/
				$1.symrow = $geti($1.sym, $1.i * $1.size, $1.size); /*20458*/
				$k[$j++] = Infinity; /*20459*/
				$k[$j++] = 0; /*20462*/
				$k[$j++] = 0; /*20462*/
				$forall($1.symrow, function() { /*20462*/
					var _Wz = $k[--$j]; /*20461*/
					var _X0 = $k[--$j]; /*20461*/
					$k[$j++] = _Wz; /*20461*/
					if ($eq(_X0, _Wz)) { /*20461*/
						var _X1 = $k[--$j]; /*20461*/
						var _X2 = $k[--$j]; /*20461*/
						$k[$j++] = _X2 + 1; /*20461*/
						$k[$j++] = _X1; /*20461*/
					} else { /*20461*/
						var _X3 = $k[--$j]; /*20461*/
						$k[$j++] = 1; /*20461*/
						$k[$j++] = _X3; /*20461*/
					} /*20461*/
				}); /*20461*/
				$j--; /*20463*/
				var _X5 = $counttomark() + 2; /*20464*/
				$astore($geti($1.rle, 0, _X5 - 2)); /*20464*/
				if ($1.evalfulln1n3() == $b) break; /*20465*/
				$1.n3 = $k[--$j] + $1.n3; /*20465*/
				$1.n1 = $k[--$j] + $1.n1; /*20465*/
				$j--; /*20466*/
			} /*20466*/
			$k[$j++] = $1.n1 + $1.n3; /*20470*/
		}; /*20471*/
		$1.bestscore = 999999999; /*20474*/
		for (var _XF = 0, _XE = $1.masks.length - 1; _XF <= _XE; _XF += 1) { /*20492*/
			$1.m = _XF; /*20476*/
			$1.masksym = $a($1.size * $1.size); /*20477*/
			for (var _XM = 0, _XL = ($1.size * $1.size) - 1; _XM <= _XL; _XM += 1) { /*20481*/
				$1.i = _XM; /*20479*/
				$put($1.masksym, $1.i, $xo($get($1.pixs, $1.i), $get($get($1.masks, $1.m), $1.i))); /*20480*/
			} /*20480*/
			if ($1.masks.length != 1) { /*20490*/
				$k[$j++] = $1.masksym; /*20483*/
				if ($1.evalfull() == $b) break; /*20483*/
				$1.score = $k[--$j]; /*20483*/
				if ($1.score < $1.bestscore) { /*20488*/
					$1.bestsym = $1.masksym; /*20485*/
					$1.bestmaskval = $1.m; /*20486*/
					$1.bestscore = $1.score; /*20487*/
				} /*20487*/
			} else { /*20490*/
				$1.bestsym = $1.masksym; /*20490*/
			} /*20490*/
		} /*20490*/
		$1.pixs = $1.bestsym; /*20493*/
		$1.funval = (((((~~(($1.size - 21) / 2)) + 20) * 4) + $1.eclval) * 4) + $1.bestmaskval; /*20496*/
		$k[$j++] = $a([($1.funval & 3840) >>> 8, ($1.funval & 240) >>> 4, $1.funval & 15]); /*20500*/
		$k[$j++] = 4; /*20500*/
		$k[$j++] = 16; /*20500*/
		$k[$j++] = 19; /*20500*/
		if ($1.rscodes() == $b) return $b; /*20500*/
		$1.funvals = $k[--$j]; /*20500*/
		$k[$j++] = Infinity; /*20506*/
		$forall($1.funvals, function() { /*20504*/
			$k[$j++] = 4; /*20503*/
			if ($1.tobin() == $b) return $b; /*20503*/
			$forall($k[--$j], function() { /*20503*/
				var _Xr = $k[--$j]; /*20503*/
				$k[$j++] = _Xr - 48; /*20503*/
			}); /*20503*/
		}); /*20503*/
		$k[$j++] = 0; /*20505*/
		$k[$j++] = 1; /*20505*/
		$k[$j++] = 0; /*20505*/
		$k[$j++] = 1; /*20505*/
		$k[$j++] = 0; /*20505*/
		$k[$j++] = 1; /*20505*/
		$1.funbits = $a(); /*20506*/
		for (var _Xv = 0, _Xu = $1.functionmap.length - 1; _Xv <= _Xu; _Xv += 1) { /*20512*/
			$1.i = _Xv; /*20508*/
			$forall($get($1.functionmap, $1.i), function() { /*20511*/
				var _Y0 = $k[--$j]; /*20510*/
				$k[$j++] = $1.pixs; /*20510*/
				$aload(_Y0); /*20510*/
				if ($1.qmv() == $b) return $b; /*20510*/
				var _Y4 = $k[--$j]; /*20510*/
				$put($k[--$j], _Y4, $get($1.funbits, $1.i)); /*20510*/
			}); /*20510*/
		} /*20510*/
		var _YC = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.size,
			pixy: $1.size,
			height: ($1.size * 2) / 72,
			width: ($1.size * 2) / 72,
			opt: $1.options
		}; /*20522*/
		$k[$j++] = _YC; /*20525*/
		if (!$1.dontdraw) { /*20525*/
			$0.renmatrix(); /*20525*/
		} /*20525*/
	};
	$0.dotcode = function() {
		var $1 = {}; /*20552*/
		$1.options = $k[--$j]; /*20554*/
		$1.barcode = $k[--$j]; /*20555*/
		$1.dontdraw = false; /*20557*/
		$1.rows = -1; /*20558*/
		$1.columns = -1; /*20559*/
		$1.ratio = -1; /*20560*/
		$1.parse = false; /*20561*/
		$1.parsefnc = false; /*20562*/
		$1.raw = false; /*20563*/
		$1.fast = false; /*20564*/
		$1.mask = -1; /*20565*/
		$forall($1.options, function() { /*20576*/
			var _3 = $k[--$j]; /*20576*/
			$1[$k[--$j]] = _3; /*20576*/
		}); /*20576*/
		$1.rows = ~~$1.rows; /*20578*/
		$1.columns = ~~$1.columns; /*20579*/
		$1.ratio = +$1.ratio; /*20580*/
		$1.mask = ~~$1.mask; /*20581*/
		if ((($1.ratio == -1) && ($1.rows == -1)) && ($1.columns == -1)) { /*20586*/
			$1.ratio = 3 / 2; /*20585*/
		} /*20585*/
		$1.barlen = $1.barcode.length; /*20609*/
		$1.laa = -1; /*20612*/
		$1.lab = -2; /*20612*/
		$1.lac = -3; /*20612*/
		$1.bin = -4; /*20612*/
		$1.sfa = -5; /*20613*/
		$1.sfb = -6; /*20613*/
		$1.sb2 = -7; /*20613*/
		$1.sb3 = -8; /*20613*/
		$1.sb4 = -9; /*20614*/
		$1.sb5 = -10; /*20614*/
		$1.sb6 = -11; /*20614*/
		$1.sfc = -12; /*20614*/
		$1.sc2 = -13; /*20615*/
		$1.sc3 = -14; /*20615*/
		$1.sc4 = -15; /*20615*/
		$1.sc5 = -16; /*20615*/
		$1.sc6 = -17; /*20616*/
		$1.sc7 = -18; /*20616*/
		$1.bsa = -19; /*20616*/
		$1.bsb = -20; /*20616*/
		$1.tma = -21; /*20617*/
		$1.tmb = -22; /*20617*/
		$1.tmc = -23; /*20617*/
		$1.tms = -24; /*20617*/
		$1.fn1 = -25; /*20618*/
		$1.fn2 = -26; /*20618*/
		$1.fn3 = -27; /*20618*/
		$1.crl = -28; /*20618*/
		$1.aim = -29; /*20619*/
		$1.m05 = -30; /*20619*/
		$1.m06 = -31; /*20619*/
		$1.m12 = -32; /*20619*/
		$1.mac = -33; /*20620*/
		$1.charmaps = $a([$a([32, 32, "00"]), $a(["!", "!", "01"]), $a(["\"", "\"", "02"]), $a(["#", "#", "03"]), $a(["$", "$", "04"]), $a(["%", "%", "05"]), $a(["&", "&", "06"]), $a(["'", "'", "07"]), $a([40, 40, "08"]), $a([41, 41, "09"]), $a(["*", "*", "10"]), $a(["+", "+", "11"]), $a([",", ",", "12"]), $a(["-", "-", "13"]), $a([".", ".", "14"]), $a(["/", "/", "15"]), $a(["0", "0", "16"]), $a(["1", "1", "17"]), $a(["2", "2", "18"]), $a(["3", "3", "19"]), $a(["4", "4", "20"]), $a(["5", "5", "21"]), $a(["6", "6", "22"]), $a(["7", "7", "23"]), $a(["8", "8", "24"]), $a(["9", "9", "25"]), $a([":", ":", "26"]), $a([";", ";", "27"]), $a(["<", "<", "28"]), $a(["=", "=", "29"]), $a([">", ">", "30"]), $a(["?", "?", "31"]), $a(["@", "@", "32"]), $a(["A", "A", "33"]), $a(["B", "B", "34"]), $a(["C", "C", "35"]), $a(["D", "D", "36"]), $a(["E", "E", "37"]), $a(["F", "F", "38"]), $a(["G", "G", "39"]), $a(["H", "H", "40"]), $a(["I", "I", "41"]), $a(["J", "J", "42"]), $a(["K", "K", "43"]), $a(["L", "L", "44"]), $a(["M", "M", "45"]), $a(["N", "N", "46"]), $a(["O", "O", "47"]), $a(["P", "P", "48"]), $a(["Q", "Q", "49"]), $a(["R", "R", "50"]), $a(["S", "S", "51"]), $a(["T", "T", "52"]), $a(["U", "U", "53"]), $a(["V", "V", "54"]), $a(["W", "W", "55"]), $a(["X", "X", "56"]), $a(["Y", "Y", "57"]), $a(["Z", "Z", "58"]), $a(["[", "[", "59"]), $a([92, 92, "60"]), $a(["]", "]", "61"]), $a(["^", "^", "62"]), $a(["_", "_", "63"]), $a([0, "`", "64"]), $a([1, "a", "65"]), $a([2, "b", "66"]), $a([3, "c", "67"]), $a([4, "d", "68"]), $a([5, "e", "69"]), $a([6, "f", "70"]), $a([7, "g", "71"]), $a([8, "h", "72"]), $a([9, "i", "73"]), $a([10, "j", "74"]), $a([11, "k", "75"]), $a([12, "l", "76"]), $a([13, "m", "77"]), $a([14, "n", "78"]), $a([15, "o", "79"]), $a([16, "p", "80"]), $a([17, "q", "81"]), $a([18, "r", "82"]), $a([19, "s", "83"]), $a([20, "t", "84"]), $a([21, "u", "85"]), $a([22, "v", "86"]), $a([23, "w", "87"]), $a([24, "x", "88"]), $a([25, "y", "89"]), $a([26, "z", "90"]), $a([27, "{", "91"]), $a([28, "|", "92"]), $a([29, "}", "93"]), $a([30, "~", "94"]), $a([31, 127, "95"]), $a([$1.sfb, $1.crl, "96"]), $a([$1.sb2, 9, "97"]), $a([$1.sb3, 28, "98"]), $a([$1.sb4, 29, "99"]), $a([$1.sb5, 30, $1.aim]), $a([$1.sb6, $1.sfa, $1.laa]), $a([$1.lab, $1.laa, $1.sfb]), $a([$1.sc2, $1.sc2, $1.sb2]), $a([$1.sc3, $1.sc3, $1.sb3]), $a([$1.sc4, $1.sc4, $1.sb4]), $a([$1.lac, $1.lac, $1.lab]), $a([$1.fn1, $1.fn1, $1.fn1]), $a([$1.fn2, $1.fn2, $1.fn2]), $a([$1.fn3, $1.fn3, $1.fn3]), $a([$1.bsa, $1.bsa, $1.bsa]), $a([$1.bsb, $1.bsb, $1.bsb]), $a([$1.bin, $1.bin, $1.bin])]); /*20663*/
		$1.charvals = $a([{}, {}, {}]); /*20666*/
		for (var _2n = 0, _2m = $1.charmaps.length - 1; _2n <= _2m; _2n += 1) { /*20675*/
			$1.i = _2n; /*20668*/
			$1.encs = $get($1.charmaps, $1.i); /*20669*/
			for (var _2r = 0; _2r <= 2; _2r += 1) { /*20674*/
				$1.j = _2r; /*20671*/
				var _2u = $get($1.encs, $1.j); /*20672*/
				$k[$j++] = _2u; /*20672*/
				if ($eq($type(_2u), "stringtype")) { /*20672*/
					var _2x = $get($k[--$j], 0); /*20672*/
					$k[$j++] = _2x; /*20672*/
				} /*20672*/
				$put($get($1.charvals, $1.j), $k[--$j], $1.i); /*20673*/
			} /*20673*/
		} /*20673*/
		$1.Avals = $get($1.charvals, 0); /*20676*/
		$1.Bvals = $get($1.charvals, 1); /*20677*/
		$put($1.Bvals, $1.m05, 97); /*20678*/
		$put($1.Bvals, $1.m06, 98); /*20679*/
		$put($1.Bvals, $1.m12, 99); /*20680*/
		$put($1.Bvals, $1.mac, 100); /*20681*/
		$1.Cvals = $get($1.charvals, 2); /*20682*/
		$k[$j++] = "BINvals"; /*20684*/
		$k[$j++] = Infinity; /*20684*/
		var _3R = $a([$1.sc2, $1.sc3, $1.sc4, $1.sc5, $1.sc6, $1.sc7, $1.tma, $1.tmb, $1.tmc, $1.tms]); /*20684*/
		$k[$j++] = 102; /*20684*/
		for (var _3S = 0, _3T = _3R.length; _3S < _3T; _3S++) { /*20684*/
			var _3W = $k[--$j] + 1; /*20684*/
			$k[$j++] = $get(_3R, _3S); /*20684*/
			$k[$j++] = _3W; /*20684*/
			$k[$j++] = _3W; /*20684*/
		} /*20684*/
		$j--; /*20684*/
		var _3X = $d(); /*20684*/
		$1[$k[--$j]] = _3X; /*20685*/
		var _3c = {
			FNC1: $1.fn1,
			FNC2: $1.fn2,
			FNC3: $1.fn3
		}; /*20690*/
		$1.fncvals = _3c; /*20691*/
		$1.msg = $a($1.barlen); /*20692*/
		$1.i = 0; /*20693*/
		$1.j = 0; /*20693*/
		for (;;) { /*20707*/
			if ($1.i == $1.barlen) { /*20694*/
				break; /*20694*/
			} /*20694*/
			$1.char = $get($1.barcode, $1.i); /*20695*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*20703*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*20701*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*20698*/
					$1.i = $1.i + 4; /*20699*/
				} else { /*20701*/
					$1.i = $1.i + 1; /*20701*/
				} /*20701*/
			} /*20701*/
			$put($1.msg, $1.j, $1.char); /*20704*/
			$1.i = $1.i + 1; /*20705*/
			$1.j = $1.j + 1; /*20706*/
		} /*20706*/
		$1.msg = $geti($1.msg, 0, $1.j); /*20708*/
		$1.msglen = $1.msg.length; /*20709*/
		$k[$j++] = Infinity; /*20712*/
		for (var _48 = 0, _49 = $1.msglen + 1; _48 < _49; _48++) { /*20712*/
			$k[$j++] = 0; /*20712*/
		} /*20712*/
		$1.nDigits = $a(); /*20712*/
		$k[$j++] = Infinity; /*20713*/
		for (var _4C = 0, _4D = $1.msglen + 1; _4C < _4D; _4C++) { /*20713*/
			$k[$j++] = false; /*20713*/
		} /*20713*/
		$1.SeventeenTen = $a(); /*20713*/
		$k[$j++] = Infinity; /*20714*/
		for (var _4G = 0, _4H = $1.msglen + 1; _4G < _4H; _4G++) { /*20714*/
			$k[$j++] = false; /*20714*/
		} /*20714*/
		$1.ECI = $a(); /*20714*/
		$k[$j++] = Infinity; /*20715*/
		for (var _4K = 0, _4L = $1.msglen + 1; _4K < _4L; _4K++) { /*20715*/
			$k[$j++] = false; /*20715*/
		} /*20715*/
		$1.DatumA = $a(); /*20715*/
		$k[$j++] = Infinity; /*20716*/
		for (var _4O = 0, _4P = $1.msglen + 1; _4O < _4P; _4O++) { /*20716*/
			$k[$j++] = false; /*20716*/
		} /*20716*/
		$1.DatumB = $a(); /*20716*/
		$k[$j++] = Infinity; /*20717*/
		for (var _4S = 0, _4T = $1.msglen + 1; _4S < _4T; _4S++) { /*20717*/
			$k[$j++] = false; /*20717*/
		} /*20717*/
		$1.DatumC = $a(); /*20717*/
		$k[$j++] = Infinity; /*20718*/
		for (var _4W = 0, _4X = $1.msglen + 8; _4W < _4X; _4W++) { /*20718*/
			$k[$j++] = false; /*20718*/
		} /*20718*/
		$1.Binary = $a(); /*20718*/
		$k[$j++] = Infinity; /*20719*/
		for (var _4a = 0, _4b = $1.msglen + 1; _4a < _4b; _4a++) { /*20719*/
			$k[$j++] = 0; /*20719*/
		} /*20719*/
		$1.AheadC = $a(); /*20719*/
		$k[$j++] = Infinity; /*20720*/
		for (var _4e = 0, _4f = $1.msglen + 1; _4e < _4f; _4e++) { /*20720*/
			$k[$j++] = 0; /*20720*/
		} /*20720*/
		$1.TryC = $a(); /*20720*/
		$k[$j++] = Infinity; /*20721*/
		for (var _4i = 0, _4j = $1.msglen + 1; _4i < _4j; _4i++) { /*20721*/
			$k[$j++] = 0; /*20721*/
		} /*20721*/
		$1.AheadA = $a(); /*20721*/
		$k[$j++] = Infinity; /*20722*/
		for (var _4m = 0, _4n = $1.msglen + 1; _4m < _4n; _4m++) { /*20722*/
			$k[$j++] = 0; /*20722*/
		} /*20722*/
		$1.AheadB = $a(); /*20722*/
		$k[$j++] = Infinity; /*20723*/
		for (var _4q = 0, _4r = $1.msglen + 1; _4q < _4r; _4q++) { /*20723*/
			$k[$j++] = 0; /*20723*/
		} /*20723*/
		$1.UntilEndSeg = $a(); /*20723*/
		for (var _4u = $1.msglen - 1; _4u >= 0; _4u -= 1) { /*20778*/
			$1.i = _4u; /*20725*/
			$1.barchar = $get($1.msg, $1.i); /*20726*/
			if (($1.barchar >= 48) && ($1.barchar <= 57)) { /*20729*/
				$put($1.nDigits, $1.i, $get($1.nDigits, $1.i + 1) + 1); /*20728*/
			} /*20728*/
			var _57 = $get($1.Avals, $1.barchar) !== undefined; /*20730*/
			if (_57) { /*20730*/
				$put($1.DatumA, $1.i, true); /*20730*/
			} /*20730*/
			var _5C = $get($1.Bvals, $1.barchar) !== undefined; /*20731*/
			if (_5C) { /*20731*/
				$put($1.DatumB, $1.i, true); /*20731*/
			} /*20731*/
			$1.CRLF = false; /*20732*/
			if (($1.barchar == 13) && ($1.i < ($1.msglen - 1))) { /*20735*/
				if ($get($1.msg, $1.i + 1) == 10) { /*20734*/
					$1.CRLF = true; /*20734*/
				} /*20734*/
			} /*20734*/
			if ($1.CRLF) { /*20736*/
				$put($1.DatumB, $1.i, true); /*20736*/
			} /*20736*/
			if ($get($1.nDigits, $1.i) >= 2) { /*20737*/
				$put($1.DatumC, $1.i, true); /*20737*/
			} /*20737*/
			if ($1.barchar < 0) { /*20738*/
				$put($1.DatumC, $1.i, true); /*20738*/
			} /*20738*/
			if ($1.barchar >= 128) { /*20739*/
				$put($1.Binary, $1.i, true); /*20739*/
			} /*20739*/
			if ($get($1.nDigits, $1.i) >= 10) { /*20753*/
				$k[$j++] = Infinity; /*20741*/
				$aload($geti($1.msg, $1.i, 10)); /*20742*/
				for (var _5f = 0, _5g = 1; _5f < _5g; _5f++) { /*20750*/
					if ($k[--$j] != 48) { /*20744*/
						$k[$j++] = false; /*20744*/
						break; /*20744*/
					} /*20744*/
					if ($k[--$j] != 49) { /*20745*/
						$k[$j++] = false; /*20745*/
						break; /*20745*/
					} /*20745*/
					$j -= 6; /*20746*/
					if ($k[--$j] != 55) { /*20747*/
						$k[$j++] = false; /*20747*/
						break; /*20747*/
					} /*20747*/
					if ($k[--$j] != 49) { /*20748*/
						$k[$j++] = false; /*20748*/
						break; /*20748*/
					} /*20748*/
					$k[$j++] = true; /*20749*/
				} /*20749*/
				$put($1.SeventeenTen, $1.i, $k[--$j]); /*20751*/
				$cleartomark(); /*20752*/
			} /*20752*/
			if (($get($1.nDigits, $1.i + 1) >= 6) && ($get($1.msg, $1.i) == $1.fn2)) { /*20756*/
				$put($1.ECI, $1.i, true); /*20755*/
			} /*20755*/
			if ($1.barchar < 0) { /*20763*/
				$put($1.AheadC, $1.i, $get($1.AheadC, $1.i + 1) + 1); /*20758*/
			} else { /*20763*/
				if ($get($1.nDigits, $1.i) <= 1) { /*20763*/
					$put($1.AheadC, $1.i, 0); /*20761*/
				} else { /*20763*/
					$put($1.AheadC, $1.i, $get($1.AheadC, $1.i + 2) + 1); /*20763*/
				} /*20763*/
			} /*20763*/
			if (($get($1.nDigits, $1.i) > 0) && $gt($get($1.AheadC, $1.i), $get($1.AheadC, $1.i + 1))) { /*20768*/
				$put($1.TryC, $1.i, $get($1.AheadC, $1.i)); /*20767*/
			} /*20767*/
			if ($get($1.DatumA, $1.i) && ($get($1.TryC, $1.i) < 2)) { /*20771*/
				$put($1.AheadA, $1.i, $get($1.AheadA, $1.i + 1) + 1); /*20770*/
			} /*20770*/
			if ($get($1.DatumB, $1.i) && ($get($1.TryC, $1.i) < 2)) { /*20774*/
				$k[$j++] = $1.AheadB; /*20773*/
				$k[$j++] = $1.i; /*20773*/
				$k[$j++] = $1.AheadB; /*20773*/
				$k[$j++] = $1.i + 1; /*20773*/
				if ($1.CRLF) { /*20773*/
					var _6n = $k[--$j]; /*20773*/
					$k[$j++] = _6n + 1; /*20773*/
				} /*20773*/
				var _6o = $k[--$j]; /*20773*/
				var _6q = $get($k[--$j], _6o); /*20773*/
				var _6r = $k[--$j]; /*20773*/
				$put($k[--$j], _6r, _6q + 1); /*20773*/
			} /*20773*/
			if ($1.barchar != $1.fn3) { /*20777*/
				$put($1.UntilEndSeg, $1.i, $get($1.UntilEndSeg, $1.i + 1) + 1); /*20776*/
			} /*20776*/
		} /*20776*/
		$1.A = 0; /*20780*/
		$1.B = 1; /*20780*/
		$1.C = 2; /*20780*/
		$1.BIN = 3; /*20780*/
		$1.addtocws = function() {
			var _70 = $k[--$j]; /*20783*/
			$puti($1.cws, $1.j, _70); /*20783*/
			$1.j = _70.length + $1.j; /*20784*/
		}; /*20785*/
		$1.base259to103 = function() {
			$1.in = $k[--$j]; /*20789*/
			$1.inlen = $1.in.length; /*20790*/
			$k[$j++] = Infinity; /*20791*/
			for (var _77 = 0, _78 = 5 - $1.inlen; _77 < _78; _77++) { /*20791*/
				$k[$j++] = 0; /*20791*/
			} /*20791*/
			$aload($1.in); /*20791*/
			$1.in = $a(); /*20791*/
			$1.out = $a(6); /*20792*/
			$k[$j++] = Infinity; /*20793*/
			$aload($geti($1.in, 0, 2)); /*20793*/
			$1.msbs = $a(); /*20793*/
			$k[$j++] = Infinity; /*20797*/
			$aload($1.msbs); /*20795*/
			var _7G = $k[--$j]; /*20795*/
			var _7H = $k[--$j]; /*20795*/
			$k[$j++] = _7G + (_7H * 259); /*20796*/
			for (var _7I = 0, _7J = 2; _7I < _7J; _7I++) { /*20796*/
				var _7K = $k[--$j]; /*20796*/
				$k[$j++] = _7K % 103; /*20796*/
				$k[$j++] = ~~(_7K / 103); /*20796*/
			} /*20796*/
			$1.mscs = $a(); /*20797*/
			$k[$j++] = Infinity; /*20798*/
			$aload($geti($1.in, 2, 3)); /*20798*/
			$1.lsbs = $a(); /*20798*/
			$k[$j++] = Infinity; /*20802*/
			$aload($1.lsbs); /*20800*/
			var _7Q = $k[--$j]; /*20800*/
			var _7R = $k[--$j]; /*20800*/
			var _7S = $k[--$j]; /*20800*/
			$k[$j++] = (_7Q + (_7R * 259)) + (_7S * 67081); /*20801*/
			for (var _7T = 0, _7U = 3; _7T < _7U; _7T++) { /*20801*/
				var _7V = $k[--$j]; /*20801*/
				$k[$j++] = _7V % 103; /*20801*/
				$k[$j++] = ~~(_7V / 103); /*20801*/
			} /*20801*/
			$1.lscs = $a(); /*20802*/
			var _7Y = $get($1.lscs, 0); /*20803*/
			var _7a = $get($1.mscs, 0); /*20803*/
			$put($1.out, 5, (_7Y + (_7a * 42)) % 103); /*20804*/
			var _7d = $get($1.lscs, 1); /*20805*/
			var _7f = $get($1.mscs, 0); /*20805*/
			var _7h = $get($1.mscs, 1); /*20805*/
			$put($1.out, 4, ((((~~((_7Y + (_7a * 42)) / 103)) + _7d) + (_7f * 68)) + (_7h * 42)) % 103); /*20806*/
			var _7k = $get($1.lscs, 2); /*20807*/
			var _7m = $get($1.mscs, 0); /*20807*/
			var _7o = $get($1.mscs, 1); /*20807*/
			var _7q = $get($1.mscs, 2); /*20807*/
			$put($1.out, 3, (((((~~(((((~~((_7Y + (_7a * 42)) / 103)) + _7d) + (_7f * 68)) + (_7h * 42)) / 103)) + _7k) + (_7m * 92)) + (_7o * 68)) + (_7q * 42)) % 103); /*20808*/
			var _7t = $get($1.lscs, 3); /*20809*/
			var _7v = $get($1.mscs, 0); /*20809*/
			var _7x = $get($1.mscs, 1); /*20809*/
			var _7z = $get($1.mscs, 2); /*20809*/
			$put($1.out, 2, (((((~~((((((~~(((((~~((_7Y + (_7a * 42)) / 103)) + _7d) + (_7f * 68)) + (_7h * 42)) / 103)) + _7k) + (_7m * 92)) + (_7o * 68)) + (_7q * 42)) / 103)) + _7t) + (_7v * 15)) + (_7x * 92)) + (_7z * 68)) % 103); /*20810*/
			var _82 = $get($1.mscs, 1); /*20811*/
			var _84 = $get($1.mscs, 2); /*20811*/
			$put($1.out, 1, (((~~((((((~~((((((~~(((((~~((_7Y + (_7a * 42)) / 103)) + _7d) + (_7f * 68)) + (_7h * 42)) / 103)) + _7k) + (_7m * 92)) + (_7o * 68)) + (_7q * 42)) / 103)) + _7t) + (_7v * 15)) + (_7x * 92)) + (_7z * 68)) / 103)) + (_82 * 15)) + (_84 * 92)) % 103); /*20812*/
			$put($1.out, 0, ((~~((((~~((((((~~((((((~~(((((~~((_7Y + (_7a * 42)) / 103)) + _7d) + (_7f * 68)) + (_7h * 42)) / 103)) + _7k) + (_7m * 92)) + (_7o * 68)) + (_7q * 42)) / 103)) + _7t) + (_7v * 15)) + (_7x * 92)) + (_7z * 68)) / 103)) + (_82 * 15)) + (_84 * 92)) / 103)) + ($get($1.mscs, 2) * 15)) % 103); /*20814*/
			$k[$j++] = $geti($1.out, (6 - $1.inlen) - 1, $1.inlen + 1); /*20815*/
		}; /*20816*/
		$1.finaliseBIN = function() {
			if ($1.bpos != 0) { /*20822*/
				$k[$j++] = $geti($1.bvals, 0, $1.bpos); /*20820*/
				if ($1.base259to103() == $b) return $b; /*20820*/
				$aload($k[--$j]); /*20820*/
				$1.bpos = 0; /*20821*/
			} /*20821*/
		}; /*20823*/
		$1.addtobin = function() {
			$put($1.bvals, $1.bpos, $k[--$j]); /*20826*/
			$1.bpos = $1.bpos + 1; /*20827*/
			if ($1.bpos == 5) { /*20828*/
				if ($1.finaliseBIN() == $b) return $b; /*20828*/
			} /*20828*/
		}; /*20829*/
		$1.ECIabc = function() {
			$k[$j++] = 0; /*20832*/
			$forall($geti($1.msg, $1.i + 1, 6), function() { /*20832*/
				var _8Q = $k[--$j]; /*20832*/
				var _8R = $k[--$j]; /*20832*/
				$k[$j++] = (_8R + (_8Q - 48)) * 10; /*20832*/
			}); /*20832*/
			var _8T = ~~($k[--$j] / 10); /*20833*/
			$k[$j++] = _8T; /*20837*/
			if (_8T >= 40) { /*20837*/
				var _8V = $k[--$j] - 40; /*20835*/
				var _8W = _8V % 12769; /*20836*/
				$k[$j++] = (~~(_8V / 12769)) + 40; /*20836*/
				$k[$j++] = ~~(_8W / 113); /*20836*/
				$k[$j++] = _8W % 113; /*20836*/
			} /*20836*/
		}; /*20838*/
		$1.ECIbin = function() {
			$k[$j++] = Infinity; /*20849*/
			$k[$j++] = 0; /*20842*/
			$forall($geti($1.msg, $1.i + 1, 6), function() { /*20842*/
				var _8a = $k[--$j]; /*20842*/
				var _8b = $k[--$j]; /*20842*/
				$k[$j++] = (_8b + (_8a - 48)) * 10; /*20842*/
			}); /*20842*/
			var _8d = ~~($k[--$j] / 10); /*20843*/
			$k[$j++] = _8d; /*20851*/
			if (_8d >= 65536) { /*20849*/
				var _8e = $k[--$j]; /*20844*/
				var _8f = _8e % 65536; /*20844*/
				$k[$j++] = 258; /*20844*/
				$k[$j++] = ~~(_8e / 65536); /*20844*/
				$k[$j++] = ~~(_8f / 256); /*20844*/
				$k[$j++] = _8f % 256; /*20844*/
			} else { /*20849*/
				var _8g = $k[--$j]; /*20846*/
				$k[$j++] = _8g; /*20850*/
				if (_8g >= 256) { /*20849*/
					var _8h = $k[--$j]; /*20847*/
					$k[$j++] = 257; /*20847*/
					$k[$j++] = ~~(_8h / 256); /*20847*/
					$k[$j++] = _8h % 256; /*20847*/
				} else { /*20849*/
					var _8i = $k[--$j]; /*20849*/
					$k[$j++] = 256; /*20849*/
					$k[$j++] = _8i; /*20849*/
				} /*20849*/
			} /*20849*/
			var _8j = $a(); /*20849*/
			for (var _8k = 0, _8l = _8j.length; _8k < _8l; _8k++) { /*20854*/
				$k[$j++] = $get(_8j, _8k); /*20853*/
				if ($1.addtobin() == $b) return $b; /*20853*/
			} /*20853*/
		}; /*20855*/
		$1.encC = function() {
			for (var _8n = 0, _8o = 1; _8n < _8o; _8n++) { /*20955*/
				if ($1.i == $1.segstart) { /*20884*/
					for (var _8r = 0, _8s = 1; _8r < _8s; _8r++) { /*20876*/
						if ($1.i > ($1.segend - 7)) { /*20861*/
							$k[$j++] = 0; /*20861*/
							break; /*20861*/
						} /*20861*/
						if ($get($1.msg, $1.segstart) != 91) { /*20862*/
							$k[$j++] = 0; /*20862*/
							break; /*20862*/
						} /*20862*/
						if ($get($1.msg, $1.segstart + 1) != 41) { /*20863*/
							$k[$j++] = 0; /*20863*/
							break; /*20863*/
						} /*20863*/
						if ($get($1.msg, $1.segstart + 2) != 62) { /*20864*/
							$k[$j++] = 0; /*20864*/
							break; /*20864*/
						} /*20864*/
						if ($get($1.msg, $1.segstart + 3) != 30) { /*20865*/
							$k[$j++] = 0; /*20865*/
							break; /*20865*/
						} /*20865*/
						var _99 = $get($1.msg, $1.segstart + 4); /*20866*/
						if ((_99 < 48) || (_99 > 57)) { /*20866*/
							$k[$j++] = 0; /*20866*/
							break; /*20866*/
						} /*20866*/
						var _9C = $get($1.msg, $1.segstart + 5); /*20867*/
						if ((_9C < 48) || (_9C > 57)) { /*20867*/
							$k[$j++] = 0; /*20867*/
							break; /*20867*/
						} /*20867*/
						if ($get($1.msg, $1.segend - 1) != 4) { /*20868*/
							$k[$j++] = 0; /*20868*/
							break; /*20868*/
						} /*20868*/
						var _9M = (($get($1.msg, $1.segstart + 4) - 48) * 10) + ($get($1.msg, $1.segstart + 5) - 48); /*20870*/
						$k[$j++] = _9M; /*20870*/
						if ((_9M != 5) && ((_9M != 6) && (_9M != 12))) { /*20870*/
							$j--; /*20870*/
							$k[$j++] = $1.mac; /*20870*/
							break; /*20870*/
						} /*20870*/
						if ($get($1.msg, $1.segstart + 6) != 29) { /*20871*/
							$j--; /*20871*/
							$k[$j++] = 0; /*20871*/
							break; /*20871*/
						} /*20871*/
						if ($get($1.msg, $1.segend - 2) != 30) { /*20872*/
							$j--; /*20872*/
							$k[$j++] = 0; /*20872*/
							break; /*20872*/
						} /*20872*/
						var _9U = $k[--$j]; /*20873*/
						$k[$j++] = _9U; /*20873*/
						if (_9U == 5) { /*20873*/
							$j--; /*20873*/
							$k[$j++] = $1.m05; /*20873*/
							break; /*20873*/
						} /*20873*/
						if ($k[--$j] == 6) { /*20874*/
							$k[$j++] = $1.m06; /*20874*/
							break; /*20874*/
						} /*20874*/
						$k[$j++] = $1.m12; /*20875*/
						break; /*20875*/
					} /*20875*/
					$1.inmac = $k[--$j]; /*20877*/
					if ($1.inmac != 0) { /*20883*/
						$1.mode = $1.B; /*20879*/
						$k[$j++] = $a([$get($1.Bvals, $1.inmac)]); /*20880*/
						if ($1.addtocws() == $b) break; /*20880*/
						var _9j = ($1.inmac != $1.mac) ? 7 : 6; /*20881*/
						$1.i = $1.i + _9j; /*20881*/
						break; /*20882*/
					} /*20882*/
				} /*20882*/
				if ($get($1.SeventeenTen, $1.i)) { /*20894*/
					$k[$j++] = $a([$get($1.Cvals, $1.aim), (($get($1.msg, $1.i + 2) - 48) * 10) + ($get($1.msg, $1.i + 3) - 48), (($get($1.msg, $1.i + 4) - 48) * 10) + ($get($1.msg, $1.i + 5) - 48), (($get($1.msg, $1.i + 6) - 48) * 10) + ($get($1.msg, $1.i + 7) - 48)]); /*20891*/
					if ($1.addtocws() == $b) break; /*20891*/
					$1.i = $1.i + 10; /*20892*/
					break; /*20893*/
				} /*20893*/
				if ($get($1.DatumC, $1.i)) { /*20916*/
					var _AF = $get($1.msg, $1.i); /*20896*/
					if ((_AF == $1.fn1) || ((_AF == $1.fn2) || (_AF == $1.fn3))) { /*20912*/
						$k[$j++] = $a([$get($1.Cvals, $get($1.msg, $1.i))]); /*20897*/
						if ($1.addtocws() == $b) break; /*20897*/
						if ($get($1.ECI, $1.i)) { /*20902*/
							$k[$j++] = Infinity; /*20899*/
							if ($1.ECIabc() == $b) break; /*20899*/
							var _AS = $a(); /*20899*/
							$k[$j++] = _AS; /*20899*/
							if ($1.addtocws() == $b) break; /*20899*/
							$1.i = $1.i + 7; /*20900*/
							break; /*20901*/
						} /*20901*/
						if (($get($1.msg, $1.i) == $1.fn3) && ($1.segstart != $1.i)) { /*20909*/
							$1.i = $1.i + 1; /*20904*/
							$1.inmac = 0; /*20905*/
							$1.segstart = $1.i; /*20906*/
							$1.segend = $1.i + $get($1.UntilEndSeg, $1.i); /*20907*/
							break; /*20908*/
						} /*20908*/
						$1.i = $1.i + 1; /*20910*/
						break; /*20911*/
					} /*20911*/
					$k[$j++] = $a([(($get($1.msg, $1.i) - 48) * 10) + ($get($1.msg, $1.i + 1) - 48)]); /*20913*/
					if ($1.addtocws() == $b) break; /*20913*/
					$1.i = $1.i + 2; /*20914*/
					break; /*20915*/
				} /*20915*/
				if ($get($1.Binary, $1.i)) { /*20930*/
					if ($get($1.nDigits, $1.i + 1) > 0) { /*20926*/
						if ($get($1.msg, $1.i) < 160) { /*20922*/
							$k[$j++] = $a([$get($1.Cvals, $1.bsa), $get($1.Avals, $get($1.msg, $1.i) - 128)]); /*20920*/
							if ($1.addtocws() == $b) break; /*20920*/
						} else { /*20922*/
							$k[$j++] = $a([$get($1.Cvals, $1.bsb), $get($1.Bvals, $get($1.msg, $1.i) - 128)]); /*20922*/
							if ($1.addtocws() == $b) break; /*20922*/
						} /*20922*/
						$1.i = $1.i + 1; /*20924*/
						break; /*20925*/
					} /*20925*/
					$k[$j++] = $a([$get($1.Cvals, $1.bin)]); /*20927*/
					if ($1.addtocws() == $b) break; /*20927*/
					$1.mode = $1.BIN; /*20928*/
					break; /*20929*/
				} /*20929*/
				$1.m = $get($1.AheadA, $1.i); /*20931*/
				$1.n = $get($1.AheadB, $1.i); /*20931*/
				if ($gt($1.m, $1.n)) { /*20936*/
					$k[$j++] = $a([$get($1.Cvals, $1.laa)]); /*20933*/
					if ($1.addtocws() == $b) break; /*20933*/
					$1.mode = $1.A; /*20934*/
					break; /*20935*/
				} /*20935*/
				if ($1.i == $1.segstart) { /*20943*/
					var _Bd = $get($1.msg, $1.i); /*20938*/
					if ((_Bd == 9) || ((_Bd == 28) || ((_Bd == 29) || (_Bd == 30)))) { /*20942*/
						$k[$j++] = $a([$get($1.Cvals, $1.laa)]); /*20939*/
						if ($1.addtocws() == $b) break; /*20939*/
						$1.mode = $1.A; /*20940*/
						break; /*20941*/
					} /*20941*/
				} /*20941*/
				if ($1.n > 4) { /*20948*/
					$k[$j++] = $a([$get($1.Cvals, $1.lab)]); /*20945*/
					if ($1.addtocws() == $b) break; /*20945*/
					$1.mode = $1.B; /*20946*/
					break; /*20947*/
				} /*20947*/
				$k[$j++] = $a([$get($1.Cvals, $get($a([$1.sfb, $1.sb2, $1.sb3, $1.sb4]), $1.n - 1))]); /*20949*/
				if ($1.addtocws() == $b) break; /*20949*/
				for (var _C0 = 0, _C1 = $1.n; _C0 < _C1; _C0++) { /*20953*/
					$k[$j++] = $a([$get($1.Bvals, $get($1.msg, $1.i))]); /*20951*/
					if ($1.addtocws() == $b) break; /*20951*/
					$1.i = $1.i + 1; /*20952*/
				} /*20952*/
				break; /*20954*/
			} /*20954*/
		}; /*20956*/
		$1.encB = function() {
			for (var _C9 = 0, _CA = 1; _C9 < _CA; _C9++) { /*21031*/
				$1.n = $get($1.TryC, $1.i); /*20960*/
				if ($1.n >= 2) { /*20978*/
					if ($1.n > 4) { /*20966*/
						$k[$j++] = $a([$get($1.Bvals, $1.lac)]); /*20963*/
						if ($1.addtocws() == $b) break; /*20963*/
						$1.mode = $1.C; /*20964*/
						break; /*20965*/
					} /*20965*/
					$k[$j++] = $a([$get($1.Bvals, $get($a([$1.sfc, $1.sc2, $1.sc3, $1.sc4]), $1.n - 1))]); /*20967*/
					if ($1.addtocws() == $b) break; /*20967*/
					for (var _CW = 0, _CX = $1.n; _CW < _CX; _CW++) { /*20976*/
						if ($get($1.msg, $1.i) < 0) { /*20974*/
							$k[$j++] = $a([$get($1.Cvals, $get($1.msg, $1.i))]); /*20970*/
							if ($1.addtocws() == $b) break; /*20970*/
							$1.i = $1.i + 1; /*20971*/
						} else { /*20974*/
							$k[$j++] = $a([(($get($1.msg, $1.i) - 48) * 10) + ($get($1.msg, $1.i + 1) - 48)]); /*20973*/
							if ($1.addtocws() == $b) break; /*20973*/
							$1.i = $1.i + 2; /*20974*/
						} /*20974*/
					} /*20974*/
					break; /*20977*/
				} /*20977*/
				if ($get($1.DatumB, $1.i)) { /*21008*/
					var _Cv = $get($1.msg, $1.i); /*20980*/
					if ((_Cv == $1.fn1) || ((_Cv == $1.fn2) || (_Cv == $1.fn3))) { /*20997*/
						$k[$j++] = $a([$get($1.Bvals, $get($1.msg, $1.i))]); /*20981*/
						if ($1.addtocws() == $b) break; /*20981*/
						if ($get($1.ECI, $1.i)) { /*20986*/
							$k[$j++] = Infinity; /*20983*/
							if ($1.ECIabc() == $b) break; /*20983*/
							var _D8 = $a(); /*20983*/
							$k[$j++] = _D8; /*20983*/
							if ($1.addtocws() == $b) break; /*20983*/
							$1.i = $1.i + 7; /*20984*/
							break; /*20985*/
						} /*20985*/
						if (($get($1.msg, $1.i) == $1.fn3) && ($1.i != $1.segstart)) { /*20994*/
							$1.i = $1.i + 1; /*20988*/
							$1.mode = $1.C; /*20989*/
							$1.inmac = 0; /*20990*/
							$1.segstart = $1.i; /*20991*/
							$1.segend = $1.i + $get($1.UntilEndSeg, $1.i); /*20992*/
							break; /*20993*/
						} /*20993*/
						$1.i = $1.i + 1; /*20995*/
						break; /*20996*/
					} /*20996*/
					if (($get($1.msg, $1.i) == 13) && ($1.i < ($1.msglen - 1))) { /*21004*/
						if ($get($1.msg, $1.i + 1) == 10) { /*21003*/
							$k[$j++] = $a([$get($1.Bvals, $1.crl)]); /*21000*/
							if ($1.addtocws() == $b) break; /*21000*/
							$1.i = $1.i + 2; /*21001*/
							break; /*21002*/
						} /*21002*/
					} /*21002*/
					$k[$j++] = $a([$get($1.Bvals, $get($1.msg, $1.i))]); /*21005*/
					if ($1.addtocws() == $b) break; /*21005*/
					$1.i = $1.i + 1; /*21006*/
					break; /*21007*/
				} /*21007*/
				if ($get($1.Binary, $1.i)) { /*21022*/
					if ($get($1.DatumB, $1.i + 1)) { /*21018*/
						if ($get($1.msg, $1.i) < 160) { /*21014*/
							$k[$j++] = $a([$get($1.Bvals, $1.bsa), $get($1.Avals, $get($1.msg, $1.i) - 128)]); /*21012*/
							if ($1.addtocws() == $b) break; /*21012*/
						} else { /*21014*/
							$k[$j++] = $a([$get($1.Bvals, $1.bsb), $get($1.Bvals, $get($1.msg, $1.i) - 128)]); /*21014*/
							if ($1.addtocws() == $b) break; /*21014*/
						} /*21014*/
						$1.i = $1.i + 1; /*21016*/
						break; /*21017*/
					} /*21017*/
					$k[$j++] = $a([$get($1.Bvals, $1.bin)]); /*21019*/
					if ($1.addtocws() == $b) break; /*21019*/
					$1.mode = $1.BIN; /*21020*/
					break; /*21021*/
				} /*21021*/
				if ($get($1.AheadA, $1.i) == 1) { /*21027*/
					$k[$j++] = $a([$get($1.Bvals, $1.sfa), $get($1.Avals, $get($1.msg, $1.i))]); /*21024*/
					if ($1.addtocws() == $b) break; /*21024*/
					$1.i = $1.i + 1; /*21025*/
					break; /*21026*/
				} /*21026*/
				$k[$j++] = $a([$get($1.Bvals, $1.laa)]); /*21028*/
				if ($1.addtocws() == $b) break; /*21028*/
				$1.mode = $1.A; /*21029*/
				break; /*21030*/
			} /*21030*/
		}; /*21032*/
		$1.encA = function() {
			for (var _EX = 0, _EY = 1; _EX < _EY; _EX++) { /*21103*/
				$1.n = $get($1.TryC, $1.i); /*21036*/
				if ($1.n >= 2) { /*21054*/
					if ($1.n > 4) { /*21042*/
						$k[$j++] = $a([$get($1.Avals, $1.lac)]); /*21039*/
						if ($1.addtocws() == $b) break; /*21039*/
						$1.mode = $1.C; /*21040*/
						break; /*21041*/
					} /*21041*/
					$k[$j++] = $a([$get($1.Avals, $get($a([$1.sfc, $1.sc2, $1.sc3, $1.sc4]), $1.n - 1))]); /*21043*/
					if ($1.addtocws() == $b) break; /*21043*/
					for (var _Eu = 0, _Ev = $1.n; _Eu < _Ev; _Eu++) { /*21052*/
						if ($get($1.msg, $1.i) < 0) { /*21050*/
							$k[$j++] = $a([$get($1.Cvals, $get($1.msg, $1.i))]); /*21046*/
							if ($1.addtocws() == $b) break; /*21046*/
							$1.i = $1.i + 1; /*21047*/
						} else { /*21050*/
							$k[$j++] = $a([(($get($1.msg, $1.i) - 48) * 10) + ($get($1.msg, $1.i + 1) - 48)]); /*21049*/
							if ($1.addtocws() == $b) break; /*21049*/
							$1.i = $1.i + 2; /*21050*/
						} /*21050*/
					} /*21050*/
					break; /*21053*/
				} /*21053*/
				if ($get($1.DatumA, $1.i)) { /*21076*/
					var _FJ = $get($1.msg, $1.i); /*21056*/
					if ((_FJ == $1.fn1) || ((_FJ == $1.fn2) || (_FJ == $1.fn3))) { /*21072*/
						$k[$j++] = $a([$get($1.Avals, $get($1.msg, $1.i))]); /*21057*/
						if ($1.addtocws() == $b) break; /*21057*/
						if ($get($1.ECI, $1.i)) { /*21062*/
							$k[$j++] = Infinity; /*21059*/
							if ($1.ECIabc() == $b) break; /*21059*/
							var _FW = $a(); /*21059*/
							$k[$j++] = _FW; /*21059*/
							if ($1.addtocws() == $b) break; /*21059*/
							$1.i = $1.i + 7; /*21060*/
							break; /*21061*/
						} /*21061*/
						if (($get($1.msg, $1.i) == $1.fn3) && ($1.i != $1.segstart)) { /*21069*/
							$1.i = $1.i + 1; /*21064*/
							$1.mode = $1.C; /*21065*/
							$1.inmac = 0; /*21066*/
							$1.segstart = $1.i; /*21067*/
							$1.segend = $1.i + $get($1.UntilEndSeg, $1.i); /*21068*/
						} /*21068*/
						$1.i = $1.i + 1; /*21070*/
						break; /*21071*/
					} /*21071*/
					$k[$j++] = $a([$get($1.Avals, $get($1.msg, $1.i))]); /*21073*/
					if ($1.addtocws() == $b) break; /*21073*/
					$1.i = $1.i + 1; /*21074*/
					break; /*21075*/
				} /*21075*/
				if ($get($1.Binary, $1.i)) { /*21090*/
					if ($get($1.DatumA, $1.i + 1)) { /*21086*/
						if ($get($1.msg, $1.i) < 160) { /*21082*/
							$k[$j++] = $a([$get($1.Avals, $1.bsa), $get($1.Avals, $get($1.msg, $1.i) - 128)]); /*21080*/
							if ($1.addtocws() == $b) break; /*21080*/
						} else { /*21082*/
							$k[$j++] = $a([$get($1.Avals, $1.bsb), $get($1.Bvals, $get($1.msg, $1.i) - 128)]); /*21082*/
							if ($1.addtocws() == $b) break; /*21082*/
						} /*21082*/
						$1.i = $1.i + 1; /*21084*/
						break; /*21085*/
					} /*21085*/
					$k[$j++] = $a([$get($1.Avals, $1.bin)]); /*21087*/
					if ($1.addtocws() == $b) break; /*21087*/
					$1.mode = $1.BIN; /*21088*/
					break; /*21089*/
				} /*21089*/
				$1.n = $get($1.AheadB, $1.i); /*21091*/
				if ($1.n > 6) { /*21096*/
					$k[$j++] = $a([$get($1.Avals, $1.lab)]); /*21093*/
					if ($1.addtocws() == $b) break; /*21093*/
					$1.mode = $1.B; /*21094*/
					break; /*21095*/
				} /*21095*/
				$k[$j++] = $a([$get($1.Avals, $get($a([$1.sfb, $1.sb2, $1.sb3, $1.sb4, $1.sb5, $1.sb6]), $1.n - 1))]); /*21097*/
				if ($1.addtocws() == $b) break; /*21097*/
				for (var _Gm = 0, _Gn = $1.n; _Gm < _Gn; _Gm++) { /*21101*/
					$k[$j++] = $a([$get($1.Bvals, $get($1.msg, $1.i))]); /*21099*/
					if ($1.addtocws() == $b) break; /*21099*/
					$1.i = $1.i + 1; /*21100*/
				} /*21100*/
				break; /*21102*/
			} /*21102*/
		}; /*21104*/
		$1.encBIN = function() {
			for (var _Gv = 0, _Gw = 1; _Gv < _Gw; _Gv++) { /*21165*/
				$1.n = $get($1.TryC, $1.i); /*21108*/
				if ($1.n >= 2) { /*21127*/
					$k[$j++] = Infinity; /*21110*/
					if ($1.finaliseBIN() == $b) break; /*21110*/
					var _H1 = $a(); /*21110*/
					$k[$j++] = _H1; /*21110*/
					if ($1.addtocws() == $b) break; /*21110*/
					if ($1.n > 7) { /*21115*/
						var _H7 = $k[--$j]; /*21112*/
						$1.mode = $1.C; /*21113*/
						$k[$j++] = _H7 + $a([$get($1.BINvals, $1.tmc)]); /*21114*/
						break; /*21114*/
					} /*21114*/
					$k[$j++] = $a([$get($1.BINvals, $get($a([$1.sc2, $1.sc3, $1.sc4, $1.sc5, $1.sc6, $1.sc7]), $1.n - 2))]); /*21116*/
					if ($1.addtocws() == $b) break; /*21116*/
					for (var _HM = 0, _HN = $1.n; _HM < _HN; _HM++) { /*21125*/
						if ($get($1.msg, $1.i) < 0) { /*21123*/
							$k[$j++] = $a([$get($1.Cvals, $get($1.msg, $1.i))]); /*21119*/
							if ($1.addtocws() == $b) break; /*21119*/
							$1.i = $1.i + 1; /*21120*/
						} else { /*21123*/
							$k[$j++] = $a([(($get($1.msg, $1.i) - 48) * 10) + ($get($1.msg, $1.i + 1) - 48)]); /*21122*/
							if ($1.addtocws() == $b) break; /*21122*/
							$1.i = $1.i + 2; /*21123*/
						} /*21123*/
					} /*21123*/
					break; /*21126*/
				} /*21126*/
				if (($get($1.ECI, $1.i) && $get($1.Binary, $1.i + 7))) { /*21133*/
					$k[$j++] = Infinity; /*21129*/
					if ($1.ECIbin() == $b) break; /*21129*/
					var _Hm = $a(); /*21129*/
					$k[$j++] = _Hm; /*21129*/
					if ($1.addtocws() == $b) break; /*21129*/
					$1.i = $1.i + 7; /*21130*/
					if ($1.i == $1.msglen) { /*21131*/
						$k[$j++] = Infinity; /*21131*/
						if ($1.finaliseBIN() == $b) break; /*21131*/
						var _Hq = $a(); /*21131*/
						$k[$j++] = _Hq; /*21131*/
						if ($1.addtocws() == $b) break; /*21131*/
					} /*21131*/
					break; /*21132*/
				} /*21132*/
				if ($get($1.msg, $1.i) >= 0) { /*21143*/
					if (((($get($1.Binary, $1.i) || $get($1.Binary, $1.i + 1)) || $get($1.Binary, $1.i + 2)) || $get($1.Binary, $1.i + 3)) || ($get($1.ECI, $1.i + 1) && $get($1.Binary, $1.i + 8))) { /*21142*/
						$k[$j++] = Infinity; /*21138*/
						$k[$j++] = $get($1.msg, $1.i); /*21138*/
						if ($1.addtobin() == $b) break; /*21138*/
						var _IF = $a(); /*21138*/
						$k[$j++] = _IF; /*21138*/
						if ($1.addtocws() == $b) break; /*21138*/
						$1.i = $1.i + 1; /*21139*/
						if ($1.i == $1.msglen) { /*21140*/
							$k[$j++] = Infinity; /*21140*/
							if ($1.finaliseBIN() == $b) break; /*21140*/
							var _IJ = $a(); /*21140*/
							$k[$j++] = _IJ; /*21140*/
							if ($1.addtocws() == $b) break; /*21140*/
						} /*21140*/
						break; /*21141*/
					} /*21141*/
				} /*21141*/
				$k[$j++] = Infinity; /*21144*/
				if ($1.finaliseBIN() == $b) break; /*21144*/
				var _IK = $a(); /*21144*/
				$k[$j++] = _IK; /*21144*/
				if ($1.addtocws() == $b) break; /*21144*/
				if ($1.i != ($1.msglen - 1)) { /*21163*/
					if (($get($1.msg, $1.i) == $1.fn3) && ($1.i != $1.segstart)) { /*21154*/
						$k[$j++] = $a([$get($1.BINvals, $1.tms)]); /*21147*/
						if ($1.addtocws() == $b) break; /*21147*/
						$1.i = $1.i + 1; /*21148*/
						$1.mode = $1.C; /*21149*/
						$1.inmac = 0; /*21150*/
						$1.segstart = $1.i; /*21151*/
						$1.segend = $1.i + $get($1.UntilEndSeg, $1.i); /*21152*/
						break; /*21153*/
					} /*21153*/
					if ($gt($get($1.AheadA, $1.i), $get($1.AheadB, $1.i))) { /*21160*/
						$k[$j++] = $a([$get($1.BINvals, $1.tma)]); /*21156*/
						if ($1.addtocws() == $b) break; /*21156*/
						$1.mode = $1.A; /*21157*/
					} else { /*21160*/
						$k[$j++] = $a([$get($1.BINvals, $1.tmb)]); /*21159*/
						if ($1.addtocws() == $b) break; /*21159*/
						$1.mode = $1.B; /*21160*/
					} /*21160*/
					break; /*21162*/
				} /*21162*/
				break; /*21164*/
			} /*21164*/
		}; /*21166*/
		$1.cws = $a(($1.barlen * 2) + 1); /*21168*/
		$1.mode = $1.C; /*21169*/
		$1.bvals = $a(5); /*21170*/
		$1.bpos = 0; /*21170*/
		$1.inmac = 0; /*21171*/
		$1.segstart = 0; /*21171*/
		$1.segend = $get($1.UntilEndSeg, 0); /*21171*/
		$1.i = 0; /*21172*/
		$1.j = 0; /*21172*/
		for (;;) { /*21185*/
			if ($1.i >= $1.msglen) { /*21173*/
				break; /*21173*/
			} /*21173*/
			if ($1.inmac != 0) { /*21183*/
				if (($1.inmac != $1.mac) && ($1.i == ($1.segend - 2))) { /*21178*/
					$1.i = $1.i + 2; /*21176*/
					if ($1.i >= $1.msglen) { /*21177*/
						break; /*21177*/
					} /*21177*/
				} /*21177*/
				if (($1.inmac == $1.mac) && ($1.i == ($1.segend - 1))) { /*21182*/
					$1.i = $1.i + 1; /*21180*/
					if ($1.i >= $1.msglen) { /*21181*/
						break; /*21181*/
					} /*21181*/
				} /*21181*/
			} /*21181*/
			$1[$get($a(["encA", "encB", "encC", "encBIN"]), $1.mode)](); /*21184*/
		} /*21184*/
		$1.cws = $geti($1.cws, 0, $1.j); /*21186*/
		$1.nd = $1.cws.length; /*21189*/
		$1.minarea = (((($1.nd + 3) + (~~($1.nd / 2))) * 9) + 2) * 2; /*21190*/
		if ($1.ratio != -1) { /*21218*/
			$1.hgt = Math.sqrt($1.minarea / $1.ratio); /*21192*/
			$1.wid = Math.sqrt($1.minarea * $1.ratio); /*21193*/
			$1.h = ~~$1.hgt; /*21194*/
			$1.w = ~~$1.wid; /*21194*/
			if ((($1.h + $1.w) % 2) == 1) { /*21208*/
				if (($1.h * $1.w) < $1.minarea) { /*21196*/
					$1.h = $1.h + 1; /*21196*/
					$1.w = $1.w + 1; /*21196*/
				} /*21196*/
			} else { /*21208*/
				if (($1.hgt * $1.w) < ($1.wid * $1.h)) { /*21208*/
					$1.w = $1.w + 1; /*21199*/
					if (($1.h * $1.w) < $1.minarea) { /*21203*/
						$1.w = $1.w - 1; /*21201*/
						$1.h = $1.h + 1; /*21201*/
						if (($1.h * $1.w) < $1.minarea) { /*21202*/
							$1.w = $1.w + 2; /*21202*/
						} /*21202*/
					} /*21202*/
				} else { /*21208*/
					$1.h = $1.h + 1; /*21205*/
					if (($1.h * $1.w) < $1.minarea) { /*21209*/
						$1.h = $1.h - 1; /*21207*/
						$1.w = $1.w + 1; /*21207*/
						if (($1.h * $1.w) < $1.minarea) { /*21208*/
							$1.h = $1.h + 2; /*21208*/
						} /*21208*/
					} /*21208*/
				} /*21208*/
			} /*21208*/
			$1.rows = $1.h; /*21212*/
			$1.columns = $1.w; /*21212*/
		} else { /*21218*/
			if ($1.columns == -1) { /*21216*/
				var _K9 = ~~((($1.minarea + $1.rows) - 1) / $1.rows); /*21215*/
				$k[$j++] = "columns"; /*21215*/
				$k[$j++] = _K9; /*21215*/
				if (((_K9 + $1.rows) % 2) == 0) { /*21215*/
					var _KB = $k[--$j]; /*21215*/
					$k[$j++] = _KB + 1; /*21215*/
				} /*21215*/
				var _KC = $k[--$j]; /*21215*/
				$1[$k[--$j]] = _KC; /*21215*/
			} /*21215*/
			if ($1.rows == -1) { /*21219*/
				var _KI = ~~((($1.minarea + $1.columns) - 1) / $1.columns); /*21218*/
				$k[$j++] = "rows"; /*21218*/
				$k[$j++] = _KI; /*21218*/
				if (((_KI + $1.columns) % 2) == 0) { /*21218*/
					var _KK = $k[--$j]; /*21218*/
					$k[$j++] = _KK + 1; /*21218*/
				} /*21218*/
				var _KL = $k[--$j]; /*21218*/
				$1[$k[--$j]] = _KL; /*21218*/
			} /*21218*/
		} /*21218*/
		$1.ndots = ~~(($1.rows * $1.columns) / 2); /*21223*/
		for (;;) { /*21227*/
			var _KQ = $1.nd + 1; /*21225*/
			if ((((_KQ + ((~~(_KQ / 2)) + 3)) * 9) + 2) > $1.ndots) { /*21225*/
				break; /*21225*/
			} /*21225*/
			$1.nd = $1.nd + 1; /*21226*/
		} /*21226*/
		$1.nc = (~~($1.nd / 2)) + 3; /*21228*/
		$1.nw = $1.nd + $1.nc; /*21229*/
		$1.rembits = $1.ndots - (($1.nw * 9) + 2); /*21230*/
		if ($1.nd > $1.cws.length) { /*21237*/
			$k[$j++] = Infinity; /*21236*/
			$aload($1.cws); /*21233*/
			var _Kd = ($1.mode == $1.BIN) ? 109 : 106; /*21234*/
			$k[$j++] = _Kd; /*21235*/
			for (var _Kg = 0, _Kh = ($1.nd - $1.cws.length) - 1; _Kg < _Kh; _Kg++) { /*21235*/
				$k[$j++] = 106; /*21235*/
			} /*21235*/
			$1.cws = $a(); /*21236*/
		} /*21236*/
		$1.encs = $a(["101010101", "010101011", "010101101", "010110101", "011010101", "101010110", "101011010", "101101010", "110101010", "010101110", "010110110", "010111010", "011010110", "011011010", "011101010", "100101011", "100101101", "100110101", "101001011", "101001101", "101010011", "101011001", "101100101", "101101001", "110010101", "110100101", "110101001", "001010111", "001011011", "001011101", "001101011", "001101101", "001110101", "010010111", "010011011", "010011101", "010100111", "010110011", "010111001", "011001011", "011001101", "011010011", "011011001", "011100101", "011101001", "100101110", "100110110", "100111010", "101001110", "101011100", "101100110", "101101100", "101110010", "101110100", "110010110", "110011010", "110100110", "110101100", "110110010", "110110100", "111001010", "111010010", "111010100", "001011110", "001101110", "001110110", "001111010", "010011110", "010111100", "011001110", "011011100", "011100110", "011101100", "011110010", "011110100", "100010111", "100011011", "100011101", "100100111", "100110011", "100111001", "101000111", "101100011", "101110001", "110001011", "110001101", "110010011", "110011001", "110100011", "110110001", "111000101", "111001001", "111010001", "000101111", "000110111", "000111011", "000111101", "001001111", "001100111", "001110011", "001111001", "010001111", "011000111", "011100011", "011110001", "100011110", "100111100", "101111000", "110001110", "110011100", "110111000", "111000110", "111001100"]); /*21264*/
		if (($1.rows % 2) == 0) { /*21284*/
			$1.sixedges = $a([$a([$1.columns - 1, $1.rows - 2]), $a([0, $1.rows - 2]), $a([$1.columns - 2, $1.rows - 1]), $a([1, $1.rows - 1]), $a([$1.columns - 1, 0]), $a([0, 0])]); /*21275*/
		} else { /*21284*/
			$1.sixedges = $a([$a([$1.columns - 2, 0]), $a([$1.columns - 2, $1.rows - 1]), $a([$1.columns - 1, 1]), $a([$1.columns - 1, $1.rows - 2]), $a([0, 0]), $a([0, $1.rows - 1])]); /*21284*/
		} /*21284*/
		$1.dmv = function() {
			var _LE = $k[--$j]; /*21287*/
			var _LF = $k[--$j]; /*21287*/
			$k[$j++] = _LF + (_LE * $1.columns); /*21287*/
		}; /*21287*/
		$1.outline = $a($1.rows * $1.columns); /*21290*/
		for (var _LL = 0, _LK = $1.rows - 1; _LL <= _LK; _LL += 1) { /*21297*/
			$1.y = _LL; /*21292*/
			for (var _LO = 0, _LN = $1.columns - 1; _LO <= _LN; _LO += 1) { /*21296*/
				$1.x = _LO; /*21294*/
				$k[$j++] = $1.outline; /*21295*/
				$k[$j++] = $1.x; /*21295*/
				$k[$j++] = $1.y; /*21295*/
				if ($1.dmv() == $b) break; /*21295*/
				var _LU = $k[--$j]; /*21295*/
				$put($k[--$j], _LU, (($1.x + $1.y) % 2) - 1); /*21295*/
			} /*21295*/
		} /*21295*/
		var _LW = $1.sixedges; /*21298*/
		for (var _LX = 0, _LY = _LW.length; _LX < _LY; _LX++) { /*21300*/
			$k[$j++] = $1.outline; /*21299*/
			$aload($get(_LW, _LX)); /*21299*/
			if ($1.dmv() == $b) return $b; /*21299*/
			var _Lb = $k[--$j]; /*21299*/
			$put($k[--$j], _Lb, 1); /*21299*/
		} /*21299*/
		$1.clearcol = function() {
			$1.x = $k[--$j]; /*21303*/
			$k[$j++] = true; /*21307*/
			for (var _Lh = $1.x & 1, _Lg = $1.rows - 1; _Lh <= _Lg; _Lh += 2) { /*21307*/
				$k[$j++] = $1.x; /*21306*/
				$k[$j++] = _Lh; /*21306*/
				if ($1.dmv() == $b) break; /*21306*/
				if ($get($1.sym, $k[--$j]) == 1) { /*21306*/
					$j--; /*21306*/
					$k[$j++] = false; /*21306*/
					break; /*21306*/
				} /*21306*/
			} /*21306*/
		}; /*21308*/
		$1.clearrow = function() {
			$1.y = $k[--$j]; /*21311*/
			$k[$j++] = true; /*21315*/
			for (var _Lq = $1.y & 1, _Lp = $1.columns - 1; _Lq <= _Lp; _Lq += 2) { /*21315*/
				$k[$j++] = _Lq; /*21314*/
				$k[$j++] = $1.y; /*21314*/
				if ($1.dmv() == $b) break; /*21314*/
				if ($get($1.sym, $k[--$j]) == 1) { /*21314*/
					$j--; /*21314*/
					$k[$j++] = false; /*21314*/
					break; /*21314*/
				} /*21314*/
			} /*21314*/
		}; /*21316*/
		$1.evalsymbol = function() {
			$1.sym = $k[--$j]; /*21320*/
			$1.worst = 9999999; /*21323*/
			var _M0 = $a([$a(["x", 0]), $a(["x", 1]), $a(["y", 0]), $a(["y", 1])]); /*21324*/
			for (var _M1 = 0, _M2 = _M0.length; _M1 < _M2; _M1++) { /*21342*/
				$aload($get(_M0, _M1)); /*21325*/
				$1.fl = $k[--$j]; /*21325*/
				$1.dir = $k[--$j]; /*21325*/
				$1.sum = 0; /*21326*/
				$1.first = -1; /*21326*/
				$1.last = -1; /*21326*/
				var _M7 = $eq($1.dir, "x") ? $1.columns : $1.rows; /*21327*/
				for (var _M9 = 0, _M8 = _M7 - 1; _M9 <= _M8; _M9 += 1) { /*21338*/
					$1[$1.dir] = _M9; /*21328*/
					var _MB = $1.sym; /*21329*/
					var _MD = $1[$1.dir]; /*21330*/
					var _MF = $eq($1.dir, "x") ? $1.rows : $1.columns; /*21331*/
					var _MI = (_MF - 1) * $1.fl; /*21332*/
					if ($eq($1.dir, "y")) { /*21332*/
						var _ = _MI; /*21332*/
						_MI = _MD; /*21332*/
						_MD = _; /*21332*/
					} /*21332*/
					$k[$j++] = _MB; /*21333*/
					$k[$j++] = _MD; /*21333*/
					$k[$j++] = _MI; /*21333*/
					if ($1.dmv() == $b) break; /*21333*/
					var _MJ = $k[--$j]; /*21333*/
					if ($get($k[--$j], _MJ) == 1) { /*21337*/
						if ($1.first == -1) { /*21334*/
							$1.first = $1[$1.dir]; /*21334*/
						} /*21334*/
						$1.last = $1[$1.dir]; /*21335*/
						$1.sum = $1.sum + 1; /*21336*/
					} /*21336*/
				} /*21336*/
				var _MW = $eq($1.dir, "x") ? $1.rows : $1.columns; /*21340*/
				var _MX = (($1.sum + $1.last) - $1.first) * _MW; /*21341*/
				$k[$j++] = _MX; /*21341*/
				if (_MX < $1.worst) { /*21341*/
					$1.worst = $k[--$j]; /*21341*/
				} else { /*21341*/
					$j--; /*21341*/
				} /*21341*/
			} /*21341*/
			$1.pen = 0; /*21344*/
			if ((($1.rows % 2) == 1) || ($1.rows <= 12)) { /*21362*/
				$1.sum = 0; /*21350*/
				$1.p = 0; /*21350*/
				for (var _Me = 1, _Md = $1.columns - 2; _Me <= _Md; _Me += 1) { /*21360*/
					$k[$j++] = _Me; /*21352*/
					if ($1.clearcol() == $b) break; /*21352*/
					if ($k[--$j]) { /*21358*/
						$1.sum = $1.sum + 1; /*21353*/
						$k[$j++] = "p"; /*21354*/
						if ($1.sum == 1) { /*21354*/
							$k[$j++] = $1.rows; /*21354*/
						} else { /*21354*/
							$k[$j++] = $1.p * $1.rows; /*21354*/
						} /*21354*/
						var _Ml = $k[--$j]; /*21354*/
						$1[$k[--$j]] = _Ml; /*21354*/
					} else { /*21358*/
						$1.sum = 0; /*21356*/
						$1.pen = $1.pen + $1.p; /*21357*/
						$1.p = 0; /*21358*/
					} /*21358*/
				} /*21358*/
				$1.pen = $1.pen + $1.p; /*21361*/
			} /*21361*/
			if ((($1.rows % 2) == 0) || ($1.columns <= 12)) { /*21380*/
				$1.sum = 0; /*21368*/
				$1.p = 0; /*21368*/
				for (var _Mv = 1, _Mu = $1.rows - 2; _Mv <= _Mu; _Mv += 1) { /*21378*/
					$k[$j++] = _Mv; /*21370*/
					if ($1.clearrow() == $b) break; /*21370*/
					if ($k[--$j]) { /*21376*/
						$1.sum = $1.sum + 1; /*21371*/
						$k[$j++] = "p"; /*21372*/
						if ($1.sum == 1) { /*21372*/
							$k[$j++] = $1.columns; /*21372*/
						} else { /*21372*/
							$k[$j++] = $1.p * $1.columns; /*21372*/
						} /*21372*/
						var _N2 = $k[--$j]; /*21372*/
						$1[$k[--$j]] = _N2; /*21372*/
					} else { /*21376*/
						$1.sum = 0; /*21374*/
						$1.pen = $1.pen + $1.p; /*21375*/
						$1.p = 0; /*21376*/
					} /*21376*/
				} /*21376*/
				$1.pen = $1.pen + $1.p; /*21379*/
			} /*21379*/
			$k[$j++] = Infinity; /*21391*/
			for (var _N9 = 0, _NA = ($1.columns + 4) * 2; _N9 < _NA; _N9++) { /*21384*/
				$k[$j++] = 0; /*21384*/
			} /*21384*/
			for (var _NE = 0, _NF = $1.columns, _ND = $1.sym.length - 1; _NF < 0 ? _NE >= _ND : _NE <= _ND; _NE += _NF) { /*21389*/
				$k[$j++] = 0; /*21387*/
				$k[$j++] = 0; /*21387*/
				$aload($geti($1.sym, _NE, $1.columns)); /*21387*/
				$k[$j++] = 0; /*21388*/
				$k[$j++] = 0; /*21388*/
			} /*21388*/
			for (var _NK = 0, _NL = ($1.columns + 4) * 2; _NK < _NL; _NK++) { /*21390*/
				$k[$j++] = 0; /*21390*/
			} /*21390*/
			$1.symp = $a(); /*21391*/
			$1.columns = $1.columns + 4; /*21394*/
			$1.rows = $1.rows + 4; /*21395*/
			$1.sum = 0; /*21396*/
			for (var _NR = 2, _NQ = $1.rows - 3; _NR <= _NQ; _NR += 1) { /*21414*/
				$1.y = _NR; /*21398*/
				for (var _NV = ($1.y & 1) + 2, _NU = $1.columns - 3; _NV <= _NU; _NV += 2) { /*21413*/
					$1.x = _NV; /*21400*/
					for (var _NW = 0, _NX = 1; _NW < _NX; _NW++) { /*21412*/
						$k[$j++] = $1.symp; /*21402*/
						$k[$j++] = $1.x - 1; /*21402*/
						$k[$j++] = $1.y - 1; /*21402*/
						if ($1.dmv() == $b) break; /*21402*/
						var _Nb = $k[--$j]; /*21402*/
						if ($get($k[--$j], _Nb) == 1) { /*21402*/
							break; /*21402*/
						} /*21402*/
						$k[$j++] = $1.symp; /*21403*/
						$k[$j++] = $1.x + 1; /*21403*/
						$k[$j++] = $1.y - 1; /*21403*/
						if ($1.dmv() == $b) break; /*21403*/
						var _Nh = $k[--$j]; /*21403*/
						if ($get($k[--$j], _Nh) == 1) { /*21403*/
							break; /*21403*/
						} /*21403*/
						$k[$j++] = $1.symp; /*21404*/
						$k[$j++] = $1.x - 1; /*21404*/
						$k[$j++] = $1.y + 1; /*21404*/
						if ($1.dmv() == $b) break; /*21404*/
						var _Nn = $k[--$j]; /*21404*/
						if ($get($k[--$j], _Nn) == 1) { /*21404*/
							break; /*21404*/
						} /*21404*/
						$k[$j++] = $1.symp; /*21405*/
						$k[$j++] = $1.x + 1; /*21405*/
						$k[$j++] = $1.y + 1; /*21405*/
						if ($1.dmv() == $b) break; /*21405*/
						var _Nt = $k[--$j]; /*21405*/
						if ($get($k[--$j], _Nt) == 1) { /*21405*/
							break; /*21405*/
						} /*21405*/
						$k[$j++] = $1.symp; /*21406*/
						$k[$j++] = $1.x; /*21406*/
						$k[$j++] = $1.y; /*21406*/
						if ($1.dmv() == $b) break; /*21406*/
						var _Nz = $k[--$j]; /*21406*/
						if ($get($k[--$j], _Nz) == 0) { /*21406*/
							$1.sum = $1.sum + 1; /*21406*/
							break; /*21406*/
						} /*21406*/
						$k[$j++] = $1.symp; /*21407*/
						$k[$j++] = $1.x - 2; /*21407*/
						$k[$j++] = $1.y; /*21407*/
						if ($1.dmv() == $b) break; /*21407*/
						var _O6 = $k[--$j]; /*21407*/
						if ($get($k[--$j], _O6) == 1) { /*21407*/
							break; /*21407*/
						} /*21407*/
						$k[$j++] = $1.symp; /*21408*/
						$k[$j++] = $1.x; /*21408*/
						$k[$j++] = $1.y - 2; /*21408*/
						if ($1.dmv() == $b) break; /*21408*/
						var _OC = $k[--$j]; /*21408*/
						if ($get($k[--$j], _OC) == 1) { /*21408*/
							break; /*21408*/
						} /*21408*/
						$k[$j++] = $1.symp; /*21409*/
						$k[$j++] = $1.x + 2; /*21409*/
						$k[$j++] = $1.y; /*21409*/
						if ($1.dmv() == $b) break; /*21409*/
						var _OI = $k[--$j]; /*21409*/
						if ($get($k[--$j], _OI) == 1) { /*21409*/
							break; /*21409*/
						} /*21409*/
						$k[$j++] = $1.symp; /*21410*/
						$k[$j++] = $1.x; /*21410*/
						$k[$j++] = $1.y + 2; /*21410*/
						if ($1.dmv() == $b) break; /*21410*/
						var _OO = $k[--$j]; /*21410*/
						if ($get($k[--$j], _OO) == 1) { /*21410*/
							break; /*21410*/
						} /*21410*/
						$1.sum = $1.sum + 1; /*21411*/
					} /*21411*/
				} /*21411*/
			} /*21411*/
			$1.columns = $1.columns - 4; /*21415*/
			$1.rows = $1.rows - 4; /*21416*/
			$1.epen = 0; /*21419*/
			if ($1.worst == 0) { /*21425*/
				$k[$j++] = 0; /*21421*/
				$forall($geti($1.sym, 0, $1.columns), function() { /*21421*/
					var _OY = $k[--$j]; /*21421*/
					var _OZ = $k[--$j]; /*21421*/
					$k[$j++] = _OZ + _OY; /*21421*/
				}); /*21421*/
				if ($k[--$j] == 0) { /*21421*/
					$1.epen = $1.epen + 100000; /*21421*/
				} /*21421*/
				$k[$j++] = 0; /*21422*/
				$forall($geti($1.sym, $1.sym.length - $1.columns, $1.columns), function() { /*21422*/
					var _Oh = $k[--$j]; /*21422*/
					var _Oi = $k[--$j]; /*21422*/
					$k[$j++] = _Oi + _Oh; /*21422*/
				}); /*21422*/
				if ($k[--$j] == 0) { /*21422*/
					$1.epen = $1.epen + 200000; /*21422*/
				} /*21422*/
				$k[$j++] = 0; /*21423*/
				for (var _Oo = 0, _Op = $1.columns, _On = $1.sym.length - 1; _Op < 0 ? _Oo >= _On : _Oo <= _On; _Oo += _Op) { /*21423*/
					var _Os = $k[--$j]; /*21423*/
					$k[$j++] = _Os + $get($1.sym, _Oo); /*21423*/
				} /*21423*/
				if ($k[--$j] == 0) { /*21423*/
					$1.epen = $1.epen + 400000; /*21423*/
				} /*21423*/
				$k[$j++] = 0; /*21424*/
				for (var _Oz = $1.columns - 1, _P0 = $1.columns, _Oy = $1.sym.length - 1; _P0 < 0 ? _Oz >= _Oy : _Oz <= _Oy; _Oz += _P0) { /*21424*/
					var _P3 = $k[--$j]; /*21424*/
					$k[$j++] = _P3 + $get($1.sym, _Oz); /*21424*/
				} /*21424*/
				if ($k[--$j] == 0) { /*21424*/
					$1.epen = $1.epen + 800000; /*21424*/
				} /*21424*/
			} /*21424*/
			$k[$j++] = (($1.worst - ($1.sum * $1.sum)) - $1.pen) - $1.epen; /*21427*/
		}; /*21429*/
		$k[$j++] = Infinity; /*21432*/
		$k[$j++] = 1; /*21432*/
		for (var _PB = 0, _PC = 112; _PB < _PC; _PB++) { /*21432*/
			var _PD = $k[--$j]; /*21432*/
			$k[$j++] = _PD; /*21432*/
			$k[$j++] = (_PD * 3) % 113; /*21432*/
		} /*21432*/
		$1.rsalog = $a(); /*21432*/
		$1.step = (~~($1.nw / 112)) + 1; /*21433*/
		$1.offset = function() {
			var _PH = $k[--$j]; /*21434*/
			$k[$j++] = (_PH * $1.step) + $1.start; /*21434*/
		}; /*21434*/
		$1.bestscore = -99999999; /*21442*/
		$k[$j++] = "masks"; /*21447*/
		if ($1.mask != -1) { /*21446*/
			$k[$j++] = $a([$1.mask]); /*21444*/
		} else { /*21446*/
			if ($1.fast) { /*21446*/
				$k[$j++] = $a([3, 2, 1, 0]); /*21446*/
			} else { /*21446*/
				$k[$j++] = $a([0, 1, 2, 3]); /*21446*/
			} /*21446*/
		} /*21446*/
		var _PP = $k[--$j]; /*21447*/
		$1[$k[--$j]] = _PP; /*21447*/
		$1.litmasks = $a(4); /*21448*/
		$forall($1.masks, function() { /*21550*/
			$1.mask = $k[--$j]; /*21451*/
			$k[$j++] = Infinity; /*21458*/
			var _PY = $1.cws; /*21456*/
			$k[$j++] = $1.mask; /*21456*/
			$k[$j++] = $get($a([0, 3, 7, 17]), $1.mask); /*21456*/
			$k[$j++] = 0; /*21456*/
			for (var _PZ = 0, _Pa = _PY.length; _PZ < _Pa; _PZ++) { /*21456*/
				var _Pc = $k[--$j]; /*21456*/
				var _Pd = $k[--$j]; /*21456*/
				$k[$j++] = ($get(_PY, _PZ) + _Pc) % 113; /*21456*/
				$k[$j++] = _Pd; /*21456*/
				$k[$j++] = _Pc + _Pd; /*21456*/
			} /*21456*/
			$j -= 2; /*21456*/
			for (var _Pf = 0, _Pg = $1.nc; _Pf < _Pg; _Pf++) { /*21457*/
				$k[$j++] = 0; /*21457*/
			} /*21457*/
			$1.rscws = $a(); /*21458*/
			for (var _Pk = 0, _Pj = $1.step - 1; _Pk <= _Pj; _Pk += 1) { /*21481*/
				$1.start = _Pk; /*21460*/
				$1.ND = ~~((((($1.nd + 1) - $1.start) + $1.step) - 1) / $1.step); /*21461*/
				$1.NW = ~~((((($1.nw + 1) - $1.start) + $1.step) - 1) / $1.step); /*21462*/
				$1.NC = $1.NW - $1.ND; /*21463*/
				$k[$j++] = Infinity; /*21464*/
				$k[$j++] = 1; /*21464*/
				for (var _Pw = 0, _Px = $1.NC; _Pw < _Px; _Pw++) { /*21464*/
					$k[$j++] = 0; /*21464*/
				} /*21464*/
				$1.coeffs = $a(); /*21464*/
				for (var _Q1 = 1, _Q0 = $1.NC; _Q1 <= _Q0; _Q1 += 1) { /*21471*/
					$1.i = _Q1; /*21466*/
					for (var _Q3 = $1.NC; _Q3 >= 1; _Q3 -= 1) { /*21470*/
						$1.j = _Q3; /*21468*/
						$put($1.coeffs, $1.j, (($get($1.coeffs, $1.j) + 113) - (($get($1.rsalog, $1.i) * $get($1.coeffs, $1.j - 1)) % 113)) % 113); /*21469*/
					} /*21469*/
				} /*21469*/
				for (var _QH = 0, _QG = $1.ND - 1; _QH <= _QG; _QH += 1) { /*21479*/
					$k[$j++] = "t"; /*21473*/
					$k[$j++] = $1.rscws; /*21473*/
					$k[$j++] = _QH; /*21473*/
					if ($1.offset() == $b) break; /*21473*/
					var _QJ = $k[--$j]; /*21473*/
					var _QL = $get($k[--$j], _QJ); /*21473*/
					$k[$j++] = _QL; /*21473*/
					$k[$j++] = $1.rscws; /*21473*/
					$k[$j++] = $1.ND; /*21473*/
					if ($1.offset() == $b) break; /*21473*/
					var _QO = $k[--$j]; /*21473*/
					var _QQ = $get($k[--$j], _QO); /*21473*/
					var _QR = $k[--$j]; /*21473*/
					$1[$k[--$j]] = (_QR + _QQ) % 113; /*21473*/
					for (var _QV = 0, _QU = $1.NC - 2; _QV <= _QU; _QV += 1) { /*21477*/
						$1.j = _QV; /*21475*/
						$k[$j++] = $1.rscws; /*21476*/
						$k[$j++] = $1.ND + $1.j; /*21476*/
						if ($1.offset() == $b) break; /*21476*/
						$k[$j++] = $1.rscws; /*21476*/
						$k[$j++] = ($1.ND + $1.j) + 1; /*21476*/
						if ($1.offset() == $b) break; /*21476*/
						var _Qc = $k[--$j]; /*21476*/
						var _Qe = $get($k[--$j], _Qc); /*21476*/
						var _Qj = $k[--$j]; /*21476*/
						$put($k[--$j], _Qj, ((_Qe + 113) - (($1.t * $get($1.coeffs, $1.j + 1)) % 113)) % 113); /*21476*/
					} /*21476*/
					$k[$j++] = $1.rscws; /*21478*/
					$k[$j++] = ($1.ND + $1.NC) - 1; /*21478*/
					if ($1.offset() == $b) break; /*21478*/
					var _Qs = $k[--$j]; /*21478*/
					$put($k[--$j], _Qs, (113 - (($1.t * $get($1.coeffs, $1.NC)) % 113)) % 113); /*21478*/
				} /*21478*/
				for (var _Qx = $1.ND, _Qw = $1.NW - 1; _Qx <= _Qw; _Qx += 1) { /*21480*/
					$k[$j++] = _Qx; /*21480*/
					$k[$j++] = $1.rscws; /*21480*/
					$k[$j++] = _Qx; /*21480*/
					if ($1.offset() == $b) break; /*21480*/
					var _R0 = $k[--$j]; /*21480*/
					var _R1 = $k[--$j]; /*21480*/
					var _R2 = $k[--$j]; /*21480*/
					$k[$j++] = _R1; /*21480*/
					$k[$j++] = _R0; /*21480*/
					$k[$j++] = 113; /*21480*/
					$k[$j++] = $1.rscws; /*21480*/
					$k[$j++] = _R2; /*21480*/
					if ($1.offset() == $b) break; /*21480*/
					var _R3 = $k[--$j]; /*21480*/
					var _R5 = $get($k[--$j], _R3); /*21480*/
					var _R6 = $k[--$j]; /*21480*/
					var _R7 = $k[--$j]; /*21480*/
					$put($k[--$j], _R7, (_R6 - _R5) % 113); /*21480*/
				} /*21480*/
			} /*21480*/
			$1.bits = $s($1.ndots); /*21484*/
			$puti($1.bits, 0, $get($a(["00", "01", "10", "11"]), $1.mask)); /*21485*/
			for (var _RH = 1, _RG = $1.nw; _RH <= _RG; _RH += 1) { /*21489*/
				$1.i = _RH; /*21487*/
				$puti($1.bits, (($1.i - 1) * 9) + 2, $get($1.encs, $get($1.rscws, $1.i))); /*21488*/
			} /*21488*/
			if ($1.rembits > 0) { /*21492*/
				$puti($1.bits, ($1.nw * 9) + 2, $geti("11111111111111111", 0, $1.rembits)); /*21491*/
			} /*21491*/
			var _RU = $1.outline; /*21495*/
			$1.pixs = $arrcpy($a(_RU.length), _RU); /*21495*/
			$1.posx = 0; /*21496*/
			$k[$j++] = "posy"; /*21497*/
			if (($1.rows % 2) == 0) { /*21497*/
				$k[$j++] = 0; /*21497*/
			} else { /*21497*/
				$k[$j++] = $1.rows - 1; /*21497*/
			} /*21497*/
			var _RZ = $k[--$j]; /*21497*/
			$1[$k[--$j]] = _RZ; /*21497*/
			$forall($geti($1.bits, 0, $1.bits.length - 6), function() { /*21516*/
				for (;;) { /*21514*/
					$k[$j++] = $1.pixs; /*21500*/
					$k[$j++] = $1.posx; /*21500*/
					$k[$j++] = $1.posy; /*21500*/
					if ($1.dmv() == $b) break; /*21500*/
					var _Rh = $k[--$j]; /*21500*/
					if ($get($k[--$j], _Rh) == -1) { /*21500*/
						break; /*21500*/
					} /*21500*/
					if (($1.rows % 2) == 0) { /*21511*/
						$1.posy = $1.posy + 1; /*21502*/
						if ($1.posy == $1.rows) { /*21506*/
							$1.posy = 0; /*21504*/
							$1.posx = $1.posx + 1; /*21505*/
						} /*21505*/
					} else { /*21511*/
						$1.posx = $1.posx + 1; /*21508*/
						if ($1.posx == $1.columns) { /*21512*/
							$1.posx = 0; /*21510*/
							$1.posy = $1.posy - 1; /*21511*/
						} /*21511*/
					} /*21511*/
				} /*21511*/
				$k[$j++] = $1.pixs; /*21515*/
				$k[$j++] = $1.posx; /*21515*/
				$k[$j++] = $1.posy; /*21515*/
				if ($1.dmv() == $b) return $b; /*21515*/
				var _Rw = $k[--$j]; /*21515*/
				var _Rx = $k[--$j]; /*21515*/
				$put(_Rx, _Rw, $k[--$j] - 48); /*21515*/
			}); /*21515*/
			for (var _Rz = 0; _Rz <= 5; _Rz += 1) { /*21521*/
				$1.i = _Rz; /*21518*/
				$k[$j++] = $1.pixs; /*21519*/
				$aload($get($1.sixedges, $1.i)); /*21519*/
				if ($1.dmv() == $b) break; /*21519*/
				var _S8 = $k[--$j]; /*21520*/
				$put($k[--$j], _S8, $get($1.bits, ($1.bits.length - 6) + $1.i) - 48); /*21520*/
			} /*21520*/
			$k[$j++] = "score"; /*21524*/
			$k[$j++] = $1.pixs; /*21524*/
			if ($1.evalsymbol() == $b) return $b; /*21524*/
			var _SB = $k[--$j]; /*21524*/
			$1[$k[--$j]] = _SB; /*21524*/
			if ($1.score > $1.bestscore) { /*21529*/
				$1.bestsym = $1.pixs; /*21526*/
				$1.bestscore = $1.score; /*21527*/
				if ($1.fast && ($1.bestscore > (~~(($1.rows * $1.columns) / 2)))) { /*21528*/
					return $b; /*21528*/
				} /*21528*/
			} /*21528*/
			var _SL = $1.pixs; /*21532*/
			$1.litmask = $arrcpy($a(_SL.length), _SL); /*21532*/
			for (var _SO = 0; _SO <= 5; _SO += 1) { /*21537*/
				$1.i = _SO; /*21534*/
				$k[$j++] = $1.litmask; /*21535*/
				$aload($get($1.sixedges, $1.i)); /*21535*/
				if ($1.dmv() == $b) break; /*21535*/
				var _ST = $k[--$j]; /*21536*/
				$put($k[--$j], _ST, 1); /*21536*/
			} /*21536*/
			$put($1.litmasks, $1.mask, $1.litmask); /*21538*/
			if ($1.fast) { /*21548*/
				$k[$j++] = "score"; /*21542*/
				$k[$j++] = $1.litmask; /*21542*/
				if ($1.evalsymbol() == $b) return $b; /*21542*/
				var _Sa = $k[--$j]; /*21542*/
				$1[$k[--$j]] = _Sa; /*21542*/
				if ($gt($1.score, $1.bestscore)) { /*21547*/
					$1.bestsym = $1.litmask; /*21544*/
					$1.bestscore = $1.score; /*21545*/
					if ($1.bestscore > (~~(($1.rows * $1.columns) / 2))) { /*21546*/
						return $b; /*21546*/
					} /*21546*/
				} /*21546*/
			} /*21546*/
		}); /*21546*/
		$1.pixs = $1.bestsym; /*21551*/
		if ((!$1.fast) && ($1.bestscore <= (~~(($1.rows * $1.columns) / 2)))) { /*21565*/
			$1.bestscore = -99999999; /*21555*/
			$forall($1.masks, function() { /*21563*/
				$1.litmask = $get($1.litmasks, $k[--$j]); /*21557*/
				$k[$j++] = "score"; /*21558*/
				$k[$j++] = $1.litmask; /*21558*/
				if ($1.evalsymbol() == $b) return $b; /*21558*/
				var _St = $k[--$j]; /*21558*/
				$1[$k[--$j]] = _St; /*21558*/
				if ($1.score > $1.bestscore) { /*21562*/
					$1.bestsym = $1.litmask; /*21560*/
					$1.bestscore = $1.score; /*21561*/
				} /*21561*/
			}); /*21561*/
			$1.pixs = $1.bestsym; /*21564*/
		} /*21564*/
		var _T6 = {
			ren: $0.renmatrix,
			pixs: $1.pixs,
			pixx: $1.columns,
			pixy: $1.rows,
			height: ($1.rows * 2) / 72,
			width: ($1.columns * 2) / 72,
			opt: $1.options
		}; /*21575*/
		$k[$j++] = _T6; /*21578*/
		if (!$1.dontdraw) { /*21578*/
			$0.renmatrix(); /*21578*/
		} /*21578*/
	};
	$0.ultracode = function() {
		var $1 = {}; /*21605*/
		$1.options = $k[--$j]; /*21607*/
		$1.barcode = $k[--$j]; /*21608*/
		$1.dontdraw = false; /*21610*/
		$1.eclevel = "EC2"; /*21611*/
		$1.parse = false; /*21612*/
		$1.parsefnc = false; /*21613*/
		$forall($1.options, function() { /*21624*/
			var _3 = $k[--$j]; /*21624*/
			$1[$k[--$j]] = _3; /*21624*/
		}); /*21624*/
		$1.barlen = $1.barcode.length; /*21647*/
		$1.fn1 = -1; /*21650*/
		$1.fn3 = -2; /*21650*/
		var _8 = {
			FNC1: $1.fn1,
			FNC3: $1.fn3
		}; /*21653*/
		$1.fncvals = _8; /*21654*/
		$1.msg = $a($1.barlen); /*21655*/
		$1.i = 0; /*21656*/
		$1.j = 0; /*21656*/
		for (;;) { /*21670*/
			if ($1.i == $1.barlen) { /*21657*/
				break; /*21657*/
			} /*21657*/
			$1.char = $get($1.barcode, $1.i); /*21658*/
			if (($1.parsefnc && ($1.char == 94)) && ($1.i < ($1.barlen - 4))) { /*21666*/
				if ($get($1.barcode, $1.i + 1) != 94) { /*21664*/
					$1.char = $get($1.fncvals, $geti($1.barcode, $1.i + 1, 4)); /*21661*/
					$1.i = $1.i + 4; /*21662*/
				} else { /*21664*/
					$1.i = $1.i + 1; /*21664*/
				} /*21664*/
			} /*21664*/
			$put($1.msg, $1.j, $1.char); /*21667*/
			$1.i = $1.i + 1; /*21668*/
			$1.j = $1.j + 1; /*21669*/
		} /*21669*/
		$1.msg = $geti($1.msg, 0, $1.j); /*21671*/
		$1.msglen = $1.msg.length; /*21672*/
		$1.start = 257; /*21675*/
		$1.scr = $a([]); /*21676*/
		$1.link1 = 0; /*21677*/
		$1.scp = $a([]); /*21678*/
		$k[$j++] = Infinity; /*21686*/
		$aload($1.scr); /*21680*/
		$aload($1.scp); /*21681*/
		$forall($1.msg, function() { /*21685*/
			var _i = $k[--$j]; /*21683*/
			$k[$j++] = _i; /*21683*/
			if (_i == $1.fn1) { /*21683*/
				$j--; /*21683*/
				$k[$j++] = 268; /*21683*/
			} /*21683*/
			var _k = $k[--$j]; /*21684*/
			$k[$j++] = _k; /*21684*/
			if (_k == $1.fn3) { /*21684*/
				$j--; /*21684*/
				$k[$j++] = 269; /*21684*/
			} /*21684*/
		}); /*21684*/
		$1.dcws = $a(); /*21686*/
		$1.mcc = $1.dcws.length + 3; /*21687*/
		$1.eclval = $get($1.eclevel, 2) - 48; /*21689*/
		if ($1.eclval != 0) { /*21693*/
			$k[$j++] = "qcc"; /*21691*/
			$k[$j++] = $get($a([0, 1, 2, 4, 6, 8]), $1.eclval); /*21691*/
			$k[$j++] = ~~($1.mcc / 25); /*21691*/
			if (($1.mcc % 25) != 0) { /*21691*/
				var _w = $k[--$j]; /*21691*/
				$k[$j++] = _w + 1; /*21691*/
			} /*21691*/
			var _x = $k[--$j]; /*21691*/
			var _y = $k[--$j]; /*21691*/
			$1[$k[--$j]] = (_y * _x) + 5; /*21691*/
		} else { /*21693*/
			$1.qcc = 3; /*21693*/
		} /*21693*/
		$1.acc = ($1.qcc - 3) + (78 * $1.link1); /*21695*/
		$1.tcc = $1.mcc + $1.qcc; /*21696*/
		$1.metrics = $a([$a([2, 4, 34, 5]), $a([3, 33, 82, 13]), $a([4, 82, 158, 23]), $a([5, 134, 282, 30])]); /*21706*/
		for (var _19 = 0; _19 <= 3; _19 += 1) { /*21717*/
			$1.i = _19; /*21708*/
			$1.m = $get($1.metrics, $1.i); /*21709*/
			$1.rows = $get($1.m, 0); /*21710*/
			$1.minc = $get($1.m, 1); /*21711*/
			$1.maxc = $get($1.m, 2); /*21712*/
			$1.mcol = $get($1.m, 3); /*21713*/
			$1.okay = true; /*21714*/
			if (($1.tcc < $1.minc) || ($1.tcc > $1.maxc)) { /*21715*/
				$1.okay = false; /*21715*/
			} /*21715*/
			if ($1.okay) { /*21716*/
				break; /*21716*/
			} /*21716*/
		} /*21716*/
		if (!$1.okay) { /*21721*/
			$k[$j++] = "bwipp.ultracodeNoValidSymbol"; /*21720*/
			$k[$j++] = "No valid symbol available"; /*21720*/
			$0.raiseerror(); /*21720*/
		} /*21720*/
		for (var _1S = $1.mcol; _1S <= 61; _1S += 1) { /*21735*/
			$1.columns = _1S; /*21725*/
			$k[$j++] = $1.columns; /*21727*/
			if ($1.columns >= 15) { /*21727*/
				var _1V = $k[--$j]; /*21727*/
				$k[$j++] = _1V - 1; /*21727*/
			} /*21727*/
			if ($1.columns >= 31) { /*21728*/
				var _1X = $k[--$j]; /*21728*/
				$k[$j++] = _1X - 1; /*21728*/
			} /*21728*/
			if ($1.columns >= 47) { /*21729*/
				var _1Z = $k[--$j]; /*21729*/
				$k[$j++] = _1Z - 1; /*21729*/
			} /*21729*/
			var _1d = (($k[--$j] * $1.rows) - 3) - $1.tcc; /*21730*/
			$k[$j++] = _1d; /*21733*/
			if (_1d >= 0) { /*21733*/
				$1.pads = $k[--$j]; /*21731*/
				break; /*21732*/
			} /*21732*/
			$j--; /*21734*/
		} /*21734*/
		$1.dcc = $1.columns - $1.mcol; /*21736*/
		$k[$j++] = Infinity; /*21747*/
		$k[$j++] = $1.start; /*21743*/
		$k[$j++] = $1.mcc; /*21743*/
		$k[$j++] = $1.acc; /*21743*/
		$aload($1.scr); /*21743*/
		$aload($1.dcws); /*21744*/
		for (var _1n = 0, _1o = $1.qcc; _1n < _1o; _1n++) { /*21745*/
			$k[$j++] = 0; /*21745*/
		} /*21745*/
		$k[$j++] = 0; /*21746*/
		$1.rsseq = $a(); /*21747*/
		$k[$j++] = Infinity; /*21750*/
		$k[$j++] = 1; /*21750*/
		for (var _1q = 0, _1r = 282; _1q < _1r; _1q++) { /*21750*/
			var _1s = $k[--$j]; /*21750*/
			$k[$j++] = _1s; /*21750*/
			$k[$j++] = (_1s * 3) % 283; /*21750*/
		} /*21750*/
		$1.rsalog = $a(); /*21750*/
		$1.rslog = $a(283); /*21751*/
		for (var _1v = 1; _1v <= 282; _1v += 1) { /*21752*/
			$put($1.rslog, $get($1.rsalog, _1v), _1v); /*21752*/
		} /*21752*/
		$1.rsprod = function() {
			var _1z = $k[--$j]; /*21756*/
			var _20 = $k[--$j]; /*21756*/
			$k[$j++] = _20; /*21760*/
			$k[$j++] = _1z; /*21760*/
			if ((_1z != 0) && (_20 != 0)) { /*21759*/
				var _23 = $get($1.rslog, $k[--$j]); /*21757*/
				var _28 = $get($1.rsalog, (_23 + $get($1.rslog, $k[--$j])) % 282); /*21757*/
				$k[$j++] = _28; /*21757*/
			} else { /*21759*/
				$j -= 2; /*21759*/
				$k[$j++] = 0; /*21759*/
			} /*21759*/
		}; /*21761*/
		$1.n = $1.mcc; /*21764*/
		$1.k = $1.qcc; /*21764*/
		$k[$j++] = Infinity; /*21765*/
		$k[$j++] = 1; /*21765*/
		for (var _2C = 0, _2D = $1.k; _2C < _2D; _2C++) { /*21765*/
			$k[$j++] = 0; /*21765*/
		} /*21765*/
		$1.coeffs = $a(); /*21765*/
		for (var _2H = 1, _2G = $1.k; _2H <= _2G; _2H += 1) { /*21774*/
			$1.i = _2H; /*21767*/
			$put($1.coeffs, $1.i, $get($1.coeffs, $1.i - 1)); /*21768*/
			for (var _2O = $1.i - 1; _2O >= 1; _2O -= 1) { /*21772*/
				$1.j = _2O; /*21770*/
				$k[$j++] = $1.coeffs; /*21771*/
				$k[$j++] = $1.j; /*21771*/
				$k[$j++] = $get($1.coeffs, $1.j - 1); /*21771*/
				$k[$j++] = $get($1.coeffs, $1.j); /*21771*/
				$k[$j++] = $get($1.rsalog, $1.i); /*21771*/
				if ($1.rsprod() == $b) break; /*21771*/
				var _2a = $k[--$j]; /*21771*/
				var _2b = $k[--$j]; /*21771*/
				var _2c = $k[--$j]; /*21771*/
				$put($k[--$j], _2c, (_2b + _2a) % 283); /*21771*/
			} /*21771*/
			$k[$j++] = $1.coeffs; /*21773*/
			$k[$j++] = 0; /*21773*/
			$k[$j++] = $get($1.coeffs, 0); /*21773*/
			$k[$j++] = $get($1.rsalog, $1.i); /*21773*/
			if ($1.rsprod() == $b) break; /*21773*/
			var _2k = $k[--$j]; /*21773*/
			var _2l = $k[--$j]; /*21773*/
			$put($k[--$j], _2l, _2k); /*21773*/
		} /*21773*/
		$1.coeffs = $geti($1.coeffs, 0, $1.coeffs.length - 1); /*21775*/
		for (var _2r = $1.coeffs.length - 1; _2r >= 0; _2r -= 2) { /*21776*/
			var _2s = $1.coeffs; /*21776*/
			$put(_2s, _2r, 283 - $get(_2s, _2r)); /*21776*/
		} /*21776*/
		for (var _2w = 0, _2v = $1.n - 1; _2w <= _2v; _2w += 1) { /*21785*/
			$1.t = ($get($1.rsseq, _2w) + $get($1.rsseq, $1.n)) % 283; /*21780*/
			for (var _34 = 0, _33 = $1.k - 1; _34 <= _33; _34 += 1) { /*21784*/
				$1.j = _34; /*21782*/
				$put($1.rsseq, $1.n + $1.j, ($get($1.rsseq, ($1.n + $1.j) + 1) + (283 - (($1.t * $get($1.coeffs, ($1.k - $1.j) - 1)) % 283))) % 283); /*21783*/
			} /*21783*/
		} /*21783*/
		for (var _3L = $1.n, _3K = $1.n + $1.k; _3L <= _3K; _3L += 1) { /*21786*/
			$put($1.rsseq, _3L, (283 - $get($1.rsseq, _3L)) % 283); /*21786*/
		} /*21786*/
		$1.ecws = $geti($1.rsseq, $1.n, $1.k); /*21787*/
		$1.dccu = $a([51363, 51563, 51653, 53153, 53163, 53513, 53563, 53613, 53653, 56153, 56163, 56313, 56353, 56363, 56513, 56563, 51316, 51356, 51536, 51616, 53156, 53516, 53536, 53616, 53636, 53656, 56136, 56156, 56316, 56356, 56516, 56536]); /*21794*/
		$1.dccl = $a([61351, 61361, 61531, 61561, 61631, 61651, 63131, 63151, 63161, 63531, 63561, 63631, 65131, 65161, 65351, 65631, 31351, 31361, 31531, 31561, 31631, 31651, 35131, 35151, 35161, 35361, 35631, 35651, 36131, 36151, 36351, 36531]); /*21801*/
		$1.tiles = $a([13135, 13136, 13153, 13156, 13163, 13165, 13513, 13515, 13516, 13531, 13535, 13536, 13561, 13563, 13565, 13613, 13615, 13616, 13631, 13635, 13636, 13651, 13653, 13656, 15135, 15136, 15153, 15163, 15165, 15313, 15315, 15316, 15351, 15353, 15356, 15361, 15363, 15365, 15613, 15615, 15616, 15631, 15635, 15636, 15651, 15653, 15656, 16135, 16136, 16153, 16156, 16165, 16313, 16315, 16316, 16351, 16353, 16356, 16361, 16363, 16365, 16513, 16515, 16516, 16531, 16535, 16536, 16561, 16563, 16565, 31315, 31316, 31351, 31356, 31361, 31365, 31513, 31515, 31516, 31531, 31535, 31536, 31561, 31563, 31565, 31613, 31615, 31631, 31635, 31636, 31651, 31653, 31656, 35131, 35135, 35136, 35151, 35153, 35156, 35161, 35163, 35165, 35315, 35316, 35351, 35356, 35361, 35365, 35613, 35615, 35616, 35631, 35635, 35636, 35651, 35653, 35656, 36131, 36135, 36136, 36151, 36153, 36156, 36163, 36165, 36315, 36316, 36351, 36356, 36361, 36365, 36513, 36515, 36516, 36531, 36535, 36536, 36561, 36563, 36565, 51313, 51315, 51316, 51351, 51353, 51356, 51361, 51363, 51365, 51513, 51516, 51531, 51536, 51561, 51563, 51613, 51615, 51616, 51631, 51635, 51636, 51651, 51653, 51656, 53131, 53135, 53136, 53151, 53153, 53156, 53161, 53163, 53165, 53513, 53516, 53531, 53536, 53561, 53563, 53613, 53615, 53616, 53631, 53635, 53636, 53651, 53653, 53656, 56131, 56135, 56136, 56151, 56153, 56156, 56161, 56163, 56165, 56313, 56315, 56316, 56351, 56353, 56356, 56361, 56363, 56365, 56513, 56516, 56531, 56536, 56561, 56563, 61313, 61315, 61316, 61351, 61353, 61356, 61361, 61363, 61365, 61513, 61515, 61516, 61531, 61535, 61536, 61561, 61563, 61565, 61615, 61631, 61635, 61651, 61653, 63131, 63135, 63136, 63151, 63153, 63156, 63161, 63163, 63165, 63513, 63515, 63516, 63531, 63535, 63536, 63561, 63563, 63565, 63613, 63615, 63631, 63635, 63651, 63653, 65131, 65135, 65136, 65151, 65153, 65156, 65161, 65163, 65165, 65313, 65315, 65316, 65351, 65353, 65356, 65361, 65363, 65365, 65613, 65615, 65631, 65635, 65651, 65653, 56565, 51515]); /*21833*/
		$1.rows = ($1.rows * 6) + 1; /*21836*/
		$1.columns = $1.columns + 6; /*21837*/
		$k[$j++] = Infinity; /*21838*/
		for (var _3a = 0, _3b = $1.rows * $1.columns; _3a < _3b; _3a++) { /*21838*/
			$k[$j++] = -1; /*21838*/
		} /*21838*/
		$1.pixs = $a(); /*21838*/
		$1.qmv = function() {
			var _3e = $k[--$j]; /*21839*/
			var _3f = $k[--$j]; /*21839*/
			$k[$j++] = _3f + (_3e * $1.columns); /*21839*/
		}; /*21839*/
		for (var _3i = 0, _3h = $1.columns - 1; _3i <= _3h; _3i += 1) { /*21848*/
			$1.i = _3i; /*21841*/
			for (var _3l = 0, _3k = $1.rows - 1; _3l <= _3k; _3l += 6) { /*21845*/
				$1.j = _3l; /*21843*/
				if ($1.i >= 5) { /*21844*/
					$k[$j++] = $1.pixs; /*21844*/
					$k[$j++] = $1.i; /*21844*/
					$k[$j++] = $1.j; /*21844*/
					if ($1.qmv() == $b) break; /*21844*/
					var _3r = $k[--$j]; /*21844*/
					$put($k[--$j], _3r, ($1.i % 2) * 9); /*21844*/
				} /*21844*/
			} /*21844*/
			$k[$j++] = $1.pixs; /*21846*/
			$k[$j++] = $1.i; /*21846*/
			$k[$j++] = 0; /*21846*/
			if ($1.qmv() == $b) break; /*21846*/
			var _3v = $k[--$j]; /*21846*/
			$put($k[--$j], _3v, 9); /*21846*/
			$k[$j++] = $1.pixs; /*21847*/
			$k[$j++] = $1.i; /*21847*/
			$k[$j++] = $1.rows - 1; /*21847*/
			if ($1.qmv() == $b) break; /*21847*/
			var _40 = $k[--$j]; /*21847*/
			$put($k[--$j], _40, 9); /*21847*/
		} /*21847*/
		for (var _44 = 1, _43 = $1.rows - 2; _44 <= _43; _44 += 1) { /*21861*/
			$1.i = _44; /*21850*/
			for (var _47 = 3, _46 = $1.columns - 1; _47 <= _46; _47 += 16) { /*21854*/
				$1.j = _47; /*21852*/
				$k[$j++] = $1.pixs; /*21853*/
				$k[$j++] = $1.j; /*21853*/
				$k[$j++] = $1.i; /*21853*/
				if ($1.qmv() == $b) break; /*21853*/
				var _4C = $k[--$j]; /*21853*/
				$put($k[--$j], _4C, (1 - ($1.i % 2)) * 9); /*21853*/
			} /*21853*/
			$k[$j++] = $1.pixs; /*21855*/
			$k[$j++] = 0; /*21855*/
			$k[$j++] = $1.i; /*21855*/
			if ($1.qmv() == $b) break; /*21855*/
			var _4G = $k[--$j]; /*21855*/
			$put($k[--$j], _4G, 9); /*21855*/
			$k[$j++] = $1.pixs; /*21856*/
			$k[$j++] = 1; /*21856*/
			$k[$j++] = $1.i; /*21856*/
			if ($1.qmv() == $b) break; /*21856*/
			var _4L = $k[--$j]; /*21856*/
			$put($k[--$j], _4L, (1 - ($1.i % 2)) * 9); /*21856*/
			$k[$j++] = $1.pixs; /*21857*/
			$k[$j++] = 2; /*21857*/
			$k[$j++] = $1.i; /*21857*/
			if ($1.qmv() == $b) break; /*21857*/
			var _4P = $k[--$j]; /*21857*/
			$put($k[--$j], _4P, 0); /*21857*/
			$k[$j++] = $1.pixs; /*21858*/
			$k[$j++] = 3; /*21858*/
			$k[$j++] = $1.i; /*21858*/
			if ($1.qmv() == $b) break; /*21858*/
			var _4T = $k[--$j]; /*21858*/
			$put($k[--$j], _4T, 9); /*21858*/
			$k[$j++] = $1.pixs; /*21859*/
			$k[$j++] = 4; /*21859*/
			$k[$j++] = $1.i; /*21859*/
			if ($1.qmv() == $b) break; /*21859*/
			var _4X = $k[--$j]; /*21859*/
			$put($k[--$j], _4X, 0); /*21859*/
			$k[$j++] = $1.pixs; /*21860*/
			$k[$j++] = $1.columns - 1; /*21860*/
			$k[$j++] = $1.i; /*21860*/
			if ($1.qmv() == $b) break; /*21860*/
			var _4c = $k[--$j]; /*21860*/
			$put($k[--$j], _4c, 9); /*21860*/
		} /*21860*/
		$1.i = (~~($1.rows / 2)) - 5; /*21864*/
		$k[$j++] = Infinity; /*21868*/
		var _4j = $cvrs($s(5), $get($1.dccu, $1.dcc), 10); /*21866*/
		for (var _4k = 0, _4l = _4j.length; _4k < _4l; _4k++) { /*21866*/
			$k[$j++] = $get(_4j, _4k) - 48; /*21866*/
		} /*21866*/
		var _4r = $cvrs($s(5), $get($1.dccl, $1.dcc), 10); /*21868*/
		$k[$j++] = 0; /*21868*/
		for (var _4s = 0, _4t = _4r.length; _4s < _4t; _4s++) { /*21868*/
			$k[$j++] = $get(_4r, _4s) - 48; /*21868*/
		} /*21868*/
		var _4v = $a(); /*21868*/
		for (var _4w = 0, _4x = _4v.length; _4w < _4x; _4w++) { /*21872*/
			$k[$j++] = $get(_4v, _4w); /*21870*/
			$k[$j++] = $1.pixs; /*21870*/
			$k[$j++] = 2; /*21870*/
			$k[$j++] = $1.i; /*21870*/
			if ($1.qmv() == $b) return $b; /*21870*/
			var _51 = $k[--$j]; /*21870*/
			var _52 = $k[--$j]; /*21870*/
			$put(_52, _51, $k[--$j]); /*21870*/
			$1.i = $1.i + 1; /*21871*/
		} /*21871*/
		$k[$j++] = Infinity; /*21886*/
		$k[$j++] = $1.start; /*21878*/
		$k[$j++] = $1.mcc; /*21878*/
		$aload($1.ecws); /*21878*/
		$k[$j++] = $1.tcc; /*21882*/
		$k[$j++] = 283; /*21882*/
		$k[$j++] = $1.acc; /*21882*/
		$aload($1.scr); /*21882*/
		$aload($1.dcws); /*21883*/
		for (var _5D = 0, _5E = $1.pads; _5D < _5E; _5D++) { /*21884*/
			$k[$j++] = 284; /*21884*/
		} /*21884*/
		$k[$j++] = $1.qcc; /*21885*/
		$1.tileseq = $a(); /*21886*/
		$1.x = 5; /*21888*/
		$1.y = 1; /*21888*/
		var _5H = $1.tileseq; /*21889*/
		for (var _5I = 0, _5J = _5H.length; _5I < _5J; _5I++) { /*21902*/
			var _5O = $cvrs($s(5), $get($1.tiles, $get(_5H, _5I)), 10); /*21890*/
			for (var _5P = 0, _5Q = _5O.length; _5P < _5Q; _5P++) { /*21893*/
				$k[$j++] = $get(_5O, _5P); /*21891*/
				$k[$j++] = $1.pixs; /*21891*/
				$k[$j++] = $1.x; /*21891*/
				$k[$j++] = $1.y; /*21891*/
				if ($1.qmv() == $b) return $b; /*21891*/
				var _5V = $k[--$j]; /*21891*/
				var _5W = $k[--$j]; /*21891*/
				$put(_5W, _5V, $k[--$j] - 48); /*21891*/
				$1.y = $1.y + 1; /*21892*/
			} /*21892*/
			if ($1.y != ($1.rows - 1)) { /*21899*/
				$1.y = $1.y + 1; /*21895*/
			} else { /*21899*/
				$1.x = $1.x + 1; /*21897*/
				$1.y = 1; /*21897*/
				$k[$j++] = $1.pixs; /*21898*/
				$k[$j++] = $1.x; /*21898*/
				$k[$j++] = $1.y; /*21898*/
				if ($1.qmv() == $b) return $b; /*21898*/
				var _5g = $k[--$j]; /*21898*/
				if ($get($k[--$j], _5g) != -1) { /*21900*/
					$1.x = $1.x + 1; /*21899*/
				} /*21899*/
			} /*21899*/
		} /*21899*/
		$k[$j++] = Infinity; /*21920*/
		$k[$j++] = "ren"; /*21918*/
		$k[$j++] = $0.renmatrix; /*21918*/
		$k[$j++] = "pixs"; /*21918*/
		$k[$j++] = $1.pixs; /*21918*/
		$k[$j++] = "pixx"; /*21918*/
		$k[$j++] = $1.columns; /*21918*/
		$k[$j++] = "pixy"; /*21918*/
		$k[$j++] = $1.rows; /*21918*/
		$k[$j++] = "height"; /*21918*/
		$k[$j++] = $1.rows / 72; /*21918*/
		$k[$j++] = "width"; /*21918*/
		$k[$j++] = $1.columns / 72; /*21918*/
		$k[$j++] = "colormap"; /*21918*/
		$k[$j++] = Infinity; /*21918*/
		$k[$j++] = 0; /*21918*/
		$k[$j++] = "00000000"; /*21918*/
		$k[$j++] = 9; /*21918*/
		$k[$j++] = "000000FF"; /*21918*/
		$k[$j++] = 1; /*21918*/
		$k[$j++] = "FF000000"; /*21918*/
		$k[$j++] = 3; /*21918*/
		$k[$j++] = "00FF0000"; /*21918*/
		$k[$j++] = 5; /*21918*/
		$k[$j++] = "0000FF00"; /*21918*/
		$k[$j++] = 6; /*21918*/
		$k[$j++] = "7F00FF00"; /*21918*/
		var _5p = $d(); /*21918*/
		$k[$j++] = _5p; /*21920*/
		$k[$j++] = "opt"; /*21920*/
		$k[$j++] = $1.options; /*21920*/
		var _5r = $d(); /*21920*/
		$k[$j++] = _5r; /*21923*/
		if (!$1.dontdraw) { /*21923*/
			$0.renmatrix(); /*21923*/
		} /*21923*/
	};
	$0["gs1-cc"] = function() {
		var $1 = {}; /*21952*/
		$1.options = $k[--$j]; /*21954*/
		$1.barcode = $k[--$j]; /*21955*/
		$1.dontdraw = false; /*21957*/
		$1.ccversion = "a"; /*21958*/
		$1.cccolumns = -1; /*21959*/
		$1.lintype = ""; /*21960*/
		$1.linwidth = -1; /*21961*/
		$forall($1.options, function() { /*21972*/
			var _3 = $k[--$j]; /*21972*/
			$1[$k[--$j]] = _3; /*21972*/
		}); /*21972*/
		$1.cccolumns = ~~$1.cccolumns; /*21974*/
		$1.linwidth = ~~$1.linwidth; /*21975*/
		if ($1.cccolumns == -1) { /*21994*/
			$k[$j++] = Infinity; /*21992*/
			$k[$j++] = "ean13"; /*21985*/
			$k[$j++] = 4; /*21985*/
			$k[$j++] = "upca"; /*21985*/
			$k[$j++] = 4; /*21985*/
			$k[$j++] = "ean8"; /*21985*/
			$k[$j++] = 3; /*21985*/
			$k[$j++] = "upce"; /*21985*/
			$k[$j++] = 2; /*21985*/
			$k[$j++] = "gs1-128"; /*21985*/
			if ($ne($1.ccversion, "c")) { /*21985*/
				$k[$j++] = 4; /*21985*/
			} else { /*21985*/
				$k[$j++] = ~~(($1.linwidth - 52) / 17); /*21985*/
			} /*21985*/
			$k[$j++] = "databaromni"; /*21992*/
			$k[$j++] = 4; /*21992*/
			$k[$j++] = "databarstacked"; /*21992*/
			$k[$j++] = 2; /*21992*/
			$k[$j++] = "databarstackedomni"; /*21992*/
			$k[$j++] = 2; /*21992*/
			$k[$j++] = "databartruncated"; /*21992*/
			$k[$j++] = 4; /*21992*/
			$k[$j++] = "databarlimited"; /*21992*/
			$k[$j++] = 3; /*21992*/
			$k[$j++] = "databarexpanded"; /*21992*/
			$k[$j++] = 4; /*21992*/
			$k[$j++] = "databarexpandedstacked"; /*21992*/
			$k[$j++] = 4; /*21992*/
			$1.cccolumns = $get($d(), $1.lintype); /*21993*/
		} /*21993*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*21998*/
			$1.out = $s($1.in.length); /*21999*/
			$1.j = 0; /*22000*/
			$k[$j++] = $1.in; /*22014*/
			for (;;) { /*22014*/
				$search($k[--$j], "^"); /*22003*/
				if ($k[--$j]) { /*22012*/
					var _J = $k[--$j]; /*22004*/
					$puti($1.out, $1.j, _J); /*22004*/
					$1.j = (_J.length + $1.j) + 1; /*22005*/
					$j--; /*22006*/
					var _N = $k[--$j]; /*22007*/
					$put($1.out, $1.j - 1, ~~$z($geti(_N, 0, 3))); /*22007*/
					$k[$j++] = $geti(_N, 3, _N.length - 3); /*22008*/
				} else { /*22012*/
					var _S = $k[--$j]; /*22010*/
					$puti($1.out, $1.j, _S); /*22010*/
					$1.j = _S.length + $1.j; /*22011*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*22012*/
					break; /*22012*/
				} /*22012*/
			} /*22012*/
		}; /*22015*/
		$1.ais = $a([]); /*22018*/
		$1.vals = $a([]); /*22019*/
		var _b = $1.barcode; /*22020*/
		$k[$j++] = $geti(_b, 1, _b.length - 1); /*22033*/
		for (;;) { /*22033*/
			var _d = $k[--$j]; /*22022*/
			$k[$j++] = _d; /*22022*/
			if ($eq(_d, "")) { /*22022*/
				break; /*22022*/
			} /*22022*/
			$search($k[--$j], ")"); /*22023*/
			$j--; /*22023*/
			var _f = $k[--$j]; /*22024*/
			var _g = $k[--$j]; /*22024*/
			var _h = $k[--$j]; /*22025*/
			$k[$j++] = _f; /*22025*/
			$search(_h, "("); /*22025*/
			if ($k[--$j]) { /*22028*/
				var _j = $k[--$j]; /*22026*/
				var _k = $k[--$j]; /*22026*/
				var _l = $k[--$j]; /*22026*/
				var _m = $k[--$j]; /*22026*/
				$k[$j++] = _l; /*22026*/
				$k[$j++] = _m; /*22026*/
				$k[$j++] = _j; /*22026*/
			} else { /*22028*/
				var _n = $k[--$j]; /*22028*/
				var _o = $k[--$j]; /*22028*/
				$k[$j++] = ""; /*22028*/
				$k[$j++] = _o; /*22028*/
				$k[$j++] = _n; /*22028*/
			} /*22028*/
			$k[$j++] = Infinity; /*22030*/
			$aload($1.ais); /*22030*/
			var _r = $k[$j - 1 - ($counttomark() + 2)]; /*22030*/
			$k[$j++] = _r; /*22030*/
			$1.ais = $a(); /*22030*/
			$k[$j++] = Infinity; /*22031*/
			$aload($1.vals); /*22031*/
			var _v = $k[$j - 1 - ($counttomark() + 1)]; /*22031*/
			$k[$j++] = _v; /*22031*/
			if ($1.expand() == $b) break; /*22031*/
			$1.vals = $a(); /*22031*/
			$j -= 2; /*22032*/
		} /*22032*/
		$j--; /*22034*/
		$1.isupper = function() {
			var _x = $k[--$j]; /*22037*/
			$k[$j++] = (_x >= 65) && (_x <= 90); /*22037*/
		}; /*22037*/
		$1.isnum0 = function() {
			var _y = $k[--$j]; /*22038*/
			$k[$j++] = (_y >= 48) && (_y <= 57); /*22038*/
		}; /*22038*/
		$1.isnum1 = function() {
			var _z = $k[--$j]; /*22039*/
			$k[$j++] = (_z >= 49) && (_z <= 57); /*22039*/
		}; /*22039*/
		for (;;) { /*22085*/
			if ($1.ais.length >= 1) { /*22047*/
				if (($eq($get($1.ais, 0), "10") || $eq($get($1.ais, 0), "11")) || $eq($get($1.ais, 0), "17")) { /*22046*/
					$k[$j++] = -1; /*22045*/
					$k[$j++] = "10"; /*22045*/
					break; /*22045*/
				} /*22045*/
			} /*22045*/
			if ($1.ais.length >= 1) { /*22080*/
				if ($eq($get($1.ais, 0), "90")) { /*22079*/
					$1.v = $get($1.vals, 0); /*22052*/
					if ($1.v.length >= 1) { /*22057*/
						$k[$j++] = $get($1.v, 0); /*22054*/
						if ($1.isupper() == $b) break; /*22054*/
						if ($k[--$j]) { /*22056*/
							$k[$j++] = 0; /*22055*/
							$k[$j++] = "11"; /*22055*/
							break; /*22055*/
						} /*22055*/
					} /*22055*/
					if ($1.v.length >= 2) { /*22063*/
						$k[$j++] = $get($1.v, 0); /*22059*/
						if ($1.isnum1() == $b) break; /*22059*/
						$k[$j++] = $get($1.v, 1); /*22060*/
						if ($1.isupper() == $b) break; /*22060*/
						var _1L = $k[--$j]; /*22060*/
						if (($k[--$j] && _1L)) { /*22062*/
							$k[$j++] = 1; /*22061*/
							$k[$j++] = "11"; /*22061*/
							break; /*22061*/
						} /*22061*/
					} /*22061*/
					if ($1.v.length >= 3) { /*22070*/
						$k[$j++] = $get($1.v, 0); /*22065*/
						if ($1.isnum1() == $b) break; /*22065*/
						$k[$j++] = $get($1.v, 1); /*22066*/
						if ($1.isnum0() == $b) break; /*22066*/
						var _1S = $k[--$j]; /*22066*/
						var _1T = $k[--$j]; /*22066*/
						$k[$j++] = $an(_1T, _1S); /*22067*/
						$k[$j++] = $get($1.v, 2); /*22067*/
						if ($1.isupper() == $b) break; /*22067*/
						var _1W = $k[--$j]; /*22067*/
						if (($k[--$j] && _1W)) { /*22069*/
							$k[$j++] = 2; /*22068*/
							$k[$j++] = "11"; /*22068*/
							break; /*22068*/
						} /*22068*/
					} /*22068*/
					if ($1.v.length >= 4) { /*22078*/
						$k[$j++] = $get($1.v, 0); /*22072*/
						if ($1.isnum1() == $b) break; /*22072*/
						$k[$j++] = $get($1.v, 1); /*22073*/
						if ($1.isnum0() == $b) break; /*22073*/
						var _1d = $k[--$j]; /*22073*/
						var _1e = $k[--$j]; /*22073*/
						$k[$j++] = $an(_1e, _1d); /*22074*/
						$k[$j++] = $get($1.v, 2); /*22074*/
						if ($1.isnum0() == $b) break; /*22074*/
						var _1h = $k[--$j]; /*22074*/
						var _1i = $k[--$j]; /*22074*/
						$k[$j++] = $an(_1i, _1h); /*22075*/
						$k[$j++] = $get($1.v, 3); /*22075*/
						if ($1.isupper() == $b) break; /*22075*/
						var _1l = $k[--$j]; /*22075*/
						if (($k[--$j] && _1l)) { /*22077*/
							$k[$j++] = 3; /*22076*/
							$k[$j++] = "11"; /*22076*/
							break; /*22076*/
						} /*22076*/
					} /*22076*/
				} /*22076*/
			} /*22076*/
			$k[$j++] = -1; /*22083*/
			$k[$j++] = "0"; /*22083*/
			break; /*22083*/
		} /*22083*/
		$1.method = $k[--$j]; /*22086*/
		$1.npre = $k[--$j]; /*22087*/
		$1.fnc1 = -1; /*22089*/
		$1.lnumeric = -2; /*22089*/
		$1.lalphanumeric = -3; /*22089*/
		$1.liso646 = -4; /*22089*/
		$1.tobin = function() {
			var _1q = $s($k[--$j]); /*22092*/
			$k[$j++] = _1q; /*22092*/
			for (var _1s = 0, _1r = _1q.length - 1; _1s <= _1r; _1s += 1) { /*22092*/
				var _1t = $k[--$j]; /*22092*/
				$put(_1t, _1s, 48); /*22092*/
				$k[$j++] = _1t; /*22092*/
			} /*22092*/
			var _1u = $k[--$j]; /*22093*/
			var _1x = $cvrs($s(_1u.length), $k[--$j], 2); /*22093*/
			$puti(_1u, _1u.length - _1x.length, _1x); /*22093*/
			$k[$j++] = _1u; /*22093*/
		}; /*22094*/
		$k[$j++] = "alpha"; /*22099*/
		$k[$j++] = Infinity; /*22099*/
		for (var _1y = 65; _1y <= 90; _1y += 1) { /*22097*/
			$k[$j++] = _1y; /*22097*/
			$k[$j++] = _1y - 65; /*22097*/
			$k[$j++] = 5; /*22097*/
			if ($1.tobin() == $b) break; /*22097*/
		} /*22097*/
		for (var _1z = 48; _1z <= 57; _1z += 1) { /*22098*/
			$k[$j++] = _1z; /*22098*/
			$k[$j++] = _1z + 4; /*22098*/
			$k[$j++] = 6; /*22098*/
			if ($1.tobin() == $b) break; /*22098*/
		} /*22098*/
		$k[$j++] = $1.fnc1; /*22099*/
		$k[$j++] = "11111"; /*22099*/
		var _21 = $d(); /*22099*/
		$1[$k[--$j]] = _21; /*22100*/
		$k[$j++] = "numeric"; /*22112*/
		$k[$j++] = Infinity; /*22112*/
		for (var _23 = 0; _23 <= 119; _23 += 1) { /*22111*/
			var _25 = $strcpy($s(2), "00"); /*22104*/
			var _27 = $cvrs($s(2), _23, 11); /*22104*/
			$puti(_25, 2 - _27.length, _27); /*22105*/
			$k[$j++] = _23; /*22106*/
			$k[$j++] = _25; /*22106*/
			if ($get(_25, 0) == 65) { /*22106*/
				var _29 = $k[--$j]; /*22106*/
				$put(_29, 0, 94); /*22106*/
				$k[$j++] = _29; /*22106*/
			} /*22106*/
			var _2A = $k[--$j]; /*22107*/
			$k[$j++] = _2A; /*22107*/
			if ($get(_2A, 1) == 65) { /*22107*/
				var _2C = $k[--$j]; /*22107*/
				$put(_2C, 1, 94); /*22107*/
				$k[$j++] = _2C; /*22107*/
			} /*22107*/
			var _2D = $k[--$j]; /*22108*/
			var _2G = $strcpy($s(7), "0000000"); /*22109*/
			var _2I = $cvrs($s(7), $k[--$j] + 8, 2); /*22109*/
			$puti(_2G, 7 - _2I.length, _2I); /*22110*/
			$k[$j++] = _2D; /*22110*/
			$k[$j++] = _2G; /*22110*/
		} /*22110*/
		$k[$j++] = $1.lalphanumeric; /*22112*/
		$k[$j++] = "0000"; /*22112*/
		var _2K = $d(); /*22112*/
		$1[$k[--$j]] = _2K; /*22113*/
		$k[$j++] = "alphanumeric"; /*22122*/
		$k[$j++] = Infinity; /*22122*/
		for (var _2M = 48; _2M <= 57; _2M += 1) { /*22116*/
			$k[$j++] = _2M; /*22116*/
			$k[$j++] = _2M - 43; /*22116*/
			$k[$j++] = 5; /*22116*/
			if ($1.tobin() == $b) break; /*22116*/
		} /*22116*/
		$k[$j++] = $1.fnc1; /*22118*/
		$k[$j++] = "01111"; /*22118*/
		for (var _2O = 65; _2O <= 90; _2O += 1) { /*22118*/
			$k[$j++] = _2O; /*22118*/
			$k[$j++] = _2O - 33; /*22118*/
			$k[$j++] = 6; /*22118*/
			if ($1.tobin() == $b) break; /*22118*/
		} /*22118*/
		$k[$j++] = 42; /*22120*/
		$k[$j++] = "111010"; /*22120*/
		for (var _2P = 44; _2P <= 47; _2P += 1) { /*22120*/
			$k[$j++] = _2P; /*22120*/
			$k[$j++] = _2P + 15; /*22120*/
			$k[$j++] = 6; /*22120*/
			if ($1.tobin() == $b) break; /*22120*/
		} /*22120*/
		$k[$j++] = $1.lnumeric; /*22122*/
		$k[$j++] = "000"; /*22122*/
		$k[$j++] = $1.liso646; /*22122*/
		$k[$j++] = "00100"; /*22122*/
		var _2S = $d(); /*22122*/
		$1[$k[--$j]] = _2S; /*22123*/
		$k[$j++] = "iso646"; /*22137*/
		$k[$j++] = Infinity; /*22137*/
		for (var _2U = 48; _2U <= 57; _2U += 1) { /*22126*/
			$k[$j++] = _2U; /*22126*/
			$k[$j++] = _2U - 43; /*22126*/
			$k[$j++] = 5; /*22126*/
			if ($1.tobin() == $b) break; /*22126*/
		} /*22126*/
		$k[$j++] = $1.fnc1; /*22128*/
		$k[$j++] = "01111"; /*22128*/
		for (var _2W = 65; _2W <= 90; _2W += 1) { /*22128*/
			$k[$j++] = _2W; /*22128*/
			$k[$j++] = _2W - 1; /*22128*/
			$k[$j++] = 7; /*22128*/
			if ($1.tobin() == $b) break; /*22128*/
		} /*22128*/
		for (var _2X = 97; _2X <= 122; _2X += 1) { /*22129*/
			$k[$j++] = _2X; /*22129*/
			$k[$j++] = _2X - 7; /*22129*/
			$k[$j++] = 7; /*22129*/
			if ($1.tobin() == $b) break; /*22129*/
		} /*22129*/
		$k[$j++] = 33; /*22132*/
		$k[$j++] = "11101000"; /*22132*/
		$k[$j++] = 34; /*22132*/
		$k[$j++] = "11101001"; /*22132*/
		for (var _2Y = 37; _2Y <= 47; _2Y += 1) { /*22132*/
			$k[$j++] = _2Y; /*22132*/
			$k[$j++] = _2Y + 197; /*22132*/
			$k[$j++] = 8; /*22132*/
			if ($1.tobin() == $b) break; /*22132*/
		} /*22132*/
		for (var _2Z = 58; _2Z <= 63; _2Z += 1) { /*22133*/
			$k[$j++] = _2Z; /*22133*/
			$k[$j++] = _2Z + 187; /*22133*/
			$k[$j++] = 8; /*22133*/
			if ($1.tobin() == $b) break; /*22133*/
		} /*22133*/
		$k[$j++] = 95; /*22137*/
		$k[$j++] = "11111011"; /*22137*/
		$k[$j++] = 32; /*22137*/
		$k[$j++] = "11111100"; /*22137*/
		$k[$j++] = $1.lnumeric; /*22137*/
		$k[$j++] = "000"; /*22137*/
		$k[$j++] = $1.lalphanumeric; /*22137*/
		$k[$j++] = "00100"; /*22137*/
		var _2c = $d(); /*22137*/
		$1[$k[--$j]] = _2c; /*22138*/
		if ($eq($1.method, "10")) { /*22171*/
			if ($eq($get($1.ais, 0), "11") || $eq($get($1.ais, 0), "17")) { /*22155*/
				var _2k = $get($1.vals, 0); /*22142*/
				var _2p = $strcpy($s(16), "0000000000000000"); /*22146*/
				var _2r = $cvrs($s(16), ((~~$z($geti(_2k, 0, 2))) * 384) + ((((~~$z($geti(_2k, 2, 2))) - 1) * 32) + (~~$z($geti(_2k, 4, 2)))), 2); /*22146*/
				$puti(_2p, 16 - _2r.length, _2r); /*22147*/
				$k[$j++] = _2p; /*22150*/
				$k[$j++] = Infinity; /*22150*/
				var _2s = $k[--$j]; /*22149*/
				var _2t = $k[--$j]; /*22149*/
				$k[$j++] = _2s; /*22149*/
				$k[$j++] = 1; /*22149*/
				$k[$j++] = 0; /*22149*/
				$forall(_2t, function() { /*22149*/
					var _2u = $k[--$j]; /*22149*/
					$k[$j++] = _2u - 48; /*22149*/
				}); /*22149*/
				var _2x = $eq($get($1.ais, 0), "11") ? 0 : 1; /*22150*/
				$k[$j++] = _2x; /*22150*/
				$1.cdf = $a(); /*22151*/
				$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*22152*/
				$1.vals = $geti($1.vals, 1, $1.vals.length - 1); /*22153*/
			} else { /*22155*/
				$1.cdf = $a([1, 0, 1, 1]); /*22155*/
			} /*22155*/
			if ($1.ais.length != 0) { /*22168*/
				if ($eq($get($1.ais, 0), "10")) { /*22164*/
					$k[$j++] = Infinity; /*22159*/
					$forall($get($1.vals, 0)); /*22159*/
					$1.gpf = $a(); /*22159*/
					if ($1.ais.length > 1) { /*22160*/
						$k[$j++] = Infinity; /*22160*/
						$aload($1.gpf); /*22160*/
						$k[$j++] = $1.fnc1; /*22160*/
						$1.gpf = $a(); /*22160*/
					} /*22160*/
					$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*22161*/
					$1.vals = $geti($1.vals, 1, $1.vals.length - 1); /*22162*/
				} else { /*22164*/
					$1.gpf = $a([$1.fnc1]); /*22164*/
				} /*22164*/
			} else { /*22168*/
				$k[$j++] = Infinity; /*22167*/
				$aload($1.cdf); /*22167*/
				$k[$j++] = 0; /*22167*/
				$k[$j++] = 0; /*22167*/
				$k[$j++] = 0; /*22167*/
				$k[$j++] = 0; /*22167*/
				$k[$j++] = 0; /*22167*/
				$k[$j++] = 1; /*22167*/
				$k[$j++] = 1; /*22167*/
				$k[$j++] = 1; /*22167*/
				$k[$j++] = 1; /*22167*/
				$1.cdf = $a(); /*22167*/
				$1.gpf = $a([]); /*22168*/
			} /*22168*/
			$1.mode = "numeric"; /*22170*/
		} /*22170*/
		if ($eq($1.method, "11")) { /*22264*/
			$1.cdf = $a([1, 1]); /*22174*/
			$1.ai90 = $get($1.vals, 0); /*22175*/
			if (($1.npre + 1) != $1.ai90.length) { /*22179*/
				$k[$j++] = $geti($1.ai90, $1.npre + 1, ($1.ai90.length - $1.npre) - 1); /*22177*/
			} else { /*22179*/
				$k[$j++] = ""; /*22179*/
			} /*22179*/
			$1.ai90rem = $k[--$j]; /*22181*/
			$k[$j++] = "nalpha"; /*22182*/
			$k[$j++] = 0; /*22182*/
			$forall($1.ai90rem, function() { /*22182*/
				var _3e = $k[--$j]; /*22182*/
				if ((_3e >= 65) && (_3e <= 90)) { /*22182*/
					var _3f = $k[--$j]; /*22182*/
					$k[$j++] = _3f + 1; /*22182*/
				} /*22182*/
			}); /*22182*/
			var _3g = $k[--$j]; /*22182*/
			$1[$k[--$j]] = _3g; /*22182*/
			$k[$j++] = "nnums"; /*22183*/
			$k[$j++] = 0; /*22183*/
			$forall($1.ai90rem, function() { /*22183*/
				var _3j = $k[--$j]; /*22183*/
				if ((_3j >= 48) && (_3j <= 57)) { /*22183*/
					var _3k = $k[--$j]; /*22183*/
					$k[$j++] = _3k + 1; /*22183*/
				} /*22183*/
			}); /*22183*/
			var _3l = $k[--$j]; /*22183*/
			$1[$k[--$j]] = _3l; /*22183*/
			$k[$j++] = "mode"; /*22184*/
			if ($gt($1.nalpha, $1.nnums)) { /*22184*/
				$k[$j++] = "alpha"; /*22184*/
			} else { /*22184*/
				$k[$j++] = "numeric"; /*22184*/
			} /*22184*/
			var _3p = $k[--$j]; /*22184*/
			$1[$k[--$j]] = _3p; /*22184*/
			if (($1.nalpha + $1.nnums) != $1.ai90rem.length) { /*22185*/
				$1.mode = "alphanumeric"; /*22185*/
			} /*22185*/
			$k[$j++] = Infinity; /*22191*/
			$aload($1.cdf); /*22187*/
			if ($eq($1.mode, "alphanumeric")) { /*22188*/
				$k[$j++] = 0; /*22188*/
			} /*22188*/
			if ($eq($1.mode, "numeric")) { /*22189*/
				$k[$j++] = 1; /*22189*/
				$k[$j++] = 0; /*22189*/
			} /*22189*/
			if ($eq($1.mode, "alpha")) { /*22190*/
				$k[$j++] = 1; /*22190*/
				$k[$j++] = 1; /*22190*/
			} /*22190*/
			$1.cdf = $a(); /*22191*/
			$k[$j++] = "ais1"; /*22192*/
			if ($1.ais.length > 1) { /*22192*/
				$k[$j++] = $get($1.ais, 1); /*22192*/
			} else { /*22192*/
				$k[$j++] = -1; /*22192*/
			} /*22192*/
			var _42 = $k[--$j]; /*22192*/
			$1[$k[--$j]] = _42; /*22192*/
			$k[$j++] = "vals1"; /*22193*/
			if ($1.vals.length > 1) { /*22193*/
				$k[$j++] = $get($1.vals, 1); /*22193*/
			} else { /*22193*/
				$k[$j++] = -1; /*22193*/
			} /*22193*/
			var _47 = $k[--$j]; /*22193*/
			$1[$k[--$j]] = _47; /*22193*/
			if ($eq($1.ais1, "21") || $eq($1.ais1, "8004")) { /*22197*/
				$k[$j++] = Infinity; /*22195*/
				$aload($1.cdf); /*22195*/
				if ($eq($1.ais1, "21")) { /*22195*/
					$k[$j++] = 1; /*22195*/
					$k[$j++] = 0; /*22195*/
				} else { /*22195*/
					$k[$j++] = 1; /*22195*/
					$k[$j++] = 1; /*22195*/
				} /*22195*/
				$1.cdf = $a(); /*22195*/
			} else { /*22197*/
				$k[$j++] = Infinity; /*22197*/
				$aload($1.cdf); /*22197*/
				$k[$j++] = 0; /*22197*/
				$1.cdf = $a(); /*22197*/
			} /*22197*/
			$k[$j++] = "nval"; /*22199*/
			if ($1.npre != 0) { /*22199*/
				$k[$j++] = ~~$z($geti($1.ai90, 0, $1.npre)); /*22199*/
			} else { /*22199*/
				$k[$j++] = 0; /*22199*/
			} /*22199*/
			var _4K = $k[--$j]; /*22199*/
			$1[$k[--$j]] = _4K; /*22199*/
			$search("BDHIJKLNPQRSTVXZ", $geti($1.ai90, $1.npre, 1)); /*22200*/
			if ($k[--$j]) { /*22204*/
				var _4Q = $k[--$j]; /*22201*/
				var _4R = $k[--$j]; /*22201*/
				var _4S = $k[--$j]; /*22201*/
				$1.aval = _4Q.length; /*22202*/
			} else { /*22204*/
				$j--; /*22204*/
				$1.aval = -1; /*22204*/
			} /*22204*/
			if (($1.nval < 31) && ($1.aval != -1)) { /*22230*/
				var _4W = $strcpy($s(5), "00000"); /*22207*/
				var _4Z = $cvrs($s(5), $1.nval, 2); /*22207*/
				$puti(_4W, 5 - _4Z.length, _4Z); /*22208*/
				$k[$j++] = _4W; /*22209*/
				$k[$j++] = Infinity; /*22209*/
				var _4a = $k[--$j]; /*22209*/
				var _4b = $k[--$j]; /*22209*/
				$k[$j++] = _4a; /*22209*/
				$forall(_4b, function() { /*22209*/
					var _4c = $k[--$j]; /*22209*/
					$k[$j++] = _4c - 48; /*22209*/
				}); /*22209*/
				$1.nbits = $a(); /*22209*/
				var _4f = $strcpy($s(4), "0000"); /*22210*/
				var _4i = $cvrs($s(4), $1.aval, 2); /*22210*/
				$puti(_4f, 4 - _4i.length, _4i); /*22211*/
				$k[$j++] = _4f; /*22212*/
				$k[$j++] = Infinity; /*22212*/
				var _4j = $k[--$j]; /*22212*/
				var _4k = $k[--$j]; /*22212*/
				$k[$j++] = _4j; /*22212*/
				$forall(_4k, function() { /*22212*/
					var _4l = $k[--$j]; /*22212*/
					$k[$j++] = _4l - 48; /*22212*/
				}); /*22212*/
				$1.abits = $a(); /*22212*/
				$k[$j++] = Infinity; /*22217*/
				$aload($1.cdf); /*22214*/
				$aload($1.nbits); /*22215*/
				$aload($1.abits); /*22216*/
				$1.cdf = $a(); /*22217*/
			} else { /*22230*/
				var _4s = $strcpy($s(10), "0000000000"); /*22219*/
				var _4v = $cvrs($s(10), $1.nval, 2); /*22219*/
				$puti(_4s, 10 - _4v.length, _4v); /*22220*/
				$k[$j++] = _4s; /*22221*/
				$k[$j++] = Infinity; /*22221*/
				var _4w = $k[--$j]; /*22221*/
				var _4x = $k[--$j]; /*22221*/
				$k[$j++] = _4w; /*22221*/
				$forall(_4x, function() { /*22221*/
					var _4y = $k[--$j]; /*22221*/
					$k[$j++] = _4y - 48; /*22221*/
				}); /*22221*/
				$1.nbits = $a(); /*22221*/
				var _51 = $strcpy($s(5), "00000"); /*22222*/
				var _56 = $cvrs($s(5), $get($1.ai90, $1.npre) - 65, 2); /*22222*/
				$puti(_51, 5 - _56.length, _56); /*22223*/
				$k[$j++] = _51; /*22224*/
				$k[$j++] = Infinity; /*22224*/
				var _57 = $k[--$j]; /*22224*/
				var _58 = $k[--$j]; /*22224*/
				$k[$j++] = _57; /*22224*/
				$forall(_58, function() { /*22224*/
					var _59 = $k[--$j]; /*22224*/
					$k[$j++] = _59 - 48; /*22224*/
				}); /*22224*/
				$1.abits = $a(); /*22224*/
				$k[$j++] = Infinity; /*22230*/
				$aload($1.cdf); /*22226*/
				$k[$j++] = 1; /*22228*/
				$k[$j++] = 1; /*22228*/
				$k[$j++] = 1; /*22228*/
				$k[$j++] = 1; /*22228*/
				$k[$j++] = 1; /*22228*/
				$aload($1.nbits); /*22228*/
				$aload($1.abits); /*22229*/
				$1.cdf = $a(); /*22230*/
			} /*22230*/
			if ($eq($1.mode, "numeric")) { /*22249*/
				$k[$j++] = Infinity; /*22233*/
				$forall($1.ai90rem); /*22233*/
				if ($1.ais.length > 1) { /*22233*/
					$k[$j++] = $1.fnc1; /*22233*/
				} /*22233*/
				$1.gpf = $a(); /*22233*/
			} else { /*22249*/
				$k[$j++] = "encs"; /*22235*/
				if ($eq($1.mode, "alpha")) { /*22235*/
					$k[$j++] = $1.alpha; /*22235*/
				} else { /*22235*/
					$k[$j++] = $1.alphanumeric; /*22235*/
				} /*22235*/
				var _5N = $k[--$j]; /*22235*/
				$1[$k[--$j]] = _5N; /*22235*/
				$k[$j++] = Infinity; /*22236*/
				$forall($1.ai90rem); /*22236*/
				if ($1.ais.length > 1) { /*22236*/
					$k[$j++] = $1.fnc1; /*22236*/
				} /*22236*/
				$1.in = $a(); /*22236*/
				$1.out = $a($1.in.length * 6); /*22237*/
				$1.j = 0; /*22238*/
				for (var _5X = 0, _5W = $1.in.length - 1; _5X <= _5W; _5X += 1) { /*22243*/
					var _5b = $get($1.encs, $get($1.in, _5X)); /*22240*/
					$k[$j++] = _5b; /*22241*/
					$k[$j++] = _5b; /*22241*/
					$k[$j++] = Infinity; /*22241*/
					var _5c = $k[--$j]; /*22241*/
					var _5d = $k[--$j]; /*22241*/
					$k[$j++] = _5c; /*22241*/
					$forall(_5d, function() { /*22241*/
						var _5e = $k[--$j]; /*22241*/
						$k[$j++] = _5e - 48; /*22241*/
					}); /*22241*/
					$puti($1.out, $1.j, $a()); /*22241*/
					$1.j = $k[--$j].length + $1.j; /*22242*/
				} /*22242*/
				$k[$j++] = Infinity; /*22247*/
				$aload($1.cdf); /*22245*/
				$aload($geti($1.out, 0, $1.j)); /*22246*/
				$1.cdf = $a(); /*22247*/
				$1.gpf = $a([]); /*22248*/
				if (($1.ais.length > 1) || $ne($1.mode, "alpha")) { /*22249*/
					$1.mode = "numeric"; /*22249*/
				} /*22249*/
			} /*22249*/
			$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*22251*/
			$1.vals = $geti($1.vals, 1, $1.vals.length - 1); /*22252*/
			if ($1.ais.length != 0) { /*22263*/
				if ($eq($1.ais1, "21") || $eq($1.ais1, "8004")) { /*22262*/
					$k[$j++] = Infinity; /*22258*/
					$aload($1.gpf); /*22256*/
					$forall($1.vals1); /*22257*/
					$1.gpf = $a(); /*22258*/
					$1.ais = $geti($1.ais, 1, $1.ais.length - 1); /*22259*/
					$1.vals = $geti($1.vals, 1, $1.vals.length - 1); /*22260*/
					if ($1.ais.length != 0) { /*22261*/
						$k[$j++] = Infinity; /*22261*/
						$aload($1.gpf); /*22261*/
						$k[$j++] = $1.fnc1; /*22261*/
						$1.gpf = $a(); /*22261*/
					} /*22261*/
				} /*22261*/
			} /*22261*/
		} /*22261*/
		if ($eq($1.method, "0")) { /*22270*/
			$1.cdf = $a([0]); /*22267*/
			$1.gpf = $a([]); /*22268*/
			$1.mode = "numeric"; /*22269*/
		} /*22269*/
		$1.aifixed = {}; /*22275*/
		$k[$j++] = Infinity; /*22277*/
		for (var _6H = 0; _6H <= 4; _6H += 1) { /*22277*/
			$k[$j++] = _6H; /*22277*/
		} /*22277*/
		var _6I = $a(); /*22277*/
		for (var _6J = 0, _6K = _6I.length; _6J < _6K; _6J++) { /*22280*/
			var _6N = $strcpy($s(2), "00"); /*22279*/
			$put(_6N, 1, $get(_6I, _6J) + 48); /*22279*/
			$put($1.aifixed, _6N, _6N); /*22279*/
		} /*22279*/
		$k[$j++] = Infinity; /*22285*/
		for (var _6P = 11; _6P <= 20; _6P += 1) { /*22282*/
			$k[$j++] = _6P; /*22282*/
		} /*22282*/
		$k[$j++] = 23; /*22284*/
		for (var _6Q = 31; _6Q <= 36; _6Q += 1) { /*22284*/
			$k[$j++] = _6Q; /*22284*/
		} /*22284*/
		$k[$j++] = 41; /*22285*/
		var _6R = $a(); /*22285*/
		for (var _6S = 0, _6T = _6R.length; _6S < _6T; _6S++) { /*22288*/
			var _6W = $cvrs($s(2), $get(_6R, _6S), 10); /*22287*/
			$put($1.aifixed, _6W, _6W); /*22287*/
		} /*22287*/
		for (var _6a = 0, _6Z = $1.ais.length - 1; _6a <= _6Z; _6a += 1) { /*22306*/
			$1.i = _6a; /*22292*/
			$1.ai = $get($1.ais, $1.i); /*22293*/
			$1.val = $get($1.vals, $1.i); /*22294*/
			var _6k = $a(($1.gpf.length + $1.ai.length) + $1.val.length); /*22295*/
			$puti(_6k, 0, $1.gpf); /*22296*/
			$k[$j++] = _6k; /*22297*/
			$k[$j++] = _6k; /*22297*/
			$k[$j++] = $1.gpf.length; /*22297*/
			$k[$j++] = $1.ai; /*22297*/
			$k[$j++] = Infinity; /*22297*/
			var _6o = $k[--$j]; /*22297*/
			var _6p = $k[--$j]; /*22297*/
			$k[$j++] = _6o; /*22297*/
			$forall(_6p); /*22297*/
			var _6q = $a(); /*22297*/
			var _6r = $k[--$j]; /*22297*/
			$puti($k[--$j], _6r, _6q); /*22297*/
			var _6t = $k[--$j]; /*22298*/
			$k[$j++] = _6t; /*22298*/
			$k[$j++] = _6t; /*22298*/
			$k[$j++] = $1.gpf.length + $1.ai.length; /*22298*/
			$k[$j++] = $1.val; /*22298*/
			$k[$j++] = Infinity; /*22298*/
			var _6x = $k[--$j]; /*22298*/
			var _6y = $k[--$j]; /*22298*/
			$k[$j++] = _6x; /*22298*/
			$forall(_6y); /*22298*/
			var _6z = $a(); /*22298*/
			var _70 = $k[--$j]; /*22298*/
			$puti($k[--$j], _70, _6z); /*22298*/
			$1.gpf = $k[--$j]; /*22299*/
			var _78 = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*22300*/
			if (($1.i != ($1.ais.length - 1)) && (!_78)) { /*22305*/
				var _7A = $a($1.gpf.length + 1); /*22301*/
				$puti(_7A, 0, $1.gpf); /*22302*/
				$put(_7A, $1.gpf.length, $1.fnc1); /*22303*/
				$1.gpf = _7A; /*22304*/
			} /*22304*/
		} /*22304*/
		$1.rembits = function() {
			$1.used = $k[--$j]; /*22310*/
			if ($ne($1.ccversion, "c")) { /*22339*/
				var _7O = {
					a: $a([$a([167, 138, 118, 108, 88, 78, 59]), $a([167, 138, 118, 98, 78]), $a([197, 167, 138, 108, 78])]),
					b: $a([$a([336, 296, 256, 208, 160, 104, 56]), $a([768, 648, 536, 416, 304, 208, 152, 112, 72, 32]), $a([1184, 1016, 840, 672, 496, 352, 264, 208, 152, 96, 56])])
				}; /*22321*/
				$1.bitcaps = $get($get(_7O, $1.ccversion), $1.cccolumns - 2); /*22323*/
				$k[$j++] = -1; /*22324*/
				$forall($1.bitcaps, function() { /*22324*/
					var _7U = $k[--$j]; /*22324*/
					$k[$j++] = _7U; /*22324*/
					if ($ge(_7U, $1.used)) { /*22324*/
						var _7W = $k[--$j]; /*22324*/
						var _7X = $k[--$j]; /*22324*/
						$k[$j++] = _7W; /*22324*/
						$k[$j++] = _7X; /*22324*/
					} /*22324*/
					$j--; /*22324*/
				}); /*22324*/
				var _7Y = $k[--$j]; /*22325*/
				$k[$j++] = _7Y; /*22325*/
				if (_7Y != -1) { /*22325*/
					var _7a = $k[--$j]; /*22325*/
					$k[$j++] = _7a - $1.used; /*22325*/
				} /*22325*/
			} else { /*22339*/
				var _7b = {
					c: -1
				}; /*22327*/
				var _7d = $get(_7b, $1.ccversion); /*22327*/
				var _7f = ~~Math.ceil($1.used / 8); /*22328*/
				$1.m = ((~~(_7f / 6)) * 5) + (_7f % 6); /*22328*/
				if ($1.m <= 40) { /*22329*/
					$k[$j++] = 8; /*22329*/
				} /*22329*/
				if (($1.m >= 41) && ($1.m <= 160)) { /*22330*/
					$k[$j++] = 16; /*22330*/
				} /*22330*/
				if (($1.m >= 161) && ($1.m <= 320)) { /*22331*/
					$k[$j++] = 32; /*22331*/
				} /*22331*/
				if ($1.m >= 321) { /*22332*/
					$k[$j++] = 64; /*22332*/
				} /*22332*/
				$1.eccws = $k[--$j]; /*22333*/
				$1.m = ($1.m + $1.eccws) + 3; /*22334*/
				$1.c = ~~(($1.linwidth - 52) / 17); /*22335*/
				if ((~~($1.m / $1.c)) > 90) { /*22336*/
					$1.c = $1.c + 1; /*22336*/
				} /*22336*/
				$1.r = ~~Math.ceil($1.m / $1.c); /*22337*/
				var _7y = (($1.c * $1.r) - $1.eccws) - 3; /*22338*/
				$1.tgt = (((~~(_7y / 5)) * 6) + (_7y % 5)) * 8; /*22338*/
				if ($1.used <= 8296) { /*22339*/
					$k[$j++] = $1.tgt - $1.used; /*22339*/
				} else { /*22339*/
					$k[$j++] = -1; /*22339*/
				} /*22339*/
			} /*22339*/
			var _82 = $k[--$j]; /*22341*/
			$k[$j++] = _82; /*22354*/
			if (_82 == -1) { /*22354*/
				$j--; /*22342*/
				if ($eq($1.ccversion, "a")) { /*22350*/
					$1.ccversion = "b"; /*22344*/
				} else { /*22350*/
					if ($eq($1.ccversion, "b") && $eq($1.lintype, "gs1-128")) { /*22350*/
						$1.ccversion = "c"; /*22347*/
						$1.cccolumns = ~~(($1.linwidth - 52) / 17); /*22348*/
					} else { /*22350*/
						$1.ccversion = -1; /*22350*/
					} /*22350*/
				} /*22350*/
				$k[$j++] = $1.used; /*22353*/
				if ($1.rembits() == $b) return $b; /*22353*/
			} /*22353*/
		}; /*22355*/
		$1.encode = function() {
			var _88 = $k[--$j]; /*22358*/
			$k[$j++] = _88; /*22358*/
			if ($ne(_88, "raw")) { /*22358*/
				var _89 = $k[--$j]; /*22358*/
				var _8B = $get(_89, $k[--$j]); /*22358*/
				$k[$j++] = _8B; /*22358*/
			} else { /*22358*/
				$j--; /*22358*/
			} /*22358*/
			$k[$j++] = Infinity; /*22359*/
			var _8C = $k[--$j]; /*22359*/
			var _8D = $k[--$j]; /*22359*/
			$k[$j++] = _8C; /*22359*/
			$forall(_8D, function() { /*22359*/
				var _8E = $k[--$j]; /*22359*/
				$k[$j++] = _8E - 48; /*22359*/
			}); /*22359*/
			var _8F = $a(); /*22359*/
			$puti($1.gpfenc, $1.j, _8F); /*22361*/
			$1.j = _8F.length + $1.j; /*22362*/
		}; /*22363*/
		$k[$j++] = Infinity; /*22366*/
		for (var _8K = 0, _8L = $1.gpf.length; _8K < _8L; _8K++) { /*22366*/
			$k[$j++] = 0; /*22366*/
		} /*22366*/
		$k[$j++] = 0; /*22366*/
		$k[$j++] = -1; /*22366*/
		$1.numericruns = $a(); /*22366*/
		$k[$j++] = Infinity; /*22367*/
		for (var _8O = 0, _8P = $1.gpf.length; _8O < _8P; _8O++) { /*22367*/
			$k[$j++] = 0; /*22367*/
		} /*22367*/
		$k[$j++] = 0; /*22367*/
		$1.alphanumericruns = $a(); /*22367*/
		$k[$j++] = Infinity; /*22368*/
		for (var _8S = 0, _8T = $1.gpf.length; _8S < _8T; _8S++) { /*22368*/
			$k[$j++] = 0; /*22368*/
		} /*22368*/
		$k[$j++] = 9999; /*22368*/
		$1.nextiso646only = $a(); /*22368*/
		for (var _8W = $1.gpf.length - 1; _8W >= 0; _8W -= 1) { /*22390*/
			$1.i = _8W; /*22370*/
			var _8b = $strcpy($s(2), "00"); /*22372*/
			var _8e = $get($1.gpf, $1.i); /*22373*/
			$k[$j++] = $get($1.gpf, $1.i); /*22373*/
			$k[$j++] = _8b; /*22373*/
			$k[$j++] = _8b; /*22373*/
			$k[$j++] = 0; /*22373*/
			$k[$j++] = _8e; /*22373*/
			if (_8e == $1.fnc1) { /*22373*/
				$j--; /*22373*/
				$k[$j++] = 94; /*22373*/
			} /*22373*/
			var _8g = $k[--$j]; /*22373*/
			var _8h = $k[--$j]; /*22373*/
			$put($k[--$j], _8h, _8g); /*22373*/
			if ($1.i < ($1.gpf.length - 1)) { /*22374*/
				var _8l = $k[--$j]; /*22374*/
				var _8o = $get($1.gpf, $1.i + 1); /*22374*/
				$k[$j++] = _8l; /*22374*/
				$k[$j++] = _8l; /*22374*/
				$k[$j++] = 1; /*22374*/
				$k[$j++] = _8o; /*22374*/
				if (_8o == $1.fnc1) { /*22374*/
					$j--; /*22374*/
					$k[$j++] = 94; /*22374*/
				} /*22374*/
				var _8q = $k[--$j]; /*22374*/
				var _8r = $k[--$j]; /*22374*/
				$put($k[--$j], _8r, _8q); /*22374*/
			} /*22374*/
			var _8v = $get($1.numeric, $k[--$j]) !== undefined; /*22375*/
			if (_8v) { /*22378*/
				$put($1.numericruns, $1.i, $get($1.numericruns, $1.i + 2) + 2); /*22376*/
			} else { /*22378*/
				$put($1.numericruns, $1.i, 0); /*22378*/
			} /*22378*/
			var _93 = $k[--$j]; /*22380*/
			var _95 = $get($1.alphanumeric, _93) !== undefined; /*22380*/
			$k[$j++] = _93; /*22384*/
			if (_95) { /*22383*/
				$put($1.alphanumericruns, $1.i, $get($1.alphanumericruns, $1.i + 1) + 1); /*22381*/
			} else { /*22383*/
				$put($1.alphanumericruns, $1.i, 0); /*22383*/
			} /*22383*/
			var _9D = $k[--$j]; /*22385*/
			var _9F = $get($1.iso646, _9D) !== undefined; /*22385*/
			var _9H = $get($1.alphanumeric, _9D) !== undefined; /*22385*/
			if (_9F && (!_9H)) { /*22388*/
				$put($1.nextiso646only, $1.i, 0); /*22386*/
			} else { /*22388*/
				$put($1.nextiso646only, $1.i, $get($1.nextiso646only, $1.i + 1) + 1); /*22388*/
			} /*22388*/
		} /*22388*/
		$1.gpfenc = $a(8296); /*22393*/
		$1.i = 0; /*22394*/
		$1.j = 0; /*22394*/
		for (;;) { /*22484*/
			if ($1.i == $1.gpf.length) { /*22396*/
				break; /*22396*/
			} /*22396*/
			for (;;) { /*22483*/
				if ($eq($1.mode, "numeric")) { /*22432*/
					if ($1.i <= ($1.gpf.length - 2)) { /*22429*/
						var _9V = $s(2); /*22401*/
						var _9Y = $get($1.gpf, $1.i); /*22402*/
						$k[$j++] = _9V; /*22402*/
						$k[$j++] = _9V; /*22402*/
						$k[$j++] = 0; /*22402*/
						$k[$j++] = _9Y; /*22402*/
						if (_9Y == $1.fnc1) { /*22402*/
							$j--; /*22402*/
							$k[$j++] = 94; /*22402*/
						} /*22402*/
						var _9a = $k[--$j]; /*22402*/
						var _9b = $k[--$j]; /*22402*/
						$put($k[--$j], _9b, _9a); /*22402*/
						var _9d = $k[--$j]; /*22403*/
						var _9g = $get($1.gpf, $1.i + 1); /*22403*/
						$k[$j++] = _9d; /*22403*/
						$k[$j++] = _9d; /*22403*/
						$k[$j++] = 1; /*22403*/
						$k[$j++] = _9g; /*22403*/
						if (_9g == $1.fnc1) { /*22403*/
							$j--; /*22403*/
							$k[$j++] = 94; /*22403*/
						} /*22403*/
						var _9i = $k[--$j]; /*22403*/
						var _9j = $k[--$j]; /*22403*/
						$put($k[--$j], _9j, _9i); /*22403*/
						var _9l = $k[--$j]; /*22404*/
						var _9n = $get($1.numeric, _9l) !== undefined; /*22404*/
						$k[$j++] = _9l; /*22408*/
						if (_9n) { /*22408*/
							$k[$j++] = $1.numeric; /*22405*/
							if ($1.encode() == $b) break; /*22405*/
							$1.i = $1.i + 2; /*22406*/
							break; /*22407*/
						} /*22407*/
						$j--; /*22409*/
						$k[$j++] = $1.lalphanumeric; /*22410*/
						$k[$j++] = $1.numeric; /*22410*/
						if ($1.encode() == $b) break; /*22410*/
						$1.mode = "alphanumeric"; /*22411*/
						break; /*22412*/
					} else { /*22429*/
						var _9u = $get($1.gpf, $1.i); /*22414*/
						if ((_9u < 48) || (_9u > 57)) { /*22418*/
							$k[$j++] = $1.lalphanumeric; /*22415*/
							$k[$j++] = $1.numeric; /*22415*/
							if ($1.encode() == $b) break; /*22415*/
							$1.mode = "alphanumeric"; /*22416*/
							break; /*22417*/
						} /*22417*/
						$k[$j++] = "rem"; /*22419*/
						$k[$j++] = $1.cdf.length + $1.j; /*22419*/
						if ($1.rembits() == $b) break; /*22419*/
						var _9z = $k[--$j]; /*22419*/
						$1[$k[--$j]] = _9z; /*22419*/
						if (($1.rem >= 4) && ($1.rem <= 6)) { /*22429*/
							var _A6 = $geti($strcpy($s(6), "000000"), 0, $1.rem); /*22421*/
							var _AB = $cvrs($s(4), $get($1.gpf, $1.i) - 47, 2); /*22422*/
							$puti(_A6, 4 - _AB.length, _AB); /*22423*/
							$k[$j++] = _A6; /*22423*/
							$k[$j++] = "raw"; /*22423*/
							if ($1.encode() == $b) break; /*22423*/
							$1.i = $1.i + 1; /*22424*/
							break; /*22425*/
						} else { /*22429*/
							var _AD = $s(2); /*22427*/
							$put(_AD, 0, $get($1.gpf, $1.i)); /*22427*/
							$put(_AD, 1, 94); /*22427*/
							$k[$j++] = _AD; /*22427*/
							$k[$j++] = $1.numeric; /*22427*/
							if ($1.encode() == $b) break; /*22427*/
							$1.i = $1.i + 1; /*22428*/
							break; /*22429*/
						} /*22429*/
					} /*22429*/
				} /*22429*/
				if ($eq($1.mode, "alphanumeric")) { /*22459*/
					if ($get($1.gpf, $1.i) == $1.fnc1) { /*22440*/
						$k[$j++] = $1.fnc1; /*22436*/
						$k[$j++] = $1.alphanumeric; /*22436*/
						if ($1.encode() == $b) break; /*22436*/
						$1.mode = "numeric"; /*22437*/
						$1.i = $1.i + 1; /*22438*/
						break; /*22439*/
					} /*22439*/
					var _AT = $get($1.gpf, $1.i); /*22441*/
					var _AV = $get($1.iso646, _AT) !== undefined; /*22441*/
					var _AX = $get($1.alphanumeric, _AT) !== undefined; /*22441*/
					if (_AV && (!_AX)) { /*22445*/
						$k[$j++] = $1.liso646; /*22442*/
						$k[$j++] = $1.alphanumeric; /*22442*/
						if ($1.encode() == $b) break; /*22442*/
						$1.mode = "iso646"; /*22443*/
						break; /*22444*/
					} /*22444*/
					if ($get($1.numericruns, $1.i) >= 6) { /*22450*/
						$k[$j++] = $1.lnumeric; /*22447*/
						$k[$j++] = $1.alphanumeric; /*22447*/
						if ($1.encode() == $b) break; /*22447*/
						$1.mode = "numeric"; /*22448*/
						break; /*22449*/
					} /*22449*/
					var _Ah = $get($1.numericruns, $1.i); /*22451*/
					if ((_Ah >= 4) && ((_Ah + $1.i) == $1.gpf.length)) { /*22455*/
						$k[$j++] = $1.lnumeric; /*22452*/
						$k[$j++] = $1.alphanumeric; /*22452*/
						if ($1.encode() == $b) break; /*22452*/
						$1.mode = "numeric"; /*22453*/
						break; /*22454*/
					} /*22454*/
					$k[$j++] = $get($1.gpf, $1.i); /*22456*/
					$k[$j++] = $1.alphanumeric; /*22456*/
					if ($1.encode() == $b) break; /*22456*/
					$1.i = $1.i + 1; /*22457*/
					break; /*22458*/
				} /*22458*/
				if ($eq($1.mode, "iso646")) { /*22481*/
					if ($get($1.gpf, $1.i) == $1.fnc1) { /*22467*/
						$k[$j++] = $1.fnc1; /*22463*/
						$k[$j++] = $1.iso646; /*22463*/
						if ($1.encode() == $b) break; /*22463*/
						$1.mode = "numeric"; /*22464*/
						$1.i = $1.i + 1; /*22465*/
						break; /*22466*/
					} /*22466*/
					if (($get($1.numericruns, $1.i) >= 4) && ($get($1.nextiso646only, $1.i) >= 10)) { /*22472*/
						$k[$j++] = $1.lnumeric; /*22469*/
						$k[$j++] = $1.iso646; /*22469*/
						if ($1.encode() == $b) break; /*22469*/
						$1.mode = "numeric"; /*22470*/
						break; /*22471*/
					} /*22471*/
					if (($get($1.alphanumericruns, $1.i) >= 5) && ($get($1.nextiso646only, $1.i) >= 10)) { /*22477*/
						$k[$j++] = $1.lalphanumeric; /*22474*/
						$k[$j++] = $1.iso646; /*22474*/
						if ($1.encode() == $b) break; /*22474*/
						$1.mode = "alphanumeric"; /*22475*/
						break; /*22476*/
					} /*22476*/
					$k[$j++] = $get($1.gpf, $1.i); /*22478*/
					$k[$j++] = $1.iso646; /*22478*/
					if ($1.encode() == $b) break; /*22478*/
					$1.i = $1.i + 1; /*22479*/
					break; /*22480*/
				} /*22480*/
			} /*22480*/
		} /*22480*/
		$1.gpf = $geti($1.gpfenc, 0, $1.j); /*22485*/
		$k[$j++] = "pad"; /*22488*/
		$k[$j++] = $1.cdf.length + $1.gpf.length; /*22488*/
		if ($1.rembits() == $b) return $b; /*22488*/
		var _BQ = $a($k[--$j]); /*22488*/
		$1[$k[--$j]] = _BQ; /*22488*/
		if ($1.pad.length > 0) { /*22500*/
			for (var _BV = 0, _BU = $1.pad.length - 1; _BV <= _BU; _BV += 5) { /*22493*/
				$1.i = _BV; /*22491*/
				var _BW = $1.pad; /*22492*/
				var _BX = $1.i; /*22492*/
				var _BY = $a([0, 0, 1, 0, 0]); /*22492*/
				var _BZ = $1.pad; /*22492*/
				var _Ba = $1.i; /*22492*/
				var _Bb = 5; /*22492*/
				var _Bc = _BZ.length - _Ba; /*22492*/
				if ((_BZ.length - _Ba) > 5) { /*22492*/
					var _ = _Bb; /*22492*/
					_Bb = _Bc; /*22492*/
					_Bc = _; /*22492*/
				} /*22492*/
				$puti(_BW, _BX, $geti(_BY, 0, _Bc)); /*22492*/
			} /*22492*/
			if ($eq($1.mode, "numeric")) { /*22496*/
				$k[$j++] = "pad"; /*22495*/
				$k[$j++] = Infinity; /*22495*/
				$k[$j++] = 0; /*22495*/
				$k[$j++] = 0; /*22495*/
				$k[$j++] = 0; /*22495*/
				$k[$j++] = 0; /*22495*/
				$aload($1.pad); /*22495*/
				var _Bi = $geti($a(), 0, $1.pad.length); /*22495*/
				$1[$k[--$j]] = _Bi; /*22495*/
			} /*22495*/
			if ($eq($1.mode, "alpha")) { /*22499*/
				$k[$j++] = "pad"; /*22498*/
				$k[$j++] = Infinity; /*22498*/
				$k[$j++] = 1; /*22498*/
				$k[$j++] = 1; /*22498*/
				$k[$j++] = 1; /*22498*/
				$k[$j++] = 1; /*22498*/
				$k[$j++] = 1; /*22498*/
				$aload($1.pad); /*22498*/
				var _Bo = $geti($a(), 0, $1.pad.length); /*22498*/
				$1[$k[--$j]] = _Bo; /*22498*/
			} /*22498*/
		} /*22498*/
		$k[$j++] = Infinity; /*22507*/
		$aload($1.cdf); /*22504*/
		$aload($1.gpf); /*22505*/
		$aload($1.pad); /*22506*/
		$1.bits = $a(); /*22507*/
		if ($1.ccversion == "a") { /*22562*/
			$k[$j++] = Infinity; /*22513*/
			$k[$j++] = $a([0, 0, 0, 0, 0, 0, 1]); /*22512*/
			for (var _Bw = 0, _Bx = 68; _Bw < _Bx; _Bw++) { /*22512*/
				$k[$j++] = $a(7); /*22512*/
			} /*22512*/
			$1.pwr928 = $a(); /*22513*/
			for (var _C0 = 1; _C0 <= 68; _C0 += 1) { /*22523*/
				$1.j = _C0; /*22515*/
				$1.v = 0; /*22516*/
				for (var _C1 = 6; _C1 >= 1; _C1 -= 1) { /*22521*/
					$1.i = _C1; /*22518*/
					$1.v = ($get($get($1.pwr928, $1.j - 1), $1.i) * 2) + (~~($1.v / 928)); /*22519*/
					$put($get($1.pwr928, $1.j), $1.i, $1.v % 928); /*22520*/
				} /*22520*/
				$put($get($1.pwr928, $1.j), 0, ($get($get($1.pwr928, $1.j - 1), 0) * 2) + (~~($1.v / 928))); /*22522*/
			} /*22522*/
			$k[$j++] = Infinity; /*22524*/
			for (var _CL = 0, _CM = 28; _CL < _CM; _CL++) { /*22524*/
				$k[$j++] = 0; /*22524*/
			} /*22524*/
			$1.cws = $a(); /*22524*/
			$1.b = 0; /*22525*/
			$1.c = 0; /*22525*/
			for (;;) { /*22549*/
				if ($1.b == $1.bits.length) { /*22527*/
					break; /*22527*/
				} /*22527*/
				var _CQ = $1.bits; /*22528*/
				var _CR = $1.b; /*22528*/
				var _CS = $1.bits; /*22528*/
				var _CT = $1.b; /*22528*/
				var _CU = _CS.length - _CT; /*22528*/
				var _CV = 69; /*22528*/
				if (69 > (_CS.length - _CT)) { /*22528*/
					var _ = _CU; /*22528*/
					_CU = _CV; /*22528*/
					_CV = _; /*22528*/
				} /*22528*/
				$1.bs = $geti(_CQ, _CR, _CV); /*22528*/
				$1.bsl = $1.bs.length; /*22529*/
				$1.cs = $geti($1.cws, $1.c, (~~($1.bsl / 10)) + 1); /*22530*/
				$1.csl = $1.cs.length; /*22531*/
				for (var _Cf = 0, _Ce = $1.bsl - 1; _Cf <= _Ce; _Cf += 1) { /*22541*/
					$1.i = _Cf; /*22533*/
					for (var _Ci = 0, _Ch = $1.csl - 1; _Ci <= _Ch; _Ci += 1) { /*22540*/
						$1.j = _Ci; /*22535*/
						var _Cj = $1.cs; /*22536*/
						var _Ck = $1.j; /*22536*/
						$put(_Cj, _Ck, $get(_Cj, _Ck) + ($get($get($1.pwr928, $1.i), ($1.j + 7) - $1.csl) * $get($1.bs, ($1.bsl - $1.i) - 1))); /*22539*/
					} /*22539*/
				} /*22539*/
				for (var _Cx = $1.csl - 1; _Cx >= 1; _Cx -= 1) { /*22546*/
					$1.i = _Cx; /*22543*/
					var _Cy = $1.cs; /*22544*/
					var _Cz = $1.i; /*22544*/
					$put(_Cy, _Cz - 1, $get(_Cy, _Cz - 1) + (~~($get($1.cs, $1.i) / 928))); /*22544*/
					var _D4 = $1.cs; /*22545*/
					var _D5 = $1.i; /*22545*/
					$put(_D4, _D5, $get(_D4, _D5) % 928); /*22545*/
				} /*22545*/
				$1.b = $1.b + $1.bsl; /*22547*/
				$1.c = $1.c + $1.csl; /*22548*/
			} /*22548*/
			$1.cws = $geti($1.cws, 0, $1.c); /*22550*/
			$1.barcode = $s($1.cws.length * 4); /*22551*/
			for (var _DI = 0, _DH = $1.cws.length - 1; _DI <= _DH; _DI += 1) { /*22557*/
				$1.i = _DI; /*22553*/
				var _DK = $strcpy($s(4), "^   "); /*22554*/
				var _DP = $cvrs($s(4), $get($1.cws, $1.i), 10); /*22554*/
				$puti(_DK, 4 - _DP.length, _DP); /*22555*/
				$puti($1.barcode, $1.i * 4, _DK); /*22556*/
			} /*22556*/
			$1.options.dontdraw = true; /*22558*/
			$1.options.cca = true; /*22559*/
			$1.options.columns = $1.cccolumns; /*22560*/
			$k[$j++] = "args"; /*22561*/
			$k[$j++] = $1.barcode; /*22561*/
			$k[$j++] = $1.options; /*22561*/
			$0.micropdf417(); /*22561*/
			var _DY = $k[--$j]; /*22561*/
			$1[$k[--$j]] = _DY; /*22561*/
		} /*22561*/
		if ($1.ccversion == "b") { /*22575*/
			$1.barcode = $s(~~($1.bits.length / 8)); /*22565*/
			for (var _Df = 0, _De = $1.barcode.length - 1; _Df <= _De; _Df += 1) { /*22570*/
				$1.i = _Df; /*22567*/
				$k[$j++] = 0; /*22568*/
				$forall($geti($1.bits, $1.i * 8, 8), function() { /*22568*/
					var _Dj = $k[--$j]; /*22568*/
					var _Dk = $k[--$j]; /*22568*/
					$k[$j++] = (_Dk + _Dj) * 2; /*22568*/
				}); /*22568*/
				$put($1.barcode, $1.i, ~~($k[--$j] / 2)); /*22569*/
			} /*22569*/
			$1.options.dontdraw = true; /*22571*/
			$1.options.ccb = true; /*22572*/
			$1.options.columns = $1.cccolumns; /*22573*/
			$k[$j++] = "args"; /*22574*/
			$k[$j++] = $1.barcode; /*22574*/
			$k[$j++] = $1.options; /*22574*/
			$0.micropdf417(); /*22574*/
			var _Du = $k[--$j]; /*22574*/
			$1[$k[--$j]] = _Du; /*22574*/
		} /*22574*/
		if ($1.ccversion == "c") { /*22588*/
			$1.barcode = $s(~~($1.bits.length / 8)); /*22578*/
			for (var _E1 = 0, _E0 = $1.barcode.length - 1; _E1 <= _E0; _E1 += 1) { /*22583*/
				$1.i = _E1; /*22580*/
				$k[$j++] = 0; /*22581*/
				$forall($geti($1.bits, $1.i * 8, 8), function() { /*22581*/
					var _E5 = $k[--$j]; /*22581*/
					var _E6 = $k[--$j]; /*22581*/
					$k[$j++] = (_E6 + _E5) * 2; /*22581*/
				}); /*22581*/
				$put($1.barcode, $1.i, ~~($k[--$j] / 2)); /*22582*/
			} /*22582*/
			$1.options.dontdraw = true; /*22584*/
			$1.options.ccc = true; /*22585*/
			$1.options.columns = $1.cccolumns; /*22586*/
			$k[$j++] = "args"; /*22587*/
			$k[$j++] = $1.barcode; /*22587*/
			$k[$j++] = $1.options; /*22587*/
			$0.pdf417(); /*22587*/
			var _EG = $k[--$j]; /*22587*/
			$1[$k[--$j]] = _EG; /*22587*/
		} /*22587*/
		$k[$j++] = $1.args; /*22591*/
		if (!$1.dontdraw) { /*22591*/
			$0.renmatrix(); /*22591*/
		} /*22591*/
	};
	$0.ean13composite = function() {
		var $1 = {}; /*22621*/
		$1.options = $k[--$j]; /*22623*/
		$1.barcode = $k[--$j]; /*22624*/
		$1.dontdraw = false; /*22626*/
		$forall($1.options, function() { /*22637*/
			var _3 = $k[--$j]; /*22637*/
			$1[$k[--$j]] = _3; /*22637*/
		}); /*22637*/
		$search($1.barcode, "|"); /*22640*/
		if ($k[--$j]) { /*22645*/
			$1.linear = $k[--$j]; /*22641*/
			$j--; /*22642*/
			$1.comp = $k[--$j]; /*22643*/
		} else { /*22645*/
			$j--; /*22645*/
		} /*22645*/
		$$.save(); /*22648*/
		$1.options.lintype = "ean13"; /*22650*/
		$1.options.inkspread = "0"; /*22651*/
		$1.options.dontdraw = true; /*22652*/
		$k[$j++] = $1.linear; /*22655*/
		$k[$j++] = $1.options; /*22655*/
		$0.ean13(); /*22655*/
		$0.renlinear(); /*22655*/
		$$.rmoveto(-1, 72); /*22658*/
		$k[$j++] = Infinity; /*22669*/
		$k[$j++] = "ren"; /*22665*/
		$k[$j++] = $0.renmatrix; /*22665*/
		$k[$j++] = "pixs"; /*22665*/
		$k[$j++] = Infinity; /*22665*/
		$k[$j++] = 0; /*22661*/
		$k[$j++] = 1; /*22661*/
		for (var _E = 0, _F = 93; _E < _F; _E++) { /*22661*/
			$k[$j++] = 0; /*22661*/
		} /*22661*/
		$k[$j++] = 1; /*22662*/
		$k[$j++] = 0; /*22662*/
		$k[$j++] = 1; /*22662*/
		$k[$j++] = 0; /*22662*/
		for (var _G = 0, _H = 93; _G < _H; _G++) { /*22662*/
			$k[$j++] = 0; /*22662*/
		} /*22662*/
		$k[$j++] = 0; /*22663*/
		$k[$j++] = 1; /*22663*/
		$k[$j++] = 0; /*22663*/
		$k[$j++] = 1; /*22663*/
		for (var _I = 0, _J = 93; _I < _J; _I++) { /*22663*/
			$k[$j++] = 0; /*22663*/
		} /*22663*/
		$k[$j++] = 1; /*22663*/
		$k[$j++] = 0; /*22663*/
		var _K = $a(); /*22665*/
		$k[$j++] = _K; /*22669*/
		$k[$j++] = "pixx"; /*22669*/
		$k[$j++] = 97; /*22669*/
		$k[$j++] = "pixy"; /*22669*/
		$k[$j++] = 3; /*22669*/
		$k[$j++] = "height"; /*22669*/
		$k[$j++] = 6 / 72; /*22669*/
		$k[$j++] = "width"; /*22669*/
		$k[$j++] = 97 / 72; /*22669*/
		$k[$j++] = "opt"; /*22669*/
		$k[$j++] = $1.options; /*22669*/
		var _M = $d(); /*22669*/
		$k[$j++] = _M; /*22670*/
		$0.renmatrix(); /*22670*/
		$$.rmoveto(-2, 6); /*22673*/
		$k[$j++] = $1.comp; /*22673*/
		$k[$j++] = $1.options; /*22673*/
		$0["gs1-cc"](); /*22673*/
		$0.renmatrix(); /*22673*/
		$$.restore(); /*22675*/
	};
	$0.ean8composite = function() {
		var $1 = {}; /*22705*/
		$1.options = $k[--$j]; /*22707*/
		$1.barcode = $k[--$j]; /*22708*/
		$1.dontdraw = false; /*22710*/
		$forall($1.options, function() { /*22721*/
			var _3 = $k[--$j]; /*22721*/
			$1[$k[--$j]] = _3; /*22721*/
		}); /*22721*/
		$search($1.barcode, "|"); /*22724*/
		if ($k[--$j]) { /*22729*/
			$1.linear = $k[--$j]; /*22725*/
			$j--; /*22726*/
			$1.comp = $k[--$j]; /*22727*/
		} else { /*22729*/
			$j--; /*22729*/
		} /*22729*/
		$$.save(); /*22732*/
		$1.options.lintype = "ean8"; /*22735*/
		$1.options.inkspread = "0"; /*22736*/
		$1.options.dontdraw = true; /*22737*/
		$k[$j++] = $1.linear; /*22740*/
		$k[$j++] = $1.options; /*22740*/
		$0.ean8(); /*22740*/
		$0.renlinear(); /*22740*/
		$$.rmoveto(-1, 72); /*22743*/
		$k[$j++] = Infinity; /*22754*/
		$k[$j++] = "ren"; /*22750*/
		$k[$j++] = $0.renmatrix; /*22750*/
		$k[$j++] = "pixs"; /*22750*/
		$k[$j++] = Infinity; /*22750*/
		$k[$j++] = 0; /*22746*/
		$k[$j++] = 1; /*22746*/
		for (var _E = 0, _F = 65; _E < _F; _E++) { /*22746*/
			$k[$j++] = 0; /*22746*/
		} /*22746*/
		$k[$j++] = 1; /*22747*/
		$k[$j++] = 0; /*22747*/
		$k[$j++] = 1; /*22747*/
		$k[$j++] = 0; /*22747*/
		for (var _G = 0, _H = 65; _G < _H; _G++) { /*22747*/
			$k[$j++] = 0; /*22747*/
		} /*22747*/
		$k[$j++] = 0; /*22748*/
		$k[$j++] = 1; /*22748*/
		$k[$j++] = 0; /*22748*/
		$k[$j++] = 1; /*22748*/
		for (var _I = 0, _J = 65; _I < _J; _I++) { /*22748*/
			$k[$j++] = 0; /*22748*/
		} /*22748*/
		$k[$j++] = 1; /*22748*/
		$k[$j++] = 0; /*22748*/
		var _K = $a(); /*22750*/
		$k[$j++] = _K; /*22754*/
		$k[$j++] = "pixx"; /*22754*/
		$k[$j++] = 69; /*22754*/
		$k[$j++] = "pixy"; /*22754*/
		$k[$j++] = 3; /*22754*/
		$k[$j++] = "height"; /*22754*/
		$k[$j++] = 6 / 72; /*22754*/
		$k[$j++] = "width"; /*22754*/
		$k[$j++] = 69 / 72; /*22754*/
		$k[$j++] = "opt"; /*22754*/
		$k[$j++] = $1.options; /*22754*/
		var _M = $d(); /*22754*/
		$k[$j++] = _M; /*22755*/
		$0.renmatrix(); /*22755*/
		$k[$j++] = $1.comp; /*22758*/
		$k[$j++] = $1.options; /*22758*/
		$0["gs1-cc"](); /*22758*/
		var _P = $k[--$j]; /*22759*/
		$$.rmoveto(69 - _P.pixx, 6); /*22759*/
		$k[$j++] = _P; /*22760*/
		$0.renmatrix(); /*22760*/
		$$.restore(); /*22762*/
	};
	$0.upcacomposite = function() {
		var $1 = {}; /*22792*/
		$1.options = $k[--$j]; /*22794*/
		$1.barcode = $k[--$j]; /*22795*/
		$1.dontdraw = false; /*22797*/
		$forall($1.options, function() { /*22808*/
			var _3 = $k[--$j]; /*22808*/
			$1[$k[--$j]] = _3; /*22808*/
		}); /*22808*/
		$search($1.barcode, "|"); /*22811*/
		if ($k[--$j]) { /*22816*/
			$1.linear = $k[--$j]; /*22812*/
			$j--; /*22813*/
			$1.comp = $k[--$j]; /*22814*/
		} else { /*22816*/
			$j--; /*22816*/
		} /*22816*/
		$$.save(); /*22819*/
		$1.options.lintype = "ean13"; /*22821*/
		$1.options.inkspread = "0"; /*22822*/
		$1.options.dontdraw = true; /*22823*/
		$k[$j++] = $1.linear; /*22826*/
		$k[$j++] = $1.options; /*22826*/
		$0.upca(); /*22826*/
		$0.renlinear(); /*22826*/
		$$.rmoveto(-1, 72); /*22829*/
		$k[$j++] = Infinity; /*22840*/
		$k[$j++] = "ren"; /*22836*/
		$k[$j++] = $0.renmatrix; /*22836*/
		$k[$j++] = "pixs"; /*22836*/
		$k[$j++] = Infinity; /*22836*/
		$k[$j++] = 0; /*22832*/
		$k[$j++] = 1; /*22832*/
		for (var _E = 0, _F = 93; _E < _F; _E++) { /*22832*/
			$k[$j++] = 0; /*22832*/
		} /*22832*/
		$k[$j++] = 1; /*22833*/
		$k[$j++] = 0; /*22833*/
		$k[$j++] = 1; /*22833*/
		$k[$j++] = 0; /*22833*/
		for (var _G = 0, _H = 93; _G < _H; _G++) { /*22833*/
			$k[$j++] = 0; /*22833*/
		} /*22833*/
		$k[$j++] = 0; /*22834*/
		$k[$j++] = 1; /*22834*/
		$k[$j++] = 0; /*22834*/
		$k[$j++] = 1; /*22834*/
		for (var _I = 0, _J = 93; _I < _J; _I++) { /*22834*/
			$k[$j++] = 0; /*22834*/
		} /*22834*/
		$k[$j++] = 1; /*22834*/
		$k[$j++] = 0; /*22834*/
		var _K = $a(); /*22836*/
		$k[$j++] = _K; /*22840*/
		$k[$j++] = "pixx"; /*22840*/
		$k[$j++] = 97; /*22840*/
		$k[$j++] = "pixy"; /*22840*/
		$k[$j++] = 3; /*22840*/
		$k[$j++] = "height"; /*22840*/
		$k[$j++] = 6 / 72; /*22840*/
		$k[$j++] = "width"; /*22840*/
		$k[$j++] = 97 / 72; /*22840*/
		$k[$j++] = "opt"; /*22840*/
		$k[$j++] = $1.options; /*22840*/
		var _M = $d(); /*22840*/
		$k[$j++] = _M; /*22841*/
		$0.renmatrix(); /*22841*/
		$$.rmoveto(-2, 6); /*22844*/
		$k[$j++] = $1.comp; /*22844*/
		$k[$j++] = $1.options; /*22844*/
		$0["gs1-cc"](); /*22844*/
		$0.renmatrix(); /*22844*/
		$$.restore(); /*22846*/
	};
	$0.upcecomposite = function() {
		var $1 = {}; /*22876*/
		$1.options = $k[--$j]; /*22878*/
		$1.barcode = $k[--$j]; /*22879*/
		$1.dontdraw = false; /*22881*/
		$forall($1.options, function() { /*22892*/
			var _3 = $k[--$j]; /*22892*/
			$1[$k[--$j]] = _3; /*22892*/
		}); /*22892*/
		$search($1.barcode, "|"); /*22895*/
		if ($k[--$j]) { /*22900*/
			$1.linear = $k[--$j]; /*22896*/
			$j--; /*22897*/
			$1.comp = $k[--$j]; /*22898*/
		} else { /*22900*/
			$j--; /*22900*/
		} /*22900*/
		$k[$j++] = "sep"; /*22915*/
		$k[$j++] = Infinity; /*22915*/
		$k[$j++] = "ren"; /*22911*/
		$k[$j++] = $0.renmatrix; /*22911*/
		$k[$j++] = "pixs"; /*22911*/
		$k[$j++] = Infinity; /*22911*/
		$k[$j++] = 0; /*22907*/
		$k[$j++] = 1; /*22907*/
		for (var _9 = 0, _A = 49; _9 < _A; _9++) { /*22907*/
			$k[$j++] = 0; /*22907*/
		} /*22907*/
		$k[$j++] = 1; /*22908*/
		$k[$j++] = 0; /*22908*/
		$k[$j++] = 1; /*22908*/
		$k[$j++] = 0; /*22908*/
		for (var _B = 0, _C = 49; _B < _C; _B++) { /*22908*/
			$k[$j++] = 0; /*22908*/
		} /*22908*/
		$k[$j++] = 0; /*22909*/
		$k[$j++] = 1; /*22909*/
		$k[$j++] = 0; /*22909*/
		$k[$j++] = 1; /*22909*/
		for (var _D = 0, _E = 49; _D < _E; _D++) { /*22909*/
			$k[$j++] = 0; /*22909*/
		} /*22909*/
		$k[$j++] = 1; /*22909*/
		$k[$j++] = 0; /*22909*/
		var _F = $a(); /*22911*/
		$k[$j++] = _F; /*22915*/
		$k[$j++] = "pixx"; /*22915*/
		$k[$j++] = 53; /*22915*/
		$k[$j++] = "pixy"; /*22915*/
		$k[$j++] = 3; /*22915*/
		$k[$j++] = "height"; /*22915*/
		$k[$j++] = 6 / 72; /*22915*/
		$k[$j++] = "width"; /*22915*/
		$k[$j++] = 53 / 72; /*22915*/
		$k[$j++] = "opt"; /*22915*/
		$k[$j++] = $1.options; /*22915*/
		var _H = $d(); /*22915*/
		$1[$k[--$j]] = _H; /*22916*/
		$$.save(); /*22918*/
		$1.options.lintype = "upce"; /*22920*/
		$1.options.inkspread = "0"; /*22921*/
		$1.options.dontdraw = true; /*22922*/
		$k[$j++] = $1.linear; /*22925*/
		$k[$j++] = $1.options; /*22925*/
		$0.upce(); /*22925*/
		$0.renlinear(); /*22925*/
		$$.rmoveto(-1, 72); /*22928*/
		$k[$j++] = Infinity; /*22939*/
		$k[$j++] = "ren"; /*22935*/
		$k[$j++] = $0.renmatrix; /*22935*/
		$k[$j++] = "pixs"; /*22935*/
		$k[$j++] = Infinity; /*22935*/
		$k[$j++] = 0; /*22931*/
		$k[$j++] = 1; /*22931*/
		for (var _O = 0, _P = 49; _O < _P; _O++) { /*22931*/
			$k[$j++] = 0; /*22931*/
		} /*22931*/
		$k[$j++] = 1; /*22932*/
		$k[$j++] = 0; /*22932*/
		$k[$j++] = 1; /*22932*/
		$k[$j++] = 0; /*22932*/
		for (var _Q = 0, _R = 49; _Q < _R; _Q++) { /*22932*/
			$k[$j++] = 0; /*22932*/
		} /*22932*/
		$k[$j++] = 0; /*22933*/
		$k[$j++] = 1; /*22933*/
		$k[$j++] = 0; /*22933*/
		$k[$j++] = 1; /*22933*/
		for (var _S = 0, _T = 49; _S < _T; _S++) { /*22933*/
			$k[$j++] = 0; /*22933*/
		} /*22933*/
		$k[$j++] = 1; /*22933*/
		$k[$j++] = 0; /*22933*/
		var _U = $a(); /*22935*/
		$k[$j++] = _U; /*22939*/
		$k[$j++] = "pixx"; /*22939*/
		$k[$j++] = 53; /*22939*/
		$k[$j++] = "pixy"; /*22939*/
		$k[$j++] = 3; /*22939*/
		$k[$j++] = "height"; /*22939*/
		$k[$j++] = 6 / 72; /*22939*/
		$k[$j++] = "width"; /*22939*/
		$k[$j++] = 53 / 72; /*22939*/
		$k[$j++] = "opt"; /*22939*/
		$k[$j++] = $1.options; /*22939*/
		var _W = $d(); /*22939*/
		$k[$j++] = _W; /*22940*/
		$0.renmatrix(); /*22940*/
		$$.rmoveto(-2, 6); /*22943*/
		$k[$j++] = $1.comp; /*22943*/
		$k[$j++] = $1.options; /*22943*/
		$0["gs1-cc"](); /*22943*/
		$0.renmatrix(); /*22943*/
		$$.restore(); /*22945*/
	};
	$0.databaromnicomposite = function() {
		var $1 = {}; /*22975*/
		$1.options = $k[--$j]; /*22977*/
		$1.barcode = $k[--$j]; /*22978*/
		$1.dontdraw = false; /*22980*/
		$forall($1.options, function() { /*22991*/
			var _3 = $k[--$j]; /*22991*/
			$1[$k[--$j]] = _3; /*22991*/
		}); /*22991*/
		$search($1.barcode, "|"); /*22994*/
		if ($k[--$j]) { /*22999*/
			$1.linear = $k[--$j]; /*22995*/
			$j--; /*22996*/
			$1.comp = $k[--$j]; /*22997*/
		} else { /*22999*/
			$j--; /*22999*/
		} /*22999*/
		$$.save(); /*23002*/
		$1.options.lintype = "databaromni"; /*23004*/
		$1.options.linkage = true; /*23005*/
		$1.options.inkspread = "0"; /*23006*/
		$1.options.dontdraw = true; /*23007*/
		$k[$j++] = $1.linear; /*23010*/
		$k[$j++] = $1.options; /*23010*/
		$0.databaromni(); /*23010*/
		var _F = $k[--$j]; /*23011*/
		$1.linsbs = _F.sbs; /*23011*/
		$1.linheight = $get(_F.bhs, 0) * 72; /*23012*/
		$k[$j++] = _F; /*23013*/
		$0.renlinear(); /*23013*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*23017*/
			for (var _N = $1.fp, _M = $1.fp + 12; _N <= _M; _N += 1) { /*23030*/
				$1.i = _N; /*23019*/
				if ($get($1.bot, $1.i) == 0) { /*23027*/
					if ($get($1.bot, $1.i - 1) == 1) { /*23024*/
						$k[$j++] = 1; /*23022*/
					} else { /*23024*/
						var _X = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23024*/
						$k[$j++] = _X; /*23024*/
					} /*23024*/
				} else { /*23027*/
					$k[$j++] = 0; /*23027*/
				} /*23027*/
				$put($1.sep, $1.i, $k[--$j]); /*23029*/
			} /*23029*/
			$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*23031*/
			$k[$j++] = true; /*23032*/
			for (var _c = 0; _c <= 12; _c += 1) { /*23032*/
				var _i = $k[--$j]; /*23032*/
				$k[$j++] = _i && $eq($get($1.bot, _c + $1.fp), $get($1.f3, _c)); /*23032*/
			} /*23032*/
			if ($k[--$j]) { /*23035*/
				$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*23034*/
			} /*23034*/
		}; /*23036*/
		$k[$j++] = Infinity; /*23037*/
		$k[$j++] = 0; /*23038*/
		$forall($1.linsbs, function() { /*23038*/
			var _o = $k[--$j]; /*23038*/
			var _p = $k[--$j]; /*23038*/
			var _q = (_p == 1) ? 0 : 1; /*23038*/
			$k[$j++] = _p; /*23038*/
			for (var _r = 0, _s = _o; _r < _s; _r++) { /*23038*/
				$k[$j++] = _q /*23038*/
			} /*23038*/
		}); /*23038*/
		$astore($a($counttomark() - 1)); /*23039*/
		$1.bot = $k[--$j]; /*23039*/
		$j -= 2; /*23039*/
		$k[$j++] = Infinity; /*23040*/
		$forall($1.bot, function() { /*23040*/
			var _x = $k[--$j]; /*23040*/
			$k[$j++] = 1 - _x; /*23040*/
		}); /*23040*/
		$1.sep = $a(); /*23040*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*23041*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23042*/
		$k[$j++] = 18; /*23043*/
		if ($1.sepfinder() == $b) return $b; /*23043*/
		$k[$j++] = 64; /*23043*/
		if ($1.sepfinder() == $b) return $b; /*23043*/
		$$.rmoveto(0, $1.linheight); /*23044*/
		var _19 = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*23051*/
		$k[$j++] = _19; /*23052*/
		$0.renmatrix(); /*23052*/
		$$.rmoveto(-5, 1); /*23055*/
		$k[$j++] = $1.comp; /*23055*/
		$k[$j++] = $1.options; /*23055*/
		$0["gs1-cc"](); /*23055*/
		$0.renmatrix(); /*23055*/
		$$.restore(); /*23057*/
	};
	$0.databarstackedcomposite = function() {
		var $1 = {}; /*23086*/
		$1.options = $k[--$j]; /*23088*/
		$1.barcode = $k[--$j]; /*23089*/
		$1.dontdraw = false; /*23091*/
		$forall($1.options, function() { /*23102*/
			var _3 = $k[--$j]; /*23102*/
			$1[$k[--$j]] = _3; /*23102*/
		}); /*23102*/
		$search($1.barcode, "|"); /*23105*/
		if ($k[--$j]) { /*23110*/
			$1.linear = $k[--$j]; /*23106*/
			$j--; /*23107*/
			$1.comp = $k[--$j]; /*23108*/
		} else { /*23110*/
			$j--; /*23110*/
		} /*23110*/
		$$.save(); /*23113*/
		$1.options.lintype = "databarstacked"; /*23115*/
		$1.options.linkage = true; /*23116*/
		$1.options.inkspread = "0"; /*23117*/
		$1.options.dontdraw = true; /*23118*/
		$k[$j++] = $1.linear; /*23121*/
		$k[$j++] = $1.options; /*23121*/
		$0.databarstacked(); /*23121*/
		var _F = $k[--$j]; /*23122*/
		$1.bot = $geti(_F.pixs, 0, _F.pixx); /*23122*/
		$1.linheight = _F.pixy; /*23123*/
		$k[$j++] = _F; /*23124*/
		$0.renmatrix(); /*23124*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*23128*/
			for (var _O = $1.fp, _N = $1.fp + 12; _O <= _N; _O += 1) { /*23141*/
				$1.i = _O; /*23130*/
				if ($get($1.bot, $1.i) == 0) { /*23138*/
					if ($get($1.bot, $1.i - 1) == 1) { /*23135*/
						$k[$j++] = 1; /*23133*/
					} else { /*23135*/
						var _Y = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23135*/
						$k[$j++] = _Y; /*23135*/
					} /*23135*/
				} else { /*23138*/
					$k[$j++] = 0; /*23138*/
				} /*23138*/
				$put($1.sep, $1.i, $k[--$j]); /*23140*/
			} /*23140*/
			$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*23142*/
			$k[$j++] = true; /*23143*/
			for (var _d = 0; _d <= 12; _d += 1) { /*23143*/
				var _j = $k[--$j]; /*23143*/
				$k[$j++] = _j && $eq($get($1.bot, _d + $1.fp), $get($1.f3, _d)); /*23143*/
			} /*23143*/
			if ($k[--$j]) { /*23146*/
				$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*23145*/
			} /*23145*/
		}; /*23147*/
		$k[$j++] = Infinity; /*23148*/
		$forall($1.bot, function() { /*23148*/
			var _p = $k[--$j]; /*23148*/
			$k[$j++] = 1 - _p; /*23148*/
		}); /*23148*/
		$1.sep = $a(); /*23148*/
		$puti($1.sep, 0, $a([0, 0, 0, 0])); /*23149*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23150*/
		$k[$j++] = 18; /*23151*/
		if ($1.sepfinder() == $b) return $b; /*23151*/
		$$.rmoveto(0, $1.linheight); /*23152*/
		var _11 = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*23159*/
		$k[$j++] = _11; /*23160*/
		$0.renmatrix(); /*23160*/
		$$.rmoveto(1, 1); /*23163*/
		$k[$j++] = $1.comp; /*23163*/
		$k[$j++] = $1.options; /*23163*/
		$0["gs1-cc"](); /*23163*/
		$0.renmatrix(); /*23163*/
		$$.restore(); /*23165*/
	};
	$0.databarstackedomnicomposite = function() {
		var $1 = {}; /*23194*/
		$1.options = $k[--$j]; /*23196*/
		$1.barcode = $k[--$j]; /*23197*/
		$1.dontdraw = false; /*23199*/
		$forall($1.options, function() { /*23210*/
			var _3 = $k[--$j]; /*23210*/
			$1[$k[--$j]] = _3; /*23210*/
		}); /*23210*/
		$search($1.barcode, "|"); /*23213*/
		if ($k[--$j]) { /*23218*/
			$1.linear = $k[--$j]; /*23214*/
			$j--; /*23215*/
			$1.comp = $k[--$j]; /*23216*/
		} else { /*23218*/
			$j--; /*23218*/
		} /*23218*/
		$$.save(); /*23221*/
		$1.options.lintype = "databarstackedomni"; /*23223*/
		$1.options.linkage = true; /*23224*/
		$1.options.inkspread = "0"; /*23225*/
		$1.options.dontdraw = true; /*23226*/
		$k[$j++] = $1.linear; /*23229*/
		$k[$j++] = $1.options; /*23229*/
		$0.databarstackedomni(); /*23229*/
		var _F = $k[--$j]; /*23230*/
		$1.bot = $geti(_F.pixs, 0, _F.pixx); /*23230*/
		$1.linheight = _F.pixy; /*23231*/
		$k[$j++] = _F; /*23232*/
		$0.renmatrix(); /*23232*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*23236*/
			for (var _O = $1.fp, _N = $1.fp + 12; _O <= _N; _O += 1) { /*23249*/
				$1.i = _O; /*23238*/
				if ($get($1.bot, $1.i) == 0) { /*23246*/
					if ($get($1.bot, $1.i - 1) == 1) { /*23243*/
						$k[$j++] = 1; /*23241*/
					} else { /*23243*/
						var _Y = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23243*/
						$k[$j++] = _Y; /*23243*/
					} /*23243*/
				} else { /*23246*/
					$k[$j++] = 0; /*23246*/
				} /*23246*/
				$put($1.sep, $1.i, $k[--$j]); /*23248*/
			} /*23248*/
			$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*23250*/
			$k[$j++] = true; /*23251*/
			for (var _d = 0; _d <= 12; _d += 1) { /*23251*/
				var _j = $k[--$j]; /*23251*/
				$k[$j++] = _j && $eq($get($1.bot, _d + $1.fp), $get($1.f3, _d)); /*23251*/
			} /*23251*/
			if ($k[--$j]) { /*23254*/
				$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*23253*/
			} /*23253*/
		}; /*23255*/
		$k[$j++] = Infinity; /*23256*/
		$forall($1.bot, function() { /*23256*/
			var _p = $k[--$j]; /*23256*/
			$k[$j++] = 1 - _p; /*23256*/
		}); /*23256*/
		$1.sep = $a(); /*23256*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*23257*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23258*/
		$k[$j++] = 18; /*23259*/
		if ($1.sepfinder() == $b) return $b; /*23259*/
		$$.rmoveto(0, $1.linheight); /*23260*/
		var _11 = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*23267*/
		$k[$j++] = _11; /*23268*/
		$0.renmatrix(); /*23268*/
		$$.rmoveto(1, 1); /*23271*/
		$k[$j++] = $1.comp; /*23271*/
		$k[$j++] = $1.options; /*23271*/
		$0["gs1-cc"](); /*23271*/
		$0.renmatrix(); /*23271*/
		$$.restore(); /*23273*/
	};
	$0.databartruncatedcomposite = function() {
		var $1 = {}; /*23303*/
		$1.options = $k[--$j]; /*23305*/
		$1.barcode = $k[--$j]; /*23306*/
		$1.dontdraw = false; /*23308*/
		$forall($1.options, function() { /*23319*/
			var _3 = $k[--$j]; /*23319*/
			$1[$k[--$j]] = _3; /*23319*/
		}); /*23319*/
		$search($1.barcode, "|"); /*23322*/
		if ($k[--$j]) { /*23327*/
			$1.linear = $k[--$j]; /*23323*/
			$j--; /*23324*/
			$1.comp = $k[--$j]; /*23325*/
		} else { /*23327*/
			$j--; /*23327*/
		} /*23327*/
		$$.save(); /*23330*/
		$1.options.lintype = "databartruncated"; /*23332*/
		$1.options.linkage = true; /*23333*/
		$1.options.inkspread = "0"; /*23334*/
		$1.options.dontdraw = true; /*23335*/
		$k[$j++] = $1.linear; /*23338*/
		$k[$j++] = $1.options; /*23338*/
		$0.databartruncated(); /*23338*/
		var _F = $k[--$j]; /*23339*/
		$1.linsbs = _F.sbs; /*23339*/
		$1.linheight = $get(_F.bhs, 0) * 72; /*23340*/
		$k[$j++] = _F; /*23341*/
		$0.renlinear(); /*23341*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*23345*/
			for (var _N = $1.fp, _M = $1.fp + 12; _N <= _M; _N += 1) { /*23358*/
				$1.i = _N; /*23347*/
				if ($get($1.bot, $1.i) == 0) { /*23355*/
					if ($get($1.bot, $1.i - 1) == 1) { /*23352*/
						$k[$j++] = 1; /*23350*/
					} else { /*23352*/
						var _X = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23352*/
						$k[$j++] = _X; /*23352*/
					} /*23352*/
				} else { /*23355*/
					$k[$j++] = 0; /*23355*/
				} /*23355*/
				$put($1.sep, $1.i, $k[--$j]); /*23357*/
			} /*23357*/
			$1.f3 = $a([1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1]); /*23359*/
			$k[$j++] = true; /*23360*/
			for (var _c = 0; _c <= 12; _c += 1) { /*23360*/
				var _i = $k[--$j]; /*23360*/
				$k[$j++] = _i && $eq($get($1.bot, _c + $1.fp), $get($1.f3, _c)); /*23360*/
			} /*23360*/
			if ($k[--$j]) { /*23363*/
				$puti($1.sep, $1.fp, $a([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0])); /*23362*/
			} /*23362*/
		}; /*23364*/
		$k[$j++] = Infinity; /*23365*/
		$k[$j++] = 0; /*23366*/
		$forall($1.linsbs, function() { /*23366*/
			var _o = $k[--$j]; /*23366*/
			var _p = $k[--$j]; /*23366*/
			var _q = (_p == 1) ? 0 : 1; /*23366*/
			$k[$j++] = _p; /*23366*/
			for (var _r = 0, _s = _o; _r < _s; _r++) { /*23366*/
				$k[$j++] = _q /*23366*/
			} /*23366*/
		}); /*23366*/
		$astore($a($counttomark() - 1)); /*23367*/
		$1.bot = $k[--$j]; /*23367*/
		$j -= 2; /*23367*/
		$k[$j++] = Infinity; /*23368*/
		$forall($1.bot, function() { /*23368*/
			var _x = $k[--$j]; /*23368*/
			$k[$j++] = 1 - _x; /*23368*/
		}); /*23368*/
		$1.sep = $a(); /*23368*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*23369*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23370*/
		$k[$j++] = 18; /*23371*/
		if ($1.sepfinder() == $b) return $b; /*23371*/
		$k[$j++] = 64; /*23371*/
		if ($1.sepfinder() == $b) return $b; /*23371*/
		$$.rmoveto(0, $1.linheight); /*23372*/
		var _19 = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*23379*/
		$k[$j++] = _19; /*23380*/
		$0.renmatrix(); /*23380*/
		$$.rmoveto(-5, 1); /*23383*/
		$k[$j++] = $1.comp; /*23383*/
		$k[$j++] = $1.options; /*23383*/
		$0["gs1-cc"](); /*23383*/
		$0.renmatrix(); /*23383*/
		$$.restore(); /*23385*/
	};
	$0.databarlimitedcomposite = function() {
		var $1 = {}; /*23415*/
		$1.options = $k[--$j]; /*23417*/
		$1.barcode = $k[--$j]; /*23418*/
		$1.dontdraw = false; /*23420*/
		$forall($1.options, function() { /*23431*/
			var _3 = $k[--$j]; /*23431*/
			$1[$k[--$j]] = _3; /*23431*/
		}); /*23431*/
		$search($1.barcode, "|"); /*23434*/
		if ($k[--$j]) { /*23439*/
			$1.linear = $k[--$j]; /*23435*/
			$j--; /*23436*/
			$1.comp = $k[--$j]; /*23437*/
		} else { /*23439*/
			$j--; /*23439*/
		} /*23439*/
		$$.save(); /*23442*/
		$1.options.lintype = "databarlimited"; /*23444*/
		$1.options.linkage = true; /*23445*/
		$1.options.inkspread = "0"; /*23446*/
		$1.options.dontdraw = true; /*23447*/
		$k[$j++] = $1.linear; /*23450*/
		$k[$j++] = $1.options; /*23450*/
		$0.databarlimited(); /*23450*/
		var _F = $k[--$j]; /*23451*/
		$1.linsbs = _F.sbs; /*23451*/
		$1.linheight = $get(_F.bhs, 0) * 72; /*23452*/
		$k[$j++] = _F; /*23453*/
		$0.renlinear(); /*23453*/
		$k[$j++] = Infinity; /*23456*/
		$k[$j++] = 1; /*23457*/
		$forall($1.linsbs, function() { /*23457*/
			var _K = $k[--$j]; /*23457*/
			var _L = $k[--$j]; /*23457*/
			var _M = (_L == 0) ? 1 : 0; /*23457*/
			$k[$j++] = _L; /*23457*/
			for (var _N = 0, _O = _K; _N < _O; _N++) { /*23457*/
				$k[$j++] = _M /*23457*/
			} /*23457*/
		}); /*23457*/
		$astore($a($counttomark() - 1)); /*23458*/
		$1.sep = $k[--$j]; /*23458*/
		$j -= 2; /*23458*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*23459*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23460*/
		$$.rmoveto(0, $1.linheight); /*23461*/
		var _c = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*23468*/
		$k[$j++] = _c; /*23469*/
		$0.renmatrix(); /*23469*/
		$k[$j++] = $1.comp; /*23472*/
		$k[$j++] = $1.options; /*23472*/
		$0["gs1-cc"](); /*23472*/
		var _f = $k[--$j]; /*23473*/
		$$.rmoveto(72 - _f.pixx, 1); /*23473*/
		$k[$j++] = _f; /*23474*/
		$0.renmatrix(); /*23474*/
		$$.restore(); /*23476*/
	};
	$0.databarexpandedcomposite = function() {
		var $1 = {}; /*23506*/
		$1.options = $k[--$j]; /*23508*/
		$1.barcode = $k[--$j]; /*23509*/
		$1.dontdraw = false; /*23511*/
		$forall($1.options, function() { /*23522*/
			var _3 = $k[--$j]; /*23522*/
			$1[$k[--$j]] = _3; /*23522*/
		}); /*23522*/
		$search($1.barcode, "|"); /*23525*/
		if ($k[--$j]) { /*23530*/
			$1.linear = $k[--$j]; /*23526*/
			$j--; /*23527*/
			$1.comp = $k[--$j]; /*23528*/
		} else { /*23530*/
			$j--; /*23530*/
		} /*23530*/
		$$.save(); /*23533*/
		$1.options.lintype = "databarexpanded"; /*23535*/
		$1.options.linkage = true; /*23536*/
		$1.options.inkspread = "0"; /*23537*/
		$1.options.dontdraw = true; /*23538*/
		$k[$j++] = $1.linear; /*23541*/
		$k[$j++] = $1.options; /*23541*/
		$0.databarexpanded(); /*23541*/
		var _F = $k[--$j]; /*23542*/
		$1.linsbs = _F.sbs; /*23542*/
		$1.linheight = $get(_F.bhs, 0) * 72; /*23543*/
		$k[$j++] = _F; /*23544*/
		$0.renlinear(); /*23544*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*23548*/
			for (var _N = $1.fp, _M = $1.fp + 12; _N <= _M; _N += 1) { /*23561*/
				$1.i = _N; /*23550*/
				if ($get($1.bot, $1.i) == 0) { /*23558*/
					if ($get($1.bot, $1.i - 1) == 1) { /*23555*/
						$k[$j++] = 1; /*23553*/
					} else { /*23555*/
						var _X = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23555*/
						$k[$j++] = _X; /*23555*/
					} /*23555*/
				} else { /*23558*/
					$k[$j++] = 0; /*23558*/
				} /*23558*/
				$put($1.sep, $1.i, $k[--$j]); /*23560*/
			} /*23560*/
		}; /*23562*/
		$k[$j++] = Infinity; /*23563*/
		$k[$j++] = 0; /*23564*/
		$forall($1.linsbs, function() { /*23564*/
			var _c = $k[--$j]; /*23564*/
			var _d = $k[--$j]; /*23564*/
			var _e = (_d == 1) ? 0 : 1; /*23564*/
			$k[$j++] = _d; /*23564*/
			for (var _f = 0, _g = _c; _f < _g; _f++) { /*23564*/
				$k[$j++] = _e /*23564*/
			} /*23564*/
		}); /*23564*/
		$astore($a($counttomark() - 1)); /*23565*/
		$1.bot = $k[--$j]; /*23565*/
		$j -= 2; /*23565*/
		$k[$j++] = Infinity; /*23566*/
		$forall($1.bot, function() { /*23566*/
			var _l = $k[--$j]; /*23566*/
			$k[$j++] = 1 - _l; /*23566*/
		}); /*23566*/
		$1.sep = $a(); /*23566*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*23567*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23568*/
		$k[$j++] = Infinity; /*23571*/
		for (var _u = 18, _t = $1.bot.length - 13; _u <= _t; _u += 98) { /*23570*/
			$k[$j++] = _u; /*23570*/
		} /*23570*/
		for (var _x = 69, _w = $1.bot.length - 13; _x <= _w; _x += 98) { /*23571*/
			$k[$j++] = _x; /*23571*/
		} /*23571*/
		var _y = $a(); /*23571*/
		for (var _z = 0, _10 = _y.length; _z < _10; _z++) { /*23572*/
			$k[$j++] = $get(_y, _z); /*23572*/
			if ($1.sepfinder() == $b) return $b; /*23572*/
		} /*23572*/
		$$.rmoveto(0, $1.linheight); /*23573*/
		var _17 = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*23580*/
		$k[$j++] = _17; /*23581*/
		$0.renmatrix(); /*23581*/
		$$.rmoveto(1, 1); /*23584*/
		$k[$j++] = $1.comp; /*23584*/
		$k[$j++] = $1.options; /*23584*/
		$0["gs1-cc"](); /*23584*/
		$0.renmatrix(); /*23584*/
		$$.restore(); /*23586*/
	};
	$0.databarexpandedstackedcomposite = function() {
		var $1 = {}; /*23615*/
		$1.options = $k[--$j]; /*23617*/
		$1.barcode = $k[--$j]; /*23618*/
		$1.dontdraw = false; /*23620*/
		$forall($1.options, function() { /*23631*/
			var _3 = $k[--$j]; /*23631*/
			$1[$k[--$j]] = _3; /*23631*/
		}); /*23631*/
		$search($1.barcode, "|"); /*23634*/
		if ($k[--$j]) { /*23639*/
			$1.linear = $k[--$j]; /*23635*/
			$j--; /*23636*/
			$1.comp = $k[--$j]; /*23637*/
		} else { /*23639*/
			$j--; /*23639*/
		} /*23639*/
		$$.save(); /*23642*/
		$1.options.lintype = "databarexpandedstacked"; /*23644*/
		$1.options.linkage = true; /*23645*/
		$1.options.inkspread = "0"; /*23646*/
		$1.options.dontdraw = true; /*23647*/
		$k[$j++] = $1.linear; /*23650*/
		$k[$j++] = $1.options; /*23650*/
		$0.databarexpandedstacked(); /*23650*/
		var _F = $k[--$j]; /*23651*/
		$1.bot = $geti(_F.pixs, 0, _F.pixx); /*23651*/
		$1.linheight = _F.pixy; /*23652*/
		$k[$j++] = _F; /*23653*/
		$0.renmatrix(); /*23653*/
		$1.sepfinder = function() {
			$1.fp = $k[--$j]; /*23657*/
			for (var _O = $1.fp, _N = $1.fp + 12; _O <= _N; _O += 1) { /*23670*/
				$1.i = _O; /*23659*/
				if ($get($1.bot, $1.i) == 0) { /*23667*/
					if ($get($1.bot, $1.i - 1) == 1) { /*23664*/
						$k[$j++] = 1; /*23662*/
					} else { /*23664*/
						var _Y = ($get($1.sep, $1.i - 1) == 0) ? 1 : 0; /*23664*/
						$k[$j++] = _Y; /*23664*/
					} /*23664*/
				} else { /*23667*/
					$k[$j++] = 0; /*23667*/
				} /*23667*/
				$put($1.sep, $1.i, $k[--$j]); /*23669*/
			} /*23669*/
		}; /*23671*/
		$k[$j++] = Infinity; /*23672*/
		$forall($1.bot, function() { /*23672*/
			var _d = $k[--$j]; /*23672*/
			$k[$j++] = 1 - _d; /*23672*/
		}); /*23672*/
		$1.sep = $a(); /*23672*/
		$puti($1.sep, 0, $a([0, 0, 0])); /*23673*/
		$puti($1.sep, $1.sep.length - 4, $a([0, 0, 0, 0])); /*23674*/
		$k[$j++] = Infinity; /*23677*/
		for (var _m = 19, _l = $1.bot.length - 13; _m <= _l; _m += 98) { /*23676*/
			$k[$j++] = _m; /*23676*/
		} /*23676*/
		for (var _p = 70, _o = $1.bot.length - 13; _p <= _o; _p += 98) { /*23677*/
			$k[$j++] = _p; /*23677*/
		} /*23677*/
		var _q = $a(); /*23677*/
		for (var _r = 0, _s = _q.length; _r < _s; _r++) { /*23678*/
			$k[$j++] = $get(_q, _r); /*23678*/
			if ($1.sepfinder() == $b) return $b; /*23678*/
		} /*23678*/
		$$.rmoveto(0, $1.linheight); /*23679*/
		var _z = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*23686*/
		$k[$j++] = _z; /*23687*/
		$0.renmatrix(); /*23687*/
		var _12 = ($get($1.bot, 0) == 0) ? 2 : 0; /*23690*/
		$$.rmoveto(_12, 1); /*23690*/
		$k[$j++] = $1.comp; /*23691*/
		$k[$j++] = $1.options; /*23691*/
		$0["gs1-cc"](); /*23691*/
		$0.renmatrix(); /*23691*/
		$$.restore(); /*23693*/
	};
	$0["gs1-128composite"] = function() {
		var $1 = {}; /*23723*/
		$1.options = $k[--$j]; /*23725*/
		$1.barcode = $k[--$j]; /*23726*/
		$1.dontdraw = false; /*23728*/
		$forall($1.options, function() { /*23739*/
			var _3 = $k[--$j]; /*23739*/
			$1[$k[--$j]] = _3; /*23739*/
		}); /*23739*/
		$search($1.barcode, "|"); /*23742*/
		if ($k[--$j]) { /*23747*/
			$1.linear = $k[--$j]; /*23743*/
			$j--; /*23744*/
			$1.comp = $k[--$j]; /*23745*/
		} else { /*23747*/
			$j--; /*23747*/
		} /*23747*/
		$$.save(); /*23750*/
		$1.options.inkspread = "0"; /*23752*/
		$1.options.dontdraw = true; /*23753*/
		$1.options.linkagea = true; /*23756*/
		$k[$j++] = $1.linear; /*23757*/
		$k[$j++] = Infinity; /*23757*/
		$forall($1.options); /*23757*/
		var _E = $d(); /*23757*/
		$k[$j++] = _E; /*23757*/
		$0["gs1-128"](); /*23757*/
		var _G = $k[--$j].sbs; /*23758*/
		$k[$j++] = 0; /*23758*/
		$forall(_G, function() { /*23758*/
			var _H = $k[--$j]; /*23758*/
			var _I = $k[--$j]; /*23758*/
			$k[$j++] = _I + _H; /*23758*/
		}); /*23758*/
		$1.linwidth = $k[--$j]; /*23758*/
		$1.options.lintype = "gs1-128"; /*23761*/
		$1.options.linwidth = $1.linwidth; /*23762*/
		$k[$j++] = $1.comp; /*23763*/
		$k[$j++] = $1.options; /*23763*/
		$0["gs1-cc"](); /*23763*/
		$1.compsym = $k[--$j]; /*23763*/
		if ($1.compsym.pixx == 99) { /*23764*/
			$k[$j++] = "a"; /*23764*/
		} else { /*23764*/
			$k[$j++] = "c"; /*23764*/
		} /*23764*/
		$1.linktype = $k[--$j]; /*23764*/
		if ($eq($1.linktype, "a")) { /*23772*/
			$1.options.linkagea = true; /*23768*/
			$1.options.linkagec = false; /*23769*/
		} else { /*23772*/
			$1.options.linkagea = false; /*23771*/
			$1.options.linkagec = true; /*23772*/
		} /*23772*/
		$k[$j++] = $1.linear; /*23774*/
		$k[$j++] = Infinity; /*23774*/
		$forall($1.options); /*23774*/
		var _a = $d(); /*23774*/
		$k[$j++] = _a; /*23774*/
		$0["gs1-128"](); /*23774*/
		var _b = $k[--$j]; /*23775*/
		$1.linsbs = _b.sbs; /*23775*/
		$1.linheight = $get(_b.bhs, 0) * 72; /*23776*/
		$k[$j++] = _b; /*23777*/
		$0.renlinear(); /*23777*/
		$k[$j++] = Infinity; /*23780*/
		$k[$j++] = 1; /*23781*/
		$forall($1.linsbs, function() { /*23781*/
			var _g = $k[--$j]; /*23781*/
			var _h = $k[--$j]; /*23781*/
			var _i = (_h == 0) ? 1 : 0; /*23781*/
			$k[$j++] = _h; /*23781*/
			for (var _j = 0, _k = _g; _j < _k; _j++) { /*23781*/
				$k[$j++] = _i /*23781*/
			} /*23781*/
		}); /*23781*/
		$astore($a($counttomark() - 1)); /*23782*/
		$1.sep = $k[--$j]; /*23782*/
		$j -= 2; /*23782*/
		$$.rmoveto(0, $1.linheight); /*23783*/
		var _t = {
			ren: $0.renmatrix,
			pixs: $1.sep,
			pixx: $1.sep.length,
			pixy: 1,
			height: 1 / 72,
			width: $1.sep.length / 72,
			opt: $1.options
		}; /*23790*/
		$k[$j++] = _t; /*23791*/
		$0.renmatrix(); /*23791*/
		if ($eq($1.linktype, "a")) { /*23800*/
			$1.s = ~~(($1.linwidth - 2) / 11); /*23795*/
			$1.p = ~~(($1.s - 9) / 2); /*23796*/
			$k[$j++] = "x"; /*23797*/
			$k[$j++] = ((($1.s - $1.p) - 1) * 11) + 10; /*23797*/
			if ($1.p == 0) { /*23797*/
				var _10 = $k[--$j]; /*23797*/
				$k[$j++] = _10 + 2; /*23797*/
			} /*23797*/
			var _11 = $k[--$j]; /*23797*/
			$1[$k[--$j]] = _11 - 99; /*23797*/
			$$.rmoveto($1.x, 1); /*23798*/
		} else { /*23800*/
			$$.rmoveto(-7, 1); /*23800*/
		} /*23800*/
		$k[$j++] = $1.compsym; /*23803*/
		$0.renmatrix(); /*23803*/
		$$.restore(); /*23805*/
	};
	$0.gs1datamatrix = function() {
		var $1 = {}; /*23833*/
		$1.options = $k[--$j]; /*23835*/
		$1.barcode = $k[--$j]; /*23836*/
		$1.dontdraw = false; /*23838*/
		$forall($1.options, function() { /*23849*/
			var _3 = $k[--$j]; /*23849*/
			$1[$k[--$j]] = _3; /*23849*/
		}); /*23849*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*23853*/
			$1.out = $s($1.in.length); /*23854*/
			$1.j = 0; /*23855*/
			$k[$j++] = $1.in; /*23869*/
			for (;;) { /*23869*/
				$search($k[--$j], "^"); /*23858*/
				if ($k[--$j]) { /*23867*/
					var _B = $k[--$j]; /*23859*/
					$puti($1.out, $1.j, _B); /*23859*/
					$1.j = (_B.length + $1.j) + 1; /*23860*/
					$j--; /*23861*/
					var _F = $k[--$j]; /*23862*/
					$put($1.out, $1.j - 1, ~~$z($geti(_F, 0, 3))); /*23862*/
					$k[$j++] = $geti(_F, 3, _F.length - 3); /*23863*/
				} else { /*23867*/
					var _K = $k[--$j]; /*23865*/
					$puti($1.out, $1.j, _K); /*23865*/
					$1.j = _K.length + $1.j; /*23866*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*23867*/
					break; /*23867*/
				} /*23867*/
			} /*23867*/
		}; /*23870*/
		$1.ais = $a([]); /*23873*/
		$1.vals = $a([]); /*23874*/
		var _T = $1.barcode; /*23875*/
		$k[$j++] = $geti(_T, 1, _T.length - 1); /*23888*/
		for (;;) { /*23888*/
			var _V = $k[--$j]; /*23877*/
			$k[$j++] = _V; /*23877*/
			if ($eq(_V, "")) { /*23877*/
				break; /*23877*/
			} /*23877*/
			$search($k[--$j], ")"); /*23878*/
			$j--; /*23878*/
			var _X = $k[--$j]; /*23879*/
			var _Y = $k[--$j]; /*23879*/
			var _Z = $k[--$j]; /*23880*/
			$k[$j++] = _X; /*23880*/
			$search(_Z, "("); /*23880*/
			if ($k[--$j]) { /*23883*/
				var _b = $k[--$j]; /*23881*/
				var _c = $k[--$j]; /*23881*/
				var _d = $k[--$j]; /*23881*/
				var _e = $k[--$j]; /*23881*/
				$k[$j++] = _d; /*23881*/
				$k[$j++] = _e; /*23881*/
				$k[$j++] = _b; /*23881*/
			} else { /*23883*/
				var _f = $k[--$j]; /*23883*/
				var _g = $k[--$j]; /*23883*/
				$k[$j++] = ""; /*23883*/
				$k[$j++] = _g; /*23883*/
				$k[$j++] = _f; /*23883*/
			} /*23883*/
			$k[$j++] = Infinity; /*23885*/
			$aload($1.ais); /*23885*/
			var _j = $k[$j - 1 - ($counttomark() + 2)]; /*23885*/
			$k[$j++] = _j; /*23885*/
			$1.ais = $a(); /*23885*/
			$k[$j++] = Infinity; /*23886*/
			$aload($1.vals); /*23886*/
			var _n = $k[$j - 1 - ($counttomark() + 1)]; /*23886*/
			$k[$j++] = _n; /*23886*/
			if ($1.expand() == $b) break; /*23886*/
			$1.vals = $a(); /*23886*/
			$j -= 2; /*23887*/
		} /*23887*/
		$j--; /*23889*/
		$1.aifixed = {}; /*23894*/
		$k[$j++] = Infinity; /*23896*/
		for (var _p = 0; _p <= 4; _p += 1) { /*23896*/
			$k[$j++] = _p; /*23896*/
		} /*23896*/
		var _q = $a(); /*23896*/
		for (var _r = 0, _s = _q.length; _r < _s; _r++) { /*23899*/
			var _v = $strcpy($s(2), "00"); /*23898*/
			$put(_v, 1, $get(_q, _r) + 48); /*23898*/
			$put($1.aifixed, _v, _v); /*23898*/
		} /*23898*/
		$k[$j++] = Infinity; /*23904*/
		for (var _x = 11; _x <= 20; _x += 1) { /*23901*/
			$k[$j++] = _x; /*23901*/
		} /*23901*/
		$k[$j++] = 23; /*23903*/
		for (var _y = 31; _y <= 36; _y += 1) { /*23903*/
			$k[$j++] = _y; /*23903*/
		} /*23903*/
		$k[$j++] = 41; /*23904*/
		var _z = $a(); /*23904*/
		for (var _10 = 0, _11 = _z.length; _10 < _11; _10++) { /*23907*/
			var _14 = $cvrs($s(2), $get(_z, _10), 10); /*23906*/
			$put($1.aifixed, _14, _14); /*23906*/
		} /*23906*/
		$1.fnc1 = -1; /*23910*/
		$1.dmtx = $a([$1.fnc1]); /*23911*/
		for (var _1A = 0, _19 = $1.ais.length - 1; _1A <= _19; _1A += 1) { /*23927*/
			$1.i = _1A; /*23913*/
			$1.ai = $get($1.ais, $1.i); /*23914*/
			$1.val = $get($1.vals, $1.i); /*23915*/
			var _1K = $a(($1.dmtx.length + $1.ai.length) + $1.val.length); /*23916*/
			$puti(_1K, 0, $1.dmtx); /*23917*/
			$k[$j++] = _1K; /*23918*/
			$k[$j++] = _1K; /*23918*/
			$k[$j++] = $1.dmtx.length; /*23918*/
			$k[$j++] = $1.ai; /*23918*/
			$k[$j++] = Infinity; /*23918*/
			var _1O = $k[--$j]; /*23918*/
			var _1P = $k[--$j]; /*23918*/
			$k[$j++] = _1O; /*23918*/
			$forall(_1P); /*23918*/
			var _1Q = $a(); /*23918*/
			var _1R = $k[--$j]; /*23918*/
			$puti($k[--$j], _1R, _1Q); /*23918*/
			var _1T = $k[--$j]; /*23919*/
			$k[$j++] = _1T; /*23919*/
			$k[$j++] = _1T; /*23919*/
			$k[$j++] = $1.dmtx.length + $1.ai.length; /*23919*/
			$k[$j++] = $1.val; /*23919*/
			$k[$j++] = Infinity; /*23919*/
			var _1X = $k[--$j]; /*23919*/
			var _1Y = $k[--$j]; /*23919*/
			$k[$j++] = _1X; /*23919*/
			$forall(_1Y); /*23919*/
			var _1Z = $a(); /*23919*/
			var _1a = $k[--$j]; /*23919*/
			$puti($k[--$j], _1a, _1Z); /*23919*/
			$1.dmtx = $k[--$j]; /*23920*/
			var _1i = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*23921*/
			if (($1.i != ($1.ais.length - 1)) && (!_1i)) { /*23926*/
				var _1k = $a($1.dmtx.length + 1); /*23922*/
				$puti(_1k, 0, $1.dmtx); /*23923*/
				$put(_1k, $1.dmtx.length, $1.fnc1); /*23924*/
				$1.dmtx = _1k; /*23925*/
			} /*23925*/
		} /*23925*/
		$1.barcode = $s(($1.dmtx.length + 1) * 5); /*23930*/
		$1.i = 0; /*23931*/
		$1.j = 0; /*23931*/
		for (;;) { /*23941*/
			if ($1.i == $1.dmtx.length) { /*23932*/
				break; /*23932*/
			} /*23932*/
			var _1u = $get($1.dmtx, $1.i); /*23933*/
			$k[$j++] = _1u; /*23938*/
			if (_1u == $1.fnc1) { /*23937*/
				$j--; /*23934*/
				$puti($1.barcode, $1.j, "^FNC1"); /*23934*/
				$1.j = $1.j + 4; /*23935*/
			} else { /*23937*/
				$put($1.barcode, $1.j, $k[--$j]); /*23937*/
			} /*23937*/
			$1.i = $1.i + 1; /*23939*/
			$1.j = $1.j + 1; /*23940*/
		} /*23940*/
		$1.barcode = $geti($1.barcode, 0, $1.j); /*23942*/
		$1.options.dontdraw = true; /*23945*/
		$1.options.parsefnc = true; /*23946*/
		$k[$j++] = "args"; /*23947*/
		$k[$j++] = $1.barcode; /*23947*/
		$k[$j++] = $1.options; /*23947*/
		$0.datamatrix(); /*23947*/
		var _2B = $k[--$j]; /*23947*/
		$1[$k[--$j]] = _2B; /*23947*/
		$1.args.opt = $1.options; /*23949*/
		$k[$j++] = $1.args; /*23952*/
		if (!$1.dontdraw) { /*23952*/
			$0.renmatrix(); /*23952*/
		} /*23952*/
	};
	$0.gs1datamatrixrectangular = function() {
		var $1 = {}; /*23980*/
		$1.options = $k[--$j]; /*23982*/
		$1.barcode = $k[--$j]; /*23983*/
		$1.dontdraw = false; /*23985*/
		$forall($1.options, function() { /*23996*/
			var _3 = $k[--$j]; /*23996*/
			$1[$k[--$j]] = _3; /*23996*/
		}); /*23996*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*24000*/
			$1.out = $s($1.in.length); /*24001*/
			$1.j = 0; /*24002*/
			$k[$j++] = $1.in; /*24016*/
			for (;;) { /*24016*/
				$search($k[--$j], "^"); /*24005*/
				if ($k[--$j]) { /*24014*/
					var _B = $k[--$j]; /*24006*/
					$puti($1.out, $1.j, _B); /*24006*/
					$1.j = (_B.length + $1.j) + 1; /*24007*/
					$j--; /*24008*/
					var _F = $k[--$j]; /*24009*/
					$put($1.out, $1.j - 1, ~~$z($geti(_F, 0, 3))); /*24009*/
					$k[$j++] = $geti(_F, 3, _F.length - 3); /*24010*/
				} else { /*24014*/
					var _K = $k[--$j]; /*24012*/
					$puti($1.out, $1.j, _K); /*24012*/
					$1.j = _K.length + $1.j; /*24013*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*24014*/
					break; /*24014*/
				} /*24014*/
			} /*24014*/
		}; /*24017*/
		$1.ais = $a([]); /*24020*/
		$1.vals = $a([]); /*24021*/
		var _T = $1.barcode; /*24022*/
		$k[$j++] = $geti(_T, 1, _T.length - 1); /*24035*/
		for (;;) { /*24035*/
			var _V = $k[--$j]; /*24024*/
			$k[$j++] = _V; /*24024*/
			if ($eq(_V, "")) { /*24024*/
				break; /*24024*/
			} /*24024*/
			$search($k[--$j], ")"); /*24025*/
			$j--; /*24025*/
			var _X = $k[--$j]; /*24026*/
			var _Y = $k[--$j]; /*24026*/
			var _Z = $k[--$j]; /*24027*/
			$k[$j++] = _X; /*24027*/
			$search(_Z, "("); /*24027*/
			if ($k[--$j]) { /*24030*/
				var _b = $k[--$j]; /*24028*/
				var _c = $k[--$j]; /*24028*/
				var _d = $k[--$j]; /*24028*/
				var _e = $k[--$j]; /*24028*/
				$k[$j++] = _d; /*24028*/
				$k[$j++] = _e; /*24028*/
				$k[$j++] = _b; /*24028*/
			} else { /*24030*/
				var _f = $k[--$j]; /*24030*/
				var _g = $k[--$j]; /*24030*/
				$k[$j++] = ""; /*24030*/
				$k[$j++] = _g; /*24030*/
				$k[$j++] = _f; /*24030*/
			} /*24030*/
			$k[$j++] = Infinity; /*24032*/
			$aload($1.ais); /*24032*/
			var _j = $k[$j - 1 - ($counttomark() + 2)]; /*24032*/
			$k[$j++] = _j; /*24032*/
			$1.ais = $a(); /*24032*/
			$k[$j++] = Infinity; /*24033*/
			$aload($1.vals); /*24033*/
			var _n = $k[$j - 1 - ($counttomark() + 1)]; /*24033*/
			$k[$j++] = _n; /*24033*/
			if ($1.expand() == $b) break; /*24033*/
			$1.vals = $a(); /*24033*/
			$j -= 2; /*24034*/
		} /*24034*/
		$j--; /*24036*/
		$1.aifixed = {}; /*24041*/
		$k[$j++] = Infinity; /*24043*/
		for (var _p = 0; _p <= 4; _p += 1) { /*24043*/
			$k[$j++] = _p; /*24043*/
		} /*24043*/
		var _q = $a(); /*24043*/
		for (var _r = 0, _s = _q.length; _r < _s; _r++) { /*24046*/
			var _v = $strcpy($s(2), "00"); /*24045*/
			$put(_v, 1, $get(_q, _r) + 48); /*24045*/
			$put($1.aifixed, _v, _v); /*24045*/
		} /*24045*/
		$k[$j++] = Infinity; /*24051*/
		for (var _x = 11; _x <= 20; _x += 1) { /*24048*/
			$k[$j++] = _x; /*24048*/
		} /*24048*/
		$k[$j++] = 23; /*24050*/
		for (var _y = 31; _y <= 36; _y += 1) { /*24050*/
			$k[$j++] = _y; /*24050*/
		} /*24050*/
		$k[$j++] = 41; /*24051*/
		var _z = $a(); /*24051*/
		for (var _10 = 0, _11 = _z.length; _10 < _11; _10++) { /*24054*/
			var _14 = $cvrs($s(2), $get(_z, _10), 10); /*24053*/
			$put($1.aifixed, _14, _14); /*24053*/
		} /*24053*/
		$1.fnc1 = -1; /*24057*/
		$1.dmtx = $a([$1.fnc1]); /*24058*/
		for (var _1A = 0, _19 = $1.ais.length - 1; _1A <= _19; _1A += 1) { /*24074*/
			$1.i = _1A; /*24060*/
			$1.ai = $get($1.ais, $1.i); /*24061*/
			$1.val = $get($1.vals, $1.i); /*24062*/
			var _1K = $a(($1.dmtx.length + $1.ai.length) + $1.val.length); /*24063*/
			$puti(_1K, 0, $1.dmtx); /*24064*/
			$k[$j++] = _1K; /*24065*/
			$k[$j++] = _1K; /*24065*/
			$k[$j++] = $1.dmtx.length; /*24065*/
			$k[$j++] = $1.ai; /*24065*/
			$k[$j++] = Infinity; /*24065*/
			var _1O = $k[--$j]; /*24065*/
			var _1P = $k[--$j]; /*24065*/
			$k[$j++] = _1O; /*24065*/
			$forall(_1P); /*24065*/
			var _1Q = $a(); /*24065*/
			var _1R = $k[--$j]; /*24065*/
			$puti($k[--$j], _1R, _1Q); /*24065*/
			var _1T = $k[--$j]; /*24066*/
			$k[$j++] = _1T; /*24066*/
			$k[$j++] = _1T; /*24066*/
			$k[$j++] = $1.dmtx.length + $1.ai.length; /*24066*/
			$k[$j++] = $1.val; /*24066*/
			$k[$j++] = Infinity; /*24066*/
			var _1X = $k[--$j]; /*24066*/
			var _1Y = $k[--$j]; /*24066*/
			$k[$j++] = _1X; /*24066*/
			$forall(_1Y); /*24066*/
			var _1Z = $a(); /*24066*/
			var _1a = $k[--$j]; /*24066*/
			$puti($k[--$j], _1a, _1Z); /*24066*/
			$1.dmtx = $k[--$j]; /*24067*/
			var _1i = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*24068*/
			if (($1.i != ($1.ais.length - 1)) && (!_1i)) { /*24073*/
				var _1k = $a($1.dmtx.length + 1); /*24069*/
				$puti(_1k, 0, $1.dmtx); /*24070*/
				$put(_1k, $1.dmtx.length, $1.fnc1); /*24071*/
				$1.dmtx = _1k; /*24072*/
			} /*24072*/
		} /*24072*/
		$1.barcode = $s(($1.dmtx.length + 1) * 5); /*24077*/
		$1.i = 0; /*24078*/
		$1.j = 0; /*24078*/
		for (;;) { /*24088*/
			if ($1.i == $1.dmtx.length) { /*24079*/
				break; /*24079*/
			} /*24079*/
			var _1u = $get($1.dmtx, $1.i); /*24080*/
			$k[$j++] = _1u; /*24085*/
			if (_1u == $1.fnc1) { /*24084*/
				$j--; /*24081*/
				$puti($1.barcode, $1.j, "^FNC1"); /*24081*/
				$1.j = $1.j + 4; /*24082*/
			} else { /*24084*/
				$put($1.barcode, $1.j, $k[--$j]); /*24084*/
			} /*24084*/
			$1.i = $1.i + 1; /*24086*/
			$1.j = $1.j + 1; /*24087*/
		} /*24087*/
		$1.barcode = $geti($1.barcode, 0, $1.j); /*24089*/
		$1.options.dontdraw = true; /*24092*/
		$1.options.parsefnc = true; /*24093*/
		$1.options.format = "rectangle"; /*24094*/
		$k[$j++] = "args"; /*24095*/
		$k[$j++] = $1.barcode; /*24095*/
		$k[$j++] = $1.options; /*24095*/
		$0.datamatrix(); /*24095*/
		var _2C = $k[--$j]; /*24095*/
		$1[$k[--$j]] = _2C; /*24095*/
		$1.args.opt = $1.options; /*24097*/
		$k[$j++] = $1.args; /*24100*/
		if (!$1.dontdraw) { /*24100*/
			$0.renmatrix(); /*24100*/
		} /*24100*/
	};
	$0.gs1qrcode = function() {
		var $1 = {}; /*24127*/
		$1.options = $k[--$j]; /*24129*/
		$1.barcode = $k[--$j]; /*24130*/
		$1.dontdraw = false; /*24132*/
		$forall($1.options, function() { /*24143*/
			var _3 = $k[--$j]; /*24143*/
			$1[$k[--$j]] = _3; /*24143*/
		}); /*24143*/
		$1.expand = function() {
			$1.in = $k[--$j]; /*24147*/
			$1.out = $s($1.in.length); /*24148*/
			$1.j = 0; /*24149*/
			$k[$j++] = $1.in; /*24163*/
			for (;;) { /*24163*/
				$search($k[--$j], "^"); /*24152*/
				if ($k[--$j]) { /*24161*/
					var _B = $k[--$j]; /*24153*/
					$puti($1.out, $1.j, _B); /*24153*/
					$1.j = (_B.length + $1.j) + 1; /*24154*/
					$j--; /*24155*/
					var _F = $k[--$j]; /*24156*/
					$put($1.out, $1.j - 1, ~~$z($geti(_F, 0, 3))); /*24156*/
					$k[$j++] = $geti(_F, 3, _F.length - 3); /*24157*/
				} else { /*24161*/
					var _K = $k[--$j]; /*24159*/
					$puti($1.out, $1.j, _K); /*24159*/
					$1.j = _K.length + $1.j; /*24160*/
					$k[$j++] = $geti($1.out, 0, $1.j); /*24161*/
					break; /*24161*/
				} /*24161*/
			} /*24161*/
		}; /*24164*/
		$1.ais = $a([]); /*24167*/
		$1.vals = $a([]); /*24168*/
		var _T = $1.barcode; /*24169*/
		$k[$j++] = $geti(_T, 1, _T.length - 1); /*24182*/
		for (;;) { /*24182*/
			var _V = $k[--$j]; /*24171*/
			$k[$j++] = _V; /*24171*/
			if ($eq(_V, "")) { /*24171*/
				break; /*24171*/
			} /*24171*/
			$search($k[--$j], ")"); /*24172*/
			$j--; /*24172*/
			var _X = $k[--$j]; /*24173*/
			var _Y = $k[--$j]; /*24173*/
			var _Z = $k[--$j]; /*24174*/
			$k[$j++] = _X; /*24174*/
			$search(_Z, "("); /*24174*/
			if ($k[--$j]) { /*24177*/
				var _b = $k[--$j]; /*24175*/
				var _c = $k[--$j]; /*24175*/
				var _d = $k[--$j]; /*24175*/
				var _e = $k[--$j]; /*24175*/
				$k[$j++] = _d; /*24175*/
				$k[$j++] = _e; /*24175*/
				$k[$j++] = _b; /*24175*/
			} else { /*24177*/
				var _f = $k[--$j]; /*24177*/
				var _g = $k[--$j]; /*24177*/
				$k[$j++] = ""; /*24177*/
				$k[$j++] = _g; /*24177*/
				$k[$j++] = _f; /*24177*/
			} /*24177*/
			$k[$j++] = Infinity; /*24179*/
			$aload($1.ais); /*24179*/
			var _j = $k[$j - 1 - ($counttomark() + 2)]; /*24179*/
			$k[$j++] = _j; /*24179*/
			$1.ais = $a(); /*24179*/
			$k[$j++] = Infinity; /*24180*/
			$aload($1.vals); /*24180*/
			var _n = $k[$j - 1 - ($counttomark() + 1)]; /*24180*/
			$k[$j++] = _n; /*24180*/
			if ($1.expand() == $b) break; /*24180*/
			$1.vals = $a(); /*24180*/
			$j -= 2; /*24181*/
		} /*24181*/
		$j--; /*24183*/
		$1.aifixed = {}; /*24188*/
		$k[$j++] = Infinity; /*24190*/
		for (var _p = 0; _p <= 4; _p += 1) { /*24190*/
			$k[$j++] = _p; /*24190*/
		} /*24190*/
		var _q = $a(); /*24190*/
		for (var _r = 0, _s = _q.length; _r < _s; _r++) { /*24193*/
			var _v = $strcpy($s(2), "00"); /*24192*/
			$put(_v, 1, $get(_q, _r) + 48); /*24192*/
			$put($1.aifixed, _v, _v); /*24192*/
		} /*24192*/
		$k[$j++] = Infinity; /*24198*/
		for (var _x = 11; _x <= 20; _x += 1) { /*24195*/
			$k[$j++] = _x; /*24195*/
		} /*24195*/
		$k[$j++] = 23; /*24197*/
		for (var _y = 31; _y <= 36; _y += 1) { /*24197*/
			$k[$j++] = _y; /*24197*/
		} /*24197*/
		$k[$j++] = 41; /*24198*/
		var _z = $a(); /*24198*/
		for (var _10 = 0, _11 = _z.length; _10 < _11; _10++) { /*24201*/
			var _14 = $cvrs($s(2), $get(_z, _10), 10); /*24200*/
			$put($1.aifixed, _14, _14); /*24200*/
		} /*24200*/
		$1.fnc1 = -1; /*24204*/
		$1.qrc = $a([$1.fnc1]); /*24205*/
		for (var _1A = 0, _19 = $1.ais.length - 1; _1A <= _19; _1A += 1) { /*24221*/
			$1.i = _1A; /*24207*/
			$1.ai = $get($1.ais, $1.i); /*24208*/
			$1.val = $get($1.vals, $1.i); /*24209*/
			var _1K = $a(($1.qrc.length + $1.ai.length) + $1.val.length); /*24210*/
			$puti(_1K, 0, $1.qrc); /*24211*/
			$k[$j++] = _1K; /*24212*/
			$k[$j++] = _1K; /*24212*/
			$k[$j++] = $1.qrc.length; /*24212*/
			$k[$j++] = $1.ai; /*24212*/
			$k[$j++] = Infinity; /*24212*/
			var _1O = $k[--$j]; /*24212*/
			var _1P = $k[--$j]; /*24212*/
			$k[$j++] = _1O; /*24212*/
			$forall(_1P); /*24212*/
			var _1Q = $a(); /*24212*/
			var _1R = $k[--$j]; /*24212*/
			$puti($k[--$j], _1R, _1Q); /*24212*/
			var _1T = $k[--$j]; /*24213*/
			$k[$j++] = _1T; /*24213*/
			$k[$j++] = _1T; /*24213*/
			$k[$j++] = $1.qrc.length + $1.ai.length; /*24213*/
			$k[$j++] = $1.val; /*24213*/
			$k[$j++] = Infinity; /*24213*/
			var _1X = $k[--$j]; /*24213*/
			var _1Y = $k[--$j]; /*24213*/
			$k[$j++] = _1X; /*24213*/
			$forall(_1Y); /*24213*/
			var _1Z = $a(); /*24213*/
			var _1a = $k[--$j]; /*24213*/
			$puti($k[--$j], _1a, _1Z); /*24213*/
			$1.qrc = $k[--$j]; /*24214*/
			var _1i = $get($1.aifixed, $geti($1.ai, 0, 2)) !== undefined; /*24215*/
			if (($1.i != ($1.ais.length - 1)) && (!_1i)) { /*24220*/
				var _1k = $a($1.qrc.length + 1); /*24216*/
				$puti(_1k, 0, $1.qrc); /*24217*/
				$put(_1k, $1.qrc.length, $1.fnc1); /*24218*/
				$1.qrc = _1k; /*24219*/
			} /*24219*/
		} /*24219*/
		$1.barcode = $s(($1.qrc.length + 1) * 5); /*24224*/
		$1.i = 0; /*24225*/
		$1.j = 0; /*24225*/
		for (;;) { /*24235*/
			if ($1.i == $1.qrc.length) { /*24226*/
				break; /*24226*/
			} /*24226*/
			var _1u = $get($1.qrc, $1.i); /*24227*/
			$k[$j++] = _1u; /*24232*/
			if (_1u == $1.fnc1) { /*24231*/
				$j--; /*24228*/
				$puti($1.barcode, $1.j, "^FNC1"); /*24228*/
				$1.j = $1.j + 4; /*24229*/
			} else { /*24231*/
				$put($1.barcode, $1.j, $k[--$j]); /*24231*/
			} /*24231*/
			$1.i = $1.i + 1; /*24233*/
			$1.j = $1.j + 1; /*24234*/
		} /*24234*/
		$1.barcode = $geti($1.barcode, 0, $1.j); /*24236*/
		$1.options.dontdraw = true; /*24239*/
		$1.options.parsefnc = true; /*24240*/
		$k[$j++] = "args"; /*24241*/
		$k[$j++] = $1.barcode; /*24241*/
		$k[$j++] = $1.options; /*24241*/
		$0.qrcode(); /*24241*/
		var _2B = $k[--$j]; /*24241*/
		$1[$k[--$j]] = _2B; /*24241*/
		$1.args.opt = $1.options; /*24243*/
		$k[$j++] = $1.args; /*24246*/
		if (!$1.dontdraw) { /*24246*/
			$0.renmatrix(); /*24246*/
		} /*24246*/
	};
	$0.hibccode39 = function() {
		var $1 = {}; /*24274*/
		$1.options = $k[--$j]; /*24276*/
		$1.barcode = $k[--$j]; /*24277*/
		$1.dontdraw = false; /*24279*/
		$1.textfont = "Courier"; /*24280*/
		$1.textsize = 10; /*24281*/
		$1.textyoffset = -8.5; /*24282*/
		$1.textxoffset = 0; /*24283*/
		$1.validatecheck = false; /*24284*/
		$forall($1.options, function() { /*24295*/
			var _3 = $k[--$j]; /*24295*/
			$1[$k[--$j]] = _3; /*24295*/
		}); /*24295*/
		$1.textfont = "" + $1.textfont; /*24297*/
		$1.textsize = +$1.textsize; /*24298*/
		$1.textyoffset = +$1.textyoffset; /*24299*/
		$1.textxoffset = +$1.textxoffset; /*24300*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24303*/
		$1.charvals = {}; /*24304*/
		for (var _9 = 0; _9 <= 42; _9 += 1) { /*24305*/
			$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*24305*/
		} /*24305*/
		for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*24312*/
			var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*24309*/
			if (!_J) { /*24311*/
				$k[$j++] = "bwipp.hibccode39badCharacter"; /*24310*/
				$k[$j++] = "HIBC Code 39 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24310*/
				$0.raiseerror(); /*24310*/
			} /*24310*/
		} /*24310*/
		$k[$j++] = "barlen"; /*24314*/
		$k[$j++] = $1.barcode.length; /*24314*/
		if ($1.validatecheck) { /*24314*/
			var _M = $k[--$j]; /*24314*/
			$k[$j++] = _M - 1; /*24314*/
		} /*24314*/
		var _N = $k[--$j]; /*24314*/
		$1[$k[--$j]] = _N; /*24314*/
		$1.checksum = 41; /*24316*/
		for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*24320*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _R, 1)) + $1.checksum; /*24319*/
		} /*24319*/
		$1.checksum = $1.checksum % 43; /*24321*/
		if ($1.validatecheck) { /*24327*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24325*/
				$k[$j++] = "bwipp.hibccode39badCheckDigit"; /*24324*/
				$k[$j++] = "Incorrect HIBC Code 39 check digit provided"; /*24324*/
				$0.raiseerror(); /*24324*/
			} /*24324*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24326*/
		} /*24326*/
		var _j = $s($1.barlen + 2); /*24329*/
		$puti(_j, 1, $1.barcode); /*24329*/
		$1.barcode = _j; /*24329*/
		$put($1.barcode, 0, 43); /*24330*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24331*/
		$1.text = $s($1.barlen + 4); /*24333*/
		$put($1.text, 0, 42); /*24334*/
		$puti($1.text, 1, $1.barcode); /*24335*/
		var _10 = $get($1.barcode, $1.barlen + 1); /*24336*/
		$k[$j++] = $1.text; /*24336*/
		$k[$j++] = $1.barlen + 2; /*24336*/
		$k[$j++] = _10; /*24336*/
		if (_10 == 32) { /*24336*/
			$j--; /*24336*/
			$k[$j++] = 95; /*24336*/
		} /*24336*/
		var _11 = $k[--$j]; /*24336*/
		var _12 = $k[--$j]; /*24336*/
		$put($k[--$j], _12, _11); /*24336*/
		$put($1.text, $1.barlen + 3, 42); /*24337*/
		$1.options.dontdraw = true; /*24340*/
		$1.options.includecheck = false; /*24341*/
		$1.options.validatecheck = false; /*24342*/
		$k[$j++] = "args"; /*24343*/
		$k[$j++] = $1.barcode; /*24343*/
		$k[$j++] = $1.options; /*24343*/
		$0.code39(); /*24343*/
		var _1B = $k[--$j]; /*24343*/
		$1[$k[--$j]] = _1B; /*24343*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*24345*/
		$1.args.textxalign = "center"; /*24346*/
		$1.args.opt = $1.options; /*24347*/
		$k[$j++] = $1.args; /*24350*/
		if (!$1.dontdraw) { /*24350*/
			$0.renlinear(); /*24350*/
		} /*24350*/
	};
	$0.hibccode128 = function() {
		var $1 = {}; /*24378*/
		$1.options = $k[--$j]; /*24380*/
		$1.barcode = $k[--$j]; /*24381*/
		$1.dontdraw = false; /*24383*/
		$1.textfont = "Courier"; /*24384*/
		$1.textsize = 10; /*24385*/
		$1.textyoffset = -8.5; /*24386*/
		$1.textxoffset = 0; /*24387*/
		$1.validatecheck = false; /*24388*/
		$forall($1.options, function() { /*24399*/
			var _3 = $k[--$j]; /*24399*/
			$1[$k[--$j]] = _3; /*24399*/
		}); /*24399*/
		$1.textfont = "" + $1.textfont; /*24401*/
		$1.textsize = +$1.textsize; /*24402*/
		$1.textyoffset = +$1.textyoffset; /*24403*/
		$1.textxoffset = +$1.textxoffset; /*24404*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24407*/
		$1.charvals = {}; /*24408*/
		for (var _9 = 0; _9 <= 42; _9 += 1) { /*24409*/
			$put($1.charvals, $geti($1.barchars, _9, 1), _9); /*24409*/
		} /*24409*/
		for (var _F = 0, _E = $1.barcode.length - 1; _F <= _E; _F += 1) { /*24416*/
			var _J = $get($1.charvals, $geti($1.barcode, _F, 1)) !== undefined; /*24413*/
			if (!_J) { /*24415*/
				$k[$j++] = "bwipp.hibccode128badCharacter"; /*24414*/
				$k[$j++] = "HIBC Code 128 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24414*/
				$0.raiseerror(); /*24414*/
			} /*24414*/
		} /*24414*/
		$k[$j++] = "barlen"; /*24418*/
		$k[$j++] = $1.barcode.length; /*24418*/
		if ($1.validatecheck) { /*24418*/
			var _M = $k[--$j]; /*24418*/
			$k[$j++] = _M - 1; /*24418*/
		} /*24418*/
		var _N = $k[--$j]; /*24418*/
		$1[$k[--$j]] = _N; /*24418*/
		$1.checksum = 41; /*24420*/
		for (var _R = 0, _Q = $1.barlen - 1; _R <= _Q; _R += 1) { /*24424*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _R, 1)) + $1.checksum; /*24423*/
		} /*24423*/
		$1.checksum = $1.checksum % 43; /*24425*/
		if ($1.validatecheck) { /*24431*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24429*/
				$k[$j++] = "bwipp.hibccode128badCheckDigit"; /*24428*/
				$k[$j++] = "Incorrect HIBC Code 128 check digit provided"; /*24428*/
				$0.raiseerror(); /*24428*/
			} /*24428*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24430*/
		} /*24430*/
		var _j = $s($1.barlen + 2); /*24433*/
		$puti(_j, 1, $1.barcode); /*24433*/
		$1.barcode = _j; /*24433*/
		$put($1.barcode, 0, 43); /*24434*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24435*/
		$1.text = $s($1.barlen + 4); /*24437*/
		$put($1.text, 0, 42); /*24438*/
		$puti($1.text, 1, $1.barcode); /*24439*/
		var _10 = $get($1.barcode, $1.barlen + 1); /*24440*/
		$k[$j++] = $1.text; /*24440*/
		$k[$j++] = $1.barlen + 2; /*24440*/
		$k[$j++] = _10; /*24440*/
		if (_10 == 32) { /*24440*/
			$j--; /*24440*/
			$k[$j++] = 95; /*24440*/
		} /*24440*/
		var _11 = $k[--$j]; /*24440*/
		var _12 = $k[--$j]; /*24440*/
		$put($k[--$j], _12, _11); /*24440*/
		$put($1.text, $1.barlen + 3, 42); /*24441*/
		$1.options.dontdraw = true; /*24444*/
		$1.options.validatecheck = false; /*24445*/
		$k[$j++] = "args"; /*24446*/
		$k[$j++] = $1.barcode; /*24446*/
		$k[$j++] = $1.options; /*24446*/
		$0.code128(); /*24446*/
		var _1A = $k[--$j]; /*24446*/
		$1[$k[--$j]] = _1A; /*24446*/
		$1.args.txt = $a([$a([$1.text, $1.textxoffset, $1.textyoffset, $1.textfont, $1.textsize])]); /*24448*/
		$1.args.textxalign = "center"; /*24449*/
		$1.args.opt = $1.options; /*24450*/
		$k[$j++] = $1.args; /*24453*/
		if (!$1.dontdraw) { /*24453*/
			$0.renlinear(); /*24453*/
		} /*24453*/
	};
	$0.hibcdatamatrix = function() {
		var $1 = {}; /*24481*/
		$1.options = $k[--$j]; /*24483*/
		$1.barcode = $k[--$j]; /*24484*/
		$1.dontdraw = false; /*24486*/
		$1.validatecheck = false; /*24487*/
		$forall($1.options, function() { /*24498*/
			var _3 = $k[--$j]; /*24498*/
			$1[$k[--$j]] = _3; /*24498*/
		}); /*24498*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24501*/
		$1.charvals = {}; /*24502*/
		for (var _5 = 0; _5 <= 42; _5 += 1) { /*24503*/
			$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*24503*/
		} /*24503*/
		for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*24510*/
			var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*24507*/
			if (!_F) { /*24509*/
				$k[$j++] = "bwipp.hibcdatamatrixBadCharacter"; /*24508*/
				$k[$j++] = "HIBC Data Matrix must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24508*/
				$0.raiseerror(); /*24508*/
			} /*24508*/
		} /*24508*/
		$k[$j++] = "barlen"; /*24512*/
		$k[$j++] = $1.barcode.length; /*24512*/
		if ($1.validatecheck) { /*24512*/
			var _I = $k[--$j]; /*24512*/
			$k[$j++] = _I - 1; /*24512*/
		} /*24512*/
		var _J = $k[--$j]; /*24512*/
		$1[$k[--$j]] = _J; /*24512*/
		$1.checksum = 41; /*24514*/
		for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*24518*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*24517*/
		} /*24517*/
		$1.checksum = $1.checksum % 43; /*24519*/
		if ($1.validatecheck) { /*24525*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24523*/
				$k[$j++] = "bwipp.hibcdatamatrixBadCheckDigit"; /*24522*/
				$k[$j++] = "Incorrect HIBC Data Matrix check digit provided"; /*24522*/
				$0.raiseerror(); /*24522*/
			} /*24522*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24524*/
		} /*24524*/
		var _f = $s($1.barlen + 2); /*24527*/
		$puti(_f, 1, $1.barcode); /*24527*/
		$1.barcode = _f; /*24527*/
		$put($1.barcode, 0, 43); /*24528*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24529*/
		$1.options.dontdraw = true; /*24532*/
		$1.options.validatecheck = false; /*24533*/
		$k[$j++] = "args"; /*24534*/
		$k[$j++] = $1.barcode; /*24534*/
		$k[$j++] = $1.options; /*24534*/
		$0.datamatrix(); /*24534*/
		var _r = $k[--$j]; /*24534*/
		$1[$k[--$j]] = _r; /*24534*/
		$1.args.opt = $1.options; /*24536*/
		$k[$j++] = $1.args; /*24539*/
		if (!$1.dontdraw) { /*24539*/
			$0.renmatrix(); /*24539*/
		} /*24539*/
	};
	$0.hibcdatamatrixrectangular = function() {
		var $1 = {}; /*24567*/
		$1.options = $k[--$j]; /*24569*/
		$1.barcode = $k[--$j]; /*24570*/
		$1.dontdraw = false; /*24572*/
		$1.validatecheck = false; /*24573*/
		$forall($1.options, function() { /*24584*/
			var _3 = $k[--$j]; /*24584*/
			$1[$k[--$j]] = _3; /*24584*/
		}); /*24584*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24587*/
		$1.charvals = {}; /*24588*/
		for (var _5 = 0; _5 <= 42; _5 += 1) { /*24589*/
			$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*24589*/
		} /*24589*/
		for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*24596*/
			var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*24593*/
			if (!_F) { /*24595*/
				$k[$j++] = "bwipp.hibcdatamatrixrectangularBadCharacter"; /*24594*/
				$k[$j++] = "HIBC Data Matrix Rectangular must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24594*/
				$0.raiseerror(); /*24594*/
			} /*24594*/
		} /*24594*/
		$k[$j++] = "barlen"; /*24598*/
		$k[$j++] = $1.barcode.length; /*24598*/
		if ($1.validatecheck) { /*24598*/
			var _I = $k[--$j]; /*24598*/
			$k[$j++] = _I - 1; /*24598*/
		} /*24598*/
		var _J = $k[--$j]; /*24598*/
		$1[$k[--$j]] = _J; /*24598*/
		$1.checksum = 41; /*24600*/
		for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*24604*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*24603*/
		} /*24603*/
		$1.checksum = $1.checksum % 43; /*24605*/
		if ($1.validatecheck) { /*24611*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24609*/
				$k[$j++] = "bwipp.hibcdatamatrixrectangularBadCheckDigit"; /*24608*/
				$k[$j++] = "Incorrect HIBC Data Matrix Rectangular check digit provided"; /*24608*/
				$0.raiseerror(); /*24608*/
			} /*24608*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24610*/
		} /*24610*/
		var _f = $s($1.barlen + 2); /*24613*/
		$puti(_f, 1, $1.barcode); /*24613*/
		$1.barcode = _f; /*24613*/
		$put($1.barcode, 0, 43); /*24614*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24615*/
		$1.options.dontdraw = true; /*24618*/
		$1.options.validatecheck = false; /*24619*/
		$1.options.format = "rectangle"; /*24620*/
		$k[$j++] = "args"; /*24621*/
		$k[$j++] = $1.barcode; /*24621*/
		$k[$j++] = $1.options; /*24621*/
		$0.datamatrix(); /*24621*/
		var _s = $k[--$j]; /*24621*/
		$1[$k[--$j]] = _s; /*24621*/
		$1.args.opt = $1.options; /*24623*/
		$k[$j++] = $1.args; /*24626*/
		if (!$1.dontdraw) { /*24626*/
			$0.renmatrix(); /*24626*/
		} /*24626*/
	};
	$0.hibcpdf417 = function() {
		var $1 = {}; /*24654*/
		$1.options = $k[--$j]; /*24656*/
		$1.barcode = $k[--$j]; /*24657*/
		$1.dontdraw = false; /*24659*/
		$1.columns = 2; /*24660*/
		$1.validatecheck = false; /*24661*/
		$forall($1.options, function() { /*24672*/
			var _3 = $k[--$j]; /*24672*/
			$1[$k[--$j]] = _3; /*24672*/
		}); /*24672*/
		$1.columns = ~~$1.columns; /*24674*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24677*/
		$1.charvals = {}; /*24678*/
		for (var _6 = 0; _6 <= 42; _6 += 1) { /*24679*/
			$put($1.charvals, $geti($1.barchars, _6, 1), _6); /*24679*/
		} /*24679*/
		for (var _C = 0, _B = $1.barcode.length - 1; _C <= _B; _C += 1) { /*24686*/
			var _G = $get($1.charvals, $geti($1.barcode, _C, 1)) !== undefined; /*24683*/
			if (!_G) { /*24685*/
				$k[$j++] = "bwipp.hibcpdf417BadCharacter"; /*24684*/
				$k[$j++] = "HIBC PDF417 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24684*/
				$0.raiseerror(); /*24684*/
			} /*24684*/
		} /*24684*/
		$k[$j++] = "barlen"; /*24688*/
		$k[$j++] = $1.barcode.length; /*24688*/
		if ($1.validatecheck) { /*24688*/
			var _J = $k[--$j]; /*24688*/
			$k[$j++] = _J - 1; /*24688*/
		} /*24688*/
		var _K = $k[--$j]; /*24688*/
		$1[$k[--$j]] = _K; /*24688*/
		$1.checksum = 41; /*24690*/
		for (var _O = 0, _N = $1.barlen - 1; _O <= _N; _O += 1) { /*24694*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _O, 1)) + $1.checksum; /*24693*/
		} /*24693*/
		$1.checksum = $1.checksum % 43; /*24695*/
		if ($1.validatecheck) { /*24701*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24699*/
				$k[$j++] = "bwipp.hibcpdf417BadCheckDigit"; /*24698*/
				$k[$j++] = "Incorrect HIBC PDF417 check digit provided"; /*24698*/
				$0.raiseerror(); /*24698*/
			} /*24698*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24700*/
		} /*24700*/
		var _g = $s($1.barlen + 2); /*24703*/
		$puti(_g, 1, $1.barcode); /*24703*/
		$1.barcode = _g; /*24703*/
		$put($1.barcode, 0, 43); /*24704*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24705*/
		$1.options.dontdraw = true; /*24708*/
		$1.options.columns = $1.columns; /*24709*/
		$1.options.validatecheck = false; /*24710*/
		$k[$j++] = "args"; /*24711*/
		$k[$j++] = $1.barcode; /*24711*/
		$k[$j++] = $1.options; /*24711*/
		$0.pdf417(); /*24711*/
		var _u = $k[--$j]; /*24711*/
		$1[$k[--$j]] = _u; /*24711*/
		$1.args.opt = $1.options; /*24713*/
		$k[$j++] = $1.args; /*24716*/
		if (!$1.dontdraw) { /*24716*/
			$0.renmatrix(); /*24716*/
		} /*24716*/
	};
	$0.hibcmicropdf417 = function() {
		var $1 = {}; /*24744*/
		$1.options = $k[--$j]; /*24746*/
		$1.barcode = $k[--$j]; /*24747*/
		$1.dontdraw = false; /*24749*/
		$1.columns = 2; /*24750*/
		$1.validatecheck = false; /*24751*/
		$forall($1.options, function() { /*24762*/
			var _3 = $k[--$j]; /*24762*/
			$1[$k[--$j]] = _3; /*24762*/
		}); /*24762*/
		$1.columns = ~~$1.columns; /*24764*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24767*/
		$1.charvals = {}; /*24768*/
		for (var _6 = 0; _6 <= 42; _6 += 1) { /*24769*/
			$put($1.charvals, $geti($1.barchars, _6, 1), _6); /*24769*/
		} /*24769*/
		for (var _C = 0, _B = $1.barcode.length - 1; _C <= _B; _C += 1) { /*24776*/
			var _G = $get($1.charvals, $geti($1.barcode, _C, 1)) !== undefined; /*24773*/
			if (!_G) { /*24775*/
				$k[$j++] = "bwipp.hibcmicropdf417BadCharacter"; /*24774*/
				$k[$j++] = "HIBC MicroPDF417 must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24774*/
				$0.raiseerror(); /*24774*/
			} /*24774*/
		} /*24774*/
		$k[$j++] = "barlen"; /*24778*/
		$k[$j++] = $1.barcode.length; /*24778*/
		if ($1.validatecheck) { /*24778*/
			var _J = $k[--$j]; /*24778*/
			$k[$j++] = _J - 1; /*24778*/
		} /*24778*/
		var _K = $k[--$j]; /*24778*/
		$1[$k[--$j]] = _K; /*24778*/
		$1.checksum = 41; /*24780*/
		for (var _O = 0, _N = $1.barlen - 1; _O <= _N; _O += 1) { /*24784*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _O, 1)) + $1.checksum; /*24783*/
		} /*24783*/
		$1.checksum = $1.checksum % 43; /*24785*/
		if ($1.validatecheck) { /*24791*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24789*/
				$k[$j++] = "bwipp.hibcmicropdf417BadCheckDigit"; /*24788*/
				$k[$j++] = "Incorrect HIBC MicroPDF417 check digit provided"; /*24788*/
				$0.raiseerror(); /*24788*/
			} /*24788*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24790*/
		} /*24790*/
		var _g = $s($1.barlen + 2); /*24793*/
		$puti(_g, 1, $1.barcode); /*24793*/
		$1.barcode = _g; /*24793*/
		$put($1.barcode, 0, 43); /*24794*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24795*/
		$1.options.dontdraw = true; /*24798*/
		$1.options.columns = $1.columns; /*24799*/
		$1.options.validatecheck = false; /*24800*/
		$k[$j++] = "args"; /*24801*/
		$k[$j++] = $1.barcode; /*24801*/
		$k[$j++] = $1.options; /*24801*/
		$0.micropdf417(); /*24801*/
		var _u = $k[--$j]; /*24801*/
		$1[$k[--$j]] = _u; /*24801*/
		$1.args.opt = $1.options; /*24803*/
		$k[$j++] = $1.args; /*24806*/
		if (!$1.dontdraw) { /*24806*/
			$0.renmatrix(); /*24806*/
		} /*24806*/
	};
	$0.hibcqrcode = function() {
		var $1 = {}; /*24834*/
		$1.options = $k[--$j]; /*24836*/
		$1.barcode = $k[--$j]; /*24837*/
		$1.dontdraw = false; /*24839*/
		$1.validatecheck = false; /*24840*/
		$forall($1.options, function() { /*24851*/
			var _3 = $k[--$j]; /*24851*/
			$1[$k[--$j]] = _3; /*24851*/
		}); /*24851*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24854*/
		$1.charvals = {}; /*24855*/
		for (var _5 = 0; _5 <= 42; _5 += 1) { /*24856*/
			$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*24856*/
		} /*24856*/
		for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*24863*/
			var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*24860*/
			if (!_F) { /*24862*/
				$k[$j++] = "bwipp.hibcqrcodeBadCharacter"; /*24861*/
				$k[$j++] = "HIBC QR Code must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24861*/
				$0.raiseerror(); /*24861*/
			} /*24861*/
		} /*24861*/
		$k[$j++] = "barlen"; /*24865*/
		$k[$j++] = $1.barcode.length; /*24865*/
		if ($1.validatecheck) { /*24865*/
			var _I = $k[--$j]; /*24865*/
			$k[$j++] = _I - 1; /*24865*/
		} /*24865*/
		var _J = $k[--$j]; /*24865*/
		$1[$k[--$j]] = _J; /*24865*/
		$1.checksum = 41; /*24867*/
		for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*24871*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*24870*/
		} /*24870*/
		$1.checksum = $1.checksum % 43; /*24872*/
		if ($1.validatecheck) { /*24878*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24876*/
				$k[$j++] = "bwipp.hibcqrcodeBadCheckDigit"; /*24875*/
				$k[$j++] = "Incorrect HIBC QR Code check digit provided"; /*24875*/
				$0.raiseerror(); /*24875*/
			} /*24875*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24877*/
		} /*24877*/
		var _f = $s($1.barlen + 2); /*24880*/
		$puti(_f, 1, $1.barcode); /*24880*/
		$1.barcode = _f; /*24880*/
		$put($1.barcode, 0, 43); /*24881*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24882*/
		$1.options.dontdraw = true; /*24885*/
		$1.options.validatecheck = false; /*24886*/
		$k[$j++] = "args"; /*24887*/
		$k[$j++] = $1.barcode; /*24887*/
		$k[$j++] = $1.options; /*24887*/
		$0.qrcode(); /*24887*/
		var _r = $k[--$j]; /*24887*/
		$1[$k[--$j]] = _r; /*24887*/
		$1.args.opt = $1.options; /*24889*/
		$k[$j++] = $1.args; /*24892*/
		if (!$1.dontdraw) { /*24892*/
			$0.renmatrix(); /*24892*/
		} /*24892*/
	};
	$0.hibccodablockf = function() {
		var $1 = {}; /*24920*/
		$1.options = $k[--$j]; /*24922*/
		$1.barcode = $k[--$j]; /*24923*/
		$1.dontdraw = false; /*24925*/
		$1.validatecheck = false; /*24926*/
		$forall($1.options, function() { /*24937*/
			var _3 = $k[--$j]; /*24937*/
			$1[$k[--$j]] = _3; /*24937*/
		}); /*24937*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*24940*/
		$1.charvals = {}; /*24941*/
		for (var _5 = 0; _5 <= 42; _5 += 1) { /*24942*/
			$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*24942*/
		} /*24942*/
		for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*24949*/
			var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*24946*/
			if (!_F) { /*24948*/
				$k[$j++] = "bwipp.codablockfBadCharacter"; /*24947*/
				$k[$j++] = "HIBC Codablock F must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*24947*/
				$0.raiseerror(); /*24947*/
			} /*24947*/
		} /*24947*/
		$k[$j++] = "barlen"; /*24951*/
		$k[$j++] = $1.barcode.length; /*24951*/
		if ($1.validatecheck) { /*24951*/
			var _I = $k[--$j]; /*24951*/
			$k[$j++] = _I - 1; /*24951*/
		} /*24951*/
		var _J = $k[--$j]; /*24951*/
		$1[$k[--$j]] = _J; /*24951*/
		$1.checksum = 41; /*24953*/
		for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*24957*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*24956*/
		} /*24956*/
		$1.checksum = $1.checksum % 43; /*24958*/
		if ($1.validatecheck) { /*24964*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*24962*/
				$k[$j++] = "bwipp.hibccodablockfBadCheckDigit"; /*24961*/
				$k[$j++] = "Incorrect HIBC Codablock F check digit provided"; /*24961*/
				$0.raiseerror(); /*24961*/
			} /*24961*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*24963*/
		} /*24963*/
		var _f = $s($1.barlen + 2); /*24966*/
		$puti(_f, 1, $1.barcode); /*24966*/
		$1.barcode = _f; /*24966*/
		$put($1.barcode, 0, 43); /*24967*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*24968*/
		$1.options.dontdraw = true; /*24971*/
		$1.options.validatecheck = false; /*24972*/
		$k[$j++] = "args"; /*24973*/
		$k[$j++] = $1.barcode; /*24973*/
		$k[$j++] = $1.options; /*24973*/
		$0.codablockf(); /*24973*/
		var _r = $k[--$j]; /*24973*/
		$1[$k[--$j]] = _r; /*24973*/
		$1.args.opt = $1.options; /*24975*/
		$k[$j++] = $1.args; /*24978*/
		if (!$1.dontdraw) { /*24978*/
			$0.renmatrix(); /*24978*/
		} /*24978*/
	};
	$0.hibcazteccode = function() {
		var $1 = {}; /*25006*/
		$1.options = $k[--$j]; /*25008*/
		$1.barcode = $k[--$j]; /*25009*/
		$1.dontdraw = false; /*25011*/
		$1.validatecheck = false; /*25012*/
		$forall($1.options, function() { /*25023*/
			var _3 = $k[--$j]; /*25023*/
			$1[$k[--$j]] = _3; /*25023*/
		}); /*25023*/
		$1.barchars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%"; /*25026*/
		$1.charvals = {}; /*25027*/
		for (var _5 = 0; _5 <= 42; _5 += 1) { /*25028*/
			$put($1.charvals, $geti($1.barchars, _5, 1), _5); /*25028*/
		} /*25028*/
		for (var _B = 0, _A = $1.barcode.length - 1; _B <= _A; _B += 1) { /*25035*/
			var _F = $get($1.charvals, $geti($1.barcode, _B, 1)) !== undefined; /*25032*/
			if (!_F) { /*25034*/
				$k[$j++] = "bwipp.hibcazteccodeBadCharacter"; /*25033*/
				$k[$j++] = "HIBC Aztec Code must contain only digits, capital letters, spaces and the symbols -.$/+%"; /*25033*/
				$0.raiseerror(); /*25033*/
			} /*25033*/
		} /*25033*/
		$k[$j++] = "barlen"; /*25037*/
		$k[$j++] = $1.barcode.length; /*25037*/
		if ($1.validatecheck) { /*25037*/
			var _I = $k[--$j]; /*25037*/
			$k[$j++] = _I - 1; /*25037*/
		} /*25037*/
		var _J = $k[--$j]; /*25037*/
		$1[$k[--$j]] = _J; /*25037*/
		$1.checksum = 41; /*25039*/
		for (var _N = 0, _M = $1.barlen - 1; _N <= _M; _N += 1) { /*25043*/
			$1.checksum = $get($1.charvals, $geti($1.barcode, _N, 1)) + $1.checksum; /*25042*/
		} /*25042*/
		$1.checksum = $1.checksum % 43; /*25044*/
		if ($1.validatecheck) { /*25050*/
			if ($get($1.barcode, $1.barlen) != $get($1.barchars, $1.checksum)) { /*25048*/
				$k[$j++] = "bwipp.hibcazteccodeBadCheckDigit"; /*25047*/
				$k[$j++] = "Incorrect HIBC Aztec Code check digit provided"; /*25047*/
				$0.raiseerror(); /*25047*/
			} /*25047*/
			$1.barcode = $geti($1.barcode, 0, $1.barlen); /*25049*/
		} /*25049*/
		var _f = $s($1.barlen + 2); /*25052*/
		$puti(_f, 1, $1.barcode); /*25052*/
		$1.barcode = _f; /*25052*/
		$put($1.barcode, 0, 43); /*25053*/
		$put($1.barcode, $1.barlen + 1, $get($1.barchars, $1.checksum)); /*25054*/
		$1.options.dontdraw = true; /*25057*/
		$1.options.validatecheck = false; /*25058*/
		$k[$j++] = "args"; /*25059*/
		$k[$j++] = $1.barcode; /*25059*/
		$k[$j++] = $1.options; /*25059*/
		$0.azteccode(); /*25059*/
		var _r = $k[--$j]; /*25059*/
		$1[$k[--$j]] = _r; /*25059*/
		$1.args.opt = $1.options; /*25061*/
		$k[$j++] = $1.args; /*25064*/
		if (!$1.dontdraw) { /*25064*/
			$0.renmatrix(); /*25064*/
		} /*25064*/
	};
	$0.channelcode = function() {
		var $1 = {}; /*25092*/
		$1.options = $k[--$j]; /*25094*/
		$1.barcode = $k[--$j]; /*25095*/
		$1.dontdraw = false; /*25097*/
		$1.shortfinder = false; /*25098*/
		$1.includetext = false; /*25099*/
		$1.includecheck = false; /*25100*/
		$1.height = 1; /*25101*/
		$forall($1.options, function() { /*25112*/
			var _3 = $k[--$j]; /*25112*/
			$1[$k[--$j]] = _3; /*25112*/
		}); /*25112*/
		$1.height = +$1.height; /*25114*/
		if (($1.barcode.length < 2) || ($1.barcode.length > 7)) { /*25119*/
			$k[$j++] = "bwipp.channelcodeBadLength"; /*25118*/
			$k[$j++] = "Channel Code must be 2 to 7 digits"; /*25118*/
			$0.raiseerror(); /*25118*/
		} /*25118*/
		$forall($1.barcode, function() { /*25124*/
			var _9 = $k[--$j]; /*25121*/
			if ((_9 < 48) || (_9 > 57)) { /*25123*/
				$k[$j++] = "bwipp.channelcodeBadCharacter"; /*25122*/
				$k[$j++] = "Channel Code must contain only digits"; /*25122*/
				$0.raiseerror(); /*25122*/
			} /*25122*/
		}); /*25122*/
		if ((~~$z($1.barcode)) > $get($a([26, 292, 3493, 44072, 576688, 7742862]), $1.barcode.length - 2)) { /*25127*/
			$k[$j++] = "bwipp.channelcodeTooBig"; /*25126*/
			$k[$j++] = "The Channel Code value is too big for the number of channels"; /*25126*/
			$0.raiseerror(); /*25126*/
		} /*25126*/
		$1.nextb = function() {
			var _E = $k[--$j]; /*25130*/
			var _N = (($get($1.s, _E) + ($get($1.b, _E - 1) + ($get($1.b, _E - 2) + $get($1.s, _E - 1)))) > 4) ? 1 : 2; /*25135*/
			$k[$j++] = _E; /*25151*/
			$k[$j++] = _N; /*25151*/
			if (_E < ($1.chan + 2)) { /*25149*/
				var _P = $k[--$j]; /*25137*/
				var _Q = $k[--$j]; /*25137*/
				var _R = $k[--$j]; /*25137*/
				$k[$j++] = _R; /*25140*/
				$k[$j++] = _Q; /*25140*/
				$k[$j++] = _P; /*25140*/
				for (var _T = _P, _S = _R; _T <= _S; _T += 1) { /*25140*/
					var _V = $k[--$j]; /*25138*/
					var _W = $k[--$j]; /*25138*/
					$put($1.b, _W, _T); /*25138*/
					var _X = $k[--$j]; /*25139*/
					var _Y = $k[--$j]; /*25139*/
					$k[$j++] = _Y; /*25139*/
					$k[$j++] = _X; /*25139*/
					$k[$j++] = _W; /*25139*/
					$k[$j++] = _V; /*25139*/
					$k[$j++] = (_X - _T) + 1; /*25139*/
					$k[$j++] = _Y; /*25139*/
					$k[$j++] = _W + 1; /*25139*/
					if ($1.nexts() == $b) break; /*25139*/
				} /*25139*/
			} else { /*25149*/
				var _Z = $k[--$j]; /*25142*/
				var _a = $k[--$j]; /*25142*/
				var _b = $k[--$j]; /*25142*/
				$k[$j++] = _b; /*25150*/
				$k[$j++] = _a; /*25150*/
				$k[$j++] = _Z; /*25150*/
				if ($le(_Z, _b)) { /*25150*/
					var _d = $k[--$j]; /*25143*/
					var _e = $k[--$j]; /*25143*/
					var _f = $k[--$j]; /*25143*/
					$put($1.b, _e, _f); /*25143*/
					$k[$j++] = _f; /*25148*/
					$k[$j++] = _e; /*25148*/
					$k[$j++] = _d; /*25148*/
					if ($1.value == $1.target) { /*25148*/
						$k[$j++] = "out"; /*25147*/
						$k[$j++] = Infinity; /*25147*/
						for (var _i = 3; _i <= 10; _i += 1) { /*25146*/
							$k[$j++] = $get($1.s, _i); /*25146*/
							$k[$j++] = $get($1.b, _i); /*25146*/
						} /*25146*/
						var _p = $geti($a(), 0, $1.chan * 2); /*25147*/
						$1[$k[--$j]] = _p; /*25147*/
					} /*25147*/
					$1.value = $1.value + 1; /*25149*/
				} /*25149*/
			} /*25149*/
			$j -= 4; /*25152*/
		}; /*25153*/
		$1.nexts = function() {
			var _s = $k[--$j]; /*25156*/
			$k[$j++] = _s; /*25156*/
			if (_s < ($1.chan + 2)) { /*25156*/
				$k[$j++] = 1; /*25156*/
			} else { /*25156*/
				var _u = $k[--$j]; /*25156*/
				var _v = $k[--$j]; /*25156*/
				$k[$j++] = _v; /*25156*/
				$k[$j++] = _u; /*25156*/
				$k[$j++] = _v; /*25156*/
			} /*25156*/
			var _w = $k[--$j]; /*25156*/
			var _x = $k[--$j]; /*25156*/
			var _y = $k[--$j]; /*25156*/
			$k[$j++] = _y; /*25159*/
			$k[$j++] = _x; /*25159*/
			for (var _10 = _w, _z = _y; _10 <= _z; _10 += 1) { /*25159*/
				var _12 = $k[--$j]; /*25157*/
				$put($1.s, _12, _10); /*25157*/
				var _13 = $k[--$j]; /*25158*/
				var _14 = $k[--$j]; /*25158*/
				$k[$j++] = _14; /*25158*/
				$k[$j++] = _13; /*25158*/
				$k[$j++] = _12; /*25158*/
				$k[$j++] = (_13 - _10) + 1; /*25158*/
				$k[$j++] = _14; /*25158*/
				$k[$j++] = _12; /*25158*/
				if ($1.nextb() == $b) break; /*25158*/
			} /*25158*/
			$j -= 3; /*25160*/
		}; /*25161*/
		$1.encode = function() {
			$1.chan = $k[--$j]; /*25164*/
			$1.target = $k[--$j]; /*25165*/
			$1.value = 0; /*25166*/
			$1.out = -1; /*25167*/
			$1.b = $a([1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0]); /*25168*/
			$1.s = $a([0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0]); /*25169*/
			var _19 = $1.chan; /*25170*/
			$k[$j++] = _19; /*25170*/
			$k[$j++] = _19; /*25170*/
			$k[$j++] = 3; /*25170*/
			if ($1.nexts() == $b) return $b; /*25170*/
			$k[$j++] = $1.out; /*25171*/
		}; /*25172*/
		$1.barlen = $1.barcode.length; /*25174*/
		$k[$j++] = "finder"; /*25177*/
		if ($1.shortfinder) { /*25177*/
			$k[$j++] = $a([1, 1, 1, 1, 1]); /*25177*/
		} else { /*25177*/
			$k[$j++] = $a([1, 1, 1, 1, 1, 1, 1, 1, 1]); /*25177*/
		} /*25177*/
		var _1F = $k[--$j]; /*25177*/
		$1[$k[--$j]] = _1F; /*25177*/
		$k[$j++] = "data"; /*25180*/
		$k[$j++] = ~~$z($1.barcode); /*25180*/
		$k[$j++] = $1.barlen + 1; /*25180*/
		if ($1.encode() == $b) return $b; /*25180*/
		var _1J = $k[--$j]; /*25180*/
		$1[$k[--$j]] = _1J; /*25180*/
		$1.check = $a([]); /*25183*/
		if ($1.includecheck) { /*25199*/
			$1.mod23 = $get($a([$a([]), $a([]), $a([13, 12, 4, 9, 3, 1]), $a([13, 2, 12, 3, 18, 16, 4, 1]), $a([11, 16, 17, 8, 20, 4, 10, 2, 5, 1]), $a([1, 4, 16, 18, 3, 12, 2, 8, 9, 13, 6, 1]), $a([20, 16, 22, 13, 15, 12, 5, 4, 8, 9, 21, 3, 7, 1]), $a([2, 6, 18, 8, 1, 3, 9, 4, 12, 13, 16, 2, 6, 18, 8, 1])]), $1.barlen); /*25193*/
			$k[$j++] = 0; /*25197*/
			for (var _1a = 0, _1Z = $1.data.length - 1; _1a <= _1Z; _1a += 1) { /*25197*/
				var _1f = $k[--$j]; /*25196*/
				$k[$j++] = _1f + (($get($1.data, _1a) - 1) * $get($1.mod23, _1a)); /*25196*/
			} /*25196*/
			var _1g = $k[--$j]; /*25198*/
			$k[$j++] = _1g % 23; /*25198*/
			$k[$j++] = 3; /*25198*/
			if ($1.encode() == $b) return $b; /*25198*/
			$1.check = $k[--$j]; /*25198*/
		} /*25198*/
		$k[$j++] = Infinity; /*25206*/
		$aload($1.finder); /*25203*/
		$aload($1.data); /*25204*/
		$aload($1.check); /*25205*/
		$1.sbs = $a(); /*25206*/
		$1.txt = $a($1.barlen); /*25209*/
		for (var _1q = 0, _1p = $1.barlen - 1; _1q <= _1p; _1q += 1) { /*25213*/
			$1.i = _1q; /*25211*/
			$put($1.txt, $1.i, $a([$geti($1.barcode, $1.i, 1), 0, 0, "", 0])); /*25212*/
		} /*25212*/
		$k[$j++] = Infinity; /*25223*/
		$k[$j++] = "ren"; /*25220*/
		$k[$j++] = $0.renlinear; /*25220*/
		$k[$j++] = "sbs"; /*25220*/
		$k[$j++] = $1.sbs; /*25220*/
		$k[$j++] = "bhs"; /*25220*/
		$k[$j++] = Infinity; /*25220*/
		for (var _1z = 0, _20 = ~~(($1.sbs.length + 1) / 2); _1z < _20; _1z++) { /*25219*/
			$k[$j++] = $1.height; /*25219*/
		} /*25219*/
		var _22 = $a(); /*25220*/
		$k[$j++] = _22; /*25221*/
		$k[$j++] = "bbs"; /*25221*/
		$k[$j++] = Infinity; /*25221*/
		for (var _24 = 0, _25 = ~~(($1.sbs.length + 1) / 2); _24 < _25; _24++) { /*25220*/
			$k[$j++] = 0; /*25220*/
		} /*25220*/
		var _26 = $a(); /*25221*/
		$k[$j++] = _26; /*25223*/
		$k[$j++] = "txt"; /*25223*/
		$k[$j++] = $1.txt; /*25223*/
		$k[$j++] = "textxalign"; /*25223*/
		$k[$j++] = "center"; /*25223*/
		$k[$j++] = "opt"; /*25223*/
		$k[$j++] = $1.options; /*25223*/
		var _29 = $d(); /*25223*/
		$k[$j++] = _29; /*25226*/
		if (!$1.dontdraw) { /*25226*/
			$0.renlinear(); /*25226*/
		} /*25226*/
	};
	$0.renlinear = function() {
		if ($0.bwipjs_dontdraw) { /*25248*/
			return; /*25248*/
		} /*25248*/
		var $1 = {}; /*25250*/
		$1.args = $k[--$j]; /*25252*/
		$1.sbs = $a([]); /*25255*/
		$1.bhs = $a([]); /*25256*/
		$1.bbs = $a([]); /*25257*/
		$1.txt = $a([]); /*25258*/
		$1.barcolor = "unset"; /*25259*/
		$1.includetext = false; /*25260*/
		$1.textcolor = "unset"; /*25261*/
		$1.textxalign = "unset"; /*25262*/
		$1.textyalign = "unset"; /*25263*/
		$1.textfont = "Courier"; /*25264*/
		$1.textsize = 10; /*25265*/
		$1.textxoffset = 0; /*25266*/
		$1.textyoffset = 0; /*25267*/
		$1.textgaps = 0; /*25268*/
		$1.alttext = ""; /*25269*/
		$1.bordercolor = "unset"; /*25270*/
		$1.backgroundcolor = "unset"; /*25271*/
		$1.inkspread = 0; /*25272*/
		$1.width = 0; /*25273*/
		$1.barratio = 1; /*25274*/
		$1.spaceratio = 1; /*25275*/
		$1.showborder = false; /*25276*/
		$1.borderleft = 10; /*25277*/
		$1.borderright = 10; /*25278*/
		$1.bordertop = 1; /*25279*/
		$1.borderbottom = 1; /*25280*/
		$1.borderwidth = 0.5; /*25281*/
		$1.guardwhitespace = false; /*25282*/
		$1.guardleftpos = 0; /*25283*/
		$1.guardleftypos = 0; /*25284*/
		$1.guardrightpos = 0; /*25285*/
		$1.guardrightypos = 0; /*25286*/
		$1.guardwidth = 7; /*25287*/
		$1.guardheight = 7; /*25288*/
		$forall($1.args, function() { /*25291*/
			var _7 = $k[--$j]; /*25291*/
			$1[$k[--$j]] = _7; /*25291*/
		}); /*25291*/
		var _9 = $1.opt; /*25292*/
		for (var _A in _9) { /*25292*/
			$1[_A] = _9[_A]; /*25292*/
		} /*25292*/
		$1.barcolor = "" + $1.barcolor; /*25294*/
		$1.textcolor = "" + $1.textcolor; /*25295*/
		$1.textxalign = "" + $1.textxalign; /*25296*/
		$1.textyalign = "" + $1.textyalign; /*25297*/
		$1.textfont = "" + $1.textfont; /*25298*/
		$1.textsize = +$1.textsize; /*25299*/
		$1.textxoffset = +$1.textxoffset; /*25300*/
		$1.textyoffset = +$1.textyoffset; /*25301*/
		$1.textgaps = +$1.textgaps; /*25302*/
		$1.alttext = "" + $1.alttext; /*25303*/
		$1.bordercolor = "" + $1.bordercolor; /*25304*/
		$1.backgroundcolor = "" + $1.backgroundcolor; /*25305*/
		$1.inkspread = +$1.inkspread; /*25306*/
		$1.width = +$1.width; /*25307*/
		$1.barratio = +$1.barratio; /*25308*/
		$1.spaceratio = +$1.spaceratio; /*25309*/
		$1.borderleft = +$1.borderleft; /*25310*/
		$1.borderright = +$1.borderright; /*25311*/
		$1.bordertop = +$1.bordertop; /*25312*/
		$1.borderbottom = +$1.borderbottom; /*25313*/
		$1.borderwidth = +$1.borderwidth; /*25314*/
		$1.guardleftpos = +$1.guardleftpos; /*25315*/
		$1.guardleftypos = +$1.guardleftypos; /*25316*/
		$1.guardrightpos = +$1.guardrightpos; /*25317*/
		$1.guardrightypos = +$1.guardrightypos; /*25318*/
		$1.guardwidth = +$1.guardwidth; /*25319*/
		$1.guardheight = +$1.guardheight; /*25320*/
		$1.bars = $a(~~(($1.sbs.length + 1) / 2)); /*25323*/
		$1.x = 0; /*25324*/
		$1.maxh = 0; /*25324*/
		for (var _h = 0, _g = ((~~(($1.sbs.length + 1) / 2)) * 2) - 2; _h <= _g; _h += 1) { /*25343*/
			$1.i = _h; /*25326*/
			if (($1.i % 2) == 0) { /*25340*/
				$1.d = (($get($1.sbs, $1.i) * $1.barratio) - $1.barratio) + 1; /*25328*/
				if ($get($1.sbs, $1.i) != 0) { /*25337*/
					$1.h = $get($1.bhs, ~~($1.i / 2)) * 72; /*25330*/
					$1.c = ($1.d / 2) + $1.x; /*25331*/
					$1.y = $get($1.bbs, ~~($1.i / 2)) * 72; /*25332*/
					$1.w = $1.d - $1.inkspread; /*25333*/
					$put($1.bars, ~~($1.i / 2), $a([$1.h, $1.c, $1.y, $1.w])); /*25334*/
					if (($1.h + $1.y) > $1.maxh) { /*25335*/
						$1.maxh = $1.h + $1.y; /*25335*/
					} /*25335*/
				} else { /*25337*/
					$put($1.bars, ~~($1.i / 2), -1); /*25337*/
				} /*25337*/
			} else { /*25340*/
				$1.d = (($get($1.sbs, $1.i) * $1.spaceratio) - $1.spaceratio) + 1; /*25340*/
			} /*25340*/
			$1.x = $1.x + $1.d; /*25342*/
		} /*25342*/
		$$.save(); /*25345*/
		var _1M = $$.currpos(); /*25347*/
		$$.translate(_1M.x, _1M.y); /*25347*/
		if ($1.width != 0) { /*25352*/
			$$.scale(($1.width * 72) / $1.x, 1); /*25351*/
		} /*25351*/
		$$.floorscale(); /*25355*/
		$$.newpath(); /*25358*/
		$$.moveto(-$1.borderleft, -$1.borderbottom); /*25359*/
		$$.rlineto(($1.x + $1.borderleft) + $1.borderright, 0); /*25360*/
		$$.rlineto(0, ($1.maxh + $1.borderbottom) + $1.bordertop); /*25361*/
		$$.rlineto(-(($1.x + $1.borderleft) + $1.borderright), 0); /*25362*/
		$$.rlineto(0, -(($1.maxh + $1.borderbottom) + $1.bordertop)); /*25363*/
		$$.closepath(); /*25364*/
		if ($1.showborder) { /*25372*/
			$$.save(); /*25368*/
			if ($ne($1.bordercolor, "unset")) { /*25369*/
				$$.setcolor($1.bordercolor); /*25369*/
			} /*25369*/
			$$.setlinewidth($1.borderwidth); /*25370*/
			$$.stroke(); /*25370*/
			$$.restore(); /*25371*/
		} /*25371*/
		$$.save(); /*25375*/
		if ($ne($1.barcolor, "unset")) { /*25377*/
			$$.setcolor($1.barcolor); /*25377*/
		} /*25377*/
		var _1k = $1.bars; /*25378*/
		for (var _1l = 0, _1m = _1k.length; _1l < _1m; _1l++) { /*25384*/
			var _1n = $get(_1k, _1l); /*25384*/
			$k[$j++] = _1n; /*25383*/
			if (_1n != -1) { /*25382*/
				$aload($k[--$j]); /*25380*/
				$$.newpath(); /*25380*/
				$$.setlinewidth($k[--$j]); /*25380*/
				var _1q = $k[--$j]; /*25380*/
				$$.moveto($k[--$j], _1q); /*25380*/
				$$.rlineto(0, $k[--$j]); /*25380*/
				$$.stroke(); /*25380*/
			} else { /*25382*/
				$j--; /*25382*/
			} /*25382*/
		} /*25382*/
		$$.restore(); /*25385*/
		if ($ne($1.textcolor, "unset")) { /*25388*/
			$$.setcolor($1.textcolor); /*25388*/
		} /*25388*/
		if ($1.includetext) { /*25445*/
			if (($eq($1.textxalign, "unset") && $eq($1.textyalign, "unset")) && $eq($1.alttext, "")) { /*25443*/
				$1.s = 0; /*25391*/
				$1.fn = ""; /*25391*/
				var _1z = $1.txt; /*25392*/
				for (var _20 = 0, _21 = _1z.length; _20 < _21; _20++) { /*25401*/
					$forall($get(_1z, _20)); /*25393*/
					var _23 = $k[--$j]; /*25394*/
					var _24 = $k[--$j]; /*25394*/
					$k[$j++] = _24; /*25399*/
					$k[$j++] = _23; /*25399*/
					if ((_23 != $1.s) || $ne(_24, $1.fn)) { /*25398*/
						var _27 = $k[--$j]; /*25395*/
						var _28 = $k[--$j]; /*25395*/
						$1.s = _27; /*25395*/
						$1.fn = _28; /*25395*/
						var _29 = $$.findfont(_28); /*25396*/
						_29.FontSize = _27; /*25396*/
						$$.setfont(_29); /*25396*/
					} else { /*25398*/
						$j -= 2; /*25398*/
					} /*25398*/
					var _2A = $k[--$j]; /*25400*/
					$$.moveto($k[--$j], _2A); /*25400*/
					$$.show($k[--$j], 0, 0); /*25400*/
				} /*25400*/
			} else { /*25443*/
				var _2E = $$.findfont($1.textfont); /*25403*/
				_2E.FontSize = $1.textsize; /*25403*/
				$$.setfont(_2E); /*25403*/
				if ($eq($1.alttext, "")) { /*25409*/
					$k[$j++] = Infinity; /*25405*/
					var _2H = $1.txt; /*25405*/
					for (var _2I = 0, _2J = _2H.length; _2I < _2J; _2I++) { /*25405*/
						$forall($get($get(_2H, _2I), 0)); /*25405*/
					} /*25405*/
					$1.txt = $a(); /*25405*/
					$1.tstr = $s($1.txt.length); /*25406*/
					for (var _2R = 0, _2Q = $1.txt.length - 1; _2R <= _2Q; _2R += 1) { /*25407*/
						$put($1.tstr, _2R, $get($1.txt, _2R)); /*25407*/
					} /*25407*/
				} else { /*25409*/
					$1.tstr = $1.alttext; /*25409*/
				} /*25409*/
				if ($1.tstr.length == 0) { /*25425*/
					$k[$j++] = 0; /*25414*/
				} else { /*25425*/
					$$.save(); /*25416*/
					$$.newpath(); /*25417*/
					$$.moveto(0, 0); /*25417*/
					$$.charpath("0", false); /*25417*/
					var _2X = $$.pathbbox(); /*25417*/
					$$.restore(); /*25419*/
					var _2Y = $$.currfont(); /*25420*/
					var _2Z = _2Y.PaintType !== undefined; /*25420*/
					$k[$j++] = _2X.ury; /*25420*/
					if (_2Z) { /*25420*/
						var _2a = $$.currfont(); /*25420*/
						$k[$j++] = _2a.PaintType == 2; /*25420*/
					} else { /*25420*/
						$k[$j++] = false; /*25420*/
					} /*25420*/
					var _2c = $$.currfont(); /*25421*/
					var _2d = _2c.StrokeWidth !== undefined; /*25421*/
					if ($k[--$j] && _2d) { /*25426*/
						var _2f = $$.currfont(); /*25422*/
						var _2h = $$.currfont(); /*25423*/
						var _2i = _2h.FontMatrix; /*25423*/
						var _2j = _2f.StrokeWidth / 2; /*25424*/
						var _2k = $k[--$j]; /*25425*/
						$k[$j++] = _2k + (Math.sqrt((_2j * _2j) + (0 * 0))); /*25425*/
					} /*25425*/
				} /*25425*/
				$1.textascent = $k[--$j]; /*25428*/
				var _2n = $$.stringwidth($1.tstr); /*25429*/
				$1.textwidth = _2n.w + (($1.tstr.length - 1) * $1.textgaps); /*25429*/
				$1.textxpos = $1.textxoffset + (($1.x - $1.textwidth) / 2); /*25431*/
				if ($eq($1.textxalign, "left")) { /*25432*/
					$1.textxpos = $1.textxoffset; /*25432*/
				} /*25432*/
				if ($eq($1.textxalign, "right")) { /*25433*/
					$1.textxpos = ($1.x - $1.textxoffset) - $1.textwidth; /*25433*/
				} /*25433*/
				if ($eq($1.textxalign, "offleft")) { /*25434*/
					$1.textxpos = -($1.textwidth + $1.textxoffset); /*25434*/
				} /*25434*/
				if ($eq($1.textxalign, "offright")) { /*25435*/
					$1.textxpos = $1.x + $1.textxoffset; /*25435*/
				} /*25435*/
				if ($eq($1.textxalign, "justify") && ($1.textwidth < $1.x)) { /*25439*/
					$1.textxpos = 0; /*25437*/
					$1.textgaps = ($1.x - $1.textwidth) / ($1.tstr.length - 1); /*25438*/
				} /*25438*/
				$1.textypos = -(($1.textyoffset + $1.textascent) + 1); /*25440*/
				if ($eq($1.textyalign, "above")) { /*25441*/
					$1.textypos = ($1.textyoffset + $1.maxh) + 1; /*25441*/
				} /*25441*/
				if ($eq($1.textyalign, "center")) { /*25442*/
					$1.textypos = $1.textyoffset + (($1.maxh - $1.textascent) / 2); /*25442*/
				} /*25442*/
				$$.moveto($1.textxpos, $1.textypos); /*25443*/
				$$.show($1.tstr, $1.textgaps, 0); /*25443*/
			} /*25443*/
		} /*25443*/
		if ($1.guardwhitespace) { /*25458*/
			var _3P = $$.findfont("OCR-B"); /*25449*/
			_3P.FontSize = ($1.guardheight * 2) - 1; /*25449*/
			$$.setfont(_3P); /*25449*/
			if ($1.guardleftpos != 0) { /*25453*/
				$$.moveto((-$1.guardleftpos) - 1.5, ($1.guardleftypos - ($1.guardheight / 2)) - 1); /*25451*/
				$$.show("<", 0, 0); /*25452*/
			} /*25452*/
			if ($1.guardrightpos != 0) { /*25457*/
				$$.moveto(($1.guardrightpos + $1.x) - $1.guardwidth, ($1.guardrightypos - ($1.guardheight / 2)) - 1); /*25455*/
				$$.show(">", 0, 0); /*25456*/
			} /*25456*/
		} /*25456*/
		$$.restore(); /*25460*/
	};
	$0.renmatrix = function() {
		if ($0.bwipjs_dontdraw) { /*25478*/
			return; /*25478*/
		} /*25478*/
		var $1 = {}; /*25480*/
		$1.args = $k[--$j]; /*25482*/
		$1.width = 1; /*25485*/
		$1.height = 1; /*25486*/
		$1.barcolor = "unset"; /*25487*/
		$1.backgroundcolor = "unset"; /*25488*/
		$1.includetext = false; /*25489*/
		$1.txt = $a([]); /*25490*/
		$1.textcolor = "unset"; /*25491*/
		$1.textxalign = "unset"; /*25492*/
		$1.textyalign = "unset"; /*25493*/
		$1.textfont = "Courier"; /*25494*/
		$1.textsize = 10; /*25495*/
		$1.textxoffset = 0; /*25496*/
		$1.textyoffset = 0; /*25497*/
		$1.textgaps = 0; /*25498*/
		$1.alttext = ""; /*25499*/
		$forall($1.args, function() { /*25502*/
			var _4 = $k[--$j]; /*25502*/
			$1[$k[--$j]] = _4; /*25502*/
		}); /*25502*/
		var _6 = $1.opt; /*25503*/
		for (var _7 in _6) { /*25503*/
			$1[_7] = _6[_7]; /*25503*/
		} /*25503*/
		$1.width = +$1.width; /*25505*/
		$1.height = +$1.height; /*25506*/
		$1.barcolor = "" + $1.barcolor; /*25507*/
		$1.backgroundcolor = "" + $1.backgroundcolor; /*25508*/
		$1.inkspread = +$1.inkspread; /*25509*/
		$1.inkspreadh = +$1.inkspreadh; /*25510*/
		$1.inkspreadv = +$1.inkspreadv; /*25511*/
		$1.textcolor = "" + $1.textcolor; /*25512*/
		$1.textxalign = "" + $1.textxalign; /*25513*/
		$1.textyalign = "" + $1.textyalign; /*25514*/
		$1.textfont = "" + $1.textfont; /*25515*/
		$1.textsize = +$1.textsize; /*25516*/
		$1.textxoffset = +$1.textxoffset; /*25517*/
		$1.textyoffset = +$1.textyoffset; /*25518*/
		$1.textgaps = +$1.textgaps; /*25519*/
		$1.alttext = "" + $1.alttext; /*25520*/
		$1.pixx8 = (~~Math.ceil($1.pixx / 8)) * 8; /*25523*/
		$k[$j++] = Infinity; /*25524*/
		for (var _S = 0, _T = $1.pixx8 * $1.pixy; _S < _T; _S++) { /*25524*/
			$k[$j++] = 0; /*25524*/
		} /*25524*/
		$1.pixs8 = $a(); /*25524*/
		for (var _X = 0, _W = $1.pixy - 1; _X <= _W; _X += 1) { /*25528*/
			$1.i = _X; /*25526*/
			$puti($1.pixs8, $1.pixx8 * $1.i, $geti($1.pixs, $1.pixx * $1.i, $1.pixx)); /*25527*/
		} /*25527*/
		$1.pixs = $1.pixs8; /*25529*/
		$1.imgstr = $s(~~($1.pixs.length / 8)); /*25532*/
		for (var _l = 0, _k = $1.pixs.length - 1; _l <= _k; _l += 1) { /*25536*/
			$1.i = _l; /*25534*/
			var _m = $1.imgstr; /*25535*/
			var _n = $1.i; /*25535*/
			$put(_m, ~~(_n / 8), $get(_m, ~~(_n / 8)) + ((~~(Math.pow(2, 7 - ($1.i % 8)))) * $get($1.pixs, $1.i))); /*25535*/
		} /*25535*/
		$$.save(); /*25539*/
		$$.floorscale(); /*25543*/
		var _t = $$.currpos(); /*25545*/
		$$.translate(_t.x, _t.y); /*25545*/
		$$.scale(72 * $1.width, 72 * $1.height); /*25546*/
		$$.moveto(0.0001, 0.0001); /*25547*/
		$$.lineto(0.9999, 0.0001); /*25547*/
		$$.lineto(0.9999, 0.9999); /*25547*/
		$$.lineto(0.0001, 0.9999); /*25547*/
		$$.closepath(); /*25547*/
		if ($ne($1.barcolor, "unset")) { /*25549*/
			$$.setcolor($1.barcolor); /*25549*/
		} /*25549*/
		$$.imagemask($1.pixx, $1.pixy, $1.imgstr); /*25554*/
		$$.restore(); /*25555*/
		if ($1.includetext) { /*25623*/
			$$.save(); /*25559*/
			$$.floorscale(); /*25563*/
			if ($ne($1.textcolor, "unset")) { /*25565*/
				$$.setcolor($1.textcolor); /*25565*/
			} /*25565*/
			if (($eq($1.textxalign, "unset") && $eq($1.textyalign, "unset")) && $eq($1.alttext, "")) { /*25620*/
				$1.s = 0; /*25567*/
				$1.fn = ""; /*25567*/
				var _17 = $1.txt; /*25568*/
				for (var _18 = 0, _19 = _17.length; _18 < _19; _18++) { /*25578*/
					$forall($get(_17, _18)); /*25569*/
					var _1B = $k[--$j]; /*25570*/
					var _1C = $k[--$j]; /*25570*/
					$k[$j++] = _1C; /*25576*/
					$k[$j++] = _1B; /*25576*/
					if ((_1B != $1.s) || $ne(_1C, $1.fn)) { /*25575*/
						var _1F = $k[--$j]; /*25571*/
						var _1G = $k[--$j]; /*25571*/
						$1.s = _1F; /*25571*/
						$1.fn = _1G; /*25571*/
						var _1H = $$.findfont(_1G); /*25573*/
						_1H.FontSize = _1F; /*25573*/
						$$.setfont(_1H); /*25573*/
					} else { /*25575*/
						$j -= 2; /*25575*/
					} /*25575*/
					var _1I = $k[--$j]; /*25577*/
					$$.moveto($k[--$j], _1I); /*25577*/
					$$.show($k[--$j], 0, 0); /*25577*/
				} /*25577*/
			} else { /*25620*/
				var _1N = $$.findfont($1.textfont); /*25580*/
				_1N.FontSize = $1.textsize; /*25580*/
				$$.setfont(_1N); /*25580*/
				if ($eq($1.alttext, "")) { /*25586*/
					$k[$j++] = Infinity; /*25582*/
					var _1P = $1.txt; /*25582*/
					for (var _1Q = 0, _1R = _1P.length; _1Q < _1R; _1Q++) { /*25582*/
						$forall($get($get(_1P, _1Q), 0)); /*25582*/
					} /*25582*/
					$1.txt = $a(); /*25582*/
					$1.tstr = $s($1.txt.length); /*25583*/
					for (var _1Z = 0, _1Y = $1.txt.length - 1; _1Z <= _1Y; _1Z += 1) { /*25584*/
						$put($1.tstr, _1Z, $get($1.txt, _1Z)); /*25584*/
					} /*25584*/
				} else { /*25586*/
					$1.tstr = $1.alttext; /*25586*/
				} /*25586*/
				if ($1.tstr.length == 0) { /*25602*/
					$k[$j++] = 0; /*25591*/
				} else { /*25602*/
					$$.save(); /*25593*/
					$$.newpath(); /*25594*/
					$$.moveto(0, 0); /*25594*/
					$$.charpath("0", false); /*25594*/
					var _1f = $$.pathbbox(); /*25594*/
					$$.restore(); /*25596*/
					var _1g = $$.currfont(); /*25597*/
					var _1h = _1g.PaintType !== undefined; /*25597*/
					$k[$j++] = _1f.ury; /*25597*/
					if (_1h) { /*25597*/
						var _1i = $$.currfont(); /*25597*/
						$k[$j++] = _1i.PaintType == 2; /*25597*/
					} else { /*25597*/
						$k[$j++] = false; /*25597*/
					} /*25597*/
					var _1k = $$.currfont(); /*25598*/
					var _1l = _1k.StrokeWidth !== undefined; /*25598*/
					if ($k[--$j] && _1l) { /*25603*/
						var _1n = $$.currfont(); /*25599*/
						var _1p = $$.currfont(); /*25600*/
						var _1q = _1p.FontMatrix; /*25600*/
						var _1r = _1n.StrokeWidth / 2; /*25601*/
						var _1s = $k[--$j]; /*25602*/
						$k[$j++] = _1s + (Math.sqrt((_1r * _1r) + (0 * 0))); /*25602*/
					} /*25602*/
				} /*25602*/
				$1.textascent = $k[--$j]; /*25605*/
				var _1v = $$.stringwidth($1.tstr); /*25606*/
				$1.textwidth = _1v.w + (($1.tstr.length - 1) * $1.textgaps); /*25606*/
				$1.textxpos = $1.textxoffset + (($1.pixx - $1.textwidth) / 2); /*25608*/
				if ($eq($1.textxalign, "left")) { /*25609*/
					$1.textxpos = $1.textxoffset; /*25609*/
				} /*25609*/
				if ($eq($1.textxalign, "right")) { /*25610*/
					$1.textxpos = ($1.pixx - $1.textxoffset) - $1.textwidth; /*25610*/
				} /*25610*/
				if ($eq($1.textxalign, "offleft")) { /*25611*/
					$1.textxpos = -($1.textwidth + $1.textxoffset); /*25611*/
				} /*25611*/
				if ($eq($1.textxalign, "offright")) { /*25612*/
					$1.textxpos = $1.pixx + $1.textxoffset; /*25612*/
				} /*25612*/
				if ($eq($1.textxalign, "justify") && ($1.textwidth < $1.pixx)) { /*25616*/
					$1.textxpos = 0; /*25614*/
					$1.textgaps = ($1.pixx - $1.textwidth) / ($1.tstr.length - 1); /*25615*/
				} /*25615*/
				$1.textypos = -(($1.textyoffset + $1.textascent) + 1); /*25617*/
				if ($eq($1.textyalign, "above")) { /*25618*/
					$1.textypos = ($1.textyoffset + $1.pixy) + 1; /*25618*/
				} /*25618*/
				if ($eq($1.textyalign, "center")) { /*25619*/
					$1.textypos = $1.textyoffset + (($1.pixy - $1.textascent) / 2); /*25619*/
				} /*25619*/
				$$.moveto($1.textxpos, $1.textypos); /*25620*/
				$$.show($1.tstr, $1.textgaps, 0); /*25620*/
			} /*25620*/
			$$.restore(); /*25622*/
		} /*25622*/
	};
	$0.renmaximatrix = function() {
		if ($0.bwipjs_dontdraw) { /*25643*/
			return; /*25643*/
		} /*25643*/
		var $1 = {}; /*25645*/
		$1.args = $k[--$j]; /*25647*/
		$1.barcolor = "unset"; /*25650*/
		$1.backgroundcolor = "unset"; /*25651*/
		$forall($1.args, function() { /*25654*/
			var _3 = $k[--$j]; /*25654*/
			$1[$k[--$j]] = _3; /*25654*/
		}); /*25654*/
		var _5 = $1.opt; /*25655*/
		for (var _6 in _5) { /*25655*/
			$1[_6] = _5[_6]; /*25655*/
		} /*25655*/
		$1.barcolor = "" + $1.barcolor; /*25657*/
		$1.backgroundcolor = "" + $1.backgroundcolor; /*25658*/
		$$.save(); /*25660*/
		var _A = $$.currpos(); /*25662*/
		$$.translate(_A.x, _A.y); /*25662*/
		$$.moveto(0, 0); /*25667*/
		$$.lineto(30, 0); /*25667*/
		$$.lineto(30, 29); /*25667*/
		$$.lineto(0, 29); /*25667*/
		$$.closepath(); /*25667*/
		if ($ne($1.barcolor, "unset")) { /*25669*/
			$$.setcolor($1.barcolor); /*25669*/
		} /*25669*/
		var _D = $$.findfont("Symbol"); /*25675*/
		_D.FontSize = 10; /*25675*/
		$$.setfont(_D); /*25675*/
		$1.chars = $a(["0", "1", "2", "3"]); /*25677*/
		$$.newpath(); /*25678*/
		var _F = $1.pixs; /*25679*/
		for (var _G = 0, _H = _F.length; _G < _H; _G++) { /*25690*/
			var _I = $get(_F, _G); /*25690*/
			$1.x = _I % 30; /*25681*/
			$1.y = ~~(_I / 30); /*25682*/
			var _L = (($1.y % 2) == 0) ? 0 : 2; /*25684*/
			var _N = (($1.x % 2) == 0) ? 0 : 1; /*25685*/
			$k[$j++] = $get($1.chars, _L + _N); /*25687*/
			$k[$j++] = $1.x * 3.5; /*25687*/
			if (($1.y % 2) == 1) { /*25687*/
				var _R = $k[--$j]; /*25687*/
				$k[$j++] = _R + 1.75; /*25687*/
			} /*25687*/
			$$.moveto($k[--$j], (32 - $1.y) * 3); /*25689*/
			$$.show($k[--$j], 0, 0); /*25689*/
		} /*25689*/
		var _V = $$.findfont("Symbol"); /*25693*/
		_V.FontSize = 10; /*25693*/
		$$.setfont(_V); /*25693*/
		$$.moveto(36, 35); /*25694*/
		$$.show("4", 0, 0); /*25694*/
		$$.restore(); /*25696*/
	};
	// bwip-js/barcode-ftr.js
	//
	// This code is injected below the cross-compiled barcode.ps.

	// The BWIPP symbol is a factory object.  When called, it returns this
	// function, which is a re-usable postscript emulation for BWIPP.
	return function(bwipjs, encoder, text, opts, dontdraw) {
		if (!$0[encoder]) {
			throw new Error('bwipp.unknownEncoder: ' + encoder);
		}
		if (typeof text !== 'string') {
			throw new Error('bwipp.typeError: barcode text not a string (' +
				text + ')');
		}
		opts = opts || {};
		if (typeof opts === 'string') {
			var tmp = opts.split(' ');
			opts = {};
			for (var i = 0; i < tmp.length; i++) {
				if (!tmp[i]) {
					continue;
				}
				var eq = tmp[i].indexOf('=');
				if (eq == -1) {
					opts[tmp[i]] = true;
				} else {
					opts[tmp[i].substr(0, eq)] = tmp[i].substr(eq + 1);
				}
			}
		} else if (typeof opts !== 'object' || opts.constructor !== Object) {
			throw new Error('bwipp.typeError: options not an object');
		}

		// Convert utf-16 to utf-8 but leave binary (8-bit) strings untouched.
		if (/[\u0100-\uffff]/.test(text)) {
			text = unescape(encodeURIComponent(text));
		}

		// Handle the `parse` option here rather than in BWIPP - eliminates
		// conflict with the parsefnc option and allows removing the parsing
		// code from BWIPP.
		if (opts.parse) {
			text = text.replace(/\^(\d\d\d)/g, function($0, $1) {
				var v = +$1;
				if (v > 255) {
					throw new Error('bwipp.rangeError:' +
						' ^NNN out-of-range (' + $0 + ')');
				}
				return String.fromCharCode(v);
			});
			delete opts.parse;
		}

		// Don't draw? (See file runtest)
		$0.bwipjs_dontdraw = dontdraw || false;

		// Invoke the encoder
		$$ = bwipjs;
		$k = [text, opts];
		$j = 2;
		$0[encoder]();

		// Return what is left on the stack.  This branch should only be taken
		// when running tests with the dontdraw option.
		if ($j) {
			return $k.splice(0, $j);
		}

		return true;
	}
}
BWIPP.VERSION = '2018-02-04';
if (typeof module === 'object' && module.exports) {
	module.exports = BWIPP;
}



//////////////////
// WEBPACK FOOTER
// ./~/bwip-js/bwipp.js
// module id = 347
// module chunks = 1